/* tslint:disable */
/* eslint-disable */
/**
 * MaestroAPI v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @enum {string}
 */
export enum Action {
    Create = 'Create',
    Update = 'Update'
}

/**
 * 
 * @export
 * @interface ActivateIntegrationCommand
 */
export interface ActivateIntegrationCommand {
    /**
     * 
     * @type {string}
     * @memberof ActivateIntegrationCommand
     */
    integrationId?: string;
}
/**
 * 
 * @export
 * @interface ActivateWorkflowCommand
 */
export interface ActivateWorkflowCommand {
    /**
     * 
     * @type {string}
     * @memberof ActivateWorkflowCommand
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface ActivatedIntegrationOutputDTO
 */
export interface ActivatedIntegrationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ActivatedIntegrationOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivatedIntegrationOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {IntegrationType}
     * @memberof ActivatedIntegrationOutputDTO
     */
    type?: IntegrationType;
}
/**
 * 
 * @export
 * @interface ActiveInboundBoxesOutputDTO
 */
export interface ActiveInboundBoxesOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    purchaseOrderId?: string;
    /**
     * 
     * @type {number}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    inboundBoxLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    purchaseOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    waybillReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    waybillId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    targetedRecivingCompletionDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    operatorName?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    lastSeenAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    expectedDeliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    arrivedAt?: string;
    /**
     * 
     * @type {ReceivingState}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    state?: ReceivingState;
    /**
     * 
     * @type {PurchaseOrderSource}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    source?: PurchaseOrderSource;
    /**
     * 
     * @type {boolean}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    isPallet?: boolean;
    /**
     * 
     * @type {PalletState}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    palletState?: PalletState;
    /**
     * 
     * @type {number}
     * @memberof ActiveInboundBoxesOutputDTO
     */
    palletCount?: number;
}
/**
 * 
 * @export
 * @interface ActiveInboundBoxesOutputDTODynamicQueryOutputDTO
 */
export interface ActiveInboundBoxesOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ActiveInboundBoxesOutputDTO>}
     * @memberof ActiveInboundBoxesOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ActiveInboundBoxesOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ActiveInboundBoxesOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ActivePickingProcessesOutputDTO
 */
export interface ActivePickingProcessesOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof ActivePickingProcessesOutputDTO
     */
    pickingTrolleyId?: number;
    /**
     * 
     * @type {string}
     * @memberof ActivePickingProcessesOutputDTO
     */
    pickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivePickingProcessesOutputDTO
     */
    vehicleType?: string;
    /**
     * 
     * @type {number}
     * @memberof ActivePickingProcessesOutputDTO
     */
    vehicleToteCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ActivePickingProcessesOutputDTO
     */
    pickingStartedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivePickingProcessesOutputDTO
     */
    operatorFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivePickingProcessesOutputDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivePickingProcessesOutputDTO
     */
    lastSeenAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ActivePickingProcessesOutputDTO
     */
    pickingTrolleyPickedItemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ActivePickingProcessesOutputDTO
     */
    pickingTrolleyItemsCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ActivePickingProcessesOutputDTO
     */
    pickingZone?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivePickingProcessesOutputDTO
     */
    pickListId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivePickingProcessesOutputDTO
     */
    pickListName?: string;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof ActivePickingProcessesOutputDTO
     */
    pickingFlowTag?: PickingFlowTag;
    /**
     * 
     * @type {string}
     * @memberof ActivePickingProcessesOutputDTO
     */
    oldestSalesOrderSoldAt?: string;
    /**
     * 
     * @type {PickingMethod}
     * @memberof ActivePickingProcessesOutputDTO
     */
    pickingMethod?: PickingMethod;
    /**
     * 
     * @type {PickingType}
     * @memberof ActivePickingProcessesOutputDTO
     */
    pickingType?: PickingType;
}
/**
 * 
 * @export
 * @interface ActivePickingProcessesOutputDTODynamicQueryOutputDTO
 */
export interface ActivePickingProcessesOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ActivePickingProcessesOutputDTO>}
     * @memberof ActivePickingProcessesOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ActivePickingProcessesOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ActivePickingProcessesOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ActivePutAwayOutputDTO
 */
export interface ActivePutAwayOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ActivePutAwayOutputDTO
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof ActivePutAwayOutputDTO
     */
    vehicleToteCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ActivePutAwayOutputDTO
     */
    totalItemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ActivePutAwayOutputDTO
     */
    containedItemsCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ActivePutAwayOutputDTO
     */
    putAwayStartedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivePutAwayOutputDTO
     */
    operatorFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivePutAwayOutputDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivePutAwayOutputDTO
     */
    lastSeenAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ActivePutAwayOutputDTO
     */
    percentage?: number;
}
/**
 * 
 * @export
 * @interface ActivePutAwayOutputDTODynamicQueryOutputDTO
 */
export interface ActivePutAwayOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ActivePutAwayOutputDTO>}
     * @memberof ActivePutAwayOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ActivePutAwayOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ActivePutAwayOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ActiveStockCountingListsOutputDTO
 */
export interface ActiveStockCountingListsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ActiveStockCountingListsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveStockCountingListsOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ActiveStockCountingListsOutputDTO
     */
    referenceNumber?: number;
    /**
     * 
     * @type {StockCountingType}
     * @memberof ActiveStockCountingListsOutputDTO
     */
    stockCountingType?: StockCountingType;
    /**
     * 
     * @type {string}
     * @memberof ActiveStockCountingListsOutputDTO
     */
    processedByFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveStockCountingListsOutputDTO
     */
    startedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ActiveStockCountingListsOutputDTO
     */
    isPrioritized?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ActiveStockCountingListsOutputDTO
     */
    stockCountingListItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ActiveStockCountingListsOutputDTO
     */
    stockCountingListProcessedItemCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ActiveStockCountingListsOutputDTO
     */
    source?: string;
    /**
     * 
     * @type {number}
     * @memberof ActiveStockCountingListsOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof ActiveStockCountingListsOutputDTO
     */
    zoneName?: string;
    /**
     * 
     * @type {number}
     * @memberof ActiveStockCountingListsOutputDTO
     */
    stockCountingPlanReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof ActiveStockCountingListsOutputDTO
     */
    stockCountingPlanId?: string;
}
/**
 * 
 * @export
 * @interface ActiveStockCountingListsOutputDTODynamicQueryOutputDTO
 */
export interface ActiveStockCountingListsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ActiveStockCountingListsOutputDTO>}
     * @memberof ActiveStockCountingListsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ActiveStockCountingListsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ActiveStockCountingListsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ActiveTransferTrolleysOutputDTO
 */
export interface ActiveTransferTrolleysOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ActiveTransferTrolleysOutputDTO
     */
    transferTrolleyLabel?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof ActiveTransferTrolleysOutputDTO
     */
    trolleyType?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof ActiveTransferTrolleysOutputDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveTransferTrolleysOutputDTO
     */
    lastSeenAt?: string;
}
/**
 * 
 * @export
 * @interface ActiveTransferTrolleysOutputDTODynamicQueryOutputDTO
 */
export interface ActiveTransferTrolleysOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ActiveTransferTrolleysOutputDTO>}
     * @memberof ActiveTransferTrolleysOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ActiveTransferTrolleysOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ActiveTransferTrolleysOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ActiveWebReceivingProcessOutputDTO
 */
export interface ActiveWebReceivingProcessOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    purchaseOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    purchaseOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    waybillReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    waybillId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    inboundBoxLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    inboundAddressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    operatorName?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    lastSeenAt?: string;
    /**
     * 
     * @type {ReceivingState}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    state?: ReceivingState;
    /**
     * 
     * @type {PurchaseOrderSource}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    source?: PurchaseOrderSource;
    /**
     * 
     * @type {number}
     * @memberof ActiveWebReceivingProcessOutputDTO
     */
    palletCount?: number;
}
/**
 * 
 * @export
 * @interface ActiveWebReceivingProcessOutputDTODynamicQueryOutputDTO
 */
export interface ActiveWebReceivingProcessOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ActiveWebReceivingProcessOutputDTO>}
     * @memberof ActiveWebReceivingProcessOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ActiveWebReceivingProcessOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ActiveWebReceivingProcessOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ActualPickingItemState {
    CannotBePicked = 'CannotBePicked',
    PickedAsPlanned = 'PickedAsPlanned',
    PickedFromElsewhere = 'PickedFromElsewhere'
}

/**
 * 
 * @export
 * @interface AddAcceptedLineItemRecordsAndDeleteCommand
 */
export interface AddAcceptedLineItemRecordsAndDeleteCommand {
    /**
     * 
     * @type {string}
     * @memberof AddAcceptedLineItemRecordsAndDeleteCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddAcceptedLineItemRecordsAndDeleteCommand
     */
    purchaseOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AddAcceptedLineItemRecordsAndDeleteCommand
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof AddAcceptedLineItemRecordsAndDeleteCommand
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface AddAddPrinterActionCommand
 */
export interface AddAddPrinterActionCommand {
    /**
     * 
     * @type {string}
     * @memberof AddAddPrinterActionCommand
     */
    printerName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddAddPrinterActionCommand
     */
    selectedPrinterName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddAddPrinterActionCommand
     */
    machineName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddAddPrinterActionCommand
     */
    addressLabels?: Array<string>;
    /**
     * 
     * @type {PrinterTypes}
     * @memberof AddAddPrinterActionCommand
     */
    type?: PrinterTypes;
}
/**
 * 
 * @export
 * @interface AddAddressToCustomerCommand
 */
export interface AddAddressToCustomerCommand {
    /**
     * 
     * @type {string}
     * @memberof AddAddressToCustomerCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddAddressToCustomerCommand
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AddAddressToCustomerCommand
     */
    firstLine?: string;
    /**
     * 
     * @type {string}
     * @memberof AddAddressToCustomerCommand
     */
    secondLine?: string;
    /**
     * 
     * @type {string}
     * @memberof AddAddressToCustomerCommand
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof AddAddressToCustomerCommand
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof AddAddressToCustomerCommand
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof AddAddressToCustomerCommand
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof AddAddressToCustomerCommand
     */
    fullAddress?: string;
}
/**
 * 
 * @export
 * @interface AddAllUnassignedProductsToZoneCommand
 */
export interface AddAllUnassignedProductsToZoneCommand {
    /**
     * 
     * @type {string}
     * @memberof AddAllUnassignedProductsToZoneCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddAllUnassignedProductsToZoneCommand
     */
    zoneLabel?: string;
}
/**
 * 
 * @export
 * @interface AddBarcodeCommand
 */
export interface AddBarcodeCommand {
    /**
     * 
     * @type {string}
     * @memberof AddBarcodeCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddBarcodeCommand
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof AddBarcodeCommand
     */
    barcode?: string;
}
/**
 * 
 * @export
 * @interface AddCargoPackageCommand
 */
export interface AddCargoPackageCommand {
    /**
     * 
     * @type {string}
     * @memberof AddCargoPackageCommand
     */
    packingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof AddCargoPackageCommand
     */
    cargoPackageTypeBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof AddCargoPackageCommand
     */
    packageIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof AddCargoPackageCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface AddCargoPackageCommandOutputDTO
 */
export interface AddCargoPackageCommandOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof AddCargoPackageCommandOutputDTO
     */
    cargoPackageId?: number;
    /**
     * 
     * @type {number}
     * @memberof AddCargoPackageCommandOutputDTO
     */
    cargoPackageIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof AddCargoPackageCommandOutputDTO
     */
    cargoPackageLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof AddCargoPackageCommandOutputDTO
     */
    cargoPackageTotalCount?: number;
    /**
     *
     * @type {number}
     * @memberof AddCargoPackageCommandOutputDTO
     */
    sealedCargoPackageId?: number;
}
/**
 * 
 * @export
 * @interface AddCargoPackagesAndPrintCargoPackageLabelsCommand
 */
export interface AddCargoPackagesAndPrintCargoPackageLabelsCommand {
    /**
     * 
     * @type {string}
     * @memberof AddCargoPackagesAndPrintCargoPackageLabelsCommand
     */
    singleItemFastPackPackingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof AddCargoPackagesAndPrintCargoPackageLabelsCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof AddCargoPackagesAndPrintCargoPackageLabelsCommand
     */
    cargoPackageTypeBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof AddCargoPackagesAndPrintCargoPackageLabelsCommand
     */
    productId?: string;
}
/**
 * 
 * @export
 * @interface AddCargoPackagesAndPrintCargoPackageLabelsOutputDTO
 */
export interface AddCargoPackagesAndPrintCargoPackageLabelsOutputDTO {
    /**
     * 
     * @type {Array<SalesOrderLineItemOutputDTO>}
     * @memberof AddCargoPackagesAndPrintCargoPackageLabelsOutputDTO
     */
    cancelledSalesOrderLineItems?: Array<SalesOrderLineItemOutputDTO>;
    /**
     * 
     * @type {Array<SalesOrderCargoPackageLabelDTO>}
     * @memberof AddCargoPackagesAndPrintCargoPackageLabelsOutputDTO
     */
    referenceNumbersCargoPackages?: Array<SalesOrderCargoPackageLabelDTO>;
}
/**
 * 
 * @export
 * @interface AddCarrierPreferenceCommand
 */
export interface AddCarrierPreferenceCommand {
    /**
     * 
     * @type {string}
     * @memberof AddCarrierPreferenceCommand
     */
    operationId?: string;
    /**
     * 
     * @type {CarrierPreferenceInputDTO}
     * @memberof AddCarrierPreferenceCommand
     */
    carrierPreference?: CarrierPreferenceInputDTO;
}
/**
 * 
 * @export
 * @interface AddContainerToSalesOrderCommand
 */
export interface AddContainerToSalesOrderCommand {
    /**
     * 
     * @type {string}
     * @memberof AddContainerToSalesOrderCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddContainerToSalesOrderCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AddContainerToSalesOrderCommand
     */
    cargoPackageTypeBarcode?: string;
}
/**
 * 
 * @export
 * @interface AddContainerToSalesOrderOutputDTO
 */
export interface AddContainerToSalesOrderOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof AddContainerToSalesOrderOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof AddContainerToSalesOrderOutputDTO
     */
    containerId?: number;
    /**
     * 
     * @type {number}
     * @memberof AddContainerToSalesOrderOutputDTO
     */
    index?: number;
    /**
     * 
     * @type {string}
     * @memberof AddContainerToSalesOrderOutputDTO
     */
    cargoPackageTypeName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddContainerToSalesOrderOutputDTO
     */
    movedProductId?: string;
}
/**
 * 
 * @export
 * @interface AddCustomActionVasToSalesOrderCommand
 */
export interface AddCustomActionVasToSalesOrderCommand {
    /**
     * 
     * @type {Array<SalesOrderAddCustomVASInputDTO>}
     * @memberof AddCustomActionVasToSalesOrderCommand
     */
    customActionVasToSalesOrders?: Array<SalesOrderAddCustomVASInputDTO>;
}
/**
 * 
 * @export
 * @interface AddDeletePrinterActionCommand
 */
export interface AddDeletePrinterActionCommand {
    /**
     * 
     * @type {string}
     * @memberof AddDeletePrinterActionCommand
     */
    selectedPrinterName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddDeletePrinterActionCommand
     */
    machineName?: string;
}
/**
 * 
 * @export
 * @interface AddHOVCargoPackageCommand
 */
export interface AddHOVCargoPackageCommand {
    /**
     * 
     * @type {string}
     * @memberof AddHOVCargoPackageCommand
     */
    hovPackingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof AddHOVCargoPackageCommand
     */
    cargoPackageTypeBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof AddHOVCargoPackageCommand
     */
    packageIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof AddHOVCargoPackageCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface AddHOVCargoPackageCommandOutputDTO
 */
export interface AddHOVCargoPackageCommandOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof AddHOVCargoPackageCommandOutputDTO
     */
    sealedCargoPackageId?: number;
    /**
     * 
     * @type {number}
     * @memberof AddHOVCargoPackageCommandOutputDTO
     */
    cargoPackageId?: number;
    /**
     * 
     * @type {number}
     * @memberof AddHOVCargoPackageCommandOutputDTO
     */
    cargoPackageIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof AddHOVCargoPackageCommandOutputDTO
     */
    cargoPackageLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof AddHOVCargoPackageCommandOutputDTO
     */
    cargoPackageTotalCount?: number;
}
/**
 * 
 * @export
 * @interface AddLostItemToToteOutputDTO
 */
export interface AddLostItemToToteOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof AddLostItemToToteOutputDTO
     */
    isMissingApproveRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddLostItemToToteOutputDTO
     */
    missingProductId?: string;
    /**
     * 
     * @type {string}
     * @memberof AddLostItemToToteOutputDTO
     */
    missingProductSKU?: string;
    /**
     * 
     * @type {number}
     * @memberof AddLostItemToToteOutputDTO
     */
    missingCount?: number;
}
/**
 * 
 * @export
 * @interface AddManualVasRecordCommand
 */
export interface AddManualVasRecordCommand {
    /**
     * 
     * @type {ManualVasRecordInputDto}
     * @memberof AddManualVasRecordCommand
     */
    manualVasRecord?: ManualVasRecordInputDto;
}
/**
 * 
 * @export
 * @interface AddOrUpdateCargoPackageToQueueForSingleItemPackingCommand
 */
export interface AddOrUpdateCargoPackageToQueueForSingleItemPackingCommand {
    /**
     * 
     * @type {string}
     * @memberof AddOrUpdateCargoPackageToQueueForSingleItemPackingCommand
     */
    packingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof AddOrUpdateCargoPackageToQueueForSingleItemPackingCommand
     */
    cargoPackageTypeBarcode?: string;
}
/**
 * 
 * @export
 * @interface AddOrUpdatePutAwayCellRuleCommand
 */
export interface AddOrUpdatePutAwayCellRuleCommand {
    /**
     * 
     * @type {Array<PutAwayCellRuleInputDTO>}
     * @memberof AddOrUpdatePutAwayCellRuleCommand
     */
    putAwayCellRules?: Array<PutAwayCellRuleInputDTO>;
}
/**
 * 
 * @export
 * @interface AddPrinterAddressCommand
 */
export interface AddPrinterAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof AddPrinterAddressCommand
     */
    printerName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddPrinterAddressCommand
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface AddProductBarcodeOutputDTO
 */
export interface AddProductBarcodeOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof AddProductBarcodeOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof AddProductBarcodeOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof AddProductBarcodeOutputDTO
     */
    addedBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof AddProductBarcodeOutputDTO
     */
    barcodes?: string;
}
/**
 * 
 * @export
 * @interface AddProductStockZoneDTO
 */
export interface AddProductStockZoneDTO {
    /**
     * 
     * @type {string}
     * @memberof AddProductStockZoneDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof AddProductStockZoneDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddProductStockZoneDTO
     */
    sku?: string;
}
/**
 * 
 * @export
 * @interface AddProductStockZoneOutputDTO
 */
export interface AddProductStockZoneOutputDTO {
    /**
     * 
     * @type {Array<SuccessAddProductStockZoneOutputDTO>}
     * @memberof AddProductStockZoneOutputDTO
     */
    success?: Array<SuccessAddProductStockZoneOutputDTO>;
    /**
     * 
     * @type {Array<FailedAddProductStockZoneOutputDTO>}
     * @memberof AddProductStockZoneOutputDTO
     */
    failures?: Array<FailedAddProductStockZoneOutputDTO>;
}
/**
 * 
 * @export
 * @interface AddProductToZoneCommand
 */
export interface AddProductToZoneCommand {
    /**
     * 
     * @type {Array<AddProductStockZoneDTO>}
     * @memberof AddProductToZoneCommand
     */
    productStockZones?: Array<AddProductStockZoneDTO>;
}
/**
 * 
 * @export
 * @interface AddQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand
 */
export interface AddQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand {
    /**
     * 
     * @type {Array<CargoPackagesOutputDTO>}
     * @memberof AddQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand
     */
    cargoPackages?: Array<CargoPackagesOutputDTO>;
    /**
     * 
     * @type {string}
     * @memberof AddQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand
     */
    quarantineAddressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof AddQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand
     */
    salesOrderId?: string;
}
/**
 * 
 * @export
 * @interface AddQuarantineQuotaProblemDispatchedSalesOrderCommand
 */
export interface AddQuarantineQuotaProblemDispatchedSalesOrderCommand {
    /**
     * 
     * @type {Array<CargoPackagesOutputDTO>}
     * @memberof AddQuarantineQuotaProblemDispatchedSalesOrderCommand
     */
    cargoPackages?: Array<CargoPackagesOutputDTO>;
    /**
     * 
     * @type {string}
     * @memberof AddQuarantineQuotaProblemDispatchedSalesOrderCommand
     */
    quarantineAddressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof AddQuarantineQuotaProblemDispatchedSalesOrderCommand
     */
    salesOrderId?: string;
}
/**
 * 
 * @export
 * @interface AddQuarantineUnDispatchedSalesOrderCommand
 */
export interface AddQuarantineUnDispatchedSalesOrderCommand {
    /**
     * 
     * @type {string}
     * @memberof AddQuarantineUnDispatchedSalesOrderCommand
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof AddQuarantineUnDispatchedSalesOrderCommand
     */
    quarantineAddressLabel?: string;
    /**
     * 
     * @type {Array<CargoPackagesOutputDTO>}
     * @memberof AddQuarantineUnDispatchedSalesOrderCommand
     */
    cargoPackages?: Array<CargoPackagesOutputDTO>;
}
/**
 * 
 * @export
 * @interface AddReceivedItemCommand
 */
export interface AddReceivedItemCommand {
    /**
     * 
     * @type {string}
     * @memberof AddReceivedItemCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof AddReceivedItemCommand
     */
    palletLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof AddReceivedItemCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof AddReceivedItemCommand
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof AddReceivedItemCommand
     */
    lotNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof AddReceivedItemCommand
     */
    productAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AddReceivedItemCommand
     */
    force?: boolean;
}
/**
 * 
 * @export
 * @interface AddSalesOrderLostItemToToteCommand
 */
export interface AddSalesOrderLostItemToToteCommand {
    /**
     * 
     * @type {string}
     * @memberof AddSalesOrderLostItemToToteCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AddSalesOrderLostItemToToteCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddSalesOrderLostItemToToteCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface AddSimpleCargoPackageCommand
 */
export interface AddSimpleCargoPackageCommand {
    /**
     * 
     * @type {string}
     * @memberof AddSimpleCargoPackageCommand
     */
    packingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof AddSimpleCargoPackageCommand
     */
    cargoPackageTypeBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof AddSimpleCargoPackageCommand
     */
    packageIndex?: number;
}
/**
 * 
 * @export
 * @interface AddVasConditionCommand
 */
export interface AddVasConditionCommand {
    /**
     * 
     * @type {VasConditionInputDTO}
     * @memberof AddVasConditionCommand
     */
    vasCondition?: VasConditionInputDTO;
}
/**
 * 
 * @export
 * @interface AddVasDefinitionCommand
 */
export interface AddVasDefinitionCommand {
    /**
     * 
     * @type {VasDefinitionInputDTO}
     * @memberof AddVasDefinitionCommand
     */
    vasDefinition?: VasDefinitionInputDTO;
}
/**
 * 
 * @export
 * @interface AddVasDocumentUrlCommand
 */
export interface AddVasDocumentUrlCommand {
    /**
     * 
     * @type {string}
     * @memberof AddVasDocumentUrlCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddVasDocumentUrlCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AddVasDocumentUrlCommand
     */
    vasDocumentUrl?: string;
}
/**
 * 
 * @export
 * @interface AddVasDocumentUrlOutputDTO
 */
export interface AddVasDocumentUrlOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof AddVasDocumentUrlOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof AddVasDocumentUrlOutputDTO
     */
    vasId?: number;
    /**
     * 
     * @type {string}
     * @memberof AddVasDocumentUrlOutputDTO
     */
    vasDocumentUrl?: string;
}
/**
 * 
 * @export
 * @interface AddWaybillImageCommand
 */
export interface AddWaybillImageCommand {
    /**
     * 
     * @type {string}
     * @memberof AddWaybillImageCommand
     */
    waybillId?: string;
    /**
     * 
     * @type {string}
     * @memberof AddWaybillImageCommand
     */
    imageUrl?: string;
}
/**
 * 
 * @export
 * @interface AddressComponentInputDTO
 */
export interface AddressComponentInputDTO {
    /**
     * 
     * @type {string}
     * @memberof AddressComponentInputDTO
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof AddressComponentInputDTO
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof AddressComponentInputDTO
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof AddressComponentInputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AddressFamily {
    Unknown = 'Unknown',
    Unspecified = 'Unspecified',
    Unix = 'Unix',
    InterNetwork = 'InterNetwork',
    ImpLink = 'ImpLink',
    Pup = 'Pup',
    Chaos = 'Chaos',
    Ns = 'NS',
    Ipx = 'Ipx',
    Iso = 'Iso',
    Osi = 'Osi',
    Ecma = 'Ecma',
    DataKit = 'DataKit',
    Ccitt = 'Ccitt',
    Sna = 'Sna',
    DecNet = 'DecNet',
    DataLink = 'DataLink',
    Lat = 'Lat',
    HyperChannel = 'HyperChannel',
    AppleTalk = 'AppleTalk',
    NetBios = 'NetBios',
    VoiceView = 'VoiceView',
    FireFox = 'FireFox',
    Banyan = 'Banyan',
    Atm = 'Atm',
    InterNetworkV6 = 'InterNetworkV6',
    Cluster = 'Cluster',
    Ieee12844 = 'Ieee12844',
    Irda = 'Irda',
    NetworkDesigners = 'NetworkDesigners',
    Max = 'Max',
    Packet = 'Packet',
    ControllerAreaNetwork = 'ControllerAreaNetwork'
}

/**
 * 
 * @export
 * @interface AddressQueryOutputDTO
 */
export interface AddressQueryOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof AddressQueryOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AddressQueryOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressQueryOutputDTO
     */
    labelFormat?: string;
    /**
     * 
     * @type {AddressType}
     * @memberof AddressQueryOutputDTO
     */
    type?: AddressType;
    /**
     * 
     * @type {string}
     * @memberof AddressQueryOutputDTO
     */
    section?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressQueryOutputDTO
     */
    side?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressQueryOutputDTO
     */
    slot?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressQueryOutputDTO
     */
    level?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressQueryOutputDTO
     */
    depth?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressQueryOutputDTO
     */
    index?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressQueryOutputDTO
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressQueryOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface AddressQueryOutputDTODynamicQueryOutputDTO
 */
export interface AddressQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<AddressQueryOutputDTO>}
     * @memberof AddressQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<AddressQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof AddressQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AddressType {
    None = 'None',
    DispatchAddress = 'DispatchAddress',
    InboundAddress = 'InboundAddress',
    LostItemAddress = 'LostItemAddress',
    PackingAddress = 'PackingAddress',
    ParkAddress = 'ParkAddress',
    ReturnAddress = 'ReturnAddress',
    StockAddress = 'StockAddress',
    PickingTrolley = 'PickingTrolley',
    PutAwayTrolley = 'PutAwayTrolley',
    ReturnTrolley = 'ReturnTrolley',
    SlamAddress = 'SLAMAddress',
    ProblemSolverAddress = 'ProblemSolverAddress',
    QuarantineAddress = 'QuarantineAddress',
    TransferTrolley = 'TransferTrolley',
    MissingItemTransferAddress = 'MissingItemTransferAddress',
    SingleItemPackingAddress = 'SingleItemPackingAddress',
    DropAddress = 'DropAddress',
    ReceivingAddress = 'ReceivingAddress',
    ManualDeliveryAddress = 'ManualDeliveryAddress',
    HovPackingAddress = 'HOVPackingAddress',
    RebinAddress = 'RebinAddress',
    RebinSingleAddress = 'RebinSingleAddress',
    BatchTrolley = 'BatchTrolley',
    RebinTrolley = 'RebinTrolley',
    VirtualTrolley = 'VirtualTrolley',
    SimplePackingAddress = 'SimplePackingAddress',
    RasDropAddress = 'RasDropAddress',
    RasPickStation = 'RasPickStation',
    RasStowStation = 'RasStowStation',
    HoldingZoneAddress = 'HoldingZoneAddress',
    HovRebinAddress = 'HOVRebinAddress',
    ApprovedSlamAddress = 'ApprovedSLAMAddress',
    SingleItemFastPackPackingAddress = 'SingleItemFastPackPackingAddress',
    RasOrderBasedPickStation = 'RasOrderBasedPickStation',
    WallPackingAddress = 'WallPackingAddress',
    RasProblemSolverStation = 'RasProblemSolverStation'
}

/**
 * 
 * @export
 * @interface AddressTypeOutputDTO
 */
export interface AddressTypeOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof AddressTypeOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AddressTypeOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressTypeOutputDTO
     */
    discriminator?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddressTypeOutputDTO
     */
    isPrintAdditionalPackageLabel?: boolean;
}
/**
 * 
 * @export
 * @interface AdjustCellStockCommand
 */
export interface AdjustCellStockCommand {
    /**
     * 
     * @type {string}
     * @memberof AdjustCellStockCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {Array<AdjustCellStockProductInputDTO>}
     * @memberof AdjustCellStockCommand
     */
    productAmounts?: Array<AdjustCellStockProductInputDTO>;
}
/**
 * 
 * @export
 * @interface AdjustCellStockProductInputDTO
 */
export interface AdjustCellStockProductInputDTO {
    /**
     * 
     * @type {string}
     * @memberof AdjustCellStockProductInputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {number}
     * @memberof AdjustCellStockProductInputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface AffectedProductDTO
 */
export interface AffectedProductDTO {
    /**
     * 
     * @type {string}
     * @memberof AffectedProductDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof AffectedProductDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof AffectedProductDTO
     */
    itemType?: string;
    /**
     * 
     * @type {number}
     * @memberof AffectedProductDTO
     */
    deletedQuantity?: number;
}
/**
 * 
 * @export
 * @interface AlternateSourceCellOutputDTO
 */
export interface AlternateSourceCellOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof AlternateSourceCellOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof AlternateSourceCellOutputDTO
     */
    availableAmount?: number;
}
/**
 * 
 * @export
 * @interface ApplicationEventPayloadSchemaOutputDTO
 */
export interface ApplicationEventPayloadSchemaOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ApplicationEventPayloadSchemaOutputDTO
     */
    $id?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplicationEventPayloadSchemaOutputDTO
     */
    type?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: ApplicationEventPayloadSchemaOutputDTO; }}
     * @memberof ApplicationEventPayloadSchemaOutputDTO
     */
    properties?: { [key: string]: ApplicationEventPayloadSchemaOutputDTO; };
    /**
     * 
     * @type {{ [key: string]: ApplicationEventPayloadSchemaOutputDTO; }}
     * @memberof ApplicationEventPayloadSchemaOutputDTO
     */
    items?: { [key: string]: ApplicationEventPayloadSchemaOutputDTO; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplicationEventPayloadSchemaOutputDTO
     */
    required?: Array<string>;
}
/**
 * 
 * @export
 * @interface ApplyClause
 */
export interface ApplyClause {
    /**
     * 
     * @type {Array<TransformationNode>}
     * @memberof ApplyClause
     */
    transformations?: Array<TransformationNode>;
}
/**
 * 
 * @export
 * @interface ApplyQueryOption
 */
export interface ApplyQueryOption {
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof ApplyQueryOption
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {string}
     * @memberof ApplyQueryOption
     */
    resultClrType?: string;
    /**
     * 
     * @type {ApplyClause}
     * @memberof ApplyQueryOption
     */
    applyClause?: ApplyClause;
    /**
     * 
     * @type {string}
     * @memberof ApplyQueryOption
     */
    rawValue?: string;
}
/**
 * 
 * @export
 * @interface ApplyWallToWallStockCountingPlanToStockCommand
 */
export interface ApplyWallToWallStockCountingPlanToStockCommand {
    /**
     * 
     * @type {string}
     * @memberof ApplyWallToWallStockCountingPlanToStockCommand
     */
    stockCountingPlanId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplyWallToWallStockCountingPlanToStockCommand
     */
    includeInProgressPlans?: boolean;
}
/**
 * 
 * @export
 * @interface ApplyWallToWallStockCountingResultsCommand
 */
export interface ApplyWallToWallStockCountingResultsCommand {
    /**
     * 
     * @type {string}
     * @memberof ApplyWallToWallStockCountingResultsCommand
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyWallToWallStockCountingResultsCommand
     */
    stockCountingId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyWallToWallStockCountingResultsCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyWallToWallStockCountingResultsCommand
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyWallToWallStockCountingResultsCommand
     */
    barcode?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplyWallToWallStockCountingResultsCommand
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplyWallToWallStockCountingResultsCommand
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyWallToWallStockCountingResultsCommand
     */
    lotNumber?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplyWallToWallStockCountingResultsCommand
     */
    serialNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface ApproveSalesOrderDispatchCommand
 */
export interface ApproveSalesOrderDispatchCommand {
    /**
     * 
     * @type {string}
     * @memberof ApproveSalesOrderDispatchCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveSalesOrderDispatchCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveSalesOrderDispatchCommand
     */
    asn?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveSalesOrderDispatchCommand
     */
    invoiceUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveSalesOrderDispatchCommand
     */
    shippingAddressFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveSalesOrderDispatchCommand
     */
    shippingAddressPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveSalesOrderDispatchCommand
     */
    shippingAddressEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveSalesOrderDispatchCommand
     */
    shippingAddressCity?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveSalesOrderDispatchCommand
     */
    shippingAddressDistrict?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveSalesOrderDispatchCommand
     */
    shippingAddressFullAddress?: string;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof ApproveSalesOrderDispatchCommand
     */
    deliveryType?: DeliveryTypeTag;
}
/**
 * 
 * @export
 * @interface ArrivedReturnPackageQueryOutputDTO
 */
export interface ArrivedReturnPackageQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ArrivedReturnPackageQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ArrivedReturnPackageQueryOutputDTO
     */
    trackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof ArrivedReturnPackageQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ArrivedReturnPackageQueryOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ArrivedReturnPackageQueryOutputDTO
     */
    cargoTrackingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ArrivedReturnPackageQueryOutputDTO
     */
    arrivedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ArrivedReturnPackageQueryOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof ArrivedReturnPackageQueryOutputDTO
     */
    operation?: OperationOutputDTO;
}
/**
 * 
 * @export
 * @interface ArrivedReturnPackageQueryOutputDTODynamicQueryOutputDTO
 */
export interface ArrivedReturnPackageQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ArrivedReturnPackageQueryOutputDTO>}
     * @memberof ArrivedReturnPackageQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ArrivedReturnPackageQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ArrivedReturnPackageQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface AsnEncodedData
 */
export interface AsnEncodedData {
    /**
     * 
     * @type {Oid}
     * @memberof AsnEncodedData
     */
    oid?: Oid;
    /**
     * 
     * @type {string}
     * @memberof AsnEncodedData
     */
    rawData?: string;
}
/**
 * 
 * @export
 * @interface AssignAddressesToSubZoneCommand
 */
export interface AssignAddressesToSubZoneCommand {
    /**
     * 
     * @type {number}
     * @memberof AssignAddressesToSubZoneCommand
     */
    subZoneId?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignAddressesToSubZoneCommand
     */
    addressLabels?: Array<string>;
}
/**
 * 
 * @export
 * @interface AssignHOVQuarantineToteCommand
 */
export interface AssignHOVQuarantineToteCommand {
    /**
     * 
     * @type {string}
     * @memberof AssignHOVQuarantineToteCommand
     */
    packingQuarantineProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignHOVQuarantineToteCommand
     */
    quarantinetoteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignHOVQuarantineToteCommand
     */
    hovPackingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface AssignNewAddressesToPlanCommand
 */
export interface AssignNewAddressesToPlanCommand {
    /**
     * 
     * @type {string}
     * @memberof AssignNewAddressesToPlanCommand
     */
    stockCountingPlanId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignNewAddressesToPlanCommand
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof AssignNewAddressesToPlanCommand
     */
    cellIds?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof AssignNewAddressesToPlanCommand
     */
    createNewList?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssignNewAddressesToPlanCommand
     */
    allowManualEntry?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssignNewAddressesToPlanCommand
     */
    isSignificant?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AssignNewAddressesToPlanCommand
     */
    minCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof AssignNewAddressesToPlanCommand
     */
    totalListCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AssignNewAddressesToPlanCommand
     */
    addressCountPerList?: number;
}
/**
 * 
 * @export
 * @interface AssignPalletBarcodeToWaybillCommand
 */
export interface AssignPalletBarcodeToWaybillCommand {
    /**
     * 
     * @type {string}
     * @memberof AssignPalletBarcodeToWaybillCommand
     */
    purchaseOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignPalletBarcodeToWaybillCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignPalletBarcodeToWaybillCommand
     */
    palletBarcode?: string;
}
/**
 * 
 * @export
 * @interface AssignQuarantineToteCommand
 */
export interface AssignQuarantineToteCommand {
    /**
     * 
     * @type {string}
     * @memberof AssignQuarantineToteCommand
     */
    packingQuarantineProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignQuarantineToteCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignQuarantineToteCommand
     */
    packingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface AssignRebinTrolleyCommand
 */
export interface AssignRebinTrolleyCommand {
    /**
     * 
     * @type {number}
     * @memberof AssignRebinTrolleyCommand
     */
    sortingProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof AssignRebinTrolleyCommand
     */
    rebinTrolleyLabel?: string;
}
/**
 * 
 * @export
 * @interface AssignStockCellTypeCommand
 */
export interface AssignStockCellTypeCommand {
    /**
     * 
     * @type {Array<StockCellTypeAssignmentInputDTO>}
     * @memberof AssignStockCellTypeCommand
     */
    assignments?: Array<StockCellTypeAssignmentInputDTO>;
}
/**
 * 
 * @export
 * @interface AssignToWallToWallStockCountingPlanCommand
 */
export interface AssignToWallToWallStockCountingPlanCommand {
    /**
     * 
     * @type {string}
     * @memberof AssignToWallToWallStockCountingPlanCommand
     */
    stockCountingPlanId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignToWallToWallStockCountingPlanCommand
     */
    stockCountingPlanName?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof AssignToWallToWallStockCountingPlanCommand
     */
    cellIds?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof AssignToWallToWallStockCountingPlanCommand
     */
    allowManualEntry?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssignToWallToWallStockCountingPlanCommand
     */
    isSignificant?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AssignToWallToWallStockCountingPlanCommand
     */
    totalListCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AssignToWallToWallStockCountingPlanCommand
     */
    addressCountPerList?: number;
    /**
     * 
     * @type {number}
     * @memberof AssignToWallToWallStockCountingPlanCommand
     */
    minCountingAmount?: number;
}
/**
 * 
 * @export
 * @interface AsymmetricAlgorithm
 */
export interface AsymmetricAlgorithm {
    /**
     * 
     * @type {number}
     * @memberof AsymmetricAlgorithm
     */
    keySize?: number;
    /**
     * 
     * @type {Array<KeySizes>}
     * @memberof AsymmetricAlgorithm
     */
    legalKeySizes?: Array<KeySizes>;
    /**
     * 
     * @type {string}
     * @memberof AsymmetricAlgorithm
     */
    signatureAlgorithm?: string;
    /**
     * 
     * @type {string}
     * @memberof AsymmetricAlgorithm
     */
    keyExchangeAlgorithm?: string;
}
/**
 * 
 * @export
 * @interface AutoScaleTestCommand
 */
export interface AutoScaleTestCommand {
    /**
     * 
     * @type {OperationType}
     * @memberof AutoScaleTestCommand
     */
    operationType?: OperationType;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AutomaticStockCountingState {
    None = 'None',
    Created = 'Created',
    InProgress = 'InProgress',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum Availability {
    Available = 'Available',
    NotAvailable = 'NotAvailable'
}

/**
 * 
 * @export
 * @interface AvailablePickingTrolleysOutputDTO
 */
export interface AvailablePickingTrolleysOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof AvailablePickingTrolleysOutputDTO
     */
    pickingTrolleyId?: number;
    /**
     * 
     * @type {string}
     * @memberof AvailablePickingTrolleysOutputDTO
     */
    pickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailablePickingTrolleysOutputDTO
     */
    vehicleType?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailablePickingTrolleysOutputDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailablePickingTrolleysOutputDTO
     */
    lastSeenAt?: string;
    /**
     * 
     * @type {number}
     * @memberof AvailablePickingTrolleysOutputDTO
     */
    vehicleToteCount?: number;
    /**
     * 
     * @type {string}
     * @memberof AvailablePickingTrolleysOutputDTO
     */
    stagedZone?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailablePickingTrolleysOutputDTO
     */
    stagedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof AvailablePickingTrolleysOutputDTO
     */
    stagedSalesOrderCount?: number;
}
/**
 * 
 * @export
 * @interface AvailablePickingTrolleysOutputDTODynamicQueryOutputDTO
 */
export interface AvailablePickingTrolleysOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<AvailablePickingTrolleysOutputDTO>}
     * @memberof AvailablePickingTrolleysOutputDTODynamicQueryOutputDTO
     */
    data?: Array<AvailablePickingTrolleysOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof AvailablePickingTrolleysOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface AvailablePutAwayTrolleysOutputDTO
 */
export interface AvailablePutAwayTrolleysOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof AvailablePutAwayTrolleysOutputDTO
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailablePutAwayTrolleysOutputDTO
     */
    currentAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailablePutAwayTrolleysOutputDTO
     */
    parkingAt?: string;
}
/**
 * 
 * @export
 * @interface AvailablePutAwayTrolleysOutputDTODynamicQueryOutputDTO
 */
export interface AvailablePutAwayTrolleysOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<AvailablePutAwayTrolleysOutputDTO>}
     * @memberof AvailablePutAwayTrolleysOutputDTODynamicQueryOutputDTO
     */
    data?: Array<AvailablePutAwayTrolleysOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof AvailablePutAwayTrolleysOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface BarcodeActionInfo
 */
export interface BarcodeActionInfo {
    /**
     * 
     * @type {string}
     * @memberof BarcodeActionInfo
     */
    originalBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof BarcodeActionInfo
     */
    action?: string;
    /**
     * 
     * @type {string}
     * @memberof BarcodeActionInfo
     */
    newBarcode?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum BarcodeType {
    None = 'None',
    Cell = 'Cell',
    Product = 'Product',
    Tote = 'Tote',
    MasterCarton = 'MasterCarton'
}

/**
 * 
 * @export
 * @interface BarcodeTypeOutputDTO
 */
export interface BarcodeTypeOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof BarcodeTypeOutputDTO
     */
    isSalesOrder?: boolean;
    /**
     * 
     * @type {Array<SalesOrderOperationOutputDTO>}
     * @memberof BarcodeTypeOutputDTO
     */
    salesOrdersWithOperation?: Array<SalesOrderOperationOutputDTO>;
    /**
     * 
     * @type {Array<ProblemOperationOutputDTO>}
     * @memberof BarcodeTypeOutputDTO
     */
    problemsWithOperation?: Array<ProblemOperationOutputDTO>;
}
/**
 * 
 * @export
 * @interface BatchPackingStateDetailsOutputDTO
 */
export interface BatchPackingStateDetailsOutputDTO {
    /**
     * 
     * @type {BatchPickingPackingState}
     * @memberof BatchPackingStateDetailsOutputDTO
     */
    state?: BatchPickingPackingState;
    /**
     * 
     * @type {string}
     * @memberof BatchPackingStateDetailsOutputDTO
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchPackingStateDetailsOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchPackingStateDetailsOutputDTO
     */
    doneByFullName?: string;
}
/**
 * 
 * @export
 * @interface BatchPickingConfigurationDTO
 */
export interface BatchPickingConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof BatchPickingConfigurationDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BatchPickingConfigurationDTO
     */
    isBatchActiveForZone?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingConfigurationDTO
     */
    rebinVolumeCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingConfigurationDTO
     */
    rebinVolumeThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingConfigurationDTO
     */
    rebinSalesOrderCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingConfigurationDTO
     */
    pickListPickingDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingConfigurationDTO
     */
    pickListPickingDurationThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingConfigurationDTO
     */
    durationBetweenAddresses?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingConfigurationDTO
     */
    durationBetweenAisles?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingConfigurationDTO
     */
    productPickingDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingConfigurationDTO
     */
    specialProductPickingDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingConfigurationDTO
     */
    toteVolumeCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingConfigurationDTO
     */
    toteVolumeThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingConfigurationDTO
     */
    toteWeightCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingConfigurationDTO
     */
    batchTrolleyToteCountLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingConfigurationDTO
     */
    batchPickingTrolleyToteCountLimit?: number;
    /**
     * 
     * @type {RebinVolumeConfigType}
     * @memberof BatchPickingConfigurationDTO
     */
    rebinVolumeConfigType?: RebinVolumeConfigType;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingConfigurationDTO
     */
    maxAmountOfItemsPerPickList?: number;
}
/**
 * 
 * @export
 * @interface BatchPickingLostItemCommand
 */
export interface BatchPickingLostItemCommand {
    /**
     * 
     * @type {number}
     * @memberof BatchPickingLostItemCommand
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof BatchPickingLostItemCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchPickingLostItemCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingLostItemCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum BatchPickingPackingState {
    None = 'None',
    Started = 'Started',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum BatchPickingPickingState {
    None = 'None',
    Started = 'Started',
    CompletedWithLostItems = 'CompletedWithLostItems',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @interface BatchPickingPicklistDetailsOutputDTO
 */
export interface BatchPickingPicklistDetailsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof BatchPickingPicklistDetailsOutputDTO
     */
    salesOrderCount?: number;
    /**
     * 
     * @type {string}
     * @memberof BatchPickingPicklistDetailsOutputDTO
     */
    zoneName?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchPickingPicklistDetailsOutputDTO
     */
    pickingFlow?: string;
}
/**
 * 
 * @export
 * @interface BatchPickingProductDetailOutputDTO
 */
export interface BatchPickingProductDetailOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof BatchPickingProductDetailOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchPickingProductDetailOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchPickingProductDetailOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchPickingProductDetailOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchPickingProductDetailOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof BatchPickingProductDetailOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {ToteDetailsOutputDTO}
     * @memberof BatchPickingProductDetailOutputDTO
     */
    toteDetails?: ToteDetailsOutputDTO;
}
/**
 * 
 * @export
 * @interface BatchPickingProductDetailWithToteOutputDTO
 */
export interface BatchPickingProductDetailWithToteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof BatchPickingProductDetailWithToteOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchPickingProductDetailWithToteOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchPickingProductDetailWithToteOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchPickingProductDetailWithToteOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchPickingProductDetailWithToteOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof BatchPickingProductDetailWithToteOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof BatchPickingProductDetailWithToteOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof BatchPickingProductDetailWithToteOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {RebinTrolleySide}
     * @memberof BatchPickingProductDetailWithToteOutputDTO
     */
    rebinTrolleySide?: RebinTrolleySide;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum BatchPickingSortingState {
    None = 'None',
    Started = 'Started',
    CompletedWithLostItems = 'CompletedWithLostItems',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum BatchPickingState {
    None = 'None',
    Sorting = 'Sorting',
    Packing = 'Packing',
    Packed = 'Packed'
}

/**
 * 
 * @export
 * @interface BatchPickingStateDetailsOutputDTO
 */
export interface BatchPickingStateDetailsOutputDTO {
    /**
     * 
     * @type {BatchPickingPickingState}
     * @memberof BatchPickingStateDetailsOutputDTO
     */
    state?: BatchPickingPickingState;
    /**
     * 
     * @type {string}
     * @memberof BatchPickingStateDetailsOutputDTO
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchPickingStateDetailsOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchPickingStateDetailsOutputDTO
     */
    doneByFullName?: string;
}
/**
 * 
 * @export
 * @interface BatchSortingStateDetailsOutputDTO
 */
export interface BatchSortingStateDetailsOutputDTO {
    /**
     * 
     * @type {BatchPickingSortingState}
     * @memberof BatchSortingStateDetailsOutputDTO
     */
    state?: BatchPickingSortingState;
    /**
     * 
     * @type {string}
     * @memberof BatchSortingStateDetailsOutputDTO
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchSortingStateDetailsOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchSortingStateDetailsOutputDTO
     */
    doneByFullName?: string;
}
/**
 * 
 * @export
 * @interface BatchTrolleyDetailsOutputDTO
 */
export interface BatchTrolleyDetailsOutputDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchTrolleyDetailsOutputDTO
     */
    totes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BatchTrolleyDetailsOutputDTO
     */
    batchPickingName?: string;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof BatchTrolleyDetailsOutputDTO
     */
    pickingFlowTag?: PickingFlowTag;
    /**
     * 
     * @type {string}
     * @memberof BatchTrolleyDetailsOutputDTO
     */
    currentUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchTrolleyDetailsOutputDTO
     */
    currentUserFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchTrolleyDetailsOutputDTO
     */
    currentRebinAddress?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum BatchTrolleyState {
    None = 'None',
    Available = 'Available',
    Loading = 'Loading',
    LoadingCompleted = 'LoadingCompleted',
    Sorting = 'Sorting',
    SortingCompleted = 'SortingCompleted'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum BatchType {
    None = 'None',
    ItemBase = 'ItemBase',
    OrderBase = 'OrderBase'
}

/**
 * 
 * @export
 * @interface BlobActionInputDTO
 */
export interface BlobActionInputDTO {
    /**
     * 
     * @type {string}
     * @memberof BlobActionInputDTO
     */
    storageConnectionString?: string;
    /**
     * 
     * @type {string}
     * @memberof BlobActionInputDTO
     */
    blobContainerName?: string;
    /**
     * 
     * @type {string}
     * @memberof BlobActionInputDTO
     */
    url?: string;
    /**
     * 
     * @type {HttpMethod}
     * @memberof BlobActionInputDTO
     */
    method?: HttpMethod;
    /**
     * 
     * @type {string}
     * @memberof BlobActionInputDTO
     */
    headers?: string;
    /**
     * 
     * @type {string}
     * @memberof BlobActionInputDTO
     */
    body?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum BlockingErrorType {
    None = 'None',
    ExpirationDateConflict = 'ExpirationDateConflict'
}

/**
 * 
 * @export
 * @interface BulkCreateMasterCartonCommand
 */
export interface BulkCreateMasterCartonCommand {
    /**
     * 
     * @type {Array<CreateMasterCartonCommand>}
     * @memberof BulkCreateMasterCartonCommand
     */
    masterCartons?: Array<CreateMasterCartonCommand>;
}
/**
 * 
 * @export
 * @interface BulkCreateMasterCartonCommandOutputDTO
 */
export interface BulkCreateMasterCartonCommandOutputDTO {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BulkCreateMasterCartonCommandOutputDTO
     */
    failures?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkCreateMasterCartonCommandOutputDTO
     */
    successful?: Array<string>;
}
/**
 * 
 * @export
 * @interface BulkCreateProductCommand
 */
export interface BulkCreateProductCommand {
    /**
     * 
     * @type {Array<CreateProductCommand>}
     * @memberof BulkCreateProductCommand
     */
    products?: Array<CreateProductCommand>;
}
/**
 * 
 * @export
 * @interface BulkCreateProductCommandOutputDTO
 */
export interface BulkCreateProductCommandOutputDTO {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BulkCreateProductCommandOutputDTO
     */
    failures?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkCreateProductCommandOutputDTO
     */
    successful?: Array<string>;
}
/**
 * 
 * @export
 * @interface BulkCreateSalesOrderWithCustomerCommand
 */
export interface BulkCreateSalesOrderWithCustomerCommand {
    /**
     * 
     * @type {Array<CreateSalesOrderWithCustomerCommand>}
     * @memberof BulkCreateSalesOrderWithCustomerCommand
     */
    salesOrders?: Array<CreateSalesOrderWithCustomerCommand>;
}
/**
 * 
 * @export
 * @interface BulkCreateSalesOrderWithCustomerCommandOutputDTO
 */
export interface BulkCreateSalesOrderWithCustomerCommandOutputDTO {
    /**
     * 
     * @type {{ [key: string]: CreateSalesOrderOpenAPIQueueCodes; }}
     * @memberof BulkCreateSalesOrderWithCustomerCommandOutputDTO
     */
    results?: { [key: string]: CreateSalesOrderOpenAPIQueueCodes; };
}
/**
 * 
 * @export
 * @interface BulkCreateStockZonesCommand
 */
export interface BulkCreateStockZonesCommand {
    /**
     * 
     * @type {Array<CreateStockZoneInputDTO>}
     * @memberof BulkCreateStockZonesCommand
     */
    stockZones?: Array<CreateStockZoneInputDTO>;
}
/**
 * 
 * @export
 * @interface BulkCreateStockZonesOutputDTO
 */
export interface BulkCreateStockZonesOutputDTO {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BulkCreateStockZonesOutputDTO
     */
    failedZones?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkCreateStockZonesOutputDTO
     */
    successZones?: Array<string>;
    /**
     * 
     * @type {Array<CreateStockZonesOutputDTO>}
     * @memberof BulkCreateStockZonesOutputDTO
     */
    createStockZonesOutputDTO?: Array<CreateStockZonesOutputDTO>;
}
/**
 * 
 * @export
 * @interface BulkDeleteContainerInventoryItemsCommand
 */
export interface BulkDeleteContainerInventoryItemsCommand {
    /**
     * 
     * @type {string}
     * @memberof BulkDeleteContainerInventoryItemsCommand
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkDeleteContainerInventoryItemsCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkDeleteContainerInventoryItemsCommand
     */
    itemType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDeleteContainerInventoryItemsCommand
     */
    confirmDeletion?: boolean;
}
/**
 * 
 * @export
 * @interface BulkDeleteInventoryItemsOutputDTO
 */
export interface BulkDeleteInventoryItemsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof BulkDeleteInventoryItemsOutputDTO
     */
    deletedCount?: number;
    /**
     * 
     * @type {string}
     * @memberof BulkDeleteInventoryItemsOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkDeleteInventoryItemsOutputDTO
     */
    itemType?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkDeleteInventoryItemsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {Array<AffectedProductDTO>}
     * @memberof BulkDeleteInventoryItemsOutputDTO
     */
    affectedProducts?: Array<AffectedProductDTO>;
    /**
     * 
     * @type {ContainerStatusDTO}
     * @memberof BulkDeleteInventoryItemsOutputDTO
     */
    containerStatus?: ContainerStatusDTO;
}
/**
 * 
 * @export
 * @interface BulkSoftDeleteContainersCommand
 */
export interface BulkSoftDeleteContainersCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkSoftDeleteContainersCommand
     */
    containerLabels?: Array<string>;
}
/**
 * 
 * @export
 * @interface BulkSoftDeleteContainersOutputDTO
 */
export interface BulkSoftDeleteContainersOutputDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkSoftDeleteContainersOutputDTO
     */
    successfulContainers?: Array<string>;
    /**
     * 
     * @type {Array<SkippedContainerInfo>}
     * @memberof BulkSoftDeleteContainersOutputDTO
     */
    skippedContainers?: Array<SkippedContainerInfo>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkSoftDeleteContainersOutputDTO
     */
    notFoundContainers?: Array<string>;
    /**
     * 
     * @type {Array<FailedContainerInfo>}
     * @memberof BulkSoftDeleteContainersOutputDTO
     */
    failedContainers?: Array<FailedContainerInfo>;
    /**
     * 
     * @type {number}
     * @memberof BulkSoftDeleteContainersOutputDTO
     */
    deletedContainersCount?: number;
}
/**
 * 
 * @export
 * @interface BulkSycnCompleteReturnCommand
 */
export interface BulkSycnCompleteReturnCommand {
    /**
     * 
     * @type {Array<SyncReturnCompleteInputDTO>}
     * @memberof BulkSycnCompleteReturnCommand
     */
    completedReturnList?: Array<SyncReturnCompleteInputDTO>;
}
/**
 * 
 * @export
 * @interface BulkSyncOperationPurchaseOrdersCommand
 */
export interface BulkSyncOperationPurchaseOrdersCommand {
    /**
     * 
     * @type {string}
     * @memberof BulkSyncOperationPurchaseOrdersCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkSyncOperationPurchaseOrdersCommand
     */
    date?: string;
}
/**
 * 
 * @export
 * @interface BulkSyncOperationReturnRequestsCommand
 */
export interface BulkSyncOperationReturnRequestsCommand {
    /**
     * 
     * @type {string}
     * @memberof BulkSyncOperationReturnRequestsCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkSyncOperationReturnRequestsCommand
     */
    date?: string;
}
/**
 * 
 * @export
 * @interface BulkSyncOperationSalesOrderStatesCommand
 */
export interface BulkSyncOperationSalesOrderStatesCommand {
    /**
     * 
     * @type {string}
     * @memberof BulkSyncOperationSalesOrderStatesCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkSyncOperationSalesOrderStatesCommand
     */
    date?: string;
}
/**
 * 
 * @export
 * @interface BulkSyncPurchaseOrderFromIntegrationCommand
 */
export interface BulkSyncPurchaseOrderFromIntegrationCommand {
    /**
     * 
     * @type {Array<SyncPurchaseOrderFromIntegrationCommand>}
     * @memberof BulkSyncPurchaseOrderFromIntegrationCommand
     */
    purchaseOrders?: Array<SyncPurchaseOrderFromIntegrationCommand>;
}
/**
 * 
 * @export
 * @interface BulkSyncResultsOutputDTO
 */
export interface BulkSyncResultsOutputDTO {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BulkSyncResultsOutputDTO
     */
    failures?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkSyncResultsOutputDTO
     */
    successful?: Array<string>;
}
/**
 * 
 * @export
 * @interface BulkSyncReturnsFromIntegrationCommand
 */
export interface BulkSyncReturnsFromIntegrationCommand {
    /**
     * 
     * @type {Array<SyncReturnFromIntegrationCommand>}
     * @memberof BulkSyncReturnsFromIntegrationCommand
     */
    returns?: Array<SyncReturnFromIntegrationCommand>;
}
/**
 * 
 * @export
 * @interface BulkSyncReturnsFromIntegrationCommandOutputDTO
 */
export interface BulkSyncReturnsFromIntegrationCommandOutputDTO {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BulkSyncReturnsFromIntegrationCommandOutputDTO
     */
    failures?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkSyncReturnsFromIntegrationCommandOutputDTO
     */
    successful?: Array<string>;
}
/**
 * 
 * @export
 * @interface BulkUpdateCargoPackageTypeStatusCommand
 */
export interface BulkUpdateCargoPackageTypeStatusCommand {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateCargoPackageTypeStatusCommand
     */
    operationName?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkUpdateCargoPackageTypeStatusCommand
     */
    cargoPackageTypeIds?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateCargoPackageTypeStatusCommand
     */
    isDisabled?: boolean;
}
/**
 * 
 * @export
 * @interface BulkUpdateCargoPackageTypeStatusOutputDTO
 */
export interface BulkUpdateCargoPackageTypeStatusOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateCargoPackageTypeStatusOutputDTO
     */
    updatedCount?: number;
    /**
     * 
     * @type {Array<CargoPackageTypeStatusItemDTO>}
     * @memberof BulkUpdateCargoPackageTypeStatusOutputDTO
     */
    updatedItems?: Array<CargoPackageTypeStatusItemDTO>;
}
/**
 * 
 * @export
 * @interface BulkUpdateContainerTypeCommand
 */
export interface BulkUpdateContainerTypeCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUpdateContainerTypeCommand
     */
    containerLabels?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateContainerTypeCommand
     */
    targetType?: string;
}
/**
 * 
 * @export
 * @interface BulkUpdateContainerTypeOutputDTO
 */
export interface BulkUpdateContainerTypeOutputDTO {
    /**
     * 
     * @type {Array<SuccessfulContainerInfo>}
     * @memberof BulkUpdateContainerTypeOutputDTO
     */
    successfulContainers?: Array<SuccessfulContainerInfo>;
    /**
     * 
     * @type {Array<SkippedContainerInfo>}
     * @memberof BulkUpdateContainerTypeOutputDTO
     */
    skippedContainers?: Array<SkippedContainerInfo>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUpdateContainerTypeOutputDTO
     */
    notFoundContainers?: Array<string>;
    /**
     * 
     * @type {Array<FailedContainerInfo>}
     * @memberof BulkUpdateContainerTypeOutputDTO
     */
    failedContainers?: Array<FailedContainerInfo>;
}
/**
 * 
 * @export
 * @interface BulkUpdateMasterCartonCommand
 */
export interface BulkUpdateMasterCartonCommand {
    /**
     * 
     * @type {Array<UpdateMasterCartonCommand>}
     * @memberof BulkUpdateMasterCartonCommand
     */
    masterCartons?: Array<UpdateMasterCartonCommand>;
}
/**
 * 
 * @export
 * @interface BulkUpsertOutputItem
 */
export interface BulkUpsertOutputItem {
    /**
     * 
     * @type {string}
     * @memberof BulkUpsertOutputItem
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpsertOutputItem
     */
    operationName?: string;
    /**
     * 
     * @type {Action}
     * @memberof BulkUpsertOutputItem
     */
    action?: Action;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpsertOutputItem
     */
    isSuccessful?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BulkUpsertOutputItem
     */
    failureMessage?: string;
}
/**
 * 
 * @export
 * @interface BulkUpsertProductCommand
 */
export interface BulkUpsertProductCommand {
    /**
     * 
     * @type {Array<CreateProductCommand>}
     * @memberof BulkUpsertProductCommand
     */
    products?: Array<CreateProductCommand>;
}
/**
 * 
 * @export
 * @interface BulkUpsertProductCommandOutputDTO
 */
export interface BulkUpsertProductCommandOutputDTO {
    /**
     * 
     * @type {Array<BulkUpsertOutputItem>}
     * @memberof BulkUpsertProductCommandOutputDTO
     */
    bulkUpsertResult?: Array<BulkUpsertOutputItem>;
}
/**
 * 
 * @export
 * @interface ByteReadOnlyMemory
 */
export interface ByteReadOnlyMemory {
    /**
     * 
     * @type {number}
     * @memberof ByteReadOnlyMemory
     */
    length?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ByteReadOnlyMemory
     */
    isEmpty?: boolean;
}
/**
 * 
 * @export
 * @interface CallPodCommand
 */
export interface CallPodCommand {
    /**
     * 
     * @type {string}
     * @memberof CallPodCommand
     */
    stationAddressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CallPodCommand
     */
    podNo?: string;
    /**
     * 
     * @type {string}
     * @memberof CallPodCommand
     */
    face?: string;
    /**
     * 
     * @type {string}
     * @memberof CallPodCommand
     */
    podAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CancelReplenishmentJobsInputDTO
 */
export interface CancelReplenishmentJobsInputDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof CancelReplenishmentJobsInputDTO
     */
    jobIds?: Array<string>;
}
/**
 * 
 * @export
 * @interface CancelReplenishmentJobsOutputDTO
 */
export interface CancelReplenishmentJobsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CancelReplenishmentJobsOutputDTO
     */
    cancelledCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CancelReplenishmentJobsOutputDTO
     */
    skippedCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CancelReplenishmentJobsOutputDTO
     */
    skippedReferenceNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface CancelReservationCommand
 */
export interface CancelReservationCommand {
    /**
     * 
     * @type {string}
     * @memberof CancelReservationCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof CancelReservationCommand
     */
    purchaseOrderReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface CancelSalesOrderCommand
 */
export interface CancelSalesOrderCommand {
    /**
     * 
     * @type {string}
     * @memberof CancelSalesOrderCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CancelSalesOrderCommand
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface CancelSalesOrderOutputDTO
 */
export interface CancelSalesOrderOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CancelSalesOrderOutputDTO
     */
    cancelledAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CancelSalesOrderOutputDTO
     */
    pickedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CancelSalesOrderOutputDTO
     */
    packedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CancelSalesOrderOutputDTO
     */
    shippedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CancelSalesOrderOutputDTO
     */
    deliveredAt?: string;
}
/**
 * 
 * @export
 * @interface CancellationToken
 */
export interface CancellationToken {
    /**
     * 
     * @type {boolean}
     * @memberof CancellationToken
     */
    isCancellationRequested?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CancellationToken
     */
    canBeCanceled?: boolean;
    /**
     * 
     * @type {WaitHandle}
     * @memberof CancellationToken
     */
    waitHandle?: WaitHandle;
}
/**
 * 
 * @export
 * @interface CancelledMissingItemTransferProcessCommand
 */
export interface CancelledMissingItemTransferProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CancelledMissingItemTransferProcessCommand
     */
    missingItemTransferProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof CancelledMissingItemTransferProcessCommand
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CancelledMissingItemTransferProcessCommand
     */
    quarantineToteLabelForPutIntoCancelledOrder?: string;
    /**
     * 
     * @type {Array<PickedMissingItemsInputDTO>}
     * @memberof CancelledMissingItemTransferProcessCommand
     */
    pickedMissingItems?: Array<PickedMissingItemsInputDTO>;
}
/**
 * 
 * @export
 * @interface CancelledPackingItemInputDTO
 */
export interface CancelledPackingItemInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CancelledPackingItemInputDTO
     */
    productBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof CancelledPackingItemInputDTO
     */
    amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CancelledPackingItemInputDTO
     */
    serialNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface CancelledSalesOrderQueryOutputDTO
 */
export interface CancelledSalesOrderQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    cancelledAt?: string;
    /**
     * 
     * @type {SalesOrderCancelledState}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    salesOrderCancelledState?: SalesOrderCancelledState;
    /**
     * 
     * @type {boolean}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    hasPendingInventory?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    orderCreatedAt?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {SalesChannel}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {SalesOrderPickingPriority}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    priority?: SalesOrderPickingPriority;
    /**
     * 
     * @type {boolean}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    isSuspended?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    isCutOff?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    isSoftCutOff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {string}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    suspendedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    isCargoCodeUpdated?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    isSalesChannelMatch?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CancelledSalesOrderQueryOutputDTO
     */
    cargoCarrier?: string;
}
/**
 * 
 * @export
 * @interface CancelledSalesOrderQueryOutputDTODynamicQueryOutputDTO
 */
export interface CancelledSalesOrderQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<CancelledSalesOrderQueryOutputDTO>}
     * @memberof CancelledSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<CancelledSalesOrderQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof CancelledSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CancelledStateDetailsOutputDTO
 */
export interface CancelledStateDetailsOutputDTO {
    /**
     * 
     * @type {SalesOrderCancelledState}
     * @memberof CancelledStateDetailsOutputDTO
     */
    state?: SalesOrderCancelledState;
    /**
     * 
     * @type {string}
     * @memberof CancelledStateDetailsOutputDTO
     */
    at?: string;
}
/**
 * 
 * @export
 * @interface CargoCarriersODataDTOODataQueryOptions
 */
export interface CargoCarriersODataDTOODataQueryOptions {
    /**
     * 
     * @type {string}
     * @memberof CargoCarriersODataDTOODataQueryOptions
     */
    ifMatch?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoCarriersODataDTOODataQueryOptions
     */
    ifNoneMatch?: string;
    /**
     * 
     * @type {HttpRequest}
     * @memberof CargoCarriersODataDTOODataQueryOptions
     */
    request?: HttpRequest;
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof CargoCarriersODataDTOODataQueryOptions
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {ODataRawQueryOptions}
     * @memberof CargoCarriersODataDTOODataQueryOptions
     */
    rawValues?: ODataRawQueryOptions;
    /**
     * 
     * @type {SelectExpandQueryOption}
     * @memberof CargoCarriersODataDTOODataQueryOptions
     */
    selectExpand?: SelectExpandQueryOption;
    /**
     * 
     * @type {ApplyQueryOption}
     * @memberof CargoCarriersODataDTOODataQueryOptions
     */
    apply?: ApplyQueryOption;
    /**
     * 
     * @type {ComputeQueryOption}
     * @memberof CargoCarriersODataDTOODataQueryOptions
     */
    compute?: ComputeQueryOption;
    /**
     * 
     * @type {FilterQueryOption}
     * @memberof CargoCarriersODataDTOODataQueryOptions
     */
    filter?: FilterQueryOption;
    /**
     * 
     * @type {SearchQueryOption}
     * @memberof CargoCarriersODataDTOODataQueryOptions
     */
    search?: SearchQueryOption;
    /**
     * 
     * @type {OrderByQueryOption}
     * @memberof CargoCarriersODataDTOODataQueryOptions
     */
    orderBy?: OrderByQueryOption;
    /**
     * 
     * @type {SkipQueryOption}
     * @memberof CargoCarriersODataDTOODataQueryOptions
     */
    skip?: SkipQueryOption;
    /**
     * 
     * @type {SkipTokenQueryOption}
     * @memberof CargoCarriersODataDTOODataQueryOptions
     */
    skipToken?: SkipTokenQueryOption;
    /**
     * 
     * @type {TopQueryOption}
     * @memberof CargoCarriersODataDTOODataQueryOptions
     */
    top?: TopQueryOption;
    /**
     * 
     * @type {CountQueryOption}
     * @memberof CargoCarriersODataDTOODataQueryOptions
     */
    count?: CountQueryOption;
    /**
     * 
     * @type {object}
     * @memberof CargoCarriersODataDTOODataQueryOptions
     */
    validator?: object;
}
/**
 * 
 * @export
 * @interface CargoCodeUpdatedProblemDetailsOutputDTO
 */
export interface CargoCodeUpdatedProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CargoCodeUpdatedProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoCodeUpdatedProblemDetailsOutputDTO
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoCodeUpdatedProblemDetailsOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {ProblemSource}
     * @memberof CargoCodeUpdatedProblemDetailsOutputDTO
     */
    source?: ProblemSource;
    /**
     * 
     * @type {ProblemState}
     * @memberof CargoCodeUpdatedProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {CargoCodeUpdatedProblemState}
     * @memberof CargoCodeUpdatedProblemDetailsOutputDTO
     */
    stateDetail?: CargoCodeUpdatedProblemState;
    /**
     * 
     * @type {string}
     * @memberof CargoCodeUpdatedProblemDetailsOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoCodeUpdatedProblemDetailsOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoCodeUpdatedProblemDetailsOutputDTO
     */
    resolutionNote?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CargoCodeUpdatedProblemDetailsOutputDTO
     */
    cargoPackageLabels?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CargoCodeUpdatedProblemState {
    None = 'None',
    Created = 'Created',
    Resolved = 'Resolved'
}

/**
 * 
 * @export
 * @interface CargoPackageContainedItemOutputDTO
 */
export interface CargoPackageContainedItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CargoPackageContainedItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageContainedItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageContainedItemOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageContainedItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageContainedItemOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {number}
     * @memberof CargoPackageContainedItemOutputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface CargoPackageCountByCarrierOutputDTO
 */
export interface CargoPackageCountByCarrierOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CargoPackageCountByCarrierOutputDTO
     */
    cargoCarrier?: string;
    /**
     * 
     * @type {number}
     * @memberof CargoPackageCountByCarrierOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CargoPackageCountByOperationOutputDTO
 */
export interface CargoPackageCountByOperationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CargoPackageCountByOperationOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageCountByOperationOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageCountByOperationOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof CargoPackageCountByOperationOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CargoPackageInputDTO
 */
export interface CargoPackageInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CargoPackageInputDTO
     */
    cargoPackageTypeBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof CargoPackageInputDTO
     */
    cargoPackageIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageInputDTO
     */
    cargoPackageLabel?: string;
    /**
     * 
     * @type {Array<PackingItemInputDTO>}
     * @memberof CargoPackageInputDTO
     */
    packingItems?: Array<PackingItemInputDTO>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CargoPackageLabelUrlState {
    NotAcquired = 'NotAcquired',
    Acquired = 'Acquired'
}

/**
 * 
 * @export
 * @interface CargoPackageListOutputDTO
 */
export interface CargoPackageListOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CargoPackageListOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageListOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof CargoPackageListOutputDTO
     */
    volumetricWeight?: number;
    /**
     * 
     * @type {CargoPackageOutputState}
     * @memberof CargoPackageListOutputDTO
     */
    state?: CargoPackageOutputState;
    /**
     *
     * @type {string}
     * @memberof CargoPackageListOutputDTO
     */
    trackingId?: string;
    /**
     *
     * @type {string}
     * @memberof CargoPackageListOutputDTO
     */
    trackingLinkUrl?: string;
    /**
     *
     * @type {Array<CargoPackageContainedItemOutputDTO>}
     * @memberof CargoPackageListOutputDTO
     */
    containedItems?: Array<CargoPackageContainedItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface CargoPackageOutputDTO
 */
export interface CargoPackageOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CargoPackageOutputDTO
     */
    cargoPackageId?: number;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageOutputDTO
     */
    cargoPackageLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {Array<PackingItemOutputDTO>}
     * @memberof CargoPackageOutputDTO
     */
    packingItems?: Array<PackingItemOutputDTO>;
    /**
     * 
     * @type {Array<ShippingItemTransferOutputDTO>}
     * @memberof CargoPackageOutputDTO
     */
    shippingItems?: Array<ShippingItemTransferOutputDTO>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CargoPackageOutputState {
    Cancelled = 'Cancelled',
    None = 'None',
    WaitingForSlam = 'WaitingForSLAM',
    Suspended = 'Suspended',
    ReadyToShip = 'ReadyToShip',
    Dispatched = 'Dispatched',
    WaitingForManualDelivery = 'WaitingForManualDelivery',
    Delivered = 'Delivered',
    ManuallyDelivered = 'ManuallyDelivered',
    Transferred = 'Transferred'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum CargoPackageSLAMState {
    ReadyToShip = 'ReadyToShip',
    ShipmentFailure = 'ShipmentFailure',
    Cancelled = 'Cancelled'
}

/**
 * 
 * @export
 * @interface CargoPackageSalesOrderDetailsOutputDTO
 */
export interface CargoPackageSalesOrderDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CargoPackageSalesOrderDetailsOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageSalesOrderDetailsOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof CargoPackageSalesOrderDetailsOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {SalesChannel}
     * @memberof CargoPackageSalesOrderDetailsOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof CargoPackageSalesOrderDetailsOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {CargoPackageSalesOrderDispatchState}
     * @memberof CargoPackageSalesOrderDetailsOutputDTO
     */
    state?: CargoPackageSalesOrderDispatchState;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageSalesOrderDetailsOutputDTO
     */
    marketPlaceName?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageSalesOrderDetailsOutputDTO
     */
    carrierName?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageSalesOrderDetailsOutputDTO
     */
    carrierImageURL?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CargoPackageSalesOrderDetailsOutputDTO
     */
    isSingleItemSalesOrder?: boolean;
    /**
     * 
     * @type {Array<CargoPackagesOutputDTO>}
     * @memberof CargoPackageSalesOrderDetailsOutputDTO
     */
    cargoPackages?: Array<CargoPackagesOutputDTO>;
    /**
     * 
     * @type {Array<CargoPackagesOutputDTO>}
     * @memberof CargoPackageSalesOrderDetailsOutputDTO
     */
    cargoPackagesWaitingForDispatch?: Array<CargoPackagesOutputDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof CargoPackageSalesOrderDetailsOutputDTO
     */
    isCargoCodeUpdated?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CargoPackageSalesOrderDispatchState {
    None = 'None',
    Cancelled = 'Cancelled',
    Dispatched = 'Dispatched',
    Suspended = 'Suspended',
    SlamOperationNotCompleted = 'SLAMOperationNotCompleted',
    ManualDeliverySalesOrder = 'ManualDeliverySalesOrder'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum CargoPackageState {
    Cancelled = 'Cancelled',
    None = 'None',
    WaitingForSlam = 'WaitingForSLAM',
    Suspended = 'Suspended',
    ReadyToShip = 'ReadyToShip',
    Dispatched = 'Dispatched',
    Delivered = 'Delivered',
    Transferred = 'Transferred'
}

/**
 * 
 * @export
 * @interface CargoPackageTypeDimensionInputDTO
 */
export interface CargoPackageTypeDimensionInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CargoPackageTypeDimensionInputDTO
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof CargoPackageTypeDimensionInputDTO
     */
    value?: number;
}
/**
 * 
 * @export
 * @interface CargoPackageTypeOutputDTO
 */
export interface CargoPackageTypeOutputDTO {
    /**
     * 
     * @type {PackageType}
     * @memberof CargoPackageTypeOutputDTO
     */
    type?: PackageType;
    /**
     * 
     * @type {number}
     * @memberof CargoPackageTypeOutputDTO
     */
    volumetricWeight?: number;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageTypeOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageTypeOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CargoPackageTypeOutputDTO
     */
    isDisabled?: boolean;
}
/**
 * 
 * @export
 * @interface CargoPackageTypeStatusItemDTO
 */
export interface CargoPackageTypeStatusItemDTO {
    /**
     * 
     * @type {number}
     * @memberof CargoPackageTypeStatusItemDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageTypeStatusItemDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CargoPackageTypeStatusItemDTO
     */
    barcode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CargoPackageTypeStatusItemDTO
     */
    isDisabled?: boolean;
}
/**
 * 
 * @export
 * @interface CargoPackagesDTO
 */
export interface CargoPackagesDTO {
    /**
     * 
     * @type {string}
     * @memberof CargoPackagesDTO
     */
    label?: string;
    /**
     * 
     * @type {CargoPackageState}
     * @memberof CargoPackagesDTO
     */
    state?: CargoPackageState;
    /**
     * 
     * @type {string}
     * @memberof CargoPackagesDTO
     */
    labelUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof CargoPackagesDTO
     */
    index?: number;
    /**
     * 
     * @type {SalesOrderDispatchStateSteps}
     * @memberof CargoPackagesDTO
     */
    cargoPackageSLAMState?: SalesOrderDispatchStateSteps;
}
/**
 * 
 * @export
 * @interface CargoPackagesOutputDTO
 */
export interface CargoPackagesOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CargoPackagesOutputDTO
     */
    label?: string;
}
/**
 * 
 * @export
 * @interface CarriableTransferContainerDetailsOutputDTO
 */
export interface CarriableTransferContainerDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CarriableTransferContainerDetailsOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CarriableTransferContainerDetailsOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CarriableTransferContainerDetailsOutputDTO
     */
    isPallet?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CarriableTransferContainerDetailsOutputDTO
     */
    hasZoneProblem?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CarriableTransferContainerDetailsOutputDTO
     */
    hasExpirationDateProblem?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CarriableTransferContainerDetailsOutputDTO
     */
    zones?: Array<string>;
    /**
     * 
     * @type {Array<CarriableTransferContainerItemDetailsOutputDTO>}
     * @memberof CarriableTransferContainerDetailsOutputDTO
     */
    items?: Array<CarriableTransferContainerItemDetailsOutputDTO>;
}
/**
 * 
 * @export
 * @interface CarriableTransferContainerItemDetailsOutputDTO
 */
export interface CarriableTransferContainerItemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CarriableTransferContainerItemDetailsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof CarriableTransferContainerItemDetailsOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CarriableTransferContainerItemDetailsOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CarriableTransferContainerItemDetailsOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof CarriableTransferContainerItemDetailsOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CarriableTransferContainerItemDetailsOutputDTO
     */
    hasMultipleExpirationDates?: boolean;
    /**
     * 
     * @type {Array<ContainerItemExpirationDateAmount>}
     * @memberof CarriableTransferContainerItemDetailsOutputDTO
     */
    expirationDatesAndAmounts?: Array<ContainerItemExpirationDateAmount>;
    /**
     * 
     * @type {boolean}
     * @memberof CarriableTransferContainerItemDetailsOutputDTO
     */
    hasSerialNumber?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CarriableTransferContainerItemDetailsOutputDTO
     */
    serialNumbers?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CarriableTransferContainerItemDetailsOutputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface CarrierInfoDetailOutputDTO
 */
export interface CarrierInfoDetailOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoDetailOutputDTO
     */
    driverName?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoDetailOutputDTO
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoDetailOutputDTO
     */
    licensePlate?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoDetailOutputDTO
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoDetailOutputDTO
     */
    personId?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoDetailOutputDTO
     */
    arrivedAt?: string;
}
/**
 * 
 * @export
 * @interface CarrierInfoInputDTO
 */
export interface CarrierInfoInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoInputDTO
     */
    driverFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoInputDTO
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoInputDTO
     */
    arrivedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoInputDTO
     */
    licensePlate?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoInputDTO
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoInputDTO
     */
    personId?: string;
}
/**
 * 
 * @export
 * @interface CarrierInfoOutputDTO
 */
export interface CarrierInfoOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoOutputDTO
     */
    waybillId?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoOutputDTO
     */
    licensePlate?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoOutputDTO
     */
    carrierCompany?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoOutputDTO
     */
    driverFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoOutputDTO
     */
    personId?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoOutputDTO
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierInfoOutputDTO
     */
    arrivedAt?: string;
}
/**
 * 
 * @export
 * @interface CarrierOutputDTO
 */
export interface CarrierOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CarrierOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierOutputDTO
     */
    cargoCarrierId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CarrierOutputDTO
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CarrierOutputDTO
     */
    enabledLogoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierOutputDTO
     */
    disabledLogoUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof CarrierOutputDTO
     */
    volumetricWeightLimitPerPackage?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrierOutputDTO
     */
    volumetricWeightLimitPerOrder?: number;
}
/**
 * 
 * @export
 * @interface CarrierPreferenceInputDTO
 */
export interface CarrierPreferenceInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CarrierPreferenceInputDTO
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierPreferenceInputDTO
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierPreferenceInputDTO
     */
    district?: string;
    /**
     * 
     * @type {number}
     * @memberof CarrierPreferenceInputDTO
     */
    deciMin?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrierPreferenceInputDTO
     */
    deciMax?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrierPreferenceInputDTO
     */
    priority?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrierPreferenceInputDTO
     */
    carrierName?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierPreferenceInputDTO
     */
    salesLocation?: string;
}
/**
 * 
 * @export
 * @interface CarrierPreferencesOutputDTO
 */
export interface CarrierPreferencesOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CarrierPreferencesOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierPreferencesOutputDTO
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierPreferencesOutputDTO
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierPreferencesOutputDTO
     */
    district?: string;
    /**
     * 
     * @type {number}
     * @memberof CarrierPreferencesOutputDTO
     */
    deciMin?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrierPreferencesOutputDTO
     */
    deciMax?: number;
    /**
     * 
     * @type {number}
     * @memberof CarrierPreferencesOutputDTO
     */
    priority?: number;
    /**
     * 
     * @type {string}
     * @memberof CarrierPreferencesOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof CarrierPreferencesOutputDTO
     */
    carrierName?: string;
}
/**
 * 
 * @export
 * @interface CellContainerQueryOutputDTO
 */
export interface CellContainerQueryOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CellContainerQueryOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CellContainerQueryOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CellContainerQueryOutputDTO
     */
    labelFormat?: string;
    /**
     * 
     * @type {string}
     * @memberof CellContainerQueryOutputDTO
     */
    containedIn?: string;
    /**
     * 
     * @type {AddressType}
     * @memberof CellContainerQueryOutputDTO
     */
    addressType?: AddressType;
    /**
     * 
     * @type {string}
     * @memberof CellContainerQueryOutputDTO
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CellContainerQueryOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CellContainerQueryOutputDTODynamicQueryOutputDTO
 */
export interface CellContainerQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<CellContainerQueryOutputDTO>}
     * @memberof CellContainerQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<CellContainerQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof CellContainerQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CellStatusOutputDTO
 */
export interface CellStatusOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CellStatusOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CellStatusOutputDTO
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof CellStatusOutputDTO
     */
    currentStockZone?: string;
    /**
     * 
     * @type {number}
     * @memberof CellStatusOutputDTO
     */
    productAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CellStatusOutputDTO
     */
    productVariety?: number;
    /**
     * 
     * @type {number}
     * @memberof CellStatusOutputDTO
     */
    operationCount?: number;
    /**
     * 
     * @type {StockCellCategory}
     * @memberof CellStatusOutputDTO
     */
    stockCellType?: StockCellCategory;
    /**
     * 
     * @type {Array<OperationOutputDTO>}
     * @memberof CellStatusOutputDTO
     */
    operations?: Array<OperationOutputDTO>;
}
/**
 * 
 * @export
 * @interface CellStockCountProcessOutputDTO
 */
export interface CellStockCountProcessOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CellStockCountProcessOutputDTO
     */
    totalAddressAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CellStockCountProcessOutputDTO
     */
    totalProductAmount?: number;
    /**
     * 
     * @type {Array<StockCountingProcessAddressOutputDTO>}
     * @memberof CellStockCountProcessOutputDTO
     */
    stockAdressTaskDetails?: Array<StockCountingProcessAddressOutputDTO>;
}
/**
 * 
 * @export
 * @interface CellStockCountingTasksQueryOutputDTO
 */
export interface CellStockCountingTasksQueryOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CellStockCountingTasksQueryOutputDTO
     */
    stockCountingReferenceNumber?: number;
    /**
     * 
     * @type {StockCountingProcessState}
     * @memberof CellStockCountingTasksQueryOutputDTO
     */
    state?: StockCountingProcessState;
    /**
     * 
     * @type {string}
     * @memberof CellStockCountingTasksQueryOutputDTO
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CellStockCountingTasksQueryOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CellStockCountingTasksQueryOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof CellStockCountingTasksQueryOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof CellStockCountingTasksQueryOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof CellStockCountingTasksQueryOutputDTO
     */
    taskCreatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CellStockCountingTasksQueryOutputDTO
     */
    taskCreatedBy?: string;
}
/**
 * 
 * @export
 * @interface CellStockCountingTasksQueryOutputDTODynamicQueryOutputDTO
 */
export interface CellStockCountingTasksQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<CellStockCountingTasksQueryOutputDTO>}
     * @memberof CellStockCountingTasksQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<CellStockCountingTasksQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof CellStockCountingTasksQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CellType {
    PrimeCell = 'PrimeCell',
    ReservedCell = 'ReservedCell'
}

/**
 * 
 * @export
 * @interface CellTypeOccupancyDetailsOutputDTO
 */
export interface CellTypeOccupancyDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CellTypeOccupancyDetailsOutputDTO
     */
    cellType?: string;
    /**
     * 
     * @type {number}
     * @memberof CellTypeOccupancyDetailsOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof CellTypeOccupancyDetailsOutputDTO
     */
    totalVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof CellTypeOccupancyDetailsOutputDTO
     */
    emptyCellAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CellTypeOccupancyDetailsOutputDTO
     */
    occupancy?: number;
}
/**
 * 
 * @export
 * @interface CellWithStockItemAmountOutputDTO
 */
export interface CellWithStockItemAmountOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CellWithStockItemAmountOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CellWithStockItemAmountOutputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface CellsForControlCountOutputDTO
 */
export interface CellsForControlCountOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CellsForControlCountOutputDTO
     */
    cellId?: number;
    /**
     * 
     * @type {string}
     * @memberof CellsForControlCountOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CellsForControlCountOutputDTO
     */
    afterCountingAmount?: number;
    /**
     * 
     * @type {StockCountingProcessState}
     * @memberof CellsForControlCountOutputDTO
     */
    state?: StockCountingProcessState;
}
/**
 * 
 * @export
 * @interface CellsForControlCountOutputDTODynamicQueryOutputDTO
 */
export interface CellsForControlCountOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<CellsForControlCountOutputDTO>}
     * @memberof CellsForControlCountOutputDTODynamicQueryOutputDTO
     */
    data?: Array<CellsForControlCountOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof CellsForControlCountOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ChangeDeliveryTypeCommand
 */
export interface ChangeDeliveryTypeCommand {
    /**
     * 
     * @type {string}
     * @memberof ChangeDeliveryTypeCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeDeliveryTypeCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof ChangeDeliveryTypeCommand
     */
    newDeliveryType?: number;
}
/**
 * 
 * @export
 * @interface ChangeDeliveryTypeOutputDTO
 */
export interface ChangeDeliveryTypeOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ChangeDeliveryTypeOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeDeliveryTypeOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof ChangeDeliveryTypeOutputDTO
     */
    oldDeliveryType?: number;
    /**
     * 
     * @type {string}
     * @memberof ChangeDeliveryTypeOutputDTO
     */
    oldDeliveryTypeName?: string;
    /**
     * 
     * @type {number}
     * @memberof ChangeDeliveryTypeOutputDTO
     */
    newDeliveryType?: number;
    /**
     * 
     * @type {string}
     * @memberof ChangeDeliveryTypeOutputDTO
     */
    newDeliveryTypeName?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeDeliveryTypeOutputDTO
     */
    currentState?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeDeliveryTypeOutputDTO
     */
    updatedAt?: string;
}
/**
 * 
 * @export
 * @interface CheckAndPlaceBatchPickingProductCommand
 */
export interface CheckAndPlaceBatchPickingProductCommand {
    /**
     * 
     * @type {number}
     * @memberof CheckAndPlaceBatchPickingProductCommand
     */
    sortingProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckAndPlaceBatchPickingProductCommand
     */
    batchPickingToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckAndPlaceBatchPickingProductCommand
     */
    productBarcode?: string;
}
/**
 * 
 * @export
 * @interface CheckAndPlaceBatchPickingProductOutputDTO
 */
export interface CheckAndPlaceBatchPickingProductOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckAndPlaceBatchPickingProductOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckAndPlaceBatchPickingProductOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckAndPlaceBatchPickingProductOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckAndPlaceBatchPickingProductOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckAndPlaceBatchPickingProductOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof CheckAndPlaceBatchPickingProductOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof CheckAndPlaceBatchPickingProductOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckAndPlaceBatchPickingProductOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {RebinTrolleySide}
     * @memberof CheckAndPlaceBatchPickingProductOutputDTO
     */
    rebinTrolleySide?: RebinTrolleySide;
    /**
     * 
     * @type {boolean}
     * @memberof CheckAndPlaceBatchPickingProductOutputDTO
     */
    isToteCompleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckAndPlaceBatchPickingProductOutputDTO
     */
    isSortingCompleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CheckAndPlaceBatchPickingProductOutputDTO
     */
    productCount?: number;
}
/**
 * 
 * @export
 * @interface CheckBarcodeOutputDTO
 */
export interface CheckBarcodeOutputDTO {
    /**
     * 
     * @type {CheckProductBarcodeOutputDto}
     * @memberof CheckBarcodeOutputDTO
     */
    product?: CheckProductBarcodeOutputDto;
    /**
     * 
     * @type {CarriableTransferContainerDetailsOutputDTO}
     * @memberof CheckBarcodeOutputDTO
     */
    container?: CarriableTransferContainerDetailsOutputDTO;
}
/**
 * 
 * @export
 * @interface CheckBarcodeTypeForFastPackPickingOutputDTO
 */
export interface CheckBarcodeTypeForFastPackPickingOutputDTO {
    /**
     * 
     * @type {BarcodeType}
     * @memberof CheckBarcodeTypeForFastPackPickingOutputDTO
     */
    type?: BarcodeType;
}
/**
 * 
 * @export
 * @interface CheckBarcodeTypeForHOVPickingOutputDTO
 */
export interface CheckBarcodeTypeForHOVPickingOutputDTO {
    /**
     * 
     * @type {BarcodeType}
     * @memberof CheckBarcodeTypeForHOVPickingOutputDTO
     */
    type?: BarcodeType;
    /**
     * 
     * @type {number}
     * @memberof CheckBarcodeTypeForHOVPickingOutputDTO
     */
    masterCartonProductQuantity?: number;
}
/**
 * 
 * @export
 * @interface CheckBarcodeTypeForMultiItemPickingOutputDTO
 */
export interface CheckBarcodeTypeForMultiItemPickingOutputDTO {
    /**
     * 
     * @type {BarcodeType}
     * @memberof CheckBarcodeTypeForMultiItemPickingOutputDTO
     */
    type?: BarcodeType;
    /**
     * 
     * @type {number}
     * @memberof CheckBarcodeTypeForMultiItemPickingOutputDTO
     */
    masterCartonProductQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof CheckBarcodeTypeForMultiItemPickingOutputDTO
     */
    expectedCurrentItemAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CheckBarcodeTypeForMultiItemPickingOutputDTO
     */
    isCurrentItemCountEntryAllowed?: boolean;
}
/**
 * 
 * @export
 * @interface CheckBarcodeTypeForQuickPutAway
 */
export interface CheckBarcodeTypeForQuickPutAway {
    /**
     * 
     * @type {string}
     * @memberof CheckBarcodeTypeForQuickPutAway
     */
    barcode?: string;
}
/**
 * 
 * @export
 * @interface CheckBarcodeTypeForQuickPutAwayOutputDTO
 */
export interface CheckBarcodeTypeForQuickPutAwayOutputDTO {
    /**
     * 
     * @type {QuickPutAwayBarcodeType}
     * @memberof CheckBarcodeTypeForQuickPutAwayOutputDTO
     */
    type?: QuickPutAwayBarcodeType;
}
/**
 * 
 * @export
 * @interface CheckBarcodeTypeForRasOutputDTO
 */
export interface CheckBarcodeTypeForRasOutputDTO {
    /**
     * 
     * @type {BarcodeType}
     * @memberof CheckBarcodeTypeForRasOutputDTO
     */
    type?: BarcodeType;
}
/**
 * 
 * @export
 * @interface CheckBarcodeTypeForReceivingOutputDTO
 */
export interface CheckBarcodeTypeForReceivingOutputDTO {
    /**
     * 
     * @type {ReceivingBarcodeTypeEnum}
     * @memberof CheckBarcodeTypeForReceivingOutputDTO
     */
    barcodeType?: ReceivingBarcodeTypeEnum;
    /**
     * 
     * @type {ReceivingProductDetailsOutputDTO}
     * @memberof CheckBarcodeTypeForReceivingOutputDTO
     */
    productDetails?: ReceivingProductDetailsOutputDTO;
    /**
     * 
     * @type {boolean}
     * @memberof CheckBarcodeTypeForReceivingOutputDTO
     */
    isNotInWaybill?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckBarcodeTypeForReceivingOutputDTO
     */
    isExceedsExpectedAmount?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CheckBarcodeTypeForReceivingOutputDTO
     */
    expectedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CheckBarcodeTypeForReceivingOutputDTO
     */
    acceptedAmount?: number;
}
/**
 * 
 * @export
 * @interface CheckBarcodeTypeForSingleItemPickingOutputDTO
 */
export interface CheckBarcodeTypeForSingleItemPickingOutputDTO {
    /**
     * 
     * @type {BarcodeType}
     * @memberof CheckBarcodeTypeForSingleItemPickingOutputDTO
     */
    type?: BarcodeType;
}
/**
 * 
 * @export
 * @interface CheckBarcodeTypeForSingleItemReceivingOutputDTO
 */
export interface CheckBarcodeTypeForSingleItemReceivingOutputDTO {
    /**
     * 
     * @type {SingleItemReceivingBarcodeTypeEnum}
     * @memberof CheckBarcodeTypeForSingleItemReceivingOutputDTO
     */
    barcodeType?: SingleItemReceivingBarcodeTypeEnum;
    /**
     * 
     * @type {ReceivingProductDetailsOutputDTO}
     * @memberof CheckBarcodeTypeForSingleItemReceivingOutputDTO
     */
    productDetails?: ReceivingProductDetailsOutputDTO;
    /**
     * 
     * @type {boolean}
     * @memberof CheckBarcodeTypeForSingleItemReceivingOutputDTO
     */
    isNotInWaybill?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckBarcodeTypeForSingleItemReceivingOutputDTO
     */
    isExceedsExpectedAmount?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CheckBarcodeTypeForSingleItemReceivingOutputDTO
     */
    expectedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CheckBarcodeTypeForSingleItemReceivingOutputDTO
     */
    acceptedAmount?: number;
}
/**
 * 
 * @export
 * @interface CheckBarcodeTypeForTransferOutputDTO
 */
export interface CheckBarcodeTypeForTransferOutputDTO {
    /**
     * 
     * @type {BarcodeType}
     * @memberof CheckBarcodeTypeForTransferOutputDTO
     */
    type?: BarcodeType;
}
/**
 * 
 * @export
 * @interface CheckBarcodeTypeForWebReceivingOutputDTO
 */
export interface CheckBarcodeTypeForWebReceivingOutputDTO {
    /**
     * 
     * @type {WebReceivingBarcodeTypeEnum}
     * @memberof CheckBarcodeTypeForWebReceivingOutputDTO
     */
    barcodeType?: WebReceivingBarcodeTypeEnum;
}
/**
 * 
 * @export
 * @interface CheckBatchPickingDropAddressCommand
 */
export interface CheckBatchPickingDropAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckBatchPickingDropAddressCommand
     */
    batchPickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckBatchPickingDropAddressCommand
     */
    dropAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckBatchPickingDropAddressCommandOutputDTO
 */
export interface CheckBatchPickingDropAddressCommandOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckBatchPickingDropAddressCommandOutputDTO
     */
    nextToteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckBatchPickingDropAddressCommandOutputDTO
     */
    nextToteContainedItemsAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CheckBatchPickingDropAddressCommandOutputDTO
     */
    remainingToteCount?: number;
}
/**
 * 
 * @export
 * @interface CheckBatchPickingProductCommand
 */
export interface CheckBatchPickingProductCommand {
    /**
     * 
     * @type {number}
     * @memberof CheckBatchPickingProductCommand
     */
    sortingProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckBatchPickingProductCommand
     */
    batchPickingToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckBatchPickingProductCommand
     */
    productBarcode?: string;
}
/**
 * 
 * @export
 * @interface CheckBatchPickingToteCommand
 */
export interface CheckBatchPickingToteCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckBatchPickingToteCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckBatchPickingToteForRebinCommand
 */
export interface CheckBatchPickingToteForRebinCommand {
    /**
     * 
     * @type {number}
     * @memberof CheckBatchPickingToteForRebinCommand
     */
    sortingProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckBatchPickingToteForRebinCommand
     */
    batchPickingToteLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckBatchPickingToteOutputDTO
 */
export interface CheckBatchPickingToteOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CheckBatchPickingToteOutputDTO
     */
    productCount?: number;
}
/**
 * 
 * @export
 * @interface CheckBatchTrolleyCommand
 */
export interface CheckBatchTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckBatchTrolleyCommand
     */
    batchTrolleyLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckCellCommand
 */
export interface CheckCellCommand {
    /**
     * 
     * @type {number}
     * @memberof CheckCellCommand
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckCellCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckCellCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface CheckCellContainsPickingStartedItemsCommand
 */
export interface CheckCellContainsPickingStartedItemsCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckCellContainsPickingStartedItemsCommand
     */
    stockCountingId?: string;
}
/**
 * 
 * @export
 * @interface CheckCellForHOVPickingCommand
 */
export interface CheckCellForHOVPickingCommand {
    /**
     * 
     * @type {number}
     * @memberof CheckCellForHOVPickingCommand
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckCellForHOVPickingCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckCellForHOVPickingCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface CheckCellForSingleItemFastPackPickingCommand
 */
export interface CheckCellForSingleItemFastPackPickingCommand {
    /**
     * 
     * @type {number}
     * @memberof CheckCellForSingleItemFastPackPickingCommand
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckCellForSingleItemFastPackPickingCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckCellForSingleItemFastPackPickingCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface CheckCellForSingleItemPickingCommand
 */
export interface CheckCellForSingleItemPickingCommand {
    /**
     * 
     * @type {number}
     * @memberof CheckCellForSingleItemPickingCommand
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckCellForSingleItemPickingCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckCellForSingleItemPickingCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface CheckCellForStockToQuarantineTransferCommand
 */
export interface CheckCellForStockToQuarantineTransferCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckCellForStockToQuarantineTransferCommand
     */
    cellLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckCellForStockToRestowTransferCommand
 */
export interface CheckCellForStockToRestowTransferCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckCellForStockToRestowTransferCommand
     */
    cellLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckCellForStockToRestowTransferOutputDTO
 */
export interface CheckCellForStockToRestowTransferOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CheckCellForStockToRestowTransferOutputDTO
     */
    canTransferAll?: boolean;
    /**
     * 
     * @type {Array<CheckCellForStockToRestowTransferProductOutputDTO>}
     * @memberof CheckCellForStockToRestowTransferOutputDTO
     */
    transferableProducts?: Array<CheckCellForStockToRestowTransferProductOutputDTO>;
    /**
     * 
     * @type {Array<CheckCellForStockToRestowTransferProductOutputDTO>}
     * @memberof CheckCellForStockToRestowTransferOutputDTO
     */
    hardAllocatedProducts?: Array<CheckCellForStockToRestowTransferProductOutputDTO>;
    /**
     * 
     * @type {Array<CheckCellForStockToRestowTransferProductOutputDTO>}
     * @memberof CheckCellForStockToRestowTransferOutputDTO
     */
    lostProducts?: Array<CheckCellForStockToRestowTransferProductOutputDTO>;
}
/**
 * 
 * @export
 * @interface CheckCellForStockToRestowTransferProductOutputDTO
 */
export interface CheckCellForStockToRestowTransferProductOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckCellForStockToRestowTransferProductOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckCellForStockToRestowTransferProductOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckCellForStockToRestowTransferProductOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckCellForStockToRestowTransferProductOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckCellForStockToRestowTransferProductOutputDTO
     */
    imageURL?: string;
}
/**
 * 
 * @export
 * @interface CheckCellLabelCommand
 */
export interface CheckCellLabelCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckCellLabelCommand
     */
    cellLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckCellProductContainsPickingStartedItemsCommand
 */
export interface CheckCellProductContainsPickingStartedItemsCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckCellProductContainsPickingStartedItemsCommand
     */
    stockCountingId?: string;
}
/**
 * 
 * @export
 * @interface CheckCellTypeOutputDTO
 */
export interface CheckCellTypeOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckCellTypeOutputDTO
     */
    cellTypeName?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckCellTypeOutputDTO
     */
    label?: string;
}
/**
 * 
 * @export
 * @interface CheckContainerBarcodeTypeOutputDTO
 */
export interface CheckContainerBarcodeTypeOutputDTO {
    /**
     * 
     * @type {ContainerBarcodeType}
     * @memberof CheckContainerBarcodeTypeOutputDTO
     */
    containerBarcodeType?: ContainerBarcodeType;
}
/**
 * 
 * @export
 * @interface CheckDamagedProductCommand
 */
export interface CheckDamagedProductCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckDamagedProductCommand
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckDamagedProductCommand
     */
    barcode?: string;
}
/**
 * 
 * @export
 * @interface CheckDamagedProductOutputDTO
 */
export interface CheckDamagedProductOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckDamagedProductOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckDamagedProductOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckDamagedProductOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckDamagedProductOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckDamagedProductOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckDamagedProductOutputDTO
     */
    isTrackExpirationDate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckDamagedProductOutputDTO
     */
    isTrackLotNumber?: boolean;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof CheckDamagedProductOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof CheckDamagedProductOutputDTO
     */
    damagedAmount?: number;
}
/**
 * 
 * @export
 * @interface CheckEligibleProductsForTransferCommand
 */
export interface CheckEligibleProductsForTransferCommand {
    /**
     * 
     * @type {Array<TransferProductInputDTO>}
     * @memberof CheckEligibleProductsForTransferCommand
     */
    transferProducts?: Array<TransferProductInputDTO>;
    /**
     * 
     * @type {string}
     * @memberof CheckEligibleProductsForTransferCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckEligibleProductsForTransferCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckIfControlCountingIsActiveForHOVPickingOutputDTO
 */
export interface CheckIfControlCountingIsActiveForHOVPickingOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CheckIfControlCountingIsActiveForHOVPickingOutputDTO
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface CheckIfControlCountingIsActiveForSingleItemFastPackPickingOutputDTO
 */
export interface CheckIfControlCountingIsActiveForSingleItemFastPackPickingOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CheckIfControlCountingIsActiveForSingleItemFastPackPickingOutputDTO
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface CheckIfControlCountingIsActiveForSingleItemPickingOutputDTO
 */
export interface CheckIfControlCountingIsActiveForSingleItemPickingOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CheckIfControlCountingIsActiveForSingleItemPickingOutputDTO
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface CheckIfControlCountingIsActiveOutputDTO
 */
export interface CheckIfControlCountingIsActiveOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CheckIfControlCountingIsActiveOutputDTO
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface CheckPickingItemExistCommand
 */
export interface CheckPickingItemExistCommand {
    /**
     * 
     * @type {number}
     * @memberof CheckPickingItemExistCommand
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckPickingItemExistCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckPickingItemExistCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckPickingItemExistCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface CheckPickingProductSerialNumberOutputDTO
 */
export interface CheckPickingProductSerialNumberOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CheckPickingProductSerialNumberOutputDTO
     */
    isExistInCell?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckPickingProductSerialNumberOutputDTO
     */
    isInOtherSalesOrder?: boolean;
}
/**
 * 
 * @export
 * @interface CheckPlanSelectionActiveInStockCountingsOutputDTO
 */
export interface CheckPlanSelectionActiveInStockCountingsOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CheckPlanSelectionActiveInStockCountingsOutputDTO
     */
    isPlanSelectionActiveInStockCounting?: boolean;
}
/**
 * 
 * @export
 * @interface CheckProblematicTotesOutputDTO
 */
export interface CheckProblematicTotesOutputDTO {
    /**
     * 
     * @type {Array<ProblematicToteDTO>}
     * @memberof CheckProblematicTotesOutputDTO
     */
    totes?: Array<ProblematicToteDTO>;
    /**
     * 
     * @type {number}
     * @memberof CheckProblematicTotesOutputDTO
     */
    totalCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProblematicTotesOutputDTO
     */
    isToteScanned?: boolean;
}
/**
 * 
 * @export
 * @interface CheckProductBarcodeOutputDto
 */
export interface CheckProductBarcodeOutputDto {
    /**
     * 
     * @type {string}
     * @memberof CheckProductBarcodeOutputDto
     */
    productId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductBarcodeOutputDto
     */
    isTrackSerialNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductBarcodeOutputDto
     */
    isTrackSimpleSerialNumber?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CheckProductBarcodeOutputDto
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductBarcodeOutputDto
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductBarcodeOutputDto
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductBarcodeOutputDto
     */
    productImageURL?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductBarcodeOutputDto
     */
    isTrackExpirationDate?: boolean;
}
/**
 * 
 * @export
 * @interface CheckProductExistCellSuggestedCommand
 */
export interface CheckProductExistCellSuggestedCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistCellSuggestedCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistCellSuggestedCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckProductExistCellSuggestedCommand
     */
    putAwayReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface CheckProductExistCommand
 */
export interface CheckProductExistCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckProductExistCommand
     */
    putAwayReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface CheckProductExistForQuickPutAwayCommand
 */
export interface CheckProductExistForQuickPutAwayCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistForQuickPutAwayCommand
     */
    inboundBoxLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistForQuickPutAwayCommand
     */
    productLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckProductExistInToteOutputDTO
 */
export interface CheckProductExistInToteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistInToteOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistInToteOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistInToteOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistInToteOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistInToteOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductExistInToteOutputDTO
     */
    shouldTakeExpirationDate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductExistInToteOutputDTO
     */
    shouldTakeSerialNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductExistInToteOutputDTO
     */
    shouldTakeLotNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductExistInToteOutputDTO
     */
    isMasterCarton?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CheckProductExistInToteOutputDTO
     */
    masterCartonAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CheckProductExistInToteOutputDTO
     */
    primeCellStockCount?: number;
}
/**
 * 
 * @export
 * @interface CheckProductExistOutputDTO
 */
export interface CheckProductExistOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductExistOutputDTO
     */
    shouldTakeExpirationDate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductExistOutputDTO
     */
    shouldTakeSerialNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductExistOutputDTO
     */
    shouldTakeLotNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductExistOutputDTO
     */
    isMasterCarton?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CheckProductExistOutputDTO
     */
    masterCartonAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CheckProductExistOutputDTO
     */
    primeCellStockCount?: number;
}
/**
 * 
 * @export
 * @interface CheckProductExistsForTransferCommand
 */
export interface CheckProductExistsForTransferCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistsForTransferCommand
     */
    stockCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistsForTransferCommand
     */
    productLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckProductExistsInToteForTransferCommand
 */
export interface CheckProductExistsInToteForTransferCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistsInToteForTransferCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductExistsInToteForTransferCommand
     */
    productLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckProductForCellStockCountingOutputDTO
 */
export interface CheckProductForCellStockCountingOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckProductForCellStockCountingOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForCellStockCountingOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForCellStockCountingOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForCellStockCountingOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductForCellStockCountingOutputDTO
     */
    isTrackExpirationDate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForCellStockCountingOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductForCellStockCountingOutputDTO
     */
    isTrackSerialNumber?: boolean;
}
/**
 * 
 * @export
 * @interface CheckProductForControlCountingOutputDTO
 */
export interface CheckProductForControlCountingOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckProductForControlCountingOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForControlCountingOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForControlCountingOutputDTO
     */
    productBarcode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductForControlCountingOutputDTO
     */
    isTrackSerialNumber?: boolean;
}
/**
 * 
 * @export
 * @interface CheckProductForDirectStowOutputDTO
 */
export interface CheckProductForDirectStowOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckProductForDirectStowOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForDirectStowOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForDirectStowOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForDirectStowOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForDirectStowOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForDirectStowOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductForDirectStowOutputDTO
     */
    hasOpenPurchaseOrder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForDirectStowOutputDTO
     */
    purchaseOrderReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface CheckProductForManualCellStockCountingOutputDTO
 */
export interface CheckProductForManualCellStockCountingOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckProductForManualCellStockCountingOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForManualCellStockCountingOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForManualCellStockCountingOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductForManualCellStockCountingOutputDTO
     */
    isTrackExpirationDate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForManualCellStockCountingOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductForManualCellStockCountingOutputDTO
     */
    isTrackSerialNumber?: boolean;
}
/**
 * 
 * @export
 * @interface CheckProductForPickOutputDTO
 */
export interface CheckProductForPickOutputDTO {
    /**
     * 
     * @type {Array<ToteForPickOutputDTO>}
     * @memberof CheckProductForPickOutputDTO
     */
    availableTotes?: Array<ToteForPickOutputDTO>;
    /**
     * 
     * @type {Array<ToteForPickOutputDTO>}
     * @memberof CheckProductForPickOutputDTO
     */
    candidateDropTotes?: Array<ToteForPickOutputDTO>;
}
/**
 * 
 * @export
 * @interface CheckProductForQuarantineToValidTransferCommand
 */
export interface CheckProductForQuarantineToValidTransferCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckProductForQuarantineToValidTransferCommand
     */
    sourceToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForQuarantineToValidTransferCommand
     */
    productBarcode?: string;
}
/**
 * 
 * @export
 * @interface CheckProductForQuarantineToValidTransferOutputDTO
 */
export interface CheckProductForQuarantineToValidTransferOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckProductForQuarantineToValidTransferOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductForQuarantineToValidTransferOutputDTO
     */
    isTrackSerialNumber?: boolean;
}
/**
 * 
 * @export
 * @interface CheckProductForStockToQuarantineTransferCommand
 */
export interface CheckProductForStockToQuarantineTransferCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckProductForStockToQuarantineTransferCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForStockToQuarantineTransferCommand
     */
    productBarcode?: string;
}
/**
 * 
 * @export
 * @interface CheckProductForStockToQuarantineTransferOutputDTO
 */
export interface CheckProductForStockToQuarantineTransferOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckProductForStockToQuarantineTransferOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckProductForStockToQuarantineTransferOutputDTO
     */
    transferableAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductForStockToQuarantineTransferOutputDTO
     */
    isTrackSerialNumber?: boolean;
}
/**
 * 
 * @export
 * @interface CheckProductForStowOutputDTO
 */
export interface CheckProductForStowOutputDTO {
    /**
     * 
     * @type {Array<ToteContainedItemOutputDTO>}
     * @memberof CheckProductForStowOutputDTO
     */
    containedProducts?: Array<ToteContainedItemOutputDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductForStowOutputDTO
     */
    isCancelled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForStowOutputDTO
     */
    cancelReason?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForStowOutputDTO
     */
    cancelDirectiveMessage?: string;
}
/**
 * 
 * @export
 * @interface CheckProductForWallToWallStockCountingOutputDTO
 */
export interface CheckProductForWallToWallStockCountingOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckProductForWallToWallStockCountingOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForWallToWallStockCountingOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForWallToWallStockCountingOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForWallToWallStockCountingOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductForWallToWallStockCountingOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductForWallToWallStockCountingOutputDTO
     */
    isTrackExpirationDate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckProductForWallToWallStockCountingOutputDTO
     */
    isTrackLotNumber?: boolean;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof CheckProductForWallToWallStockCountingOutputDTO
     */
    operation?: OperationOutputDTO;
}
/**
 * 
 * @export
 * @interface CheckProductsSerialNumberCommand
 */
export interface CheckProductsSerialNumberCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckProductsSerialNumberCommand
     */
    sourceToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductsSerialNumberCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckProductsSerialNumberCommand
     */
    serialNumber?: string;
}
/**
 * 
 * @export
 * @interface CheckPutAwayCellRuleForPalletItemOutputDTO
 */
export interface CheckPutAwayCellRuleForPalletItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckPutAwayCellRuleForPalletItemOutputDTO
     */
    validation?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CheckPutAwayCellRuleForPalletItemOutputDTO
     */
    skUs?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CheckPutAwayCellRuleForPalletItemOutputDTO
     */
    expectedValue?: number;
    /**
     * 
     * @type {number}
     * @memberof CheckPutAwayCellRuleForPalletItemOutputDTO
     */
    actualValue?: number;
}
/**
 * 
 * @export
 * @interface CheckPutAwayCellRuleForPalletOutputDTO
 */
export interface CheckPutAwayCellRuleForPalletOutputDTO {
    /**
     * 
     * @type {Array<CheckPutAwayCellRuleForPalletItemOutputDTO>}
     * @memberof CheckPutAwayCellRuleForPalletOutputDTO
     */
    validations?: Array<CheckPutAwayCellRuleForPalletItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface CheckQuarantineToteCommand
 */
export interface CheckQuarantineToteCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckQuarantineToteCommand
     */
    quarantineToteLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckReturnItemSerialNumberCommandOutputDTO
 */
export interface CheckReturnItemSerialNumberCommandOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CheckReturnItemSerialNumberCommandOutputDTO
     */
    isExistOnOtherItems?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckReturnItemSerialNumberCommandOutputDTO
     */
    isExistInCurrentSalesOrder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckReturnItemSerialNumberCommandOutputDTO
     */
    isExistInSalesOrderSimpleSerialNumberItems?: boolean;
}
/**
 * 
 * @export
 * @interface CheckSalesOrderSimpleSerialNumber
 */
export interface CheckSalesOrderSimpleSerialNumber {
    /**
     * 
     * @type {string}
     * @memberof CheckSalesOrderSimpleSerialNumber
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckSalesOrderSimpleSerialNumber
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckSalesOrderSimpleSerialNumber
     */
    simpleSerialNumber?: string;
}
/**
 * 
 * @export
 * @interface CheckSerialNumberExistsInOtherCellCommand
 */
export interface CheckSerialNumberExistsInOtherCellCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckSerialNumberExistsInOtherCellCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckSerialNumberExistsInOtherCellCommand
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckSerialNumberExistsInOtherCellCommand
     */
    productId?: string;
}
/**
 * 
 * @export
 * @interface CheckSerialNumberExistsInOtherCellOutputDTO
 */
export interface CheckSerialNumberExistsInOtherCellOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CheckSerialNumberExistsInOtherCellOutputDTO
     */
    isExistsInOtherCell?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CheckSerialNumberExistsInOtherCellOutputDTO
     */
    cellLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckTargetToteForQuarantineToValidTransferCommand
 */
export interface CheckTargetToteForQuarantineToValidTransferCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckTargetToteForQuarantineToValidTransferCommand
     */
    sourceToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckTargetToteForQuarantineToValidTransferCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckTargetToteForQuarantineToValidTransferCommand
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckTargetToteForQuarantineToValidTransferCommand
     */
    targetToteLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckTotalCountForQuarantineToValidTransferCommand
 */
export interface CheckTotalCountForQuarantineToValidTransferCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckTotalCountForQuarantineToValidTransferCommand
     */
    sourceToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckTotalCountForQuarantineToValidTransferCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckTotalCountForQuarantineToValidTransferCommand
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface CheckTotalProductCountExistCommand
 */
export interface CheckTotalProductCountExistCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckTotalProductCountExistCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckTotalProductCountExistCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckTotalProductCountExistCommand
     */
    productCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CheckTotalProductCountExistCommand
     */
    putAwayReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface CheckToteCommand
 */
export interface CheckToteCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckToteCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckToteForQuarantineToValidTransferCommand
 */
export interface CheckToteForQuarantineToValidTransferCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckToteForQuarantineToValidTransferCommand
     */
    sourceToteLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckToteForStockToQuarantineTransferCommand
 */
export interface CheckToteForStockToQuarantineTransferCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckToteForStockToQuarantineTransferCommand
     */
    sourceCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckToteForStockToQuarantineTransferCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckToteForStockToQuarantineTransferCommand
     */
    targetToteLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckToteForStockToRestowTransferCommand
 */
export interface CheckToteForStockToRestowTransferCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckToteForStockToRestowTransferCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckToteIfAvailableCommand
 */
export interface CheckToteIfAvailableCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckToteIfAvailableCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckToteOnTrolleyCommand
 */
export interface CheckToteOnTrolleyCommand {
    /**
     * 
     * @type {number}
     * @memberof CheckToteOnTrolleyCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckToteOnTrolleyCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckToteSalesOrderStateOutputDTO
 */
export interface CheckToteSalesOrderStateOutputDTO {
    /**
     * 
     * @type {ToteSalesOrderState}
     * @memberof CheckToteSalesOrderStateOutputDTO
     */
    toteSalesOrderState?: ToteSalesOrderState;
}
/**
 * 
 * @export
 * @interface CheckToteSelectivePickingDropAddressCommand
 */
export interface CheckToteSelectivePickingDropAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckToteSelectivePickingDropAddressCommand
     */
    pickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckToteSelectivePickingDropAddressCommand
     */
    dropAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckToteSelectivePickingDropAddressCommandOutputDTO
 */
export interface CheckToteSelectivePickingDropAddressCommandOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckToteSelectivePickingDropAddressCommandOutputDTO
     */
    nextToteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckToteSelectivePickingDropAddressCommandOutputDTO
     */
    nextToteContainedItemsAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CheckToteSelectivePickingDropAddressCommandOutputDTO
     */
    remainingToteCount?: number;
}
/**
 * 
 * @export
 * @interface CheckTransferTrolleyBarcodeTypeOutputDTO
 */
export interface CheckTransferTrolleyBarcodeTypeOutputDTO {
    /**
     * 
     * @type {AddressType}
     * @memberof CheckTransferTrolleyBarcodeTypeOutputDTO
     */
    addressType?: AddressType;
}
/**
 * 
 * @export
 * @interface CheckTrolleyForRasReplenishmentOutputDTO
 */
export interface CheckTrolleyForRasReplenishmentOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckTrolleyForRasReplenishmentOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {PlaceToteToTrolleyOutputDTO}
     * @memberof CheckTrolleyForRasReplenishmentOutputDTO
     */
    totes?: PlaceToteToTrolleyOutputDTO;
}
/**
 * 
 * @export
 * @interface CheckUserActivePickingOutputDTO
 */
export interface CheckUserActivePickingOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CheckUserActivePickingOutputDTO
     */
    hasActivePicking?: boolean;
}
/**
 * 
 * @export
 * @interface CheckWaitingPutAwayPalletsOutputDTO
 */
export interface CheckWaitingPutAwayPalletsOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CheckWaitingPutAwayPalletsOutputDTO
     */
    hasProblems?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckWaitingPutAwayPalletsOutputDTO
     */
    hasZoneProblem?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CheckWaitingPutAwayPalletsOutputDTO
     */
    hasExpirationDateProblems?: boolean;
}
/**
 * 
 * @export
 * @interface CheckWaitingPutAwayPalletsOutputDTODynamicQueryOutputDTO
 */
export interface CheckWaitingPutAwayPalletsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<CheckWaitingPutAwayPalletsOutputDTO>}
     * @memberof CheckWaitingPutAwayPalletsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<CheckWaitingPutAwayPalletsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof CheckWaitingPutAwayPalletsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CheckWallToWallStockCountingPlanNameIfAvailableCommand
 */
export interface CheckWallToWallStockCountingPlanNameIfAvailableCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckWallToWallStockCountingPlanNameIfAvailableCommand
     */
    stockCountingPlanName?: string;
}
/**
 * 
 * @export
 * @interface CheckWranglingToteCommand
 */
export interface CheckWranglingToteCommand {
    /**
     * 
     * @type {string}
     * @memberof CheckWranglingToteCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface CheckWranglingToteOutputDTO
 */
export interface CheckWranglingToteOutputDTO {
    /**
     * 
     * @type {WranglingToteType}
     * @memberof CheckWranglingToteOutputDTO
     */
    type?: WranglingToteType;
    /**
     * 
     * @type {string}
     * @memberof CheckWranglingToteOutputDTO
     */
    batchTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckWranglingToteOutputDTO
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface Claim
 */
export interface Claim {
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    issuer?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    originalIssuer?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Claim
     */
    properties?: { [key: string]: string; };
    /**
     * 
     * @type {ClaimsIdentity}
     * @memberof Claim
     */
    subject?: ClaimsIdentity;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    valueType?: string;
}
/**
 * 
 * @export
 * @interface ClaimsIdentity
 */
export interface ClaimsIdentity {
    /**
     * 
     * @type {string}
     * @memberof ClaimsIdentity
     */
    authenticationType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimsIdentity
     */
    isAuthenticated?: boolean;
    /**
     * 
     * @type {ClaimsIdentity}
     * @memberof ClaimsIdentity
     */
    actor?: ClaimsIdentity;
    /**
     * 
     * @type {object}
     * @memberof ClaimsIdentity
     */
    bootstrapContext?: object;
    /**
     * 
     * @type {Array<Claim>}
     * @memberof ClaimsIdentity
     */
    claims?: Array<Claim>;
    /**
     * 
     * @type {string}
     * @memberof ClaimsIdentity
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsIdentity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsIdentity
     */
    nameClaimType?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsIdentity
     */
    roleClaimType?: string;
}
/**
 * 
 * @export
 * @interface ClaimsPrincipal
 */
export interface ClaimsPrincipal {
    /**
     * 
     * @type {Array<Claim>}
     * @memberof ClaimsPrincipal
     */
    claims?: Array<Claim>;
    /**
     * 
     * @type {Array<ClaimsIdentity>}
     * @memberof ClaimsPrincipal
     */
    identities?: Array<ClaimsIdentity>;
    /**
     * 
     * @type {IIdentity}
     * @memberof ClaimsPrincipal
     */
    identity?: IIdentity;
}
/**
 * 
 * @export
 * @interface CleanupDeletedOperationInventoryItemsCommand
 */
export interface CleanupDeletedOperationInventoryItemsCommand {
    /**
     * 
     * @type {string}
     * @memberof CleanupDeletedOperationInventoryItemsCommand
     */
    operationId?: string;
}
/**
 * 
 * @export
 * @interface CleanupDeletedOperationInventoryItemsOutputDTO
 */
export interface CleanupDeletedOperationInventoryItemsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CleanupDeletedOperationInventoryItemsOutputDTO
     */
    deletedInventoryItemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CleanupDeletedOperationInventoryItemsOutputDTO
     */
    affectedProductsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CleanupDeletedOperationInventoryItemsOutputDTO
     */
    affectedOperationsCount?: number;
    /**
     * 
     * @type {Array<DeletedOperationInfo>}
     * @memberof CleanupDeletedOperationInventoryItemsOutputDTO
     */
    deletedOperations?: Array<DeletedOperationInfo>;
}
/**
 * 
 * @export
 * @interface ClearSalesOrderSuspendedStateCommand
 */
export interface ClearSalesOrderSuspendedStateCommand {
    /**
     * 
     * @type {string}
     * @memberof ClearSalesOrderSuspendedStateCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClearSalesOrderSuspendedStateCommand
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface ClosePickStationCommand
 */
export interface ClosePickStationCommand {
    /**
     * 
     * @type {string}
     * @memberof ClosePickStationCommand
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface CloseStowStationCommand
 */
export interface CloseStowStationCommand {
    /**
     * 
     * @type {string}
     * @memberof CloseStowStationCommand
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface CombineSalesOrderItemsToToteCommand
 */
export interface CombineSalesOrderItemsToToteCommand {
    /**
     * 
     * @type {string}
     * @memberof CombineSalesOrderItemsToToteCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CombineSalesOrderItemsToToteCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof CombineSalesOrderItemsToToteCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface CombineToToteOutputDTO
 */
export interface CombineToToteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CombineToToteOutputDTO
     */
    restrictedTargetToteLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteBatchPickingProcessCommand
 */
export interface CompleteBatchPickingProcessCommand {
    /**
     * 
     * @type {number}
     * @memberof CompleteBatchPickingProcessCommand
     */
    pickingReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof CompleteBatchPickingProcessCommand
     */
    placeTrolleyAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteBatchWranglingCommand
 */
export interface CompleteBatchWranglingCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteBatchWranglingCommand
     */
    batchTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteBatchWranglingCommand
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteDispatchSalesOrderCommand
 */
export interface CompleteDispatchSalesOrderCommand {
    /**
     * 
     * @type {number}
     * @memberof CompleteDispatchSalesOrderCommand
     */
    dispatchProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof CompleteDispatchSalesOrderCommand
     */
    salesOrderId?: string;
    /**
     * 
     * @type {Array<CargoPackagesOutputDTO>}
     * @memberof CompleteDispatchSalesOrderCommand
     */
    cargoPackages?: Array<CargoPackagesOutputDTO>;
}
/**
 * 
 * @export
 * @interface CompleteHOVBatchWranglingCommand
 */
export interface CompleteHOVBatchWranglingCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteHOVBatchWranglingCommand
     */
    batchTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteHOVBatchWranglingCommand
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteHOVPackingProcessCommand
 */
export interface CompleteHOVPackingProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteHOVPackingProcessCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {Array<HOVCargoPackageInputDTO>}
     * @memberof CompleteHOVPackingProcessCommand
     */
    packages?: Array<HOVCargoPackageInputDTO>;
    /**
     * 
     * @type {Array<InsertToHOVPackageVASInputDTO>}
     * @memberof CompleteHOVPackingProcessCommand
     */
    insertToPackageVAS?: Array<InsertToHOVPackageVASInputDTO>;
    /**
     * 
     * @type {string}
     * @memberof CompleteHOVPackingProcessCommand
     */
    hovPackingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteHOVPackingQuarantineProcessCommand
 */
export interface CompleteHOVPackingQuarantineProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteHOVPackingQuarantineProcessCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {HOVQuarantineToteInputDTO}
     * @memberof CompleteHOVPackingQuarantineProcessCommand
     */
    quarantineTote?: HOVQuarantineToteInputDTO;
    /**
     * 
     * @type {string}
     * @memberof CompleteHOVPackingQuarantineProcessCommand
     */
    hovPackingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteHOVSalesOrderPackingCommand
 */
export interface CompleteHOVSalesOrderPackingCommand {
    /**
     * 
     * @type {Array<CompleteHOVSalesOrderPackingInputDTO>}
     * @memberof CompleteHOVSalesOrderPackingCommand
     */
    salesOrders?: Array<CompleteHOVSalesOrderPackingInputDTO>;
}
/**
 * 
 * @export
 * @interface CompleteHOVSalesOrderPackingInputDTO
 */
export interface CompleteHOVSalesOrderPackingInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CompleteHOVSalesOrderPackingInputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteHOVSalesOrderPackingInputDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface CompleteHOVSalesOrderPickingCommand
 */
export interface CompleteHOVSalesOrderPickingCommand {
    /**
     * 
     * @type {Array<CompleteHOVSalesOrderPickingInputDTO>}
     * @memberof CompleteHOVSalesOrderPickingCommand
     */
    salesOrders?: Array<CompleteHOVSalesOrderPickingInputDTO>;
}
/**
 * 
 * @export
 * @interface CompleteHOVSalesOrderPickingInputDTO
 */
export interface CompleteHOVSalesOrderPickingInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CompleteHOVSalesOrderPickingInputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteHOVSalesOrderPickingInputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteHOVSalesOrderPickingInputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteHOVSalesOrderPickingInputDTO
     */
    trolleyLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteHOVSortingCommand
 */
export interface CompleteHOVSortingCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteHOVSortingCommand
     */
    batchTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteHOVSortingCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteHovSortingOutputDto
 */
export interface CompleteHovSortingOutputDto {
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof CompleteHovSortingOutputDto
     */
    pickingFlowTag?: PickingFlowTag;
    /**
     * 
     * @type {string}
     * @memberof CompleteHovSortingOutputDto
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteHovSortingOutputDto
     */
    sortingStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteHovSortingOutputDto
     */
    salesOrderState?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteHovSortingOutputDto
     */
    pickListRequestState?: string;
}
/**
 * 
 * @export
 * @interface CompleteHovSortingOutputDtoDynamicQueryOutputDTO
 */
export interface CompleteHovSortingOutputDtoDynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<CompleteHovSortingOutputDto>}
     * @memberof CompleteHovSortingOutputDtoDynamicQueryOutputDTO
     */
    data?: Array<CompleteHovSortingOutputDto>;
    /**
     * 
     * @type {number}
     * @memberof CompleteHovSortingOutputDtoDynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CompleteMissingWranglingCommand
 */
export interface CompleteMissingWranglingCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteMissingWranglingCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteMissingWranglingCommand
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompletePackingProcessCommand
 */
export interface CompletePackingProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CompletePackingProcessCommand
     */
    pickingToteLabel?: string;
    /**
     * 
     * @type {Array<CargoPackageInputDTO>}
     * @memberof CompletePackingProcessCommand
     */
    packages?: Array<CargoPackageInputDTO>;
    /**
     * 
     * @type {Array<InsertToPackageVASInputDTO>}
     * @memberof CompletePackingProcessCommand
     */
    insertToPackageVAS?: Array<InsertToPackageVASInputDTO>;
    /**
     * 
     * @type {string}
     * @memberof CompletePackingProcessCommand
     */
    packingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompletePackingProcessOutputDTO
 */
export interface CompletePackingProcessOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CompletePackingProcessOutputDTO
     */
    failedMessage?: string;
    /**
     * 
     * @type {InternalErrorNumber}
     * @memberof CompletePackingProcessOutputDTO
     */
    errorNumber?: InternalErrorNumber;
}
/**
 * 
 * @export
 * @interface CompletePackingQuarantineProcessCommand
 */
export interface CompletePackingQuarantineProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CompletePackingQuarantineProcessCommand
     */
    pickingToteLabel?: string;
    /**
     * 
     * @type {QuarantineToteInputDTO}
     * @memberof CompletePackingQuarantineProcessCommand
     */
    quarantineTote?: QuarantineToteInputDTO;
    /**
     * 
     * @type {string}
     * @memberof CompletePackingQuarantineProcessCommand
     */
    packingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompletePalletPutAwayCommand
 */
export interface CompletePalletPutAwayCommand {
    /**
     * 
     * @type {number}
     * @memberof CompletePalletPutAwayCommand
     */
    putAwayReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface CompletePickingProcessCommand
 */
export interface CompletePickingProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CompletePickingProcessCommand
     */
    placeTrolleyAddressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CompletePickingProcessCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface CompletePickingProcessForSingleItemFastPackPickingCommand
 */
export interface CompletePickingProcessForSingleItemFastPackPickingCommand {
    /**
     * 
     * @type {number}
     * @memberof CompletePickingProcessForSingleItemFastPackPickingCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface CompletePickingProcessForSingleItemPickingCommand
 */
export interface CompletePickingProcessForSingleItemPickingCommand {
    /**
     * 
     * @type {number}
     * @memberof CompletePickingProcessForSingleItemPickingCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface CompletePurchaseOrderCommand
 */
export interface CompletePurchaseOrderCommand {
    /**
     * 
     * @type {string}
     * @memberof CompletePurchaseOrderCommand
     */
    purchaseOrderId?: string;
}
/**
 * 
 * @export
 * @interface CompletePutAwayCommand
 */
export interface CompletePutAwayCommand {
    /**
     * 
     * @type {number}
     * @memberof CompletePutAwayCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof CompletePutAwayCommand
     */
    parkAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteQuickPutAwayCommand
 */
export interface CompleteQuickPutAwayCommand {
    /**
     * 
     * @type {number}
     * @memberof CompleteQuickPutAwayCommand
     */
    quickPutAwayReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface CompleteReceivingProcessCommand
 */
export interface CompleteReceivingProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteReceivingProcessCommand
     */
    receivingProcessId?: string;
}
/**
 * 
 * @export
 * @interface CompleteReplenishmentJobInputDTO
 */
export interface CompleteReplenishmentJobInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CompleteReplenishmentJobInputDTO
     */
    jobId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteReplenishmentJobInputDTO
     */
    sourceCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteReplenishmentJobInputDTO
     */
    targetCellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CompleteReplenishmentJobInputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface CompleteRestowProcessCommand
 */
export interface CompleteRestowProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteRestowProcessCommand
     */
    quarantineToteLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteRestowProcessOutputDTO
 */
export interface CompleteRestowProcessOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CompleteRestowProcessOutputDTO
     */
    damagedItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CompleteRestowProcessOutputDTO
     */
    restowItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CompleteRestowProcessOutputDTO
     */
    totalItemCount?: number;
}
/**
 * 
 * @export
 * @interface CompleteReturnProcessCommand
 */
export interface CompleteReturnProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteReturnProcessCommand
     */
    processId?: string;
    /**
     * 
     * @type {Array<ReturnToteInputDTO>}
     * @memberof CompleteReturnProcessCommand
     */
    totes?: Array<ReturnToteInputDTO>;
}
/**
 * 
 * @export
 * @interface CompleteReturnReceivingCommand
 */
export interface CompleteReturnReceivingCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteReturnReceivingCommand
     */
    returnReceivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteReturnReceivingCommand
     */
    returnAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteReturnReceivingOutputDTO
 */
export interface CompleteReturnReceivingOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CompleteReturnReceivingOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteReturnReceivingOutputDTO
     */
    operatorId?: string;
    /**
     * 
     * @type {number}
     * @memberof CompleteReturnReceivingOutputDTO
     */
    returnTrolleyId?: number;
    /**
     * 
     * @type {Array<ReturnPackageComponentOutputDTO>}
     * @memberof CompleteReturnReceivingOutputDTO
     */
    returnPackages?: Array<ReturnPackageComponentOutputDTO>;
}
/**
 * 
 * @export
 * @interface CompleteSLAMForManualDeliverySalesOrdersCommand
 */
export interface CompleteSLAMForManualDeliverySalesOrdersCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteSLAMForManualDeliverySalesOrdersCommand
     */
    salesOrderReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface CompleteSalesOrderCargoPackagesTransferToAddressCommand
 */
export interface CompleteSalesOrderCargoPackagesTransferToAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteSalesOrderCargoPackagesTransferToAddressCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteSalesOrderCargoPackagesTransferToAddressCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompleteSalesOrderCargoPackagesTransferToAddressCommand
     */
    cargoPackageLabels?: Array<string>;
}
/**
 * 
 * @export
 * @interface CompleteSalesOrderPackingProcessCommand
 */
export interface CompleteSalesOrderPackingProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteSalesOrderPackingProcessCommand
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteSalesOrderPackingProcessCommand
     */
    cargoPackageTypeBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteSalesOrderPackingProcessCommand
     */
    singleItemPackingAddressLabel?: string;
    /**
     * 
     * @type {Array<InsertToPackageVASInputDTO>}
     * @memberof CompleteSalesOrderPackingProcessCommand
     */
    insertToPackageVAS?: Array<InsertToPackageVASInputDTO>;
}
/**
 * 
 * @export
 * @interface CompleteSimplePackingProcessCommand
 */
export interface CompleteSimplePackingProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteSimplePackingProcessCommand
     */
    packingAddressLabel?: string;
    /**
     * 
     * @type {Array<CargoPackageInputDTO>}
     * @memberof CompleteSimplePackingProcessCommand
     */
    packages?: Array<CargoPackageInputDTO>;
    /**
     * 
     * @type {Array<InsertToPackageVASInputDTO>}
     * @memberof CompleteSimplePackingProcessCommand
     */
    insertToPackageVAS?: Array<InsertToPackageVASInputDTO>;
}
/**
 * 
 * @export
 * @interface CompleteSimplePickingProcessCommand
 */
export interface CompleteSimplePickingProcessCommand {
    /**
     * 
     * @type {number}
     * @memberof CompleteSimplePickingProcessCommand
     */
    pickingReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof CompleteSimplePickingProcessCommand
     */
    packingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteSingleItemFastPackQuarantineProcessCommand
 */
export interface CompleteSingleItemFastPackQuarantineProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteSingleItemFastPackQuarantineProcessCommand
     */
    pickingToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteSingleItemFastPackQuarantineProcessCommand
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteSingleItemFastPackQuarantineProcessCommand
     */
    quarantineAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteSingleItemPackingQuarantineProcessCommand
 */
export interface CompleteSingleItemPackingQuarantineProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteSingleItemPackingQuarantineProcessCommand
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteSingleItemPackingQuarantineProcessCommand
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteSingleItemPackingQuarantineProcessCommand
     */
    quarantineAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteSingleItemReceivingCommand
 */
export interface CompleteSingleItemReceivingCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteSingleItemReceivingCommand
     */
    receivingProcessId?: string;
}
/**
 * 
 * @export
 * @interface CompleteSingleWranglingCommand
 */
export interface CompleteSingleWranglingCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteSingleWranglingCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteSingleWranglingCommand
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteStockCountingListCommand
 */
export interface CompleteStockCountingListCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteStockCountingListCommand
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteStockCountingListCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteStockCountingListCommandOutputDTO
 */
export interface CompleteStockCountingListCommandOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CompleteStockCountingListCommandOutputDTO
     */
    completedStockCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CompleteStockCountingListCommandOutputDTO
     */
    totalStockCountingAmount?: number;
}
/**
 * 
 * @export
 * @interface CompleteStockItemsToRestowTransferCommand
 */
export interface CompleteStockItemsToRestowTransferCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteStockItemsToRestowTransferCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteStockItemsToRestowTransferCommand
     */
    inboundLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand
 */
export interface CompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand
     */
    singleItemFastPackPackingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand
     */
    dropAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteToteSingleItemPackingProcessCommand
 */
export interface CompleteToteSingleItemPackingProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteToteSingleItemPackingProcessCommand
     */
    singleItemPackingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteToteSingleItemPackingProcessCommand
     */
    dropAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteTrolleyTransferCommand
 */
export interface CompleteTrolleyTransferCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteTrolleyTransferCommand
     */
    transferTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteTrolleyTransferCommand
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteUnassignedHOVSalesOrderPickingCommand
 */
export interface CompleteUnassignedHOVSalesOrderPickingCommand {
    /**
     * 
     * @type {Array<CompleteUnassignedHOVSalesOrderPickingInputDTO>}
     * @memberof CompleteUnassignedHOVSalesOrderPickingCommand
     */
    salesOrders?: Array<CompleteUnassignedHOVSalesOrderPickingInputDTO>;
}
/**
 * 
 * @export
 * @interface CompleteUnassignedHOVSalesOrderPickingInputDTO
 */
export interface CompleteUnassignedHOVSalesOrderPickingInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CompleteUnassignedHOVSalesOrderPickingInputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteUnassignedHOVSalesOrderPickingInputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteUnassignedHOVSalesOrderPickingInputDTO
     */
    containerLabel?: string;
}
/**
 * 
 * @export
 * @interface CompleteWaybillCommand
 */
export interface CompleteWaybillCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteWaybillCommand
     */
    waybillId?: string;
}
/**
 * 
 * @export
 * @interface CompleteWebReceivingCommand
 */
export interface CompleteWebReceivingCommand {
    /**
     * 
     * @type {string}
     * @memberof CompleteWebReceivingCommand
     */
    webReceivingProcessId?: string;
}
/**
 * 
 * @export
 * @interface CompletedMissingItemTransferProcessCommand
 */
export interface CompletedMissingItemTransferProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CompletedMissingItemTransferProcessCommand
     */
    missingItemTransferProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompletedMissingItemTransferProcessCommand
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {Array<PickedMissingItemsInputDTO>}
     * @memberof CompletedMissingItemTransferProcessCommand
     */
    pickedMissingItems?: Array<PickedMissingItemsInputDTO>;
}
/**
 * 
 * @export
 * @interface CompletedWithLostItemMissingItemTransferProcessCommand
 */
export interface CompletedWithLostItemMissingItemTransferProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CompletedWithLostItemMissingItemTransferProcessCommand
     */
    missingItemTransferProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompletedWithLostItemMissingItemTransferProcessCommand
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {Array<PickedMissingItemsInputDTO>}
     * @memberof CompletedWithLostItemMissingItemTransferProcessCommand
     */
    pickedMissingItems?: Array<PickedMissingItemsInputDTO>;
}
/**
 * 
 * @export
 * @interface CompletionTimeResultDTO
 */
export interface CompletionTimeResultDTO {
    /**
     * 
     * @type {number}
     * @memberof CompletionTimeResultDTO
     */
    totalTime?: number;
}
/**
 * 
 * @export
 * @interface ComputeClause
 */
export interface ComputeClause {
    /**
     * 
     * @type {Array<ComputeExpression>}
     * @memberof ComputeClause
     */
    computedItems?: Array<ComputeExpression>;
}
/**
 * 
 * @export
 * @interface ComputeExpression
 */
export interface ComputeExpression {
    /**
     * 
     * @type {SingleValueNode}
     * @memberof ComputeExpression
     */
    expression?: SingleValueNode;
    /**
     * 
     * @type {string}
     * @memberof ComputeExpression
     */
    alias?: string;
    /**
     * 
     * @type {IEdmTypeReference}
     * @memberof ComputeExpression
     */
    typeReference?: IEdmTypeReference;
}
/**
 * 
 * @export
 * @interface ComputeQueryOption
 */
export interface ComputeQueryOption {
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof ComputeQueryOption
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {string}
     * @memberof ComputeQueryOption
     */
    resultClrType?: string;
    /**
     * 
     * @type {ComputeClause}
     * @memberof ComputeQueryOption
     */
    computeClause?: ComputeClause;
    /**
     * 
     * @type {string}
     * @memberof ComputeQueryOption
     */
    rawValue?: string;
}
/**
 * 
 * @export
 * @interface ConnectionInfo
 */
export interface ConnectionInfo {
    /**
     * 
     * @type {string}
     * @memberof ConnectionInfo
     */
    id?: string;
    /**
     * 
     * @type {IPAddress}
     * @memberof ConnectionInfo
     */
    remoteIpAddress?: IPAddress;
    /**
     * 
     * @type {number}
     * @memberof ConnectionInfo
     */
    remotePort?: number;
    /**
     * 
     * @type {IPAddress}
     * @memberof ConnectionInfo
     */
    localIpAddress?: IPAddress;
    /**
     * 
     * @type {number}
     * @memberof ConnectionInfo
     */
    localPort?: number;
    /**
     * 
     * @type {X509Certificate2}
     * @memberof ConnectionInfo
     */
    clientCertificate?: X509Certificate2;
}
/**
 * 
 * @export
 * @interface ContactInfoOutputDTO
 */
export interface ContactInfoOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ContactInfoOutputDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInfoOutputDTO
     */
    phone?: string;
}
/**
 * 
 * @export
 * @interface ContainedItemZoneListOutputDTO
 */
export interface ContainedItemZoneListOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ContainedItemZoneListOutputDTO
     */
    zoneName?: string;
    /**
     * 
     * @type {number}
     * @memberof ContainedItemZoneListOutputDTO
     */
    productCount?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ContainedItemsType {
    Empty = 'Empty',
    Received = 'Received',
    Damaged = 'Damaged',
    Outbound = 'Outbound'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ContainerBarcodeType {
    None = 'None',
    InboundBox = 'InboundBox',
    PrimeCell = 'PrimeCell',
    ReservedCell = 'ReservedCell',
    Tote = 'Tote',
    LostItemContainer = 'LostItemContainer',
    CargoPackage = 'CargoPackage'
}

/**
 * 
 * @export
 * @interface ContainerDetailsOutputDTO
 */
export interface ContainerDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ContainerDetailsOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {Array<OperationOutputDTO>}
     * @memberof ContainerDetailsOutputDTO
     */
    operations?: Array<OperationOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ContainerDetailsOutputDTO
     */
    productTypeCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ContainerDetailsOutputDTO
     */
    productCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ContainerDetailsOutputDTO
     */
    zone?: string;
    /**
     * 
     * @type {StockCellCategory}
     * @memberof ContainerDetailsOutputDTO
     */
    stockCellType?: StockCellCategory;
}
/**
 * 
 * @export
 * @interface ContainerItemExpirationDateAmount
 */
export interface ContainerItemExpirationDateAmount {
    /**
     * 
     * @type {string}
     * @memberof ContainerItemExpirationDateAmount
     */
    expirationDate?: string;
    /**
     * 
     * @type {number}
     * @memberof ContainerItemExpirationDateAmount
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface ContainerOutputDTO
 */
export interface ContainerOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ContainerOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerOutputDTO
     */
    containerType?: string;
    /**
     * 
     * @type {number}
     * @memberof ContainerOutputDTO
     */
    productCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ContainerOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerOutputDTO
     */
    referenceNumber?: string;
}
/**
 * 
 * @export
 * @interface ContainerProductDetailsOutputDTO
 */
export interface ContainerProductDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ContainerProductDetailsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerProductDetailsOutputDTO
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerProductDetailsOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerProductDetailsOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerProductDetailsOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {number}
     * @memberof ContainerProductDetailsOutputDTO
     */
    productCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ContainerProductDetailsOutputDTO
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerProductDetailsOutputDTO
     */
    lotNumber?: string;
    /**
     * 
     * @type {Array<OperationOutputDTO>}
     * @memberof ContainerProductDetailsOutputDTO
     */
    operations?: Array<OperationOutputDTO>;
}
/**
 * 
 * @export
 * @interface ContainerStatusDTO
 */
export interface ContainerStatusDTO {
    /**
     * 
     * @type {boolean}
     * @memberof ContainerStatusDTO
     */
    isEmpty?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContainerStatusDTO
     */
    remainingItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ContainerStatusDTO
     */
    remainingStockItems?: number;
    /**
     * 
     * @type {number}
     * @memberof ContainerStatusDTO
     */
    remainingDamagedItems?: number;
    /**
     * 
     * @type {number}
     * @memberof ContainerStatusDTO
     */
    remainingOtherItems?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ContainerType {
    PrimeCell = 'PrimeCell',
    LostItemContainer = 'LostItemContainer',
    Tote = 'Tote',
    CargoPackage = 'CargoPackage',
    InboundBox = 'InboundBox',
    ReservedCell = 'ReservedCell',
    Pallet = 'Pallet',
    VirtualPackingTote = 'VirtualPackingTote'
}

/**
 * 
 * @export
 * @interface ContainerWithReceivedItemsOutputDTO
 */
export interface ContainerWithReceivedItemsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ContainerWithReceivedItemsOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof ContainerWithReceivedItemsOutputDTO
     */
    masterCartonItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ContainerWithReceivedItemsOutputDTO
     */
    totalItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ContainerWithReceivedItemsOutputDTO
     */
    totalProductCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ContainerWithReceivedItemsOutputDTO
     */
    containerType?: string;
    /**
     * 
     * @type {Array<ReceivedItemOutputDTO>}
     * @memberof ContainerWithReceivedItemsOutputDTO
     */
    receivedItems?: Array<ReceivedItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface ContinueBatchPickingOutputDTO
 */
export interface ContinueBatchPickingOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ContinueBatchPickingOutputDTO
     */
    nextToteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof ContinueBatchPickingOutputDTO
     */
    nextToteContainedItemsAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ContinueBatchPickingOutputDTO
     */
    remainingToteCount?: number;
}
/**
 * 
 * @export
 * @interface ContinueCreatedSimplePickingCommand
 */
export interface ContinueCreatedSimplePickingCommand {
    /**
     * 
     * @type {string}
     * @memberof ContinueCreatedSimplePickingCommand
     */
    qrCode?: string;
}
/**
 * 
 * @export
 * @interface ContinueIfTotesExistsOnReceivingAddressOutputDTO
 */
export interface ContinueIfTotesExistsOnReceivingAddressOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ContinueIfTotesExistsOnReceivingAddressOutputDTO
     */
    webReceivingProcessId?: string;
    /**
     * 
     * @type {WebReceivingInboundBoxDetailsOutputDTO}
     * @memberof ContinueIfTotesExistsOnReceivingAddressOutputDTO
     */
    inboundBox?: WebReceivingInboundBoxDetailsOutputDTO;
    /**
     * 
     * @type {WebReceivingToteDetailsOutputDTO}
     * @memberof ContinueIfTotesExistsOnReceivingAddressOutputDTO
     */
    receivingTote?: WebReceivingToteDetailsOutputDTO;
    /**
     * 
     * @type {WebReceivingToteDetailsOutputDTO}
     * @memberof ContinueIfTotesExistsOnReceivingAddressOutputDTO
     */
    quarantineTote?: WebReceivingToteDetailsOutputDTO;
}
/**
 * 
 * @export
 * @interface ContinuePickingIfExistCommand
 */
export interface ContinuePickingIfExistCommand {
    /**
     * 
     * @type {string}
     * @memberof ContinuePickingIfExistCommand
     */
    trolleyLabel?: string;
}
/**
 * 
 * @export
 * @interface ContinuePickingIfExistCommandOutputDTO
 */
export interface ContinuePickingIfExistCommandOutputDTO {
    /**
     * 
     * @type {RouteOutputDTO}
     * @memberof ContinuePickingIfExistCommandOutputDTO
     */
    route?: RouteOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof ContinuePickingIfExistCommandOutputDTO
     */
    currentTote?: string;
    /**
     * 
     * @type {number}
     * @memberof ContinuePickingIfExistCommandOutputDTO
     */
    currentToteContainedItemsCount?: number;
    /**
     * 
     * @type {PickingProcessType}
     * @memberof ContinuePickingIfExistCommandOutputDTO
     */
    pickingProcessType?: PickingProcessType;
    /**
     * 
     * @type {number}
     * @memberof ContinuePickingIfExistCommandOutputDTO
     */
    expectedCurrentItemAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ContinuePickingIfExistCommandOutputDTO
     */
    isCurrentItemCountEntryAllowed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContinuePickingIfExistCommandOutputDTO
     */
    salesOrderCount?: number;
    /**
     * 
     * @type {ContinueBatchPickingOutputDTO}
     * @memberof ContinuePickingIfExistCommandOutputDTO
     */
    continueBatchPickingOutputDTO?: ContinueBatchPickingOutputDTO;
}
/**
 * 
 * @export
 * @interface ContinueWallToWallStockCountingListCommand
 */
export interface ContinueWallToWallStockCountingListCommand {
    /**
     * 
     * @type {string}
     * @memberof ContinueWallToWallStockCountingListCommand
     */
    qrCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ContinueWallToWallStockCountingListCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContinueWallToWallStockCountingListCommand
     */
    isOperatorReassigned?: boolean;
}
/**
 * 
 * @export
 * @interface ControlCountingResultItemInputDTO
 */
export interface ControlCountingResultItemInputDTO {
    /**
     * 
     * @type {string}
     * @memberof ControlCountingResultItemInputDTO
     */
    productBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlCountingResultItemInputDTO
     */
    amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlCountingResultItemInputDTO
     */
    serialNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface ConvertCancelledToteSalesOrderItemsToRestowItemCommand
 */
export interface ConvertCancelledToteSalesOrderItemsToRestowItemCommand {
    /**
     * 
     * @type {string}
     * @memberof ConvertCancelledToteSalesOrderItemsToRestowItemCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface CorrectInboundProblemCommand
 */
export interface CorrectInboundProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof CorrectInboundProblemCommand
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {InboundProblemSolutionType}
     * @memberof CorrectInboundProblemCommand
     */
    solutionType?: InboundProblemSolutionType;
}
/**
 * 
 * @export
 * @interface CorrectWrongShippingAddressCommand
 */
export interface CorrectWrongShippingAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof CorrectWrongShippingAddressCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof CorrectWrongShippingAddressCommand
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CorrectWrongShippingAddressCommand
     */
    addressFirstLine?: string;
    /**
     * 
     * @type {string}
     * @memberof CorrectWrongShippingAddressCommand
     */
    addressSecondLine?: string;
    /**
     * 
     * @type {string}
     * @memberof CorrectWrongShippingAddressCommand
     */
    district?: string;
    /**
     * 
     * @type {string}
     * @memberof CorrectWrongShippingAddressCommand
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CorrectWrongShippingAddressCommand
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CorrectWrongShippingAddressCommand
     */
    zipCode?: string;
}
/**
 * 
 * @export
 * @interface CountCellStockCountProcessProductAmountInputDTO
 */
export interface CountCellStockCountProcessProductAmountInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CountCellStockCountProcessProductAmountInputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {number}
     * @memberof CountCellStockCountProcessProductAmountInputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof CountCellStockCountProcessProductAmountInputDTO
     */
    expirationDate?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CountCellStockCountProcessProductAmountInputDTO
     */
    serialNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface CountCellStockCountingCommand
 */
export interface CountCellStockCountingCommand {
    /**
     * 
     * @type {string}
     * @memberof CountCellStockCountingCommand
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {string}
     * @memberof CountCellStockCountingCommand
     */
    stockCountingId?: string;
    /**
     * 
     * @type {string}
     * @memberof CountCellStockCountingCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {Array<CountCellStockCountProcessProductAmountInputDTO>}
     * @memberof CountCellStockCountingCommand
     */
    productAmounts?: Array<CountCellStockCountProcessProductAmountInputDTO>;
}
/**
 * 
 * @export
 * @interface CountCellTotalStockCountingCommand
 */
export interface CountCellTotalStockCountingCommand {
    /**
     * 
     * @type {string}
     * @memberof CountCellTotalStockCountingCommand
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {string}
     * @memberof CountCellTotalStockCountingCommand
     */
    stockCountingId?: string;
    /**
     * 
     * @type {string}
     * @memberof CountCellTotalStockCountingCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CountCellTotalStockCountingCommand
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface CountDamagedItemsCommand
 */
export interface CountDamagedItemsCommand {
    /**
     * 
     * @type {number}
     * @memberof CountDamagedItemsCommand
     */
    referenceNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof CountDamagedItemsCommand
     */
    cellId?: number;
    /**
     * 
     * @type {WallToWallStockCountingProductInputDTO}
     * @memberof CountDamagedItemsCommand
     */
    damagedItemCount?: WallToWallStockCountingProductInputDTO;
}
/**
 * 
 * @export
 * @interface CountManualCellStockCountingCommand
 */
export interface CountManualCellStockCountingCommand {
    /**
     * 
     * @type {string}
     * @memberof CountManualCellStockCountingCommand
     */
    stockCountingId?: string;
    /**
     * 
     * @type {string}
     * @memberof CountManualCellStockCountingCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CountManualCellStockCountingCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {Array<CountManualCellStockCountingProductAmountInputDTO>}
     * @memberof CountManualCellStockCountingCommand
     */
    productAmounts?: Array<CountManualCellStockCountingProductAmountInputDTO>;
}
/**
 * 
 * @export
 * @interface CountManualCellStockCountingProductAmountInputDTO
 */
export interface CountManualCellStockCountingProductAmountInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CountManualCellStockCountingProductAmountInputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {number}
     * @memberof CountManualCellStockCountingProductAmountInputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof CountManualCellStockCountingProductAmountInputDTO
     */
    expirationDate?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CountManualCellStockCountingProductAmountInputDTO
     */
    serialNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface CountProductStockCountingCommand
 */
export interface CountProductStockCountingCommand {
    /**
     * 
     * @type {string}
     * @memberof CountProductStockCountingCommand
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {string}
     * @memberof CountProductStockCountingCommand
     */
    stockCountingId?: string;
    /**
     * 
     * @type {string}
     * @memberof CountProductStockCountingCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CountProductStockCountingCommand
     */
    productId?: string;
    /**
     * 
     * @type {number}
     * @memberof CountProductStockCountingCommand
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof CountProductStockCountingCommand
     */
    expirationDate?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CountProductStockCountingCommand
     */
    serialNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface CountQueryOption
 */
export interface CountQueryOption {
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof CountQueryOption
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {string}
     * @memberof CountQueryOption
     */
    rawValue?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CountQueryOption
     */
    value?: boolean;
    /**
     * 
     * @type {object}
     * @memberof CountQueryOption
     */
    validator?: object;
}
/**
 * 
 * @export
 * @interface CountWallToWallStockCountingProductsCommand
 */
export interface CountWallToWallStockCountingProductsCommand {
    /**
     * 
     * @type {number}
     * @memberof CountWallToWallStockCountingProductsCommand
     */
    referenceNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof CountWallToWallStockCountingProductsCommand
     */
    cellId?: number;
    /**
     * 
     * @type {Array<WallToWallStockCountingProductInputDTO>}
     * @memberof CountWallToWallStockCountingProductsCommand
     */
    productStockCounts?: Array<WallToWallStockCountingProductInputDTO>;
}
/**
 * 
 * @export
 * @interface CreateApprovedSLAMAddressOutputDTO
 */
export interface CreateApprovedSLAMAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateApprovedSLAMAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateApprovedSLAMAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateApprovedSLAMAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateApprovedSLAMAddressesCommand
 */
export interface CreateApprovedSLAMAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateApprovedSLAMAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateApprovedSLAMAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateApprovedSLAMAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateApprovedSLAMAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateBacklogRequest
 */
export interface CreateBacklogRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateBacklogRequest
     */
    warehouseId?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateBacklogRequest
     */
    orderDate?: string;
    /**
     * 
     * @type {Array<TrendyolBacklogItemInputDTO>}
     * @memberof CreateBacklogRequest
     */
    data?: Array<TrendyolBacklogItemInputDTO>;
}
/**
 * 
 * @export
 * @interface CreateBatchTrolleyOutputDTO
 */
export interface CreateBatchTrolleyOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateBatchTrolleyOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateBatchTrolleyOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBatchTrolleyOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateBatchTrolleysCommand
 */
export interface CreateBatchTrolleysCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateBatchTrolleysCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateBatchTrolleysCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateBatchTrolleysCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateBatchTrolleysCommand
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateBatchTrolleysCommand
     */
    variation?: string;
}
/**
 * 
 * @export
 * @interface CreateCargoCarrierPreferenceProblemCommand
 */
export interface CreateCargoCarrierPreferenceProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateCargoCarrierPreferenceProblemCommand
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCargoCarrierPreferenceProblemCommand
     */
    problemSolverAddress?: string;
}
/**
 * 
 * @export
 * @interface CreateCargoPackageTypeCommand
 */
export interface CreateCargoPackageTypeCommand {
    /**
     * 
     * @type {PackageType}
     * @memberof CreateCargoPackageTypeCommand
     */
    type?: PackageType;
    /**
     * 
     * @type {number}
     * @memberof CreateCargoPackageTypeCommand
     */
    volumetricWeight?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCargoPackageTypeCommand
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCargoPackageTypeCommand
     */
    name?: string;
    /**
     * 
     * @type {CargoPackageTypeDimensionInputDTO}
     * @memberof CreateCargoPackageTypeCommand
     */
    width?: CargoPackageTypeDimensionInputDTO;
    /**
     * 
     * @type {CargoPackageTypeDimensionInputDTO}
     * @memberof CreateCargoPackageTypeCommand
     */
    height?: CargoPackageTypeDimensionInputDTO;
    /**
     * 
     * @type {CargoPackageTypeDimensionInputDTO}
     * @memberof CreateCargoPackageTypeCommand
     */
    length?: CargoPackageTypeDimensionInputDTO;
    /**
     * 
     * @type {string}
     * @memberof CreateCargoPackageTypeCommand
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface CreateCargoPackageTypeOutputDTO
 */
export interface CreateCargoPackageTypeOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateCargoPackageTypeOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {PackageType}
     * @memberof CreateCargoPackageTypeOutputDTO
     */
    type?: PackageType;
    /**
     * 
     * @type {number}
     * @memberof CreateCargoPackageTypeOutputDTO
     */
    volumetricWeight?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCargoPackageTypeOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCargoPackageTypeOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateCarrierCommand
 */
export interface CreateCarrierCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierCommand
     */
    cargoCarrierId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierCommand
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierCommand
     */
    enabledLogoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierCommand
     */
    disabledLogoUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCarrierCommand
     */
    doesSupportSameDayShipment?: boolean;
}
/**
 * 
 * @export
 * @interface CreateCellCommand
 */
export interface CreateCellCommand {
    /**
     * 
     * @type {Array<CreateCellInputDTO>}
     * @memberof CreateCellCommand
     */
    cells?: Array<CreateCellInputDTO>;
}
/**
 * 
 * @export
 * @interface CreateCellInputDTO
 */
export interface CreateCellInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateCellInputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCellInputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCellInputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {CellType}
     * @memberof CreateCellInputDTO
     */
    cellType?: CellType;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCellInputDTO
     */
    setRasLabel?: boolean;
}
/**
 * 
 * @export
 * @interface CreateCellOutputDTO
 */
export interface CreateCellOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateCellOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCellOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCellOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateCustomActionVASTypeCommand
 */
export interface CreateCustomActionVASTypeCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomActionVASTypeCommand
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomActionVASTypeCommand
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface CreateCustomerCommand
 */
export interface CreateCustomerCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerCommand
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerCommand
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerCommand
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerCommand
     */
    phone?: string;
}
/**
 * 
 * @export
 * @interface CreateDispatchAddressOutputDTO
 */
export interface CreateDispatchAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateDispatchAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDispatchAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDispatchAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateDispatchAddressesCommand
 */
export interface CreateDispatchAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateDispatchAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateDispatchAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateDispatchAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateDispatchAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateDispatchProcessIfNotExistCommand
 */
export interface CreateDispatchProcessIfNotExistCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateDispatchProcessIfNotExistCommand
     */
    salesOrderId?: string;
}
/**
 * 
 * @export
 * @interface CreateDispatchProcessIfNotExistOutputDTO
 */
export interface CreateDispatchProcessIfNotExistOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateDispatchProcessIfNotExistOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateDispatchProcessIfNotExistOutputDTO
     */
    referenceNumber?: number;
}
/**
 * 
 * @export
 * @interface CreateDropAddressOutputDTO
 */
export interface CreateDropAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateDropAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDropAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDropAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateDropAddressesCommand
 */
export interface CreateDropAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateDropAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateDropAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateDropAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateDropAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateHOVPackingAddressOutputDTO
 */
export interface CreateHOVPackingAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateHOVPackingAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateHOVPackingAddressesCommand
 */
export interface CreateHOVPackingAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateHOVPackingAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateHOVPackingAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateHOVPackingAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateHOVPackingProcessIfNotExistsCommand
 */
export interface CreateHOVPackingProcessIfNotExistsCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingProcessIfNotExistsCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingProcessIfNotExistsCommand
     */
    hovPackingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CreateHOVPackingProcessOutputDTO
 */
export interface CreateHOVPackingProcessOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    canCloseCargoPackagesAtPacking?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    packingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    pickingTrolleyLabel?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {ShippingFlowTag}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    shippingFlow?: ShippingFlowTag;
    /**
     * 
     * @type {boolean}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    isEligibleForSLAMPrint?: boolean;
    /**
     * 
     * @type {Array<HOVSalesOrderLineItemOutputDTO>}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    salesOrderLineItems?: Array<HOVSalesOrderLineItemOutputDTO>;
    /**
     * 
     * @type {Array<HOVPickingItemByProductOutputDTO>}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    pickingItems?: Array<HOVPickingItemByProductOutputDTO>;
    /**
     * 
     * @type {Array<HOVVASOutputDTO>}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    vas?: Array<HOVVASOutputDTO>;
    /**
     * 
     * @type {Array<QueuedHOVCargoPackageOutputDTO>}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    cargoPackages?: Array<QueuedHOVCargoPackageOutputDTO>;
    /**
     * 
     * @type {Array<HOVProcessedVASItemsOutputDTO>}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    processedVASItems?: Array<HOVProcessedVASItemsOutputDTO>;
    /**
     * 
     * @type {Array<HOVCargoPackageTypeOutputDTO>}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    operationCargoPackageTypes?: Array<HOVCargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {Array<HOVCargoPackageTypeOutputDTO>}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    oplogCargoPackageTypes?: Array<HOVCargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {Array<HOVOwnContainerCargoPackageTypeOutputDTO>}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    ownContainerCargoPackageTypes?: Array<HOVOwnContainerCargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    failedMessage?: string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    marketPlaceName?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    packedItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    salesOrderTotalItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    hovMultiplePackingItemCountThreshold?: number;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {InternalErrorNumber}
     * @memberof CreateHOVPackingProcessOutputDTO
     */
    errorNumber?: InternalErrorNumber;
}
/**
 * 
 * @export
 * @interface CreateHOVPackingQuarantineProcessIfNotExistsCommand
 */
export interface CreateHOVPackingQuarantineProcessIfNotExistsCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingQuarantineProcessIfNotExistsCommand
     */
    coOperatorId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingQuarantineProcessIfNotExistsCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingQuarantineProcessIfNotExistsCommand
     */
    hovPackingAddressLabel?: string;
    /**
     * 
     * @type {PackingQuarantineReason}
     * @memberof CreateHOVPackingQuarantineProcessIfNotExistsCommand
     */
    state?: PackingQuarantineReason;
}
/**
 * 
 * @export
 * @interface CreateHOVPackingQuarantineProcessOutputDTO
 */
export interface CreateHOVPackingQuarantineProcessOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    packingQuarantineProcessId?: string;
    /**
     * 
     * @type {PackingQuarantineReason}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    state?: PackingQuarantineReason;
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    pickingTrolleyLabel?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {ShippingFlowTag}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    shippingFlow?: ShippingFlowTag;
    /**
     * 
     * @type {Array<HOVSalesOrderLineItemOutputDTO>}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    salesOrderLineItems?: Array<HOVSalesOrderLineItemOutputDTO>;
    /**
     * 
     * @type {Array<HOVPickingItemByProductOutputDTO>}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    pickingItems?: Array<HOVPickingItemByProductOutputDTO>;
    /**
     * 
     * @type {Array<PackingHOVMissingItemOutputDTO>}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    missingItems?: Array<PackingHOVMissingItemOutputDTO>;
    /**
     * 
     * @type {Array<HOVVASOutputDTO>}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    vas?: Array<HOVVASOutputDTO>;
    /**
     * 
     * @type {HOVQueuedQuarantineToteOutputDTO}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    quarantineTote?: HOVQueuedQuarantineToteOutputDTO;
    /**
     * 
     * @type {SalesChannel}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    marketPlaceName?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    queuedQuarantineItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    salesOrderTotalItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    hovMultiplePackingItemCountThreshold?: number;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof CreateHOVPackingQuarantineProcessOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
}
/**
 * 
 * @export
 * @interface CreateHOVRebinAddressesCommand
 */
export interface CreateHOVRebinAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateHOVRebinAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateHOVRebinAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateHOVRebinAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateHOVRebinAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateHoldingZoneAddressCommand
 */
export interface CreateHoldingZoneAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateHoldingZoneAddressCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateHoldingZoneAddressCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateHoldingZoneAddressCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateHoldingZoneAddressCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateHoldingZoneAddressOutputDTO
 */
export interface CreateHoldingZoneAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateHoldingZoneAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateHoldingZoneAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateHoldingZoneAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateInboundAddressOutputDTO
 */
export interface CreateInboundAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateInboundAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateInboundAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInboundAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateInboundAddressesCommand
 */
export interface CreateInboundAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateInboundAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateInboundAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateInboundAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateInboundAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateListForIncorrectCountedCellsCommand
 */
export interface CreateListForIncorrectCountedCellsCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateListForIncorrectCountedCellsCommand
     */
    stockCountingPlanId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateListForIncorrectCountedCellsCommand
     */
    stockCountingListIds?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateListForIncorrectCountedCellsCommand
     */
    cellIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface CreateLostItemAddressOutputDTO
 */
export interface CreateLostItemAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateLostItemAddressOutputDTO
     */
    addressId?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLostItemAddressOutputDTO
     */
    containerId?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLostItemAddressOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLostItemAddressOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLostItemAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateLostItemAddressesCommand
 */
export interface CreateLostItemAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateLostItemAddressesCommand
     */
    addressName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLostItemAddressesCommand
     */
    containerName?: string;
}
/**
 * 
 * @export
 * @interface CreateManualCellStockCountingProcessCommand
 */
export interface CreateManualCellStockCountingProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateManualCellStockCountingProcessCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateManualCellStockCountingProcessCommand
     */
    cellLabel?: string;
}
/**
 * 
 * @export
 * @interface CreateManualCellStockCountingProcessCommandOutputDTO
 */
export interface CreateManualCellStockCountingProcessCommandOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateManualCellStockCountingProcessCommandOutputDTO
     */
    stockCountingId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateManualCellStockCountingProcessCommandOutputDTO
     */
    isInputCountEntryActiveInManualCellStockCounting?: boolean;
}
/**
 * 
 * @export
 * @interface CreateManualDeliveryAddressOutputDTO
 */
export interface CreateManualDeliveryAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateManualDeliveryAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateManualDeliveryAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateManualDeliveryAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateManualDeliveryAddressesCommand
 */
export interface CreateManualDeliveryAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateManualDeliveryAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateManualDeliveryAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateManualDeliveryAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateManualDeliveryAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateManualPicklistRequestCommand
 */
export interface CreateManualPicklistRequestCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateManualPicklistRequestCommand
     */
    salesOrderIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateManualPicklistRequestCommand
     */
    picklistRequestName?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateManualPicklistRequestCommand
     */
    maxSalesOrdersPerBatch?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateManualPicklistRequestCommand
     */
    isFastPackEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateManualPicklistRequestCommand
     */
    subZoneId?: number;
    /**
     * 
     * @type {SubZoneSelectionSource}
     * @memberof CreateManualPicklistRequestCommand
     */
    subZoneSelectionSource?: SubZoneSelectionSource;
}
/**
 * 
 * @export
 * @interface CreateManualReplenishmentJobsInputDTO
 */
export interface CreateManualReplenishmentJobsInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateManualReplenishmentJobsInputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateManualReplenishmentJobsInputDTO
     */
    isPriority?: boolean;
    /**
     * 
     * @type {Array<ManualReplenishmentLineInputDTO>}
     * @memberof CreateManualReplenishmentJobsInputDTO
     */
    lines?: Array<ManualReplenishmentLineInputDTO>;
}
/**
 * 
 * @export
 * @interface CreateManualReplenishmentJobsOutputDTO
 */
export interface CreateManualReplenishmentJobsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateManualReplenishmentJobsOutputDTO
     */
    importBatchId?: string;
    /**
     * 
     * @type {Array<ReplenishmentJobOutputDTO>}
     * @memberof CreateManualReplenishmentJobsOutputDTO
     */
    jobs?: Array<ReplenishmentJobOutputDTO>;
    /**
     * 
     * @type {Array<ManualReplenishmentRowOutputDTO>}
     * @memberof CreateManualReplenishmentJobsOutputDTO
     */
    skippedRows?: Array<ManualReplenishmentRowOutputDTO>;
}
/**
 * 
 * @export
 * @interface CreateMasterCartonCommand
 */
export interface CreateMasterCartonCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateMasterCartonCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterCartonCommand
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterCartonCommand
     */
    sku?: string;
    /**
     * 
     * @type {ProductType}
     * @memberof CreateMasterCartonCommand
     */
    productType?: ProductType;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterCartonCommand
     */
    imageUrl?: string;
    /**
     * 
     * @type {Array<ProductBarcodeInputDTO>}
     * @memberof CreateMasterCartonCommand
     */
    barcodeDefinitions?: Array<ProductBarcodeInputDTO>;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterCartonCommand
     */
    innerProductSKU?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterCartonCommand
     */
    innerProductAmount?: number;
    /**
     * 
     * @type {TaxIncludedSalePriceInputDTO}
     * @memberof CreateMasterCartonCommand
     */
    taxIncludedSalePrice?: TaxIncludedSalePriceInputDTO;
}
/**
 * 
 * @export
 * @interface CreateMissingCargoPackageLabelProblemCommand
 */
export interface CreateMissingCargoPackageLabelProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateMissingCargoPackageLabelProblemCommand
     */
    salesOrderId?: string;
}
/**
 * 
 * @export
 * @interface CreateMissingItemTransferProcessIfNotExistsCommand
 */
export interface CreateMissingItemTransferProcessIfNotExistsCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateMissingItemTransferProcessIfNotExistsCommand
     */
    pickingToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMissingItemTransferProcessIfNotExistsCommand
     */
    missingItemTransferAddress?: string;
}
/**
 * 
 * @export
 * @interface CreateMissingItemTransferProcessOutputDTO
 */
export interface CreateMissingItemTransferProcessOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateMissingItemTransferProcessOutputDTO
     */
    missingItemTransferProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMissingItemTransferProcessOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMissingItemTransferProcessOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMissingItemTransferProcessOutputDTO
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMissingItemTransferProcessOutputDTO
     */
    pickingToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMissingItemTransferProcessOutputDTO
     */
    pickingTrolleyLabel?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof CreateMissingItemTransferProcessOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof CreateMissingItemTransferProcessOutputDTO
     */
    salesOrderLineItemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMissingItemTransferProcessOutputDTO
     */
    quarantineToteItemsCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMissingItemTransferProcessOutputDTO
     */
    isCancelledSalesOrderToteOnTheQuarantineAddress?: boolean;
    /**
     * 
     * @type {MissingItemTransferSalesOrderPickingState}
     * @memberof CreateMissingItemTransferProcessOutputDTO
     */
    missingItemTransferSalesOrderPickingState?: MissingItemTransferSalesOrderPickingState;
    /**
     * 
     * @type {Array<PickedMissingItemsOutputDTO>}
     * @memberof CreateMissingItemTransferProcessOutputDTO
     */
    pickedMissingItems?: Array<PickedMissingItemsOutputDTO>;
    /**
     * 
     * @type {Array<UnPickedMissingItemsOutputDTO>}
     * @memberof CreateMissingItemTransferProcessOutputDTO
     */
    unPickedMissingItems?: Array<UnPickedMissingItemsOutputDTO>;
    /**
     * 
     * @type {Array<PickedItemsInQuarantineToteOutputDTO>}
     * @memberof CreateMissingItemTransferProcessOutputDTO
     */
    pickedItemsInQuarantineTote?: Array<PickedItemsInQuarantineToteOutputDTO>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof CreateMissingItemTransferProcessOutputDTO
     */
    pickingToteContainedItemSerialNumbers?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof CreateMissingItemTransferProcessOutputDTO
     */
    quarantineToteContainedItemSerialNumbers?: { [key: string]: Array<string>; };
}
/**
 * 
 * @export
 * @interface CreateMissingSLAMLabelProblemCommand
 */
export interface CreateMissingSLAMLabelProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateMissingSLAMLabelProblemCommand
     */
    salesOrderId?: string;
}
/**
 * 
 * @export
 * @interface CreateOpenAPIIntegrationCommand
 */
export interface CreateOpenAPIIntegrationCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateOpenAPIIntegrationCommand
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface CreateOpenAPIIntegrationOutputDTO
 */
export interface CreateOpenAPIIntegrationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateOpenAPIIntegrationOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOpenAPIIntegrationOutputDTO
     */
    clientId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOpenAPIIntegrationOutputDTO
     */
    clientSecret?: string;
}
/**
 * 
 * @export
 * @interface CreateOperationCommand
 */
export interface CreateOperationCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    prefix?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    b2BRoadRunnerInvoiceCustomerId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    b2CRoadRunnerInvoiceCustomerId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    cutoffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    targetDispatchTime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    sameDeliveryFirstCutOffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    sameDeliverySecondCutOffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    sameDeliveryFirstTargetDispatchTime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    sameDeliverySecondTargetDispatchTime?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOperationCommand
     */
    hourForCalculateManualDeliveryCutOff?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    marketplaceCutOffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    marketplaceTargetDispatchTime?: string;
    /**
     * 
     * @type {PrintPageSizeType}
     * @memberof CreateOperationCommand
     */
    vasPageSizeType?: PrintPageSizeType;
    /**
     * 
     * @type {PrintPageSizeType}
     * @memberof CreateOperationCommand
     */
    giftVASPageSizeType?: PrintPageSizeType;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOperationCommand
     */
    isPrintingItems?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    shipmentReturnCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOperationCommand
     */
    isSameDayDeliveryActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOperationCommand
     */
    isUIBulkCancelBlockedAllowed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    companyTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    companyAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    companyPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    companyTaxNo?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    companyTaxAdministration?: string;
    /**
     * 
     * @type {Array<CarrierPreferenceInputDTO>}
     * @memberof CreateOperationCommand
     */
    carrierPreferences?: Array<CarrierPreferenceInputDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOperationCommand
     */
    useOrderSoldAtForCutOff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOperationCommand
     */
    useBothDatesForCutOff?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    orderSoldAtCutoffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationCommand
     */
    cluster?: string;
}
/**
 * 
 * @export
 * @interface CreateOperationOutputDTO
 */
export interface CreateOperationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateOperationOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOperationOutputDTO
     */
    cluster?: string;
}
/**
 * 
 * @export
 * @interface CreatePackingAddressOutputDTO
 */
export interface CreatePackingAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreatePackingAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePackingAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePackingAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreatePackingAddressesCommand
 */
export interface CreatePackingAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreatePackingAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePackingAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePackingAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePackingAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreatePackingCompletedSalesOrdersLoadSeedPayload
 */
export interface CreatePackingCompletedSalesOrdersLoadSeedPayload {
    /**
     * 
     * @type {Array<SalesOrderPackingLoadSeedPayload>}
     * @memberof CreatePackingCompletedSalesOrdersLoadSeedPayload
     */
    salesOrderConfigurations?: Array<SalesOrderPackingLoadSeedPayload>;
    /**
     * 
     * @type {TenantsEnum}
     * @memberof CreatePackingCompletedSalesOrdersLoadSeedPayload
     */
    tenant?: TenantsEnum;
    /**
     * 
     * @type {OperationsEnum}
     * @memberof CreatePackingCompletedSalesOrdersLoadSeedPayload
     */
    operation?: OperationsEnum;
}
/**
 * 
 * @export
 * @interface CreatePackingProcessIfNotExistsCommand
 */
export interface CreatePackingProcessIfNotExistsCommand {
    /**
     * 
     * @type {string}
     * @memberof CreatePackingProcessIfNotExistsCommand
     */
    coOperatorId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePackingProcessIfNotExistsCommand
     */
    pickingToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePackingProcessIfNotExistsCommand
     */
    packingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CreatePackingProcessOutputDTO
 */
export interface CreatePackingProcessOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreatePackingProcessOutputDTO
     */
    packingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePackingProcessOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {PackingQuarantineReason}
     * @memberof CreatePackingProcessOutputDTO
     */
    state?: PackingQuarantineReason;
    /**
     * 
     * @type {string}
     * @memberof CreatePackingProcessOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePackingProcessOutputDTO
     */
    pickingTrolleyLabel?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof CreatePackingProcessOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {ShippingFlowTag}
     * @memberof CreatePackingProcessOutputDTO
     */
    shippingFlow?: ShippingFlowTag;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePackingProcessOutputDTO
     */
    isEligibleForSLAMPrint?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CreatePackingProcessOutputDTO
     */
    canCloseCargoPackagesAtPacking?: boolean;
    /**
     * 
     * @type {Array<SalesOrderLineItemOutputDTO>}
     * @memberof CreatePackingProcessOutputDTO
     */
    salesOrderLineItems?: Array<SalesOrderLineItemOutputDTO>;
    /**
     * 
     * @type {Array<PickingItemByProductOutputDTO>}
     * @memberof CreatePackingProcessOutputDTO
     */
    pickingItems?: Array<PickingItemByProductOutputDTO>;
    /**
     * 
     * @type {Array<VASOutputDTO>}
     * @memberof CreatePackingProcessOutputDTO
     */
    vas?: Array<VASOutputDTO>;
    /**
     * 
     * @type {Array<QueuedCargoPackageOutputDTO>}
     * @memberof CreatePackingProcessOutputDTO
     */
    cargoPackages?: Array<QueuedCargoPackageOutputDTO>;
    /**
     * 
     * @type {Array<ProcessedVASItemsOutputDTO>}
     * @memberof CreatePackingProcessOutputDTO
     */
    processedVASItems?: Array<ProcessedVASItemsOutputDTO>;
    /**
     * 
     * @type {Array<CargoPackageTypeOutputDTO>}
     * @memberof CreatePackingProcessOutputDTO
     */
    operationCargoPackageTypes?: Array<CargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {Array<CargoPackageTypeOutputDTO>}
     * @memberof CreatePackingProcessOutputDTO
     */
    oplogCargoPackageTypes?: Array<CargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {Array<OwnContainerCargoPackageTypeOutputDTO>}
     * @memberof CreatePackingProcessOutputDTO
     */
    ownContainerCargoPackageTypes?: Array<OwnContainerCargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {string}
     * @memberof CreatePackingProcessOutputDTO
     */
    defaultCargoPackageTypeBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePackingProcessOutputDTO
     */
    failedMessage?: string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof CreatePackingProcessOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof CreatePackingProcessOutputDTO
     */
    marketPlaceName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePackingProcessOutputDTO
     */
    isPrintable?: boolean;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof CreatePackingProcessOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {InternalErrorNumber}
     * @memberof CreatePackingProcessOutputDTO
     */
    errorNumber?: InternalErrorNumber;
}
/**
 * 
 * @export
 * @interface CreatePackingQuarantineProcessIfNotExistsCommand
 */
export interface CreatePackingQuarantineProcessIfNotExistsCommand {
    /**
     * 
     * @type {string}
     * @memberof CreatePackingQuarantineProcessIfNotExistsCommand
     */
    coOperatorId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePackingQuarantineProcessIfNotExistsCommand
     */
    pickingToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePackingQuarantineProcessIfNotExistsCommand
     */
    packingAddressLabel?: string;
    /**
     * 
     * @type {PackingQuarantineReason}
     * @memberof CreatePackingQuarantineProcessIfNotExistsCommand
     */
    state?: PackingQuarantineReason;
}
/**
 * 
 * @export
 * @interface CreatePackingQuarantineProcessOutputDTO
 */
export interface CreatePackingQuarantineProcessOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreatePackingQuarantineProcessOutputDTO
     */
    packingQuarantineProcessId?: string;
    /**
     * 
     * @type {PackingQuarantineReason}
     * @memberof CreatePackingQuarantineProcessOutputDTO
     */
    state?: PackingQuarantineReason;
    /**
     * 
     * @type {string}
     * @memberof CreatePackingQuarantineProcessOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePackingQuarantineProcessOutputDTO
     */
    pickingTrolleyLabel?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof CreatePackingQuarantineProcessOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {ShippingFlowTag}
     * @memberof CreatePackingQuarantineProcessOutputDTO
     */
    shippingFlow?: ShippingFlowTag;
    /**
     * 
     * @type {Array<SalesOrderLineItemOutputDTO>}
     * @memberof CreatePackingQuarantineProcessOutputDTO
     */
    salesOrderLineItems?: Array<SalesOrderLineItemOutputDTO>;
    /**
     * 
     * @type {Array<PickingItemByProductOutputDTO>}
     * @memberof CreatePackingQuarantineProcessOutputDTO
     */
    pickingItems?: Array<PickingItemByProductOutputDTO>;
    /**
     * 
     * @type {Array<PackingMissingItemOutputDTO>}
     * @memberof CreatePackingQuarantineProcessOutputDTO
     */
    missingItems?: Array<PackingMissingItemOutputDTO>;
    /**
     * 
     * @type {Array<VASOutputDTO>}
     * @memberof CreatePackingQuarantineProcessOutputDTO
     */
    vas?: Array<VASOutputDTO>;
    /**
     * 
     * @type {QueuedQuarantineToteOutputDTO}
     * @memberof CreatePackingQuarantineProcessOutputDTO
     */
    quarantineTote?: QueuedQuarantineToteOutputDTO;
    /**
     * 
     * @type {SalesChannel}
     * @memberof CreatePackingQuarantineProcessOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof CreatePackingQuarantineProcessOutputDTO
     */
    marketPlaceName?: string;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof CreatePackingQuarantineProcessOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
}
/**
 * 
 * @export
 * @interface CreateParkAddressOutputDTO
 */
export interface CreateParkAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateParkAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateParkAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateParkAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateParkAddressesCommand
 */
export interface CreateParkAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateParkAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateParkAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateParkAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateParkAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreatePickingCompletedSalesOrdersLoadSeedPayload
 */
export interface CreatePickingCompletedSalesOrdersLoadSeedPayload {
    /**
     * 
     * @type {Array<SalesOrderPickingLoadSeedPayload>}
     * @memberof CreatePickingCompletedSalesOrdersLoadSeedPayload
     */
    salesOrderConfigurations?: Array<SalesOrderPickingLoadSeedPayload>;
    /**
     * 
     * @type {TenantsEnum}
     * @memberof CreatePickingCompletedSalesOrdersLoadSeedPayload
     */
    tenant?: TenantsEnum;
    /**
     * 
     * @type {OperationsEnum}
     * @memberof CreatePickingCompletedSalesOrdersLoadSeedPayload
     */
    operation?: OperationsEnum;
}
/**
 * 
 * @export
 * @interface CreatePickingProcessCommand
 */
export interface CreatePickingProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CreatePickingProcessCommand
     */
    zoneLabel?: string;
}
/**
 * 
 * @export
 * @interface CreatePickingProcessCommandWithQrCode
 */
export interface CreatePickingProcessCommandWithQrCode {
    /**
     * 
     * @type {string}
     * @memberof CreatePickingProcessCommandWithQrCode
     */
    zoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePickingProcessCommandWithQrCode
     */
    qrCode?: string;
}
/**
 * 
 * @export
 * @interface CreatePickingProcessOutputDTO
 */
export interface CreatePickingProcessOutputDTO {
    /**
     * 
     * @type {PickingProcessType}
     * @memberof CreatePickingProcessOutputDTO
     */
    pickingFlow?: PickingProcessType;
    /**
     * 
     * @type {string}
     * @memberof CreatePickingProcessOutputDTO
     */
    variation?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePickingProcessOutputDTO
     */
    pickingProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePickingProcessOutputDTO
     */
    pickListName?: string;
}
/**
 * 
 * @export
 * @interface CreatePickingStartedSalesOrderLoadSeedPayload
 */
export interface CreatePickingStartedSalesOrderLoadSeedPayload {
    /**
     * 
     * @type {Array<SalesOrderPickingLoadSeedPayload>}
     * @memberof CreatePickingStartedSalesOrderLoadSeedPayload
     */
    salesOrderConfigurations?: Array<SalesOrderPickingLoadSeedPayload>;
    /**
     * 
     * @type {TenantsEnum}
     * @memberof CreatePickingStartedSalesOrderLoadSeedPayload
     */
    tenant?: TenantsEnum;
    /**
     * 
     * @type {OperationsEnum}
     * @memberof CreatePickingStartedSalesOrderLoadSeedPayload
     */
    operation?: OperationsEnum;
}
/**
 * 
 * @export
 * @interface CreatePickingTrolleyOutputDTO
 */
export interface CreatePickingTrolleyOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreatePickingTrolleyOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePickingTrolleyOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePickingTrolleyOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreatePickingTrolleysCommand
 */
export interface CreatePickingTrolleysCommand {
    /**
     * 
     * @type {string}
     * @memberof CreatePickingTrolleysCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePickingTrolleysCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePickingTrolleysCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePickingTrolleysCommand
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePickingTrolleysCommand
     */
    variation?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePickingTrolleysCommand
     */
    toteCount?: number;
}
/**
 * 
 * @export
 * @interface CreateProblemSolverAddressesCommand
 */
export interface CreateProblemSolverAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateProblemSolverAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateProblemSolverAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProblemSolverAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProblemSolverAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateProblemSolverAddressesOutputDTO
 */
export interface CreateProblemSolverAddressesOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateProblemSolverAddressesOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateProblemSolverAddressesOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProblemSolverAddressesOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateProductCommand
 */
export interface CreateProductCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateProductCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductCommand
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductCommand
     */
    sku?: string;
    /**
     * 
     * @type {ProductType}
     * @memberof CreateProductCommand
     */
    productType?: ProductType;
    /**
     * 
     * @type {string}
     * @memberof CreateProductCommand
     */
    imageUrl?: string;
    /**
     * 
     * @type {Array<ProductBarcodeInputDTO>}
     * @memberof CreateProductCommand
     */
    barcodeDefinitions?: Array<ProductBarcodeInputDTO>;
    /**
     * 
     * @type {Array<ProductListingInputDTO>}
     * @memberof CreateProductCommand
     */
    productListings?: Array<ProductListingInputDTO>;
    /**
     * 
     * @type {ProductDimensionsInputDTO}
     * @memberof CreateProductCommand
     */
    dimensions?: ProductDimensionsInputDTO;
    /**
     * 
     * @type {TaxIncludedSalePriceInputDTO}
     * @memberof CreateProductCommand
     */
    taxIncludedSalePrice?: TaxIncludedSalePriceInputDTO;
    /**
     * 
     * @type {Array<ProductTagType>}
     * @memberof CreateProductCommand
     */
    operationalTags?: Array<ProductTagType>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductCommand
     */
    isTrackExpirationDate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductCommand
     */
    isTrackSerialNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductCommand
     */
    isTrackLotNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductCommand
     */
    isTrackSimpleSerialNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductCommand
     */
    isSioc?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateProductCommand
     */
    expirationDateThresholdDayValue?: number;
}
/**
 * 
 * @export
 * @interface CreatePurchaseOrderCommand
 */
export interface CreatePurchaseOrderCommand {
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseOrderCommand
     */
    operationId?: string;
}
/**
 * 
 * @export
 * @interface CreatePurchaseOrderLineItemCommand
 */
export interface CreatePurchaseOrderLineItemCommand {
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseOrderLineItemCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseOrderLineItemCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {Array<MaestroPurchaseOrderLineItemInputDTO>}
     * @memberof CreatePurchaseOrderLineItemCommand
     */
    lineItems?: Array<MaestroPurchaseOrderLineItemInputDTO>;
}
/**
 * 
 * @export
 * @interface CreatePutAwayIfNotExistCommand
 */
export interface CreatePutAwayIfNotExistCommand {
    /**
     * 
     * @type {string}
     * @memberof CreatePutAwayIfNotExistCommand
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePutAwayIfNotExistCommand
     */
    isOperatorReassigned?: boolean;
}
/**
 * 
 * @export
 * @interface CreatePutAwayTrolleyOutputDTO
 */
export interface CreatePutAwayTrolleyOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreatePutAwayTrolleyOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePutAwayTrolleyOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePutAwayTrolleyOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreatePutAwayTrolleysCommand
 */
export interface CreatePutAwayTrolleysCommand {
    /**
     * 
     * @type {string}
     * @memberof CreatePutAwayTrolleysCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePutAwayTrolleysCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePutAwayTrolleysCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePutAwayTrolleysCommand
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePutAwayTrolleysCommand
     */
    variation?: string;
}
/**
 * 
 * @export
 * @interface CreateQuickPutAwayIfNotExistCommand
 */
export interface CreateQuickPutAwayIfNotExistCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateQuickPutAwayIfNotExistCommand
     */
    inboundBoxLabel?: string;
}
/**
 * 
 * @export
 * @interface CreateRasDropAddressOutputDTO
 */
export interface CreateRasDropAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateRasDropAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRasDropAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRasDropAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateRasDropAddressesCommand
 */
export interface CreateRasDropAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateRasDropAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRasDropAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRasDropAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRasDropAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateRasOrderBasedPickStationOutputDTO
 */
export interface CreateRasOrderBasedPickStationOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateRasOrderBasedPickStationOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRasOrderBasedPickStationOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRasOrderBasedPickStationOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateRasOrderBasedPickStationsCommand
 */
export interface CreateRasOrderBasedPickStationsCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateRasOrderBasedPickStationsCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRasOrderBasedPickStationsCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRasOrderBasedPickStationsCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRasOrderBasedPickStationsCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateRasPickListsForOrdersCommand
 */
export interface CreateRasPickListsForOrdersCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRasPickListsForOrdersCommand
     */
    referenceNumbers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateRasPickListsForOrdersCommand
     */
    operationId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRasPickListsForOrdersCommand
     */
    batchSize?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRasPickListsForOrdersCommand
     */
    pickListCapacity?: number;
}
/**
 * 
 * @export
 * @interface CreateRasPickListsForOrdersOutputDTO
 */
export interface CreateRasPickListsForOrdersOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateRasPickListsForOrdersOutputDTO
     */
    candidateOrderCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRasPickListsForOrdersOutputDTO
     */
    swapCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRasPickListsForOrdersOutputDTO
     */
    eligibleOrderCount?: number;
    /**
     * 
     * @type {Array<CreatedRasPickListDetail>}
     * @memberof CreateRasPickListsForOrdersOutputDTO
     */
    createdPickLists?: Array<CreatedRasPickListDetail>;
    /**
     * 
     * @type {Array<SkippedRasSalesOrderDetail>}
     * @memberof CreateRasPickListsForOrdersOutputDTO
     */
    skippedSalesOrders?: Array<SkippedRasSalesOrderDetail>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRasPickListsForOrdersOutputDTO
     */
    notFoundReferenceNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateRasPickStationOutputDTO
 */
export interface CreateRasPickStationOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateRasPickStationOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRasPickStationOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRasPickStationOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateRasPickStationsCommand
 */
export interface CreateRasPickStationsCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateRasPickStationsCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRasPickStationsCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRasPickStationsCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRasPickStationsCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateRasProblemSolverStationOutputDTO
 */
export interface CreateRasProblemSolverStationOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateRasProblemSolverStationOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRasProblemSolverStationOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRasProblemSolverStationOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateRasProblemSolverStationsCommand
 */
export interface CreateRasProblemSolverStationsCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateRasProblemSolverStationsCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRasProblemSolverStationsCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRasProblemSolverStationsCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRasProblemSolverStationsCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateRasStowStationOutputDTO
 */
export interface CreateRasStowStationOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateRasStowStationOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRasStowStationOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRasStowStationOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateRasStowStationsCommand
 */
export interface CreateRasStowStationsCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateRasStowStationsCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRasStowStationsCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRasStowStationsCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRasStowStationsCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateRebinAddressesCommand
 */
export interface CreateRebinAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateRebinAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRebinAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRebinAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRebinAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateRebinAddressesOutputDTO
 */
export interface CreateRebinAddressesOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateRebinAddressesOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRebinAddressesOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRebinAddressesOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateRebinSingleAddressesCommand
 */
export interface CreateRebinSingleAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateRebinSingleAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRebinSingleAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRebinSingleAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRebinSingleAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateRebinSingleAddressesOutputDTO
 */
export interface CreateRebinSingleAddressesOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateRebinSingleAddressesOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRebinSingleAddressesOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRebinSingleAddressesOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateRebinTrolleyOutputDTO
 */
export interface CreateRebinTrolleyOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateRebinTrolleyOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRebinTrolleyOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRebinTrolleyOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateRebinTrolleysCommand
 */
export interface CreateRebinTrolleysCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateRebinTrolleysCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRebinTrolleysCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRebinTrolleysCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRebinTrolleysCommand
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRebinTrolleysCommand
     */
    variation?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRebinTrolleysCommand
     */
    toteCount?: number;
}
/**
 * 
 * @export
 * @interface CreateReceivingAddressOutputDTO
 */
export interface CreateReceivingAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateReceivingAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateReceivingAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReceivingAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateReceivingAddressesCommand
 */
export interface CreateReceivingAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateReceivingAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateReceivingAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateReceivingAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateReceivingAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateReceivingProcessIfNotExistsCommand
 */
export interface CreateReceivingProcessIfNotExistsCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateReceivingProcessIfNotExistsCommand
     */
    inboundBoxLabel?: string;
}
/**
 * 
 * @export
 * @interface CreateReceivingProcessOutputDTO
 */
export interface CreateReceivingProcessOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateReceivingProcessOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReceivingProcessOutputDTO
     */
    containerType?: string;
}
/**
 * 
 * @export
 * @interface CreateReplenishmentJobsInputDTO
 */
export interface CreateReplenishmentJobsInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateReplenishmentJobsInputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateReplenishmentJobsInputDTO
     */
    targetSubZoneId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateReplenishmentJobsInputDTO
     */
    isPriority?: boolean;
    /**
     * 
     * @type {Array<ReplenishmentJobLineInputDTO>}
     * @memberof CreateReplenishmentJobsInputDTO
     */
    lines?: Array<ReplenishmentJobLineInputDTO>;
}
/**
 * 
 * @export
 * @interface CreateReplenishmentJobsOutputDTO
 */
export interface CreateReplenishmentJobsOutputDTO {
    /**
     * 
     * @type {Array<ReplenishmentJobOutputDTO>}
     * @memberof CreateReplenishmentJobsOutputDTO
     */
    jobs?: Array<ReplenishmentJobOutputDTO>;
    /**
     * 
     * @type {Array<SkippedReplenishmentLineOutputDTO>}
     * @memberof CreateReplenishmentJobsOutputDTO
     */
    skippedLines?: Array<SkippedReplenishmentLineOutputDTO>;
}
/**
 * 
 * @export
 * @interface CreateReturnAddressOutputDTO
 */
export interface CreateReturnAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateReturnAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateReturnAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReturnAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateReturnAddressesCommand
 */
export interface CreateReturnAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateReturnAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateReturnAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateReturnAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateReturnAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateReturnProcessIfNotExistCommand
 */
export interface CreateReturnProcessIfNotExistCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateReturnProcessIfNotExistCommand
     */
    trackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReturnProcessIfNotExistCommand
     */
    coOperatorId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateReturnProcessIfNotExistCommand
     */
    isOperatorReassigned?: boolean;
}
/**
 * 
 * @export
 * @interface CreateReturnProcessIfNotExistOutputDTO
 */
export interface CreateReturnProcessIfNotExistOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateReturnProcessIfNotExistOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReturnProcessIfNotExistOutputDTO
     */
    returnPackageId?: string;
    /**
     * 
     * @type {ReturnPackageState}
     * @memberof CreateReturnProcessIfNotExistOutputDTO
     */
    state?: ReturnPackageState;
    /**
     * 
     * @type {TrackingInfoComponentOutputDTO}
     * @memberof CreateReturnProcessIfNotExistOutputDTO
     */
    trackingInfo?: TrackingInfoComponentOutputDTO;
    /**
     * 
     * @type {SalesOrdersSearchOutputDTO}
     * @memberof CreateReturnProcessIfNotExistOutputDTO
     */
    salesOrderInfo?: SalesOrdersSearchOutputDTO;
}
/**
 * 
 * @export
 * @interface CreateReturnReceivingProcessIfNotExistCommand
 */
export interface CreateReturnReceivingProcessIfNotExistCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateReturnReceivingProcessIfNotExistCommand
     */
    trolleyLabel?: string;
}
/**
 * 
 * @export
 * @interface CreateReturnTrolleyOutputDTO
 */
export interface CreateReturnTrolleyOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateReturnTrolleyOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateReturnTrolleyOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReturnTrolleyOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateReturnTrolleysCommand
 */
export interface CreateReturnTrolleysCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateReturnTrolleysCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateReturnTrolleysCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateReturnTrolleysCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateReturnTrolleysCommand
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateReturnTrolleysCommand
     */
    variation?: string;
}
/**
 * 
 * @export
 * @interface CreateSLAMAddressOutputDTO
 */
export interface CreateSLAMAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateSLAMAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSLAMAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSLAMAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateSLAMAddressesCommand
 */
export interface CreateSLAMAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateSLAMAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateSLAMAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSLAMAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSLAMAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateSLAMCompletedSalesOrdersLoadSeedPayload
 */
export interface CreateSLAMCompletedSalesOrdersLoadSeedPayload {
    /**
     * 
     * @type {Array<SalesOrderSLAMLoadSeedPayload>}
     * @memberof CreateSLAMCompletedSalesOrdersLoadSeedPayload
     */
    salesOrderConfigurations?: Array<SalesOrderSLAMLoadSeedPayload>;
    /**
     * 
     * @type {TenantsEnum}
     * @memberof CreateSLAMCompletedSalesOrdersLoadSeedPayload
     */
    tenant?: TenantsEnum;
    /**
     * 
     * @type {OperationsEnum}
     * @memberof CreateSLAMCompletedSalesOrdersLoadSeedPayload
     */
    operation?: OperationsEnum;
}
/**
 * 
 * @export
 * @interface CreateSalesOrderNoteCommand
 */
export interface CreateSalesOrderNoteCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderNoteCommand
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderNoteCommand
     */
    salesOrderId?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CreateSalesOrderOpenAPIQueueCodes {
    None = 'None',
    AddedToQueue = 'AddedToQueue',
    AlreadyInQueue = 'AlreadyInQueue',
    AlreadyCreated = 'AlreadyCreated'
}

/**
 * 
 * @export
 * @interface CreateSalesOrderPackingProcessIfNotExistsCommand
 */
export interface CreateSalesOrderPackingProcessIfNotExistsCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderPackingProcessIfNotExistsCommand
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderPackingProcessIfNotExistsCommand
     */
    singleItemPackingAddressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderPackingProcessIfNotExistsCommand
     */
    simpleSerialNumber?: string;
}
/**
 * 
 * @export
 * @interface CreateSalesOrderPackingProcessOutputDTO
 */
export interface CreateSalesOrderPackingProcessOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    packingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    isEligibleForSLAMPrint?: boolean;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {Array<SalesOrderLineItemOutputDTO>}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    salesOrderLineItems?: Array<SalesOrderLineItemOutputDTO>;
    /**
     * 
     * @type {Array<VASOutputDTO>}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    vas?: Array<VASOutputDTO>;
    /**
     * 
     * @type {Array<CargoPackageTypeOutputDTO>}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    operationCargoPackageTypes?: Array<CargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {Array<CargoPackageTypeOutputDTO>}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    oplogCargoPackageTypes?: Array<CargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {Array<OwnContainerCargoPackageTypeOutputDTO>}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    ownContainerCargoPackageTypes?: Array<OwnContainerCargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    defaultCargoPackageTypeBarcode?: string;
    /**
     * 
     * @type {ShippingFlowTag}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    shippingFlow?: ShippingFlowTag;
    /**
     * 
     * @type {SalesChannel}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    marketPlaceName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    simpleSerialNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    isPrintable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    siocVolumetricWeight?: number;
    /**
     *
     * @type {boolean}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    isSioc?: boolean;
    /**
     *
     * @type {DeliveryTypeTag}
     * @memberof CreateSalesOrderPackingProcessOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
}
/**
 * 
 * @export
 * @interface CreateSalesOrderWithCustomerCommand
 */
export interface CreateSalesOrderWithCustomerCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    externalOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    operationName?: string;
    /**
     * 
     * @type {CustomerInputDTO}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    customer?: CustomerInputDTO;
    /**
     * 
     * @type {SalesOrderAddressInputDTO}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    shippingAddress?: SalesOrderAddressInputDTO;
    /**
     * 
     * @type {SalesOrderAddressInputDTO}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    billingAddress?: SalesOrderAddressInputDTO;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    orderCreatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    orderSoldAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    salesChannel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    salesLocation?: string;
    /**
     * 
     * @type {SalesOrderShippingMethodInputDTO}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    shippingMethod?: SalesOrderShippingMethodInputDTO;
    /**
     * 
     * @type {Array<SalesOrderLineItemInputDTO>}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    lineItems?: Array<SalesOrderLineItemInputDTO>;
    /**
     * 
     * @type {InvoiceInputDTO}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    invoice?: InvoiceInputDTO;
    /**
     * 
     * @type {Array<SalesOrderVASInputDTO>}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    vas?: Array<SalesOrderVASInputDTO>;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    deliveryType?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    expectedShipmentDate?: string;
    /**
     * 
     * @type {CustomPackageLabelDTO}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    customPackageLabels?: CustomPackageLabelDTO;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    isNeedDispatchApprove?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    missingPackingApproved?: boolean;
    /**
     * 
     * @type {SalesOrderEIrsaliyeInputDTO}
     * @memberof CreateSalesOrderWithCustomerCommand
     */
    irsaliye?: SalesOrderEIrsaliyeInputDTO;
}
/**
 * 
 * @export
 * @interface CreateSimplePackingAddressOutputDTO
 */
export interface CreateSimplePackingAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateSimplePackingAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSimplePackingAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSimplePackingAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateSimplePackingAddressesCommand
 */
export interface CreateSimplePackingAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateSimplePackingAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateSimplePackingAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSimplePackingAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSimplePackingAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateSimplePackingProcessCommand
 */
export interface CreateSimplePackingProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateSimplePackingProcessCommand
     */
    packingAddressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSimplePackingProcessCommand
     */
    productBarcode?: string;
}
/**
 * 
 * @export
 * @interface CreateSingleItemFastPackPackingAddressOutputDTO
 */
export interface CreateSingleItemFastPackPackingAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateSingleItemFastPackPackingAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSingleItemFastPackPackingAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSingleItemFastPackPackingAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateSingleItemFastPackPackingAddressesCommand
 */
export interface CreateSingleItemFastPackPackingAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateSingleItemFastPackPackingAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateSingleItemFastPackPackingAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSingleItemFastPackPackingAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSingleItemFastPackPackingAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateSingleItemPackingAddressOutputDTO
 */
export interface CreateSingleItemPackingAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateSingleItemPackingAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSingleItemPackingAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSingleItemPackingAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateSingleItemPackingAddressesCommand
 */
export interface CreateSingleItemPackingAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateSingleItemPackingAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateSingleItemPackingAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSingleItemPackingAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSingleItemPackingAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateSorterCommand
 */
export interface CreateSorterCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateSorterCommand
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateSorterCommand
     */
    exitPointCount?: number;
}
/**
 * 
 * @export
 * @interface CreateStockAddressOutputDTO
 */
export interface CreateStockAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateStockAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateStockAddressOutputDTO
     */
    labelFormat?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStockAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStockAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateStockAddressesCommand
 */
export interface CreateStockAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateStockAddressesCommand
     */
    sectionName?: string;
    /**
     * 
     * @type {AddressComponentInputDTO}
     * @memberof CreateStockAddressesCommand
     */
    side?: AddressComponentInputDTO;
    /**
     * 
     * @type {AddressComponentInputDTO}
     * @memberof CreateStockAddressesCommand
     */
    slot?: AddressComponentInputDTO;
    /**
     * 
     * @type {AddressComponentInputDTO}
     * @memberof CreateStockAddressesCommand
     */
    level?: AddressComponentInputDTO;
    /**
     * 
     * @type {AddressComponentInputDTO}
     * @memberof CreateStockAddressesCommand
     */
    depth?: AddressComponentInputDTO;
    /**
     * 
     * @type {AddressComponentInputDTO}
     * @memberof CreateStockAddressesCommand
     */
    cell?: AddressComponentInputDTO;
}
/**
 * 
 * @export
 * @interface CreateStockCellTypeCommand
 */
export interface CreateStockCellTypeCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateStockCellTypeCommand
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateStockCellTypeCommand
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateStockCellTypeCommand
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateStockCellTypeCommand
     */
    depth?: number;
}
/**
 * 
 * @export
 * @interface CreateStockCountingPlanCommand
 */
export interface CreateStockCountingPlanCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateStockCountingPlanCommand
     */
    stockCountingPlanName?: string;
    /**
     * 
     * @type {StockCountingType}
     * @memberof CreateStockCountingPlanCommand
     */
    stockCountingType?: StockCountingType;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateStockCountingPlanCommand
     */
    cellIds?: Array<number>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof CreateStockCountingPlanCommand
     */
    cellAndProductIdPairs?: { [key: string]: Array<string>; };
}
/**
 * 
 * @export
 * @interface CreateStockCountingProcessCommand
 */
export interface CreateStockCountingProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateStockCountingProcessCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStockCountingProcessCommand
     */
    stockCountingPlanId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStockCountingProcessCommand
     */
    qrCode?: string;
}
/**
 * 
 * @export
 * @interface CreateStockCountingProcessCommandOutputDTO
 */
export interface CreateStockCountingProcessCommandOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateStockCountingProcessCommandOutputDTO
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateStockCountingProcessCommandOutputDTO
     */
    stockCountingListReferenceNumber?: number;
    /**
     * 
     * @type {StockCountingType}
     * @memberof CreateStockCountingProcessCommandOutputDTO
     */
    stockCountingListType?: StockCountingType;
    /**
     * 
     * @type {boolean}
     * @memberof CreateStockCountingProcessCommandOutputDTO
     */
    isInputCountEntryActiveInCellStockCounting?: boolean;
}
/**
 * 
 * @export
 * @interface CreateStockZoneInputDTO
 */
export interface CreateStockZoneInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateStockZoneInputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStockZoneInputDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateStockZoneInputDTO
     */
    priority?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateStockZoneInputDTO
     */
    maxPickingCapacity?: number;
    /**
     * 
     * @type {PickingRouteType}
     * @memberof CreateStockZoneInputDTO
     */
    pickingRouteType?: PickingRouteType;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateStockZoneInputDTO
     */
    stockAddresses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateStockZoneInputDTO
     */
    productCatalog?: Array<string>;
    /**
     * 
     * @type {Array<StockZonePickListConfigInputDTO>}
     * @memberof CreateStockZoneInputDTO
     */
    pickListConfigurations?: Array<StockZonePickListConfigInputDTO>;
}
/**
 * 
 * @export
 * @interface CreateStockZonesOutputDTO
 */
export interface CreateStockZonesOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateStockZonesOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateStockZonesOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStockZonesOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateStockZonesOutputDTO
     */
    priority?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateStockZonesOutputDTO
     */
    maxPickingCapacity?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateStockZonesOutputDTO
     */
    stockAddresses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateStockZonesOutputDTO
     */
    productCatalog?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateSubZoneCommand
 */
export interface CreateSubZoneCommand {
    /**
     * 
     * @type {number}
     * @memberof CreateSubZoneCommand
     */
    stockZoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSubZoneCommand
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubZoneCommand
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface CreateTenantCommand
 */
export interface CreateTenantCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateTenantCommand
     */
    tenantName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantCommand
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantCommand
     */
    companyPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantCommand
     */
    companyEmail?: string;
}
/**
 * 
 * @export
 * @interface CreateTenantOutputDTO
 */
export interface CreateTenantOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateTenantOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantOutputDTO
     */
    tenantName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantOutputDTO
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantOutputDTO
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantOutputDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateToteOutputDTO
 */
export interface CreateToteOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateToteOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateToteOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateToteOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateToteSingleItemFastPackPackingProcessIfNotExistsCommand
 */
export interface CreateToteSingleItemFastPackPackingProcessIfNotExistsCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateToteSingleItemFastPackPackingProcessIfNotExistsCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateToteSingleItemFastPackPackingProcessIfNotExistsCommand
     */
    fastPackStationLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateToteSingleItemFastPackPackingProcessIfNotExistsCommand
     */
    isOperatorReassigned?: boolean;
}
/**
 * 
 * @export
 * @interface CreateToteSingleItemFastPackPackingProcessOutputDTO
 */
export interface CreateToteSingleItemFastPackPackingProcessOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    packingProcessId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    salesOrderCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    isSioc?: boolean;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {Array<SalesOrderLineItemOutputDTO>}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    salesOrderLineItems?: Array<SalesOrderLineItemOutputDTO>;
    /**
     * 
     * @type {ShippingFlowTag}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    shippingFlow?: ShippingFlowTag;
    /**
     * 
     * @type {Array<CargoPackageTypeOutputDTO>}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    operationCargoPackageTypes?: Array<CargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {Array<CargoPackageTypeOutputDTO>}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    oplogCargoPackageTypes?: Array<CargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {Array<OwnContainerCargoPackageTypeOutputDTO>}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    ownContainerCargoPackageTypes?: Array<OwnContainerCargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {string}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    defaultCargoPackageTypeBarcode?: string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    marketPlaceName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    selectedCargoPackageTypeBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    siocVolumetricWeight?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    isPackingCompleted?: boolean;
    /**
     * 
     * @type {Array<SalesOrderLineItemOutputDTO>}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    cancelledSalesOrderLineItems?: Array<SalesOrderLineItemOutputDTO>;
    /**
     * 
     * @type {Array<SalesOrderCargoPackageLabelDTO>}
     * @memberof CreateToteSingleItemFastPackPackingProcessOutputDTO
     */
    salesOrderCargoPackageLabels?: Array<SalesOrderCargoPackageLabelDTO>;
}
/**
 * 
 * @export
 * @interface CreateToteSingleItemPackingProcessIfNotExistsCommand
 */
export interface CreateToteSingleItemPackingProcessIfNotExistsCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateToteSingleItemPackingProcessIfNotExistsCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateToteSingleItemPackingProcessIfNotExistsCommand
     */
    singleItemPackingAddressLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateToteSingleItemPackingProcessIfNotExistsCommand
     */
    isOperatorReassigned?: boolean;
}
/**
 * 
 * @export
 * @interface CreateToteSingleItemPackingProcessOutputDTO
 */
export interface CreateToteSingleItemPackingProcessOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateToteSingleItemPackingProcessOutputDTO
     */
    singleItemPackingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateToteSingleItemPackingProcessOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateToteSingleItemPackingProcessOutputDTO
     */
    toteContainedItemsCount?: number;
    /**
     * 
     * @type {SingleItemPackingProcessSalesOrderProductOutputDTO}
     * @memberof CreateToteSingleItemPackingProcessOutputDTO
     */
    ongoingPackingProcessSalesOrderProduct?: SingleItemPackingProcessSalesOrderProductOutputDTO;
    /**
     * 
     * @type {boolean}
     * @memberof CreateToteSingleItemPackingProcessOutputDTO
     */
    isPrintable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateToteSingleItemPackingProcessOutputDTO
     */
    isSioc?: boolean;
}
/**
 * 
 * @export
 * @interface CreateTotesCommand
 */
export interface CreateTotesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateTotesCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTotesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateTotesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTotesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTotesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateUndefinedReturnPackageCommand
 */
export interface CreateUndefinedReturnPackageCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateUndefinedReturnPackageCommand
     */
    trackingId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUndefinedReturnPackageCommand
     */
    productIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUndefinedReturnPackageCommand
     */
    operationIds?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateUserCommand
 */
export interface CreateUserCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateUserCommand
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCommand
     */
    kindeId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCommand
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCommand
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCommand
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCommand
     */
    lastName?: string;
}
/**
 * 
 * @export
 * @interface CreateUserOutputDTO
 */
export interface CreateUserOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateUserOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserOutputDTO
     */
    kindeId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserOutputDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserOutputDTO
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserOutputDTO
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserOutputDTO
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserOutputDTO
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateVirtualTrolleyOutputDTO
 */
export interface CreateVirtualTrolleyOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateVirtualTrolleyOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateVirtualTrolleyOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVirtualTrolleyOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateVirtualTrolleysCommand
 */
export interface CreateVirtualTrolleysCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateVirtualTrolleysCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateVirtualTrolleysCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateVirtualTrolleysCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateVirtualTrolleysCommand
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateVirtualTrolleysCommand
     */
    variation?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateVirtualTrolleysCommand
     */
    toteCount?: number;
}
/**
 * 
 * @export
 * @interface CreateWallPackingAddressOutputDTO
 */
export interface CreateWallPackingAddressOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateWallPackingAddressOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateWallPackingAddressOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWallPackingAddressOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface CreateWallPackingAddressesCommand
 */
export interface CreateWallPackingAddressesCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateWallPackingAddressesCommand
     */
    prefix?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateWallPackingAddressesCommand
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateWallPackingAddressesCommand
     */
    increment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateWallPackingAddressesCommand
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreateWaybillCommand
 */
export interface CreateWaybillCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateWaybillCommand
     */
    purchaseOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWaybillCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWaybillCommand
     */
    waybillDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWaybillCommand
     */
    supplierCompany?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWaybillCommand
     */
    documentImageUrl?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateWaybillCommand
     */
    imageUrls?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateWaybillCommand
     */
    notes?: string;
    /**
     * 
     * @type {Array<CarrierInfoInputDTO>}
     * @memberof CreateWaybillCommand
     */
    carrierInfos?: Array<CarrierInfoInputDTO>;
    /**
     * 
     * @type {number}
     * @memberof CreateWaybillCommand
     */
    palletCount?: number;
}
/**
 * 
 * @export
 * @interface CreateWaybillOutputDTO
 */
export interface CreateWaybillOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateWaybillOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWaybillOutputDTO
     */
    purchaseOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWaybillOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWaybillOutputDTO
     */
    waybillDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWaybillOutputDTO
     */
    supplierCompany?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWaybillOutputDTO
     */
    documentImageUrl?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateWaybillOutputDTO
     */
    imageUrls?: Array<string>;
    /**
     * 
     * @type {Array<CarrierInfoOutputDTO>}
     * @memberof CreateWaybillOutputDTO
     */
    carrierInfos?: Array<CarrierInfoOutputDTO>;
    /**
     * 
     * @type {string}
     * @memberof CreateWaybillOutputDTO
     */
    notes?: string;
}
/**
 * 
 * @export
 * @interface CreateWebReceivingProcessIfNotExistsCommand
 */
export interface CreateWebReceivingProcessIfNotExistsCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateWebReceivingProcessIfNotExistsCommand
     */
    inboundBoxLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWebReceivingProcessIfNotExistsCommand
     */
    receivingToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWebReceivingProcessIfNotExistsCommand
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWebReceivingProcessIfNotExistsCommand
     */
    receivingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface CreateWebReceivingProcessIfNotExistsOutputDTO
 */
export interface CreateWebReceivingProcessIfNotExistsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateWebReceivingProcessIfNotExistsOutputDTO
     */
    webReceivingProcessId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateWebReceivingProcessIfNotExistsOutputDTO
     */
    referenceNumber?: number;
    /**
     * 
     * @type {WebReceivingToteDetailsOutputDTO}
     * @memberof CreateWebReceivingProcessIfNotExistsOutputDTO
     */
    receivingTote?: WebReceivingToteDetailsOutputDTO;
    /**
     * 
     * @type {WebReceivingToteDetailsOutputDTO}
     * @memberof CreateWebReceivingProcessIfNotExistsOutputDTO
     */
    quarantineTote?: WebReceivingToteDetailsOutputDTO;
}
/**
 * 
 * @export
 * @interface CreateWorkflowCommand
 */
export interface CreateWorkflowCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateWorkflowCommand
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkflowCommand
     */
    triggerEvent?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkflowCommand
     */
    filter?: string;
    /**
     * 
     * @type {WorkflowActionType}
     * @memberof CreateWorkflowCommand
     */
    type?: WorkflowActionType;
    /**
     * 
     * @type {EmailActionInputDTO}
     * @memberof CreateWorkflowCommand
     */
    emailAction?: EmailActionInputDTO;
    /**
     * 
     * @type {PrintActionInputDTO}
     * @memberof CreateWorkflowCommand
     */
    printAction?: PrintActionInputDTO;
    /**
     * 
     * @type {WebhookActionInputDTO}
     * @memberof CreateWorkflowCommand
     */
    webhookAction?: WebhookActionInputDTO;
    /**
     * 
     * @type {BlobActionInputDTO}
     * @memberof CreateWorkflowCommand
     */
    blobAction?: BlobActionInputDTO;
}
/**
 * 
 * @export
 * @interface CreateWorkflowOutputDTO
 */
export interface CreateWorkflowOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateWorkflowOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkflowOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkflowOutputDTO
     */
    triggerEvent?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkflowOutputDTO
     */
    filter?: string;
    /**
     * 
     * @type {WorkflowState}
     * @memberof CreateWorkflowOutputDTO
     */
    state?: WorkflowState;
    /**
     * 
     * @type {object}
     * @memberof CreateWorkflowOutputDTO
     */
    action?: object;
}
/**
 * 
 * @export
 * @interface CreateZonePickListConfigurationCommand
 */
export interface CreateZonePickListConfigurationCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateZonePickListConfigurationCommand
     */
    stockZone?: string;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof CreateZonePickListConfigurationCommand
     */
    pickingFlowTag?: PickingFlowTag;
    /**
     * 
     * @type {number}
     * @memberof CreateZonePickListConfigurationCommand
     */
    pickListCountThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateZonePickListConfigurationCommand
     */
    pickListCreateAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateZonePickListConfigurationCommand
     */
    disposePickLists?: boolean;
    /**
     * 
     * @type {StockZonePickingType}
     * @memberof CreateZonePickListConfigurationCommand
     */
    zonePickingType?: StockZonePickingType;
}
/**
 * 
 * @export
 * @interface CreateZonePickListConfigurationOutputDTO
 */
export interface CreateZonePickListConfigurationOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof CreateZonePickListConfigurationOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateZonePickListConfigurationOutputDTO
     */
    stockZoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateZonePickListConfigurationOutputDTO
     */
    stockZone?: string;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof CreateZonePickListConfigurationOutputDTO
     */
    pickingFlowTag?: PickingFlowTag;
    /**
     * 
     * @type {number}
     * @memberof CreateZonePickListConfigurationOutputDTO
     */
    pickListCountThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateZonePickListConfigurationOutputDTO
     */
    pickListCreateAmount?: number;
}
/**
 * 
 * @export
 * @interface CreatedCarrierOutputDTO
 */
export interface CreatedCarrierOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreatedCarrierOutputDTO
     */
    cargoCarrierId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedCarrierOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatedCarrierOutputDTO
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatedCarrierOutputDTO
     */
    logoUrl?: string;
}
/**
 * 
 * @export
 * @interface CreatedCustomerOutputDTO
 */
export interface CreatedCustomerOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CreatedCustomerOutputDTO
     */
    customerId?: string;
}
/**
 * 
 * @export
 * @interface CreatedRasPickListDetail
 */
export interface CreatedRasPickListDetail {
    /**
     * 
     * @type {string}
     * @memberof CreatedRasPickListDetail
     */
    pickListId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatedRasPickListDetail
     */
    pickListRequestId?: number;
    /**
     * 
     * @type {number}
     * @memberof CreatedRasPickListDetail
     */
    salesOrderBatchId?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatedRasPickListDetail
     */
    namePrefix?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatedRasPickListDetail
     */
    referenceNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreatedSalesOrderQueryOutputDTO
 */
export interface CreatedSalesOrderQueryOutputDTO {
    /**
     * 
     * @type {SalesOrderOutputCreatedStateEnum}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    salesOrderCreatedState?: SalesOrderOutputCreatedStateEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    isWaitingFeeding?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    orderCreatedAt?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {SalesChannel}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {SalesOrderPickingPriority}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    priority?: SalesOrderPickingPriority;
    /**
     * 
     * @type {boolean}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    isSuspended?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    isCutOff?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    isSoftCutOff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {string}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    suspendedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    isCargoCodeUpdated?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    isSalesChannelMatch?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatedSalesOrderQueryOutputDTO
     */
    cargoCarrier?: string;
}
/**
 * 
 * @export
 * @interface CreatedSalesOrderQueryOutputDTODynamicQueryOutputDTO
 */
export interface CreatedSalesOrderQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<CreatedSalesOrderQueryOutputDTO>}
     * @memberof CreatedSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<CreatedSalesOrderQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof CreatedSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CreatedStateDetailsOutputDTO
 */
export interface CreatedStateDetailsOutputDTO {
    /**
     * 
     * @type {SalesOrderOutputCreatedStateEnum}
     * @memberof CreatedStateDetailsOutputDTO
     */
    state?: SalesOrderOutputCreatedStateEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatedStateDetailsOutputDTO
     */
    at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatedStateDetailsOutputDTO
     */
    suspendedInThisState?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum Currency {
    None = 'None',
    Try = 'TRY',
    Usd = 'USD',
    Eur = 'EUR',
    Gbp = 'GBP',
    Rub = 'RUB',
    Uah = 'UAH',
    Unsupported = 'UNSUPPORTED',
    Afn = 'AFN',
    All = 'ALL',
    Aoa = 'AOA',
    Ars = 'ARS',
    Amd = 'AMD',
    Awg = 'AWG',
    Azn = 'AZN',
    Bsd = 'BSD',
    Bhd = 'BHD',
    Bdt = 'BDT',
    Bbd = 'BBD',
    Byn = 'BYN',
    Bzd = 'BZD',
    Bmd = 'BMD',
    Btn = 'BTN',
    Bob = 'BOB',
    Bam = 'BAM',
    Bwp = 'BWP',
    Brl = 'BRL',
    Bgn = 'BGN',
    Bif = 'BIF',
    Khr = 'KHR',
    Cad = 'CAD',
    Cve = 'CVE',
    Kyd = 'KYD',
    Clp = 'CLP',
    Cny = 'CNY',
    Cop = 'COP',
    Kmf = 'KMF',
    Cdf = 'CDF',
    Crc = 'CRC',
    Hrk = 'HRK',
    Cup = 'CUP',
    Czk = 'CZK',
    Djf = 'DJF',
    Dop = 'DOP',
    Egp = 'EGP',
    Ern = 'ERN',
    Szl = 'SZL',
    Etb = 'ETB',
    Fkp = 'FKP',
    Fjd = 'FJD',
    Xaf = 'XAF',
    Gmd = 'GMD',
    Gel = 'GEL',
    Ghs = 'GHS',
    Gip = 'GIP',
    Dkk = 'DKK',
    Gtq = 'GTQ',
    Gnf = 'GNF',
    Gyd = 'GYD',
    Htg = 'HTG',
    Hnl = 'HNL',
    Huf = 'HUF',
    Isk = 'ISK',
    Inr = 'INR',
    Idr = 'IDR',
    Irr = 'IRR',
    Iqd = 'IQD',
    Jmd = 'JMD',
    Jpy = 'JPY',
    Kzt = 'KZT',
    Kes = 'KES',
    Kpw = 'KPW',
    Krw = 'KRW',
    Kwd = 'KWD',
    Kgs = 'KGS',
    Lak = 'LAK',
    Lbp = 'LBP',
    Lsl = 'LSL',
    Lrd = 'LRD',
    Lyd = 'LYD',
    Mop = 'MOP',
    Hkd = 'HKD',
    Mga = 'MGA',
    Mwk = 'MWK',
    Myr = 'MYR',
    Mvr = 'MVR',
    Mur = 'MUR',
    Mxn = 'MXN',
    Mdl = 'MDL',
    Mnt = 'MNT',
    Mzn = 'MZN',
    Mmk = 'MMK',
    Nad = 'NAD',
    Npr = 'NPR',
    Nio = 'NIO',
    Ngn = 'NGN',
    Mkd = 'MKD',
    Nok = 'NOK',
    Omr = 'OMR',
    Pkr = 'PKR',
    Ils = 'ILS',
    Jod = 'JOD',
    Pab = 'PAB',
    Pgk = 'PGK',
    Pyg = 'PYG',
    Pen = 'PEN',
    Php = 'PHP',
    Nzd = 'NZD',
    Pln = 'PLN',
    Qar = 'QAR',
    Ron = 'RON',
    Rwf = 'RWF',
    Dzd = 'DZD',
    Mru = 'MRU',
    Mad = 'MAD',
    Shp = 'SHP',
    Xcd = 'XCD',
    Wst = 'WST',
    Stn = 'STN',
    Sar = 'SAR',
    Rsd = 'RSD',
    Scr = 'SCR',
    Sll = 'SLL',
    Sgd = 'SGD',
    Bnd = 'BND',
    Ang = 'ANG',
    Sbd = 'SBD',
    Sos = 'SOS',
    Zar = 'ZAR',
    Ssp = 'SSP',
    Lkr = 'LKR',
    Sdg = 'SDG',
    Srd = 'SRD',
    Sek = 'SEK',
    Chf = 'CHF',
    Syp = 'SYP',
    Twd = 'TWD',
    Tjs = 'TJS',
    Tzs = 'TZS',
    Thb = 'THB',
    Xof = 'XOF',
    Top = 'TOP',
    Ttd = 'TTD',
    Tnd = 'TND',
    Tmt = 'TMT',
    Aud = 'AUD',
    Ugx = 'UGX',
    Aed = 'AED',
    Uyu = 'UYU',
    Uzs = 'UZS',
    Vuv = 'VUV',
    Ves = 'VES',
    Ved = 'VED',
    Vnd = 'VND',
    Xpf = 'XPF',
    Yer = 'YER',
    Zmw = 'ZMW'
}

/**
 * 
 * @export
 * @interface CustomActionVasTypeOutputDTO
 */
export interface CustomActionVasTypeOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CustomActionVasTypeOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomActionVasTypeOutputDTO
     */
    description?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CustomCargoPackageBarcodeType {
    None = 'None',
    Code128 = 'Code128',
    Qr = 'QR'
}

/**
 * 
 * @export
 * @interface CustomPackageLabelDTO
 */
export interface CustomPackageLabelDTO {
    /**
     * 
     * @type {string}
     * @memberof CustomPackageLabelDTO
     */
    header?: string;
    /**
     * 
     * @type {Array<CustomPackageLabelFieldsInputDTO>}
     * @memberof CustomPackageLabelDTO
     */
    fields?: Array<CustomPackageLabelFieldsInputDTO>;
}
/**
 * 
 * @export
 * @interface CustomPackageLabelFieldsInputDTO
 */
export interface CustomPackageLabelFieldsInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CustomPackageLabelFieldsInputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomPackageLabelFieldsInputDTO
     */
    value?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomPackageLabelFieldsInputDTO
     */
    isCode?: boolean;
    /**
     * 
     * @type {CustomCargoPackageBarcodeType}
     * @memberof CustomPackageLabelFieldsInputDTO
     */
    barcodeType?: CustomCargoPackageBarcodeType;
}
/**
 * 
 * @export
 * @interface CustomerInputDTO
 */
export interface CustomerInputDTO {
    /**
     * 
     * @type {string}
     * @memberof CustomerInputDTO
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInputDTO
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInputDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInputDTO
     */
    phone?: string;
}
/**
 * 
 * @export
 * @interface CustomerOutputDTO
 */
export interface CustomerOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof CustomerOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOutputDTO
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface CustomersODataDTOODataQueryOptions
 */
export interface CustomersODataDTOODataQueryOptions {
    /**
     * 
     * @type {string}
     * @memberof CustomersODataDTOODataQueryOptions
     */
    ifMatch?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomersODataDTOODataQueryOptions
     */
    ifNoneMatch?: string;
    /**
     * 
     * @type {HttpRequest}
     * @memberof CustomersODataDTOODataQueryOptions
     */
    request?: HttpRequest;
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof CustomersODataDTOODataQueryOptions
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {ODataRawQueryOptions}
     * @memberof CustomersODataDTOODataQueryOptions
     */
    rawValues?: ODataRawQueryOptions;
    /**
     * 
     * @type {SelectExpandQueryOption}
     * @memberof CustomersODataDTOODataQueryOptions
     */
    selectExpand?: SelectExpandQueryOption;
    /**
     * 
     * @type {ApplyQueryOption}
     * @memberof CustomersODataDTOODataQueryOptions
     */
    apply?: ApplyQueryOption;
    /**
     * 
     * @type {ComputeQueryOption}
     * @memberof CustomersODataDTOODataQueryOptions
     */
    compute?: ComputeQueryOption;
    /**
     * 
     * @type {FilterQueryOption}
     * @memberof CustomersODataDTOODataQueryOptions
     */
    filter?: FilterQueryOption;
    /**
     * 
     * @type {SearchQueryOption}
     * @memberof CustomersODataDTOODataQueryOptions
     */
    search?: SearchQueryOption;
    /**
     * 
     * @type {OrderByQueryOption}
     * @memberof CustomersODataDTOODataQueryOptions
     */
    orderBy?: OrderByQueryOption;
    /**
     * 
     * @type {SkipQueryOption}
     * @memberof CustomersODataDTOODataQueryOptions
     */
    skip?: SkipQueryOption;
    /**
     * 
     * @type {SkipTokenQueryOption}
     * @memberof CustomersODataDTOODataQueryOptions
     */
    skipToken?: SkipTokenQueryOption;
    /**
     * 
     * @type {TopQueryOption}
     * @memberof CustomersODataDTOODataQueryOptions
     */
    top?: TopQueryOption;
    /**
     * 
     * @type {CountQueryOption}
     * @memberof CustomersODataDTOODataQueryOptions
     */
    count?: CountQueryOption;
    /**
     * 
     * @type {object}
     * @memberof CustomersODataDTOODataQueryOptions
     */
    validator?: object;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CutOffStatus {
    None = 'None',
    CutOff = 'CutOff',
    Late = 'Late'
}

/**
 * 
 * @export
 * @interface DamagedItemOutputDTO
 */
export interface DamagedItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof DamagedItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof DamagedItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof DamagedItemOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DamagedItemOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof DamagedItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof DamagedItemOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {InboundProblemType}
     * @memberof DamagedItemOutputDTO
     */
    problemType?: InboundProblemType;
    /**
     * 
     * @type {string}
     * @memberof DamagedItemOutputDTO
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DamagedItemOutputDTO
     */
    isExpirationDateRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DamagedItemOutputDTO
     */
    expirationDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DamagedItemOutputDTO
     */
    isLotNumberTrackingRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DamagedItemOutputDTO
     */
    lotNumber?: string;
}
/**
 * 
 * @export
 * @interface DamagedItemToteOutputDTO
 */
export interface DamagedItemToteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof DamagedItemToteOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof DamagedItemToteOutputDTO
     */
    containedItemCount?: number;
    /**
     * 
     * @type {AddressType}
     * @memberof DamagedItemToteOutputDTO
     */
    addressType?: AddressType;
}
/**
 * 
 * @export
 * @interface DamagedItemToteOutputDTODynamicQueryOutputDTO
 */
export interface DamagedItemToteOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<DamagedItemToteOutputDTO>}
     * @memberof DamagedItemToteOutputDTODynamicQueryOutputDTO
     */
    data?: Array<DamagedItemToteOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof DamagedItemToteOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface DamagedItemsOutputDTO
 */
export interface DamagedItemsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof DamagedItemsOutputDTO
     */
    totalItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DamagedItemsOutputDTO
     */
    totalToteCount?: number;
    /**
     * 
     * @type {Array<DamagedItemToteOutputDTO>}
     * @memberof DamagedItemsOutputDTO
     */
    damagedItemTotes?: Array<DamagedItemToteOutputDTO>;
}
/**
 * 
 * @export
 * @interface DateRangeInputDTO
 */
export interface DateRangeInputDTO {
    /**
     * 
     * @type {string}
     * @memberof DateRangeInputDTO
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof DateRangeInputDTO
     */
    to?: string;
}
/**
 * 
 * @export
 * @interface DateRangeOutputDTO
 */
export interface DateRangeOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof DateRangeOutputDTO
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof DateRangeOutputDTO
     */
    to?: string;
}
/**
 * 
 * @export
 * @interface DeactivateIntegrationCommand
 */
export interface DeactivateIntegrationCommand {
    /**
     * 
     * @type {string}
     * @memberof DeactivateIntegrationCommand
     */
    integrationId?: string;
}
/**
 * 
 * @export
 * @interface DeactivateWorkflowCommand
 */
export interface DeactivateWorkflowCommand {
    /**
     * 
     * @type {string}
     * @memberof DeactivateWorkflowCommand
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface DeactivatedIntegrationOutputDTO
 */
export interface DeactivatedIntegrationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof DeactivatedIntegrationOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DeactivatedIntegrationOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {IntegrationType}
     * @memberof DeactivatedIntegrationOutputDTO
     */
    type?: IntegrationType;
}
/**
 * 
 * @export
 * @interface DefaultQuerySettings
 */
export interface DefaultQuerySettings {
    /**
     * 
     * @type {boolean}
     * @memberof DefaultQuerySettings
     */
    enableExpand?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultQuerySettings
     */
    enableSelect?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultQuerySettings
     */
    enableCount?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultQuerySettings
     */
    enableOrderBy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultQuerySettings
     */
    enableFilter?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DefaultQuerySettings
     */
    maxTop?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultQuerySettings
     */
    enableSkipToken?: boolean;
}
/**
 * 
 * @export
 * @interface DeleteCargoPackageFromQueueForSingleItemPackingCommand
 */
export interface DeleteCargoPackageFromQueueForSingleItemPackingCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteCargoPackageFromQueueForSingleItemPackingCommand
     */
    packingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCargoPackageFromQueueForSingleItemPackingCommand
     */
    cargoPackageTypeBarcode?: string;
}
/**
 * 
 * @export
 * @interface DeleteCarrierPreferenceCommand
 */
export interface DeleteCarrierPreferenceCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteCarrierPreferenceCommand
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteCarrierPreferenceCommand
     */
    preferenceId?: string;
}
/**
 * 
 * @export
 * @interface DeleteDamagedItemsCommand
 */
export interface DeleteDamagedItemsCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteDamagedItemsCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteDamagedItemsCommand
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteDamagedItemsCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof DeleteDamagedItemsCommand
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof DeleteDamagedItemsCommand
     */
    problemReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface DeleteExcessReceivingProductsCommand
 */
export interface DeleteExcessReceivingProductsCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteExcessReceivingProductsCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteExcessReceivingProductsCommand
     */
    purchaseOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteExcessReceivingProductsCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof DeleteExcessReceivingProductsCommand
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface DeleteGridFilterPresetInputDTO
 */
export interface DeleteGridFilterPresetInputDTO {
    /**
     * 
     * @type {string}
     * @memberof DeleteGridFilterPresetInputDTO
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface DeleteIntegrationCommand
 */
export interface DeleteIntegrationCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteIntegrationCommand
     */
    integrationId?: string;
}
/**
 * 
 * @export
 * @interface DeleteLastDamagedItemCommand
 */
export interface DeleteLastDamagedItemCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteLastDamagedItemCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteLastDamagedItemCommand
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteLastDamagedItemCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteLastDamagedItemCommand
     */
    problemReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface DeleteLastReceivedItemCommand
 */
export interface DeleteLastReceivedItemCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteLastReceivedItemCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteLastReceivedItemCommand
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteLastReceivedItemCommand
     */
    containerLabel?: string;
}
/**
 * 
 * @export
 * @interface DeletePickListRequestsCommand
 */
export interface DeletePickListRequestsCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeletePickListRequestsCommand
     */
    referenceNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface DeletePickListsCommand
 */
export interface DeletePickListsCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeletePickListsCommand
     */
    pickListIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DeletePickListsCommand
     */
    deleteMissingItemPickLists?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeletePickListsCommand
     */
    deleteBatchPickingPickLists?: boolean;
}
/**
 * 
 * @export
 * @interface DeletePrinterCommand
 */
export interface DeletePrinterCommand {
    /**
     * 
     * @type {string}
     * @memberof DeletePrinterCommand
     */
    queueName?: string;
}
/**
 * 
 * @export
 * @interface DeletePrinterOutputDTO
 */
export interface DeletePrinterOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof DeletePrinterOutputDTO
     */
    printerName?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletePrinterOutputDTO
     */
    selectedPrinterName?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletePrinterOutputDTO
     */
    queueName?: string;
}
/**
 * 
 * @export
 * @interface DeleteProductBarcodeCommand
 */
export interface DeleteProductBarcodeCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteProductBarcodeCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteProductBarcodeCommand
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteProductBarcodeCommand
     */
    barcode?: string;
}
/**
 * 
 * @export
 * @interface DeleteProductBarcodeOutputDTO
 */
export interface DeleteProductBarcodeOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof DeleteProductBarcodeOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteProductBarcodeOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteProductBarcodeOutputDTO
     */
    removedBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteProductBarcodeOutputDTO
     */
    remainingBarcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteProductBarcodeOutputDTO
     */
    renamedBarcode?: string;
}
/**
 * 
 * @export
 * @interface DeleteProductCommand
 */
export interface DeleteProductCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteProductCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteProductCommand
     */
    sku?: string;
}
/**
 * 
 * @export
 * @interface DeleteProductFromContainerCommand
 */
export interface DeleteProductFromContainerCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteProductFromContainerCommand
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteProductFromContainerCommand
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteProductFromContainerCommand
     */
    itemType?: string;
    /**
     * 
     * @type {number}
     * @memberof DeleteProductFromContainerCommand
     */
    quantity?: number;
}
/**
 * 
 * @export
 * @interface DeleteProductFromContainerOutputDTO
 */
export interface DeleteProductFromContainerOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof DeleteProductFromContainerOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteProductFromContainerOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteProductFromContainerOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {number}
     * @memberof DeleteProductFromContainerOutputDTO
     */
    deletedQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof DeleteProductFromContainerOutputDTO
     */
    itemType?: string;
    /**
     * 
     * @type {RemainingItemsDTO}
     * @memberof DeleteProductFromContainerOutputDTO
     */
    remainingInContainer?: RemainingItemsDTO;
    /**
     * 
     * @type {Array<OtherContainerDTO>}
     * @memberof DeleteProductFromContainerOutputDTO
     */
    otherContainersWithThisProduct?: Array<OtherContainerDTO>;
}
/**
 * 
 * @export
 * @interface DeleteProductOutputDTO
 */
export interface DeleteProductOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof DeleteProductOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteProductOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteProductOutputDTO
     */
    action?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteProductOutputDTO
     */
    newSKU?: string;
    /**
     * 
     * @type {Array<BarcodeActionInfo>}
     * @memberof DeleteProductOutputDTO
     */
    barcodeActions?: Array<BarcodeActionInfo>;
}
/**
 * 
 * @export
 * @interface DeleteProductsCommand
 */
export interface DeleteProductsCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteProductsCommand
     */
    operationId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteProductsCommand
     */
    skUs?: Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteProductsOutputDTO
 */
export interface DeleteProductsOutputDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteProductsOutputDTO
     */
    deletedSKUs?: Array<string>;
    /**
     * 
     * @type {Array<RenamedSKUInfo>}
     * @memberof DeleteProductsOutputDTO
     */
    renamedSKUs?: Array<RenamedSKUInfo>;
    /**
     * 
     * @type {number}
     * @memberof DeleteProductsOutputDTO
     */
    deletedProductsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DeleteProductsOutputDTO
     */
    deletedBarcodesCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DeleteProductsOutputDTO
     */
    renamedProductsCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteProductsOutputDTO
     */
    notFoundSKUs?: Array<string>;
    /**
     * 
     * @type {Array<FailedSKUInfo>}
     * @memberof DeleteProductsOutputDTO
     */
    failedSKUs?: Array<FailedSKUInfo>;
}
/**
 * 
 * @export
 * @interface DeletePurchaseOrderCommand
 */
export interface DeletePurchaseOrderCommand {
    /**
     * 
     * @type {string}
     * @memberof DeletePurchaseOrderCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletePurchaseOrderCommand
     */
    purchaseOrderReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface DeletePutAwayCellRuleCommand
 */
export interface DeletePutAwayCellRuleCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeletePutAwayCellRuleCommand
     */
    cellLabels?: Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteReceivedItemsCommand
 */
export interface DeleteReceivedItemsCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteReceivedItemsCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteReceivedItemsCommand
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteReceivedItemsCommand
     */
    containerLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof DeleteReceivedItemsCommand
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface DeleteReturnPackageCommand
 */
export interface DeleteReturnPackageCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteReturnPackageCommand
     */
    salesOrderReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface DeleteSorterCommand
 */
export interface DeleteSorterCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteSorterCommand
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface DeleteStockCellTypeCommand
 */
export interface DeleteStockCellTypeCommand {
    /**
     * 
     * @type {number}
     * @memberof DeleteStockCellTypeCommand
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface DeleteSupportProductCommand
 */
export interface DeleteSupportProductCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteSupportProductCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteSupportProductCommand
     */
    sku?: string;
}
/**
 * 
 * @export
 * @interface DeleteTenantCommand
 */
export interface DeleteTenantCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteTenantCommand
     */
    tenantName?: string;
}
/**
 * 
 * @export
 * @interface DeleteWallToWallStockCountingAddressCommand
 */
export interface DeleteWallToWallStockCountingAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteWallToWallStockCountingAddressCommand
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {number}
     * @memberof DeleteWallToWallStockCountingAddressCommand
     */
    cellId?: number;
}
/**
 * 
 * @export
 * @interface DeleteWallToWallStockCountingListCommand
 */
export interface DeleteWallToWallStockCountingListCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteWallToWallStockCountingListCommand
     */
    stockCountingListId?: string;
}
/**
 * 
 * @export
 * @interface DeleteWaybillImageUrlCommand
 */
export interface DeleteWaybillImageUrlCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteWaybillImageUrlCommand
     */
    waybillId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeleteWaybillImageUrlCommand
     */
    imageUrl?: string;
}
/**
 * 
 * @export
 * @interface DeleteWorkflowCommand
 */
export interface DeleteWorkflowCommand {
    /**
     * 
     * @type {string}
     * @memberof DeleteWorkflowCommand
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface DeletedIntegrationOutputDTO
 */
export interface DeletedIntegrationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof DeletedIntegrationOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletedIntegrationOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {IntegrationType}
     * @memberof DeletedIntegrationOutputDTO
     */
    type?: IntegrationType;
}
/**
 * 
 * @export
 * @interface DeletedOperationInfo
 */
export interface DeletedOperationInfo {
    /**
     * 
     * @type {string}
     * @memberof DeletedOperationInfo
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletedOperationInfo
     */
    operationName?: string;
    /**
     * 
     * @type {number}
     * @memberof DeletedOperationInfo
     */
    productCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DeletedOperationInfo
     */
    inventoryItemCount?: number;
}
/**
 * 
 * @export
 * @interface DeletedPickListsOutputDTO
 */
export interface DeletedPickListsOutputDTO {
    /**
     * 
     * @type {Array<DeletedPicklistDetailDTO>}
     * @memberof DeletedPickListsOutputDTO
     */
    deleted?: Array<DeletedPicklistDetailDTO>;
    /**
     * 
     * @type {Array<DeletedPicklistDetailDTO>}
     * @memberof DeletedPickListsOutputDTO
     */
    failed?: Array<DeletedPicklistDetailDTO>;
}
/**
 * 
 * @export
 * @interface DeletedPicklistDetailDTO
 */
export interface DeletedPicklistDetailDTO {
    /**
     * 
     * @type {string}
     * @memberof DeletedPicklistDetailDTO
     */
    picklistId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletedPicklistDetailDTO
     */
    picklistName?: string;
    /**
     * 
     * @type {PickListState}
     * @memberof DeletedPicklistDetailDTO
     */
    pickListState?: PickListState;
    /**
     * 
     * @type {PickingTrolleySelectionConfigurationPickingType}
     * @memberof DeletedPicklistDetailDTO
     */
    pickingType?: PickingTrolleySelectionConfigurationPickingType;
}
/**
 * 
 * @export
 * @interface DeliverCargoPackageInputDTO
 */
export interface DeliverCargoPackageInputDTO {
    /**
     * 
     * @type {string}
     * @memberof DeliverCargoPackageInputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliverCargoPackageInputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeliverCargoPackageInputDTO
     */
    cargoPackageLabels?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DeliverCargoPackageInputDTO
     */
    recipientFirstname?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliverCargoPackageInputDTO
     */
    recipientLastname?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliverCargoPackageInputDTO
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliverCargoPackageInputDTO
     */
    recipientCompanyName?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliverCargoPackageInputDTO
     */
    licensePlate?: string;
}
/**
 * 
 * @export
 * @interface DeliverCargoPackagesForManualDeliverySalesOrdersCommand
 */
export interface DeliverCargoPackagesForManualDeliverySalesOrdersCommand {
    /**
     * 
     * @type {Array<DeliverCargoPackageInputDTO>}
     * @memberof DeliverCargoPackagesForManualDeliverySalesOrdersCommand
     */
    packages?: Array<DeliverCargoPackageInputDTO>;
}
/**
 * 
 * @export
 * @interface DeliverCargoPackagesForManualDeliverySalesOrdersCommandOutputDTO
 */
export interface DeliverCargoPackagesForManualDeliverySalesOrdersCommandOutputDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeliverCargoPackagesForManualDeliverySalesOrdersCommandOutputDTO
     */
    successfulCargoPackages?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof DeliverCargoPackagesForManualDeliverySalesOrdersCommandOutputDTO
     */
    failedCargoPackages?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof DeliverCargoPackagesForManualDeliverySalesOrdersCommandOutputDTO
     */
    notFoundCargoPackages?: Array<string>;
}
/**
 * 
 * @export
 * @interface DeliverCargoPackagesForSingleManualDeliverySalesOrderCommand
 */
export interface DeliverCargoPackagesForSingleManualDeliverySalesOrderCommand {
    /**
     * 
     * @type {DeliverCargoPackageInputDTO}
     * @memberof DeliverCargoPackagesForSingleManualDeliverySalesOrderCommand
     */
    cargoPackages?: DeliverCargoPackageInputDTO;
}
/**
 * 
 * @export
 * @interface DeliverSalesOrderInputDTO
 */
export interface DeliverSalesOrderInputDTO {
    /**
     * 
     * @type {string}
     * @memberof DeliverSalesOrderInputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliverSalesOrderInputDTO
     */
    salesOrderReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface DeliveredSalesOrderQueryOutputDTO
 */
export interface DeliveredSalesOrderQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    deliveredAt?: string;
    /**
     * 
     * @type {SalesOrderDeliveredState}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    salesOrderDeliveredState?: SalesOrderDeliveredState;
    /**
     * 
     * @type {string}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    orderCreatedAt?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {SalesChannel}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {SalesOrderPickingPriority}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    priority?: SalesOrderPickingPriority;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    isSuspended?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    isCutOff?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    isSoftCutOff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {string}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    suspendedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    isCargoCodeUpdated?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    isSalesChannelMatch?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeliveredSalesOrderQueryOutputDTO
     */
    cargoCarrier?: string;
}
/**
 * 
 * @export
 * @interface DeliveredSalesOrderQueryOutputDTODynamicQueryOutputDTO
 */
export interface DeliveredSalesOrderQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<DeliveredSalesOrderQueryOutputDTO>}
     * @memberof DeliveredSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<DeliveredSalesOrderQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof DeliveredSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface DeliveredStateDetailsOutputDTO
 */
export interface DeliveredStateDetailsOutputDTO {
    /**
     * 
     * @type {SalesOrderOutputDeliveredState}
     * @memberof DeliveredStateDetailsOutputDTO
     */
    state?: SalesOrderOutputDeliveredState;
    /**
     * 
     * @type {string}
     * @memberof DeliveredStateDetailsOutputDTO
     */
    at?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DeliveryTypeTag {
    RegularDelivery = 'RegularDelivery',
    SameDayDelivery = 'SameDayDelivery',
    ManualDelivery = 'ManualDelivery',
    ScheduledDelivery = 'ScheduledDelivery',
    CustomerPickup = 'CustomerPickup',
    ManagedShipping = 'ManagedShipping'
}

/**
 * 
 * @export
 * @interface DeprioritizePickListRequestsCommand
 */
export interface DeprioritizePickListRequestsCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeprioritizePickListRequestsCommand
     */
    referenceNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface DeprioritizeStockCountingPlanCommand
 */
export interface DeprioritizeStockCountingPlanCommand {
    /**
     * 
     * @type {number}
     * @memberof DeprioritizeStockCountingPlanCommand
     */
    referenceNumber?: number;
}
/**
 * 
 * @export
 * @interface DirectItemPlacedCommand
 */
export interface DirectItemPlacedCommand {
    /**
     * 
     * @type {string}
     * @memberof DirectItemPlacedCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof DirectItemPlacedCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof DirectItemPlacedCommand
     */
    productBarcode?: string;
}
/**
 * 
 * @export
 * @interface DirectZoneTransferCommand
 */
export interface DirectZoneTransferCommand {
    /**
     * 
     * @type {string}
     * @memberof DirectZoneTransferCommand
     */
    operationName?: string;
    /**
     * 
     * @type {number}
     * @memberof DirectZoneTransferCommand
     */
    oldZoneId?: number;
    /**
     * 
     * @type {number}
     * @memberof DirectZoneTransferCommand
     */
    newZoneId?: number;
}
/**
 * 
 * @export
 * @interface DisableCarrierCommand
 */
export interface DisableCarrierCommand {
    /**
     * 
     * @type {string}
     * @memberof DisableCarrierCommand
     */
    carrierName?: string;
}
/**
 * 
 * @export
 * @interface DisableProductExpirationTrackingCommand
 */
export interface DisableProductExpirationTrackingCommand {
    /**
     * 
     * @type {string}
     * @memberof DisableProductExpirationTrackingCommand
     */
    operationId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DisableProductExpirationTrackingCommand
     */
    skUs?: Array<string>;
}
/**
 * 
 * @export
 * @interface DisableProductExpirationTrackingOutputDTO
 */
export interface DisableProductExpirationTrackingOutputDTO {
    /**
     * 
     * @type {Array<SuccessfulOperationInfo>}
     * @memberof DisableProductExpirationTrackingOutputDTO
     */
    successfulOperations?: Array<SuccessfulOperationInfo>;
    /**
     * 
     * @type {number}
     * @memberof DisableProductExpirationTrackingOutputDTO
     */
    successfulCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DisableProductExpirationTrackingOutputDTO
     */
    totalInventoryItemsUpdated?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DisableProductExpirationTrackingOutputDTO
     */
    notFoundSKUs?: Array<string>;
    /**
     * 
     * @type {Array<FailedSKUInfo>}
     * @memberof DisableProductExpirationTrackingOutputDTO
     */
    failedSKUs?: Array<FailedSKUInfo>;
}
/**
 * 
 * @export
 * @interface DisableProductLotNumberTrackingCommand
 */
export interface DisableProductLotNumberTrackingCommand {
    /**
     * 
     * @type {string}
     * @memberof DisableProductLotNumberTrackingCommand
     */
    operationName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DisableProductLotNumberTrackingCommand
     */
    skUs?: Array<string>;
}
/**
 * 
 * @export
 * @interface DisableProductLotNumberTrackingOutputDTO
 */
export interface DisableProductLotNumberTrackingOutputDTO {
    /**
     * 
     * @type {Array<SuccessfulOperationInfo>}
     * @memberof DisableProductLotNumberTrackingOutputDTO
     */
    successfulOperations?: Array<SuccessfulOperationInfo>;
    /**
     * 
     * @type {number}
     * @memberof DisableProductLotNumberTrackingOutputDTO
     */
    successfulCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DisableProductLotNumberTrackingOutputDTO
     */
    totalInventoryItemsUpdated?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DisableProductLotNumberTrackingOutputDTO
     */
    notFoundSKUs?: Array<string>;
    /**
     * 
     * @type {Array<FailedSKUInfo>}
     * @memberof DisableProductLotNumberTrackingOutputDTO
     */
    failedSKUs?: Array<FailedSKUInfo>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DispatchApproveState {
    None = 'None',
    WaitingForApprove = 'WaitingForApprove',
    Approved = 'Approved'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum DispatchCargoPackageState {
    None = 'None',
    WaitingForSlam = 'WaitingForSLAM',
    Suspended = 'Suspended',
    ReadyForDispatch = 'ReadyForDispatch',
    Cancelled = 'Cancelled',
    Transferred = 'Transferred',
    Dispatched = 'Dispatched',
    WaitingForManualDelivery = 'WaitingForManualDelivery',
    Delivered = 'Delivered',
    ManuallyDelivered = 'ManuallyDelivered'
}

/**
 * 
 * @export
 * @interface DispatchHistoryOutputDTO
 */
export interface DispatchHistoryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof DispatchHistoryOutputDTO
     */
    dispatchProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchHistoryOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchHistoryOutputDTO
     */
    carrierName?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchHistoryOutputDTO
     */
    carrierLogoURL?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchHistoryOutputDTO
     */
    documentImageURL?: string;
    /**
     * 
     * @type {number}
     * @memberof DispatchHistoryOutputDTO
     */
    salesOrdersCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DispatchHistoryOutputDTO
     */
    cargoPackagesCount?: number;
}
/**
 * 
 * @export
 * @interface DispatchHistoryOutputDTODynamicQueryOutputDTO
 */
export interface DispatchHistoryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<DispatchHistoryOutputDTO>}
     * @memberof DispatchHistoryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<DispatchHistoryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof DispatchHistoryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface DispatchProcessCargoPackageDetailsOutputDTO
 */
export interface DispatchProcessCargoPackageDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackageDetailsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackageDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackageDetailsOutputDTO
     */
    cargoPackageLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessCargoPackageDetailsOutputDTO
     */
    cargoPackageItemsCount?: number;
}
/**
 * 
 * @export
 * @interface DispatchProcessCargoPackageDetailsOutputDTODynamicQueryOutputDTO
 */
export interface DispatchProcessCargoPackageDetailsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<DispatchProcessCargoPackageDetailsOutputDTO>}
     * @memberof DispatchProcessCargoPackageDetailsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<DispatchProcessCargoPackageDetailsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessCargoPackageDetailsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface DispatchProcessCargoPackageManagementCountsOutputDTO
 */
export interface DispatchProcessCargoPackageManagementCountsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessCargoPackageManagementCountsOutputDTO
     */
    totalNotDispatchedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessCargoPackageManagementCountsOutputDTO
     */
    waitingForSLAMCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessCargoPackageManagementCountsOutputDTO
     */
    suspendedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessCargoPackageManagementCountsOutputDTO
     */
    readyForDispatchCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessCargoPackageManagementCountsOutputDTO
     */
    notDispatchedCutOffCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessCargoPackageManagementCountsOutputDTO
     */
    notDispatchedLateCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessCargoPackageManagementCountsOutputDTO
     */
    cancelledCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessCargoPackageManagementCountsOutputDTO
     */
    transferredCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessCargoPackageManagementCountsOutputDTO
     */
    waitingForManualDeliveryCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessCargoPackageManagementCountsOutputDTO
     */
    waitingForApproveCount?: number;
}
/**
 * 
 * @export
 * @interface DispatchProcessCargoPackagesCombinedOutputDTO
 */
export interface DispatchProcessCargoPackagesCombinedOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    cargoPackageLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {DispatchCargoPackageState}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    cargoPackageState?: DispatchCargoPackageState;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    packingDate?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    slamDate?: string;
    /**
     * 
     * @type {CutOffStatus}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    cutOffStatus?: CutOffStatus;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    dispatchDate?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    targetDispatchDate?: string;
    /**
     * 
     * @type {DispatchApproveState}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    dispatchApproveState?: DispatchApproveState;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    shippingTrackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    carrierName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    isNotDispatched?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    isWaitingForSLAM?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    isSuspended?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    isReadyForDispatch?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    isCancelled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    isTransferred?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    isNotDispatchedCutOff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    isNotDispatchedLate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    isWaitingForManualDelivery?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTO
     */
    itemCount?: number;
}
/**
 * 
 * @export
 * @interface DispatchProcessCargoPackagesCombinedOutputDTODynamicQueryOutputDTO
 */
export interface DispatchProcessCargoPackagesCombinedOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<DispatchProcessCargoPackagesCombinedOutputDTO>}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTODynamicQueryOutputDTO
     */
    data?: Array<DispatchProcessCargoPackagesCombinedOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessCargoPackagesCombinedOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface DispatchProcessDetailsOutputDTO
 */
export interface DispatchProcessDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessDetailsOutputDTO
     */
    dispatchProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessDetailsOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessDetailsOutputDTO
     */
    carrierName?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessDetailsOutputDTO
     */
    carrierLogoURL?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessDetailsOutputDTO
     */
    documentImageURL?: string;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessDetailsOutputDTO
     */
    salesOrdersCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessDetailsOutputDTO
     */
    cargoPackagesCount?: number;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessDetailsOutputDTO
     */
    invoiceUrl?: string;
}
/**
 * 
 * @export
 * @interface DispatchProcessSalesOrderDetailsOutputDTO
 */
export interface DispatchProcessSalesOrderDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessSalesOrderDetailsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchProcessSalesOrderDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessSalesOrderDetailsOutputDTO
     */
    cargoPackagesCount?: number;
}
/**
 * 
 * @export
 * @interface DispatchProcessSalesOrderDetailsOutputDTODynamicQueryOutputDTO
 */
export interface DispatchProcessSalesOrderDetailsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<DispatchProcessSalesOrderDetailsOutputDTO>}
     * @memberof DispatchProcessSalesOrderDetailsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<DispatchProcessSalesOrderDetailsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof DispatchProcessSalesOrderDetailsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface DispatchSalesOrderWithProblemToDeliverCommand
 */
export interface DispatchSalesOrderWithProblemToDeliverCommand {
    /**
     * 
     * @type {string}
     * @memberof DispatchSalesOrderWithProblemToDeliverCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchSalesOrderWithProblemToDeliverCommand
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface DivertCancelledItemToToteCommand
 */
export interface DivertCancelledItemToToteCommand {
    /**
     * 
     * @type {string}
     * @memberof DivertCancelledItemToToteCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof DivertCancelledItemToToteCommand
     */
    sourceToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof DivertCancelledItemToToteCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof DivertCancelledItemToToteCommand
     */
    cancelToteLabel?: string;
}
/**
 * 
 * @export
 * @interface DropAllBatchTotesCommand
 */
export interface DropAllBatchTotesCommand {
    /**
     * 
     * @type {number}
     * @memberof DropAllBatchTotesCommand
     */
    sortingProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof DropAllBatchTotesCommand
     */
    dropAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface DropAllBatchTotesWithLostItemsCommand
 */
export interface DropAllBatchTotesWithLostItemsCommand {
    /**
     * 
     * @type {number}
     * @memberof DropAllBatchTotesWithLostItemsCommand
     */
    sortingProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof DropAllBatchTotesWithLostItemsCommand
     */
    dropAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface DropBatchToteCommand
 */
export interface DropBatchToteCommand {
    /**
     * 
     * @type {number}
     * @memberof DropBatchToteCommand
     */
    sortingProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof DropBatchToteCommand
     */
    batchPickingToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof DropBatchToteCommand
     */
    dropAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface DropBatchToteOutputDTO
 */
export interface DropBatchToteOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof DropBatchToteOutputDTO
     */
    toteCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DropBatchToteOutputDTO
     */
    sortingCompleted?: boolean;
}
/**
 * 
 * @export
 * @interface DropBatchToteWithLostItemsCommand
 */
export interface DropBatchToteWithLostItemsCommand {
    /**
     * 
     * @type {number}
     * @memberof DropBatchToteWithLostItemsCommand
     */
    sortingProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof DropBatchToteWithLostItemsCommand
     */
    batchPickingToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof DropBatchToteWithLostItemsCommand
     */
    dropAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface DropBatchTrolleyCommand
 */
export interface DropBatchTrolleyCommand {
    /**
     * 
     * @type {number}
     * @memberof DropBatchTrolleyCommand
     */
    sortingProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof DropBatchTrolleyCommand
     */
    batchTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof DropBatchTrolleyCommand
     */
    parkAddressLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DropBatchTrolleyCommand
     */
    skipCheckSortingCompleted?: boolean;
}
/**
 * 
 * @export
 * @interface DropRebinTrolleyCommand
 */
export interface DropRebinTrolleyCommand {
    /**
     * 
     * @type {number}
     * @memberof DropRebinTrolleyCommand
     */
    sortingProcessReferenceNumber?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DropRebinTrolleyCommand
     */
    rebinTrolleyLabels?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DropRebinTrolleyCommand
     */
    dropAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface DropToteForWebReceivingCommand
 */
export interface DropToteForWebReceivingCommand {
    /**
     * 
     * @type {string}
     * @memberof DropToteForWebReceivingCommand
     */
    webReceivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof DropToteForWebReceivingCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof DropToteForWebReceivingCommand
     */
    dropAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface DropToteFromPickStationCommand
 */
export interface DropToteFromPickStationCommand {
    /**
     * 
     * @type {string}
     * @memberof DropToteFromPickStationCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof DropToteFromPickStationCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface DropToteFromStowStationCommand
 */
export interface DropToteFromStowStationCommand {
    /**
     * 
     * @type {string}
     * @memberof DropToteFromStowStationCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof DropToteFromStowStationCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface DropToteToRasDropAddressCommand
 */
export interface DropToteToRasDropAddressCommand {
    /**
     * 
     * @type {number}
     * @memberof DropToteToRasDropAddressCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof DropToteToRasDropAddressCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof DropToteToRasDropAddressCommand
     */
    rasDropAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface DropToteToRasDropAddressForReplenishmentCommand
 */
export interface DropToteToRasDropAddressForReplenishmentCommand {
    /**
     * 
     * @type {number}
     * @memberof DropToteToRasDropAddressForReplenishmentCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof DropToteToRasDropAddressForReplenishmentCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof DropToteToRasDropAddressForReplenishmentCommand
     */
    rasDropAddressLabel?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum EdmContainerElementKind {
    None = 'None',
    EntitySet = 'EntitySet',
    ActionImport = 'ActionImport',
    FunctionImport = 'FunctionImport',
    Singleton = 'Singleton'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum EdmExpressionKind {
    None = 'None',
    BinaryConstant = 'BinaryConstant',
    BooleanConstant = 'BooleanConstant',
    DateTimeOffsetConstant = 'DateTimeOffsetConstant',
    DecimalConstant = 'DecimalConstant',
    FloatingConstant = 'FloatingConstant',
    GuidConstant = 'GuidConstant',
    IntegerConstant = 'IntegerConstant',
    StringConstant = 'StringConstant',
    DurationConstant = 'DurationConstant',
    Null = 'Null',
    Record = 'Record',
    Collection = 'Collection',
    Path = 'Path',
    If = 'If',
    Cast = 'Cast',
    IsType = 'IsType',
    FunctionApplication = 'FunctionApplication',
    LabeledExpressionReference = 'LabeledExpressionReference',
    Labeled = 'Labeled',
    PropertyPath = 'PropertyPath',
    NavigationPropertyPath = 'NavigationPropertyPath',
    DateConstant = 'DateConstant',
    TimeOfDayConstant = 'TimeOfDayConstant',
    EnumMember = 'EnumMember',
    AnnotationPath = 'AnnotationPath'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum EdmOnDeleteAction {
    None = 'None',
    Cascade = 'Cascade'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum EdmPropertyKind {
    None = 'None',
    Structural = 'Structural',
    Navigation = 'Navigation'
}

/**
 * 
 * @export
 * @interface EdmReferentialConstraintPropertyPair
 */
export interface EdmReferentialConstraintPropertyPair {
    /**
     * 
     * @type {IEdmStructuralProperty}
     * @memberof EdmReferentialConstraintPropertyPair
     */
    dependentProperty?: IEdmStructuralProperty;
    /**
     * 
     * @type {IEdmStructuralProperty}
     * @memberof EdmReferentialConstraintPropertyPair
     */
    principalProperty?: IEdmStructuralProperty;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum EdmSchemaElementKind {
    None = 'None',
    TypeDefinition = 'TypeDefinition',
    Term = 'Term',
    Action = 'Action',
    EntityContainer = 'EntityContainer',
    Function = 'Function'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum EdmTypeKind {
    None = 'None',
    Primitive = 'Primitive',
    Entity = 'Entity',
    Complex = 'Complex',
    Collection = 'Collection',
    EntityReference = 'EntityReference',
    Enum = 'Enum',
    TypeDefinition = 'TypeDefinition',
    Untyped = 'Untyped',
    Path = 'Path'
}

/**
 * 
 * @export
 * @interface EmailActionInputDTO
 */
export interface EmailActionInputDTO {
    /**
     * 
     * @type {string}
     * @memberof EmailActionInputDTO
     */
    to?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailActionInputDTO
     */
    cc?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailActionInputDTO
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailActionInputDTO
     */
    subject?: string;
}
/**
 * 
 * @export
 * @interface EnableCarrierCommand
 */
export interface EnableCarrierCommand {
    /**
     * 
     * @type {string}
     * @memberof EnableCarrierCommand
     */
    carrierName?: string;
}
/**
 * 
 * @export
 * @interface EnableProductExpirationDateCommand
 */
export interface EnableProductExpirationDateCommand {
    /**
     * 
     * @type {string}
     * @memberof EnableProductExpirationDateCommand
     */
    operationName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EnableProductExpirationDateCommand
     */
    skUs?: Array<string>;
}
/**
 * 
 * @export
 * @interface EnableProductExpirationDateOutputDTO
 */
export interface EnableProductExpirationDateOutputDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof EnableProductExpirationDateOutputDTO
     */
    updatedSKUs?: Array<string>;
}
/**
 * 
 * @export
 * @interface EnableProductLotNumberTrackingCommand
 */
export interface EnableProductLotNumberTrackingCommand {
    /**
     * 
     * @type {string}
     * @memberof EnableProductLotNumberTrackingCommand
     */
    operationName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EnableProductLotNumberTrackingCommand
     */
    skUs?: Array<string>;
}
/**
 * 
 * @export
 * @interface EnableProductLotNumberTrackingOutputDTO
 */
export interface EnableProductLotNumberTrackingOutputDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof EnableProductLotNumberTrackingOutputDTO
     */
    updatedSKUs?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ExcelExtensionType {
    Xlsx = 'XLSX',
    Csv = 'CSV'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ExpectedPickingItemState {
    None = 'None',
    Awaiting = 'Awaiting',
    Picked = 'Picked',
    CannotBePicked = 'CannotBePicked'
}

/**
 * 
 * @export
 * @interface FailedAddProductStockZoneOutputDTO
 */
export interface FailedAddProductStockZoneOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof FailedAddProductStockZoneOutputDTO
     */
    failedMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedAddProductStockZoneOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedAddProductStockZoneOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedAddProductStockZoneOutputDTO
     */
    sku?: string;
}
/**
 * 
 * @export
 * @interface FailedContainerInfo
 */
export interface FailedContainerInfo {
    /**
     * 
     * @type {string}
     * @memberof FailedContainerInfo
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedContainerInfo
     */
    reason?: string;
}
/**
 * 
 * @export
 * @interface FailedPickListDetail
 */
export interface FailedPickListDetail {
    /**
     * 
     * @type {string}
     * @memberof FailedPickListDetail
     */
    pickListId?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedPickListDetail
     */
    pickListName?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedPickListDetail
     */
    reason?: string;
}
/**
 * 
 * @export
 * @interface FailedSKUInfo
 */
export interface FailedSKUInfo {
    /**
     * 
     * @type {string}
     * @memberof FailedSKUInfo
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedSKUInfo
     */
    reason?: string;
}
/**
 * 
 * @export
 * @interface FailedTransferItemsOutputDTO
 */
export interface FailedTransferItemsOutputDTO {
    /**
     * 
     * @type {TransferFailReason}
     * @memberof FailedTransferItemsOutputDTO
     */
    failReason?: TransferFailReason;
    /**
     * 
     * @type {Array<TransferItemOutputDTO>}
     * @memberof FailedTransferItemsOutputDTO
     */
    items?: Array<TransferItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface FailedTransferToteItemsOutputDTO
 */
export interface FailedTransferToteItemsOutputDTO {
    /**
     * 
     * @type {TransferToteItemFailReason}
     * @memberof FailedTransferToteItemsOutputDTO
     */
    failReason?: TransferToteItemFailReason;
    /**
     * 
     * @type {Array<TransferItemOutputDTO>}
     * @memberof FailedTransferToteItemsOutputDTO
     */
    items?: Array<TransferItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface FailedTrolleyInfo
 */
export interface FailedTrolleyInfo {
    /**
     * 
     * @type {string}
     * @memberof FailedTrolleyInfo
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof FailedTrolleyInfo
     */
    reason?: string;
}
/**
 * 
 * @export
 * @interface Filter
 */
export interface Filter {
    /**
     * 
     * @type {string}
     * @memberof Filter
     */
    propertyName?: string;
    /**
     * 
     * @type {object}
     * @memberof Filter
     */
    value?: object;
    /**
     * 
     * @type {FilterOperation}
     * @memberof Filter
     */
    operator?: FilterOperation;
    /**
     * 
     * @type {boolean}
     * @memberof Filter
     */
    caseSensitive?: boolean;
    /**
     * 
     * @type {LogicalOperator}
     * @memberof Filter
     */
    logicalOperator?: LogicalOperator;
}
/**
 * 
 * @export
 * @interface FilterClause
 */
export interface FilterClause {
    /**
     * 
     * @type {SingleValueNode}
     * @memberof FilterClause
     */
    expression?: SingleValueNode;
    /**
     * 
     * @type {RangeVariable}
     * @memberof FilterClause
     */
    rangeVariable?: RangeVariable;
    /**
     * 
     * @type {IEdmTypeReference}
     * @memberof FilterClause
     */
    itemType?: IEdmTypeReference;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum FilterOperation {
    In = 'In',
    Equals = 'Equals',
    LessThan = 'LessThan',
    Contains = 'Contains',
    NotEqual = 'NotEqual',
    EndsWith = 'EndsWith',
    StartsWith = 'StartsWith',
    GreaterThan = 'GreaterThan',
    LessThanOrEqual = 'LessThanOrEqual',
    GreaterThanOrEqual = 'GreaterThanOrEqual',
    Any = 'Any',
    All = 'All'
}

/**
 * 
 * @export
 * @interface FilterQueryOption
 */
export interface FilterQueryOption {
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof FilterQueryOption
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {object}
     * @memberof FilterQueryOption
     */
    validator?: object;
    /**
     * 
     * @type {ComputeQueryOption}
     * @memberof FilterQueryOption
     */
    compute?: ComputeQueryOption;
    /**
     * 
     * @type {FilterClause}
     * @memberof FilterQueryOption
     */
    filterClause?: FilterClause;
    /**
     * 
     * @type {string}
     * @memberof FilterQueryOption
     */
    rawValue?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum FilterableFieldType {
    String = 'String',
    Number = 'Number',
    Boolean = 'Boolean',
    Object = 'Object',
    Date = 'Date',
    DateTime = 'DateTime'
}

/**
 * 
 * @export
 * @interface FinishWallToWallStockCountingPlanCommand
 */
export interface FinishWallToWallStockCountingPlanCommand {
    /**
     * 
     * @type {string}
     * @memberof FinishWallToWallStockCountingPlanCommand
     */
    stockCountingPlanId?: string;
}
/**
 * 
 * @export
 * @interface FixGhostAllocationsCommand
 */
export interface FixGhostAllocationsCommand {
    /**
     * 
     * @type {string}
     * @memberof FixGhostAllocationsCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof FixGhostAllocationsCommand
     */
    sku?: string;
}
/**
 * 
 * @export
 * @interface FixGhostAllocationsOutputDTO
 */
export interface FixGhostAllocationsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof FixGhostAllocationsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof FixGhostAllocationsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof FixGhostAllocationsOutputDTO
     */
    fixedItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof FixGhostAllocationsOutputDTO
     */
    skippedItemCount?: number;
    /**
     * 
     * @type {Array<FixedGhostAllocationDTO>}
     * @memberof FixGhostAllocationsOutputDTO
     */
    fixedItems?: Array<FixedGhostAllocationDTO>;
    /**
     * 
     * @type {Array<SkippedGhostAllocationDTO>}
     * @memberof FixGhostAllocationsOutputDTO
     */
    skippedItems?: Array<SkippedGhostAllocationDTO>;
}
/**
 * 
 * @export
 * @interface FixedGhostAllocationDTO
 */
export interface FixedGhostAllocationDTO {
    /**
     * 
     * @type {string}
     * @memberof FixedGhostAllocationDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof FixedGhostAllocationDTO
     */
    salesOrderState?: SalesOrderState;
    /**
     * 
     * @type {InventoryItemType}
     * @memberof FixedGhostAllocationDTO
     */
    fromItemType?: InventoryItemType;
    /**
     * 
     * @type {InventoryItemType}
     * @memberof FixedGhostAllocationDTO
     */
    toItemType?: InventoryItemType;
    /**
     * 
     * @type {string}
     * @memberof FixedGhostAllocationDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof FixedGhostAllocationDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface ForceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand
 */
export interface ForceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof ForceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand
     */
    placeTrolleyAddressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof ForceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface ForceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand
 */
export interface ForceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof ForceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand
     */
    placeTrolleyAddressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof ForceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface ForceCompletePutAwayCommand
 */
export interface ForceCompletePutAwayCommand {
    /**
     * 
     * @type {number}
     * @memberof ForceCompletePutAwayCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof ForceCompletePutAwayCommand
     */
    parkAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface ForceCompletePutAwayReleaseCommand
 */
export interface ForceCompletePutAwayReleaseCommand {
    /**
     * 
     * @type {number}
     * @memberof ForceCompletePutAwayReleaseCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof ForceCompletePutAwayReleaseCommand
     */
    parkAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface ForceCompleteStockCountingListCommand
 */
export interface ForceCompleteStockCountingListCommand {
    /**
     * 
     * @type {string}
     * @memberof ForceCompleteStockCountingListCommand
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {string}
     * @memberof ForceCompleteStockCountingListCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface ForceCompleteStockCountingListCommandOutputDTO
 */
export interface ForceCompleteStockCountingListCommandOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof ForceCompleteStockCountingListCommandOutputDTO
     */
    completedStockCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ForceCompleteStockCountingListCommandOutputDTO
     */
    totalStockCountingAmount?: number;
}
/**
 * 
 * @export
 * @interface ForceDeletePickListsCommand
 */
export interface ForceDeletePickListsCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof ForceDeletePickListsCommand
     */
    pickListIds?: Array<string>;
}
/**
 * 
 * @export
 * @interface ForceDeletePickListsOutputDTO
 */
export interface ForceDeletePickListsOutputDTO {
    /**
     * 
     * @type {Array<ForceDeletedPickListDetail>}
     * @memberof ForceDeletePickListsOutputDTO
     */
    deleted?: Array<ForceDeletedPickListDetail>;
    /**
     * 
     * @type {Array<ForceDeletedPickListDetail>}
     * @memberof ForceDeletePickListsOutputDTO
     */
    skipped?: Array<ForceDeletedPickListDetail>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ForceDeletePickListsOutputDTO
     */
    notFound?: Array<string>;
    /**
     * 
     * @type {Array<FailedPickListDetail>}
     * @memberof ForceDeletePickListsOutputDTO
     */
    failed?: Array<FailedPickListDetail>;
}
/**
 * 
 * @export
 * @interface ForceDeletedPickListDetail
 */
export interface ForceDeletedPickListDetail {
    /**
     * 
     * @type {string}
     * @memberof ForceDeletedPickListDetail
     */
    pickListId?: string;
    /**
     * 
     * @type {string}
     * @memberof ForceDeletedPickListDetail
     */
    pickListName?: string;
    /**
     * 
     * @type {PickListState}
     * @memberof ForceDeletedPickListDetail
     */
    state?: PickListState;
    /**
     * 
     * @type {number}
     * @memberof ForceDeletedPickListDetail
     */
    unassignedSalesOrderCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ForceDeletedPickListDetail
     */
    rolledBackInventoryItemCount?: number;
}
/**
 * 
 * @export
 * @interface ForceManualDeliveryCommand
 */
export interface ForceManualDeliveryCommand {
    /**
     * 
     * @type {string}
     * @memberof ForceManualDeliveryCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ForceManualDeliveryCommand
     */
    salesOrderReferenceNumber?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ForceTransferType {
    None = 'None',
    OnlyValidItems = 'OnlyValidItems',
    AllItems = 'AllItems'
}

/**
 * 
 * @export
 * @interface GetActiveStockCountingPlansOutputDTO
 */
export interface GetActiveStockCountingPlansOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetActiveStockCountingPlansOutputDTO
     */
    stockCountingPlanId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActiveStockCountingPlansOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActiveStockCountingPlansOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {StockCountingType}
     * @memberof GetActiveStockCountingPlansOutputDTO
     */
    stockCountingType?: StockCountingType;
}
/**
 * 
 * @export
 * @interface GetAllBatchPickingTotesDetails
 */
export interface GetAllBatchPickingTotesDetails {
    /**
     * 
     * @type {number}
     * @memberof GetAllBatchPickingTotesDetails
     */
    sortingProcessReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface GetBarcodeMismatchProblemDetailsOutputDTO
 */
export interface GetBarcodeMismatchProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetBarcodeMismatchProblemDetailsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBarcodeMismatchProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {ProblemState}
     * @memberof GetBarcodeMismatchProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {string}
     * @memberof GetBarcodeMismatchProblemDetailsOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBarcodeMismatchProblemDetailsOutputDTO
     */
    progressStartedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBarcodeMismatchProblemDetailsOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBarcodeMismatchProblemDetailsOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBarcodeMismatchProblemDetailsOutputDTO
     */
    resolutionNote?: string;
    /**
     * 
     * @type {InboundProblemSolutionType}
     * @memberof GetBarcodeMismatchProblemDetailsOutputDTO
     */
    solutionType?: InboundProblemSolutionType;
}
/**
 * 
 * @export
 * @interface GetBarcodeNotExistProblemDetailsOutputDTO
 */
export interface GetBarcodeNotExistProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetBarcodeNotExistProblemDetailsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBarcodeNotExistProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {ProblemState}
     * @memberof GetBarcodeNotExistProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {string}
     * @memberof GetBarcodeNotExistProblemDetailsOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBarcodeNotExistProblemDetailsOutputDTO
     */
    progressStartedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBarcodeNotExistProblemDetailsOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBarcodeNotExistProblemDetailsOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBarcodeNotExistProblemDetailsOutputDTO
     */
    resolutionNote?: string;
    /**
     * 
     * @type {InboundProblemSolutionType}
     * @memberof GetBarcodeNotExistProblemDetailsOutputDTO
     */
    solutionType?: InboundProblemSolutionType;
}
/**
 * 
 * @export
 * @interface GetBatchPickingToteDetails
 */
export interface GetBatchPickingToteDetails {
    /**
     * 
     * @type {number}
     * @memberof GetBatchPickingToteDetails
     */
    sortingProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof GetBatchPickingToteDetails
     */
    batchPickingToteLabel?: string;
}
/**
 * 
 * @export
 * @interface GetCargoCarrierPreferenceProblemDetailsOutputDTO
 */
export interface GetCargoCarrierPreferenceProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetCargoCarrierPreferenceProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {ProblemType}
     * @memberof GetCargoCarrierPreferenceProblemDetailsOutputDTO
     */
    type?: ProblemType;
    /**
     * 
     * @type {string}
     * @memberof GetCargoCarrierPreferenceProblemDetailsOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {ProblemSource}
     * @memberof GetCargoCarrierPreferenceProblemDetailsOutputDTO
     */
    source?: ProblemSource;
    /**
     * 
     * @type {ProblemState}
     * @memberof GetCargoCarrierPreferenceProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {string}
     * @memberof GetCargoCarrierPreferenceProblemDetailsOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCargoCarrierPreferenceProblemDetailsOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCargoCarrierPreferenceProblemDetailsOutputDTO
     */
    resolutionNote?: string;
}
/**
 * 
 * @export
 * @interface GetCargoCarrierQuotaProblemDetailsOutputDTO
 */
export interface GetCargoCarrierQuotaProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetCargoCarrierQuotaProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {ProblemType}
     * @memberof GetCargoCarrierQuotaProblemDetailsOutputDTO
     */
    type?: ProblemType;
    /**
     * 
     * @type {string}
     * @memberof GetCargoCarrierQuotaProblemDetailsOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {ProblemSource}
     * @memberof GetCargoCarrierQuotaProblemDetailsOutputDTO
     */
    source?: ProblemSource;
    /**
     * 
     * @type {ProblemState}
     * @memberof GetCargoCarrierQuotaProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {string}
     * @memberof GetCargoCarrierQuotaProblemDetailsOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCargoCarrierQuotaProblemDetailsOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCargoCarrierQuotaProblemDetailsOutputDTO
     */
    resolutionNote?: string;
}
/**
 * 
 * @export
 * @interface GetCargoCarriersQueryOutputDTO
 */
export interface GetCargoCarriersQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetCargoCarriersQueryOutputDTO
     */
    carrierId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCargoCarriersQueryOutputDTO
     */
    cargoCarrierName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCargoCarriersQueryOutputDTO
     */
    carrierImageUrl?: string;
}
/**
 * 
 * @export
 * @interface GetCargoPackageSLAMDetailsOutputDTO
 */
export interface GetCargoPackageSLAMDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetCargoPackageSLAMDetailsOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {SLAMTag}
     * @memberof GetCargoPackageSLAMDetailsOutputDTO
     */
    slamTag?: SLAMTag;
    /**
     * 
     * @type {SLAMUnitErrorCode}
     * @memberof GetCargoPackageSLAMDetailsOutputDTO
     */
    errorCode?: SLAMUnitErrorCode;
    /**
     * 
     * @type {string}
     * @memberof GetCargoPackageSLAMDetailsOutputDTO
     */
    operationLogoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCargoPackageSLAMDetailsOutputDTO
     */
    slamBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCargoPackageSLAMDetailsOutputDTO
     */
    orderRefNo?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCargoPackageSLAMDetailsOutputDTO
     */
    cargoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCargoPackageSLAMDetailsOutputDTO
     */
    dimension?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCargoPackageSLAMDetailsOutputDTO
     */
    scale?: number;
    /**
     * 
     * @type {string}
     * @memberof GetCargoPackageSLAMDetailsOutputDTO
     */
    oplogBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCargoPackageSLAMDetailsOutputDTO
     */
    packageQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof GetCargoPackageSLAMDetailsOutputDTO
     */
    orderPath?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCargoPackageSLAMDetailsOutputDTO
     */
    cargoName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCargoPackageSLAMDetailsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCargoPackageSLAMDetailsOutputDTO
     */
    fullAdress?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCargoPackageSLAMDetailsOutputDTO
     */
    packageIndex?: string;
}
/**
 * 
 * @export
 * @interface GetCellStockCountingTaskAddressDetails
 */
export interface GetCellStockCountingTaskAddressDetails {
    /**
     * 
     * @type {SortDirection}
     * @memberof GetCellStockCountingTaskAddressDetails
     */
    sortDirection?: SortDirection;
    /**
     * 
     * @type {StockCountingProcessSortType}
     * @memberof GetCellStockCountingTaskAddressDetails
     */
    sortType?: StockCountingProcessSortType;
}
/**
 * 
 * @export
 * @interface GetDamagedItemsProblemDetailsOutputDTO
 */
export interface GetDamagedItemsProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetDamagedItemsProblemDetailsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDamagedItemsProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {ProblemState}
     * @memberof GetDamagedItemsProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {string}
     * @memberof GetDamagedItemsProblemDetailsOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDamagedItemsProblemDetailsOutputDTO
     */
    progressStartedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDamagedItemsProblemDetailsOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDamagedItemsProblemDetailsOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDamagedItemsProblemDetailsOutputDTO
     */
    resolutionNote?: string;
    /**
     * 
     * @type {InboundProblemSolutionType}
     * @memberof GetDamagedItemsProblemDetailsOutputDTO
     */
    solutionType?: InboundProblemSolutionType;
}
/**
 * 
 * @export
 * @interface GetDetailLostItemProblemSalesOrderOutputDTO
 */
export interface GetDetailLostItemProblemSalesOrderOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetDetailLostItemProblemSalesOrderOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDetailLostItemProblemSalesOrderOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDetailLostItemProblemSalesOrderOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDetailLostItemProblemSalesOrderOutputDTO
     */
    salesOrderReferenceNo?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDetailLostItemProblemSalesOrderOutputDTO
     */
    problemReferenceNo?: string;
    /**
     * 
     * @type {ProductStockCountingProcessState}
     * @memberof GetDetailLostItemProblemSalesOrderOutputDTO
     */
    state?: ProductStockCountingProcessState;
    /**
     * 
     * @type {string}
     * @memberof GetDetailLostItemProblemSalesOrderOutputDTO
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof GetDetailLostItemProblemSalesOrderOutputDTO
     */
    lostItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetDetailLostItemProblemSalesOrderOutputDTO
     */
    totalItemAmount?: number;
    /**
     * 
     * @type {Array<SalesOrderLostItemOutputDTO>}
     * @memberof GetDetailLostItemProblemSalesOrderOutputDTO
     */
    lostItems?: Array<SalesOrderLostItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface GetDuplicateBarcodeProblemDetailsOutputDTO
 */
export interface GetDuplicateBarcodeProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetDuplicateBarcodeProblemDetailsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDuplicateBarcodeProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {ProblemState}
     * @memberof GetDuplicateBarcodeProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {string}
     * @memberof GetDuplicateBarcodeProblemDetailsOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDuplicateBarcodeProblemDetailsOutputDTO
     */
    progressStartedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDuplicateBarcodeProblemDetailsOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDuplicateBarcodeProblemDetailsOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDuplicateBarcodeProblemDetailsOutputDTO
     */
    resolutionNote?: string;
    /**
     * 
     * @type {InboundProblemSolutionType}
     * @memberof GetDuplicateBarcodeProblemDetailsOutputDTO
     */
    solutionType?: InboundProblemSolutionType;
}
/**
 * 
 * @export
 * @interface GetFloorNumberToCarryToteOutputDTO
 */
export interface GetFloorNumberToCarryToteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetFloorNumberToCarryToteOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof GetFloorNumberToCarryToteOutputDTO
     */
    floorNumber?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetFloorNumberToCarryToteOutputDTO
     */
    isReject?: boolean;
}
/**
 * 
 * @export
 * @interface GetHOVPickingTrolleyTotesOutputDTO
 */
export interface GetHOVPickingTrolleyTotesOutputDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetHOVPickingTrolleyTotesOutputDTO
     */
    toteLabels?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetInboundBoxDetailsOutputDTO
 */
export interface GetInboundBoxDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetInboundBoxDetailsOutputDTO
     */
    inboundBoxLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof GetInboundBoxDetailsOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof GetInboundBoxDetailsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetInboundBoxDetailsOutputDTO
     */
    waybillReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetInboundBoxDetailsOutputDTO
     */
    purchaseOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetInboundBoxDetailsOutputDTO
     */
    containerType?: string;
}
/**
 * 
 * @export
 * @interface GetInboundProblemDetailsOutputDTO
 */
export interface GetInboundProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    quarantineContainerId?: number;
    /**
     * 
     * @type {number}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    inboundBoxId?: number;
    /**
     * 
     * @type {string}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    quarantineContainerLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    quarantineContainerProblemCount?: number;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    waybill?: string;
    /**
     * 
     * @type {string}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    waybillImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    receivedAt?: string;
    /**
     * 
     * @type {ProblemState}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {string}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {InboundProblemType}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    type?: InboundProblemType;
    /**
     * 
     * @type {string}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    inboundBoxLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    itemAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    openedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof GetInboundProblemDetailsOutputDTO
     */
    barcodes?: string;
}
/**
 * 
 * @export
 * @interface GetInboundProblemsAnalyticsOutputDTO
 */
export interface GetInboundProblemsAnalyticsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof GetInboundProblemsAnalyticsOutputDTO
     */
    createdInboundProblemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetInboundProblemsAnalyticsOutputDTO
     */
    inProgressInboundProblemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetInboundProblemsAnalyticsOutputDTO
     */
    resolvedInboundProblemsCount?: number;
}
/**
 * 
 * @export
 * @interface GetInboundProblemsByQuarantineContainerOrInboundBoxOutputDTO
 */
export interface GetInboundProblemsByQuarantineContainerOrInboundBoxOutputDTO {
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof GetInboundProblemsByQuarantineContainerOrInboundBoxOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof GetInboundProblemsByQuarantineContainerOrInboundBoxOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof GetInboundProblemsByQuarantineContainerOrInboundBoxOutputDTO
     */
    waybill?: string;
    /**
     * 
     * @type {string}
     * @memberof GetInboundProblemsByQuarantineContainerOrInboundBoxOutputDTO
     */
    waybillImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof GetInboundProblemsByQuarantineContainerOrInboundBoxOutputDTO
     */
    receivedAt?: string;
    /**
     * 
     * @type {Array<InboundProblemListOutputDTO>}
     * @memberof GetInboundProblemsByQuarantineContainerOrInboundBoxOutputDTO
     */
    createdInboundProblems?: Array<InboundProblemListOutputDTO>;
    /**
     * 
     * @type {Array<InboundProblemListOutputDTO>}
     * @memberof GetInboundProblemsByQuarantineContainerOrInboundBoxOutputDTO
     */
    inProgressInboundProblems?: Array<InboundProblemListOutputDTO>;
    /**
     * 
     * @type {Array<InboundProblemListOutputDTO>}
     * @memberof GetInboundProblemsByQuarantineContainerOrInboundBoxOutputDTO
     */
    resolvedInboundProblems?: Array<InboundProblemListOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof GetInboundProblemsByQuarantineContainerOrInboundBoxOutputDTO
     */
    createdInboundProblemsCount?: number;
}
/**
 * 
 * @export
 * @interface GetIsPickingStockZoneInputActiveOutputDTO
 */
export interface GetIsPickingStockZoneInputActiveOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof GetIsPickingStockZoneInputActiveOutputDTO
     */
    isPickingStockZoneInputActive?: boolean;
}
/**
 * 
 * @export
 * @interface GetLostItemProblemDetailsOutputDTO
 */
export interface GetLostItemProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetLostItemProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {ProblemType}
     * @memberof GetLostItemProblemDetailsOutputDTO
     */
    type?: ProblemType;
    /**
     * 
     * @type {string}
     * @memberof GetLostItemProblemDetailsOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLostItemProblemDetailsOutputDTO
     */
    customerServicesReviewedAt?: string;
    /**
     * 
     * @type {ProblemSource}
     * @memberof GetLostItemProblemDetailsOutputDTO
     */
    source?: ProblemSource;
    /**
     * 
     * @type {ProblemState}
     * @memberof GetLostItemProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {ProblemDetailsLostItemProblemState}
     * @memberof GetLostItemProblemDetailsOutputDTO
     */
    lostItemProblemState?: ProblemDetailsLostItemProblemState;
    /**
     * 
     * @type {string}
     * @memberof GetLostItemProblemDetailsOutputDTO
     */
    reviewedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLostItemProblemDetailsOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLostItemProblemDetailsOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLostItemProblemDetailsOutputDTO
     */
    openedBy?: string;
    /**
     * 
     * @type {LostItemProblemSolutionType}
     * @memberof GetLostItemProblemDetailsOutputDTO
     */
    solutionType?: LostItemProblemSolutionType;
}
/**
 * 
 * @export
 * @interface GetLostItemProblemSalesOrdersOutputDTO
 */
export interface GetLostItemProblemSalesOrdersOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetLostItemProblemSalesOrdersOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLostItemProblemSalesOrdersOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLostItemProblemSalesOrdersOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLostItemProblemSalesOrdersOutputDTO
     */
    salesOrderReferenceNo?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLostItemProblemSalesOrdersOutputDTO
     */
    problemReferenceNo?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLostItemProblemSalesOrdersOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {ProductStockCountingProcessState}
     * @memberof GetLostItemProblemSalesOrdersOutputDTO
     */
    state?: ProductStockCountingProcessState;
    /**
     * 
     * @type {LostItemProblemSolutionType}
     * @memberof GetLostItemProblemSalesOrdersOutputDTO
     */
    solutionType?: LostItemProblemSolutionType;
}
/**
 * 
 * @export
 * @interface GetLostItemProblemSalesOrdersQuery
 */
export interface GetLostItemProblemSalesOrdersQuery {
    /**
     * 
     * @type {string}
     * @memberof GetLostItemProblemSalesOrdersQuery
     */
    filterText?: string;
    /**
     * 
     * @type {ProductStockCountingProcessState}
     * @memberof GetLostItemProblemSalesOrdersQuery
     */
    productStockCountingProcessState?: ProductStockCountingProcessState;
}
/**
 * 
 * @export
 * @interface GetMarketplaceCargoCarrierQuotaProblemDetailsOutputDTO
 */
export interface GetMarketplaceCargoCarrierQuotaProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetMarketplaceCargoCarrierQuotaProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {ProblemType}
     * @memberof GetMarketplaceCargoCarrierQuotaProblemDetailsOutputDTO
     */
    type?: ProblemType;
    /**
     * 
     * @type {string}
     * @memberof GetMarketplaceCargoCarrierQuotaProblemDetailsOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMarketplaceCargoCarrierQuotaProblemDetailsOutputDTO
     */
    customerServicesReviewedAt?: string;
    /**
     * 
     * @type {ProblemSource}
     * @memberof GetMarketplaceCargoCarrierQuotaProblemDetailsOutputDTO
     */
    source?: ProblemSource;
    /**
     * 
     * @type {ProblemState}
     * @memberof GetMarketplaceCargoCarrierQuotaProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {MarketplaceCargoCarrierQuotaProblemState}
     * @memberof GetMarketplaceCargoCarrierQuotaProblemDetailsOutputDTO
     */
    marketplaceCargoCarrierQuotaProblemState?: MarketplaceCargoCarrierQuotaProblemState;
    /**
     * 
     * @type {string}
     * @memberof GetMarketplaceCargoCarrierQuotaProblemDetailsOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMarketplaceCargoCarrierQuotaProblemDetailsOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMarketplaceCargoCarrierQuotaProblemDetailsOutputDTO
     */
    resolutionNote?: string;
}
/**
 * 
 * @export
 * @interface GetMasterCartonDetailsOutputDTO
 */
export interface GetMasterCartonDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    masterCartonName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    masterCartonImageURL?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    innerProductName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    innerProductSKU?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    innerProductBarcodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    masterCartonSKU?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    masterCartonBarcodes?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    innerProductAmount?: number;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    masterCartonWidth?: MeasurementDTO;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    masterCartonLength?: MeasurementDTO;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    masterCartonHeight?: MeasurementDTO;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    masterCartonWeight?: MeasurementDTO;
    /**
     * 
     * @type {string}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {ProductType}
     * @memberof GetMasterCartonDetailsOutputDTO
     */
    type?: ProductType;
}
/**
 * 
 * @export
 * @interface GetNextCellStockCounting
 */
export interface GetNextCellStockCounting {
    /**
     * 
     * @type {string}
     * @memberof GetNextCellStockCounting
     */
    stockCountingListId?: string;
}
/**
 * 
 * @export
 * @interface GetNextCellStockCountingOutputDTO
 */
export interface GetNextCellStockCountingOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetNextCellStockCountingOutputDTO
     */
    stockCountingId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNextCellStockCountingOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNextCellStockCountingOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof GetNextCellStockCountingOutputDTO
     */
    completedStockCountings?: number;
    /**
     * 
     * @type {number}
     * @memberof GetNextCellStockCountingOutputDTO
     */
    totalStockCountings?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetNextCellStockCountingOutputDTO
     */
    isCompleted?: boolean;
}
/**
 * 
 * @export
 * @interface GetNextCellTotalStockCountingOutputDTO
 */
export interface GetNextCellTotalStockCountingOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetNextCellTotalStockCountingOutputDTO
     */
    stockCountingId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNextCellTotalStockCountingOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNextCellTotalStockCountingOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof GetNextCellTotalStockCountingOutputDTO
     */
    completedStockCountings?: number;
    /**
     * 
     * @type {number}
     * @memberof GetNextCellTotalStockCountingOutputDTO
     */
    totalStockCountings?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetNextCellTotalStockCountingOutputDTO
     */
    isCompleted?: boolean;
}
/**
 * 
 * @export
 * @interface GetNextProductStockCountingOutputDTO
 */
export interface GetNextProductStockCountingOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetNextProductStockCountingOutputDTO
     */
    stockCountingId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNextProductStockCountingOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNextProductStockCountingOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNextProductStockCountingOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNextProductStockCountingOutputDTO
     */
    productSKU?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetNextProductStockCountingOutputDTO
     */
    productBarcodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetNextProductStockCountingOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNextProductStockCountingOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {number}
     * @memberof GetNextProductStockCountingOutputDTO
     */
    completedStockCountings?: number;
    /**
     * 
     * @type {number}
     * @memberof GetNextProductStockCountingOutputDTO
     */
    totalStockCountings?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetNextProductStockCountingOutputDTO
     */
    isCompleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetNextProductStockCountingOutputDTO
     */
    isTrackExpirationDate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetNextProductStockCountingOutputDTO
     */
    isTrackSerialNumber?: boolean;
}
/**
 * 
 * @export
 * @interface GetOngoingToteSingleItemPackingProcessOutputDTO
 */
export interface GetOngoingToteSingleItemPackingProcessOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof GetOngoingToteSingleItemPackingProcessOutputDTO
     */
    isOngoingProcessExists?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOngoingToteSingleItemPackingProcessOutputDTO
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface GetPendingCellStockCountingPlanDetailsOutputDTO
 */
export interface GetPendingCellStockCountingPlanDetailsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof GetPendingCellStockCountingPlanDetailsOutputDTO
     */
    totalProductAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPendingCellStockCountingPlanDetailsOutputDTO
     */
    totalCellAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPendingCellStockCountingPlanDetailsOutputDTO
     */
    totalZoneAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPendingCellStockCountingPlanDetailsOutputDTO
     */
    totalOperationAmount?: number;
}
/**
 * 
 * @export
 * @interface GetPendingItemStockCountingPlanDetailsOutputDTO
 */
export interface GetPendingItemStockCountingPlanDetailsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof GetPendingItemStockCountingPlanDetailsOutputDTO
     */
    totalProductAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPendingItemStockCountingPlanDetailsOutputDTO
     */
    totalCellAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPendingItemStockCountingPlanDetailsOutputDTO
     */
    totalZoneAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPendingItemStockCountingPlanDetailsOutputDTO
     */
    totalOperationAmount?: number;
}
/**
 * 
 * @export
 * @interface GetPickListDetailsBySalesOrderIdOutputDTO
 */
export interface GetPickListDetailsBySalesOrderIdOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetPickListDetailsBySalesOrderIdOutputDTO
     */
    pickListName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPickListDetailsBySalesOrderIdOutputDTO
     */
    pickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPickListDetailsBySalesOrderIdOutputDTO
     */
    pickingToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPickListDetailsBySalesOrderIdOutputDTO
     */
    pickingStartedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPickListDetailsBySalesOrderIdOutputDTO
     */
    pickingCompletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPickListDetailsBySalesOrderIdOutputDTO
     */
    batchName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPickListDetailsBySalesOrderIdOutputDTO
     */
    missingPickListName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPickListDetailsBySalesOrderIdOutputDTO
     */
    missingPickingToteLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPickListDetailsBySalesOrderIdOutputDTO
     */
    hasLostItemProblem?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPickListDetailsBySalesOrderIdOutputDTO
     */
    quarantineWallToteLabels?: string;
}
/**
 * 
 * @export
 * @interface GetPickingRouteElementsOutputDTO
 */
export interface GetPickingRouteElementsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetPickingRouteElementsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPickingRouteElementsOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPickingRouteElementsOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPickingRouteElementsOutputDTO
     */
    productImage?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPickingRouteElementsOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof GetPickingRouteElementsOutputDTO
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPickingRouteElementsOutputDTO
     */
    stockZone?: string;
    /**
     * 
     * @type {PickingRouteDirection}
     * @memberof GetPickingRouteElementsOutputDTO
     */
    direction?: PickingRouteDirection;
    /**
     * 
     * @type {PickingRouteElementState}
     * @memberof GetPickingRouteElementsOutputDTO
     */
    state?: PickingRouteElementState;
    /**
     * 
     * @type {boolean}
     * @memberof GetPickingRouteElementsOutputDTO
     */
    isTrackSerialNumber?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPickingRouteElementsOutputDTO
     */
    targetSerialNumber?: string;
}
/**
 * 
 * @export
 * @interface GetPickingTrolleyDetailsOutputDTO
 */
export interface GetPickingTrolleyDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetPickingTrolleyDetailsOutputDTO
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof GetPickingTrolleyDetailsOutputDTO
     */
    percentage?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPickingTrolleyDetailsOutputDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPickingTrolleyDetailsOutputDTO
     */
    lastSeenAt?: string;
    /**
     * 
     * @type {number}
     * @memberof GetPickingTrolleyDetailsOutputDTO
     */
    totalToteCount?: number;
}
/**
 * 
 * @export
 * @interface GetPrinterOutputDTO
 */
export interface GetPrinterOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetPrinterOutputDTO
     */
    printerName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPrinterOutputDTO
     */
    selectedPrinterName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPrinterOutputDTO
     */
    queueName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPrinterOutputDTO
     */
    machineName?: string;
}
/**
 * 
 * @export
 * @interface GetProductAddressDetailsOutputDTO
 */
export interface GetProductAddressDetailsOutputDTO {
    /**
     * 
     * @type {Array<ProductAddressDetailOutputDTO>}
     * @memberof GetProductAddressDetailsOutputDTO
     */
    primeCellDetails?: Array<ProductAddressDetailOutputDTO>;
    /**
     * 
     * @type {Array<ProductAddressDetailOutputDTO>}
     * @memberof GetProductAddressDetailsOutputDTO
     */
    reservedCellDetails?: Array<ProductAddressDetailOutputDTO>;
}
/**
 * 
 * @export
 * @interface GetPutAwayCellAddressForToteCommand
 */
export interface GetPutAwayCellAddressForToteCommand {
    /**
     * 
     * @type {number}
     * @memberof GetPutAwayCellAddressForToteCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPutAwayCellAddressForToteCommand
     */
    putAwayToteLabel?: string;
}
/**
 * 
 * @export
 * @interface GetPutAwayCellAddressForToteOutputDTO
 */
export interface GetPutAwayCellAddressForToteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetPutAwayCellAddressForToteOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPutAwayCellAddressForToteOutputDTO
     */
    productSku?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPutAwayCellAddressForToteOutputDTO
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPutAwayCellAddressForToteOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPutAwayCellAddressForToteOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPutAwayCellAddressForToteOutputDTO
     */
    stockCellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof GetPutAwayCellAddressForToteOutputDTO
     */
    itemCount?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPutAwayCellAddressForToteOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof GetPutAwayCellAddressForToteOutputDTO
     */
    totalItemCountInTote?: number;
}
/**
 * 
 * @export
 * @interface GetQuarantineToteDetailsForSingleItemReceivingOutputDTO
 */
export interface GetQuarantineToteDetailsForSingleItemReceivingOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetQuarantineToteDetailsForSingleItemReceivingOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof GetQuarantineToteDetailsForSingleItemReceivingOutputDTO
     */
    totalItemAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof GetQuarantineToteDetailsForSingleItemReceivingOutputDTO
     */
    containerType?: string;
    /**
     * 
     * @type {Array<SingleItemReceivingDamagedItemOutputDTO>}
     * @memberof GetQuarantineToteDetailsForSingleItemReceivingOutputDTO
     */
    damagedItems?: Array<SingleItemReceivingDamagedItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface GetReceivingContainerDetailsForSingleItemReceivingOutputDTO
 */
export interface GetReceivingContainerDetailsForSingleItemReceivingOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetReceivingContainerDetailsForSingleItemReceivingOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof GetReceivingContainerDetailsForSingleItemReceivingOutputDTO
     */
    totalItemAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof GetReceivingContainerDetailsForSingleItemReceivingOutputDTO
     */
    containerType?: string;
    /**
     * 
     * @type {Array<SingleItemReceivingReceivedItemOutputDTO>}
     * @memberof GetReceivingContainerDetailsForSingleItemReceivingOutputDTO
     */
    receivedItems?: Array<SingleItemReceivingReceivedItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface GetSalesOrderCargoPackagesByReferenceQuery
 */
export interface GetSalesOrderCargoPackagesByReferenceQuery {
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderCargoPackagesByReferenceQuery
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderCargoPackagesByReferenceQuery
     */
    referenceNumber?: string;
}
/**
 * 
 * @export
 * @interface GetSalesOrderDetailsForProblemOutputDTO
 */
export interface GetSalesOrderDetailsForProblemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderDetailsForProblemOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderDetailsForProblemOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderDetailsForProblemOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof GetSalesOrderDetailsForProblemOutputDTO
     */
    cargoPackagesCount?: number;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderDetailsForProblemOutputDTO
     */
    shippingCompany?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderDetailsForProblemOutputDTO
     */
    shippingCompanyImageUrl?: string;
    /**
     * 
     * @type {ShippingMethod}
     * @memberof GetSalesOrderDetailsForProblemOutputDTO
     */
    shippingMethod?: ShippingMethod;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderDetailsForProblemOutputDTO
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {ProblemType}
     * @memberof GetSalesOrderDetailsForProblemOutputDTO
     */
    type?: ProblemType;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderDetailsForProblemOutputDTO
     */
    source?: string;
    /**
     * 
     * @type {ProblemState}
     * @memberof GetSalesOrderDetailsForProblemOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderDetailsForProblemOutputDTO
     */
    openedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof GetSalesOrderDetailsForProblemOutputDTO
     */
    unresolvedProblemsCount?: number;
}
/**
 * 
 * @export
 * @interface GetSalesOrderDetailsOutputDTO
 */
export interface GetSalesOrderDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderDetailsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderDetailsOutputDTO
     */
    orderCreatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderDetailsOutputDTO
     */
    pickingCompletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderDetailsOutputDTO
     */
    packingCompletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderDetailsOutputDTO
     */
    dispatchCompletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderDetailsOutputDTO
     */
    deliveredAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrderDetailsOutputDTO
     */
    cancelledAt?: string;
}
/**
 * 
 * @export
 * @interface GetSalesOrdersWithPickListProblemsOutputDTO
 */
export interface GetSalesOrdersWithPickListProblemsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTO
     */
    lineItemCount?: number;
    /**
     * 
     * @type {ProblemType}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTO
     */
    problemType?: ProblemType;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTO
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {CutOffStatus}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTO
     */
    cutOffStatus?: CutOffStatus;
    /**
     * 
     * @type {SalesOrderPickingPriority}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTO
     */
    pickingPriority?: SalesOrderPickingPriority;
    /**
     * 
     * @type {SalesChannel}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTO
     */
    salesOrderCreatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTO
     */
    zoneLabel?: string;
}
/**
 * 
 * @export
 * @interface GetSalesOrdersWithPickListProblemsOutputDTODynamicQueryOutputDTO
 */
export interface GetSalesOrdersWithPickListProblemsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<GetSalesOrdersWithPickListProblemsOutputDTO>}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<GetSalesOrdersWithPickListProblemsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof GetSalesOrdersWithPickListProblemsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface GetSingleItemFastPackPickingTrolleyTotesOutputDTO
 */
export interface GetSingleItemFastPackPickingTrolleyTotesOutputDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSingleItemFastPackPickingTrolleyTotesOutputDTO
     */
    toteLabels?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetSingleItemPickingTrolleyTotesOutputDTO
 */
export interface GetSingleItemPickingTrolleyTotesOutputDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSingleItemPickingTrolleyTotesOutputDTO
     */
    toteLabels?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetSortingStationForCargoPackageOutputDTO
 */
export interface GetSortingStationForCargoPackageOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof GetSortingStationForCargoPackageOutputDTO
     */
    stationIndex?: number;
}
/**
 * 
 * @export
 * @interface GetStockCountingPlanDetailsOutputDTO
 */
export interface GetStockCountingPlanDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetStockCountingPlanDetailsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStockCountingPlanDetailsOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof GetStockCountingPlanDetailsOutputDTO
     */
    referenceNumber?: number;
    /**
     * 
     * @type {StockCountingType}
     * @memberof GetStockCountingPlanDetailsOutputDTO
     */
    stockCountingType?: StockCountingType;
    /**
     * 
     * @type {string}
     * @memberof GetStockCountingPlanDetailsOutputDTO
     */
    createdByFullName?: string;
    /**
     * 
     * @type {StockCountingPlanState}
     * @memberof GetStockCountingPlanDetailsOutputDTO
     */
    state?: StockCountingPlanState;
    /**
     * 
     * @type {number}
     * @memberof GetStockCountingPlanDetailsOutputDTO
     */
    totalBeforeStockCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockCountingPlanDetailsOutputDTO
     */
    totalAfterStockCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockCountingPlanDetailsOutputDTO
     */
    totalDifferenceInAmount?: number;
}
/**
 * 
 * @export
 * @interface GetStockZonePickListCapacityOutputDTO
 */
export interface GetStockZonePickListCapacityOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetStockZonePickListCapacityOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonePickListCapacityOutputDTO
     */
    multiItemPickListCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonePickListCapacityOutputDTO
     */
    multiItemPickListCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonePickListCapacityOutputDTO
     */
    multiItemPickListAwaiting?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonePickListCapacityOutputDTO
     */
    singleItemPickListCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonePickListCapacityOutputDTO
     */
    singleItemPickListCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonePickListCapacityOutputDTO
     */
    singleItemPickListAwaiting?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonePickListCapacityOutputDTO
     */
    hovPickListCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonePickListCapacityOutputDTO
     */
    hovPickListCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonePickListCapacityOutputDTO
     */
    hovPickListAwaiting?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonePickListCapacityOutputDTO
     */
    oversizePickListCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonePickListCapacityOutputDTO
     */
    oversizePickListCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonePickListCapacityOutputDTO
     */
    oversizePickListAwaiting?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonePickListCapacityOutputDTO
     */
    siocPickListCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonePickListCapacityOutputDTO
     */
    siocPickListCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonePickListCapacityOutputDTO
     */
    siocPickListAwaiting?: number;
}
/**
 * 
 * @export
 * @interface GetStockZonePickListCapacityOutputDTODynamicQueryOutputDTO
 */
export interface GetStockZonePickListCapacityOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<GetStockZonePickListCapacityOutputDTO>}
     * @memberof GetStockZonePickListCapacityOutputDTODynamicQueryOutputDTO
     */
    data?: Array<GetStockZonePickListCapacityOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonePickListCapacityOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface GetStockZonesOutputDTO
 */
export interface GetStockZonesOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof GetStockZonesOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof GetStockZonesOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStockZonesOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {ZoneType}
     * @memberof GetStockZonesOutputDTO
     */
    type?: ZoneType;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonesOutputDTO
     */
    priority?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonesOutputDTO
     */
    maxPickingCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonesOutputDTO
     */
    zoneAdressesCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonesOutputDTO
     */
    zoneProductsCount?: number;
}
/**
 * 
 * @export
 * @interface GetStockZonesOutputDTODynamicQueryOutputDTO
 */
export interface GetStockZonesOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<GetStockZonesOutputDTO>}
     * @memberof GetStockZonesOutputDTODynamicQueryOutputDTO
     */
    data?: Array<GetStockZonesOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof GetStockZonesOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface GetStorageAccountConnectionStringOutputDTO
 */
export interface GetStorageAccountConnectionStringOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetStorageAccountConnectionStringOutputDTO
     */
    storageAccountConnectionString?: string;
}
/**
 * 
 * @export
 * @interface GetTotesReadyToPackOutputDTO
 */
export interface GetTotesReadyToPackOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetTotesReadyToPackOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTotesReadyToPackOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof GetTotesReadyToPackOutputDTO
     */
    pickingFlowTag?: PickingFlowTag;
    /**
     * 
     * @type {number}
     * @memberof GetTotesReadyToPackOutputDTO
     */
    itemAmount?: number;
}
/**
 * 
 * @export
 * @interface GetTransferTrolleyTotesOutputDTO
 */
export interface GetTransferTrolleyTotesOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof GetTransferTrolleyTotesOutputDTO
     */
    toteId?: number;
    /**
     * 
     * @type {string}
     * @memberof GetTransferTrolleyTotesOutputDTO
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface GetTrolleyToteOutputDTO
 */
export interface GetTrolleyToteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetTrolleyToteOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof GetTrolleyToteOutputDTO
     */
    productAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTrolleyToteOutputDTO
     */
    productVariety?: number;
    /**
     * 
     * @type {ToteStatus}
     * @memberof GetTrolleyToteOutputDTO
     */
    status?: ToteStatus;
    /**
     * 
     * @type {string}
     * @memberof GetTrolleyToteOutputDTO
     */
    lastSeenAt?: string;
}
/**
 * 
 * @export
 * @interface GetTrolleyTotesResponseDTO
 */
export interface GetTrolleyTotesResponseDTO {
    /**
     * 
     * @type {Array<GetTrolleyToteOutputDTO>}
     * @memberof GetTrolleyTotesResponseDTO
     */
    totes?: Array<GetTrolleyToteOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof GetTrolleyTotesResponseDTO
     */
    waitingToLoadCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTrolleyTotesResponseDTO
     */
    waitingForPickingListCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrolleyTotesResponseDTO
     */
    pickListNames?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetUndefinedZoneProductsOutputDTO
 */
export interface GetUndefinedZoneProductsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetUndefinedZoneProductsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUndefinedZoneProductsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUndefinedZoneProductsOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetUndefinedZoneProductsOutputDTO
     */
    barcodes?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetUndefinedZoneProductsOutputDTODynamicQueryOutputDTO
 */
export interface GetUndefinedZoneProductsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<GetUndefinedZoneProductsOutputDTO>}
     * @memberof GetUndefinedZoneProductsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<GetUndefinedZoneProductsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof GetUndefinedZoneProductsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface GetUnidentifiedProductProblemDetailsOutputDTO
 */
export interface GetUnidentifiedProductProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetUnidentifiedProductProblemDetailsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUnidentifiedProductProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {ProblemState}
     * @memberof GetUnidentifiedProductProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {string}
     * @memberof GetUnidentifiedProductProblemDetailsOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUnidentifiedProductProblemDetailsOutputDTO
     */
    progressStartedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUnidentifiedProductProblemDetailsOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUnidentifiedProductProblemDetailsOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUnidentifiedProductProblemDetailsOutputDTO
     */
    resolutionNote?: string;
    /**
     * 
     * @type {InboundProblemSolutionType}
     * @memberof GetUnidentifiedProductProblemDetailsOutputDTO
     */
    solutionType?: InboundProblemSolutionType;
}
/**
 * 
 * @export
 * @interface GetUnreadableBarcodeProblemDetailsOutputDTO
 */
export interface GetUnreadableBarcodeProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetUnreadableBarcodeProblemDetailsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUnreadableBarcodeProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {ProblemState}
     * @memberof GetUnreadableBarcodeProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {string}
     * @memberof GetUnreadableBarcodeProblemDetailsOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUnreadableBarcodeProblemDetailsOutputDTO
     */
    progressStartedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUnreadableBarcodeProblemDetailsOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUnreadableBarcodeProblemDetailsOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUnreadableBarcodeProblemDetailsOutputDTO
     */
    resolutionNote?: string;
    /**
     * 
     * @type {InboundProblemSolutionType}
     * @memberof GetUnreadableBarcodeProblemDetailsOutputDTO
     */
    solutionType?: InboundProblemSolutionType;
}
/**
 * 
 * @export
 * @interface GetWaybillsQueryOutputDTO
 */
export interface GetWaybillsQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetWaybillsQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetWaybillsQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetWaybillsQueryOutputDTO
     */
    waybillCreatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetWaybillsQueryOutputDTO
     */
    operationDateTime?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetWaybillsQueryOutputDTO
     */
    waybillImageUrls?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetWaybillsQueryOutputDTO
     */
    documentImageURL?: string;
    /**
     * 
     * @type {number}
     * @memberof GetWaybillsQueryOutputDTO
     */
    inboundBoxCount?: number;
    /**
     * 
     * @type {string}
     * @memberof GetWaybillsQueryOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetWaybillsQueryOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetWaybillsQueryOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof GetWaybillsQueryOutputDTO
     */
    supplierCompany?: string;
    /**
     * 
     * @type {PurchaseOrderSource}
     * @memberof GetWaybillsQueryOutputDTO
     */
    purchaseOrderSource?: PurchaseOrderSource;
    /**
     * 
     * @type {string}
     * @memberof GetWaybillsQueryOutputDTO
     */
    purchaseOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetWaybillsQueryOutputDTO
     */
    purchaseOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetWaybillsQueryOutputDTO
     */
    expectedDeliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof GetWaybillsQueryOutputDTO
     */
    targetedRecivingCompletionDateTime?: string;
    /**
     * 
     * @type {ReceivingState}
     * @memberof GetWaybillsQueryOutputDTO
     */
    state?: ReceivingState;
    /**
     * 
     * @type {number}
     * @memberof GetWaybillsQueryOutputDTO
     */
    inventoryItemCount?: number;
    /**
     * 
     * @type {string}
     * @memberof GetWaybillsQueryOutputDTO
     */
    operatorFullName?: string;
    /**
     * 
     * @type {number}
     * @memberof GetWaybillsQueryOutputDTO
     */
    palletCount?: number;
}
/**
 * 
 * @export
 * @interface GetWaybillsQueryOutputDTODynamicQueryOutputDTO
 */
export interface GetWaybillsQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<GetWaybillsQueryOutputDTO>}
     * @memberof GetWaybillsQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<GetWaybillsQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof GetWaybillsQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface GetZoneAdressesOutputDTO
 */
export interface GetZoneAdressesOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof GetZoneAdressesOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {number}
     * @memberof GetZoneAdressesOutputDTO
     */
    cellId?: number;
    /**
     * 
     * @type {string}
     * @memberof GetZoneAdressesOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZoneAdressesOutputDTO
     */
    labelFormat?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZoneAdressesOutputDTO
     */
    containedIn?: string;
    /**
     * 
     * @type {AddressType}
     * @memberof GetZoneAdressesOutputDTO
     */
    addressType?: AddressType;
    /**
     * 
     * @type {string}
     * @memberof GetZoneAdressesOutputDTO
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZoneAdressesOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface GetZoneAdressesOutputDTODynamicQueryOutputDTO
 */
export interface GetZoneAdressesOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<GetZoneAdressesOutputDTO>}
     * @memberof GetZoneAdressesOutputDTODynamicQueryOutputDTO
     */
    data?: Array<GetZoneAdressesOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof GetZoneAdressesOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface GetZoneByCellLabelOutputDTO
 */
export interface GetZoneByCellLabelOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof GetZoneByCellLabelOutputDTO
     */
    zoneLabel?: string;
}
/**
 * 
 * @export
 * @interface GetZoneProductsOutputDTO
 */
export interface GetZoneProductsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof GetZoneProductsOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof GetZoneProductsOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZoneProductsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZoneProductsOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZoneProductsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetZoneProductsOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetZoneProductsOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZoneProductsOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {ProductType}
     * @memberof GetZoneProductsOutputDTO
     */
    type?: ProductType;
    /**
     * 
     * @type {string}
     * @memberof GetZoneProductsOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface GetZoneProductsOutputDTODynamicQueryOutputDTO
 */
export interface GetZoneProductsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<GetZoneProductsOutputDTO>}
     * @memberof GetZoneProductsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<GetZoneProductsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof GetZoneProductsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface HOVCargoPackageInputDTO
 */
export interface HOVCargoPackageInputDTO {
    /**
     * 
     * @type {string}
     * @memberof HOVCargoPackageInputDTO
     */
    cargoPackageTypeBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof HOVCargoPackageInputDTO
     */
    cargoPackageIndex?: number;
    /**
     * 
     * @type {Array<HOVPackingItemInputDTO>}
     * @memberof HOVCargoPackageInputDTO
     */
    packingItems?: Array<HOVPackingItemInputDTO>;
}
/**
 * 
 * @export
 * @interface HOVCargoPackageTypeOutputDTO
 */
export interface HOVCargoPackageTypeOutputDTO {
    /**
     * 
     * @type {PackageType}
     * @memberof HOVCargoPackageTypeOutputDTO
     */
    type?: PackageType;
    /**
     * 
     * @type {number}
     * @memberof HOVCargoPackageTypeOutputDTO
     */
    volumetricWeight?: number;
    /**
     * 
     * @type {string}
     * @memberof HOVCargoPackageTypeOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof HOVCargoPackageTypeOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HOVCargoPackageTypeOutputDTO
     */
    isDisabled?: boolean;
}
/**
 * 
 * @export
 * @interface HOVOwnContainerCargoPackageTypeOutputDTO
 */
export interface HOVOwnContainerCargoPackageTypeOutputDTO {
    /**
     * 
     * @type {PackageType}
     * @memberof HOVOwnContainerCargoPackageTypeOutputDTO
     */
    type?: PackageType;
    /**
     * 
     * @type {number}
     * @memberof HOVOwnContainerCargoPackageTypeOutputDTO
     */
    volumetricWeight?: number;
    /**
     * 
     * @type {string}
     * @memberof HOVOwnContainerCargoPackageTypeOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof HOVOwnContainerCargoPackageTypeOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HOVOwnContainerCargoPackageTypeOutputDTO
     */
    isDisabled?: boolean;
}
/**
 * 
 * @export
 * @interface HOVPackingItemInputDTO
 */
export interface HOVPackingItemInputDTO {
    /**
     * 
     * @type {string}
     * @memberof HOVPackingItemInputDTO
     */
    productId?: string;
    /**
     * 
     * @type {number}
     * @memberof HOVPackingItemInputDTO
     */
    amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof HOVPackingItemInputDTO
     */
    serialNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface HOVPickingItemByProductOutputDTO
 */
export interface HOVPickingItemByProductOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof HOVPickingItemByProductOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof HOVPickingItemByProductOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof HOVPickingItemByProductOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof HOVPickingItemByProductOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof HOVPickingItemByProductOutputDTO
     */
    amountInOrder?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof HOVPickingItemByProductOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {Array<MasterCartonDefinitionOutputDTO>}
     * @memberof HOVPickingItemByProductOutputDTO
     */
    masterCartonDefinitions?: Array<MasterCartonDefinitionOutputDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof HOVPickingItemByProductOutputDTO
     */
    isTrackSerialNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HOVPickingItemByProductOutputDTO
     */
    isTrackSimpleSerialNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HOVPickingItemByProductOutputDTO
     */
    isCreatedWithSerialNumber?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof HOVPickingItemByProductOutputDTO
     */
    serialNumbers?: Array<string>;
    /**
     * 
     * @type {HOVProductTagsOutputDTO}
     * @memberof HOVPickingItemByProductOutputDTO
     */
    productTags?: HOVProductTagsOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof HOVPickingItemByProductOutputDTO
     */
    weightInGrams?: number;
}
/**
 * 
 * @export
 * @interface HOVPrintSLAMDocumentsOnPackingCommand
 */
export interface HOVPrintSLAMDocumentsOnPackingCommand {
    /**
     * 
     * @type {string}
     * @memberof HOVPrintSLAMDocumentsOnPackingCommand
     */
    pickingToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof HOVPrintSLAMDocumentsOnPackingCommand
     */
    hovPackingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface HOVPrintSLAMDocumentsOnPackingOutputDTO
 */
export interface HOVPrintSLAMDocumentsOnPackingOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof HOVPrintSLAMDocumentsOnPackingOutputDTO
     */
    isSuspended?: boolean;
}
/**
 * 
 * @export
 * @interface HOVPrintVASCommand
 */
export interface HOVPrintVASCommand {
    /**
     * 
     * @type {string}
     * @memberof HOVPrintVASCommand
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof HOVPrintVASCommand
     */
    hovPackingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface HOVProcessedVASItemsOutputDTO
 */
export interface HOVProcessedVASItemsOutputDTO {
    /**
     * 
     * @type {OutputVASType}
     * @memberof HOVProcessedVASItemsOutputDTO
     */
    vasType?: OutputVASType;
    /**
     * 
     * @type {string}
     * @memberof HOVProcessedVASItemsOutputDTO
     */
    barcode?: string;
}
/**
 * 
 * @export
 * @interface HOVProductTagsOutputDTO
 */
export interface HOVProductTagsOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof HOVProductTagsOutputDTO
     */
    isPourable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HOVProductTagsOutputDTO
     */
    isFragile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HOVProductTagsOutputDTO
     */
    isBattery?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HOVProductTagsOutputDTO
     */
    isFood?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HOVProductTagsOutputDTO
     */
    isChemical?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HOVProductTagsOutputDTO
     */
    isSharp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HOVProductTagsOutputDTO
     */
    isValuable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HOVProductTagsOutputDTO
     */
    isAdult?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HOVProductTagsOutputDTO
     */
    isQualityControlNeeded?: boolean;
}
/**
 * 
 * @export
 * @interface HOVQuarantineItemInputDTO
 */
export interface HOVQuarantineItemInputDTO {
    /**
     * 
     * @type {string}
     * @memberof HOVQuarantineItemInputDTO
     */
    productId?: string;
    /**
     * 
     * @type {number}
     * @memberof HOVQuarantineItemInputDTO
     */
    amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof HOVQuarantineItemInputDTO
     */
    serialNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface HOVQuarantineToteInputDTO
 */
export interface HOVQuarantineToteInputDTO {
    /**
     * 
     * @type {string}
     * @memberof HOVQuarantineToteInputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {Array<HOVQuarantineItemInputDTO>}
     * @memberof HOVQuarantineToteInputDTO
     */
    quarantineItems?: Array<HOVQuarantineItemInputDTO>;
}
/**
 * 
 * @export
 * @interface HOVQueuedQuarantineToteOutputDTO
 */
export interface HOVQueuedQuarantineToteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof HOVQueuedQuarantineToteOutputDTO
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {Array<PackingBoxHOVItemOutputDTO>}
     * @memberof HOVQueuedQuarantineToteOutputDTO
     */
    boxItems?: Array<PackingBoxHOVItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface HOVSalesOrderLineItemOutputDTO
 */
export interface HOVSalesOrderLineItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof HOVSalesOrderLineItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof HOVSalesOrderLineItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof HOVSalesOrderLineItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof HOVSalesOrderLineItemOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof HOVSalesOrderLineItemOutputDTO
     */
    amountInOrder?: number;
    /**
     * 
     * @type {string}
     * @memberof HOVSalesOrderLineItemOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {ReturnLineItemState}
     * @memberof HOVSalesOrderLineItemOutputDTO
     */
    returnState?: ReturnLineItemState;
    /**
     * 
     * @type {boolean}
     * @memberof HOVSalesOrderLineItemOutputDTO
     */
    isCreatedWithSerialNumber?: boolean;
    /**
     * 
     * @type {HOVProductTagsOutputDTO}
     * @memberof HOVSalesOrderLineItemOutputDTO
     */
    productTags?: HOVProductTagsOutputDTO;
}
/**
 * 
 * @export
 * @interface HOVSalesOrderStateOutputDTO
 */
export interface HOVSalesOrderStateOutputDTO {
    /**
     * 
     * @type {SalesOrderStateForPacking}
     * @memberof HOVSalesOrderStateOutputDTO
     */
    state?: SalesOrderStateForPacking;
    /**
     * 
     * @type {boolean}
     * @memberof HOVSalesOrderStateOutputDTO
     */
    missingPackingApproved?: boolean;
}
/**
 * 
 * @export
 * @interface HOVVASOutputDTO
 */
export interface HOVVASOutputDTO {
    /**
     * 
     * @type {OutputVASType}
     * @memberof HOVVASOutputDTO
     */
    vasType?: OutputVASType;
    /**
     * 
     * @type {string}
     * @memberof HOVVASOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof HOVVASOutputDTO
     */
    info?: string;
}
/**
 * 
 * @export
 * @interface HostString
 */
export interface HostString {
    /**
     * 
     * @type {string}
     * @memberof HostString
     */
    value?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HostString
     */
    hasValue?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HostString
     */
    host?: string;
    /**
     * 
     * @type {number}
     * @memberof HostString
     */
    port?: number;
}
/**
 * 
 * @export
 * @interface HttpContext
 */
export interface HttpContext {
    /**
     * 
     * @type {Array<TypeObjectKeyValuePair>}
     * @memberof HttpContext
     */
    features?: Array<TypeObjectKeyValuePair>;
    /**
     * 
     * @type {HttpRequest}
     * @memberof HttpContext
     */
    request?: HttpRequest;
    /**
     * 
     * @type {HttpResponse}
     * @memberof HttpContext
     */
    response?: HttpResponse;
    /**
     * 
     * @type {ConnectionInfo}
     * @memberof HttpContext
     */
    connection?: ConnectionInfo;
    /**
     * 
     * @type {WebSocketManager}
     * @memberof HttpContext
     */
    webSockets?: WebSocketManager;
    /**
     * 
     * @type {ClaimsPrincipal}
     * @memberof HttpContext
     */
    user?: ClaimsPrincipal;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof HttpContext
     */
    items?: { [key: string]: object; };
    /**
     * 
     * @type {object}
     * @memberof HttpContext
     */
    requestServices?: object;
    /**
     * 
     * @type {CancellationToken}
     * @memberof HttpContext
     */
    requestAborted?: CancellationToken;
    /**
     * 
     * @type {string}
     * @memberof HttpContext
     */
    traceIdentifier?: string;
    /**
     * 
     * @type {ISession}
     * @memberof HttpContext
     */
    session?: ISession;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum HttpMethod {
    None = 'NONE',
    Get = 'GET',
    Post = 'POST',
    Put = 'PUT',
    Delete = 'DELETE',
    Head = 'HEAD',
    Options = 'OPTIONS'
}

/**
 * 
 * @export
 * @interface HttpRequest
 */
export interface HttpRequest {
    /**
     * 
     * @type {HttpContext}
     * @memberof HttpRequest
     */
    httpContext?: HttpContext;
    /**
     * 
     * @type {string}
     * @memberof HttpRequest
     */
    method?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpRequest
     */
    scheme?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HttpRequest
     */
    isHttps?: boolean;
    /**
     * 
     * @type {HostString}
     * @memberof HttpRequest
     */
    host?: HostString;
    /**
     * 
     * @type {string}
     * @memberof HttpRequest
     */
    pathBase?: string;
    /**
     * 
     * @type {string}
     * @memberof HttpRequest
     */
    path?: string;
    /**
     * 
     * @type {QueryString}
     * @memberof HttpRequest
     */
    queryString?: QueryString;
    /**
     * 
     * @type {Array<StringStringValuesKeyValuePair>}
     * @memberof HttpRequest
     */
    query?: Array<StringStringValuesKeyValuePair>;
    /**
     * 
     * @type {string}
     * @memberof HttpRequest
     */
    protocol?: string;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof HttpRequest
     */
    headers?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<StringStringKeyValuePair>}
     * @memberof HttpRequest
     */
    cookies?: Array<StringStringKeyValuePair>;
    /**
     * 
     * @type {number}
     * @memberof HttpRequest
     */
    contentLength?: number;
    /**
     * 
     * @type {string}
     * @memberof HttpRequest
     */
    contentType?: string;
    /**
     * 
     * @type {Stream}
     * @memberof HttpRequest
     */
    body?: Stream;
    /**
     * 
     * @type {object}
     * @memberof HttpRequest
     */
    bodyReader?: object;
    /**
     * 
     * @type {boolean}
     * @memberof HttpRequest
     */
    hasFormContentType?: boolean;
    /**
     * 
     * @type {Array<StringStringValuesKeyValuePair>}
     * @memberof HttpRequest
     */
    form?: Array<StringStringValuesKeyValuePair>;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof HttpRequest
     */
    routeValues?: { [key: string]: object; };
}
/**
 * 
 * @export
 * @interface HttpResponse
 */
export interface HttpResponse {
    /**
     * 
     * @type {HttpContext}
     * @memberof HttpResponse
     */
    httpContext?: HttpContext;
    /**
     * 
     * @type {number}
     * @memberof HttpResponse
     */
    statusCode?: number;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof HttpResponse
     */
    headers?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Stream}
     * @memberof HttpResponse
     */
    body?: Stream;
    /**
     * 
     * @type {PipeWriter}
     * @memberof HttpResponse
     */
    bodyWriter?: PipeWriter;
    /**
     * 
     * @type {number}
     * @memberof HttpResponse
     */
    contentLength?: number;
    /**
     * 
     * @type {string}
     * @memberof HttpResponse
     */
    contentType?: string;
    /**
     * 
     * @type {object}
     * @memberof HttpResponse
     */
    cookies?: object;
    /**
     * 
     * @type {boolean}
     * @memberof HttpResponse
     */
    hasStarted?: boolean;
}
/**
 * 
 * @export
 * @interface IEdmEntityContainer
 */
export interface IEdmEntityContainer {
    /**
     * 
     * @type {Array<IEdmEntityContainerElement>}
     * @memberof IEdmEntityContainer
     */
    elements?: Array<IEdmEntityContainerElement>;
    /**
     * 
     * @type {EdmSchemaElementKind}
     * @memberof IEdmEntityContainer
     */
    schemaElementKind?: EdmSchemaElementKind;
    /**
     * 
     * @type {string}
     * @memberof IEdmEntityContainer
     */
    namespace?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IEdmEntityContainer
     */
    name?: string | null;
}
/**
 * 
 * @export
 * @interface IEdmEntityContainerElement
 */
export interface IEdmEntityContainerElement {
    /**
     * 
     * @type {EdmContainerElementKind}
     * @memberof IEdmEntityContainerElement
     */
    containerElementKind?: EdmContainerElementKind;
    /**
     * 
     * @type {IEdmEntityContainer}
     * @memberof IEdmEntityContainerElement
     */
    container?: IEdmEntityContainer;
    /**
     * 
     * @type {string}
     * @memberof IEdmEntityContainerElement
     */
    name?: string | null;
}
/**
 * 
 * @export
 * @interface IEdmExpression
 */
export interface IEdmExpression {
    /**
     * 
     * @type {EdmExpressionKind}
     * @memberof IEdmExpression
     */
    expressionKind?: EdmExpressionKind;
}
/**
 * 
 * @export
 * @interface IEdmModel
 */
export interface IEdmModel {
    /**
     * 
     * @type {Array<IEdmSchemaElement>}
     * @memberof IEdmModel
     */
    schemaElements?: Array<IEdmSchemaElement>;
    /**
     * 
     * @type {Array<IEdmVocabularyAnnotation>}
     * @memberof IEdmModel
     */
    vocabularyAnnotations?: Array<IEdmVocabularyAnnotation>;
    /**
     * 
     * @type {Array<IEdmModel>}
     * @memberof IEdmModel
     */
    referencedModels?: Array<IEdmModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IEdmModel
     */
    declaredNamespaces?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof IEdmModel
     */
    directValueAnnotationsManager?: object;
    /**
     * 
     * @type {IEdmEntityContainer}
     * @memberof IEdmModel
     */
    entityContainer?: IEdmEntityContainer;
}
/**
 * 
 * @export
 * @interface IEdmNavigationProperty
 */
export interface IEdmNavigationProperty {
    /**
     * 
     * @type {IEdmNavigationProperty}
     * @memberof IEdmNavigationProperty
     */
    partner?: IEdmNavigationProperty;
    /**
     * 
     * @type {EdmOnDeleteAction}
     * @memberof IEdmNavigationProperty
     */
    onDelete?: EdmOnDeleteAction;
    /**
     * 
     * @type {boolean}
     * @memberof IEdmNavigationProperty
     */
    containsTarget?: boolean;
    /**
     * 
     * @type {IEdmReferentialConstraint}
     * @memberof IEdmNavigationProperty
     */
    referentialConstraint?: IEdmReferentialConstraint;
    /**
     * 
     * @type {EdmPropertyKind}
     * @memberof IEdmNavigationProperty
     */
    propertyKind?: EdmPropertyKind;
    /**
     * 
     * @type {IEdmTypeReference}
     * @memberof IEdmNavigationProperty
     */
    type?: IEdmTypeReference;
    /**
     * 
     * @type {IEdmStructuredType}
     * @memberof IEdmNavigationProperty
     */
    declaringType?: IEdmStructuredType;
    /**
     * 
     * @type {string}
     * @memberof IEdmNavigationProperty
     */
    name?: string | null;
}
/**
 * 
 * @export
 * @interface IEdmNavigationPropertyBinding
 */
export interface IEdmNavigationPropertyBinding {
    /**
     * 
     * @type {IEdmNavigationProperty}
     * @memberof IEdmNavigationPropertyBinding
     */
    navigationProperty?: IEdmNavigationProperty;
    /**
     * 
     * @type {IEdmNavigationSource}
     * @memberof IEdmNavigationPropertyBinding
     */
    target?: IEdmNavigationSource;
    /**
     * 
     * @type {IEdmPathExpression}
     * @memberof IEdmNavigationPropertyBinding
     */
    path?: IEdmPathExpression;
}
/**
 * 
 * @export
 * @interface IEdmNavigationSource
 */
export interface IEdmNavigationSource {
    /**
     * 
     * @type {Array<IEdmNavigationPropertyBinding>}
     * @memberof IEdmNavigationSource
     */
    navigationPropertyBindings?: Array<IEdmNavigationPropertyBinding>;
    /**
     * 
     * @type {IEdmPathExpression}
     * @memberof IEdmNavigationSource
     */
    path?: IEdmPathExpression;
    /**
     * 
     * @type {IEdmType}
     * @memberof IEdmNavigationSource
     */
    type?: IEdmType;
    /**
     * 
     * @type {string}
     * @memberof IEdmNavigationSource
     */
    name?: string | null;
}
/**
 * 
 * @export
 * @interface IEdmPathExpression
 */
export interface IEdmPathExpression {
    /**
     * 
     * @type {Array<string>}
     * @memberof IEdmPathExpression
     */
    pathSegments?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof IEdmPathExpression
     */
    path?: string;
    /**
     * 
     * @type {EdmExpressionKind}
     * @memberof IEdmPathExpression
     */
    expressionKind?: EdmExpressionKind;
}
/**
 * 
 * @export
 * @interface IEdmProperty
 */
export interface IEdmProperty {
    /**
     * 
     * @type {EdmPropertyKind}
     * @memberof IEdmProperty
     */
    propertyKind?: EdmPropertyKind;
    /**
     * 
     * @type {IEdmTypeReference}
     * @memberof IEdmProperty
     */
    type?: IEdmTypeReference;
    /**
     * 
     * @type {IEdmStructuredType}
     * @memberof IEdmProperty
     */
    declaringType?: IEdmStructuredType;
    /**
     * 
     * @type {string}
     * @memberof IEdmProperty
     */
    name?: string | null;
}
/**
 * 
 * @export
 * @interface IEdmReferentialConstraint
 */
export interface IEdmReferentialConstraint {
    /**
     * 
     * @type {Array<EdmReferentialConstraintPropertyPair>}
     * @memberof IEdmReferentialConstraint
     */
    propertyPairs?: Array<EdmReferentialConstraintPropertyPair>;
}
/**
 * 
 * @export
 * @interface IEdmSchemaElement
 */
export interface IEdmSchemaElement {
    /**
     * 
     * @type {EdmSchemaElementKind}
     * @memberof IEdmSchemaElement
     */
    schemaElementKind?: EdmSchemaElementKind;
    /**
     * 
     * @type {string}
     * @memberof IEdmSchemaElement
     */
    namespace?: string;
    /**
     * 
     * @type {string}
     * @memberof IEdmSchemaElement
     */
    name?: string | null;
}
/**
 * 
 * @export
 * @interface IEdmStructuralProperty
 */
export interface IEdmStructuralProperty {
    /**
     * 
     * @type {string}
     * @memberof IEdmStructuralProperty
     */
    defaultValueString?: string;
    /**
     * 
     * @type {EdmPropertyKind}
     * @memberof IEdmStructuralProperty
     */
    propertyKind?: EdmPropertyKind;
    /**
     * 
     * @type {IEdmTypeReference}
     * @memberof IEdmStructuralProperty
     */
    type?: IEdmTypeReference;
    /**
     * 
     * @type {IEdmStructuredType}
     * @memberof IEdmStructuralProperty
     */
    declaringType?: IEdmStructuredType;
    /**
     * 
     * @type {string}
     * @memberof IEdmStructuralProperty
     */
    name?: string | null;
}
/**
 * 
 * @export
 * @interface IEdmStructuredType
 */
export interface IEdmStructuredType {
    /**
     * 
     * @type {boolean}
     * @memberof IEdmStructuredType
     */
    isAbstract?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IEdmStructuredType
     */
    isOpen?: boolean;
    /**
     * 
     * @type {IEdmStructuredType}
     * @memberof IEdmStructuredType
     */
    baseType?: IEdmStructuredType;
    /**
     * 
     * @type {Array<IEdmProperty>}
     * @memberof IEdmStructuredType
     */
    declaredProperties?: Array<IEdmProperty>;
    /**
     * 
     * @type {EdmTypeKind}
     * @memberof IEdmStructuredType
     */
    typeKind?: EdmTypeKind;
}
/**
 * 
 * @export
 * @interface IEdmTerm
 */
export interface IEdmTerm {
    /**
     * 
     * @type {IEdmTypeReference}
     * @memberof IEdmTerm
     */
    type?: IEdmTypeReference;
    /**
     * 
     * @type {string}
     * @memberof IEdmTerm
     */
    appliesTo?: string;
    /**
     * 
     * @type {string}
     * @memberof IEdmTerm
     */
    defaultValue?: string;
    /**
     * 
     * @type {EdmSchemaElementKind}
     * @memberof IEdmTerm
     */
    schemaElementKind?: EdmSchemaElementKind;
    /**
     * 
     * @type {string}
     * @memberof IEdmTerm
     */
    namespace?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IEdmTerm
     */
    name?: string | null;
}
/**
 * 
 * @export
 * @interface IEdmType
 */
export interface IEdmType {
    /**
     * 
     * @type {EdmTypeKind}
     * @memberof IEdmType
     */
    typeKind?: EdmTypeKind;
}
/**
 * 
 * @export
 * @interface IEdmTypeReference
 */
export interface IEdmTypeReference {
    /**
     * 
     * @type {boolean}
     * @memberof IEdmTypeReference
     */
    isNullable?: boolean;
    /**
     * 
     * @type {IEdmType}
     * @memberof IEdmTypeReference
     */
    definition?: IEdmType;
}
/**
 * 
 * @export
 * @interface IEdmVocabularyAnnotation
 */
export interface IEdmVocabularyAnnotation {
    /**
     * 
     * @type {string}
     * @memberof IEdmVocabularyAnnotation
     */
    qualifier?: string;
    /**
     * 
     * @type {IEdmTerm}
     * @memberof IEdmVocabularyAnnotation
     */
    term?: IEdmTerm;
    /**
     * 
     * @type {object}
     * @memberof IEdmVocabularyAnnotation
     */
    target?: object;
    /**
     * 
     * @type {IEdmExpression}
     * @memberof IEdmVocabularyAnnotation
     */
    value?: IEdmExpression;
}
/**
 * 
 * @export
 * @interface IErrorModel
 */
export interface IErrorModel {
    /**
     * 
     * @type {number}
     * @memberof IErrorModel
     */
    code?: number;
    /**
     * 
     * @type {number}
     * @memberof IErrorModel
     */
    applicationErrorCode?: number;
    /**
     * 
     * @type {string}
     * @memberof IErrorModel
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof IErrorModel
     */
    exceptionContent?: string;
    /**
     * 
     * @type {Array<IPropertyError>}
     * @memberof IErrorModel
     */
    errors?: Array<IPropertyError>;
    /**
     * 
     * @type {InternalErrorNumber}
     * @memberof IErrorModel
     */
    internalErrorNumber?: InternalErrorNumber;
}
/**
 * 
 * @export
 * @interface IErrorResponse
 */
export interface IErrorResponse {
    /**
     * 
     * @type {IErrorModel}
     * @memberof IErrorResponse
     */
    error?: IErrorModel;
}
/**
 * 
 * @export
 * @interface IIdentity
 */
export interface IIdentity {
    /**
     * 
     * @type {string}
     * @memberof IIdentity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IIdentity
     */
    authenticationType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IIdentity
     */
    isAuthenticated?: boolean;
}
/**
 * 
 * @export
 * @interface IPAddress
 */
export interface IPAddress {
    /**
     * 
     * @type {AddressFamily}
     * @memberof IPAddress
     */
    addressFamily?: AddressFamily;
    /**
     * 
     * @type {number}
     * @memberof IPAddress
     */
    scopeId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPAddress
     */
    isIPv6Multicast?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPAddress
     */
    isIPv6LinkLocal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPAddress
     */
    isIPv6SiteLocal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPAddress
     */
    isIPv6Teredo?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPAddress
     */
    isIPv6UniqueLocal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPAddress
     */
    isIPv4MappedToIPv6?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IPAddress
     */
    address?: number;
}
/**
 * 
 * @export
 * @interface IPropertyError
 */
export interface IPropertyError {
    /**
     * 
     * @type {object}
     * @memberof IPropertyError
     */
    property?: object;
    /**
     * 
     * @type {object}
     * @memberof IPropertyError
     */
    message?: object;
    /**
     * 
     * @type {object}
     * @memberof IPropertyError
     */
    errorCode?: object;
}
/**
 * 
 * @export
 * @interface ISession
 */
export interface ISession {
    /**
     * 
     * @type {boolean}
     * @memberof ISession
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ISession
     */
    id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ISession
     */
    keys?: Array<string>;
}
/**
 * 
 * @export
 * @interface ImageOutputDTO
 */
export interface ImageOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ImageOutputDTO
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface InDispatchSalesOrderQueryOutputDTO
 */
export interface InDispatchSalesOrderQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {OutputDispatchState}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    salesOrderDispatchState?: OutputDispatchState;
    /**
     * 
     * @type {ImageOutputDTO}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    carrierImageUrl?: ImageOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    orderCreatedAt?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {SalesChannel}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {SalesOrderPickingPriority}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    priority?: SalesOrderPickingPriority;
    /**
     * 
     * @type {boolean}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    isSuspended?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    isCutOff?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    isSoftCutOff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {string}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    suspendedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    isCargoCodeUpdated?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    isSalesChannelMatch?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InDispatchSalesOrderQueryOutputDTO
     */
    cargoCarrier?: string;
}
/**
 * 
 * @export
 * @interface InDispatchSalesOrderQueryOutputDTODynamicQueryOutputDTO
 */
export interface InDispatchSalesOrderQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<InDispatchSalesOrderQueryOutputDTO>}
     * @memberof InDispatchSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<InDispatchSalesOrderQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof InDispatchSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface InPackingSalesOrderQueryOutputDTO
 */
export interface InPackingSalesOrderQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {SalesOrderPackingState}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    salesOrderPackingState?: SalesOrderPackingState;
    /**
     * 
     * @type {string}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    orderCreatedAt?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {SalesChannel}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {SalesOrderPickingPriority}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    priority?: SalesOrderPickingPriority;
    /**
     * 
     * @type {boolean}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    isSuspended?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    isCutOff?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    isSoftCutOff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {string}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    suspendedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    isCargoCodeUpdated?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    isSalesChannelMatch?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InPackingSalesOrderQueryOutputDTO
     */
    cargoCarrier?: string;
}
/**
 * 
 * @export
 * @interface InPackingSalesOrderQueryOutputDTODynamicQueryOutputDTO
 */
export interface InPackingSalesOrderQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<InPackingSalesOrderQueryOutputDTO>}
     * @memberof InPackingSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<InPackingSalesOrderQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof InPackingSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface InPickingSalesOrderQueryOutputDTO
 */
export interface InPickingSalesOrderQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {SalesOrderPickingState}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    salesOrderPickingState?: SalesOrderPickingState;
    /**
     * 
     * @type {string}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    orderCreatedAt?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {SalesChannel}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {SalesOrderPickingPriority}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    priority?: SalesOrderPickingPriority;
    /**
     * 
     * @type {boolean}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    isSuspended?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    isCutOff?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    isSoftCutOff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {string}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    suspendedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    isCargoCodeUpdated?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    isSalesChannelMatch?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InPickingSalesOrderQueryOutputDTO
     */
    cargoCarrier?: string;
}
/**
 * 
 * @export
 * @interface InPickingSalesOrderQueryOutputDTODynamicQueryOutputDTO
 */
export interface InPickingSalesOrderQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<InPickingSalesOrderQueryOutputDTO>}
     * @memberof InPickingSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<InPickingSalesOrderQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof InPickingSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface InProcessReturnPackageQueryOutputDTO
 */
export interface InProcessReturnPackageQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InProcessReturnPackageQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InProcessReturnPackageQueryOutputDTO
     */
    trackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof InProcessReturnPackageQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InProcessReturnPackageQueryOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InProcessReturnPackageQueryOutputDTO
     */
    cargoTrackingNumber?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof InProcessReturnPackageQueryOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof InProcessReturnPackageQueryOutputDTO
     */
    matchedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof InProcessReturnPackageQueryOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface InProcessReturnPackageQueryOutputDTODynamicQueryOutputDTO
 */
export interface InProcessReturnPackageQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<InProcessReturnPackageQueryOutputDTO>}
     * @memberof InProcessReturnPackageQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<InProcessReturnPackageQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof InProcessReturnPackageQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface InSLAMOrSuspendedSalesOrderQueryOutputDTO
 */
export interface InSLAMOrSuspendedSalesOrderQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {SalesOrderSLAMState}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    salesOrderSLAMState?: SalesOrderSLAMState;
    /**
     * 
     * @type {ImageOutputDTO}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    carrierImageUrl?: ImageOutputDTO;
    /**
     * 
     * @type {boolean}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    isCargoCodeUpdated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    orderCreatedAt?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {SalesChannel}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {SalesOrderPickingPriority}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    priority?: SalesOrderPickingPriority;
    /**
     * 
     * @type {boolean}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    isSuspended?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    isCutOff?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    isSoftCutOff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {string}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    suspendedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    isSalesChannelMatch?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTO
     */
    cargoCarrier?: string;
}
/**
 * 
 * @export
 * @interface InSLAMOrSuspendedSalesOrderQueryOutputDTODynamicQueryOutputDTO
 */
export interface InSLAMOrSuspendedSalesOrderQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<InSLAMOrSuspendedSalesOrderQueryOutputDTO>}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<InSLAMOrSuspendedSalesOrderQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof InSLAMOrSuspendedSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface InSortingSalesOrderQueryOutputDTO
 */
export interface InSortingSalesOrderQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {SalesOrderSortingState}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    salesOrderSortingState?: SalesOrderSortingState;
    /**
     * 
     * @type {string}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    orderCreatedAt?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {SalesChannel}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {SalesOrderPickingPriority}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    priority?: SalesOrderPickingPriority;
    /**
     * 
     * @type {boolean}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    isSuspended?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    isCutOff?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    isSoftCutOff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {string}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    suspendedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    isCargoCodeUpdated?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    isSalesChannelMatch?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InSortingSalesOrderQueryOutputDTO
     */
    cargoCarrier?: string;
}
/**
 * 
 * @export
 * @interface InSortingSalesOrderQueryOutputDTODynamicQueryOutputDTO
 */
export interface InSortingSalesOrderQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<InSortingSalesOrderQueryOutputDTO>}
     * @memberof InSortingSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<InSortingSalesOrderQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof InSortingSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface InboundBoxCargoPackageDetailDTO
 */
export interface InboundBoxCargoPackageDetailDTO {
    /**
     * 
     * @type {ContainerType}
     * @memberof InboundBoxCargoPackageDetailDTO
     */
    boxType?: ContainerType;
    /**
     * 
     * @type {string}
     * @memberof InboundBoxCargoPackageDetailDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof InboundBoxCargoPackageDetailDTO
     */
    orderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InboundBoxCargoPackageDetailDTO
     */
    operatorName?: string;
    /**
     * 
     * @type {string}
     * @memberof InboundBoxCargoPackageDetailDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof InboundBoxCargoPackageDetailDTO
     */
    lastSeenAt?: string;
    /**
     * 
     * @type {string}
     * @memberof InboundBoxCargoPackageDetailDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof InboundBoxCargoPackageDetailDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {ReceivingState}
     * @memberof InboundBoxCargoPackageDetailDTO
     */
    receivingState?: ReceivingState;
    /**
     * 
     * @type {CargoPackageState}
     * @memberof InboundBoxCargoPackageDetailDTO
     */
    cargoPackageState?: CargoPackageState;
    /**
     * 
     * @type {Array<string>}
     * @memberof InboundBoxCargoPackageDetailDTO
     */
    orderCargoPackageLabels?: Array<string>;
}
/**
 * 
 * @export
 * @interface InboundBoxDetailsOutputDTO
 */
export interface InboundBoxDetailsOutputDTO {
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof InboundBoxDetailsOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof InboundBoxDetailsOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof InboundBoxDetailsOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof InboundBoxDetailsOutputDTO
     */
    expectedDeliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof InboundBoxDetailsOutputDTO
     */
    containerType?: string;
}
/**
 * 
 * @export
 * @interface InboundProblemListOutputDTO
 */
export interface InboundProblemListOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InboundProblemListOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InboundProblemListOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {InboundProblemType}
     * @memberof InboundProblemListOutputDTO
     */
    type?: InboundProblemType;
    /**
     * 
     * @type {number}
     * @memberof InboundProblemListOutputDTO
     */
    itemAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof InboundProblemListOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {ProblemState}
     * @memberof InboundProblemListOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {string}
     * @memberof InboundProblemListOutputDTO
     */
    barcodes?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum InboundProblemSolutionType {
    None = 'None',
    ReBarcoding = 'ReBarcoding',
    Destroy = 'Destroy',
    Return = 'Return',
    UpdateDefinition = 'UpdateDefinition',
    Grant = 'Grant'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum InboundProblemType {
    None = 'None',
    UnreadableBarcodeProblem = 'UnreadableBarcodeProblem',
    DuplicateBarcodeProblem = 'DuplicateBarcodeProblem',
    UnidentifiedProductProblem = 'UnidentifiedProductProblem',
    BarcodeMismatchProblem = 'BarcodeMismatchProblem',
    DamagedItemsProblem = 'DamagedItemsProblem',
    BarcodeNotExistProblem = 'BarcodeNotExistProblem',
    ExpirationDateNotExistProblem = 'ExpirationDateNotExistProblem',
    SerialNumberNotExistProblem = 'SerialNumberNotExistProblem',
    ExpiredProductProblem = 'ExpiredProductProblem'
}

/**
 * 
 * @export
 * @interface InboundProblemsBarcodeTypeOutputDTO
 */
export interface InboundProblemsBarcodeTypeOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof InboundProblemsBarcodeTypeOutputDTO
     */
    quarantineContainerId?: number;
    /**
     * 
     * @type {string}
     * @memberof InboundProblemsBarcodeTypeOutputDTO
     */
    quarantineContainerLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof InboundProblemsBarcodeTypeOutputDTO
     */
    inboundBoxId?: number;
    /**
     * 
     * @type {string}
     * @memberof InboundProblemsBarcodeTypeOutputDTO
     */
    inboundBoxLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof InboundProblemsBarcodeTypeOutputDTO
     */
    inboundProblemId?: string;
    /**
     * 
     * @type {string}
     * @memberof InboundProblemsBarcodeTypeOutputDTO
     */
    inboundProblemLabel?: string;
}
/**
 * 
 * @export
 * @interface InsertToHOVPackageVASInputDTO
 */
export interface InsertToHOVPackageVASInputDTO {
    /**
     * 
     * @type {string}
     * @memberof InsertToHOVPackageVASInputDTO
     */
    barcode?: string;
}
/**
 * 
 * @export
 * @interface InsertToPackageVASInputDTO
 */
export interface InsertToPackageVASInputDTO {
    /**
     * 
     * @type {string}
     * @memberof InsertToPackageVASInputDTO
     */
    barcode?: string;
}
/**
 * 
 * @export
 * @interface InsertToteToTransferTrolleyCommand
 */
export interface InsertToteToTransferTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof InsertToteToTransferTrolleyCommand
     */
    transferTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof InsertToteToTransferTrolleyCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface InstallOrUpdatePrinterOrchestratorCommand
 */
export interface InstallOrUpdatePrinterOrchestratorCommand {
    /**
     * 
     * @type {string}
     * @memberof InstallOrUpdatePrinterOrchestratorCommand
     */
    machineName?: string;
}
/**
 * 
 * @export
 * @interface InstallOrUpdatePrinterOrchestratorOutputDTO
 */
export interface InstallOrUpdatePrinterOrchestratorOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InstallOrUpdatePrinterOrchestratorOutputDTO
     */
    queueName?: string;
    /**
     * 
     * @type {string}
     * @memberof InstallOrUpdatePrinterOrchestratorOutputDTO
     */
    machineName?: string;
}
/**
 * 
 * @export
 * @interface InstallPrinterCommand
 */
export interface InstallPrinterCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof InstallPrinterCommand
     */
    addressLabels?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InstallPrinterCommand
     */
    printerName?: string;
    /**
     * 
     * @type {string}
     * @memberof InstallPrinterCommand
     */
    selectedPrinterName?: string;
    /**
     * 
     * @type {string}
     * @memberof InstallPrinterCommand
     */
    machineName?: string;
    /**
     * 
     * @type {PrinterTypes}
     * @memberof InstallPrinterCommand
     */
    type?: PrinterTypes;
}
/**
 * 
 * @export
 * @interface InstallPrinterOutputDTO
 */
export interface InstallPrinterOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InstallPrinterOutputDTO
     */
    printerName?: string;
    /**
     * 
     * @type {string}
     * @memberof InstallPrinterOutputDTO
     */
    selectedPrinterName?: string;
    /**
     * 
     * @type {string}
     * @memberof InstallPrinterOutputDTO
     */
    queueName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InstallPrinterOutputDTO
     */
    addressLabels?: Array<string>;
}
/**
 * 
 * @export
 * @interface InstalledPrinterQueryOutputDTO
 */
export interface InstalledPrinterQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InstalledPrinterQueryOutputDTO
     */
    printerName?: string;
    /**
     * 
     * @type {string}
     * @memberof InstalledPrinterQueryOutputDTO
     */
    selectedPrinterName?: string;
    /**
     * 
     * @type {string}
     * @memberof InstalledPrinterQueryOutputDTO
     */
    machineName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InstalledPrinterQueryOutputDTO
     */
    addressLabel?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InstalledPrinterQueryOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface InstalledPrinterQueryOutputDTODynamicQueryOutputDTO
 */
export interface InstalledPrinterQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<InstalledPrinterQueryOutputDTO>}
     * @memberof InstalledPrinterQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<InstalledPrinterQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof InstalledPrinterQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface IntegrationCodeProblemDetailsOutputDTO
 */
export interface IntegrationCodeProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof IntegrationCodeProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCodeProblemDetailsOutputDTO
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCodeProblemDetailsOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {ProblemSource}
     * @memberof IntegrationCodeProblemDetailsOutputDTO
     */
    source?: ProblemSource;
    /**
     * 
     * @type {ProblemState}
     * @memberof IntegrationCodeProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {IntegrationCodeProblemState}
     * @memberof IntegrationCodeProblemDetailsOutputDTO
     */
    stateDetail?: IntegrationCodeProblemState;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCodeProblemDetailsOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCodeProblemDetailsOutputDTO
     */
    reviewedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCodeProblemDetailsOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCodeProblemDetailsOutputDTO
     */
    resolutionNote?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum IntegrationCodeProblemState {
    None = 'None',
    Created = 'Created',
    Reviewed = 'Reviewed',
    Resolved = 'Resolved'
}

/**
 * 
 * @export
 * @interface IntegrationListOutputDTO
 */
export interface IntegrationListOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof IntegrationListOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationListOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {IntegrationState}
     * @memberof IntegrationListOutputDTO
     */
    state?: IntegrationState;
    /**
     * 
     * @type {IntegrationType}
     * @memberof IntegrationListOutputDTO
     */
    type?: IntegrationType;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum IntegrationState {
    None = 'None',
    Passive = 'Passive',
    Active = 'Active'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum IntegrationType {
    None = 'None',
    OpenApiIntegration = 'OpenAPIIntegration'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalErrorNumber {
    None = 'None',
    SlamCargoPackageDispatchedError = 'SLAM_CargoPackageDispatchedError',
    SlamCargoPackageReadyToShipError = 'SLAM_CargoPackageReadyToShipError',
    SlamCargoPackageShippingDomesticError = 'SLAM_CargoPackageShippingDomesticError',
    ControlCountingProductNotFoundWithBarcodeError = 'ControlCounting_ProductNotFoundWithBarcodeError',
    ControlCountingToteShouldBeEmptyError = 'ControlCounting_ToteShouldBeEmptyError',
    ReceivingExpirationDateRequiredProduct = 'Receiving_ExpirationDateRequiredProduct',
    ReceivingToteContainsSameProductDifferentExpirationDate = 'Receiving_ToteContainsSameProductDifferentExpirationDate',
    WebRecevingInboundBoxNotFound = 'WebReceving_InboundBoxNotFound',
    WebRecevingPurchaseOrderAlreadyCompleted = 'WebReceving_PurchaseOrderAlreadyCompleted',
    WebRecevingExpectedDeliveryDateNotAvailableToReceiveItems = 'WebReceving_ExpectedDeliveryDateNotAvailableToReceiveItems',
    WebRecevingReceivingAlreadyCompleted = 'WebReceving_ReceivingAlreadyCompleted',
    WebRecevingInboundBoxIsProcessedAtDifferentAddress = 'WebReceving_InboundBoxIsProcessedAtDifferentAddress',
    WebRecevingInboundBoxIsProcessedOnMobile = 'WebReceving_InboundBoxIsProcessedOnMobile',
    WebRecevingReceivingMustBeCompletedByAnotherOperator = 'WebReceving_ReceivingMustBeCompletedByAnotherOperator',
    WebRecevingInboundBoxHasAlreadyReceivingTote = 'WebReceving_InboundBoxHasAlreadyReceivingTote',
    WebRecevingReceivingHasAlreadyQuarantineTote = 'WebReceving_ReceivingHasAlreadyQuarantineTote',
    WebRecevingToteAssignedToPickingTrolley = 'WebReceving_ToteAssignedToPickingTrolley',
    WebRecevingReceivingHasAlreadyTote = 'WebReceving_ReceivingHasAlreadyTote',
    WebRecevingToteIsNotAvailable = 'WebReceving_ToteIsNotAvailable',
    WebRecevingReceivingIsProcessedAtAnotherWebOperation = 'WebReceving_ReceivingIsProcessedAtAnotherWebOperation',
    WebRecevingToteIsProcessedOnMobile = 'WebReceving_ToteIsProcessedOnMobile',
    WebRecevingToteIsProcessedAtDifferentPutaway = 'WebReceving_ToteIsProcessedAtDifferentPutaway',
    WebRecevingToteContainsQuarantineItems = 'WebReceving_ToteContainsQuarantineItems',
    WebRecevingQuarantineToteIsNotAvailable = 'WebReceving_QuarantineToteIsNotAvailable',
    WebRecevingQuarantineToteIsUsedAtAnotherWebOperation = 'WebReceving_QuarantineToteIsUsedAtAnotherWebOperation',
    WebRecevingQuarantineToteIsUsedAtAnotherMobileOperation = 'WebReceving_QuarantineToteIsUsedAtAnotherMobileOperation',
    WebRecevingReceivingHasNoToteToDrop = 'WebReceving_ReceivingHasNoToteToDrop',
    WebRecevingReceivingToteNotBelongsToWebReceiving = 'WebReceving_ReceivingToteNotBelongsToWebReceiving',
    WebRecevingReceivingMustHaveTote = 'WebReceving_ReceivingMustHaveTote',
    WebRecevingReceivingNotFound = 'WebReceving_ReceivingNotFound',
    WebRecevingQuarantineToteNotFound = 'WebReceving_QuarantineToteNotFound',
    WebRecevingProductBarcodeMustNotBeEmptyToAddProblem = 'WebReceving_ProductBarcodeMustNotBeEmptyToAddProblem',
    WebRecevingTransferredReceivingItemsNotFoundInReceivingTote = 'WebReceving_TransferredReceivingItemsNotFoundInReceivingTote',
    WebRecevingRecevingProcessHasNoLastSuccessfullProductId = 'WebReceving_RecevingProcessHasNoLastSuccessfullProductId',
    WebRecevingRecevingAddressNotFound = 'WebReceving_RecevingAddressNotFound',
    WebRecevingReceivingToteNotFound = 'WebReceving_ReceivingToteNotFound',
    WebRecevingDropAddressNotFound = 'WebReceving_DropAddressNotFound',
    WebRecevingProductNotFoundWithBarcodeError = 'WebReceving_ProductNotFoundWithBarcodeError',
    ProcessNotFound = 'Process_NotFound',
    RecevingRecevingAddressNotFound = 'Receving_RecevingAddressNotFound',
    RecevingToteNotFound = 'Receving_ToteNotFound',
    RecevingToteNotFoundForReferenceNumber = 'Receving_ToteNotFoundForReferenceNumber',
    RecevingQuarantineToteNotFound = 'Receving_QuarantineToteNotFound',
    RecevingQuarantineToteNotFoundForReferenceNumber = 'Receving_QuarantineToteNotFoundForReferenceNumber',
    ToteProductWithSameBarcodeIsAlreadyInCellWithDifferentOperation = 'Tote_ProductWithSameBarcodeIsAlreadyInCellWithDifferentOperation',
    ToteContainsOtherTypeOfItems = 'Tote_ContainsOtherTypeOfItems',
    WebRecevingProductNotFound = 'WebReceving_ProductNotFound',
    RecevingReceivingAlreadyCompleted = 'Receving_ReceivingAlreadyCompleted',
    PackingProductsAlreadyAddedToPackageQueue = 'Packing_ProductsAlreadyAddedToPackageQueue',
    PickingStockZoneInputDeactive = 'Picking_StockZoneInputDeactive',
    PickingStockZoneNotFoundForCell = 'Picking_StockZoneNotFoundForCell',
    PickingStockZoneInformationMissingOnStockZoneInput = 'Picking_StockZoneInformationMissingOnStockZoneInput',
    PickingNoAwaitingPickList = 'Picking_NoAwaitingPickList',
    PickingNoActiveFlow = 'Picking_NoActiveFlow',
    PickingNoAvailableTrolleyForAwaitingPicklist = 'Picking_NoAvailableTrolleyForAwaitingPicklist',
    StockCountingSameProductDifferentExpirationDateError = 'StockCounting_SameProductDifferentExpirationDateError',
    PutAwayProductMustHaveWeightWhenMaxTotalProductWeightIsDefined = 'PutAway_ProductMustHaveWeightWhenMaxTotalProductWeightIsDefined',
    PutAwayPrimeCellHasReachedTotalProductWeight = 'PutAway_PrimeCellHasReachedTotalProductWeight',
    HovPickingTrolleyMustBeEmptyToCompletePicking = 'HOVPicking_TrolleyMustBeEmptyToCompletePicking',
    HovPickingEnteredItemCountGreaterThanExpectedItemCount = 'HOVPicking_EnteredItemCountGreaterThanExpectedItemCount',
    HovPickingTrolleyVariationMustBeHov = 'HOVPicking_TrolleyVariationMustBeHOV',
    PickingPickingToteMustBeEmpty = 'Picking_PickingToteMustBeEmpty',
    HovPickingPickListVariationMustBeHov = 'HOVPicking_PickListVariationMustBeHOV',
    HovPickingPickingTrolleyNotValidForPicking = 'HOVPicking_PickingTrolleyNotValidForPicking',
    HovPickingPickingToteShouldNotBeOnTrolley = 'HOVPicking_PickingToteShouldNotBeOnTrolley',
    PackingSerialNumberRequiredForThisProduct = 'Packing_SerialNumberRequiredForThisProduct',
    ReceivingSerialNumberRequiredForProduct = 'Receiving_SerialNumberRequiredForProduct',
    SerialNumberAlreadyExists = 'SerialNumberAlreadyExists',
    PlaceProductThereIsProductWithSameSerialNumber = 'PlaceProduct_ThereIsProductWithSameSerialNumber',
    PlaceProductThereIsNoProductWithSerialNumber = 'PlaceProduct_ThereIsNoProductWithSerialNumber',
    PlaceProductProductNeedsSerialNumber = 'PlaceProduct_ProductNeedsSerialNumber',
    ReceivingProcessSerialNumberTrackedProductNotSupported = 'ReceivingProcess_SerialNumberTrackedProductNotSupported',
    PutAwayTheSameOperatorHasAnActivePutaway = 'PutAway_TheSameOperatorHasAnActivePutaway',
    PickingPickingTrolleyStateNotAvailable = 'Picking_PickingTrolleyStateNotAvailable',
    PickingPickingProcessHasNoValueForTrolley = 'Picking_PickingProcessHasNoValueForTrolley',
    PickingSingleItemTrolleyIsNotValidForThisOperation = 'Picking_SingleItemTrolleyIsNotValidForThisOperation',
    PickingTrolleyVariationIsNotEqualPickListVariation = 'Picking_TrolleyVariationIsNotEqualPickListVariation',
    HovPickingTrolleyMustBeEmpty = 'HOVPicking_TrolleyMustBeEmpty',
    PickingNoAwaitingPickListForStockZone = 'Picking_NoAwaitingPickListForStockZone',
    PickingNoActivePickingFlowForPickingOperation = 'Picking_NoActivePickingFlowForPickingOperation',
    PickingTrolleyNotFoundForRequestedLabel = 'Picking_TrolleyNotFoundForRequestedLabel',
    StockCountingPickingStartedSalesOrderItemExistsInCell = 'StockCounting_PickingStartedSalesOrderItemExistsInCell',
    StockCountingCountedProductsNotDefinedInCellStockZone = 'StockCounting_CountedProductsNotDefinedInCellStockZone',
    StockCountingExpirationDateRequiredForCountedProducts = 'StockCounting_ExpirationDateRequiredForCountedProducts',
    StockCountingOperationLostItemContainerNotFound = 'StockCounting_OperationLostItemContainerNotFound',
    StockCountingNotAllowedSameBarcodeDifferentOperationInStockCell = 'StockCounting_NotAllowedSameBarcodeDifferentOperationInStockCell',
    PickingSalesOrderAlreadyInPickingState = 'Picking_SalesOrderAlreadyInPickingState',
    PickingCancelledSalesOrderCannotBePicked = 'Picking_CancelledSalesOrderCannotBePicked',
    ContainerTransferToteMustBePlacedToQuarantineAddress = 'ContainerTransfer_ToteMustBePlacedToQuarantineAddress',
    ContainerTransferToteHasCancelledSalesOrderWithRefNumber = 'ContainerTransfer_ToteHasCancelledSalesOrderWithRefNumber',
    ContainerTransferToteIsAlreadyAssignedToPackingAddress = 'ContainerTransfer_ToteIsAlreadyAssignedToPackingAddress',
    ContainerTransferToteIsProcessingAtMissingItemTransferAddress = 'ContainerTransfer_ToteIsProcessingAtMissingItemTransferAddress',
    ContainerTransferToteContainsRestowItem = 'ContainerTransfer_ToteContainsRestowItem',
    StockCountingPickingStartedSalesOrderItemExistsInCellAndStockCountingUnassigned = 'StockCounting_PickingStartedSalesOrderItemExistsInCellAndStockCountingUnassigned',
    StockCountingPickingStartedSalesOrderItemExistsInCellForProductAndStockCountingUnassigned = 'StockCounting_PickingStartedSalesOrderItemExistsInCellForProductAndStockCountingUnassigned',
    StockCountingPickingStartedSalesOrderItemExistsInCellForManuelStockCounting = 'StockCounting_PickingStartedSalesOrderItemExistsInCellForManuelStockCounting',
    StockCountingOperationOnlyValidForSrCstockCountingList = 'StockCounting_OperationOnlyValidForSRCstockCountingList',
    StockCountingOperationOnlyValidForCCstockCountingList = 'StockCounting_OperationOnlyValidForCCstockCountingList',
    PackingPackageTypeMustBePaletteForPrintingPackingList = 'Packing_PackageTypeMustBePaletteForPrintingPackingList',
    StockCountingCountedProductsNotDefinedInStockZone = 'StockCounting_CountedProductsNotDefinedInStockZone',
    StockCountingCountedProductZoneIsDifferentFromCellZone = 'StockCounting_CountedProductZoneIsDifferentFromCellZone',
    TransferTargetCellLabelAndSourceCellLabelCannotBeTheSame = 'Transfer_TargetCellLabelAndSourceCellLabelCannotBeTheSame',
    TransferAmountOfProductsIsGreaterThanAmountOfProductsAtTheAddress = 'Transfer_AmountOfProductsIsGreaterThanAmountOfProductsAtTheAddress',
    TransferFollowingProductIsNotDefinedInTargetStockZone = 'Transfer_FollowingProductIsNotDefinedInTargetStockZone',
    PutAwayStockCellHasReachedMaximumProductAmount = 'PutAway_StockCellHasReachedMaximumProductAmount',
    PutAwayStockCelHasReachedMaximumProductVarietyAmount = 'PutAway_StockCelHasReachedMaximumProductVarietyAmount',
    PutAwayStockCelHasReachedMaximumOperationCount = 'PutAway_StockCelHasReachedMaximumOperationCount',
    PutAwayNotSuitableForProductHigherThanMaxProductHeight = 'PutAway_NotSuitableForProductHigherThanMaxProductHeight',
    PutAwayNotSuitableForProductHeavierThanMaxProductWeight = 'PutAway_NotSuitableForProductHeavierThanMaxProductWeight',
    PutAwayNotSuitableForProductBiggerThanMaxProductVolume = 'PutAway_NotSuitableForProductBiggerThanMaxProductVolume',
    PutAwayProductsNotFound = 'PutAway_ProductsNotFound',
    ProductWithSameBarcodeAndDifferentExpDateIsInCellWithSameOperation = 'ProductWithSameBarcodeAndDifferentExpDateIsInCellWithSameOperation',
    SourceCellNotContainsTransferableItems = 'SourceCellNotContainsTransferableItems',
    HardAllocatedItemIsNotSupportedForTransferToCell = 'HardAllocatedItemIsNotSupportedForTransferToCell',
    TargetCellContainsSameProductForAnotherOperation = 'TargetCellContainsSameProductForAnotherOperation',
    AlreadySalesOrderCancelled = 'AlreadySalesOrderCancelled',
    CancelLineItemUnsolvedOutOfStockProblemNotFound = 'CancelLineItem_UnsolvedOutOfStockProblemNotFound',
    CancelLineItemCancelLineItemNotFound = 'CancelLineItem_CancelLineItemNotFound',
    CancelLineItemAmountGreaterThanAmountInOrder = 'CancelLineItem_AmountGreaterThanAmountInOrder',
    CancelLineItemSalesOrderMustBeCancelled = 'CancelLineItem_SalesOrderMustBeCancelled',
    StockCountingPlanEnabledStockCountingListConfigurationNotFound = 'StockCountingPlan_EnabledStockCountingListConfigurationNotFound',
    ReceivingExpirationDateHasExpired = 'Receiving_ExpirationDateHasExpired',
    ReceivingExpirationDateWithThresholdDayHasExpired = 'Receiving_ExpirationDateWithThresholdDayHasExpired',
    MissingItemTransferPickingToteNotFound = 'MissingItemTransfer_PickingToteNotFound',
    ReceivingProcessPurchaseOrderStateCompleted = 'ReceivingProcess_PurchaseOrderStateCompleted',
    ReceivingNoProductFoundInReceivedInboundBoxForDeletion = 'Receiving_NoProductFoundInReceivedInboundBoxForDeletion',
    ReceivingMaxAmountAvailableForDeletionFromReceivingToteExceeded = 'Receiving_MaxAmountAvailableForDeletionFromReceivingToteExceeded',
    ReceivingNoProductFoundInQuarantinedInboundBoxForDeletion = 'Receiving_NoProductFoundInQuarantinedInboundBoxForDeletion',
    ReceivingMaxAmountAvailableForDeletionFromQuarantineToteExceeded = 'Receiving_MaxAmountAvailableForDeletionFromQuarantineToteExceeded',
    ReceivingNoValidProductFoundInReceivedToteForUpdate = 'Receiving_NoValidProductFoundInReceivedToteForUpdate',
    ReceivingNoValidProductFoundInQuarantinedToteForUpdate = 'Receiving_NoValidProductFoundInQuarantinedToteForUpdate',
    ReceivingNoProductFoundInReceivedInboundBoxForTransfer = 'Receiving_NoProductFoundInReceivedInboundBoxForTransfer',
    ReceivingMaxAmountAvailableForTransferFromReceivingToteExceeded = 'Receiving_MaxAmountAvailableForTransferFromReceivingToteExceeded',
    PackingCargoPackageQueueIsNotFound = 'Packing_CargoPackageQueueIsNotFound',
    PutAwayStockCellHasReachedMaximumSingleProductAmountWithSerialNumber = 'PutAway_StockCellHasReachedMaximumSingleProductAmountWithSerialNumber',
    StockCountingSerialNumberRequiredForCountedProducts = 'StockCounting_SerialNumberRequiredForCountedProducts',
    StockCountingFoundSerialNumberInventoryItemTypeNotSuitableForCounting = 'StockCounting_FoundSerialNumberInventoryItemTypeNotSuitableForCounting',
    StockCountingCellContainsSameProductHasDifferentExpirationDate = 'StockCounting_CellContainsSameProductHasDifferentExpirationDate',
    TransferSerialNumberRequiredForProduct = 'Transfer_SerialNumberRequiredForProduct',
    TransferThereIsNoProductWithSerialNumber = 'Transfer_ThereIsNoProductWithSerialNumber',
    NoProductFoundWithGivenSerialNumber = 'NoProductFoundWithGivenSerialNumber',
    MissingItemTransferPickingToteSalesOrderNotFound = 'MissingItemTransfer_PickingToteSalesOrderNotFound',
    MissingItemTransferQuarantineToteContainsSalesOrderNotFound = 'MissingItemTransfer_QuarantineToteContainsSalesOrderNotFound',
    MissingItemTransferProcessNotFound = 'MissingItemTransfer_ProcessNotFound',
    MissingItemTransferQuarantineToteNotFound = 'MissingItemTransfer_QuarantineToteNotFound',
    MissingItemTransferPickingToteSalesOrderCancelled = 'MissingItemTransfer_PickingToteSalesOrderCancelled',
    MissingItemTransferProcessAndQuarantineToteSalesOrderNotMatched = 'MissingItemTransfer_ProcessAndQuarantineToteSalesOrderNotMatched',
    MissingItemTransferProcessCompleteError = 'MissingItemTransfer_ProcessCompleteError',
    MissingItemTransferPickedItemsMustBePlacedToQuarantineToteOnProblemSolverAddresss = 'MissingItemTransfer_PickedItemsMustBePlacedToQuarantineToteOnProblemSolverAddresss',
    MissingItemTransferPickedItemsMustBePlacedToQuarantineToteOnPackingAddress = 'MissingItemTransfer_PickedItemsMustBePlacedToQuarantineToteOnPackingAddress',
    MissingItemTransferSalesOrderStateNotSuitable = 'MissingItemTransfer_SalesOrderStateNotSuitable',
    MissingItemTransferQuarantineToteAlreadyAssignedToAnotherSalesOrder = 'MissingItemTransfer_QuarantineToteAlreadyAssignedToAnotherSalesOrder',
    MissingItemTransferToteIsNotAvailableForPutIntoCancelledOrder = 'MissingItemTransfer_ToteIsNotAvailableForPutIntoCancelledOrder',
    MissingItemTransferToteHasSameProductWithDifferentOperation = 'MissingItemTransfer_ToteHasSameProductWithDifferentOperation',
    MissingItemTransferPickingItemsCannotBeGreaterThanPickedMissingItemsInPickingTote = 'MissingItemTransfer_PickingItemsCannotBeGreaterThanPickedMissingItemsInPickingTote',
    MissingItemTransferQuarantineToteSalesOrderCancelled = 'MissingItemTransfer_QuarantineToteSalesOrderCancelled',
    MissingItemTransferPickedItemAmountCannotBeGreaterThanSalesOrderItemAmount = 'MissingItemTransfer_PickedItemAmountCannotBeGreaterThanSalesOrderItemAmount',
    ToteToteIsUsedForSingleItemPackingProcess = 'Tote_ToteIsUsedForSingleItemPackingProcess',
    ProductControlCountingSerialNumberReadIsNotSameAsExpectedSerialNumber = 'ProductControlCounting_SerialNumberReadIsNotSameAsExpectedSerialNumber',
    TransferThereIsNoProductToTransfer = 'Transfer_ThereIsNoProductToTransfer',
    SimpleSerialNumberToteLabelCannotBeSimpleSerialNumber = 'SimpleSerialNumber_ToteLabelCannotBeSimpleSerialNumber',
    SimpleSerialNumberBarcodeCannotBeSimpleSerialNumber = 'SimpleSerialNumber_BarcodeCannotBeSimpleSerialNumber',
    SimpleSerialNumberIsUsedForAnotherSaleOrder = 'SimpleSerialNumber_IsUsedForAnotherSaleOrder',
    PackingSimpleSerialNumberRequiredForThisProduct = 'Packing_SimpleSerialNumberRequiredForThisProduct',
    SimpleSerialNumberCargoPackageCannotBeSimpleSerialNumber = 'SimpleSerialNumber_CargoPackageCannotBeSimpleSerialNumber',
    HovPackingDuplicateSimpleSerialNumberCantBeAdded = 'HOVPacking_DuplicateSimpleSerialNumberCantBeAdded',
    TransferTrolleyCannotPlaceToPackingAddress = 'TransferTrolley_CannotPlaceToPackingAddress',
    TransferTrolleyCannotBeTransferred = 'TransferTrolley_CannotBeTransferred',
    PickingInvalidQrCode = 'Picking_InvalidQrCode',
    PickingInvalidPickingStateQrCode = 'Picking_InvalidPickingStateQrCode',
    PickingToteCountMustBeSameWithSalesOrderCount = 'Picking_ToteCountMustBeSameWithSalesOrderCount',
    PickingToteNotFound = 'Picking_ToteNotFound',
    PickingToteAssignedAnotherSalesOrder = 'Picking_ToteAssignedAnotherSalesOrder',
    PickingToteAssignedAnotherVehicle = 'Picking_ToteAssignedAnotherVehicle',
    PickingToteAlreadyStarted = 'Picking_ToteAlreadyStarted',
    PickingStockCellWasNotFound = 'Picking_StockCellWasNotFound',
    PackingToteIsUsedForAnotherPackingQuarantineProcess = 'Packing_ToteIsUsedForAnotherPackingQuarantineProcess',
    PackingCantQuarantineAllItems = 'Packing_CantQuarantineAllItems',
    ReceivingPalletContainsProductsFromDifferentZones = 'Receiving_PalletContainsProductsFromDifferentZones',
    ReceivingPalletBarcodeInvalid = 'Receiving_PalletBarcodeInvalid',
    ReceivingPalletInvalidState = 'Receiving_PalletInvalidState',
    ReceivingPalletHasSameSkuFromDifferentOperation = 'Receiving_PalletHasSameSKUFromDifferentOperation',
    ReceivingInvalidContainerToMovePalletItem = 'Receiving_InvalidContainerToMovePalletItem',
    PutAwayCellContainsSameProductWithDifferentExpirationDate = 'PutAway_CellContainsSameProductWithDifferentExpirationDate',
    ReceivingTransferExpirationDateRequiredProduct = 'ReceivingTransfer_ExpirationDateRequiredProduct',
    ReceivingTransferSkuNotFoundInContainer = 'ReceivingTransfer_SkuNotFoundInContainer',
    ReceivingTransferNotEnoughItem = 'ReceivingTransfer_NotEnoughItem',
    PutAwayNoStockZoneFoundForProduct = 'PutAway_NoStockZoneFoundForProduct',
    PutAwayProductsStockZoneNotValidForCell = 'PutAway_ProductsStockZoneNotValidForCell',
    ReceivingCantMovePalletItemToToteWithoutReceivingProcess = 'Receiving_CantMovePalletItemToToteWithoutReceivingProcess',
    ReceivingTransferInvalidExpirationDate = 'ReceivingTransfer_InvalidExpirationDate',
    ToteTransferTrolleyCannotBeUsed = 'ToteTransfer_TrolleyCannotBeUsed',
    ToteTransferWrongTote = 'ToteTransfer_WrongTote',
    ReceivingTransferInvalidTargetContainer = 'ReceivingTransfer_InvalidTargetContainer',
    ReceivingTransferInvalidSourceContainer = 'ReceivingTransfer_InvalidSourceContainer',
    SortingSalesOrderAlreadyInSortingState = 'Sorting_SalesOrderAlreadyInSortingState',
    SortingCancelledSalesOrderCannotBeSorted = 'Sorting_CancelledSalesOrderCannotBeSorted',
    PickingBatchAlreadyInPickingState = 'Picking_BatchAlreadyInPickingState',
    SortingBatchAlreadyInSortingState = 'Sorting_BatchAlreadyInSortingState',
    SortingInvalidBatchState = 'Sorting_InvalidBatchState',
    SortingProcessUnavailableBatchTrolley = 'SortingProcess_UnavailableBatchTrolley',
    SortingProcessUnavailableRebinTrolley = 'SortingProcess_UnavailableRebinTrolley',
    BatchPickingInvalidTotelabel = 'BatchPicking_InvalidTotelabel',
    BatchPickingInvalidProductBarcode = 'BatchPicking_InvalidProductBarcode',
    BatchPickingToteAlreadyMounted = 'BatchPicking_ToteAlreadyMounted',
    BatchPickingToteAssignedToAnotherPickList = 'BatchPicking_ToteAssignedToAnotherPickList',
    BatchPickingToteCountMustBeSameAsConfig = 'BatchPicking_ToteCountMustBeSameAsConfig',
    BatchPickingDropAddressNotFound = 'BatchPicking_DropAddressNotFound',
    TransferBatchPickingStarted = 'Transfer_BatchPickingStarted',
    StockCountingBatchPickingStarted = 'StockCounting_BatchPickingStarted',
    SortingProcessBatchTrolleyInUseByAnotherOperator = 'SortingProcess_BatchTrolleyInUseByAnotherOperator',
    SortingProcessRebinTrolleyInUseByAnotherProcess = 'SortingProcess_RebinTrolleyInUseByAnotherProcess',
    SortingProcessRebinTrolleysAlreadyAssigned = 'SortingProcess_RebinTrolleysAlreadyAssigned',
    WallToWallStockCountingWrongQuarantineTote = 'WallToWallStockCounting_WrongQuarantineTote',
    WallToWallStockCountingUndamagedItemMoreThanDamagedItem = 'WallToWallStockCounting_UndamagedItemMoreThanDamagedItem',
    WallToWallStockCountingProductNotFoundInQuarantineTote = 'WallToWallStockCounting_ProductNotFoundInQuarantineTote',
    WallToWallStockCountingListAssignedToAnotherUser = 'WallToWallStockCounting_ListAssignedToAnotherUser',
    SorterSorterNotFound = 'Sorter_SorterNotFound',
    BatchPickingNoAvailableToteFound = 'BatchPicking_NoAvailableToteFound',
    SimplePickingTenantDoesntSupportSimplePickingProcess = 'SimplePicking_TenantDoesntSupportSimplePickingProcess',
    SimplePickingNoAvailableVirtualTrolleys = 'SimplePicking_NoAvailableVirtualTrolleys',
    SimplePickingStockZoneConfigurationNotFound = 'SimplePicking_StockZoneConfigurationNotFound',
    SimplePickingAmountEnteredCantBeLessThanThreshold = 'SimplePicking_AmountEnteredCantBeLessThanThreshold',
    SimplePickingAmountEnteredShouldBeEqualToExpected = 'SimplePicking_AmountEnteredShouldBeEqualToExpected',
    SimplePickingInvalidPickingReferenceNumber = 'SimplePicking_InvalidPickingReferenceNumber',
    SimplePackingStockZoneConfigurationNotFound = 'SimplePacking_StockZoneConfigurationNotFound',
    ReceivingProcessWrongTote = 'ReceivingProcess_WrongTote',
    BatchPickingAllPickListsAlreadyStarted = 'BatchPicking_AllPickListsAlreadyStarted',
    PickingPickListWithQrCodeAlreadyStarted = 'Picking_PickListWithQrCodeAlreadyStarted',
    BatchPickingTrolleyNotL = 'BatchPicking_TrolleyNotL',
    BatchPickingTrolleyCantHaveTotes = 'BatchPicking_TrolleyCantHaveTotes',
    PickingBatchTrolleyIsNotValidForThisOperation = 'Picking_BatchTrolleyIsNotValidForThisOperation',
    PickingInvalidPlaceTrolleyAddress = 'Picking_InvalidPlaceTrolleyAddress',
    TransferHardAllocatedItemsAreNotAllowed = 'Transfer_HardAllocatedItemsAreNotAllowed',
    TransferItemTypeIsNotValid = 'Transfer_ItemTypeIsNotValid',
    ToteWranglingRebinSingleAddressNotFound = 'ToteWrangling_RebinSingleAddressNotFound',
    ToteWranglingRebinAddressNotFound = 'ToteWrangling_RebinAddressNotFound',
    PutAwayRasToteIsEmpty = 'PutAway_RasToteIsEmpty',
    PutAwayRasToteContainsNonEligibleProducts = 'PutAway_RasToteContainsNonEligibleProducts',
    PutAwayRasToteContainsProductsFromMultipleZones = 'PutAway_RasToteContainsProductsFromMultipleZones',
    PutAwayToteIsNotOnTrolley = 'PutAway_ToteIsNotOnTrolley',
    VasDefinitionAlreadyExists = 'VAS_DefinitionAlreadyExists',
    VasConditionAlreadyExists = 'VAS_ConditionAlreadyExists',
    RasReplenishmentWrongTypeVehicle = 'RasReplenishment_WrongTypeVehicle',
    RasReplenishmentToteContainsNonRestowItems = 'RasReplenishment_ToteContainsNonRestowItems',
    RasReplenishmentBarcodeNotFoundInRasZone = 'RasReplenishment_BarcodeNotFoundInRasZone',
    RasReplenishmentGivenToteNotOnTrolley = 'RasReplenishment_GivenToteNotOnTrolley',
    RasReplenishmentDifferentExpirationDate = 'RasReplenishment_DifferentExpirationDate',
    RasReplenishmentDifferentOperationWithSameBarcode = 'RasReplenishment_DifferentOperationWithSameBarcode',
    RasReplenishmentNotEnoughStock = 'RasReplenishment_NotEnoughStock',
    PackingRebinTrolleyIsInWrongState = 'Packing_RebinTrolleyIsInWrongState',
    NpsQrCodeIsNotInUriFormat = 'NPS_QrCodeIsNotInURIFormat',
    NpsWrongQrCodeDomain = 'NPS_WrongQrCodeDomain',
    NpsUsedQrCodeId = 'NPS_UsedQrCodeId',
    NpsInvalidGuidFormat = 'NPS_InvalidGuidFormat',
    NpsSalesOrderCanNotBeFound = 'NPS_SalesOrderCanNotBeFound',
    PickingNoPickingTrolley = 'Picking_NoPickingTrolley',
    StockCountingToteShouldBeEmpty = 'StockCounting_ToteShouldBeEmpty',
    PickingWrongToteAddress = 'Picking_WrongToteAddress',
    PickingToteAssignedToAnotherSalesOrder = 'Picking_ToteAssignedToAnotherSalesOrder',
    DispatchSalesOrderWaitingForSlam = 'Dispatch_SalesOrderWaitingForSlam',
    DispatchUnresolvedProblemOrSuspend = 'Dispatch_UnresolvedProblemOrSuspend',
    BatchPickingSalesOrderAlreadySorting = 'BatchPicking_SalesOrderAlreadySorting',
    TransferToteAssignedAndContainItems = 'Transfer_ToteAssignedAndContainItems',
    ToteWranglingTotesNotPlacedInBatchTrolley = 'ToteWrangling_TotesNotPlacedInBatchTrolley',
    ToteWranglingBatchTrolleyIsNotAvailable = 'ToteWrangling_BatchTrolleyIsNotAvailable',
    WallToWallStockCountingListAlreadyCompleted = 'WallToWallStockCounting_ListAlreadyCompleted',
    SalesOrderResourceAlreadyAssigned = 'SalesOrder_ResourceAlreadyAssigned',
    ToteWranglingAlreadyInProblemSolverAddress = 'ToteWrangling_AlreadyInProblemSolverAddress',
    RasBarcodeNotFound = 'Ras_BarcodeNotFound',
    RasToteNotFound = 'Ras_ToteNotFound',
    RasToteNotAvailable = 'Ras_ToteNotAvailable',
    RasToteAlreadyAtStation = 'Ras_ToteAlreadyAtStation',
    RasToteNotAtStation = 'Ras_ToteNotAtStation',
    RasProductNotFound = 'Ras_ProductNotFound',
    RasCellNotFound = 'Ras_CellNotFound',
    RasCellNotInPodAtStation = 'Ras_CellNotInPodAtStation',
    RasSlotIsNotEmpty = 'Ras_SlotIsNotEmpty',
    RasNoAvailableToteFound = 'Ras_NoAvailableToteFound',
    RasPickListNotFound = 'Ras_PickListNotFound',
    RasPickItemNotFound = 'Ras_PickItemNotFound',
    RasNoToteAtStation = 'Ras_NoToteAtStation',
    RasStowLastTote = 'Ras_StowLastTote',
    RasToteBelongToAnotherPickList = 'Ras_ToteBelongToAnotherPickList',
    StockCellTypeNameAlreadyExists = 'StockCellType_NameAlreadyExists',
    StockCellTypeIdNotFound = 'StockCellType_IdNotFound',
    StockCellTypeDuplicateAssignment = 'StockCellType_DuplicateAssignment',
    StockCellTypeInvalidAssignmentZoneNotFound = 'StockCellType_InvalidAssignment_ZoneNotFound',
    StockCellTypeInvalidAssignmentCellNotFound = 'StockCellType_InvalidAssignment_CellNotFound',
    StockCellTypeInvalidAssignmentCellTypeNotFound = 'StockCellType_InvalidAssignment_CellTypeNotFound',
    PutAwayRasCellCanNotContainProductsFromMultipleZones = 'PutAway_RasCellCanNotContainProductsFromMultipleZones',
    PutAwayRasToteAlreadyAtDifferentStation = 'PutAway_RasToteAlreadyAtDifferentStation',
    PutAwayRasToteHasProductNotInStockZone = 'PutAway_RasToteHasProductNotInStockZone',
    PutAwayRasToteHasProductNotInRasZone = 'PutAway_RasToteHasProductNotInRasZone',
    RasToteAlreadyAtDifferentStation = 'Ras_ToteAlreadyAtDifferentStation',
    TransferSalesOrderNotFound = 'Transfer_SalesOrderNotFound',
    TransferSalesOrderPackingNotCompleted = 'Transfer_SalesOrderPackingNotCompleted',
    TransferHoldingZoneAddressNotFound = 'Transfer_HoldingZoneAddressNotFound',
    PutAwayToteHaveUnmeasuredItems = 'PutAway_ToteHaveUnmeasuredItems',
    BatchPickingProductNotFound = 'BatchPicking_ProductNotFound',
    BatchPickingToteNotFound = 'BatchPicking_ToteNotFound',
    SalesOrderSalesOrderOrCargoPackageNotFound = 'SalesOrder_SalesOrderOrCargoPackageNotFound',
    SalesOrderSalesOrderIsNotManualDelivery = 'SalesOrder_SalesOrderIsNotManualDelivery',
    SalesOrderMultipleSalesOrderWithReferenceNumber = 'SalesOrder_MultipleSalesOrderWithReferenceNumber',
    TransferSalesOrderCargoPackageNotFound = 'Transfer_SalesOrderCargoPackageNotFound',
    TransferCargoPackageHasNoSalesOrder = 'Transfer_CargoPackageHasNoSalesOrder',
    TransferCargoPackageDoesntBelongToSalesOrder = 'Transfer_CargoPackageDoesntBelongToSalesOrder',
    PickingPickListRequestNameAlreadyExist = 'Picking_PickListRequestNameAlreadyExist',
    BatchPickingPickListIsNotCompleted = 'BatchPicking_PickListIsNotCompleted',
    SortingProcessToteNotAssignedToSalesOrder = 'SortingProcessToteNotAssignedToSalesOrder',
    SortingProcessToteNotAssignedToPickList = 'SortingProcessToteNotAssignedToPickList',
    SortingProcessEmptyTote = 'SortingProcessEmptyTote',
    SortingProcessToteNotFound = 'SortingProcessToteNotFound',
    SortingProcessBatchTrolleyNotFound = 'SortingProcessBatchTrolleyNotFound',
    SortingProcessBatchTrolleyNotReady = 'SortingProcessBatchTrolleyNotReady',
    SortingProcessInvalidToteFlow = 'SortingProcessInvalidToteFlow',
    SortingProcessToteAlreadyAssignedSalesOrder = 'SortingProcessToteAlreadyAssignedSalesOrder',
    SortingProcessNoAvailableTote = 'SortingProcessNoAvailableTote',
    ParkAddressNotFound = 'ParkAddress_NotFound',
    SortingProcessToteContainsItems = 'SortingProcessToteContainsItems',
    PackingToteNotAssignedPickListOrSalesOrder = 'Packing_ToteNotAssignedPickListOrSalesOrder',
    PackingToteNotAvailable = 'Packing_ToteNotAvailable',
    PackingToteNotFound = 'Packing_ToteNotFound',
    PackingCannotRemoveInternationalCargoPackage = 'Packing_CannotRemoveInternationalCargoPackage',
    SortingProcessToteAssignedToPickList = 'SortingProcessToteAssignedToPickList',
    SortingProcessDropAddressNotFound = 'SortingProcessDropAddressNotFound',
    SortingProcessBatchTrolleyNotCompleteLoading = 'SortingProcessBatchTrolleyNotCompleteLoading',
    SortingProcessToteNotOnParkOrDropAddress = 'SortingProcessToteNotOnParkOrDropAddress',
    PickingToteAssignedPickList = 'Picking_ToteAssignedPickList',
    PutAwayToteHasNoItemOrItemsToBePlacedInDifferentZones = 'PutAway_ToteHasNoItemOrItemsToBePlacedInDifferentZones',
    PutAwayNoSuitableStockCellFound = 'PutAway_NoSuitableStockCellFound',
    PutAwayToteIsNotBoundToTrolley = 'PutAway_ToteIsNotBoundToTrolley',
    PutAwayToteIsEmptyForCellSuggestion = 'PutAway_ToteIsEmptyForCellSuggestion',
    PutAwayTrolleyHaveDifferentZoneTotes = 'PutAway_TrolleyHaveDifferentZoneTotes',
    PutAwayCellIsDifferentFromExpectedCell = 'PutAway_CellIsDifferentFromExpectedCell',
    PutAwayProductIsDifferentFromExpectedProduct = 'PutAway_ProductIsDifferentFromExpectedProduct',
    PutAwayProductCountIsGraterThanProductsInTote = 'PutAway_ProductCountIsGraterThanProductsInTote',
    QuickPutAwayInboundBoxHasNoPurchaseOrder = 'QuickPutAway_InboundBoxHasNoPurchaseOrder',
    QuickPutAwayPurchaseOrderIsCompleted = 'QuickPutAway_PurchaseOrderIsCompleted',
    QuickPutAwayNoInboundBoxFound = 'QuickPutAway_NoInboundBoxFound',
    QuickPutAwayWrongProductBarcode = 'QuickPutAway_WrongProductBarcode',
    QuickPutAwayWrongCellLabel = 'QuickPutAway_WrongCellLabel',
    QuickPutAwayIncompatibleProductZone = 'QuickPutAway_IncompatibleProductZone',
    LostItemNoItemsFoundForMissingCounterIncrement = 'LostItem_NoItemsFoundForMissingCounterIncrement',
    LostItemNoItemsFoundForMissingCounterReset = 'LostItem_NoItemsFoundForMissingCounterReset',
    TransferToteNotAvailable = 'Transfer_ToteNotAvailable',
    TransferToteContainsNonRestowItems = 'Transfer_ToteContainsNonRestowItems',
    TransferCellIsNeitherPrimeNorReserved = 'Transfer_CellIsNeitherPrimeNorReserved',
    TransferPrimeCellContainsNoStockOrSoftAllocatedItems = 'Transfer_PrimeCellContainsNoStockOrSoftAllocatedItems',
    TransferReservedCellContainsNoReservedOrReservedAllocatedItems = 'Transfer_ReservedCellContainsNoReservedOrReservedAllocatedItems',
    TransferCellDoesntContainAnyTransferrableItems = 'Transfer_CellDoesntContainAnyTransferrableItems',
    TransferCellDoesntContainEnoughTransferrableItems = 'Transfer_CellDoesntContainEnoughTransferrableItems',
    TransferToteContainsDifferentProductWithSameBarcode = 'Transfer_ToteContainsDifferentProductWithSameBarcode',
    TransferSerialNumbersAreNotProvidedForProduct = 'Transfer_SerialNumbersAreNotProvidedForProduct',
    TransferToteIsAssignedToPickList = 'Transfer_ToteIsAssignedToPickList',
    TransferToteIsAssignedToSalesOrder = 'Transfer_ToteIsAssignedToSalesOrder',
    TransferStockCellNotFound = 'Transfer_StockCellNotFound',
    TransferWrongProductBarcodeOrDoesntExistInCell = 'Transfer_WrongProductBarcodeOrDoesntExistInCell',
    TransferCellDoesntContainAnyItems = 'Transfer_CellDoesntContainAnyItems',
    TransferPrimeCellContainsOnlyHardAllocatedItems = 'Transfer_PrimeCellContainsOnlyHardAllocatedItems',
    SortingProcessTotePackingNotCompleted = 'SortingProcess_TotePackingNotCompleted',
    SalesOrderInvalidForApprove = 'SalesOrder_InvalidForApprove',
    SalesOrderInvalidStateForApprove = 'SalesOrder_InvalidStateForApprove',
    SlamSalesOrderMustBeApproved = 'SLAM_SalesOrderMustBeApproved',
    SlamCargoPackageLabelUrlError = 'SLAM_CargoPackageLabelUrlError',
    SlamInvalidAddressForSalesOrder = 'SLAM_InvalidAddressForSalesOrder',
    SlamSalesOrderPackingMustBeCompleted = 'SLAM_SalesOrderPackingMustBeCompleted',
    ReturnSalesOrderNotEligibleForReturn = 'Return_SalesOrderNotEligibleForReturn',
    ReturnSalesOrderIsCancelled = 'Return_SalesOrderIsCancelled',
    PutAwayProductStockZoneNotDefined = 'PutAway_ProductStockZoneNotDefined',
    BatchPickingToteIsNotAvailable = 'BatchPicking_ToteIsNotAvailable',
    StockCountingToteBelongsToPickListOrSalesOrder = 'StockCounting_ToteBelongsToPickListOrSalesOrder',
    SlamSalesOrderAlreadyPassedSlam = 'SLAM_SalesOrderAlreadyPassedSLAM',
    SlamCargoPackageIsReadyToShip = 'SLAM_CargoPackageIsReadyToShip',
    ReturnToteHaveOtherItemTypesThanReceived = 'Return_ToteHaveOtherItemTypesThanReceived',
    TransferToteIsAssignedToVehicle = 'Transfer_ToteIsAssignedToVehicle',
    TransferToteNotContainEnoughItems = 'Transfer_ToteNotContainEnoughItems',
    TransferSourceToteNotFound = 'Transfer_SourceToteNotFound',
    TransferTargetToteNotFound = 'Transfer_TargetToteNotFound',
    TransferToteDoesntContainAnyItem = 'Transfer_ToteDoesntContainAnyItem',
    TransferToteDoesntContainAnyTransferrableItems = 'Transfer_ToteDoesntContainAnyTransferrableItems',
    TransferWrongProductBarcodeOrDoesntExistInTote = 'Transfer_WrongProductBarcodeOrDoesntExistInTote',
    TransferToteContainsSameProductDifferentExpirationDate = 'Transfer_ToteContainsSameProductDifferentExpirationDate',
    TransferInvalidItemTypeToTransfer = 'Transfer_InvalidItemTypeToTransfer',
    TransferInvalidItemTypeForTargetTote = 'Transfer_InvalidItemTypeForTargetTote',
    CountingOutOfStockProblemCantBeAddedForCancelledSalesOrder = 'Counting_OutOfStockProblemCantBeAddedForCancelledSalesOrder',
    CountingOutOfStockProblemCantBeAddedForNotCreatedSalesOrder = 'Counting_OutOfStockProblemCantBeAddedForNotCreatedSalesOrder',
    PickingRouteUpdated = 'Picking_RouteUpdated',
    WallToWallStockCountingListCountedByAnotherUser = 'WallToWallStockCounting_ListCountedByAnotherUser',
    RebinTrolleyInUse = 'RebinTrolley_InUse',
    RebinTrolleyNotRelatedToOrder = 'RebinTrolley_NotRelatedToOrder',
    ProblematicTotesInvalidBarcode = 'ProblematicTotes_InvalidBarcode',
    ToteNotMissingItemPickList = 'Tote_NotMissingItemPickList',
    ToteNotRelatedToOrder = 'Tote_NotRelatedToOrder',
    PickingTrolleyNotRelatedToOrder = 'PickingTrolley_NotRelatedToOrder',
    PackingCargoPackageTypeIsDisabled = 'Packing_CargoPackageTypeIsDisabled',
    PutAwayStartedByAnotherUser = 'PutAway_StartedByAnotherUser',
    ReturnStartedByAnotherUser = 'Return_StartedByAnotherUser',
    SimpleSerialNumberNotFoundForCargoPackageAndProduct = 'SimpleSerialNumber_NotFoundForCargoPackageAndProduct',
    QuarantineWallSourceToteNotFound = 'QuarantineWall_SourceToteNotFound',
    QuarantineWallSourceToteNotAssignedToSalesOrder = 'QuarantineWall_SourceToteNotAssignedToSalesOrder',
    QuarantineWallTargetToteNotFound = 'QuarantineWall_TargetToteNotFound',
    QuarantineWallTargetToteAssignedToAnotherSalesOrder = 'QuarantineWall_TargetToteAssignedToAnotherSalesOrder',
    QuarantineWallSourceToteHasNotEnoughItem = 'QuarantineWall_SourceToteHasNotEnoughItem',
    QuarantineWallSourceToteHasNoItem = 'QuarantineWall_SourceToteHasNoItem',
    QuarantineWallSourceToteContainsNonPickingItem = 'QuarantineWall_SourceToteContainsNonPickingItem',
    QuarantineWallTargetToteContainsInvalidItem = 'QuarantineWall_TargetToteContainsInvalidItem',
    QuarantineWallTargetToteContainsDifferentZoneItem = 'QuarantineWall_TargetToteContainsDifferentZoneItem',
    QuarantineWallInvalidTargetTote = 'QuarantineWall_InvalidTargetTote',
    PackingUnpackableTote = 'Packing_UnpackableTote',
    PackingInternationalOrderSingleCargoPackageLimit = 'Packing_InternationalOrder_SingleCargoPackageLimit',
    PackingMarketplaceOrderSingleCargoPackageLimit = 'Packing_MarketplaceOrder_SingleCargoPackageLimit',
    PackingToteIsEmpty = 'Packing_ToteIsEmpty',
    PackingToteContainsNonPickingItems = 'Packing_ToteContainsNonPickingItems',
    PackingToteAtWrongAddress = 'Packing_ToteAtWrongAddress',
    PackingHovOrderNotSupported = 'Packing_HOVOrderNotSupported',
    PackingMultiItemOrderInTote = 'Packing_MultiItemOrderInTote',
    PackingWrongPickingFlow = 'Packing_WrongPickingFlow',
    PackingDropAddressNotFound = 'Packing_DropAddressNotFound',
    PackingCargoPackageRequired = 'Packing_CargoPackageRequired',
    PackingOperatorAlreadyAssigned = 'Packing_OperatorAlreadyAssigned',
    ReceivingLotNumberRequiredForProduct = 'Receiving_LotNumberRequiredForProduct',
    ReceivingPalletContainsSameProductDifferentLotNumber = 'Receiving_PalletContainsSameProductDifferentLotNumber',
    ReceivingToteContainsSameProductDifferentLotNumber = 'Receiving_ToteContainsSameProductDifferentLotNumber',
    PlaceProductThereIsNoProductWithLotNumber = 'PlaceProduct_ThereIsNoProductWithLotNumber',
    PlaceProductProductNeedsLotNumber = 'PlaceProduct_ProductNeedsLotNumber',
    ProductWithSameBarcodeAndDifferentLotNumberIsInCellWithSameOperation = 'ProductWithSameBarcodeAndDifferentLotNumberIsInCellWithSameOperation',
    TransferToteContainsSameProductDifferentLotNumber = 'Transfer_ToteContainsSameProductDifferentLotNumber',
    RasReplenishmentDifferentLotNumber = 'RasReplenishment_DifferentLotNumber',
    SingleItemPickingEnteredItemCountGreaterThanExpectedItemCount = 'SingleItemPicking_EnteredItemCountGreaterThanExpectedItemCount',
    SingleItemPickingNoHardAllocatedItemsFound = 'SingleItemPicking_NoHardAllocatedItemsFound',
    FastPackInternationalOrdersNotAllowed = 'FastPack_InternationalOrdersNotAllowed',
    FastPackVasNotAllowed = 'FastPack_VASNotAllowed',
    FastPackManualDeliveryNotAllowed = 'FastPack_ManualDeliveryNotAllowed',
    FastPackDifferentProductsInTote = 'FastPack_DifferentProductsInTote',
    FastPackWrongPickingFlow = 'FastPack_WrongPickingFlow',
    ReturnReturnPackageTrackingIdAlreadyExists = 'Return_ReturnPackageTrackingIdAlreadyExists',
    FastPackQuarantineAddressNotFound = 'FastPack_QuarantineAddressNotFound',
    FastPackQuarantineToteNotAvailable = 'FastPack_QuarantineToteNotAvailable',
    FastPackPickingToteHasNoCancelledOrders = 'FastPack_PickingToteHasNoCancelledOrders',
    FastPackQuarantineToteProductConflict = 'FastPack_QuarantineToteProductConflict',
    StockCountingLotNumberRequiredForCountedProducts = 'StockCounting_LotNumberRequiredForCountedProducts',
    StockCountingSameProductDifferentLotNumberError = 'StockCounting_SameProductDifferentLotNumberError',
    PackingToteContainsItemsNotInOrder = 'Packing_ToteContainsItemsNotInOrder',
    PackingToteHasDifferentAmount = 'Packing_ToteHasDifferentAmount',
    PackingToteContainsItemsNotInOrderAndDifferentAmount = 'Packing_ToteContainsItemsNotInOrderAndDifferentAmount',
    PackingOperatorNotAuthorized = 'Packing_OperatorNotAuthorized',
    PackingAlreadyAssignedToOperator = 'Packing_AlreadyAssignedToOperator',
    PackingSalesOrderPickingNotCompleted = 'Packing_SalesOrderPickingNotCompleted',
    PackingPickingToteCannotBeQuarantineTote = 'Packing_PickingToteCannotBeQuarantineTote',
    PackingQuarantineToteNotAvailable = 'Packing_QuarantineToteNotAvailable',
    PackingSalesOrderCancelled = 'Packing_SalesOrderCancelled',
    PackingQuarantineToteAlreadyAssigned = 'Packing_QuarantineToteAlreadyAssigned',
    PackingHovSalesOrderNotSupported = 'Packing_HOVSalesOrderNotSupported',
    PackingSameProductDifferentOperationInQuarantineTote = 'Packing_SameProductDifferentOperationInQuarantineTote',
    PackingQuarantineToteAlreadyContainsItems = 'Packing_QuarantineToteAlreadyContainsItems',
    PackingCargoPackageTypeNotDefinedForOperation = 'Packing_CargoPackageTypeNotDefinedForOperation',
    PackingInvalidQuarantineAddress = 'Packing_InvalidQuarantineAddress',
    InventoryItemsNoItemsFoundInContainerMatchingCriteria = 'InventoryItems_NoItemsFoundInContainerMatchingCriteria',
    InventoryItemsProductNotFoundInContainer = 'InventoryItems_ProductNotFoundInContainer',
    PackingToteIsAtMissingItemTransferAddress = 'Packing_ToteIsAtMissingItemTransferAddress',
    HovSalesOrderIsCancelled = 'HOV_SalesOrderIsCancelled',
    HovInvalidStateForPickingCompletion = 'HOV_InvalidStateForPickingCompletion',
    HovInvalidStateForPackingCompletion = 'HOV_InvalidStateForPackingCompletion',
    HovInvalidInventoryItemType = 'HOV_InvalidInventoryItemType',
    SupportMarketplaceOrderCannotUpdatePreferredCarrier = 'Support_MarketplaceOrderCannotUpdatePreferredCarrier',
    SupportProductLotNumberTrackingNotEnabled = 'Support_ProductLotNumberTrackingNotEnabled',
    SupportNoInventoryItemsFoundForSkuInContainer = 'Support_NoInventoryItemsFoundForSkuInContainer',
    ZoneTransferActivePicklistBlockingTransfer = 'ZoneTransfer_ActivePicklistBlockingTransfer',
    ZoneTransferNewZoneDefinitionsAlreadyExist = 'ZoneTransfer_NewZoneDefinitionsAlreadyExist',
    ZoneTransferItemsStillInOldZone = 'ZoneTransfer_ItemsStillInOldZone',
    ZoneTransferMixedContainerBlockingDirectTransfer = 'ZoneTransfer_MixedContainerBlockingDirectTransfer',
    SupportPrinterNotFound = 'Support_PrinterNotFound',
    SupportAddressNotFound = 'Support_AddressNotFound',
    SupportPrinterAddressNotFound = 'Support_PrinterAddressNotFound',
    SupportAddressAlreadyAssignedToPrinter = 'Support_AddressAlreadyAssignedToPrinter',
    PlaceProductProductCountExceedsAvailable = 'PlaceProduct_ProductCountExceedsAvailable',
    SimpleSerialNumberInvalidFormat = 'SimpleSerialNumber_InvalidFormat',
    SimpleSerialNumberDuplicateInSameOrder = 'SimpleSerialNumber_DuplicateInSameOrder',
    PackingPickingItemNotFoundInTote = 'Packing_PickingItemNotFoundInTote',
    PackingCargoPackagesEmpty = 'Packing_CargoPackagesEmpty',
    PackingCargoPackageIsSealedAtPacking = 'Packing_CargoPackageIsSealedAtPacking',
    PackingCargoPackageIsEmpty = 'Packing_CargoPackageIsEmpty',
    PackingCargoPackageIsNotSealedAtPacking = 'Packing_CargoPackageIsNotSealedAtPacking',
    PackingCargoPackageLabelMismatch = 'Packing_CargoPackageLabelMismatch',
    PackingUnsealCargoPackageNotEnabled = 'Packing_UnsealCargoPackageNotEnabled',
    RasSessionNotFound = 'Ras_SessionNotFound',
    RasPickingTrolleyNotFound = 'Ras_PickingTrolleyNotFound',
    RasPickingTrolleyHasNoTotes = 'Ras_PickingTrolleyHasNoTotes',
    RasStationNotFound = 'Ras_StationNotFound',
    RasPickingTrolleyAlreadyAssigned = 'Ras_PickingTrolleyAlreadyAssigned',
    RasToteBelongToAnotherSalesOrder = 'Ras_ToteBelongToAnotherSalesOrder',
    RasSalesOrderNotFound = 'Ras_SalesOrderNotFound',
    PickingTrolleyCapacityInsufficientForPickList = 'Picking_TrolleyCapacityInsufficientForPickList',
    PackingTrolleyNotAttachedToWallPackingAddress = 'Packing_TrolleyNotAttachedToWallPackingAddress',
    StockAdjustmentTrackedProductsNotSupported = 'StockAdjustment_TrackedProductsNotSupported',
    RasPickListMismatch = 'Ras_PickListMismatch',
    ReplenishmentJobNotFound = 'Replenishment_JobNotFound',
    ReplenishmentJobNotInProgress = 'Replenishment_JobNotInProgress',
    ReplenishmentJobNotClaimedByCurrentUser = 'Replenishment_JobNotClaimedByCurrentUser',
    ReplenishmentSourceCellNotFound = 'Replenishment_SourceCellNotFound',
    ReplenishmentNotEnoughStockInSourceCell = 'Replenishment_NotEnoughStockInSourceCell',
    ReplenishmentTargetCellNotFound = 'Replenishment_TargetCellNotFound',
    ReplenishmentTargetCellHasDifferentSku = 'Replenishment_TargetCellHasDifferentSku',
    ReplenishmentJobNotPending = 'Replenishment_JobNotPending',
    ReplenishmentJobAlreadyCompleted = 'Replenishment_JobAlreadyCompleted',
    CancelTrendyolItemOrderAlreadyFlushed = 'CancelTrendyolItem_OrderAlreadyFlushed',
    CancelTrendyolItemFlushBlockedByPendingCancellation = 'CancelTrendyolItem_FlushBlockedByPendingCancellation',
    RasDirectPutAwayProductNotFound = 'Ras_DirectPutAwayProductNotFound',
    RasDirectPutAwayBarcodeAmbiguous = 'Ras_DirectPutAwayBarcodeAmbiguous',
    ReplenishmentTargetSubZoneNotFound = 'Replenishment_TargetSubZoneNotFound',
    ReplenishmentTargetSubZoneDisabled = 'Replenishment_TargetSubZoneDisabled',
    ReplenishmentTargetCellOutsideTargetSubZone = 'Replenishment_TargetCellOutsideTargetSubZone',
    ReplenishmentPalletJobSourceCellMismatch = 'Replenishment_PalletJobSourceCellMismatch',
    ReplenishmentAllSourceCellsPalletLocked = 'Replenishment_AllSourceCellsPalletLocked',
    FastPackPackingProcessNotFound = 'FastPack_PackingProcessNotFound',
    FastPackProcessNotInProgress = 'FastPack_ProcessNotInProgress',
    FastPackSalesOrderInvalidPackingState = 'FastPack_SalesOrderInvalidPackingState'
}

/**
 * 
 * @export
 * @interface InventoryByProductQueryOutputDTO
 */
export interface InventoryByProductQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InventoryByProductQueryOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {AddressType}
     * @memberof InventoryByProductQueryOutputDTO
     */
    addressType?: AddressType;
    /**
     * 
     * @type {string}
     * @memberof InventoryByProductQueryOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {ContainerType}
     * @memberof InventoryByProductQueryOutputDTO
     */
    containerType?: ContainerType;
    /**
     * 
     * @type {InventoryItemTypeForQueries}
     * @memberof InventoryByProductQueryOutputDTO
     */
    itemType?: InventoryItemTypeForQueries;
    /**
     * 
     * @type {number}
     * @memberof InventoryByProductQueryOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryByProductQueryOutputDTO
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryByProductQueryOutputDTO
     */
    purchaseOrderReferenceNumbers?: string;
}
/**
 * 
 * @export
 * @interface InventoryByProductQueryOutputDTODynamicQueryOutputDTO
 */
export interface InventoryByProductQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<InventoryByProductQueryOutputDTO>}
     * @memberof InventoryByProductQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<InventoryByProductQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof InventoryByProductQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface InventoryCountOutputDTO
 */
export interface InventoryCountOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof InventoryCountOutputDTO
     */
    totalCount?: number;
}
/**
 * 
 * @export
 * @interface InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
 */
export interface InventoryItemExpirationDateAndSerialNoTrackingOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {ContainerType}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    containerType?: ContainerType;
    /**
     * 
     * @type {InventoryItemTypeForQueries}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    itemType?: InventoryItemTypeForQueries;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {AddressType}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    addressType?: AddressType;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    customerExpirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    serialNumber?: string;
}
/**
 * 
 * @export
 * @interface InventoryItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO
 */
export interface InventoryItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<InventoryItemExpirationDateAndSerialNoTrackingOutputDTO>}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO
     */
    data?: Array<InventoryItemExpirationDateAndSerialNoTrackingOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof InventoryItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface InventoryItemExpirationDateTrackingCountOutputDTO
 */
export interface InventoryItemExpirationDateTrackingCountOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof InventoryItemExpirationDateTrackingCountOutputDTO
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryItemExpirationDateTrackingCountOutputDTO
     */
    oneHundredEightyToExpiryDateCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryItemExpirationDateTrackingCountOutputDTO
     */
    ninetyToExpiryDateCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryItemExpirationDateTrackingCountOutputDTO
     */
    thirtyToExpiryDateCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryItemExpirationDateTrackingCountOutputDTO
     */
    sevenToExpiryDateCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryItemExpirationDateTrackingCountOutputDTO
     */
    dateExpiredCount?: number;
}
/**
 * 
 * @export
 * @interface InventoryItemGetByCargoPackageLabelGroupByDTO
 */
export interface InventoryItemGetByCargoPackageLabelGroupByDTO {
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByCargoPackageLabelGroupByDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByCargoPackageLabelGroupByDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByCargoPackageLabelGroupByDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByCargoPackageLabelGroupByDTO
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByCargoPackageLabelGroupByDTO
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByCargoPackageLabelGroupByDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByCargoPackageLabelGroupByDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByCargoPackageLabelGroupByDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByCargoPackageLabelGroupByDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {InventoryItemType}
     * @memberof InventoryItemGetByCargoPackageLabelGroupByDTO
     */
    itemType?: InventoryItemType;
    /**
     * 
     * @type {number}
     * @memberof InventoryItemGetByCargoPackageLabelGroupByDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByCargoPackageLabelGroupByDTO
     */
    expirationDate?: string;
}
/**
 * 
 * @export
 * @interface InventoryItemGetByToteLabelGroupByDTO
 */
export interface InventoryItemGetByToteLabelGroupByDTO {
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByToteLabelGroupByDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByToteLabelGroupByDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByToteLabelGroupByDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByToteLabelGroupByDTO
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByToteLabelGroupByDTO
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByToteLabelGroupByDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByToteLabelGroupByDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByToteLabelGroupByDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByToteLabelGroupByDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {InventoryItemType}
     * @memberof InventoryItemGetByToteLabelGroupByDTO
     */
    itemType?: InventoryItemType;
    /**
     * 
     * @type {number}
     * @memberof InventoryItemGetByToteLabelGroupByDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemGetByToteLabelGroupByDTO
     */
    expirationDate?: string;
}
/**
 * 
 * @export
 * @interface InventoryItemOutputDTO
 */
export interface InventoryItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InventoryItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryItemOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InventoryItemOutputDTO
     */
    isMasterCarton?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InventoryItemOutputDTO
     */
    masterCartonAmount?: number;
}
/**
 * 
 * @export
 * @interface InventoryItemSerialNumberTrackingCountOutputDTO
 */
export interface InventoryItemSerialNumberTrackingCountOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof InventoryItemSerialNumberTrackingCountOutputDTO
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryItemSerialNumberTrackingCountOutputDTO
     */
    serialNumberTrackedSKUCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryItemSerialNumberTrackingCountOutputDTO
     */
    serialNumberTrackedOperationCount?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum InventoryItemType {
    StockItem = 'StockItem',
    ReceivedItem = 'ReceivedItem',
    RestowItem = 'RestowItem',
    ReservedItem = 'ReservedItem',
    PickingItem = 'PickingItem',
    PackingItem = 'PackingItem',
    SoftAllocatedItem = 'SoftAllocatedItem',
    RestowAllocatedItem = 'RestowAllocatedItem',
    ReservedAllocatedItem = 'ReservedAllocatedItem',
    HardAllocatedItem = 'HardAllocatedItem',
    LostItem = 'LostItem',
    FoundItem = 'FoundItem',
    DamagedItem = 'DamagedItem',
    OutboundItem = 'OutboundItem'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum InventoryItemTypeForQueries {
    ReceivedItem = 'ReceivedItem',
    StockItem = 'StockItem',
    CellAllocatedItem = 'CellAllocatedItem',
    PickingItem = 'PickingItem',
    PackingItem = 'PackingItem',
    ShippingItem = 'ShippingItem',
    DeliveredItem = 'DeliveredItem',
    DamagedItem = 'DamagedItem',
    LostItem = 'LostItem',
    OutboundItem = 'OutboundItem',
    FoundItem = 'FoundItem',
    RestowItem = 'RestowItem',
    ReservedItem = 'ReservedItem'
}

/**
 * 
 * @export
 * @interface InventoryItemWithProductOutputDTO
 */
export interface InventoryItemWithProductOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof InventoryItemWithProductOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemWithProductOutputDTO
     */
    type?: string;
    /**
     * 
     * @type {ProductWithBarcodesOutputDTO}
     * @memberof InventoryItemWithProductOutputDTO
     */
    product?: ProductWithBarcodesOutputDTO;
}
/**
 * 
 * @export
 * @interface InventoryItemsByContainerOutputDTO
 */
export interface InventoryItemsByContainerOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InventoryItemsByContainerOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemsByContainerOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemsByContainerOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemsByContainerOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemsByContainerOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemsByContainerOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemsByContainerOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {InventoryItemType}
     * @memberof InventoryItemsByContainerOutputDTO
     */
    itemType?: InventoryItemType;
    /**
     * 
     * @type {number}
     * @memberof InventoryItemsByContainerOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemsByContainerOutputDTO
     */
    expirationDate?: string;
}
/**
 * 
 * @export
 * @interface InventoryItemsByProductOutputDTO
 */
export interface InventoryItemsByProductOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InventoryItemsByProductOutputDTO
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryItemsByProductOutputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface InventoryItemsODataDTOODataQueryOptions
 */
export interface InventoryItemsODataDTOODataQueryOptions {
    /**
     * 
     * @type {string}
     * @memberof InventoryItemsODataDTOODataQueryOptions
     */
    ifMatch?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryItemsODataDTOODataQueryOptions
     */
    ifNoneMatch?: string;
    /**
     * 
     * @type {HttpRequest}
     * @memberof InventoryItemsODataDTOODataQueryOptions
     */
    request?: HttpRequest;
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof InventoryItemsODataDTOODataQueryOptions
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {ODataRawQueryOptions}
     * @memberof InventoryItemsODataDTOODataQueryOptions
     */
    rawValues?: ODataRawQueryOptions;
    /**
     * 
     * @type {SelectExpandQueryOption}
     * @memberof InventoryItemsODataDTOODataQueryOptions
     */
    selectExpand?: SelectExpandQueryOption;
    /**
     * 
     * @type {ApplyQueryOption}
     * @memberof InventoryItemsODataDTOODataQueryOptions
     */
    apply?: ApplyQueryOption;
    /**
     * 
     * @type {ComputeQueryOption}
     * @memberof InventoryItemsODataDTOODataQueryOptions
     */
    compute?: ComputeQueryOption;
    /**
     * 
     * @type {FilterQueryOption}
     * @memberof InventoryItemsODataDTOODataQueryOptions
     */
    filter?: FilterQueryOption;
    /**
     * 
     * @type {SearchQueryOption}
     * @memberof InventoryItemsODataDTOODataQueryOptions
     */
    search?: SearchQueryOption;
    /**
     * 
     * @type {OrderByQueryOption}
     * @memberof InventoryItemsODataDTOODataQueryOptions
     */
    orderBy?: OrderByQueryOption;
    /**
     * 
     * @type {SkipQueryOption}
     * @memberof InventoryItemsODataDTOODataQueryOptions
     */
    skip?: SkipQueryOption;
    /**
     * 
     * @type {SkipTokenQueryOption}
     * @memberof InventoryItemsODataDTOODataQueryOptions
     */
    skipToken?: SkipTokenQueryOption;
    /**
     * 
     * @type {TopQueryOption}
     * @memberof InventoryItemsODataDTOODataQueryOptions
     */
    top?: TopQueryOption;
    /**
     * 
     * @type {CountQueryOption}
     * @memberof InventoryItemsODataDTOODataQueryOptions
     */
    count?: CountQueryOption;
    /**
     * 
     * @type {object}
     * @memberof InventoryItemsODataDTOODataQueryOptions
     */
    validator?: object;
}
/**
 * 
 * @export
 * @interface InventoryQueryByContainerLabelOutputDTO
 */
export interface InventoryQueryByContainerLabelOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByContainerLabelOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByContainerLabelOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByContainerLabelOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByContainerLabelOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByContainerLabelOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByContainerLabelOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByContainerLabelOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {InventoryItemTypeForQueries}
     * @memberof InventoryQueryByContainerLabelOutputDTO
     */
    itemType?: InventoryItemTypeForQueries;
    /**
     * 
     * @type {number}
     * @memberof InventoryQueryByContainerLabelOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByContainerLabelOutputDTO
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByContainerLabelOutputDTO
     */
    lotNumber?: string;
}
/**
 * 
 * @export
 * @interface InventoryQueryByContainerLabelOutputDTODynamicQueryOutputDTO
 */
export interface InventoryQueryByContainerLabelOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<InventoryQueryByContainerLabelOutputDTO>}
     * @memberof InventoryQueryByContainerLabelOutputDTODynamicQueryOutputDTO
     */
    data?: Array<InventoryQueryByContainerLabelOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof InventoryQueryByContainerLabelOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface InventoryQueryByZoneOutputDTO
 */
export interface InventoryQueryByZoneOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof InventoryQueryByZoneOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByZoneOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByZoneOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByZoneOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByZoneOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByZoneOutputDTO
     */
    productImageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByZoneOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {ProductType}
     * @memberof InventoryQueryByZoneOutputDTO
     */
    productType?: ProductType;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByZoneOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryByZoneOutputDTO
     */
    zone?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryQueryByZoneOutputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface InventoryQueryByZoneOutputDTODynamicQueryOutputDTO
 */
export interface InventoryQueryByZoneOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<InventoryQueryByZoneOutputDTO>}
     * @memberof InventoryQueryByZoneOutputDTODynamicQueryOutputDTO
     */
    data?: Array<InventoryQueryByZoneOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof InventoryQueryByZoneOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface InventoryQueryOutputDTO
 */
export interface InventoryQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {ContainerType}
     * @memberof InventoryQueryOutputDTO
     */
    containerType?: ContainerType;
    /**
     * 
     * @type {InventoryItemTypeForQueries}
     * @memberof InventoryQueryOutputDTO
     */
    itemType?: InventoryItemTypeForQueries;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryQueryOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof InventoryQueryOutputDTO
     */
    productType?: ProductType;
    /**
     * 
     * @type {AddressType}
     * @memberof InventoryQueryOutputDTO
     */
    addressType?: AddressType;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryOutputDTO
     */
    zone?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryOutputDTO
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryOutputDTO
     */
    customerExpirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryOutputDTO
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryQueryOutputDTO
     */
    lotNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InventoryQueryOutputDTO
     */
    isVehicle?: boolean;
}
/**
 * 
 * @export
 * @interface InventoryQueryOutputDTODynamicQueryOutputDTO
 */
export interface InventoryQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<InventoryQueryOutputDTO>}
     * @memberof InventoryQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<InventoryQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof InventoryQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface InventoryStatusByProductOutputDTO
 */
export interface InventoryStatusByProductOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof InventoryStatusByProductOutputDTO
     */
    availableStockCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryStatusByProductOutputDTO
     */
    stockItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryStatusByProductOutputDTO
     */
    restowItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryStatusByProductOutputDTO
     */
    reservedItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryStatusByProductOutputDTO
     */
    receivedItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryStatusByProductOutputDTO
     */
    pickingItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryStatusByProductOutputDTO
     */
    packingItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryStatusByProductOutputDTO
     */
    shippingItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryStatusByProductOutputDTO
     */
    deliveredItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryStatusByProductOutputDTO
     */
    damagedItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryStatusByProductOutputDTO
     */
    lostItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryStatusByProductOutputDTO
     */
    foundItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryStatusByProductOutputDTO
     */
    waitingForPickingItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryStatusByProductOutputDTO
     */
    expiredItemCount?: number;
}
/**
 * 
 * @export
 * @interface InvoiceInputDTO
 */
export interface InvoiceInputDTO {
    /**
     * 
     * @type {number}
     * @memberof InvoiceInputDTO
     */
    taxIncludedSalePrice?: number;
    /**
     * 
     * @type {Currency}
     * @memberof InvoiceInputDTO
     */
    taxIncludedSalePriceCurrency?: Currency;
    /**
     * 
     * @type {string}
     * @memberof InvoiceInputDTO
     */
    invoiceURL?: string;
}
/**
 * 
 * @export
 * @interface ItemCancelledRequest
 */
export interface ItemCancelledRequest {
    /**
     * 
     * @type {number}
     * @memberof ItemCancelledRequest
     */
    warehouseId?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemCancelledRequest
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemCancelledRequest
     */
    cancelDate?: string;
    /**
     * 
     * @type {number}
     * @memberof ItemCancelledRequest
     */
    cancelReasonId?: number;
}
/**
 * 
 * @export
 * @interface ItemPickedCommand
 */
export interface ItemPickedCommand {
    /**
     * 
     * @type {string}
     * @memberof ItemPickedCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemPickedCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemPickedCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemPickedCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemPickedCommand
     */
    pickListId?: string;
}
/**
 * 
 * @export
 * @interface ItemPlacedCommand
 */
export interface ItemPlacedCommand {
    /**
     * 
     * @type {string}
     * @memberof ItemPlacedCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemPlacedCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemPlacedCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemPlacedCommand
     */
    productBarcode?: string;
}
/**
 * 
 * @export
 * @interface ItemReceivedRequest
 */
export interface ItemReceivedRequest {
    /**
     * 
     * @type {number}
     * @memberof ItemReceivedRequest
     */
    warehouseId?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemReceivedRequest
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemReceivedRequest
     */
    receivedDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemReceivedRequest
     */
    receivedLocation?: string;
}
/**
 * 
 * @export
 * @interface ItemToPickOutputDTO
 */
export interface ItemToPickOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ItemToPickOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {number}
     * @memberof ItemToPickOutputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface KeySizes
 */
export interface KeySizes {
    /**
     * 
     * @type {number}
     * @memberof KeySizes
     */
    minSize?: number;
    /**
     * 
     * @type {number}
     * @memberof KeySizes
     */
    maxSize?: number;
    /**
     * 
     * @type {number}
     * @memberof KeySizes
     */
    skipSize?: number;
}
/**
 * 
 * @export
 * @interface LabelCargoPackageInputDTO
 */
export interface LabelCargoPackageInputDTO {
    /**
     * 
     * @type {string}
     * @memberof LabelCargoPackageInputDTO
     */
    cargoPackageLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof LabelCargoPackageInputDTO
     */
    labelUrl?: string;
}
/**
 * 
 * @export
 * @interface LeavePutAwayCommand
 */
export interface LeavePutAwayCommand {
    /**
     * 
     * @type {number}
     * @memberof LeavePutAwayCommand
     */
    putAwayReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface LineItemAcceptedExpirationDate
 */
export interface LineItemAcceptedExpirationDate {
    /**
     * 
     * @type {string}
     * @memberof LineItemAcceptedExpirationDate
     */
    expirationDate?: string;
    /**
     * 
     * @type {number}
     * @memberof LineItemAcceptedExpirationDate
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface ListCarriersOutputDTO
 */
export interface ListCarriersOutputDTO {
    /**
     * 
     * @type {Array<CarrierOutputDTO>}
     * @memberof ListCarriersOutputDTO
     */
    carriers?: Array<CarrierOutputDTO>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum LogicalOperator {
    None = 'None',
    AndAlso = 'AndAlso',
    OrElse = 'OrElse',
    And = 'And',
    Or = 'Or',
    Xor = 'Xor'
}

/**
 * 
 * @export
 * @interface LostItemCommand
 */
export interface LostItemCommand {
    /**
     * 
     * @type {number}
     * @memberof LostItemCommand
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof LostItemCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof LostItemCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface LostItemForHOVPickingCommand
 */
export interface LostItemForHOVPickingCommand {
    /**
     * 
     * @type {number}
     * @memberof LostItemForHOVPickingCommand
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof LostItemForHOVPickingCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemForHOVPickingCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof LostItemForHOVPickingCommand
     */
    productCount?: number;
    /**
     * 
     * @type {number}
     * @memberof LostItemForHOVPickingCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface LostItemForHOVPickingOutputDTO
 */
export interface LostItemForHOVPickingOutputDTO {
    /**
     * 
     * @type {RouteOutputDTO}
     * @memberof LostItemForHOVPickingOutputDTO
     */
    route?: RouteOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof LostItemForHOVPickingOutputDTO
     */
    expectedCurrentItemAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LostItemForHOVPickingOutputDTO
     */
    isCurrentItemCountEntryAllowed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LostItemForHOVPickingOutputDTO
     */
    missingItemsWithoutStockCount?: number;
}
/**
 * 
 * @export
 * @interface LostItemForSingleItemFastPackPickingCommand
 */
export interface LostItemForSingleItemFastPackPickingCommand {
    /**
     * 
     * @type {number}
     * @memberof LostItemForSingleItemFastPackPickingCommand
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof LostItemForSingleItemFastPackPickingCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemForSingleItemFastPackPickingCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof LostItemForSingleItemFastPackPickingCommand
     */
    productCount?: number;
    /**
     * 
     * @type {number}
     * @memberof LostItemForSingleItemFastPackPickingCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface LostItemForSingleItemFastPackPickingOutputDTO
 */
export interface LostItemForSingleItemFastPackPickingOutputDTO {
    /**
     * 
     * @type {RouteOutputDTO}
     * @memberof LostItemForSingleItemFastPackPickingOutputDTO
     */
    route?: RouteOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof LostItemForSingleItemFastPackPickingOutputDTO
     */
    expectedCurrentItemAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LostItemForSingleItemFastPackPickingOutputDTO
     */
    isCurrentItemCountEntryAllowed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LostItemForSingleItemFastPackPickingOutputDTO
     */
    missingItemsWithoutStockCount?: number;
}
/**
 * 
 * @export
 * @interface LostItemForSingleItemPickingCommand
 */
export interface LostItemForSingleItemPickingCommand {
    /**
     * 
     * @type {number}
     * @memberof LostItemForSingleItemPickingCommand
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof LostItemForSingleItemPickingCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemForSingleItemPickingCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof LostItemForSingleItemPickingCommand
     */
    productCount?: number;
    /**
     * 
     * @type {number}
     * @memberof LostItemForSingleItemPickingCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface LostItemForSingleItemPickingOutputDTO
 */
export interface LostItemForSingleItemPickingOutputDTO {
    /**
     * 
     * @type {RouteOutputDTO}
     * @memberof LostItemForSingleItemPickingOutputDTO
     */
    route?: RouteOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof LostItemForSingleItemPickingOutputDTO
     */
    expectedCurrentItemAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LostItemForSingleItemPickingOutputDTO
     */
    isCurrentItemCountEntryAllowed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LostItemForSingleItemPickingOutputDTO
     */
    missingItemsWithoutStockCount?: number;
}
/**
 * 
 * @export
 * @interface LostItemLogRecordOutputDTO
 */
export interface LostItemLogRecordOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof LostItemLogRecordOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemLogRecordOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemLogRecordOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemLogRecordOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemLogRecordOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemLogRecordOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemLogRecordOutputDTO
     */
    productBarcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemLogRecordOutputDTO
     */
    lostFrom?: string;
    /**
     * 
     * @type {LostItemLostDuringProcess}
     * @memberof LostItemLogRecordOutputDTO
     */
    lostDuringProcess?: LostItemLostDuringProcess;
    /**
     * 
     * @type {string}
     * @memberof LostItemLogRecordOutputDTO
     */
    operatorName?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemLogRecordOutputDTO
     */
    lostDateTime?: string;
}
/**
 * 
 * @export
 * @interface LostItemLogRecordOutputDTODynamicQueryOutputDTO
 */
export interface LostItemLogRecordOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<LostItemLogRecordOutputDTO>}
     * @memberof LostItemLogRecordOutputDTODynamicQueryOutputDTO
     */
    data?: Array<LostItemLogRecordOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof LostItemLogRecordOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum LostItemLostDuringProcess {
    Picking = 'Picking',
    LostItemPicking = 'LostItemPicking',
    Packing = 'Packing',
    StockCounting = 'StockCounting',
    PutAway = 'PutAway',
    MissingItemTransfer = 'MissingItemTransfer',
    Sorting = 'Sorting'
}

/**
 * 
 * @export
 * @interface LostItemOutputDto
 */
export interface LostItemOutputDto {
    /**
     * 
     * @type {string}
     * @memberof LostItemOutputDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemOutputDto
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemOutputDto
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof LostItemOutputDto
     */
    missingAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof LostItemOutputDto
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemOutputDto
     */
    serialNumber?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum LostItemProblemSolutionType {
    None = 'None',
    WaitForStock = 'WaitForStock',
    SendAsMissing = 'SendAsMissing',
    MissingItemsReadyToPick = 'MissingItemsReadyToPick'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum LostItemProblemState {
    None = 'None',
    Created = 'Created',
    AssignedToMissingItemPickList = 'AssignedToMissingItemPickList',
    WaitingForPutAway = 'WaitingForPutAway',
    WaitingForFeeding = 'WaitingForFeeding',
    Reviewed = 'Reviewed',
    SendAsMissing = 'SendAsMissing',
    WaitForStock = 'WaitForStock',
    Resolved = 'Resolved'
}

/**
 * 
 * @export
 * @interface LostItemQueryOutputDTO
 */
export interface LostItemQueryOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof LostItemQueryOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof LostItemQueryOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemQueryOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LostItemQueryOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LostItemQueryOutputDTO
     */
    latestContainer?: string;
    /**
     * 
     * @type {string}
     * @memberof LostItemQueryOutputDTO
     */
    lostAt?: string;
}
/**
 * 
 * @export
 * @interface LostItemQueryOutputDTODynamicQueryOutputDTO
 */
export interface LostItemQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<LostItemQueryOutputDTO>}
     * @memberof LostItemQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<LostItemQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof LostItemQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface LostRemainingItemsOfQuarantineWallToteCommand
 */
export interface LostRemainingItemsOfQuarantineWallToteCommand {
    /**
     * 
     * @type {string}
     * @memberof LostRemainingItemsOfQuarantineWallToteCommand
     */
    sourceToteLabel?: string;
}
/**
 * 
 * @export
 * @interface LotNumberInputDTO
 */
export interface LotNumberInputDTO {
    /**
     * 
     * @type {string}
     * @memberof LotNumberInputDTO
     */
    lotNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof LotNumberInputDTO
     */
    quantity?: number;
}
/**
 * 
 * @export
 * @interface MaestroPurchaseOrderLineItemInputDTO
 */
export interface MaestroPurchaseOrderLineItemInputDTO {
    /**
     * 
     * @type {string}
     * @memberof MaestroPurchaseOrderLineItemInputDTO
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof MaestroPurchaseOrderLineItemInputDTO
     */
    expectedAmount?: number;
}
/**
 * 
 * @export
 * @interface ManualDeliveryCargoPackagesOutputDTO
 */
export interface ManualDeliveryCargoPackagesOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ManualDeliveryCargoPackagesOutputDTO
     */
    cargoPackageId?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualDeliveryCargoPackagesOutputDTO
     */
    cargoPackageLabel?: string;
}
/**
 * 
 * @export
 * @interface ManualDeliverySalesOrderWithCargoPackagesOutputDTO
 */
export interface ManualDeliverySalesOrderWithCargoPackagesOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ManualDeliverySalesOrderWithCargoPackagesOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualDeliverySalesOrderWithCargoPackagesOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof ManualDeliverySalesOrderWithCargoPackagesOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof ManualDeliverySalesOrderWithCargoPackagesOutputDTO
     */
    deliveryTypeTag?: DeliveryTypeTag;
    /**
     * 
     * @type {number}
     * @memberof ManualDeliverySalesOrderWithCargoPackagesOutputDTO
     */
    cargoPackageCount?: number;
    /**
     * 
     * @type {Array<ManualDeliveryCargoPackagesOutputDTO>}
     * @memberof ManualDeliverySalesOrderWithCargoPackagesOutputDTO
     */
    cargoPackages?: Array<ManualDeliveryCargoPackagesOutputDTO>;
}
/**
 * 
 * @export
 * @interface ManualPicklistWaitingForPickingSalesOrdersOutputDTO
 */
export interface ManualPicklistWaitingForPickingSalesOrdersOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    orderSoldAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    orderCreatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    vehicleType?: string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {number}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    lineItemsCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    targetDispatchDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    marketPlaceAgreedDeliveryDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    isCutOff?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    isSoftCutOff?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    problemCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    city?: string;
    /**
     * 
     * @type {number}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    cargoCarrierName?: string;
    /**
     * 
     * @type {SalesOrderPickingPriority}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTO
     */
    pickingPriority?: SalesOrderPickingPriority;
}
/**
 * 
 * @export
 * @interface ManualPicklistWaitingForPickingSalesOrdersOutputDTODynamicQueryOutputDTO
 */
export interface ManualPicklistWaitingForPickingSalesOrdersOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ManualPicklistWaitingForPickingSalesOrdersOutputDTO>}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ManualPicklistWaitingForPickingSalesOrdersOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ManualPicklistWaitingForPickingSalesOrdersOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ManualReplenishmentAlternateCellDTO
 */
export interface ManualReplenishmentAlternateCellDTO {
    /**
     * 
     * @type {string}
     * @memberof ManualReplenishmentAlternateCellDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof ManualReplenishmentAlternateCellDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface ManualReplenishmentLineInputDTO
 */
export interface ManualReplenishmentLineInputDTO {
    /**
     * 
     * @type {string}
     * @memberof ManualReplenishmentLineInputDTO
     */
    productSku?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualReplenishmentLineInputDTO
     */
    sourceCellLabel?: string;
}
/**
 * 
 * @export
 * @interface ManualReplenishmentRowOutputDTO
 */
export interface ManualReplenishmentRowOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ManualReplenishmentRowOutputDTO
     */
    productSku?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualReplenishmentRowOutputDTO
     */
    sourceCellLabel?: string;
    /**
     * 
     * @type {ManualReplenishmentRowStatus}
     * @memberof ManualReplenishmentRowOutputDTO
     */
    status?: ManualReplenishmentRowStatus;
    /**
     * 
     * @type {Array<ManualReplenishmentRowReason>}
     * @memberof ManualReplenishmentRowOutputDTO
     */
    reasons?: Array<ManualReplenishmentRowReason>;
    /**
     * 
     * @type {number}
     * @memberof ManualReplenishmentRowOutputDTO
     */
    availableAmount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ManualReplenishmentRowOutputDTO
     */
    otherSkusInCell?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ManualReplenishmentRowOutputDTO
     */
    conflictingJobReferenceNumbers?: Array<string>;
    /**
     * 
     * @type {Array<ManualReplenishmentAlternateCellDTO>}
     * @memberof ManualReplenishmentRowOutputDTO
     */
    cellsWithStock?: Array<ManualReplenishmentAlternateCellDTO>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ManualReplenishmentRowReason {
    SkuNotFound = 'SkuNotFound',
    CellNotFound = 'CellNotFound',
    CellNotReservedCell = 'CellNotReservedCell',
    NoStockAtCell = 'NoStockAtCell',
    ConflictingOpenJob = 'ConflictingOpenJob',
    DuplicateRow = 'DuplicateRow',
    MixedCell = 'MixedCell'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ManualReplenishmentRowStatus {
    Ok = 'Ok',
    Warning = 'Warning',
    Blocked = 'Blocked'
}

/**
 * 
 * @export
 * @interface ManualReplenishmentValidationOutputDTO
 */
export interface ManualReplenishmentValidationOutputDTO {
    /**
     * 
     * @type {Array<ManualReplenishmentRowOutputDTO>}
     * @memberof ManualReplenishmentValidationOutputDTO
     */
    rows?: Array<ManualReplenishmentRowOutputDTO>;
}
/**
 * 
 * @export
 * @interface ManualVasRecordInputDto
 */
export interface ManualVasRecordInputDto {
    /**
     * 
     * @type {number}
     * @memberof ManualVasRecordInputDto
     */
    vasId?: number;
    /**
     * 
     * @type {string}
     * @memberof ManualVasRecordInputDto
     */
    operationId?: string;
    /**
     * 
     * @type {number}
     * @memberof ManualVasRecordInputDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ManualVasRecordInputDto
     */
    username?: string;
    /**
     * 
     * @type {VasDefinitionInputDTO}
     * @memberof ManualVasRecordInputDto
     */
    vasDetails?: VasDefinitionInputDTO;
    /**
     * 
     * @type {string}
     * @memberof ManualVasRecordInputDto
     */
    processReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualVasRecordInputDto
     */
    appliedAt?: string;
}
/**
 * 
 * @export
 * @interface ManualVasRecordOutputDTO
 */
export interface ManualVasRecordOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof ManualVasRecordOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {VasDefinitionOutputDTO}
     * @memberof ManualVasRecordOutputDTO
     */
    vasDefinition?: VasDefinitionOutputDTO;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof ManualVasRecordOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof ManualVasRecordOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ManualVasRecordOutputDTO
     */
    appliedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualVasRecordOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualVasRecordOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualVasRecordOutputDTO
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualVasRecordOutputDTO
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualVasRecordOutputDTO
     */
    processReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface ManualVasRecordOutputDTODynamicQueryOutputDTO
 */
export interface ManualVasRecordOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ManualVasRecordOutputDTO>}
     * @memberof ManualVasRecordOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ManualVasRecordOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ManualVasRecordOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ManuallyDeliverSalesOrdersCommand
 */
export interface ManuallyDeliverSalesOrdersCommand {
    /**
     * 
     * @type {Array<ManuallyDeliverSalesOrdersInputDTO>}
     * @memberof ManuallyDeliverSalesOrdersCommand
     */
    salesOrders?: Array<ManuallyDeliverSalesOrdersInputDTO>;
}
/**
 * 
 * @export
 * @interface ManuallyDeliverSalesOrdersInputDTO
 */
export interface ManuallyDeliverSalesOrdersInputDTO {
    /**
     * 
     * @type {string}
     * @memberof ManuallyDeliverSalesOrdersInputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ManuallyDeliverSalesOrdersInputDTO
     */
    trackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof ManuallyDeliverSalesOrdersInputDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface ManuallyDispatchSalesOrdersCommand
 */
export interface ManuallyDispatchSalesOrdersCommand {
    /**
     * 
     * @type {string}
     * @memberof ManuallyDispatchSalesOrdersCommand
     */
    carrierName?: string;
    /**
     * 
     * @type {Array<ManuallyDispatchSalesOrdersInputDTO>}
     * @memberof ManuallyDispatchSalesOrdersCommand
     */
    salesOrders?: Array<ManuallyDispatchSalesOrdersInputDTO>;
}
/**
 * 
 * @export
 * @interface ManuallyDispatchSalesOrdersInputDTO
 */
export interface ManuallyDispatchSalesOrdersInputDTO {
    /**
     * 
     * @type {string}
     * @memberof ManuallyDispatchSalesOrdersInputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ManuallyDispatchSalesOrdersInputDTO
     */
    trackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof ManuallyDispatchSalesOrdersInputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ManuallyDispatchSalesOrdersInputDTO
     */
    shipmentTrackingLinkUrl?: string;
}
/**
 * 
 * @export
 * @interface ManuallyPackSalesOrdersCommand
 */
export interface ManuallyPackSalesOrdersCommand {
    /**
     * 
     * @type {Array<ManuallyPackSalesOrdersInputDTO>}
     * @memberof ManuallyPackSalesOrdersCommand
     */
    salesOrders?: Array<ManuallyPackSalesOrdersInputDTO>;
}
/**
 * 
 * @export
 * @interface ManuallyPackSalesOrdersInputDTO
 */
export interface ManuallyPackSalesOrdersInputDTO {
    /**
     * 
     * @type {string}
     * @memberof ManuallyPackSalesOrdersInputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ManuallyPackSalesOrdersInputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {Array<CargoPackageInputDTO>}
     * @memberof ManuallyPackSalesOrdersInputDTO
     */
    packages?: Array<CargoPackageInputDTO>;
}
/**
 * 
 * @export
 * @interface MarkWaybillAsPrintedCommand
 */
export interface MarkWaybillAsPrintedCommand {
    /**
     * 
     * @type {string}
     * @memberof MarkWaybillAsPrintedCommand
     */
    referenceNumber?: string;
}
/**
 * 
 * @export
 * @interface MarketPlaceSalesOrderDeliverToDispatchCommand
 */
export interface MarketPlaceSalesOrderDeliverToDispatchCommand {
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderDeliverToDispatchCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderDeliverToDispatchCommand
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface MarketPlaceSalesOrderOutputDTO
 */
export interface MarketPlaceSalesOrderOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    marketPlaceName?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    externalOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    orderNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    shipmentPackageId?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    shipmentNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    supplierId?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    orderDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    shipmentPackageStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    deliveryType?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    deliveryAddressType?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    cargoProviderName?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    cargoTrackingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    cargoTrackingLink?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    cargoSenderNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    cargoDeci?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    isCargoScanned?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    cargoScannedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    cargoScanStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    agreedDeliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    extendedAgreedDeliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    estimatedDeliveryStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    estimatedDeliveryEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    originShipmentDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    packageLastModifiedDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    customerFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    customerLastName?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    customerEmail?: string;
    /**
     * 
     * @type {number}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    packageGrossAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    packageTotalPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    packageTotalDiscount?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    currencyCode?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    invoiceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    invoiceLink?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    invoiceStatus?: string;
    /**
     * 
     * @type {MarketPlaceSalesOrderSyncState}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    syncState?: MarketPlaceSalesOrderSyncState;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    fetchedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    fetchAttemptCount?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketPlaceSalesOrderOutputDTO
     */
    lastFetchError?: string;
}
/**
 * 
 * @export
 * @interface MarketPlaceSalesOrderOutputDTODynamicQueryOutputDTO
 */
export interface MarketPlaceSalesOrderOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<MarketPlaceSalesOrderOutputDTO>}
     * @memberof MarketPlaceSalesOrderOutputDTODynamicQueryOutputDTO
     */
    data?: Array<MarketPlaceSalesOrderOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof MarketPlaceSalesOrderOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MarketPlaceSalesOrderSyncState {
    Pending = 'Pending',
    Synced = 'Synced',
    Failed = 'Failed'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum MarketplaceCargoCarrierQuotaProblemState {
    None = 'None',
    Created = 'Created',
    CustomerServicesReviewed = 'CustomerServicesReviewed',
    Resolved = 'Resolved'
}

/**
 * 
 * @export
 * @interface MasterCartonDefinitionOutputDTO
 */
export interface MasterCartonDefinitionOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof MasterCartonDefinitionOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {number}
     * @memberof MasterCartonDefinitionOutputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface MasterCartonQueryOutputDTO
 */
export interface MasterCartonQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof MasterCartonQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof MasterCartonQueryOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof MasterCartonQueryOutputDTO
     */
    masterCartonSKU?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MasterCartonQueryOutputDTO
     */
    masterCartonBarcodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MasterCartonQueryOutputDTO
     */
    masterCartonImageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterCartonQueryOutputDTO
     */
    masterCartonName?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterCartonQueryOutputDTO
     */
    innerProductSKU?: string;
    /**
     * 
     * @type {number}
     * @memberof MasterCartonQueryOutputDTO
     */
    innerProductAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterCartonQueryOutputDTO
     */
    innerProductName?: string;
    /**
     * 
     * @type {ProductType}
     * @memberof MasterCartonQueryOutputDTO
     */
    type?: ProductType;
    /**
     * 
     * @type {string}
     * @memberof MasterCartonQueryOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface MasterCartonQueryOutputDTODynamicQueryOutputDTO
 */
export interface MasterCartonQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<MasterCartonQueryOutputDTO>}
     * @memberof MasterCartonQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<MasterCartonQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof MasterCartonQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface MatchingLineItemDTO
 */
export interface MatchingLineItemDTO {
    /**
     * 
     * @type {string}
     * @memberof MatchingLineItemDTO
     */
    returnLineItemId?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchingLineItemDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchingLineItemDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchingLineItemDTO
     */
    productSKU?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchingLineItemDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MatchingLineItemDTO
     */
    hasImages?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MatchingLineItemDTO
     */
    existingImageCount?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchingLineItemDTO
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchingLineItemDTO
     */
    expirationDate?: string;
}
/**
 * 
 * @export
 * @interface MeasurementDTO
 */
export interface MeasurementDTO {
    /**
     * 
     * @type {string}
     * @memberof MeasurementDTO
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof MeasurementDTO
     */
    value?: number;
}
/**
 * 
 * @export
 * @interface MissingCargoPackageLabelProblemDetailsOutputDTO
 */
export interface MissingCargoPackageLabelProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof MissingCargoPackageLabelProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingCargoPackageLabelProblemDetailsOutputDTO
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingCargoPackageLabelProblemDetailsOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {ProblemSource}
     * @memberof MissingCargoPackageLabelProblemDetailsOutputDTO
     */
    source?: ProblemSource;
    /**
     * 
     * @type {ProblemState}
     * @memberof MissingCargoPackageLabelProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {MissingCargoPackageLabelProblemState}
     * @memberof MissingCargoPackageLabelProblemDetailsOutputDTO
     */
    stateDetail?: MissingCargoPackageLabelProblemState;
    /**
     * 
     * @type {string}
     * @memberof MissingCargoPackageLabelProblemDetailsOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingCargoPackageLabelProblemDetailsOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingCargoPackageLabelProblemDetailsOutputDTO
     */
    resolutionNote?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MissingCargoPackageLabelProblemState {
    None = 'None',
    Created = 'Created',
    Resolved = 'Resolved'
}

/**
 * 
 * @export
 * @interface MissingItemOutputDTO
 */
export interface MissingItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof MissingItemOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingItemOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof MissingItemOutputDTO
     */
    missingCount?: number;
}
/**
 * 
 * @export
 * @interface MissingItemTransferProcessOutputDTO
 */
export interface MissingItemTransferProcessOutputDTO {
    /**
     * 
     * @type {Array<UnPickedMissingItemsOutputDTO>}
     * @memberof MissingItemTransferProcessOutputDTO
     */
    unPickedMissingItems?: Array<UnPickedMissingItemsOutputDTO>;
    /**
     * 
     * @type {Array<PickedItemsInQuarantineToteOutputDTO>}
     * @memberof MissingItemTransferProcessOutputDTO
     */
    pickedItemsInQuarantineTote?: Array<PickedItemsInQuarantineToteOutputDTO>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MissingItemTransferSalesOrderPickingState {
    None = 'None',
    AllItemsPicked = 'AllItemsPicked',
    AllItemsNotPicked = 'AllItemsNotPicked'
}

/**
 * 
 * @export
 * @interface MissingNotificationQueryOutputDTO
 */
export interface MissingNotificationQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof MissingNotificationQueryOutputDTO
     */
    cellName?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingNotificationQueryOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingNotificationQueryOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {number}
     * @memberof MissingNotificationQueryOutputDTO
     */
    missingNotification?: number;
    /**
     * 
     * @type {string}
     * @memberof MissingNotificationQueryOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingNotificationQueryOutputDTO
     */
    zone?: string;
}
/**
 * 
 * @export
 * @interface MissingNotificationQueryOutputDTODynamicQueryOutputDTO
 */
export interface MissingNotificationQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<MissingNotificationQueryOutputDTO>}
     * @memberof MissingNotificationQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<MissingNotificationQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof MissingNotificationQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface MissingSLAMLabelProblemDetailsOutputDTO
 */
export interface MissingSLAMLabelProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof MissingSLAMLabelProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingSLAMLabelProblemDetailsOutputDTO
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingSLAMLabelProblemDetailsOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {ProblemSource}
     * @memberof MissingSLAMLabelProblemDetailsOutputDTO
     */
    source?: ProblemSource;
    /**
     * 
     * @type {ProblemState}
     * @memberof MissingSLAMLabelProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {MissingSLAMLabelProblemState}
     * @memberof MissingSLAMLabelProblemDetailsOutputDTO
     */
    stateDetail?: MissingSLAMLabelProblemState;
    /**
     * 
     * @type {string}
     * @memberof MissingSLAMLabelProblemDetailsOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingSLAMLabelProblemDetailsOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingSLAMLabelProblemDetailsOutputDTO
     */
    resolutionNote?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MissingSLAMLabelProblemState {
    None = 'None',
    Created = 'Created',
    Resolved = 'Resolved'
}

/**
 * 
 * @export
 * @interface MissingSalesOrderCountsQueryOutputDTO
 */
export interface MissingSalesOrderCountsQueryOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderCountsQueryOutputDTO
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderCountsQueryOutputDTO
     */
    awaitingWallPlacementCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderCountsQueryOutputDTO
     */
    awaitingWallTransferCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderCountsQueryOutputDTO
     */
    awaitingLostPickingListCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderCountsQueryOutputDTO
     */
    awaitingCustomerSupportApprovalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderCountsQueryOutputDTO
     */
    packableCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderCountsQueryOutputDTO
     */
    awaitingStockCountingCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderCountsQueryOutputDTO
     */
    awaitingStockCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderCountsQueryOutputDTO
     */
    cancelledCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderCountsQueryOutputDTO
     */
    awaitingRestowCount?: number;
}
/**
 * 
 * @export
 * @interface MissingSalesOrderDetailsQueryOutputDTO
 */
export interface MissingSalesOrderDetailsQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof MissingSalesOrderDetailsQueryOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingSalesOrderDetailsQueryOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingSalesOrderDetailsQueryOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingSalesOrderDetailsQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingSalesOrderDetailsQueryOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {ProductState}
     * @memberof MissingSalesOrderDetailsQueryOutputDTO
     */
    productState?: ProductState;
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderDetailsQueryOutputDTO
     */
    missingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderDetailsQueryOutputDTO
     */
    sendAsMissingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderDetailsQueryOutputDTO
     */
    missingCounter?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MissingSalesOrderDetailsQueryOutputDTO
     */
    missingCells?: Array<string>;
}
/**
 * 
 * @export
 * @interface MissingSalesOrderDetailsQueryOutputDTODynamicQueryOutputDTO
 */
export interface MissingSalesOrderDetailsQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<MissingSalesOrderDetailsQueryOutputDTO>}
     * @memberof MissingSalesOrderDetailsQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<MissingSalesOrderDetailsQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderDetailsQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface MissingSalesOrderQueryOutputDTO
 */
export interface MissingSalesOrderQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    orderCreatedAt?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {ProblemSolverStationProblemState}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    problemSolverState?: ProblemSolverStationProblemState;
    /**
     * 
     * @type {ProblemState}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    problemState?: ProblemState;
    /**
     * 
     * @type {LostItemProblemState}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    lostItemProblemState?: LostItemProblemState;
    /**
     * 
     * @type {SalesChannel}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {SalesOrderPickingPriority}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    priority?: SalesOrderPickingPriority;
    /**
     * 
     * @type {boolean}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    isSuspended?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    isCancelled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    isCutOff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {Array<string>}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    quarantineToteLabels?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    pickingToteLabels?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    missingQuantity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    hasQuarantineToteLabels?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    hasPickingToteLabels?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderQueryOutputDTO
     */
    timePassedSincePlacedToQuarantineWall?: number;
}
/**
 * 
 * @export
 * @interface MissingSalesOrderQueryOutputDTODynamicQueryOutputDTO
 */
export interface MissingSalesOrderQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<MissingSalesOrderQueryOutputDTO>}
     * @memberof MissingSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<MissingSalesOrderQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof MissingSalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface MountToteToBatchPickingTrolleyCommand
 */
export interface MountToteToBatchPickingTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof MountToteToBatchPickingTrolleyCommand
     */
    batchPickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof MountToteToBatchPickingTrolleyCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof MountToteToBatchPickingTrolleyCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface MountToteToBatchTrolleyCommand
 */
export interface MountToteToBatchTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof MountToteToBatchTrolleyCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof MountToteToBatchTrolleyCommand
     */
    batchTrolleyLabel?: string;
}
/**
 * 
 * @export
 * @interface MountToteToBatchTrolleyOutputDTO
 */
export interface MountToteToBatchTrolleyOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof MountToteToBatchTrolleyOutputDTO
     */
    isAllTotesLoaded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MountToteToBatchTrolleyOutputDTO
     */
    isHOVBatch?: boolean;
}
/**
 * 
 * @export
 * @interface MountToteToFastPackPickingTrolleyCommandOutputDTO
 */
export interface MountToteToFastPackPickingTrolleyCommandOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof MountToteToFastPackPickingTrolleyCommandOutputDTO
     */
    currentContainedItemsCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MountToteToFastPackPickingTrolleyCommandOutputDTO
     */
    isNewToteForTrolley?: boolean;
}
/**
 * 
 * @export
 * @interface MountToteToHOVPickingTrolleyCommand
 */
export interface MountToteToHOVPickingTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof MountToteToHOVPickingTrolleyCommand
     */
    hovPickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof MountToteToHOVPickingTrolleyCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface MountToteToHOVPickingTrolleyCommandOutputDTO
 */
export interface MountToteToHOVPickingTrolleyCommandOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof MountToteToHOVPickingTrolleyCommandOutputDTO
     */
    currentContainedItemsCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MountToteToHOVPickingTrolleyCommandOutputDTO
     */
    isNewToteForTrolley?: boolean;
}
/**
 * 
 * @export
 * @interface MountToteToSingleItemFastPackPickingTrolleyCommand
 */
export interface MountToteToSingleItemFastPackPickingTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof MountToteToSingleItemFastPackPickingTrolleyCommand
     */
    singleItemFastPackPickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof MountToteToSingleItemFastPackPickingTrolleyCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface MountToteToSingleItemPickingTrolleyCommand
 */
export interface MountToteToSingleItemPickingTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof MountToteToSingleItemPickingTrolleyCommand
     */
    singleItemPickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof MountToteToSingleItemPickingTrolleyCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface MountToteToSingleItemPickingTrolleyCommandOutputDTO
 */
export interface MountToteToSingleItemPickingTrolleyCommandOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof MountToteToSingleItemPickingTrolleyCommandOutputDTO
     */
    currentContainedItemsCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MountToteToSingleItemPickingTrolleyCommandOutputDTO
     */
    isNewToteForTrolley?: boolean;
}
/**
 * 
 * @export
 * @interface MountToteToToteSelectivePickingTrolleyCommand
 */
export interface MountToteToToteSelectivePickingTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof MountToteToToteSelectivePickingTrolleyCommand
     */
    toteSelectivePickingTrolleyLabel?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MountToteToToteSelectivePickingTrolleyCommand
     */
    toteLabels?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof MountToteToToteSelectivePickingTrolleyCommand
     */
    pickingReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface MoveContainerItemsCommand
 */
export interface MoveContainerItemsCommand {
    /**
     * 
     * @type {string}
     * @memberof MoveContainerItemsCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof MoveContainerItemsCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof MoveContainerItemsCommand
     */
    sourceContainerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof MoveContainerItemsCommand
     */
    targetContainerLabel?: string;
}
/**
 * 
 * @export
 * @interface MoveContainerItemsOutputDTO
 */
export interface MoveContainerItemsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof MoveContainerItemsOutputDTO
     */
    sourceContainerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof MoveContainerItemsOutputDTO
     */
    targetContainerLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof MoveContainerItemsOutputDTO
     */
    movedItemCount?: number;
}
/**
 * 
 * @export
 * @interface MoveContainersToZoneCommand
 */
export interface MoveContainersToZoneCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveContainersToZoneCommand
     */
    containerLabels?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MoveContainersToZoneCommand
     */
    zoneLabel?: string;
}
/**
 * 
 * @export
 * @interface MoveContainersToZoneOutputDTO
 */
export interface MoveContainersToZoneOutputDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveContainersToZoneOutputDTO
     */
    successfulContainers?: Array<string>;
    /**
     * 
     * @type {Array<SkippedContainerInfo>}
     * @memberof MoveContainersToZoneOutputDTO
     */
    skippedContainers?: Array<SkippedContainerInfo>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveContainersToZoneOutputDTO
     */
    notFoundContainers?: Array<string>;
    /**
     * 
     * @type {Array<FailedContainerInfo>}
     * @memberof MoveContainersToZoneOutputDTO
     */
    failedContainers?: Array<FailedContainerInfo>;
    /**
     * 
     * @type {number}
     * @memberof MoveContainersToZoneOutputDTO
     */
    updatedAddressesCount?: number;
}
/**
 * 
 * @export
 * @interface MoveReceivedItemCommand
 */
export interface MoveReceivedItemCommand {
    /**
     * 
     * @type {string}
     * @memberof MoveReceivedItemCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof MoveReceivedItemCommand
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof MoveReceivedItemCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof MoveReceivedItemCommand
     */
    expirationDate?: string;
    /**
     * 
     * @type {number}
     * @memberof MoveReceivedItemCommand
     */
    productAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MoveReceivedItemCommand
     */
    force?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum NameCheckType {
    Contains = 'Contains',
    StartsWith = 'StartsWith',
    EndsWith = 'EndsWith',
    Equals = 'Equals'
}

/**
 * 
 * @export
 * @interface ODataEntitySetInfo
 */
export interface ODataEntitySetInfo {
    /**
     * 
     * @type {string}
     * @memberof ODataEntitySetInfo
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataEntitySetInfo
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataEntitySetInfo
     */
    title?: string;
    /**
     * 
     * @type {ODataTypeAnnotation}
     * @memberof ODataEntitySetInfo
     */
    typeAnnotation?: ODataTypeAnnotation;
}
/**
 * 
 * @export
 * @interface ODataFunctionImportInfo
 */
export interface ODataFunctionImportInfo {
    /**
     * 
     * @type {string}
     * @memberof ODataFunctionImportInfo
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataFunctionImportInfo
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataFunctionImportInfo
     */
    title?: string;
    /**
     * 
     * @type {ODataTypeAnnotation}
     * @memberof ODataFunctionImportInfo
     */
    typeAnnotation?: ODataTypeAnnotation;
}
/**
 * 
 * @export
 * @interface ODataPathSegment
 */
export interface ODataPathSegment {
    /**
     * 
     * @type {IEdmType}
     * @memberof ODataPathSegment
     */
    edmType?: IEdmType;
    /**
     * 
     * @type {string}
     * @memberof ODataPathSegment
     */
    identifier?: string;
}
/**
 * 
 * @export
 * @interface ODataQueryContext
 */
export interface ODataQueryContext {
    /**
     * 
     * @type {DefaultQuerySettings}
     * @memberof ODataQueryContext
     */
    defaultQuerySettings?: DefaultQuerySettings;
    /**
     * 
     * @type {IEdmModel}
     * @memberof ODataQueryContext
     */
    model?: IEdmModel;
    /**
     * 
     * @type {IEdmType}
     * @memberof ODataQueryContext
     */
    elementType?: IEdmType;
    /**
     * 
     * @type {IEdmNavigationSource}
     * @memberof ODataQueryContext
     */
    navigationSource?: IEdmNavigationSource;
    /**
     * 
     * @type {string}
     * @memberof ODataQueryContext
     */
    elementClrType?: string;
    /**
     * 
     * @type {Array<ODataPathSegment>}
     * @memberof ODataQueryContext
     */
    path?: Array<ODataPathSegment>;
    /**
     * 
     * @type {object}
     * @memberof ODataQueryContext
     */
    requestContainer?: object;
}
/**
 * 
 * @export
 * @interface ODataRawQueryOptions
 */
export interface ODataRawQueryOptions {
    /**
     * 
     * @type {string}
     * @memberof ODataRawQueryOptions
     */
    filter?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataRawQueryOptions
     */
    apply?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataRawQueryOptions
     */
    compute?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataRawQueryOptions
     */
    search?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataRawQueryOptions
     */
    orderBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataRawQueryOptions
     */
    top?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataRawQueryOptions
     */
    skip?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataRawQueryOptions
     */
    select?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataRawQueryOptions
     */
    expand?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataRawQueryOptions
     */
    count?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataRawQueryOptions
     */
    format?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataRawQueryOptions
     */
    skipToken?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataRawQueryOptions
     */
    deltaToken?: string;
}
/**
 * 
 * @export
 * @interface ODataResponseModel
 */
export interface ODataResponseModel {
    /**
     * 
     * @type {number}
     * @memberof ODataResponseModel
     */
    count?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof ODataResponseModel
     */
    data?: Array<object>;
}
/**
 * 
 * @export
 * @interface ODataServiceDocument
 */
export interface ODataServiceDocument {
    /**
     * 
     * @type {Array<ODataEntitySetInfo>}
     * @memberof ODataServiceDocument
     */
    entitySets?: Array<ODataEntitySetInfo>;
    /**
     * 
     * @type {Array<ODataSingletonInfo>}
     * @memberof ODataServiceDocument
     */
    singletons?: Array<ODataSingletonInfo>;
    /**
     * 
     * @type {Array<ODataFunctionImportInfo>}
     * @memberof ODataServiceDocument
     */
    functionImports?: Array<ODataFunctionImportInfo>;
    /**
     * 
     * @type {ODataTypeAnnotation}
     * @memberof ODataServiceDocument
     */
    typeAnnotation?: ODataTypeAnnotation;
}
/**
 * 
 * @export
 * @interface ODataSingletonInfo
 */
export interface ODataSingletonInfo {
    /**
     * 
     * @type {string}
     * @memberof ODataSingletonInfo
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataSingletonInfo
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ODataSingletonInfo
     */
    title?: string;
    /**
     * 
     * @type {ODataTypeAnnotation}
     * @memberof ODataSingletonInfo
     */
    typeAnnotation?: ODataTypeAnnotation;
}
/**
 * 
 * @export
 * @interface ODataTypeAnnotation
 */
export interface ODataTypeAnnotation {
    /**
     * 
     * @type {string}
     * @memberof ODataTypeAnnotation
     */
    typeName?: string;
}
/**
 * 
 * @export
 * @interface ObjectCustomFilterableField
 */
export interface ObjectCustomFilterableField {
    /**
     * 
     * @type {string}
     * @memberof ObjectCustomFilterableField
     */
    dataField?: string;
    /**
     * 
     * @type {string}
     * @memberof ObjectCustomFilterableField
     */
    caption?: string;
    /**
     * 
     * @type {FilterableFieldType}
     * @memberof ObjectCustomFilterableField
     */
    dataType?: FilterableFieldType;
    /**
     * 
     * @type {Array<ObjectLookupOperationCustomFilterableField>}
     * @memberof ObjectCustomFilterableField
     */
    lookupOperations?: Array<ObjectLookupOperationCustomFilterableField>;
}
/**
 * 
 * @export
 * @interface ObjectLookupOperationCustomFilterableField
 */
export interface ObjectLookupOperationCustomFilterableField {
    /**
     * 
     * @type {object}
     * @memberof ObjectLookupOperationCustomFilterableField
     */
    id?: object;
    /**
     * 
     * @type {string}
     * @memberof ObjectLookupOperationCustomFilterableField
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface OccupancyBySKUCountOutputDTO
 */
export interface OccupancyBySKUCountOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof OccupancyBySKUCountOutputDTO
     */
    skuCellCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OccupancyBySKUCountOutputDTO
     */
    warehouseCellCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OccupancyBySKUCountOutputDTO
     */
    occupancy?: number;
    /**
     * 
     * @type {number}
     * @memberof OccupancyBySKUCountOutputDTO
     */
    totalCellVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof OccupancyBySKUCountOutputDTO
     */
    totalOccupiedVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof OccupancyBySKUCountOutputDTO
     */
    totalAvailableVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof OccupancyBySKUCountOutputDTO
     */
    cellPercentage?: number;
}
/**
 * 
 * @export
 * @interface Oid
 */
export interface Oid {
    /**
     * 
     * @type {string}
     * @memberof Oid
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof Oid
     */
    friendlyName?: string;
}
/**
 * 
 * @export
 * @interface OnHoldPutAwayCommand
 */
export interface OnHoldPutAwayCommand {
    /**
     * 
     * @type {number}
     * @memberof OnHoldPutAwayCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof OnHoldPutAwayCommand
     */
    parkAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface OpenAPIIntegrationOutputDTO
 */
export interface OpenAPIIntegrationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof OpenAPIIntegrationOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenAPIIntegrationOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {IntegrationState}
     * @memberof OpenAPIIntegrationOutputDTO
     */
    state?: IntegrationState;
}
/**
 * 
 * @export
 * @interface OperationDTO
 */
export interface OperationDTO {
    /**
     * 
     * @type {string}
     * @memberof OperationDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationDTO
     */
    imageUrl?: string;
}
/**
 * 
 * @export
 * @interface OperationODataDTOODataQueryOptions
 */
export interface OperationODataDTOODataQueryOptions {
    /**
     * 
     * @type {string}
     * @memberof OperationODataDTOODataQueryOptions
     */
    ifMatch?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationODataDTOODataQueryOptions
     */
    ifNoneMatch?: string;
    /**
     * 
     * @type {HttpRequest}
     * @memberof OperationODataDTOODataQueryOptions
     */
    request?: HttpRequest;
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof OperationODataDTOODataQueryOptions
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {ODataRawQueryOptions}
     * @memberof OperationODataDTOODataQueryOptions
     */
    rawValues?: ODataRawQueryOptions;
    /**
     * 
     * @type {SelectExpandQueryOption}
     * @memberof OperationODataDTOODataQueryOptions
     */
    selectExpand?: SelectExpandQueryOption;
    /**
     * 
     * @type {ApplyQueryOption}
     * @memberof OperationODataDTOODataQueryOptions
     */
    apply?: ApplyQueryOption;
    /**
     * 
     * @type {ComputeQueryOption}
     * @memberof OperationODataDTOODataQueryOptions
     */
    compute?: ComputeQueryOption;
    /**
     * 
     * @type {FilterQueryOption}
     * @memberof OperationODataDTOODataQueryOptions
     */
    filter?: FilterQueryOption;
    /**
     * 
     * @type {SearchQueryOption}
     * @memberof OperationODataDTOODataQueryOptions
     */
    search?: SearchQueryOption;
    /**
     * 
     * @type {OrderByQueryOption}
     * @memberof OperationODataDTOODataQueryOptions
     */
    orderBy?: OrderByQueryOption;
    /**
     * 
     * @type {SkipQueryOption}
     * @memberof OperationODataDTOODataQueryOptions
     */
    skip?: SkipQueryOption;
    /**
     * 
     * @type {SkipTokenQueryOption}
     * @memberof OperationODataDTOODataQueryOptions
     */
    skipToken?: SkipTokenQueryOption;
    /**
     * 
     * @type {TopQueryOption}
     * @memberof OperationODataDTOODataQueryOptions
     */
    top?: TopQueryOption;
    /**
     * 
     * @type {CountQueryOption}
     * @memberof OperationODataDTOODataQueryOptions
     */
    count?: CountQueryOption;
    /**
     * 
     * @type {object}
     * @memberof OperationODataDTOODataQueryOptions
     */
    validator?: object;
}
/**
 * 
 * @export
 * @interface OperationOccupancyDetailsOutputDTO
 */
export interface OperationOccupancyDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof OperationOccupancyDetailsOutputDTO
     */
    operation?: string;
    /**
     * 
     * @type {number}
     * @memberof OperationOccupancyDetailsOutputDTO
     */
    operationVolume?: number;
    /**
     * 
     * @type {string}
     * @memberof OperationOccupancyDetailsOutputDTO
     */
    stockZone?: string;
    /**
     * 
     * @type {number}
     * @memberof OperationOccupancyDetailsOutputDTO
     */
    zoneOccupancy?: number;
    /**
     * 
     * @type {number}
     * @memberof OperationOccupancyDetailsOutputDTO
     */
    warehouseOccupancy?: number;
}
/**
 * 
 * @export
 * @interface OperationOutputDTO
 */
export interface OperationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof OperationOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof OperationOutputDTO
     */
    awaitingInventoryPurchaseOrdersCount?: number;
    /**
     * 
     * @type {PrintPageSizeType}
     * @memberof OperationOutputDTO
     */
    packageVASPageSizeType?: PrintPageSizeType;
    /**
     * 
     * @type {PrintPageSizeType}
     * @memberof OperationOutputDTO
     */
    giftPackageVASPageSizeType?: PrintPageSizeType;
    /**
     * 
     * @type {boolean}
     * @memberof OperationOutputDTO
     */
    isPrintingItems?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OperationOutputDTO
     */
    singleItemFastPackThreshold?: number;
    /**
     * 
     * @type {string}
     * @memberof OperationOutputDTO
     */
    salesChannelClassifierRegex?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationOutputDTO
     */
    salesChannelMatchLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationOutputDTO
     */
    salesChannelNonMatchLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationOutputDTO
     */
    cutoffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationOutputDTO
     */
    targetDispatchTime?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationOutputDTO
     */
    sameDeliveryFirstCutOffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationOutputDTO
     */
    sameDeliveryFirstTargetDispatchTime?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationOutputDTO
     */
    sameDeliverySecondCutOffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationOutputDTO
     */
    sameDeliverySecondTargetDispatchTime?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationOutputDTO
     */
    marketplaceCutOffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationOutputDTO
     */
    marketplaceTargetDispatchTime?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationOutputDTO
     */
    cluster?: string;
}
/**
 * 
 * @export
 * @interface OperationQueryOutputDTO
 */
export interface OperationQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof OperationQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationQueryOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationQueryOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof OperationQueryOutputDTO
     */
    singleItemFastPackThreshold?: number;
    /**
     * 
     * @type {string}
     * @memberof OperationQueryOutputDTO
     */
    cluster?: string;
}
/**
 * 
 * @export
 * @interface OperationQueryOutputDTODynamicQueryOutputDTO
 */
export interface OperationQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<OperationQueryOutputDTO>}
     * @memberof OperationQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<OperationQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof OperationQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface OperationToteDTO
 */
export interface OperationToteDTO {
    /**
     * 
     * @type {string}
     * @memberof OperationToteDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof OperationToteDTO
     */
    timePassedSincePlacedToQuarantineWall?: number;
    /**
     * 
     * @type {SalesChannel}
     * @memberof OperationToteDTO
     */
    salesChannel?: SalesChannel;
}
/**
 * 
 * @export
 * @interface OperationTotes
 */
export interface OperationTotes {
    /**
     * 
     * @type {string}
     * @memberof OperationTotes
     */
    operationName?: string;
    /**
     * 
     * @type {Array<OperationToteDTO>}
     * @memberof OperationTotes
     */
    totes?: Array<OperationToteDTO>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum OperationType {
    CpuTroubleshoot = 'CPUTroubleshoot',
    DbPerformenceTroubleshoot = 'DBPerformenceTroubleshoot'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum OperationsEnum {
    Rossmann = 'Rossmann',
    IamNotBasic = 'IamNotBasic'
}

/**
 * 
 * @export
 * @interface OrderBasedPicklistDetailsOutputDTO
 */
export interface OrderBasedPicklistDetailsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof OrderBasedPicklistDetailsOutputDTO
     */
    salesOrdersCount?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderBasedPicklistDetailsOutputDTO
     */
    zoneName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderBasedPicklistDetailsOutputDTO
     */
    vehicleVariation?: string;
}
/**
 * 
 * @export
 * @interface OrderByClause
 */
export interface OrderByClause {
    /**
     * 
     * @type {OrderByClause}
     * @memberof OrderByClause
     */
    thenBy?: OrderByClause;
    /**
     * 
     * @type {SingleValueNode}
     * @memberof OrderByClause
     */
    expression?: SingleValueNode;
    /**
     * 
     * @type {OrderByDirection}
     * @memberof OrderByClause
     */
    direction?: OrderByDirection;
    /**
     * 
     * @type {RangeVariable}
     * @memberof OrderByClause
     */
    rangeVariable?: RangeVariable;
    /**
     * 
     * @type {IEdmTypeReference}
     * @memberof OrderByClause
     */
    itemType?: IEdmTypeReference;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum OrderByDirection {
    Ascending = 'Ascending',
    Descending = 'Descending'
}

/**
 * 
 * @export
 * @interface OrderByNode
 */
export interface OrderByNode {
    /**
     * 
     * @type {OrderByDirection}
     * @memberof OrderByNode
     */
    direction?: OrderByDirection;
}
/**
 * 
 * @export
 * @interface OrderByQueryOption
 */
export interface OrderByQueryOption {
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof OrderByQueryOption
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {Array<OrderByNode>}
     * @memberof OrderByQueryOption
     */
    orderByNodes?: Array<OrderByNode>;
    /**
     * 
     * @type {string}
     * @memberof OrderByQueryOption
     */
    rawValue?: string;
    /**
     * 
     * @type {object}
     * @memberof OrderByQueryOption
     */
    validator?: object;
    /**
     * 
     * @type {ComputeQueryOption}
     * @memberof OrderByQueryOption
     */
    compute?: ComputeQueryOption;
    /**
     * 
     * @type {OrderByClause}
     * @memberof OrderByQueryOption
     */
    orderByClause?: OrderByClause;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum OrderTrackingFeedingState {
    None = 'None',
    Sufficient = 'Sufficient',
    Insufficient = 'Insufficient',
    OutOfStock = 'OutOfStock'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum OrderTrackingLastActivityType {
    None = 'None',
    Created = 'Created',
    Staged = 'Staged',
    PickingStarted = 'PickingStarted',
    PickingCompleted = 'PickingCompleted',
    SortingCompleted = 'SortingCompleted',
    PackingStarted = 'PackingStarted',
    Suspended = 'Suspended',
    PlacedOnQuarantineWall = 'PlacedOnQuarantineWall'
}

/**
 * 
 * @export
 * @interface OrderTrackingPendingSalesOrderOutputDTO
 */
export interface OrderTrackingPendingSalesOrderOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof OrderTrackingPendingSalesOrderOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTrackingPendingSalesOrderOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTrackingPendingSalesOrderOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTrackingPendingSalesOrderOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof OrderTrackingPendingSalesOrderOutputDTO
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {boolean}
     * @memberof OrderTrackingPendingSalesOrderOutputDTO
     */
    hasPickList?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderTrackingPendingSalesOrderOutputDTO
     */
    pickingToteLabel?: string;
    /**
     * 
     * @type {OrderTrackingLastActivityType}
     * @memberof OrderTrackingPendingSalesOrderOutputDTO
     */
    lastActivityType?: OrderTrackingLastActivityType;
    /**
     * 
     * @type {string}
     * @memberof OrderTrackingPendingSalesOrderOutputDTO
     */
    lastActivityAt?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingPendingSalesOrderOutputDTO
     */
    lineCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingPendingSalesOrderOutputDTO
     */
    itemCount?: number;
    /**
     * 
     * @type {OrderTrackingFeedingState}
     * @memberof OrderTrackingPendingSalesOrderOutputDTO
     */
    feedingState?: OrderTrackingFeedingState;
    /**
     * 
     * @type {boolean}
     * @memberof OrderTrackingPendingSalesOrderOutputDTO
     */
    isBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderTrackingPendingSalesOrderOutputDTO
     */
    isSalesChannelMatch?: boolean;
}
/**
 * 
 * @export
 * @interface OrderTrackingPendingSalesOrderOutputDTODynamicQueryOutputDTO
 */
export interface OrderTrackingPendingSalesOrderOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<OrderTrackingPendingSalesOrderOutputDTO>}
     * @memberof OrderTrackingPendingSalesOrderOutputDTODynamicQueryOutputDTO
     */
    data?: Array<OrderTrackingPendingSalesOrderOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingPendingSalesOrderOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface OrderTrackingReportSeriesOutputDTO
 */
export interface OrderTrackingReportSeriesOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof OrderTrackingReportSeriesOutputDTO
     */
    generatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesOutputDTO
     */
    days?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesOutputDTO
     */
    utcOffsetMinutes?: number;
    /**
     * 
     * @type {Array<OrderTrackingReportSeriesRowDTO>}
     * @memberof OrderTrackingReportSeriesOutputDTO
     */
    rows?: Array<OrderTrackingReportSeriesRowDTO>;
}
/**
 * 
 * @export
 * @interface OrderTrackingReportSeriesRowDTO
 */
export interface OrderTrackingReportSeriesRowDTO {
    /**
     * 
     * @type {string}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    day?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    isChannelMatch?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    createdOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    createdItems?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    pickedOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    pickedItems?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    packedOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    packedItems?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    waitingOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    waitingItems?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    blockedOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    blockedItems?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    cohortPackedOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    cohortPackedItems?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    cancelledOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    cancelledItems?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    otherOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTrackingReportSeriesRowDTO
     */
    otherItems?: number;
}
/**
 * 
 * @export
 * @interface OtherContainerDTO
 */
export interface OtherContainerDTO {
    /**
     * 
     * @type {string}
     * @memberof OtherContainerDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof OtherContainerDTO
     */
    quantity?: number;
}
/**
 * 
 * @export
 * @interface OutOfStockItemQueryOutputDTO
 */
export interface OutOfStockItemQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof OutOfStockItemQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof OutOfStockItemQueryOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof OutOfStockItemQueryOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OutOfStockItemQueryOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OutOfStockItemQueryOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof OutOfStockItemQueryOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {ProductType}
     * @memberof OutOfStockItemQueryOutputDTO
     */
    type?: ProductType;
}
/**
 * 
 * @export
 * @interface OutOfStockItemQueryOutputDTODynamicQueryOutputDTO
 */
export interface OutOfStockItemQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<OutOfStockItemQueryOutputDTO>}
     * @memberof OutOfStockItemQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<OutOfStockItemQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof OutOfStockItemQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface OutboundItemToteOutputDTO
 */
export interface OutboundItemToteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof OutboundItemToteOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof OutboundItemToteOutputDTO
     */
    containedItemCount?: number;
    /**
     * 
     * @type {AddressType}
     * @memberof OutboundItemToteOutputDTO
     */
    addressType?: AddressType;
}
/**
 * 
 * @export
 * @interface OutboundItemToteOutputDTODynamicQueryOutputDTO
 */
export interface OutboundItemToteOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<OutboundItemToteOutputDTO>}
     * @memberof OutboundItemToteOutputDTODynamicQueryOutputDTO
     */
    data?: Array<OutboundItemToteOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof OutboundItemToteOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface OutboundItemsOutputDTO
 */
export interface OutboundItemsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof OutboundItemsOutputDTO
     */
    totalItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OutboundItemsOutputDTO
     */
    totalToteCount?: number;
    /**
     * 
     * @type {Array<OutboundItemToteOutputDTO>}
     * @memberof OutboundItemsOutputDTO
     */
    outboundItemTotes?: Array<OutboundItemToteOutputDTO>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum OutputDispatchState {
    None = 'None',
    Started = 'Started',
    ManualDeliverySalesOrderStarted = 'ManualDeliverySalesOrderStarted',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum OutputVASType {
    None = 'None',
    InsertToPackageVas = 'InsertToPackageVAS',
    GiftPackageWithWrappingAndWithMessage = 'GiftPackageWithWrappingAndWithMessage',
    GiftPackageWithWrappingAndWithoutMessage = 'GiftPackageWithWrappingAndWithoutMessage',
    GiftPackageWithoutWrappingAndWithMessage = 'GiftPackageWithoutWrappingAndWithMessage',
    CustomActionVas = 'CustomActionVAS',
    PackingNoteVas = 'PackingNoteVAS',
    NpsVas = 'NpsVAS'
}

/**
 * 
 * @export
 * @interface OverwriteCarrierPreferencesCommand
 */
export interface OverwriteCarrierPreferencesCommand {
    /**
     * 
     * @type {string}
     * @memberof OverwriteCarrierPreferencesCommand
     */
    operationId?: string;
    /**
     * 
     * @type {Array<CarrierPreferenceInputDTO>}
     * @memberof OverwriteCarrierPreferencesCommand
     */
    carrierPreferences?: Array<CarrierPreferenceInputDTO>;
}
/**
 * 
 * @export
 * @interface OwnContainerCargoPackageTypeOutputDTO
 */
export interface OwnContainerCargoPackageTypeOutputDTO {
    /**
     * 
     * @type {PackageType}
     * @memberof OwnContainerCargoPackageTypeOutputDTO
     */
    type?: PackageType;
    /**
     * 
     * @type {number}
     * @memberof OwnContainerCargoPackageTypeOutputDTO
     */
    volumetricWeight?: number;
    /**
     * 
     * @type {string}
     * @memberof OwnContainerCargoPackageTypeOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof OwnContainerCargoPackageTypeOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OwnContainerCargoPackageTypeOutputDTO
     */
    isDisabled?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PackageType {
    None = 'None',
    Envelope = 'Envelope',
    Box = 'Box',
    Pouch = 'Pouch',
    Palette = 'Palette',
    OwnContainer = 'OwnContainer'
}

/**
 * 
 * @export
 * @interface PackingBoxHOVItemOutputDTO
 */
export interface PackingBoxHOVItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PackingBoxHOVItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingBoxHOVItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingBoxHOVItemOutputDTO
     */
    productSKU?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingBoxHOVItemOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof PackingBoxHOVItemOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PackingBoxHOVItemOutputDTO
     */
    serialNumbers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PackingBoxHOVItemOutputDTO
     */
    barcodes?: Array<string>;
}
/**
 * 
 * @export
 * @interface PackingBoxItemOutputDTO
 */
export interface PackingBoxItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PackingBoxItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingBoxItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingBoxItemOutputDTO
     */
    productSKU?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingBoxItemOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof PackingBoxItemOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PackingBoxItemOutputDTO
     */
    serialNumbers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PackingBoxItemOutputDTO
     */
    barcodes?: Array<string>;
}
/**
 * 
 * @export
 * @interface PackingHOVMissingItemOutputDTO
 */
export interface PackingHOVMissingItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PackingHOVMissingItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingHOVMissingItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingHOVMissingItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingHOVMissingItemOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof PackingHOVMissingItemOutputDTO
     */
    missingAmount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PackingHOVMissingItemOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {HOVProductTagsOutputDTO}
     * @memberof PackingHOVMissingItemOutputDTO
     */
    productTags?: HOVProductTagsOutputDTO;
}
/**
 * 
 * @export
 * @interface PackingItemInputDTO
 */
export interface PackingItemInputDTO {
    /**
     * 
     * @type {string}
     * @memberof PackingItemInputDTO
     */
    productId?: string;
    /**
     * 
     * @type {number}
     * @memberof PackingItemInputDTO
     */
    amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PackingItemInputDTO
     */
    serialNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface PackingItemOutputDTO
 */
export interface PackingItemOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof PackingItemOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PackingItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PackingItemOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PackingItemOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PackingItemOutputDTO
     */
    isTrackSerialNumber?: boolean;
}
/**
 * 
 * @export
 * @interface PackingMissingItemOutputDTO
 */
export interface PackingMissingItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PackingMissingItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingMissingItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingMissingItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingMissingItemOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof PackingMissingItemOutputDTO
     */
    missingAmount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PackingMissingItemOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {ProductTagsOutputDTO}
     * @memberof PackingMissingItemOutputDTO
     */
    productTags?: ProductTagsOutputDTO;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PackingQuarantineReason {
    Cancelled = 'Cancelled',
    None = 'None',
    CompletedWithLostItems = 'CompletedWithLostItems'
}

/**
 * 
 * @export
 * @interface PackingStateDetailsOutputDTO
 */
export interface PackingStateDetailsOutputDTO {
    /**
     * 
     * @type {SalesOrderPackingState}
     * @memberof PackingStateDetailsOutputDTO
     */
    state?: SalesOrderPackingState;
    /**
     * 
     * @type {string}
     * @memberof PackingStateDetailsOutputDTO
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PackingStateDetailsOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PackingStateDetailsOutputDTO
     */
    suspendedInThisState?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PackingStateDetailsOutputDTO
     */
    doneByFullName?: string;
}
/**
 * 
 * @export
 * @interface PalletProductDetailsOutputDTO
 */
export interface PalletProductDetailsOutputDTO {
    /**
     * 
     * @type {Array<PalletProductItemOutputDTO>}
     * @memberof PalletProductDetailsOutputDTO
     */
    products?: Array<PalletProductItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface PalletProductItemOutputDTO
 */
export interface PalletProductItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PalletProductItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof PalletProductItemOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof PalletProductItemOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof PalletProductItemOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof PalletProductItemOutputDTO
     */
    imageURL?: string;
}
/**
 * 
 * @export
 * @interface PalletPutAwayCellOutputDTO
 */
export interface PalletPutAwayCellOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof PalletPutAwayCellOutputDTO
     */
    hasItems?: boolean;
}
/**
 * 
 * @export
 * @interface PalletPutAwayHistoryItemOutputDTO
 */
export interface PalletPutAwayHistoryItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PalletPutAwayHistoryItemOutputDTO
     */
    palletLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PalletPutAwayHistoryItemOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PalletPutAwayHistoryItemOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PalletPutAwayHistoryItemOutputDTO
     */
    completion?: string;
}
/**
 * 
 * @export
 * @interface PalletPutAwayHistoryOutputDTO
 */
export interface PalletPutAwayHistoryOutputDTO {
    /**
     * 
     * @type {Array<PalletPutAwayHistoryItemOutputDTO>}
     * @memberof PalletPutAwayHistoryOutputDTO
     */
    historyItems?: Array<PalletPutAwayHistoryItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface PalletPutAwayOutputDTO
 */
export interface PalletPutAwayOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PalletPutAwayOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof PalletPutAwayOutputDTO
     */
    referenceNumber?: number;
    /**
     * 
     * @type {PalletPutAwayState}
     * @memberof PalletPutAwayOutputDTO
     */
    state?: PalletPutAwayState;
    /**
     * 
     * @type {CheckPutAwayCellRuleForPalletOutputDTO}
     * @memberof PalletPutAwayOutputDTO
     */
    validationResult?: CheckPutAwayCellRuleForPalletOutputDTO;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PalletPutAwayState {
    None = 'None',
    Started = 'Started',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @interface PalletPutAwayZoneOutputDTO
 */
export interface PalletPutAwayZoneOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PalletPutAwayZoneOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PalletPutAwayZoneOutputDTO
     */
    hasProblems?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PalletState {
    None = 'None',
    Created = 'Created',
    IneligibleForPutAway = 'IneligibleForPutAway',
    ReadyForPutAway = 'ReadyForPutAway',
    PutAwayCompleted = 'PutAwayCompleted'
}

/**
 * 
 * @export
 * @interface PalletSummaryOutputDTO
 */
export interface PalletSummaryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PalletSummaryOutputDTO
     */
    palletLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PalletSummaryOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PalletSummaryOutputDTO
     */
    hasZoneProblem?: boolean;
}
/**
 * 
 * @export
 * @interface PalletWaybillOutputDTO
 */
export interface PalletWaybillOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PalletWaybillOutputDTO
     */
    palletLabel?: string;
}
/**
 * 
 * @export
 * @interface ParkPutAwayTrolleyOutputDTO
 */
export interface ParkPutAwayTrolleyOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof ParkPutAwayTrolleyOutputDTO
     */
    productCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ParkPutAwayTrolleyOutputDTO
     */
    toteCount?: number;
}
/**
 * 
 * @export
 * @interface ParkTrolleyCommand
 */
export interface ParkTrolleyCommand {
    /**
     * 
     * @type {number}
     * @memberof ParkTrolleyCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof ParkTrolleyCommand
     */
    parkAddressLabel?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PaymentMethod {
    None = 'None',
    Cash = 'Cash',
    CreditCard = 'CreditCard'
}

/**
 * 
 * @export
 * @interface PendingCancellationCellSummaryQueryOutputDTO
 */
export interface PendingCancellationCellSummaryQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PendingCancellationCellSummaryQueryOutputDTO
     */
    podNo?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingCancellationCellSummaryQueryOutputDTO
     */
    face?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingCancellationCellSummaryQueryOutputDTO
     */
    podCellLabels?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingCancellationCellSummaryQueryOutputDTO
     */
    podAddressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PendingCancellationCellSummaryQueryOutputDTO
     */
    cancelledCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PendingCancellationCellSummaryQueryOutputDTO
     */
    skus?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingCancellationCellSummaryQueryOutputDTO
     */
    productIds?: string;
}
/**
 * 
 * @export
 * @interface PendingCancellationCellSummaryQueryOutputDTODynamicQueryOutputDTO
 */
export interface PendingCancellationCellSummaryQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PendingCancellationCellSummaryQueryOutputDTO>}
     * @memberof PendingCancellationCellSummaryQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PendingCancellationCellSummaryQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PendingCancellationCellSummaryQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface PendingItemCancellationQueryOutputDTO
 */
export interface PendingItemCancellationQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PendingItemCancellationQueryOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingItemCancellationQueryOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingItemCancellationQueryOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingItemCancellationQueryOutputDTO
     */
    cancelReason?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingItemCancellationQueryOutputDTO
     */
    currentLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingItemCancellationQueryOutputDTO
     */
    orderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingItemCancellationQueryOutputDTO
     */
    stage?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingItemCancellationQueryOutputDTO
     */
    cancelDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingItemCancellationQueryOutputDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface PendingItemCancellationQueryOutputDTODynamicQueryOutputDTO
 */
export interface PendingItemCancellationQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PendingItemCancellationQueryOutputDTO>}
     * @memberof PendingItemCancellationQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PendingItemCancellationQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PendingItemCancellationQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface PersonInfoOutputDTO
 */
export interface PersonInfoOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PersonInfoOutputDTO
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonInfoOutputDTO
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonInfoOutputDTO
     */
    personId?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonInfoOutputDTO
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonInfoOutputDTO
     */
    phone?: string;
}
/**
 * 
 * @export
 * @interface PhysicalCompleteZoneTransferCommand
 */
export interface PhysicalCompleteZoneTransferCommand {
    /**
     * 
     * @type {string}
     * @memberof PhysicalCompleteZoneTransferCommand
     */
    operationName?: string;
    /**
     * 
     * @type {number}
     * @memberof PhysicalCompleteZoneTransferCommand
     */
    oldZoneId?: number;
    /**
     * 
     * @type {number}
     * @memberof PhysicalCompleteZoneTransferCommand
     */
    newZoneId?: number;
}
/**
 * 
 * @export
 * @interface PhysicalPrepareZoneTransferCommand
 */
export interface PhysicalPrepareZoneTransferCommand {
    /**
     * 
     * @type {string}
     * @memberof PhysicalPrepareZoneTransferCommand
     */
    operationName?: string;
    /**
     * 
     * @type {number}
     * @memberof PhysicalPrepareZoneTransferCommand
     */
    oldZoneId?: number;
    /**
     * 
     * @type {number}
     * @memberof PhysicalPrepareZoneTransferCommand
     */
    newZoneId?: number;
}
/**
 * 
 * @export
 * @interface PickListDetailsOutputDTO
 */
export interface PickListDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickListDetailsOutputDTO
     */
    pickListName?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListDetailsOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListDetailsOutputDTO
     */
    pickingStartedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListDetailsOutputDTO
     */
    pickingCompletedAt?: string;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof PickListDetailsOutputDTO
     */
    pickingFlowTag?: PickingFlowTag;
    /**
     * 
     * @type {PickingMethod}
     * @memberof PickListDetailsOutputDTO
     */
    pickingMethod?: PickingMethod;
    /**
     * 
     * @type {PickingType}
     * @memberof PickListDetailsOutputDTO
     */
    pickingType?: PickingType;
    /**
     * 
     * @type {string}
     * @memberof PickListDetailsOutputDTO
     */
    pickingTrolleyLabel?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PickListDetailsOutputDTO
     */
    pickingToteLabels?: Array<string>;
    /**
     * 
     * @type {PickingCapacityUnit}
     * @memberof PickListDetailsOutputDTO
     */
    pickingCapacityUnit?: PickingCapacityUnit;
    /**
     * 
     * @type {number}
     * @memberof PickListDetailsOutputDTO
     */
    capacity?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PickListGenerationType {
    None = 'None',
    Automated = 'Automated',
    Manual = 'Manual',
    Batch = 'Batch'
}

/**
 * 
 * @export
 * @interface PickListItemOutputDTO
 */
export interface PickListItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickListItemOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListItemOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListItemOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListItemOutputDTO
     */
    expectedCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListItemOutputDTO
     */
    actualCellLabel?: string;
    /**
     * 
     * @type {ActualPickingItemState}
     * @memberof PickListItemOutputDTO
     */
    state?: ActualPickingItemState;
    /**
     * 
     * @type {string}
     * @memberof PickListItemOutputDTO
     */
    processedByUserName?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListItemOutputDTO
     */
    processedAt?: string;
}
/**
 * 
 * @export
 * @interface PickListItemOutputDTODynamicQueryOutputDTO
 */
export interface PickListItemOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PickListItemOutputDTO>}
     * @memberof PickListItemOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PickListItemOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PickListItemOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface PickListPickingHistoryOutputDTO
 */
export interface PickListPickingHistoryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickListPickingHistoryOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingHistoryOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingHistoryOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {number}
     * @memberof PickListPickingHistoryOutputDTO
     */
    pickedProductCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingHistoryOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {ActualPickingItemState}
     * @memberof PickListPickingHistoryOutputDTO
     */
    actualPickingItemState?: ActualPickingItemState;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingHistoryOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingHistoryOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingHistoryOutputDTO
     */
    productId?: string;
}
/**
 * 
 * @export
 * @interface PickListPickingHistoryOutputDTODynamicQueryOutputDTO
 */
export interface PickListPickingHistoryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PickListPickingHistoryOutputDTO>}
     * @memberof PickListPickingHistoryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PickListPickingHistoryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PickListPickingHistoryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface PickListPickingPlanByCellLabelOutputDTO
 */
export interface PickListPickingPlanByCellLabelOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanByCellLabelOutputDTO
     */
    targetCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanByCellLabelOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanByCellLabelOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanByCellLabelOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanByCellLabelOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanByCellLabelOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanByCellLabelOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanByCellLabelOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {number}
     * @memberof PickListPickingPlanByCellLabelOutputDTO
     */
    expectedProductCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanByCellLabelOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanByCellLabelOutputDTO
     */
    pickListId?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanByCellLabelOutputDTO
     */
    pickListName?: string;
    /**
     * 
     * @type {ExpectedPickingItemState}
     * @memberof PickListPickingPlanByCellLabelOutputDTO
     */
    expectedPickingItemState?: ExpectedPickingItemState;
    /**
     * 
     * @type {PickListState}
     * @memberof PickListPickingPlanByCellLabelOutputDTO
     */
    pickingListState?: PickListState;
}
/**
 * 
 * @export
 * @interface PickListPickingPlanByCellLabelOutputDTODynamicQueryOutputDTO
 */
export interface PickListPickingPlanByCellLabelOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PickListPickingPlanByCellLabelOutputDTO>}
     * @memberof PickListPickingPlanByCellLabelOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PickListPickingPlanByCellLabelOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PickListPickingPlanByCellLabelOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface PickListPickingPlanOutputDTO
 */
export interface PickListPickingPlanOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanOutputDTO
     */
    targetCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {number}
     * @memberof PickListPickingPlanOutputDTO
     */
    expectedProductCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PickListPickingPlanOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {ExpectedPickingItemState}
     * @memberof PickListPickingPlanOutputDTO
     */
    expectedPickingItemState?: ExpectedPickingItemState;
}
/**
 * 
 * @export
 * @interface PickListPickingPlanOutputDTODynamicQueryOutputDTO
 */
export interface PickListPickingPlanOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PickListPickingPlanOutputDTO>}
     * @memberof PickListPickingPlanOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PickListPickingPlanOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PickListPickingPlanOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface PickListQrCodeOutputDTO
 */
export interface PickListQrCodeOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickListQrCodeOutputDTO
     */
    qrCode?: string;
}
/**
 * 
 * @export
 * @interface PickListRequestPickListDetailsOutputDTO
 */
export interface PickListRequestPickListDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickListRequestPickListDetailsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestPickListDetailsOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {PickListState}
     * @memberof PickListRequestPickListDetailsOutputDTO
     */
    state?: PickListState;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestPickListDetailsOutputDTO
     */
    vehicleVariation?: string;
    /**
     * 
     * @type {number}
     * @memberof PickListRequestPickListDetailsOutputDTO
     */
    capacity?: number;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof PickListRequestPickListDetailsOutputDTO
     */
    flow?: PickingFlowTag;
    /**
     * 
     * @type {PickingMethod}
     * @memberof PickListRequestPickListDetailsOutputDTO
     */
    method?: PickingMethod;
    /**
     * 
     * @type {PickingTrolleySelectionConfigurationPickingType}
     * @memberof PickListRequestPickListDetailsOutputDTO
     */
    pickingType?: PickingTrolleySelectionConfigurationPickingType;
    /**
     * 
     * @type {number}
     * @memberof PickListRequestPickListDetailsOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestPickListDetailsOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestPickListDetailsOutputDTO
     */
    pickingTrolley?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestPickListDetailsOutputDTO
     */
    operator?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestPickListDetailsOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof PickListRequestPickListDetailsOutputDTO
     */
    productCount?: number;
}
/**
 * 
 * @export
 * @interface PickListRequestPickListDetailsOutputDTODynamicQueryOutputDTO
 */
export interface PickListRequestPickListDetailsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PickListRequestPickListDetailsOutputDTO>}
     * @memberof PickListRequestPickListDetailsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PickListRequestPickListDetailsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PickListRequestPickListDetailsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface PickListRequestQueryOutputDTO
 */
export interface PickListRequestQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickListRequestQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestQueryOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestQueryOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof PickListRequestQueryOutputDTO
     */
    ordersInBatch?: number;
    /**
     * 
     * @type {number}
     * @memberof PickListRequestQueryOutputDTO
     */
    pickListsInBatch?: number;
    /**
     * 
     * @type {number}
     * @memberof PickListRequestQueryOutputDTO
     */
    startedListCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickListRequestQueryOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestQueryOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PickListRequestQueryOutputDTO
     */
    subZoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestQueryOutputDTO
     */
    subZoneName?: string;
    /**
     * 
     * @type {PicklistRequestState}
     * @memberof PickListRequestQueryOutputDTO
     */
    state?: PicklistRequestState;
    /**
     * 
     * @type {PickListRequestType}
     * @memberof PickListRequestQueryOutputDTO
     */
    creationType?: PickListRequestType;
    /**
     * 
     * @type {BatchType}
     * @memberof PickListRequestQueryOutputDTO
     */
    batchType?: BatchType;
    /**
     * 
     * @type {boolean}
     * @memberof PickListRequestQueryOutputDTO
     */
    prioritized?: boolean;
    /**
     * 
     * @type {BatchPickingState}
     * @memberof PickListRequestQueryOutputDTO
     */
    batchPickingState?: BatchPickingState;
    /**
     * 
     * @type {number}
     * @memberof PickListRequestQueryOutputDTO
     */
    prioritizedOrdersInBatch?: number;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestQueryOutputDTO
     */
    minSalesOrderCreationDate?: string;
}
/**
 * 
 * @export
 * @interface PickListRequestQueryOutputDTODynamicQueryOutputDTO
 */
export interface PickListRequestQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PickListRequestQueryOutputDTO>}
     * @memberof PickListRequestQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PickListRequestQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PickListRequestQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface PickListRequestSalesOrderDetailsOutputDTO
 */
export interface PickListRequestSalesOrderDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    targetDispatchDateTime?: string;
    /**
     * 
     * @type {SalesOrderDispatchStateSteps}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    createState?: SalesOrderDispatchStateSteps;
    /**
     * 
     * @type {SalesOrderDispatchStateSteps}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    pickingState?: SalesOrderDispatchStateSteps;
    /**
     * 
     * @type {SalesOrderDispatchStateSteps}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    sortingState?: SalesOrderDispatchStateSteps;
    /**
     * 
     * @type {SalesOrderDispatchStateSteps}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    packingState?: SalesOrderDispatchStateSteps;
    /**
     * 
     * @type {SalesOrderDispatchStateSteps}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    slamState?: SalesOrderDispatchStateSteps;
    /**
     * 
     * @type {SalesOrderDispatchStateSteps}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    dispatchState?: SalesOrderDispatchStateSteps;
    /**
     * 
     * @type {SalesOrderDispatchStateSteps}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    deliveringState?: SalesOrderDispatchStateSteps;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    orderCreatedAt?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {SalesChannel}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {SalesOrderPickingPriority}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    priority?: SalesOrderPickingPriority;
    /**
     * 
     * @type {boolean}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    isSuspended?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    isCutOff?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    isSoftCutOff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    suspendedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    isCargoCodeUpdated?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    isSalesChannelMatch?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PickListRequestSalesOrderDetailsOutputDTO
     */
    cargoCarrier?: string;
}
/**
 * 
 * @export
 * @interface PickListRequestSalesOrderDetailsOutputDTODynamicQueryOutputDTO
 */
export interface PickListRequestSalesOrderDetailsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PickListRequestSalesOrderDetailsOutputDTO>}
     * @memberof PickListRequestSalesOrderDetailsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PickListRequestSalesOrderDetailsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PickListRequestSalesOrderDetailsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface PickListRequestStateDetailsOutputDTO
 */
export interface PickListRequestStateDetailsOutputDTO {
    /**
     * 
     * @type {BatchPickingStateDetailsOutputDTO}
     * @memberof PickListRequestStateDetailsOutputDTO
     */
    pickingState?: BatchPickingStateDetailsOutputDTO;
    /**
     * 
     * @type {BatchSortingStateDetailsOutputDTO}
     * @memberof PickListRequestStateDetailsOutputDTO
     */
    sortingState?: BatchSortingStateDetailsOutputDTO;
    /**
     * 
     * @type {BatchPackingStateDetailsOutputDTO}
     * @memberof PickListRequestStateDetailsOutputDTO
     */
    packingState?: BatchPackingStateDetailsOutputDTO;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PickListRequestType {
    Manual = 'Manual',
    Auto = 'Auto',
    Batch = 'Batch'
}

/**
 * 
 * @export
 * @interface PickListSalesOrdersOutputDTO
 */
export interface PickListSalesOrdersOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickListSalesOrdersOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListSalesOrdersOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListSalesOrdersOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListSalesOrdersOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListSalesOrdersOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListSalesOrdersOutputDTO
     */
    vehicleType?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListSalesOrdersOutputDTO
     */
    pickListName?: string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof PickListSalesOrdersOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof PickListSalesOrdersOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {number}
     * @memberof PickListSalesOrdersOutputDTO
     */
    lineItemsCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PickListSalesOrdersOutputDTO
     */
    targetDispatchDateTime?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PickListSalesOrdersOutputDTO
     */
    isCutOff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PickListSalesOrdersOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PickListSalesOrdersOutputDTO
     */
    problemCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PickListSalesOrdersOutputDTO
     */
    stagedZones?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PickListSalesOrdersOutputDTO
     */
    candidateZones?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PickListSalesOrdersOutputDTO
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListSalesOrdersOutputDTO
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PickListSalesOrdersOutputDTO
     */
    stagedAt?: string;
}
/**
 * 
 * @export
 * @interface PickListSalesOrdersOutputDTODynamicQueryOutputDTO
 */
export interface PickListSalesOrdersOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PickListSalesOrdersOutputDTO>}
     * @memberof PickListSalesOrdersOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PickListSalesOrdersOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PickListSalesOrdersOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PickListState {
    None = 'None',
    Created = 'Created',
    Assigned = 'Assigned',
    PickingStarted = 'PickingStarted',
    PickingCompleted = 'PickingCompleted'
}

/**
 * 
 * @export
 * @interface PickedItemsInQuarantineToteOutputDTO
 */
export interface PickedItemsInQuarantineToteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickedItemsInQuarantineToteOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PickedItemsInQuarantineToteOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PickedItemsInQuarantineToteOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof PickedItemsInQuarantineToteOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof PickedItemsInQuarantineToteOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PickedItemsInQuarantineToteOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PickedItemsInQuarantineToteOutputDTO
     */
    isTrackSerialNumber?: boolean;
}
/**
 * 
 * @export
 * @interface PickedMissingItemsInputDTO
 */
export interface PickedMissingItemsInputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickedMissingItemsInputDTO
     */
    productId?: string;
    /**
     * 
     * @type {number}
     * @memberof PickedMissingItemsInputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface PickedMissingItemsOutputDTO
 */
export interface PickedMissingItemsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickedMissingItemsOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PickedMissingItemsOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PickedMissingItemsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof PickedMissingItemsOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof PickedMissingItemsOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PickedMissingItemsOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PickedMissingItemsOutputDTO
     */
    isTrackSerialNumber?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PickingCapacityUnit {
    None = 'None',
    Order = 'Order',
    Product = 'Product'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PickingFlowTag {
    None = 'None',
    Oversize = 'Oversize',
    Heavy = 'Heavy',
    SingleItem = 'SingleItem',
    Hov = 'HOV',
    MultiItem = 'MultiItem',
    SingleItemSioc = 'SingleItemSioc',
    Simple = 'Simple',
    SingleItemFastPack = 'SingleItemFastPack'
}

/**
 * 
 * @export
 * @interface PickingItemByProductOutputDTO
 */
export interface PickingItemByProductOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickingItemByProductOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingItemByProductOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingItemByProductOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingItemByProductOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof PickingItemByProductOutputDTO
     */
    amountInOrder?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PickingItemByProductOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {Array<MasterCartonDefinitionOutputDTO>}
     * @memberof PickingItemByProductOutputDTO
     */
    masterCartonDefinitions?: Array<MasterCartonDefinitionOutputDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof PickingItemByProductOutputDTO
     */
    isTrackSerialNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PickingItemByProductOutputDTO
     */
    isTrackSimpleSerialNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PickingItemByProductOutputDTO
     */
    isCreatedWithSerialNumber?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PickingItemByProductOutputDTO
     */
    serialNumbers?: Array<string>;
    /**
     * 
     * @type {ProductTagsOutputDTO}
     * @memberof PickingItemByProductOutputDTO
     */
    productTags?: ProductTagsOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof PickingItemByProductOutputDTO
     */
    weightInGrams?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PickingMethod {
    None = 'None',
    OrderBased = 'OrderBased',
    SingleItem = 'SingleItem',
    Batch = 'Batch',
    OperationBased = 'OperationBased'
}

/**
 * 
 * @export
 * @interface PickingProblemQueryOutputDTO
 */
export interface PickingProblemQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickingProblemQueryOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingProblemQueryOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingProblemQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingProblemQueryOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingProblemQueryOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingProblemQueryOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {ProblemState}
     * @memberof PickingProblemQueryOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {string}
     * @memberof PickingProblemQueryOutputDTO
     */
    source?: string;
    /**
     * 
     * @type {PickingProblemType}
     * @memberof PickingProblemQueryOutputDTO
     */
    type?: PickingProblemType;
    /**
     * 
     * @type {string}
     * @memberof PickingProblemQueryOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingProblemQueryOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingProblemQueryOutputDTO
     */
    resolvedUser?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingProblemQueryOutputDTO
     */
    resolutionNote?: string;
}
/**
 * 
 * @export
 * @interface PickingProblemQueryOutputDTODynamicQueryOutputDTO
 */
export interface PickingProblemQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PickingProblemQueryOutputDTO>}
     * @memberof PickingProblemQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PickingProblemQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PickingProblemQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PickingProblemType {
    None = 'None',
    LostItemProblem = 'LostItemProblem',
    MixPickingProblem = 'MixPickingProblem',
    OutOfStockProblem = 'OutOfStockProblem'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PickingProcessType {
    None = 'None',
    Oversize = 'Oversize',
    Heavy = 'Heavy',
    SingleItem = 'SingleItem',
    Hov = 'HOV',
    MultiItem = 'MultiItem',
    ToteSelective = 'ToteSelective',
    Batch = 'Batch',
    Simple = 'Simple',
    FastPack = 'FastPack'
}

/**
 * 
 * @export
 * @interface PickingQuarantineTotesOutputDTO
 */
export interface PickingQuarantineTotesOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickingQuarantineTotesOutputDTO
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingQuarantineTotesOutputDTO
     */
    salesOrderRefNo?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingQuarantineTotesOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingQuarantineTotesOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingQuarantineTotesOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingQuarantineTotesOutputDTO
     */
    problemId?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingQuarantineTotesOutputDTO
     */
    problemRefNo?: string;
    /**
     * 
     * @type {ProblemType}
     * @memberof PickingQuarantineTotesOutputDTO
     */
    problemReason?: ProblemType;
    /**
     * 
     * @type {LostItemProblemState}
     * @memberof PickingQuarantineTotesOutputDTO
     */
    problemState?: LostItemProblemState;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof PickingQuarantineTotesOutputDTO
     */
    salesOrderState?: SalesOrderState;
    /**
     * 
     * @type {string}
     * @memberof PickingQuarantineTotesOutputDTO
     */
    pickingToteLabel?: string;
}
/**
 * 
 * @export
 * @interface PickingQuarantineTotesOutputDTODynamicQueryOutputDTO
 */
export interface PickingQuarantineTotesOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PickingQuarantineTotesOutputDTO>}
     * @memberof PickingQuarantineTotesOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PickingQuarantineTotesOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PickingQuarantineTotesOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PickingRouteDirection {
    Asc = 'Asc',
    Desc = 'Desc'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PickingRouteElementState {
    None = 'None',
    Lost = 'Lost',
    Picked = 'Picked'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PickingRouteType {
    None = 'None',
    SRoute = 'SRoute',
    SRouteSkuGrouped = 'SRouteSKUGrouped',
    Ras = 'RAS'
}

/**
 * 
 * @export
 * @interface PickingStateDetailsOutputDTO
 */
export interface PickingStateDetailsOutputDTO {
    /**
     * 
     * @type {SalesOrderPickingState}
     * @memberof PickingStateDetailsOutputDTO
     */
    state?: SalesOrderPickingState;
    /**
     * 
     * @type {string}
     * @memberof PickingStateDetailsOutputDTO
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingStateDetailsOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PickingStateDetailsOutputDTO
     */
    suspendedInThisState?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PickingStateDetailsOutputDTO
     */
    doneByFullName?: string;
}
/**
 * 
 * @export
 * @interface PickingTrolleyDetailsOutputDTO
 */
export interface PickingTrolleyDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleyDetailsOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleyDetailsOutputDTO
     */
    percentage?: number;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleyDetailsOutputDTO
     */
    operatorName?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleyDetailsOutputDTO
     */
    lastSeenAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleyDetailsOutputDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {PickingTrolleySalesOrderState}
     * @memberof PickingTrolleyDetailsOutputDTO
     */
    state?: PickingTrolleySalesOrderState;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleyDetailsOutputDTO
     */
    totalToteCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleyDetailsOutputDTO
     */
    remainingSalesOrderCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleyDetailsOutputDTO
     */
    suspendedSalesOrderCount?: number;
}
/**
 * 
 * @export
 * @interface PickingTrolleyPickingToteQueryOutputDTO
 */
export interface PickingTrolleyPickingToteQueryOutputDTO {
    /**
     * 
     * @type {PickingTrolleySalesOrderState}
     * @memberof PickingTrolleyPickingToteQueryOutputDTO
     */
    pickingTrolleyState?: PickingTrolleySalesOrderState;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleyPickingToteQueryOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleyPickingToteQueryOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleyPickingToteQueryOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleyPickingToteQueryOutputDTO
     */
    salesOrderOperationName?: string;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleyPickingToteQueryOutputDTO
     */
    totalLineItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleyPickingToteQueryOutputDTO
     */
    totalItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleyPickingToteQueryOutputDTO
     */
    percentage?: number;
    /**
     * 
     * @type {SalesChannel}
     * @memberof PickingTrolleyPickingToteQueryOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof PickingTrolleyPickingToteQueryOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
}
/**
 * 
 * @export
 * @interface PickingTrolleyPickingToteQueryOutputDTODynamicQueryOutputDTO
 */
export interface PickingTrolleyPickingToteQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PickingTrolleyPickingToteQueryOutputDTO>}
     * @memberof PickingTrolleyPickingToteQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PickingTrolleyPickingToteQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleyPickingToteQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PickingTrolleySalesOrderState {
    Picking = 'Picking',
    Packing = 'Packing',
    Cancelled = 'Cancelled'
}

/**
 * 
 * @export
 * @interface PickingTrolleySelectionConfiguration
 */
export interface PickingTrolleySelectionConfiguration {
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfiguration
     */
    rId?: number;
    /**
     * 
     * @type {PickingTrolleyType}
     * @memberof PickingTrolleySelectionConfiguration
     */
    type?: PickingTrolleyType;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleySelectionConfiguration
     */
    variation?: string;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfiguration
     */
    minSalesOrderItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfiguration
     */
    maxSalesOrderItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfiguration
     */
    capacity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PickingTrolleySelectionConfiguration
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfiguration
     */
    minSalesOrdersToStart?: number;
    /**
     * 
     * @type {PickingTrolleySelectionConfigurationPickingType}
     * @memberof PickingTrolleySelectionConfiguration
     */
    pickingType?: PickingTrolleySelectionConfigurationPickingType;
    /**
     * 
     * @type {PickingRouteType}
     * @memberof PickingTrolleySelectionConfiguration
     */
    pickingRouteType?: PickingRouteType;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleySelectionConfiguration
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleySelectionConfiguration
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfiguration
     */
    version?: number;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleySelectionConfiguration
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleySelectionConfiguration
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleySelectionConfiguration
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleySelectionConfiguration
     */
    updatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleySelectionConfiguration
     */
    deletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleySelectionConfiguration
     */
    deletedBy?: string;
}
/**
 * 
 * @export
 * @interface PickingTrolleySelectionConfigurationOutputDTO
 */
export interface PickingTrolleySelectionConfigurationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {PickingTrolleyType}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    vehicleType?: PickingTrolleyType;
    /**
     * 
     * @type {PickingTrolleySelectionConfigurationPickingType}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    pickingType?: PickingTrolleySelectionConfigurationPickingType;
    /**
     * 
     * @type {PickingRouteType}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    pickingRouteType?: PickingRouteType;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    vehicleVariation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    lateCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    cutOffCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    priority1?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    priority2?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    priority3?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    normalOrderCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    activePickingSalesOrderCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    activePickingSalesOrderLineItemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    waitingForPackingSalesOrderCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    waitingForPackingSalesOrderLineItemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    waitingForSLAMCargoPackageCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfigurationOutputDTO
     */
    waitingForDispatchCargoPackageCount?: number;
}
/**
 * 
 * @export
 * @interface PickingTrolleySelectionConfigurationOutputDTODynamicQueryOutputDTO
 */
export interface PickingTrolleySelectionConfigurationOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PickingTrolleySelectionConfigurationOutputDTO>}
     * @memberof PickingTrolleySelectionConfigurationOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PickingTrolleySelectionConfigurationOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleySelectionConfigurationOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PickingTrolleySelectionConfigurationPickingType {
    Normal = 'Normal',
    MissingItem = 'MissingItem'
}

/**
 * 
 * @export
 * @interface PickingTrolleyTotesQueryOutputDTO
 */
export interface PickingTrolleyTotesQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleyTotesQueryOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleyTotesQueryOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleyTotesQueryOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleyTotesQueryOutputDTO
     */
    salesOrderOperationName?: string;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleyTotesQueryOutputDTO
     */
    totalLineItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleyTotesQueryOutputDTO
     */
    totalItemAmount?: number;
}
/**
 * 
 * @export
 * @interface PickingTrolleyTotesQueryOutputDTODynamicQueryOutputDTO
 */
export interface PickingTrolleyTotesQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PickingTrolleyTotesQueryOutputDTO>}
     * @memberof PickingTrolleyTotesQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PickingTrolleyTotesQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleyTotesQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PickingTrolleyType {
    None = 'None',
    Oversize = 'Oversize',
    Heavy = 'Heavy',
    Hov = 'HOV',
    MultiItem = 'MultiItem',
    SingleItem = 'SingleItem',
    SingleItemSioc = 'SingleItemSioc',
    SingleItemFastPack = 'SingleItemFastPack',
    Simple = 'Simple',
    Tarqan = 'Tarqan'
}

/**
 * 
 * @export
 * @interface PickingTrolleysInPackingOutputDTO
 */
export interface PickingTrolleysInPackingOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleysInPackingOutputDTO
     */
    pickingTrolleyId?: number;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleysInPackingOutputDTO
     */
    pickingTrolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleysInPackingOutputDTO
     */
    timePassedSincePickingCompleted?: number;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleysInPackingOutputDTO
     */
    vehicleType?: string;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleysInPackingOutputDTO
     */
    vehicleToteCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleysInPackingOutputDTO
     */
    packingAddressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleysInPackingOutputDTO
     */
    waitingPackingSalesOrdersCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleysInPackingOutputDTO
     */
    waitingPackingSalesOrdersLineItemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleysInPackingOutputDTO
     */
    pickingTrolleyPackedItemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleysInPackingOutputDTO
     */
    pickingTrolleyLineItemsAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleysInPackingOutputDTO
     */
    pickListId?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleysInPackingOutputDTO
     */
    pickingZone?: string;
    /**
     * 
     * @type {string}
     * @memberof PickingTrolleysInPackingOutputDTO
     */
    pickListName?: string;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof PickingTrolleysInPackingOutputDTO
     */
    pickingFlowTag?: PickingFlowTag;
    /**
     * 
     * @type {PickingMethod}
     * @memberof PickingTrolleysInPackingOutputDTO
     */
    pickingMethod?: PickingMethod;
    /**
     * 
     * @type {PickingType}
     * @memberof PickingTrolleysInPackingOutputDTO
     */
    pickingType?: PickingType;
}
/**
 * 
 * @export
 * @interface PickingTrolleysInPackingOutputDTODynamicQueryOutputDTO
 */
export interface PickingTrolleysInPackingOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PickingTrolleysInPackingOutputDTO>}
     * @memberof PickingTrolleysInPackingOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PickingTrolleysInPackingOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PickingTrolleysInPackingOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PickingType {
    None = 'None',
    Zone = 'Zone',
    Wave = 'Wave'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PicklistRequestState {
    Failed = 'Failed',
    None = 'None',
    PickingNotStarted = 'PickingNotStarted',
    PickingStarted = 'PickingStarted',
    PickingCompleted = 'PickingCompleted'
}

/**
 * 
 * @export
 * @interface PipeWriter
 */
export interface PipeWriter {
    /**
     * 
     * @type {boolean}
     * @memberof PipeWriter
     */
    canGetUnflushedBytes?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PipeWriter
     */
    unflushedBytes?: number;
}
/**
 * 
 * @export
 * @interface PlaceBatchPickingProductCommand
 */
export interface PlaceBatchPickingProductCommand {
    /**
     * 
     * @type {number}
     * @memberof PlaceBatchPickingProductCommand
     */
    sortingProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceBatchPickingProductCommand
     */
    batchPickingToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceBatchPickingProductCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceBatchPickingProductCommand
     */
    targetToteLabel?: string;
}
/**
 * 
 * @export
 * @interface PlaceDamagedItemCommand
 */
export interface PlaceDamagedItemCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceDamagedItemCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceDamagedItemCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceDamagedItemCommand
     */
    inboundAddressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceDamagedItemCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceDamagedItemCommand
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceDamagedItemCommand
     */
    lotNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceDamagedItemCommand
     */
    productAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceDamagedItemCommand
     */
    imageUrl?: string;
    /**
     * 
     * @type {InboundProblemType}
     * @memberof PlaceDamagedItemCommand
     */
    problemType?: InboundProblemType;
}
/**
 * 
 * @export
 * @interface PlaceHOVPickingTrolleyToParkAddressCommand
 */
export interface PlaceHOVPickingTrolleyToParkAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceHOVPickingTrolleyToParkAddressCommand
     */
    hovPickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceHOVPickingTrolleyToParkAddressCommand
     */
    parkAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface PlaceHOVQuarantineToteToQuarantineToteCommand
 */
export interface PlaceHOVQuarantineToteToQuarantineToteCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceHOVQuarantineToteToQuarantineToteCommand
     */
    packingQuarantineProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceHOVQuarantineToteToQuarantineToteCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceHOVQuarantineToteToQuarantineToteCommand
     */
    quarantineAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface PlaceItemOutputDTO
 */
export interface PlaceItemOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof PlaceItemOutputDTO
     */
    masterCartonItemAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PlaceItemOutputDTO
     */
    isExpirationDateRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemOutputDTO
     */
    expirationDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PlaceItemOutputDTO
     */
    isLotNumberTrackingRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemOutputDTO
     */
    lotNumber?: string;
}
/**
 * 
 * @export
 * @interface PlaceItemToQuarantineToteCommand
 */
export interface PlaceItemToQuarantineToteCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteCommand
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteCommand
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteCommand
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteCommand
     */
    inboundAddressLabel?: string;
    /**
     * 
     * @type {InboundProblemType}
     * @memberof PlaceItemToQuarantineToteCommand
     */
    problemType?: InboundProblemType;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteCommand
     */
    imageUrl?: string;
}
/**
 * 
 * @export
 * @interface PlaceItemToQuarantineToteForWebReceivingCommand
 */
export interface PlaceItemToQuarantineToteForWebReceivingCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteForWebReceivingCommand
     */
    webReceivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteForWebReceivingCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteForWebReceivingCommand
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {InboundProblemType}
     * @memberof PlaceItemToQuarantineToteForWebReceivingCommand
     */
    inboundProblemType?: InboundProblemType;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteForWebReceivingCommand
     */
    receivingAddressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceItemToQuarantineToteForWebReceivingCommand
     */
    masterCartonDamagedItemAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteForWebReceivingCommand
     */
    lotNumber?: string;
}
/**
 * 
 * @export
 * @interface PlaceItemToQuarantineToteForWebReceivingOutputDTO
 */
export interface PlaceItemToQuarantineToteForWebReceivingOutputDTO {
    /**
     * 
     * @type {WebReceivingToteDetailsOutputDTO}
     * @memberof PlaceItemToQuarantineToteForWebReceivingOutputDTO
     */
    receivingTote?: WebReceivingToteDetailsOutputDTO;
    /**
     * 
     * @type {WebReceivingToteDetailsOutputDTO}
     * @memberof PlaceItemToQuarantineToteForWebReceivingOutputDTO
     */
    quarantineTote?: WebReceivingToteDetailsOutputDTO;
    /**
     * 
     * @type {ScannedProductDetailsOutputDTO}
     * @memberof PlaceItemToQuarantineToteForWebReceivingOutputDTO
     */
    productDetails?: ScannedProductDetailsOutputDTO;
    /**
     * 
     * @type {boolean}
     * @memberof PlaceItemToQuarantineToteForWebReceivingOutputDTO
     */
    isToteContainsDifferentOperationSameBarcodeProduct?: boolean;
}
/**
 * 
 * @export
 * @interface PlaceItemToQuarantineToteOutputDTO
 */
export interface PlaceItemToQuarantineToteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToQuarantineToteOutputDTO
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {InboundProblemType}
     * @memberof PlaceItemToQuarantineToteOutputDTO
     */
    inboundProblemType?: InboundProblemType;
}
/**
 * 
 * @export
 * @interface PlaceItemToReceivingToteCommand
 */
export interface PlaceItemToReceivingToteCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToReceivingToteCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToReceivingToteCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToReceivingToteCommand
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToReceivingToteCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToReceivingToteCommand
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToReceivingToteCommand
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToReceivingToteCommand
     */
    inboundAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface PlaceItemToReceivingToteForWebReceivingCommand
 */
export interface PlaceItemToReceivingToteForWebReceivingCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToReceivingToteForWebReceivingCommand
     */
    webReceivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToReceivingToteForWebReceivingCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToReceivingToteForWebReceivingCommand
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToReceivingToteForWebReceivingCommand
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToReceivingToteForWebReceivingCommand
     */
    receivingAddress?: string;
}
/**
 * 
 * @export
 * @interface PlaceItemToReceivingToteForWebReceivingOutputDTO
 */
export interface PlaceItemToReceivingToteForWebReceivingOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof PlaceItemToReceivingToteForWebReceivingOutputDTO
     */
    totalItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaceItemToReceivingToteForWebReceivingOutputDTO
     */
    totalProductAmount?: number;
    /**
     * 
     * @type {ScannedProductDetailsOutputDTO}
     * @memberof PlaceItemToReceivingToteForWebReceivingOutputDTO
     */
    productDetails?: ScannedProductDetailsOutputDTO;
    /**
     * 
     * @type {boolean}
     * @memberof PlaceItemToReceivingToteForWebReceivingOutputDTO
     */
    isToteContainsDifferentOperationSameBarcodeProduct?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PlaceItemToReceivingToteForWebReceivingOutputDTO
     */
    isToteContainsDifferentOperationSameExpirationDateProduct?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PlaceItemToReceivingToteForWebReceivingOutputDTO
     */
    isExpirationDateRequiredProduct?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PlaceItemToReceivingToteForWebReceivingOutputDTO
     */
    isLotNumberTrackingRequired?: boolean;
}
/**
 * 
 * @export
 * @interface PlaceItemToReceivingToteOutputDTO
 */
export interface PlaceItemToReceivingToteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToReceivingToteOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToReceivingToteOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToReceivingToteOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceItemToReceivingToteOutputDTO
     */
    sku?: string;
}
/**
 * 
 * @export
 * @interface PlaceManualDeliveryCargoPackagesCommand
 */
export interface PlaceManualDeliveryCargoPackagesCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceManualDeliveryCargoPackagesCommand
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceManualDeliveryCargoPackagesCommand
     */
    manualDeliveryAddressLabel?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PlaceManualDeliveryCargoPackagesCommand
     */
    cargoPackages?: Array<string>;
}
/**
 * 
 * @export
 * @interface PlacePalletCommand
 */
export interface PlacePalletCommand {
    /**
     * 
     * @type {string}
     * @memberof PlacePalletCommand
     */
    palletLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlacePalletCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PlacePalletCommand
     */
    putAwayReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface PlaceProductCellSuggestedCommand
 */
export interface PlaceProductCellSuggestedCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceProductCellSuggestedCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductCellSuggestedCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductCellSuggestedCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductCellSuggestedCommand
     */
    productCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductCellSuggestedCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductCellSuggestedCommand
     */
    currentZoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductCellSuggestedCommand
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductCellSuggestedCommand
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductCellSuggestedCommand
     */
    lotNumber?: string;
}
/**
 * 
 * @export
 * @interface PlaceProductCellSuggestedOutputDTO
 */
export interface PlaceProductCellSuggestedOutputDTO {
    /**
     * 
     * @type {GetPutAwayCellAddressForToteOutputDTO}
     * @memberof PlaceProductCellSuggestedOutputDTO
     */
    cellAddressForTote?: GetPutAwayCellAddressForToteOutputDTO;
    /**
     * 
     * @type {TrolleyOutputDTO}
     * @memberof PlaceProductCellSuggestedOutputDTO
     */
    trolley?: TrolleyOutputDTO;
}
/**
 * 
 * @export
 * @interface PlaceProductCommand
 */
export interface PlaceProductCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceProductCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductCommand
     */
    productCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductCommand
     */
    currentZoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductCommand
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductCommand
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductCommand
     */
    lotNumber?: string;
}
/**
 * 
 * @export
 * @interface PlaceProductForFastPackPickingCommandOutputDTO
 */
export interface PlaceProductForFastPackPickingCommandOutputDTO {
    /**
     * 
     * @type {RouteOutputDTO}
     * @memberof PlaceProductForFastPackPickingCommandOutputDTO
     */
    route?: RouteOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForFastPackPickingCommandOutputDTO
     */
    currentContainedItemsAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForFastPackPickingCommandOutputDTO
     */
    expectedCurrentItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForFastPackPickingCommandOutputDTO
     */
    pickedCurrentItemAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PlaceProductForFastPackPickingCommandOutputDTO
     */
    isCurrentItemCountEntryAllowed?: boolean;
}
/**
 * 
 * @export
 * @interface PlaceProductForHOVPickingCommand
 */
export interface PlaceProductForHOVPickingCommand {
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForHOVPickingCommand
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForHOVPickingCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForHOVPickingCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForHOVPickingCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForHOVPickingCommand
     */
    pickingReferenceNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForHOVPickingCommand
     */
    productCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForHOVPickingCommand
     */
    serialNumber?: string;
}
/**
 * 
 * @export
 * @interface PlaceProductForHOVPickingCommandOutputDTO
 */
export interface PlaceProductForHOVPickingCommandOutputDTO {
    /**
     * 
     * @type {RouteOutputDTO}
     * @memberof PlaceProductForHOVPickingCommandOutputDTO
     */
    route?: RouteOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForHOVPickingCommandOutputDTO
     */
    currentContainedItemsAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForHOVPickingCommandOutputDTO
     */
    expectedCurrentItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForHOVPickingCommandOutputDTO
     */
    pickedCurrentItemAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PlaceProductForHOVPickingCommandOutputDTO
     */
    isCurrentItemCountEntryAllowed?: boolean;
}
/**
 * 
 * @export
 * @interface PlaceProductForQuickPutAwayCommand
 */
export interface PlaceProductForQuickPutAwayCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForQuickPutAwayCommand
     */
    inboundBoxLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForQuickPutAwayCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForQuickPutAwayCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForQuickPutAwayCommand
     */
    productCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForQuickPutAwayCommand
     */
    quickPutAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForQuickPutAwayCommand
     */
    currentZoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForQuickPutAwayCommand
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForQuickPutAwayCommand
     */
    lotNumber?: string;
}
/**
 * 
 * @export
 * @interface PlaceProductForRasOrderBasedPickCommand
 */
export interface PlaceProductForRasOrderBasedPickCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForRasOrderBasedPickCommand
     */
    stationLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForRasOrderBasedPickCommand
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForRasOrderBasedPickCommand
     */
    pickListId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForRasOrderBasedPickCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForRasOrderBasedPickCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForRasOrderBasedPickCommand
     */
    productBarcode?: string;
}
/**
 * 
 * @export
 * @interface PlaceProductForSingleItemFastPackPickingCommand
 */
export interface PlaceProductForSingleItemFastPackPickingCommand {
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForSingleItemFastPackPickingCommand
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForSingleItemFastPackPickingCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForSingleItemFastPackPickingCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForSingleItemFastPackPickingCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForSingleItemFastPackPickingCommand
     */
    pickingReferenceNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForSingleItemFastPackPickingCommand
     */
    productCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForSingleItemFastPackPickingCommand
     */
    serialNumber?: string;
}
/**
 * 
 * @export
 * @interface PlaceProductForSingleItemPickingCommand
 */
export interface PlaceProductForSingleItemPickingCommand {
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForSingleItemPickingCommand
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForSingleItemPickingCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForSingleItemPickingCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForSingleItemPickingCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForSingleItemPickingCommand
     */
    pickingReferenceNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForSingleItemPickingCommand
     */
    productCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductForSingleItemPickingCommand
     */
    serialNumber?: string;
}
/**
 * 
 * @export
 * @interface PlaceProductForSingleItemPickingCommandOutputDTO
 */
export interface PlaceProductForSingleItemPickingCommandOutputDTO {
    /**
     * 
     * @type {RouteOutputDTO}
     * @memberof PlaceProductForSingleItemPickingCommandOutputDTO
     */
    route?: RouteOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForSingleItemPickingCommandOutputDTO
     */
    currentContainedItemsAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForSingleItemPickingCommandOutputDTO
     */
    expectedCurrentItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductForSingleItemPickingCommandOutputDTO
     */
    pickedCurrentItemAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PlaceProductForSingleItemPickingCommandOutputDTO
     */
    isCurrentItemCountEntryAllowed?: boolean;
}
/**
 * 
 * @export
 * @interface PlaceProductOutputDTO
 */
export interface PlaceProductOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof PlaceProductOutputDTO
     */
    isToteCompleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PlaceProductOutputDTO
     */
    isSortingCompleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductOutputDTO
     */
    productCount?: number;
}
/**
 * 
 * @export
 * @interface PlaceProductToPickingToteCommand
 */
export interface PlaceProductToPickingToteCommand {
    /**
     * 
     * @type {number}
     * @memberof PlaceProductToPickingToteCommand
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductToPickingToteCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductToPickingToteCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductToPickingToteCommand
     */
    pickingToteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductToPickingToteCommand
     */
    pickingReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductToPickingToteCommand
     */
    serialNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductToPickingToteCommand
     */
    productCount?: number;
}
/**
 * 
 * @export
 * @interface PlaceProductToQuarantineWallCommand
 */
export interface PlaceProductToQuarantineWallCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceProductToQuarantineWallCommand
     */
    sourceToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductToQuarantineWallCommand
     */
    targetToteLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PlaceProductToQuarantineWallCommand
     */
    placeAllItems?: boolean;
    /**
     * 
     * @type {Array<QuarantineWallProductInputDTO>}
     * @memberof PlaceProductToQuarantineWallCommand
     */
    products?: Array<QuarantineWallProductInputDTO>;
}
/**
 * 
 * @export
 * @interface PlaceProductToSimplePickingToteCommand
 */
export interface PlaceProductToSimplePickingToteCommand {
    /**
     * 
     * @type {number}
     * @memberof PlaceProductToSimplePickingToteCommand
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductToSimplePickingToteCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductToSimplePickingToteCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductToSimplePickingToteCommand
     */
    pickingToteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductToSimplePickingToteCommand
     */
    pickingReferenceNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductToSimplePickingToteCommand
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductToSimplePickingToteCommand
     */
    serialNumber?: string;
}
/**
 * 
 * @export
 * @interface PlaceProductToToteCommand
 */
export interface PlaceProductToToteCommand {
    /**
     * 
     * @type {number}
     * @memberof PlaceProductToToteCommand
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductToToteCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductToToteCommand
     */
    productLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductToToteCommand
     */
    pickingToteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceProductToToteCommand
     */
    pickingReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceProductToToteCommand
     */
    serialNumber?: string;
}
/**
 * 
 * @export
 * @interface PlaceQuarantineToteToQuarantineAddressCommand
 */
export interface PlaceQuarantineToteToQuarantineAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceQuarantineToteToQuarantineAddressCommand
     */
    packingQuarantineProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceQuarantineToteToQuarantineAddressCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceQuarantineToteToQuarantineAddressCommand
     */
    quarantineAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface PlaceReceivedItemCommand
 */
export interface PlaceReceivedItemCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceReceivedItemCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceReceivedItemCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceReceivedItemCommand
     */
    inboundAddressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceReceivedItemCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceReceivedItemCommand
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceReceivedItemCommand
     */
    lotNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceReceivedItemCommand
     */
    productAmount?: number;
}
/**
 * 
 * @export
 * @interface PlaceReturnPackageToTrolleyCommand
 */
export interface PlaceReturnPackageToTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceReturnPackageToTrolleyCommand
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceReturnPackageToTrolleyCommand
     */
    returnReceivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceReturnPackageToTrolleyCommand
     */
    trackingId?: string;
}
/**
 * 
 * @export
 * @interface PlaceReturnPackageToTrolleyOutputDTO
 */
export interface PlaceReturnPackageToTrolleyOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PlaceReturnPackageToTrolleyOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceReturnPackageToTrolleyOutputDTO
     */
    operatorId?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceReturnPackageToTrolleyOutputDTO
     */
    returnTrolleyId?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceReturnPackageToTrolleyOutputDTO
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {Array<ReturnPackageComponentOutputDTO>}
     * @memberof PlaceReturnPackageToTrolleyOutputDTO
     */
    returnPackages?: Array<ReturnPackageComponentOutputDTO>;
}
/**
 * 
 * @export
 * @interface PlaceSingleItemFastPackPickingTrolleyToParkAddressCommand
 */
export interface PlaceSingleItemFastPackPickingTrolleyToParkAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceSingleItemFastPackPickingTrolleyToParkAddressCommand
     */
    singleItemFastPackPickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceSingleItemFastPackPickingTrolleyToParkAddressCommand
     */
    parkAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface PlaceSingleItemPickingTrolleyToParkAddressCommand
 */
export interface PlaceSingleItemPickingTrolleyToParkAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceSingleItemPickingTrolleyToParkAddressCommand
     */
    singleItemPickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceSingleItemPickingTrolleyToParkAddressCommand
     */
    parkAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface PlaceToteToInboundCommand
 */
export interface PlaceToteToInboundCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceToteToInboundCommand
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceToteToInboundCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceToteToInboundCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceToteToInboundCommand
     */
    inboundLabel?: string;
}
/**
 * 
 * @export
 * @interface PlaceToteToPickStationCommand
 */
export interface PlaceToteToPickStationCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceToteToPickStationCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceToteToPickStationCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceToteToPickStationCommand
     */
    slot?: number;
}
/**
 * 
 * @export
 * @interface PlaceToteToRASTrolleyCommand
 */
export interface PlaceToteToRASTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceToteToRASTrolleyCommand
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceToteToRASTrolleyCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceToteToRASTrolleyCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceToteToRASTrolleyCommand
     */
    inboundLabel?: string;
}
/**
 * 
 * @export
 * @interface PlaceToteToStowStationCommand
 */
export interface PlaceToteToStowStationCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceToteToStowStationCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceToteToStowStationCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceToteToStowStationCommand
     */
    slot?: number;
}
/**
 * 
 * @export
 * @interface PlaceToteToTrolleyCommand
 */
export interface PlaceToteToTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceToteToTrolleyCommand
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceToteToTrolleyCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceToteToTrolleyCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceToteToTrolleyCommand
     */
    inboundLabel?: string;
}
/**
 * 
 * @export
 * @interface PlaceToteToTrolleyForRasReplenishmentCommand
 */
export interface PlaceToteToTrolleyForRasReplenishmentCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceToteToTrolleyForRasReplenishmentCommand
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceToteToTrolleyForRasReplenishmentCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PlaceToteToTrolleyForRasReplenishmentCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceToteToTrolleyForRasReplenishmentCommand
     */
    inboundLabel?: string;
}
/**
 * 
 * @export
 * @interface PlaceToteToTrolleyOutputDTO
 */
export interface PlaceToteToTrolleyOutputDTO {
    /**
     * 
     * @type {Array<RasReplenishmentToteDetailsOutputDTO>}
     * @memberof PlaceToteToTrolleyOutputDTO
     */
    totes?: Array<RasReplenishmentToteDetailsOutputDTO>;
}
/**
 * 
 * @export
 * @interface PlaceTrolleysCommand
 */
export interface PlaceTrolleysCommand {
    /**
     * 
     * @type {string}
     * @memberof PlaceTrolleysCommand
     */
    stationLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceTrolleysCommand
     */
    leftTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceTrolleysCommand
     */
    rightTrolleyLabel?: string;
}
/**
 * 
 * @export
 * @interface PreviewManualPicklistRequestCommand
 */
export interface PreviewManualPicklistRequestCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof PreviewManualPicklistRequestCommand
     */
    salesOrderIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PreviewManualPicklistRequestCommand
     */
    isFastPackEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PreviewManualPicklistRequestCommand
     */
    subZoneId?: number;
}
/**
 * 
 * @export
 * @interface PreviewManualPicklistRequestOutputDTO
 */
export interface PreviewManualPicklistRequestOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof PreviewManualPicklistRequestOutputDTO
     */
    totalBatchPickingBatchCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewManualPicklistRequestOutputDTO
     */
    totalBatchPickingOrdersCount?: number;
    /**
     * 
     * @type {Array<BatchPickingPicklistDetailsOutputDTO>}
     * @memberof PreviewManualPicklistRequestOutputDTO
     */
    batchPicklistDetails?: Array<BatchPickingPicklistDetailsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PreviewManualPicklistRequestOutputDTO
     */
    totalOrderBasedPickingPicklistCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewManualPicklistRequestOutputDTO
     */
    totalOrderBasedPickingOrdersCount?: number;
    /**
     * 
     * @type {Array<OrderBasedPicklistDetailsOutputDTO>}
     * @memberof PreviewManualPicklistRequestOutputDTO
     */
    orderBasedPicklistDetails?: Array<OrderBasedPicklistDetailsOutputDTO>;
    /**
     * 
     * @type {UnassignableSalesOrdersOutputDTO}
     * @memberof PreviewManualPicklistRequestOutputDTO
     */
    assignmentFailedOrders?: UnassignableSalesOrdersOutputDTO;
    /**
     * 
     * @type {Array<SubZoneUnavailableOrderOutputDTO>}
     * @memberof PreviewManualPicklistRequestOutputDTO
     */
    subZoneUnavailableOrders?: Array<SubZoneUnavailableOrderOutputDTO>;
}
/**
 * 
 * @export
 * @interface PreviewWallToWallStockCountingPlanItemOutputDTO
 */
export interface PreviewWallToWallStockCountingPlanItemOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof PreviewWallToWallStockCountingPlanItemOutputDTO
     */
    cellId?: number;
    /**
     * 
     * @type {string}
     * @memberof PreviewWallToWallStockCountingPlanItemOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PreviewWallToWallStockCountingPlanItemOutputDTO
     */
    stockCount?: number;
}
/**
 * 
 * @export
 * @interface PreviewWallToWallStockCountingPlanItemOutputDTODynamicQueryOutputDTO
 */
export interface PreviewWallToWallStockCountingPlanItemOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PreviewWallToWallStockCountingPlanItemOutputDTO>}
     * @memberof PreviewWallToWallStockCountingPlanItemOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PreviewWallToWallStockCountingPlanItemOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PreviewWallToWallStockCountingPlanItemOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface PreviewWallToWallStockCountingPlanListOutputDTO
 */
export interface PreviewWallToWallStockCountingPlanListOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PreviewWallToWallStockCountingPlanListOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewWallToWallStockCountingPlanListOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof PreviewWallToWallStockCountingPlanListOutputDTO
     */
    addressCount?: number;
}
/**
 * 
 * @export
 * @interface PreviewWallToWallStockCountingPlanListOutputDTODynamicQueryOutputDTO
 */
export interface PreviewWallToWallStockCountingPlanListOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PreviewWallToWallStockCountingPlanListOutputDTO>}
     * @memberof PreviewWallToWallStockCountingPlanListOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PreviewWallToWallStockCountingPlanListOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PreviewWallToWallStockCountingPlanListOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface PrintActionInputDTO
 */
export interface PrintActionInputDTO {
    /**
     * 
     * @type {PrintWorkflowApplicability}
     * @memberof PrintActionInputDTO
     */
    applicability?: PrintWorkflowApplicability;
    /**
     * 
     * @type {string}
     * @memberof PrintActionInputDTO
     */
    targetPrinter?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintActionInputDTO
     */
    addressType?: string;
    /**
     * 
     * @type {PrinterTypes}
     * @memberof PrintActionInputDTO
     */
    printerType?: PrinterTypes;
}
/**
 * 
 * @export
 * @interface PrintAdditionalCargoPackageLabelsCommand
 */
export interface PrintAdditionalCargoPackageLabelsCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintAdditionalCargoPackageLabelsCommand
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintAdditionalCargoPackageLabelsCommand
     */
    packingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface PrintApprovedCargoPackageCarrierLabelCommand
 */
export interface PrintApprovedCargoPackageCarrierLabelCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintApprovedCargoPackageCarrierLabelCommand
     */
    cargoPackageBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintApprovedCargoPackageCarrierLabelCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PrintApprovedCargoPackageCarrierLabelCommand
     */
    isForcePrint?: boolean;
}
/**
 * 
 * @export
 * @interface PrintApprovedCargoPackageCarrierLabelOutputDTO
 */
export interface PrintApprovedCargoPackageCarrierLabelOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PrintApprovedCargoPackageCarrierLabelOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintApprovedCargoPackageCarrierLabelOutputDTO
     */
    cargoPackageLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintApprovedCargoPackageCarrierLabelOutputDTO
     */
    cargoCarrier?: string;
    /**
     * 
     * @type {CargoPackageSLAMState}
     * @memberof PrintApprovedCargoPackageCarrierLabelOutputDTO
     */
    state?: CargoPackageSLAMState;
    /**
     * 
     * @type {string}
     * @memberof PrintApprovedCargoPackageCarrierLabelOutputDTO
     */
    printedASN?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PrintApprovedCargoPackageCarrierLabelOutputDTO
     */
    isWaybillPrinted?: boolean;
}
/**
 * 
 * @export
 * @interface PrintCargoPackageCarrierLabelCommand
 */
export interface PrintCargoPackageCarrierLabelCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintCargoPackageCarrierLabelCommand
     */
    cargoPackageBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintCargoPackageCarrierLabelCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PrintCargoPackageCarrierLabelCommand
     */
    isForcePrint?: boolean;
}
/**
 * 
 * @export
 * @interface PrintCargoPackageCarrierLabelOutputDTO
 */
export interface PrintCargoPackageCarrierLabelOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PrintCargoPackageCarrierLabelOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintCargoPackageCarrierLabelOutputDTO
     */
    cargoPackageLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintCargoPackageCarrierLabelOutputDTO
     */
    cargoCarrier?: string;
    /**
     *
     * @type {CargoPackageSLAMState}
     * @memberof PrintCargoPackageCarrierLabelOutputDTO
     */
    state?: CargoPackageSLAMState;
    /**
     *
     * @type {boolean}
     * @memberof PrintCargoPackageCarrierLabelOutputDTO
     */
    isCargoLabelAlreadyPrintedAtPacking?: boolean;
}
/**
 * 
 * @export
 * @interface PrintCargoPackageLabelsCommand
 */
export interface PrintCargoPackageLabelsCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintCargoPackageLabelsCommand
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintCargoPackageLabelsCommand
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface PrintHOVCargoPackageLabelsCommand
 */
export interface PrintHOVCargoPackageLabelsCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintHOVCargoPackageLabelsCommand
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintHOVCargoPackageLabelsCommand
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface PrintHOVPalettePackingListCommand
 */
export interface PrintHOVPalettePackingListCommand {
    /**
     * 
     * @type {number}
     * @memberof PrintHOVPalettePackingListCommand
     */
    cargoPackageId?: number;
    /**
     * 
     * @type {string}
     * @memberof PrintHOVPalettePackingListCommand
     */
    packingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface PrintNewPalletCommand
 */
export interface PrintNewPalletCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintNewPalletCommand
     */
    palletLabel?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PrintPageSizeType {
    None = 'None',
    A3 = 'A3',
    A4 = 'A4',
    A5 = 'A5',
    A6 = 'A6'
}

/**
 * 
 * @export
 * @interface PrintPalettePackingListCommand
 */
export interface PrintPalettePackingListCommand {
    /**
     * 
     * @type {number}
     * @memberof PrintPalettePackingListCommand
     */
    cargoPackageId?: number;
    /**
     * 
     * @type {string}
     * @memberof PrintPalettePackingListCommand
     */
    packingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface PrintReceivedReturnPackagesCommand
 */
export interface PrintReceivedReturnPackagesCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintReceivedReturnPackagesCommand
     */
    returnReceivingProcessId?: string;
}
/**
 * 
 * @export
 * @interface PrintSLAMDocumentsOnPackingCommand
 */
export interface PrintSLAMDocumentsOnPackingCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintSLAMDocumentsOnPackingCommand
     */
    pickingToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintSLAMDocumentsOnPackingCommand
     */
    packingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface PrintSLAMDocumentsOnPackingOutputDTO
 */
export interface PrintSLAMDocumentsOnPackingOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof PrintSLAMDocumentsOnPackingOutputDTO
     */
    isSuspended?: boolean;
}
/**
 * 
 * @export
 * @interface PrintSLAMDocumentsOnSimplePackingCommand
 */
export interface PrintSLAMDocumentsOnSimplePackingCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintSLAMDocumentsOnSimplePackingCommand
     */
    simplePackingAddressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintSLAMDocumentsOnSimplePackingCommand
     */
    salesOrderId?: string;
}
/**
 * 
 * @export
 * @interface PrintSLAMDocumentsOnSingleItemPackingOutputDTO
 */
export interface PrintSLAMDocumentsOnSingleItemPackingOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof PrintSLAMDocumentsOnSingleItemPackingOutputDTO
     */
    isSuspended?: boolean;
}
/**
 * 
 * @export
 * @interface PrintSLAMDocumentsOnSingleItemSalesOrderPackingCommand
 */
export interface PrintSLAMDocumentsOnSingleItemSalesOrderPackingCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintSLAMDocumentsOnSingleItemSalesOrderPackingCommand
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintSLAMDocumentsOnSingleItemSalesOrderPackingCommand
     */
    singleItemPackingAddress?: string;
}
/**
 * 
 * @export
 * @interface PrintSingleItemFastPackSalesOrderCargoPackageLabelsCommand
 */
export interface PrintSingleItemFastPackSalesOrderCargoPackageLabelsCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintSingleItemFastPackSalesOrderCargoPackageLabelsCommand
     */
    singleItemFastPackPackingProcessId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrintSingleItemFastPackSalesOrderCargoPackageLabelsCommand
     */
    scannedSalesOrderReferenceNumbers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PrintSingleItemFastPackSalesOrderCargoPackageLabelsCommand
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface PrintSingleItemSalesOrderCargoPackageLabelsCommand
 */
export interface PrintSingleItemSalesOrderCargoPackageLabelsCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintSingleItemSalesOrderCargoPackageLabelsCommand
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintSingleItemSalesOrderCargoPackageLabelsCommand
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface PrintSingleItemSalesOrderVASCommand
 */
export interface PrintSingleItemSalesOrderVASCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintSingleItemSalesOrderVASCommand
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintSingleItemSalesOrderVASCommand
     */
    singleItemPackingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface PrintTestPageCommand
 */
export interface PrintTestPageCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintTestPageCommand
     */
    selectedPrinterName?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintTestPageCommand
     */
    machineName?: string;
}
/**
 * 
 * @export
 * @interface PrintUnprintedHOVPalettePackingListCommand
 */
export interface PrintUnprintedHOVPalettePackingListCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintUnprintedHOVPalettePackingListCommand
     */
    salesOrderId?: string;
}
/**
 * 
 * @export
 * @interface PrintUnprintedPalettePackingListCommand
 */
export interface PrintUnprintedPalettePackingListCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintUnprintedPalettePackingListCommand
     */
    salesOrderId?: string;
}
/**
 * 
 * @export
 * @interface PrintVASCommand
 */
export interface PrintVASCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintVASCommand
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintVASCommand
     */
    packingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface PrintWaybillCommand
 */
export interface PrintWaybillCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintWaybillCommand
     */
    purchaseOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintWaybillCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintWaybillCommand
     */
    inboundBoxType?: string;
}
/**
 * 
 * @export
 * @interface PrintWaybillDocumentCommand
 */
export interface PrintWaybillDocumentCommand {
    /**
     * 
     * @type {string}
     * @memberof PrintWaybillDocumentCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintWaybillDocumentCommand
     */
    waybillStationAddressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PrintWaybillDocumentCommand
     */
    copyCount?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PrintWorkflowApplicability {
    AddressType = 'AddressType',
    SinglePrinter = 'SinglePrinter'
}

/**
 * 
 * @export
 * @interface PrinterAddressOutputDTO
 */
export interface PrinterAddressOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PrinterAddressOutputDTO
     */
    printerName?: string;
    /**
     * 
     * @type {string}
     * @memberof PrinterAddressOutputDTO
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface PrinterOutputDTO
 */
export interface PrinterOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PrinterOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PrinterOutputDTO
     */
    printerName?: string;
    /**
     * 
     * @type {string}
     * @memberof PrinterOutputDTO
     */
    queueName?: string;
    /**
     * 
     * @type {string}
     * @memberof PrinterOutputDTO
     */
    selectedPrinterName?: string;
    /**
     * 
     * @type {string}
     * @memberof PrinterOutputDTO
     */
    machineName?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PrinterTypes {
    None = 'None',
    Barcode = 'Barcode',
    A4 = 'A4',
    A4Barcode = 'A4Barcode'
}

/**
 * 
 * @export
 * @interface PrioritizePickListRequestsCommand
 */
export interface PrioritizePickListRequestsCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof PrioritizePickListRequestsCommand
     */
    referenceNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface PrioritizeSalesOrdersCommand
 */
export interface PrioritizeSalesOrdersCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof PrioritizeSalesOrdersCommand
     */
    salesOrderIds?: Array<string>;
    /**
     * 
     * @type {SalesOrderPickingPriority}
     * @memberof PrioritizeSalesOrdersCommand
     */
    priority?: SalesOrderPickingPriority;
}
/**
 * 
 * @export
 * @interface PrioritizeStockCountingPlanCommand
 */
export interface PrioritizeStockCountingPlanCommand {
    /**
     * 
     * @type {number}
     * @memberof PrioritizeStockCountingPlanCommand
     */
    referenceNumber?: number;
}
/**
 * 
 * @export
 * @interface PrioritizedSalesOrderOutputDTO
 */
export interface PrioritizedSalesOrderOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {SalesOrderPickingPriority}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    priority?: SalesOrderPickingPriority;
    /**
     * 
     * @type {number}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    itemCount?: number;
    /**
     * 
     * @type {SalesChannel}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {string}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    targetDispatchDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    vehicleType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    isCutOff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    pickListZone?: string;
    /**
     * 
     * @type {string}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    pickListName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    candidateZones?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    province?: string;
    /**
     * 
     * @type {number}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    problemCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PrioritizedSalesOrderOutputDTO
     */
    batchName?: string;
}
/**
 * 
 * @export
 * @interface PrioritizedSalesOrderOutputDTODynamicQueryOutputDTO
 */
export interface PrioritizedSalesOrderOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PrioritizedSalesOrderOutputDTO>}
     * @memberof PrioritizedSalesOrderOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PrioritizedSalesOrderOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PrioritizedSalesOrderOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    detail?: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    instance?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProblemDetails
     */
    extensions?: { [key: string]: object; };
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProblemDetailsLostItemProblemState {
    None = 'None',
    Created = 'Created',
    Reviewed = 'Reviewed',
    CustomerServicesReviewed = 'CustomerServicesReviewed',
    Resolved = 'Resolved'
}

/**
 * 
 * @export
 * @interface ProblemOperationOutputDTO
 */
export interface ProblemOperationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProblemOperationOutputDTO
     */
    problemId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemOperationOutputDTO
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemOperationOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemOperationOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemOperationOutputDTO
     */
    operationImageURL?: string;
}
/**
 * 
 * @export
 * @interface ProblemQueryOutputDTO
 */
export interface ProblemQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProblemQueryOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemQueryOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemQueryOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemQueryOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemQueryOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {ProblemState}
     * @memberof ProblemQueryOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {string}
     * @memberof ProblemQueryOutputDTO
     */
    source?: string;
    /**
     * 
     * @type {ProblemType}
     * @memberof ProblemQueryOutputDTO
     */
    type?: ProblemType;
    /**
     * 
     * @type {string}
     * @memberof ProblemQueryOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemQueryOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemQueryOutputDTO
     */
    resolvedUser?: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemQueryOutputDTO
     */
    resolutionNote?: string;
}
/**
 * 
 * @export
 * @interface ProblemQueryOutputDTODynamicQueryOutputDTO
 */
export interface ProblemQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ProblemQueryOutputDTO>}
     * @memberof ProblemQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ProblemQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ProblemQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProblemSolverStationProblemState {
    AwaitingStockCounting = 'AwaitingStockCounting',
    AwaitingStock = 'AwaitingStock',
    AwaitingWallPlacement = 'AwaitingWallPlacement',
    AwaitingWallTransfer = 'AwaitingWallTransfer',
    AwaitingLostPickingList = 'AwaitingLostPickingList',
    AwaitingCustomerSupportApproval = 'AwaitingCustomerSupportApproval',
    Packable = 'Packable',
    AwaitingRestow = 'AwaitingRestow'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ProblemSource {
    None = 'None',
    Maestro = 'Maestro',
    User = 'User',
    Ras = 'RAS',
    Counting = 'Counting'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ProblemState {
    None = 'None',
    Created = 'Created',
    InProgress = 'InProgress',
    Resolved = 'Resolved'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ProblemType {
    None = 'None',
    CargoCarrierPreferenceProblem = 'CargoCarrierPreferenceProblem',
    CargoCarrierQuotaProblem = 'CargoCarrierQuotaProblem',
    LostItemProblem = 'LostItemProblem',
    MarketplaceCargoCarrierQuotaProblem = 'MarketplaceCargoCarrierQuotaProblem',
    MissingCargoPackageLabelProblem = 'MissingCargoPackageLabelProblem',
    MissingSlamLabelProblem = 'MissingSLAMLabelProblem',
    SlamShipmentProblem = 'SLAMShipmentProblem',
    WrongShippingAddressProblem = 'WrongShippingAddressProblem',
    MixPickingProblem = 'MixPickingProblem',
    OutOfStockProblem = 'OutOfStockProblem',
    IntegrationCodeProblem = 'IntegrationCodeProblem',
    InvalidCountryCityProvinceProblem = 'InvalidCountryCityProvinceProblem',
    CargoCodeUpdatedProblem = 'CargoCodeUpdatedProblem',
    AwaitingFeedingProblem = 'AwaitingFeedingProblem',
    AwaitingPutAwayProblem = 'AwaitingPutAwayProblem'
}

/**
 * 
 * @export
 * @interface ProblematicToteDTO
 */
export interface ProblematicToteDTO {
    /**
     * 
     * @type {number}
     * @memberof ProblematicToteDTO
     */
    toteId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProblematicToteDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ProblematicToteDTO
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ProblematicToteDTO
     */
    referenceNumber?: string;
}
/**
 * 
 * @export
 * @interface ProcessConfigurationsOutputDTO
 */
export interface ProcessConfigurationsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProcessConfigurationsOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {number}
     * @memberof ProcessConfigurationsOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProcessConfigurationsOutputDTO
     */
    isCellSuggestedPutAwayActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProcessConfigurationsOutputDTO
     */
    putAwayCellAllocationThresholdInMinutes?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProcessType {
    None = 'None',
    Receiving = 'Receiving',
    PutAway = 'PutAway',
    Picking = 'Picking',
    Packing = 'Packing',
    Dispatch = 'Dispatch',
    ReturnReceiving = 'ReturnReceiving',
    Return = 'Return',
    SingleItemPacking = 'SingleItemPacking',
    PalletPutAway = 'PalletPutAway'
}

/**
 * 
 * @export
 * @interface ProcessedVASItemsOutputDTO
 */
export interface ProcessedVASItemsOutputDTO {
    /**
     * 
     * @type {OutputVASType}
     * @memberof ProcessedVASItemsOutputDTO
     */
    vasType?: OutputVASType;
    /**
     * 
     * @type {string}
     * @memberof ProcessedVASItemsOutputDTO
     */
    barcode?: string;
}
/**
 * 
 * @export
 * @interface ProductAddressDetailOutputDTO
 */
export interface ProductAddressDetailOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductAddressDetailOutputDTO
     */
    containerType?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAddressDetailOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductAddressDetailOutputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface ProductBarcodeInputDTO
 */
export interface ProductBarcodeInputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductBarcodeInputDTO
     */
    barcode?: string;
}
/**
 * 
 * @export
 * @interface ProductContainerDetailsOutputDTO
 */
export interface ProductContainerDetailsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof ProductContainerDetailsOutputDTO
     */
    containerCount?: number;
    /**
     * 
     * @type {Array<ContainerOutputDTO>}
     * @memberof ProductContainerDetailsOutputDTO
     */
    containers?: Array<ContainerOutputDTO>;
}
/**
 * 
 * @export
 * @interface ProductControlCountingForHOVPickingResultOutputDTO
 */
export interface ProductControlCountingForHOVPickingResultOutputDTO {
    /**
     * 
     * @type {Array<LostItemOutputDto>}
     * @memberof ProductControlCountingForHOVPickingResultOutputDTO
     */
    lostItems?: Array<LostItemOutputDto>;
    /**
     * 
     * @type {RouteOutputDTO}
     * @memberof ProductControlCountingForHOVPickingResultOutputDTO
     */
    nextRoute?: RouteOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof ProductControlCountingForHOVPickingResultOutputDTO
     */
    expectedCurrentItemAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductControlCountingForHOVPickingResultOutputDTO
     */
    isCurrentItemCountEntryAllowed?: boolean;
    /**
     * 
     * @type {ProductControlCountingResultAction}
     * @memberof ProductControlCountingForHOVPickingResultOutputDTO
     */
    resultAction?: ProductControlCountingResultAction;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductControlCountingResultAction {
    NoAction = 'NoAction',
    CurrentItemPickedFromOtherAddress = 'CurrentItemPickedFromOtherAddress',
    ShowMissingItemsAndContinuePicking = 'ShowMissingItemsAndContinuePicking'
}

/**
 * 
 * @export
 * @interface ProductControlCountingResultOutputDTO
 */
export interface ProductControlCountingResultOutputDTO {
    /**
     * 
     * @type {Array<LostItemOutputDto>}
     * @memberof ProductControlCountingResultOutputDTO
     */
    lostItems?: Array<LostItemOutputDto>;
    /**
     * 
     * @type {RouteOutputDTO}
     * @memberof ProductControlCountingResultOutputDTO
     */
    nextRoute?: RouteOutputDTO;
    /**
     * 
     * @type {ProductControlCountingResultAction}
     * @memberof ProductControlCountingResultOutputDTO
     */
    resultAction?: ProductControlCountingResultAction;
}
/**
 * 
 * @export
 * @interface ProductDTO
 */
export interface ProductDTO {
    /**
     * 
     * @type {number}
     * @memberof ProductDTO
     */
    productQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDTO
     */
    productSku?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDTO
     */
    productName?: string;
}
/**
 * 
 * @export
 * @interface ProductDetailsByOperationOutputDTO
 */
export interface ProductDetailsByOperationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsByOperationOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsByOperationOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsByOperationOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsByOperationOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsByOperationOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsByOperationOutputDTO
     */
    stockZones?: string;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof ProductDetailsByOperationOutputDTO
     */
    width?: MeasurementDTO;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof ProductDetailsByOperationOutputDTO
     */
    length?: MeasurementDTO;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof ProductDetailsByOperationOutputDTO
     */
    height?: MeasurementDTO;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof ProductDetailsByOperationOutputDTO
     */
    weight?: MeasurementDTO;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetailsByOperationOutputDTO
     */
    isTrackExpirationDate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetailsByOperationOutputDTO
     */
    isTrackSerialNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetailsByOperationOutputDTO
     */
    isTrackLotNumber?: boolean;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof ProductDetailsByOperationOutputDTO
     */
    operation?: OperationOutputDTO;
}
/**
 * 
 * @export
 * @interface ProductDetailsOutputDTO
 */
export interface ProductDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {ProductType}
     * @memberof ProductDetailsOutputDTO
     */
    type?: ProductType;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductDetailsOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof ProductDetailsOutputDTO
     */
    width?: MeasurementDTO;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof ProductDetailsOutputDTO
     */
    length?: MeasurementDTO;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof ProductDetailsOutputDTO
     */
    height?: MeasurementDTO;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof ProductDetailsOutputDTO
     */
    weight?: MeasurementDTO;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsOutputDTO
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetailsOutputDTO
     */
    isHeavy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetailsOutputDTO
     */
    isOversize?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsOutputDTO
     */
    stockZones?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetailsOutputDTO
     */
    isTrackExpirationDate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetailsOutputDTO
     */
    isTrackSerialNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetailsOutputDTO
     */
    isTrackSimpleSerialNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetailsOutputDTO
     */
    isTrackLotNumber?: boolean;
}
/**
 * 
 * @export
 * @interface ProductDetailsWithOperationOutputDTO
 */
export interface ProductDetailsWithOperationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsWithOperationOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductDetailsWithOperationOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof ProductDetailsWithOperationOutputDTO
     */
    operation?: OperationOutputDTO;
}
/**
 * 
 * @export
 * @interface ProductDetailsWithOperationsOutputDTO
 */
export interface ProductDetailsWithOperationsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsWithOperationsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsWithOperationsOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsWithOperationsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsWithOperationsOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsWithOperationsOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetailsWithOperationsOutputDTO
     */
    isTrackExpirationDate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetailsWithOperationsOutputDTO
     */
    isTrackSerialNumber?: boolean;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof ProductDetailsWithOperationsOutputDTO
     */
    width?: MeasurementDTO;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof ProductDetailsWithOperationsOutputDTO
     */
    length?: MeasurementDTO;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof ProductDetailsWithOperationsOutputDTO
     */
    height?: MeasurementDTO;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof ProductDetailsWithOperationsOutputDTO
     */
    weight?: MeasurementDTO;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsWithOperationsOutputDTO
     */
    stockZones?: string;
    /**
     * 
     * @type {Array<OperationOutputDTO>}
     * @memberof ProductDetailsWithOperationsOutputDTO
     */
    operations?: Array<OperationOutputDTO>;
}
/**
 * 
 * @export
 * @interface ProductDimensionBulkItemInputDTO
 */
export interface ProductDimensionBulkItemInputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductDimensionBulkItemInputDTO
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductDimensionBulkItemInputDTO
     */
    weight?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductDimensionBulkItemInputDTO
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductDimensionBulkItemInputDTO
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductDimensionBulkItemInputDTO
     */
    length?: number;
}
/**
 * 
 * @export
 * @interface ProductDimensionInputDTO
 */
export interface ProductDimensionInputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductDimensionInputDTO
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductDimensionInputDTO
     */
    value?: number;
}
/**
 * 
 * @export
 * @interface ProductDimensionUpdateOutputDTO
 */
export interface ProductDimensionUpdateOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof ProductDimensionUpdateOutputDTO
     */
    isSuccess?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductDimensionUpdateOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDimensionUpdateOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductDimensionUpdateOutputDTO
     */
    possibleOperationNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductDimensionUpdateOutputDTO
     */
    exceptionMessage?: string;
}
/**
 * 
 * @export
 * @interface ProductDimensionsInputDTO
 */
export interface ProductDimensionsInputDTO {
    /**
     * 
     * @type {ProductDimensionInputDTO}
     * @memberof ProductDimensionsInputDTO
     */
    weight?: ProductDimensionInputDTO;
    /**
     * 
     * @type {ProductDimensionInputDTO}
     * @memberof ProductDimensionsInputDTO
     */
    height?: ProductDimensionInputDTO;
    /**
     * 
     * @type {ProductDimensionInputDTO}
     * @memberof ProductDimensionsInputDTO
     */
    width?: ProductDimensionInputDTO;
    /**
     * 
     * @type {ProductDimensionInputDTO}
     * @memberof ProductDimensionsInputDTO
     */
    lenght?: ProductDimensionInputDTO;
}
/**
 * 
 * @export
 * @interface ProductInventoryItemDetailsOutputDTO
 */
export interface ProductInventoryItemDetailsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof ProductInventoryItemDetailsOutputDTO
     */
    availableStockCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductInventoryItemDetailsOutputDTO
     */
    stockItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductInventoryItemDetailsOutputDTO
     */
    receivedItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductInventoryItemDetailsOutputDTO
     */
    pickingItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductInventoryItemDetailsOutputDTO
     */
    packingItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductInventoryItemDetailsOutputDTO
     */
    damagedItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductInventoryItemDetailsOutputDTO
     */
    lostItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductInventoryItemDetailsOutputDTO
     */
    waitingForPicking?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductInventoryItemDetailsOutputDTO
     */
    reservedStockAmount?: number;
}
/**
 * 
 * @export
 * @interface ProductListingInputDTO
 */
export interface ProductListingInputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductListingInputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductListingInputDTO
     */
    imageUrl?: string;
}
/**
 * 
 * @export
 * @interface ProductListingQueryOutputDTO
 */
export interface ProductListingQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductListingQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductListingQueryOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductListingQueryOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductListingQueryOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface ProductListingQueryOutputDTODynamicQueryOutputDTO
 */
export interface ProductListingQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ProductListingQueryOutputDTO>}
     * @memberof ProductListingQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ProductListingQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ProductListingQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ProductNotSuitableForTransferDTO
 */
export interface ProductNotSuitableForTransferDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductNotSuitableForTransferDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductNotSuitableForTransferDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductNotSuitableForTransferDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductNotSuitableForTransferDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductNotSuitableForTransferDTO
     */
    expirationDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductNotSuitableForTransferDTO
     */
    hasExpirationDateProblem?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductNotSuitableForTransferDTO
     */
    hasZoneProblem?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductNotSuitableForTransferDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface ProductODataDTOODataQueryOptions
 */
export interface ProductODataDTOODataQueryOptions {
    /**
     * 
     * @type {string}
     * @memberof ProductODataDTOODataQueryOptions
     */
    ifMatch?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductODataDTOODataQueryOptions
     */
    ifNoneMatch?: string;
    /**
     * 
     * @type {HttpRequest}
     * @memberof ProductODataDTOODataQueryOptions
     */
    request?: HttpRequest;
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof ProductODataDTOODataQueryOptions
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {ODataRawQueryOptions}
     * @memberof ProductODataDTOODataQueryOptions
     */
    rawValues?: ODataRawQueryOptions;
    /**
     * 
     * @type {SelectExpandQueryOption}
     * @memberof ProductODataDTOODataQueryOptions
     */
    selectExpand?: SelectExpandQueryOption;
    /**
     * 
     * @type {ApplyQueryOption}
     * @memberof ProductODataDTOODataQueryOptions
     */
    apply?: ApplyQueryOption;
    /**
     * 
     * @type {ComputeQueryOption}
     * @memberof ProductODataDTOODataQueryOptions
     */
    compute?: ComputeQueryOption;
    /**
     * 
     * @type {FilterQueryOption}
     * @memberof ProductODataDTOODataQueryOptions
     */
    filter?: FilterQueryOption;
    /**
     * 
     * @type {SearchQueryOption}
     * @memberof ProductODataDTOODataQueryOptions
     */
    search?: SearchQueryOption;
    /**
     * 
     * @type {OrderByQueryOption}
     * @memberof ProductODataDTOODataQueryOptions
     */
    orderBy?: OrderByQueryOption;
    /**
     * 
     * @type {SkipQueryOption}
     * @memberof ProductODataDTOODataQueryOptions
     */
    skip?: SkipQueryOption;
    /**
     * 
     * @type {SkipTokenQueryOption}
     * @memberof ProductODataDTOODataQueryOptions
     */
    skipToken?: SkipTokenQueryOption;
    /**
     * 
     * @type {TopQueryOption}
     * @memberof ProductODataDTOODataQueryOptions
     */
    top?: TopQueryOption;
    /**
     * 
     * @type {CountQueryOption}
     * @memberof ProductODataDTOODataQueryOptions
     */
    count?: CountQueryOption;
    /**
     * 
     * @type {object}
     * @memberof ProductODataDTOODataQueryOptions
     */
    validator?: object;
}
/**
 * 
 * @export
 * @interface ProductOpenReceivingDTO
 */
export interface ProductOpenReceivingDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductOpenReceivingDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductOpenReceivingDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductOpenReceivingDTO
     */
    openReceivingAcceptedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOpenReceivingDTO
     */
    openReceivingPlacedAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductOpenReceivingDTO
     */
    openReceivingReferenceNumbers?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductOpenReceivingDTO
     */
    countingIncreasedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOpenReceivingDTO
     */
    countingDecreasedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOpenReceivingDTO
     */
    packedNotDispatchedAmount?: number;
}
/**
 * 
 * @export
 * @interface ProductQueryOutputDTO
 */
export interface ProductQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductQueryOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductQueryOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductQueryOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductQueryOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductQueryOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductQueryOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {ProductType}
     * @memberof ProductQueryOutputDTO
     */
    type?: ProductType;
    /**
     * 
     * @type {string}
     * @memberof ProductQueryOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductQueryOutputDTO
     */
    stockZones?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ProductQueryOutputDTO
     */
    width?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductQueryOutputDTO
     */
    widthUnit?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductQueryOutputDTO
     */
    length?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductQueryOutputDTO
     */
    lengthUnit?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductQueryOutputDTO
     */
    height?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductQueryOutputDTO
     */
    heightUnit?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductQueryOutputDTO
     */
    weight?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductQueryOutputDTO
     */
    weightUnit?: string;
}
/**
 * 
 * @export
 * @interface ProductQueryOutputDTODynamicQueryOutputDTO
 */
export interface ProductQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ProductQueryOutputDTO>}
     * @memberof ProductQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ProductQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ProductQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ProductReturnPackageDetailsOutputDTO
 */
export interface ProductReturnPackageDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductReturnPackageDetailsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductReturnPackageDetailsOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductReturnPackageDetailsOutputDTO
     */
    returnPackageReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductReturnPackageDetailsOutputDTO
     */
    returnPackageId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductReturnPackageDetailsOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductReturnPackageDetailsOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductReturnPackageDetailsOutputDTO
     */
    trackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductReturnPackageDetailsOutputDTO
     */
    cargoTrackingNumber?: string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof ProductReturnPackageDetailsOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof ProductReturnPackageDetailsOutputDTO
     */
    dispatchedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductReturnPackageDetailsOutputDTO
     */
    returnedAt?: string;
    /**
     * 
     * @type {ReturnPackageState}
     * @memberof ProductReturnPackageDetailsOutputDTO
     */
    returnPackageState?: ReturnPackageState;
}
/**
 * 
 * @export
 * @interface ProductReturnPackageDetailsOutputDTODynamicQueryOutputDTO
 */
export interface ProductReturnPackageDetailsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ProductReturnPackageDetailsOutputDTO>}
     * @memberof ProductReturnPackageDetailsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ProductReturnPackageDetailsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ProductReturnPackageDetailsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductState {
    None = 'None',
    AwaitingFeeding = 'AwaitingFeeding',
    AwaitingCustomerSupportApproval = 'AwaitingCustomerSupportApproval',
    InPicking = 'InPicking',
    InStock = 'InStock',
    OutOfStock = 'OutOfStock',
    Picked = 'Picked',
    AwaitingPutAway = 'AwaitingPutAway',
    Cancelled = 'Cancelled'
}

/**
 * 
 * @export
 * @interface ProductStockCountingListsOutputDTO
 */
export interface ProductStockCountingListsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductStockCountingListsOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductStockCountingListsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductStockCountingListsOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductStockCountingListsOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductStockCountingListsOutputDTO
     */
    zoneName?: string;
    /**
     * 
     * @type {StockCountingType}
     * @memberof ProductStockCountingListsOutputDTO
     */
    stockCountingType?: StockCountingType;
    /**
     * 
     * @type {StockCountingState}
     * @memberof ProductStockCountingListsOutputDTO
     */
    state?: StockCountingState;
    /**
     * 
     * @type {string}
     * @memberof ProductStockCountingListsOutputDTO
     */
    operatorFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductStockCountingListsOutputDTO
     */
    countedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductStockCountingListsOutputDTO
     */
    stockCountingListReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductStockCountingListsOutputDTO
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductStockCountingListsOutputDTO
     */
    beforeCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductStockCountingListsOutputDTO
     */
    afterCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductStockCountingListsOutputDTO
     */
    totalDifferenceInAmount?: number;
}
/**
 * 
 * @export
 * @interface ProductStockCountingListsOutputDTODynamicQueryOutputDTO
 */
export interface ProductStockCountingListsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ProductStockCountingListsOutputDTO>}
     * @memberof ProductStockCountingListsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ProductStockCountingListsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ProductStockCountingListsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductStockCountingProcessState {
    Awaiting = 'Awaiting',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductTagType {
    None = 'None',
    Heavy = 'Heavy',
    OverSize = 'OverSize',
    Pourable = 'Pourable',
    Fragile = 'Fragile',
    Battery = 'Battery',
    Food = 'Food',
    Chemical = 'Chemical',
    Sharp = 'Sharp',
    Valuable = 'Valuable',
    Adult = 'Adult'
}

/**
 * 
 * @export
 * @interface ProductTagsOutputDTO
 */
export interface ProductTagsOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof ProductTagsOutputDTO
     */
    isPourable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTagsOutputDTO
     */
    isFragile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTagsOutputDTO
     */
    isBattery?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTagsOutputDTO
     */
    isFood?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTagsOutputDTO
     */
    isChemical?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTagsOutputDTO
     */
    isSharp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTagsOutputDTO
     */
    isValuable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTagsOutputDTO
     */
    isAdult?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTagsOutputDTO
     */
    isQualityControlNeeded?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductType {
    None = 'None',
    Commercial = 'Commercial',
    Unknown = 'Unknown'
}

/**
 * 
 * @export
 * @interface ProductWithBarcodesOutputDTO
 */
export interface ProductWithBarcodesOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductWithBarcodesOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductWithBarcodesOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductWithBarcodesOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductWithBarcodesOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductWithBarcodesOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductWithBarcodesOutputDTO
     */
    isTrackSerialNumber?: boolean;
}
/**
 * 
 * @export
 * @interface PublicKey
 */
export interface PublicKey {
    /**
     * 
     * @type {AsnEncodedData}
     * @memberof PublicKey
     */
    encodedKeyValue?: AsnEncodedData;
    /**
     * 
     * @type {AsnEncodedData}
     * @memberof PublicKey
     */
    encodedParameters?: AsnEncodedData;
    /**
     * 
     * @type {AsymmetricAlgorithm}
     * @memberof PublicKey
     */
    key?: AsymmetricAlgorithm;
    /**
     * 
     * @type {Oid}
     * @memberof PublicKey
     */
    oid?: Oid;
}
/**
 * 
 * @export
 * @interface PurchaseOrderDetailsOutputDTO
 */
export interface PurchaseOrderDetailsOutputDTO {
    /**
     * 
     * @type {DateRangeOutputDTO}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    expectedDeliveryDate?: DateRangeOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    arrivedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    completingState?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    waybillCount?: number;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    problemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    expectedTotalItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    unDamagedTotalItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    processedTotalItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    totalQuarantineItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    damagedItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    unidentifiedProductItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    duplicateBarcodeItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    unreadableBarcodeItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    barcodeNotExistItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    barcodeMismatchItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    expirationDateNotExistItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    expiredProductItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    quarantineItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    processedItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderDetailsOutputDTO
     */
    differenceExpectedItemAmount?: number;
}
/**
 * 
 * @export
 * @interface PurchaseOrderLineItemCountsOutputDTO
 */
export interface PurchaseOrderLineItemCountsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLineItemCountsOutputDTO
     */
    acceptedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLineItemCountsOutputDTO
     */
    damagedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLineItemCountsOutputDTO
     */
    expectedAmount?: number;
}
/**
 * 
 * @export
 * @interface PurchaseOrderLineItemInputDTO
 */
export interface PurchaseOrderLineItemInputDTO {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLineItemInputDTO
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLineItemInputDTO
     */
    expectedAmount?: number;
    /**
     * 
     * @type {PurchaseOrderLineItemSource}
     * @memberof PurchaseOrderLineItemInputDTO
     */
    source?: PurchaseOrderLineItemSource;
    /**
     * 
     * @type {Array<PurchaseOrderLineItemLotNumbersInputDTO>}
     * @memberof PurchaseOrderLineItemInputDTO
     */
    lotNumbers?: Array<PurchaseOrderLineItemLotNumbersInputDTO>;
}
/**
 * 
 * @export
 * @interface PurchaseOrderLineItemLotNumbersInputDTO
 */
export interface PurchaseOrderLineItemLotNumbersInputDTO {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLineItemLotNumbersInputDTO
     */
    lotNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLineItemLotNumbersInputDTO
     */
    expectedAmount?: number;
}
/**
 * 
 * @export
 * @interface PurchaseOrderLineItemOutputDTO
 */
export interface PurchaseOrderLineItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLineItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLineItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLineItemOutputDTO
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLineItemOutputDTO
     */
    productImageURL?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLineItemOutputDTO
     */
    expectedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLineItemOutputDTO
     */
    acceptedAmount?: number;
}
/**
 * 
 * @export
 * @interface PurchaseOrderLineItemQueryOutputDTO
 */
export interface PurchaseOrderLineItemQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLineItemQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLineItemQueryOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLineItemQueryOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLineItemQueryOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PurchaseOrderLineItemQueryOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLineItemQueryOutputDTO
     */
    acceptedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLineItemQueryOutputDTO
     */
    damagedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLineItemQueryOutputDTO
     */
    expectedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLineItemQueryOutputDTO
     */
    difference?: number;
}
/**
 * 
 * @export
 * @interface PurchaseOrderLineItemQueryOutputDTODynamicQueryOutputDTO
 */
export interface PurchaseOrderLineItemQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PurchaseOrderLineItemQueryOutputDTO>}
     * @memberof PurchaseOrderLineItemQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PurchaseOrderLineItemQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLineItemQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PurchaseOrderLineItemRecordType {
    None = 'None',
    AcceptedLineItem = 'AcceptedLineItem',
    DamagedLineItem = 'DamagedLineItem'
}

/**
 * 
 * @export
 * @interface PurchaseOrderLineItemRecordsForDeleteOutputDTO
 */
export interface PurchaseOrderLineItemRecordsForDeleteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLineItemRecordsForDeleteOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLineItemRecordsForDeleteOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {PurchaseOrderLineItemRecordType}
     * @memberof PurchaseOrderLineItemRecordsForDeleteOutputDTO
     */
    type?: PurchaseOrderLineItemRecordType;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PurchaseOrderLineItemSource {
    None = 'None',
    Omnitro = 'Omnitro',
    Maestro = 'Maestro',
    Trendyol = 'Trendyol'
}

/**
 * 
 * @export
 * @interface PurchaseOrderLotNumberSummaryDTO
 */
export interface PurchaseOrderLotNumberSummaryDTO {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLotNumberSummaryDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLotNumberSummaryDTO
     */
    purchaseOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLotNumberSummaryDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLotNumberSummaryDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLotNumberSummaryDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderLotNumberSummaryDTO
     */
    lotNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLotNumberSummaryDTO
     */
    expectedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLotNumberSummaryDTO
     */
    acceptedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLotNumberSummaryDTO
     */
    damagedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLotNumberSummaryDTO
     */
    difference?: number;
}
/**
 * 
 * @export
 * @interface PurchaseOrderLotNumberSummaryDTODynamicQueryOutputDTO
 */
export interface PurchaseOrderLotNumberSummaryDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PurchaseOrderLotNumberSummaryDTO>}
     * @memberof PurchaseOrderLotNumberSummaryDTODynamicQueryOutputDTO
     */
    data?: Array<PurchaseOrderLotNumberSummaryDTO>;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderLotNumberSummaryDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface PurchaseOrderManagementCountsOutputDTO
 */
export interface PurchaseOrderManagementCountsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderManagementCountsOutputDTO
     */
    incompletedPurcaseOrderCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderManagementCountsOutputDTO
     */
    delayedPurchaseOrderCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderManagementCountsOutputDTO
     */
    canBeStartedPurchaseOrderCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderManagementCountsOutputDTO
     */
    onHoldPurchaseOrderCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderManagementCountsOutputDTO
     */
    completedPurchaseOrderCount?: number;
}
/**
 * 
 * @export
 * @interface PurchaseOrderODataDTOODataQueryOptions
 */
export interface PurchaseOrderODataDTOODataQueryOptions {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderODataDTOODataQueryOptions
     */
    ifMatch?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderODataDTOODataQueryOptions
     */
    ifNoneMatch?: string;
    /**
     * 
     * @type {HttpRequest}
     * @memberof PurchaseOrderODataDTOODataQueryOptions
     */
    request?: HttpRequest;
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof PurchaseOrderODataDTOODataQueryOptions
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {ODataRawQueryOptions}
     * @memberof PurchaseOrderODataDTOODataQueryOptions
     */
    rawValues?: ODataRawQueryOptions;
    /**
     * 
     * @type {SelectExpandQueryOption}
     * @memberof PurchaseOrderODataDTOODataQueryOptions
     */
    selectExpand?: SelectExpandQueryOption;
    /**
     * 
     * @type {ApplyQueryOption}
     * @memberof PurchaseOrderODataDTOODataQueryOptions
     */
    apply?: ApplyQueryOption;
    /**
     * 
     * @type {ComputeQueryOption}
     * @memberof PurchaseOrderODataDTOODataQueryOptions
     */
    compute?: ComputeQueryOption;
    /**
     * 
     * @type {FilterQueryOption}
     * @memberof PurchaseOrderODataDTOODataQueryOptions
     */
    filter?: FilterQueryOption;
    /**
     * 
     * @type {SearchQueryOption}
     * @memberof PurchaseOrderODataDTOODataQueryOptions
     */
    search?: SearchQueryOption;
    /**
     * 
     * @type {OrderByQueryOption}
     * @memberof PurchaseOrderODataDTOODataQueryOptions
     */
    orderBy?: OrderByQueryOption;
    /**
     * 
     * @type {SkipQueryOption}
     * @memberof PurchaseOrderODataDTOODataQueryOptions
     */
    skip?: SkipQueryOption;
    /**
     * 
     * @type {SkipTokenQueryOption}
     * @memberof PurchaseOrderODataDTOODataQueryOptions
     */
    skipToken?: SkipTokenQueryOption;
    /**
     * 
     * @type {TopQueryOption}
     * @memberof PurchaseOrderODataDTOODataQueryOptions
     */
    top?: TopQueryOption;
    /**
     * 
     * @type {CountQueryOption}
     * @memberof PurchaseOrderODataDTOODataQueryOptions
     */
    count?: CountQueryOption;
    /**
     * 
     * @type {object}
     * @memberof PurchaseOrderODataDTOODataQueryOptions
     */
    validator?: object;
}
/**
 * 
 * @export
 * @interface PurchaseOrderOutputDTO
 */
export interface PurchaseOrderOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderOutputDTO
     */
    expectedDeliveryDate?: string;
    /**
     * 
     * @type {PurchaseOrderSource}
     * @memberof PurchaseOrderOutputDTO
     */
    source?: PurchaseOrderSource;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderOutputDTO
     */
    waybillCount?: number;
    /**
     * 
     * @type {Array<PurchaseOrderLineItemOutputDTO>}
     * @memberof PurchaseOrderOutputDTO
     */
    lineItems?: Array<PurchaseOrderLineItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface PurchaseOrderQueryOutputDTO
 */
export interface PurchaseOrderQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    waybillCount?: number;
    /**
     * 
     * @type {PurchaseOrderSource}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    source?: PurchaseOrderSource;
    /**
     * 
     * @type {ReceivingState}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    state?: ReceivingState;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    totalExpectedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    totalAcceptedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    differenceAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    arrivedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    expectedDeliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    targetedRecivingCompletionDateTime?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    problemCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    waybillReferenceNumbers?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    palletCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderQueryOutputDTO
     */
    completedAt?: string;
}
/**
 * 
 * @export
 * @interface PurchaseOrderQueryOutputDTODynamicQueryOutputDTO
 */
export interface PurchaseOrderQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PurchaseOrderQueryOutputDTO>}
     * @memberof PurchaseOrderQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PurchaseOrderQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PurchaseOrderSource {
    None = 'None',
    Omnitro = 'Omnitro',
    Maestro = 'Maestro',
    Trendyol = 'Trendyol'
}

/**
 * 
 * @export
 * @interface PurchaseOrderSummaryLineItemOutputDTO
 */
export interface PurchaseOrderSummaryLineItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderSummaryLineItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderSummaryLineItemOutputDTO
     */
    damagedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderSummaryLineItemOutputDTO
     */
    acceptedAmount?: number;
    /**
     * 
     * @type {Array<LineItemAcceptedExpirationDate>}
     * @memberof PurchaseOrderSummaryLineItemOutputDTO
     */
    acceptedExpirationDates?: Array<LineItemAcceptedExpirationDate>;
}
/**
 * 
 * @export
 * @interface PurchaseOrderSummaryOutputDTO
 */
export interface PurchaseOrderSummaryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderSummaryOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderSummaryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {Array<PurchaseOrderSummaryLineItemOutputDTO>}
     * @memberof PurchaseOrderSummaryOutputDTO
     */
    lineItems?: Array<PurchaseOrderSummaryLineItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface PutAwayCellRuleInputDTO
 */
export interface PutAwayCellRuleInputDTO {
    /**
     * 
     * @type {string}
     * @memberof PutAwayCellRuleInputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PutAwayCellRuleInputDTO
     */
    maxProductVarietyAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PutAwayCellRuleInputDTO
     */
    maxProductAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PutAwayCellRuleInputDTO
     */
    maxSingleProductAmountWithSerialNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PutAwayCellRuleInputDTO
     */
    maxOperationAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PutAwayCellRuleInputDTO
     */
    maxProductVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof PutAwayCellRuleInputDTO
     */
    maxProductHeight?: number;
    /**
     * 
     * @type {number}
     * @memberof PutAwayCellRuleInputDTO
     */
    maxProductWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof PutAwayCellRuleInputDTO
     */
    maxTotalProductWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof PutAwayCellRuleInputDTO
     */
    maxSingleProductAmountWithLotNumber?: number;
}
/**
 * 
 * @export
 * @interface PutAwayCellRuleOutputDTO
 */
export interface PutAwayCellRuleOutputDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof PutAwayCellRuleOutputDTO
     */
    addedCells?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PutAwayCellRuleOutputDTO
     */
    updatedCells?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PutAwayCellRuleOutputDTO
     */
    failedCells?: Array<string>;
}
/**
 * 
 * @export
 * @interface PutAwayLostItemOutputDTO
 */
export interface PutAwayLostItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PutAwayLostItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayLostItemOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayLostItemOutputDTO
     */
    previousContainerLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PutAwayLostItemOutputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface PutAwayNextZoneOutputDTO
 */
export interface PutAwayNextZoneOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PutAwayNextZoneOutputDTO
     */
    nextZoneName?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayNextZoneOutputDTO
     */
    nextZoneLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof PutAwayNextZoneOutputDTO
     */
    nextZoneId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PutAwayNextZoneOutputDTO
     */
    isCellSuggestedPutAwayActive?: boolean;
}
/**
 * 
 * @export
 * @interface PutAwayOutputDTO
 */
export interface PutAwayOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PutAwayOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof PutAwayOutputDTO
     */
    referenceNumber?: number;
    /**
     * 
     * @type {PutAwayState}
     * @memberof PutAwayOutputDTO
     */
    state?: PutAwayState;
    /**
     * 
     * @type {PutAwayNextZoneOutputDTO}
     * @memberof PutAwayOutputDTO
     */
    putAwayNextZone?: PutAwayNextZoneOutputDTO;
    /**
     * 
     * @type {TrolleyOutputDTO}
     * @memberof PutAwayOutputDTO
     */
    trolley?: TrolleyOutputDTO;
    /**
     * 
     * @type {boolean}
     * @memberof PutAwayOutputDTO
     */
    isCellSuggestedPutAwayActive?: boolean;
}
/**
 * 
 * @export
 * @interface PutAwayProductMissingCommand
 */
export interface PutAwayProductMissingCommand {
    /**
     * 
     * @type {number}
     * @memberof PutAwayProductMissingCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PutAwayProductMissingCommand
     */
    putAwayToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayProductMissingCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof PutAwayProductMissingCommand
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof PutAwayProductMissingCommand
     */
    inboundLabel?: string;
}
/**
 * 
 * @export
 * @interface PutAwayReceivedItemsOutputDTO
 */
export interface PutAwayReceivedItemsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedItemsOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedItemsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedItemsOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedItemsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedItemsOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedItemsOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedItemsOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedItemsOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof PutAwayReceivedItemsOutputDTO
     */
    productAmount?: number;
}
/**
 * 
 * @export
 * @interface PutAwayReceivedItemsOutputDTODynamicQueryOutputDTO
 */
export interface PutAwayReceivedItemsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PutAwayReceivedItemsOutputDTO>}
     * @memberof PutAwayReceivedItemsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PutAwayReceivedItemsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PutAwayReceivedItemsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface PutAwayReceivedPalletItemsExpirationDateOutputDTO
 */
export interface PutAwayReceivedPalletItemsExpirationDateOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedPalletItemsExpirationDateOutputDTO
     */
    expirationDate?: string;
    /**
     * 
     * @type {number}
     * @memberof PutAwayReceivedPalletItemsExpirationDateOutputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface PutAwayReceivedPalletItemsOutputDTO
 */
export interface PutAwayReceivedPalletItemsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedPalletItemsOutputDTO
     */
    palletLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedPalletItemsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedPalletItemsOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedPalletItemsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedPalletItemsOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedPalletItemsOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedPalletItemsOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedPalletItemsOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof PutAwayReceivedPalletItemsOutputDTO
     */
    productAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PutAwayReceivedPalletItemsOutputDTO
     */
    hasExpirationDate?: boolean;
    /**
     * 
     * @type {Array<PutAwayReceivedPalletItemsExpirationDateOutputDTO>}
     * @memberof PutAwayReceivedPalletItemsOutputDTO
     */
    expirationDates?: Array<PutAwayReceivedPalletItemsExpirationDateOutputDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof PutAwayReceivedPalletItemsOutputDTO
     */
    hasExpirationDateProblem?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PutAwayReceivedPalletItemsOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof PutAwayReceivedPalletItemsOutputDTO
     */
    zoneLabel?: string;
}
/**
 * 
 * @export
 * @interface PutAwayReceivedPalletItemsOutputDTODynamicQueryOutputDTO
 */
export interface PutAwayReceivedPalletItemsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PutAwayReceivedPalletItemsOutputDTO>}
     * @memberof PutAwayReceivedPalletItemsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PutAwayReceivedPalletItemsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PutAwayReceivedPalletItemsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PutAwayState {
    None = 'None',
    Allocated = 'Allocated',
    Started = 'Started',
    OnHold = 'OnHold',
    Completed = 'Completed',
    SemiCompleted = 'SemiCompleted',
    WaitingForRas = 'WaitingForRas',
    RasPutAwayStarted = 'RasPutAwayStarted'
}

/**
 * 
 * @export
 * @interface PutAwayToteLostItemsCommand
 */
export interface PutAwayToteLostItemsCommand {
    /**
     * 
     * @type {number}
     * @memberof PutAwayToteLostItemsCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PutAwayToteLostItemsCommand
     */
    putAwayToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayToteLostItemsCommand
     */
    inboundLabel?: string;
}
/**
 * 
 * @export
 * @interface PutAwayTrolleyDetailsOutputDTO
 */
export interface PutAwayTrolleyDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PutAwayTrolleyDetailsOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof PutAwayTrolleyDetailsOutputDTO
     */
    percentage?: number;
    /**
     * 
     * @type {string}
     * @memberof PutAwayTrolleyDetailsOutputDTO
     */
    operatorName?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayTrolleyDetailsOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAwayTrolleyDetailsOutputDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {number}
     * @memberof PutAwayTrolleyDetailsOutputDTO
     */
    totalToteCount?: number;
}
/**
 * 
 * @export
 * @interface PutAwayTrolleyReturnCommand
 */
export interface PutAwayTrolleyReturnCommand {
    /**
     * 
     * @type {number}
     * @memberof PutAwayTrolleyReturnCommand
     */
    putAwayReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface PutAwayTrolleyToteQueryOutputDTO
 */
export interface PutAwayTrolleyToteQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof PutAwayTrolleyToteQueryOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof PutAwayTrolleyToteQueryOutputDTO
     */
    toteTotalItemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PutAwayTrolleyToteQueryOutputDTO
     */
    totePutAwayItemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PutAwayTrolleyToteQueryOutputDTO
     */
    percentage?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PutAwayTrolleyToteQueryOutputDTO
     */
    hasLostItem?: boolean;
}
/**
 * 
 * @export
 * @interface PutAwayTrolleyToteQueryOutputDTODynamicQueryOutputDTO
 */
export interface PutAwayTrolleyToteQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<PutAwayTrolleyToteQueryOutputDTO>}
     * @memberof PutAwayTrolleyToteQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<PutAwayTrolleyToteQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof PutAwayTrolleyToteQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum QualityStockCountingListSourceProcess {
    None = 'None',
    PutAway = 'PutAway',
    Transfer = 'Transfer'
}

/**
 * 
 * @export
 * @interface QuarantineItemCountOutputDTO
 */
export interface QuarantineItemCountOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof QuarantineItemCountOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QuarantineItemInputDTO
 */
export interface QuarantineItemInputDTO {
    /**
     * 
     * @type {string}
     * @memberof QuarantineItemInputDTO
     */
    productId?: string;
    /**
     * 
     * @type {number}
     * @memberof QuarantineItemInputDTO
     */
    amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuarantineItemInputDTO
     */
    serialNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum QuarantineItemType {
    None = 'None',
    ReceivedItem = 'ReceivedItem',
    DamagedItem = 'DamagedItem',
    OutboundItem = 'OutboundItem'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum QuarantineToValidTransferReason {
    None = 'None',
    OperationRequest = 'OperationRequest',
    ManagerRequest = 'ManagerRequest',
    Other = 'Other',
    RepairedProduction = 'RepairedProduction',
    RepairedOperation = 'RepairedOperation',
    Repaired = 'Repaired'
}

/**
 * 
 * @export
 * @interface QuarantineToteContainedItemsOutputDTO
 */
export interface QuarantineToteContainedItemsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QuarantineToteContainedItemsOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof QuarantineToteContainedItemsOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof QuarantineToteContainedItemsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof QuarantineToteContainedItemsOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof QuarantineToteContainedItemsOutputDTO
     */
    itemAmount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuarantineToteContainedItemsOutputDTO
     */
    barcodes?: Array<string>;
}
/**
 * 
 * @export
 * @interface QuarantineToteDetailsForWebReceivingOutputDTO
 */
export interface QuarantineToteDetailsForWebReceivingOutputDTO {
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof QuarantineToteDetailsForWebReceivingOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof QuarantineToteDetailsForWebReceivingOutputDTO
     */
    purchaseOrdeReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof QuarantineToteDetailsForWebReceivingOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof QuarantineToteDetailsForWebReceivingOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof QuarantineToteDetailsForWebReceivingOutputDTO
     */
    productImageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof QuarantineToteDetailsForWebReceivingOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {number}
     * @memberof QuarantineToteDetailsForWebReceivingOutputDTO
     */
    totalAmount?: number;
    /**
     * 
     * @type {InboundProblemType}
     * @memberof QuarantineToteDetailsForWebReceivingOutputDTO
     */
    inboundProblemType?: InboundProblemType;
    /**
     * 
     * @type {string}
     * @memberof QuarantineToteDetailsForWebReceivingOutputDTO
     */
    inboundProblemTypeDiscriminator?: string;
}
/**
 * 
 * @export
 * @interface QuarantineToteDetailsForWebReceivingOutputDTODynamicQueryOutputDTO
 */
export interface QuarantineToteDetailsForWebReceivingOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QuarantineToteDetailsForWebReceivingOutputDTO>}
     * @memberof QuarantineToteDetailsForWebReceivingOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QuarantineToteDetailsForWebReceivingOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QuarantineToteDetailsForWebReceivingOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QuarantineToteDetailsOutputDTO
 */
export interface QuarantineToteDetailsOutputDTO {
    /**
     * 
     * @type {Array<QuarantineToteContainedItemsOutputDTO>}
     * @memberof QuarantineToteDetailsOutputDTO
     */
    quarantineToteContainedItems?: Array<QuarantineToteContainedItemsOutputDTO>;
}
/**
 * 
 * @export
 * @interface QuarantineToteInputDTO
 */
export interface QuarantineToteInputDTO {
    /**
     * 
     * @type {string}
     * @memberof QuarantineToteInputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {Array<QuarantineItemInputDTO>}
     * @memberof QuarantineToteInputDTO
     */
    quarantineItems?: Array<QuarantineItemInputDTO>;
}
/**
 * 
 * @export
 * @interface QuarantineWallProductInputDTO
 */
export interface QuarantineWallProductInputDTO {
    /**
     * 
     * @type {string}
     * @memberof QuarantineWallProductInputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof QuarantineWallProductInputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {number}
     * @memberof QuarantineWallProductInputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface QuarantineWallToteDetailsOutputDTO
 */
export interface QuarantineWallToteDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QuarantineWallToteDetailsOutputDTO
     */
    targetToteLabel?: string;
    /**
     * 
     * @type {Array<InventoryItemGetByToteLabelGroupByDTO>}
     * @memberof QuarantineWallToteDetailsOutputDTO
     */
    inventoryItems?: Array<InventoryItemGetByToteLabelGroupByDTO>;
}
/**
 * 
 * @export
 * @interface QueryAutomaticStockCountingTasksOutputDTO
 */
export interface QueryAutomaticStockCountingTasksOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryAutomaticStockCountingTasksOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryAutomaticStockCountingTasksOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryAutomaticStockCountingTasksOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryAutomaticStockCountingTasksOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryAutomaticStockCountingTasksOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryAutomaticStockCountingTasksOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryAutomaticStockCountingTasksOutputDTO
     */
    zoneName?: string;
    /**
     * 
     * @type {StockCountingType}
     * @memberof QueryAutomaticStockCountingTasksOutputDTO
     */
    stockCountingType?: StockCountingType;
    /**
     * 
     * @type {AutomaticStockCountingState}
     * @memberof QueryAutomaticStockCountingTasksOutputDTO
     */
    state?: AutomaticStockCountingState;
    /**
     * 
     * @type {string}
     * @memberof QueryAutomaticStockCountingTasksOutputDTO
     */
    operatorFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryAutomaticStockCountingTasksOutputDTO
     */
    countedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryAutomaticStockCountingTasksOutputDTO
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryAutomaticStockCountingTasksOutputDTO
     */
    stockCountingListReferenceNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryAutomaticStockCountingTasksOutputDTO
     */
    beforeCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryAutomaticStockCountingTasksOutputDTO
     */
    afterCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryAutomaticStockCountingTasksOutputDTO
     */
    totalDifferenceInAmount?: number;
}
/**
 * 
 * @export
 * @interface QueryAutomaticStockCountingTasksOutputDTODynamicQueryOutputDTO
 */
export interface QueryAutomaticStockCountingTasksOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryAutomaticStockCountingTasksOutputDTO>}
     * @memberof QueryAutomaticStockCountingTasksOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryAutomaticStockCountingTasksOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryAutomaticStockCountingTasksOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryDispatchManagementCountsOutputDTO
 */
export interface QueryDispatchManagementCountsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof QueryDispatchManagementCountsOutputDTO
     */
    totalNotDispatchedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryDispatchManagementCountsOutputDTO
     */
    waitingForPickingCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryDispatchManagementCountsOutputDTO
     */
    waitingForPackingCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryDispatchManagementCountsOutputDTO
     */
    waitingForSLAMCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryDispatchManagementCountsOutputDTO
     */
    suspendedSalesOrdersCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryDispatchManagementCountsOutputDTO
     */
    readyForDispatchCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryDispatchManagementCountsOutputDTO
     */
    notDispatchedCutOffCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryDispatchManagementCountsOutputDTO
     */
    notDispatchedLateCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryDispatchManagementCountsOutputDTO
     */
    waitingForApproveCount?: number;
}
/**
 * 
 * @export
 * @interface QueryDispatchProblemsManagementCountsOutputDTO
 */
export interface QueryDispatchProblemsManagementCountsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof QueryDispatchProblemsManagementCountsOutputDTO
     */
    createdProblemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryDispatchProblemsManagementCountsOutputDTO
     */
    inProgressProblemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryDispatchProblemsManagementCountsOutputDTO
     */
    resolvedProblemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryDispatchProblemsManagementCountsOutputDTO
     */
    waitingStockCountingTasksCount?: number;
}
/**
 * 
 * @export
 * @interface QueryDropAddressedPickingToteDetailsOutputDTO
 */
export interface QueryDropAddressedPickingToteDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryDropAddressedPickingToteDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof QueryDropAddressedPickingToteDetailsOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {SalesOrderLineItemOutputDTO}
     * @memberof QueryDropAddressedPickingToteDetailsOutputDTO
     */
    salesOrderLineItem?: SalesOrderLineItemOutputDTO;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof QueryDropAddressedPickingToteDetailsOutputDTO
     */
    salesOrderState?: SalesOrderState;
    /**
     * 
     * @type {SalesOrderPackingState}
     * @memberof QueryDropAddressedPickingToteDetailsOutputDTO
     */
    salesOrderPackingState?: SalesOrderPackingState;
}
/**
 * 
 * @export
 * @interface QueryDropAddressedPickingToteDetailsOutputDTODynamicQueryOutputDTO
 */
export interface QueryDropAddressedPickingToteDetailsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryDropAddressedPickingToteDetailsOutputDTO>}
     * @memberof QueryDropAddressedPickingToteDetailsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryDropAddressedPickingToteDetailsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryDropAddressedPickingToteDetailsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryDropAddressedPickingTotesOutputDTO
 */
export interface QueryDropAddressedPickingTotesOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof QueryDropAddressedPickingTotesOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryDropAddressedPickingTotesOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryDropAddressedPickingTotesOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryDropAddressedPickingTotesOutputDTO
     */
    itemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryDropAddressedPickingTotesOutputDTO
     */
    packingPercentage?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryDropAddressedPickingTotesOutputDTO
     */
    pickListName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryDropAddressedPickingTotesOutputDTO
     */
    pickListId?: string;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof QueryDropAddressedPickingTotesOutputDTO
     */
    pickingFlow?: PickingFlowTag;
    /**
     * 
     * @type {PickingMethod}
     * @memberof QueryDropAddressedPickingTotesOutputDTO
     */
    pickingMethod?: PickingMethod;
    /**
     * 
     * @type {PickingType}
     * @memberof QueryDropAddressedPickingTotesOutputDTO
     */
    pickingType?: PickingType;
    /**
     * 
     * @type {string}
     * @memberof QueryDropAddressedPickingTotesOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryDropAddressedPickingTotesOutputDTO
     */
    zoneId?: number;
}
/**
 * 
 * @export
 * @interface QueryDropAddressedPickingTotesOutputDTODynamicQueryOutputDTO
 */
export interface QueryDropAddressedPickingTotesOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryDropAddressedPickingTotesOutputDTO>}
     * @memberof QueryDropAddressedPickingTotesOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryDropAddressedPickingTotesOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryDropAddressedPickingTotesOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryInboundBoxRecordsOutputDTO
 */
export interface QueryInboundBoxRecordsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryInboundBoxRecordsOutputDTO
     */
    productSKU?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundBoxRecordsOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundBoxRecordsOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundBoxRecordsOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryInboundBoxRecordsOutputDTO
     */
    receivedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryInboundBoxRecordsOutputDTO
     */
    quarantineAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryInboundBoxRecordsOutputDTO
     */
    totalAmount?: number;
}
/**
 * 
 * @export
 * @interface QueryInboundBoxRecordsOutputDTODynamicQueryOutputDTO
 */
export interface QueryInboundBoxRecordsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryInboundBoxRecordsOutputDTO>}
     * @memberof QueryInboundBoxRecordsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryInboundBoxRecordsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryInboundBoxRecordsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryInboundBoxesByPurchaseOrderOutputDTO
 */
export interface QueryInboundBoxesByPurchaseOrderOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof QueryInboundBoxesByPurchaseOrderOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundBoxesByPurchaseOrderOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundBoxesByPurchaseOrderOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundBoxesByPurchaseOrderOutputDTO
     */
    waybillReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundBoxesByPurchaseOrderOutputDTO
     */
    waybillId?: string;
}
/**
 * 
 * @export
 * @interface QueryInboundBoxesByPurchaseOrderOutputDTODynamicQueryOutputDTO
 */
export interface QueryInboundBoxesByPurchaseOrderOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryInboundBoxesByPurchaseOrderOutputDTO>}
     * @memberof QueryInboundBoxesByPurchaseOrderOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryInboundBoxesByPurchaseOrderOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryInboundBoxesByPurchaseOrderOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryInboundBoxesByWaybillOutputDTO
 */
export interface QueryInboundBoxesByWaybillOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof QueryInboundBoxesByWaybillOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundBoxesByWaybillOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundBoxesByWaybillOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundBoxesByWaybillOutputDTO
     */
    waybillId?: string;
}
/**
 * 
 * @export
 * @interface QueryInboundBoxesByWaybillOutputDTODynamicQueryOutputDTO
 */
export interface QueryInboundBoxesByWaybillOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryInboundBoxesByWaybillOutputDTO>}
     * @memberof QueryInboundBoxesByWaybillOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryInboundBoxesByWaybillOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryInboundBoxesByWaybillOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryInboundProblemsByPurchaseOrderOutputDTO
 */
export interface QueryInboundProblemsByPurchaseOrderOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByPurchaseOrderOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByPurchaseOrderOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByPurchaseOrderOutputDTO
     */
    waybillReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByPurchaseOrderOutputDTO
     */
    waybillId?: string;
    /**
     * 
     * @type {InboundProblemType}
     * @memberof QueryInboundProblemsByPurchaseOrderOutputDTO
     */
    type?: InboundProblemType;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByPurchaseOrderOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByPurchaseOrderOutputDTO
     */
    source?: string;
    /**
     * 
     * @type {ProblemState}
     * @memberof QueryInboundProblemsByPurchaseOrderOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByPurchaseOrderOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByPurchaseOrderOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByPurchaseOrderOutputDTO
     */
    resolutionNote?: string;
}
/**
 * 
 * @export
 * @interface QueryInboundProblemsByPurchaseOrderOutputDTODynamicQueryOutputDTO
 */
export interface QueryInboundProblemsByPurchaseOrderOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryInboundProblemsByPurchaseOrderOutputDTO>}
     * @memberof QueryInboundProblemsByPurchaseOrderOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryInboundProblemsByPurchaseOrderOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryInboundProblemsByPurchaseOrderOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryInboundProblemsByWaybillOutputDTO
 */
export interface QueryInboundProblemsByWaybillOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByWaybillOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByWaybillOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {InboundProblemType}
     * @memberof QueryInboundProblemsByWaybillOutputDTO
     */
    type?: InboundProblemType;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByWaybillOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByWaybillOutputDTO
     */
    source?: string;
    /**
     * 
     * @type {ProblemState}
     * @memberof QueryInboundProblemsByWaybillOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByWaybillOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByWaybillOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByWaybillOutputDTO
     */
    resolutionNote?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByWaybillOutputDTO
     */
    waybillId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsByWaybillOutputDTO
     */
    inboundBoxLabel?: string;
}
/**
 * 
 * @export
 * @interface QueryInboundProblemsByWaybillOutputDTODynamicQueryOutputDTO
 */
export interface QueryInboundProblemsByWaybillOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryInboundProblemsByWaybillOutputDTO>}
     * @memberof QueryInboundProblemsByWaybillOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryInboundProblemsByWaybillOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryInboundProblemsByWaybillOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryInboundProblemsOutputDTO
 */
export interface QueryInboundProblemsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryInboundProblemsOutputDTO
     */
    itemAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsOutputDTO
     */
    openedBy?: string;
    /**
     * 
     * @type {InboundProblemType}
     * @memberof QueryInboundProblemsOutputDTO
     */
    inboundProblemType?: InboundProblemType;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsOutputDTO
     */
    inboundBoxLabel?: string;
    /**
     * 
     * @type {ProblemState}
     * @memberof QueryInboundProblemsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {InboundProblemSolutionType}
     * @memberof QueryInboundProblemsOutputDTO
     */
    inboundProblemSolution?: InboundProblemSolutionType;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsOutputDTO
     */
    receivedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsOutputDTO
     */
    waybill?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryInboundProblemsOutputDTO
     */
    barcodes?: string;
}
/**
 * 
 * @export
 * @interface QueryInboundProblemsOutputDTODynamicQueryOutputDTO
 */
export interface QueryInboundProblemsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryInboundProblemsOutputDTO>}
     * @memberof QueryInboundProblemsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryInboundProblemsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryInboundProblemsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryManualStockCountingTasksOutputDTO
 */
export interface QueryManualStockCountingTasksOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryManualStockCountingTasksOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryManualStockCountingTasksOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryManualStockCountingTasksOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryManualStockCountingTasksOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryManualStockCountingTasksOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {StockCountingType}
     * @memberof QueryManualStockCountingTasksOutputDTO
     */
    stockCountingType?: StockCountingType;
    /**
     * 
     * @type {number}
     * @memberof QueryManualStockCountingTasksOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryManualStockCountingTasksOutputDTO
     */
    zoneName?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryManualStockCountingTasksOutputDTO
     */
    beforeCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryManualStockCountingTasksOutputDTO
     */
    afterCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryManualStockCountingTasksOutputDTO
     */
    totalDifferenceInAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryManualStockCountingTasksOutputDTO
     */
    operatorFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryManualStockCountingTasksOutputDTO
     */
    countedAt?: string;
}
/**
 * 
 * @export
 * @interface QueryManualStockCountingTasksOutputDTODynamicQueryOutputDTO
 */
export interface QueryManualStockCountingTasksOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryManualStockCountingTasksOutputDTO>}
     * @memberof QueryManualStockCountingTasksOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryManualStockCountingTasksOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryManualStockCountingTasksOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum QueryNodeKind {
    None = 'None',
    Constant = 'Constant',
    Convert = 'Convert',
    NonResourceRangeVariableReference = 'NonResourceRangeVariableReference',
    BinaryOperator = 'BinaryOperator',
    UnaryOperator = 'UnaryOperator',
    SingleValuePropertyAccess = 'SingleValuePropertyAccess',
    CollectionPropertyAccess = 'CollectionPropertyAccess',
    SingleValueFunctionCall = 'SingleValueFunctionCall',
    Any = 'Any',
    CollectionNavigationNode = 'CollectionNavigationNode',
    SingleNavigationNode = 'SingleNavigationNode',
    SingleValueOpenPropertyAccess = 'SingleValueOpenPropertyAccess',
    SingleResourceCast = 'SingleResourceCast',
    All = 'All',
    CollectionResourceCast = 'CollectionResourceCast',
    ResourceRangeVariableReference = 'ResourceRangeVariableReference',
    SingleResourceFunctionCall = 'SingleResourceFunctionCall',
    CollectionFunctionCall = 'CollectionFunctionCall',
    CollectionResourceFunctionCall = 'CollectionResourceFunctionCall',
    NamedFunctionParameter = 'NamedFunctionParameter',
    ParameterAlias = 'ParameterAlias',
    EntitySet = 'EntitySet',
    KeyLookup = 'KeyLookup',
    SearchTerm = 'SearchTerm',
    CollectionOpenPropertyAccess = 'CollectionOpenPropertyAccess',
    CollectionComplexNode = 'CollectionComplexNode',
    SingleComplexNode = 'SingleComplexNode',
    Count = 'Count',
    SingleValueCast = 'SingleValueCast',
    CollectionPropertyNode = 'CollectionPropertyNode',
    AggregatedCollectionPropertyNode = 'AggregatedCollectionPropertyNode',
    In = 'In',
    CollectionConstant = 'CollectionConstant'
}

/**
 * 
 * @export
 * @interface QueryPickListsOutputDTO
 */
export interface QueryPickListsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryPickListsOutputDTO
     */
    pickListId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryPickListsOutputDTO
     */
    pickListName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryPickListsOutputDTO
     */
    vehicleVariation?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryPickListsOutputDTO
     */
    capacity?: number;
    /**
     * 
     * @type {PickingCapacityUnit}
     * @memberof QueryPickListsOutputDTO
     */
    capacityUnit?: PickingCapacityUnit;
    /**
     * 
     * @type {string}
     * @memberof QueryPickListsOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {PickListState}
     * @memberof QueryPickListsOutputDTO
     */
    state?: PickListState;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof QueryPickListsOutputDTO
     */
    pickingFlowTag?: PickingFlowTag;
    /**
     * 
     * @type {PickingMethod}
     * @memberof QueryPickListsOutputDTO
     */
    pickingMethod?: PickingMethod;
    /**
     * 
     * @type {PickingType}
     * @memberof QueryPickListsOutputDTO
     */
    pickingType?: PickingType;
    /**
     * 
     * @type {PickingRouteType}
     * @memberof QueryPickListsOutputDTO
     */
    pickingRouteType?: PickingRouteType;
    /**
     * 
     * @type {string}
     * @memberof QueryPickListsOutputDTO
     */
    pickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryPickListsOutputDTO
     */
    operatorFullName?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryPickListsOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryPickListsOutputDTO
     */
    zoneName?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryPickListsOutputDTO
     */
    subZoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryPickListsOutputDTO
     */
    subZoneName?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryPickListsOutputDTO
     */
    salesOrderCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryPickListsOutputDTO
     */
    salesOrderPriority1Count?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryPickListsOutputDTO
     */
    salesOrderPriority2Count?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryPickListsOutputDTO
     */
    salesOrderPriority3Count?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryPickListsOutputDTO
     */
    productAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryPickListsOutputDTO
     */
    targetDispatchDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryPickListsOutputDTO
     */
    oldestSalesOrderSoldAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryPickListsOutputDTO
     */
    qrCode?: string;
    /**
     * 
     * @type {PickListGenerationType}
     * @memberof QueryPickListsOutputDTO
     */
    pickListGenerationType?: PickListGenerationType;
    /**
     * 
     * @type {string}
     * @memberof QueryPickListsOutputDTO
     */
    batchName?: string;
}
/**
 * 
 * @export
 * @interface QueryPickListsOutputDTODynamicQueryOutputDTO
 */
export interface QueryPickListsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryPickListsOutputDTO>}
     * @memberof QueryPickListsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryPickListsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryPickListsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryPickingProblemsManagementCountsOutputDTO
 */
export interface QueryPickingProblemsManagementCountsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof QueryPickingProblemsManagementCountsOutputDTO
     */
    createdProblemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryPickingProblemsManagementCountsOutputDTO
     */
    inProgressProblemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryPickingProblemsManagementCountsOutputDTO
     */
    resolvedProblemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryPickingProblemsManagementCountsOutputDTO
     */
    waitingStockCountingTasksCount?: number;
}
/**
 * 
 * @export
 * @interface QueryPutAwayAwaitingReceivedItemsOutputDTO
 */
export interface QueryPutAwayAwaitingReceivedItemsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryPutAwayAwaitingReceivedItemsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryPutAwayAwaitingReceivedItemsOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryPutAwayAwaitingReceivedItemsOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryPutAwayAwaitingReceivedItemsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryPutAwayAwaitingReceivedItemsOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryPutAwayAwaitingReceivedItemsOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryPutAwayAwaitingReceivedItemsOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryPutAwayAwaitingReceivedItemsOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof QueryPutAwayAwaitingReceivedItemsOutputDTO
     */
    productType?: ProductType;
    /**
     * 
     * @type {string}
     * @memberof QueryPutAwayAwaitingReceivedItemsOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryPutAwayAwaitingReceivedItemsOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryPutAwayAwaitingReceivedItemsOutputDTO
     */
    salesOrderReferenceNumbers?: string;
}
/**
 * 
 * @export
 * @interface QueryPutAwayAwaitingReceivedItemsOutputDTODynamicQueryOutputDTO
 */
export interface QueryPutAwayAwaitingReceivedItemsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryPutAwayAwaitingReceivedItemsOutputDTO>}
     * @memberof QueryPutAwayAwaitingReceivedItemsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryPutAwayAwaitingReceivedItemsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryPutAwayAwaitingReceivedItemsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryPutAwayManagementCountsOutputDTO
 */
export interface QueryPutAwayManagementCountsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof QueryPutAwayManagementCountsOutputDTO
     */
    waitingForPutAwayProductCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryPutAwayManagementCountsOutputDTO
     */
    waitingForPutAwayToteCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryPutAwayManagementCountsOutputDTO
     */
    waitingForPutAwayPalletCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryPutAwayManagementCountsOutputDTO
     */
    activePutAwayCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryPutAwayManagementCountsOutputDTO
     */
    readyPutAwayTrolleyCount?: number;
}
/**
 * 
 * @export
 * @interface QueryQualityStockCountingTasksOutputDTO
 */
export interface QueryQualityStockCountingTasksOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {StockCountingType}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    stockCountingType?: StockCountingType;
    /**
     * 
     * @type {AutomaticStockCountingState}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    state?: AutomaticStockCountingState;
    /**
     * 
     * @type {string}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    operatorFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    countedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    stockCountingListReferenceNumber?: number;
    /**
     * 
     * @type {QualityStockCountingListSourceProcess}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    qualityStockCountingListSourceProcess?: QualityStockCountingListSourceProcess;
    /**
     * 
     * @type {string}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    processOperatorFullName?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    beforeCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    afterCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    totalDifferenceInAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryQualityStockCountingTasksOutputDTO
     */
    logId?: string;
}
/**
 * 
 * @export
 * @interface QueryQualityStockCountingTasksOutputDTODynamicQueryOutputDTO
 */
export interface QueryQualityStockCountingTasksOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryQualityStockCountingTasksOutputDTO>}
     * @memberof QueryQualityStockCountingTasksOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryQualityStockCountingTasksOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryQualityStockCountingTasksOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryReservedProductManagementBlockerFeedsOutputDTO
 */
export interface QueryReservedProductManagementBlockerFeedsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementBlockerFeedsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementBlockerFeedsOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementBlockerFeedsOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementBlockerFeedsOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementBlockerFeedsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementBlockerFeedsOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementBlockerFeedsOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryReservedProductManagementBlockerFeedsOutputDTO
     */
    productAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryReservedProductManagementBlockerFeedsOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementBlockerFeedsOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementBlockerFeedsOutputDTO
     */
    salesOrderReferenceNumbers?: string;
}
/**
 * 
 * @export
 * @interface QueryReservedProductManagementBlockerFeedsOutputDTODynamicQueryOutputDTO
 */
export interface QueryReservedProductManagementBlockerFeedsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryReservedProductManagementBlockerFeedsOutputDTO>}
     * @memberof QueryReservedProductManagementBlockerFeedsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryReservedProductManagementBlockerFeedsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryReservedProductManagementBlockerFeedsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryReservedProductManagementCountsOutputDTO
 */
export interface QueryReservedProductManagementCountsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof QueryReservedProductManagementCountsOutputDTO
     */
    reservedProductCount?: number;
}
/**
 * 
 * @export
 * @interface QueryReservedProductManagementProposedFeedsOutputDTO
 */
export interface QueryReservedProductManagementProposedFeedsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementProposedFeedsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementProposedFeedsOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementProposedFeedsOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementProposedFeedsOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementProposedFeedsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementProposedFeedsOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementProposedFeedsOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryReservedProductManagementProposedFeedsOutputDTO
     */
    primaryStockAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryReservedProductManagementProposedFeedsOutputDTO
     */
    reservedStockAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementProposedFeedsOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementProposedFeedsOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryReservedProductManagementProposedFeedsOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementProposedFeedsOutputDTO
     */
    zoneLabel?: string;
}
/**
 * 
 * @export
 * @interface QueryReservedProductManagementProposedFeedsOutputDTODynamicQueryOutputDTO
 */
export interface QueryReservedProductManagementProposedFeedsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryReservedProductManagementProposedFeedsOutputDTO>}
     * @memberof QueryReservedProductManagementProposedFeedsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryReservedProductManagementProposedFeedsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryReservedProductManagementProposedFeedsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryReservedProductManagementReservedProductsOutputDTO
 */
export interface QueryReservedProductManagementReservedProductsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementReservedProductsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementReservedProductsOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementReservedProductsOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementReservedProductsOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementReservedProductsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementReservedProductsOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementReservedProductsOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryReservedProductManagementReservedProductsOutputDTO
     */
    productAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementReservedProductsOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementReservedProductsOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryReservedProductManagementReservedProductsOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryReservedProductManagementReservedProductsOutputDTO
     */
    zoneLabel?: string;
}
/**
 * 
 * @export
 * @interface QueryReservedProductManagementReservedProductsOutputDTODynamicQueryOutputDTO
 */
export interface QueryReservedProductManagementReservedProductsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryReservedProductManagementReservedProductsOutputDTO>}
     * @memberof QueryReservedProductManagementReservedProductsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryReservedProductManagementReservedProductsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryReservedProductManagementReservedProductsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QuerySalesOrdersForDispatchOutputDTO
 */
export interface QuerySalesOrdersForDispatchOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    orderCreatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    pickedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    sortedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    packedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    slamAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    dispatchedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    lastUser?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {SalesChannel}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {number}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    totalCargoPackageCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    totalItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    totalSLAMSuccessfulCargoPackageCount?: number;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    isCutOff?: boolean;
    /**
     * 
     * @type {SalesOrderPickingPriority}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    priority?: SalesOrderPickingPriority;
    /**
     * 
     * @type {boolean}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    isSuspended?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    targetDispatchDateTime?: string;
    /**
     * 
     * @type {Array<CargoPackagesDTO>}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    cargoPackages?: Array<CargoPackagesDTO>;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    carrierId?: string;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    carrierName?: string;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    carrierEnabledLogoUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    problemCount?: number;
    /**
     * 
     * @type {string}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    problemReferenceNumbers?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    isCancelledStepStarted?: boolean;
    /**
     * 
     * @type {SalesOrderDispatchStateSteps}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    createState?: SalesOrderDispatchStateSteps;
    /**
     * 
     * @type {SalesOrderDispatchStateSteps}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    pickingState?: SalesOrderDispatchStateSteps;
    /**
     * 
     * @type {SalesOrderDispatchStateSteps}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    packingState?: SalesOrderDispatchStateSteps;
    /**
     * 
     * @type {SalesOrderDispatchStateSteps}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    sortingState?: SalesOrderDispatchStateSteps;
    /**
     * 
     * @type {SalesOrderDispatchStateSteps}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    slamState?: SalesOrderDispatchStateSteps;
    /**
     * 
     * @type {SalesOrderDispatchStateSteps}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    dispatchState?: SalesOrderDispatchStateSteps;
    /**
     * 
     * @type {SalesOrderDispatchStateSteps}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    deliveringState?: SalesOrderDispatchStateSteps;
    /**
     * 
     * @type {DispatchApproveState}
     * @memberof QuerySalesOrdersForDispatchOutputDTO
     */
    dispatchApproveState?: DispatchApproveState;
}
/**
 * 
 * @export
 * @interface QuerySalesOrdersForDispatchOutputDTODynamicQueryOutputDTO
 */
export interface QuerySalesOrdersForDispatchOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QuerySalesOrdersForDispatchOutputDTO>}
     * @memberof QuerySalesOrdersForDispatchOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QuerySalesOrdersForDispatchOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QuerySalesOrdersForDispatchOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QuerySingleItemFastPackPickingTotesOutputDTO
 */
export interface QuerySingleItemFastPackPickingTotesOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof QuerySingleItemFastPackPickingTotesOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof QuerySingleItemFastPackPickingTotesOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof QuerySingleItemFastPackPickingTotesOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof QuerySingleItemFastPackPickingTotesOutputDTO
     */
    itemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QuerySingleItemFastPackPickingTotesOutputDTO
     */
    packingPercentage?: number;
    /**
     * 
     * @type {string}
     * @memberof QuerySingleItemFastPackPickingTotesOutputDTO
     */
    pickListName?: string;
    /**
     * 
     * @type {string}
     * @memberof QuerySingleItemFastPackPickingTotesOutputDTO
     */
    pickListId?: string;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof QuerySingleItemFastPackPickingTotesOutputDTO
     */
    pickingFlow?: PickingFlowTag;
    /**
     * 
     * @type {PickingMethod}
     * @memberof QuerySingleItemFastPackPickingTotesOutputDTO
     */
    pickingMethod?: PickingMethod;
    /**
     * 
     * @type {PickingType}
     * @memberof QuerySingleItemFastPackPickingTotesOutputDTO
     */
    pickingType?: PickingType;
    /**
     * 
     * @type {string}
     * @memberof QuerySingleItemFastPackPickingTotesOutputDTO
     */
    zoneLabel?: string;
}
/**
 * 
 * @export
 * @interface QuerySingleItemFastPackPickingTotesOutputDTODynamicQueryOutputDTO
 */
export interface QuerySingleItemFastPackPickingTotesOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QuerySingleItemFastPackPickingTotesOutputDTO>}
     * @memberof QuerySingleItemFastPackPickingTotesOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QuerySingleItemFastPackPickingTotesOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QuerySingleItemFastPackPickingTotesOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QuerySingleItemPickingTotesOutputDTO
 */
export interface QuerySingleItemPickingTotesOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof QuerySingleItemPickingTotesOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof QuerySingleItemPickingTotesOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof QuerySingleItemPickingTotesOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof QuerySingleItemPickingTotesOutputDTO
     */
    itemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QuerySingleItemPickingTotesOutputDTO
     */
    packingPercentage?: number;
    /**
     * 
     * @type {string}
     * @memberof QuerySingleItemPickingTotesOutputDTO
     */
    pickListName?: string;
    /**
     * 
     * @type {string}
     * @memberof QuerySingleItemPickingTotesOutputDTO
     */
    pickListId?: string;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof QuerySingleItemPickingTotesOutputDTO
     */
    pickingFlow?: PickingFlowTag;
    /**
     * 
     * @type {PickingMethod}
     * @memberof QuerySingleItemPickingTotesOutputDTO
     */
    pickingMethod?: PickingMethod;
    /**
     * 
     * @type {PickingType}
     * @memberof QuerySingleItemPickingTotesOutputDTO
     */
    pickingType?: PickingType;
    /**
     * 
     * @type {string}
     * @memberof QuerySingleItemPickingTotesOutputDTO
     */
    zoneLabel?: string;
}
/**
 * 
 * @export
 * @interface QuerySingleItemPickingTotesOutputDTODynamicQueryOutputDTO
 */
export interface QuerySingleItemPickingTotesOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QuerySingleItemPickingTotesOutputDTO>}
     * @memberof QuerySingleItemPickingTotesOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QuerySingleItemPickingTotesOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QuerySingleItemPickingTotesOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryStockCountingListConfigurationsOutputDTO
 */
export interface QueryStockCountingListConfigurationsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListConfigurationsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {StockCountingSource}
     * @memberof QueryStockCountingListConfigurationsOutputDTO
     */
    source?: StockCountingSource;
    /**
     * 
     * @type {StockCountingType}
     * @memberof QueryStockCountingListConfigurationsOutputDTO
     */
    type?: StockCountingType;
    /**
     * 
     * @type {QualityStockCountingListSourceProcess}
     * @memberof QueryStockCountingListConfigurationsOutputDTO
     */
    process?: QualityStockCountingListSourceProcess;
    /**
     * 
     * @type {boolean}
     * @memberof QueryStockCountingListConfigurationsOutputDTO
     */
    isActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListConfigurationsOutputDTO
     */
    amountOfProductsWaitingForCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListConfigurationsOutputDTO
     */
    amountOfCellsWaitingForCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListConfigurationsOutputDTO
     */
    amountOfStockCountListsWaitingForCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListConfigurationsOutputDTO
     */
    amountOfStockCountListsInProcess?: number;
}
/**
 * 
 * @export
 * @interface QueryStockCountingListConfigurationsOutputDTODynamicQueryOutputDTO
 */
export interface QueryStockCountingListConfigurationsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryStockCountingListConfigurationsOutputDTO>}
     * @memberof QueryStockCountingListConfigurationsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryStockCountingListConfigurationsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListConfigurationsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryStockCountingListDetailsByReferenceNumberOutputDTO
 */
export interface QueryStockCountingListDetailsByReferenceNumberOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTO
     */
    zoneName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTO
     */
    operatorFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTO
     */
    stockCountingCreatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTO
     */
    countedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTO
     */
    beforeCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTO
     */
    afterCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTO
     */
    totalDifferenceInAmount?: number;
}
/**
 * 
 * @export
 * @interface QueryStockCountingListDetailsByReferenceNumberOutputDTODynamicQueryOutputDTO
 */
export interface QueryStockCountingListDetailsByReferenceNumberOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryStockCountingListDetailsByReferenceNumberOutputDTO>}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryStockCountingListDetailsByReferenceNumberOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListDetailsByReferenceNumberOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryStockCountingListsOutputDTO
 */
export interface QueryStockCountingListsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListsOutputDTO
     */
    referenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListsOutputDTO
     */
    stockCountingListName?: string;
    /**
     * 
     * @type {StockCountingListState}
     * @memberof QueryStockCountingListsOutputDTO
     */
    state?: StockCountingListState;
    /**
     * 
     * @type {StockCountingType}
     * @memberof QueryStockCountingListsOutputDTO
     */
    stockCountingType?: StockCountingType;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListsOutputDTO
     */
    beforeStockCountingTotalAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListsOutputDTO
     */
    afterStockCountingTotalAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListsOutputDTO
     */
    totalDifferenceInAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListsOutputDTO
     */
    operatorFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListsOutputDTO
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListsOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QueryStockCountingListsOutputDTO
     */
    isPrioritized?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListsOutputDTO
     */
    source?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListsOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListsOutputDTO
     */
    zoneName?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListsOutputDTO
     */
    stockCountingPlanReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListsOutputDTO
     */
    stockCountingPlanId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingListsOutputDTO
     */
    qr?: string;
}
/**
 * 
 * @export
 * @interface QueryStockCountingListsOutputDTODynamicQueryOutputDTO
 */
export interface QueryStockCountingListsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryStockCountingListsOutputDTO>}
     * @memberof QueryStockCountingListsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryStockCountingListsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingListsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
 */
export interface QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    productSKU?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    totalAmountBeforeCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    totalAmountAfterCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    totalDifferenceInAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    stockCountingPlanId?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    stockCountingPlanReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    stockCountingListReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    processedByFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO
     */
    countedAt?: string;
}
/**
 * 
 * @export
 * @interface QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTODynamicQueryOutputDTO
 */
export interface QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO>}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryStockCountingPlanOutputDTO
 */
export interface QueryStockCountingPlanOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingPlanOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingPlanOutputDTO
     */
    referenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingPlanOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {StockCountingPlanState}
     * @memberof QueryStockCountingPlanOutputDTO
     */
    state?: StockCountingPlanState;
    /**
     * 
     * @type {StockCountingType}
     * @memberof QueryStockCountingPlanOutputDTO
     */
    stockCountingType?: StockCountingType;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingPlanOutputDTO
     */
    beforeStockCountingTotalAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingPlanOutputDTO
     */
    afterStockCountingTotalAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingPlanOutputDTO
     */
    totalDifferenceInAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingPlanOutputDTO
     */
    createdByFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingPlanOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingPlanOutputDTO
     */
    priorityTimestamp?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QueryStockCountingPlanOutputDTO
     */
    isEligibleForPrioritization?: boolean;
}
/**
 * 
 * @export
 * @interface QueryStockCountingPlanOutputDTODynamicQueryOutputDTO
 */
export interface QueryStockCountingPlanOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryStockCountingPlanOutputDTO>}
     * @memberof QueryStockCountingPlanOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryStockCountingPlanOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingPlanOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryStockCountingTasksByCellLabelOutputDTO
 */
export interface QueryStockCountingTasksByCellLabelOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingTasksByCellLabelOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingTasksByCellLabelOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingTasksByCellLabelOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingTasksByCellLabelOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingTasksByCellLabelOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingTasksByCellLabelOutputDTO
     */
    zoneName?: string;
    /**
     * 
     * @type {StockCountingType}
     * @memberof QueryStockCountingTasksByCellLabelOutputDTO
     */
    stockCountingType?: StockCountingType;
    /**
     * 
     * @type {AutomaticStockCountingState}
     * @memberof QueryStockCountingTasksByCellLabelOutputDTO
     */
    state?: AutomaticStockCountingState;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingTasksByCellLabelOutputDTO
     */
    operatorFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryStockCountingTasksByCellLabelOutputDTO
     */
    countedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingTasksByCellLabelOutputDTO
     */
    stockCountingListReferenceNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingTasksByCellLabelOutputDTO
     */
    beforeCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingTasksByCellLabelOutputDTO
     */
    afterCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingTasksByCellLabelOutputDTO
     */
    totalDifferenceInAmount?: number;
}
/**
 * 
 * @export
 * @interface QueryStockCountingTasksByCellLabelOutputDTODynamicQueryOutputDTO
 */
export interface QueryStockCountingTasksByCellLabelOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryStockCountingTasksByCellLabelOutputDTO>}
     * @memberof QueryStockCountingTasksByCellLabelOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryStockCountingTasksByCellLabelOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryStockCountingTasksByCellLabelOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryStockStatusCountsOutputDTO
 */
export interface QueryStockStatusCountsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof QueryStockStatusCountsOutputDTO
     */
    productCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryStockStatusCountsOutputDTO
     */
    productVariety?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryStockStatusCountsOutputDTO
     */
    operationCount?: number;
}
/**
 * 
 * @export
 * @interface QueryString
 */
export interface QueryString {
    /**
     * 
     * @type {string}
     * @memberof QueryString
     */
    value?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QueryString
     */
    hasValue?: boolean;
}
/**
 * 
 * @export
 * @interface QueryToCreateCellStockCountingPlanOutputDTO
 */
export interface QueryToCreateCellStockCountingPlanOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof QueryToCreateCellStockCountingPlanOutputDTO
     */
    cellId?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryToCreateCellStockCountingPlanOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryToCreateCellStockCountingPlanOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryToCreateCellStockCountingPlanOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryToCreateCellStockCountingPlanOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {Array<OperationOutputDTO>}
     * @memberof QueryToCreateCellStockCountingPlanOutputDTO
     */
    operations?: Array<OperationOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryToCreateCellStockCountingPlanOutputDTO
     */
    numberOfSkuVariety?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryToCreateCellStockCountingPlanOutputDTO
     */
    totalItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryToCreateCellStockCountingPlanOutputDTO
     */
    numberOfSkuVarietyMissing?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryToCreateCellStockCountingPlanOutputDTO
     */
    maxNumberOfMissingCounter?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryToCreateCellStockCountingPlanOutputDTO
     */
    section?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryToCreateCellStockCountingPlanOutputDTO
     */
    side?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryToCreateCellStockCountingPlanOutputDTO
     */
    level?: string;
}
/**
 * 
 * @export
 * @interface QueryToCreateCellStockCountingPlanOutputDTODynamicQueryOutputDTO
 */
export interface QueryToCreateCellStockCountingPlanOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryToCreateCellStockCountingPlanOutputDTO>}
     * @memberof QueryToCreateCellStockCountingPlanOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryToCreateCellStockCountingPlanOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryToCreateCellStockCountingPlanOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueryToCreateItemStockCountingPlanOutputDTO
 */
export interface QueryToCreateItemStockCountingPlanOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof QueryToCreateItemStockCountingPlanOutputDTO
     */
    cellId?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryToCreateItemStockCountingPlanOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryToCreateItemStockCountingPlanOutputDTO
     */
    productSKU?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryToCreateItemStockCountingPlanOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryToCreateItemStockCountingPlanOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryToCreateItemStockCountingPlanOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryToCreateItemStockCountingPlanOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryToCreateItemStockCountingPlanOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryToCreateItemStockCountingPlanOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryToCreateItemStockCountingPlanOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryToCreateItemStockCountingPlanOutputDTO
     */
    maxNumberOfMissingCounter?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryToCreateItemStockCountingPlanOutputDTO
     */
    numberOfItems?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryToCreateItemStockCountingPlanOutputDTO
     */
    numberOfItemsMissing?: number;
}
/**
 * 
 * @export
 * @interface QueryToCreateItemStockCountingPlanOutputDTODynamicQueryOutputDTO
 */
export interface QueryToCreateItemStockCountingPlanOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<QueryToCreateItemStockCountingPlanOutputDTO>}
     * @memberof QueryToCreateItemStockCountingPlanOutputDTODynamicQueryOutputDTO
     */
    data?: Array<QueryToCreateItemStockCountingPlanOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueryToCreateItemStockCountingPlanOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface QueueHOVItemIntoCargoPackageCommand
 */
export interface QueueHOVItemIntoCargoPackageCommand {
    /**
     * 
     * @type {string}
     * @memberof QueueHOVItemIntoCargoPackageCommand
     */
    hovPackingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueueHOVItemIntoCargoPackageCommand
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueueHOVItemIntoCargoPackageCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof QueueHOVItemIntoCargoPackageCommand
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueueHOVItemIntoCargoPackageCommand
     */
    packageIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof QueueHOVItemIntoCargoPackageCommand
     */
    serialNumber?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueueHOVItemIntoCargoPackageCommand
     */
    simpleSerialNumbers?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof QueueHOVItemIntoCargoPackageCommand
     */
    masterCartonCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueueHOVItemIntoCargoPackageCommand
     */
    masterCartonAmount?: number;
}
/**
 * 
 * @export
 * @interface QueueHOVItemIntoQuarantineToteCommand
 */
export interface QueueHOVItemIntoQuarantineToteCommand {
    /**
     * 
     * @type {string}
     * @memberof QueueHOVItemIntoQuarantineToteCommand
     */
    packingQuarantineProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueueHOVItemIntoQuarantineToteCommand
     */
    productId?: string;
    /**
     * 
     * @type {number}
     * @memberof QueueHOVItemIntoQuarantineToteCommand
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof QueueHOVItemIntoQuarantineToteCommand
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QueueHOVItemIntoQuarantineToteCommand
     */
    serialNumber?: string;
}
/**
 * 
 * @export
 * @interface QueueItemIntoCargoPackageCommand
 */
export interface QueueItemIntoCargoPackageCommand {
    /**
     * 
     * @type {string}
     * @memberof QueueItemIntoCargoPackageCommand
     */
    packingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueueItemIntoCargoPackageCommand
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueueItemIntoCargoPackageCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof QueueItemIntoCargoPackageCommand
     */
    packageIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof QueueItemIntoCargoPackageCommand
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof QueueItemIntoCargoPackageCommand
     */
    simpleSerialNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof QueueItemIntoCargoPackageCommand
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueueItemIntoCargoPackageCommand
     */
    masterCartonCount?: number;
    /**
     * 
     * @type {number}
     * @memberof QueueItemIntoCargoPackageCommand
     */
    masterCartonAmount?: number;
}
/**
 * 
 * @export
 * @interface QueueItemIntoCargoPackageOutputDTO
 */
export interface QueueItemIntoCargoPackageOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueueItemIntoCargoPackageOutputDTO
     */
    failedMessage?: string;
    /**
     * 
     * @type {InternalErrorNumber}
     * @memberof QueueItemIntoCargoPackageOutputDTO
     */
    errorNumber?: InternalErrorNumber;
}
/**
 * 
 * @export
 * @interface QueueItemIntoQuarantineToteCommand
 */
export interface QueueItemIntoQuarantineToteCommand {
    /**
     * 
     * @type {string}
     * @memberof QueueItemIntoQuarantineToteCommand
     */
    packingQuarantineProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueueItemIntoQuarantineToteCommand
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof QueueItemIntoQuarantineToteCommand
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof QueueItemIntoQuarantineToteCommand
     */
    quarantineToteLabel?: string;
}
/**
 * 
 * @export
 * @interface QueueItemsIntoCargoPackageCommand
 */
export interface QueueItemsIntoCargoPackageCommand {
    /**
     * 
     * @type {Array<SimplePackingQueueItem>}
     * @memberof QueueItemsIntoCargoPackageCommand
     */
    items?: Array<SimplePackingQueueItem>;
    /**
     * 
     * @type {string}
     * @memberof QueueItemsIntoCargoPackageCommand
     */
    packingProcessId?: string;
    /**
     * 
     * @type {number}
     * @memberof QueueItemsIntoCargoPackageCommand
     */
    packageIndex?: number;
}
/**
 * 
 * @export
 * @interface QueuedCargoPackageOutputDTO
 */
export interface QueuedCargoPackageOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof QueuedCargoPackageOutputDTO
     */
    packageId?: number;
    /**
     * 
     * @type {string}
     * @memberof QueuedCargoPackageOutputDTO
     */
    cargoPackageTypeBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof QueuedCargoPackageOutputDTO
     */
    packageIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof QueuedCargoPackageOutputDTO
     */
    packageLabel?: string;
    /**
     *
     * @type {boolean}
     * @memberof QueuedCargoPackageOutputDTO
     */
    isSealedAtPacking?: boolean;
    /**
     *
     * @type {Array<PackingBoxItemOutputDTO>}
     * @memberof QueuedCargoPackageOutputDTO
     */
    boxItems?: Array<PackingBoxItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface QueuedHOVCargoPackageOutputDTO
 */
export interface QueuedHOVCargoPackageOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof QueuedHOVCargoPackageOutputDTO
     */
    isSealedAtPacking?: boolean;
    /**
     * 
     * @type {number}
     * @memberof QueuedHOVCargoPackageOutputDTO
     */
    packageId?: number;
    /**
     * 
     * @type {string}
     * @memberof QueuedHOVCargoPackageOutputDTO
     */
    cargoPackageTypeBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof QueuedHOVCargoPackageOutputDTO
     */
    packageIndex?: number;
    /**
     * 
     * @type {Array<PackingBoxHOVItemOutputDTO>}
     * @memberof QueuedHOVCargoPackageOutputDTO
     */
    boxItems?: Array<PackingBoxHOVItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface QueuedQuarantineToteOutputDTO
 */
export interface QueuedQuarantineToteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QueuedQuarantineToteOutputDTO
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {Array<PackingBoxItemOutputDTO>}
     * @memberof QueuedQuarantineToteOutputDTO
     */
    boxItems?: Array<PackingBoxItemOutputDTO>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum QuickPutAwayBarcodeType {
    None = 'None',
    Cell = 'Cell',
    Product = 'Product',
    InboundBox = 'InboundBox'
}

/**
 * 
 * @export
 * @interface QuickPutAwayNextZoneOutputDTO
 */
export interface QuickPutAwayNextZoneOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QuickPutAwayNextZoneOutputDTO
     */
    nextZoneName?: string;
    /**
     * 
     * @type {string}
     * @memberof QuickPutAwayNextZoneOutputDTO
     */
    nextZoneLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof QuickPutAwayNextZoneOutputDTO
     */
    nextZoneId?: number;
}
/**
 * 
 * @export
 * @interface QuickPutAwayOutputDTO
 */
export interface QuickPutAwayOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof QuickPutAwayOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof QuickPutAwayOutputDTO
     */
    referenceNumber?: number;
    /**
     * 
     * @type {PutAwayState}
     * @memberof QuickPutAwayOutputDTO
     */
    state?: PutAwayState;
    /**
     * 
     * @type {QuickPutAwayNextZoneOutputDTO}
     * @memberof QuickPutAwayOutputDTO
     */
    quickPutAwayNextZone?: QuickPutAwayNextZoneOutputDTO;
}
/**
 * 
 * @export
 * @interface RangeVariable
 */
export interface RangeVariable {
    /**
     * 
     * @type {string}
     * @memberof RangeVariable
     */
    name?: string;
    /**
     * 
     * @type {IEdmTypeReference}
     * @memberof RangeVariable
     */
    typeReference?: IEdmTypeReference;
    /**
     * 
     * @type {number}
     * @memberof RangeVariable
     */
    kind?: number;
}
/**
 * 
 * @export
 * @interface RasConfigDTO
 */
export interface RasConfigDTO {
    /**
     * 
     * @type {number}
     * @memberof RasConfigDTO
     */
    stockZoneId?: number;
    /**
     * 
     * @type {number}
     * @memberof RasConfigDTO
     */
    maxPickItemAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RasConfigDTO
     */
    sameDayBatchesEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RasConfigDTO
     */
    marketPlaceBatchesEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RasConfigDTO
     */
    webBatchesEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RasConfigDTO
     */
    singleItemsEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RasConfigDTO
     */
    skipPickCellScan?: boolean;
}
/**
 * 
 * @export
 * @interface RasConfigOutputDTO
 */
export interface RasConfigOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof RasConfigOutputDTO
     */
    skipPickCellScan?: boolean;
}
/**
 * 
 * @export
 * @interface RasDirectItemPlacedOutputDTO
 */
export interface RasDirectItemPlacedOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof RasDirectItemPlacedOutputDTO
     */
    receivedToPurchaseOrder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RasDirectItemPlacedOutputDTO
     */
    purchaseOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof RasDirectItemPlacedOutputDTO
     */
    purchaseOrderState?: string;
    /**
     * 
     * @type {number}
     * @memberof RasDirectItemPlacedOutputDTO
     */
    acceptedTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof RasDirectItemPlacedOutputDTO
     */
    expectedTotal?: number;
}
/**
 * 
 * @export
 * @interface RasItemPlacedOutputDTO
 */
export interface RasItemPlacedOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof RasItemPlacedOutputDTO
     */
    remainingItemAmount?: number;
}
/**
 * 
 * @export
 * @interface RasLostItemCommand
 */
export interface RasLostItemCommand {
    /**
     * 
     * @type {string}
     * @memberof RasLostItemCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasLostItemCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasLostItemCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof RasLostItemCommand
     */
    pickListId?: string;
}
/**
 * 
 * @export
 * @interface RasMetricDTO
 */
export interface RasMetricDTO {
    /**
     * 
     * @type {RasMetricType}
     * @memberof RasMetricDTO
     */
    metricType?: RasMetricType;
    /**
     * 
     * @type {string}
     * @memberof RasMetricDTO
     */
    time?: string;
    /**
     * 
     * @type {string}
     * @memberof RasMetricDTO
     */
    warehouseName?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum RasMetricType {
    StationOpen = 'STATION_OPEN',
    StationClose = 'STATION_CLOSE',
    PodReady = 'POD_READY',
    PodLeaving = 'POD_LEAVING',
    AwaitingPod = 'AWAITING_POD',
    AwaitingPicklist = 'AWAITING_PICKLIST',
    ScanCell = 'SCAN_CELL',
    ScanItem = 'SCAN_ITEM',
    AssignTote = 'ASSIGN_TOTE',
    ToteReplace = 'TOTE_REPLACE',
    ReleasePod = 'RELEASE_POD',
    ToteRelease = 'TOTE_RELEASE',
    ForceAddTote = 'FORCE_ADD_TOTE',
    ForceDropTote = 'FORCE_DROP_TOTE',
    AddTote = 'ADD_TOTE',
    DropTote = 'DROP_TOTE',
    ItemPicked = 'ITEM_PICKED',
    ItemPlaced = 'ITEM_PLACED',
    LostItem = 'LOST_ITEM',
    DamagedItem = 'DAMAGED_ITEM',
    QueueItemCount = 'QUEUE_ITEM_COUNT',
    ItemThreshold = 'ITEM_THRESHOLD',
    StockCount = 'STOCK_COUNT',
    PicklistCapacity = 'PICKLIST_CAPACITY'
}

/**
 * 
 * @export
 * @interface RasMissingNotificationFaceSummaryQueryOutputDTO
 */
export interface RasMissingNotificationFaceSummaryQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RasMissingNotificationFaceSummaryQueryOutputDTO
     */
    podNo?: string;
    /**
     * 
     * @type {string}
     * @memberof RasMissingNotificationFaceSummaryQueryOutputDTO
     */
    face?: string;
    /**
     * 
     * @type {string}
     * @memberof RasMissingNotificationFaceSummaryQueryOutputDTO
     */
    podCellLabels?: string;
    /**
     * 
     * @type {string}
     * @memberof RasMissingNotificationFaceSummaryQueryOutputDTO
     */
    podAddressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof RasMissingNotificationFaceSummaryQueryOutputDTO
     */
    missingCount?: number;
    /**
     * 
     * @type {string}
     * @memberof RasMissingNotificationFaceSummaryQueryOutputDTO
     */
    skus?: string;
    /**
     * 
     * @type {string}
     * @memberof RasMissingNotificationFaceSummaryQueryOutputDTO
     */
    productIds?: string;
}
/**
 * 
 * @export
 * @interface RasMissingNotificationFaceSummaryQueryOutputDTODynamicQueryOutputDTO
 */
export interface RasMissingNotificationFaceSummaryQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<RasMissingNotificationFaceSummaryQueryOutputDTO>}
     * @memberof RasMissingNotificationFaceSummaryQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<RasMissingNotificationFaceSummaryQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof RasMissingNotificationFaceSummaryQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface RasOrderBasedPickCancelledItemCommand
 */
export interface RasOrderBasedPickCancelledItemCommand {
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickCancelledItemCommand
     */
    stationLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickCancelledItemCommand
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickCancelledItemCommand
     */
    pickListId?: string;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickCancelledItemCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickCancelledItemCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickCancelledItemCommand
     */
    cancelToteLabel?: string;
}
/**
 * 
 * @export
 * @interface RasOrderBasedPickCheckProductOutputDTO
 */
export interface RasOrderBasedPickCheckProductOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickCheckProductOutputDTO
     */
    targetToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickCheckProductOutputDTO
     */
    targetTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickCheckProductOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickCheckProductOutputDTO
     */
    redirectToToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickCheckProductOutputDTO
     */
    redirectToTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickCheckProductOutputDTO
     */
    redirectToStationLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickCheckProductOutputDTO
     */
    cluster?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RasOrderBasedPickCheckProductOutputDTO
     */
    isCancelled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickCheckProductOutputDTO
     */
    cancelDirectiveMessage?: string;
    /**
     * 
     * @type {number}
     * @memberof RasOrderBasedPickCheckProductOutputDTO
     */
    remainingPickAmount?: number;
}
/**
 * 
 * @export
 * @interface RasOrderBasedPickClusterOutputDTO
 */
export interface RasOrderBasedPickClusterOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickClusterOutputDTO
     */
    cluster?: string;
}
/**
 * 
 * @export
 * @interface RasOrderBasedPickMissingItemCommand
 */
export interface RasOrderBasedPickMissingItemCommand {
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickMissingItemCommand
     */
    stationLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickMissingItemCommand
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickMissingItemCommand
     */
    pickListId?: string;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickMissingItemCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickMissingItemCommand
     */
    productBarcode?: string;
}
/**
 * 
 * @export
 * @interface RasOrderBasedPickStationTrolleysOutputDTO
 */
export interface RasOrderBasedPickStationTrolleysOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickStationTrolleysOutputDTO
     */
    leftTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasOrderBasedPickStationTrolleysOutputDTO
     */
    rightTrolleyLabel?: string;
}
/**
 * 
 * @export
 * @interface RasPickListsOutputDTO
 */
export interface RasPickListsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RasPickListsOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof RasPickListsOutputDTO
     */
    pickListId?: string;
    /**
     * 
     * @type {string}
     * @memberof RasPickListsOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof RasPickListsOutputDTO
     */
    targetDispatchDateTime?: string;
    /**
     * 
     * @type {number}
     * @memberof RasPickListsOutputDTO
     */
    priority?: number;
    /**
     * 
     * @type {string}
     * @memberof RasPickListsOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof RasPickListsOutputDTO
     */
    salesChannel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasPickListsOutputDTO
     */
    method?: string;
    /**
     * 
     * @type {string}
     * @memberof RasPickListsOutputDTO
     */
    flow?: string;
    /**
     * 
     * @type {Array<ItemToPickOutputDTO>}
     * @memberof RasPickListsOutputDTO
     */
    itemsToPick?: Array<ItemToPickOutputDTO>;
    /**
     * 
     * @type {string}
     * @memberof RasPickListsOutputDTO
     */
    inProgressStationLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasPickListsOutputDTO
     */
    cluster?: string;
}
/**
 * 
 * @export
 * @interface RasPlaceProductOutputDTO
 */
export interface RasPlaceProductOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof RasPlaceProductOutputDTO
     */
    waitingListAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RasPlaceProductOutputDTO
     */
    isPickListCompleted?: boolean;
    /**
     * 
     * @type {Array<RasStationToteOutputDTO>}
     * @memberof RasPlaceProductOutputDTO
     */
    completedTotes?: Array<RasStationToteOutputDTO>;
}
/**
 * 
 * @export
 * @interface RasPodOutputDTO
 */
export interface RasPodOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RasPodOutputDTO
     */
    podLabel?: string;
}
/**
 * 
 * @export
 * @interface RasProblemSolverItemFoundCommand
 */
export interface RasProblemSolverItemFoundCommand {
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverItemFoundCommand
     */
    stationAddressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverItemFoundCommand
     */
    podCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverItemFoundCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RasProblemSolverItemFoundCommand
     */
    serialNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface RasProblemSolverItemLostCommand
 */
export interface RasProblemSolverItemLostCommand {
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverItemLostCommand
     */
    stationAddressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverItemLostCommand
     */
    podCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverItemLostCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RasProblemSolverItemLostCommand
     */
    serialNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface RasProblemSolverMissingNotificationQueryOutputDTO
 */
export interface RasProblemSolverMissingNotificationQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverMissingNotificationQueryOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverMissingNotificationQueryOutputDTO
     */
    podCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverMissingNotificationQueryOutputDTO
     */
    podAddressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverMissingNotificationQueryOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverMissingNotificationQueryOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {number}
     * @memberof RasProblemSolverMissingNotificationQueryOutputDTO
     */
    missingIncrement?: number;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverMissingNotificationQueryOutputDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface RasProblemSolverMissingNotificationQueryOutputDTODynamicQueryOutputDTO
 */
export interface RasProblemSolverMissingNotificationQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<RasProblemSolverMissingNotificationQueryOutputDTO>}
     * @memberof RasProblemSolverMissingNotificationQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<RasProblemSolverMissingNotificationQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof RasProblemSolverMissingNotificationQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface RasProblemSolverPodCancellationItemOutputDTO
 */
export interface RasProblemSolverPodCancellationItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverPodCancellationItemOutputDTO
     */
    podCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverPodCancellationItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverPodCancellationItemOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverPodCancellationItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverPodCancellationItemOutputDTO
     */
    orderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverPodCancellationItemOutputDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface RasProblemSolverPodItemOutputDTO
 */
export interface RasProblemSolverPodItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverPodItemOutputDTO
     */
    podCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverPodItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverPodItemOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {number}
     * @memberof RasProblemSolverPodItemOutputDTO
     */
    missingIncrement?: number;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverPodItemOutputDTO
     */
    productId?: string;
}
/**
 * 
 * @export
 * @interface RasProblemSolverStripCancelledItemCommand
 */
export interface RasProblemSolverStripCancelledItemCommand {
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverStripCancelledItemCommand
     */
    podCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverStripCancelledItemCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof RasProblemSolverStripCancelledItemCommand
     */
    cancelToteLabel?: string;
}
/**
 * 
 * @export
 * @interface RasReplenishmentToteDetailsOutputDTO
 */
export interface RasReplenishmentToteDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RasReplenishmentToteDetailsOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {Array<TransferItemOutputDTO>}
     * @memberof RasReplenishmentToteDetailsOutputDTO
     */
    containedProducts?: Array<TransferItemOutputDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof RasReplenishmentToteDetailsOutputDTO
     */
    selected?: boolean;
}
/**
 * 
 * @export
 * @interface RasStationMetricDTO
 */
export interface RasStationMetricDTO {
    /**
     * 
     * @type {string}
     * @memberof RasStationMetricDTO
     */
    station?: string;
    /**
     * 
     * @type {StationType}
     * @memberof RasStationMetricDTO
     */
    stationType?: StationType;
    /**
     * 
     * @type {string}
     * @memberof RasStationMetricDTO
     */
    podLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasStationMetricDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasStationMetricDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasStationMetricDTO
     */
    podFace?: string;
    /**
     * 
     * @type {RasMetricType}
     * @memberof RasStationMetricDTO
     */
    metricType?: RasMetricType;
    /**
     * 
     * @type {string}
     * @memberof RasStationMetricDTO
     */
    time?: string;
    /**
     * 
     * @type {string}
     * @memberof RasStationMetricDTO
     */
    warehouseName?: string;
}
/**
 * 
 * @export
 * @interface RasStationToteOutputDTO
 */
export interface RasStationToteOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof RasStationToteOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RasStationToteOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof RasStationToteOutputDTO
     */
    stationSlot?: number;
    /**
     * 
     * @type {Array<ToteContainedItemOutputDTO>}
     * @memberof RasStationToteOutputDTO
     */
    containedProducts?: Array<ToteContainedItemOutputDTO>;
    /**
     * 
     * @type {string}
     * @memberof RasStationToteOutputDTO
     */
    pickListId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RasStationToteOutputDTO
     */
    forceDrop?: boolean;
}
/**
 * 
 * @export
 * @interface RasStockItemProductOutputDTO
 */
export interface RasStockItemProductOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof RasStockItemProductOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RasStockItemProductOutputDTO
     */
    identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof RasStockItemProductOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof RasStockItemProductOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof RasStockItemProductOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof RasStockItemProductOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RasStockItemProductOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RasStockItemProductOutputDTO
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof RasStockItemProductOutputDTO
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof RasStockItemProductOutputDTO
     */
    length?: number;
    /**
     * 
     * @type {number}
     * @memberof RasStockItemProductOutputDTO
     */
    weight?: number;
    /**
     * 
     * @type {number}
     * @memberof RasStockItemProductOutputDTO
     */
    volume?: number;
    /**
     * 
     * @type {number}
     * @memberof RasStockItemProductOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof RasStockItemProductOutputDTO
     */
    missingCounter?: number;
}
/**
 * 
 * @export
 * @interface RasStockItemProductOutputDTODynamicQueryOutputDTO
 */
export interface RasStockItemProductOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<RasStockItemProductOutputDTO>}
     * @memberof RasStockItemProductOutputDTODynamicQueryOutputDTO
     */
    data?: Array<RasStockItemProductOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof RasStockItemProductOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface RasStockItemsOutputDTO
 */
export interface RasStockItemsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RasStockItemsOutputDTO
     */
    podLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasStockItemsOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RasStockItemsOutputDTO
     */
    podFace?: string;
    /**
     * 
     * @type {Array<RasStockItemProductOutputDTO>}
     * @memberof RasStockItemsOutputDTO
     */
    products?: Array<RasStockItemProductOutputDTO>;
}
/**
 * 
 * @export
 * @interface ReactivatePurchaseOrderCommand
 */
export interface ReactivatePurchaseOrderCommand {
    /**
     * 
     * @type {string}
     * @memberof ReactivatePurchaseOrderCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReactivatePurchaseOrderCommand
     */
    purchaseOrderReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface ReactivatePurchaseOrderOutputDTO
 */
export interface ReactivatePurchaseOrderOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReactivatePurchaseOrderOutputDTO
     */
    purchaseOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ReactivatePurchaseOrderOutputDTO
     */
    purchaseOrderState?: string;
    /**
     * 
     * @type {number}
     * @memberof ReactivatePurchaseOrderOutputDTO
     */
    waybillsReactivatedCount?: number;
}
/**
 * 
 * @export
 * @interface ReadyToCollectEntry
 */
export interface ReadyToCollectEntry {
    /**
     * 
     * @type {number}
     * @memberof ReadyToCollectEntry
     */
    consolidationId?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadyToCollectEntry
     */
    maturedDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadyToCollectEntry
     */
    orderDate?: string;
    /**
     * 
     * @type {Array<TrendyolReadyToCollectItemInputDTO>}
     * @memberof ReadyToCollectEntry
     */
    items?: Array<TrendyolReadyToCollectItemInputDTO>;
}
/**
 * 
 * @export
 * @interface ReadyToCollectRequest
 */
export interface ReadyToCollectRequest {
    /**
     * 
     * @type {number}
     * @memberof ReadyToCollectRequest
     */
    warehouseId?: number;
    /**
     * 
     * @type {Array<ReadyToCollectEntry>}
     * @memberof ReadyToCollectRequest
     */
    data?: Array<ReadyToCollectEntry>;
}
/**
 * 
 * @export
 * @interface ReadyToShipCargoPackagesCountOutputDTO
 */
export interface ReadyToShipCargoPackagesCountOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof ReadyToShipCargoPackagesCountOutputDTO
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadyToShipCargoPackagesCountOutputDTO
     */
    shipmentFailure?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadyToShipCargoPackagesCountOutputDTO
     */
    cancelled?: number;
    /**
     * 
     * @type {Array<CargoPackageCountByOperationOutputDTO>}
     * @memberof ReadyToShipCargoPackagesCountOutputDTO
     */
    byOperation?: Array<CargoPackageCountByOperationOutputDTO>;
    /**
     * 
     * @type {Array<CargoPackageCountByCarrierOutputDTO>}
     * @memberof ReadyToShipCargoPackagesCountOutputDTO
     */
    byCargoCarrier?: Array<CargoPackageCountByCarrierOutputDTO>;
}
/**
 * 
 * @export
 * @interface ReadyToShipCargoPackagesOutputDTO
 */
export interface ReadyToShipCargoPackagesOutputDTO {
    /**
     * 
     * @type {SLAMQueryCompletedCargoState}
     * @memberof ReadyToShipCargoPackagesOutputDTO
     */
    state?: SLAMQueryCompletedCargoState;
    /**
     * 
     * @type {string}
     * @memberof ReadyToShipCargoPackagesOutputDTO
     */
    cargoCarrier?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof ReadyToShipCargoPackagesOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof ReadyToShipCargoPackagesOutputDTO
     */
    packingCompletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadyToShipCargoPackagesOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadyToShipCargoPackagesOutputDTO
     */
    cargoPackageLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadyToShipCargoPackagesOutputDTO
     */
    shipmentAddressFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadyToShipCargoPackagesOutputDTO
     */
    shipmentAddressCity?: string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof ReadyToShipCargoPackagesOutputDTO
     */
    salesChannel?: SalesChannel;
}
/**
 * 
 * @export
 * @interface ReadyToShipCargoPackagesOutputDTODynamicQueryOutputDTO
 */
export interface ReadyToShipCargoPackagesOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ReadyToShipCargoPackagesOutputDTO>}
     * @memberof ReadyToShipCargoPackagesOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ReadyToShipCargoPackagesOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ReadyToShipCargoPackagesOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface RebinSortingHistoryOutputDTO
 */
export interface RebinSortingHistoryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RebinSortingHistoryOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof RebinSortingHistoryOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof RebinSortingHistoryOutputDTO
     */
    productBarcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof RebinSortingHistoryOutputDTO
     */
    batchToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RebinSortingHistoryOutputDTO
     */
    rebinToteLabel?: string;
}
/**
 * 
 * @export
 * @interface RebinSortingHistoryOutputDTODynamicQueryOutputDTO
 */
export interface RebinSortingHistoryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<RebinSortingHistoryOutputDTO>}
     * @memberof RebinSortingHistoryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<RebinSortingHistoryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof RebinSortingHistoryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum RebinTrolleySide {
    Left = 'Left',
    Right = 'Right'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum RebinVolumeConfigType {
    Cell = 'Cell',
    Trolley = 'Trolley'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ReceiveType {
    Standard = 'Standard',
    Deducted = 'Deducted',
    Return = 'Return'
}

/**
 * 
 * @export
 * @interface ReceivedItemOutputDTO
 */
export interface ReceivedItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReceivedItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivedItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivedItemOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivedItemOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivedItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof ReceivedItemOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReceivedItemOutputDTO
     */
    isExpirationDateRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReceivedItemOutputDTO
     */
    expirationDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReceivedItemOutputDTO
     */
    isLotNumberTrackingRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReceivedItemOutputDTO
     */
    lotNumber?: string;
}
/**
 * 
 * @export
 * @interface ReceivedItemToteOutputDTO
 */
export interface ReceivedItemToteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReceivedItemToteOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof ReceivedItemToteOutputDTO
     */
    containedItemCount?: number;
    /**
     * 
     * @type {AddressType}
     * @memberof ReceivedItemToteOutputDTO
     */
    addressType?: AddressType;
}
/**
 * 
 * @export
 * @interface ReceivedItemToteOutputDTODynamicQueryOutputDTO
 */
export interface ReceivedItemToteOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ReceivedItemToteOutputDTO>}
     * @memberof ReceivedItemToteOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ReceivedItemToteOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ReceivedItemToteOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ReceivedItemsOutputDTO
 */
export interface ReceivedItemsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof ReceivedItemsOutputDTO
     */
    totalItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ReceivedItemsOutputDTO
     */
    totalToteCount?: number;
    /**
     * 
     * @type {Array<ReceivedItemToteOutputDTO>}
     * @memberof ReceivedItemsOutputDTO
     */
    receivedItemTotes?: Array<ReceivedItemToteOutputDTO>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ReceivingBarcodeTypeEnum {
    Product = 'Product',
    ExpirationDateRequiredProduct = 'ExpirationDateRequiredProduct',
    MasterCarton = 'MasterCarton',
    MeasurementRequiredProduct = 'MeasurementRequiredProduct',
    ExpirationDateAndMeasurementRequiredProduct = 'ExpirationDateAndMeasurementRequiredProduct',
    LotNumberTrackingRequiredProduct = 'LotNumberTrackingRequiredProduct'
}

/**
 * 
 * @export
 * @interface ReceivingInitialLoadSeedPayload
 */
export interface ReceivingInitialLoadSeedPayload {
    /**
     * 
     * @type {number}
     * @memberof ReceivingInitialLoadSeedPayload
     */
    inboundBoxAmount?: number;
    /**
     * 
     * @type {TenantsEnum}
     * @memberof ReceivingInitialLoadSeedPayload
     */
    tenant?: TenantsEnum;
    /**
     * 
     * @type {OperationsEnum}
     * @memberof ReceivingInitialLoadSeedPayload
     */
    operation?: OperationsEnum;
}
/**
 * 
 * @export
 * @interface ReceivingProcessTotalItemAmountOutputDTO
 */
export interface ReceivingProcessTotalItemAmountOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof ReceivingProcessTotalItemAmountOutputDTO
     */
    totalItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ReceivingProcessTotalItemAmountOutputDTO
     */
    receivedItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ReceivingProcessTotalItemAmountOutputDTO
     */
    damagedItemAmount?: number;
}
/**
 * 
 * @export
 * @interface ReceivingProductDetailsOutputDTO
 */
export interface ReceivingProductDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReceivingProductDetailsOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivingProductDetailsOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivingProductDetailsOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivingProductDetailsOutputDTO
     */
    sku?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ReceivingState {
    AwaitingInventory = 'AwaitingInventory',
    ReceivingOnHold = 'ReceivingOnHold',
    ReceivingCanBeStarted = 'ReceivingCanBeStarted',
    ReceivingInProgress = 'ReceivingInProgress',
    ReceivingCompleted = 'ReceivingCompleted'
}

/**
 * 
 * @export
 * @interface ReceivingToteDetailsForWebReceivingOutputDTO
 */
export interface ReceivingToteDetailsForWebReceivingOutputDTO {
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof ReceivingToteDetailsForWebReceivingOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof ReceivingToteDetailsForWebReceivingOutputDTO
     */
    purchaseOrdeReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivingToteDetailsForWebReceivingOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivingToteDetailsForWebReceivingOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivingToteDetailsForWebReceivingOutputDTO
     */
    productImageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivingToteDetailsForWebReceivingOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {number}
     * @memberof ReceivingToteDetailsForWebReceivingOutputDTO
     */
    totalAmount?: number;
}
/**
 * 
 * @export
 * @interface ReceivingToteDetailsForWebReceivingOutputDTODynamicQueryOutputDTO
 */
export interface ReceivingToteDetailsForWebReceivingOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ReceivingToteDetailsForWebReceivingOutputDTO>}
     * @memberof ReceivingToteDetailsForWebReceivingOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ReceivingToteDetailsForWebReceivingOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ReceivingToteDetailsForWebReceivingOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ReceivingTransferHistoryItemOutputDTO
 */
export interface ReceivingTransferHistoryItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReceivingTransferHistoryItemOutputDTO
     */
    sourceLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivingTransferHistoryItemOutputDTO
     */
    targetLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivingTransferHistoryItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivingTransferHistoryItemOutputDTO
     */
    productSKU?: string;
    /**
     * 
     * @type {number}
     * @memberof ReceivingTransferHistoryItemOutputDTO
     */
    productCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ReceivingTransferHistoryItemOutputDTO
     */
    transferTime?: string;
}
/**
 * 
 * @export
 * @interface ReceivingTransferHistoryOutputDTO
 */
export interface ReceivingTransferHistoryOutputDTO {
    /**
     * 
     * @type {Array<ReceivingTransferHistoryItemOutputDTO>}
     * @memberof ReceivingTransferHistoryOutputDTO
     */
    transfers?: Array<ReceivingTransferHistoryItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface RecipientAddressDetailsOutputDTO
 */
export interface RecipientAddressDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RecipientAddressDetailsOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientAddressDetailsOutputDTO
     */
    recipientFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientAddressDetailsOutputDTO
     */
    recipientFullAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientAddressDetailsOutputDTO
     */
    customerFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientAddressDetailsOutputDTO
     */
    orderCreatedAt?: string;
}
/**
 * 
 * @export
 * @interface ReleasePodCommand
 */
export interface ReleasePodCommand {
    /**
     * 
     * @type {string}
     * @memberof ReleasePodCommand
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface RemainingItemsDTO
 */
export interface RemainingItemsDTO {
    /**
     * 
     * @type {number}
     * @memberof RemainingItemsDTO
     */
    stockItems?: number;
    /**
     * 
     * @type {number}
     * @memberof RemainingItemsDTO
     */
    damagedItems?: number;
    /**
     * 
     * @type {number}
     * @memberof RemainingItemsDTO
     */
    otherItems?: number;
    /**
     * 
     * @type {number}
     * @memberof RemainingItemsDTO
     */
    totalRemaining?: number;
}
/**
 * 
 * @export
 * @interface RemainingReceivedItemOutputDTO
 */
export interface RemainingReceivedItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RemainingReceivedItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof RemainingReceivedItemOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof RemainingReceivedItemOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof RemainingReceivedItemOutputDTO
     */
    amount?: number;
}
/**
 *
 * @export
 * @interface CloseCargoPackageCommand
 */
export interface CloseCargoPackageCommand {
    /**
     *
     * @type {string}
     * @memberof CloseCargoPackageCommand
     */
    packingProcessId?: string;
    /**
     *
     * @type {number}
     * @memberof CloseCargoPackageCommand
     */
    packageIndex?: number;
}
/**
 *
 * @export
 * @interface CloseCargoPackageCommandOutputDTO
 */
export interface CloseCargoPackageCommandOutputDTO {
    /**
     *
     * @type {number}
     * @memberof CloseCargoPackageCommandOutputDTO
     */
    cargoPackageId?: number;
    /**
     *
     * @type {boolean}
     * @memberof CloseCargoPackageCommandOutputDTO
     */
    isSealed?: boolean;
}
/**
 *
 * @export
 * @interface UnsealCargoPackageCommand
 */
export interface UnsealCargoPackageCommand {
    /**
     *
     * @type {string}
     * @memberof UnsealCargoPackageCommand
     */
    packingProcessId?: string;
    /**
     *
     * @type {number}
     * @memberof UnsealCargoPackageCommand
     */
    packageIndex?: number;
    /**
     *
     * @type {string}
     * @memberof UnsealCargoPackageCommand
     */
    scannedCargoPackageLabel?: string | null;
}
/**
 *
 * @export
 * @interface UnsealCargoPackageCommandOutputDTO
 */
export interface UnsealCargoPackageCommandOutputDTO {
    /**
     *
     * @type {number}
     * @memberof UnsealCargoPackageCommandOutputDTO
     */
    cargoPackageId?: number;
    /**
     *
     * @type {string}
     * @memberof UnsealCargoPackageCommandOutputDTO
     */
    cargoPackageLabel?: string | null;
    /**
     *
     * @type {boolean}
     * @memberof UnsealCargoPackageCommandOutputDTO
     */
    isShipmentCancelled?: boolean;
}
/**
 *
 * @export
 * @interface RemoveCargoPackageCommand
 */
export interface RemoveCargoPackageCommand {
    /**
     * 
     * @type {string}
     * @memberof RemoveCargoPackageCommand
     */
    packingProcessId?: string;
    /**
     * 
     * @type {number}
     * @memberof RemoveCargoPackageCommand
     */
    packageIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof RemoveCargoPackageCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface RemoveCargoPackageCommandOutputDTO
 */
export interface RemoveCargoPackageCommandOutputDTO {
    /**
     * 
     * @type {Array<UpdatedIndexCargoPackageOutputDTO>}
     * @memberof RemoveCargoPackageCommandOutputDTO
     */
    packages?: Array<UpdatedIndexCargoPackageOutputDTO>;
}
/**
 * 
 * @export
 * @interface RemoveContainerFromSalesOrderCommand
 */
export interface RemoveContainerFromSalesOrderCommand {
    /**
     * 
     * @type {string}
     * @memberof RemoveContainerFromSalesOrderCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveContainerFromSalesOrderCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveContainerFromSalesOrderCommand
     */
    containerLabel?: string;
}
/**
 * 
 * @export
 * @interface RemoveContainerFromSalesOrderOutputDTO
 */
export interface RemoveContainerFromSalesOrderOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RemoveContainerFromSalesOrderOutputDTO
     */
    removedContainerLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof RemoveContainerFromSalesOrderOutputDTO
     */
    itemsMovedCount?: number;
    /**
     * 
     * @type {string}
     * @memberof RemoveContainerFromSalesOrderOutputDTO
     */
    targetContainerLabel?: string;
}
/**
 * 
 * @export
 * @interface RemoveHOVCargoPackageCommand
 */
export interface RemoveHOVCargoPackageCommand {
    /**
     * 
     * @type {string}
     * @memberof RemoveHOVCargoPackageCommand
     */
    hovPackingProcessId?: string;
    /**
     * 
     * @type {number}
     * @memberof RemoveHOVCargoPackageCommand
     */
    packageIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof RemoveHOVCargoPackageCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface RemoveHOVCargoPackageCommandOutputDTO
 */
export interface RemoveHOVCargoPackageCommandOutputDTO {
    /**
     * 
     * @type {Array<UpdatedIndexHOVCargoPackageOutputDTO>}
     * @memberof RemoveHOVCargoPackageCommandOutputDTO
     */
    packages?: Array<UpdatedIndexHOVCargoPackageOutputDTO>;
}
/**
 * 
 * @export
 * @interface RemoveHOVItemFromCargoPackageCommand
 */
export interface RemoveHOVItemFromCargoPackageCommand {
    /**
     * 
     * @type {string}
     * @memberof RemoveHOVItemFromCargoPackageCommand
     */
    hovPackingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveHOVItemFromCargoPackageCommand
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveHOVItemFromCargoPackageCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof RemoveHOVItemFromCargoPackageCommand
     */
    packageIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof RemoveHOVItemFromCargoPackageCommand
     */
    simpleSerialNumber?: string;
}
/**
 * 
 * @export
 * @interface RemoveHOVPackingProcessOfUnpackableToteCommand
 */
export interface RemoveHOVPackingProcessOfUnpackableToteCommand {
    /**
     * 
     * @type {string}
     * @memberof RemoveHOVPackingProcessOfUnpackableToteCommand
     */
    pickingToteLabel?: string;
}
/**
 * 
 * @export
 * @interface RemoveItemFromCargoPackageCommand
 */
export interface RemoveItemFromCargoPackageCommand {
    /**
     * 
     * @type {string}
     * @memberof RemoveItemFromCargoPackageCommand
     */
    packingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveItemFromCargoPackageCommand
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveItemFromCargoPackageCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof RemoveItemFromCargoPackageCommand
     */
    packageIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof RemoveItemFromCargoPackageCommand
     */
    simpleSerialNumber?: string;
}
/**
 * 
 * @export
 * @interface RemovePackingProcessOfUnpackableToteCommand
 */
export interface RemovePackingProcessOfUnpackableToteCommand {
    /**
     * 
     * @type {string}
     * @memberof RemovePackingProcessOfUnpackableToteCommand
     */
    pickingToteLabel?: string;
}
/**
 * 
 * @export
 * @interface RemovePackingQuarantineProcessCommand
 */
export interface RemovePackingQuarantineProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof RemovePackingQuarantineProcessCommand
     */
    packingQuarantineProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof RemovePackingQuarantineProcessCommand
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RemovePackingQuarantineProcessCommand
     */
    operatorId?: string;
}
/**
 * 
 * @export
 * @interface RemovePickingPrioritiesCommand
 */
export interface RemovePickingPrioritiesCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof RemovePickingPrioritiesCommand
     */
    salesOrderIds?: Array<string>;
}
/**
 * 
 * @export
 * @interface RemovePrinterAddressCommand
 */
export interface RemovePrinterAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof RemovePrinterAddressCommand
     */
    printerName?: string;
    /**
     * 
     * @type {string}
     * @memberof RemovePrinterAddressCommand
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface RemoveToteFromTransferTrolleyCommand
 */
export interface RemoveToteFromTransferTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof RemoveToteFromTransferTrolleyCommand
     */
    transferTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveToteFromTransferTrolleyCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveToteFromTransferTrolleyCommand
     */
    targetAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface RenamedSKUInfo
 */
export interface RenamedSKUInfo {
    /**
     * 
     * @type {string}
     * @memberof RenamedSKUInfo
     */
    oldSKU?: string;
    /**
     * 
     * @type {string}
     * @memberof RenamedSKUInfo
     */
    newSKU?: string;
}
/**
 * 
 * @export
 * @interface RenewExternalContractCommand
 */
export interface RenewExternalContractCommand {
    /**
     * 
     * @type {string}
     * @memberof RenewExternalContractCommand
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof RenewExternalContractCommand
     */
    newCargoCode?: string;
    /**
     * 
     * @type {string}
     * @memberof RenewExternalContractCommand
     */
    newCargoDocumentUrl?: string;
}
/**
 * 
 * @export
 * @interface ReplenishmentCellContentItemDTO
 */
export interface ReplenishmentCellContentItemDTO {
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentCellContentItemDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentCellContentItemDTO
     */
    productSku?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentCellContentItemDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentCellContentItemDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof ReplenishmentCellContentItemDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentCellContentItemDTO
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentCellContentItemDTO
     */
    expirationDate?: string;
}
/**
 * 
 * @export
 * @interface ReplenishmentCellContentOutputDTO
 */
export interface ReplenishmentCellContentOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentCellContentOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentCellContentOutputDTO
     */
    cellType?: string;
    /**
     * 
     * @type {number}
     * @memberof ReplenishmentCellContentOutputDTO
     */
    totalSkuCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ReplenishmentCellContentOutputDTO
     */
    totalAmount?: number;
    /**
     * 
     * @type {Array<ReplenishmentCellContentItemDTO>}
     * @memberof ReplenishmentCellContentOutputDTO
     */
    items?: Array<ReplenishmentCellContentItemDTO>;
}
/**
 * 
 * @export
 * @interface ReplenishmentJobLineInputDTO
 */
export interface ReplenishmentJobLineInputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobLineInputDTO
     */
    sourceCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobLineInputDTO
     */
    productSku?: string;
    /**
     * 
     * @type {number}
     * @memberof ReplenishmentJobLineInputDTO
     */
    requestedAmount?: number;
}
/**
 * 
 * @export
 * @interface ReplenishmentJobManagementOutputDTO
 */
export interface ReplenishmentJobManagementOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    rId?: number;
    /**
     * 
     * @type {ReplenishmentJobState}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    state?: ReplenishmentJobState;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    sourceCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    productSku?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {number}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    requestedAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    isPriority?: boolean;
    /**
     * 
     * @type {ReplenishmentJobType}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    jobType?: ReplenishmentJobType;
    /**
     * 
     * @type {ReplenishmentJobOrigin}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    origin?: ReplenishmentJobOrigin;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    importBatchId?: string;
    /**
     * 
     * @type {number}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    targetSubZoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    targetSubZoneName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    actualSourceCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    actualTargetCellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    actualAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    claimedByUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    claimedByFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    claimedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobManagementOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface ReplenishmentJobManagementOutputDTODynamicQueryOutputDTO
 */
export interface ReplenishmentJobManagementOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ReplenishmentJobManagementOutputDTO>}
     * @memberof ReplenishmentJobManagementOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ReplenishmentJobManagementOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ReplenishmentJobManagementOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ReplenishmentJobOrigin {
    SystemNeed = 'SystemNeed',
    Manual = 'Manual'
}

/**
 * 
 * @export
 * @interface ReplenishmentJobOutputDTO
 */
export interface ReplenishmentJobOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobOutputDTO
     */
    sourceCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobOutputDTO
     */
    productSku?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobOutputDTO
     */
    productBarcodes?: string;
    /**
     * 
     * @type {number}
     * @memberof ReplenishmentJobOutputDTO
     */
    requestedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ReplenishmentJobOutputDTO
     */
    targetSubZoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentJobOutputDTO
     */
    targetSubZoneName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReplenishmentJobOutputDTO
     */
    isPriority?: boolean;
    /**
     * 
     * @type {ReplenishmentJobType}
     * @memberof ReplenishmentJobOutputDTO
     */
    jobType?: ReplenishmentJobType;
    /**
     * 
     * @type {ReplenishmentJobState}
     * @memberof ReplenishmentJobOutputDTO
     */
    state?: ReplenishmentJobState;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ReplenishmentJobState {
    Pending = 'Pending',
    InProgress = 'InProgress',
    Completed = 'Completed',
    Cancelled = 'Cancelled'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ReplenishmentJobType {
    Quantity = 'Quantity',
    Pallet = 'Pallet'
}

/**
 * 
 * @export
 * @interface ReplenishmentNeedOutputDTO
 */
export interface ReplenishmentNeedOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentNeedOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentNeedOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentNeedOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentNeedOutputDTO
     */
    productSku?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentNeedOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentNeedOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {number}
     * @memberof ReplenishmentNeedOutputDTO
     */
    neededAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentNeedOutputDTO
     */
    suggestedSourceCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentNeedOutputDTO
     */
    expirationDate?: string;
}
/**
 * 
 * @export
 * @interface ReplenishmentNeedOutputDTODynamicQueryOutputDTO
 */
export interface ReplenishmentNeedOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ReplenishmentNeedOutputDTO>}
     * @memberof ReplenishmentNeedOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ReplenishmentNeedOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ReplenishmentNeedOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ReplenishmentTransferableAmountOutputDTO
 */
export interface ReplenishmentTransferableAmountOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof ReplenishmentTransferableAmountOutputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface ReprintHOVPalettePackingListCommand
 */
export interface ReprintHOVPalettePackingListCommand {
    /**
     * 
     * @type {string}
     * @memberof ReprintHOVPalettePackingListCommand
     */
    salesOrderId?: string;
}
/**
 * 
 * @export
 * @interface ReprintPalettePackingListCommand
 */
export interface ReprintPalettePackingListCommand {
    /**
     * 
     * @type {string}
     * @memberof ReprintPalettePackingListCommand
     */
    salesOrderId?: string;
}
/**
 * 
 * @export
 * @interface ResetContainerErrorCommand
 */
export interface ResetContainerErrorCommand {
    /**
     * 
     * @type {string}
     * @memberof ResetContainerErrorCommand
     */
    containerLabel?: string;
}
/**
 * 
 * @export
 * @interface ResetContainerErrorOutputDTO
 */
export interface ResetContainerErrorOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ResetContainerErrorOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof ResetContainerErrorOutputDTO
     */
    salesOrdersCleared?: number;
    /**
     * 
     * @type {number}
     * @memberof ResetContainerErrorOutputDTO
     */
    packingProcessesCompletedCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResetContainerErrorOutputDTO
     */
    containerCleared?: boolean;
}
/**
 * 
 * @export
 * @interface ResetSalesOrderStateToInitialCommand
 */
export interface ResetSalesOrderStateToInitialCommand {
    /**
     * 
     * @type {string}
     * @memberof ResetSalesOrderStateToInitialCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ResetSalesOrderStateToInitialCommand
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface ResolveSalesOrderProblemsCommand
 */
export interface ResolveSalesOrderProblemsCommand {
    /**
     * 
     * @type {string}
     * @memberof ResolveSalesOrderProblemsCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolveSalesOrderProblemsCommand
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface ResolvedReturnPackageQueryOutputDTO
 */
export interface ResolvedReturnPackageQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ResolvedReturnPackageQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedReturnPackageQueryOutputDTO
     */
    trackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedReturnPackageQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedReturnPackageQueryOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedReturnPackageQueryOutputDTO
     */
    cargoTrackingNumber?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof ResolvedReturnPackageQueryOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof ResolvedReturnPackageQueryOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedReturnPackageQueryOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface ResolvedReturnPackageQueryOutputDTODynamicQueryOutputDTO
 */
export interface ResolvedReturnPackageQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ResolvedReturnPackageQueryOutputDTO>}
     * @memberof ResolvedReturnPackageQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ResolvedReturnPackageQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ResolvedReturnPackageQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface RestowUndamagedItemCommand
 */
export interface RestowUndamagedItemCommand {
    /**
     * 
     * @type {string}
     * @memberof RestowUndamagedItemCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RestowUndamagedItemCommand
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {WallToWallStockCountingProductInputDTO}
     * @memberof RestowUndamagedItemCommand
     */
    undamagedItemCount?: WallToWallStockCountingProductInputDTO;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ReturnImageCategory {
    None = 'None',
    CargoImpactCrushing = 'CargoImpactCrushing',
    CustomerUsedProduct = 'CustomerUsedProduct',
    Other = 'Other'
}

/**
 * 
 * @export
 * @interface ReturnImageOutputDTO
 */
export interface ReturnImageOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnImageOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnImageOutputDTO
     */
    returnPackageId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnImageOutputDTO
     */
    returnLineItemId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnImageOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnImageOutputDTO
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnImageOutputDTO
     */
    uploadedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnImageOutputDTO
     */
    uploadedAt?: string;
    /**
     * 
     * @type {ReturnImageCategory}
     * @memberof ReturnImageOutputDTO
     */
    category?: ReturnImageCategory;
    /**
     * 
     * @type {number}
     * @memberof ReturnImageOutputDTO
     */
    remainingItemsWithoutImagesCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ReturnImageOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnImageOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnImageOutputDTO
     */
    productSKU?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnImageOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnImageOutputDTO
     */
    totalImagesForThisItem?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnImageOutputDTO
     */
    affectedItemsCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReturnImageOutputDTO
     */
    affectedLineItemIds?: Array<string>;
}
/**
 * 
 * @export
 * @interface ReturnInventoryItemsInputDTO
 */
export interface ReturnInventoryItemsInputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnInventoryItemsInputDTO
     */
    productId?: string;
    /**
     * 
     * @type {ReturnItemType}
     * @memberof ReturnInventoryItemsInputDTO
     */
    type?: ReturnItemType;
    /**
     * 
     * @type {number}
     * @memberof ReturnInventoryItemsInputDTO
     */
    amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReturnInventoryItemsInputDTO
     */
    serialNumbers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReturnInventoryItemsInputDTO
     */
    simpleSerialNumbers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ReturnInventoryItemsInputDTO
     */
    expirationDate?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ReturnItemType {
    None = 'None',
    Damaged = 'Damaged',
    Received = 'Received',
    Outbound = 'Outbound'
}

/**
 * 
 * @export
 * @interface ReturnLineItemOutputDTO
 */
export interface ReturnLineItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnLineItemOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnLineItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnLineItemOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {ReturnLineItemState}
     * @memberof ReturnLineItemOutputDTO
     */
    state?: ReturnLineItemState;
    /**
     * 
     * @type {string}
     * @memberof ReturnLineItemOutputDTO
     */
    returnImageUrl?: string;
    /**
     * 
     * @type {ReturnImageCategory}
     * @memberof ReturnLineItemOutputDTO
     */
    returnSubReason?: ReturnImageCategory;
    /**
     * 
     * @type {string}
     * @memberof ReturnLineItemOutputDTO
     */
    note?: string;
}
/**
 * 
 * @export
 * @interface ReturnLineItemOutputDTODynamicQueryOutputDTO
 */
export interface ReturnLineItemOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ReturnLineItemOutputDTO>}
     * @memberof ReturnLineItemOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ReturnLineItemOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ReturnLineItemOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ReturnLineItemState {
    None = 'None',
    WaitingToBeProcessed = 'WaitingToBeProcessed',
    Missing = 'Missing',
    Damaged = 'Damaged',
    Undamaged = 'Undamaged',
    Outbound = 'Outbound'
}

/**
 * 
 * @export
 * @interface ReturnLineItemUpdateRequest
 */
export interface ReturnLineItemUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ReturnLineItemUpdateRequest
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnLineItemUpdateRequest
     */
    salesOrderRefNo?: string;
    /**
     * 
     * @type {ReturnPackageLineItemState}
     * @memberof ReturnLineItemUpdateRequest
     */
    state?: ReturnPackageLineItemState;
    /**
     * 
     * @type {string}
     * @memberof ReturnLineItemUpdateRequest
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface ReturnPackageComponentOutputDTO
 */
export interface ReturnPackageComponentOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageComponentOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {ReturnPackageState}
     * @memberof ReturnPackageComponentOutputDTO
     */
    state?: ReturnPackageState;
}
/**
 * 
 * @export
 * @interface ReturnPackageDetailsOutputDTO
 */
export interface ReturnPackageDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageDetailsOutputDTO
     */
    returnPackageId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageDetailsOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageDetailsOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {PersonInfoOutputDTO}
     * @memberof ReturnPackageDetailsOutputDTO
     */
    sender?: PersonInfoOutputDTO;
    /**
     * 
     * @type {PersonInfoOutputDTO}
     * @memberof ReturnPackageDetailsOutputDTO
     */
    customer?: PersonInfoOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageDetailsOutputDTO
     */
    senderAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageDetailsOutputDTO
     */
    cargoCarrierName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageDetailsOutputDTO
     */
    cargoCarrierLogoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageDetailsOutputDTO
     */
    trackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageDetailsOutputDTO
     */
    cargoTrackingNumber?: string;
    /**
     * 
     * @type {Array<OperationOutputDTO>}
     * @memberof ReturnPackageDetailsOutputDTO
     */
    operations?: Array<OperationOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ReturnPackageDetailsOutputDTO
     */
    itemsWithoutImagesCount?: number;
}
/**
 * 
 * @export
 * @interface ReturnPackageLineItemQueryOutputDTO
 */
export interface ReturnPackageLineItemQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageLineItemQueryOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageLineItemQueryOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageLineItemQueryOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageLineItemQueryOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {ReturnPackageLineItemState}
     * @memberof ReturnPackageLineItemQueryOutputDTO
     */
    state?: ReturnPackageLineItemState;
    /**
     * 
     * @type {number}
     * @memberof ReturnPackageLineItemQueryOutputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface ReturnPackageLineItemQueryOutputDTODynamicQueryOutputDTO
 */
export interface ReturnPackageLineItemQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ReturnPackageLineItemQueryOutputDTO>}
     * @memberof ReturnPackageLineItemQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ReturnPackageLineItemQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ReturnPackageLineItemQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ReturnPackageLineItemState {
    None = 'None',
    Received = 'Received',
    Damaged = 'Damaged',
    Outbound = 'Outbound'
}

/**
 * 
 * @export
 * @interface ReturnPackageQueryOutputDTO
 */
export interface ReturnPackageQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageQueryOutputDTO
     */
    trackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageQueryOutputDTO
     */
    cargoTrackingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageQueryOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageQueryOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageQueryOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageQueryOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {ReturnPackageState}
     * @memberof ReturnPackageQueryOutputDTO
     */
    state?: ReturnPackageState;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageQueryOutputDTO
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageQueryOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface ReturnPackageQueryOutputDTODynamicQueryOutputDTO
 */
export interface ReturnPackageQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ReturnPackageQueryOutputDTO>}
     * @memberof ReturnPackageQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ReturnPackageQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ReturnPackageQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ReturnPackageState {
    Undefined = 'Undefined',
    None = 'None',
    Arrived = 'Arrived',
    InProcess = 'InProcess',
    Resolved = 'Resolved'
}

/**
 * 
 * @export
 * @interface ReturnPackageStateDetailsOutputDTO
 */
export interface ReturnPackageStateDetailsOutputDTO {
    /**
     * 
     * @type {ReturnPackageState}
     * @memberof ReturnPackageStateDetailsOutputDTO
     */
    state?: ReturnPackageState;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageStateDetailsOutputDTO
     */
    arrivedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageStateDetailsOutputDTO
     */
    matchedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnPackageStateDetailsOutputDTO
     */
    resolvedAt?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ReturnProcessState {
    None = 'None',
    Created = 'Created',
    InProgress = 'InProgress',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @interface ReturnReceivingProcessOutputDTO
 */
export interface ReturnReceivingProcessOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnReceivingProcessOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnReceivingProcessOutputDTO
     */
    operatorId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnReceivingProcessOutputDTO
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnReceivingProcessOutputDTO
     */
    returnTrolleyId?: number;
    /**
     * 
     * @type {Array<ReturnPackageComponentOutputDTO>}
     * @memberof ReturnReceivingProcessOutputDTO
     */
    returnPackages?: Array<ReturnPackageComponentOutputDTO>;
}
/**
 * 
 * @export
 * @interface ReturnSalesOrderLineItemOutputDTO
 */
export interface ReturnSalesOrderLineItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnSalesOrderLineItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnSalesOrderLineItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnSalesOrderLineItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnSalesOrderLineItemOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnSalesOrderLineItemOutputDTO
     */
    amountInOrder?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReturnSalesOrderLineItemOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {ReturnLineItemState}
     * @memberof ReturnSalesOrderLineItemOutputDTO
     */
    returnState?: ReturnLineItemState;
    /**
     * 
     * @type {boolean}
     * @memberof ReturnSalesOrderLineItemOutputDTO
     */
    isTrackSerialNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReturnSalesOrderLineItemOutputDTO
     */
    isTrackSimpleSerialNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReturnSalesOrderLineItemOutputDTO
     */
    isTrackExpirationDate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReturnSalesOrderLineItemOutputDTO
     */
    allowedExpirationDate?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ReturnSource {
    None = 'None',
    Omnitro = 'Omnitro',
    Maestro = 'Maestro'
}

/**
 * 
 * @export
 * @interface ReturnToteInputDTO
 */
export interface ReturnToteInputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnToteInputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {Array<ReturnInventoryItemsInputDTO>}
     * @memberof ReturnToteInputDTO
     */
    returnItems?: Array<ReturnInventoryItemsInputDTO>;
}
/**
 * 
 * @export
 * @interface ReturnsODataODataDTOODataQueryOptions
 */
export interface ReturnsODataODataDTOODataQueryOptions {
    /**
     * 
     * @type {string}
     * @memberof ReturnsODataODataDTOODataQueryOptions
     */
    ifMatch?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnsODataODataDTOODataQueryOptions
     */
    ifNoneMatch?: string;
    /**
     * 
     * @type {HttpRequest}
     * @memberof ReturnsODataODataDTOODataQueryOptions
     */
    request?: HttpRequest;
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof ReturnsODataODataDTOODataQueryOptions
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {ODataRawQueryOptions}
     * @memberof ReturnsODataODataDTOODataQueryOptions
     */
    rawValues?: ODataRawQueryOptions;
    /**
     * 
     * @type {SelectExpandQueryOption}
     * @memberof ReturnsODataODataDTOODataQueryOptions
     */
    selectExpand?: SelectExpandQueryOption;
    /**
     * 
     * @type {ApplyQueryOption}
     * @memberof ReturnsODataODataDTOODataQueryOptions
     */
    apply?: ApplyQueryOption;
    /**
     * 
     * @type {ComputeQueryOption}
     * @memberof ReturnsODataODataDTOODataQueryOptions
     */
    compute?: ComputeQueryOption;
    /**
     * 
     * @type {FilterQueryOption}
     * @memberof ReturnsODataODataDTOODataQueryOptions
     */
    filter?: FilterQueryOption;
    /**
     * 
     * @type {SearchQueryOption}
     * @memberof ReturnsODataODataDTOODataQueryOptions
     */
    search?: SearchQueryOption;
    /**
     * 
     * @type {OrderByQueryOption}
     * @memberof ReturnsODataODataDTOODataQueryOptions
     */
    orderBy?: OrderByQueryOption;
    /**
     * 
     * @type {SkipQueryOption}
     * @memberof ReturnsODataODataDTOODataQueryOptions
     */
    skip?: SkipQueryOption;
    /**
     * 
     * @type {SkipTokenQueryOption}
     * @memberof ReturnsODataODataDTOODataQueryOptions
     */
    skipToken?: SkipTokenQueryOption;
    /**
     * 
     * @type {TopQueryOption}
     * @memberof ReturnsODataODataDTOODataQueryOptions
     */
    top?: TopQueryOption;
    /**
     * 
     * @type {CountQueryOption}
     * @memberof ReturnsODataODataDTOODataQueryOptions
     */
    count?: CountQueryOption;
    /**
     * 
     * @type {object}
     * @memberof ReturnsODataODataDTOODataQueryOptions
     */
    validator?: object;
}
/**
 * 
 * @export
 * @interface RevertDispatchedSalesOrderToPackingStateCommand
 */
export interface RevertDispatchedSalesOrderToPackingStateCommand {
    /**
     * 
     * @type {string}
     * @memberof RevertDispatchedSalesOrderToPackingStateCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof RevertDispatchedSalesOrderToPackingStateCommand
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface RevertToDispatchedCommand
 */
export interface RevertToDispatchedCommand {
    /**
     * 
     * @type {string}
     * @memberof RevertToDispatchedCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof RevertToDispatchedCommand
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface ReviewLostItemProblemByOrderCommand
 */
export interface ReviewLostItemProblemByOrderCommand {
    /**
     * 
     * @type {string}
     * @memberof ReviewLostItemProblemByOrderCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewLostItemProblemByOrderCommand
     */
    salesOrderReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface ReviewLostItemProblemByTrolleyCommand
 */
export interface ReviewLostItemProblemByTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof ReviewLostItemProblemByTrolleyCommand
     */
    trolleyLabel?: string;
}
/**
 * 
 * @export
 * @interface ReviewLostItemProblemByTrolleyOutputDTO
 */
export interface ReviewLostItemProblemByTrolleyOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ReviewLostItemProblemByTrolleyOutputDTO
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof ReviewLostItemProblemByTrolleyOutputDTO
     */
    reviewedProblemCount?: number;
}
/**
 * 
 * @export
 * @interface ReviewSalesOrderMissingProblemCommand
 */
export interface ReviewSalesOrderMissingProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof ReviewSalesOrderMissingProblemCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewSalesOrderMissingProblemCommand
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface RoleOutputDTO
 */
export interface RoleOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RoleOutputDTO
     */
    roleName?: string;
}
/**
 * 
 * @export
 * @interface RollbackDispatchOrSLAMSalesOrdersToPackingStateCommand
 */
export interface RollbackDispatchOrSLAMSalesOrdersToPackingStateCommand {
    /**
     * 
     * @type {Array<RollbackSalesOrdersToPackingStateInputDTO>}
     * @memberof RollbackDispatchOrSLAMSalesOrdersToPackingStateCommand
     */
    salesOrders?: Array<RollbackSalesOrdersToPackingStateInputDTO>;
}
/**
 * 
 * @export
 * @interface RollbackSalesOrdersToPackingStateInputDTO
 */
export interface RollbackSalesOrdersToPackingStateInputDTO {
    /**
     * 
     * @type {string}
     * @memberof RollbackSalesOrdersToPackingStateInputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof RollbackSalesOrdersToPackingStateInputDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface RouteOutputDTO
 */
export interface RouteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof RouteOutputDTO
     */
    pickListName?: string;
    /**
     * 
     * @type {number}
     * @memberof RouteOutputDTO
     */
    index?: number;
    /**
     * 
     * @type {string}
     * @memberof RouteOutputDTO
     */
    pickingProcessId?: string;
    /**
     * 
     * @type {number}
     * @memberof RouteOutputDTO
     */
    allocatedItemId?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteOutputDTO
     */
    pickingProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof RouteOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RouteOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof RouteOutputDTO
     */
    productLabels?: string;
    /**
     * 
     * @type {string}
     * @memberof RouteOutputDTO
     */
    pickingToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof RouteOutputDTO
     */
    productImage?: string;
    /**
     * 
     * @type {string}
     * @memberof RouteOutputDTO
     */
    currenState?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RouteOutputDTO
     */
    isCompleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RouteOutputDTO
     */
    pickingZoneName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RouteOutputDTO
     */
    continueWithLostItem?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RouteOutputDTO
     */
    isTrackSerialNumber?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RouteOutputDTO
     */
    targetSerialNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof RouteOutputDTO
     */
    salesOrderCount?: number;
    /**
     * 
     * @type {PickingTrolleySelectionConfigurationPickingType}
     * @memberof RouteOutputDTO
     */
    pickListType?: PickingTrolleySelectionConfigurationPickingType;
    /**
     * 
     * @type {number}
     * @memberof RouteOutputDTO
     */
    toteItemsWeightInGrams?: number;
    /**
     * 
     * @type {string}
     * @memberof RouteOutputDTO
     */
    masterCartonLabels?: string;
    /**
     * 
     * @type {number}
     * @memberof RouteOutputDTO
     */
    masterCartonProductQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof RouteOutputDTO
     */
    expectedCurrentItemAmount?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SLAMQueryCargoState {
    Total = 'Total',
    InProcess = 'InProcess',
    WaitingToProcess = 'WaitingToProcess',
    Cancelled = 'Cancelled'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SLAMQueryCompletedCargoState {
    Total = 'Total',
    ShipmentFailure = 'ShipmentFailure',
    Cancelled = 'Cancelled'
}

/**
 * 
 * @export
 * @interface SLAMSalesOrderWithProblemToDispatchCommand
 */
export interface SLAMSalesOrderWithProblemToDispatchCommand {
    /**
     * 
     * @type {string}
     * @memberof SLAMSalesOrderWithProblemToDispatchCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SLAMSalesOrderWithProblemToDispatchCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof SLAMSalesOrderWithProblemToDispatchCommand
     */
    trackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof SLAMSalesOrderWithProblemToDispatchCommand
     */
    carrierName?: string;
    /**
     * 
     * @type {string}
     * @memberof SLAMSalesOrderWithProblemToDispatchCommand
     */
    shipmentTrackingLinkUrl?: string;
}
/**
 * 
 * @export
 * @interface SLAMShipmentProblemDetailsOutputDTO
 */
export interface SLAMShipmentProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SLAMShipmentProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SLAMShipmentProblemDetailsOutputDTO
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof SLAMShipmentProblemDetailsOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {ProblemSource}
     * @memberof SLAMShipmentProblemDetailsOutputDTO
     */
    source?: ProblemSource;
    /**
     * 
     * @type {ProblemState}
     * @memberof SLAMShipmentProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {SLAMShipmentProblemState}
     * @memberof SLAMShipmentProblemDetailsOutputDTO
     */
    stateDetail?: SLAMShipmentProblemState;
    /**
     * 
     * @type {string}
     * @memberof SLAMShipmentProblemDetailsOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SLAMShipmentProblemDetailsOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof SLAMShipmentProblemDetailsOutputDTO
     */
    resolutionNote?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SLAMShipmentProblemState {
    None = 'None',
    Created = 'Created',
    Resolved = 'Resolved'
}

/**
 * 
 * @export
 * @interface SLAMStateDetailsOutputDTO
 */
export interface SLAMStateDetailsOutputDTO {
    /**
     * 
     * @type {SalesOrderSLAMState}
     * @memberof SLAMStateDetailsOutputDTO
     */
    state?: SalesOrderSLAMState;
    /**
     * 
     * @type {string}
     * @memberof SLAMStateDetailsOutputDTO
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SLAMStateDetailsOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SLAMStateDetailsOutputDTO
     */
    suspendedInThisState?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SLAMStateDetailsOutputDTO
     */
    doneByFullName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SLAMStateDetailsOutputDTO
     */
    isCargoCodeUpdated?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SLAMTag {
    Cancelled = 'Cancelled',
    None = 'None',
    Flat = 'Flat',
    LessThanMinWeight = 'LessThanMinWeight',
    WrongSize = 'WrongSize',
    LighterThanExpected = 'LighterThanExpected',
    HeavierThanExpected = 'HeavierThanExpected',
    Proper = 'Proper'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SLAMUnitErrorCode {
    None = 'None',
    C3 = 'C3',
    C4 = 'C4',
    C5 = 'C5',
    C6 = 'C6',
    C7 = 'C7'
}

/**
 * 
 * @export
 * @interface SafeWaitHandle
 */
export interface SafeWaitHandle {
    /**
     * 
     * @type {boolean}
     * @memberof SafeWaitHandle
     */
    isInvalid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafeWaitHandle
     */
    isClosed?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesChannel {
    Web = 'Web',
    Marketplace = 'Marketplace'
}

/**
 * 
 * @export
 * @interface SalesOrderAddCustomVASInputDTO
 */
export interface SalesOrderAddCustomVASInputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderAddCustomVASInputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderAddCustomVASInputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {Array<SalesOrderCustomVASInputDTO>}
     * @memberof SalesOrderAddCustomVASInputDTO
     */
    salesOrderCustomVAS?: Array<SalesOrderCustomVASInputDTO>;
}
/**
 * 
 * @export
 * @interface SalesOrderAddressInputDTO
 */
export interface SalesOrderAddressInputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderAddressInputDTO
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderAddressInputDTO
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderAddressInputDTO
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderAddressInputDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderAddressInputDTO
     */
    firstLine?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderAddressInputDTO
     */
    secondLine?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderAddressInputDTO
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderAddressInputDTO
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderAddressInputDTO
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderAddressInputDTO
     */
    country?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesOrderCancelledState {
    None = 'None',
    Cancelled = 'Cancelled'
}

/**
 * 
 * @export
 * @interface SalesOrderCargoPackageLabelDTO
 */
export interface SalesOrderCargoPackageLabelDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderCargoPackageLabelDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderCargoPackageLabelDTO
     */
    cargoPackageLabel?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderCargoPackageTypesOutputDTO
 */
export interface SalesOrderCargoPackageTypesOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderCargoPackageTypesOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderCargoPackageTypesOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderCargoPackageTypesOutputDTO
     */
    cargoPackageTypeOperation?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderCargoPackageTypesOutputDTO
     */
    cargoPackageTypeName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderCargoPackageTypesOutputDTO
     */
    cargoPackageTypeBarcode?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderCargoPackageTypesOutputDTODynamicQueryOutputDTO
 */
export interface SalesOrderCargoPackageTypesOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<SalesOrderCargoPackageTypesOutputDTO>}
     * @memberof SalesOrderCargoPackageTypesOutputDTODynamicQueryOutputDTO
     */
    data?: Array<SalesOrderCargoPackageTypesOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderCargoPackageTypesOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesOrderCreatedState {
    None = 'None',
    OutOfStock = 'OutOfStock',
    Created = 'Created',
    AssignedToManualBatch = 'AssignedToManualBatch',
    AssignedToBatchPicking = 'AssignedToBatchPicking',
    Staged = 'Staged'
}

/**
 * 
 * @export
 * @interface SalesOrderCustomVASInputDTO
 */
export interface SalesOrderCustomVASInputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderCustomVASInputDTO
     */
    customVASName?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesOrderDeliveredState {
    None = 'None',
    Delivered = 'Delivered'
}

/**
 * 
 * @export
 * @interface SalesOrderDetailDTO
 */
export interface SalesOrderDetailDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    pickingCompletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    packingCompletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    dispatchCompletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    deliveredAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    cancelledAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    invoiceTaxIncludedSalePrice?: string;
    /**
     * 
     * @type {Currency}
     * @memberof SalesOrderDetailDTO
     */
    invoiceTaxIncludedSalePriceCurrency?: Currency;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    invoiceInvoiceUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    recipientFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    contactInfoPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    contactInfoEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    detailsFullAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    detailsPostalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    detailsProvince?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    detailsCity?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    detailsCountry?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    carrierId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    packageQuantity?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    totalVolumetricWeight?: string;
    /**
     * 
     * @type {ShippingMethod}
     * @memberof SalesOrderDetailDTO
     */
    shippingMethod?: ShippingMethod;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderDetailDTO
     */
    paymentReceiptTotalAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    returnDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    carrierName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    salesChannel?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof SalesOrderDetailDTO
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof SalesOrderDetailDTO
     */
    paymentPaymentMethod?: PaymentMethod;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    b2BRoadRunnerInvoiceCustomerId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    b2CRoadRunnerInvoiceCustomerId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    roadRunnerInvoiceId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetailDTO
     */
    roadRunnerInvoiceCustomerId?: string;
    /**
     * 
     * @type {Array<ProductDTO>}
     * @memberof SalesOrderDetailDTO
     */
    products?: Array<ProductDTO>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesOrderDispatchStateSteps {
    None = 'None',
    Completed = 'Completed',
    Failed = 'Failed',
    Cancelled = 'Cancelled',
    OutOfStock = 'OutOfStock'
}

/**
 * 
 * @export
 * @interface SalesOrderEIrsaliyeInputDTO
 */
export interface SalesOrderEIrsaliyeInputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderEIrsaliyeInputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderEIrsaliyeInputDTO
     */
    ettn?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderEIrsaliyeInputDTO
     */
    tip?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderEIrsaliyeInputDTO
     */
    senaryo?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderEIrsaliyeInputDTO
     */
    tasiyiciVKN?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderEIrsaliyeInputDTO
     */
    vknTckn?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderEIrsaliyeInputDTO
     */
    aVknTckn?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderEIrsaliyeInputDTO
     */
    plaka?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderForManualDeliveryDetailDTO
 */
export interface SalesOrderForManualDeliveryDetailDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderForManualDeliveryDetailDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderForManualDeliveryDetailDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderForRegularDeliveryDetailDTO
 */
export interface SalesOrderForRegularDeliveryDetailDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderForRegularDeliveryDetailDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderForRegularDeliveryDetailDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderForSameDayDeliveryDetailDTO
 */
export interface SalesOrderForSameDayDeliveryDetailDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderForSameDayDeliveryDetailDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderForSameDayDeliveryDetailDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderInventoryItemCombineOutputDTO
 */
export interface SalesOrderInventoryItemCombineOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderInventoryItemCombineOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderInventoryItemCombineOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderInventoryItemCombineOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderInventoryItemCombineOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {InventoryItemType}
     * @memberof SalesOrderInventoryItemCombineOutputDTO
     */
    itemType?: InventoryItemType;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderInventoryItemCombineOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderInventoryItemCombineOutputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface SalesOrderItemsToCombineOutputDTO
 */
export interface SalesOrderItemsToCombineOutputDTO {
    /**
     * 
     * @type {SalesOrderState}
     * @memberof SalesOrderItemsToCombineOutputDTO
     */
    salesOrderState?: SalesOrderState;
    /**
     * 
     * @type {Array<SalesOrderLineItemCombineOutputDTO>}
     * @memberof SalesOrderItemsToCombineOutputDTO
     */
    lineItems?: Array<SalesOrderLineItemCombineOutputDTO>;
    /**
     * 
     * @type {Array<SalesOrderInventoryItemCombineOutputDTO>}
     * @memberof SalesOrderItemsToCombineOutputDTO
     */
    inventoryItems?: Array<SalesOrderInventoryItemCombineOutputDTO>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesOrderItemsToCombineOutputDTO
     */
    hardAllocatedItemPickLists?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SalesOrderItemsToCombineOutputDTO
     */
    hasMissingItem?: boolean;
}
/**
 * 
 * @export
 * @interface SalesOrderLineItemCombineOutputDTO
 */
export interface SalesOrderLineItemCombineOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemCombineOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderLineItemCombineOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemCombineOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemCombineOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemCombineOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemCombineOutputDTO
     */
    barcodes?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderLineItemInputDTO
 */
export interface SalesOrderLineItemInputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemInputDTO
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderLineItemInputDTO
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderLineItemInputDTO
     */
    taxIncludedSalePricePerProductAmount?: number;
    /**
     * 
     * @type {Currency}
     * @memberof SalesOrderLineItemInputDTO
     */
    taxIncludedSalePricePerProductCurrency?: Currency;
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesOrderLineItemInputDTO
     */
    serialNumbers?: Array<string>;
    /**
     * 
     * @type {Array<LotNumberInputDTO>}
     * @memberof SalesOrderLineItemInputDTO
     */
    lotNumbers?: Array<LotNumberInputDTO>;
}
/**
 * 
 * @export
 * @interface SalesOrderLineItemOutputDTO
 */
export interface SalesOrderLineItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderLineItemOutputDTO
     */
    amountInOrder?: number;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {ReturnLineItemState}
     * @memberof SalesOrderLineItemOutputDTO
     */
    returnState?: ReturnLineItemState;
    /**
     * 
     * @type {boolean}
     * @memberof SalesOrderLineItemOutputDTO
     */
    isCreatedWithSerialNumber?: boolean;
    /**
     * 
     * @type {ProductTagsOutputDTO}
     * @memberof SalesOrderLineItemOutputDTO
     */
    productTags?: ProductTagsOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderLineItemOutputDTO
     */
    weightInGrams?: number;
}
/**
 * 
 * @export
 * @interface SalesOrderLineItemQueryOutputDTO
 */
export interface SalesOrderLineItemQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemQueryOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemQueryOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderLineItemQueryOutputDTO
     */
    amountInOrder?: number;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemQueryOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLineItemQueryOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesOrderLineItemQueryOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderLineItemQueryOutputDTO
     */
    missingItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderLineItemQueryOutputDTO
     */
    outOfStockMissingItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderLineItemQueryOutputDTO
     */
    waitingForPutAwayProductCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderLineItemQueryOutputDTO
     */
    waitingForFeedingProductCount?: number;
}
/**
 * 
 * @export
 * @interface SalesOrderLineItemQueryOutputDTODynamicQueryOutputDTO
 */
export interface SalesOrderLineItemQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<SalesOrderLineItemQueryOutputDTO>}
     * @memberof SalesOrderLineItemQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<SalesOrderLineItemQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderLineItemQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface SalesOrderLostItemOutputDTO
 */
export interface SalesOrderLostItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLostItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLostItemOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLostItemOutputDTO
     */
    lostItemCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLostItemOutputDTO
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderLostItemOutputDTO
     */
    productSKU?: string;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderLostItemOutputDTO
     */
    lostItemAmount?: number;
}
/**
 * 
 * @export
 * @interface SalesOrderNotesQueryOutputDTO
 */
export interface SalesOrderNotesQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderNotesQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderNotesQueryOutputDTO
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderNotesQueryOutputDTO
     */
    createdDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderNotesQueryOutputDTO
     */
    updatedDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderNotesQueryOutputDTO
     */
    userFullName?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderNpsInputDTO
 */
export interface SalesOrderNpsInputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderNpsInputDTO
     */
    qrCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderNpsInputDTO
     */
    salesOrderId?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderOperationOutputDTO
 */
export interface SalesOrderOperationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderOperationOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderOperationOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderOperationOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderOperationOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderOperationOutputDTO
     */
    operationImageURL?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesOrderOutputCreatedStateEnum {
    None = 'None',
    OutOfStock = 'OutOfStock',
    Created = 'Created',
    Staged = 'Staged',
    AddedToTrolley = 'AddedToTrolley',
    WaitingForPutAway = 'WaitingForPutAway',
    WaitingForFeeding = 'WaitingForFeeding',
    AssignedToManualBatch = 'AssignedToManualBatch',
    AssignedToBatchPicking = 'AssignedToBatchPicking'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesOrderOutputDeliveredState {
    None = 'None',
    Delivered = 'Delivered',
    ManuallyDelivered = 'ManuallyDelivered'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesOrderOutputDispatchState {
    None = 'None',
    ManualDeliverySalesOrderDispatchNotStarted = 'ManualDeliverySalesOrderDispatchNotStarted',
    Started = 'Started',
    ManualDeliverySalesOrderStarted = 'ManualDeliverySalesOrderStarted',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @interface SalesOrderPackingLoadSeedPayload
 */
export interface SalesOrderPackingLoadSeedPayload {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderPackingLoadSeedPayload
     */
    referenceNumberPrefix?: string;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderPackingLoadSeedPayload
     */
    cargoPackageAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderPackingLoadSeedPayload
     */
    amountInOrder?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderPackingLoadSeedPayload
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderPackingLoadSeedPayload
     */
    productCount?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesOrderPackingState {
    None = 'None',
    Started = 'Started',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @interface SalesOrderPickingLoadSeedPayload
 */
export interface SalesOrderPickingLoadSeedPayload {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderPickingLoadSeedPayload
     */
    referenceNumberPrefix?: string;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof SalesOrderPickingLoadSeedPayload
     */
    pickingFlow?: PickingFlowTag;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderPickingLoadSeedPayload
     */
    vehicleVariation?: string;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderPickingLoadSeedPayload
     */
    amountInOrder?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderPickingLoadSeedPayload
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderPickingLoadSeedPayload
     */
    cargoPackageAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderPickingLoadSeedPayload
     */
    productCount?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesOrderPickingPriority {
    None = 'None',
    Priority1 = 'Priority1',
    Priority2 = 'Priority2',
    Priority3 = 'Priority3'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesOrderPickingState {
    None = 'None',
    Started = 'Started',
    CompletedWithLostItems = 'CompletedWithLostItems',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @interface SalesOrderPrioritizationFailedOutputDTO
 */
export interface SalesOrderPrioritizationFailedOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderPrioritizationFailedOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderPrioritizationFailedOutputDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderProblemDetailsOutputDTO
 */
export interface SalesOrderProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderProblemDetailsOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderProblemDetailsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderProblemDetailsOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderProblemDetailsOutputDTO
     */
    carrierName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderProblemDetailsOutputDTO
     */
    carrierImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderProblemDetailsOutputDTO
     */
    cargoPackageCount?: number;
    /**
     * 
     * @type {ShippingMethod}
     * @memberof SalesOrderProblemDetailsOutputDTO
     */
    shippingMethod?: ShippingMethod;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderProblemDetailsOutputDTO
     */
    waitingResolutionProblemsCount?: number;
}
/**
 * 
 * @export
 * @interface SalesOrderProblemOutputDTO
 */
export interface SalesOrderProblemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderProblemOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderProblemOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {ProblemType}
     * @memberof SalesOrderProblemOutputDTO
     */
    type?: ProblemType;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderProblemOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderProblemOutputDTO
     */
    source?: string;
    /**
     * 
     * @type {ProblemState}
     * @memberof SalesOrderProblemOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderProblemOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderProblemOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderProblemOutputDTO
     */
    resolutionNote?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderProblemOutputDTODynamicQueryOutputDTO
 */
export interface SalesOrderProblemOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<SalesOrderProblemOutputDTO>}
     * @memberof SalesOrderProblemOutputDTODynamicQueryOutputDTO
     */
    data?: Array<SalesOrderProblemOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderProblemOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface SalesOrderProblemsOutputDTO
 */
export interface SalesOrderProblemsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderProblemsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderProblemsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderProblemsOutputDTO
     */
    problemType?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderQueryOutputDTO
 */
export interface SalesOrderQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderQueryOutputDTO
     */
    createdDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderQueryOutputDTO
     */
    updatedDate?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof SalesOrderQueryOutputDTO
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderQueryOutputDTO
     */
    returnDate?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderQueryOutputDTODynamicQueryOutputDTO
 */
export interface SalesOrderQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<SalesOrderQueryOutputDTO>}
     * @memberof SalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<SalesOrderQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface SalesOrderReturnPackageLineItemOutputDTO
 */
export interface SalesOrderReturnPackageLineItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderReturnPackageLineItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderReturnPackageLineItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderReturnPackageLineItemOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {ReturnPackageLineItemState}
     * @memberof SalesOrderReturnPackageLineItemOutputDTO
     */
    state?: ReturnPackageLineItemState;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderReturnPackageLineItemOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderReturnPackageLineItemOutputDTO
     */
    barcodes?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderReturnPackageOutputDTO
 */
export interface SalesOrderReturnPackageOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderReturnPackageOutputDTO
     */
    trackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderReturnPackageOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {ReturnPackageState}
     * @memberof SalesOrderReturnPackageOutputDTO
     */
    state?: ReturnPackageState;
    /**
     * 
     * @type {Array<SalesOrderReturnPackageLineItemOutputDTO>}
     * @memberof SalesOrderReturnPackageOutputDTO
     */
    lineItems?: Array<SalesOrderReturnPackageLineItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface SalesOrderSLAMLoadSeedPayload
 */
export interface SalesOrderSLAMLoadSeedPayload {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderSLAMLoadSeedPayload
     */
    referenceNumberPrefix?: string;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderSLAMLoadSeedPayload
     */
    cargoPackageAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderSLAMLoadSeedPayload
     */
    amountInOrder?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderSLAMLoadSeedPayload
     */
    amount?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesOrderSLAMState {
    None = 'None',
    Started = 'Started',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @interface SalesOrderSerialNumberTrackingOutputDTO
 */
export interface SalesOrderSerialNumberTrackingOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderSerialNumberTrackingOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderSerialNumberTrackingOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderSerialNumberTrackingOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderSerialNumberTrackingOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderSerialNumberTrackingOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderSerialNumberTrackingOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderSerialNumberTrackingOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof SalesOrderSerialNumberTrackingOutputDTO
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderSerialNumberTrackingOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderSerialNumberTrackingOutputDTO
     */
    serialNumbers?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SalesOrderSerialNumberTrackingOutputDTO
     */
    isTrackSerialNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalesOrderSerialNumberTrackingOutputDTO
     */
    isTrackSimpleSerialNumber?: boolean;
}
/**
 * 
 * @export
 * @interface SalesOrderSerialNumberTrackingOutputDTODynamicQueryOutputDTO
 */
export interface SalesOrderSerialNumberTrackingOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<SalesOrderSerialNumberTrackingOutputDTO>}
     * @memberof SalesOrderSerialNumberTrackingOutputDTODynamicQueryOutputDTO
     */
    data?: Array<SalesOrderSerialNumberTrackingOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderSerialNumberTrackingOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface SalesOrderShipmentDetailsOutputDTO
 */
export interface SalesOrderShipmentDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShipmentDetailsOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShipmentDetailsOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SalesOrderShipmentDetailsOutputDTO
     */
    isForManualDelivery?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShipmentDetailsOutputDTO
     */
    carrierName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShipmentDetailsOutputDTO
     */
    trackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShipmentDetailsOutputDTO
     */
    carrierImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShipmentDetailsOutputDTO
     */
    suspentionErrorMessage?: string;
    /**
     * 
     * @type {ShippingMethod}
     * @memberof SalesOrderShipmentDetailsOutputDTO
     */
    shippingMethod?: ShippingMethod;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShipmentDetailsOutputDTO
     */
    marketPlaceName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShipmentDetailsOutputDTO
     */
    cargoCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShipmentDetailsOutputDTO
     */
    cargoDocumentUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShipmentDetailsOutputDTO
     */
    shipmentTrackingLinkUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShipmentDetailsOutputDTO
     */
    manualDeliveryRecipientFullname?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShipmentDetailsOutputDTO
     */
    manualDeliveryRecipientCompanyName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShipmentDetailsOutputDTO
     */
    manualDeliveryLicensePlate?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderShippingMethodInputDTO
 */
export interface SalesOrderShippingMethodInputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShippingMethodInputDTO
     */
    shippingMethodName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShippingMethodInputDTO
     */
    preferredCargoCarrier?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShippingMethodInputDTO
     */
    cargoCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShippingMethodInputDTO
     */
    cargoDocument?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShippingMethodInputDTO
     */
    codPaymentMethod?: string;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderShippingMethodInputDTO
     */
    codReceiptTotalAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShippingMethodInputDTO
     */
    codReceiptTotalCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderShippingMethodInputDTO
     */
    marketPlaceName?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesOrderSortingState {
    None = 'None',
    Started = 'Started',
    CompletedWithLostItems = 'CompletedWithLostItems',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesOrderState {
    Cancelled = 'Cancelled',
    None = 'None',
    Created = 'Created',
    Picking = 'Picking',
    Sorting = 'Sorting',
    Packing = 'Packing',
    Slam = 'SLAM',
    Dispatch = 'Dispatch',
    Delivered = 'Delivered'
}

/**
 * 
 * @export
 * @interface SalesOrderStateDetailsOutputDTO
 */
export interface SalesOrderStateDetailsOutputDTO {
    /**
     * 
     * @type {SalesOrderStateOperationEnum}
     * @memberof SalesOrderStateDetailsOutputDTO
     */
    operation?: SalesOrderStateOperationEnum;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderStateDetailsOutputDTO
     */
    doneBy?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderStateDetailsOutputDTO
     */
    doneAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderStateDetailsOutputDTO
     */
    doneAtAddress?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderStateDetailsOutputDTODynamicQueryOutputDTO
 */
export interface SalesOrderStateDetailsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<SalesOrderStateDetailsOutputDTO>}
     * @memberof SalesOrderStateDetailsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<SalesOrderStateDetailsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderStateDetailsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesOrderStateForPacking {
    Cancelled = 'Cancelled',
    None = 'None',
    Completed = 'Completed',
    CompletedWithLostItems = 'CompletedWithLostItems'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesOrderStateOperationEnum {
    None = 'None',
    Picking = 'Picking',
    Packing = 'Packing',
    Slam = 'SLAM',
    Dispatch = 'Dispatch'
}

/**
 * 
 * @export
 * @interface SalesOrderStateOutputDTO
 */
export interface SalesOrderStateOutputDTO {
    /**
     * 
     * @type {SalesOrderStateForPacking}
     * @memberof SalesOrderStateOutputDTO
     */
    state?: SalesOrderStateForPacking;
    /**
     * 
     * @type {boolean}
     * @memberof SalesOrderStateOutputDTO
     */
    missingPackingApproved?: boolean;
}
/**
 * 
 * @export
 * @interface SalesOrderToBeTransferredInfoDTO
 */
export interface SalesOrderToBeTransferredInfoDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderToBeTransferredInfoDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderToBeTransferredInfoDTO
     */
    cargoPackagesCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderToBeTransferredInfoDTO
     */
    currentCount?: number;
}
/**
 * 
 * @export
 * @interface SalesOrderVASInputDTO
 */
export interface SalesOrderVASInputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderVASInputDTO
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderVASInputDTO
     */
    documentURL?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderVASInputDTO
     */
    giftMessage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SalesOrderVASInputDTO
     */
    giftWrapNeeded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderVASInputDTO
     */
    packageNote?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderVasOutputDTO
 */
export interface SalesOrderVasOutputDTO {
    /**
     * 
     * @type {VASType}
     * @memberof SalesOrderVasOutputDTO
     */
    vasType?: VASType;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderVasOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderVasOutputDTO
     */
    content?: string;
    /**
     * 
     * @type {VASState}
     * @memberof SalesOrderVasOutputDTO
     */
    state?: VASState;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderVasOutputDTO
     */
    operatorName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderVasOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderVasOutputDTO
     */
    completedAtAddress?: string;
}
/**
 * 
 * @export
 * @interface SalesOrderVasOutputDTODynamicQueryOutputDTO
 */
export interface SalesOrderVasOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<SalesOrderVasOutputDTO>}
     * @memberof SalesOrderVasOutputDTODynamicQueryOutputDTO
     */
    data?: Array<SalesOrderVasOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderVasOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesOrderWithMissingItemState {
    None = 'None',
    Completed = 'Completed',
    CompletedWithLostItems = 'CompletedWithLostItems',
    Cancelled = 'Cancelled'
}

/**
 * 
 * @export
 * @interface SalesOrderWithMissingItemStateOutputDTO
 */
export interface SalesOrderWithMissingItemStateOutputDTO {
    /**
     * 
     * @type {SalesOrderWithMissingItemState}
     * @memberof SalesOrderWithMissingItemStateOutputDTO
     */
    state?: SalesOrderWithMissingItemState;
}
/**
 * 
 * @export
 * @interface SalesOrdersHoldingZoneAddressesOutputDTO
 */
export interface SalesOrdersHoldingZoneAddressesOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersHoldingZoneAddressesOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersHoldingZoneAddressesOutputDTO
     */
    address?: string;
}
/**
 * 
 * @export
 * @interface SalesOrdersODataDTOODataQueryOptions
 */
export interface SalesOrdersODataDTOODataQueryOptions {
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersODataDTOODataQueryOptions
     */
    ifMatch?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersODataDTOODataQueryOptions
     */
    ifNoneMatch?: string;
    /**
     * 
     * @type {HttpRequest}
     * @memberof SalesOrdersODataDTOODataQueryOptions
     */
    request?: HttpRequest;
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof SalesOrdersODataDTOODataQueryOptions
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {ODataRawQueryOptions}
     * @memberof SalesOrdersODataDTOODataQueryOptions
     */
    rawValues?: ODataRawQueryOptions;
    /**
     * 
     * @type {SelectExpandQueryOption}
     * @memberof SalesOrdersODataDTOODataQueryOptions
     */
    selectExpand?: SelectExpandQueryOption;
    /**
     * 
     * @type {ApplyQueryOption}
     * @memberof SalesOrdersODataDTOODataQueryOptions
     */
    apply?: ApplyQueryOption;
    /**
     * 
     * @type {ComputeQueryOption}
     * @memberof SalesOrdersODataDTOODataQueryOptions
     */
    compute?: ComputeQueryOption;
    /**
     * 
     * @type {FilterQueryOption}
     * @memberof SalesOrdersODataDTOODataQueryOptions
     */
    filter?: FilterQueryOption;
    /**
     * 
     * @type {SearchQueryOption}
     * @memberof SalesOrdersODataDTOODataQueryOptions
     */
    search?: SearchQueryOption;
    /**
     * 
     * @type {OrderByQueryOption}
     * @memberof SalesOrdersODataDTOODataQueryOptions
     */
    orderBy?: OrderByQueryOption;
    /**
     * 
     * @type {SkipQueryOption}
     * @memberof SalesOrdersODataDTOODataQueryOptions
     */
    skip?: SkipQueryOption;
    /**
     * 
     * @type {SkipTokenQueryOption}
     * @memberof SalesOrdersODataDTOODataQueryOptions
     */
    skipToken?: SkipTokenQueryOption;
    /**
     * 
     * @type {TopQueryOption}
     * @memberof SalesOrdersODataDTOODataQueryOptions
     */
    top?: TopQueryOption;
    /**
     * 
     * @type {CountQueryOption}
     * @memberof SalesOrdersODataDTOODataQueryOptions
     */
    count?: CountQueryOption;
    /**
     * 
     * @type {object}
     * @memberof SalesOrdersODataDTOODataQueryOptions
     */
    validator?: object;
}
/**
 * 
 * @export
 * @interface SalesOrdersOperationCountOutputDTO
 */
export interface SalesOrdersOperationCountOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof SalesOrdersOperationCountOutputDTO
     */
    createdSalesOrdersOperationCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrdersOperationCountOutputDTO
     */
    pickingSalesOrdersOperationCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrdersOperationCountOutputDTO
     */
    packingSalesOrdersOperationCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrdersOperationCountOutputDTO
     */
    sortingSalesOrdersOperationCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrdersOperationCountOutputDTO
     */
    slamSalesOrdersOperationCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrdersOperationCountOutputDTO
     */
    dispatchedSalesOrdersOperationCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrdersOperationCountOutputDTO
     */
    cancelledSalesOrdersOperationCount?: number;
}
/**
 * 
 * @export
 * @interface SalesOrdersOperationQueryOutputDTO
 */
export interface SalesOrdersOperationQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersOperationQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersOperationQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersOperationQueryOutputDTO
     */
    createdDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersOperationQueryOutputDTO
     */
    updatedDate?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof SalesOrdersOperationQueryOutputDTO
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersOperationQueryOutputDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface SalesOrdersOperationQueryOutputDTODynamicQueryOutputDTO
 */
export interface SalesOrdersOperationQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<SalesOrdersOperationQueryOutputDTO>}
     * @memberof SalesOrdersOperationQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<SalesOrdersOperationQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof SalesOrdersOperationQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface SalesOrdersResultOutputDTO
 */
export interface SalesOrdersResultOutputDTO {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SalesOrdersResultOutputDTO
     */
    failures?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesOrdersResultOutputDTO
     */
    successful?: Array<string>;
}
/**
 * 
 * @export
 * @interface SalesOrdersSearchOutputDTO
 */
export interface SalesOrdersSearchOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersSearchOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersSearchOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersSearchOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {ReturnSource}
     * @memberof SalesOrdersSearchOutputDTO
     */
    returnSource?: ReturnSource;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersSearchOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersSearchOutputDTO
     */
    orderId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersSearchOutputDTO
     */
    orderCreatedAt?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof SalesOrdersSearchOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {Array<ReturnSalesOrderLineItemOutputDTO>}
     * @memberof SalesOrdersSearchOutputDTO
     */
    lineItems?: Array<ReturnSalesOrderLineItemOutputDTO>;
    /**
     * 
     * @type {PersonInfoOutputDTO}
     * @memberof SalesOrdersSearchOutputDTO
     */
    customer?: PersonInfoOutputDTO;
    /**
     * 
     * @type {PersonInfoOutputDTO}
     * @memberof SalesOrdersSearchOutputDTO
     */
    recipient?: PersonInfoOutputDTO;
    /**
     * 
     * @type {ContactInfoOutputDTO}
     * @memberof SalesOrdersSearchOutputDTO
     */
    contactInfo?: ContactInfoOutputDTO;
    /**
     * 
     * @type {ShipmentAddressDetailsOutputDTO}
     * @memberof SalesOrdersSearchOutputDTO
     */
    details?: ShipmentAddressDetailsOutputDTO;
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesOrdersSearchOutputDTO
     */
    cargoPackageLabels?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesOrdersSearchOutputDTO
     */
    serialNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface SalesOrdersSearchOutputDTODynamicQueryOutputDTO
 */
export interface SalesOrdersSearchOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<SalesOrdersSearchOutputDTO>}
     * @memberof SalesOrdersSearchOutputDTODynamicQueryOutputDTO
     */
    data?: Array<SalesOrdersSearchOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof SalesOrdersSearchOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface SalesOrdersStateDetailsOutputDTO
 */
export interface SalesOrdersStateDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    pickingToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    targetCutOffDateTime?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    isCutOff?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    targetDispatchDateTime?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    isWaitingFeeding?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    isSuspended?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    isSendingAsMissing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    isForManualDelivery?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    suspendedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    dispatchDocumentImageUrl?: string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {SalesOrderPickingPriority}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    priority?: SalesOrderPickingPriority;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    marketPlaceName?: string;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    pickingFlowTag?: PickingFlowTag;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    vehicleVariation?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {CreatedStateDetailsOutputDTO}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    created?: CreatedStateDetailsOutputDTO;
    /**
     * 
     * @type {PickingStateDetailsOutputDTO}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    picking?: PickingStateDetailsOutputDTO;
    /**
     * 
     * @type {SortingStateDetailsOutputDTO}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    sorting?: SortingStateDetailsOutputDTO;
    /**
     * 
     * @type {PackingStateDetailsOutputDTO}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    packing?: PackingStateDetailsOutputDTO;
    /**
     * 
     * @type {SLAMStateDetailsOutputDTO}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    slam?: SLAMStateDetailsOutputDTO;
    /**
     * 
     * @type {ShippedStateDetailsOutputDTO}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    dispatch?: ShippedStateDetailsOutputDTO;
    /**
     * 
     * @type {DeliveredStateDetailsOutputDTO}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    delivered?: DeliveredStateDetailsOutputDTO;
    /**
     * 
     * @type {CancelledStateDetailsOutputDTO}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    cancelled?: CancelledStateDetailsOutputDTO;
    /**
     * 
     * @type {boolean}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    batchPicked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SalesOrdersStateDetailsOutputDTO
     */
    invoiceUrl?: string;
}
/**
 * 
 * @export
 * @interface SaveGridFilterPresetInputDTO
 */
export interface SaveGridFilterPresetInputDTO {
    /**
     * 
     * @type {string}
     * @memberof SaveGridFilterPresetInputDTO
     */
    gridKey?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveGridFilterPresetInputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveGridFilterPresetInputDTO
     */
    filtersJson?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveGridFilterPresetInputDTO
     */
    sortJson?: string;
}
/**
 * 
 * @export
 * @interface ScannedProductDetailsOutputDTO
 */
export interface ScannedProductDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ScannedProductDetailsOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof ScannedProductDetailsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ScannedProductDetailsOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof ScannedProductDetailsOutputDTO
     */
    productImageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof ScannedProductDetailsOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof ScannedProductDetailsOutputDTO
     */
    width?: MeasurementDTO;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof ScannedProductDetailsOutputDTO
     */
    length?: MeasurementDTO;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof ScannedProductDetailsOutputDTO
     */
    height?: MeasurementDTO;
    /**
     * 
     * @type {MeasurementDTO}
     * @memberof ScannedProductDetailsOutputDTO
     */
    weight?: MeasurementDTO;
    /**
     * 
     * @type {boolean}
     * @memberof ScannedProductDetailsOutputDTO
     */
    isHeavy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ScannedProductDetailsOutputDTO
     */
    isOversized?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ScannedProductDetailsOutputDTO
     */
    isMasterCarton?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ScannedProductDetailsOutputDTO
     */
    masterCartonItemAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof ScannedProductDetailsOutputDTO
     */
    masterCartonBarcode?: string;
}
/**
 * 
 * @export
 * @interface SearchClause
 */
export interface SearchClause {
    /**
     * 
     * @type {SingleValueNode}
     * @memberof SearchClause
     */
    expression?: SingleValueNode;
}
/**
 * 
 * @export
 * @interface SearchQueryOption
 */
export interface SearchQueryOption {
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof SearchQueryOption
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {string}
     * @memberof SearchQueryOption
     */
    resultClrType?: string;
    /**
     * 
     * @type {SearchClause}
     * @memberof SearchQueryOption
     */
    searchClause?: SearchClause;
    /**
     * 
     * @type {string}
     * @memberof SearchQueryOption
     */
    rawValue?: string;
}
/**
 * 
 * @export
 * @interface SearchUserByFullNameOutputDTO
 */
export interface SearchUserByFullNameOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SearchUserByFullNameOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUserByFullNameOutputDTO
     */
    fullName?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SeedServiceTypes {
    None = 'None',
    Carrier = 'Carrier',
    CompletedPurchaseOrder = 'CompletedPurchaseOrder',
    Customer = 'Customer',
    DeliveredSalesOrders = 'DeliveredSalesOrders',
    Dispatch = 'Dispatch',
    EmptyWarehouse = 'EmptyWarehouse',
    History = 'History',
    InProgressPurchaseOrders = 'InProgressPurchaseOrders',
    Integrations = 'Integrations',
    InventoryQuery = 'InventoryQuery',
    Operations = 'Operations',
    PackingInitial = 'PackingInitial',
    PackingQuarantine = 'PackingQuarantine',
    PickingInitial = 'PickingInitial',
    PickingLostItem = 'PickingLostItem',
    PickingSingleItem = 'PickingSingleItem',
    PickingSingleLostItem = 'PickingSingleLostItem',
    PickingSingleOrder = 'PickingSingleOrder',
    Print = 'Print',
    Products = 'Products',
    PurchaseOrders = 'PurchaseOrders',
    PutAwayInitial = 'PutAwayInitial',
    PutAwayOngoing = 'PutAwayOngoing',
    PutAwayOnHold = 'PutAwayOnHold',
    QuarantineManagement = 'QuarantineManagement',
    QueryManagement = 'QueryManagement',
    ReceivingToteSelection = 'ReceivingToteSelection',
    ReturnQuery = 'ReturnQuery',
    SalesOrderInventoryItem = 'SalesOrderInventoryItem',
    SalesOrdersQuery = 'SalesOrdersQuery',
    Tenants = 'Tenants',
    TransferPackageToTote = 'TransferPackageToTote',
    TransferQuarantineToValid = 'TransferQuarantineToValid',
    Transfer = 'Transfer',
    TransferStockToQuarantine = 'TransferStockToQuarantine',
    Waybills = 'Waybills',
    PackedSalesOrders = 'PackedSalesOrders',
    DispatchCompleted = 'DispatchCompleted',
    DispatchQuery = 'DispatchQuery',
    StockItems = 'StockItems',
    DispatchHistory = 'DispatchHistory',
    PickingSelectionVariation = 'PickingSelectionVariation',
    PickingInProgress = 'PickingInProgress',
    PackingInProgress = 'PackingInProgress',
    PickingProcessOnGoing = 'PickingProcessOnGoing',
    CreateShipment = 'CreateShipment',
    DispatchPazaryeriWeb = 'DispatchPazaryeriWeb',
    SalesOrderProblemCount = 'SalesOrderProblemCount',
    SalesOrderDetailProblemQuery = 'SalesOrderDetailProblemQuery',
    Problem = 'Problem',
    CargoCarrierQuotaProblem = 'CargoCarrierQuotaProblem',
    CargoCarrierPreferenceProblem = 'CargoCarrierPreferenceProblem',
    MarketplaceCargoCarrierQuotaProblem = 'MarketplaceCargoCarrierQuotaProblem',
    PickingMultiLostItem = 'PickingMultiLostItem',
    Zone = 'Zone',
    PickingZoneStagingInitial = 'PickingZoneStagingInitial',
    MultipleZoneInventoryQuery = 'MultipleZoneInventoryQuery',
    MultiZonePickingQuery = 'MultiZonePickingQuery',
    PickingSRoute = 'PickingSRoute',
    PackingInitialWithVasSalesOrders = 'PackingInitialWithVASSalesOrders',
    PickingLostItemBackwardLookup = 'PickingLostItemBackwardLookup',
    PickingLostItemSRoute = 'PickingLostItemSRoute',
    InboundProblemsQuery = 'InboundProblemsQuery',
    QueryCellStockCountingTasks = 'QueryCellStockCountingTasks',
    LostItemProblems = 'LostItemProblems',
    PickingForStockCountingProcess = 'PickingForStockCountingProcess',
    PackingSingleOrder = 'PackingSingleOrder',
    DispatchCargoQueuedPazaryeriWeb = 'DispatchCargoQueuedPazaryeriWeb',
    ManuallyDispatchSalesOrders = 'ManuallyDispatchSalesOrders',
    LostItemPickingProcess = 'LostItemPickingProcess',
    Dimensioner = 'Dimensioner',
    Printers = 'Printers',
    ProductStockCounting = 'ProductStockCounting',
    SlamonPacking = 'SLAMOnPacking',
    PickListJobHardAllocation = 'PickListJobHardAllocation',
    PickListHov = 'PickListHOV',
    PickListJobResolveOutOfStock = 'PickListJobResolveOutOfStock',
    PickListJobOutOfStock = 'PickListJobOutOfStock',
    PickListJobCapacityOverflow = 'PickListJobCapacityOverflow',
    PickListJobMultiItemVariation = 'PickListJobMultiItemVariation',
    PickListJobMultiItemZoneAllocation = 'PickListJobMultiItemZoneAllocation',
    PickListJobIncompletedList = 'PickListJobIncompletedList',
    PickListJobResolveLostItemProblem = 'PickListJobResolveLostItemProblem',
    PickListJobSoftAllocatedItemExchange = 'PickListJobSoftAllocatedItemExchange',
    PickListJobStockItemExchange = 'PickListJobStockItemExchange',
    PickListLostItemAlternative = 'PickListLostItemAlternative',
    PickLists = 'PickLists',
    PickingSingleOrderSingleItem = 'PickingSingleOrderSingleItem',
    OutOfStockAwaitingReceiving = 'OutOfStockAwaitingReceiving',
    LostItemPickingInitial = 'LostItemPickingInitial',
    QueryProductContainer = 'QueryProductContainer',
    PurchaseOrdersQuery = 'PurchaseOrdersQuery',
    StockCountingLists = 'StockCountingLists',
    SingleItemReceiving = 'SingleItemReceiving',
    TransferToteTrolley = 'TransferToteTrolley',
    TransferTrolleyManagement = 'TransferTrolleyManagement',
    PickListJobMissingMultiItemVariation = 'PickListJobMissingMultiItemVariation',
    PickListJobMissingHovVariation = 'PickListJobMissingHOVVariation',
    PickListJobMissingOversizeVariation = 'PickListJobMissingOversizeVariation',
    PickListJobMissingHeavyVariation = 'PickListJobMissingHeavyVariation',
    MissingItemTransfer = 'MissingItemTransfer',
    PickListVariation = 'PickListVariation',
    PickListJobSingleItemVariation = 'PickListJobSingleItemVariation',
    PickListSingleItem = 'PickListSingleItem',
    SingleItemPackingInitial = 'SingleItemPackingInitial',
    MissingItemTransferCompleted = 'MissingItemTransferCompleted',
    MissingItemTransferOnPacking = 'MissingItemTransferOnPacking',
    SingleItemPickingInProgress = 'SingleItemPickingInProgress',
    PackedBigSalesOrder = 'PackedBigSalesOrder',
    StockCountingPlanQuery = 'StockCountingPlanQuery',
    StockCountingTasks = 'StockCountingTasks',
    ProductStockCountingInitial = 'ProductStockCountingInitial',
    CellTotalStockCountingInitial = 'CellTotalStockCountingInitial',
    CellStockCountingInitial = 'CellStockCountingInitial',
    StockCountingInitial = 'StockCountingInitial',
    StockCountingManagement = 'StockCountingManagement',
    DuplicateCellStockCountingInitial = 'DuplicateCellStockCountingInitial',
    DuplicateCellTotalStockCountingInitial = 'DuplicateCellTotalStockCountingInitial',
    DuplicateProductStockCountingInitial = 'DuplicateProductStockCountingInitial',
    MultiZoneStockCountingListJob = 'MultiZoneStockCountingListJob',
    WebReceiving = 'WebReceiving',
    StockCountingPlanListSRoute = 'StockCountingPlanListSRoute',
    StockCountingTaskListSRoute = 'StockCountingTaskListSRoute',
    OngoingSingleItemPackingProcess = 'OngoingSingleItemPackingProcess',
    TransferPackingItemsToTote = 'TransferPackingItemsToTote',
    LostItemReviewedProblem = 'LostItemReviewedProblem',
    ManualDeliveryQuery = 'ManualDeliveryQuery',
    PickingRestowInitial = 'PickingRestowInitial',
    StockAndRestowItems = 'StockAndRestowItems',
    PickListJobExpirationDate = 'PickListJobExpirationDate',
    QualityStockCountingJob = 'QualityStockCountingJob',
    PickListJobSalesOrderInDifferentTargetDispatchTime = 'PickListJobSalesOrderInDifferentTargetDispatchTime',
    QualityStockCountingQuery = 'QualityStockCountingQuery',
    InventoryWithExpirationDateQuery = 'InventoryWithExpirationDateQuery',
    PickingInProgressForLoadTest = 'PickingInProgressForLoadTest',
    InboundBoxReceivingRecordsQuery = 'InboundBoxReceivingRecordsQuery',
    DefaultPrintResources = 'DefaultPrintResources',
    PackingInitialBigSalesOrder = 'PackingInitialBigSalesOrder',
    PickListJobMultiBarcodeMultiItemVariation = 'PickListJobMultiBarcodeMultiItemVariation',
    LightStockItems = 'LightStockItems',
    HovPackingInitial = 'HOVPackingInitial',
    PickListHovStagingRule = 'PickListHOVStagingRule',
    SerialNumberPackingInitial = 'SerialNumberPackingInitial',
    SerialNumberHovPackingInitial = 'SerialNumberHOVPackingInitial',
    SerialNumberProductReceivingInitial = 'SerialNumberProductReceivingInitial',
    MissingItemTransferWithSerialNumbers = 'MissingItemTransferWithSerialNumbers',
    PickListJobWithSerialNumber = 'PickListJobWithSerialNumber',
    SerialNumberProductPutAwayOnGoing = 'SerialNumberProductPutAwayOnGoing',
    PickListJobSerialNumber = 'PickListJobSerialNumber',
    ReturnWithSerialNumberQuery = 'ReturnWithSerialNumberQuery',
    PackingInitialWithCustomCargoPackageLabel = 'PackingInitialWithCustomCargoPackageLabel',
    PickingSRouteSkuGrouped = 'PickingSRouteSKUGrouped',
    MissingItemTransferInitial = 'MissingItemTransferInitial',
    PickListJobLowToHighAllocation = 'PickListJobLowToHighAllocation',
    PackingInitialWithSimpleSerialNumberTracking = 'PackingInitialWithSimpleSerialNumberTracking',
    PickListToteSelective = 'PickListToteSelective',
    SalesOrderBatches = 'SalesOrderBatches',
    SalesOrderMultipleZones = 'SalesOrderMultipleZones',
    PalletReceiving = 'PalletReceiving',
    PalletPutAway = 'PalletPutAway',
    InventoryItemConcurrency = 'InventoryItemConcurrency',
    SiocSingleItemPackingInitial = 'SIOCSingleItemPackingInitial',
    SiocPickingSingleItem = 'SIOCPickingSingleItem',
    WranglingTote = 'WranglingTote',
    RebinStation = 'RebinStation',
    BatchPickLists = 'BatchPickLists',
    BatchPickListJob = 'BatchPickListJob',
    WallToWallStockCountingInitial = 'WallToWallStockCountingInitial',
    WallToWallStockCountingTracking = 'WallToWallStockCountingTracking',
    BatchPickListJobCell = 'BatchPickListJobCell',
    SimplePickLists = 'SimplePickLists',
    SimplePacking = 'SimplePacking',
    SalesOrdersWithMissingItems = 'SalesOrdersWithMissingItems',
    MissingItemSPicking = 'MissingItemSPicking',
    BatchPickListsWithRas = 'BatchPickListsWithRAS',
    SalesOrderAllocationsJob = 'SalesOrderAllocationsJob',
    OutOfStockSalesOrderJob = 'OutOfStockSalesOrderJob',
    PackingInitialWithNpsVasSalesOrders = 'PackingInitialWithNpsVASSalesOrders',
    RasStow = 'RasStow',
    BatchPickListsWithRasSimulator = 'BatchPickListsWithRASSimulator',
    StockCellTypes = 'StockCellTypes',
    SalesOrderTransfer = 'SalesOrderTransfer',
    DimensionClassification = 'DimensionClassification',
    HovBigPacking = 'HOVBigPacking',
    ManualDeliverySalesOrders = 'ManualDeliverySalesOrders',
    ManualPickListSalesOrders = 'ManualPickListSalesOrders',
    TrolleyToteDetailed = 'TrolleyToteDetailed',
    HovBigPackingSingleCargoPackage = 'HOVBigPackingSingleCargoPackage',
    TransferStockItemsToRestow = 'TransferStockItemsToRestow',
    CellSuggestedPutAway = 'CellSuggestedPutAway',
    ToteTransfer = 'ToteTransfer',
    ProblematicTotes = 'ProblematicTotes',
    QuarantineWallAwaitingRestow = 'QuarantineWallAwaitingRestow',
    QuarantineWallPackable = 'QuarantineWallPackable',
    SingleItemFastPackPickingInProgress = 'SingleItemFastPackPickingInProgress',
    PickListSingleItemFastPack = 'PickListSingleItemFastPack',
    MasterCartonPickingInitial = 'MasterCartonPickingInitial',
    MasterCartonHovPackingInitial = 'MasterCartonHOVPackingInitial',
    WaybillStationInitial = 'WaybillStationInitial',
    MasterCartonMultiItemPickingInitial = 'MasterCartonMultiItemPickingInitial',
    MasterCartonMultiItemPackingInitial = 'MasterCartonMultiItemPackingInitial',
    ReplenishmentTest = 'ReplenishmentTest',
    RasManualPickListSupportTest = 'RasManualPickListSupportTest'
}

/**
 * 
 * @export
 * @interface SelectAllItemsForTransferToQuarantineCommand
 */
export interface SelectAllItemsForTransferToQuarantineCommand {
    /**
     * 
     * @type {string}
     * @memberof SelectAllItemsForTransferToQuarantineCommand
     */
    sourceCellLabel?: string;
}
/**
 * 
 * @export
 * @interface SelectAllItemsForTransferToQuarantineDTO
 */
export interface SelectAllItemsForTransferToQuarantineDTO {
    /**
     * 
     * @type {number}
     * @memberof SelectAllItemsForTransferToQuarantineDTO
     */
    transferableItemAmount?: number;
    /**
     * 
     * @type {Array<TransferItemOutputDTO>}
     * @memberof SelectAllItemsForTransferToQuarantineDTO
     */
    nonTransferableItems?: Array<TransferItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface SelectContainerForReceivingCommand
 */
export interface SelectContainerForReceivingCommand {
    /**
     * 
     * @type {string}
     * @memberof SelectContainerForReceivingCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectContainerForReceivingCommand
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectContainerForReceivingCommand
     */
    inboundAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface SelectExpandClause
 */
export interface SelectExpandClause {
    /**
     * 
     * @type {Array<object>}
     * @memberof SelectExpandClause
     */
    selectedItems?: Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof SelectExpandClause
     */
    allSelected?: boolean;
}
/**
 * 
 * @export
 * @interface SelectExpandQueryOption
 */
export interface SelectExpandQueryOption {
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof SelectExpandQueryOption
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {string}
     * @memberof SelectExpandQueryOption
     */
    rawSelect?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectExpandQueryOption
     */
    rawExpand?: string;
    /**
     * 
     * @type {ComputeQueryOption}
     * @memberof SelectExpandQueryOption
     */
    compute?: ComputeQueryOption;
    /**
     * 
     * @type {object}
     * @memberof SelectExpandQueryOption
     */
    validator?: object;
    /**
     * 
     * @type {SelectExpandClause}
     * @memberof SelectExpandQueryOption
     */
    selectExpandClause?: SelectExpandClause;
    /**
     * 
     * @type {number}
     * @memberof SelectExpandQueryOption
     */
    levelsMaxLiteralExpansionDepth?: number;
}
/**
 * 
 * @export
 * @interface SelectPalletToPutAwayCommand
 */
export interface SelectPalletToPutAwayCommand {
    /**
     * 
     * @type {string}
     * @memberof SelectPalletToPutAwayCommand
     */
    putAwayId?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectPalletToPutAwayCommand
     */
    palletLabel?: string;
}
/**
 * 
 * @export
 * @interface SelectQuarantineToteForWebReceivingCommand
 */
export interface SelectQuarantineToteForWebReceivingCommand {
    /**
     * 
     * @type {string}
     * @memberof SelectQuarantineToteForWebReceivingCommand
     */
    webReceivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectQuarantineToteForWebReceivingCommand
     */
    quarantineToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectQuarantineToteForWebReceivingCommand
     */
    receivingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface SelectReceivingToteForWebReceivingCommand
 */
export interface SelectReceivingToteForWebReceivingCommand {
    /**
     * 
     * @type {string}
     * @memberof SelectReceivingToteForWebReceivingCommand
     */
    webReceivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectReceivingToteForWebReceivingCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectReceivingToteForWebReceivingCommand
     */
    receivingAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface SelectSalesOrderForReturnCommand
 */
export interface SelectSalesOrderForReturnCommand {
    /**
     * 
     * @type {string}
     * @memberof SelectSalesOrderForReturnCommand
     */
    returnProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectSalesOrderForReturnCommand
     */
    salesOrderId?: string;
}
/**
 * 
 * @export
 * @interface SelectSalesOrderForReturnOutputDTO
 */
export interface SelectSalesOrderForReturnOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SelectSalesOrderForReturnOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectSalesOrderForReturnOutputDTO
     */
    returnPackageId?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectSalesOrderForReturnOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {ReturnProcessState}
     * @memberof SelectSalesOrderForReturnOutputDTO
     */
    state?: ReturnProcessState;
}
/**
 * 
 * @export
 * @interface SelectSorterExitDataOutputDTO
 */
export interface SelectSorterExitDataOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SelectSorterExitDataOutputDTO
     */
    roller?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectSorterExitDataOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectSorterExitDataOutputDTO
     */
    cargoPackageLabel?: string;
}
/**
 * 
 * @export
 * @interface SelectSorterExitInputDTO
 */
export interface SelectSorterExitInputDTO {
    /**
     * 
     * @type {string}
     * @memberof SelectSorterExitInputDTO
     */
    barcode?: string;
}
/**
 * 
 * @export
 * @interface SelectSorterExitOutputDTO
 */
export interface SelectSorterExitOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof SelectSorterExitOutputDTO
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof SelectSorterExitOutputDTO
     */
    msg?: string;
    /**
     * 
     * @type {SelectSorterExitDataOutputDTO}
     * @memberof SelectSorterExitOutputDTO
     */
    data?: SelectSorterExitDataOutputDTO;
}
/**
 * 
 * @export
 * @interface SelectToteForMeasurementCommand
 */
export interface SelectToteForMeasurementCommand {
    /**
     * 
     * @type {string}
     * @memberof SelectToteForMeasurementCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectToteForMeasurementCommand
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectToteForMeasurementCommand
     */
    inboundAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface SelectToteForQuarantineCommand
 */
export interface SelectToteForQuarantineCommand {
    /**
     * 
     * @type {string}
     * @memberof SelectToteForQuarantineCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectToteForQuarantineCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectToteForQuarantineCommand
     */
    inboundAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface SelectToteForReturnProcessCommand
 */
export interface SelectToteForReturnProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof SelectToteForReturnProcessCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectToteForReturnProcessCommand
     */
    returnAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface SelectToteForReturnProcessOutputDTO
 */
export interface SelectToteForReturnProcessOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof SelectToteForReturnProcessOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof SelectToteForReturnProcessOutputDTO
     */
    addressId?: number;
    /**
     * 
     * @type {string}
     * @memberof SelectToteForReturnProcessOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {ContainedItemsType}
     * @memberof SelectToteForReturnProcessOutputDTO
     */
    containedItemsType?: ContainedItemsType;
}
/**
 * 
 * @export
 * @interface SetCellFullCommand
 */
export interface SetCellFullCommand {
    /**
     * 
     * @type {number}
     * @memberof SetCellFullCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof SetCellFullCommand
     */
    putAwayToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SetCellFullCommand
     */
    containerLabel?: string;
}
/**
 * 
 * @export
 * @interface SetContainerIsFullCommand
 */
export interface SetContainerIsFullCommand {
    /**
     * 
     * @type {string}
     * @memberof SetContainerIsFullCommand
     */
    containerLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SetContainerIsFullCommand
     */
    isFull?: boolean;
}
/**
 * 
 * @export
 * @interface SetDispatchDocumentImageCommand
 */
export interface SetDispatchDocumentImageCommand {
    /**
     * 
     * @type {number}
     * @memberof SetDispatchDocumentImageCommand
     */
    dispatchProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof SetDispatchDocumentImageCommand
     */
    documentImageUrl?: string;
}
/**
 * 
 * @export
 * @interface SetExpirationDateForSellableItemsInputDTO
 */
export interface SetExpirationDateForSellableItemsInputDTO {
    /**
     * 
     * @type {string}
     * @memberof SetExpirationDateForSellableItemsInputDTO
     */
    operation?: string;
    /**
     * 
     * @type {string}
     * @memberof SetExpirationDateForSellableItemsInputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof SetExpirationDateForSellableItemsInputDTO
     */
    expirationTime?: string;
}
/**
 * 
 * @export
 * @interface SetIsNpsActiveDTO
 */
export interface SetIsNpsActiveDTO {
    /**
     * 
     * @type {boolean}
     * @memberof SetIsNpsActiveDTO
     */
    setIsActiveValue?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SetIsNpsActiveDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface SetPickingTrolleySelectionConfigurationStatusCommand
 */
export interface SetPickingTrolleySelectionConfigurationStatusCommand {
    /**
     * 
     * @type {string}
     * @memberof SetPickingTrolleySelectionConfigurationStatusCommand
     */
    pickingTrolleySelectionConfigurationId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SetPickingTrolleySelectionConfigurationStatusCommand
     */
    isEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface SetProductsControlCountingCommand
 */
export interface SetProductsControlCountingCommand {
    /**
     * 
     * @type {number}
     * @memberof SetProductsControlCountingCommand
     */
    pickingProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof SetProductsControlCountingCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SetProductsControlCountingCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {Array<ControlCountingResultItemInputDTO>}
     * @memberof SetProductsControlCountingCommand
     */
    items?: Array<ControlCountingResultItemInputDTO>;
}
/**
 * 
 * @export
 * @interface SetProductsControlCountingForHOVPickingCommand
 */
export interface SetProductsControlCountingForHOVPickingCommand {
    /**
     * 
     * @type {number}
     * @memberof SetProductsControlCountingForHOVPickingCommand
     */
    pickingProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof SetProductsControlCountingForHOVPickingCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SetProductsControlCountingForHOVPickingCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {Array<ControlCountingResultItemInputDTO>}
     * @memberof SetProductsControlCountingForHOVPickingCommand
     */
    items?: Array<ControlCountingResultItemInputDTO>;
}
/**
 * 
 * @export
 * @interface SetSalesOrderPriorityCommand
 */
export interface SetSalesOrderPriorityCommand {
    /**
     * 
     * @type {string}
     * @memberof SetSalesOrderPriorityCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SetSalesOrderPriorityCommand
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface SetSalesOrdersForManualDeliveryCommand
 */
export interface SetSalesOrdersForManualDeliveryCommand {
    /**
     * 
     * @type {string}
     * @memberof SetSalesOrdersForManualDeliveryCommand
     */
    operationName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SetSalesOrdersForManualDeliveryCommand
     */
    salesOrderReferenceNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface SetSalesOrdersForManualDeliveryOutputDTO
 */
export interface SetSalesOrdersForManualDeliveryOutputDTO {
    /**
     * 
     * @type {Array<SalesOrderForManualDeliveryDetailDTO>}
     * @memberof SetSalesOrdersForManualDeliveryOutputDTO
     */
    notFoundSalesOrders?: Array<SalesOrderForManualDeliveryDetailDTO>;
    /**
     * 
     * @type {Array<SalesOrderForManualDeliveryDetailDTO>}
     * @memberof SetSalesOrdersForManualDeliveryOutputDTO
     */
    successFulSalesOrders?: Array<SalesOrderForManualDeliveryDetailDTO>;
    /**
     * 
     * @type {Array<SalesOrderForManualDeliveryDetailDTO>}
     * @memberof SetSalesOrdersForManualDeliveryOutputDTO
     */
    failedSalesOrders?: Array<SalesOrderForManualDeliveryDetailDTO>;
}
/**
 * 
 * @export
 * @interface SetSalesOrdersForRegularDeliveryCommand
 */
export interface SetSalesOrdersForRegularDeliveryCommand {
    /**
     * 
     * @type {string}
     * @memberof SetSalesOrdersForRegularDeliveryCommand
     */
    operationName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SetSalesOrdersForRegularDeliveryCommand
     */
    salesOrderReferenceNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface SetSalesOrdersForRegularDeliveryOutputDTO
 */
export interface SetSalesOrdersForRegularDeliveryOutputDTO {
    /**
     * 
     * @type {Array<SalesOrderForRegularDeliveryDetailDTO>}
     * @memberof SetSalesOrdersForRegularDeliveryOutputDTO
     */
    notFoundSalesOrders?: Array<SalesOrderForRegularDeliveryDetailDTO>;
    /**
     * 
     * @type {Array<SalesOrderForRegularDeliveryDetailDTO>}
     * @memberof SetSalesOrdersForRegularDeliveryOutputDTO
     */
    successFulSalesOrders?: Array<SalesOrderForRegularDeliveryDetailDTO>;
    /**
     * 
     * @type {Array<SalesOrderForRegularDeliveryDetailDTO>}
     * @memberof SetSalesOrdersForRegularDeliveryOutputDTO
     */
    failedSalesOrders?: Array<SalesOrderForRegularDeliveryDetailDTO>;
}
/**
 * 
 * @export
 * @interface SetSalesOrdersForSameDayDeliveryCommand
 */
export interface SetSalesOrdersForSameDayDeliveryCommand {
    /**
     * 
     * @type {string}
     * @memberof SetSalesOrdersForSameDayDeliveryCommand
     */
    operationName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SetSalesOrdersForSameDayDeliveryCommand
     */
    salesOrderReferenceNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface SetSalesOrdersForSameDayDeliveryOutputDTO
 */
export interface SetSalesOrdersForSameDayDeliveryOutputDTO {
    /**
     * 
     * @type {Array<SalesOrderForSameDayDeliveryDetailDTO>}
     * @memberof SetSalesOrdersForSameDayDeliveryOutputDTO
     */
    notFoundSalesOrders?: Array<SalesOrderForSameDayDeliveryDetailDTO>;
    /**
     * 
     * @type {Array<SalesOrderForSameDayDeliveryDetailDTO>}
     * @memberof SetSalesOrdersForSameDayDeliveryOutputDTO
     */
    successFulSalesOrders?: Array<SalesOrderForSameDayDeliveryDetailDTO>;
    /**
     * 
     * @type {Array<SalesOrderForSameDayDeliveryDetailDTO>}
     * @memberof SetSalesOrdersForSameDayDeliveryOutputDTO
     */
    failedSalesOrders?: Array<SalesOrderForSameDayDeliveryDetailDTO>;
}
/**
 * 
 * @export
 * @interface SetStockCountingListConfigurationStatusCommand
 */
export interface SetStockCountingListConfigurationStatusCommand {
    /**
     * 
     * @type {boolean}
     * @memberof SetStockCountingListConfigurationStatusCommand
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SetStockCountingListConfigurationStatusCommand
     */
    stockCountingListConfigurationId?: string;
}
/**
 * 
 * @export
 * @interface SetTargetDispatchTimeForSalesOrderDTO
 */
export interface SetTargetDispatchTimeForSalesOrderDTO {
    /**
     * 
     * @type {string}
     * @memberof SetTargetDispatchTimeForSalesOrderDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SetTargetDispatchTimeForSalesOrderDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface SetTargetDispatchTimeForSalesOrdersCommand
 */
export interface SetTargetDispatchTimeForSalesOrdersCommand {
    /**
     * 
     * @type {string}
     * @memberof SetTargetDispatchTimeForSalesOrdersCommand
     */
    operationName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SetTargetDispatchTimeForSalesOrdersCommand
     */
    salesOrderReferenceNumbers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SetTargetDispatchTimeForSalesOrdersCommand
     */
    newTargetDispatchDateTime?: string;
}
/**
 * 
 * @export
 * @interface SetTargetDispatchTimeForSalesOrdersOutputDTO
 */
export interface SetTargetDispatchTimeForSalesOrdersOutputDTO {
    /**
     * 
     * @type {Array<SetTargetDispatchTimeForSalesOrderDTO>}
     * @memberof SetTargetDispatchTimeForSalesOrdersOutputDTO
     */
    notFoundSalesOrders?: Array<SetTargetDispatchTimeForSalesOrderDTO>;
    /**
     * 
     * @type {Array<SetTargetDispatchTimeForSalesOrderDTO>}
     * @memberof SetTargetDispatchTimeForSalesOrdersOutputDTO
     */
    successFulSalesOrders?: Array<SetTargetDispatchTimeForSalesOrderDTO>;
    /**
     * 
     * @type {Array<SetTargetDispatchTimeForSalesOrderDTO>}
     * @memberof SetTargetDispatchTimeForSalesOrdersOutputDTO
     */
    failedSalesOrders?: Array<SetTargetDispatchTimeForSalesOrderDTO>;
}
/**
 * 
 * @export
 * @interface SetToteUnavailableForControlCountingCommand
 */
export interface SetToteUnavailableForControlCountingCommand {
    /**
     * 
     * @type {string}
     * @memberof SetToteUnavailableForControlCountingCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface ShipmentAddressDetailsOutputDTO
 */
export interface ShipmentAddressDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ShipmentAddressDetailsOutputDTO
     */
    firstLine?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentAddressDetailsOutputDTO
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentAddressDetailsOutputDTO
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentAddressDetailsOutputDTO
     */
    secondLine?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentAddressDetailsOutputDTO
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentAddressDetailsOutputDTO
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentAddressDetailsOutputDTO
     */
    company?: string;
}
/**
 * 
 * @export
 * @interface ShippedStateDetailsOutputDTO
 */
export interface ShippedStateDetailsOutputDTO {
    /**
     * 
     * @type {SalesOrderOutputDispatchState}
     * @memberof ShippedStateDetailsOutputDTO
     */
    state?: SalesOrderOutputDispatchState;
    /**
     * 
     * @type {string}
     * @memberof ShippedStateDetailsOutputDTO
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippedStateDetailsOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShippedStateDetailsOutputDTO
     */
    suspendedInThisState?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShippedStateDetailsOutputDTO
     */
    doneByFullName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShippedStateDetailsOutputDTO
     */
    isCargoCodeUpdated?: boolean;
}
/**
 * 
 * @export
 * @interface ShippingByProductQueryOutputDTO
 */
export interface ShippingByProductQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ShippingByProductQueryOutputDTO
     */
    cargoPackageLabel?: string;
    /**
     * 
     * @type {PackageType}
     * @memberof ShippingByProductQueryOutputDTO
     */
    cargoPackageType?: PackageType;
    /**
     * 
     * @type {number}
     * @memberof ShippingByProductQueryOutputDTO
     */
    cargoPackageVolumetricWeight?: number;
    /**
     * 
     * @type {string}
     * @memberof ShippingByProductQueryOutputDTO
     */
    cargoPackageBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingByProductQueryOutputDTO
     */
    cargoPackageName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingByProductQueryOutputDTO
     */
    isDelivered?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShippingByProductQueryOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ShippingByProductQueryOutputDTO
     */
    expirationDate?: string;
}
/**
 * 
 * @export
 * @interface ShippingByProductQueryOutputDTODynamicQueryOutputDTO
 */
export interface ShippingByProductQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ShippingByProductQueryOutputDTO>}
     * @memberof ShippingByProductQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ShippingByProductQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ShippingByProductQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ShippingFlowTag {
    Domestic = 'Domestic',
    ExternalDomestic = 'ExternalDomestic',
    International = 'International'
}

/**
 * 
 * @export
 * @interface ShippingItemCountOutputDTO
 */
export interface ShippingItemCountOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof ShippingItemCountOutputDTO
     */
    totalCount?: number;
}
/**
 * 
 * @export
 * @interface ShippingItemExpirationDateAndSerialNoTrackingOutputDTO
 */
export interface ShippingItemExpirationDateAndSerialNoTrackingOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ShippingItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {number}
     * @memberof ShippingItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemExpirationDateAndSerialNoTrackingOutputDTO
     */
    serialNumber?: string;
}
/**
 * 
 * @export
 * @interface ShippingItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO
 */
export interface ShippingItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ShippingItemExpirationDateAndSerialNoTrackingOutputDTO>}
     * @memberof ShippingItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ShippingItemExpirationDateAndSerialNoTrackingOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ShippingItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ShippingItemGetByCargoPackageLabelGroupByDTO
 */
export interface ShippingItemGetByCargoPackageLabelGroupByDTO {
    /**
     * 
     * @type {string}
     * @memberof ShippingItemGetByCargoPackageLabelGroupByDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemGetByCargoPackageLabelGroupByDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemGetByCargoPackageLabelGroupByDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemGetByCargoPackageLabelGroupByDTO
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemGetByCargoPackageLabelGroupByDTO
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemGetByCargoPackageLabelGroupByDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemGetByCargoPackageLabelGroupByDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemGetByCargoPackageLabelGroupByDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemGetByCargoPackageLabelGroupByDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingItemGetByCargoPackageLabelGroupByDTO
     */
    isDelivered?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShippingItemGetByCargoPackageLabelGroupByDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemGetByCargoPackageLabelGroupByDTO
     */
    expirationDate?: string;
}
/**
 * 
 * @export
 * @interface ShippingItemOutputDTO
 */
export interface ShippingItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ShippingItemOutputDTO
     */
    cargoPackageLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {number}
     * @memberof ShippingItemOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof ShippingItemOutputDTO
     */
    productType?: ProductType;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemOutputDTO
     */
    expirationDate?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShippingItemOutputDTO
     */
    serialNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface ShippingItemOutputDTODynamicQueryOutputDTO
 */
export interface ShippingItemOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ShippingItemOutputDTO>}
     * @memberof ShippingItemOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ShippingItemOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ShippingItemOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ShippingItemTransferOutputDTO
 */
export interface ShippingItemTransferOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof ShippingItemTransferOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemTransferOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemTransferOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShippingItemTransferOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ShippingItemTransferOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingItemTransferOutputDTO
     */
    isTrackSerialNumber?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ShippingMethod {
    None = 'None',
    SenderPays = 'SenderPays',
    ExternalContract = 'ExternalContract',
    CoD = 'CoD'
}

/**
 * 
 * @export
 * @interface SimplePackingItemOutputDTO
 */
export interface SimplePackingItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SimplePackingItemOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof SimplePackingItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof SimplePackingItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof SimplePackingItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof SimplePackingItemOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof SimplePackingItemOutputDTO
     */
    serialNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof SimplePackingItemOutputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface SimplePackingProcessOutputDTO
 */
export interface SimplePackingProcessOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof SimplePackingProcessOutputDTO
     */
    canCloseCargoPackagesAtPacking?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SimplePackingProcessOutputDTO
     */
    packingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof SimplePackingProcessOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof SimplePackingProcessOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof SimplePackingProcessOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {ShippingFlowTag}
     * @memberof SimplePackingProcessOutputDTO
     */
    shippingFlow?: ShippingFlowTag;
    /**
     * 
     * @type {boolean}
     * @memberof SimplePackingProcessOutputDTO
     */
    isEligibleForSLAMPrint?: boolean;
    /**
     * 
     * @type {Array<SalesOrderLineItemOutputDTO>}
     * @memberof SimplePackingProcessOutputDTO
     */
    salesOrderLineItems?: Array<SalesOrderLineItemOutputDTO>;
    /**
     * 
     * @type {Array<PickingItemByProductOutputDTO>}
     * @memberof SimplePackingProcessOutputDTO
     */
    pickingItems?: Array<PickingItemByProductOutputDTO>;
    /**
     * 
     * @type {Array<VASOutputDTO>}
     * @memberof SimplePackingProcessOutputDTO
     */
    vas?: Array<VASOutputDTO>;
    /**
     * 
     * @type {Array<QueuedCargoPackageOutputDTO>}
     * @memberof SimplePackingProcessOutputDTO
     */
    cargoPackages?: Array<QueuedCargoPackageOutputDTO>;
    /**
     * 
     * @type {Array<ProcessedVASItemsOutputDTO>}
     * @memberof SimplePackingProcessOutputDTO
     */
    processedVASItems?: Array<ProcessedVASItemsOutputDTO>;
    /**
     * 
     * @type {Array<CargoPackageTypeOutputDTO>}
     * @memberof SimplePackingProcessOutputDTO
     */
    operationCargoPackageTypes?: Array<CargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {Array<CargoPackageTypeOutputDTO>}
     * @memberof SimplePackingProcessOutputDTO
     */
    oplogCargoPackageTypes?: Array<CargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {Array<OwnContainerCargoPackageTypeOutputDTO>}
     * @memberof SimplePackingProcessOutputDTO
     */
    ownContainerCargoPackageTypes?: Array<OwnContainerCargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {string}
     * @memberof SimplePackingProcessOutputDTO
     */
    failedMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof SimplePackingProcessOutputDTO
     */
    stackTrace?: string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof SimplePackingProcessOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof SimplePackingProcessOutputDTO
     */
    marketPlaceName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SimplePackingProcessOutputDTO
     */
    isPrintable?: boolean;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof SimplePackingProcessOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
}
/**
 * 
 * @export
 * @interface SimplePackingQueueItem
 */
export interface SimplePackingQueueItem {
    /**
     * 
     * @type {string}
     * @memberof SimplePackingQueueItem
     */
    productId?: string;
    /**
     * 
     * @type {number}
     * @memberof SimplePackingQueueItem
     */
    amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimplePackingQueueItem
     */
    serialNumbers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimplePackingQueueItem
     */
    simpleSerialNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface SimplePackingTotesReadyToPackOutputDTO
 */
export interface SimplePackingTotesReadyToPackOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SimplePackingTotesReadyToPackOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {Array<SimplePackingItemOutputDTO>}
     * @memberof SimplePackingTotesReadyToPackOutputDTO
     */
    items?: Array<SimplePackingItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface SimplePickingOutputDTO
 */
export interface SimplePickingOutputDTO {
    /**
     * 
     * @type {RouteOutputDTO}
     * @memberof SimplePickingOutputDTO
     */
    route?: RouteOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof SimplePickingOutputDTO
     */
    expectedCurrentItemAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SimplePickingOutputDTO
     */
    isCurrentItemCountEntryAllowed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SimplePickingOutputDTO
     */
    currentToteContainedItemsCount?: number;
}
/**
 * 
 * @export
 * @interface SingleItemCheckProductBarcodeOutputDTO
 */
export interface SingleItemCheckProductBarcodeOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof SingleItemCheckProductBarcodeOutputDTO
     */
    isSerialNumberTrackRequiredProduct?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SingleItemCheckProductBarcodeOutputDTO
     */
    isSimpleSerialNumberTrackRequiredProduct?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SingleItemCheckProductBarcodeOutputDTO
     */
    totePickingItemsSerialNumbers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SingleItemCheckProductBarcodeOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemCheckProductBarcodeOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemCheckProductBarcodeOutputDTO
     */
    productImageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemCheckProductBarcodeOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemCheckProductBarcodeOutputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {SingleItemProductTagsOutputDTO}
     * @memberof SingleItemCheckProductBarcodeOutputDTO
     */
    productTags?: SingleItemProductTagsOutputDTO;
}
/**
 * 
 * @export
 * @interface SingleItemFastPackPickingToteDetailsOutputDTO
 */
export interface SingleItemFastPackPickingToteDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SingleItemFastPackPickingToteDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof SingleItemFastPackPickingToteDetailsOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {SingleItemFastPackSalesOrderLineItemOutputDTO}
     * @memberof SingleItemFastPackPickingToteDetailsOutputDTO
     */
    singleItemFastPackSalesOrderLineItem?: SingleItemFastPackSalesOrderLineItemOutputDTO;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof SingleItemFastPackPickingToteDetailsOutputDTO
     */
    salesOrderState?: SalesOrderState;
    /**
     * 
     * @type {SalesOrderPackingState}
     * @memberof SingleItemFastPackPickingToteDetailsOutputDTO
     */
    salesOrderPackingState?: SalesOrderPackingState;
}
/**
 * 
 * @export
 * @interface SingleItemFastPackPickingToteDetailsOutputDTODynamicQueryOutputDTO
 */
export interface SingleItemFastPackPickingToteDetailsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<SingleItemFastPackPickingToteDetailsOutputDTO>}
     * @memberof SingleItemFastPackPickingToteDetailsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<SingleItemFastPackPickingToteDetailsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof SingleItemFastPackPickingToteDetailsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface SingleItemFastPackSalesOrderLineItemOutputDTO
 */
export interface SingleItemFastPackSalesOrderLineItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SingleItemFastPackSalesOrderLineItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemFastPackSalesOrderLineItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemFastPackSalesOrderLineItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemFastPackSalesOrderLineItemOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof SingleItemFastPackSalesOrderLineItemOutputDTO
     */
    amountInOrder?: number;
    /**
     * 
     * @type {string}
     * @memberof SingleItemFastPackSalesOrderLineItemOutputDTO
     */
    barcodes?: string;
}
/**
 * 
 * @export
 * @interface SingleItemFastPackSalesOrdersToteDetailsOutputDTO
 */
export interface SingleItemFastPackSalesOrdersToteDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SingleItemFastPackSalesOrdersToteDetailsOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemFastPackSalesOrdersToteDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof SingleItemFastPackSalesOrdersToteDetailsOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {SingleItemFastPackSalesOrderLineItemOutputDTO}
     * @memberof SingleItemFastPackSalesOrdersToteDetailsOutputDTO
     */
    singleItemFastPackSalesOrderLineItem?: SingleItemFastPackSalesOrderLineItemOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof SingleItemFastPackSalesOrdersToteDetailsOutputDTO
     */
    serialNumber?: string;
    /**
     * 
     * @type {SalesOrderPackingState}
     * @memberof SingleItemFastPackSalesOrdersToteDetailsOutputDTO
     */
    salesOrderPackingState?: SalesOrderPackingState;
}
/**
 * 
 * @export
 * @interface SingleItemFastPackSalesOrdersToteDetailsOutputDTODynamicQueryOutputDTO
 */
export interface SingleItemFastPackSalesOrdersToteDetailsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<SingleItemFastPackSalesOrdersToteDetailsOutputDTO>}
     * @memberof SingleItemFastPackSalesOrdersToteDetailsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<SingleItemFastPackSalesOrdersToteDetailsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof SingleItemFastPackSalesOrdersToteDetailsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface SingleItemPackingProcessSalesOrderProductOutputDTO
 */
export interface SingleItemPackingProcessSalesOrderProductOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    packingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    isEligibleForSLAMPrint?: boolean;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {Array<SalesOrderLineItemOutputDTO>}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    salesOrderLineItems?: Array<SalesOrderLineItemOutputDTO>;
    /**
     * 
     * @type {Array<VASOutputDTO>}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    vas?: Array<VASOutputDTO>;
    /**
     * 
     * @type {Array<CargoPackageTypeOutputDTO>}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    operationCargoPackageTypes?: Array<CargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {Array<CargoPackageTypeOutputDTO>}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    oplogCargoPackageTypes?: Array<CargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {Array<OwnContainerCargoPackageTypeOutputDTO>}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    ownContainerCargoPackageTypes?: Array<OwnContainerCargoPackageTypeOutputDTO>;
    /**
     * 
     * @type {ShippingFlowTag}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    shippingFlow?: ShippingFlowTag;
    /**
     * 
     * @type {SalesChannel}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    marketPlaceName?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    selectedCargoPackageTypeBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    defaultCargoPackageTypeBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    orderSerialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    simpleSerialNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    siocVolumetricWeight?: number;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof SingleItemPackingProcessSalesOrderProductOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
}
/**
 * 
 * @export
 * @interface SingleItemPickingToteDetailsOutputDTO
 */
export interface SingleItemPickingToteDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SingleItemPickingToteDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof SingleItemPickingToteDetailsOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {SingleItemSalesOrderLineItemOutputDTO}
     * @memberof SingleItemPickingToteDetailsOutputDTO
     */
    singleItemSalesOrderLineItem?: SingleItemSalesOrderLineItemOutputDTO;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof SingleItemPickingToteDetailsOutputDTO
     */
    salesOrderState?: SalesOrderState;
    /**
     * 
     * @type {SalesOrderPackingState}
     * @memberof SingleItemPickingToteDetailsOutputDTO
     */
    salesOrderPackingState?: SalesOrderPackingState;
}
/**
 * 
 * @export
 * @interface SingleItemPickingToteDetailsOutputDTODynamicQueryOutputDTO
 */
export interface SingleItemPickingToteDetailsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<SingleItemPickingToteDetailsOutputDTO>}
     * @memberof SingleItemPickingToteDetailsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<SingleItemPickingToteDetailsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof SingleItemPickingToteDetailsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface SingleItemProductTagsOutputDTO
 */
export interface SingleItemProductTagsOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof SingleItemProductTagsOutputDTO
     */
    isPourable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SingleItemProductTagsOutputDTO
     */
    isFragile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SingleItemProductTagsOutputDTO
     */
    isBattery?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SingleItemProductTagsOutputDTO
     */
    isFood?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SingleItemProductTagsOutputDTO
     */
    isChemical?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SingleItemProductTagsOutputDTO
     */
    isSharp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SingleItemProductTagsOutputDTO
     */
    isValuable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SingleItemProductTagsOutputDTO
     */
    isAdult?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SingleItemProductTagsOutputDTO
     */
    isQualityControlNeeded?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SingleItemReceivingBarcodeTypeEnum {
    Product = 'Product',
    ExpirationDateRequiredProduct = 'ExpirationDateRequiredProduct',
    SerialNumberRequiredProduct = 'SerialNumberRequiredProduct',
    ExpirationDateAndSerialNumberRequiredProduct = 'ExpirationDateAndSerialNumberRequiredProduct',
    Tote = 'Tote',
    MeasurementRequiredProduct = 'MeasurementRequiredProduct',
    MeasurementAndSerialNumberRequiredProduct = 'MeasurementAndSerialNumberRequiredProduct',
    MeasurementAndExpirationDateRequiredProduct = 'MeasurementAndExpirationDateRequiredProduct',
    ExpirationDateAndSerialNumberAndMeasurementRequiredProduct = 'ExpirationDateAndSerialNumberAndMeasurementRequiredProduct',
    LotNumberTrackingRequiredProduct = 'LotNumberTrackingRequiredProduct'
}

/**
 * 
 * @export
 * @interface SingleItemReceivingCreateProcessIfNotExistsCommand
 */
export interface SingleItemReceivingCreateProcessIfNotExistsCommand {
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingCreateProcessIfNotExistsCommand
     */
    inboundBoxLabel?: string;
}
/**
 * 
 * @export
 * @interface SingleItemReceivingCreateProcessOutputDTO
 */
export interface SingleItemReceivingCreateProcessOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingCreateProcessOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingCreateProcessOutputDTO
     */
    containerType?: string;
}
/**
 * 
 * @export
 * @interface SingleItemReceivingDamagedItemOutputDTO
 */
export interface SingleItemReceivingDamagedItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingDamagedItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingDamagedItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingDamagedItemOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingDamagedItemOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingDamagedItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof SingleItemReceivingDamagedItemOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {InboundProblemType}
     * @memberof SingleItemReceivingDamagedItemOutputDTO
     */
    problemType?: InboundProblemType;
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingDamagedItemOutputDTO
     */
    problemReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface SingleItemReceivingInboundBoxDetailsOutputDTO
 */
export interface SingleItemReceivingInboundBoxDetailsOutputDTO {
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof SingleItemReceivingInboundBoxDetailsOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingInboundBoxDetailsOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingInboundBoxDetailsOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingInboundBoxDetailsOutputDTO
     */
    expectedDeliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingInboundBoxDetailsOutputDTO
     */
    containerType?: string;
}
/**
 * 
 * @export
 * @interface SingleItemReceivingReceivedItemOutputDTO
 */
export interface SingleItemReceivingReceivedItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingReceivedItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingReceivedItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingReceivedItemOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingReceivedItemOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemReceivingReceivedItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof SingleItemReceivingReceivedItemOutputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface SingleItemReceivingTotalItemAmountOutputDTO
 */
export interface SingleItemReceivingTotalItemAmountOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof SingleItemReceivingTotalItemAmountOutputDTO
     */
    totalItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleItemReceivingTotalItemAmountOutputDTO
     */
    receivedItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleItemReceivingTotalItemAmountOutputDTO
     */
    damagedItemAmount?: number;
}
/**
 * 
 * @export
 * @interface SingleItemSalesOrderLineItemOutputDTO
 */
export interface SingleItemSalesOrderLineItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SingleItemSalesOrderLineItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemSalesOrderLineItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemSalesOrderLineItemOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemSalesOrderLineItemOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof SingleItemSalesOrderLineItemOutputDTO
     */
    amountInOrder?: number;
    /**
     * 
     * @type {string}
     * @memberof SingleItemSalesOrderLineItemOutputDTO
     */
    barcodes?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SingleItemSalesOrderState {
    None = 'None',
    PickingCompleted = 'PickingCompleted',
    Cancelled = 'Cancelled',
    ToteNotContainsThisProduct = 'ToteNotContainsThisProduct',
    SalesOrderStateNotSuitableForPacking = 'SalesOrderStateNotSuitableForPacking'
}

/**
 * 
 * @export
 * @interface SingleItemSalesOrderStateOutputDTO
 */
export interface SingleItemSalesOrderStateOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SingleItemSalesOrderStateOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {SingleItemSalesOrderState}
     * @memberof SingleItemSalesOrderStateOutputDTO
     */
    state?: SingleItemSalesOrderState;
    /**
     * 
     * @type {number}
     * @memberof SingleItemSalesOrderStateOutputDTO
     */
    toteRemainingItemsCount?: number;
}
/**
 * 
 * @export
 * @interface SingleItemSalesOrdersToteDetailsOutputDTO
 */
export interface SingleItemSalesOrdersToteDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SingleItemSalesOrdersToteDetailsOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemSalesOrdersToteDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof SingleItemSalesOrdersToteDetailsOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {SingleItemSalesOrderLineItemOutputDTO}
     * @memberof SingleItemSalesOrdersToteDetailsOutputDTO
     */
    singleItemSalesOrderLineItem?: SingleItemSalesOrderLineItemOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof SingleItemSalesOrdersToteDetailsOutputDTO
     */
    serialNumber?: string;
    /**
     * 
     * @type {SalesOrderPackingState}
     * @memberof SingleItemSalesOrdersToteDetailsOutputDTO
     */
    salesOrderPackingState?: SalesOrderPackingState;
}
/**
 * 
 * @export
 * @interface SingleItemSalesOrdersToteDetailsOutputDTODynamicQueryOutputDTO
 */
export interface SingleItemSalesOrdersToteDetailsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<SingleItemSalesOrdersToteDetailsOutputDTO>}
     * @memberof SingleItemSalesOrdersToteDetailsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<SingleItemSalesOrdersToteDetailsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof SingleItemSalesOrdersToteDetailsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface SingleItemSalesOrdersToteRemainingItemsOutputDTO
 */
export interface SingleItemSalesOrdersToteRemainingItemsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SingleItemSalesOrdersToteRemainingItemsOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemSalesOrdersToteRemainingItemsOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemSalesOrdersToteRemainingItemsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleItemSalesOrdersToteRemainingItemsOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof SingleItemSalesOrdersToteRemainingItemsOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SingleItemSalesOrdersToteRemainingItemsOutputDTO
     */
    barcodes?: Array<string>;
}
/**
 * 
 * @export
 * @interface SingleValueNode
 */
export interface SingleValueNode {
    /**
     * 
     * @type {IEdmTypeReference}
     * @memberof SingleValueNode
     */
    typeReference?: IEdmTypeReference;
    /**
     * 
     * @type {QueryNodeKind}
     * @memberof SingleValueNode
     */
    kind?: QueryNodeKind;
}
/**
 * 
 * @export
 * @interface SkipQueryOption
 */
export interface SkipQueryOption {
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof SkipQueryOption
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {string}
     * @memberof SkipQueryOption
     */
    rawValue?: string;
    /**
     * 
     * @type {number}
     * @memberof SkipQueryOption
     */
    value?: number;
    /**
     * 
     * @type {object}
     * @memberof SkipQueryOption
     */
    validator?: object;
}
/**
 * 
 * @export
 * @interface SkipTokenQueryOption
 */
export interface SkipTokenQueryOption {
    /**
     * 
     * @type {string}
     * @memberof SkipTokenQueryOption
     */
    rawValue?: string;
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof SkipTokenQueryOption
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {object}
     * @memberof SkipTokenQueryOption
     */
    validator?: object;
    /**
     * 
     * @type {object}
     * @memberof SkipTokenQueryOption
     */
    handler?: object;
}
/**
 * 
 * @export
 * @interface SkippedContainerInfo
 */
export interface SkippedContainerInfo {
    /**
     * 
     * @type {string}
     * @memberof SkippedContainerInfo
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SkippedContainerInfo
     */
    reason?: string;
}
/**
 * 
 * @export
 * @interface SkippedGhostAllocationDTO
 */
export interface SkippedGhostAllocationDTO {
    /**
     * 
     * @type {number}
     * @memberof SkippedGhostAllocationDTO
     */
    inventoryItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof SkippedGhostAllocationDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof SkippedGhostAllocationDTO
     */
    salesOrderState?: SalesOrderState;
    /**
     * 
     * @type {InventoryItemType}
     * @memberof SkippedGhostAllocationDTO
     */
    itemType?: InventoryItemType;
    /**
     * 
     * @type {string}
     * @memberof SkippedGhostAllocationDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SkippedGhostAllocationDTO
     */
    reason?: string;
}
/**
 * 
 * @export
 * @interface SkippedRasSalesOrderDetail
 */
export interface SkippedRasSalesOrderDetail {
    /**
     * 
     * @type {string}
     * @memberof SkippedRasSalesOrderDetail
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SkippedRasSalesOrderDetail
     */
    reason?: string;
}
/**
 * 
 * @export
 * @interface SkippedReplenishmentLineOutputDTO
 */
export interface SkippedReplenishmentLineOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SkippedReplenishmentLineOutputDTO
     */
    productSku?: string;
    /**
     * 
     * @type {SkippedReplenishmentLineReason}
     * @memberof SkippedReplenishmentLineOutputDTO
     */
    reason?: SkippedReplenishmentLineReason;
    /**
     * 
     * @type {Array<string>}
     * @memberof SkippedReplenishmentLineOutputDTO
     */
    conflictingJobReferenceNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SkippedReplenishmentLineReason {
    AllSourceCellsPalletLocked = 'AllSourceCellsPalletLocked'
}

/**
 * 
 * @export
 * @interface SolveBarcodeMismatchProblemCommand
 */
export interface SolveBarcodeMismatchProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof SolveBarcodeMismatchProblemCommand
     */
    problemReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface SolveBarcodeNotExistProblemCommand
 */
export interface SolveBarcodeNotExistProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof SolveBarcodeNotExistProblemCommand
     */
    problemReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface SolveCargoCarrierPreferenceProblemCommand
 */
export interface SolveCargoCarrierPreferenceProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof SolveCargoCarrierPreferenceProblemCommand
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveCargoCarrierPreferenceProblemCommand
     */
    carrierName?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveCargoCarrierPreferenceProblemCommand
     */
    problemSolverAddress?: string;
}
/**
 * 
 * @export
 * @interface SolveCargoCarrierQuotaProblemCommand
 */
export interface SolveCargoCarrierQuotaProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof SolveCargoCarrierQuotaProblemCommand
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveCargoCarrierQuotaProblemCommand
     */
    carrierName?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveCargoCarrierQuotaProblemCommand
     */
    problemSolverAddress?: string;
}
/**
 * 
 * @export
 * @interface SolveCargoCodeUpdatedProblemOutputDTO
 */
export interface SolveCargoCodeUpdatedProblemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SolveCargoCodeUpdatedProblemOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveCargoCodeUpdatedProblemOutputDTO
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveCargoCodeUpdatedProblemOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {ProblemSource}
     * @memberof SolveCargoCodeUpdatedProblemOutputDTO
     */
    source?: ProblemSource;
    /**
     * 
     * @type {ProblemState}
     * @memberof SolveCargoCodeUpdatedProblemOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {CargoCodeUpdatedProblemState}
     * @memberof SolveCargoCodeUpdatedProblemOutputDTO
     */
    stateDetail?: CargoCodeUpdatedProblemState;
    /**
     * 
     * @type {string}
     * @memberof SolveCargoCodeUpdatedProblemOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveCargoCodeUpdatedProblemOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveCargoCodeUpdatedProblemOutputDTO
     */
    resolutionNote?: string;
}
/**
 * 
 * @export
 * @interface SolveDamagedItemsProblemCommand
 */
export interface SolveDamagedItemsProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof SolveDamagedItemsProblemCommand
     */
    problemReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface SolveDuplicateBarcodeProblemCommand
 */
export interface SolveDuplicateBarcodeProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof SolveDuplicateBarcodeProblemCommand
     */
    problemReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface SolveIntegrationCodeProblemCommand
 */
export interface SolveIntegrationCodeProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof SolveIntegrationCodeProblemCommand
     */
    problemReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface SolveMarketplaceCargoCarrierQuotaProblemCommand
 */
export interface SolveMarketplaceCargoCarrierQuotaProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof SolveMarketplaceCargoCarrierQuotaProblemCommand
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveMarketplaceCargoCarrierQuotaProblemCommand
     */
    problemSolverAddress?: string;
}
/**
 * 
 * @export
 * @interface SolveMissingCargoPackageLabelProblemCommand
 */
export interface SolveMissingCargoPackageLabelProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof SolveMissingCargoPackageLabelProblemCommand
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveMissingCargoPackageLabelProblemCommand
     */
    problemSolverAddress?: string;
}
/**
 * 
 * @export
 * @interface SolveMissingSLAMLabelProblemCommand
 */
export interface SolveMissingSLAMLabelProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof SolveMissingSLAMLabelProblemCommand
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveMissingSLAMLabelProblemCommand
     */
    problemSolverAddress?: string;
}
/**
 * 
 * @export
 * @interface SolveSLAMShipmentProblemCommand
 */
export interface SolveSLAMShipmentProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof SolveSLAMShipmentProblemCommand
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveSLAMShipmentProblemCommand
     */
    selectedCarrier?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveSLAMShipmentProblemCommand
     */
    problemSolverAddress?: string;
}
/**
 * 
 * @export
 * @interface SolveSLAMShipmentProblemOutputDTO
 */
export interface SolveSLAMShipmentProblemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SolveSLAMShipmentProblemOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveSLAMShipmentProblemOutputDTO
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveSLAMShipmentProblemOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {ProblemSource}
     * @memberof SolveSLAMShipmentProblemOutputDTO
     */
    source?: ProblemSource;
    /**
     * 
     * @type {ProblemState}
     * @memberof SolveSLAMShipmentProblemOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {SLAMShipmentProblemState}
     * @memberof SolveSLAMShipmentProblemOutputDTO
     */
    stateDetail?: SLAMShipmentProblemState;
    /**
     * 
     * @type {string}
     * @memberof SolveSLAMShipmentProblemOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveSLAMShipmentProblemOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveSLAMShipmentProblemOutputDTO
     */
    resolutionNote?: string;
}
/**
 * 
 * @export
 * @interface SolveSalesOrderProblemCommand
 */
export interface SolveSalesOrderProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof SolveSalesOrderProblemCommand
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveSalesOrderProblemCommand
     */
    problemSolverAddress?: string;
}
/**
 * 
 * @export
 * @interface SolveUnidentifiedProductProblemCommand
 */
export interface SolveUnidentifiedProductProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof SolveUnidentifiedProductProblemCommand
     */
    problemReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface SolveUnreadableBarcodeProblemCommand
 */
export interface SolveUnreadableBarcodeProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof SolveUnreadableBarcodeProblemCommand
     */
    problemReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface SolveWrongShippingAddressProblemCommand
 */
export interface SolveWrongShippingAddressProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof SolveWrongShippingAddressProblemCommand
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveWrongShippingAddressProblemCommand
     */
    problemSolverAddress?: string;
}
/**
 * 
 * @export
 * @interface SolveWrongShippingAddressProblemOutputDTO
 */
export interface SolveWrongShippingAddressProblemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SolveWrongShippingAddressProblemOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveWrongShippingAddressProblemOutputDTO
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveWrongShippingAddressProblemOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {ProblemSource}
     * @memberof SolveWrongShippingAddressProblemOutputDTO
     */
    source?: ProblemSource;
    /**
     * 
     * @type {ProblemState}
     * @memberof SolveWrongShippingAddressProblemOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {WrongShippingAddressProblemState}
     * @memberof SolveWrongShippingAddressProblemOutputDTO
     */
    stateDetail?: WrongShippingAddressProblemState;
    /**
     * 
     * @type {string}
     * @memberof SolveWrongShippingAddressProblemOutputDTO
     */
    customerServicesReviewedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveWrongShippingAddressProblemOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveWrongShippingAddressProblemOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof SolveWrongShippingAddressProblemOutputDTO
     */
    resolutionNote?: string;
}
/**
 * 
 * @export
 * @interface SortCellFlushedRequest
 */
export interface SortCellFlushedRequest {
    /**
     * 
     * @type {number}
     * @memberof SortCellFlushedRequest
     */
    warehouseId?: number;
    /**
     * 
     * @type {number}
     * @memberof SortCellFlushedRequest
     */
    consolidationId?: number;
    /**
     * 
     * @type {string}
     * @memberof SortCellFlushedRequest
     */
    sortcellCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SortCellFlushedRequest
     */
    flushTime?: string;
    /**
     * 
     * @type {string}
     * @memberof SortCellFlushedRequest
     */
    sisLocation?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SortDirection {
    Asc = 'Asc',
    Desc = 'Desc'
}

/**
 * 
 * @export
 * @interface SortOption
 */
export interface SortOption {
    /**
     * 
     * @type {string}
     * @memberof SortOption
     */
    propertyName?: string;
    /**
     * 
     * @type {SortingDirection}
     * @memberof SortOption
     */
    sortingDirection?: SortingDirection;
    /**
     * 
     * @type {boolean}
     * @memberof SortOption
     */
    caseSensitive?: boolean;
}
/**
 * 
 * @export
 * @interface SorterConfigFileOutputDTO
 */
export interface SorterConfigFileOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SorterConfigFileOutputDTO
     */
    baseUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SorterConfigFileOutputDTO
     */
    sorterId?: string;
    /**
     * 
     * @type {string}
     * @memberof SorterConfigFileOutputDTO
     */
    authorization?: string;
    /**
     * 
     * @type {string}
     * @memberof SorterConfigFileOutputDTO
     */
    findExitEndPoint?: string;
    /**
     * 
     * @type {string}
     * @memberof SorterConfigFileOutputDTO
     */
    dispatchPackageEndpoint?: string;
}
/**
 * 
 * @export
 * @interface SorterConfigInputDTO
 */
export interface SorterConfigInputDTO {
    /**
     * 
     * @type {string}
     * @memberof SorterConfigInputDTO
     */
    carrierId?: string;
    /**
     * 
     * @type {number}
     * @memberof SorterConfigInputDTO
     */
    exitPoint?: number;
}
/**
 * 
 * @export
 * @interface SorterConfigOutputDTO
 */
export interface SorterConfigOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SorterConfigOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SorterConfigOutputDTO
     */
    carrierName?: string;
    /**
     * 
     * @type {string}
     * @memberof SorterConfigOutputDTO
     */
    carrierId?: string;
    /**
     * 
     * @type {number}
     * @memberof SorterConfigOutputDTO
     */
    exitPoint?: number;
    /**
     * 
     * @type {SorterOutputDTO}
     * @memberof SorterConfigOutputDTO
     */
    sorter?: SorterOutputDTO;
}
/**
 * 
 * @export
 * @interface SorterOutputDTO
 */
export interface SorterOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SorterOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SorterOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof SorterOutputDTO
     */
    exitPointCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SorterOutputDTO
     */
    defaultExit?: number;
    /**
     * 
     * @type {number}
     * @memberof SorterOutputDTO
     */
    failureExit?: number;
    /**
     * 
     * @type {SorterConfigFileOutputDTO}
     * @memberof SorterOutputDTO
     */
    sorterConfigFile?: SorterConfigFileOutputDTO;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SortingDirection {
    Asc = 'Asc',
    Desc = 'Desc'
}

/**
 * 
 * @export
 * @interface SortingStateDetailsOutputDTO
 */
export interface SortingStateDetailsOutputDTO {
    /**
     * 
     * @type {SalesOrderSortingState}
     * @memberof SortingStateDetailsOutputDTO
     */
    state?: SalesOrderSortingState;
    /**
     * 
     * @type {string}
     * @memberof SortingStateDetailsOutputDTO
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SortingStateDetailsOutputDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SortingStateDetailsOutputDTO
     */
    suspendedInThisState?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SortingStateDetailsOutputDTO
     */
    doneByFullName?: string;
}
/**
 * 
 * @export
 * @interface StartCreatedBatchPickingCommand
 */
export interface StartCreatedBatchPickingCommand {
    /**
     * 
     * @type {string}
     * @memberof StartCreatedBatchPickingCommand
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof StartCreatedBatchPickingCommand
     */
    pickingProcessReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface StartCreatedPickingCommand
 */
export interface StartCreatedPickingCommand {
    /**
     * 
     * @type {string}
     * @memberof StartCreatedPickingCommand
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof StartCreatedPickingCommand
     */
    pickingProcessReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface StartCreatedPickingForHOVPickingCommand
 */
export interface StartCreatedPickingForHOVPickingCommand {
    /**
     * 
     * @type {string}
     * @memberof StartCreatedPickingForHOVPickingCommand
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof StartCreatedPickingForHOVPickingCommand
     */
    pickingProcessReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface StartCreatedPickingForHOVPickingOutputDTO
 */
export interface StartCreatedPickingForHOVPickingOutputDTO {
    /**
     * 
     * @type {RouteOutputDTO}
     * @memberof StartCreatedPickingForHOVPickingOutputDTO
     */
    route?: RouteOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof StartCreatedPickingForHOVPickingOutputDTO
     */
    expectedCurrentItemAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StartCreatedPickingForHOVPickingOutputDTO
     */
    isCurrentItemCountEntryAllowed?: boolean;
}
/**
 * 
 * @export
 * @interface StartCreatedPickingForSingleItemFastPackPickingCommand
 */
export interface StartCreatedPickingForSingleItemFastPackPickingCommand {
    /**
     * 
     * @type {string}
     * @memberof StartCreatedPickingForSingleItemFastPackPickingCommand
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof StartCreatedPickingForSingleItemFastPackPickingCommand
     */
    pickingProcessReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface StartCreatedPickingForSingleItemFastPackPickingOutputDTO
 */
export interface StartCreatedPickingForSingleItemFastPackPickingOutputDTO {
    /**
     * 
     * @type {RouteOutputDTO}
     * @memberof StartCreatedPickingForSingleItemFastPackPickingOutputDTO
     */
    route?: RouteOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof StartCreatedPickingForSingleItemFastPackPickingOutputDTO
     */
    expectedCurrentItemAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StartCreatedPickingForSingleItemFastPackPickingOutputDTO
     */
    isCurrentItemCountEntryAllowed?: boolean;
}
/**
 * 
 * @export
 * @interface StartCreatedPickingForSingleItemPickingCommand
 */
export interface StartCreatedPickingForSingleItemPickingCommand {
    /**
     * 
     * @type {string}
     * @memberof StartCreatedPickingForSingleItemPickingCommand
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof StartCreatedPickingForSingleItemPickingCommand
     */
    pickingProcessReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface StartCreatedPickingForSingleItemPickingOutputDTO
 */
export interface StartCreatedPickingForSingleItemPickingOutputDTO {
    /**
     * 
     * @type {RouteOutputDTO}
     * @memberof StartCreatedPickingForSingleItemPickingOutputDTO
     */
    route?: RouteOutputDTO;
    /**
     * 
     * @type {number}
     * @memberof StartCreatedPickingForSingleItemPickingOutputDTO
     */
    expectedCurrentItemAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StartCreatedPickingForSingleItemPickingOutputDTO
     */
    isCurrentItemCountEntryAllowed?: boolean;
}
/**
 * 
 * @export
 * @interface StartCreatedPickingToteSelectiveCommand
 */
export interface StartCreatedPickingToteSelectiveCommand {
    /**
     * 
     * @type {string}
     * @memberof StartCreatedPickingToteSelectiveCommand
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof StartCreatedPickingToteSelectiveCommand
     */
    pickingProcessReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface StartCreatedPickingToteSelectiveCommandOutputDTO
 */
export interface StartCreatedPickingToteSelectiveCommandOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof StartCreatedPickingToteSelectiveCommandOutputDTO
     */
    salesOrderCount?: number;
}
/**
 * 
 * @export
 * @interface StartCreatedSimplePickingCommand
 */
export interface StartCreatedSimplePickingCommand {
    /**
     * 
     * @type {number}
     * @memberof StartCreatedSimplePickingCommand
     */
    pickingProcessReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface StartPutAwayCommand
 */
export interface StartPutAwayCommand {
    /**
     * 
     * @type {number}
     * @memberof StartPutAwayCommand
     */
    putAwayReferenceNumber?: number;
}
/**
 * 
 * @export
 * @interface StartSortingProcessCommand
 */
export interface StartSortingProcessCommand {
    /**
     * 
     * @type {string}
     * @memberof StartSortingProcessCommand
     */
    batchTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof StartSortingProcessCommand
     */
    rebinAddress?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StartSortingProcessCommand
     */
    isOperatorReassigned?: boolean;
}
/**
 * 
 * @export
 * @interface StartSortingProcessOutputDTO
 */
export interface StartSortingProcessOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof StartSortingProcessOutputDTO
     */
    sortingProcessReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof StartSortingProcessOutputDTO
     */
    leftRebinTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof StartSortingProcessOutputDTO
     */
    rightRebinTrolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof StartSortingProcessOutputDTO
     */
    toteCount?: number;
    /**
     * 
     * @type {number}
     * @memberof StartSortingProcessOutputDTO
     */
    rebinTrolleyCount?: number;
    /**
     * 
     * @type {Array<ToteDetailsOutputDTO>}
     * @memberof StartSortingProcessOutputDTO
     */
    batchTotes?: Array<ToteDetailsOutputDTO>;
}
/**
 * 
 * @export
 * @interface StartWallToWallStockCountingListCommand
 */
export interface StartWallToWallStockCountingListCommand {
    /**
     * 
     * @type {string}
     * @memberof StartWallToWallStockCountingListCommand
     */
    qrCode?: string;
    /**
     * 
     * @type {string}
     * @memberof StartWallToWallStockCountingListCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface StartWallToWallStockCountingListOutputDTO
 */
export interface StartWallToWallStockCountingListOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof StartWallToWallStockCountingListOutputDTO
     */
    referenceNumber?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StartWallToWallStockCountingListOutputDTO
     */
    allowManualEntry?: boolean;
    /**
     * 
     * @type {WallToWallStockCountingRouteOutputDTO}
     * @memberof StartWallToWallStockCountingListOutputDTO
     */
    route?: WallToWallStockCountingRouteOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof StartWallToWallStockCountingListOutputDTO
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface StartWallToWallStockCountingPlanCommand
 */
export interface StartWallToWallStockCountingPlanCommand {
    /**
     * 
     * @type {string}
     * @memberof StartWallToWallStockCountingPlanCommand
     */
    stockCountingPlanId?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum StationType {
    Stow = 'Stow',
    Pick = 'Pick',
    Count = 'Count',
    ProblemSolver = 'ProblemSolver'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum StockCellCategory {
    Undefined = 'Undefined',
    PrimeCell = 'PrimeCell',
    ReservedCell = 'ReservedCell'
}

/**
 * 
 * @export
 * @interface StockCellDetailsOutputDTO
 */
export interface StockCellDetailsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof StockCellDetailsOutputDTO
     */
    cellId?: number;
    /**
     * 
     * @type {string}
     * @memberof StockCellDetailsOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof StockCellDetailsOutputDTO
     */
    stockCellTypeName?: string;
    /**
     * 
     * @type {number}
     * @memberof StockCellDetailsOutputDTO
     */
    stockCellTypeVolume?: number;
    /**
     * 
     * @type {string}
     * @memberof StockCellDetailsOutputDTO
     */
    section?: string;
    /**
     * 
     * @type {string}
     * @memberof StockCellDetailsOutputDTO
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof StockCellDetailsOutputDTO
     */
    stockZone?: string;
    /**
     * 
     * @type {number}
     * @memberof StockCellDetailsOutputDTO
     */
    skuCount?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCellDetailsOutputDTO
     */
    productVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCellDetailsOutputDTO
     */
    occupancy?: number;
}
/**
 * 
 * @export
 * @interface StockCellDetailsOutputDTODynamicQueryOutputDTO
 */
export interface StockCellDetailsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<StockCellDetailsOutputDTO>}
     * @memberof StockCellDetailsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<StockCellDetailsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof StockCellDetailsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface StockCellStatusOutputDTO
 */
export interface StockCellStatusOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof StockCellStatusOutputDTO
     */
    cellId?: number;
    /**
     * 
     * @type {string}
     * @memberof StockCellStatusOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof StockCellStatusOutputDTO
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof StockCellStatusOutputDTO
     */
    section?: string;
    /**
     * 
     * @type {string}
     * @memberof StockCellStatusOutputDTO
     */
    slot?: string;
    /**
     * 
     * @type {string}
     * @memberof StockCellStatusOutputDTO
     */
    side?: string;
    /**
     * 
     * @type {string}
     * @memberof StockCellStatusOutputDTO
     */
    level?: string;
    /**
     * 
     * @type {string}
     * @memberof StockCellStatusOutputDTO
     */
    depth?: string;
    /**
     * 
     * @type {number}
     * @memberof StockCellStatusOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof StockCellStatusOutputDTO
     */
    currentStockZone?: string;
    /**
     * 
     * @type {number}
     * @memberof StockCellStatusOutputDTO
     */
    productAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCellStatusOutputDTO
     */
    productVariety?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCellStatusOutputDTO
     */
    operationCount?: number;
    /**
     * 
     * @type {StockCellCategory}
     * @memberof StockCellStatusOutputDTO
     */
    stockCellType?: StockCellCategory;
    /**
     * 
     * @type {Array<OperationOutputDTO>}
     * @memberof StockCellStatusOutputDTO
     */
    operations?: Array<OperationOutputDTO>;
    /**
     * 
     * @type {string}
     * @memberof StockCellStatusOutputDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface StockCellStatusOutputDTODynamicQueryOutputDTO
 */
export interface StockCellStatusOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<StockCellStatusOutputDTO>}
     * @memberof StockCellStatusOutputDTODynamicQueryOutputDTO
     */
    data?: Array<StockCellStatusOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof StockCellStatusOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface StockCellTypeAssignmentInputDTO
 */
export interface StockCellTypeAssignmentInputDTO {
    /**
     * 
     * @type {string}
     * @memberof StockCellTypeAssignmentInputDTO
     */
    stockZone?: string;
    /**
     * 
     * @type {string}
     * @memberof StockCellTypeAssignmentInputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof StockCellTypeAssignmentInputDTO
     */
    stockCellType?: string;
}
/**
 * 
 * @export
 * @interface StockCellTypeOutputDTO
 */
export interface StockCellTypeOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof StockCellTypeOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockCellTypeOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof StockCellTypeOutputDTO
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCellTypeOutputDTO
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCellTypeOutputDTO
     */
    depth?: number;
}
/**
 * 
 * @export
 * @interface StockCellTypesWithCountsOutputDTO
 */
export interface StockCellTypesWithCountsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof StockCellTypesWithCountsOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockCellTypesWithCountsOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof StockCellTypesWithCountsOutputDTO
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCellTypesWithCountsOutputDTO
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCellTypesWithCountsOutputDTO
     */
    depth?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCellTypesWithCountsOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface StockCellTypesWithCountsOutputDTODynamicQueryOutputDTO
 */
export interface StockCellTypesWithCountsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<StockCellTypesWithCountsOutputDTO>}
     * @memberof StockCellTypesWithCountsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<StockCellTypesWithCountsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof StockCellTypesWithCountsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum StockCountingCellState {
    None = 'None',
    Created = 'Created',
    WaitingForCounting = 'WaitingForCounting',
    InProgress = 'InProgress',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @interface StockCountingListConfigurationOutputDTO
 */
export interface StockCountingListConfigurationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof StockCountingListConfigurationOutputDTO
     */
    tenantName?: string;
    /**
     * 
     * @type {number}
     * @memberof StockCountingListConfigurationOutputDTO
     */
    srcStockCountingListCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCountingListConfigurationOutputDTO
     */
    srcStockCountingListCountingStartThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCountingListConfigurationOutputDTO
     */
    ccStockCountingListCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCountingListConfigurationOutputDTO
     */
    ccStockCountingListCountingStartThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCountingListConfigurationOutputDTO
     */
    sbcStockCountingListCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCountingListConfigurationOutputDTO
     */
    sbcStockCountingListCountingStartThreshold?: number;
}
/**
 * 
 * @export
 * @interface StockCountingListDetailsOutputDTO
 */
export interface StockCountingListDetailsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof StockCountingListDetailsOutputDTO
     */
    referenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof StockCountingListDetailsOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof StockCountingListDetailsOutputDTO
     */
    createdByFullName?: string;
    /**
     * 
     * @type {StockCountingListState}
     * @memberof StockCountingListDetailsOutputDTO
     */
    state?: StockCountingListState;
    /**
     * 
     * @type {StockCountingType}
     * @memberof StockCountingListDetailsOutputDTO
     */
    stockCountingType?: StockCountingType;
    /**
     * 
     * @type {number}
     * @memberof StockCountingListDetailsOutputDTO
     */
    beforeStockCountingTotalAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCountingListDetailsOutputDTO
     */
    afterStockCountingTotalAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCountingListDetailsOutputDTO
     */
    totalDifferenceInAmount?: number;
}
/**
 * 
 * @export
 * @interface StockCountingListOutputDTO
 */
export interface StockCountingListOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof StockCountingListOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof StockCountingListOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {StockCountingListState}
     * @memberof StockCountingListOutputDTO
     */
    state?: StockCountingListState;
    /**
     * 
     * @type {string}
     * @memberof StockCountingListOutputDTO
     */
    qrCode?: string;
    /**
     * 
     * @type {string}
     * @memberof StockCountingListOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof StockCountingListOutputDTO
     */
    sections?: string;
    /**
     * 
     * @type {string}
     * @memberof StockCountingListOutputDTO
     */
    zoneLabel?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum StockCountingListState {
    None = 'None',
    Created = 'Created',
    InProgres = 'InProgres',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum StockCountingListType {
    None = 'None',
    Src = 'SRC',
    Cc = 'CC',
    Sbc = 'SBC'
}

/**
 * 
 * @export
 * @interface StockCountingListsOutputDTO
 */
export interface StockCountingListsOutputDTO {
    /**
     * 
     * @type {Array<StockCountingListOutputDTO>}
     * @memberof StockCountingListsOutputDTO
     */
    stockCountingLists?: Array<StockCountingListOutputDTO>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum StockCountingPlanState {
    None = 'None',
    WaitingForCounting = 'WaitingForCounting',
    InProgress = 'InProgress',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @interface StockCountingProcessAddressOutputDTO
 */
export interface StockCountingProcessAddressOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof StockCountingProcessAddressOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof StockCountingProcessAddressOutputDTO
     */
    totalProductAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCountingProcessAddressOutputDTO
     */
    totalStockCountingTaskAmount?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum StockCountingProcessSortType {
    Address = 'Address',
    ProductAmount = 'ProductAmount',
    TaskAmount = 'TaskAmount'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum StockCountingProcessState {
    None = 'None',
    Created = 'Created',
    InProgress = 'InProgress',
    Counted = 'Counted',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum StockCountingSource {
    System = 'System',
    StockCountingPlan = 'StockCountingPlan',
    Quality = 'Quality',
    W2WStockCountingPlan = 'W2WStockCountingPlan'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum StockCountingState {
    None = 'None',
    Created = 'Created',
    InProgress = 'InProgress',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @interface StockCountingStatisticsOutputDTO
 */
export interface StockCountingStatisticsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof StockCountingStatisticsOutputDTO
     */
    countsOfProductsWaitingToBeCounted?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCountingStatisticsOutputDTO
     */
    countsOfCellsWaitingForCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCountingStatisticsOutputDTO
     */
    countsOfStockCountListsWaitingForCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof StockCountingStatisticsOutputDTO
     */
    countsOfStockCountListsInProcess?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum StockCountingStatus {
    None = 'None',
    Red = 'Red',
    Yellow = 'Yellow',
    Green = 'Green'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum StockCountingType {
    None = 'None',
    Src = 'SRC',
    Cc = 'CC',
    Sbc = 'SBC',
    W2W = 'W2W'
}

/**
 * 
 * @export
 * @interface StockItemQueryOutputDTO
 */
export interface StockItemQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof StockItemQueryOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof StockItemQueryOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof StockItemQueryOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof StockItemQueryOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof StockItemQueryOutputDTO
     */
    productImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof StockItemQueryOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof StockItemQueryOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {number}
     * @memberof StockItemQueryOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof StockItemQueryOutputDTO
     */
    productType?: ProductType;
}
/**
 * 
 * @export
 * @interface StockItemQueryOutputDTODynamicQueryOutputDTO
 */
export interface StockItemQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<StockItemQueryOutputDTO>}
     * @memberof StockItemQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<StockItemQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof StockItemQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface StockItemsByProductOutputDTO
 */
export interface StockItemsByProductOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof StockItemsByProductOutputDTO
     */
    totalCellAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof StockItemsByProductOutputDTO
     */
    totalItemAmount?: number;
    /**
     * 
     * @type {Array<CellWithStockItemAmountOutputDTO>}
     * @memberof StockItemsByProductOutputDTO
     */
    cells?: Array<CellWithStockItemAmountOutputDTO>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum StockToQuarantineTransferReason {
    None = 'None',
    Fracture = 'Fracture',
    Deformation = 'Deformation',
    Leakage = 'Leakage',
    Other = 'Other',
    ExpiredProduct = 'ExpiredProduct',
    CustomerRequest = 'CustomerRequest',
    Production = 'Production'
}

/**
 * 
 * @export
 * @interface StockZonePickListConfigInputDTO
 */
export interface StockZonePickListConfigInputDTO {
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof StockZonePickListConfigInputDTO
     */
    pickingFlowTag?: PickingFlowTag;
    /**
     * 
     * @type {number}
     * @memberof StockZonePickListConfigInputDTO
     */
    pickListCountThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof StockZonePickListConfigInputDTO
     */
    pickListCreateAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StockZonePickListConfigInputDTO
     */
    disposePickLists?: boolean;
    /**
     * 
     * @type {StockZonePickingType}
     * @memberof StockZonePickListConfigInputDTO
     */
    zonePickingType?: StockZonePickingType;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum StockZonePickingType {
    None = 'None',
    Order = 'Order',
    Batch = 'Batch',
    Simple = 'Simple',
    MissingOrder = 'MissingOrder'
}

/**
 * 
 * @export
 * @interface StowStationActiveToteCommand
 */
export interface StowStationActiveToteCommand {
    /**
     * 
     * @type {string}
     * @memberof StowStationActiveToteCommand
     */
    addressLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof StowStationActiveToteCommand
     */
    slot?: number;
}
/**
 * 
 * @export
 * @interface Stream
 */
export interface Stream {
    /**
     * 
     * @type {boolean}
     * @memberof Stream
     */
    canRead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Stream
     */
    canWrite?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Stream
     */
    canSeek?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Stream
     */
    canTimeout?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Stream
     */
    length?: number;
    /**
     * 
     * @type {number}
     * @memberof Stream
     */
    position?: number;
    /**
     * 
     * @type {number}
     * @memberof Stream
     */
    readTimeout?: number;
    /**
     * 
     * @type {number}
     * @memberof Stream
     */
    writeTimeout?: number;
}
/**
 * 
 * @export
 * @interface StringStringKeyValuePair
 */
export interface StringStringKeyValuePair {
    /**
     * 
     * @type {string}
     * @memberof StringStringKeyValuePair
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof StringStringKeyValuePair
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface StringStringValuesKeyValuePair
 */
export interface StringStringValuesKeyValuePair {
    /**
     * 
     * @type {string}
     * @memberof StringStringValuesKeyValuePair
     */
    key?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StringStringValuesKeyValuePair
     */
    value?: Array<string>;
}
/**
 * 
 * @export
 * @interface StripCancelledCellItemToToteCommand
 */
export interface StripCancelledCellItemToToteCommand {
    /**
     * 
     * @type {string}
     * @memberof StripCancelledCellItemToToteCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof StripCancelledCellItemToToteCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof StripCancelledCellItemToToteCommand
     */
    cancelToteLabel?: string;
}
/**
 * 
 * @export
 * @interface StripCancelledToteItemToToteCommand
 */
export interface StripCancelledToteItemToToteCommand {
    /**
     * 
     * @type {string}
     * @memberof StripCancelledToteItemToToteCommand
     */
    sourceToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof StripCancelledToteItemToToteCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof StripCancelledToteItemToToteCommand
     */
    cancelToteLabel?: string;
}
/**
 * 
 * @export
 * @interface SubZoneOutputDTO
 */
export interface SubZoneOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof SubZoneOutputDTO
     */
    subZoneId?: number;
    /**
     * 
     * @type {number}
     * @memberof SubZoneOutputDTO
     */
    stockZoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof SubZoneOutputDTO
     */
    stockZoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SubZoneOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof SubZoneOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubZoneOutputDTO
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubZoneOutputDTO
     */
    isDefault?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubZoneOutputDTO
     */
    addressCount?: number;
}
/**
 * 
 * @export
 * @interface SubZoneOutputDTODynamicQueryOutputDTO
 */
export interface SubZoneOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<SubZoneOutputDTO>}
     * @memberof SubZoneOutputDTODynamicQueryOutputDTO
     */
    data?: Array<SubZoneOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof SubZoneOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SubZoneSelectionSource {
    WholeZoneChosen = 'WholeZoneChosen',
    DefaultApplied = 'DefaultApplied',
    ExplicitlyChosen = 'ExplicitlyChosen'
}

/**
 * 
 * @export
 * @interface SubZoneUnavailableOrderOutputDTO
 */
export interface SubZoneUnavailableOrderOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SubZoneUnavailableOrderOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof SubZoneUnavailableOrderOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SubZoneUnavailableOrderOutputDTO
     */
    missingSku?: string;
}
/**
 * 
 * @export
 * @interface SuccessAddProductStockZoneOutputDTO
 */
export interface SuccessAddProductStockZoneOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SuccessAddProductStockZoneOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SuccessAddProductStockZoneOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof SuccessAddProductStockZoneOutputDTO
     */
    sku?: string;
}
/**
 * 
 * @export
 * @interface SuccessfulContainerInfo
 */
export interface SuccessfulContainerInfo {
    /**
     * 
     * @type {string}
     * @memberof SuccessfulContainerInfo
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof SuccessfulContainerInfo
     */
    previousType?: string;
    /**
     * 
     * @type {string}
     * @memberof SuccessfulContainerInfo
     */
    newType?: string;
    /**
     * 
     * @type {number}
     * @memberof SuccessfulContainerInfo
     */
    updatedInventoryItemsCount?: number;
}
/**
 * 
 * @export
 * @interface SuccessfulOperationInfo
 */
export interface SuccessfulOperationInfo {
    /**
     * 
     * @type {string}
     * @memberof SuccessfulOperationInfo
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof SuccessfulOperationInfo
     */
    inventoryItemsUpdatedCount?: number;
}
/**
 * 
 * @export
 * @interface SuggestedTargetCellOutputDTO
 */
export interface SuggestedTargetCellOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SuggestedTargetCellOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SuggestedTargetCellOutputDTO
     */
    holdsThisSku?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SuggestedTargetCellOutputDTO
     */
    currentSkuCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SuggestedTargetCellOutputDTO
     */
    currentAmount?: number;
}
/**
 * 
 * @export
 * @interface SupplierCompaniesOutputDTO
 */
export interface SupplierCompaniesOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof SupplierCompaniesOutputDTO
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface SwitchToteOnTrolleyCommand
 */
export interface SwitchToteOnTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof SwitchToteOnTrolleyCommand
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof SwitchToteOnTrolleyCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof SwitchToteOnTrolleyCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface SyncPurchaseOrderCommand
 */
export interface SyncPurchaseOrderCommand {
    /**
     * 
     * @type {string}
     * @memberof SyncPurchaseOrderCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof SyncPurchaseOrderCommand
     */
    purchaseOrderRefenceNumber?: string;
}
/**
 * 
 * @export
 * @interface SyncPurchaseOrderFromIntegrationCommand
 */
export interface SyncPurchaseOrderFromIntegrationCommand {
    /**
     * 
     * @type {string}
     * @memberof SyncPurchaseOrderFromIntegrationCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof SyncPurchaseOrderFromIntegrationCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {DateRangeInputDTO}
     * @memberof SyncPurchaseOrderFromIntegrationCommand
     */
    expectedDeliveryDate?: DateRangeInputDTO;
    /**
     * 
     * @type {PurchaseOrderSource}
     * @memberof SyncPurchaseOrderFromIntegrationCommand
     */
    source?: PurchaseOrderSource;
    /**
     * 
     * @type {Array<PurchaseOrderLineItemInputDTO>}
     * @memberof SyncPurchaseOrderFromIntegrationCommand
     */
    lineItems?: Array<PurchaseOrderLineItemInputDTO>;
    /**
     * 
     * @type {ReceiveType}
     * @memberof SyncPurchaseOrderFromIntegrationCommand
     */
    receiveType?: ReceiveType;
}
/**
 * 
 * @export
 * @interface SyncPurchaseOrderFromIntegrationCommandOutputDTO
 */
export interface SyncPurchaseOrderFromIntegrationCommandOutputDTO {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SyncPurchaseOrderFromIntegrationCommandOutputDTO
     */
    failures?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncPurchaseOrderFromIntegrationCommandOutputDTO
     */
    successful?: Array<string>;
}
/**
 * 
 * @export
 * @interface SyncReturnCompleteInputDTO
 */
export interface SyncReturnCompleteInputDTO {
    /**
     * 
     * @type {string}
     * @memberof SyncReturnCompleteInputDTO
     */
    returnReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SyncReturnCompleteInputDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface SyncReturnFromIntegrationCommand
 */
export interface SyncReturnFromIntegrationCommand {
    /**
     * 
     * @type {string}
     * @memberof SyncReturnFromIntegrationCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SyncReturnFromIntegrationCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof SyncReturnFromIntegrationCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {ReturnSource}
     * @memberof SyncReturnFromIntegrationCommand
     */
    source?: ReturnSource;
    /**
     * 
     * @type {boolean}
     * @memberof SyncReturnFromIntegrationCommand
     */
    courierRequested?: boolean;
}
/**
 * 
 * @export
 * @interface SyncStockItemAmountsCommand
 */
export interface SyncStockItemAmountsCommand {
    /**
     * 
     * @type {string}
     * @memberof SyncStockItemAmountsCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof SyncStockItemAmountsCommand
     */
    sku?: string;
}
/**
 * 
 * @export
 * @interface SyncTotePickListIdCommand
 */
export interface SyncTotePickListIdCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncTotePickListIdCommand
     */
    containerLabels?: Array<string>;
}
/**
 * 
 * @export
 * @interface TagCargoPackageCommand
 */
export interface TagCargoPackageCommand {
    /**
     * 
     * @type {string}
     * @memberof TagCargoPackageCommand
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof TagCargoPackageCommand
     */
    dimensionsInMillimeters?: string;
    /**
     * 
     * @type {number}
     * @memberof TagCargoPackageCommand
     */
    scaleInGrams?: number;
}
/**
 * 
 * @export
 * @interface TagCargoPackageCommandOutputDTO
 */
export interface TagCargoPackageCommandOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof TagCargoPackageCommandOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {SLAMTag}
     * @memberof TagCargoPackageCommandOutputDTO
     */
    slamTag?: SLAMTag;
}
/**
 * 
 * @export
 * @interface TaxIncludedSalePriceInputDTO
 */
export interface TaxIncludedSalePriceInputDTO {
    /**
     * 
     * @type {number}
     * @memberof TaxIncludedSalePriceInputDTO
     */
    taxIncludedSalePriceAmount?: number;
    /**
     * 
     * @type {Currency}
     * @memberof TaxIncludedSalePriceInputDTO
     */
    taxIncludedSalePriceCurrency?: Currency;
}
/**
 * 
 * @export
 * @interface TenantConfigurationsOutputDTO
 */
export interface TenantConfigurationsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof TenantConfigurationsOutputDTO
     */
    tenantId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigurationsOutputDTO
     */
    isHOVPickingControlCountingActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigurationsOutputDTO
     */
    isPickingStockZoneInputActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigurationsOutputDTO
     */
    isPickListTargetDispatchTimeActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigurationsOutputDTO
     */
    isPutawayCompleteWithLostItemButtonOpen?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigurationsOutputDTO
     */
    isPutawayStockAddressDetailPageOpen?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigurationsOutputDTO
     */
    isSimpleFlowActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigurationsOutputDTO
     */
    isMeasurementControlOnReceivingActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigurationsOutputDTO
     */
    isIncludeAssignedPickListsActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigurationsOutputDTO
     */
    isRebinAddressScanRemoved?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigurationsOutputDTO
     */
    isPickPerformanceEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigurationsOutputDTO
     */
    isCargoPackageTypeQrActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigurationsOutputDTO
     */
    isQuarantineWallActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigurationsOutputDTO
     */
    allowInternationalMultiCargoPackage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigurationsOutputDTO
     */
    isAllocationFixPrimeStockPreFilterEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TenantConfigurationsOutputDTO
     */
    multiItemMultiplePickingItemCountThreshold?: number;
}
/**
 * 
 * @export
 * @interface TenantQueryOutputDTO
 */
export interface TenantQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof TenantQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantQueryOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantQueryOutputDTO
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantQueryOutputDTO
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantQueryOutputDTO
     */
    companyEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantQueryOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface TenantQueryOutputDTODynamicQueryOutputDTO
 */
export interface TenantQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<TenantQueryOutputDTO>}
     * @memberof TenantQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<TenantQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof TenantQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum TenantsEnum {
    SpeedyLojistik = 'SpeedyLojistik',
    ToptanAs = 'ToptanAs'
}

/**
 * 
 * @export
 * @interface TopQueryOption
 */
export interface TopQueryOption {
    /**
     * 
     * @type {ODataQueryContext}
     * @memberof TopQueryOption
     */
    context?: ODataQueryContext;
    /**
     * 
     * @type {string}
     * @memberof TopQueryOption
     */
    rawValue?: string;
    /**
     * 
     * @type {number}
     * @memberof TopQueryOption
     */
    value?: number;
    /**
     * 
     * @type {object}
     * @memberof TopQueryOption
     */
    validator?: object;
}
/**
 * 
 * @export
 * @interface ToteContainedItemOutputDTO
 */
export interface ToteContainedItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ToteContainedItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof ToteContainedItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {number}
     * @memberof ToteContainedItemOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ToteContainedItemOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof ToteContainedItemOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ToteContainedItemOutputDTO
     */
    barcodes?: string;
}
/**
 * 
 * @export
 * @interface ToteContainerDTO
 */
export interface ToteContainerDTO {
    /**
     * 
     * @type {string}
     * @memberof ToteContainerDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof ToteContainerDTO
     */
    updatedAt?: string;
    /**
     * 
     * @type {Array<InventoryItemOutputDTO>}
     * @memberof ToteContainerDTO
     */
    containedProducts?: Array<InventoryItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface ToteContainerQueryOutputDTO
 */
export interface ToteContainerQueryOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof ToteContainerQueryOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ToteContainerQueryOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof ToteContainerQueryOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ToteContainerQueryOutputDTO
     */
    containedIn?: string;
    /**
     * 
     * @type {AddressType}
     * @memberof ToteContainerQueryOutputDTO
     */
    addressType?: AddressType;
    /**
     * 
     * @type {string}
     * @memberof ToteContainerQueryOutputDTO
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ToteContainerQueryOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface ToteContainerQueryOutputDTODynamicQueryOutputDTO
 */
export interface ToteContainerQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ToteContainerQueryOutputDTO>}
     * @memberof ToteContainerQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ToteContainerQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ToteContainerQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ToteDetailByLabelOutputDTO
 */
export interface ToteDetailByLabelOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ToteDetailByLabelOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof ToteDetailByLabelOutputDTO
     */
    containerId?: number;
    /**
     * 
     * @type {string}
     * @memberof ToteDetailByLabelOutputDTO
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof ToteDetailByLabelOutputDTO
     */
    addressType?: string;
    /**
     * 
     * @type {ToteProcessType}
     * @memberof ToteDetailByLabelOutputDTO
     */
    processType?: ToteProcessType;
    /**
     * 
     * @type {number}
     * @memberof ToteDetailByLabelOutputDTO
     */
    productVariety?: number;
    /**
     * 
     * @type {number}
     * @memberof ToteDetailByLabelOutputDTO
     */
    productAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof ToteDetailByLabelOutputDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ToteDetailByLabelOutputDTO
     */
    lastSeenAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ToteDetailByLabelOutputDTO
     */
    operatorName?: string;
    /**
     * 
     * @type {Availability}
     * @memberof ToteDetailByLabelOutputDTO
     */
    availability?: Availability;
    /**
     * 
     * @type {Array<OperationDTO>}
     * @memberof ToteDetailByLabelOutputDTO
     */
    operations?: Array<OperationDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof ToteDetailByLabelOutputDTO
     */
    isPallet?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ToteDetailByLabelOutputDTO
     */
    batchName?: string;
    /**
     * 
     * @type {string}
     * @memberof ToteDetailByLabelOutputDTO
     */
    picklistName?: string;
    /**
     * 
     * @type {string}
     * @memberof ToteDetailByLabelOutputDTO
     */
    vehicleName?: string;
    /**
     * 
     * @type {string}
     * @memberof ToteDetailByLabelOutputDTO
     */
    orderReferenceNumber?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ToteDetailByLabelOutputDTO
     */
    orderReferenceNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface ToteDetailsOutputDTO
 */
export interface ToteDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ToteDetailsOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof ToteDetailsOutputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface ToteForPickOutputDTO
 */
export interface ToteForPickOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ToteForPickOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof ToteForPickOutputDTO
     */
    slot?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ToteOperationType {
    None = 'None',
    Picking = 'Picking',
    Packing = 'Packing',
    PutAway = 'PutAway',
    Return = 'Return',
    Transfer = 'Transfer',
    Quarantine = 'Quarantine',
    Receiving = 'Receiving',
    WaitOnParkAddress = 'WaitOnParkAddress',
    Others = 'Others'
}

/**
 * 
 * @export
 * @interface TotePackingTypeOutputDTO
 */
export interface TotePackingTypeOutputDTO {
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof TotePackingTypeOutputDTO
     */
    flow?: PickingFlowTag;
    /**
     * 
     * @type {Array<string>}
     * @memberof TotePackingTypeOutputDTO
     */
    attachedWallPackingAddressLabels?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ToteProcessType {
    None = 'None',
    Picking = 'Picking',
    PutAway = 'PutAway',
    Return = 'Return',
    Quarantine = 'Quarantine'
}

/**
 * 
 * @export
 * @interface ToteProductZoneDetailsOutputDTO
 */
export interface ToteProductZoneDetailsOutputDTO {
    /**
     * 
     * @type {Array<ContainedItemZoneListOutputDTO>}
     * @memberof ToteProductZoneDetailsOutputDTO
     */
    zoneDetails?: Array<ContainedItemZoneListOutputDTO>;
    /**
     * 
     * @type {ToteOperationType}
     * @memberof ToteProductZoneDetailsOutputDTO
     */
    toteOperationType?: ToteOperationType;
}
/**
 * 
 * @export
 * @interface ToteReadyToPackDTO
 */
export interface ToteReadyToPackDTO {
    /**
     * 
     * @type {string}
     * @memberof ToteReadyToPackDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {ToteReadyToPackState}
     * @memberof ToteReadyToPackDTO
     */
    toteState?: ToteReadyToPackState;
    /**
     * 
     * @type {number}
     * @memberof ToteReadyToPackDTO
     */
    column?: number;
    /**
     * 
     * @type {number}
     * @memberof ToteReadyToPackDTO
     */
    row?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ToteReadyToPackState {
    NotReady = 'NotReady',
    Ready = 'Ready',
    InProgress = 'InProgress'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ToteSalesOrderState {
    NotContainsSalesOrder = 'NotContainsSalesOrder',
    NotCancelled = 'NotCancelled',
    Cancelled = 'Cancelled'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ToteStatus {
    InProgress = 'InProgress',
    WaitingToLoad = 'WaitingToLoad',
    Loaded = 'Loaded'
}

/**
 * 
 * @export
 * @interface ToteStatusOutputDTO
 */
export interface ToteStatusOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ToteStatusOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ToteStatusOutputDTO
     */
    address?: string;
    /**
     * 
     * @type {ToteProcessType}
     * @memberof ToteStatusOutputDTO
     */
    processType?: ToteProcessType;
    /**
     * 
     * @type {number}
     * @memberof ToteStatusOutputDTO
     */
    productVariety?: number;
    /**
     * 
     * @type {number}
     * @memberof ToteStatusOutputDTO
     */
    productAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof ToteStatusOutputDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ToteStatusOutputDTO
     */
    lastSeenAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ToteStatusOutputDTO
     */
    operatorName?: string;
    /**
     * 
     * @type {Availability}
     * @memberof ToteStatusOutputDTO
     */
    availability?: Availability;
}
/**
 * 
 * @export
 * @interface ToteStatusOutputDTODynamicQueryOutputDTO
 */
export interface ToteStatusOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ToteStatusOutputDTO>}
     * @memberof ToteStatusOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ToteStatusOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ToteStatusOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ToteWithDamagedItemsOutputDTO
 */
export interface ToteWithDamagedItemsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ToteWithDamagedItemsOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof ToteWithDamagedItemsOutputDTO
     */
    masterCartonItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ToteWithDamagedItemsOutputDTO
     */
    totalItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ToteWithDamagedItemsOutputDTO
     */
    totalProductCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ToteWithDamagedItemsOutputDTO
     */
    containerType?: string;
    /**
     * 
     * @type {Array<DamagedItemOutputDTO>}
     * @memberof ToteWithDamagedItemsOutputDTO
     */
    damagedItems?: Array<DamagedItemOutputDTO>;
}
/**
 * 
 * @export
 * @interface TrackingInfoComponentOutputDTO
 */
export interface TrackingInfoComponentOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof TrackingInfoComponentOutputDTO
     */
    trackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingInfoComponentOutputDTO
     */
    cargoCarrierName?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingInfoComponentOutputDTO
     */
    cargoCarrierLogoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingInfoComponentOutputDTO
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingInfoComponentOutputDTO
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingInfoComponentOutputDTO
     */
    cargoTrackingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingInfoComponentOutputDTO
     */
    cargoCarrierId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingInfoComponentOutputDTO
     */
    address?: string;
}
/**
 * 
 * @export
 * @interface TransferAllContainerItemsCommand
 */
export interface TransferAllContainerItemsCommand {
    /**
     * 
     * @type {string}
     * @memberof TransferAllContainerItemsCommand
     */
    sourceBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferAllContainerItemsCommand
     */
    targetBarcode?: string;
    /**
     * 
     * @type {ForceTransferType}
     * @memberof TransferAllContainerItemsCommand
     */
    forceType?: ForceTransferType;
}
/**
 * 
 * @export
 * @interface TransferAllProductsToToteCommand
 */
export interface TransferAllProductsToToteCommand {
    /**
     * 
     * @type {string}
     * @memberof TransferAllProductsToToteCommand
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof TransferAllProductsToToteCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof TransferAllProductsToToteCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferAllProductsToToteCommand
     */
    toteLabel?: string;
}
/**
 * 
 * @export
 * @interface TransferAllStockItemsToRestowCommand
 */
export interface TransferAllStockItemsToRestowCommand {
    /**
     * 
     * @type {string}
     * @memberof TransferAllStockItemsToRestowCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferAllStockItemsToRestowCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {Array<CheckCellForStockToRestowTransferProductOutputDTO>}
     * @memberof TransferAllStockItemsToRestowCommand
     */
    products?: Array<CheckCellForStockToRestowTransferProductOutputDTO>;
}
/**
 * 
 * @export
 * @interface TransferAwaitingRestowItemsCommand
 */
export interface TransferAwaitingRestowItemsCommand {
    /**
     * 
     * @type {string}
     * @memberof TransferAwaitingRestowItemsCommand
     */
    sourceToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferAwaitingRestowItemsCommand
     */
    targetToteLabel?: string;
}
/**
 * 
 * @export
 * @interface TransferCancelledSalesOrderToteToQurantineAddressCommand
 */
export interface TransferCancelledSalesOrderToteToQurantineAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof TransferCancelledSalesOrderToteToQurantineAddressCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferCancelledSalesOrderToteToQurantineAddressCommand
     */
    quarantineAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface TransferContainerItemCommand
 */
export interface TransferContainerItemCommand {
    /**
     * 
     * @type {string}
     * @memberof TransferContainerItemCommand
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof TransferContainerItemCommand
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof TransferContainerItemCommand
     */
    expirationDate?: string;
}
/**
 * 
 * @export
 * @interface TransferContainerItemsCommand
 */
export interface TransferContainerItemsCommand {
    /**
     * 
     * @type {Array<TransferContainerItemCommand>}
     * @memberof TransferContainerItemsCommand
     */
    items?: Array<TransferContainerItemCommand>;
    /**
     * 
     * @type {string}
     * @memberof TransferContainerItemsCommand
     */
    sourceBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferContainerItemsCommand
     */
    targetBarcode?: string;
    /**
     * 
     * @type {ForceTransferType}
     * @memberof TransferContainerItemsCommand
     */
    forceType?: ForceTransferType;
}
/**
 * 
 * @export
 * @interface TransferContainerItemsOutputDTO
 */
export interface TransferContainerItemsOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof TransferContainerItemsOutputDTO
     */
    success?: boolean;
    /**
     * 
     * @type {BlockingErrorType}
     * @memberof TransferContainerItemsOutputDTO
     */
    blockingErrorType?: BlockingErrorType;
    /**
     * 
     * @type {Array<ProductNotSuitableForTransferDTO>}
     * @memberof TransferContainerItemsOutputDTO
     */
    productsNotSuitableForTransfer?: Array<ProductNotSuitableForTransferDTO>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum TransferFailReason {
    HardAllocated = 'HardAllocated',
    DifferentExpirationDate = 'DifferentExpirationDate',
    DifferentOperationWithSameBarcode = 'DifferentOperationWithSameBarcode',
    NotEnoughStock = 'NotEnoughStock',
    DifferentLotNumber = 'DifferentLotNumber'
}

/**
 * 
 * @export
 * @interface TransferItemInputDTO
 */
export interface TransferItemInputDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferItemInputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferItemInputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {number}
     * @memberof TransferItemInputDTO
     */
    amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransferItemInputDTO
     */
    serialNumbers?: Array<string>;
}
/**
 * 
 * @export
 * @interface TransferItemOutputDTO
 */
export interface TransferItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferItemOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferItemOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {number}
     * @memberof TransferItemOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof TransferItemOutputDTO
     */
    imageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferItemOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferItemOutputDTO
     */
    barcodes?: string;
}
/**
 * 
 * @export
 * @interface TransferItemToQuarantineCommand
 */
export interface TransferItemToQuarantineCommand {
    /**
     * 
     * @type {string}
     * @memberof TransferItemToQuarantineCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferItemToQuarantineCommand
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferItemToQuarantineCommand
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferItemToQuarantineCommand
     */
    targetToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferItemToQuarantineCommand
     */
    inboundAddressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferItemToQuarantineCommand
     */
    imageUrl?: string;
    /**
     * 
     * @type {InboundProblemType}
     * @memberof TransferItemToQuarantineCommand
     */
    problemType?: InboundProblemType;
}
/**
 * 
 * @export
 * @interface TransferPackableItemsCommand
 */
export interface TransferPackableItemsCommand {
    /**
     * 
     * @type {string}
     * @memberof TransferPackableItemsCommand
     */
    sourceToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferPackableItemsCommand
     */
    targetToteLabel?: string;
}
/**
 * 
 * @export
 * @interface TransferPackingItemsToToteCommand
 */
export interface TransferPackingItemsToToteCommand {
    /**
     * 
     * @type {string}
     * @memberof TransferPackingItemsToToteCommand
     */
    dispatchAddressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferPackingItemsToToteCommand
     */
    cargoPackageLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferPackingItemsToToteCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {Array<CancelledPackingItemInputDTO>}
     * @memberof TransferPackingItemsToToteCommand
     */
    cancelledPackingItems?: Array<CancelledPackingItemInputDTO>;
}
/**
 * 
 * @export
 * @interface TransferProductInputDTO
 */
export interface TransferProductInputDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferProductInputDTO
     */
    productId?: string;
    /**
     * 
     * @type {number}
     * @memberof TransferProductInputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface TransferProductsToToteOutputDTO
 */
export interface TransferProductsToToteOutputDTO {
    /**
     * 
     * @type {Array<FailedTransferItemsOutputDTO>}
     * @memberof TransferProductsToToteOutputDTO
     */
    failedItems?: Array<FailedTransferItemsOutputDTO>;
    /**
     * 
     * @type {Array<TransferItemOutputDTO>}
     * @memberof TransferProductsToToteOutputDTO
     */
    transferItems?: Array<TransferItemOutputDTO>;
    /**
     * 
     * @type {PlaceToteToTrolleyOutputDTO}
     * @memberof TransferProductsToToteOutputDTO
     */
    toteContainedItems?: PlaceToteToTrolleyOutputDTO;
}
/**
 * 
 * @export
 * @interface TransferQuarantineToValidCommand
 */
export interface TransferQuarantineToValidCommand {
    /**
     * 
     * @type {string}
     * @memberof TransferQuarantineToValidCommand
     */
    sourceToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferQuarantineToValidCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof TransferQuarantineToValidCommand
     */
    amount?: number;
    /**
     * 
     * @type {QuarantineToValidTransferReason}
     * @memberof TransferQuarantineToValidCommand
     */
    validationReason?: QuarantineToValidTransferReason;
    /**
     * 
     * @type {string}
     * @memberof TransferQuarantineToValidCommand
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferQuarantineToValidCommand
     */
    targetToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferQuarantineToValidCommand
     */
    serialNumber?: string;
}
/**
 * 
 * @export
 * @interface TransferSelectedProductsToToteCommand
 */
export interface TransferSelectedProductsToToteCommand {
    /**
     * 
     * @type {string}
     * @memberof TransferSelectedProductsToToteCommand
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof TransferSelectedProductsToToteCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof TransferSelectedProductsToToteCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferSelectedProductsToToteCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {Array<TransferProductInputDTO>}
     * @memberof TransferSelectedProductsToToteCommand
     */
    transferProducts?: Array<TransferProductInputDTO>;
}
/**
 * 
 * @export
 * @interface TransferStockItemsCommand
 */
export interface TransferStockItemsCommand {
    /**
     * 
     * @type {string}
     * @memberof TransferStockItemsCommand
     */
    sourceCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferStockItemsCommand
     */
    targetCellLabel?: string;
    /**
     * 
     * @type {Array<TransferItemInputDTO>}
     * @memberof TransferStockItemsCommand
     */
    transferItems?: Array<TransferItemInputDTO>;
}
/**
 * 
 * @export
 * @interface TransferStockItemsToQuarantineCommand
 */
export interface TransferStockItemsToQuarantineCommand {
    /**
     * 
     * @type {string}
     * @memberof TransferStockItemsToQuarantineCommand
     */
    sourceCellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferStockItemsToQuarantineCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {StockToQuarantineTransferReason}
     * @memberof TransferStockItemsToQuarantineCommand
     */
    quarantineTransferReason?: StockToQuarantineTransferReason;
    /**
     * 
     * @type {string}
     * @memberof TransferStockItemsToQuarantineCommand
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferStockItemsToQuarantineCommand
     */
    notes?: string;
    /**
     * 
     * @type {number}
     * @memberof TransferStockItemsToQuarantineCommand
     */
    amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TransferStockItemsToQuarantineCommand
     */
    transferAllItems?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferStockItemsToQuarantineCommand
     */
    targetToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferStockItemsToQuarantineCommand
     */
    serialNumber?: string;
}
/**
 * 
 * @export
 * @interface TransferStockItemsToRestowCommand
 */
export interface TransferStockItemsToRestowCommand {
    /**
     * 
     * @type {string}
     * @memberof TransferStockItemsToRestowCommand
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferStockItemsToRestowCommand
     */
    productBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferStockItemsToRestowCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof TransferStockItemsToRestowCommand
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface TransferToQuarantineCommand
 */
export interface TransferToQuarantineCommand {
    /**
     * 
     * @type {string}
     * @memberof TransferToQuarantineCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferToQuarantineCommand
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferToQuarantineCommand
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferToQuarantineCommand
     */
    targetToteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof TransferToQuarantineCommand
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof TransferToQuarantineCommand
     */
    inboundAddressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferToQuarantineCommand
     */
    imageUrl?: string;
    /**
     * 
     * @type {InboundProblemType}
     * @memberof TransferToQuarantineCommand
     */
    problemType?: InboundProblemType;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum TransferToteItemFailReason {
    DifferentExpirationDate = 'DifferentExpirationDate',
    InvalidItemTypeToTransfer = 'InvalidItemTypeToTransfer',
    InvalidItemTypeForTargetTote = 'InvalidItemTypeForTargetTote',
    DifferentLotNumber = 'DifferentLotNumber'
}

/**
 * 
 * @export
 * @interface TransferToteItemInputDTO
 */
export interface TransferToteItemInputDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferToteItemInputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferToteItemInputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {number}
     * @memberof TransferToteItemInputDTO
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface TransferToteItemOutputDTO
 */
export interface TransferToteItemOutputDTO {
    /**
     * 
     * @type {Array<TransferItemOutputDTO>}
     * @memberof TransferToteItemOutputDTO
     */
    transferredItems?: Array<TransferItemOutputDTO>;
    /**
     * 
     * @type {Array<FailedTransferToteItemsOutputDTO>}
     * @memberof TransferToteItemOutputDTO
     */
    failedTransfers?: Array<FailedTransferToteItemsOutputDTO>;
}
/**
 * 
 * @export
 * @interface TransferToteItemsToToteCommand
 */
export interface TransferToteItemsToToteCommand {
    /**
     * 
     * @type {string}
     * @memberof TransferToteItemsToToteCommand
     */
    sourceToteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferToteItemsToToteCommand
     */
    targetToteLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferToteItemsToToteCommand
     */
    transferAllItems?: boolean;
    /**
     * 
     * @type {Array<TransferToteItemInputDTO>}
     * @memberof TransferToteItemsToToteCommand
     */
    transferItems?: Array<TransferToteItemInputDTO>;
}
/**
 * 
 * @export
 * @interface TransferTrolleyDetailsOutputDTO
 */
export interface TransferTrolleyDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferTrolleyDetailsOutputDTO
     */
    transferTrolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof TransferTrolleyDetailsOutputDTO
     */
    percentage?: number;
    /**
     * 
     * @type {string}
     * @memberof TransferTrolleyDetailsOutputDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferTrolleyDetailsOutputDTO
     */
    lastSeenAt?: string;
    /**
     * 
     * @type {number}
     * @memberof TransferTrolleyDetailsOutputDTO
     */
    totalToteCount?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum TransferTrolleyToteStatus {
    None = 'None',
    WaitingStockCount = 'WaitingStockCount',
    AwaitingCustomerServicesReview = 'AwaitingCustomerServicesReview',
    WaitingForPicking = 'WaitingForPicking',
    Packable = 'Packable',
    Cancelled = 'Cancelled'
}

/**
 * 
 * @export
 * @interface TransferTrolleyTotesQueryOutputDTO
 */
export interface TransferTrolleyTotesQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferTrolleyTotesQueryOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferTrolleyTotesQueryOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferTrolleyTotesQueryOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferTrolleyTotesQueryOutputDTO
     */
    salesOrderOperationName?: string;
    /**
     * 
     * @type {number}
     * @memberof TransferTrolleyTotesQueryOutputDTO
     */
    toteSalesOrderLineItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof TransferTrolleyTotesQueryOutputDTO
     */
    toteTotalItemAmount?: number;
    /**
     * 
     * @type {TransferTrolleyToteStatus}
     * @memberof TransferTrolleyTotesQueryOutputDTO
     */
    transferTrolleyToteStatus?: TransferTrolleyToteStatus;
}
/**
 * 
 * @export
 * @interface TransferTrolleyTotesQueryOutputDTODynamicQueryOutputDTO
 */
export interface TransferTrolleyTotesQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<TransferTrolleyTotesQueryOutputDTO>}
     * @memberof TransferTrolleyTotesQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<TransferTrolleyTotesQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof TransferTrolleyTotesQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface TransformationNode
 */
export interface TransformationNode {
    /**
     * 
     * @type {TransformationNodeKind}
     * @memberof TransformationNode
     */
    kind?: TransformationNodeKind;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum TransformationNodeKind {
    Aggregate = 'Aggregate',
    GroupBy = 'GroupBy',
    Filter = 'Filter',
    Compute = 'Compute',
    Expand = 'Expand'
}

/**
 * 
 * @export
 * @interface TrendyolAck
 */
export interface TrendyolAck {
    /**
     * 
     * @type {boolean}
     * @memberof TrendyolAck
     */
    isSuccess?: boolean;
}
/**
 * 
 * @export
 * @interface TrendyolBacklogItemInputDTO
 */
export interface TrendyolBacklogItemInputDTO {
    /**
     * 
     * @type {string}
     * @memberof TrendyolBacklogItemInputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {number}
     * @memberof TrendyolBacklogItemInputDTO
     */
    deci?: number;
    /**
     * 
     * @type {string}
     * @memberof TrendyolBacklogItemInputDTO
     */
    uom?: string;
}
/**
 * 
 * @export
 * @interface TrendyolError
 */
export interface TrendyolError {
    /**
     * 
     * @type {string}
     * @memberof TrendyolError
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof TrendyolError
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof TrendyolError
     */
    details?: object;
}
/**
 * 
 * @export
 * @interface TrendyolErrorResponse
 */
export interface TrendyolErrorResponse {
    /**
     * 
     * @type {TrendyolError}
     * @memberof TrendyolErrorResponse
     */
    error?: TrendyolError;
    /**
     * 
     * @type {TrendyolMeta}
     * @memberof TrendyolErrorResponse
     */
    meta?: TrendyolMeta;
}
/**
 * 
 * @export
 * @interface TrendyolMeta
 */
export interface TrendyolMeta {
    /**
     * 
     * @type {string}
     * @memberof TrendyolMeta
     */
    correlationId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrendyolMeta
     */
    timestamp?: string;
}
/**
 * 
 * @export
 * @interface TrendyolReadyToCollectItemInputDTO
 */
export interface TrendyolReadyToCollectItemInputDTO {
    /**
     * 
     * @type {string}
     * @memberof TrendyolReadyToCollectItemInputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof TrendyolReadyToCollectItemInputDTO
     */
    currentLocation?: string;
}
/**
 * 
 * @export
 * @interface TrolleyDetailOutputDTO
 */
export interface TrolleyDetailOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof TrolleyDetailOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TrolleyDetailOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof TrolleyDetailOutputDTO
     */
    type?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof TrolleyDetailOutputDTO
     */
    variation?: string;
    /**
     * 
     * @type {number}
     * @memberof TrolleyDetailOutputDTO
     */
    containerCount?: number;
    /**
     * 
     * @type {string}
     * @memberof TrolleyDetailOutputDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof TrolleyDetailOutputDTO
     */
    lastSeenAt?: string;
    /**
     * 
     * @type {string}
     * @memberof TrolleyDetailOutputDTO
     */
    operatorName?: string;
    /**
     * 
     * @type {Availability}
     * @memberof TrolleyDetailOutputDTO
     */
    availability?: Availability;
    /**
     * 
     * @type {BatchTrolleyState}
     * @memberof TrolleyDetailOutputDTO
     */
    batchTrolleyState?: BatchTrolleyState;
    /**
     * 
     * @type {string}
     * @memberof TrolleyDetailOutputDTO
     */
    sortingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrolleyDetailOutputDTO
     */
    relatedBatchTrolleyLabel?: string;
}
/**
 * 
 * @export
 * @interface TrolleyOutputDTO
 */
export interface TrolleyOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof TrolleyOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {Array<ToteContainerDTO>}
     * @memberof TrolleyOutputDTO
     */
    totes?: Array<ToteContainerDTO>;
}
/**
 * 
 * @export
 * @interface TrolleyStatusOutputDTO
 */
export interface TrolleyStatusOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof TrolleyStatusOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TrolleyStatusOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof TrolleyStatusOutputDTO
     */
    type?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof TrolleyStatusOutputDTO
     */
    variation?: string;
    /**
     * 
     * @type {number}
     * @memberof TrolleyStatusOutputDTO
     */
    containerCount?: number;
    /**
     * 
     * @type {string}
     * @memberof TrolleyStatusOutputDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof TrolleyStatusOutputDTO
     */
    lastSeenAt?: string;
    /**
     * 
     * @type {string}
     * @memberof TrolleyStatusOutputDTO
     */
    operatorId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrolleyStatusOutputDTO
     */
    operatorName?: string;
    /**
     * 
     * @type {Availability}
     * @memberof TrolleyStatusOutputDTO
     */
    availability?: Availability;
    /**
     * 
     * @type {BatchTrolleyState}
     * @memberof TrolleyStatusOutputDTO
     */
    batchTrolleyState?: BatchTrolleyState;
}
/**
 * 
 * @export
 * @interface TrolleyStatusOutputDTODynamicQueryOutputDTO
 */
export interface TrolleyStatusOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<TrolleyStatusOutputDTO>}
     * @memberof TrolleyStatusOutputDTODynamicQueryOutputDTO
     */
    data?: Array<TrolleyStatusOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof TrolleyStatusOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface TrolleyToteOutputDTO
 */
export interface TrolleyToteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof TrolleyToteOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof TrolleyToteOutputDTO
     */
    productAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof TrolleyToteOutputDTO
     */
    productVariety?: number;
}
/**
 * 
 * @export
 * @interface TrolleyToteOutputDTODynamicQueryOutputDTO
 */
export interface TrolleyToteOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<TrolleyToteOutputDTO>}
     * @memberof TrolleyToteOutputDTODynamicQueryOutputDTO
     */
    data?: Array<TrolleyToteOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof TrolleyToteOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface TypeObjectKeyValuePair
 */
export interface TypeObjectKeyValuePair {
    /**
     * 
     * @type {string}
     * @memberof TypeObjectKeyValuePair
     */
    key?: string;
    /**
     * 
     * @type {object}
     * @memberof TypeObjectKeyValuePair
     */
    value?: object;
}
/**
 * 
 * @export
 * @interface UnPickedMissingItemsOutputDTO
 */
export interface UnPickedMissingItemsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UnPickedMissingItemsOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof UnPickedMissingItemsOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof UnPickedMissingItemsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof UnPickedMissingItemsOutputDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof UnPickedMissingItemsOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UnPickedMissingItemsOutputDTO
     */
    barcodes?: Array<string>;
}
/**
 * 
 * @export
 * @interface UnassignHOVQuarantineToteCommand
 */
export interface UnassignHOVQuarantineToteCommand {
    /**
     * 
     * @type {string}
     * @memberof UnassignHOVQuarantineToteCommand
     */
    packingQuarantineProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof UnassignHOVQuarantineToteCommand
     */
    quarantineToteLabel?: string;
}
/**
 * 
 * @export
 * @interface UnassignQuarantineToteCommand
 */
export interface UnassignQuarantineToteCommand {
    /**
     * 
     * @type {string}
     * @memberof UnassignQuarantineToteCommand
     */
    packingQuarantineProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof UnassignQuarantineToteCommand
     */
    quarantineToteLabel?: string;
}
/**
 * 
 * @export
 * @interface UnassignableOrders
 */
export interface UnassignableOrders {
    /**
     * 
     * @type {string}
     * @memberof UnassignableOrders
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof UnassignableOrders
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UnassignableOrders
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UnassignableOrders
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {SalesOrderState}
     * @memberof UnassignableOrders
     */
    state?: SalesOrderState;
    /**
     * 
     * @type {SalesOrderCreatedState}
     * @memberof UnassignableOrders
     */
    createdState?: SalesOrderCreatedState;
}
/**
 * 
 * @export
 * @interface UnassignableSalesOrdersOutputDTO
 */
export interface UnassignableSalesOrdersOutputDTO {
    /**
     * 
     * @type {Array<UnassignableOrders>}
     * @memberof UnassignableSalesOrdersOutputDTO
     */
    unassignableOrders?: Array<UnassignableOrders>;
}
/**
 * 
 * @export
 * @interface UnassignedAlreadyStagedSalesOrdersOutputDTO
 */
export interface UnassignedAlreadyStagedSalesOrdersOutputDTO {
    /**
     * 
     * @type {UnassignableSalesOrdersOutputDTO}
     * @memberof UnassignedAlreadyStagedSalesOrdersOutputDTO
     */
    assignmentFailedOrders?: UnassignableSalesOrdersOutputDTO;
}
/**
 * 
 * @export
 * @interface UndefinedReturnPackageQueryOutputDTO
 */
export interface UndefinedReturnPackageQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UndefinedReturnPackageQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UndefinedReturnPackageQueryOutputDTO
     */
    trackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof UndefinedReturnPackageQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UndefinedReturnPackageQueryOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UndefinedReturnPackageQueryOutputDTO
     */
    cargoTrackingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UndefinedReturnPackageQueryOutputDTO
     */
    markedAsUndefinedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof UndefinedReturnPackageQueryOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof UndefinedReturnPackageQueryOutputDTO
     */
    operation?: OperationOutputDTO;
}
/**
 * 
 * @export
 * @interface UndefinedReturnPackageQueryOutputDTODynamicQueryOutputDTO
 */
export interface UndefinedReturnPackageQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<UndefinedReturnPackageQueryOutputDTO>}
     * @memberof UndefinedReturnPackageQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<UndefinedReturnPackageQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof UndefinedReturnPackageQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface UnmountToteAndCompletePickingProcessForHOVPickingCommand
 */
export interface UnmountToteAndCompletePickingProcessForHOVPickingCommand {
    /**
     * 
     * @type {string}
     * @memberof UnmountToteAndCompletePickingProcessForHOVPickingCommand
     */
    hovPickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UnmountToteAndCompletePickingProcessForHOVPickingCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UnmountToteAndCompletePickingProcessForHOVPickingCommand
     */
    dropAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface UnmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand
 */
export interface UnmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand {
    /**
     * 
     * @type {string}
     * @memberof UnmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand
     */
    hovPickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UnmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UnmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand
     */
    problemSolverAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface UnmountToteFromBatchPickingTrolleyCommand
 */
export interface UnmountToteFromBatchPickingTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromBatchPickingTrolleyCommand
     */
    batchPickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromBatchPickingTrolleyCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromBatchPickingTrolleyCommand
     */
    dropAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface UnmountToteFromFastPackPickingTrolleyCommandOutputDTO
 */
export interface UnmountToteFromFastPackPickingTrolleyCommandOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromFastPackPickingTrolleyCommandOutputDTO
     */
    nextToteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof UnmountToteFromFastPackPickingTrolleyCommandOutputDTO
     */
    nextToteContainedItemsAmount?: number;
}
/**
 * 
 * @export
 * @interface UnmountToteFromHOVPickingTrolleyCommandOutputDTO
 */
export interface UnmountToteFromHOVPickingTrolleyCommandOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromHOVPickingTrolleyCommandOutputDTO
     */
    nextToteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof UnmountToteFromHOVPickingTrolleyCommandOutputDTO
     */
    nextToteContainedItemsAmount?: number;
}
/**
 * 
 * @export
 * @interface UnmountToteFromRASTrolleyCommand
 */
export interface UnmountToteFromRASTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromRASTrolleyCommand
     */
    trolleyLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof UnmountToteFromRASTrolleyCommand
     */
    putAwayReferenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromRASTrolleyCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromRASTrolleyCommand
     */
    inboundLabel?: string;
}
/**
 * 
 * @export
 * @interface UnmountToteFromSingleItemFastPackPickingTrolleyCommand
 */
export interface UnmountToteFromSingleItemFastPackPickingTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromSingleItemFastPackPickingTrolleyCommand
     */
    singleItemFastPackPickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromSingleItemFastPackPickingTrolleyCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromSingleItemFastPackPickingTrolleyCommand
     */
    dropAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface UnmountToteFromSingleItemPickingTrolleyCommand
 */
export interface UnmountToteFromSingleItemPickingTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromSingleItemPickingTrolleyCommand
     */
    singleItemPickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromSingleItemPickingTrolleyCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromSingleItemPickingTrolleyCommand
     */
    dropAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface UnmountToteFromSingleItemPickingTrolleyCommandOutputDTO
 */
export interface UnmountToteFromSingleItemPickingTrolleyCommandOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromSingleItemPickingTrolleyCommandOutputDTO
     */
    nextToteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof UnmountToteFromSingleItemPickingTrolleyCommandOutputDTO
     */
    nextToteContainedItemsAmount?: number;
}
/**
 * 
 * @export
 * @interface UnmountToteFromToteSelectivePickingTrolleyCommand
 */
export interface UnmountToteFromToteSelectivePickingTrolleyCommand {
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromToteSelectivePickingTrolleyCommand
     */
    pickingTrolleyLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromToteSelectivePickingTrolleyCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromToteSelectivePickingTrolleyCommand
     */
    dropAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface UnmountToteFromToteSelectivePickingTrolleyCommandOutputDTO
 */
export interface UnmountToteFromToteSelectivePickingTrolleyCommandOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UnmountToteFromToteSelectivePickingTrolleyCommandOutputDTO
     */
    nextToteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof UnmountToteFromToteSelectivePickingTrolleyCommandOutputDTO
     */
    nextToteContainedItemsAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof UnmountToteFromToteSelectivePickingTrolleyCommandOutputDTO
     */
    remainingToteCount?: number;
}
/**
 * 
 * @export
 * @interface UnprintedWaybillOrderDTO
 */
export interface UnprintedWaybillOrderDTO {
    /**
     * 
     * @type {string}
     * @memberof UnprintedWaybillOrderDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof UnprintedWaybillOrderDTO
     */
    cargoPackageCount?: number;
}
/**
 * 
 * @export
 * @interface UpdateCargoDetailsIntegrationCodeProblemCommand
 */
export interface UpdateCargoDetailsIntegrationCodeProblemCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateCargoDetailsIntegrationCodeProblemCommand
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCargoDetailsIntegrationCodeProblemCommand
     */
    newCargoCode?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCargoDetailsIntegrationCodeProblemCommand
     */
    newCargoDocumentUrl?: string;
}
/**
 * 
 * @export
 * @interface UpdateCarrierInfoCommand
 */
export interface UpdateCarrierInfoCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierInfoCommand
     */
    waybillId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierInfoCommand
     */
    carrierInfoId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierInfoCommand
     */
    driverFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierInfoCommand
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierInfoCommand
     */
    arrivedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierInfoCommand
     */
    licensePlate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierInfoCommand
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierInfoCommand
     */
    personId?: string;
}
/**
 * 
 * @export
 * @interface UpdateCarrierInfoOutputDTO
 */
export interface UpdateCarrierInfoOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierInfoOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierInfoOutputDTO
     */
    waybillId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierInfoOutputDTO
     */
    driverFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierInfoOutputDTO
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierInfoOutputDTO
     */
    arrivedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierInfoOutputDTO
     */
    licensePlate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierInfoOutputDTO
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierInfoOutputDTO
     */
    personId?: string;
}
/**
 * 
 * @export
 * @interface UpdateCarrierPreferencePriorityCommand
 */
export interface UpdateCarrierPreferencePriorityCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierPreferencePriorityCommand
     */
    operationId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierPreferencePriorityCommand
     */
    preferenceId?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCarrierPreferencePriorityCommand
     */
    priority?: number;
}
/**
 * 
 * @export
 * @interface UpdateCarrierVolumetricWeightLimitCommand
 */
export interface UpdateCarrierVolumetricWeightLimitCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierVolumetricWeightLimitCommand
     */
    carrierName?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCarrierVolumetricWeightLimitCommand
     */
    volumetricWeightLimitPerPackage?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCarrierVolumetricWeightLimitCommand
     */
    volumetricWeightLimitPerOrder?: number;
}
/**
 * 
 * @export
 * @interface UpdateDamagedItemAmountCommand
 */
export interface UpdateDamagedItemAmountCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateDamagedItemAmountCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDamagedItemAmountCommand
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDamagedItemAmountCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDamagedItemAmountCommand
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDamagedItemAmountCommand
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDamagedItemAmountCommand
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDamagedItemAmountCommand
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDamagedItemAmountCommand
     */
    problemReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface UpdateDispatchCompletedAtCommand
 */
export interface UpdateDispatchCompletedAtCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateDispatchCompletedAtCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDispatchCompletedAtCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDispatchCompletedAtCommand
     */
    completedAt?: string;
}
/**
 * 
 * @export
 * @interface UpdateGiftNoteCommand
 */
export interface UpdateGiftNoteCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateGiftNoteCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGiftNoteCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGiftNoteCommand
     */
    newGiftMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGiftNoteCommand
     */
    newPackageNote?: string;
}
/**
 * 
 * @export
 * @interface UpdateGiftNoteOutputDTO
 */
export interface UpdateGiftNoteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateGiftNoteOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {Array<UpdatedGiftNoteItemDTO>}
     * @memberof UpdateGiftNoteOutputDTO
     */
    updatedItems?: Array<UpdatedGiftNoteItemDTO>;
}
/**
 * 
 * @export
 * @interface UpdateInventoryItemLotNumberCommand
 */
export interface UpdateInventoryItemLotNumberCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryItemLotNumberCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryItemLotNumberCommand
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryItemLotNumberCommand
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryItemLotNumberCommand
     */
    newLotNumber?: string;
}
/**
 * 
 * @export
 * @interface UpdateInventoryItemLotNumberOutputDTO
 */
export interface UpdateInventoryItemLotNumberOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryItemLotNumberOutputDTO
     */
    containerLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryItemLotNumberOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInventoryItemLotNumberOutputDTO
     */
    newLotNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateInventoryItemLotNumberOutputDTO
     */
    updatedCount?: number;
}
/**
 * 
 * @export
 * @interface UpdateLostItemProblemSolutionTypeCommand
 */
export interface UpdateLostItemProblemSolutionTypeCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateLostItemProblemSolutionTypeCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLostItemProblemSolutionTypeCommand
     */
    problemReferenceNumber?: string;
    /**
     * 
     * @type {LostItemProblemSolutionType}
     * @memberof UpdateLostItemProblemSolutionTypeCommand
     */
    solutionType?: LostItemProblemSolutionType;
    /**
     * 
     * @type {string}
     * @memberof UpdateLostItemProblemSolutionTypeCommand
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLostItemProblemSolutionTypeCommand
     */
    quantityToMarkAsMissing?: number;
}
/**
 * 
 * @export
 * @interface UpdateManualVasRecordCommand
 */
export interface UpdateManualVasRecordCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateManualVasRecordCommand
     */
    manualVasId?: number;
    /**
     * 
     * @type {ManualVasRecordInputDto}
     * @memberof UpdateManualVasRecordCommand
     */
    manualVasRecord?: ManualVasRecordInputDto;
}
/**
 * 
 * @export
 * @interface UpdateMasterCartonCommand
 */
export interface UpdateMasterCartonCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterCartonCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterCartonCommand
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterCartonCommand
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterCartonCommand
     */
    imageUrl?: string;
    /**
     * 
     * @type {ProductType}
     * @memberof UpdateMasterCartonCommand
     */
    type?: ProductType;
    /**
     * 
     * @type {TaxIncludedSalePriceInputDTO}
     * @memberof UpdateMasterCartonCommand
     */
    taxIncludedSalePrice?: TaxIncludedSalePriceInputDTO;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateMasterCartonCommand
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterCartonCommand
     */
    innerProductSKU?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterCartonCommand
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface UpdateOpenAPIIntegrationCommand
 */
export interface UpdateOpenAPIIntegrationCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateOpenAPIIntegrationCommand
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOpenAPIIntegrationCommand
     */
    name?: string;
    /**
     * 
     * @type {IntegrationState}
     * @memberof UpdateOpenAPIIntegrationCommand
     */
    state?: IntegrationState;
}
/**
 * 
 * @export
 * @interface UpdateOpenAPIIntegrationOutputDTO
 */
export interface UpdateOpenAPIIntegrationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateOpenAPIIntegrationOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOpenAPIIntegrationOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {IntegrationState}
     * @memberof UpdateOpenAPIIntegrationOutputDTO
     */
    state?: IntegrationState;
}
/**
 * 
 * @export
 * @interface UpdateOperationB2CRoadRunnerInvoiceCustomerIdCommand
 */
export interface UpdateOperationB2CRoadRunnerInvoiceCustomerIdCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationB2CRoadRunnerInvoiceCustomerIdCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationB2CRoadRunnerInvoiceCustomerIdCommand
     */
    b2CRoadRunnerInvoiceCustomerId?: string;
}
/**
 * 
 * @export
 * @interface UpdateOperationB2CRoadRunnerInvoiceCustomerIdOutputDTO
 */
export interface UpdateOperationB2CRoadRunnerInvoiceCustomerIdOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationB2CRoadRunnerInvoiceCustomerIdOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationB2CRoadRunnerInvoiceCustomerIdOutputDTO
     */
    b2BRoadRunnerInvoiceCustomerId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationB2CRoadRunnerInvoiceCustomerIdOutputDTO
     */
    b2CRoadRunnerInvoiceCustomerId?: string;
}
/**
 * 
 * @export
 * @interface UpdateOperationClusterCommand
 */
export interface UpdateOperationClusterCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationClusterCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationClusterCommand
     */
    cluster?: string;
}
/**
 * 
 * @export
 * @interface UpdateOperationClusterOutputDTO
 */
export interface UpdateOperationClusterOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationClusterOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationClusterOutputDTO
     */
    cluster?: string;
}
/**
 * 
 * @export
 * @interface UpdateOperationCutOffTimesCommand
 */
export interface UpdateOperationCutOffTimesCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesCommand
     */
    cutoffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesCommand
     */
    targetDispatchTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesCommand
     */
    sameDeliveryFirstCutOffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesCommand
     */
    sameDeliveryFirstTargetDispatchTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesCommand
     */
    sameDeliverySecondCutOffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesCommand
     */
    sameDeliverySecondTargetDispatchTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesCommand
     */
    marketplaceCutOffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesCommand
     */
    marketplaceTargetDispatchTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesCommand
     */
    orderSoldAtCutoffTime?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOperationCutOffTimesCommand
     */
    useBothDatesForCutOff?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateOperationCutOffTimesOutputDTO
 */
export interface UpdateOperationCutOffTimesOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesOutputDTO
     */
    cutoffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesOutputDTO
     */
    targetDispatchTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesOutputDTO
     */
    sameDeliveryFirstCutOffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesOutputDTO
     */
    sameDeliveryFirstTargetDispatchTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesOutputDTO
     */
    sameDeliverySecondCutOffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesOutputDTO
     */
    sameDeliverySecondTargetDispatchTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesOutputDTO
     */
    marketplaceCutOffTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesOutputDTO
     */
    marketplaceTargetDispatchTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationCutOffTimesOutputDTO
     */
    orderSoldAtCutoffTime?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOperationCutOffTimesOutputDTO
     */
    useBothDatesForCutOff?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateOperationMultiItemVehicleVariationCommand
 */
export interface UpdateOperationMultiItemVehicleVariationCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationMultiItemVehicleVariationCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationMultiItemVehicleVariationCommand
     */
    multiItemVehicleVariation?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationMultiItemVehicleVariationCommand
     */
    multiItemVehicleVariationSalesLocationFilter?: string;
}
/**
 * 
 * @export
 * @interface UpdateOperationMultiItemVehicleVariationOutputDTO
 */
export interface UpdateOperationMultiItemVehicleVariationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationMultiItemVehicleVariationOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationMultiItemVehicleVariationOutputDTO
     */
    multiItemVehicleVariation?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOperationMultiItemVehicleVariationOutputDTO
     */
    multiItemVehicleVariationSalesLocationFilter?: string;
}
/**
 * 
 * @export
 * @interface UpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand
 */
export interface UpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand {
    /**
     * 
     * @type {PickingTrolleySelectionConfigurationPickingType}
     * @memberof UpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand
     */
    pickingType?: PickingTrolleySelectionConfigurationPickingType;
    /**
     * 
     * @type {string}
     * @memberof UpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand
     */
    variation?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand
     */
    capacity?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand
     */
    minSalesOrderToStart?: number;
    /**
     * 
     * @type {PickingRouteType}
     * @memberof UpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand
     */
    pickingRouteType?: PickingRouteType;
}
/**
 * 
 * @export
 * @interface UpdatePreferredCargoCarrierCommand
 */
export interface UpdatePreferredCargoCarrierCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdatePreferredCargoCarrierCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePreferredCargoCarrierCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePreferredCargoCarrierCommand
     */
    carrierName?: string;
}
/**
 * 
 * @export
 * @interface UpdatePreferredCargoCarrierOutputDTO
 */
export interface UpdatePreferredCargoCarrierOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdatePreferredCargoCarrierOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePreferredCargoCarrierOutputDTO
     */
    previousPreferredCargoCarrier?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePreferredCargoCarrierOutputDTO
     */
    newPreferredCargoCarrier?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePreferredCargoCarrierOutputDTO
     */
    shippingMethod?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePreferredCargoCarrierOutputDTO
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface UpdatePrinterAddressCommand
 */
export interface UpdatePrinterAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdatePrinterAddressCommand
     */
    printerName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePrinterAddressCommand
     */
    oldAddressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePrinterAddressCommand
     */
    newAddressLabel?: string;
}
/**
 * 
 * @export
 * @interface UpdateProductBarcodeCommand
 */
export interface UpdateProductBarcodeCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBarcodeCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBarcodeCommand
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBarcodeCommand
     */
    oldBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBarcodeCommand
     */
    newBarcode?: string;
}
/**
 * 
 * @export
 * @interface UpdateProductBarcodeOutputDTO
 */
export interface UpdateProductBarcodeOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBarcodeOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBarcodeOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBarcodeOutputDTO
     */
    oldBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBarcodeOutputDTO
     */
    newBarcode?: string;
}
/**
 * 
 * @export
 * @interface UpdateProductDimensionsCommand
 */
export interface UpdateProductDimensionsCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductDimensionsCommand
     */
    height?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductDimensionsCommand
     */
    width?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductDimensionsCommand
     */
    length?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductDimensionsCommand
     */
    weight?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductDimensionsCommand
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductDimensionsCommand
     */
    operation?: string;
}
/**
 * 
 * @export
 * @interface UpdateProductSkuCommand
 */
export interface UpdateProductSkuCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductSkuCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductSkuCommand
     */
    currentSKU?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductSkuCommand
     */
    newSKU?: string;
}
/**
 * 
 * @export
 * @interface UpdateProductSkuOutputDTO
 */
export interface UpdateProductSkuOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductSkuOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductSkuOutputDTO
     */
    oldSKU?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductSkuOutputDTO
     */
    newSKU?: string;
}
/**
 * 
 * @export
 * @interface UpdatePurchaseOrderExpectedAmountCommand
 */
export interface UpdatePurchaseOrderExpectedAmountCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseOrderExpectedAmountCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseOrderExpectedAmountCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseOrderExpectedAmountCommand
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePurchaseOrderExpectedAmountCommand
     */
    expectedAmount?: number;
}
/**
 * 
 * @export
 * @interface UpdateRebinTrolleyStateToPackingCommand
 */
export interface UpdateRebinTrolleyStateToPackingCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateRebinTrolleyStateToPackingCommand
     */
    addressLabel?: string;
}
/**
 * 
 * @export
 * @interface UpdateRebinTrolleyStateToPackingOutputDTO
 */
export interface UpdateRebinTrolleyStateToPackingOutputDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateRebinTrolleyStateToPackingOutputDTO
     */
    updatedRebinTrolleys?: Array<string>;
    /**
     * 
     * @type {Array<FailedTrolleyInfo>}
     * @memberof UpdateRebinTrolleyStateToPackingOutputDTO
     */
    failedRebinTrolleys?: Array<FailedTrolleyInfo>;
}
/**
 * 
 * @export
 * @interface UpdateReceivedItemAmountCommand
 */
export interface UpdateReceivedItemAmountCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateReceivedItemAmountCommand
     */
    receivingProcessId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReceivedItemAmountCommand
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReceivedItemAmountCommand
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReceivedItemAmountCommand
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReceivedItemAmountCommand
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateReceivedItemAmountCommand
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface UpdateReturnLineItemsStateCommand
 */
export interface UpdateReturnLineItemsStateCommand {
    /**
     * 
     * @type {Array<ReturnLineItemUpdateRequest>}
     * @memberof UpdateReturnLineItemsStateCommand
     */
    updates?: Array<ReturnLineItemUpdateRequest>;
}
/**
 * 
 * @export
 * @interface UpdateReturnLineItemsStateOutputDTO
 */
export interface UpdateReturnLineItemsStateOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof UpdateReturnLineItemsStateOutputDTO
     */
    updatedCount?: number;
}
/**
 * 
 * @export
 * @interface UpdateSalesOrderCargoInfoCommand
 */
export interface UpdateSalesOrderCargoInfoCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderCargoInfoCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderCargoInfoCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderCargoInfoCommand
     */
    preferredCargoCarrier?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderCargoInfoCommand
     */
    cargoCode?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderCargoInfoCommand
     */
    cargoDocument?: string;
}
/**
 * 
 * @export
 * @interface UpdateSalesOrderCustomerInfoCommand
 */
export interface UpdateSalesOrderCustomerInfoCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderCustomerInfoCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderCustomerInfoCommand
     */
    operationName?: string;
    /**
     * 
     * @type {SalesOrderAddressInputDTO}
     * @memberof UpdateSalesOrderCustomerInfoCommand
     */
    addressInfo?: SalesOrderAddressInputDTO;
}
/**
 * 
 * @export
 * @interface UpdateSalesOrderDeliveryTypeToManualCommand
 */
export interface UpdateSalesOrderDeliveryTypeToManualCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderDeliveryTypeToManualCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderDeliveryTypeToManualCommand
     */
    salesOrderReferenceNumber?: string;
}
/**
 * 
 * @export
 * @interface UpdateSalesOrderShippingAddressCommand
 */
export interface UpdateSalesOrderShippingAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderShippingAddressCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderShippingAddressCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderShippingAddressCommand
     */
    addressFirstLine?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderShippingAddressCommand
     */
    addressSecondLine?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderShippingAddressCommand
     */
    district?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderShippingAddressCommand
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderShippingAddressCommand
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderShippingAddressCommand
     */
    zipCode?: string;
}
/**
 * 
 * @export
 * @interface UpdateSalesOrderShippingTrackingIdCommand
 */
export interface UpdateSalesOrderShippingTrackingIdCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderShippingTrackingIdCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderShippingTrackingIdCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderShippingTrackingIdCommand
     */
    shippingTrackingId?: string;
}
/**
 * 
 * @export
 * @interface UpdateSalesOrderStatesCommand
 */
export interface UpdateSalesOrderStatesCommand {
    /**
     * 
     * @type {Array<UpdateSalesOrderStatesInputDTO>}
     * @memberof UpdateSalesOrderStatesCommand
     */
    salesOrders?: Array<UpdateSalesOrderStatesInputDTO>;
}
/**
 * 
 * @export
 * @interface UpdateSalesOrderStatesInputDTO
 */
export interface UpdateSalesOrderStatesInputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderStatesInputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSalesOrderStatesInputDTO
     */
    referenceNumber?: string;
}
/**
 * 
 * @export
 * @interface UpdateSingleItemFastPackThresholdCommand
 */
export interface UpdateSingleItemFastPackThresholdCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateSingleItemFastPackThresholdCommand
     */
    operationName?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateSingleItemFastPackThresholdCommand
     */
    singleItemFastPackThreshold?: number;
}
/**
 * 
 * @export
 * @interface UpdateSingleItemFastPackThresholdOutputDTO
 */
export interface UpdateSingleItemFastPackThresholdOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateSingleItemFastPackThresholdOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateSingleItemFastPackThresholdOutputDTO
     */
    singleItemFastPackThreshold?: number;
}
/**
 * 
 * @export
 * @interface UpdateSorterCommand
 */
export interface UpdateSorterCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateSorterCommand
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSorterCommand
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateSorterCommand
     */
    exitPointCount?: number;
}
/**
 * 
 * @export
 * @interface UpdateStockCellTypeCommand
 */
export interface UpdateStockCellTypeCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateStockCellTypeCommand
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateStockCellTypeCommand
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateStockCellTypeCommand
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateStockCellTypeCommand
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateStockCellTypeCommand
     */
    depth?: number;
}
/**
 * 
 * @export
 * @interface UpdateStockCountingListConfigurationsCommand
 */
export interface UpdateStockCountingListConfigurationsCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateStockCountingListConfigurationsCommand
     */
    tenantName?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateStockCountingListConfigurationsCommand
     */
    stockCountingListCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateStockCountingListConfigurationsCommand
     */
    stockCountingListCountingStartThreshold?: number;
    /**
     * 
     * @type {StockCountingListType}
     * @memberof UpdateStockCountingListConfigurationsCommand
     */
    stockCountingListType?: StockCountingListType;
}
/**
 * 
 * @export
 * @interface UpdateStockZoneCommand
 */
export interface UpdateStockZoneCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateStockZoneCommand
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStockZoneCommand
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateStockZoneCommand
     */
    priority?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateStockZoneCommand
     */
    maxPickingCapacity?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateStockZoneCommand
     */
    stockAddresses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateStockZoneCommand
     */
    productCatalog?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateStockZoneOutputDTO
 */
export interface UpdateStockZoneOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof UpdateStockZoneOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateStockZoneOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStockZoneOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateStockZoneOutputDTO
     */
    priority?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateStockZoneOutputDTO
     */
    maxPickingCapacity?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateStockZoneOutputDTO
     */
    stockAddresses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateStockZoneOutputDTO
     */
    productCatalog?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateSubZoneCommand
 */
export interface UpdateSubZoneCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateSubZoneCommand
     */
    subZoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubZoneCommand
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSubZoneCommand
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSubZoneCommand
     */
    isDefault?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateTenantConfigurationCommand
 */
export interface UpdateTenantConfigurationCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantConfigurationCommand
     */
    tenantName?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTenantConfigurationCommand
     */
    srcListCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTenantConfigurationCommand
     */
    srcListThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTenantConfigurationCommand
     */
    ccListCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTenantConfigurationCommand
     */
    ccListThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTenantConfigurationCommand
     */
    sbcListCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTenantConfigurationCommand
     */
    sbcListThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTenantConfigurationCommand
     */
    qualityPutAwayPercentage?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantConfigurationCommand
     */
    isSimpleFlowActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantConfigurationCommand
     */
    isMissingItemPickingInSVehiclesActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateTenantConfigurationCommand
     */
    hovTotalItemsThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTenantConfigurationCommand
     */
    hovMultiplePackingItemCountThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTenantConfigurationCommand
     */
    hovMultiplePickingItemCountThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTenantConfigurationCommand
     */
    hovLineItemCountThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTenantConfigurationCommand
     */
    hovAvarageLineItemAmountThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTenantConfigurationCommand
     */
    hovLineItemAmountPerProductThreshold?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantConfigurationCommand
     */
    getReturnItemsAsReceived?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantConfigurationCommand
     */
    isPickPerformanceEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantConfigurationCommand
     */
    isRebinAddressScanRemoved?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantConfigurationCommand
     */
    isMeasurementControlOnReceivingActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantConfigurationCommand
     */
    allowInternationalMultiCargoPackage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantConfigurationCommand
     */
    isAllocationFixPrimeStockPreFilterEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateTenantConfigurationCommand
     */
    multiItemMultiplePickingItemCountThreshold?: number;
}
/**
 * 
 * @export
 * @interface UpdateTenantConfigurationOutputDTO
 */
export interface UpdateTenantConfigurationOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantConfigurationOutputDTO
     */
    tenantName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTenantConfigurationOutputDTO
     */
    updatedFields?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateTrackingInfoCommand
 */
export interface UpdateTrackingInfoCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateTrackingInfoCommand
     */
    trackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrackingInfoCommand
     */
    carrierId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrackingInfoCommand
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrackingInfoCommand
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrackingInfoCommand
     */
    cargoTrackingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrackingInfoCommand
     */
    address?: string;
}
/**
 * 
 * @export
 * @interface UpdateTrackingInfoCommandOutputDTO
 */
export interface UpdateTrackingInfoCommandOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateTrackingInfoCommandOutputDTO
     */
    trackingId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrackingInfoCommandOutputDTO
     */
    cargoCarrierName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrackingInfoCommandOutputDTO
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrackingInfoCommandOutputDTO
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrackingInfoCommandOutputDTO
     */
    cargoTrackingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrackingInfoCommandOutputDTO
     */
    cargoCarrierLogoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrackingInfoCommandOutputDTO
     */
    address?: string;
}
/**
 * 
 * @export
 * @interface UpdateVasConditionCommand
 */
export interface UpdateVasConditionCommand {
    /**
     * 
     * @type {number}
     * @memberof UpdateVasConditionCommand
     */
    id?: number;
    /**
     * 
     * @type {VasConditionInputDTO}
     * @memberof UpdateVasConditionCommand
     */
    vasCondition?: VasConditionInputDTO;
}
/**
 * 
 * @export
 * @interface UpdateVasDocumentUrlCommand
 */
export interface UpdateVasDocumentUrlCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateVasDocumentUrlCommand
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVasDocumentUrlCommand
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVasDocumentUrlCommand
     */
    newDocumentUrl?: string;
}
/**
 * 
 * @export
 * @interface UpdateVasDocumentUrlOutputDTO
 */
export interface UpdateVasDocumentUrlOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateVasDocumentUrlOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateVasDocumentUrlOutputDTO
     */
    vasId?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateVasDocumentUrlOutputDTO
     */
    oldDocumentUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVasDocumentUrlOutputDTO
     */
    newDocumentUrl?: string;
}
/**
 * 
 * @export
 * @interface UpdateWaybillCommand
 */
export interface UpdateWaybillCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateWaybillCommand
     */
    purchaseOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaybillCommand
     */
    waybillId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaybillCommand
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaybillCommand
     */
    waybillDate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaybillCommand
     */
    supplierCompany?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaybillCommand
     */
    documentImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateWaybillCommand
     */
    palletCount?: number;
}
/**
 * 
 * @export
 * @interface UpdateWaybillNotesCommand
 */
export interface UpdateWaybillNotesCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateWaybillNotesCommand
     */
    waybillId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaybillNotesCommand
     */
    notes?: string;
}
/**
 * 
 * @export
 * @interface UpdateWaybillNotesOutputDTO
 */
export interface UpdateWaybillNotesOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateWaybillNotesOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaybillNotesOutputDTO
     */
    notes?: string;
}
/**
 * 
 * @export
 * @interface UpdateWaybillOutputDTO
 */
export interface UpdateWaybillOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateWaybillOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaybillOutputDTO
     */
    purchaseOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaybillOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaybillOutputDTO
     */
    waybillDate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaybillOutputDTO
     */
    supplierCompany?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaybillOutputDTO
     */
    documentImageUrl?: string;
}
/**
 * 
 * @export
 * @interface UpdateWorkflowCommand
 */
export interface UpdateWorkflowCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkflowCommand
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkflowCommand
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkflowCommand
     */
    triggerEvent?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkflowCommand
     */
    filter?: string;
    /**
     * 
     * @type {WorkflowActionType}
     * @memberof UpdateWorkflowCommand
     */
    type?: WorkflowActionType;
    /**
     * 
     * @type {EmailActionInputDTO}
     * @memberof UpdateWorkflowCommand
     */
    emailAction?: EmailActionInputDTO;
    /**
     * 
     * @type {PrintActionInputDTO}
     * @memberof UpdateWorkflowCommand
     */
    printAction?: PrintActionInputDTO;
    /**
     * 
     * @type {WebhookActionInputDTO}
     * @memberof UpdateWorkflowCommand
     */
    webhookAction?: WebhookActionInputDTO;
    /**
     * 
     * @type {BlobActionInputDTO}
     * @memberof UpdateWorkflowCommand
     */
    blobAction?: BlobActionInputDTO;
}
/**
 * 
 * @export
 * @interface UpdateWorkflowOutputDTO
 */
export interface UpdateWorkflowOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkflowOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkflowOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkflowOutputDTO
     */
    triggerEvent?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkflowOutputDTO
     */
    filter?: string;
    /**
     * 
     * @type {WorkflowState}
     * @memberof UpdateWorkflowOutputDTO
     */
    state?: WorkflowState;
    /**
     * 
     * @type {object}
     * @memberof UpdateWorkflowOutputDTO
     */
    action?: object;
}
/**
 * 
 * @export
 * @interface UpdateZonePickListConfigurationCommand
 */
export interface UpdateZonePickListConfigurationCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateZonePickListConfigurationCommand
     */
    stockZone?: string;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof UpdateZonePickListConfigurationCommand
     */
    pickingFlowTag?: PickingFlowTag;
    /**
     * 
     * @type {number}
     * @memberof UpdateZonePickListConfigurationCommand
     */
    pickListCountThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateZonePickListConfigurationCommand
     */
    pickListCreateAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateZonePickListConfigurationCommand
     */
    disposePickLists?: boolean;
    /**
     * 
     * @type {StockZonePickingType}
     * @memberof UpdateZonePickListConfigurationCommand
     */
    zonePickingType?: StockZonePickingType;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateZonePickListConfigurationCommand
     */
    rasEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateZonePickListConfigurationOutputDTO
 */
export interface UpdateZonePickListConfigurationOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof UpdateZonePickListConfigurationOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateZonePickListConfigurationOutputDTO
     */
    stockZoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateZonePickListConfigurationOutputDTO
     */
    stockZone?: string;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof UpdateZonePickListConfigurationOutputDTO
     */
    pickingFlowTag?: PickingFlowTag;
    /**
     * 
     * @type {number}
     * @memberof UpdateZonePickListConfigurationOutputDTO
     */
    pickListCountThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateZonePickListConfigurationOutputDTO
     */
    pickListCreateAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateZonePickListConfigurationOutputDTO
     */
    rasEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface UpdatedGiftNoteItemDTO
 */
export interface UpdatedGiftNoteItemDTO {
    /**
     * 
     * @type {number}
     * @memberof UpdatedGiftNoteItemDTO
     */
    vasId?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdatedGiftNoteItemDTO
     */
    vasType?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatedGiftNoteItemDTO
     */
    oldNote?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatedGiftNoteItemDTO
     */
    newNote?: string;
}
/**
 * 
 * @export
 * @interface UpdatedIndexCargoPackageOutputDTO
 */
export interface UpdatedIndexCargoPackageOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof UpdatedIndexCargoPackageOutputDTO
     */
    packageId?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdatedIndexCargoPackageOutputDTO
     */
    newIndex?: number;
}
/**
 * 
 * @export
 * @interface UpdatedIndexHOVCargoPackageOutputDTO
 */
export interface UpdatedIndexHOVCargoPackageOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof UpdatedIndexHOVCargoPackageOutputDTO
     */
    packageId?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdatedIndexHOVCargoPackageOutputDTO
     */
    newIndex?: number;
}
/**
 * 
 * @export
 * @interface UploadCarrierImageOutputDTO
 */
export interface UploadCarrierImageOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UploadCarrierImageOutputDTO
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface UploadDispatchDocumentImageOutputDTO
 */
export interface UploadDispatchDocumentImageOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UploadDispatchDocumentImageOutputDTO
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface UploadOperationImageOutputDTO
 */
export interface UploadOperationImageOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UploadOperationImageOutputDTO
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface UpsertBatchPickingConfigurationCommand
 */
export interface UpsertBatchPickingConfigurationCommand {
    /**
     * 
     * @type {number}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    zoneId?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    rebinVolumeCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    rebinVolumeThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    rebinSalesOrderCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    pickListPickingDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    pickListPickingDurationThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    durationBetweenAddresses?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    durationBetweenAisles?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    productPickingDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    specialProductPickingDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    toteVolumeCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    toteVolumeThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    batchTrolleyToteCountLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    toteWeightCapacity?: number;
    /**
     * 
     * @type {RebinVolumeConfigType}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    rebinVolumeConfigType?: RebinVolumeConfigType;
    /**
     * 
     * @type {number}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    batchPickingTrolleyToteCountLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertBatchPickingConfigurationCommand
     */
    maxAmountOfItemsPerPickList?: number;
}
/**
 * 
 * @export
 * @interface UpsertCarrierPreferencesCommand
 */
export interface UpsertCarrierPreferencesCommand {
    /**
     * 
     * @type {string}
     * @memberof UpsertCarrierPreferencesCommand
     */
    operationId?: string;
    /**
     * 
     * @type {Array<CarrierPreferenceInputDTO>}
     * @memberof UpsertCarrierPreferencesCommand
     */
    carrierPreferences?: Array<CarrierPreferenceInputDTO>;
}
/**
 * 
 * @export
 * @interface UpsertMasterCartonProductCommand
 */
export interface UpsertMasterCartonProductCommand {
    /**
     * 
     * @type {string}
     * @memberof UpsertMasterCartonProductCommand
     */
    operationName?: string;
    /**
     * 
     * @type {Array<UpsertMasterCartonProductInputDTO>}
     * @memberof UpsertMasterCartonProductCommand
     */
    products?: Array<UpsertMasterCartonProductInputDTO>;
}
/**
 * 
 * @export
 * @interface UpsertMasterCartonProductInputDTO
 */
export interface UpsertMasterCartonProductInputDTO {
    /**
     * 
     * @type {string}
     * @memberof UpsertMasterCartonProductInputDTO
     */
    innerProductSKU?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertMasterCartonProductInputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertMasterCartonProductInputDTO
     */
    mcBarcode?: string;
    /**
     * 
     * @type {number}
     * @memberof UpsertMasterCartonProductInputDTO
     */
    mcBarcodeAmount?: number;
}
/**
 * 
 * @export
 * @interface UpsertMasterCartonProductOutputDTO
 */
export interface UpsertMasterCartonProductOutputDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertMasterCartonProductOutputDTO
     */
    successful?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof UpsertMasterCartonProductOutputDTO
     */
    failures?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface UpsertProductDimensionsBulkCommand
 */
export interface UpsertProductDimensionsBulkCommand {
    /**
     * 
     * @type {string}
     * @memberof UpsertProductDimensionsBulkCommand
     */
    operationName?: string;
    /**
     * 
     * @type {Array<ProductDimensionBulkItemInputDTO>}
     * @memberof UpsertProductDimensionsBulkCommand
     */
    products?: Array<ProductDimensionBulkItemInputDTO>;
}
/**
 * 
 * @export
 * @interface UpsertProductDimensionsBulkOutputDTO
 */
export interface UpsertProductDimensionsBulkOutputDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertProductDimensionsBulkOutputDTO
     */
    updatedSKUs?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertProductDimensionsBulkOutputDTO
     */
    createdSKUs?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertProductDimensionsBulkOutputDTO
     */
    notFoundSKUs?: Array<string>;
    /**
     * 
     * @type {Array<FailedSKUInfo>}
     * @memberof UpsertProductDimensionsBulkOutputDTO
     */
    failedSKUs?: Array<FailedSKUInfo>;
    /**
     * 
     * @type {number}
     * @memberof UpsertProductDimensionsBulkOutputDTO
     */
    updatedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertProductDimensionsBulkOutputDTO
     */
    createdCount?: number;
}
/**
 * 
 * @export
 * @interface UpsertSorterConfigCommand
 */
export interface UpsertSorterConfigCommand {
    /**
     * 
     * @type {string}
     * @memberof UpsertSorterConfigCommand
     */
    sorterId?: string;
    /**
     * 
     * @type {Array<SorterConfigInputDTO>}
     * @memberof UpsertSorterConfigCommand
     */
    configs?: Array<SorterConfigInputDTO>;
    /**
     * 
     * @type {number}
     * @memberof UpsertSorterConfigCommand
     */
    defaultExit?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertSorterConfigCommand
     */
    failureExit?: number;
}
/**
 * 
 * @export
 * @interface UserGridFilterPresetOutputDTO
 */
export interface UserGridFilterPresetOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UserGridFilterPresetOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGridFilterPresetOutputDTO
     */
    gridKey?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGridFilterPresetOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGridFilterPresetOutputDTO
     */
    filtersJson?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGridFilterPresetOutputDTO
     */
    sortJson?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGridFilterPresetOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface UserPickPerformanceOutputDTO
 */
export interface UserPickPerformanceOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof UserPickPerformanceOutputDTO
     */
    last15MinutesPicks?: number;
}
/**
 * 
 * @export
 * @interface UserQueryOutputDTO
 */
export interface UserQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof UserQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserQueryOutputDTO
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserQueryOutputDTO
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserQueryOutputDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserQueryOutputDTO
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UserQueryOutputDTO
     */
    role?: string;
    /**
     * 
     * @type {string}
     * @memberof UserQueryOutputDTO
     */
    auth0Id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserQueryOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface UserQueryOutputDTODynamicQueryOutputDTO
 */
export interface UserQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<UserQueryOutputDTO>}
     * @memberof UserQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<UserQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof UserQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface VASOutputDTO
 */
export interface VASOutputDTO {
    /**
     * 
     * @type {OutputVASType}
     * @memberof VASOutputDTO
     */
    vasType?: OutputVASType;
    /**
     * 
     * @type {string}
     * @memberof VASOutputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof VASOutputDTO
     */
    info?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum VASState {
    Created = 'Created',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum VASType {
    None = 'None',
    InsertToPackageVas = 'InsertToPackageVAS',
    GiftPackageVas = 'GiftPackageVAS',
    CustomActionVas = 'CustomActionVAS',
    PackingNoteVas = 'PackingNoteVAS',
    NpsVas = 'NpsVAS'
}

/**
 * 
 * @export
 * @interface ValidateBarcodeForReturnOutputDTO
 */
export interface ValidateBarcodeForReturnOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateBarcodeForReturnOutputDTO
     */
    isValid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ValidateBarcodeForReturnOutputDTO
     */
    returnPackageId?: string;
    /**
     * 
     * @type {Array<MatchingLineItemDTO>}
     * @memberof ValidateBarcodeForReturnOutputDTO
     */
    matchingLineItems?: Array<MatchingLineItemDTO>;
    /**
     * 
     * @type {string}
     * @memberof ValidateBarcodeForReturnOutputDTO
     */
    message?: string;
    /**
     * 
     * @type {number}
     * @memberof ValidateBarcodeForReturnOutputDTO
     */
    itemsWithoutImagesCount?: number;
}
/**
 * 
 * @export
 * @interface ValidateManualReplenishmentJobsInputDTO
 */
export interface ValidateManualReplenishmentJobsInputDTO {
    /**
     * 
     * @type {string}
     * @memberof ValidateManualReplenishmentJobsInputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {Array<ManualReplenishmentLineInputDTO>}
     * @memberof ValidateManualReplenishmentJobsInputDTO
     */
    lines?: Array<ManualReplenishmentLineInputDTO>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum VasApplyLevel {
    PreReceiving = 'PreReceiving',
    Receiving = 'Receiving',
    PutAway = 'PutAway',
    Picking = 'Picking',
    Packing = 'Packing',
    Shipping = 'Shipping',
    Return = 'Return'
}

/**
 * 
 * @export
 * @interface VasConditionInputDTO
 */
export interface VasConditionInputDTO {
    /**
     * 
     * @type {number}
     * @memberof VasConditionInputDTO
     */
    vasId?: number;
    /**
     * 
     * @type {Set<string>}
     * @memberof VasConditionInputDTO
     */
    productIds?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof VasConditionInputDTO
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof VasConditionInputDTO
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof VasConditionInputDTO
     */
    operationId?: string;
    /**
     * 
     * @type {number}
     * @memberof VasConditionInputDTO
     */
    amount?: number;
    /**
     * 
     * @type {SalesChannel}
     * @memberof VasConditionInputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof VasConditionInputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {NameCheckType}
     * @memberof VasConditionInputDTO
     */
    nameCheckType?: NameCheckType;
    /**
     * 
     * @type {string}
     * @memberof VasConditionInputDTO
     */
    nameCheckValue?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof VasConditionInputDTO
     */
    customerIds?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof VasConditionInputDTO
     */
    packageType?: string;
}
/**
 * 
 * @export
 * @interface VasConditionOutputDTO
 */
export interface VasConditionOutputDTO {
    /**
     * 
     * @type {VasDefinitionOutputDTO}
     * @memberof VasConditionOutputDTO
     */
    vasDefinition?: VasDefinitionOutputDTO;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof VasConditionOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {Array<VasCustomerOutputDTO>}
     * @memberof VasConditionOutputDTO
     */
    customers?: Array<VasCustomerOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof VasConditionOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {Array<VasProductOutputDTO>}
     * @memberof VasConditionOutputDTO
     */
    products?: Array<VasProductOutputDTO>;
    /**
     * 
     * @type {string}
     * @memberof VasConditionOutputDTO
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof VasConditionOutputDTO
     */
    endDate?: string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof VasConditionOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof VasConditionOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {string}
     * @memberof VasConditionOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof VasConditionOutputDTO
     */
    customerName?: string;
    /**
     * 
     * @type {NameCheckType}
     * @memberof VasConditionOutputDTO
     */
    nameCheckType?: NameCheckType;
    /**
     * 
     * @type {string}
     * @memberof VasConditionOutputDTO
     */
    nameCheckValue?: string;
    /**
     * 
     * @type {number}
     * @memberof VasConditionOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VasConditionOutputDTO
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VasConditionOutputDTO
     */
    packageType?: string;
}
/**
 * 
 * @export
 * @interface VasConditionOutputDTODynamicQueryOutputDTO
 */
export interface VasConditionOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<VasConditionOutputDTO>}
     * @memberof VasConditionOutputDTODynamicQueryOutputDTO
     */
    data?: Array<VasConditionOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof VasConditionOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface VasCustomerOutputDTO
 */
export interface VasCustomerOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof VasCustomerOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VasCustomerOutputDTO
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface VasDefinitionInputDTO
 */
export interface VasDefinitionInputDTO {
    /**
     * 
     * @type {string}
     * @memberof VasDefinitionInputDTO
     */
    name?: string;
    /**
     * 
     * @type {VasApplyLevel}
     * @memberof VasDefinitionInputDTO
     */
    applyLevel?: VasApplyLevel;
    /**
     * 
     * @type {VasPriceUnit}
     * @memberof VasDefinitionInputDTO
     */
    priceUnit?: VasPriceUnit;
    /**
     * 
     * @type {boolean}
     * @memberof VasDefinitionInputDTO
     */
    manualVasAvailable?: boolean;
}
/**
 * 
 * @export
 * @interface VasDefinitionOutputDTO
 */
export interface VasDefinitionOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof VasDefinitionOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof VasDefinitionOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {VasApplyLevel}
     * @memberof VasDefinitionOutputDTO
     */
    applyLevel?: VasApplyLevel;
    /**
     * 
     * @type {VasPriceUnit}
     * @memberof VasDefinitionOutputDTO
     */
    priceUnit?: VasPriceUnit;
    /**
     * 
     * @type {boolean}
     * @memberof VasDefinitionOutputDTO
     */
    manualVasAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VasDefinitionOutputDTO
     */
    enabled?: boolean;
}
/**
 * 
 * @export
 * @interface VasDefinitionOutputDTODynamicQueryOutputDTO
 */
export interface VasDefinitionOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<VasDefinitionOutputDTO>}
     * @memberof VasDefinitionOutputDTODynamicQueryOutputDTO
     */
    data?: Array<VasDefinitionOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof VasDefinitionOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum VasPriceUnit {
    BoxQty = 'BoxQty',
    ProductQty = 'ProductQty',
    PalletQty = 'PalletQty',
    OrderQty = 'OrderQty'
}

/**
 * 
 * @export
 * @interface VasProductOutputDTO
 */
export interface VasProductOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof VasProductOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VasProductOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof VasProductOutputDTO
     */
    sku?: string;
}
/**
 * 
 * @export
 * @interface VasRecordOutputDTO
 */
export interface VasRecordOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof VasRecordOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {VasSource}
     * @memberof VasRecordOutputDTO
     */
    source?: VasSource;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof VasRecordOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof VasRecordOutputDTO
     */
    vasName?: string;
    /**
     * 
     * @type {VasApplyLevel}
     * @memberof VasRecordOutputDTO
     */
    applyLevel?: VasApplyLevel;
    /**
     * 
     * @type {VasPriceUnit}
     * @memberof VasRecordOutputDTO
     */
    priceUnit?: VasPriceUnit;
    /**
     * 
     * @type {string}
     * @memberof VasRecordOutputDTO
     */
    processReferenceNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof VasRecordOutputDTO
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof VasRecordOutputDTO
     */
    appliedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof VasRecordOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface VasRecordOutputDTODynamicQueryOutputDTO
 */
export interface VasRecordOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<VasRecordOutputDTO>}
     * @memberof VasRecordOutputDTODynamicQueryOutputDTO
     */
    data?: Array<VasRecordOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof VasRecordOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum VasSource {
    VasCondition = 'VasCondition',
    Manual = 'Manual',
    Omni = 'Omni',
    CustomAction = 'CustomAction'
}

/**
 * 
 * @export
 * @interface VehicleQueryOutputDTO
 */
export interface VehicleQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof VehicleQueryOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof VehicleQueryOutputDTO
     */
    type?: VehicleType;
    /**
     * 
     * @type {string}
     * @memberof VehicleQueryOutputDTO
     */
    variation?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleQueryOutputDTO
     */
    containerCount?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleQueryOutputDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleQueryOutputDTO
     */
    lastSeenAt?: string;
}
/**
 * 
 * @export
 * @interface VehicleQueryOutputDTODynamicQueryOutputDTO
 */
export interface VehicleQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<VehicleQueryOutputDTO>}
     * @memberof VehicleQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<VehicleQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof VehicleQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum VehicleType {
    None = 'None',
    PickingTrolley = 'PickingTrolley',
    PutAwayTrolley = 'PutAwayTrolley',
    ReturnTrolley = 'ReturnTrolley',
    TransferTrolley = 'TransferTrolley',
    BatchTrolley = 'BatchTrolley',
    RebinTrolley = 'RebinTrolley',
    VirtualTrolley = 'VirtualTrolley'
}

/**
 * 
 * @export
 * @interface WaitHandle
 */
export interface WaitHandle {
    /**
     * 
     * @type {string}
     * @memberof WaitHandle
     */
    handle?: string;
    /**
     * 
     * @type {SafeWaitHandle}
     * @memberof WaitHandle
     */
    safeWaitHandle?: SafeWaitHandle;
}
/**
 * 
 * @export
 * @interface WaitingForPickingSalesOrdersOutputDTO
 */
export interface WaitingForPickingSalesOrdersOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    operationImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    vehicleType?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    pickListName?: string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {string}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    salesLocation?: string;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {number}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    lineItemsCount?: number;
    /**
     * 
     * @type {string}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    targetDispatchDateTime?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    isCutOff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    isLate?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    problemCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    candidateZones?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    stagedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingForPickingSalesOrdersOutputDTO
     */
    batchName?: string;
}
/**
 * 
 * @export
 * @interface WaitingForPickingSalesOrdersOutputDTODynamicQueryOutputDTO
 */
export interface WaitingForPickingSalesOrdersOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WaitingForPickingSalesOrdersOutputDTO>}
     * @memberof WaitingForPickingSalesOrdersOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WaitingForPickingSalesOrdersOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WaitingForPickingSalesOrdersOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface WaitingForSLAMApprovedCargoPackageOutputDTO
 */
export interface WaitingForSLAMApprovedCargoPackageOutputDTO {
    /**
     * 
     * @type {SLAMQueryCargoState}
     * @memberof WaitingForSLAMApprovedCargoPackageOutputDTO
     */
    state?: SLAMQueryCargoState;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof WaitingForSLAMApprovedCargoPackageOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof WaitingForSLAMApprovedCargoPackageOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingForSLAMApprovedCargoPackageOutputDTO
     */
    cargoPackageLabel?: string;
    /**
     * 
     * @type {CargoPackageLabelUrlState}
     * @memberof WaitingForSLAMApprovedCargoPackageOutputDTO
     */
    labelUrlState?: CargoPackageLabelUrlState;
    /**
     * 
     * @type {DeliveryTypeTag}
     * @memberof WaitingForSLAMApprovedCargoPackageOutputDTO
     */
    deliveryType?: DeliveryTypeTag;
    /**
     * 
     * @type {string}
     * @memberof WaitingForSLAMApprovedCargoPackageOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingForSLAMApprovedCargoPackageOutputDTO
     */
    dispatchApprovedAt?: string;
}
/**
 * 
 * @export
 * @interface WaitingForSLAMApprovedCargoPackageOutputDTODynamicQueryOutputDTO
 */
export interface WaitingForSLAMApprovedCargoPackageOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WaitingForSLAMApprovedCargoPackageOutputDTO>}
     * @memberof WaitingForSLAMApprovedCargoPackageOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WaitingForSLAMApprovedCargoPackageOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WaitingForSLAMApprovedCargoPackageOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface WaitingForSLAMCargoPackageOutputDTO
 */
export interface WaitingForSLAMCargoPackageOutputDTO {
    /**
     * 
     * @type {SLAMQueryCargoState}
     * @memberof WaitingForSLAMCargoPackageOutputDTO
     */
    state?: SLAMQueryCargoState;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof WaitingForSLAMCargoPackageOutputDTO
     */
    operation?: OperationOutputDTO;
    /**
     * 
     * @type {string}
     * @memberof WaitingForSLAMCargoPackageOutputDTO
     */
    packingCompletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingForSLAMCargoPackageOutputDTO
     */
    salesOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingForSLAMCargoPackageOutputDTO
     */
    cargoPackageLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingForSLAMCargoPackageOutputDTO
     */
    shipmentAddressFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingForSLAMCargoPackageOutputDTO
     */
    shipmentAddressCity?: string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof WaitingForSLAMCargoPackageOutputDTO
     */
    salesChannel?: SalesChannel;
    /**
     * 
     * @type {CargoPackageLabelUrlState}
     * @memberof WaitingForSLAMCargoPackageOutputDTO
     */
    labelUrlState?: CargoPackageLabelUrlState;
}
/**
 * 
 * @export
 * @interface WaitingForSLAMCargoPackageOutputDTODynamicQueryOutputDTO
 */
export interface WaitingForSLAMCargoPackageOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WaitingForSLAMCargoPackageOutputDTO>}
     * @memberof WaitingForSLAMCargoPackageOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WaitingForSLAMCargoPackageOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WaitingForSLAMCargoPackageOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface WaitingForSLAMCargoPackagesCountOutputDTO
 */
export interface WaitingForSLAMCargoPackagesCountOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof WaitingForSLAMCargoPackagesCountOutputDTO
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof WaitingForSLAMCargoPackagesCountOutputDTO
     */
    inProcess?: number;
    /**
     * 
     * @type {number}
     * @memberof WaitingForSLAMCargoPackagesCountOutputDTO
     */
    waitingToProcess?: number;
    /**
     * 
     * @type {number}
     * @memberof WaitingForSLAMCargoPackagesCountOutputDTO
     */
    cancelled?: number;
    /**
     * 
     * @type {Array<CargoPackageCountByOperationOutputDTO>}
     * @memberof WaitingForSLAMCargoPackagesCountOutputDTO
     */
    byOperation?: Array<CargoPackageCountByOperationOutputDTO>;
}
/**
 * 
 * @export
 * @interface WaitingPutAwayPalletsOutputDTO
 */
export interface WaitingPutAwayPalletsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WaitingPutAwayPalletsOutputDTO
     */
    palletLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof WaitingPutAwayPalletsOutputDTO
     */
    productAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WaitingPutAwayPalletsOutputDTO
     */
    productVariety?: number;
    /**
     * 
     * @type {Array<OperationOutputDTO>}
     * @memberof WaitingPutAwayPalletsOutputDTO
     */
    operations?: Array<OperationOutputDTO>;
    /**
     * 
     * @type {string}
     * @memberof WaitingPutAwayPalletsOutputDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingPutAwayPalletsOutputDTO
     */
    lastSeenAt?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingPutAwayPalletsOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WaitingPutAwayPalletsOutputDTO
     */
    hasZoneProblem?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WaitingPutAwayPalletsOutputDTO
     */
    hasExpirationDateProblem?: boolean;
}
/**
 * 
 * @export
 * @interface WaitingPutAwayPalletsOutputDTODynamicQueryOutputDTO
 */
export interface WaitingPutAwayPalletsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WaitingPutAwayPalletsOutputDTO>}
     * @memberof WaitingPutAwayPalletsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WaitingPutAwayPalletsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WaitingPutAwayPalletsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface WaitingPutAwayTotesOutputDTO
 */
export interface WaitingPutAwayTotesOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WaitingPutAwayTotesOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof WaitingPutAwayTotesOutputDTO
     */
    productAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WaitingPutAwayTotesOutputDTO
     */
    productVariety?: number;
    /**
     * 
     * @type {Array<OperationOutputDTO>}
     * @memberof WaitingPutAwayTotesOutputDTO
     */
    operations?: Array<OperationOutputDTO>;
    /**
     * 
     * @type {string}
     * @memberof WaitingPutAwayTotesOutputDTO
     */
    lastSeenAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingPutAwayTotesOutputDTO
     */
    lastSeenAt?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitingPutAwayTotesOutputDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface WaitingPutAwayTotesOutputDTODynamicQueryOutputDTO
 */
export interface WaitingPutAwayTotesOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WaitingPutAwayTotesOutputDTO>}
     * @memberof WaitingPutAwayTotesOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WaitingPutAwayTotesOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WaitingPutAwayTotesOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface WallInventoryItemOutputDTO
 */
export interface WallInventoryItemOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WallInventoryItemOutputDTO
     */
    addressLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof WallInventoryItemOutputDTO
     */
    salesOrderName?: string;
    /**
     * 
     * @type {string}
     * @memberof WallInventoryItemOutputDTO
     */
    cellType?: string;
    /**
     * 
     * @type {string}
     * @memberof WallInventoryItemOutputDTO
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof WallInventoryItemOutputDTO
     */
    salesOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof WallInventoryItemOutputDTO
     */
    isDuplicate?: string;
}
/**
 * 
 * @export
 * @interface WallInventoryItemOutputDTODynamicQueryOutputDTO
 */
export interface WallInventoryItemOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WallInventoryItemOutputDTO>}
     * @memberof WallInventoryItemOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WallInventoryItemOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WallInventoryItemOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface WallInventoryViewOutputDTO
 */
export interface WallInventoryViewOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof WallInventoryViewOutputDTO
     */
    totalCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof WallInventoryViewOutputDTO
     */
    fullCellCount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallInventoryViewOutputDTO
     */
    emptyCellCount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallInventoryViewOutputDTO
     */
    occupancyRate?: number;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingAddressesOutputDTO
 */
export interface WallToWallStockCountingAddressesOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    cellId?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {StockCountingCellState}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    state?: StockCountingCellState;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    skuCount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    beforeCountingAmount?: number;
    /**
     * 
     * @type {StockCountingStatus}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    beforeCountStatus?: StockCountingStatus;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    firstCountAmount?: number;
    /**
     * 
     * @type {StockCountingStatus}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    firstCountStatus?: StockCountingStatus;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    secondCountAmount?: number;
    /**
     * 
     * @type {StockCountingStatus}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    secondCountStatus?: StockCountingStatus;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    thirdCountAmount?: number;
    /**
     * 
     * @type {StockCountingStatus}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    thirdCountStatus?: StockCountingStatus;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    controlCountAmount?: number;
    /**
     * 
     * @type {StockCountingStatus}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    controlCountStatus?: StockCountingStatus;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    afterCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    damagedItemCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    significant?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    allowManualEntry?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    stockCountingListIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    stockCountingListNames?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof WallToWallStockCountingAddressesOutputDTO
     */
    incorrectCounted?: boolean;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingAddressesOutputDTODynamicQueryOutputDTO
 */
export interface WallToWallStockCountingAddressesOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WallToWallStockCountingAddressesOutputDTO>}
     * @memberof WallToWallStockCountingAddressesOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WallToWallStockCountingAddressesOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingAddressProductsReportOutputDTO
 */
export interface WallToWallStockCountingAddressProductsReportOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    cellId?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    stockCountBeforeCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    firstCountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    secondCountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    thirdCountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    controlCountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    stockCountAfterCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    stockDifference?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    stockCountingDateTime?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    damagedItemCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    stockCountingListIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    stockCountingListNames?: Array<string>;
    /**
     * 
     * @type {WallToWallStockUpdateState}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTO
     */
    stockUpdateState?: WallToWallStockUpdateState;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingAddressProductsReportOutputDTODynamicQueryOutputDTO
 */
export interface WallToWallStockCountingAddressProductsReportOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WallToWallStockCountingAddressProductsReportOutputDTO>}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WallToWallStockCountingAddressProductsReportOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressProductsReportOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingAddressesReportOutputDTO
 */
export interface WallToWallStockCountingAddressesReportOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    cellId?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    skuCountBeforeCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    skuCountAfterCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    skuDifference?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    stockCountBeforeCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    stockCountAfterCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    stockDifference?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    stockCountingDateTime?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    damagedItemCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    stockCountingListIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    stockCountingListNames?: Array<string>;
    /**
     * 
     * @type {WallToWallStockUpdateState}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    stockUpdateState?: WallToWallStockUpdateState;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    firstCountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    secondCountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    thirdCountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesReportOutputDTO
     */
    controlCountAmount?: number;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingAddressesReportOutputDTODynamicQueryOutputDTO
 */
export interface WallToWallStockCountingAddressesReportOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WallToWallStockCountingAddressesReportOutputDTO>}
     * @memberof WallToWallStockCountingAddressesReportOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WallToWallStockCountingAddressesReportOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingAddressesReportOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingCountsOutputDTO
 */
export interface WallToWallStockCountingCountsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingCountsOutputDTO
     */
    stockCountingListCount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingCountsOutputDTO
     */
    cellCount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingCountsOutputDTO
     */
    skuCount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingCountsOutputDTO
     */
    stockCount?: number;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingDamagedItemsOutputDTO
 */
export interface WallToWallStockCountingDamagedItemsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingDamagedItemsOutputDTO
     */
    cellId?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingDamagedItemsOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingDamagedItemsOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingDamagedItemsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WallToWallStockCountingDamagedItemsOutputDTO
     */
    barcodes?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingDamagedItemsOutputDTO
     */
    damagedItemCount?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingDamagedItemsOutputDTO
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingDamagedItemsOutputDTO
     */
    stockCountingList?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingDamagedItemsOutputDTO
     */
    operator?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WallToWallStockCountingDamagedItemsOutputDTO
     */
    controlState?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingDamagedItemsOutputDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingDamagedItemsOutputDTODynamicQueryOutputDTO
 */
export interface WallToWallStockCountingDamagedItemsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WallToWallStockCountingDamagedItemsOutputDTO>}
     * @memberof WallToWallStockCountingDamagedItemsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WallToWallStockCountingDamagedItemsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingDamagedItemsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingDamagedItemsReportOutputDTO
 */
export interface WallToWallStockCountingDamagedItemsReportOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingDamagedItemsReportOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingDamagedItemsReportOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingDamagedItemsReportOutputDTO
     */
    cellId?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingDamagedItemsReportOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingDamagedItemsReportOutputDTO
     */
    operator?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingDamagedItemsReportOutputDTO
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingDamagedItemsReportOutputDTO
     */
    stockCountingListName?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingDamagedItemsReportOutputDTO
     */
    damagedItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingDamagedItemsReportOutputDTO
     */
    restowItemAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingDamagedItemsReportOutputDTO
     */
    operationName?: string;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingDamagedItemsReportOutputDTODynamicQueryOutputDTO
 */
export interface WallToWallStockCountingDamagedItemsReportOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WallToWallStockCountingDamagedItemsReportOutputDTO>}
     * @memberof WallToWallStockCountingDamagedItemsReportOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WallToWallStockCountingDamagedItemsReportOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingDamagedItemsReportOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WallToWallStockCountingListIndex {
    None = 'None',
    First = 'First',
    Second = 'Second',
    Third = 'Third',
    Control = 'Control'
}

/**
 * 
 * @export
 * @interface WallToWallStockCountingListOutputDTO
 */
export interface WallToWallStockCountingListOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    countedAddresses?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    totalAddresses?: number;
    /**
     * 
     * @type {StockCountingListState}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    state?: StockCountingListState;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    operator?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    stockAmountToBeCounted?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    incorrectCountedCellCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    significant?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    allowManualEntry?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    qrCode?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    referenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    sections?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    countingIndex?: number;
    /**
     * 
     * @type {WallToWallStockCountingListIndex}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    listIndex?: WallToWallStockCountingListIndex;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingListOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingListOutputDTODynamicQueryOutputDTO
 */
export interface WallToWallStockCountingListOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WallToWallStockCountingListOutputDTO>}
     * @memberof WallToWallStockCountingListOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WallToWallStockCountingListOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingListsOutputDTO
 */
export interface WallToWallStockCountingListsOutputDTO {
    /**
     * 
     * @type {Array<WallToWallStockCountingListOutputDTO>}
     * @memberof WallToWallStockCountingListsOutputDTO
     */
    wallToWallStockCountingLists?: Array<WallToWallStockCountingListOutputDTO>;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingListsReportOutputDTO
 */
export interface WallToWallStockCountingListsReportOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingListsReportOutputDTO
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingListsReportOutputDTO
     */
    stockCountingListName?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListsReportOutputDTO
     */
    countedCells?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingListsReportOutputDTO
     */
    operator?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListsReportOutputDTO
     */
    stockCountBeforeCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListsReportOutputDTO
     */
    stockCountAfterCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListsReportOutputDTO
     */
    stockDifference?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingListsReportOutputDTO
     */
    stockCountingDateTime?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListsReportOutputDTO
     */
    damagedItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListsReportOutputDTO
     */
    completeDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListsReportOutputDTO
     */
    countingIndex?: number;
    /**
     * 
     * @type {WallToWallStockCountingListIndex}
     * @memberof WallToWallStockCountingListsReportOutputDTO
     */
    listIndex?: WallToWallStockCountingListIndex;
    /**
     * 
     * @type {WallToWallStockUpdateState}
     * @memberof WallToWallStockCountingListsReportOutputDTO
     */
    stockUpdateState?: WallToWallStockUpdateState;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingListsReportOutputDTODynamicQueryOutputDTO
 */
export interface WallToWallStockCountingListsReportOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WallToWallStockCountingListsReportOutputDTO>}
     * @memberof WallToWallStockCountingListsReportOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WallToWallStockCountingListsReportOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListsReportOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingListsWithIncorrectCountedCellsOutputDTO
 */
export interface WallToWallStockCountingListsWithIncorrectCountedCellsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingListsWithIncorrectCountedCellsOutputDTO
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingListsWithIncorrectCountedCellsOutputDTO
     */
    stockCountingListName?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingListsWithIncorrectCountedCellsOutputDTO
     */
    operator?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListsWithIncorrectCountedCellsOutputDTO
     */
    incorrectCountedCellCount?: number;
    /**
     * 
     * @type {WallToWallStockCountingListIndex}
     * @memberof WallToWallStockCountingListsWithIncorrectCountedCellsOutputDTO
     */
    nextCountIndex?: WallToWallStockCountingListIndex;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingListsWithIncorrectCountedCellsOutputDTODynamicQueryOutputDTO
 */
export interface WallToWallStockCountingListsWithIncorrectCountedCellsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WallToWallStockCountingListsWithIncorrectCountedCellsOutputDTO>}
     * @memberof WallToWallStockCountingListsWithIncorrectCountedCellsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WallToWallStockCountingListsWithIncorrectCountedCellsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingListsWithIncorrectCountedCellsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingOperationsReportOutputDTO
 */
export interface WallToWallStockCountingOperationsReportOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingOperationsReportOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingOperationsReportOutputDTO
     */
    countedCells?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingOperationsReportOutputDTO
     */
    stockCountBeforeCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingOperationsReportOutputDTO
     */
    stockCountAfterCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingOperationsReportOutputDTO
     */
    stockDifference?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingOperationsReportOutputDTO
     */
    stockCountingDateTime?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingOperationsReportOutputDTO
     */
    damagedItemCount?: number;
    /**
     * 
     * @type {WallToWallStockUpdateState}
     * @memberof WallToWallStockCountingOperationsReportOutputDTO
     */
    stockUpdateState?: WallToWallStockUpdateState;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingOperationsReportOutputDTODynamicQueryOutputDTO
 */
export interface WallToWallStockCountingOperationsReportOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WallToWallStockCountingOperationsReportOutputDTO>}
     * @memberof WallToWallStockCountingOperationsReportOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WallToWallStockCountingOperationsReportOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingOperationsReportOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingPlanOutputDTO
 */
export interface WallToWallStockCountingPlanOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingPlanOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingPlanOutputDTO
     */
    referenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingPlanOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {StockCountingPlanState}
     * @memberof WallToWallStockCountingPlanOutputDTO
     */
    state?: StockCountingPlanState;
    /**
     * 
     * @type {StockCountingType}
     * @memberof WallToWallStockCountingPlanOutputDTO
     */
    stockCountingType?: StockCountingType;
    /**
     * 
     * @type {boolean}
     * @memberof WallToWallStockCountingPlanOutputDTO
     */
    readyToComplete?: boolean;
    /**
     * 
     * @type {WallToWallStockCountingPlanStockApplyState}
     * @memberof WallToWallStockCountingPlanOutputDTO
     */
    updateState?: WallToWallStockCountingPlanStockApplyState;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WallToWallStockCountingPlanStockApplyState {
    None = 'None',
    Ready = 'Ready',
    InProgress = 'InProgress',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @interface WallToWallStockCountingPlansOutputDTO
 */
export interface WallToWallStockCountingPlansOutputDTO {
    /**
     * 
     * @type {Array<WallToWallStockCountingPlanOutputDTO>}
     * @memberof WallToWallStockCountingPlansOutputDTO
     */
    wallToWallStockCountingPlans?: Array<WallToWallStockCountingPlanOutputDTO>;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingProductInputDTO
 */
export interface WallToWallStockCountingProductInputDTO {
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingProductInputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingProductInputDTO
     */
    barcode?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingProductInputDTO
     */
    stockCount?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingProductInputDTO
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingProductInputDTO
     */
    lotNumber?: string;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingProductsOutputDTO
 */
export interface WallToWallStockCountingProductsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingProductsOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingProductsOutputDTO
     */
    barcodes?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingProductsOutputDTO
     */
    beforeCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingProductsOutputDTO
     */
    firstCountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingProductsOutputDTO
     */
    secondCountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingProductsOutputDTO
     */
    thirdCountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingProductsOutputDTO
     */
    controlCountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingProductsOutputDTO
     */
    afterCountingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingProductsOutputDTO
     */
    damagedItemCount?: number;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingProductsOutputDTODynamicQueryOutputDTO
 */
export interface WallToWallStockCountingProductsOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WallToWallStockCountingProductsOutputDTO>}
     * @memberof WallToWallStockCountingProductsOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WallToWallStockCountingProductsOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingProductsOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingProductsReportOutputDTO
 */
export interface WallToWallStockCountingProductsReportOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingProductsReportOutputDTO
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingProductsReportOutputDTO
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingProductsReportOutputDTO
     */
    stockCountBeforeCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingProductsReportOutputDTO
     */
    stockCountAfterCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingProductsReportOutputDTO
     */
    stockDifference?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingProductsReportOutputDTO
     */
    stockCountingDateTime?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingProductsReportOutputDTO
     */
    damagedItemCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof WallToWallStockCountingProductsReportOutputDTO
     */
    stockCountingListIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WallToWallStockCountingProductsReportOutputDTO
     */
    stockCountingListNames?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof WallToWallStockCountingProductsReportOutputDTO
     */
    cellIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WallToWallStockCountingProductsReportOutputDTO
     */
    cellLabels?: Array<string>;
    /**
     * 
     * @type {WallToWallStockUpdateState}
     * @memberof WallToWallStockCountingProductsReportOutputDTO
     */
    stockUpdateState?: WallToWallStockUpdateState;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingProductsReportOutputDTODynamicQueryOutputDTO
 */
export interface WallToWallStockCountingProductsReportOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WallToWallStockCountingProductsReportOutputDTO>}
     * @memberof WallToWallStockCountingProductsReportOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WallToWallStockCountingProductsReportOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingProductsReportOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingReportCountsOutputDTO
 */
export interface WallToWallStockCountingReportCountsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingReportCountsOutputDTO
     */
    stockCountBeforeCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingReportCountsOutputDTO
     */
    stockCountAfterCounting?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingReportCountsOutputDTO
     */
    stockDifference?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingReportCountsOutputDTO
     */
    damagedItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingReportCountsOutputDTO
     */
    countedCells?: number;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingRouteOutputDTO
 */
export interface WallToWallStockCountingRouteOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingRouteOutputDTO
     */
    stockCountingListId?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingRouteOutputDTO
     */
    cellId?: number;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingRouteOutputDTO
     */
    zoneLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof WallToWallStockCountingRouteOutputDTO
     */
    cellLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingRouteOutputDTO
     */
    index?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingRouteOutputDTO
     */
    countedCells?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingRouteOutputDTO
     */
    totalCells?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WallToWallStockCountingRouteOutputDTO
     */
    isCompleted?: boolean;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingSummaryReportOutputDTO
 */
export interface WallToWallStockCountingSummaryReportOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingSummaryReportOutputDTO
     */
    stockBasedAccuracyRate?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingSummaryReportOutputDTO
     */
    damagedItemRate?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingSummaryReportOutputDTO
     */
    cellBasedAccuracyRate?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingSummaryReportOutputDTO
     */
    skuBasedDamagedItemRate?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingSummaryReportOutputDTO
     */
    skuBasedAccuracyRate?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingSummaryReportOutputDTO
     */
    stockInconsistencyRate?: number;
}
/**
 * 
 * @export
 * @interface WallToWallStockCountingTrackingCountsOutputDTO
 */
export interface WallToWallStockCountingTrackingCountsOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingTrackingCountsOutputDTO
     */
    listsWaitingForCount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingTrackingCountsOutputDTO
     */
    cellsToBeCountAgain?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingTrackingCountsOutputDTO
     */
    damagedItemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingTrackingCountsOutputDTO
     */
    completionPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingTrackingCountsOutputDTO
     */
    firstCountingCompletionPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingTrackingCountsOutputDTO
     */
    secondCountingCompletionPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingTrackingCountsOutputDTO
     */
    thirdCountingCompletionPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof WallToWallStockCountingTrackingCountsOutputDTO
     */
    controlCountingCompletionPercentage?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WallToWallStockUpdateState {
    None = 'None',
    Awaiting = 'Awaiting',
    InProgress = 'InProgress',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @interface WarehouseConfigOutputDTO
 */
export interface WarehouseConfigOutputDTO {
    /**
     * 
     * @type {boolean}
     * @memberof WarehouseConfigOutputDTO
     */
    batchPickingEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface WaybillDetailsOutputDTO
 */
export interface WaybillDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WaybillDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillDetailsOutputDTO
     */
    documentImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillDetailsOutputDTO
     */
    supplierCompanyName?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillDetailsOutputDTO
     */
    waybillDate?: string;
    /**
     * 
     * @type {WaybillState}
     * @memberof WaybillDetailsOutputDTO
     */
    state?: WaybillState;
    /**
     * 
     * @type {string}
     * @memberof WaybillDetailsOutputDTO
     */
    notes?: string;
    /**
     * 
     * @type {PurchaseOrderSource}
     * @memberof WaybillDetailsOutputDTO
     */
    source?: PurchaseOrderSource;
    /**
     * 
     * @type {Array<string>}
     * @memberof WaybillDetailsOutputDTO
     */
    imageUrls?: Array<string>;
    /**
     * 
     * @type {Array<CarrierInfoDetailOutputDTO>}
     * @memberof WaybillDetailsOutputDTO
     */
    carrierInfos?: Array<CarrierInfoDetailOutputDTO>;
    /**
     * 
     * @type {string}
     * @memberof WaybillDetailsOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface WaybillOutputDTO
 */
export interface WaybillOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WaybillOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillOutputDTO
     */
    purchaseOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillOutputDTO
     */
    supplierCompany?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillOutputDTO
     */
    waybillDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillOutputDTO
     */
    documentImageUrl?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WaybillOutputDTO
     */
    imageUrls?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WaybillOutputDTO
     */
    notes?: string;
    /**
     * 
     * @type {Array<CarrierInfoOutputDTO>}
     * @memberof WaybillOutputDTO
     */
    carrierInfos?: Array<CarrierInfoOutputDTO>;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof WaybillOutputDTO
     */
    inboundBoxCounts?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof WaybillOutputDTO
     */
    palletCount?: number;
}
/**
 * 
 * @export
 * @interface WaybillQueryOutputDTO
 */
export interface WaybillQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WaybillQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillQueryOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillQueryOutputDTO
     */
    waybillDate?: string;
    /**
     * 
     * @type {WaybillState}
     * @memberof WaybillQueryOutputDTO
     */
    state?: WaybillState;
}
/**
 * 
 * @export
 * @interface WaybillQueryOutputDTODynamicQueryOutputDTO
 */
export interface WaybillQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WaybillQueryOutputDTO>}
     * @memberof WaybillQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WaybillQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WaybillQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WaybillState {
    None = 'None',
    Created = 'Created',
    InProgress = 'InProgress',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @interface WaybillStationEIrsaliyeOutputDTO
 */
export interface WaybillStationEIrsaliyeOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WaybillStationEIrsaliyeOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillStationEIrsaliyeOutputDTO
     */
    ettn?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillStationEIrsaliyeOutputDTO
     */
    tip?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillStationEIrsaliyeOutputDTO
     */
    senaryo?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillStationEIrsaliyeOutputDTO
     */
    tasiyiciVKN?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillStationEIrsaliyeOutputDTO
     */
    vknTckn?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillStationEIrsaliyeOutputDTO
     */
    aVknTckn?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillStationEIrsaliyeOutputDTO
     */
    plaka?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillStationEIrsaliyeOutputDTO
     */
    tarih?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillStationEIrsaliyeOutputDTO
     */
    sevkTarihi?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillStationEIrsaliyeOutputDTO
     */
    sevkZamani?: string;
}
/**
 * 
 * @export
 * @interface WaybillStationInfoOutputDTO
 */
export interface WaybillStationInfoOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WaybillStationInfoOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof WaybillStationInfoOutputDTO
     */
    vasDocumentUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof WaybillStationInfoOutputDTO
     */
    cargoPackageCount?: number;
    /**
     * 
     * @type {WaybillStationEIrsaliyeOutputDTO}
     * @memberof WaybillStationInfoOutputDTO
     */
    irsaliye?: WaybillStationEIrsaliyeOutputDTO;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WebReceivingBarcodeTypeEnum {
    Product = 'Product',
    Tote = 'Tote',
    InboundBox = 'InboundBox',
    Undefined = 'Undefined'
}

/**
 * 
 * @export
 * @interface WebReceivingInboundBoxDetailsOutputDTO
 */
export interface WebReceivingInboundBoxDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WebReceivingInboundBoxDetailsOutputDTO
     */
    inbounBoxLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof WebReceivingInboundBoxDetailsOutputDTO
     */
    purchaseOrderReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof WebReceivingInboundBoxDetailsOutputDTO
     */
    waybillReferenceNumber?: string;
    /**
     * 
     * @type {OperationOutputDTO}
     * @memberof WebReceivingInboundBoxDetailsOutputDTO
     */
    operation?: OperationOutputDTO;
}
/**
 * 
 * @export
 * @interface WebReceivingToteDetailsOutputDTO
 */
export interface WebReceivingToteDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WebReceivingToteDetailsOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof WebReceivingToteDetailsOutputDTO
     */
    totalItemAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WebReceivingToteDetailsOutputDTO
     */
    totalProductAmount?: number;
}
/**
 * 
 * @export
 * @interface WebSocketManager
 */
export interface WebSocketManager {
    /**
     * 
     * @type {boolean}
     * @memberof WebSocketManager
     */
    isWebSocketRequest?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebSocketManager
     */
    webSocketRequestedProtocols?: Array<string>;
}
/**
 * 
 * @export
 * @interface WebhookActionInputDTO
 */
export interface WebhookActionInputDTO {
    /**
     * 
     * @type {string}
     * @memberof WebhookActionInputDTO
     */
    url?: string;
    /**
     * 
     * @type {HttpMethod}
     * @memberof WebhookActionInputDTO
     */
    method?: HttpMethod;
    /**
     * 
     * @type {string}
     * @memberof WebhookActionInputDTO
     */
    headers?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookActionInputDTO
     */
    body?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WorkflowActionType {
    None = 'None',
    EmailAction = 'EmailAction',
    PrintAction = 'PrintAction',
    WebhookAction = 'WebhookAction',
    QueueAction = 'QueueAction'
}

/**
 * 
 * @export
 * @interface WorkflowQueryOutputDTO
 */
export interface WorkflowQueryOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WorkflowQueryOutputDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowQueryOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowQueryOutputDTO
     */
    triggerEvent?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowQueryOutputDTO
     */
    filter?: string;
    /**
     * 
     * @type {WorkflowActionType}
     * @memberof WorkflowQueryOutputDTO
     */
    action?: WorkflowActionType;
    /**
     * 
     * @type {WorkflowState}
     * @memberof WorkflowQueryOutputDTO
     */
    state?: WorkflowState;
    /**
     * 
     * @type {string}
     * @memberof WorkflowQueryOutputDTO
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowQueryOutputDTO
     */
    createdAt?: string;
}
/**
 * 
 * @export
 * @interface WorkflowQueryOutputDTODynamicQueryOutputDTO
 */
export interface WorkflowQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<WorkflowQueryOutputDTO>}
     * @memberof WorkflowQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<WorkflowQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof WorkflowQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WorkflowState {
    None = 'None',
    Active = 'Active',
    Deactive = 'Deactive'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum WranglingToteType {
    None = 'None',
    SingleOrder = 'SingleOrder',
    Batch = 'Batch',
    Missing = 'Missing',
    HovBatch = 'HOVBatch'
}

/**
 * 
 * @export
 * @interface WrongShippingAddressProblemDetailsOutputDTO
 */
export interface WrongShippingAddressProblemDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof WrongShippingAddressProblemDetailsOutputDTO
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof WrongShippingAddressProblemDetailsOutputDTO
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof WrongShippingAddressProblemDetailsOutputDTO
     */
    openedAt?: string;
    /**
     * 
     * @type {ProblemSource}
     * @memberof WrongShippingAddressProblemDetailsOutputDTO
     */
    source?: ProblemSource;
    /**
     * 
     * @type {ProblemState}
     * @memberof WrongShippingAddressProblemDetailsOutputDTO
     */
    state?: ProblemState;
    /**
     * 
     * @type {WrongShippingAddressProblemState}
     * @memberof WrongShippingAddressProblemDetailsOutputDTO
     */
    stateDetail?: WrongShippingAddressProblemState;
    /**
     * 
     * @type {string}
     * @memberof WrongShippingAddressProblemDetailsOutputDTO
     */
    customerServicesReviewedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof WrongShippingAddressProblemDetailsOutputDTO
     */
    resolvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof WrongShippingAddressProblemDetailsOutputDTO
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof WrongShippingAddressProblemDetailsOutputDTO
     */
    resolutionNote?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WrongShippingAddressProblemState {
    None = 'None',
    Created = 'Created',
    CustomerServicesReviewed = 'CustomerServicesReviewed',
    Resolved = 'Resolved'
}

/**
 * 
 * @export
 * @interface X500DistinguishedName
 */
export interface X500DistinguishedName {
    /**
     * 
     * @type {string}
     * @memberof X500DistinguishedName
     */
    name?: string;
    /**
     * 
     * @type {Oid}
     * @memberof X500DistinguishedName
     */
    oid?: Oid;
    /**
     * 
     * @type {string}
     * @memberof X500DistinguishedName
     */
    rawData?: string;
}
/**
 * 
 * @export
 * @interface X509Certificate2
 */
export interface X509Certificate2 {
    /**
     * 
     * @type {boolean}
     * @memberof X509Certificate2
     */
    archived?: boolean;
    /**
     * 
     * @type {Array<X509Extension>}
     * @memberof X509Certificate2
     */
    extensions?: Array<X509Extension>;
    /**
     * 
     * @type {string}
     * @memberof X509Certificate2
     */
    friendlyName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof X509Certificate2
     */
    hasPrivateKey?: boolean;
    /**
     * 
     * @type {AsymmetricAlgorithm}
     * @memberof X509Certificate2
     */
    privateKey?: AsymmetricAlgorithm;
    /**
     * 
     * @type {X500DistinguishedName}
     * @memberof X509Certificate2
     */
    issuerName?: X500DistinguishedName;
    /**
     * 
     * @type {string}
     * @memberof X509Certificate2
     */
    notAfter?: string;
    /**
     * 
     * @type {string}
     * @memberof X509Certificate2
     */
    notBefore?: string;
    /**
     * 
     * @type {PublicKey}
     * @memberof X509Certificate2
     */
    publicKey?: PublicKey;
    /**
     * 
     * @type {string}
     * @memberof X509Certificate2
     */
    rawData?: string;
    /**
     * 
     * @type {ByteReadOnlyMemory}
     * @memberof X509Certificate2
     */
    rawDataMemory?: ByteReadOnlyMemory;
    /**
     * 
     * @type {string}
     * @memberof X509Certificate2
     */
    serialNumber?: string;
    /**
     * 
     * @type {Oid}
     * @memberof X509Certificate2
     */
    signatureAlgorithm?: Oid;
    /**
     * 
     * @type {X500DistinguishedName}
     * @memberof X509Certificate2
     */
    subjectName?: X500DistinguishedName;
    /**
     * 
     * @type {string}
     * @memberof X509Certificate2
     */
    thumbprint?: string;
    /**
     * 
     * @type {number}
     * @memberof X509Certificate2
     */
    version?: number;
    /**
     * 
     * @type {string}
     * @memberof X509Certificate2
     */
    handle?: string;
    /**
     * 
     * @type {string}
     * @memberof X509Certificate2
     */
    issuer?: string;
    /**
     * 
     * @type {string}
     * @memberof X509Certificate2
     */
    subject?: string;
    /**
     * 
     * @type {ByteReadOnlyMemory}
     * @memberof X509Certificate2
     */
    serialNumberBytes?: ByteReadOnlyMemory;
}
/**
 * 
 * @export
 * @interface X509Extension
 */
export interface X509Extension {
    /**
     * 
     * @type {boolean}
     * @memberof X509Extension
     */
    critical?: boolean;
    /**
     * 
     * @type {Oid}
     * @memberof X509Extension
     */
    oid?: Oid;
    /**
     * 
     * @type {string}
     * @memberof X509Extension
     */
    rawData?: string;
}
/**
 * 
 * @export
 * @interface ZoneDetailOutputDTO
 */
export interface ZoneDetailOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof ZoneDetailOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof ZoneDetailOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof ZoneDetailOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {ZoneType}
     * @memberof ZoneDetailOutputDTO
     */
    type?: ZoneType;
    /**
     * 
     * @type {number}
     * @memberof ZoneDetailOutputDTO
     */
    priority?: number;
    /**
     * 
     * @type {number}
     * @memberof ZoneDetailOutputDTO
     */
    maxPickingCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof ZoneDetailOutputDTO
     */
    zoneAdressesCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ZoneDetailOutputDTO
     */
    zoneProductsCount?: number;
}
/**
 * 
 * @export
 * @interface ZoneOccupancyDetailsOutputDTO
 */
export interface ZoneOccupancyDetailsOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ZoneOccupancyDetailsOutputDTO
     */
    stockZone?: string;
    /**
     * 
     * @type {number}
     * @memberof ZoneOccupancyDetailsOutputDTO
     */
    zoneVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof ZoneOccupancyDetailsOutputDTO
     */
    productVolume?: number;
    /**
     * 
     * @type {number}
     * @memberof ZoneOccupancyDetailsOutputDTO
     */
    occupancy?: number;
}
/**
 * 
 * @export
 * @interface ZonePickListConfigurationOutputDTO
 */
export interface ZonePickListConfigurationOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof ZonePickListConfigurationOutputDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ZonePickListConfigurationOutputDTO
     */
    stockZoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof ZonePickListConfigurationOutputDTO
     */
    stockZone?: string;
    /**
     * 
     * @type {PickingFlowTag}
     * @memberof ZonePickListConfigurationOutputDTO
     */
    pickingFlowTag?: PickingFlowTag;
    /**
     * 
     * @type {number}
     * @memberof ZonePickListConfigurationOutputDTO
     */
    pickListCountThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof ZonePickListConfigurationOutputDTO
     */
    pickListCreateAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ZonePickListConfigurationOutputDTO
     */
    disposePickLists?: boolean;
    /**
     * 
     * @type {StockZonePickingType}
     * @memberof ZonePickListConfigurationOutputDTO
     */
    zonePickingType?: StockZonePickingType;
    /**
     * 
     * @type {boolean}
     * @memberof ZonePickListConfigurationOutputDTO
     */
    rasEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface ZonePickListConfigurationOutputDTODynamicQueryOutputDTO
 */
export interface ZonePickListConfigurationOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ZonePickListConfigurationOutputDTO>}
     * @memberof ZonePickListConfigurationOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ZonePickListConfigurationOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ZonePickListConfigurationOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ZoneQueryOutputDTO
 */
export interface ZoneQueryOutputDTO {
    /**
     * 
     * @type {number}
     * @memberof ZoneQueryOutputDTO
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof ZoneQueryOutputDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof ZoneQueryOutputDTO
     */
    name?: string;
    /**
     * 
     * @type {ZoneType}
     * @memberof ZoneQueryOutputDTO
     */
    type?: ZoneType;
    /**
     * 
     * @type {number}
     * @memberof ZoneQueryOutputDTO
     */
    priority?: number;
    /**
     * 
     * @type {number}
     * @memberof ZoneQueryOutputDTO
     */
    maxPickingCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof ZoneQueryOutputDTO
     */
    zoneAdressesCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ZoneQueryOutputDTO
     */
    zoneProductsCount?: number;
}
/**
 * 
 * @export
 * @interface ZoneQueryOutputDTODynamicQueryOutputDTO
 */
export interface ZoneQueryOutputDTODynamicQueryOutputDTO {
    /**
     * 
     * @type {Array<ZoneQueryOutputDTO>}
     * @memberof ZoneQueryOutputDTODynamicQueryOutputDTO
     */
    data?: Array<ZoneQueryOutputDTO>;
    /**
     * 
     * @type {number}
     * @memberof ZoneQueryOutputDTODynamicQueryOutputDTO
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ZoneToteDTO
 */
export interface ZoneToteDTO {
    /**
     * 
     * @type {string}
     * @memberof ZoneToteDTO
     */
    toteLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof ZoneToteDTO
     */
    timePassedSincePlacedToQuarantineWall?: number;
    /**
     * 
     * @type {SalesChannel}
     * @memberof ZoneToteDTO
     */
    salesChannel?: SalesChannel;
}
/**
 * 
 * @export
 * @interface ZoneTotes
 */
export interface ZoneTotes {
    /**
     * 
     * @type {string}
     * @memberof ZoneTotes
     */
    zoneName?: string;
    /**
     * 
     * @type {Array<ZoneToteDTO>}
     * @memberof ZoneTotes
     */
    totes?: Array<ZoneToteDTO>;
}
/**
 * 
 * @export
 * @interface ZoneTransferOutputDTO
 */
export interface ZoneTransferOutputDTO {
    /**
     * 
     * @type {string}
     * @memberof ZoneTransferOutputDTO
     */
    operationName?: string;
    /**
     * 
     * @type {number}
     * @memberof ZoneTransferOutputDTO
     */
    oldZoneId?: number;
    /**
     * 
     * @type {number}
     * @memberof ZoneTransferOutputDTO
     */
    newZoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof ZoneTransferOutputDTO
     */
    transferType?: string;
    /**
     * 
     * @type {number}
     * @memberof ZoneTransferOutputDTO
     */
    affectedStockZoneProductsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ZoneTransferOutputDTO
     */
    updatedAddressesCount?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ZoneType {
    None = 'None',
    StockZone = 'StockZone'
}


/**
 * AddressesApi - axios parameter creator
 * @export
 */
export const AddressesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateApprovedSLAMAddressesCommand} [createApprovedSLAMAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateApprovedSLAMAddressesPost: async (createApprovedSLAMAddressesCommand?: CreateApprovedSLAMAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createApprovedSLAMAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createApprovedSLAMAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDispatchAddressesCommand} [createDispatchAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateDispatchAddressesPost: async (createDispatchAddressesCommand?: CreateDispatchAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createDispatchAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDispatchAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDropAddressesCommand} [createDropAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateDropAddressesPost: async (createDropAddressesCommand?: CreateDropAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createDropAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDropAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateHOVPackingAddressesCommand} [createHOVPackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateHOVPackingAddressesPost: async (createHOVPackingAddressesCommand?: CreateHOVPackingAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createHOVPackingAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createHOVPackingAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateHOVRebinAddressesCommand} [createHOVRebinAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateHOVRebinAddressesPost: async (createHOVRebinAddressesCommand?: CreateHOVRebinAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createHOVRebinAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createHOVRebinAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateHoldingZoneAddressCommand} [createHoldingZoneAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateHoldingZoneAddressPost: async (createHoldingZoneAddressCommand?: CreateHoldingZoneAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createHoldingZoneAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createHoldingZoneAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateInboundAddressesCommand} [createInboundAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateInboundAddressesPost: async (createInboundAddressesCommand?: CreateInboundAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createInboundAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInboundAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateLostItemAddressesCommand} [createLostItemAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateLostItemAddressPost: async (createLostItemAddressesCommand?: CreateLostItemAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createLostItemAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLostItemAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateManualDeliveryAddressesCommand} [createManualDeliveryAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateManualDeliveryAddressesPost: async (createManualDeliveryAddressesCommand?: CreateManualDeliveryAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createManualDeliveryAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManualDeliveryAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePackingAddressesCommand} [createPackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreatePackingAddressesPost: async (createPackingAddressesCommand?: CreatePackingAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createPackingAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPackingAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateParkAddressesCommand} [createParkAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateParkAddressesPost: async (createParkAddressesCommand?: CreateParkAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createParkAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createParkAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateProblemSolverAddressesCommand} [createProblemSolverAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateProblemSolverAddressesPost: async (createProblemSolverAddressesCommand?: CreateProblemSolverAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createProblemSolverAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProblemSolverAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRasDropAddressesCommand} [createRasDropAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateRasDropAddressesPost: async (createRasDropAddressesCommand?: CreateRasDropAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createRasDropAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRasDropAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRasOrderBasedPickStationsCommand} [createRasOrderBasedPickStationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateRasOrderBasedPickStationsPost: async (createRasOrderBasedPickStationsCommand?: CreateRasOrderBasedPickStationsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createRasOrderBasedPickStations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRasOrderBasedPickStationsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRasPickStationsCommand} [createRasPickStationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateRasPickStationsPost: async (createRasPickStationsCommand?: CreateRasPickStationsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createRasPickStations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRasPickStationsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRasProblemSolverStationsCommand} [createRasProblemSolverStationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateRasProblemSolverStationsPost: async (createRasProblemSolverStationsCommand?: CreateRasProblemSolverStationsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createRasProblemSolverStations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRasProblemSolverStationsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRasStowStationsCommand} [createRasStowStationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateRasStowStationsPost: async (createRasStowStationsCommand?: CreateRasStowStationsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createRasStowStations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRasStowStationsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRebinAddressesCommand} [createRebinAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateRebinAddressesPost: async (createRebinAddressesCommand?: CreateRebinAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createRebinAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRebinAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRebinSingleAddressesCommand} [createRebinSingleAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateRebinSingleAddressesPost: async (createRebinSingleAddressesCommand?: CreateRebinSingleAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createRebinSingleAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRebinSingleAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateReceivingAddressesCommand} [createReceivingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateReceivingAddressesPost: async (createReceivingAddressesCommand?: CreateReceivingAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createReceivingAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReceivingAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateReturnAddressesCommand} [createReturnAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateReturnAddressesPost: async (createReturnAddressesCommand?: CreateReturnAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createReturnAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReturnAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSLAMAddressesCommand} [createSLAMAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateSLAMAddressesPost: async (createSLAMAddressesCommand?: CreateSLAMAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createSLAMAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSLAMAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSimplePackingAddressesCommand} [createSimplePackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateSimplePackingAddressesPost: async (createSimplePackingAddressesCommand?: CreateSimplePackingAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createSimplePackingAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSimplePackingAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSingleItemFastPackPackingAddressesCommand} [createSingleItemFastPackPackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateSingleItemFastPackPackingAddressesPost: async (createSingleItemFastPackPackingAddressesCommand?: CreateSingleItemFastPackPackingAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createSingleItemFastPackPackingAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSingleItemFastPackPackingAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSingleItemPackingAddressesCommand} [createSingleItemPackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateSingleItemPackingAddressesPost: async (createSingleItemPackingAddressesCommand?: CreateSingleItemPackingAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createSingleItemPackingAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSingleItemPackingAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateStockAddressesCommand} [createStockAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateStockAddressesPost: async (createStockAddressesCommand?: CreateStockAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createStockAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStockAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateWallPackingAddressesCommand} [createWallPackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateWallPackingAddressesPost: async (createWallPackingAddressesCommand?: CreateWallPackingAddressesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Addresses.createWallPackingAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWallPackingAddressesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AddressesGetAddressTypeGet: async (addressLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Addresses.getAddressType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (addressLabel !== undefined) {
                localVarQueryParameter['AddressLabel'] = addressLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AddressesQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Addresses.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MoveContainersToZoneCommand} [moveContainersToZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1AddressesMoveContainersToZonePost: async (moveContainersToZoneCommand?: MoveContainersToZoneCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Addresses/moveContainersToZone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveContainersToZoneCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateRebinTrolleyStateToPackingCommand} [updateRebinTrolleyStateToPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1AddressesUpdateRebinTrolleyStateToPackingPost: async (updateRebinTrolleyStateToPackingCommand?: UpdateRebinTrolleyStateToPackingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Addresses/updateRebinTrolleyStateToPacking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRebinTrolleyStateToPackingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressesApi - functional programming interface
 * @export
 */
export const AddressesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddressesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateApprovedSLAMAddressesCommand} [createApprovedSLAMAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateApprovedSLAMAddressesPost(createApprovedSLAMAddressesCommand?: CreateApprovedSLAMAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateApprovedSLAMAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateApprovedSLAMAddressesPost(createApprovedSLAMAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateDispatchAddressesCommand} [createDispatchAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateDispatchAddressesPost(createDispatchAddressesCommand?: CreateDispatchAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateDispatchAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateDispatchAddressesPost(createDispatchAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateDropAddressesCommand} [createDropAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateDropAddressesPost(createDropAddressesCommand?: CreateDropAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateDropAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateDropAddressesPost(createDropAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateHOVPackingAddressesCommand} [createHOVPackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateHOVPackingAddressesPost(createHOVPackingAddressesCommand?: CreateHOVPackingAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateHOVPackingAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateHOVPackingAddressesPost(createHOVPackingAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateHOVRebinAddressesCommand} [createHOVRebinAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateHOVRebinAddressesPost(createHOVRebinAddressesCommand?: CreateHOVRebinAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateRebinAddressesOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateHOVRebinAddressesPost(createHOVRebinAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateHoldingZoneAddressCommand} [createHoldingZoneAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateHoldingZoneAddressPost(createHoldingZoneAddressCommand?: CreateHoldingZoneAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateHoldingZoneAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateHoldingZoneAddressPost(createHoldingZoneAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateInboundAddressesCommand} [createInboundAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateInboundAddressesPost(createInboundAddressesCommand?: CreateInboundAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateInboundAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateInboundAddressesPost(createInboundAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateLostItemAddressesCommand} [createLostItemAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateLostItemAddressPost(createLostItemAddressesCommand?: CreateLostItemAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateLostItemAddressOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateLostItemAddressPost(createLostItemAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateManualDeliveryAddressesCommand} [createManualDeliveryAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateManualDeliveryAddressesPost(createManualDeliveryAddressesCommand?: CreateManualDeliveryAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateManualDeliveryAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateManualDeliveryAddressesPost(createManualDeliveryAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePackingAddressesCommand} [createPackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreatePackingAddressesPost(createPackingAddressesCommand?: CreatePackingAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreatePackingAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreatePackingAddressesPost(createPackingAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateParkAddressesCommand} [createParkAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateParkAddressesPost(createParkAddressesCommand?: CreateParkAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateParkAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateParkAddressesPost(createParkAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateProblemSolverAddressesCommand} [createProblemSolverAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateProblemSolverAddressesPost(createProblemSolverAddressesCommand?: CreateProblemSolverAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateProblemSolverAddressesOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateProblemSolverAddressesPost(createProblemSolverAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateRasDropAddressesCommand} [createRasDropAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateRasDropAddressesPost(createRasDropAddressesCommand?: CreateRasDropAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateRasDropAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateRasDropAddressesPost(createRasDropAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateRasOrderBasedPickStationsCommand} [createRasOrderBasedPickStationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateRasOrderBasedPickStationsPost(createRasOrderBasedPickStationsCommand?: CreateRasOrderBasedPickStationsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateRasOrderBasedPickStationOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateRasOrderBasedPickStationsPost(createRasOrderBasedPickStationsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateRasPickStationsCommand} [createRasPickStationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateRasPickStationsPost(createRasPickStationsCommand?: CreateRasPickStationsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateRasPickStationOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateRasPickStationsPost(createRasPickStationsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateRasProblemSolverStationsCommand} [createRasProblemSolverStationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateRasProblemSolverStationsPost(createRasProblemSolverStationsCommand?: CreateRasProblemSolverStationsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateRasProblemSolverStationOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateRasProblemSolverStationsPost(createRasProblemSolverStationsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateRasStowStationsCommand} [createRasStowStationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateRasStowStationsPost(createRasStowStationsCommand?: CreateRasStowStationsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateRasStowStationOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateRasStowStationsPost(createRasStowStationsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateRebinAddressesCommand} [createRebinAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateRebinAddressesPost(createRebinAddressesCommand?: CreateRebinAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateRebinAddressesOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateRebinAddressesPost(createRebinAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateRebinSingleAddressesCommand} [createRebinSingleAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateRebinSingleAddressesPost(createRebinSingleAddressesCommand?: CreateRebinSingleAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateRebinSingleAddressesOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateRebinSingleAddressesPost(createRebinSingleAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateReceivingAddressesCommand} [createReceivingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateReceivingAddressesPost(createReceivingAddressesCommand?: CreateReceivingAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateReceivingAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateReceivingAddressesPost(createReceivingAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateReturnAddressesCommand} [createReturnAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateReturnAddressesPost(createReturnAddressesCommand?: CreateReturnAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateReturnAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateReturnAddressesPost(createReturnAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSLAMAddressesCommand} [createSLAMAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateSLAMAddressesPost(createSLAMAddressesCommand?: CreateSLAMAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateSLAMAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateSLAMAddressesPost(createSLAMAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSimplePackingAddressesCommand} [createSimplePackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateSimplePackingAddressesPost(createSimplePackingAddressesCommand?: CreateSimplePackingAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateSimplePackingAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateSimplePackingAddressesPost(createSimplePackingAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSingleItemFastPackPackingAddressesCommand} [createSingleItemFastPackPackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateSingleItemFastPackPackingAddressesPost(createSingleItemFastPackPackingAddressesCommand?: CreateSingleItemFastPackPackingAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateSingleItemFastPackPackingAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateSingleItemFastPackPackingAddressesPost(createSingleItemFastPackPackingAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSingleItemPackingAddressesCommand} [createSingleItemPackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateSingleItemPackingAddressesPost(createSingleItemPackingAddressesCommand?: CreateSingleItemPackingAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateSingleItemPackingAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateSingleItemPackingAddressesPost(createSingleItemPackingAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateStockAddressesCommand} [createStockAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateStockAddressesPost(createStockAddressesCommand?: CreateStockAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateStockAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateStockAddressesPost(createStockAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateWallPackingAddressesCommand} [createWallPackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1AddressesCreateWallPackingAddressesPost(createWallPackingAddressesCommand?: CreateWallPackingAddressesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateWallPackingAddressOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1AddressesCreateWallPackingAddressesPost(createWallPackingAddressesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AddressesGetAddressTypeGet(addressLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AddressesGetAddressTypeGet(addressLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AddressesQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AddressesQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MoveContainersToZoneCommand} [moveContainersToZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1AddressesMoveContainersToZonePost(moveContainersToZoneCommand?: MoveContainersToZoneCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MoveContainersToZoneOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1AddressesMoveContainersToZonePost(moveContainersToZoneCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateRebinTrolleyStateToPackingCommand} [updateRebinTrolleyStateToPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1AddressesUpdateRebinTrolleyStateToPackingPost(updateRebinTrolleyStateToPackingCommand?: UpdateRebinTrolleyStateToPackingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateRebinTrolleyStateToPackingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1AddressesUpdateRebinTrolleyStateToPackingPost(updateRebinTrolleyStateToPackingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AddressesApi - factory interface
 * @export
 */
export const AddressesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddressesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateApprovedSLAMAddressesCommand} [createApprovedSLAMAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateApprovedSLAMAddressesPost(createApprovedSLAMAddressesCommand?: CreateApprovedSLAMAddressesCommand, options?: any): AxiosPromise<Array<CreateApprovedSLAMAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateApprovedSLAMAddressesPost(createApprovedSLAMAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateDispatchAddressesCommand} [createDispatchAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateDispatchAddressesPost(createDispatchAddressesCommand?: CreateDispatchAddressesCommand, options?: any): AxiosPromise<Array<CreateDispatchAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateDispatchAddressesPost(createDispatchAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateDropAddressesCommand} [createDropAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateDropAddressesPost(createDropAddressesCommand?: CreateDropAddressesCommand, options?: any): AxiosPromise<Array<CreateDropAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateDropAddressesPost(createDropAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateHOVPackingAddressesCommand} [createHOVPackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateHOVPackingAddressesPost(createHOVPackingAddressesCommand?: CreateHOVPackingAddressesCommand, options?: any): AxiosPromise<Array<CreateHOVPackingAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateHOVPackingAddressesPost(createHOVPackingAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateHOVRebinAddressesCommand} [createHOVRebinAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateHOVRebinAddressesPost(createHOVRebinAddressesCommand?: CreateHOVRebinAddressesCommand, options?: any): AxiosPromise<Array<CreateRebinAddressesOutputDTO>> {
            return localVarFp.adminV1AddressesCreateHOVRebinAddressesPost(createHOVRebinAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateHoldingZoneAddressCommand} [createHoldingZoneAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateHoldingZoneAddressPost(createHoldingZoneAddressCommand?: CreateHoldingZoneAddressCommand, options?: any): AxiosPromise<Array<CreateHoldingZoneAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateHoldingZoneAddressPost(createHoldingZoneAddressCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateInboundAddressesCommand} [createInboundAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateInboundAddressesPost(createInboundAddressesCommand?: CreateInboundAddressesCommand, options?: any): AxiosPromise<Array<CreateInboundAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateInboundAddressesPost(createInboundAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateLostItemAddressesCommand} [createLostItemAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateLostItemAddressPost(createLostItemAddressesCommand?: CreateLostItemAddressesCommand, options?: any): AxiosPromise<CreateLostItemAddressOutputDTO> {
            return localVarFp.adminV1AddressesCreateLostItemAddressPost(createLostItemAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateManualDeliveryAddressesCommand} [createManualDeliveryAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateManualDeliveryAddressesPost(createManualDeliveryAddressesCommand?: CreateManualDeliveryAddressesCommand, options?: any): AxiosPromise<Array<CreateManualDeliveryAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateManualDeliveryAddressesPost(createManualDeliveryAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePackingAddressesCommand} [createPackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreatePackingAddressesPost(createPackingAddressesCommand?: CreatePackingAddressesCommand, options?: any): AxiosPromise<Array<CreatePackingAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreatePackingAddressesPost(createPackingAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateParkAddressesCommand} [createParkAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateParkAddressesPost(createParkAddressesCommand?: CreateParkAddressesCommand, options?: any): AxiosPromise<Array<CreateParkAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateParkAddressesPost(createParkAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateProblemSolverAddressesCommand} [createProblemSolverAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateProblemSolverAddressesPost(createProblemSolverAddressesCommand?: CreateProblemSolverAddressesCommand, options?: any): AxiosPromise<Array<CreateProblemSolverAddressesOutputDTO>> {
            return localVarFp.adminV1AddressesCreateProblemSolverAddressesPost(createProblemSolverAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRasDropAddressesCommand} [createRasDropAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateRasDropAddressesPost(createRasDropAddressesCommand?: CreateRasDropAddressesCommand, options?: any): AxiosPromise<Array<CreateRasDropAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateRasDropAddressesPost(createRasDropAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRasOrderBasedPickStationsCommand} [createRasOrderBasedPickStationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateRasOrderBasedPickStationsPost(createRasOrderBasedPickStationsCommand?: CreateRasOrderBasedPickStationsCommand, options?: any): AxiosPromise<Array<CreateRasOrderBasedPickStationOutputDTO>> {
            return localVarFp.adminV1AddressesCreateRasOrderBasedPickStationsPost(createRasOrderBasedPickStationsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRasPickStationsCommand} [createRasPickStationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateRasPickStationsPost(createRasPickStationsCommand?: CreateRasPickStationsCommand, options?: any): AxiosPromise<Array<CreateRasPickStationOutputDTO>> {
            return localVarFp.adminV1AddressesCreateRasPickStationsPost(createRasPickStationsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRasProblemSolverStationsCommand} [createRasProblemSolverStationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateRasProblemSolverStationsPost(createRasProblemSolverStationsCommand?: CreateRasProblemSolverStationsCommand, options?: any): AxiosPromise<Array<CreateRasProblemSolverStationOutputDTO>> {
            return localVarFp.adminV1AddressesCreateRasProblemSolverStationsPost(createRasProblemSolverStationsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRasStowStationsCommand} [createRasStowStationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateRasStowStationsPost(createRasStowStationsCommand?: CreateRasStowStationsCommand, options?: any): AxiosPromise<Array<CreateRasStowStationOutputDTO>> {
            return localVarFp.adminV1AddressesCreateRasStowStationsPost(createRasStowStationsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRebinAddressesCommand} [createRebinAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateRebinAddressesPost(createRebinAddressesCommand?: CreateRebinAddressesCommand, options?: any): AxiosPromise<Array<CreateRebinAddressesOutputDTO>> {
            return localVarFp.adminV1AddressesCreateRebinAddressesPost(createRebinAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRebinSingleAddressesCommand} [createRebinSingleAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateRebinSingleAddressesPost(createRebinSingleAddressesCommand?: CreateRebinSingleAddressesCommand, options?: any): AxiosPromise<Array<CreateRebinSingleAddressesOutputDTO>> {
            return localVarFp.adminV1AddressesCreateRebinSingleAddressesPost(createRebinSingleAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateReceivingAddressesCommand} [createReceivingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateReceivingAddressesPost(createReceivingAddressesCommand?: CreateReceivingAddressesCommand, options?: any): AxiosPromise<Array<CreateReceivingAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateReceivingAddressesPost(createReceivingAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateReturnAddressesCommand} [createReturnAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateReturnAddressesPost(createReturnAddressesCommand?: CreateReturnAddressesCommand, options?: any): AxiosPromise<Array<CreateReturnAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateReturnAddressesPost(createReturnAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSLAMAddressesCommand} [createSLAMAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateSLAMAddressesPost(createSLAMAddressesCommand?: CreateSLAMAddressesCommand, options?: any): AxiosPromise<Array<CreateSLAMAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateSLAMAddressesPost(createSLAMAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSimplePackingAddressesCommand} [createSimplePackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateSimplePackingAddressesPost(createSimplePackingAddressesCommand?: CreateSimplePackingAddressesCommand, options?: any): AxiosPromise<Array<CreateSimplePackingAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateSimplePackingAddressesPost(createSimplePackingAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSingleItemFastPackPackingAddressesCommand} [createSingleItemFastPackPackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateSingleItemFastPackPackingAddressesPost(createSingleItemFastPackPackingAddressesCommand?: CreateSingleItemFastPackPackingAddressesCommand, options?: any): AxiosPromise<Array<CreateSingleItemFastPackPackingAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateSingleItemFastPackPackingAddressesPost(createSingleItemFastPackPackingAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSingleItemPackingAddressesCommand} [createSingleItemPackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateSingleItemPackingAddressesPost(createSingleItemPackingAddressesCommand?: CreateSingleItemPackingAddressesCommand, options?: any): AxiosPromise<Array<CreateSingleItemPackingAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateSingleItemPackingAddressesPost(createSingleItemPackingAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateStockAddressesCommand} [createStockAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateStockAddressesPost(createStockAddressesCommand?: CreateStockAddressesCommand, options?: any): AxiosPromise<Array<CreateStockAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateStockAddressesPost(createStockAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateWallPackingAddressesCommand} [createWallPackingAddressesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1AddressesCreateWallPackingAddressesPost(createWallPackingAddressesCommand?: CreateWallPackingAddressesCommand, options?: any): AxiosPromise<Array<CreateWallPackingAddressOutputDTO>> {
            return localVarFp.adminV1AddressesCreateWallPackingAddressesPost(createWallPackingAddressesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AddressesGetAddressTypeGet(addressLabel?: string, options?: any): AxiosPromise<AddressTypeOutputDTO> {
            return localVarFp.apiV1AddressesGetAddressTypeGet(addressLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AddressesQueryGet(dqb?: string, options?: any): AxiosPromise<AddressQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1AddressesQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MoveContainersToZoneCommand} [moveContainersToZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1AddressesMoveContainersToZonePost(moveContainersToZoneCommand?: MoveContainersToZoneCommand, options?: any): AxiosPromise<MoveContainersToZoneOutputDTO> {
            return localVarFp.supportV1AddressesMoveContainersToZonePost(moveContainersToZoneCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateRebinTrolleyStateToPackingCommand} [updateRebinTrolleyStateToPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1AddressesUpdateRebinTrolleyStateToPackingPost(updateRebinTrolleyStateToPackingCommand?: UpdateRebinTrolleyStateToPackingCommand, options?: any): AxiosPromise<UpdateRebinTrolleyStateToPackingOutputDTO> {
            return localVarFp.supportV1AddressesUpdateRebinTrolleyStateToPackingPost(updateRebinTrolleyStateToPackingCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AddressesApi - object-oriented interface
 * @export
 * @class AddressesApi
 * @extends {BaseAPI}
 */
export class AddressesApi extends BaseAPI {
    /**
     * 
     * @param {CreateApprovedSLAMAddressesCommand} [createApprovedSLAMAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateApprovedSLAMAddressesPost(createApprovedSLAMAddressesCommand?: CreateApprovedSLAMAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateApprovedSLAMAddressesPost(createApprovedSLAMAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateDispatchAddressesCommand} [createDispatchAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateDispatchAddressesPost(createDispatchAddressesCommand?: CreateDispatchAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateDispatchAddressesPost(createDispatchAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateDropAddressesCommand} [createDropAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateDropAddressesPost(createDropAddressesCommand?: CreateDropAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateDropAddressesPost(createDropAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateHOVPackingAddressesCommand} [createHOVPackingAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateHOVPackingAddressesPost(createHOVPackingAddressesCommand?: CreateHOVPackingAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateHOVPackingAddressesPost(createHOVPackingAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateHOVRebinAddressesCommand} [createHOVRebinAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateHOVRebinAddressesPost(createHOVRebinAddressesCommand?: CreateHOVRebinAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateHOVRebinAddressesPost(createHOVRebinAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateHoldingZoneAddressCommand} [createHoldingZoneAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateHoldingZoneAddressPost(createHoldingZoneAddressCommand?: CreateHoldingZoneAddressCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateHoldingZoneAddressPost(createHoldingZoneAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateInboundAddressesCommand} [createInboundAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateInboundAddressesPost(createInboundAddressesCommand?: CreateInboundAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateInboundAddressesPost(createInboundAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateLostItemAddressesCommand} [createLostItemAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateLostItemAddressPost(createLostItemAddressesCommand?: CreateLostItemAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateLostItemAddressPost(createLostItemAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateManualDeliveryAddressesCommand} [createManualDeliveryAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateManualDeliveryAddressesPost(createManualDeliveryAddressesCommand?: CreateManualDeliveryAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateManualDeliveryAddressesPost(createManualDeliveryAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePackingAddressesCommand} [createPackingAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreatePackingAddressesPost(createPackingAddressesCommand?: CreatePackingAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreatePackingAddressesPost(createPackingAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateParkAddressesCommand} [createParkAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateParkAddressesPost(createParkAddressesCommand?: CreateParkAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateParkAddressesPost(createParkAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateProblemSolverAddressesCommand} [createProblemSolverAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateProblemSolverAddressesPost(createProblemSolverAddressesCommand?: CreateProblemSolverAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateProblemSolverAddressesPost(createProblemSolverAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRasDropAddressesCommand} [createRasDropAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateRasDropAddressesPost(createRasDropAddressesCommand?: CreateRasDropAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateRasDropAddressesPost(createRasDropAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRasOrderBasedPickStationsCommand} [createRasOrderBasedPickStationsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateRasOrderBasedPickStationsPost(createRasOrderBasedPickStationsCommand?: CreateRasOrderBasedPickStationsCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateRasOrderBasedPickStationsPost(createRasOrderBasedPickStationsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRasPickStationsCommand} [createRasPickStationsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateRasPickStationsPost(createRasPickStationsCommand?: CreateRasPickStationsCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateRasPickStationsPost(createRasPickStationsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRasProblemSolverStationsCommand} [createRasProblemSolverStationsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateRasProblemSolverStationsPost(createRasProblemSolverStationsCommand?: CreateRasProblemSolverStationsCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateRasProblemSolverStationsPost(createRasProblemSolverStationsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRasStowStationsCommand} [createRasStowStationsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateRasStowStationsPost(createRasStowStationsCommand?: CreateRasStowStationsCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateRasStowStationsPost(createRasStowStationsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRebinAddressesCommand} [createRebinAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateRebinAddressesPost(createRebinAddressesCommand?: CreateRebinAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateRebinAddressesPost(createRebinAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRebinSingleAddressesCommand} [createRebinSingleAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateRebinSingleAddressesPost(createRebinSingleAddressesCommand?: CreateRebinSingleAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateRebinSingleAddressesPost(createRebinSingleAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateReceivingAddressesCommand} [createReceivingAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateReceivingAddressesPost(createReceivingAddressesCommand?: CreateReceivingAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateReceivingAddressesPost(createReceivingAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateReturnAddressesCommand} [createReturnAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateReturnAddressesPost(createReturnAddressesCommand?: CreateReturnAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateReturnAddressesPost(createReturnAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSLAMAddressesCommand} [createSLAMAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateSLAMAddressesPost(createSLAMAddressesCommand?: CreateSLAMAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateSLAMAddressesPost(createSLAMAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSimplePackingAddressesCommand} [createSimplePackingAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateSimplePackingAddressesPost(createSimplePackingAddressesCommand?: CreateSimplePackingAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateSimplePackingAddressesPost(createSimplePackingAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSingleItemFastPackPackingAddressesCommand} [createSingleItemFastPackPackingAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateSingleItemFastPackPackingAddressesPost(createSingleItemFastPackPackingAddressesCommand?: CreateSingleItemFastPackPackingAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateSingleItemFastPackPackingAddressesPost(createSingleItemFastPackPackingAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSingleItemPackingAddressesCommand} [createSingleItemPackingAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateSingleItemPackingAddressesPost(createSingleItemPackingAddressesCommand?: CreateSingleItemPackingAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateSingleItemPackingAddressesPost(createSingleItemPackingAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateStockAddressesCommand} [createStockAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateStockAddressesPost(createStockAddressesCommand?: CreateStockAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateStockAddressesPost(createStockAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateWallPackingAddressesCommand} [createWallPackingAddressesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public adminV1AddressesCreateWallPackingAddressesPost(createWallPackingAddressesCommand?: CreateWallPackingAddressesCommand, options?: any) {
        return AddressesApiFp(this.configuration).adminV1AddressesCreateWallPackingAddressesPost(createWallPackingAddressesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [addressLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public apiV1AddressesGetAddressTypeGet(addressLabel?: string, options?: any) {
        return AddressesApiFp(this.configuration).apiV1AddressesGetAddressTypeGet(addressLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public apiV1AddressesQueryGet(dqb?: string, options?: any) {
        return AddressesApiFp(this.configuration).apiV1AddressesQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MoveContainersToZoneCommand} [moveContainersToZoneCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public supportV1AddressesMoveContainersToZonePost(moveContainersToZoneCommand?: MoveContainersToZoneCommand, options?: any) {
        return AddressesApiFp(this.configuration).supportV1AddressesMoveContainersToZonePost(moveContainersToZoneCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateRebinTrolleyStateToPackingCommand} [updateRebinTrolleyStateToPackingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public supportV1AddressesUpdateRebinTrolleyStateToPackingPost(updateRebinTrolleyStateToPackingCommand?: UpdateRebinTrolleyStateToPackingCommand, options?: any) {
        return AddressesApiFp(this.configuration).supportV1AddressesUpdateRebinTrolleyStateToPackingPost(updateRebinTrolleyStateToPackingCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ArchiveApi - axios parameter creator
 * @export
 */
export const ArchiveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ArchiveReturnGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Archive.return`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArchiveApi - functional programming interface
 * @export
 */
export const ArchiveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArchiveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ArchiveReturnGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ArchiveReturnGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ArchiveApi - factory interface
 * @export
 */
export const ArchiveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArchiveApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ArchiveReturnGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ArchiveReturnGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArchiveApi - object-oriented interface
 * @export
 * @class ArchiveApi
 * @extends {BaseAPI}
 */
export class ArchiveApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArchiveApi
     */
    public apiV1ArchiveReturnGet(options?: any) {
        return ArchiveApiFp(this.configuration).apiV1ArchiveReturnGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BacklogApi - axios parameter creator
 * @export
 */
export const BacklogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateBacklogRequest} [createBacklogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trendyolV1BacklogCreatePost: async (createBacklogRequest?: CreateBacklogRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/trendyol/v1/Backlog/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBacklogRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BacklogApi - functional programming interface
 * @export
 */
export const BacklogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BacklogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateBacklogRequest} [createBacklogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trendyolV1BacklogCreatePost(createBacklogRequest?: CreateBacklogRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrendyolAck>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trendyolV1BacklogCreatePost(createBacklogRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BacklogApi - factory interface
 * @export
 */
export const BacklogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BacklogApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateBacklogRequest} [createBacklogRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trendyolV1BacklogCreatePost(createBacklogRequest?: CreateBacklogRequest, options?: any): AxiosPromise<TrendyolAck> {
            return localVarFp.trendyolV1BacklogCreatePost(createBacklogRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BacklogApi - object-oriented interface
 * @export
 * @class BacklogApi
 * @extends {BaseAPI}
 */
export class BacklogApi extends BaseAPI {
    /**
     * 
     * @param {CreateBacklogRequest} [createBacklogRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BacklogApi
     */
    public trendyolV1BacklogCreatePost(createBacklogRequest?: CreateBacklogRequest, options?: any) {
        return BacklogApiFp(this.configuration).trendyolV1BacklogCreatePost(createBacklogRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BatchPickingProcessApi - axios parameter creator
 * @export
 */
export const BatchPickingProcessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CheckCellCommand} [checkCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessCheckCellPost: async (checkCellCommand?: CheckCellCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/BatchPickingProcess.checkCell`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkCellCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckBatchPickingDropAddressCommand} [checkBatchPickingDropAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessCheckDropAddressPost: async (checkBatchPickingDropAddressCommand?: CheckBatchPickingDropAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/BatchPickingProcess.checkDropAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkBatchPickingDropAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessCheckIfControlCountingIsActiveGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/BatchPickingProcess.checkIfControlCountingIsActive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckPickingItemExistCommand} [checkPickingItemExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessCheckProductExistPost: async (checkPickingItemExistCommand?: CheckPickingItemExistCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/BatchPickingProcess.checkProductExist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkPickingItemExistCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckBatchPickingToteCommand} [checkBatchPickingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessCheckTotePost: async (checkBatchPickingToteCommand?: CheckBatchPickingToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/BatchPickingProcess.checkTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkBatchPickingToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteBatchPickingProcessCommand} [completeBatchPickingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessCompletePickingProcessPost: async (completeBatchPickingProcessCommand?: CompleteBatchPickingProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/BatchPickingProcess.completePickingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeBatchPickingProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [zoneId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessGetConfigGet: async (zoneId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/BatchPickingProcess.getConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (zoneId !== undefined) {
                localVarQueryParameter['zoneId'] = zoneId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessGetZoneByCellLabelGet: async (cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/BatchPickingProcess.getZoneByCellLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BatchPickingLostItemCommand} [batchPickingLostItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessLostItemPost: async (batchPickingLostItemCommand?: BatchPickingLostItemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/BatchPickingProcess.lostItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchPickingLostItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MountToteToBatchPickingTrolleyCommand} [mountToteToBatchPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessMountToteToTrolleyIfNotMountedPost: async (mountToteToBatchPickingTrolleyCommand?: MountToteToBatchPickingTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/BatchPickingProcess.mountToteToTrolleyIfNotMounted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mountToteToBatchPickingTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceProductToToteCommand} [placeProductToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessPlaceProductPost: async (placeProductToToteCommand?: PlaceProductToToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/BatchPickingProcess.placeProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeProductToToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartCreatedBatchPickingCommand} [startCreatedBatchPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessStartCreatedPickingPost: async (startCreatedBatchPickingCommand?: StartCreatedBatchPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/BatchPickingProcess.startCreatedPicking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startCreatedBatchPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnmountToteFromBatchPickingTrolleyCommand} [unmountToteFromBatchPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessUnmountToteFromTrolleyPost: async (unmountToteFromBatchPickingTrolleyCommand?: UnmountToteFromBatchPickingTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/BatchPickingProcess.unmountToteFromTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unmountToteFromBatchPickingTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertBatchPickingConfigurationCommand} [upsertBatchPickingConfigurationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessUpsertConfigPost: async (upsertBatchPickingConfigurationCommand?: UpsertBatchPickingConfigurationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/BatchPickingProcess.upsertConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertBatchPickingConfigurationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BatchPickingProcessApi - functional programming interface
 * @export
 */
export const BatchPickingProcessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BatchPickingProcessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CheckCellCommand} [checkCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BatchPickingProcessCheckCellPost(checkCellCommand?: CheckCellCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1BatchPickingProcessCheckCellPost(checkCellCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckBatchPickingDropAddressCommand} [checkBatchPickingDropAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BatchPickingProcessCheckDropAddressPost(checkBatchPickingDropAddressCommand?: CheckBatchPickingDropAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckBatchPickingDropAddressCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1BatchPickingProcessCheckDropAddressPost(checkBatchPickingDropAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BatchPickingProcessCheckIfControlCountingIsActiveGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckIfControlCountingIsActiveOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1BatchPickingProcessCheckIfControlCountingIsActiveGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckPickingItemExistCommand} [checkPickingItemExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BatchPickingProcessCheckProductExistPost(checkPickingItemExistCommand?: CheckPickingItemExistCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1BatchPickingProcessCheckProductExistPost(checkPickingItemExistCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckBatchPickingToteCommand} [checkBatchPickingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BatchPickingProcessCheckTotePost(checkBatchPickingToteCommand?: CheckBatchPickingToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1BatchPickingProcessCheckTotePost(checkBatchPickingToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteBatchPickingProcessCommand} [completeBatchPickingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BatchPickingProcessCompletePickingProcessPost(completeBatchPickingProcessCommand?: CompleteBatchPickingProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1BatchPickingProcessCompletePickingProcessPost(completeBatchPickingProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [zoneId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BatchPickingProcessGetConfigGet(zoneId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchPickingConfigurationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1BatchPickingProcessGetConfigGet(zoneId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BatchPickingProcessGetZoneByCellLabelGet(cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetZoneByCellLabelOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1BatchPickingProcessGetZoneByCellLabelGet(cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BatchPickingLostItemCommand} [batchPickingLostItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BatchPickingProcessLostItemPost(batchPickingLostItemCommand?: BatchPickingLostItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1BatchPickingProcessLostItemPost(batchPickingLostItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MountToteToBatchPickingTrolleyCommand} [mountToteToBatchPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BatchPickingProcessMountToteToTrolleyIfNotMountedPost(mountToteToBatchPickingTrolleyCommand?: MountToteToBatchPickingTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1BatchPickingProcessMountToteToTrolleyIfNotMountedPost(mountToteToBatchPickingTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceProductToToteCommand} [placeProductToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BatchPickingProcessPlaceProductPost(placeProductToToteCommand?: PlaceProductToToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1BatchPickingProcessPlaceProductPost(placeProductToToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StartCreatedBatchPickingCommand} [startCreatedBatchPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BatchPickingProcessStartCreatedPickingPost(startCreatedBatchPickingCommand?: StartCreatedBatchPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1BatchPickingProcessStartCreatedPickingPost(startCreatedBatchPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UnmountToteFromBatchPickingTrolleyCommand} [unmountToteFromBatchPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BatchPickingProcessUnmountToteFromTrolleyPost(unmountToteFromBatchPickingTrolleyCommand?: UnmountToteFromBatchPickingTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1BatchPickingProcessUnmountToteFromTrolleyPost(unmountToteFromBatchPickingTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpsertBatchPickingConfigurationCommand} [upsertBatchPickingConfigurationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1BatchPickingProcessUpsertConfigPost(upsertBatchPickingConfigurationCommand?: UpsertBatchPickingConfigurationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1BatchPickingProcessUpsertConfigPost(upsertBatchPickingConfigurationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BatchPickingProcessApi - factory interface
 * @export
 */
export const BatchPickingProcessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BatchPickingProcessApiFp(configuration)
    return {
        /**
         * 
         * @param {CheckCellCommand} [checkCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessCheckCellPost(checkCellCommand?: CheckCellCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1BatchPickingProcessCheckCellPost(checkCellCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckBatchPickingDropAddressCommand} [checkBatchPickingDropAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessCheckDropAddressPost(checkBatchPickingDropAddressCommand?: CheckBatchPickingDropAddressCommand, options?: any): AxiosPromise<CheckBatchPickingDropAddressCommandOutputDTO> {
            return localVarFp.apiV1BatchPickingProcessCheckDropAddressPost(checkBatchPickingDropAddressCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessCheckIfControlCountingIsActiveGet(options?: any): AxiosPromise<CheckIfControlCountingIsActiveOutputDTO> {
            return localVarFp.apiV1BatchPickingProcessCheckIfControlCountingIsActiveGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckPickingItemExistCommand} [checkPickingItemExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessCheckProductExistPost(checkPickingItemExistCommand?: CheckPickingItemExistCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1BatchPickingProcessCheckProductExistPost(checkPickingItemExistCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckBatchPickingToteCommand} [checkBatchPickingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessCheckTotePost(checkBatchPickingToteCommand?: CheckBatchPickingToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1BatchPickingProcessCheckTotePost(checkBatchPickingToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteBatchPickingProcessCommand} [completeBatchPickingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessCompletePickingProcessPost(completeBatchPickingProcessCommand?: CompleteBatchPickingProcessCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1BatchPickingProcessCompletePickingProcessPost(completeBatchPickingProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [zoneId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessGetConfigGet(zoneId?: number, options?: any): AxiosPromise<BatchPickingConfigurationDTO> {
            return localVarFp.apiV1BatchPickingProcessGetConfigGet(zoneId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessGetZoneByCellLabelGet(cellLabel?: string, options?: any): AxiosPromise<GetZoneByCellLabelOutputDTO> {
            return localVarFp.apiV1BatchPickingProcessGetZoneByCellLabelGet(cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BatchPickingLostItemCommand} [batchPickingLostItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessLostItemPost(batchPickingLostItemCommand?: BatchPickingLostItemCommand, options?: any): AxiosPromise<RouteOutputDTO> {
            return localVarFp.apiV1BatchPickingProcessLostItemPost(batchPickingLostItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MountToteToBatchPickingTrolleyCommand} [mountToteToBatchPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessMountToteToTrolleyIfNotMountedPost(mountToteToBatchPickingTrolleyCommand?: MountToteToBatchPickingTrolleyCommand, options?: any): AxiosPromise<RouteOutputDTO> {
            return localVarFp.apiV1BatchPickingProcessMountToteToTrolleyIfNotMountedPost(mountToteToBatchPickingTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceProductToToteCommand} [placeProductToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessPlaceProductPost(placeProductToToteCommand?: PlaceProductToToteCommand, options?: any): AxiosPromise<RouteOutputDTO> {
            return localVarFp.apiV1BatchPickingProcessPlaceProductPost(placeProductToToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StartCreatedBatchPickingCommand} [startCreatedBatchPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessStartCreatedPickingPost(startCreatedBatchPickingCommand?: StartCreatedBatchPickingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1BatchPickingProcessStartCreatedPickingPost(startCreatedBatchPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnmountToteFromBatchPickingTrolleyCommand} [unmountToteFromBatchPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessUnmountToteFromTrolleyPost(unmountToteFromBatchPickingTrolleyCommand?: UnmountToteFromBatchPickingTrolleyCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1BatchPickingProcessUnmountToteFromTrolleyPost(unmountToteFromBatchPickingTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertBatchPickingConfigurationCommand} [upsertBatchPickingConfigurationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1BatchPickingProcessUpsertConfigPost(upsertBatchPickingConfigurationCommand?: UpsertBatchPickingConfigurationCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1BatchPickingProcessUpsertConfigPost(upsertBatchPickingConfigurationCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BatchPickingProcessApi - object-oriented interface
 * @export
 * @class BatchPickingProcessApi
 * @extends {BaseAPI}
 */
export class BatchPickingProcessApi extends BaseAPI {
    /**
     * 
     * @param {CheckCellCommand} [checkCellCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchPickingProcessApi
     */
    public apiV1BatchPickingProcessCheckCellPost(checkCellCommand?: CheckCellCommand, options?: any) {
        return BatchPickingProcessApiFp(this.configuration).apiV1BatchPickingProcessCheckCellPost(checkCellCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckBatchPickingDropAddressCommand} [checkBatchPickingDropAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchPickingProcessApi
     */
    public apiV1BatchPickingProcessCheckDropAddressPost(checkBatchPickingDropAddressCommand?: CheckBatchPickingDropAddressCommand, options?: any) {
        return BatchPickingProcessApiFp(this.configuration).apiV1BatchPickingProcessCheckDropAddressPost(checkBatchPickingDropAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchPickingProcessApi
     */
    public apiV1BatchPickingProcessCheckIfControlCountingIsActiveGet(options?: any) {
        return BatchPickingProcessApiFp(this.configuration).apiV1BatchPickingProcessCheckIfControlCountingIsActiveGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckPickingItemExistCommand} [checkPickingItemExistCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchPickingProcessApi
     */
    public apiV1BatchPickingProcessCheckProductExistPost(checkPickingItemExistCommand?: CheckPickingItemExistCommand, options?: any) {
        return BatchPickingProcessApiFp(this.configuration).apiV1BatchPickingProcessCheckProductExistPost(checkPickingItemExistCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckBatchPickingToteCommand} [checkBatchPickingToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchPickingProcessApi
     */
    public apiV1BatchPickingProcessCheckTotePost(checkBatchPickingToteCommand?: CheckBatchPickingToteCommand, options?: any) {
        return BatchPickingProcessApiFp(this.configuration).apiV1BatchPickingProcessCheckTotePost(checkBatchPickingToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteBatchPickingProcessCommand} [completeBatchPickingProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchPickingProcessApi
     */
    public apiV1BatchPickingProcessCompletePickingProcessPost(completeBatchPickingProcessCommand?: CompleteBatchPickingProcessCommand, options?: any) {
        return BatchPickingProcessApiFp(this.configuration).apiV1BatchPickingProcessCompletePickingProcessPost(completeBatchPickingProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [zoneId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchPickingProcessApi
     */
    public apiV1BatchPickingProcessGetConfigGet(zoneId?: number, options?: any) {
        return BatchPickingProcessApiFp(this.configuration).apiV1BatchPickingProcessGetConfigGet(zoneId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchPickingProcessApi
     */
    public apiV1BatchPickingProcessGetZoneByCellLabelGet(cellLabel?: string, options?: any) {
        return BatchPickingProcessApiFp(this.configuration).apiV1BatchPickingProcessGetZoneByCellLabelGet(cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BatchPickingLostItemCommand} [batchPickingLostItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchPickingProcessApi
     */
    public apiV1BatchPickingProcessLostItemPost(batchPickingLostItemCommand?: BatchPickingLostItemCommand, options?: any) {
        return BatchPickingProcessApiFp(this.configuration).apiV1BatchPickingProcessLostItemPost(batchPickingLostItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MountToteToBatchPickingTrolleyCommand} [mountToteToBatchPickingTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchPickingProcessApi
     */
    public apiV1BatchPickingProcessMountToteToTrolleyIfNotMountedPost(mountToteToBatchPickingTrolleyCommand?: MountToteToBatchPickingTrolleyCommand, options?: any) {
        return BatchPickingProcessApiFp(this.configuration).apiV1BatchPickingProcessMountToteToTrolleyIfNotMountedPost(mountToteToBatchPickingTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceProductToToteCommand} [placeProductToToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchPickingProcessApi
     */
    public apiV1BatchPickingProcessPlaceProductPost(placeProductToToteCommand?: PlaceProductToToteCommand, options?: any) {
        return BatchPickingProcessApiFp(this.configuration).apiV1BatchPickingProcessPlaceProductPost(placeProductToToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StartCreatedBatchPickingCommand} [startCreatedBatchPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchPickingProcessApi
     */
    public apiV1BatchPickingProcessStartCreatedPickingPost(startCreatedBatchPickingCommand?: StartCreatedBatchPickingCommand, options?: any) {
        return BatchPickingProcessApiFp(this.configuration).apiV1BatchPickingProcessStartCreatedPickingPost(startCreatedBatchPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnmountToteFromBatchPickingTrolleyCommand} [unmountToteFromBatchPickingTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchPickingProcessApi
     */
    public apiV1BatchPickingProcessUnmountToteFromTrolleyPost(unmountToteFromBatchPickingTrolleyCommand?: UnmountToteFromBatchPickingTrolleyCommand, options?: any) {
        return BatchPickingProcessApiFp(this.configuration).apiV1BatchPickingProcessUnmountToteFromTrolleyPost(unmountToteFromBatchPickingTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertBatchPickingConfigurationCommand} [upsertBatchPickingConfigurationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchPickingProcessApi
     */
    public apiV1BatchPickingProcessUpsertConfigPost(upsertBatchPickingConfigurationCommand?: UpsertBatchPickingConfigurationCommand, options?: any) {
        return BatchPickingProcessApiFp(this.configuration).apiV1BatchPickingProcessUpsertConfigPost(upsertBatchPickingConfigurationCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CargoCarriersODataApi - axios parameter creator
 * @export
 */
export const CargoCarriersODataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataV1CargoCarriersODataGet: async (authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('odataV1CargoCarriersODataGet', 'authorization', authorization)
            const localVarPath = `/odata/v1/CargoCarriersOData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CargoCarriersODataApi - functional programming interface
 * @export
 */
export const CargoCarriersODataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CargoCarriersODataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async odataV1CargoCarriersODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ODataResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.odataV1CargoCarriersODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CargoCarriersODataApi - factory interface
 * @export
 */
export const CargoCarriersODataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CargoCarriersODataApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataV1CargoCarriersODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any): AxiosPromise<ODataResponseModel> {
            return localVarFp.odataV1CargoCarriersODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CargoCarriersODataApi - object-oriented interface
 * @export
 * @class CargoCarriersODataApi
 * @extends {BaseAPI}
 */
export class CargoCarriersODataApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization The authorization token
     * @param {string} [$select] Get selected properties
     * @param {string} [$filter] Filter the results using OData syntax.
     * @param {string} [$expand] Get the entities that depend on the model
     * @param {string} [$orderby] Order the results using OData syntax
     * @param {string} [$skip] Skip the specified number of entries
     * @param {string} [$top] Get the top x number of records
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CargoCarriersODataApi
     */
    public odataV1CargoCarriersODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any) {
        return CargoCarriersODataApiFp(this.configuration).odataV1CargoCarriersODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CargoPackageTypesApi - axios parameter creator
 * @export
 */
export const CargoPackageTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCargoPackageTypeCommand} [createCargoPackageTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1CargoPackageTypesCreatePost: async (createCargoPackageTypeCommand?: CreateCargoPackageTypeCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/CargoPackageTypes.create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCargoPackageTypeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CargoPackageTypesApi - functional programming interface
 * @export
 */
export const CargoPackageTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CargoPackageTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateCargoPackageTypeCommand} [createCargoPackageTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1CargoPackageTypesCreatePost(createCargoPackageTypeCommand?: CreateCargoPackageTypeCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateCargoPackageTypeOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1CargoPackageTypesCreatePost(createCargoPackageTypeCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CargoPackageTypesApi - factory interface
 * @export
 */
export const CargoPackageTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CargoPackageTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateCargoPackageTypeCommand} [createCargoPackageTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1CargoPackageTypesCreatePost(createCargoPackageTypeCommand?: CreateCargoPackageTypeCommand, options?: any): AxiosPromise<Array<CreateCargoPackageTypeOutputDTO>> {
            return localVarFp.adminV1CargoPackageTypesCreatePost(createCargoPackageTypeCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CargoPackageTypesApi - object-oriented interface
 * @export
 * @class CargoPackageTypesApi
 * @extends {BaseAPI}
 */
export class CargoPackageTypesApi extends BaseAPI {
    /**
     * 
     * @param {CreateCargoPackageTypeCommand} [createCargoPackageTypeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CargoPackageTypesApi
     */
    public adminV1CargoPackageTypesCreatePost(createCargoPackageTypeCommand?: CreateCargoPackageTypeCommand, options?: any) {
        return CargoPackageTypesApiFp(this.configuration).adminV1CargoPackageTypesCreatePost(createCargoPackageTypeCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CarriersApi - axios parameter creator
 * @export
 */
export const CarriersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCarrierCommand} [createCarrierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1CarriersCreateCarrierPost: async (createCarrierCommand?: CreateCarrierCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Carriers.createCarrier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCarrierCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1CarriersUploadCarrierImagePost: async (file?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Carriers.uploadCarrierImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CarriersApi - functional programming interface
 * @export
 */
export const CarriersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CarriersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateCarrierCommand} [createCarrierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1CarriersCreateCarrierPost(createCarrierCommand?: CreateCarrierCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedCarrierOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1CarriersCreateCarrierPost(createCarrierCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1CarriersUploadCarrierImagePost(file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadCarrierImageOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1CarriersUploadCarrierImagePost(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CarriersApi - factory interface
 * @export
 */
export const CarriersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CarriersApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateCarrierCommand} [createCarrierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1CarriersCreateCarrierPost(createCarrierCommand?: CreateCarrierCommand, options?: any): AxiosPromise<CreatedCarrierOutputDTO> {
            return localVarFp.adminV1CarriersCreateCarrierPost(createCarrierCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1CarriersUploadCarrierImagePost(file?: any, options?: any): AxiosPromise<UploadCarrierImageOutputDTO> {
            return localVarFp.adminV1CarriersUploadCarrierImagePost(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CarriersApi - object-oriented interface
 * @export
 * @class CarriersApi
 * @extends {BaseAPI}
 */
export class CarriersApi extends BaseAPI {
    /**
     * 
     * @param {CreateCarrierCommand} [createCarrierCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public adminV1CarriersCreateCarrierPost(createCarrierCommand?: CreateCarrierCommand, options?: any) {
        return CarriersApiFp(this.configuration).adminV1CarriersCreateCarrierPost(createCarrierCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public adminV1CarriersUploadCarrierImagePost(file?: any, options?: any) {
        return CarriersApiFp(this.configuration).adminV1CarriersUploadCarrierImagePost(file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConfigurationsApi - axios parameter creator
 * @export
 */
export const ConfigurationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {BulkUpdateCargoPackageTypeStatusCommand} [bulkUpdateCargoPackageTypeStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ConfigurationsBulkUpdateCargoPackageTypeStatusPost: async (bulkUpdateCargoPackageTypeStatusCommand?: BulkUpdateCargoPackageTypeStatusCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Configurations/bulkUpdateCargoPackageTypeStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateCargoPackageTypeStatusCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateOperationClusterCommand} [updateOperationClusterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ConfigurationsUpdateOperationClusterPost: async (updateOperationClusterCommand?: UpdateOperationClusterCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Configurations/updateOperationCluster`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOperationClusterCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSingleItemFastPackThresholdCommand} [updateSingleItemFastPackThresholdCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ConfigurationsUpdateSingleItemFastPackThresholdPost: async (updateSingleItemFastPackThresholdCommand?: UpdateSingleItemFastPackThresholdCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Configurations/updateSingleItemFastPackThreshold`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSingleItemFastPackThresholdCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateTenantConfigurationCommand} [updateTenantConfigurationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ConfigurationsUpdateTenantConfigurationPost: async (updateTenantConfigurationCommand?: UpdateTenantConfigurationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Configurations/updateTenantConfiguration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTenantConfigurationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigurationsApi - functional programming interface
 * @export
 */
export const ConfigurationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigurationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {BulkUpdateCargoPackageTypeStatusCommand} [bulkUpdateCargoPackageTypeStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ConfigurationsBulkUpdateCargoPackageTypeStatusPost(bulkUpdateCargoPackageTypeStatusCommand?: BulkUpdateCargoPackageTypeStatusCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkUpdateCargoPackageTypeStatusOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ConfigurationsBulkUpdateCargoPackageTypeStatusPost(bulkUpdateCargoPackageTypeStatusCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateOperationClusterCommand} [updateOperationClusterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ConfigurationsUpdateOperationClusterPost(updateOperationClusterCommand?: UpdateOperationClusterCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOperationClusterOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ConfigurationsUpdateOperationClusterPost(updateOperationClusterCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateSingleItemFastPackThresholdCommand} [updateSingleItemFastPackThresholdCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ConfigurationsUpdateSingleItemFastPackThresholdPost(updateSingleItemFastPackThresholdCommand?: UpdateSingleItemFastPackThresholdCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSingleItemFastPackThresholdOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ConfigurationsUpdateSingleItemFastPackThresholdPost(updateSingleItemFastPackThresholdCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateTenantConfigurationCommand} [updateTenantConfigurationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ConfigurationsUpdateTenantConfigurationPost(updateTenantConfigurationCommand?: UpdateTenantConfigurationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTenantConfigurationOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ConfigurationsUpdateTenantConfigurationPost(updateTenantConfigurationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConfigurationsApi - factory interface
 * @export
 */
export const ConfigurationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigurationsApiFp(configuration)
    return {
        /**
         * 
         * @param {BulkUpdateCargoPackageTypeStatusCommand} [bulkUpdateCargoPackageTypeStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ConfigurationsBulkUpdateCargoPackageTypeStatusPost(bulkUpdateCargoPackageTypeStatusCommand?: BulkUpdateCargoPackageTypeStatusCommand, options?: any): AxiosPromise<BulkUpdateCargoPackageTypeStatusOutputDTO> {
            return localVarFp.supportV1ConfigurationsBulkUpdateCargoPackageTypeStatusPost(bulkUpdateCargoPackageTypeStatusCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateOperationClusterCommand} [updateOperationClusterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ConfigurationsUpdateOperationClusterPost(updateOperationClusterCommand?: UpdateOperationClusterCommand, options?: any): AxiosPromise<UpdateOperationClusterOutputDTO> {
            return localVarFp.supportV1ConfigurationsUpdateOperationClusterPost(updateOperationClusterCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateSingleItemFastPackThresholdCommand} [updateSingleItemFastPackThresholdCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ConfigurationsUpdateSingleItemFastPackThresholdPost(updateSingleItemFastPackThresholdCommand?: UpdateSingleItemFastPackThresholdCommand, options?: any): AxiosPromise<UpdateSingleItemFastPackThresholdOutputDTO> {
            return localVarFp.supportV1ConfigurationsUpdateSingleItemFastPackThresholdPost(updateSingleItemFastPackThresholdCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateTenantConfigurationCommand} [updateTenantConfigurationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ConfigurationsUpdateTenantConfigurationPost(updateTenantConfigurationCommand?: UpdateTenantConfigurationCommand, options?: any): AxiosPromise<UpdateTenantConfigurationOutputDTO> {
            return localVarFp.supportV1ConfigurationsUpdateTenantConfigurationPost(updateTenantConfigurationCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigurationsApi - object-oriented interface
 * @export
 * @class ConfigurationsApi
 * @extends {BaseAPI}
 */
export class ConfigurationsApi extends BaseAPI {
    /**
     * 
     * @param {BulkUpdateCargoPackageTypeStatusCommand} [bulkUpdateCargoPackageTypeStatusCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsApi
     */
    public supportV1ConfigurationsBulkUpdateCargoPackageTypeStatusPost(bulkUpdateCargoPackageTypeStatusCommand?: BulkUpdateCargoPackageTypeStatusCommand, options?: any) {
        return ConfigurationsApiFp(this.configuration).supportV1ConfigurationsBulkUpdateCargoPackageTypeStatusPost(bulkUpdateCargoPackageTypeStatusCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateOperationClusterCommand} [updateOperationClusterCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsApi
     */
    public supportV1ConfigurationsUpdateOperationClusterPost(updateOperationClusterCommand?: UpdateOperationClusterCommand, options?: any) {
        return ConfigurationsApiFp(this.configuration).supportV1ConfigurationsUpdateOperationClusterPost(updateOperationClusterCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateSingleItemFastPackThresholdCommand} [updateSingleItemFastPackThresholdCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsApi
     */
    public supportV1ConfigurationsUpdateSingleItemFastPackThresholdPost(updateSingleItemFastPackThresholdCommand?: UpdateSingleItemFastPackThresholdCommand, options?: any) {
        return ConfigurationsApiFp(this.configuration).supportV1ConfigurationsUpdateSingleItemFastPackThresholdPost(updateSingleItemFastPackThresholdCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateTenantConfigurationCommand} [updateTenantConfigurationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsApi
     */
    public supportV1ConfigurationsUpdateTenantConfigurationPost(updateTenantConfigurationCommand?: UpdateTenantConfigurationCommand, options?: any) {
        return ConfigurationsApiFp(this.configuration).supportV1ConfigurationsUpdateTenantConfigurationPost(updateTenantConfigurationCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContainerTransfersApi - axios parameter creator
 * @export
 */
export const ContainerTransfersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainerTransfersCheckToteSalesOrderStateGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ContainerTransfers.checkToteSalesOrderState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConvertCancelledToteSalesOrderItemsToRestowItemCommand} [convertCancelledToteSalesOrderItemsToRestowItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainerTransfersConvertCancelledToteSalesOrderItemsToRestowItemPost: async (convertCancelledToteSalesOrderItemsToRestowItemCommand?: ConvertCancelledToteSalesOrderItemsToRestowItemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ContainerTransfers.convertCancelledToteSalesOrderItemsToRestowItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(convertCancelledToteSalesOrderItemsToRestowItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [transferTrolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainerTransfersGetTransferTrolleyTotesGet: async (transferTrolleyLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ContainerTransfers.getTransferTrolleyTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (transferTrolleyLabel !== undefined) {
                localVarQueryParameter['transferTrolleyLabel'] = transferTrolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InsertToteToTransferTrolleyCommand} [insertToteToTransferTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainerTransfersInsertToteToTransferTrolleyPost: async (insertToteToTransferTrolleyCommand?: InsertToteToTransferTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ContainerTransfers.insertToteToTransferTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(insertToteToTransferTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RemoveToteFromTransferTrolleyCommand} [removeToteFromTransferTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainerTransfersRemoveToteToTransferTrolleyPost: async (removeToteFromTransferTrolleyCommand?: RemoveToteFromTransferTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ContainerTransfers.removeToteToTransferTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeToteFromTransferTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferCancelledSalesOrderToteToQurantineAddressCommand} [transferCancelledSalesOrderToteToQurantineAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainerTransfersTransferCancelledSalesOrderToteToQurantineAddressPost: async (transferCancelledSalesOrderToteToQurantineAddressCommand?: TransferCancelledSalesOrderToteToQurantineAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ContainerTransfers.transferCancelledSalesOrderToteToQurantineAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferCancelledSalesOrderToteToQurantineAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContainerTransfersApi - functional programming interface
 * @export
 */
export const ContainerTransfersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContainerTransfersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainerTransfersCheckToteSalesOrderStateGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckToteSalesOrderStateOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainerTransfersCheckToteSalesOrderStateGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ConvertCancelledToteSalesOrderItemsToRestowItemCommand} [convertCancelledToteSalesOrderItemsToRestowItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainerTransfersConvertCancelledToteSalesOrderItemsToRestowItemPost(convertCancelledToteSalesOrderItemsToRestowItemCommand?: ConvertCancelledToteSalesOrderItemsToRestowItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainerTransfersConvertCancelledToteSalesOrderItemsToRestowItemPost(convertCancelledToteSalesOrderItemsToRestowItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [transferTrolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainerTransfersGetTransferTrolleyTotesGet(transferTrolleyLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTransferTrolleyTotesOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainerTransfersGetTransferTrolleyTotesGet(transferTrolleyLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InsertToteToTransferTrolleyCommand} [insertToteToTransferTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainerTransfersInsertToteToTransferTrolleyPost(insertToteToTransferTrolleyCommand?: InsertToteToTransferTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainerTransfersInsertToteToTransferTrolleyPost(insertToteToTransferTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RemoveToteFromTransferTrolleyCommand} [removeToteFromTransferTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainerTransfersRemoveToteToTransferTrolleyPost(removeToteFromTransferTrolleyCommand?: RemoveToteFromTransferTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainerTransfersRemoveToteToTransferTrolleyPost(removeToteFromTransferTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferCancelledSalesOrderToteToQurantineAddressCommand} [transferCancelledSalesOrderToteToQurantineAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainerTransfersTransferCancelledSalesOrderToteToQurantineAddressPost(transferCancelledSalesOrderToteToQurantineAddressCommand?: TransferCancelledSalesOrderToteToQurantineAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainerTransfersTransferCancelledSalesOrderToteToQurantineAddressPost(transferCancelledSalesOrderToteToQurantineAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContainerTransfersApi - factory interface
 * @export
 */
export const ContainerTransfersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContainerTransfersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainerTransfersCheckToteSalesOrderStateGet(toteLabel?: string, options?: any): AxiosPromise<CheckToteSalesOrderStateOutputDTO> {
            return localVarFp.apiV1ContainerTransfersCheckToteSalesOrderStateGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConvertCancelledToteSalesOrderItemsToRestowItemCommand} [convertCancelledToteSalesOrderItemsToRestowItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainerTransfersConvertCancelledToteSalesOrderItemsToRestowItemPost(convertCancelledToteSalesOrderItemsToRestowItemCommand?: ConvertCancelledToteSalesOrderItemsToRestowItemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ContainerTransfersConvertCancelledToteSalesOrderItemsToRestowItemPost(convertCancelledToteSalesOrderItemsToRestowItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [transferTrolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainerTransfersGetTransferTrolleyTotesGet(transferTrolleyLabel?: string, options?: any): AxiosPromise<Array<GetTransferTrolleyTotesOutputDTO>> {
            return localVarFp.apiV1ContainerTransfersGetTransferTrolleyTotesGet(transferTrolleyLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InsertToteToTransferTrolleyCommand} [insertToteToTransferTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainerTransfersInsertToteToTransferTrolleyPost(insertToteToTransferTrolleyCommand?: InsertToteToTransferTrolleyCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ContainerTransfersInsertToteToTransferTrolleyPost(insertToteToTransferTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RemoveToteFromTransferTrolleyCommand} [removeToteFromTransferTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainerTransfersRemoveToteToTransferTrolleyPost(removeToteFromTransferTrolleyCommand?: RemoveToteFromTransferTrolleyCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ContainerTransfersRemoveToteToTransferTrolleyPost(removeToteFromTransferTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferCancelledSalesOrderToteToQurantineAddressCommand} [transferCancelledSalesOrderToteToQurantineAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainerTransfersTransferCancelledSalesOrderToteToQurantineAddressPost(transferCancelledSalesOrderToteToQurantineAddressCommand?: TransferCancelledSalesOrderToteToQurantineAddressCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ContainerTransfersTransferCancelledSalesOrderToteToQurantineAddressPost(transferCancelledSalesOrderToteToQurantineAddressCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContainerTransfersApi - object-oriented interface
 * @export
 * @class ContainerTransfersApi
 * @extends {BaseAPI}
 */
export class ContainerTransfersApi extends BaseAPI {
    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainerTransfersApi
     */
    public apiV1ContainerTransfersCheckToteSalesOrderStateGet(toteLabel?: string, options?: any) {
        return ContainerTransfersApiFp(this.configuration).apiV1ContainerTransfersCheckToteSalesOrderStateGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConvertCancelledToteSalesOrderItemsToRestowItemCommand} [convertCancelledToteSalesOrderItemsToRestowItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainerTransfersApi
     */
    public apiV1ContainerTransfersConvertCancelledToteSalesOrderItemsToRestowItemPost(convertCancelledToteSalesOrderItemsToRestowItemCommand?: ConvertCancelledToteSalesOrderItemsToRestowItemCommand, options?: any) {
        return ContainerTransfersApiFp(this.configuration).apiV1ContainerTransfersConvertCancelledToteSalesOrderItemsToRestowItemPost(convertCancelledToteSalesOrderItemsToRestowItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [transferTrolleyLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainerTransfersApi
     */
    public apiV1ContainerTransfersGetTransferTrolleyTotesGet(transferTrolleyLabel?: string, options?: any) {
        return ContainerTransfersApiFp(this.configuration).apiV1ContainerTransfersGetTransferTrolleyTotesGet(transferTrolleyLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InsertToteToTransferTrolleyCommand} [insertToteToTransferTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainerTransfersApi
     */
    public apiV1ContainerTransfersInsertToteToTransferTrolleyPost(insertToteToTransferTrolleyCommand?: InsertToteToTransferTrolleyCommand, options?: any) {
        return ContainerTransfersApiFp(this.configuration).apiV1ContainerTransfersInsertToteToTransferTrolleyPost(insertToteToTransferTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RemoveToteFromTransferTrolleyCommand} [removeToteFromTransferTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainerTransfersApi
     */
    public apiV1ContainerTransfersRemoveToteToTransferTrolleyPost(removeToteFromTransferTrolleyCommand?: RemoveToteFromTransferTrolleyCommand, options?: any) {
        return ContainerTransfersApiFp(this.configuration).apiV1ContainerTransfersRemoveToteToTransferTrolleyPost(removeToteFromTransferTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferCancelledSalesOrderToteToQurantineAddressCommand} [transferCancelledSalesOrderToteToQurantineAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainerTransfersApi
     */
    public apiV1ContainerTransfersTransferCancelledSalesOrderToteToQurantineAddressPost(transferCancelledSalesOrderToteToQurantineAddressCommand?: TransferCancelledSalesOrderToteToQurantineAddressCommand, options?: any) {
        return ContainerTransfersApiFp(this.configuration).apiV1ContainerTransfersTransferCancelledSalesOrderToteToQurantineAddressPost(transferCancelledSalesOrderToteToQurantineAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContainersApi - axios parameter creator
 * @export
 */
export const ContainersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCellCommand} [createCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ContainersCreateCellPost: async (createCellCommand?: CreateCellCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Containers.createCell`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCellCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTotesCommand} [createTotesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ContainersCreateTotesPost: async (createTotesCommand?: CreateTotesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Containers.createTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTotesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersCheckContainerBarcodeTypeGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Containers.checkContainerBarcodeType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersGetCellStatusGet: async (cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Containers.getCellStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [boxLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersGetInboundBoxCargoPackageDetailGet: async (boxLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Containers.getInboundBoxCargoPackageDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (boxLabel !== undefined) {
                localVarQueryParameter['boxLabel'] = boxLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersGetToteDetailByLabelGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Containers.getToteDetailByLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersGetToteDetailsGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Containers.getToteDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteOrPalletLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersGetToteOrPalletDetailByLabelGet: async (toteOrPalletLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Containers.getToteOrPalletDetailByLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteOrPalletLabel !== undefined) {
                localVarQueryParameter['toteOrPalletLabel'] = toteOrPalletLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersGetToteStatusGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Containers.getToteStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersQueryCellsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Containers.queryCells`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersQueryStockCellStatusGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Containers.queryStockCellStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersQueryToteStatusGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Containers.queryToteStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersQueryTotesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Containers.queryTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetContainerIsFullCommand} [setContainerIsFullCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersSetContainerIsFullPost: async (setContainerIsFullCommand?: SetContainerIsFullCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Containers.setContainerIsFull`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setContainerIsFullCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkSoftDeleteContainersCommand} [bulkSoftDeleteContainersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ContainersBulkContainerSoftDeletePost: async (bulkSoftDeleteContainersCommand?: BulkSoftDeleteContainersCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Containers/bulkContainerSoftDelete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSoftDeleteContainersCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkUpdateContainerTypeCommand} [bulkUpdateContainerTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ContainersBulkUpdateContainerTypePost: async (bulkUpdateContainerTypeCommand?: BulkUpdateContainerTypeCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Containers/bulkUpdateContainerType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateContainerTypeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetContainerErrorCommand} [resetContainerErrorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ContainersResetContainerErrorPost: async (resetContainerErrorCommand?: ResetContainerErrorCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Containers/resetContainerError`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetContainerErrorCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContainersApi - functional programming interface
 * @export
 */
export const ContainersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContainersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateCellCommand} [createCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1ContainersCreateCellPost(createCellCommand?: CreateCellCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateCellOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1ContainersCreateCellPost(createCellCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateTotesCommand} [createTotesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1ContainersCreateTotesPost(createTotesCommand?: CreateTotesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateToteOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1ContainersCreateTotesPost(createTotesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainersCheckContainerBarcodeTypeGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckContainerBarcodeTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainersCheckContainerBarcodeTypeGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainersGetCellStatusGet(cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CellStatusOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainersGetCellStatusGet(cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [boxLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainersGetInboundBoxCargoPackageDetailGet(boxLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InboundBoxCargoPackageDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainersGetInboundBoxCargoPackageDetailGet(boxLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainersGetToteDetailByLabelGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToteDetailByLabelOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainersGetToteDetailByLabelGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainersGetToteDetailsGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToteDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainersGetToteDetailsGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteOrPalletLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainersGetToteOrPalletDetailByLabelGet(toteOrPalletLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToteDetailByLabelOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainersGetToteOrPalletDetailByLabelGet(toteOrPalletLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainersGetToteStatusGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToteStatusOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainersGetToteStatusGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainersQueryCellsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CellContainerQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainersQueryCellsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainersQueryStockCellStatusGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockCellStatusOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainersQueryStockCellStatusGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainersQueryToteStatusGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToteStatusOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainersQueryToteStatusGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainersQueryTotesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToteContainerQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainersQueryTotesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetContainerIsFullCommand} [setContainerIsFullCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ContainersSetContainerIsFullPost(setContainerIsFullCommand?: SetContainerIsFullCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ContainersSetContainerIsFullPost(setContainerIsFullCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkSoftDeleteContainersCommand} [bulkSoftDeleteContainersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ContainersBulkContainerSoftDeletePost(bulkSoftDeleteContainersCommand?: BulkSoftDeleteContainersCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkSoftDeleteContainersOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ContainersBulkContainerSoftDeletePost(bulkSoftDeleteContainersCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkUpdateContainerTypeCommand} [bulkUpdateContainerTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ContainersBulkUpdateContainerTypePost(bulkUpdateContainerTypeCommand?: BulkUpdateContainerTypeCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkUpdateContainerTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ContainersBulkUpdateContainerTypePost(bulkUpdateContainerTypeCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ResetContainerErrorCommand} [resetContainerErrorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ContainersResetContainerErrorPost(resetContainerErrorCommand?: ResetContainerErrorCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetContainerErrorOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ContainersResetContainerErrorPost(resetContainerErrorCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContainersApi - factory interface
 * @export
 */
export const ContainersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContainersApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateCellCommand} [createCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ContainersCreateCellPost(createCellCommand?: CreateCellCommand, options?: any): AxiosPromise<Array<CreateCellOutputDTO>> {
            return localVarFp.adminV1ContainersCreateCellPost(createCellCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateTotesCommand} [createTotesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ContainersCreateTotesPost(createTotesCommand?: CreateTotesCommand, options?: any): AxiosPromise<Array<CreateToteOutputDTO>> {
            return localVarFp.adminV1ContainersCreateTotesPost(createTotesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersCheckContainerBarcodeTypeGet(barcode?: string, options?: any): AxiosPromise<CheckContainerBarcodeTypeOutputDTO> {
            return localVarFp.apiV1ContainersCheckContainerBarcodeTypeGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersGetCellStatusGet(cellLabel?: string, options?: any): AxiosPromise<CellStatusOutputDTO> {
            return localVarFp.apiV1ContainersGetCellStatusGet(cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [boxLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersGetInboundBoxCargoPackageDetailGet(boxLabel?: string, options?: any): AxiosPromise<InboundBoxCargoPackageDetailDTO> {
            return localVarFp.apiV1ContainersGetInboundBoxCargoPackageDetailGet(boxLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersGetToteDetailByLabelGet(toteLabel?: string, options?: any): AxiosPromise<ToteDetailByLabelOutputDTO> {
            return localVarFp.apiV1ContainersGetToteDetailByLabelGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersGetToteDetailsGet(toteLabel?: string, options?: any): AxiosPromise<ToteDetailsOutputDTO> {
            return localVarFp.apiV1ContainersGetToteDetailsGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteOrPalletLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersGetToteOrPalletDetailByLabelGet(toteOrPalletLabel?: string, options?: any): AxiosPromise<ToteDetailByLabelOutputDTO> {
            return localVarFp.apiV1ContainersGetToteOrPalletDetailByLabelGet(toteOrPalletLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersGetToteStatusGet(toteLabel?: string, options?: any): AxiosPromise<ToteStatusOutputDTO> {
            return localVarFp.apiV1ContainersGetToteStatusGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersQueryCellsGet(dqb?: string, options?: any): AxiosPromise<CellContainerQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ContainersQueryCellsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersQueryStockCellStatusGet(dqb?: string, options?: any): AxiosPromise<StockCellStatusOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ContainersQueryStockCellStatusGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersQueryToteStatusGet(dqb?: string, options?: any): AxiosPromise<ToteStatusOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ContainersQueryToteStatusGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersQueryTotesGet(dqb?: string, options?: any): AxiosPromise<ToteContainerQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ContainersQueryTotesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetContainerIsFullCommand} [setContainerIsFullCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ContainersSetContainerIsFullPost(setContainerIsFullCommand?: SetContainerIsFullCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ContainersSetContainerIsFullPost(setContainerIsFullCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkSoftDeleteContainersCommand} [bulkSoftDeleteContainersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ContainersBulkContainerSoftDeletePost(bulkSoftDeleteContainersCommand?: BulkSoftDeleteContainersCommand, options?: any): AxiosPromise<BulkSoftDeleteContainersOutputDTO> {
            return localVarFp.supportV1ContainersBulkContainerSoftDeletePost(bulkSoftDeleteContainersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkUpdateContainerTypeCommand} [bulkUpdateContainerTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ContainersBulkUpdateContainerTypePost(bulkUpdateContainerTypeCommand?: BulkUpdateContainerTypeCommand, options?: any): AxiosPromise<BulkUpdateContainerTypeOutputDTO> {
            return localVarFp.supportV1ContainersBulkUpdateContainerTypePost(bulkUpdateContainerTypeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResetContainerErrorCommand} [resetContainerErrorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ContainersResetContainerErrorPost(resetContainerErrorCommand?: ResetContainerErrorCommand, options?: any): AxiosPromise<ResetContainerErrorOutputDTO> {
            return localVarFp.supportV1ContainersResetContainerErrorPost(resetContainerErrorCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContainersApi - object-oriented interface
 * @export
 * @class ContainersApi
 * @extends {BaseAPI}
 */
export class ContainersApi extends BaseAPI {
    /**
     * 
     * @param {CreateCellCommand} [createCellCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public adminV1ContainersCreateCellPost(createCellCommand?: CreateCellCommand, options?: any) {
        return ContainersApiFp(this.configuration).adminV1ContainersCreateCellPost(createCellCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateTotesCommand} [createTotesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public adminV1ContainersCreateTotesPost(createTotesCommand?: CreateTotesCommand, options?: any) {
        return ContainersApiFp(this.configuration).adminV1ContainersCreateTotesPost(createTotesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public apiV1ContainersCheckContainerBarcodeTypeGet(barcode?: string, options?: any) {
        return ContainersApiFp(this.configuration).apiV1ContainersCheckContainerBarcodeTypeGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public apiV1ContainersGetCellStatusGet(cellLabel?: string, options?: any) {
        return ContainersApiFp(this.configuration).apiV1ContainersGetCellStatusGet(cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [boxLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public apiV1ContainersGetInboundBoxCargoPackageDetailGet(boxLabel?: string, options?: any) {
        return ContainersApiFp(this.configuration).apiV1ContainersGetInboundBoxCargoPackageDetailGet(boxLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public apiV1ContainersGetToteDetailByLabelGet(toteLabel?: string, options?: any) {
        return ContainersApiFp(this.configuration).apiV1ContainersGetToteDetailByLabelGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public apiV1ContainersGetToteDetailsGet(toteLabel?: string, options?: any) {
        return ContainersApiFp(this.configuration).apiV1ContainersGetToteDetailsGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteOrPalletLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public apiV1ContainersGetToteOrPalletDetailByLabelGet(toteOrPalletLabel?: string, options?: any) {
        return ContainersApiFp(this.configuration).apiV1ContainersGetToteOrPalletDetailByLabelGet(toteOrPalletLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public apiV1ContainersGetToteStatusGet(toteLabel?: string, options?: any) {
        return ContainersApiFp(this.configuration).apiV1ContainersGetToteStatusGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public apiV1ContainersQueryCellsGet(dqb?: string, options?: any) {
        return ContainersApiFp(this.configuration).apiV1ContainersQueryCellsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public apiV1ContainersQueryStockCellStatusGet(dqb?: string, options?: any) {
        return ContainersApiFp(this.configuration).apiV1ContainersQueryStockCellStatusGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public apiV1ContainersQueryToteStatusGet(dqb?: string, options?: any) {
        return ContainersApiFp(this.configuration).apiV1ContainersQueryToteStatusGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public apiV1ContainersQueryTotesGet(dqb?: string, options?: any) {
        return ContainersApiFp(this.configuration).apiV1ContainersQueryTotesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetContainerIsFullCommand} [setContainerIsFullCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public apiV1ContainersSetContainerIsFullPost(setContainerIsFullCommand?: SetContainerIsFullCommand, options?: any) {
        return ContainersApiFp(this.configuration).apiV1ContainersSetContainerIsFullPost(setContainerIsFullCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkSoftDeleteContainersCommand} [bulkSoftDeleteContainersCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public supportV1ContainersBulkContainerSoftDeletePost(bulkSoftDeleteContainersCommand?: BulkSoftDeleteContainersCommand, options?: any) {
        return ContainersApiFp(this.configuration).supportV1ContainersBulkContainerSoftDeletePost(bulkSoftDeleteContainersCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkUpdateContainerTypeCommand} [bulkUpdateContainerTypeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public supportV1ContainersBulkUpdateContainerTypePost(bulkUpdateContainerTypeCommand?: BulkUpdateContainerTypeCommand, options?: any) {
        return ContainersApiFp(this.configuration).supportV1ContainersBulkUpdateContainerTypePost(bulkUpdateContainerTypeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResetContainerErrorCommand} [resetContainerErrorCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainersApi
     */
    public supportV1ContainersResetContainerErrorPost(resetContainerErrorCommand?: ResetContainerErrorCommand, options?: any) {
        return ContainersApiFp(this.configuration).supportV1ContainersResetContainerErrorPost(resetContainerErrorCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConveyorApi - axios parameter creator
 * @export
 */
export const ConveyorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ConveyorGetToteProductZoneDetailsGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Conveyor.getToteProductZoneDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['ToteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plcV1ConveyorGetCargoPackageSLAMDetailsGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/plc/v1/Conveyor.getCargoPackageSLAMDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['Barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plcV1ConveyorGetFloorNumberToCarryToteGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/plc/v1/Conveyor.getFloorNumberToCarryTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['ToteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plcV1ConveyorGetSortingStationForCargoPackageGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/plc/v1/Conveyor.getSortingStationForCargoPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['Barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TagCargoPackageCommand} [tagCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plcV1ConveyorTagCargoPackagePost: async (tagCargoPackageCommand?: TagCargoPackageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/plc/v1/Conveyor.tagCargoPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tagCargoPackageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConveyorApi - functional programming interface
 * @export
 */
export const ConveyorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConveyorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1ConveyorGetToteProductZoneDetailsGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToteProductZoneDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1ConveyorGetToteProductZoneDetailsGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plcV1ConveyorGetCargoPackageSLAMDetailsGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCargoPackageSLAMDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plcV1ConveyorGetCargoPackageSLAMDetailsGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plcV1ConveyorGetFloorNumberToCarryToteGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFloorNumberToCarryToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plcV1ConveyorGetFloorNumberToCarryToteGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plcV1ConveyorGetSortingStationForCargoPackageGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSortingStationForCargoPackageOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plcV1ConveyorGetSortingStationForCargoPackageGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TagCargoPackageCommand} [tagCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plcV1ConveyorTagCargoPackagePost(tagCargoPackageCommand?: TagCargoPackageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagCargoPackageCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plcV1ConveyorTagCargoPackagePost(tagCargoPackageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConveyorApi - factory interface
 * @export
 */
export const ConveyorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConveyorApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ConveyorGetToteProductZoneDetailsGet(toteLabel?: string, options?: any): AxiosPromise<ToteProductZoneDetailsOutputDTO> {
            return localVarFp.adminV1ConveyorGetToteProductZoneDetailsGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plcV1ConveyorGetCargoPackageSLAMDetailsGet(barcode?: string, options?: any): AxiosPromise<GetCargoPackageSLAMDetailsOutputDTO> {
            return localVarFp.plcV1ConveyorGetCargoPackageSLAMDetailsGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plcV1ConveyorGetFloorNumberToCarryToteGet(toteLabel?: string, options?: any): AxiosPromise<GetFloorNumberToCarryToteOutputDTO> {
            return localVarFp.plcV1ConveyorGetFloorNumberToCarryToteGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plcV1ConveyorGetSortingStationForCargoPackageGet(barcode?: string, options?: any): AxiosPromise<GetSortingStationForCargoPackageOutputDTO> {
            return localVarFp.plcV1ConveyorGetSortingStationForCargoPackageGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TagCargoPackageCommand} [tagCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plcV1ConveyorTagCargoPackagePost(tagCargoPackageCommand?: TagCargoPackageCommand, options?: any): AxiosPromise<TagCargoPackageCommandOutputDTO> {
            return localVarFp.plcV1ConveyorTagCargoPackagePost(tagCargoPackageCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConveyorApi - object-oriented interface
 * @export
 * @class ConveyorApi
 * @extends {BaseAPI}
 */
export class ConveyorApi extends BaseAPI {
    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConveyorApi
     */
    public adminV1ConveyorGetToteProductZoneDetailsGet(toteLabel?: string, options?: any) {
        return ConveyorApiFp(this.configuration).adminV1ConveyorGetToteProductZoneDetailsGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConveyorApi
     */
    public plcV1ConveyorGetCargoPackageSLAMDetailsGet(barcode?: string, options?: any) {
        return ConveyorApiFp(this.configuration).plcV1ConveyorGetCargoPackageSLAMDetailsGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConveyorApi
     */
    public plcV1ConveyorGetFloorNumberToCarryToteGet(toteLabel?: string, options?: any) {
        return ConveyorApiFp(this.configuration).plcV1ConveyorGetFloorNumberToCarryToteGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConveyorApi
     */
    public plcV1ConveyorGetSortingStationForCargoPackageGet(barcode?: string, options?: any) {
        return ConveyorApiFp(this.configuration).plcV1ConveyorGetSortingStationForCargoPackageGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TagCargoPackageCommand} [tagCargoPackageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConveyorApi
     */
    public plcV1ConveyorTagCargoPackagePost(tagCargoPackageCommand?: TagCargoPackageCommand, options?: any) {
        return ConveyorApiFp(this.configuration).plcV1ConveyorTagCargoPackagePost(tagCargoPackageCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomersApi - axios parameter creator
 * @export
 */
export const CustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddAddressToCustomerCommand} [addAddressToCustomerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1CustomersAddAddressToCustomerPost: async (addAddressToCustomerCommand?: AddAddressToCustomerCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/Customers/addAddressToCustomer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAddressToCustomerCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCustomerCommand} [createCustomerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1CustomersCreateCustomerPost: async (createCustomerCommand?: CreateCustomerCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/Customers/createCustomer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomerCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersApi - functional programming interface
 * @export
 */
export const CustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddAddressToCustomerCommand} [addAddressToCustomerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1CustomersAddAddressToCustomerPost(addAddressToCustomerCommand?: AddAddressToCustomerCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1CustomersAddAddressToCustomerPost(addAddressToCustomerCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateCustomerCommand} [createCustomerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1CustomersCreateCustomerPost(createCustomerCommand?: CreateCustomerCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedCustomerOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1CustomersCreateCustomerPost(createCustomerCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomersApi - factory interface
 * @export
 */
export const CustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersApiFp(configuration)
    return {
        /**
         * 
         * @param {AddAddressToCustomerCommand} [addAddressToCustomerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1CustomersAddAddressToCustomerPost(addAddressToCustomerCommand?: AddAddressToCustomerCommand, options?: any): AxiosPromise<void> {
            return localVarFp.openapiV1CustomersAddAddressToCustomerPost(addAddressToCustomerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCustomerCommand} [createCustomerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1CustomersCreateCustomerPost(createCustomerCommand?: CreateCustomerCommand, options?: any): AxiosPromise<CreatedCustomerOutputDTO> {
            return localVarFp.openapiV1CustomersCreateCustomerPost(createCustomerCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomersApi - object-oriented interface
 * @export
 * @class CustomersApi
 * @extends {BaseAPI}
 */
export class CustomersApi extends BaseAPI {
    /**
     * 
     * @param {AddAddressToCustomerCommand} [addAddressToCustomerCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public openapiV1CustomersAddAddressToCustomerPost(addAddressToCustomerCommand?: AddAddressToCustomerCommand, options?: any) {
        return CustomersApiFp(this.configuration).openapiV1CustomersAddAddressToCustomerPost(addAddressToCustomerCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateCustomerCommand} [createCustomerCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public openapiV1CustomersCreateCustomerPost(createCustomerCommand?: CreateCustomerCommand, options?: any) {
        return CustomersApiFp(this.configuration).openapiV1CustomersCreateCustomerPost(createCustomerCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomersODataApi - axios parameter creator
 * @export
 */
export const CustomersODataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataV1CustomersODataGet: async (authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('odataV1CustomersODataGet', 'authorization', authorization)
            const localVarPath = `/odata/v1/CustomersOData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersODataApi - functional programming interface
 * @export
 */
export const CustomersODataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersODataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async odataV1CustomersODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ODataResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.odataV1CustomersODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomersODataApi - factory interface
 * @export
 */
export const CustomersODataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersODataApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataV1CustomersODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any): AxiosPromise<ODataResponseModel> {
            return localVarFp.odataV1CustomersODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomersODataApi - object-oriented interface
 * @export
 * @class CustomersODataApi
 * @extends {BaseAPI}
 */
export class CustomersODataApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization The authorization token
     * @param {string} [$select] Get selected properties
     * @param {string} [$filter] Filter the results using OData syntax.
     * @param {string} [$expand] Get the entities that depend on the model
     * @param {string} [$orderby] Order the results using OData syntax
     * @param {string} [$skip] Skip the specified number of entries
     * @param {string} [$top] Get the top x number of records
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersODataApi
     */
    public odataV1CustomersODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any) {
        return CustomersODataApiFp(this.configuration).odataV1CustomersODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DebugApi - axios parameter creator
 * @export
 */
export const DebugApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apikey] 
         * @param {DeliverSalesOrderInputDTO} [deliverSalesOrderInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugDeliverSalesOrderPost: async (apikey?: string, deliverSalesOrderInputDTO?: DeliverSalesOrderInputDTO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dev/v1/Debug/DeliverSalesOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deliverSalesOrderInputDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} databaseName 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugExecuteMigrationScriptsDatabaseNamePost: async (databaseName: string, apikey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseName' is not null or undefined
            assertParamExists('devV1DebugExecuteMigrationScriptsDatabaseNamePost', 'databaseName', databaseName)
            const localVarPath = `/dev/v1/Debug/ExecuteMigrationScripts/{databaseName}`
                .replace(`{${"databaseName"}}`, encodeURIComponent(String(databaseName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {LabelCargoPackageInputDTO} [labelCargoPackageInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugLabelCargoPackagePost: async (apikey?: string, labelCargoPackageInputDTO?: LabelCargoPackageInputDTO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dev/v1/Debug/LabelCargoPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(labelCargoPackageInputDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugListSeedServicesGet: async (apikey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dev/v1/Debug/ListSeedServices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugObservabilityHealthGet: async (apikey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dev/v1/Debug/ObservabilityHealth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugRecreateDatabasePost: async (apikey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dev/v1/Debug/RecreateDatabase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SeedServiceTypes} [seeds] 
         * @param {OperationsEnum} [operation] 
         * @param {boolean} [recreateDb] 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugSeedPost: async (seeds?: SeedServiceTypes, operation?: OperationsEnum, recreateDb?: boolean, apikey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dev/v1/Debug/Seed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (seeds !== undefined) {
                localVarQueryParameter['seeds'] = seeds;
            }

            if (operation !== undefined) {
                localVarQueryParameter['operation'] = operation;
            }

            if (recreateDb !== undefined) {
                localVarQueryParameter['recreateDb'] = recreateDb;
            }

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {SetExpirationDateForSellableItemsInputDTO} [setExpirationDateForSellableItemsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugSetExpirationDateForSellableItemsPost: async (apikey?: string, setExpirationDateForSellableItemsInputDTO?: SetExpirationDateForSellableItemsInputDTO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dev/v1/Debug/SetExpirationDateForSellableItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setExpirationDateForSellableItemsInputDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugTestCustomSpanGet: async (apikey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dev/v1/Debug/TestCustomSpan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugTestErrorTraceGet: async (apikey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dev/v1/Debug/TestErrorTrace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugTestNestedSpansGet: async (apikey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dev/v1/Debug/TestNestedSpans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {string} [apikey2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugTestOpenTelemetryGet: async (apikey?: string, apikey2?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dev/v1/Debug/TestOpenTelemetry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }

            if (apikey2 !== undefined && apikey2 !== null) {
                localVarHeaderParameter['apikey'] = String(apikey2);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DebugApi - functional programming interface
 * @export
 */
export const DebugApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DebugApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apikey] 
         * @param {DeliverSalesOrderInputDTO} [deliverSalesOrderInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async devV1DebugDeliverSalesOrderPost(apikey?: string, deliverSalesOrderInputDTO?: DeliverSalesOrderInputDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.devV1DebugDeliverSalesOrderPost(apikey, deliverSalesOrderInputDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} databaseName 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async devV1DebugExecuteMigrationScriptsDatabaseNamePost(databaseName: string, apikey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.devV1DebugExecuteMigrationScriptsDatabaseNamePost(databaseName, apikey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {LabelCargoPackageInputDTO} [labelCargoPackageInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async devV1DebugLabelCargoPackagePost(apikey?: string, labelCargoPackageInputDTO?: LabelCargoPackageInputDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.devV1DebugLabelCargoPackagePost(apikey, labelCargoPackageInputDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async devV1DebugListSeedServicesGet(apikey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.devV1DebugListSeedServicesGet(apikey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async devV1DebugObservabilityHealthGet(apikey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.devV1DebugObservabilityHealthGet(apikey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async devV1DebugRecreateDatabasePost(apikey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.devV1DebugRecreateDatabasePost(apikey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SeedServiceTypes} [seeds] 
         * @param {OperationsEnum} [operation] 
         * @param {boolean} [recreateDb] 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async devV1DebugSeedPost(seeds?: SeedServiceTypes, operation?: OperationsEnum, recreateDb?: boolean, apikey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.devV1DebugSeedPost(seeds, operation, recreateDb, apikey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {SetExpirationDateForSellableItemsInputDTO} [setExpirationDateForSellableItemsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async devV1DebugSetExpirationDateForSellableItemsPost(apikey?: string, setExpirationDateForSellableItemsInputDTO?: SetExpirationDateForSellableItemsInputDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.devV1DebugSetExpirationDateForSellableItemsPost(apikey, setExpirationDateForSellableItemsInputDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async devV1DebugTestCustomSpanGet(apikey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.devV1DebugTestCustomSpanGet(apikey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async devV1DebugTestErrorTraceGet(apikey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.devV1DebugTestErrorTraceGet(apikey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async devV1DebugTestNestedSpansGet(apikey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.devV1DebugTestNestedSpansGet(apikey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {string} [apikey2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async devV1DebugTestOpenTelemetryGet(apikey?: string, apikey2?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.devV1DebugTestOpenTelemetryGet(apikey, apikey2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DebugApi - factory interface
 * @export
 */
export const DebugApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DebugApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apikey] 
         * @param {DeliverSalesOrderInputDTO} [deliverSalesOrderInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugDeliverSalesOrderPost(apikey?: string, deliverSalesOrderInputDTO?: DeliverSalesOrderInputDTO, options?: any): AxiosPromise<void> {
            return localVarFp.devV1DebugDeliverSalesOrderPost(apikey, deliverSalesOrderInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} databaseName 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugExecuteMigrationScriptsDatabaseNamePost(databaseName: string, apikey?: string, options?: any): AxiosPromise<void> {
            return localVarFp.devV1DebugExecuteMigrationScriptsDatabaseNamePost(databaseName, apikey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {LabelCargoPackageInputDTO} [labelCargoPackageInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugLabelCargoPackagePost(apikey?: string, labelCargoPackageInputDTO?: LabelCargoPackageInputDTO, options?: any): AxiosPromise<void> {
            return localVarFp.devV1DebugLabelCargoPackagePost(apikey, labelCargoPackageInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugListSeedServicesGet(apikey?: string, options?: any): AxiosPromise<void> {
            return localVarFp.devV1DebugListSeedServicesGet(apikey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugObservabilityHealthGet(apikey?: string, options?: any): AxiosPromise<void> {
            return localVarFp.devV1DebugObservabilityHealthGet(apikey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugRecreateDatabasePost(apikey?: string, options?: any): AxiosPromise<void> {
            return localVarFp.devV1DebugRecreateDatabasePost(apikey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SeedServiceTypes} [seeds] 
         * @param {OperationsEnum} [operation] 
         * @param {boolean} [recreateDb] 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugSeedPost(seeds?: SeedServiceTypes, operation?: OperationsEnum, recreateDb?: boolean, apikey?: string, options?: any): AxiosPromise<void> {
            return localVarFp.devV1DebugSeedPost(seeds, operation, recreateDb, apikey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {SetExpirationDateForSellableItemsInputDTO} [setExpirationDateForSellableItemsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugSetExpirationDateForSellableItemsPost(apikey?: string, setExpirationDateForSellableItemsInputDTO?: SetExpirationDateForSellableItemsInputDTO, options?: any): AxiosPromise<void> {
            return localVarFp.devV1DebugSetExpirationDateForSellableItemsPost(apikey, setExpirationDateForSellableItemsInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugTestCustomSpanGet(apikey?: string, options?: any): AxiosPromise<void> {
            return localVarFp.devV1DebugTestCustomSpanGet(apikey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugTestErrorTraceGet(apikey?: string, options?: any): AxiosPromise<void> {
            return localVarFp.devV1DebugTestErrorTraceGet(apikey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugTestNestedSpansGet(apikey?: string, options?: any): AxiosPromise<void> {
            return localVarFp.devV1DebugTestNestedSpansGet(apikey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {string} [apikey2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devV1DebugTestOpenTelemetryGet(apikey?: string, apikey2?: string, options?: any): AxiosPromise<void> {
            return localVarFp.devV1DebugTestOpenTelemetryGet(apikey, apikey2, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DebugApi - object-oriented interface
 * @export
 * @class DebugApi
 * @extends {BaseAPI}
 */
export class DebugApi extends BaseAPI {
    /**
     * 
     * @param {string} [apikey] 
     * @param {DeliverSalesOrderInputDTO} [deliverSalesOrderInputDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebugApi
     */
    public devV1DebugDeliverSalesOrderPost(apikey?: string, deliverSalesOrderInputDTO?: DeliverSalesOrderInputDTO, options?: any) {
        return DebugApiFp(this.configuration).devV1DebugDeliverSalesOrderPost(apikey, deliverSalesOrderInputDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} databaseName 
     * @param {string} [apikey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebugApi
     */
    public devV1DebugExecuteMigrationScriptsDatabaseNamePost(databaseName: string, apikey?: string, options?: any) {
        return DebugApiFp(this.configuration).devV1DebugExecuteMigrationScriptsDatabaseNamePost(databaseName, apikey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apikey] 
     * @param {LabelCargoPackageInputDTO} [labelCargoPackageInputDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebugApi
     */
    public devV1DebugLabelCargoPackagePost(apikey?: string, labelCargoPackageInputDTO?: LabelCargoPackageInputDTO, options?: any) {
        return DebugApiFp(this.configuration).devV1DebugLabelCargoPackagePost(apikey, labelCargoPackageInputDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apikey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebugApi
     */
    public devV1DebugListSeedServicesGet(apikey?: string, options?: any) {
        return DebugApiFp(this.configuration).devV1DebugListSeedServicesGet(apikey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apikey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebugApi
     */
    public devV1DebugObservabilityHealthGet(apikey?: string, options?: any) {
        return DebugApiFp(this.configuration).devV1DebugObservabilityHealthGet(apikey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apikey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebugApi
     */
    public devV1DebugRecreateDatabasePost(apikey?: string, options?: any) {
        return DebugApiFp(this.configuration).devV1DebugRecreateDatabasePost(apikey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SeedServiceTypes} [seeds] 
     * @param {OperationsEnum} [operation] 
     * @param {boolean} [recreateDb] 
     * @param {string} [apikey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebugApi
     */
    public devV1DebugSeedPost(seeds?: SeedServiceTypes, operation?: OperationsEnum, recreateDb?: boolean, apikey?: string, options?: any) {
        return DebugApiFp(this.configuration).devV1DebugSeedPost(seeds, operation, recreateDb, apikey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apikey] 
     * @param {SetExpirationDateForSellableItemsInputDTO} [setExpirationDateForSellableItemsInputDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebugApi
     */
    public devV1DebugSetExpirationDateForSellableItemsPost(apikey?: string, setExpirationDateForSellableItemsInputDTO?: SetExpirationDateForSellableItemsInputDTO, options?: any) {
        return DebugApiFp(this.configuration).devV1DebugSetExpirationDateForSellableItemsPost(apikey, setExpirationDateForSellableItemsInputDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apikey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebugApi
     */
    public devV1DebugTestCustomSpanGet(apikey?: string, options?: any) {
        return DebugApiFp(this.configuration).devV1DebugTestCustomSpanGet(apikey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apikey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebugApi
     */
    public devV1DebugTestErrorTraceGet(apikey?: string, options?: any) {
        return DebugApiFp(this.configuration).devV1DebugTestErrorTraceGet(apikey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apikey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebugApi
     */
    public devV1DebugTestNestedSpansGet(apikey?: string, options?: any) {
        return DebugApiFp(this.configuration).devV1DebugTestNestedSpansGet(apikey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apikey] 
     * @param {string} [apikey2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebugApi
     */
    public devV1DebugTestOpenTelemetryGet(apikey?: string, apikey2?: string, options?: any) {
        return DebugApiFp(this.configuration).devV1DebugTestOpenTelemetryGet(apikey, apikey2, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DispatchProcessApi - axios parameter creator
 * @export
 */
export const DispatchProcessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand} [addQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessAddQuarantineIntegrationCodeProblemDispatchedSalesOrderPost: async (addQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand?: AddQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/DispatchProcess.addQuarantineIntegrationCodeProblemDispatchedSalesOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddQuarantineQuotaProblemDispatchedSalesOrderCommand} [addQuarantineQuotaProblemDispatchedSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessAddQuarantineQuotaProblemDispatchedSalesOrderPost: async (addQuarantineQuotaProblemDispatchedSalesOrderCommand?: AddQuarantineQuotaProblemDispatchedSalesOrderCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/DispatchProcess.addQuarantineQuotaProblemDispatchedSalesOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addQuarantineQuotaProblemDispatchedSalesOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddQuarantineUnDispatchedSalesOrderCommand} [addQuarantineUnDispatchedSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessAddQuarantineUnDispatchedSalesOrderPost: async (addQuarantineUnDispatchedSalesOrderCommand?: AddQuarantineUnDispatchedSalesOrderCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/DispatchProcess.addQuarantineUnDispatchedSalesOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addQuarantineUnDispatchedSalesOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteDispatchSalesOrderCommand} [completeDispatchSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessCompleteDispatchSalesOrderPost: async (completeDispatchSalesOrderCommand?: CompleteDispatchSalesOrderCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/DispatchProcess.completeDispatchSalesOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeDispatchSalesOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDispatchProcessIfNotExistCommand} [createDispatchProcessIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessCreateIfNotExistPost: async (createDispatchProcessIfNotExistCommand?: CreateDispatchProcessIfNotExistCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/DispatchProcess.createIfNotExist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDispatchProcessIfNotExistCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cargoPackageLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessGetCargoPackageSalesOrderDetailsGet: async (cargoPackageLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/DispatchProcess.getCargoPackageSalesOrderDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cargoPackageLabel !== undefined) {
                localVarQueryParameter['cargoPackageLabel'] = cargoPackageLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dispatchProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessGetDispatchProcessDetailsGet: async (dispatchProcessId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/DispatchProcess.getDispatchProcessDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dispatchProcessId !== undefined) {
                localVarQueryParameter['dispatchProcessId'] = dispatchProcessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceManualDeliveryCargoPackagesCommand} [placeManualDeliveryCargoPackagesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessPlaceManualDeliveryCargoPackagesPost: async (placeManualDeliveryCargoPackagesCommand?: PlaceManualDeliveryCargoPackagesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/DispatchProcess.placeManualDeliveryCargoPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeManualDeliveryCargoPackagesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessQueryCargoPackageManagementCountsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/DispatchProcess.queryCargoPackageManagementCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dispatchProcessId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessQueryCargoPackagesByDispatchProcessIdGet: async (dispatchProcessId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dispatchProcessId' is not null or undefined
            assertParamExists('apiV1DispatchProcessQueryCargoPackagesByDispatchProcessIdGet', 'dispatchProcessId', dispatchProcessId)
            const localVarPath = `/api/v1/DispatchProcess.queryCargoPackagesByDispatchProcessId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (dispatchProcessId !== undefined) {
                localVarQueryParameter['dispatchProcessId'] = dispatchProcessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessQueryCargoPackagesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/DispatchProcess.queryCargoPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessQueryCountGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/DispatchProcess.queryCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessQueryDispatchHistoryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/DispatchProcess.queryDispatchHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessQueryDispatchManagementCountsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/DispatchProcess.queryDispatchManagementCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/DispatchProcess.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dispatchProcessId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessQuerySalesOrdersByDispatchProcessIdGet: async (dispatchProcessId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dispatchProcessId' is not null or undefined
            assertParamExists('apiV1DispatchProcessQuerySalesOrdersByDispatchProcessIdGet', 'dispatchProcessId', dispatchProcessId)
            const localVarPath = `/api/v1/DispatchProcess.querySalesOrdersByDispatchProcessId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (dispatchProcessId !== undefined) {
                localVarQueryParameter['dispatchProcessId'] = dispatchProcessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetDispatchDocumentImageCommand} [setDispatchDocumentImageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessSetDispatchDocumentImagePost: async (setDispatchDocumentImageCommand?: SetDispatchDocumentImageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/DispatchProcess.setDispatchDocumentImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setDispatchDocumentImageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessUploadDispatchDocumentImagePost: async (file?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/DispatchProcess.uploadDispatchDocumentImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DispatchProcessApi - functional programming interface
 * @export
 */
export const DispatchProcessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DispatchProcessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand} [addQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessAddQuarantineIntegrationCodeProblemDispatchedSalesOrderPost(addQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand?: AddQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessAddQuarantineIntegrationCodeProblemDispatchedSalesOrderPost(addQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddQuarantineQuotaProblemDispatchedSalesOrderCommand} [addQuarantineQuotaProblemDispatchedSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessAddQuarantineQuotaProblemDispatchedSalesOrderPost(addQuarantineQuotaProblemDispatchedSalesOrderCommand?: AddQuarantineQuotaProblemDispatchedSalesOrderCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessAddQuarantineQuotaProblemDispatchedSalesOrderPost(addQuarantineQuotaProblemDispatchedSalesOrderCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddQuarantineUnDispatchedSalesOrderCommand} [addQuarantineUnDispatchedSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessAddQuarantineUnDispatchedSalesOrderPost(addQuarantineUnDispatchedSalesOrderCommand?: AddQuarantineUnDispatchedSalesOrderCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessAddQuarantineUnDispatchedSalesOrderPost(addQuarantineUnDispatchedSalesOrderCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteDispatchSalesOrderCommand} [completeDispatchSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessCompleteDispatchSalesOrderPost(completeDispatchSalesOrderCommand?: CompleteDispatchSalesOrderCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessCompleteDispatchSalesOrderPost(completeDispatchSalesOrderCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateDispatchProcessIfNotExistCommand} [createDispatchProcessIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessCreateIfNotExistPost(createDispatchProcessIfNotExistCommand?: CreateDispatchProcessIfNotExistCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDispatchProcessIfNotExistOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessCreateIfNotExistPost(createDispatchProcessIfNotExistCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cargoPackageLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessGetCargoPackageSalesOrderDetailsGet(cargoPackageLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CargoPackageSalesOrderDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessGetCargoPackageSalesOrderDetailsGet(cargoPackageLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dispatchProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessGetDispatchProcessDetailsGet(dispatchProcessId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DispatchProcessDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessGetDispatchProcessDetailsGet(dispatchProcessId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceManualDeliveryCargoPackagesCommand} [placeManualDeliveryCargoPackagesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessPlaceManualDeliveryCargoPackagesPost(placeManualDeliveryCargoPackagesCommand?: PlaceManualDeliveryCargoPackagesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessPlaceManualDeliveryCargoPackagesPost(placeManualDeliveryCargoPackagesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessQueryCargoPackageManagementCountsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DispatchProcessCargoPackageManagementCountsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessQueryCargoPackageManagementCountsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} dispatchProcessId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessQueryCargoPackagesByDispatchProcessIdGet(dispatchProcessId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DispatchProcessCargoPackageDetailsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessQueryCargoPackagesByDispatchProcessIdGet(dispatchProcessId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessQueryCargoPackagesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DispatchProcessCargoPackagesCombinedOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessQueryCargoPackagesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessQueryCountGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessQueryCountGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessQueryDispatchHistoryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DispatchHistoryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessQueryDispatchHistoryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessQueryDispatchManagementCountsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryDispatchManagementCountsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessQueryDispatchManagementCountsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuerySalesOrdersForDispatchOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} dispatchProcessId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessQuerySalesOrdersByDispatchProcessIdGet(dispatchProcessId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DispatchProcessSalesOrderDetailsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessQuerySalesOrdersByDispatchProcessIdGet(dispatchProcessId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetDispatchDocumentImageCommand} [setDispatchDocumentImageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessSetDispatchDocumentImagePost(setDispatchDocumentImageCommand?: SetDispatchDocumentImageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessSetDispatchDocumentImagePost(setDispatchDocumentImageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DispatchProcessUploadDispatchDocumentImagePost(file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadDispatchDocumentImageOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DispatchProcessUploadDispatchDocumentImagePost(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DispatchProcessApi - factory interface
 * @export
 */
export const DispatchProcessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DispatchProcessApiFp(configuration)
    return {
        /**
         * 
         * @param {AddQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand} [addQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessAddQuarantineIntegrationCodeProblemDispatchedSalesOrderPost(addQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand?: AddQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1DispatchProcessAddQuarantineIntegrationCodeProblemDispatchedSalesOrderPost(addQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddQuarantineQuotaProblemDispatchedSalesOrderCommand} [addQuarantineQuotaProblemDispatchedSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessAddQuarantineQuotaProblemDispatchedSalesOrderPost(addQuarantineQuotaProblemDispatchedSalesOrderCommand?: AddQuarantineQuotaProblemDispatchedSalesOrderCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1DispatchProcessAddQuarantineQuotaProblemDispatchedSalesOrderPost(addQuarantineQuotaProblemDispatchedSalesOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddQuarantineUnDispatchedSalesOrderCommand} [addQuarantineUnDispatchedSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessAddQuarantineUnDispatchedSalesOrderPost(addQuarantineUnDispatchedSalesOrderCommand?: AddQuarantineUnDispatchedSalesOrderCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1DispatchProcessAddQuarantineUnDispatchedSalesOrderPost(addQuarantineUnDispatchedSalesOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteDispatchSalesOrderCommand} [completeDispatchSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessCompleteDispatchSalesOrderPost(completeDispatchSalesOrderCommand?: CompleteDispatchSalesOrderCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1DispatchProcessCompleteDispatchSalesOrderPost(completeDispatchSalesOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateDispatchProcessIfNotExistCommand} [createDispatchProcessIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessCreateIfNotExistPost(createDispatchProcessIfNotExistCommand?: CreateDispatchProcessIfNotExistCommand, options?: any): AxiosPromise<CreateDispatchProcessIfNotExistOutputDTO> {
            return localVarFp.apiV1DispatchProcessCreateIfNotExistPost(createDispatchProcessIfNotExistCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cargoPackageLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessGetCargoPackageSalesOrderDetailsGet(cargoPackageLabel?: string, options?: any): AxiosPromise<CargoPackageSalesOrderDetailsOutputDTO> {
            return localVarFp.apiV1DispatchProcessGetCargoPackageSalesOrderDetailsGet(cargoPackageLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dispatchProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessGetDispatchProcessDetailsGet(dispatchProcessId?: string, options?: any): AxiosPromise<DispatchProcessDetailsOutputDTO> {
            return localVarFp.apiV1DispatchProcessGetDispatchProcessDetailsGet(dispatchProcessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceManualDeliveryCargoPackagesCommand} [placeManualDeliveryCargoPackagesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessPlaceManualDeliveryCargoPackagesPost(placeManualDeliveryCargoPackagesCommand?: PlaceManualDeliveryCargoPackagesCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1DispatchProcessPlaceManualDeliveryCargoPackagesPost(placeManualDeliveryCargoPackagesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessQueryCargoPackageManagementCountsGet(options?: any): AxiosPromise<DispatchProcessCargoPackageManagementCountsOutputDTO> {
            return localVarFp.apiV1DispatchProcessQueryCargoPackageManagementCountsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} dispatchProcessId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessQueryCargoPackagesByDispatchProcessIdGet(dispatchProcessId: string, dqb?: string, options?: any): AxiosPromise<DispatchProcessCargoPackageDetailsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1DispatchProcessQueryCargoPackagesByDispatchProcessIdGet(dispatchProcessId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessQueryCargoPackagesGet(dqb?: string, options?: any): AxiosPromise<DispatchProcessCargoPackagesCombinedOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1DispatchProcessQueryCargoPackagesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessQueryCountGet(dqb?: string, options?: any): AxiosPromise<number> {
            return localVarFp.apiV1DispatchProcessQueryCountGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessQueryDispatchHistoryGet(dqb?: string, options?: any): AxiosPromise<DispatchHistoryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1DispatchProcessQueryDispatchHistoryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessQueryDispatchManagementCountsGet(options?: any): AxiosPromise<QueryDispatchManagementCountsOutputDTO> {
            return localVarFp.apiV1DispatchProcessQueryDispatchManagementCountsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessQueryGet(dqb?: string, options?: any): AxiosPromise<QuerySalesOrdersForDispatchOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1DispatchProcessQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} dispatchProcessId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessQuerySalesOrdersByDispatchProcessIdGet(dispatchProcessId: string, dqb?: string, options?: any): AxiosPromise<DispatchProcessSalesOrderDetailsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1DispatchProcessQuerySalesOrdersByDispatchProcessIdGet(dispatchProcessId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetDispatchDocumentImageCommand} [setDispatchDocumentImageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessSetDispatchDocumentImagePost(setDispatchDocumentImageCommand?: SetDispatchDocumentImageCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1DispatchProcessSetDispatchDocumentImagePost(setDispatchDocumentImageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DispatchProcessUploadDispatchDocumentImagePost(file?: any, options?: any): AxiosPromise<UploadDispatchDocumentImageOutputDTO> {
            return localVarFp.apiV1DispatchProcessUploadDispatchDocumentImagePost(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DispatchProcessApi - object-oriented interface
 * @export
 * @class DispatchProcessApi
 * @extends {BaseAPI}
 */
export class DispatchProcessApi extends BaseAPI {
    /**
     * 
     * @param {AddQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand} [addQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessAddQuarantineIntegrationCodeProblemDispatchedSalesOrderPost(addQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand?: AddQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand, options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessAddQuarantineIntegrationCodeProblemDispatchedSalesOrderPost(addQuarantineIntegrationCodeProblemDispatchedSalesOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddQuarantineQuotaProblemDispatchedSalesOrderCommand} [addQuarantineQuotaProblemDispatchedSalesOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessAddQuarantineQuotaProblemDispatchedSalesOrderPost(addQuarantineQuotaProblemDispatchedSalesOrderCommand?: AddQuarantineQuotaProblemDispatchedSalesOrderCommand, options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessAddQuarantineQuotaProblemDispatchedSalesOrderPost(addQuarantineQuotaProblemDispatchedSalesOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddQuarantineUnDispatchedSalesOrderCommand} [addQuarantineUnDispatchedSalesOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessAddQuarantineUnDispatchedSalesOrderPost(addQuarantineUnDispatchedSalesOrderCommand?: AddQuarantineUnDispatchedSalesOrderCommand, options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessAddQuarantineUnDispatchedSalesOrderPost(addQuarantineUnDispatchedSalesOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteDispatchSalesOrderCommand} [completeDispatchSalesOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessCompleteDispatchSalesOrderPost(completeDispatchSalesOrderCommand?: CompleteDispatchSalesOrderCommand, options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessCompleteDispatchSalesOrderPost(completeDispatchSalesOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateDispatchProcessIfNotExistCommand} [createDispatchProcessIfNotExistCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessCreateIfNotExistPost(createDispatchProcessIfNotExistCommand?: CreateDispatchProcessIfNotExistCommand, options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessCreateIfNotExistPost(createDispatchProcessIfNotExistCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cargoPackageLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessGetCargoPackageSalesOrderDetailsGet(cargoPackageLabel?: string, options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessGetCargoPackageSalesOrderDetailsGet(cargoPackageLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dispatchProcessId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessGetDispatchProcessDetailsGet(dispatchProcessId?: string, options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessGetDispatchProcessDetailsGet(dispatchProcessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceManualDeliveryCargoPackagesCommand} [placeManualDeliveryCargoPackagesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessPlaceManualDeliveryCargoPackagesPost(placeManualDeliveryCargoPackagesCommand?: PlaceManualDeliveryCargoPackagesCommand, options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessPlaceManualDeliveryCargoPackagesPost(placeManualDeliveryCargoPackagesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessQueryCargoPackageManagementCountsGet(options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessQueryCargoPackageManagementCountsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} dispatchProcessId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessQueryCargoPackagesByDispatchProcessIdGet(dispatchProcessId: string, dqb?: string, options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessQueryCargoPackagesByDispatchProcessIdGet(dispatchProcessId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessQueryCargoPackagesGet(dqb?: string, options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessQueryCargoPackagesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessQueryCountGet(dqb?: string, options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessQueryCountGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessQueryDispatchHistoryGet(dqb?: string, options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessQueryDispatchHistoryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessQueryDispatchManagementCountsGet(options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessQueryDispatchManagementCountsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessQueryGet(dqb?: string, options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} dispatchProcessId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessQuerySalesOrdersByDispatchProcessIdGet(dispatchProcessId: string, dqb?: string, options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessQuerySalesOrdersByDispatchProcessIdGet(dispatchProcessId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetDispatchDocumentImageCommand} [setDispatchDocumentImageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessSetDispatchDocumentImagePost(setDispatchDocumentImageCommand?: SetDispatchDocumentImageCommand, options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessSetDispatchDocumentImagePost(setDispatchDocumentImageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchProcessApi
     */
    public apiV1DispatchProcessUploadDispatchDocumentImagePost(file?: any, options?: any) {
        return DispatchProcessApiFp(this.configuration).apiV1DispatchProcessUploadDispatchDocumentImagePost(file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GridFilterPresetsApi - axios parameter creator
 * @export
 */
export const GridFilterPresetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DeleteGridFilterPresetInputDTO} [deleteGridFilterPresetInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GridFilterPresetsDeletePost: async (deleteGridFilterPresetInputDTO?: DeleteGridFilterPresetInputDTO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/GridFilterPresets.delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteGridFilterPresetInputDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [gridKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GridFilterPresetsListGet: async (gridKey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/GridFilterPresets.list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (gridKey !== undefined) {
                localVarQueryParameter['gridKey'] = gridKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveGridFilterPresetInputDTO} [saveGridFilterPresetInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GridFilterPresetsSavePost: async (saveGridFilterPresetInputDTO?: SaveGridFilterPresetInputDTO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/GridFilterPresets.save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveGridFilterPresetInputDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GridFilterPresetsApi - functional programming interface
 * @export
 */
export const GridFilterPresetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GridFilterPresetsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DeleteGridFilterPresetInputDTO} [deleteGridFilterPresetInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GridFilterPresetsDeletePost(deleteGridFilterPresetInputDTO?: DeleteGridFilterPresetInputDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GridFilterPresetsDeletePost(deleteGridFilterPresetInputDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [gridKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GridFilterPresetsListGet(gridKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserGridFilterPresetOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GridFilterPresetsListGet(gridKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SaveGridFilterPresetInputDTO} [saveGridFilterPresetInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GridFilterPresetsSavePost(saveGridFilterPresetInputDTO?: SaveGridFilterPresetInputDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGridFilterPresetOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GridFilterPresetsSavePost(saveGridFilterPresetInputDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GridFilterPresetsApi - factory interface
 * @export
 */
export const GridFilterPresetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GridFilterPresetsApiFp(configuration)
    return {
        /**
         * 
         * @param {DeleteGridFilterPresetInputDTO} [deleteGridFilterPresetInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GridFilterPresetsDeletePost(deleteGridFilterPresetInputDTO?: DeleteGridFilterPresetInputDTO, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1GridFilterPresetsDeletePost(deleteGridFilterPresetInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [gridKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GridFilterPresetsListGet(gridKey?: string, options?: any): AxiosPromise<Array<UserGridFilterPresetOutputDTO>> {
            return localVarFp.apiV1GridFilterPresetsListGet(gridKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SaveGridFilterPresetInputDTO} [saveGridFilterPresetInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GridFilterPresetsSavePost(saveGridFilterPresetInputDTO?: SaveGridFilterPresetInputDTO, options?: any): AxiosPromise<UserGridFilterPresetOutputDTO> {
            return localVarFp.apiV1GridFilterPresetsSavePost(saveGridFilterPresetInputDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GridFilterPresetsApi - object-oriented interface
 * @export
 * @class GridFilterPresetsApi
 * @extends {BaseAPI}
 */
export class GridFilterPresetsApi extends BaseAPI {
    /**
     * 
     * @param {DeleteGridFilterPresetInputDTO} [deleteGridFilterPresetInputDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridFilterPresetsApi
     */
    public apiV1GridFilterPresetsDeletePost(deleteGridFilterPresetInputDTO?: DeleteGridFilterPresetInputDTO, options?: any) {
        return GridFilterPresetsApiFp(this.configuration).apiV1GridFilterPresetsDeletePost(deleteGridFilterPresetInputDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [gridKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridFilterPresetsApi
     */
    public apiV1GridFilterPresetsListGet(gridKey?: string, options?: any) {
        return GridFilterPresetsApiFp(this.configuration).apiV1GridFilterPresetsListGet(gridKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SaveGridFilterPresetInputDTO} [saveGridFilterPresetInputDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridFilterPresetsApi
     */
    public apiV1GridFilterPresetsSavePost(saveGridFilterPresetInputDTO?: SaveGridFilterPresetInputDTO, options?: any) {
        return GridFilterPresetsApiFp(this.configuration).apiV1GridFilterPresetsSavePost(saveGridFilterPresetInputDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HOVPackingProcessesApi - axios parameter creator
 * @export
 */
export const HOVPackingProcessesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddHOVCargoPackageCommand} [addHOVCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesAddHOVCargoPackagePost: async (addHOVCargoPackageCommand?: AddHOVCargoPackageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.addHOVCargoPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addHOVCargoPackageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AssignHOVQuarantineToteCommand} [assignHOVQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesAssignHOVQuarantineTotePost: async (assignHOVQuarantineToteCommand?: AssignHOVQuarantineToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.assignHOVQuarantineTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignHOVQuarantineToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckSalesOrderSimpleSerialNumber} [checkSalesOrderSimpleSerialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesCheckSimpleSerialNumberPost: async (checkSalesOrderSimpleSerialNumber?: CheckSalesOrderSimpleSerialNumber, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.checkSimpleSerialNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkSalesOrderSimpleSerialNumber, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteHOVPackingProcessCommand} [completeHOVPackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesCompleteHOVPackingProcessPost: async (completeHOVPackingProcessCommand?: CompleteHOVPackingProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.completeHOVPackingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeHOVPackingProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteHOVPackingQuarantineProcessCommand} [completeHOVPackingQuarantineProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesCompleteHOVPackingQuarantineProcessPost: async (completeHOVPackingQuarantineProcessCommand?: CompleteHOVPackingQuarantineProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.completeHOVPackingQuarantineProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeHOVPackingQuarantineProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateHOVPackingProcessIfNotExistsCommand} [createHOVPackingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesCreateHOVPackingProcessIfNotExistsPost: async (createHOVPackingProcessIfNotExistsCommand?: CreateHOVPackingProcessIfNotExistsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.createHOVPackingProcessIfNotExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createHOVPackingProcessIfNotExistsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateHOVPackingQuarantineProcessIfNotExistsCommand} [createHOVPackingQuarantineProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesCreateHOVPackingQuarantineProcessIfNotExistsPost: async (createHOVPackingQuarantineProcessIfNotExistsCommand?: CreateHOVPackingQuarantineProcessIfNotExistsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.createHOVPackingQuarantineProcessIfNotExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createHOVPackingQuarantineProcessIfNotExistsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesGetHOVSalesOrderStateGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.getHOVSalesOrderState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesGetTotePackingTypeGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.getTotePackingType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {HOVPrintSLAMDocumentsOnPackingCommand} [hOVPrintSLAMDocumentsOnPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesHOVPrintSLAMDocumentsPost: async (hOVPrintSLAMDocumentsOnPackingCommand?: HOVPrintSLAMDocumentsOnPackingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.HOVPrintSLAMDocuments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hOVPrintSLAMDocumentsOnPackingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {HOVPrintVASCommand} [hOVPrintVASCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesHOVPrintVASPost: async (hOVPrintVASCommand?: HOVPrintVASCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.HOVPrintVAS`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hOVPrintVASCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceHOVQuarantineToteToQuarantineToteCommand} [placeHOVQuarantineToteToQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesPlaceHOVQuarantineToteToQuarantineAddressPost: async (placeHOVQuarantineToteToQuarantineToteCommand?: PlaceHOVQuarantineToteToQuarantineToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.placeHOVQuarantineToteToQuarantineAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeHOVQuarantineToteToQuarantineToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintAdditionalCargoPackageLabelsCommand} [printAdditionalCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesPrintAdditionalCargoPackageLabelsPost: async (printAdditionalCargoPackageLabelsCommand?: PrintAdditionalCargoPackageLabelsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.printAdditionalCargoPackageLabels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printAdditionalCargoPackageLabelsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintHOVCargoPackageLabelsCommand} [printHOVCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesPrintHOVCargoPackageLabelsPost: async (printHOVCargoPackageLabelsCommand?: PrintHOVCargoPackageLabelsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.printHOVCargoPackageLabels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printHOVCargoPackageLabelsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintHOVPalettePackingListCommand} [printHOVPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesPrintHOVPalettePackingListPost: async (printHOVPalettePackingListCommand?: PrintHOVPalettePackingListCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.printHOVPalettePackingList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printHOVPalettePackingListCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintUnprintedHOVPalettePackingListCommand} [printUnprintedHOVPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesPrintUnprintedHOVPalettePackingListPost: async (printUnprintedHOVPalettePackingListCommand?: PrintUnprintedHOVPalettePackingListCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.printUnprintedHOVPalettePackingList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printUnprintedHOVPalettePackingListCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueueHOVItemIntoCargoPackageCommand} [queueHOVItemIntoCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesQueueHOVItemIntoCargoPackagePost: async (queueHOVItemIntoCargoPackageCommand?: QueueHOVItemIntoCargoPackageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.queueHOVItemIntoCargoPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queueHOVItemIntoCargoPackageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueueHOVItemIntoQuarantineToteCommand} [queueHOVItemIntoQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesQueueHOVItemIntoQuarantineTotePost: async (queueHOVItemIntoQuarantineToteCommand?: QueueHOVItemIntoQuarantineToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.queueHOVItemIntoQuarantineTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queueHOVItemIntoQuarantineToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RemoveHOVCargoPackageCommand} [removeHOVCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesRemoveHOVCargoPackagePost: async (removeHOVCargoPackageCommand?: RemoveHOVCargoPackageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.removeHOVCargoPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeHOVCargoPackageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RemoveHOVItemFromCargoPackageCommand} [removeHOVItemFromCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesRemoveHOVItemFromCargoPackagePost: async (removeHOVItemFromCargoPackageCommand?: RemoveHOVItemFromCargoPackageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.removeHOVItemFromCargoPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeHOVItemFromCargoPackageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RemoveHOVPackingProcessOfUnpackableToteCommand} [removeHOVPackingProcessOfUnpackableToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesRemoveHOVPackingProcessOfUnpackableToteCommandPost: async (removeHOVPackingProcessOfUnpackableToteCommand?: RemoveHOVPackingProcessOfUnpackableToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.removeHOVPackingProcessOfUnpackableToteCommand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeHOVPackingProcessOfUnpackableToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReprintHOVPalettePackingListCommand} [reprintHOVPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesReprintHOVPalettePackingListPost: async (reprintHOVPalettePackingListCommand?: ReprintHOVPalettePackingListCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.reprintHOVPalettePackingList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reprintHOVPalettePackingListCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesTotesReadyToPackGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.totesReadyToPack`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnassignHOVQuarantineToteCommand} [unassignHOVQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesUnassignHOVQuarantineTotePost: async (unassignHOVQuarantineToteCommand?: UnassignHOVQuarantineToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPackingProcesses.unassignHOVQuarantineTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unassignHOVQuarantineToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HOVPackingProcessesApi - functional programming interface
 * @export
 */
export const HOVPackingProcessesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HOVPackingProcessesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddHOVCargoPackageCommand} [addHOVCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesAddHOVCargoPackagePost(addHOVCargoPackageCommand?: AddHOVCargoPackageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddHOVCargoPackageCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesAddHOVCargoPackagePost(addHOVCargoPackageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AssignHOVQuarantineToteCommand} [assignHOVQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesAssignHOVQuarantineTotePost(assignHOVQuarantineToteCommand?: AssignHOVQuarantineToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesAssignHOVQuarantineTotePost(assignHOVQuarantineToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckSalesOrderSimpleSerialNumber} [checkSalesOrderSimpleSerialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber?: CheckSalesOrderSimpleSerialNumber, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CargoPackageTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteHOVPackingProcessCommand} [completeHOVPackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesCompleteHOVPackingProcessPost(completeHOVPackingProcessCommand?: CompleteHOVPackingProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompletePackingProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesCompleteHOVPackingProcessPost(completeHOVPackingProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteHOVPackingQuarantineProcessCommand} [completeHOVPackingQuarantineProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesCompleteHOVPackingQuarantineProcessPost(completeHOVPackingQuarantineProcessCommand?: CompleteHOVPackingQuarantineProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesCompleteHOVPackingQuarantineProcessPost(completeHOVPackingQuarantineProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateHOVPackingProcessIfNotExistsCommand} [createHOVPackingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesCreateHOVPackingProcessIfNotExistsPost(createHOVPackingProcessIfNotExistsCommand?: CreateHOVPackingProcessIfNotExistsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateHOVPackingProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesCreateHOVPackingProcessIfNotExistsPost(createHOVPackingProcessIfNotExistsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateHOVPackingQuarantineProcessIfNotExistsCommand} [createHOVPackingQuarantineProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesCreateHOVPackingQuarantineProcessIfNotExistsPost(createHOVPackingQuarantineProcessIfNotExistsCommand?: CreateHOVPackingQuarantineProcessIfNotExistsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateHOVPackingQuarantineProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesCreateHOVPackingQuarantineProcessIfNotExistsPost(createHOVPackingQuarantineProcessIfNotExistsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesGetHOVSalesOrderStateGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HOVSalesOrderStateOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesGetHOVSalesOrderStateGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesGetTotePackingTypeGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotePackingTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesGetTotePackingTypeGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {HOVPrintSLAMDocumentsOnPackingCommand} [hOVPrintSLAMDocumentsOnPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesHOVPrintSLAMDocumentsPost(hOVPrintSLAMDocumentsOnPackingCommand?: HOVPrintSLAMDocumentsOnPackingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HOVPrintSLAMDocumentsOnPackingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesHOVPrintSLAMDocumentsPost(hOVPrintSLAMDocumentsOnPackingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {HOVPrintVASCommand} [hOVPrintVASCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesHOVPrintVASPost(hOVPrintVASCommand?: HOVPrintVASCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesHOVPrintVASPost(hOVPrintVASCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceHOVQuarantineToteToQuarantineToteCommand} [placeHOVQuarantineToteToQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesPlaceHOVQuarantineToteToQuarantineAddressPost(placeHOVQuarantineToteToQuarantineToteCommand?: PlaceHOVQuarantineToteToQuarantineToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesPlaceHOVQuarantineToteToQuarantineAddressPost(placeHOVQuarantineToteToQuarantineToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintAdditionalCargoPackageLabelsCommand} [printAdditionalCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesPrintAdditionalCargoPackageLabelsPost(printAdditionalCargoPackageLabelsCommand?: PrintAdditionalCargoPackageLabelsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesPrintAdditionalCargoPackageLabelsPost(printAdditionalCargoPackageLabelsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintHOVCargoPackageLabelsCommand} [printHOVCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesPrintHOVCargoPackageLabelsPost(printHOVCargoPackageLabelsCommand?: PrintHOVCargoPackageLabelsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesPrintHOVCargoPackageLabelsPost(printHOVCargoPackageLabelsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintHOVPalettePackingListCommand} [printHOVPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesPrintHOVPalettePackingListPost(printHOVPalettePackingListCommand?: PrintHOVPalettePackingListCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesPrintHOVPalettePackingListPost(printHOVPalettePackingListCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintUnprintedHOVPalettePackingListCommand} [printUnprintedHOVPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesPrintUnprintedHOVPalettePackingListPost(printUnprintedHOVPalettePackingListCommand?: PrintUnprintedHOVPalettePackingListCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesPrintUnprintedHOVPalettePackingListPost(printUnprintedHOVPalettePackingListCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {QueueHOVItemIntoCargoPackageCommand} [queueHOVItemIntoCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesQueueHOVItemIntoCargoPackagePost(queueHOVItemIntoCargoPackageCommand?: QueueHOVItemIntoCargoPackageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueueItemIntoCargoPackageOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesQueueHOVItemIntoCargoPackagePost(queueHOVItemIntoCargoPackageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {QueueHOVItemIntoQuarantineToteCommand} [queueHOVItemIntoQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesQueueHOVItemIntoQuarantineTotePost(queueHOVItemIntoQuarantineToteCommand?: QueueHOVItemIntoQuarantineToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesQueueHOVItemIntoQuarantineTotePost(queueHOVItemIntoQuarantineToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RemoveHOVCargoPackageCommand} [removeHOVCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesRemoveHOVCargoPackagePost(removeHOVCargoPackageCommand?: RemoveHOVCargoPackageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoveHOVCargoPackageCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesRemoveHOVCargoPackagePost(removeHOVCargoPackageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RemoveHOVItemFromCargoPackageCommand} [removeHOVItemFromCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesRemoveHOVItemFromCargoPackagePost(removeHOVItemFromCargoPackageCommand?: RemoveHOVItemFromCargoPackageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesRemoveHOVItemFromCargoPackagePost(removeHOVItemFromCargoPackageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RemoveHOVPackingProcessOfUnpackableToteCommand} [removeHOVPackingProcessOfUnpackableToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesRemoveHOVPackingProcessOfUnpackableToteCommandPost(removeHOVPackingProcessOfUnpackableToteCommand?: RemoveHOVPackingProcessOfUnpackableToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesRemoveHOVPackingProcessOfUnpackableToteCommandPost(removeHOVPackingProcessOfUnpackableToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReprintHOVPalettePackingListCommand} [reprintHOVPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesReprintHOVPalettePackingListPost(reprintHOVPalettePackingListCommand?: ReprintHOVPalettePackingListCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesReprintHOVPalettePackingListPost(reprintHOVPalettePackingListCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesTotesReadyToPackGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTotesReadyToPackOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesTotesReadyToPackGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UnassignHOVQuarantineToteCommand} [unassignHOVQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPackingProcessesUnassignHOVQuarantineTotePost(unassignHOVQuarantineToteCommand?: UnassignHOVQuarantineToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPackingProcessesUnassignHOVQuarantineTotePost(unassignHOVQuarantineToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HOVPackingProcessesApi - factory interface
 * @export
 */
export const HOVPackingProcessesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HOVPackingProcessesApiFp(configuration)
    return {
        /**
         * 
         * @param {AddHOVCargoPackageCommand} [addHOVCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesAddHOVCargoPackagePost(addHOVCargoPackageCommand?: AddHOVCargoPackageCommand, options?: any): AxiosPromise<AddHOVCargoPackageCommandOutputDTO> {
            return localVarFp.apiV1HOVPackingProcessesAddHOVCargoPackagePost(addHOVCargoPackageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignHOVQuarantineToteCommand} [assignHOVQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesAssignHOVQuarantineTotePost(assignHOVQuarantineToteCommand?: AssignHOVQuarantineToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1HOVPackingProcessesAssignHOVQuarantineTotePost(assignHOVQuarantineToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckSalesOrderSimpleSerialNumber} [checkSalesOrderSimpleSerialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber?: CheckSalesOrderSimpleSerialNumber, options?: any): AxiosPromise<CargoPackageTypeOutputDTO> {
            return localVarFp.apiV1HOVPackingProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteHOVPackingProcessCommand} [completeHOVPackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesCompleteHOVPackingProcessPost(completeHOVPackingProcessCommand?: CompleteHOVPackingProcessCommand, options?: any): AxiosPromise<CompletePackingProcessOutputDTO> {
            return localVarFp.apiV1HOVPackingProcessesCompleteHOVPackingProcessPost(completeHOVPackingProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteHOVPackingQuarantineProcessCommand} [completeHOVPackingQuarantineProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesCompleteHOVPackingQuarantineProcessPost(completeHOVPackingQuarantineProcessCommand?: CompleteHOVPackingQuarantineProcessCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1HOVPackingProcessesCompleteHOVPackingQuarantineProcessPost(completeHOVPackingQuarantineProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateHOVPackingProcessIfNotExistsCommand} [createHOVPackingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesCreateHOVPackingProcessIfNotExistsPost(createHOVPackingProcessIfNotExistsCommand?: CreateHOVPackingProcessIfNotExistsCommand, options?: any): AxiosPromise<CreateHOVPackingProcessOutputDTO> {
            return localVarFp.apiV1HOVPackingProcessesCreateHOVPackingProcessIfNotExistsPost(createHOVPackingProcessIfNotExistsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateHOVPackingQuarantineProcessIfNotExistsCommand} [createHOVPackingQuarantineProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesCreateHOVPackingQuarantineProcessIfNotExistsPost(createHOVPackingQuarantineProcessIfNotExistsCommand?: CreateHOVPackingQuarantineProcessIfNotExistsCommand, options?: any): AxiosPromise<CreateHOVPackingQuarantineProcessOutputDTO> {
            return localVarFp.apiV1HOVPackingProcessesCreateHOVPackingQuarantineProcessIfNotExistsPost(createHOVPackingQuarantineProcessIfNotExistsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesGetHOVSalesOrderStateGet(toteLabel?: string, options?: any): AxiosPromise<HOVSalesOrderStateOutputDTO> {
            return localVarFp.apiV1HOVPackingProcessesGetHOVSalesOrderStateGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesGetTotePackingTypeGet(toteLabel?: string, options?: any): AxiosPromise<TotePackingTypeOutputDTO> {
            return localVarFp.apiV1HOVPackingProcessesGetTotePackingTypeGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HOVPrintSLAMDocumentsOnPackingCommand} [hOVPrintSLAMDocumentsOnPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesHOVPrintSLAMDocumentsPost(hOVPrintSLAMDocumentsOnPackingCommand?: HOVPrintSLAMDocumentsOnPackingCommand, options?: any): AxiosPromise<HOVPrintSLAMDocumentsOnPackingOutputDTO> {
            return localVarFp.apiV1HOVPackingProcessesHOVPrintSLAMDocumentsPost(hOVPrintSLAMDocumentsOnPackingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HOVPrintVASCommand} [hOVPrintVASCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesHOVPrintVASPost(hOVPrintVASCommand?: HOVPrintVASCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1HOVPackingProcessesHOVPrintVASPost(hOVPrintVASCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceHOVQuarantineToteToQuarantineToteCommand} [placeHOVQuarantineToteToQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesPlaceHOVQuarantineToteToQuarantineAddressPost(placeHOVQuarantineToteToQuarantineToteCommand?: PlaceHOVQuarantineToteToQuarantineToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1HOVPackingProcessesPlaceHOVQuarantineToteToQuarantineAddressPost(placeHOVQuarantineToteToQuarantineToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintAdditionalCargoPackageLabelsCommand} [printAdditionalCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesPrintAdditionalCargoPackageLabelsPost(printAdditionalCargoPackageLabelsCommand?: PrintAdditionalCargoPackageLabelsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1HOVPackingProcessesPrintAdditionalCargoPackageLabelsPost(printAdditionalCargoPackageLabelsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintHOVCargoPackageLabelsCommand} [printHOVCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesPrintHOVCargoPackageLabelsPost(printHOVCargoPackageLabelsCommand?: PrintHOVCargoPackageLabelsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1HOVPackingProcessesPrintHOVCargoPackageLabelsPost(printHOVCargoPackageLabelsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintHOVPalettePackingListCommand} [printHOVPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesPrintHOVPalettePackingListPost(printHOVPalettePackingListCommand?: PrintHOVPalettePackingListCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1HOVPackingProcessesPrintHOVPalettePackingListPost(printHOVPalettePackingListCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintUnprintedHOVPalettePackingListCommand} [printUnprintedHOVPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesPrintUnprintedHOVPalettePackingListPost(printUnprintedHOVPalettePackingListCommand?: PrintUnprintedHOVPalettePackingListCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1HOVPackingProcessesPrintUnprintedHOVPalettePackingListPost(printUnprintedHOVPalettePackingListCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueueHOVItemIntoCargoPackageCommand} [queueHOVItemIntoCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesQueueHOVItemIntoCargoPackagePost(queueHOVItemIntoCargoPackageCommand?: QueueHOVItemIntoCargoPackageCommand, options?: any): AxiosPromise<QueueItemIntoCargoPackageOutputDTO> {
            return localVarFp.apiV1HOVPackingProcessesQueueHOVItemIntoCargoPackagePost(queueHOVItemIntoCargoPackageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueueHOVItemIntoQuarantineToteCommand} [queueHOVItemIntoQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesQueueHOVItemIntoQuarantineTotePost(queueHOVItemIntoQuarantineToteCommand?: QueueHOVItemIntoQuarantineToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1HOVPackingProcessesQueueHOVItemIntoQuarantineTotePost(queueHOVItemIntoQuarantineToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RemoveHOVCargoPackageCommand} [removeHOVCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesRemoveHOVCargoPackagePost(removeHOVCargoPackageCommand?: RemoveHOVCargoPackageCommand, options?: any): AxiosPromise<RemoveHOVCargoPackageCommandOutputDTO> {
            return localVarFp.apiV1HOVPackingProcessesRemoveHOVCargoPackagePost(removeHOVCargoPackageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RemoveHOVItemFromCargoPackageCommand} [removeHOVItemFromCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesRemoveHOVItemFromCargoPackagePost(removeHOVItemFromCargoPackageCommand?: RemoveHOVItemFromCargoPackageCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1HOVPackingProcessesRemoveHOVItemFromCargoPackagePost(removeHOVItemFromCargoPackageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RemoveHOVPackingProcessOfUnpackableToteCommand} [removeHOVPackingProcessOfUnpackableToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesRemoveHOVPackingProcessOfUnpackableToteCommandPost(removeHOVPackingProcessOfUnpackableToteCommand?: RemoveHOVPackingProcessOfUnpackableToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1HOVPackingProcessesRemoveHOVPackingProcessOfUnpackableToteCommandPost(removeHOVPackingProcessOfUnpackableToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReprintHOVPalettePackingListCommand} [reprintHOVPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesReprintHOVPalettePackingListPost(reprintHOVPalettePackingListCommand?: ReprintHOVPalettePackingListCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1HOVPackingProcessesReprintHOVPalettePackingListPost(reprintHOVPalettePackingListCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesTotesReadyToPackGet(options?: any): AxiosPromise<Array<GetTotesReadyToPackOutputDTO>> {
            return localVarFp.apiV1HOVPackingProcessesTotesReadyToPackGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnassignHOVQuarantineToteCommand} [unassignHOVQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPackingProcessesUnassignHOVQuarantineTotePost(unassignHOVQuarantineToteCommand?: UnassignHOVQuarantineToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1HOVPackingProcessesUnassignHOVQuarantineTotePost(unassignHOVQuarantineToteCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HOVPackingProcessesApi - object-oriented interface
 * @export
 * @class HOVPackingProcessesApi
 * @extends {BaseAPI}
 */
export class HOVPackingProcessesApi extends BaseAPI {
    /**
     * 
     * @param {AddHOVCargoPackageCommand} [addHOVCargoPackageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesAddHOVCargoPackagePost(addHOVCargoPackageCommand?: AddHOVCargoPackageCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesAddHOVCargoPackagePost(addHOVCargoPackageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignHOVQuarantineToteCommand} [assignHOVQuarantineToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesAssignHOVQuarantineTotePost(assignHOVQuarantineToteCommand?: AssignHOVQuarantineToteCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesAssignHOVQuarantineTotePost(assignHOVQuarantineToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckSalesOrderSimpleSerialNumber} [checkSalesOrderSimpleSerialNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber?: CheckSalesOrderSimpleSerialNumber, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteHOVPackingProcessCommand} [completeHOVPackingProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesCompleteHOVPackingProcessPost(completeHOVPackingProcessCommand?: CompleteHOVPackingProcessCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesCompleteHOVPackingProcessPost(completeHOVPackingProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteHOVPackingQuarantineProcessCommand} [completeHOVPackingQuarantineProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesCompleteHOVPackingQuarantineProcessPost(completeHOVPackingQuarantineProcessCommand?: CompleteHOVPackingQuarantineProcessCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesCompleteHOVPackingQuarantineProcessPost(completeHOVPackingQuarantineProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateHOVPackingProcessIfNotExistsCommand} [createHOVPackingProcessIfNotExistsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesCreateHOVPackingProcessIfNotExistsPost(createHOVPackingProcessIfNotExistsCommand?: CreateHOVPackingProcessIfNotExistsCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesCreateHOVPackingProcessIfNotExistsPost(createHOVPackingProcessIfNotExistsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateHOVPackingQuarantineProcessIfNotExistsCommand} [createHOVPackingQuarantineProcessIfNotExistsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesCreateHOVPackingQuarantineProcessIfNotExistsPost(createHOVPackingQuarantineProcessIfNotExistsCommand?: CreateHOVPackingQuarantineProcessIfNotExistsCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesCreateHOVPackingQuarantineProcessIfNotExistsPost(createHOVPackingQuarantineProcessIfNotExistsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesGetHOVSalesOrderStateGet(toteLabel?: string, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesGetHOVSalesOrderStateGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesGetTotePackingTypeGet(toteLabel?: string, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesGetTotePackingTypeGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HOVPrintSLAMDocumentsOnPackingCommand} [hOVPrintSLAMDocumentsOnPackingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesHOVPrintSLAMDocumentsPost(hOVPrintSLAMDocumentsOnPackingCommand?: HOVPrintSLAMDocumentsOnPackingCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesHOVPrintSLAMDocumentsPost(hOVPrintSLAMDocumentsOnPackingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HOVPrintVASCommand} [hOVPrintVASCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesHOVPrintVASPost(hOVPrintVASCommand?: HOVPrintVASCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesHOVPrintVASPost(hOVPrintVASCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceHOVQuarantineToteToQuarantineToteCommand} [placeHOVQuarantineToteToQuarantineToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesPlaceHOVQuarantineToteToQuarantineAddressPost(placeHOVQuarantineToteToQuarantineToteCommand?: PlaceHOVQuarantineToteToQuarantineToteCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesPlaceHOVQuarantineToteToQuarantineAddressPost(placeHOVQuarantineToteToQuarantineToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintAdditionalCargoPackageLabelsCommand} [printAdditionalCargoPackageLabelsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesPrintAdditionalCargoPackageLabelsPost(printAdditionalCargoPackageLabelsCommand?: PrintAdditionalCargoPackageLabelsCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesPrintAdditionalCargoPackageLabelsPost(printAdditionalCargoPackageLabelsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintHOVCargoPackageLabelsCommand} [printHOVCargoPackageLabelsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesPrintHOVCargoPackageLabelsPost(printHOVCargoPackageLabelsCommand?: PrintHOVCargoPackageLabelsCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesPrintHOVCargoPackageLabelsPost(printHOVCargoPackageLabelsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintHOVPalettePackingListCommand} [printHOVPalettePackingListCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesPrintHOVPalettePackingListPost(printHOVPalettePackingListCommand?: PrintHOVPalettePackingListCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesPrintHOVPalettePackingListPost(printHOVPalettePackingListCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintUnprintedHOVPalettePackingListCommand} [printUnprintedHOVPalettePackingListCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesPrintUnprintedHOVPalettePackingListPost(printUnprintedHOVPalettePackingListCommand?: PrintUnprintedHOVPalettePackingListCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesPrintUnprintedHOVPalettePackingListPost(printUnprintedHOVPalettePackingListCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueueHOVItemIntoCargoPackageCommand} [queueHOVItemIntoCargoPackageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesQueueHOVItemIntoCargoPackagePost(queueHOVItemIntoCargoPackageCommand?: QueueHOVItemIntoCargoPackageCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesQueueHOVItemIntoCargoPackagePost(queueHOVItemIntoCargoPackageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueueHOVItemIntoQuarantineToteCommand} [queueHOVItemIntoQuarantineToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesQueueHOVItemIntoQuarantineTotePost(queueHOVItemIntoQuarantineToteCommand?: QueueHOVItemIntoQuarantineToteCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesQueueHOVItemIntoQuarantineTotePost(queueHOVItemIntoQuarantineToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RemoveHOVCargoPackageCommand} [removeHOVCargoPackageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesRemoveHOVCargoPackagePost(removeHOVCargoPackageCommand?: RemoveHOVCargoPackageCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesRemoveHOVCargoPackagePost(removeHOVCargoPackageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RemoveHOVItemFromCargoPackageCommand} [removeHOVItemFromCargoPackageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesRemoveHOVItemFromCargoPackagePost(removeHOVItemFromCargoPackageCommand?: RemoveHOVItemFromCargoPackageCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesRemoveHOVItemFromCargoPackagePost(removeHOVItemFromCargoPackageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RemoveHOVPackingProcessOfUnpackableToteCommand} [removeHOVPackingProcessOfUnpackableToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesRemoveHOVPackingProcessOfUnpackableToteCommandPost(removeHOVPackingProcessOfUnpackableToteCommand?: RemoveHOVPackingProcessOfUnpackableToteCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesRemoveHOVPackingProcessOfUnpackableToteCommandPost(removeHOVPackingProcessOfUnpackableToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReprintHOVPalettePackingListCommand} [reprintHOVPalettePackingListCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesReprintHOVPalettePackingListPost(reprintHOVPalettePackingListCommand?: ReprintHOVPalettePackingListCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesReprintHOVPalettePackingListPost(reprintHOVPalettePackingListCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesTotesReadyToPackGet(options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesTotesReadyToPackGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnassignHOVQuarantineToteCommand} [unassignHOVQuarantineToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPackingProcessesApi
     */
    public apiV1HOVPackingProcessesUnassignHOVQuarantineTotePost(unassignHOVQuarantineToteCommand?: UnassignHOVQuarantineToteCommand, options?: any) {
        return HOVPackingProcessesApiFp(this.configuration).apiV1HOVPackingProcessesUnassignHOVQuarantineTotePost(unassignHOVQuarantineToteCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HOVPickingProcessesApi - axios parameter creator
 * @export
 */
export const HOVPickingProcessesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesCheckBarcodeTypeGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPickingProcesses.checkBarcodeType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckCellForHOVPickingCommand} [checkCellForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesCheckCellPost: async (checkCellForHOVPickingCommand?: CheckCellForHOVPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPickingProcesses.checkCell`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkCellForHOVPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesCheckIfControlCountingIsActiveGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPickingProcesses.checkIfControlCountingIsActive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesGetHOVPickingTrolleyTotesGet: async (trolleyLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPickingProcesses.getHOVPickingTrolleyTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (trolleyLabel !== undefined) {
                localVarQueryParameter['trolleyLabel'] = trolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LostItemForHOVPickingCommand} [lostItemForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesLostItemPost: async (lostItemForHOVPickingCommand?: LostItemForHOVPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPickingProcesses.lostItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lostItemForHOVPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MountToteToHOVPickingTrolleyCommand} [mountToteToHOVPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesMountToteToTrolleyIfNotMountedPost: async (mountToteToHOVPickingTrolleyCommand?: MountToteToHOVPickingTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPickingProcesses.mountToteToTrolleyIfNotMounted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mountToteToHOVPickingTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceHOVPickingTrolleyToParkAddressCommand} [placeHOVPickingTrolleyToParkAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesPlaceHOVPickingTrolleyToParkAddressPost: async (placeHOVPickingTrolleyToParkAddressCommand?: PlaceHOVPickingTrolleyToParkAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPickingProcesses.placeHOVPickingTrolleyToParkAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeHOVPickingTrolleyToParkAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceProductForHOVPickingCommand} [placeProductForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesPlaceProductPost: async (placeProductForHOVPickingCommand?: PlaceProductForHOVPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPickingProcesses.placeProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeProductForHOVPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetProductsControlCountingForHOVPickingCommand} [setProductsControlCountingForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesSetProductsControlCountingPost: async (setProductsControlCountingForHOVPickingCommand?: SetProductsControlCountingForHOVPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPickingProcesses.setProductsControlCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setProductsControlCountingForHOVPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartCreatedPickingForHOVPickingCommand} [startCreatedPickingForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesStartCreatedPickingPost: async (startCreatedPickingForHOVPickingCommand?: StartCreatedPickingForHOVPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPickingProcesses.startCreatedPicking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startCreatedPickingForHOVPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnmountToteAndCompletePickingProcessForHOVPickingCommand} [unmountToteAndCompletePickingProcessForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesUnmountToteAndCompletePickingProcessPost: async (unmountToteAndCompletePickingProcessForHOVPickingCommand?: UnmountToteAndCompletePickingProcessForHOVPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPickingProcesses.unmountToteAndCompletePickingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unmountToteAndCompletePickingProcessForHOVPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand} [unmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesUnmountToteAndCompleteWithLostItemsPickingProcessPost: async (unmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand?: UnmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/HOVPickingProcesses.unmountToteAndCompleteWithLostItemsPickingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HOVPickingProcessesApi - functional programming interface
 * @export
 */
export const HOVPickingProcessesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HOVPickingProcessesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPickingProcessesCheckBarcodeTypeGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckBarcodeTypeForHOVPickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPickingProcessesCheckBarcodeTypeGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckCellForHOVPickingCommand} [checkCellForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPickingProcessesCheckCellPost(checkCellForHOVPickingCommand?: CheckCellForHOVPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPickingProcessesCheckCellPost(checkCellForHOVPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPickingProcessesCheckIfControlCountingIsActiveGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckIfControlCountingIsActiveForHOVPickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPickingProcessesCheckIfControlCountingIsActiveGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPickingProcessesGetHOVPickingTrolleyTotesGet(trolleyLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetHOVPickingTrolleyTotesOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPickingProcessesGetHOVPickingTrolleyTotesGet(trolleyLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LostItemForHOVPickingCommand} [lostItemForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPickingProcessesLostItemPost(lostItemForHOVPickingCommand?: LostItemForHOVPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LostItemForHOVPickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPickingProcessesLostItemPost(lostItemForHOVPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MountToteToHOVPickingTrolleyCommand} [mountToteToHOVPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPickingProcessesMountToteToTrolleyIfNotMountedPost(mountToteToHOVPickingTrolleyCommand?: MountToteToHOVPickingTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MountToteToHOVPickingTrolleyCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPickingProcessesMountToteToTrolleyIfNotMountedPost(mountToteToHOVPickingTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceHOVPickingTrolleyToParkAddressCommand} [placeHOVPickingTrolleyToParkAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPickingProcessesPlaceHOVPickingTrolleyToParkAddressPost(placeHOVPickingTrolleyToParkAddressCommand?: PlaceHOVPickingTrolleyToParkAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPickingProcessesPlaceHOVPickingTrolleyToParkAddressPost(placeHOVPickingTrolleyToParkAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceProductForHOVPickingCommand} [placeProductForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPickingProcessesPlaceProductPost(placeProductForHOVPickingCommand?: PlaceProductForHOVPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceProductForHOVPickingCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPickingProcessesPlaceProductPost(placeProductForHOVPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetProductsControlCountingForHOVPickingCommand} [setProductsControlCountingForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPickingProcessesSetProductsControlCountingPost(setProductsControlCountingForHOVPickingCommand?: SetProductsControlCountingForHOVPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductControlCountingForHOVPickingResultOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPickingProcessesSetProductsControlCountingPost(setProductsControlCountingForHOVPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StartCreatedPickingForHOVPickingCommand} [startCreatedPickingForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPickingProcessesStartCreatedPickingPost(startCreatedPickingForHOVPickingCommand?: StartCreatedPickingForHOVPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartCreatedPickingForHOVPickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPickingProcessesStartCreatedPickingPost(startCreatedPickingForHOVPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UnmountToteAndCompletePickingProcessForHOVPickingCommand} [unmountToteAndCompletePickingProcessForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPickingProcessesUnmountToteAndCompletePickingProcessPost(unmountToteAndCompletePickingProcessForHOVPickingCommand?: UnmountToteAndCompletePickingProcessForHOVPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnmountToteFromHOVPickingTrolleyCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPickingProcessesUnmountToteAndCompletePickingProcessPost(unmountToteAndCompletePickingProcessForHOVPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UnmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand} [unmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1HOVPickingProcessesUnmountToteAndCompleteWithLostItemsPickingProcessPost(unmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand?: UnmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnmountToteFromHOVPickingTrolleyCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HOVPickingProcessesUnmountToteAndCompleteWithLostItemsPickingProcessPost(unmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HOVPickingProcessesApi - factory interface
 * @export
 */
export const HOVPickingProcessesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HOVPickingProcessesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesCheckBarcodeTypeGet(barcode?: string, options?: any): AxiosPromise<CheckBarcodeTypeForHOVPickingOutputDTO> {
            return localVarFp.apiV1HOVPickingProcessesCheckBarcodeTypeGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckCellForHOVPickingCommand} [checkCellForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesCheckCellPost(checkCellForHOVPickingCommand?: CheckCellForHOVPickingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1HOVPickingProcessesCheckCellPost(checkCellForHOVPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesCheckIfControlCountingIsActiveGet(options?: any): AxiosPromise<CheckIfControlCountingIsActiveForHOVPickingOutputDTO> {
            return localVarFp.apiV1HOVPickingProcessesCheckIfControlCountingIsActiveGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesGetHOVPickingTrolleyTotesGet(trolleyLabel?: string, options?: any): AxiosPromise<GetHOVPickingTrolleyTotesOutputDTO> {
            return localVarFp.apiV1HOVPickingProcessesGetHOVPickingTrolleyTotesGet(trolleyLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LostItemForHOVPickingCommand} [lostItemForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesLostItemPost(lostItemForHOVPickingCommand?: LostItemForHOVPickingCommand, options?: any): AxiosPromise<LostItemForHOVPickingOutputDTO> {
            return localVarFp.apiV1HOVPickingProcessesLostItemPost(lostItemForHOVPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MountToteToHOVPickingTrolleyCommand} [mountToteToHOVPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesMountToteToTrolleyIfNotMountedPost(mountToteToHOVPickingTrolleyCommand?: MountToteToHOVPickingTrolleyCommand, options?: any): AxiosPromise<MountToteToHOVPickingTrolleyCommandOutputDTO> {
            return localVarFp.apiV1HOVPickingProcessesMountToteToTrolleyIfNotMountedPost(mountToteToHOVPickingTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceHOVPickingTrolleyToParkAddressCommand} [placeHOVPickingTrolleyToParkAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesPlaceHOVPickingTrolleyToParkAddressPost(placeHOVPickingTrolleyToParkAddressCommand?: PlaceHOVPickingTrolleyToParkAddressCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1HOVPickingProcessesPlaceHOVPickingTrolleyToParkAddressPost(placeHOVPickingTrolleyToParkAddressCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceProductForHOVPickingCommand} [placeProductForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesPlaceProductPost(placeProductForHOVPickingCommand?: PlaceProductForHOVPickingCommand, options?: any): AxiosPromise<PlaceProductForHOVPickingCommandOutputDTO> {
            return localVarFp.apiV1HOVPickingProcessesPlaceProductPost(placeProductForHOVPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetProductsControlCountingForHOVPickingCommand} [setProductsControlCountingForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesSetProductsControlCountingPost(setProductsControlCountingForHOVPickingCommand?: SetProductsControlCountingForHOVPickingCommand, options?: any): AxiosPromise<ProductControlCountingForHOVPickingResultOutputDTO> {
            return localVarFp.apiV1HOVPickingProcessesSetProductsControlCountingPost(setProductsControlCountingForHOVPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StartCreatedPickingForHOVPickingCommand} [startCreatedPickingForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesStartCreatedPickingPost(startCreatedPickingForHOVPickingCommand?: StartCreatedPickingForHOVPickingCommand, options?: any): AxiosPromise<StartCreatedPickingForHOVPickingOutputDTO> {
            return localVarFp.apiV1HOVPickingProcessesStartCreatedPickingPost(startCreatedPickingForHOVPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnmountToteAndCompletePickingProcessForHOVPickingCommand} [unmountToteAndCompletePickingProcessForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesUnmountToteAndCompletePickingProcessPost(unmountToteAndCompletePickingProcessForHOVPickingCommand?: UnmountToteAndCompletePickingProcessForHOVPickingCommand, options?: any): AxiosPromise<UnmountToteFromHOVPickingTrolleyCommandOutputDTO> {
            return localVarFp.apiV1HOVPickingProcessesUnmountToteAndCompletePickingProcessPost(unmountToteAndCompletePickingProcessForHOVPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand} [unmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1HOVPickingProcessesUnmountToteAndCompleteWithLostItemsPickingProcessPost(unmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand?: UnmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand, options?: any): AxiosPromise<UnmountToteFromHOVPickingTrolleyCommandOutputDTO> {
            return localVarFp.apiV1HOVPickingProcessesUnmountToteAndCompleteWithLostItemsPickingProcessPost(unmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HOVPickingProcessesApi - object-oriented interface
 * @export
 * @class HOVPickingProcessesApi
 * @extends {BaseAPI}
 */
export class HOVPickingProcessesApi extends BaseAPI {
    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPickingProcessesApi
     */
    public apiV1HOVPickingProcessesCheckBarcodeTypeGet(barcode?: string, options?: any) {
        return HOVPickingProcessesApiFp(this.configuration).apiV1HOVPickingProcessesCheckBarcodeTypeGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckCellForHOVPickingCommand} [checkCellForHOVPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPickingProcessesApi
     */
    public apiV1HOVPickingProcessesCheckCellPost(checkCellForHOVPickingCommand?: CheckCellForHOVPickingCommand, options?: any) {
        return HOVPickingProcessesApiFp(this.configuration).apiV1HOVPickingProcessesCheckCellPost(checkCellForHOVPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPickingProcessesApi
     */
    public apiV1HOVPickingProcessesCheckIfControlCountingIsActiveGet(options?: any) {
        return HOVPickingProcessesApiFp(this.configuration).apiV1HOVPickingProcessesCheckIfControlCountingIsActiveGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [trolleyLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPickingProcessesApi
     */
    public apiV1HOVPickingProcessesGetHOVPickingTrolleyTotesGet(trolleyLabel?: string, options?: any) {
        return HOVPickingProcessesApiFp(this.configuration).apiV1HOVPickingProcessesGetHOVPickingTrolleyTotesGet(trolleyLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LostItemForHOVPickingCommand} [lostItemForHOVPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPickingProcessesApi
     */
    public apiV1HOVPickingProcessesLostItemPost(lostItemForHOVPickingCommand?: LostItemForHOVPickingCommand, options?: any) {
        return HOVPickingProcessesApiFp(this.configuration).apiV1HOVPickingProcessesLostItemPost(lostItemForHOVPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MountToteToHOVPickingTrolleyCommand} [mountToteToHOVPickingTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPickingProcessesApi
     */
    public apiV1HOVPickingProcessesMountToteToTrolleyIfNotMountedPost(mountToteToHOVPickingTrolleyCommand?: MountToteToHOVPickingTrolleyCommand, options?: any) {
        return HOVPickingProcessesApiFp(this.configuration).apiV1HOVPickingProcessesMountToteToTrolleyIfNotMountedPost(mountToteToHOVPickingTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceHOVPickingTrolleyToParkAddressCommand} [placeHOVPickingTrolleyToParkAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPickingProcessesApi
     */
    public apiV1HOVPickingProcessesPlaceHOVPickingTrolleyToParkAddressPost(placeHOVPickingTrolleyToParkAddressCommand?: PlaceHOVPickingTrolleyToParkAddressCommand, options?: any) {
        return HOVPickingProcessesApiFp(this.configuration).apiV1HOVPickingProcessesPlaceHOVPickingTrolleyToParkAddressPost(placeHOVPickingTrolleyToParkAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceProductForHOVPickingCommand} [placeProductForHOVPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPickingProcessesApi
     */
    public apiV1HOVPickingProcessesPlaceProductPost(placeProductForHOVPickingCommand?: PlaceProductForHOVPickingCommand, options?: any) {
        return HOVPickingProcessesApiFp(this.configuration).apiV1HOVPickingProcessesPlaceProductPost(placeProductForHOVPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetProductsControlCountingForHOVPickingCommand} [setProductsControlCountingForHOVPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPickingProcessesApi
     */
    public apiV1HOVPickingProcessesSetProductsControlCountingPost(setProductsControlCountingForHOVPickingCommand?: SetProductsControlCountingForHOVPickingCommand, options?: any) {
        return HOVPickingProcessesApiFp(this.configuration).apiV1HOVPickingProcessesSetProductsControlCountingPost(setProductsControlCountingForHOVPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StartCreatedPickingForHOVPickingCommand} [startCreatedPickingForHOVPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPickingProcessesApi
     */
    public apiV1HOVPickingProcessesStartCreatedPickingPost(startCreatedPickingForHOVPickingCommand?: StartCreatedPickingForHOVPickingCommand, options?: any) {
        return HOVPickingProcessesApiFp(this.configuration).apiV1HOVPickingProcessesStartCreatedPickingPost(startCreatedPickingForHOVPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnmountToteAndCompletePickingProcessForHOVPickingCommand} [unmountToteAndCompletePickingProcessForHOVPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPickingProcessesApi
     */
    public apiV1HOVPickingProcessesUnmountToteAndCompletePickingProcessPost(unmountToteAndCompletePickingProcessForHOVPickingCommand?: UnmountToteAndCompletePickingProcessForHOVPickingCommand, options?: any) {
        return HOVPickingProcessesApiFp(this.configuration).apiV1HOVPickingProcessesUnmountToteAndCompletePickingProcessPost(unmountToteAndCompletePickingProcessForHOVPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand} [unmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HOVPickingProcessesApi
     */
    public apiV1HOVPickingProcessesUnmountToteAndCompleteWithLostItemsPickingProcessPost(unmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand?: UnmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand, options?: any) {
        return HOVPickingProcessesApiFp(this.configuration).apiV1HOVPickingProcessesUnmountToteAndCompleteWithLostItemsPickingProcessPost(unmountToteAndCompleteWithLostItemsPickingProcessForHOVPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1HealthAwsCheckGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Health.awsCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1HealthCheckGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Health.check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1HealthAwsCheckGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1HealthAwsCheckGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1HealthCheckGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1HealthCheckGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1HealthAwsCheckGet(options?: any): AxiosPromise<void> {
            return localVarFp.adminV1HealthAwsCheckGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1HealthCheckGet(options?: any): AxiosPromise<void> {
            return localVarFp.adminV1HealthCheckGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public adminV1HealthAwsCheckGet(options?: any) {
        return HealthApiFp(this.configuration).adminV1HealthAwsCheckGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public adminV1HealthCheckGet(options?: any) {
        return HealthApiFp(this.configuration).adminV1HealthCheckGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InboundProblemsApi - axios parameter creator
 * @export
 */
export const InboundProblemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsCheckBarcodeTypeGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.checkBarcodeType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetAnalyticsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.getAnalytics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetBarcodeMismatchProblemDetailsGet: async (problemRefNo?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.getBarcodeMismatchProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemRefNo !== undefined) {
                localVarQueryParameter['problemRefNo'] = problemRefNo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetBarcodeNotExistProblemDetailsGet: async (problemRefNo?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.getBarcodeNotExistProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemRefNo !== undefined) {
                localVarQueryParameter['problemRefNo'] = problemRefNo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetDamagedItemsProblemDetailsGet: async (problemRefNo?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.getDamagedItemsProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemRefNo !== undefined) {
                localVarQueryParameter['problemRefNo'] = problemRefNo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetDuplicateBarcodeProblemDetailsGet: async (problemRefNo?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.getDuplicateBarcodeProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemRefNo !== undefined) {
                localVarQueryParameter['problemRefNo'] = problemRefNo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [inboundProblemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetInboundProblemDetailsGet: async (inboundProblemRefNo?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.getInboundProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (inboundProblemRefNo !== undefined) {
                localVarQueryParameter['inboundProblemRefNo'] = inboundProblemRefNo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [quarantineContainerId] 
         * @param {number} [inboundBoxId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetInboundProblemsByQuarantineContainerOrInboundBoxGet: async (quarantineContainerId?: number, inboundBoxId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.getInboundProblemsByQuarantineContainerOrInboundBox`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (quarantineContainerId !== undefined) {
                localVarQueryParameter['quarantineContainerId'] = quarantineContainerId;
            }

            if (inboundBoxId !== undefined) {
                localVarQueryParameter['inboundBoxId'] = inboundBoxId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetUnidentifiedProductProblemDetailsGet: async (problemRefNo?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.getUnidentifiedProductProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemRefNo !== undefined) {
                localVarQueryParameter['problemRefNo'] = problemRefNo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetUnreadableBarcodeProblemDetailsGet: async (problemRefNo?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.getUnreadableBarcodeProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemRefNo !== undefined) {
                localVarQueryParameter['problemRefNo'] = problemRefNo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} purchaseOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsQueryByPurchaseOrderGet: async (purchaseOrderId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseOrderId' is not null or undefined
            assertParamExists('apiV1InboundProblemsQueryByPurchaseOrderGet', 'purchaseOrderId', purchaseOrderId)
            const localVarPath = `/api/v1/InboundProblems.queryByPurchaseOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (purchaseOrderId !== undefined) {
                localVarQueryParameter['purchaseOrderId'] = purchaseOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} waybillId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsQueryByWaybillGet: async (waybillId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waybillId' is not null or undefined
            assertParamExists('apiV1InboundProblemsQueryByWaybillGet', 'waybillId', waybillId)
            const localVarPath = `/api/v1/InboundProblems.queryByWaybill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (waybillId !== undefined) {
                localVarQueryParameter['waybillId'] = waybillId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} purchaseOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsQueryInboundBoxesByPurchaseOrderGet: async (purchaseOrderId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseOrderId' is not null or undefined
            assertParamExists('apiV1InboundProblemsQueryInboundBoxesByPurchaseOrderGet', 'purchaseOrderId', purchaseOrderId)
            const localVarPath = `/api/v1/InboundProblems.queryInboundBoxesByPurchaseOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (purchaseOrderId !== undefined) {
                localVarQueryParameter['purchaseOrderId'] = purchaseOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} waybillId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsQueryInboundBoxesByWaybillGet: async (waybillId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'waybillId' is not null or undefined
            assertParamExists('apiV1InboundProblemsQueryInboundBoxesByWaybillGet', 'waybillId', waybillId)
            const localVarPath = `/api/v1/InboundProblems.queryInboundBoxesByWaybill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (waybillId !== undefined) {
                localVarQueryParameter['waybillId'] = waybillId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolveBarcodeMismatchProblemCommand} [solveBarcodeMismatchProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsSolveBarcodeMismatchProblemPost: async (solveBarcodeMismatchProblemCommand?: SolveBarcodeMismatchProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.solveBarcodeMismatchProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solveBarcodeMismatchProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolveBarcodeNotExistProblemCommand} [solveBarcodeNotExistProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsSolveBarcodeNotExistProblemPost: async (solveBarcodeNotExistProblemCommand?: SolveBarcodeNotExistProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.solveBarcodeNotExistProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solveBarcodeNotExistProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolveDamagedItemsProblemCommand} [solveDamagedItemsProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsSolveDamagedItemsProblemPost: async (solveDamagedItemsProblemCommand?: SolveDamagedItemsProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.solveDamagedItemsProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solveDamagedItemsProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolveDuplicateBarcodeProblemCommand} [solveDuplicateBarcodeProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsSolveDuplicateBarcodeProblemPost: async (solveDuplicateBarcodeProblemCommand?: SolveDuplicateBarcodeProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.solveDuplicateBarcodeProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solveDuplicateBarcodeProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolveUnidentifiedProductProblemCommand} [solveUnidentifiedProductProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsSolveUnidentifiedProductProblemPost: async (solveUnidentifiedProductProblemCommand?: SolveUnidentifiedProductProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.solveUnidentifiedProductProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solveUnidentifiedProductProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolveUnreadableBarcodeProblemCommand} [solveUnreadableBarcodeProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsSolveUnreadableBarcodeProblemPost: async (solveUnreadableBarcodeProblemCommand?: SolveUnreadableBarcodeProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InboundProblems.solveUnreadableBarcodeProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solveUnreadableBarcodeProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CorrectInboundProblemCommand} [correctInboundProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1InboundProblemsInboundProblemsCorrectInboundProblemPost: async (correctInboundProblemCommand?: CorrectInboundProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/InboundProblems/InboundProblems.correctInboundProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(correctInboundProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InboundProblemsApi - functional programming interface
 * @export
 */
export const InboundProblemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InboundProblemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsCheckBarcodeTypeGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InboundProblemsBarcodeTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsCheckBarcodeTypeGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsGetAnalyticsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInboundProblemsAnalyticsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsGetAnalyticsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsGetBarcodeMismatchProblemDetailsGet(problemRefNo?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBarcodeMismatchProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsGetBarcodeMismatchProblemDetailsGet(problemRefNo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsGetBarcodeNotExistProblemDetailsGet(problemRefNo?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBarcodeNotExistProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsGetBarcodeNotExistProblemDetailsGet(problemRefNo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsGetDamagedItemsProblemDetailsGet(problemRefNo?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDamagedItemsProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsGetDamagedItemsProblemDetailsGet(problemRefNo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsGetDuplicateBarcodeProblemDetailsGet(problemRefNo?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDuplicateBarcodeProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsGetDuplicateBarcodeProblemDetailsGet(problemRefNo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [inboundProblemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsGetInboundProblemDetailsGet(inboundProblemRefNo?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInboundProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsGetInboundProblemDetailsGet(inboundProblemRefNo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [quarantineContainerId] 
         * @param {number} [inboundBoxId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsGetInboundProblemsByQuarantineContainerOrInboundBoxGet(quarantineContainerId?: number, inboundBoxId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInboundProblemsByQuarantineContainerOrInboundBoxOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsGetInboundProblemsByQuarantineContainerOrInboundBoxGet(quarantineContainerId, inboundBoxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsGetUnidentifiedProductProblemDetailsGet(problemRefNo?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnidentifiedProductProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsGetUnidentifiedProductProblemDetailsGet(problemRefNo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsGetUnreadableBarcodeProblemDetailsGet(problemRefNo?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnreadableBarcodeProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsGetUnreadableBarcodeProblemDetailsGet(problemRefNo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} purchaseOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsQueryByPurchaseOrderGet(purchaseOrderId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryInboundProblemsByPurchaseOrderOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsQueryByPurchaseOrderGet(purchaseOrderId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} waybillId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsQueryByWaybillGet(waybillId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryInboundProblemsByWaybillOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsQueryByWaybillGet(waybillId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryInboundProblemsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} purchaseOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsQueryInboundBoxesByPurchaseOrderGet(purchaseOrderId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryInboundBoxesByPurchaseOrderOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsQueryInboundBoxesByPurchaseOrderGet(purchaseOrderId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} waybillId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsQueryInboundBoxesByWaybillGet(waybillId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryInboundBoxesByWaybillOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsQueryInboundBoxesByWaybillGet(waybillId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SolveBarcodeMismatchProblemCommand} [solveBarcodeMismatchProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsSolveBarcodeMismatchProblemPost(solveBarcodeMismatchProblemCommand?: SolveBarcodeMismatchProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsSolveBarcodeMismatchProblemPost(solveBarcodeMismatchProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SolveBarcodeNotExistProblemCommand} [solveBarcodeNotExistProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsSolveBarcodeNotExistProblemPost(solveBarcodeNotExistProblemCommand?: SolveBarcodeNotExistProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsSolveBarcodeNotExistProblemPost(solveBarcodeNotExistProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SolveDamagedItemsProblemCommand} [solveDamagedItemsProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsSolveDamagedItemsProblemPost(solveDamagedItemsProblemCommand?: SolveDamagedItemsProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsSolveDamagedItemsProblemPost(solveDamagedItemsProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SolveDuplicateBarcodeProblemCommand} [solveDuplicateBarcodeProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsSolveDuplicateBarcodeProblemPost(solveDuplicateBarcodeProblemCommand?: SolveDuplicateBarcodeProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsSolveDuplicateBarcodeProblemPost(solveDuplicateBarcodeProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SolveUnidentifiedProductProblemCommand} [solveUnidentifiedProductProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsSolveUnidentifiedProductProblemPost(solveUnidentifiedProductProblemCommand?: SolveUnidentifiedProductProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsSolveUnidentifiedProductProblemPost(solveUnidentifiedProductProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SolveUnreadableBarcodeProblemCommand} [solveUnreadableBarcodeProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InboundProblemsSolveUnreadableBarcodeProblemPost(solveUnreadableBarcodeProblemCommand?: SolveUnreadableBarcodeProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InboundProblemsSolveUnreadableBarcodeProblemPost(solveUnreadableBarcodeProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CorrectInboundProblemCommand} [correctInboundProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1InboundProblemsInboundProblemsCorrectInboundProblemPost(correctInboundProblemCommand?: CorrectInboundProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1InboundProblemsInboundProblemsCorrectInboundProblemPost(correctInboundProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InboundProblemsApi - factory interface
 * @export
 */
export const InboundProblemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InboundProblemsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsCheckBarcodeTypeGet(barcode?: string, options?: any): AxiosPromise<InboundProblemsBarcodeTypeOutputDTO> {
            return localVarFp.apiV1InboundProblemsCheckBarcodeTypeGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetAnalyticsGet(options?: any): AxiosPromise<GetInboundProblemsAnalyticsOutputDTO> {
            return localVarFp.apiV1InboundProblemsGetAnalyticsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetBarcodeMismatchProblemDetailsGet(problemRefNo?: string, options?: any): AxiosPromise<GetBarcodeMismatchProblemDetailsOutputDTO> {
            return localVarFp.apiV1InboundProblemsGetBarcodeMismatchProblemDetailsGet(problemRefNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetBarcodeNotExistProblemDetailsGet(problemRefNo?: string, options?: any): AxiosPromise<GetBarcodeNotExistProblemDetailsOutputDTO> {
            return localVarFp.apiV1InboundProblemsGetBarcodeNotExistProblemDetailsGet(problemRefNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetDamagedItemsProblemDetailsGet(problemRefNo?: string, options?: any): AxiosPromise<GetDamagedItemsProblemDetailsOutputDTO> {
            return localVarFp.apiV1InboundProblemsGetDamagedItemsProblemDetailsGet(problemRefNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetDuplicateBarcodeProblemDetailsGet(problemRefNo?: string, options?: any): AxiosPromise<GetDuplicateBarcodeProblemDetailsOutputDTO> {
            return localVarFp.apiV1InboundProblemsGetDuplicateBarcodeProblemDetailsGet(problemRefNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [inboundProblemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetInboundProblemDetailsGet(inboundProblemRefNo?: string, options?: any): AxiosPromise<GetInboundProblemDetailsOutputDTO> {
            return localVarFp.apiV1InboundProblemsGetInboundProblemDetailsGet(inboundProblemRefNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [quarantineContainerId] 
         * @param {number} [inboundBoxId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetInboundProblemsByQuarantineContainerOrInboundBoxGet(quarantineContainerId?: number, inboundBoxId?: number, options?: any): AxiosPromise<GetInboundProblemsByQuarantineContainerOrInboundBoxOutputDTO> {
            return localVarFp.apiV1InboundProblemsGetInboundProblemsByQuarantineContainerOrInboundBoxGet(quarantineContainerId, inboundBoxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetUnidentifiedProductProblemDetailsGet(problemRefNo?: string, options?: any): AxiosPromise<GetUnidentifiedProductProblemDetailsOutputDTO> {
            return localVarFp.apiV1InboundProblemsGetUnidentifiedProductProblemDetailsGet(problemRefNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemRefNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsGetUnreadableBarcodeProblemDetailsGet(problemRefNo?: string, options?: any): AxiosPromise<GetUnreadableBarcodeProblemDetailsOutputDTO> {
            return localVarFp.apiV1InboundProblemsGetUnreadableBarcodeProblemDetailsGet(problemRefNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} purchaseOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsQueryByPurchaseOrderGet(purchaseOrderId: string, dqb?: string, options?: any): AxiosPromise<QueryInboundProblemsByPurchaseOrderOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InboundProblemsQueryByPurchaseOrderGet(purchaseOrderId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} waybillId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsQueryByWaybillGet(waybillId: string, dqb?: string, options?: any): AxiosPromise<QueryInboundProblemsByWaybillOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InboundProblemsQueryByWaybillGet(waybillId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsQueryGet(dqb?: string, options?: any): AxiosPromise<QueryInboundProblemsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InboundProblemsQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} purchaseOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsQueryInboundBoxesByPurchaseOrderGet(purchaseOrderId: string, dqb?: string, options?: any): AxiosPromise<QueryInboundBoxesByPurchaseOrderOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InboundProblemsQueryInboundBoxesByPurchaseOrderGet(purchaseOrderId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} waybillId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsQueryInboundBoxesByWaybillGet(waybillId: string, dqb?: string, options?: any): AxiosPromise<QueryInboundBoxesByWaybillOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InboundProblemsQueryInboundBoxesByWaybillGet(waybillId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolveBarcodeMismatchProblemCommand} [solveBarcodeMismatchProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsSolveBarcodeMismatchProblemPost(solveBarcodeMismatchProblemCommand?: SolveBarcodeMismatchProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1InboundProblemsSolveBarcodeMismatchProblemPost(solveBarcodeMismatchProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolveBarcodeNotExistProblemCommand} [solveBarcodeNotExistProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsSolveBarcodeNotExistProblemPost(solveBarcodeNotExistProblemCommand?: SolveBarcodeNotExistProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1InboundProblemsSolveBarcodeNotExistProblemPost(solveBarcodeNotExistProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolveDamagedItemsProblemCommand} [solveDamagedItemsProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsSolveDamagedItemsProblemPost(solveDamagedItemsProblemCommand?: SolveDamagedItemsProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1InboundProblemsSolveDamagedItemsProblemPost(solveDamagedItemsProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolveDuplicateBarcodeProblemCommand} [solveDuplicateBarcodeProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsSolveDuplicateBarcodeProblemPost(solveDuplicateBarcodeProblemCommand?: SolveDuplicateBarcodeProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1InboundProblemsSolveDuplicateBarcodeProblemPost(solveDuplicateBarcodeProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolveUnidentifiedProductProblemCommand} [solveUnidentifiedProductProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsSolveUnidentifiedProductProblemPost(solveUnidentifiedProductProblemCommand?: SolveUnidentifiedProductProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1InboundProblemsSolveUnidentifiedProductProblemPost(solveUnidentifiedProductProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolveUnreadableBarcodeProblemCommand} [solveUnreadableBarcodeProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InboundProblemsSolveUnreadableBarcodeProblemPost(solveUnreadableBarcodeProblemCommand?: SolveUnreadableBarcodeProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1InboundProblemsSolveUnreadableBarcodeProblemPost(solveUnreadableBarcodeProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CorrectInboundProblemCommand} [correctInboundProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1InboundProblemsInboundProblemsCorrectInboundProblemPost(correctInboundProblemCommand?: CorrectInboundProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.openapiV1InboundProblemsInboundProblemsCorrectInboundProblemPost(correctInboundProblemCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InboundProblemsApi - object-oriented interface
 * @export
 * @class InboundProblemsApi
 * @extends {BaseAPI}
 */
export class InboundProblemsApi extends BaseAPI {
    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsCheckBarcodeTypeGet(barcode?: string, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsCheckBarcodeTypeGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsGetAnalyticsGet(options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsGetAnalyticsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemRefNo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsGetBarcodeMismatchProblemDetailsGet(problemRefNo?: string, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsGetBarcodeMismatchProblemDetailsGet(problemRefNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemRefNo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsGetBarcodeNotExistProblemDetailsGet(problemRefNo?: string, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsGetBarcodeNotExistProblemDetailsGet(problemRefNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemRefNo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsGetDamagedItemsProblemDetailsGet(problemRefNo?: string, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsGetDamagedItemsProblemDetailsGet(problemRefNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemRefNo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsGetDuplicateBarcodeProblemDetailsGet(problemRefNo?: string, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsGetDuplicateBarcodeProblemDetailsGet(problemRefNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [inboundProblemRefNo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsGetInboundProblemDetailsGet(inboundProblemRefNo?: string, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsGetInboundProblemDetailsGet(inboundProblemRefNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [quarantineContainerId] 
     * @param {number} [inboundBoxId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsGetInboundProblemsByQuarantineContainerOrInboundBoxGet(quarantineContainerId?: number, inboundBoxId?: number, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsGetInboundProblemsByQuarantineContainerOrInboundBoxGet(quarantineContainerId, inboundBoxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemRefNo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsGetUnidentifiedProductProblemDetailsGet(problemRefNo?: string, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsGetUnidentifiedProductProblemDetailsGet(problemRefNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemRefNo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsGetUnreadableBarcodeProblemDetailsGet(problemRefNo?: string, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsGetUnreadableBarcodeProblemDetailsGet(problemRefNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} purchaseOrderId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsQueryByPurchaseOrderGet(purchaseOrderId: string, dqb?: string, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsQueryByPurchaseOrderGet(purchaseOrderId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} waybillId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsQueryByWaybillGet(waybillId: string, dqb?: string, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsQueryByWaybillGet(waybillId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsQueryGet(dqb?: string, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} purchaseOrderId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsQueryInboundBoxesByPurchaseOrderGet(purchaseOrderId: string, dqb?: string, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsQueryInboundBoxesByPurchaseOrderGet(purchaseOrderId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} waybillId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsQueryInboundBoxesByWaybillGet(waybillId: string, dqb?: string, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsQueryInboundBoxesByWaybillGet(waybillId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolveBarcodeMismatchProblemCommand} [solveBarcodeMismatchProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsSolveBarcodeMismatchProblemPost(solveBarcodeMismatchProblemCommand?: SolveBarcodeMismatchProblemCommand, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsSolveBarcodeMismatchProblemPost(solveBarcodeMismatchProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolveBarcodeNotExistProblemCommand} [solveBarcodeNotExistProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsSolveBarcodeNotExistProblemPost(solveBarcodeNotExistProblemCommand?: SolveBarcodeNotExistProblemCommand, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsSolveBarcodeNotExistProblemPost(solveBarcodeNotExistProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolveDamagedItemsProblemCommand} [solveDamagedItemsProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsSolveDamagedItemsProblemPost(solveDamagedItemsProblemCommand?: SolveDamagedItemsProblemCommand, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsSolveDamagedItemsProblemPost(solveDamagedItemsProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolveDuplicateBarcodeProblemCommand} [solveDuplicateBarcodeProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsSolveDuplicateBarcodeProblemPost(solveDuplicateBarcodeProblemCommand?: SolveDuplicateBarcodeProblemCommand, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsSolveDuplicateBarcodeProblemPost(solveDuplicateBarcodeProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolveUnidentifiedProductProblemCommand} [solveUnidentifiedProductProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsSolveUnidentifiedProductProblemPost(solveUnidentifiedProductProblemCommand?: SolveUnidentifiedProductProblemCommand, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsSolveUnidentifiedProductProblemPost(solveUnidentifiedProductProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolveUnreadableBarcodeProblemCommand} [solveUnreadableBarcodeProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public apiV1InboundProblemsSolveUnreadableBarcodeProblemPost(solveUnreadableBarcodeProblemCommand?: SolveUnreadableBarcodeProblemCommand, options?: any) {
        return InboundProblemsApiFp(this.configuration).apiV1InboundProblemsSolveUnreadableBarcodeProblemPost(solveUnreadableBarcodeProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CorrectInboundProblemCommand} [correctInboundProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboundProblemsApi
     */
    public openapiV1InboundProblemsInboundProblemsCorrectInboundProblemPost(correctInboundProblemCommand?: CorrectInboundProblemCommand, options?: any) {
        return InboundProblemsApiFp(this.configuration).openapiV1InboundProblemsInboundProblemsCorrectInboundProblemPost(correctInboundProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IntegrationsApi - axios parameter creator
 * @export
 */
export const IntegrationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ActivateIntegrationCommand} [activateIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationsActivatePut: async (activateIntegrationCommand?: ActivateIntegrationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Integrations.activate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activateIntegrationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeactivateIntegrationCommand} [deactivateIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationsDeactivatePut: async (deactivateIntegrationCommand?: DeactivateIntegrationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Integrations.deactivate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deactivateIntegrationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteIntegrationCommand} [deleteIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationsDeleteDelete: async (deleteIntegrationCommand?: DeleteIntegrationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Integrations.delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteIntegrationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationsListGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Integrations.list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationsApi - functional programming interface
 * @export
 */
export const IntegrationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ActivateIntegrationCommand} [activateIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1IntegrationsActivatePut(activateIntegrationCommand?: ActivateIntegrationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivatedIntegrationOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1IntegrationsActivatePut(activateIntegrationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeactivateIntegrationCommand} [deactivateIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1IntegrationsDeactivatePut(deactivateIntegrationCommand?: DeactivateIntegrationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeactivatedIntegrationOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1IntegrationsDeactivatePut(deactivateIntegrationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteIntegrationCommand} [deleteIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1IntegrationsDeleteDelete(deleteIntegrationCommand?: DeleteIntegrationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeletedIntegrationOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1IntegrationsDeleteDelete(deleteIntegrationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1IntegrationsListGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IntegrationListOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1IntegrationsListGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IntegrationsApi - factory interface
 * @export
 */
export const IntegrationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationsApiFp(configuration)
    return {
        /**
         * 
         * @param {ActivateIntegrationCommand} [activateIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationsActivatePut(activateIntegrationCommand?: ActivateIntegrationCommand, options?: any): AxiosPromise<ActivatedIntegrationOutputDTO> {
            return localVarFp.apiV1IntegrationsActivatePut(activateIntegrationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeactivateIntegrationCommand} [deactivateIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationsDeactivatePut(deactivateIntegrationCommand?: DeactivateIntegrationCommand, options?: any): AxiosPromise<DeactivatedIntegrationOutputDTO> {
            return localVarFp.apiV1IntegrationsDeactivatePut(deactivateIntegrationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteIntegrationCommand} [deleteIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationsDeleteDelete(deleteIntegrationCommand?: DeleteIntegrationCommand, options?: any): AxiosPromise<DeletedIntegrationOutputDTO> {
            return localVarFp.apiV1IntegrationsDeleteDelete(deleteIntegrationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IntegrationsListGet(options?: any): AxiosPromise<Array<IntegrationListOutputDTO>> {
            return localVarFp.apiV1IntegrationsListGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntegrationsApi - object-oriented interface
 * @export
 * @class IntegrationsApi
 * @extends {BaseAPI}
 */
export class IntegrationsApi extends BaseAPI {
    /**
     * 
     * @param {ActivateIntegrationCommand} [activateIntegrationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public apiV1IntegrationsActivatePut(activateIntegrationCommand?: ActivateIntegrationCommand, options?: any) {
        return IntegrationsApiFp(this.configuration).apiV1IntegrationsActivatePut(activateIntegrationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeactivateIntegrationCommand} [deactivateIntegrationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public apiV1IntegrationsDeactivatePut(deactivateIntegrationCommand?: DeactivateIntegrationCommand, options?: any) {
        return IntegrationsApiFp(this.configuration).apiV1IntegrationsDeactivatePut(deactivateIntegrationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteIntegrationCommand} [deleteIntegrationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public apiV1IntegrationsDeleteDelete(deleteIntegrationCommand?: DeleteIntegrationCommand, options?: any) {
        return IntegrationsApiFp(this.configuration).apiV1IntegrationsDeleteDelete(deleteIntegrationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    public apiV1IntegrationsListGet(options?: any) {
        return IntegrationsApiFp(this.configuration).apiV1IntegrationsListGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InventoryItemsApi - axios parameter creator
 * @export
 */
export const InventoryItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsGetInventoryItemExpirationDateTrackingCountsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.getInventoryItemExpirationDateTrackingCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsGetInventoryItemSerialNumberTrackingCountsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.getInventoryItemSerialNumberTrackingCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cargoPackageLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsGetInventoryItemsByCargoPackageLabelGet: async (cargoPackageLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.getInventoryItemsByCargoPackageLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cargoPackageLabel !== undefined) {
                localVarQueryParameter['cargoPackageLabel'] = cargoPackageLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsGetInventoryItemsByToteLabelGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.getInventoryItemsByToteLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsGetInventoryItemsCountGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.getInventoryItemsCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsGetOutOfStockItemsCountGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.getOutOfStockItemsCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsGetStockItemsCountGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.getStockItemsCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} containerLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryByContainerLabelGet: async (containerLabel: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'containerLabel' is not null or undefined
            assertParamExists('apiV1InventoryItemsQueryByContainerLabelGet', 'containerLabel', containerLabel)
            const localVarPath = `/api/v1/InventoryItems.queryByContainerLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (containerLabel !== undefined) {
                localVarQueryParameter['containerLabel'] = containerLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryByZoneGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.queryByZone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryInventoryItemExpirationDateTrackingsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.queryInventoryItemExpirationDateTrackings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryInventoryItemSerialNumberTrackingsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.queryInventoryItemSerialNumberTrackings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryInventoryItemsByProductWithSerialNumberGet: async (productId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiV1InventoryItemsQueryInventoryItemsByProductWithSerialNumberGet', 'productId', productId)
            const localVarPath = `/api/v1/InventoryItems.queryInventoryItemsByProductWithSerialNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryLostItemLogRecordsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.queryLostItemLogRecords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryOutOfStockItemsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.queryOutOfStockItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryPutAwayAwaitingReceivedItemsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.queryPutAwayAwaitingReceivedItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} palletLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryPutAwayReceivedItemsByPalletGet: async (palletLabel: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'palletLabel' is not null or undefined
            assertParamExists('apiV1InventoryItemsQueryPutAwayReceivedItemsByPalletGet', 'palletLabel', palletLabel)
            const localVarPath = `/api/v1/InventoryItems.queryPutAwayReceivedItemsByPallet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (palletLabel !== undefined) {
                localVarQueryParameter['palletLabel'] = palletLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} toteLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryPutAwayReceivedItemsByToteGet: async (toteLabel: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'toteLabel' is not null or undefined
            assertParamExists('apiV1InventoryItemsQueryPutAwayReceivedItemsByToteGet', 'toteLabel', toteLabel)
            const localVarPath = `/api/v1/InventoryItems.queryPutAwayReceivedItemsByTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryPutAwayReceivedItemsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.queryPutAwayReceivedItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryStockItemsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.queryStockItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryStockStatusCountsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/InventoryItems.queryStockStatusCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkDeleteContainerInventoryItemsCommand} [bulkDeleteContainerInventoryItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1InventoryItemsBulkDeletePost: async (bulkDeleteContainerInventoryItemsCommand?: BulkDeleteContainerInventoryItemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/InventoryItems/bulkDelete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDeleteContainerInventoryItemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteProductFromContainerCommand} [deleteProductFromContainerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1InventoryItemsDeleteProductPost: async (deleteProductFromContainerCommand?: DeleteProductFromContainerCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/InventoryItems/deleteProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteProductFromContainerCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FixGhostAllocationsCommand} [fixGhostAllocationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1InventoryItemsFixGhostAllocationsPost: async (fixGhostAllocationsCommand?: FixGhostAllocationsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/InventoryItems/fixGhostAllocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fixGhostAllocationsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateInventoryItemLotNumberCommand} [updateInventoryItemLotNumberCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1InventoryItemsUpdateLotNumberPost: async (updateInventoryItemLotNumberCommand?: UpdateInventoryItemLotNumberCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/InventoryItems/updateLotNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInventoryItemLotNumberCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryItemsApi - functional programming interface
 * @export
 */
export const InventoryItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsGetInventoryItemExpirationDateTrackingCountsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryItemExpirationDateTrackingCountOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsGetInventoryItemExpirationDateTrackingCountsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsGetInventoryItemSerialNumberTrackingCountsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryItemSerialNumberTrackingCountOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsGetInventoryItemSerialNumberTrackingCountsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cargoPackageLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsGetInventoryItemsByCargoPackageLabelGet(cargoPackageLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InventoryItemGetByCargoPackageLabelGroupByDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsGetInventoryItemsByCargoPackageLabelGet(cargoPackageLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsGetInventoryItemsByToteLabelGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InventoryItemGetByToteLabelGroupByDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsGetInventoryItemsByToteLabelGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsGetInventoryItemsCountGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryCountOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsGetInventoryItemsCountGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsGetOutOfStockItemsCountGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutOfStockItemQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsGetOutOfStockItemsCountGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsGetStockItemsCountGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryCountOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsGetStockItemsCountGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} containerLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsQueryByContainerLabelGet(containerLabel: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryQueryByContainerLabelOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsQueryByContainerLabelGet(containerLabel, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsQueryByZoneGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryQueryByZoneOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsQueryByZoneGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsQueryInventoryItemExpirationDateTrackingsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsQueryInventoryItemExpirationDateTrackingsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsQueryInventoryItemSerialNumberTrackingsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsQueryInventoryItemSerialNumberTrackingsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsQueryInventoryItemsByProductWithSerialNumberGet(productId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsQueryInventoryItemsByProductWithSerialNumberGet(productId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsQueryLostItemLogRecordsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LostItemLogRecordOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsQueryLostItemLogRecordsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsQueryOutOfStockItemsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutOfStockItemQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsQueryOutOfStockItemsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsQueryPutAwayAwaitingReceivedItemsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryPutAwayAwaitingReceivedItemsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsQueryPutAwayAwaitingReceivedItemsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} palletLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsQueryPutAwayReceivedItemsByPalletGet(palletLabel: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAwayReceivedPalletItemsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsQueryPutAwayReceivedItemsByPalletGet(palletLabel, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} toteLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsQueryPutAwayReceivedItemsByToteGet(toteLabel: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAwayReceivedItemsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsQueryPutAwayReceivedItemsByToteGet(toteLabel, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsQueryPutAwayReceivedItemsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAwayReceivedItemsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsQueryPutAwayReceivedItemsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsQueryStockItemsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockItemQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsQueryStockItemsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1InventoryItemsQueryStockStatusCountsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryStockStatusCountsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1InventoryItemsQueryStockStatusCountsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkDeleteContainerInventoryItemsCommand} [bulkDeleteContainerInventoryItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1InventoryItemsBulkDeletePost(bulkDeleteContainerInventoryItemsCommand?: BulkDeleteContainerInventoryItemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkDeleteInventoryItemsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1InventoryItemsBulkDeletePost(bulkDeleteContainerInventoryItemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteProductFromContainerCommand} [deleteProductFromContainerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1InventoryItemsDeleteProductPost(deleteProductFromContainerCommand?: DeleteProductFromContainerCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteProductFromContainerOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1InventoryItemsDeleteProductPost(deleteProductFromContainerCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FixGhostAllocationsCommand} [fixGhostAllocationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1InventoryItemsFixGhostAllocationsPost(fixGhostAllocationsCommand?: FixGhostAllocationsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FixGhostAllocationsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1InventoryItemsFixGhostAllocationsPost(fixGhostAllocationsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateInventoryItemLotNumberCommand} [updateInventoryItemLotNumberCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1InventoryItemsUpdateLotNumberPost(updateInventoryItemLotNumberCommand?: UpdateInventoryItemLotNumberCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateInventoryItemLotNumberOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1InventoryItemsUpdateLotNumberPost(updateInventoryItemLotNumberCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InventoryItemsApi - factory interface
 * @export
 */
export const InventoryItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryItemsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsGetInventoryItemExpirationDateTrackingCountsGet(options?: any): AxiosPromise<InventoryItemExpirationDateTrackingCountOutputDTO> {
            return localVarFp.apiV1InventoryItemsGetInventoryItemExpirationDateTrackingCountsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsGetInventoryItemSerialNumberTrackingCountsGet(options?: any): AxiosPromise<InventoryItemSerialNumberTrackingCountOutputDTO> {
            return localVarFp.apiV1InventoryItemsGetInventoryItemSerialNumberTrackingCountsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cargoPackageLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsGetInventoryItemsByCargoPackageLabelGet(cargoPackageLabel?: string, options?: any): AxiosPromise<Array<InventoryItemGetByCargoPackageLabelGroupByDTO>> {
            return localVarFp.apiV1InventoryItemsGetInventoryItemsByCargoPackageLabelGet(cargoPackageLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsGetInventoryItemsByToteLabelGet(toteLabel?: string, options?: any): AxiosPromise<Array<InventoryItemGetByToteLabelGroupByDTO>> {
            return localVarFp.apiV1InventoryItemsGetInventoryItemsByToteLabelGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsGetInventoryItemsCountGet(dqb?: string, options?: any): AxiosPromise<InventoryCountOutputDTO> {
            return localVarFp.apiV1InventoryItemsGetInventoryItemsCountGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsGetOutOfStockItemsCountGet(dqb?: string, options?: any): AxiosPromise<OutOfStockItemQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InventoryItemsGetOutOfStockItemsCountGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsGetStockItemsCountGet(dqb?: string, options?: any): AxiosPromise<InventoryCountOutputDTO> {
            return localVarFp.apiV1InventoryItemsGetStockItemsCountGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} containerLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryByContainerLabelGet(containerLabel: string, dqb?: string, options?: any): AxiosPromise<InventoryQueryByContainerLabelOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InventoryItemsQueryByContainerLabelGet(containerLabel, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryByZoneGet(dqb?: string, options?: any): AxiosPromise<InventoryQueryByZoneOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InventoryItemsQueryByZoneGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryGet(dqb?: string, options?: any): AxiosPromise<InventoryQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InventoryItemsQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryInventoryItemExpirationDateTrackingsGet(dqb?: string, options?: any): AxiosPromise<InventoryItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InventoryItemsQueryInventoryItemExpirationDateTrackingsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryInventoryItemSerialNumberTrackingsGet(dqb?: string, options?: any): AxiosPromise<InventoryItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InventoryItemsQueryInventoryItemSerialNumberTrackingsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryInventoryItemsByProductWithSerialNumberGet(productId: string, dqb?: string, options?: any): AxiosPromise<InventoryItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InventoryItemsQueryInventoryItemsByProductWithSerialNumberGet(productId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryLostItemLogRecordsGet(dqb?: string, options?: any): AxiosPromise<LostItemLogRecordOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InventoryItemsQueryLostItemLogRecordsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryOutOfStockItemsGet(dqb?: string, options?: any): AxiosPromise<OutOfStockItemQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InventoryItemsQueryOutOfStockItemsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryPutAwayAwaitingReceivedItemsGet(dqb?: string, options?: any): AxiosPromise<QueryPutAwayAwaitingReceivedItemsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InventoryItemsQueryPutAwayAwaitingReceivedItemsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} palletLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryPutAwayReceivedItemsByPalletGet(palletLabel: string, dqb?: string, options?: any): AxiosPromise<PutAwayReceivedPalletItemsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InventoryItemsQueryPutAwayReceivedItemsByPalletGet(palletLabel, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} toteLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryPutAwayReceivedItemsByToteGet(toteLabel: string, dqb?: string, options?: any): AxiosPromise<PutAwayReceivedItemsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InventoryItemsQueryPutAwayReceivedItemsByToteGet(toteLabel, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryPutAwayReceivedItemsGet(dqb?: string, options?: any): AxiosPromise<PutAwayReceivedItemsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InventoryItemsQueryPutAwayReceivedItemsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryStockItemsGet(dqb?: string, options?: any): AxiosPromise<StockItemQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1InventoryItemsQueryStockItemsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1InventoryItemsQueryStockStatusCountsGet(options?: any): AxiosPromise<QueryStockStatusCountsOutputDTO> {
            return localVarFp.apiV1InventoryItemsQueryStockStatusCountsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkDeleteContainerInventoryItemsCommand} [bulkDeleteContainerInventoryItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1InventoryItemsBulkDeletePost(bulkDeleteContainerInventoryItemsCommand?: BulkDeleteContainerInventoryItemsCommand, options?: any): AxiosPromise<BulkDeleteInventoryItemsOutputDTO> {
            return localVarFp.supportV1InventoryItemsBulkDeletePost(bulkDeleteContainerInventoryItemsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteProductFromContainerCommand} [deleteProductFromContainerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1InventoryItemsDeleteProductPost(deleteProductFromContainerCommand?: DeleteProductFromContainerCommand, options?: any): AxiosPromise<DeleteProductFromContainerOutputDTO> {
            return localVarFp.supportV1InventoryItemsDeleteProductPost(deleteProductFromContainerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FixGhostAllocationsCommand} [fixGhostAllocationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1InventoryItemsFixGhostAllocationsPost(fixGhostAllocationsCommand?: FixGhostAllocationsCommand, options?: any): AxiosPromise<FixGhostAllocationsOutputDTO> {
            return localVarFp.supportV1InventoryItemsFixGhostAllocationsPost(fixGhostAllocationsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateInventoryItemLotNumberCommand} [updateInventoryItemLotNumberCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1InventoryItemsUpdateLotNumberPost(updateInventoryItemLotNumberCommand?: UpdateInventoryItemLotNumberCommand, options?: any): AxiosPromise<UpdateInventoryItemLotNumberOutputDTO> {
            return localVarFp.supportV1InventoryItemsUpdateLotNumberPost(updateInventoryItemLotNumberCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryItemsApi - object-oriented interface
 * @export
 * @class InventoryItemsApi
 * @extends {BaseAPI}
 */
export class InventoryItemsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsGetInventoryItemExpirationDateTrackingCountsGet(options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsGetInventoryItemExpirationDateTrackingCountsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsGetInventoryItemSerialNumberTrackingCountsGet(options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsGetInventoryItemSerialNumberTrackingCountsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cargoPackageLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsGetInventoryItemsByCargoPackageLabelGet(cargoPackageLabel?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsGetInventoryItemsByCargoPackageLabelGet(cargoPackageLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsGetInventoryItemsByToteLabelGet(toteLabel?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsGetInventoryItemsByToteLabelGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsGetInventoryItemsCountGet(dqb?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsGetInventoryItemsCountGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsGetOutOfStockItemsCountGet(dqb?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsGetOutOfStockItemsCountGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsGetStockItemsCountGet(dqb?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsGetStockItemsCountGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} containerLabel 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsQueryByContainerLabelGet(containerLabel: string, dqb?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsQueryByContainerLabelGet(containerLabel, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsQueryByZoneGet(dqb?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsQueryByZoneGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsQueryGet(dqb?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsQueryInventoryItemExpirationDateTrackingsGet(dqb?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsQueryInventoryItemExpirationDateTrackingsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsQueryInventoryItemSerialNumberTrackingsGet(dqb?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsQueryInventoryItemSerialNumberTrackingsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsQueryInventoryItemsByProductWithSerialNumberGet(productId: string, dqb?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsQueryInventoryItemsByProductWithSerialNumberGet(productId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsQueryLostItemLogRecordsGet(dqb?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsQueryLostItemLogRecordsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsQueryOutOfStockItemsGet(dqb?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsQueryOutOfStockItemsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsQueryPutAwayAwaitingReceivedItemsGet(dqb?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsQueryPutAwayAwaitingReceivedItemsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} palletLabel 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsQueryPutAwayReceivedItemsByPalletGet(palletLabel: string, dqb?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsQueryPutAwayReceivedItemsByPalletGet(palletLabel, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} toteLabel 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsQueryPutAwayReceivedItemsByToteGet(toteLabel: string, dqb?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsQueryPutAwayReceivedItemsByToteGet(toteLabel, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsQueryPutAwayReceivedItemsGet(dqb?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsQueryPutAwayReceivedItemsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsQueryStockItemsGet(dqb?: string, options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsQueryStockItemsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public apiV1InventoryItemsQueryStockStatusCountsGet(options?: any) {
        return InventoryItemsApiFp(this.configuration).apiV1InventoryItemsQueryStockStatusCountsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkDeleteContainerInventoryItemsCommand} [bulkDeleteContainerInventoryItemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public supportV1InventoryItemsBulkDeletePost(bulkDeleteContainerInventoryItemsCommand?: BulkDeleteContainerInventoryItemsCommand, options?: any) {
        return InventoryItemsApiFp(this.configuration).supportV1InventoryItemsBulkDeletePost(bulkDeleteContainerInventoryItemsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteProductFromContainerCommand} [deleteProductFromContainerCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public supportV1InventoryItemsDeleteProductPost(deleteProductFromContainerCommand?: DeleteProductFromContainerCommand, options?: any) {
        return InventoryItemsApiFp(this.configuration).supportV1InventoryItemsDeleteProductPost(deleteProductFromContainerCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FixGhostAllocationsCommand} [fixGhostAllocationsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public supportV1InventoryItemsFixGhostAllocationsPost(fixGhostAllocationsCommand?: FixGhostAllocationsCommand, options?: any) {
        return InventoryItemsApiFp(this.configuration).supportV1InventoryItemsFixGhostAllocationsPost(fixGhostAllocationsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateInventoryItemLotNumberCommand} [updateInventoryItemLotNumberCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsApi
     */
    public supportV1InventoryItemsUpdateLotNumberPost(updateInventoryItemLotNumberCommand?: UpdateInventoryItemLotNumberCommand, options?: any) {
        return InventoryItemsApiFp(this.configuration).supportV1InventoryItemsUpdateLotNumberPost(updateInventoryItemLotNumberCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InventoryItemsODataApi - axios parameter creator
 * @export
 */
export const InventoryItemsODataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataV1InventoryItemsODataGet: async (authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('odataV1InventoryItemsODataGet', 'authorization', authorization)
            const localVarPath = `/odata/v1/InventoryItemsOData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryItemsODataApi - functional programming interface
 * @export
 */
export const InventoryItemsODataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryItemsODataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async odataV1InventoryItemsODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ODataResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.odataV1InventoryItemsODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InventoryItemsODataApi - factory interface
 * @export
 */
export const InventoryItemsODataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryItemsODataApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataV1InventoryItemsODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any): AxiosPromise<ODataResponseModel> {
            return localVarFp.odataV1InventoryItemsODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryItemsODataApi - object-oriented interface
 * @export
 * @class InventoryItemsODataApi
 * @extends {BaseAPI}
 */
export class InventoryItemsODataApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization The authorization token
     * @param {string} [$select] Get selected properties
     * @param {string} [$filter] Filter the results using OData syntax.
     * @param {string} [$expand] Get the entities that depend on the model
     * @param {string} [$orderby] Order the results using OData syntax
     * @param {string} [$skip] Skip the specified number of entries
     * @param {string} [$top] Get the top x number of records
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryItemsODataApi
     */
    public odataV1InventoryItemsODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any) {
        return InventoryItemsODataApiFp(this.configuration).odataV1InventoryItemsODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ItemsApi - axios parameter creator
 * @export
 */
export const ItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ItemCancelledRequest} [itemCancelledRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trendyolV1ItemsCancelledPost: async (itemCancelledRequest?: ItemCancelledRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/trendyol/v1/Items/cancelled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(itemCancelledRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ItemReceivedRequest} [itemReceivedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trendyolV1ItemsReceivedPost: async (itemReceivedRequest?: ItemReceivedRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/trendyol/v1/Items/received`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(itemReceivedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ItemsApi - functional programming interface
 * @export
 */
export const ItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ItemCancelledRequest} [itemCancelledRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trendyolV1ItemsCancelledPost(itemCancelledRequest?: ItemCancelledRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrendyolAck>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trendyolV1ItemsCancelledPost(itemCancelledRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ItemReceivedRequest} [itemReceivedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trendyolV1ItemsReceivedPost(itemReceivedRequest?: ItemReceivedRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrendyolAck>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trendyolV1ItemsReceivedPost(itemReceivedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ItemsApi - factory interface
 * @export
 */
export const ItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ItemsApiFp(configuration)
    return {
        /**
         * 
         * @param {ItemCancelledRequest} [itemCancelledRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trendyolV1ItemsCancelledPost(itemCancelledRequest?: ItemCancelledRequest, options?: any): AxiosPromise<TrendyolAck> {
            return localVarFp.trendyolV1ItemsCancelledPost(itemCancelledRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ItemReceivedRequest} [itemReceivedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trendyolV1ItemsReceivedPost(itemReceivedRequest?: ItemReceivedRequest, options?: any): AxiosPromise<TrendyolAck> {
            return localVarFp.trendyolV1ItemsReceivedPost(itemReceivedRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ItemsApi - object-oriented interface
 * @export
 * @class ItemsApi
 * @extends {BaseAPI}
 */
export class ItemsApi extends BaseAPI {
    /**
     * 
     * @param {ItemCancelledRequest} [itemCancelledRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemsApi
     */
    public trendyolV1ItemsCancelledPost(itemCancelledRequest?: ItemCancelledRequest, options?: any) {
        return ItemsApiFp(this.configuration).trendyolV1ItemsCancelledPost(itemCancelledRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ItemReceivedRequest} [itemReceivedRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemsApi
     */
    public trendyolV1ItemsReceivedPost(itemReceivedRequest?: ItemReceivedRequest, options?: any) {
        return ItemsApiFp(this.configuration).trendyolV1ItemsReceivedPost(itemReceivedRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ManualPicklistsApi - axios parameter creator
 * @export
 */
export const ManualPicklistsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateManualPicklistRequestCommand} [createManualPicklistRequestCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ManualPicklistsCreateManualPicklistRequestPost: async (createManualPicklistRequestCommand?: CreateManualPicklistRequestCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ManualPicklists.createManualPicklistRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManualPicklistRequestCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PreviewManualPicklistRequestCommand} [previewManualPicklistRequestCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ManualPicklistsPreviewManualPicklistRequestPost: async (previewManualPicklistRequestCommand?: PreviewManualPicklistRequestCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ManualPicklists.previewManualPicklistRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewManualPicklistRequestCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ManualPicklistsQueryCargoCarrierNamesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ManualPicklists.queryCargoCarrierNames`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} excludeSkus 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ManualPicklistsQueryWaitingForPickingSalesOrdersGet: async (excludeSkus: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'excludeSkus' is not null or undefined
            assertParamExists('apiV1ManualPicklistsQueryWaitingForPickingSalesOrdersGet', 'excludeSkus', excludeSkus)
            const localVarPath = `/api/v1/ManualPicklists.queryWaitingForPickingSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (excludeSkus !== undefined) {
                localVarQueryParameter['excludeSkus'] = excludeSkus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManualPicklistsApi - functional programming interface
 * @export
 */
export const ManualPicklistsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ManualPicklistsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateManualPicklistRequestCommand} [createManualPicklistRequestCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ManualPicklistsCreateManualPicklistRequestPost(createManualPicklistRequestCommand?: CreateManualPicklistRequestCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnassignedAlreadyStagedSalesOrdersOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ManualPicklistsCreateManualPicklistRequestPost(createManualPicklistRequestCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PreviewManualPicklistRequestCommand} [previewManualPicklistRequestCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ManualPicklistsPreviewManualPicklistRequestPost(previewManualPicklistRequestCommand?: PreviewManualPicklistRequestCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewManualPicklistRequestOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ManualPicklistsPreviewManualPicklistRequestPost(previewManualPicklistRequestCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ManualPicklistsQueryCargoCarrierNamesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ManualPicklistsQueryCargoCarrierNamesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} excludeSkus 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ManualPicklistsQueryWaitingForPickingSalesOrdersGet(excludeSkus: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManualPicklistWaitingForPickingSalesOrdersOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ManualPicklistsQueryWaitingForPickingSalesOrdersGet(excludeSkus, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ManualPicklistsApi - factory interface
 * @export
 */
export const ManualPicklistsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ManualPicklistsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateManualPicklistRequestCommand} [createManualPicklistRequestCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ManualPicklistsCreateManualPicklistRequestPost(createManualPicklistRequestCommand?: CreateManualPicklistRequestCommand, options?: any): AxiosPromise<UnassignedAlreadyStagedSalesOrdersOutputDTO> {
            return localVarFp.apiV1ManualPicklistsCreateManualPicklistRequestPost(createManualPicklistRequestCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PreviewManualPicklistRequestCommand} [previewManualPicklistRequestCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ManualPicklistsPreviewManualPicklistRequestPost(previewManualPicklistRequestCommand?: PreviewManualPicklistRequestCommand, options?: any): AxiosPromise<PreviewManualPicklistRequestOutputDTO> {
            return localVarFp.apiV1ManualPicklistsPreviewManualPicklistRequestPost(previewManualPicklistRequestCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ManualPicklistsQueryCargoCarrierNamesGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiV1ManualPicklistsQueryCargoCarrierNamesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} excludeSkus 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ManualPicklistsQueryWaitingForPickingSalesOrdersGet(excludeSkus: string, dqb?: string, options?: any): AxiosPromise<ManualPicklistWaitingForPickingSalesOrdersOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ManualPicklistsQueryWaitingForPickingSalesOrdersGet(excludeSkus, dqb, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ManualPicklistsApi - object-oriented interface
 * @export
 * @class ManualPicklistsApi
 * @extends {BaseAPI}
 */
export class ManualPicklistsApi extends BaseAPI {
    /**
     * 
     * @param {CreateManualPicklistRequestCommand} [createManualPicklistRequestCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualPicklistsApi
     */
    public apiV1ManualPicklistsCreateManualPicklistRequestPost(createManualPicklistRequestCommand?: CreateManualPicklistRequestCommand, options?: any) {
        return ManualPicklistsApiFp(this.configuration).apiV1ManualPicklistsCreateManualPicklistRequestPost(createManualPicklistRequestCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PreviewManualPicklistRequestCommand} [previewManualPicklistRequestCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualPicklistsApi
     */
    public apiV1ManualPicklistsPreviewManualPicklistRequestPost(previewManualPicklistRequestCommand?: PreviewManualPicklistRequestCommand, options?: any) {
        return ManualPicklistsApiFp(this.configuration).apiV1ManualPicklistsPreviewManualPicklistRequestPost(previewManualPicklistRequestCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualPicklistsApi
     */
    public apiV1ManualPicklistsQueryCargoCarrierNamesGet(options?: any) {
        return ManualPicklistsApiFp(this.configuration).apiV1ManualPicklistsQueryCargoCarrierNamesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} excludeSkus 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualPicklistsApi
     */
    public apiV1ManualPicklistsQueryWaitingForPickingSalesOrdersGet(excludeSkus: string, dqb?: string, options?: any) {
        return ManualPicklistsApiFp(this.configuration).apiV1ManualPicklistsQueryWaitingForPickingSalesOrdersGet(excludeSkus, dqb, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MasterCartonsApi - axios parameter creator
 * @export
 */
export const MasterCartonsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [masterCartonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterCartonsGetMasterCartonDetailsGet: async (masterCartonId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MasterCartons.getMasterCartonDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (masterCartonId !== undefined) {
                localVarQueryParameter['masterCartonId'] = masterCartonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterCartonsQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MasterCartons.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkCreateMasterCartonCommand} [bulkCreateMasterCartonCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1MasterCartonsBulkCreatePost: async (bulkCreateMasterCartonCommand?: BulkCreateMasterCartonCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/MasterCartons/bulkCreate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateMasterCartonCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkUpdateMasterCartonCommand} [bulkUpdateMasterCartonCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1MasterCartonsBulkUpdatePost: async (bulkUpdateMasterCartonCommand?: BulkUpdateMasterCartonCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/MasterCartons/bulkUpdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateMasterCartonCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertMasterCartonProductCommand} [upsertMasterCartonProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1MasterCartonsUpsertMasterCartonProductPost: async (upsertMasterCartonProductCommand?: UpsertMasterCartonProductCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/MasterCartons/upsertMasterCartonProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertMasterCartonProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterCartonsApi - functional programming interface
 * @export
 */
export const MasterCartonsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterCartonsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [masterCartonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MasterCartonsGetMasterCartonDetailsGet(masterCartonId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMasterCartonDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MasterCartonsGetMasterCartonDetailsGet(masterCartonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MasterCartonsQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterCartonQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MasterCartonsQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkCreateMasterCartonCommand} [bulkCreateMasterCartonCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1MasterCartonsBulkCreatePost(bulkCreateMasterCartonCommand?: BulkCreateMasterCartonCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkCreateMasterCartonCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1MasterCartonsBulkCreatePost(bulkCreateMasterCartonCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkUpdateMasterCartonCommand} [bulkUpdateMasterCartonCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1MasterCartonsBulkUpdatePost(bulkUpdateMasterCartonCommand?: BulkUpdateMasterCartonCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkCreateMasterCartonCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1MasterCartonsBulkUpdatePost(bulkUpdateMasterCartonCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpsertMasterCartonProductCommand} [upsertMasterCartonProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1MasterCartonsUpsertMasterCartonProductPost(upsertMasterCartonProductCommand?: UpsertMasterCartonProductCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertMasterCartonProductOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1MasterCartonsUpsertMasterCartonProductPost(upsertMasterCartonProductCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MasterCartonsApi - factory interface
 * @export
 */
export const MasterCartonsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterCartonsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [masterCartonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterCartonsGetMasterCartonDetailsGet(masterCartonId?: string, options?: any): AxiosPromise<GetMasterCartonDetailsOutputDTO> {
            return localVarFp.apiV1MasterCartonsGetMasterCartonDetailsGet(masterCartonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterCartonsQueryGet(dqb?: string, options?: any): AxiosPromise<MasterCartonQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1MasterCartonsQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkCreateMasterCartonCommand} [bulkCreateMasterCartonCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1MasterCartonsBulkCreatePost(bulkCreateMasterCartonCommand?: BulkCreateMasterCartonCommand, options?: any): AxiosPromise<BulkCreateMasterCartonCommandOutputDTO> {
            return localVarFp.openapiV1MasterCartonsBulkCreatePost(bulkCreateMasterCartonCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkUpdateMasterCartonCommand} [bulkUpdateMasterCartonCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1MasterCartonsBulkUpdatePost(bulkUpdateMasterCartonCommand?: BulkUpdateMasterCartonCommand, options?: any): AxiosPromise<BulkCreateMasterCartonCommandOutputDTO> {
            return localVarFp.openapiV1MasterCartonsBulkUpdatePost(bulkUpdateMasterCartonCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertMasterCartonProductCommand} [upsertMasterCartonProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1MasterCartonsUpsertMasterCartonProductPost(upsertMasterCartonProductCommand?: UpsertMasterCartonProductCommand, options?: any): AxiosPromise<UpsertMasterCartonProductOutputDTO> {
            return localVarFp.openapiV1MasterCartonsUpsertMasterCartonProductPost(upsertMasterCartonProductCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterCartonsApi - object-oriented interface
 * @export
 * @class MasterCartonsApi
 * @extends {BaseAPI}
 */
export class MasterCartonsApi extends BaseAPI {
    /**
     * 
     * @param {string} [masterCartonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterCartonsApi
     */
    public apiV1MasterCartonsGetMasterCartonDetailsGet(masterCartonId?: string, options?: any) {
        return MasterCartonsApiFp(this.configuration).apiV1MasterCartonsGetMasterCartonDetailsGet(masterCartonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterCartonsApi
     */
    public apiV1MasterCartonsQueryGet(dqb?: string, options?: any) {
        return MasterCartonsApiFp(this.configuration).apiV1MasterCartonsQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkCreateMasterCartonCommand} [bulkCreateMasterCartonCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterCartonsApi
     */
    public openapiV1MasterCartonsBulkCreatePost(bulkCreateMasterCartonCommand?: BulkCreateMasterCartonCommand, options?: any) {
        return MasterCartonsApiFp(this.configuration).openapiV1MasterCartonsBulkCreatePost(bulkCreateMasterCartonCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkUpdateMasterCartonCommand} [bulkUpdateMasterCartonCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterCartonsApi
     */
    public openapiV1MasterCartonsBulkUpdatePost(bulkUpdateMasterCartonCommand?: BulkUpdateMasterCartonCommand, options?: any) {
        return MasterCartonsApiFp(this.configuration).openapiV1MasterCartonsBulkUpdatePost(bulkUpdateMasterCartonCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertMasterCartonProductCommand} [upsertMasterCartonProductCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterCartonsApi
     */
    public openapiV1MasterCartonsUpsertMasterCartonProductPost(upsertMasterCartonProductCommand?: UpsertMasterCartonProductCommand, options?: any) {
        return MasterCartonsApiFp(this.configuration).openapiV1MasterCartonsUpsertMasterCartonProductPost(upsertMasterCartonProductCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MetadataApi - axios parameter creator
 * @export
 */
export const MetadataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odata: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/odata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataMetadata: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/odata/$metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetadataApi - functional programming interface
 * @export
 */
export const MetadataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetadataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async odata(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ODataServiceDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.odata(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async odataMetadata(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IEdmModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.odataMetadata(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MetadataApi - factory interface
 * @export
 */
export const MetadataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetadataApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odata(options?: any): AxiosPromise<ODataServiceDocument> {
            return localVarFp.odata(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataMetadata(options?: any): AxiosPromise<IEdmModel> {
            return localVarFp.odataMetadata(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetadataApi - object-oriented interface
 * @export
 * @class MetadataApi
 * @extends {BaseAPI}
 */
export class MetadataApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataApi
     */
    public odata(options?: any) {
        return MetadataApiFp(this.configuration).odata(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataApi
     */
    public odataMetadata(options?: any) {
        return MetadataApiFp(this.configuration).odataMetadata(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MissingItemTransferProcessesApi - axios parameter creator
 * @export
 */
export const MissingItemTransferProcessesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CancelledMissingItemTransferProcessCommand} [cancelledMissingItemTransferProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesCancelledMissingItemTransferProcessPost: async (cancelledMissingItemTransferProcessCommand?: CancelledMissingItemTransferProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.cancelledMissingItemTransferProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelledMissingItemTransferProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesCheckBarcodeForProblematicTotesGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.checkBarcodeForProblematicTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesCheckBarcodeTypeGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.checkBarcodeType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckProductExistsInToteForTransferCommand} [checkProductExistsInToteForTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesCheckProductPost: async (checkProductExistsInToteForTransferCommand?: CheckProductExistsInToteForTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.checkProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkProductExistsInToteForTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {string} [quarantineToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesCheckQuarantineToteAvailablityForPutIntoCancelledOrderPost: async (salesOrderId?: string, quarantineToteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.checkQuarantineToteAvailablityForPutIntoCancelledOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }

            if (quarantineToteLabel !== undefined) {
                localVarQueryParameter['quarantineToteLabel'] = quarantineToteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompletedMissingItemTransferProcessCommand} [completedMissingItemTransferProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesCompletedMissingItemTransferProcessPost: async (completedMissingItemTransferProcessCommand?: CompletedMissingItemTransferProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.completedMissingItemTransferProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completedMissingItemTransferProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompletedWithLostItemMissingItemTransferProcessCommand} [completedWithLostItemMissingItemTransferProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesCompletedWithLostItemMissingItemTransferProcessPost: async (completedWithLostItemMissingItemTransferProcessCommand?: CompletedWithLostItemMissingItemTransferProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.completedWithLostItemMissingItemTransferProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completedWithLostItemMissingItemTransferProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateMissingItemTransferProcessIfNotExistsCommand} [createMissingItemTransferProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesCreateMissingItemTransferProcessIfNotExistsPost: async (createMissingItemTransferProcessIfNotExistsCommand?: CreateMissingItemTransferProcessIfNotExistsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.createMissingItemTransferProcessIfNotExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMissingItemTransferProcessIfNotExistsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesGetAwaitingRestowTotesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.getAwaitingRestowTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesGetPackableTotesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.getPackableTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {string} [quarantineToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesGetQuarantineToteDetailsPost: async (salesOrderId?: string, quarantineToteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.getQuarantineToteDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }

            if (quarantineToteLabel !== undefined) {
                localVarQueryParameter['quarantineToteLabel'] = quarantineToteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sourceToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesGetQuarantineWallToteDetailsGet: async (sourceToteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.getQuarantineWallToteDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (sourceToteLabel !== undefined) {
                localVarQueryParameter['sourceToteLabel'] = sourceToteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesGetSalesOrderStateGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.getSalesOrderState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesGetWallInventoryViewGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.getWallInventoryView`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LostRemainingItemsOfQuarantineWallToteCommand} [lostRemainingItemsOfQuarantineWallToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesLostQuarantineWallToteRemainingItemsPost: async (lostRemainingItemsOfQuarantineWallToteCommand?: LostRemainingItemsOfQuarantineWallToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.lostQuarantineWallToteRemainingItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lostRemainingItemsOfQuarantineWallToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceProductToQuarantineWallCommand} [placeProductToQuarantineWallCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesPlaceProductToQuarantineWallPost: async (placeProductToQuarantineWallCommand?: PlaceProductToQuarantineWallCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.placeProductToQuarantineWall`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeProductToQuarantineWallCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesQueryWallInventoryItemsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.queryWallInventoryItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferAwaitingRestowItemsCommand} [transferAwaitingRestowItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesTransferAwaitingRestowItemsPost: async (transferAwaitingRestowItemsCommand?: TransferAwaitingRestowItemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.transferAwaitingRestowItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferAwaitingRestowItemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferPackableItemsCommand} [transferPackableItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesTransferPackableItemsPost: async (transferPackableItemsCommand?: TransferPackableItemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/MissingItemTransferProcesses.transferPackableItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferPackableItemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MissingItemTransferProcessesApi - functional programming interface
 * @export
 */
export const MissingItemTransferProcessesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MissingItemTransferProcessesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CancelledMissingItemTransferProcessCommand} [cancelledMissingItemTransferProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesCancelledMissingItemTransferProcessPost(cancelledMissingItemTransferProcessCommand?: CancelledMissingItemTransferProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MissingItemTransferProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesCancelledMissingItemTransferProcessPost(cancelledMissingItemTransferProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesCheckBarcodeForProblematicTotesGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProblematicTotesOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesCheckBarcodeForProblematicTotesGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesCheckBarcodeTypeGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckBarcodeTypeForTransferOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesCheckBarcodeTypeGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckProductExistsInToteForTransferCommand} [checkProductExistsInToteForTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesCheckProductPost(checkProductExistsInToteForTransferCommand?: CheckProductExistsInToteForTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProductExistInToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesCheckProductPost(checkProductExistsInToteForTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {string} [quarantineToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesCheckQuarantineToteAvailablityForPutIntoCancelledOrderPost(salesOrderId?: string, quarantineToteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToteDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesCheckQuarantineToteAvailablityForPutIntoCancelledOrderPost(salesOrderId, quarantineToteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompletedMissingItemTransferProcessCommand} [completedMissingItemTransferProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesCompletedMissingItemTransferProcessPost(completedMissingItemTransferProcessCommand?: CompletedMissingItemTransferProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MissingItemTransferProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesCompletedMissingItemTransferProcessPost(completedMissingItemTransferProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompletedWithLostItemMissingItemTransferProcessCommand} [completedWithLostItemMissingItemTransferProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesCompletedWithLostItemMissingItemTransferProcessPost(completedWithLostItemMissingItemTransferProcessCommand?: CompletedWithLostItemMissingItemTransferProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MissingItemTransferProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesCompletedWithLostItemMissingItemTransferProcessPost(completedWithLostItemMissingItemTransferProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateMissingItemTransferProcessIfNotExistsCommand} [createMissingItemTransferProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesCreateMissingItemTransferProcessIfNotExistsPost(createMissingItemTransferProcessIfNotExistsCommand?: CreateMissingItemTransferProcessIfNotExistsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateMissingItemTransferProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesCreateMissingItemTransferProcessIfNotExistsPost(createMissingItemTransferProcessIfNotExistsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesGetAwaitingRestowTotesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ZoneTotes>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesGetAwaitingRestowTotesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesGetPackableTotesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OperationTotes>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesGetPackableTotesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {string} [quarantineToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesGetQuarantineToteDetailsPost(salesOrderId?: string, quarantineToteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuarantineToteDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesGetQuarantineToteDetailsPost(salesOrderId, quarantineToteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [sourceToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesGetQuarantineWallToteDetailsGet(sourceToteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuarantineWallToteDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesGetQuarantineWallToteDetailsGet(sourceToteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesGetSalesOrderStateGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrderWithMissingItemStateOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesGetSalesOrderStateGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesGetWallInventoryViewGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallInventoryViewOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesGetWallInventoryViewGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LostRemainingItemsOfQuarantineWallToteCommand} [lostRemainingItemsOfQuarantineWallToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesLostQuarantineWallToteRemainingItemsPost(lostRemainingItemsOfQuarantineWallToteCommand?: LostRemainingItemsOfQuarantineWallToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesLostQuarantineWallToteRemainingItemsPost(lostRemainingItemsOfQuarantineWallToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceProductToQuarantineWallCommand} [placeProductToQuarantineWallCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesPlaceProductToQuarantineWallPost(placeProductToQuarantineWallCommand?: PlaceProductToQuarantineWallCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuarantineWallToteDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesPlaceProductToQuarantineWallPost(placeProductToQuarantineWallCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesQueryWallInventoryItemsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallInventoryItemOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesQueryWallInventoryItemsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferAwaitingRestowItemsCommand} [transferAwaitingRestowItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesTransferAwaitingRestowItemsPost(transferAwaitingRestowItemsCommand?: TransferAwaitingRestowItemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesTransferAwaitingRestowItemsPost(transferAwaitingRestowItemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferPackableItemsCommand} [transferPackableItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1MissingItemTransferProcessesTransferPackableItemsPost(transferPackableItemsCommand?: TransferPackableItemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1MissingItemTransferProcessesTransferPackableItemsPost(transferPackableItemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MissingItemTransferProcessesApi - factory interface
 * @export
 */
export const MissingItemTransferProcessesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MissingItemTransferProcessesApiFp(configuration)
    return {
        /**
         * 
         * @param {CancelledMissingItemTransferProcessCommand} [cancelledMissingItemTransferProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesCancelledMissingItemTransferProcessPost(cancelledMissingItemTransferProcessCommand?: CancelledMissingItemTransferProcessCommand, options?: any): AxiosPromise<MissingItemTransferProcessOutputDTO> {
            return localVarFp.apiV1MissingItemTransferProcessesCancelledMissingItemTransferProcessPost(cancelledMissingItemTransferProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesCheckBarcodeForProblematicTotesGet(barcode?: string, options?: any): AxiosPromise<CheckProblematicTotesOutputDTO> {
            return localVarFp.apiV1MissingItemTransferProcessesCheckBarcodeForProblematicTotesGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesCheckBarcodeTypeGet(barcode?: string, options?: any): AxiosPromise<CheckBarcodeTypeForTransferOutputDTO> {
            return localVarFp.apiV1MissingItemTransferProcessesCheckBarcodeTypeGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckProductExistsInToteForTransferCommand} [checkProductExistsInToteForTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesCheckProductPost(checkProductExistsInToteForTransferCommand?: CheckProductExistsInToteForTransferCommand, options?: any): AxiosPromise<CheckProductExistInToteOutputDTO> {
            return localVarFp.apiV1MissingItemTransferProcessesCheckProductPost(checkProductExistsInToteForTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {string} [quarantineToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesCheckQuarantineToteAvailablityForPutIntoCancelledOrderPost(salesOrderId?: string, quarantineToteLabel?: string, options?: any): AxiosPromise<ToteDetailsOutputDTO> {
            return localVarFp.apiV1MissingItemTransferProcessesCheckQuarantineToteAvailablityForPutIntoCancelledOrderPost(salesOrderId, quarantineToteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompletedMissingItemTransferProcessCommand} [completedMissingItemTransferProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesCompletedMissingItemTransferProcessPost(completedMissingItemTransferProcessCommand?: CompletedMissingItemTransferProcessCommand, options?: any): AxiosPromise<MissingItemTransferProcessOutputDTO> {
            return localVarFp.apiV1MissingItemTransferProcessesCompletedMissingItemTransferProcessPost(completedMissingItemTransferProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompletedWithLostItemMissingItemTransferProcessCommand} [completedWithLostItemMissingItemTransferProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesCompletedWithLostItemMissingItemTransferProcessPost(completedWithLostItemMissingItemTransferProcessCommand?: CompletedWithLostItemMissingItemTransferProcessCommand, options?: any): AxiosPromise<MissingItemTransferProcessOutputDTO> {
            return localVarFp.apiV1MissingItemTransferProcessesCompletedWithLostItemMissingItemTransferProcessPost(completedWithLostItemMissingItemTransferProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateMissingItemTransferProcessIfNotExistsCommand} [createMissingItemTransferProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesCreateMissingItemTransferProcessIfNotExistsPost(createMissingItemTransferProcessIfNotExistsCommand?: CreateMissingItemTransferProcessIfNotExistsCommand, options?: any): AxiosPromise<CreateMissingItemTransferProcessOutputDTO> {
            return localVarFp.apiV1MissingItemTransferProcessesCreateMissingItemTransferProcessIfNotExistsPost(createMissingItemTransferProcessIfNotExistsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesGetAwaitingRestowTotesGet(options?: any): AxiosPromise<Array<ZoneTotes>> {
            return localVarFp.apiV1MissingItemTransferProcessesGetAwaitingRestowTotesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesGetPackableTotesGet(options?: any): AxiosPromise<Array<OperationTotes>> {
            return localVarFp.apiV1MissingItemTransferProcessesGetPackableTotesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {string} [quarantineToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesGetQuarantineToteDetailsPost(salesOrderId?: string, quarantineToteLabel?: string, options?: any): AxiosPromise<QuarantineToteDetailsOutputDTO> {
            return localVarFp.apiV1MissingItemTransferProcessesGetQuarantineToteDetailsPost(salesOrderId, quarantineToteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [sourceToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesGetQuarantineWallToteDetailsGet(sourceToteLabel?: string, options?: any): AxiosPromise<QuarantineWallToteDetailsOutputDTO> {
            return localVarFp.apiV1MissingItemTransferProcessesGetQuarantineWallToteDetailsGet(sourceToteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesGetSalesOrderStateGet(toteLabel?: string, options?: any): AxiosPromise<SalesOrderWithMissingItemStateOutputDTO> {
            return localVarFp.apiV1MissingItemTransferProcessesGetSalesOrderStateGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesGetWallInventoryViewGet(options?: any): AxiosPromise<WallInventoryViewOutputDTO> {
            return localVarFp.apiV1MissingItemTransferProcessesGetWallInventoryViewGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LostRemainingItemsOfQuarantineWallToteCommand} [lostRemainingItemsOfQuarantineWallToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesLostQuarantineWallToteRemainingItemsPost(lostRemainingItemsOfQuarantineWallToteCommand?: LostRemainingItemsOfQuarantineWallToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1MissingItemTransferProcessesLostQuarantineWallToteRemainingItemsPost(lostRemainingItemsOfQuarantineWallToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceProductToQuarantineWallCommand} [placeProductToQuarantineWallCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesPlaceProductToQuarantineWallPost(placeProductToQuarantineWallCommand?: PlaceProductToQuarantineWallCommand, options?: any): AxiosPromise<QuarantineWallToteDetailsOutputDTO> {
            return localVarFp.apiV1MissingItemTransferProcessesPlaceProductToQuarantineWallPost(placeProductToQuarantineWallCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesQueryWallInventoryItemsGet(dqb?: string, options?: any): AxiosPromise<WallInventoryItemOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1MissingItemTransferProcessesQueryWallInventoryItemsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferAwaitingRestowItemsCommand} [transferAwaitingRestowItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesTransferAwaitingRestowItemsPost(transferAwaitingRestowItemsCommand?: TransferAwaitingRestowItemsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1MissingItemTransferProcessesTransferAwaitingRestowItemsPost(transferAwaitingRestowItemsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferPackableItemsCommand} [transferPackableItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MissingItemTransferProcessesTransferPackableItemsPost(transferPackableItemsCommand?: TransferPackableItemsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1MissingItemTransferProcessesTransferPackableItemsPost(transferPackableItemsCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MissingItemTransferProcessesApi - object-oriented interface
 * @export
 * @class MissingItemTransferProcessesApi
 * @extends {BaseAPI}
 */
export class MissingItemTransferProcessesApi extends BaseAPI {
    /**
     * 
     * @param {CancelledMissingItemTransferProcessCommand} [cancelledMissingItemTransferProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesCancelledMissingItemTransferProcessPost(cancelledMissingItemTransferProcessCommand?: CancelledMissingItemTransferProcessCommand, options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesCancelledMissingItemTransferProcessPost(cancelledMissingItemTransferProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesCheckBarcodeForProblematicTotesGet(barcode?: string, options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesCheckBarcodeForProblematicTotesGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesCheckBarcodeTypeGet(barcode?: string, options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesCheckBarcodeTypeGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckProductExistsInToteForTransferCommand} [checkProductExistsInToteForTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesCheckProductPost(checkProductExistsInToteForTransferCommand?: CheckProductExistsInToteForTransferCommand, options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesCheckProductPost(checkProductExistsInToteForTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {string} [quarantineToteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesCheckQuarantineToteAvailablityForPutIntoCancelledOrderPost(salesOrderId?: string, quarantineToteLabel?: string, options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesCheckQuarantineToteAvailablityForPutIntoCancelledOrderPost(salesOrderId, quarantineToteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompletedMissingItemTransferProcessCommand} [completedMissingItemTransferProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesCompletedMissingItemTransferProcessPost(completedMissingItemTransferProcessCommand?: CompletedMissingItemTransferProcessCommand, options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesCompletedMissingItemTransferProcessPost(completedMissingItemTransferProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompletedWithLostItemMissingItemTransferProcessCommand} [completedWithLostItemMissingItemTransferProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesCompletedWithLostItemMissingItemTransferProcessPost(completedWithLostItemMissingItemTransferProcessCommand?: CompletedWithLostItemMissingItemTransferProcessCommand, options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesCompletedWithLostItemMissingItemTransferProcessPost(completedWithLostItemMissingItemTransferProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateMissingItemTransferProcessIfNotExistsCommand} [createMissingItemTransferProcessIfNotExistsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesCreateMissingItemTransferProcessIfNotExistsPost(createMissingItemTransferProcessIfNotExistsCommand?: CreateMissingItemTransferProcessIfNotExistsCommand, options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesCreateMissingItemTransferProcessIfNotExistsPost(createMissingItemTransferProcessIfNotExistsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesGetAwaitingRestowTotesGet(options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesGetAwaitingRestowTotesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesGetPackableTotesGet(options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesGetPackableTotesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {string} [quarantineToteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesGetQuarantineToteDetailsPost(salesOrderId?: string, quarantineToteLabel?: string, options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesGetQuarantineToteDetailsPost(salesOrderId, quarantineToteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [sourceToteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesGetQuarantineWallToteDetailsGet(sourceToteLabel?: string, options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesGetQuarantineWallToteDetailsGet(sourceToteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesGetSalesOrderStateGet(toteLabel?: string, options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesGetSalesOrderStateGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesGetWallInventoryViewGet(options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesGetWallInventoryViewGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LostRemainingItemsOfQuarantineWallToteCommand} [lostRemainingItemsOfQuarantineWallToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesLostQuarantineWallToteRemainingItemsPost(lostRemainingItemsOfQuarantineWallToteCommand?: LostRemainingItemsOfQuarantineWallToteCommand, options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesLostQuarantineWallToteRemainingItemsPost(lostRemainingItemsOfQuarantineWallToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceProductToQuarantineWallCommand} [placeProductToQuarantineWallCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesPlaceProductToQuarantineWallPost(placeProductToQuarantineWallCommand?: PlaceProductToQuarantineWallCommand, options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesPlaceProductToQuarantineWallPost(placeProductToQuarantineWallCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesQueryWallInventoryItemsGet(dqb?: string, options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesQueryWallInventoryItemsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferAwaitingRestowItemsCommand} [transferAwaitingRestowItemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesTransferAwaitingRestowItemsPost(transferAwaitingRestowItemsCommand?: TransferAwaitingRestowItemsCommand, options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesTransferAwaitingRestowItemsPost(transferAwaitingRestowItemsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferPackableItemsCommand} [transferPackableItemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissingItemTransferProcessesApi
     */
    public apiV1MissingItemTransferProcessesTransferPackableItemsPost(transferPackableItemsCommand?: TransferPackableItemsCommand, options?: any) {
        return MissingItemTransferProcessesApiFp(this.configuration).apiV1MissingItemTransferProcessesTransferPackableItemsPost(transferPackableItemsCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NpsMatchApi - axios parameter creator
 * @export
 */
export const NpsMatchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SalesOrderNpsInputDTO} [salesOrderNpsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NpsMatchPost: async (salesOrderNpsInputDTO?: SalesOrderNpsInputDTO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/NpsMatch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(salesOrderNpsInputDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NpsMatchApi - functional programming interface
 * @export
 */
export const NpsMatchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NpsMatchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SalesOrderNpsInputDTO} [salesOrderNpsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1NpsMatchPost(salesOrderNpsInputDTO?: SalesOrderNpsInputDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NpsMatchPost(salesOrderNpsInputDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NpsMatchApi - factory interface
 * @export
 */
export const NpsMatchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NpsMatchApiFp(configuration)
    return {
        /**
         * 
         * @param {SalesOrderNpsInputDTO} [salesOrderNpsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1NpsMatchPost(salesOrderNpsInputDTO?: SalesOrderNpsInputDTO, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1NpsMatchPost(salesOrderNpsInputDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NpsMatchApi - object-oriented interface
 * @export
 * @class NpsMatchApi
 * @extends {BaseAPI}
 */
export class NpsMatchApi extends BaseAPI {
    /**
     * 
     * @param {SalesOrderNpsInputDTO} [salesOrderNpsInputDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NpsMatchApi
     */
    public apiV1NpsMatchPost(salesOrderNpsInputDTO?: SalesOrderNpsInputDTO, options?: any) {
        return NpsMatchApiFp(this.configuration).apiV1NpsMatchPost(salesOrderNpsInputDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OpenAPIIntegrationsApi - axios parameter creator
 * @export
 */
export const OpenAPIIntegrationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateOpenAPIIntegrationCommand} [createOpenAPIIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OpenAPIIntegrationsCreatePost: async (createOpenAPIIntegrationCommand?: CreateOpenAPIIntegrationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/OpenAPIIntegrations.create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOpenAPIIntegrationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [integrationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OpenAPIIntegrationsGetGet: async (integrationId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/OpenAPIIntegrations.get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (integrationId !== undefined) {
                localVarQueryParameter['integrationId'] = integrationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateOpenAPIIntegrationCommand} [updateOpenAPIIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OpenAPIIntegrationsUpdatePut: async (updateOpenAPIIntegrationCommand?: UpdateOpenAPIIntegrationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/OpenAPIIntegrations.update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOpenAPIIntegrationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OpenAPIIntegrationsApi - functional programming interface
 * @export
 */
export const OpenAPIIntegrationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OpenAPIIntegrationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateOpenAPIIntegrationCommand} [createOpenAPIIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OpenAPIIntegrationsCreatePost(createOpenAPIIntegrationCommand?: CreateOpenAPIIntegrationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOpenAPIIntegrationOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OpenAPIIntegrationsCreatePost(createOpenAPIIntegrationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [integrationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OpenAPIIntegrationsGetGet(integrationId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenAPIIntegrationOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OpenAPIIntegrationsGetGet(integrationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateOpenAPIIntegrationCommand} [updateOpenAPIIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OpenAPIIntegrationsUpdatePut(updateOpenAPIIntegrationCommand?: UpdateOpenAPIIntegrationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOpenAPIIntegrationOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OpenAPIIntegrationsUpdatePut(updateOpenAPIIntegrationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OpenAPIIntegrationsApi - factory interface
 * @export
 */
export const OpenAPIIntegrationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OpenAPIIntegrationsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateOpenAPIIntegrationCommand} [createOpenAPIIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OpenAPIIntegrationsCreatePost(createOpenAPIIntegrationCommand?: CreateOpenAPIIntegrationCommand, options?: any): AxiosPromise<CreateOpenAPIIntegrationOutputDTO> {
            return localVarFp.apiV1OpenAPIIntegrationsCreatePost(createOpenAPIIntegrationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [integrationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OpenAPIIntegrationsGetGet(integrationId?: string, options?: any): AxiosPromise<OpenAPIIntegrationOutputDTO> {
            return localVarFp.apiV1OpenAPIIntegrationsGetGet(integrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateOpenAPIIntegrationCommand} [updateOpenAPIIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OpenAPIIntegrationsUpdatePut(updateOpenAPIIntegrationCommand?: UpdateOpenAPIIntegrationCommand, options?: any): AxiosPromise<UpdateOpenAPIIntegrationOutputDTO> {
            return localVarFp.apiV1OpenAPIIntegrationsUpdatePut(updateOpenAPIIntegrationCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OpenAPIIntegrationsApi - object-oriented interface
 * @export
 * @class OpenAPIIntegrationsApi
 * @extends {BaseAPI}
 */
export class OpenAPIIntegrationsApi extends BaseAPI {
    /**
     * 
     * @param {CreateOpenAPIIntegrationCommand} [createOpenAPIIntegrationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAPIIntegrationsApi
     */
    public apiV1OpenAPIIntegrationsCreatePost(createOpenAPIIntegrationCommand?: CreateOpenAPIIntegrationCommand, options?: any) {
        return OpenAPIIntegrationsApiFp(this.configuration).apiV1OpenAPIIntegrationsCreatePost(createOpenAPIIntegrationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [integrationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAPIIntegrationsApi
     */
    public apiV1OpenAPIIntegrationsGetGet(integrationId?: string, options?: any) {
        return OpenAPIIntegrationsApiFp(this.configuration).apiV1OpenAPIIntegrationsGetGet(integrationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateOpenAPIIntegrationCommand} [updateOpenAPIIntegrationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAPIIntegrationsApi
     */
    public apiV1OpenAPIIntegrationsUpdatePut(updateOpenAPIIntegrationCommand?: UpdateOpenAPIIntegrationCommand, options?: any) {
        return OpenAPIIntegrationsApiFp(this.configuration).apiV1OpenAPIIntegrationsUpdatePut(updateOpenAPIIntegrationCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OperationsApi - axios parameter creator
 * @export
 */
export const OperationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddCarrierPreferenceCommand} [addCarrierPreferenceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsAddCarrierPreferencePost: async (addCarrierPreferenceCommand?: AddCarrierPreferenceCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.addCarrierPreference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCarrierPreferenceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateOperationCommand} [createOperationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsCreateOperationPost: async (createOperationCommand?: CreateOperationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.createOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOperationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteCarrierPreferenceCommand} [deleteCarrierPreferenceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsDeleteCarrierPreferenceDelete: async (deleteCarrierPreferenceCommand?: DeleteCarrierPreferenceCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.deleteCarrierPreference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteCarrierPreferenceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DisableCarrierCommand} [disableCarrierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsDisableCarrierPost: async (disableCarrierCommand?: DisableCarrierCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.disableCarrier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(disableCarrierCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnableCarrierCommand} [enableCarrierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsEnableCarrierPost: async (enableCarrierCommand?: EnableCarrierCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.enableCarrier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enableCarrierCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsGetCarrierPreferencesGet: async (operationId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.getCarrierPreferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (operationId !== undefined) {
                localVarQueryParameter['operationId'] = operationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsListByNameGet: async (operationName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.listByName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (operationName !== undefined) {
                localVarQueryParameter['operationName'] = operationName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsListCarriersGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.listCarriers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsListCustomersGet: async (operationId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.listCustomers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (operationId !== undefined) {
                localVarQueryParameter['operationId'] = operationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsListEnabledCarriersGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.listEnabledCarriers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsListGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OverwriteCarrierPreferencesCommand} [overwriteCarrierPreferencesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsOverwriteCarrierPreferencesPost: async (overwriteCarrierPreferencesCommand?: OverwriteCarrierPreferencesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.overwriteCarrierPreferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(overwriteCarrierPreferencesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateOperationB2CRoadRunnerInvoiceCustomerIdCommand} [updateOperationB2CRoadRunnerInvoiceCustomerIdCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUpdateB2CRoadRunnerInvoiceCustomerIdPost: async (updateOperationB2CRoadRunnerInvoiceCustomerIdCommand?: UpdateOperationB2CRoadRunnerInvoiceCustomerIdCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.updateB2CRoadRunnerInvoiceCustomerId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOperationB2CRoadRunnerInvoiceCustomerIdCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCarrierPreferencePriorityCommand} [updateCarrierPreferencePriorityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUpdateCarrierPreferencePriorityPut: async (updateCarrierPreferencePriorityCommand?: UpdateCarrierPreferencePriorityCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.updateCarrierPreferencePriority`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCarrierPreferencePriorityCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCarrierVolumetricWeightLimitCommand} [updateCarrierVolumetricWeightLimitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUpdateCarrierVolumetricWeightLimitPut: async (updateCarrierVolumetricWeightLimitCommand?: UpdateCarrierVolumetricWeightLimitCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.updateCarrierVolumetricWeightLimit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCarrierVolumetricWeightLimitCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateOperationCutOffTimesCommand} [updateOperationCutOffTimesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUpdateCutOffTimesPost: async (updateOperationCutOffTimesCommand?: UpdateOperationCutOffTimesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.updateCutOffTimes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOperationCutOffTimesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateOperationMultiItemVehicleVariationCommand} [updateOperationMultiItemVehicleVariationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUpdateMultiItemVehicleVariationPost: async (updateOperationMultiItemVehicleVariationCommand?: UpdateOperationMultiItemVehicleVariationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.updateMultiItemVehicleVariation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOperationMultiItemVehicleVariationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateOperationClusterCommand} [updateOperationClusterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUpdateOperationClusterPost: async (updateOperationClusterCommand?: UpdateOperationClusterCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.updateOperationCluster`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOperationClusterCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSingleItemFastPackThresholdCommand} [updateSingleItemFastPackThresholdCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUpdateSingleItemFastPackThresholdPost: async (updateSingleItemFastPackThresholdCommand?: UpdateSingleItemFastPackThresholdCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.updateSingleItemFastPackThreshold`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSingleItemFastPackThresholdCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUploadOperationImagePost: async (file?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.uploadOperationImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertCarrierPreferencesCommand} [upsertCarrierPreferencesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUpsertCarrierPreferencesPost: async (upsertCarrierPreferencesCommand?: UpsertCarrierPreferencesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Operations.upsertCarrierPreferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertCarrierPreferencesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OperationsApi - functional programming interface
 * @export
 */
export const OperationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OperationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddCarrierPreferenceCommand} [addCarrierPreferenceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsAddCarrierPreferencePost(addCarrierPreferenceCommand?: AddCarrierPreferenceCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsAddCarrierPreferencePost(addCarrierPreferenceCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateOperationCommand} [createOperationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsCreateOperationPost(createOperationCommand?: CreateOperationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOperationOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsCreateOperationPost(createOperationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteCarrierPreferenceCommand} [deleteCarrierPreferenceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsDeleteCarrierPreferenceDelete(deleteCarrierPreferenceCommand?: DeleteCarrierPreferenceCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsDeleteCarrierPreferenceDelete(deleteCarrierPreferenceCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DisableCarrierCommand} [disableCarrierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsDisableCarrierPost(disableCarrierCommand?: DisableCarrierCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsDisableCarrierPost(disableCarrierCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EnableCarrierCommand} [enableCarrierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsEnableCarrierPost(enableCarrierCommand?: EnableCarrierCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsEnableCarrierPost(enableCarrierCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsGetCarrierPreferencesGet(operationId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarrierPreferencesOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsGetCarrierPreferencesGet(operationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsListByNameGet(operationName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OperationOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsListByNameGet(operationName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsListCarriersGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCarriersOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsListCarriersGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsListCustomersGet(operationId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomerOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsListCustomersGet(operationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsListEnabledCarriersGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCarriersOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsListEnabledCarriersGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsListGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OperationOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsListGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {OverwriteCarrierPreferencesCommand} [overwriteCarrierPreferencesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsOverwriteCarrierPreferencesPost(overwriteCarrierPreferencesCommand?: OverwriteCarrierPreferencesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsOverwriteCarrierPreferencesPost(overwriteCarrierPreferencesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateOperationB2CRoadRunnerInvoiceCustomerIdCommand} [updateOperationB2CRoadRunnerInvoiceCustomerIdCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsUpdateB2CRoadRunnerInvoiceCustomerIdPost(updateOperationB2CRoadRunnerInvoiceCustomerIdCommand?: UpdateOperationB2CRoadRunnerInvoiceCustomerIdCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOperationB2CRoadRunnerInvoiceCustomerIdOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsUpdateB2CRoadRunnerInvoiceCustomerIdPost(updateOperationB2CRoadRunnerInvoiceCustomerIdCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateCarrierPreferencePriorityCommand} [updateCarrierPreferencePriorityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsUpdateCarrierPreferencePriorityPut(updateCarrierPreferencePriorityCommand?: UpdateCarrierPreferencePriorityCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsUpdateCarrierPreferencePriorityPut(updateCarrierPreferencePriorityCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateCarrierVolumetricWeightLimitCommand} [updateCarrierVolumetricWeightLimitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsUpdateCarrierVolumetricWeightLimitPut(updateCarrierVolumetricWeightLimitCommand?: UpdateCarrierVolumetricWeightLimitCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsUpdateCarrierVolumetricWeightLimitPut(updateCarrierVolumetricWeightLimitCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateOperationCutOffTimesCommand} [updateOperationCutOffTimesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsUpdateCutOffTimesPost(updateOperationCutOffTimesCommand?: UpdateOperationCutOffTimesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOperationCutOffTimesOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsUpdateCutOffTimesPost(updateOperationCutOffTimesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateOperationMultiItemVehicleVariationCommand} [updateOperationMultiItemVehicleVariationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsUpdateMultiItemVehicleVariationPost(updateOperationMultiItemVehicleVariationCommand?: UpdateOperationMultiItemVehicleVariationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOperationMultiItemVehicleVariationOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsUpdateMultiItemVehicleVariationPost(updateOperationMultiItemVehicleVariationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateOperationClusterCommand} [updateOperationClusterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsUpdateOperationClusterPost(updateOperationClusterCommand?: UpdateOperationClusterCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOperationClusterOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsUpdateOperationClusterPost(updateOperationClusterCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateSingleItemFastPackThresholdCommand} [updateSingleItemFastPackThresholdCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsUpdateSingleItemFastPackThresholdPost(updateSingleItemFastPackThresholdCommand?: UpdateSingleItemFastPackThresholdCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSingleItemFastPackThresholdOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsUpdateSingleItemFastPackThresholdPost(updateSingleItemFastPackThresholdCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsUploadOperationImagePost(file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadOperationImageOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsUploadOperationImagePost(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpsertCarrierPreferencesCommand} [upsertCarrierPreferencesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1OperationsUpsertCarrierPreferencesPost(upsertCarrierPreferencesCommand?: UpsertCarrierPreferencesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OperationsUpsertCarrierPreferencesPost(upsertCarrierPreferencesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OperationsApi - factory interface
 * @export
 */
export const OperationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OperationsApiFp(configuration)
    return {
        /**
         * 
         * @param {AddCarrierPreferenceCommand} [addCarrierPreferenceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsAddCarrierPreferencePost(addCarrierPreferenceCommand?: AddCarrierPreferenceCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1OperationsAddCarrierPreferencePost(addCarrierPreferenceCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateOperationCommand} [createOperationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsCreateOperationPost(createOperationCommand?: CreateOperationCommand, options?: any): AxiosPromise<CreateOperationOutputDTO> {
            return localVarFp.apiV1OperationsCreateOperationPost(createOperationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteCarrierPreferenceCommand} [deleteCarrierPreferenceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsDeleteCarrierPreferenceDelete(deleteCarrierPreferenceCommand?: DeleteCarrierPreferenceCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1OperationsDeleteCarrierPreferenceDelete(deleteCarrierPreferenceCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DisableCarrierCommand} [disableCarrierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsDisableCarrierPost(disableCarrierCommand?: DisableCarrierCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1OperationsDisableCarrierPost(disableCarrierCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnableCarrierCommand} [enableCarrierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsEnableCarrierPost(enableCarrierCommand?: EnableCarrierCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1OperationsEnableCarrierPost(enableCarrierCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsGetCarrierPreferencesGet(operationId?: string, options?: any): AxiosPromise<Array<CarrierPreferencesOutputDTO>> {
            return localVarFp.apiV1OperationsGetCarrierPreferencesGet(operationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsListByNameGet(operationName?: string, options?: any): AxiosPromise<Array<OperationOutputDTO>> {
            return localVarFp.apiV1OperationsListByNameGet(operationName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsListCarriersGet(options?: any): AxiosPromise<ListCarriersOutputDTO> {
            return localVarFp.apiV1OperationsListCarriersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsListCustomersGet(operationId?: string, options?: any): AxiosPromise<Array<CustomerOutputDTO>> {
            return localVarFp.apiV1OperationsListCustomersGet(operationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsListEnabledCarriersGet(options?: any): AxiosPromise<ListCarriersOutputDTO> {
            return localVarFp.apiV1OperationsListEnabledCarriersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsListGet(options?: any): AxiosPromise<Array<OperationOutputDTO>> {
            return localVarFp.apiV1OperationsListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OverwriteCarrierPreferencesCommand} [overwriteCarrierPreferencesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsOverwriteCarrierPreferencesPost(overwriteCarrierPreferencesCommand?: OverwriteCarrierPreferencesCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1OperationsOverwriteCarrierPreferencesPost(overwriteCarrierPreferencesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsQueryGet(dqb?: string, options?: any): AxiosPromise<OperationQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1OperationsQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateOperationB2CRoadRunnerInvoiceCustomerIdCommand} [updateOperationB2CRoadRunnerInvoiceCustomerIdCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUpdateB2CRoadRunnerInvoiceCustomerIdPost(updateOperationB2CRoadRunnerInvoiceCustomerIdCommand?: UpdateOperationB2CRoadRunnerInvoiceCustomerIdCommand, options?: any): AxiosPromise<UpdateOperationB2CRoadRunnerInvoiceCustomerIdOutputDTO> {
            return localVarFp.apiV1OperationsUpdateB2CRoadRunnerInvoiceCustomerIdPost(updateOperationB2CRoadRunnerInvoiceCustomerIdCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCarrierPreferencePriorityCommand} [updateCarrierPreferencePriorityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUpdateCarrierPreferencePriorityPut(updateCarrierPreferencePriorityCommand?: UpdateCarrierPreferencePriorityCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1OperationsUpdateCarrierPreferencePriorityPut(updateCarrierPreferencePriorityCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCarrierVolumetricWeightLimitCommand} [updateCarrierVolumetricWeightLimitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUpdateCarrierVolumetricWeightLimitPut(updateCarrierVolumetricWeightLimitCommand?: UpdateCarrierVolumetricWeightLimitCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1OperationsUpdateCarrierVolumetricWeightLimitPut(updateCarrierVolumetricWeightLimitCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateOperationCutOffTimesCommand} [updateOperationCutOffTimesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUpdateCutOffTimesPost(updateOperationCutOffTimesCommand?: UpdateOperationCutOffTimesCommand, options?: any): AxiosPromise<UpdateOperationCutOffTimesOutputDTO> {
            return localVarFp.apiV1OperationsUpdateCutOffTimesPost(updateOperationCutOffTimesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateOperationMultiItemVehicleVariationCommand} [updateOperationMultiItemVehicleVariationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUpdateMultiItemVehicleVariationPost(updateOperationMultiItemVehicleVariationCommand?: UpdateOperationMultiItemVehicleVariationCommand, options?: any): AxiosPromise<UpdateOperationMultiItemVehicleVariationOutputDTO> {
            return localVarFp.apiV1OperationsUpdateMultiItemVehicleVariationPost(updateOperationMultiItemVehicleVariationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateOperationClusterCommand} [updateOperationClusterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUpdateOperationClusterPost(updateOperationClusterCommand?: UpdateOperationClusterCommand, options?: any): AxiosPromise<UpdateOperationClusterOutputDTO> {
            return localVarFp.apiV1OperationsUpdateOperationClusterPost(updateOperationClusterCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateSingleItemFastPackThresholdCommand} [updateSingleItemFastPackThresholdCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUpdateSingleItemFastPackThresholdPost(updateSingleItemFastPackThresholdCommand?: UpdateSingleItemFastPackThresholdCommand, options?: any): AxiosPromise<UpdateSingleItemFastPackThresholdOutputDTO> {
            return localVarFp.apiV1OperationsUpdateSingleItemFastPackThresholdPost(updateSingleItemFastPackThresholdCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUploadOperationImagePost(file?: any, options?: any): AxiosPromise<UploadOperationImageOutputDTO> {
            return localVarFp.apiV1OperationsUploadOperationImagePost(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertCarrierPreferencesCommand} [upsertCarrierPreferencesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OperationsUpsertCarrierPreferencesPost(upsertCarrierPreferencesCommand?: UpsertCarrierPreferencesCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1OperationsUpsertCarrierPreferencesPost(upsertCarrierPreferencesCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OperationsApi - object-oriented interface
 * @export
 * @class OperationsApi
 * @extends {BaseAPI}
 */
export class OperationsApi extends BaseAPI {
    /**
     * 
     * @param {AddCarrierPreferenceCommand} [addCarrierPreferenceCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsAddCarrierPreferencePost(addCarrierPreferenceCommand?: AddCarrierPreferenceCommand, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsAddCarrierPreferencePost(addCarrierPreferenceCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateOperationCommand} [createOperationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsCreateOperationPost(createOperationCommand?: CreateOperationCommand, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsCreateOperationPost(createOperationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteCarrierPreferenceCommand} [deleteCarrierPreferenceCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsDeleteCarrierPreferenceDelete(deleteCarrierPreferenceCommand?: DeleteCarrierPreferenceCommand, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsDeleteCarrierPreferenceDelete(deleteCarrierPreferenceCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DisableCarrierCommand} [disableCarrierCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsDisableCarrierPost(disableCarrierCommand?: DisableCarrierCommand, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsDisableCarrierPost(disableCarrierCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnableCarrierCommand} [enableCarrierCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsEnableCarrierPost(enableCarrierCommand?: EnableCarrierCommand, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsEnableCarrierPost(enableCarrierCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [operationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsGetCarrierPreferencesGet(operationId?: string, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsGetCarrierPreferencesGet(operationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [operationName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsListByNameGet(operationName?: string, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsListByNameGet(operationName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsListCarriersGet(options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsListCarriersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [operationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsListCustomersGet(operationId?: string, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsListCustomersGet(operationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsListEnabledCarriersGet(options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsListEnabledCarriersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsListGet(options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OverwriteCarrierPreferencesCommand} [overwriteCarrierPreferencesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsOverwriteCarrierPreferencesPost(overwriteCarrierPreferencesCommand?: OverwriteCarrierPreferencesCommand, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsOverwriteCarrierPreferencesPost(overwriteCarrierPreferencesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsQueryGet(dqb?: string, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateOperationB2CRoadRunnerInvoiceCustomerIdCommand} [updateOperationB2CRoadRunnerInvoiceCustomerIdCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsUpdateB2CRoadRunnerInvoiceCustomerIdPost(updateOperationB2CRoadRunnerInvoiceCustomerIdCommand?: UpdateOperationB2CRoadRunnerInvoiceCustomerIdCommand, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsUpdateB2CRoadRunnerInvoiceCustomerIdPost(updateOperationB2CRoadRunnerInvoiceCustomerIdCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCarrierPreferencePriorityCommand} [updateCarrierPreferencePriorityCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsUpdateCarrierPreferencePriorityPut(updateCarrierPreferencePriorityCommand?: UpdateCarrierPreferencePriorityCommand, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsUpdateCarrierPreferencePriorityPut(updateCarrierPreferencePriorityCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCarrierVolumetricWeightLimitCommand} [updateCarrierVolumetricWeightLimitCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsUpdateCarrierVolumetricWeightLimitPut(updateCarrierVolumetricWeightLimitCommand?: UpdateCarrierVolumetricWeightLimitCommand, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsUpdateCarrierVolumetricWeightLimitPut(updateCarrierVolumetricWeightLimitCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateOperationCutOffTimesCommand} [updateOperationCutOffTimesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsUpdateCutOffTimesPost(updateOperationCutOffTimesCommand?: UpdateOperationCutOffTimesCommand, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsUpdateCutOffTimesPost(updateOperationCutOffTimesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateOperationMultiItemVehicleVariationCommand} [updateOperationMultiItemVehicleVariationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsUpdateMultiItemVehicleVariationPost(updateOperationMultiItemVehicleVariationCommand?: UpdateOperationMultiItemVehicleVariationCommand, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsUpdateMultiItemVehicleVariationPost(updateOperationMultiItemVehicleVariationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateOperationClusterCommand} [updateOperationClusterCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsUpdateOperationClusterPost(updateOperationClusterCommand?: UpdateOperationClusterCommand, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsUpdateOperationClusterPost(updateOperationClusterCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateSingleItemFastPackThresholdCommand} [updateSingleItemFastPackThresholdCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsUpdateSingleItemFastPackThresholdPost(updateSingleItemFastPackThresholdCommand?: UpdateSingleItemFastPackThresholdCommand, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsUpdateSingleItemFastPackThresholdPost(updateSingleItemFastPackThresholdCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsUploadOperationImagePost(file?: any, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsUploadOperationImagePost(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertCarrierPreferencesCommand} [upsertCarrierPreferencesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    public apiV1OperationsUpsertCarrierPreferencesPost(upsertCarrierPreferencesCommand?: UpsertCarrierPreferencesCommand, options?: any) {
        return OperationsApiFp(this.configuration).apiV1OperationsUpsertCarrierPreferencesPost(upsertCarrierPreferencesCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OperationsODataApi - axios parameter creator
 * @export
 */
export const OperationsODataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataV1OperationsODataGet: async (authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('odataV1OperationsODataGet', 'authorization', authorization)
            const localVarPath = `/odata/v1/OperationsOData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OperationsODataApi - functional programming interface
 * @export
 */
export const OperationsODataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OperationsODataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async odataV1OperationsODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ODataResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.odataV1OperationsODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OperationsODataApi - factory interface
 * @export
 */
export const OperationsODataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OperationsODataApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataV1OperationsODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any): AxiosPromise<ODataResponseModel> {
            return localVarFp.odataV1OperationsODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OperationsODataApi - object-oriented interface
 * @export
 * @class OperationsODataApi
 * @extends {BaseAPI}
 */
export class OperationsODataApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization The authorization token
     * @param {string} [$select] Get selected properties
     * @param {string} [$filter] Filter the results using OData syntax.
     * @param {string} [$expand] Get the entities that depend on the model
     * @param {string} [$orderby] Order the results using OData syntax
     * @param {string} [$skip] Skip the specified number of entries
     * @param {string} [$top] Get the top x number of records
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsODataApi
     */
    public odataV1OperationsODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any) {
        return OperationsODataApiFp(this.configuration).odataV1OperationsODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrdersApi - axios parameter creator
 * @export
 */
export const OrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ReadyToCollectRequest} [readyToCollectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trendyolV1OrdersReadyToCollectPost: async (readyToCollectRequest?: ReadyToCollectRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/trendyol/v1/Orders/ready-to-collect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(readyToCollectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrdersApi - functional programming interface
 * @export
 */
export const OrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ReadyToCollectRequest} [readyToCollectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trendyolV1OrdersReadyToCollectPost(readyToCollectRequest?: ReadyToCollectRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrendyolAck>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trendyolV1OrdersReadyToCollectPost(readyToCollectRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrdersApi - factory interface
 * @export
 */
export const OrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrdersApiFp(configuration)
    return {
        /**
         * 
         * @param {ReadyToCollectRequest} [readyToCollectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trendyolV1OrdersReadyToCollectPost(readyToCollectRequest?: ReadyToCollectRequest, options?: any): AxiosPromise<TrendyolAck> {
            return localVarFp.trendyolV1OrdersReadyToCollectPost(readyToCollectRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
export class OrdersApi extends BaseAPI {
    /**
     * 
     * @param {ReadyToCollectRequest} [readyToCollectRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public trendyolV1OrdersReadyToCollectPost(readyToCollectRequest?: ReadyToCollectRequest, options?: any) {
        return OrdersApiFp(this.configuration).trendyolV1OrdersReadyToCollectPost(readyToCollectRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PackingProcessesApi - axios parameter creator
 * @export
 */
export const PackingProcessesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddCargoPackageCommand} [addCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesAddCargoPackagePost: async (addCargoPackageCommand?: AddCargoPackageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.addCargoPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCargoPackageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AssignQuarantineToteCommand} [assignQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesAssignQuarantineTotePost: async (assignQuarantineToteCommand?: AssignQuarantineToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.assignQuarantineTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignQuarantineToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesCheckOperationCargoPackageTypeBarcodeGet: async (operationName?: string, barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.checkOperationCargoPackageTypeBarcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (operationName !== undefined) {
                localVarQueryParameter['operationName'] = operationName;
            }

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckSalesOrderSimpleSerialNumber} [checkSalesOrderSimpleSerialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesCheckSimpleSerialNumberPost: async (checkSalesOrderSimpleSerialNumber?: CheckSalesOrderSimpleSerialNumber, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.checkSimpleSerialNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkSalesOrderSimpleSerialNumber, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompletePackingProcessCommand} [completePackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesCompletePackingProcessPost: async (completePackingProcessCommand?: CompletePackingProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.completePackingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completePackingProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompletePackingQuarantineProcessCommand} [completePackingQuarantineProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesCompletePackingQuarantineProcessPost: async (completePackingQuarantineProcessCommand?: CompletePackingQuarantineProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.CompletePackingQuarantineProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completePackingQuarantineProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePackingProcessIfNotExistsCommand} [createPackingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesCreatePackingProcessIfNotExistsPost: async (createPackingProcessIfNotExistsCommand?: CreatePackingProcessIfNotExistsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.createPackingProcessIfNotExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPackingProcessIfNotExistsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePackingQuarantineProcessIfNotExistsCommand} [createPackingQuarantineProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesCreatePackingQuarantineProcessIfNotExistsPost: async (createPackingQuarantineProcessIfNotExistsCommand?: CreatePackingQuarantineProcessIfNotExistsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.createPackingQuarantineProcessIfNotExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPackingQuarantineProcessIfNotExistsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesGetSalesOrderStateGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.getSalesOrderState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesGetTotePackingTypeGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.getTotePackingType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceQuarantineToteToQuarantineAddressCommand} [placeQuarantineToteToQuarantineAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesPlaceQuarantineToteToQuarantineAddressPost: async (placeQuarantineToteToQuarantineAddressCommand?: PlaceQuarantineToteToQuarantineAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.placeQuarantineToteToQuarantineAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeQuarantineToteToQuarantineAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintAdditionalCargoPackageLabelsCommand} [printAdditionalCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesPrintAdditionalCargoPackageLabelsPost: async (printAdditionalCargoPackageLabelsCommand?: PrintAdditionalCargoPackageLabelsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.printAdditionalCargoPackageLabels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printAdditionalCargoPackageLabelsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintCargoPackageLabelsCommand} [printCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesPrintCargoPackageLabelsPost: async (printCargoPackageLabelsCommand?: PrintCargoPackageLabelsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.printCargoPackageLabels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printCargoPackageLabelsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintPalettePackingListCommand} [printPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesPrintPalettePackingListPost: async (printPalettePackingListCommand?: PrintPalettePackingListCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.printPalettePackingList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printPalettePackingListCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintSLAMDocumentsOnPackingCommand} [printSLAMDocumentsOnPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesPrintSLAMDocumentsPost: async (printSLAMDocumentsOnPackingCommand?: PrintSLAMDocumentsOnPackingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.printSLAMDocuments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printSLAMDocumentsOnPackingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintUnprintedPalettePackingListCommand} [printUnprintedPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesPrintUnprintedPalettePackingListPost: async (printUnprintedPalettePackingListCommand?: PrintUnprintedPalettePackingListCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.printUnprintedPalettePackingList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printUnprintedPalettePackingListCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintVASCommand} [printVASCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesPrintVASPost: async (printVASCommand?: PrintVASCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.printVAS`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printVASCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesQueryPickingTrolleysInPackingGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.queryPickingTrolleysInPacking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [packingAddressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesQueryTotesReadyToPackGet: async (packingAddressLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.queryTotesReadyToPack`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (packingAddressLabel !== undefined) {
                localVarQueryParameter['packingAddressLabel'] = packingAddressLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueueItemIntoCargoPackageCommand} [queueItemIntoCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesQueueItemIntoCargoPackagePost: async (queueItemIntoCargoPackageCommand?: QueueItemIntoCargoPackageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.queueItemIntoCargoPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queueItemIntoCargoPackageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueueItemIntoQuarantineToteCommand} [queueItemIntoQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesQueueItemIntoQuarantineTotePost: async (queueItemIntoQuarantineToteCommand?: QueueItemIntoQuarantineToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.queueItemIntoQuarantineTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queueItemIntoQuarantineToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RemoveCargoPackageCommand} [removeCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesUnsealCargoPackagePost: async (unsealCargoPackageCommand?: UnsealCargoPackageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.unsealCargoPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unsealCargoPackageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        apiV1PackingProcessesCloseCargoPackagePost: async (closeCargoPackageCommand?: CloseCargoPackageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.closeCargoPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)



            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(closeCargoPackageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RemoveCargoPackageCommand} [removeCargoPackageCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesRemoveCargoPackagePost: async (removeCargoPackageCommand?: RemoveCargoPackageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.removeCargoPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeCargoPackageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RemoveItemFromCargoPackageCommand} [removeItemFromCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesRemoveItemFromCargoPackagePost: async (removeItemFromCargoPackageCommand?: RemoveItemFromCargoPackageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.removeItemFromCargoPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeItemFromCargoPackageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RemovePackingProcessOfUnpackableToteCommand} [removePackingProcessOfUnpackableToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesRemovePackingProcessOfUnpackableTotePost: async (removePackingProcessOfUnpackableToteCommand?: RemovePackingProcessOfUnpackableToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.removePackingProcessOfUnpackableTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removePackingProcessOfUnpackableToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RemovePackingQuarantineProcessCommand} [removePackingQuarantineProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesRemoveQuarantineProcessPost: async (removePackingQuarantineProcessCommand?: RemovePackingQuarantineProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.removeQuarantineProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removePackingQuarantineProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReprintPalettePackingListCommand} [reprintPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesReprintPalettePackingListPost: async (reprintPalettePackingListCommand?: ReprintPalettePackingListCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.reprintPalettePackingList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reprintPalettePackingListCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnassignQuarantineToteCommand} [unassignQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesUnassignQuarantineTotePost: async (unassignQuarantineToteCommand?: UnassignQuarantineToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingProcesses.unassignQuarantineTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unassignQuarantineToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PackingProcessesApi - functional programming interface
 * @export
 */
export const PackingProcessesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PackingProcessesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddCargoPackageCommand} [addCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesAddCargoPackagePost(addCargoPackageCommand?: AddCargoPackageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddCargoPackageCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesAddCargoPackagePost(addCargoPackageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AssignQuarantineToteCommand} [assignQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesAssignQuarantineTotePost(assignQuarantineToteCommand?: AssignQuarantineToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesAssignQuarantineTotePost(assignQuarantineToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesCheckOperationCargoPackageTypeBarcodeGet(operationName?: string, barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CargoPackageTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesCheckOperationCargoPackageTypeBarcodeGet(operationName, barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckSalesOrderSimpleSerialNumber} [checkSalesOrderSimpleSerialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber?: CheckSalesOrderSimpleSerialNumber, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CargoPackageTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompletePackingProcessCommand} [completePackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesCompletePackingProcessPost(completePackingProcessCommand?: CompletePackingProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompletePackingProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesCompletePackingProcessPost(completePackingProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompletePackingQuarantineProcessCommand} [completePackingQuarantineProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesCompletePackingQuarantineProcessPost(completePackingQuarantineProcessCommand?: CompletePackingQuarantineProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesCompletePackingQuarantineProcessPost(completePackingQuarantineProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePackingProcessIfNotExistsCommand} [createPackingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesCreatePackingProcessIfNotExistsPost(createPackingProcessIfNotExistsCommand?: CreatePackingProcessIfNotExistsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePackingProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesCreatePackingProcessIfNotExistsPost(createPackingProcessIfNotExistsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePackingQuarantineProcessIfNotExistsCommand} [createPackingQuarantineProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesCreatePackingQuarantineProcessIfNotExistsPost(createPackingQuarantineProcessIfNotExistsCommand?: CreatePackingQuarantineProcessIfNotExistsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePackingQuarantineProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesCreatePackingQuarantineProcessIfNotExistsPost(createPackingQuarantineProcessIfNotExistsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesGetSalesOrderStateGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrderStateOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesGetSalesOrderStateGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesGetTotePackingTypeGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotePackingTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesGetTotePackingTypeGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceQuarantineToteToQuarantineAddressCommand} [placeQuarantineToteToQuarantineAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesPlaceQuarantineToteToQuarantineAddressPost(placeQuarantineToteToQuarantineAddressCommand?: PlaceQuarantineToteToQuarantineAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesPlaceQuarantineToteToQuarantineAddressPost(placeQuarantineToteToQuarantineAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintAdditionalCargoPackageLabelsCommand} [printAdditionalCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesPrintAdditionalCargoPackageLabelsPost(printAdditionalCargoPackageLabelsCommand?: PrintAdditionalCargoPackageLabelsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesPrintAdditionalCargoPackageLabelsPost(printAdditionalCargoPackageLabelsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintCargoPackageLabelsCommand} [printCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesPrintCargoPackageLabelsPost(printCargoPackageLabelsCommand?: PrintCargoPackageLabelsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesPrintCargoPackageLabelsPost(printCargoPackageLabelsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintPalettePackingListCommand} [printPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesPrintPalettePackingListPost(printPalettePackingListCommand?: PrintPalettePackingListCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesPrintPalettePackingListPost(printPalettePackingListCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintSLAMDocumentsOnPackingCommand} [printSLAMDocumentsOnPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesPrintSLAMDocumentsPost(printSLAMDocumentsOnPackingCommand?: PrintSLAMDocumentsOnPackingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrintSLAMDocumentsOnPackingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesPrintSLAMDocumentsPost(printSLAMDocumentsOnPackingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintUnprintedPalettePackingListCommand} [printUnprintedPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesPrintUnprintedPalettePackingListPost(printUnprintedPalettePackingListCommand?: PrintUnprintedPalettePackingListCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesPrintUnprintedPalettePackingListPost(printUnprintedPalettePackingListCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintVASCommand} [printVASCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesPrintVASPost(printVASCommand?: PrintVASCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesPrintVASPost(printVASCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesQueryPickingTrolleysInPackingGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickingTrolleysInPackingOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesQueryPickingTrolleysInPackingGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [packingAddressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesQueryTotesReadyToPackGet(packingAddressLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ToteReadyToPackDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesQueryTotesReadyToPackGet(packingAddressLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {QueueItemIntoCargoPackageCommand} [queueItemIntoCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesQueueItemIntoCargoPackagePost(queueItemIntoCargoPackageCommand?: QueueItemIntoCargoPackageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueueItemIntoCargoPackageOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesQueueItemIntoCargoPackagePost(queueItemIntoCargoPackageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {QueueItemIntoQuarantineToteCommand} [queueItemIntoQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesQueueItemIntoQuarantineTotePost(queueItemIntoQuarantineToteCommand?: QueueItemIntoQuarantineToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesQueueItemIntoQuarantineTotePost(queueItemIntoQuarantineToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RemoveCargoPackageCommand} [removeCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesUnsealCargoPackagePost(unsealCargoPackageCommand?: UnsealCargoPackageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnsealCargoPackageCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesUnsealCargoPackagePost(unsealCargoPackageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        async apiV1PackingProcessesCloseCargoPackagePost(closeCargoPackageCommand?: CloseCargoPackageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CloseCargoPackageCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesCloseCargoPackagePost(closeCargoPackageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {RemoveCargoPackageCommand} [removeCargoPackageCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesRemoveCargoPackagePost(removeCargoPackageCommand?: RemoveCargoPackageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoveCargoPackageCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesRemoveCargoPackagePost(removeCargoPackageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RemoveItemFromCargoPackageCommand} [removeItemFromCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesRemoveItemFromCargoPackagePost(removeItemFromCargoPackageCommand?: RemoveItemFromCargoPackageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesRemoveItemFromCargoPackagePost(removeItemFromCargoPackageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RemovePackingProcessOfUnpackableToteCommand} [removePackingProcessOfUnpackableToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesRemovePackingProcessOfUnpackableTotePost(removePackingProcessOfUnpackableToteCommand?: RemovePackingProcessOfUnpackableToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesRemovePackingProcessOfUnpackableTotePost(removePackingProcessOfUnpackableToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RemovePackingQuarantineProcessCommand} [removePackingQuarantineProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesRemoveQuarantineProcessPost(removePackingQuarantineProcessCommand?: RemovePackingQuarantineProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesRemoveQuarantineProcessPost(removePackingQuarantineProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReprintPalettePackingListCommand} [reprintPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesReprintPalettePackingListPost(reprintPalettePackingListCommand?: ReprintPalettePackingListCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesReprintPalettePackingListPost(reprintPalettePackingListCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UnassignQuarantineToteCommand} [unassignQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingProcessesUnassignQuarantineTotePost(unassignQuarantineToteCommand?: UnassignQuarantineToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingProcessesUnassignQuarantineTotePost(unassignQuarantineToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PackingProcessesApi - factory interface
 * @export
 */
export const PackingProcessesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PackingProcessesApiFp(configuration)
    return {
        /**
         * 
         * @param {AddCargoPackageCommand} [addCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesAddCargoPackagePost(addCargoPackageCommand?: AddCargoPackageCommand, options?: any): AxiosPromise<AddCargoPackageCommandOutputDTO> {
            return localVarFp.apiV1PackingProcessesAddCargoPackagePost(addCargoPackageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignQuarantineToteCommand} [assignQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesAssignQuarantineTotePost(assignQuarantineToteCommand?: AssignQuarantineToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingProcessesAssignQuarantineTotePost(assignQuarantineToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesCheckOperationCargoPackageTypeBarcodeGet(operationName?: string, barcode?: string, options?: any): AxiosPromise<CargoPackageTypeOutputDTO> {
            return localVarFp.apiV1PackingProcessesCheckOperationCargoPackageTypeBarcodeGet(operationName, barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckSalesOrderSimpleSerialNumber} [checkSalesOrderSimpleSerialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber?: CheckSalesOrderSimpleSerialNumber, options?: any): AxiosPromise<CargoPackageTypeOutputDTO> {
            return localVarFp.apiV1PackingProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompletePackingProcessCommand} [completePackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesCompletePackingProcessPost(completePackingProcessCommand?: CompletePackingProcessCommand, options?: any): AxiosPromise<CompletePackingProcessOutputDTO> {
            return localVarFp.apiV1PackingProcessesCompletePackingProcessPost(completePackingProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompletePackingQuarantineProcessCommand} [completePackingQuarantineProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesCompletePackingQuarantineProcessPost(completePackingQuarantineProcessCommand?: CompletePackingQuarantineProcessCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingProcessesCompletePackingQuarantineProcessPost(completePackingQuarantineProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePackingProcessIfNotExistsCommand} [createPackingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesCreatePackingProcessIfNotExistsPost(createPackingProcessIfNotExistsCommand?: CreatePackingProcessIfNotExistsCommand, options?: any): AxiosPromise<CreatePackingProcessOutputDTO> {
            return localVarFp.apiV1PackingProcessesCreatePackingProcessIfNotExistsPost(createPackingProcessIfNotExistsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePackingQuarantineProcessIfNotExistsCommand} [createPackingQuarantineProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesCreatePackingQuarantineProcessIfNotExistsPost(createPackingQuarantineProcessIfNotExistsCommand?: CreatePackingQuarantineProcessIfNotExistsCommand, options?: any): AxiosPromise<CreatePackingQuarantineProcessOutputDTO> {
            return localVarFp.apiV1PackingProcessesCreatePackingQuarantineProcessIfNotExistsPost(createPackingQuarantineProcessIfNotExistsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesGetSalesOrderStateGet(toteLabel?: string, options?: any): AxiosPromise<SalesOrderStateOutputDTO> {
            return localVarFp.apiV1PackingProcessesGetSalesOrderStateGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesGetTotePackingTypeGet(toteLabel?: string, options?: any): AxiosPromise<TotePackingTypeOutputDTO> {
            return localVarFp.apiV1PackingProcessesGetTotePackingTypeGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceQuarantineToteToQuarantineAddressCommand} [placeQuarantineToteToQuarantineAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesPlaceQuarantineToteToQuarantineAddressPost(placeQuarantineToteToQuarantineAddressCommand?: PlaceQuarantineToteToQuarantineAddressCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingProcessesPlaceQuarantineToteToQuarantineAddressPost(placeQuarantineToteToQuarantineAddressCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintAdditionalCargoPackageLabelsCommand} [printAdditionalCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesPrintAdditionalCargoPackageLabelsPost(printAdditionalCargoPackageLabelsCommand?: PrintAdditionalCargoPackageLabelsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingProcessesPrintAdditionalCargoPackageLabelsPost(printAdditionalCargoPackageLabelsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintCargoPackageLabelsCommand} [printCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesPrintCargoPackageLabelsPost(printCargoPackageLabelsCommand?: PrintCargoPackageLabelsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingProcessesPrintCargoPackageLabelsPost(printCargoPackageLabelsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintPalettePackingListCommand} [printPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesPrintPalettePackingListPost(printPalettePackingListCommand?: PrintPalettePackingListCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingProcessesPrintPalettePackingListPost(printPalettePackingListCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintSLAMDocumentsOnPackingCommand} [printSLAMDocumentsOnPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesPrintSLAMDocumentsPost(printSLAMDocumentsOnPackingCommand?: PrintSLAMDocumentsOnPackingCommand, options?: any): AxiosPromise<PrintSLAMDocumentsOnPackingOutputDTO> {
            return localVarFp.apiV1PackingProcessesPrintSLAMDocumentsPost(printSLAMDocumentsOnPackingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintUnprintedPalettePackingListCommand} [printUnprintedPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesPrintUnprintedPalettePackingListPost(printUnprintedPalettePackingListCommand?: PrintUnprintedPalettePackingListCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingProcessesPrintUnprintedPalettePackingListPost(printUnprintedPalettePackingListCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintVASCommand} [printVASCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesPrintVASPost(printVASCommand?: PrintVASCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingProcessesPrintVASPost(printVASCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesQueryPickingTrolleysInPackingGet(dqb?: string, options?: any): AxiosPromise<PickingTrolleysInPackingOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PackingProcessesQueryPickingTrolleysInPackingGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [packingAddressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesQueryTotesReadyToPackGet(packingAddressLabel?: string, options?: any): AxiosPromise<Array<ToteReadyToPackDTO>> {
            return localVarFp.apiV1PackingProcessesQueryTotesReadyToPackGet(packingAddressLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueueItemIntoCargoPackageCommand} [queueItemIntoCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesQueueItemIntoCargoPackagePost(queueItemIntoCargoPackageCommand?: QueueItemIntoCargoPackageCommand, options?: any): AxiosPromise<QueueItemIntoCargoPackageOutputDTO> {
            return localVarFp.apiV1PackingProcessesQueueItemIntoCargoPackagePost(queueItemIntoCargoPackageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueueItemIntoQuarantineToteCommand} [queueItemIntoQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesQueueItemIntoQuarantineTotePost(queueItemIntoQuarantineToteCommand?: QueueItemIntoQuarantineToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingProcessesQueueItemIntoQuarantineTotePost(queueItemIntoQuarantineToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RemoveCargoPackageCommand} [removeCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesUnsealCargoPackagePost(unsealCargoPackageCommand?: UnsealCargoPackageCommand, options?: any): AxiosPromise<UnsealCargoPackageCommandOutputDTO> {
            return localVarFp.apiV1PackingProcessesUnsealCargoPackagePost(unsealCargoPackageCommand, options).then((request) => request(axios, basePath));
        },
        apiV1PackingProcessesCloseCargoPackagePost(closeCargoPackageCommand?: CloseCargoPackageCommand, options?: any): AxiosPromise<CloseCargoPackageCommandOutputDTO> {
            return localVarFp.apiV1PackingProcessesCloseCargoPackagePost(closeCargoPackageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RemoveCargoPackageCommand} [removeCargoPackageCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesRemoveCargoPackagePost(removeCargoPackageCommand?: RemoveCargoPackageCommand, options?: any): AxiosPromise<RemoveCargoPackageCommandOutputDTO> {
            return localVarFp.apiV1PackingProcessesRemoveCargoPackagePost(removeCargoPackageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RemoveItemFromCargoPackageCommand} [removeItemFromCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesRemoveItemFromCargoPackagePost(removeItemFromCargoPackageCommand?: RemoveItemFromCargoPackageCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingProcessesRemoveItemFromCargoPackagePost(removeItemFromCargoPackageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RemovePackingProcessOfUnpackableToteCommand} [removePackingProcessOfUnpackableToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesRemovePackingProcessOfUnpackableTotePost(removePackingProcessOfUnpackableToteCommand?: RemovePackingProcessOfUnpackableToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingProcessesRemovePackingProcessOfUnpackableTotePost(removePackingProcessOfUnpackableToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RemovePackingQuarantineProcessCommand} [removePackingQuarantineProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesRemoveQuarantineProcessPost(removePackingQuarantineProcessCommand?: RemovePackingQuarantineProcessCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingProcessesRemoveQuarantineProcessPost(removePackingQuarantineProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReprintPalettePackingListCommand} [reprintPalettePackingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesReprintPalettePackingListPost(reprintPalettePackingListCommand?: ReprintPalettePackingListCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingProcessesReprintPalettePackingListPost(reprintPalettePackingListCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnassignQuarantineToteCommand} [unassignQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingProcessesUnassignQuarantineTotePost(unassignQuarantineToteCommand?: UnassignQuarantineToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingProcessesUnassignQuarantineTotePost(unassignQuarantineToteCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PackingProcessesApi - object-oriented interface
 * @export
 * @class PackingProcessesApi
 * @extends {BaseAPI}
 */
export class PackingProcessesApi extends BaseAPI {
    /**
     * 
     * @param {AddCargoPackageCommand} [addCargoPackageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesAddCargoPackagePost(addCargoPackageCommand?: AddCargoPackageCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesAddCargoPackagePost(addCargoPackageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignQuarantineToteCommand} [assignQuarantineToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesAssignQuarantineTotePost(assignQuarantineToteCommand?: AssignQuarantineToteCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesAssignQuarantineTotePost(assignQuarantineToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [operationName] 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesCheckOperationCargoPackageTypeBarcodeGet(operationName?: string, barcode?: string, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesCheckOperationCargoPackageTypeBarcodeGet(operationName, barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckSalesOrderSimpleSerialNumber} [checkSalesOrderSimpleSerialNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber?: CheckSalesOrderSimpleSerialNumber, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompletePackingProcessCommand} [completePackingProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesCompletePackingProcessPost(completePackingProcessCommand?: CompletePackingProcessCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesCompletePackingProcessPost(completePackingProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompletePackingQuarantineProcessCommand} [completePackingQuarantineProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesCompletePackingQuarantineProcessPost(completePackingQuarantineProcessCommand?: CompletePackingQuarantineProcessCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesCompletePackingQuarantineProcessPost(completePackingQuarantineProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePackingProcessIfNotExistsCommand} [createPackingProcessIfNotExistsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesCreatePackingProcessIfNotExistsPost(createPackingProcessIfNotExistsCommand?: CreatePackingProcessIfNotExistsCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesCreatePackingProcessIfNotExistsPost(createPackingProcessIfNotExistsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePackingQuarantineProcessIfNotExistsCommand} [createPackingQuarantineProcessIfNotExistsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesCreatePackingQuarantineProcessIfNotExistsPost(createPackingQuarantineProcessIfNotExistsCommand?: CreatePackingQuarantineProcessIfNotExistsCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesCreatePackingQuarantineProcessIfNotExistsPost(createPackingQuarantineProcessIfNotExistsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesGetSalesOrderStateGet(toteLabel?: string, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesGetSalesOrderStateGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesGetTotePackingTypeGet(toteLabel?: string, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesGetTotePackingTypeGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceQuarantineToteToQuarantineAddressCommand} [placeQuarantineToteToQuarantineAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesPlaceQuarantineToteToQuarantineAddressPost(placeQuarantineToteToQuarantineAddressCommand?: PlaceQuarantineToteToQuarantineAddressCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesPlaceQuarantineToteToQuarantineAddressPost(placeQuarantineToteToQuarantineAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintAdditionalCargoPackageLabelsCommand} [printAdditionalCargoPackageLabelsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesPrintAdditionalCargoPackageLabelsPost(printAdditionalCargoPackageLabelsCommand?: PrintAdditionalCargoPackageLabelsCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesPrintAdditionalCargoPackageLabelsPost(printAdditionalCargoPackageLabelsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintCargoPackageLabelsCommand} [printCargoPackageLabelsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesPrintCargoPackageLabelsPost(printCargoPackageLabelsCommand?: PrintCargoPackageLabelsCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesPrintCargoPackageLabelsPost(printCargoPackageLabelsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintPalettePackingListCommand} [printPalettePackingListCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesPrintPalettePackingListPost(printPalettePackingListCommand?: PrintPalettePackingListCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesPrintPalettePackingListPost(printPalettePackingListCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintSLAMDocumentsOnPackingCommand} [printSLAMDocumentsOnPackingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesPrintSLAMDocumentsPost(printSLAMDocumentsOnPackingCommand?: PrintSLAMDocumentsOnPackingCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesPrintSLAMDocumentsPost(printSLAMDocumentsOnPackingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintUnprintedPalettePackingListCommand} [printUnprintedPalettePackingListCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesPrintUnprintedPalettePackingListPost(printUnprintedPalettePackingListCommand?: PrintUnprintedPalettePackingListCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesPrintUnprintedPalettePackingListPost(printUnprintedPalettePackingListCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintVASCommand} [printVASCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesPrintVASPost(printVASCommand?: PrintVASCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesPrintVASPost(printVASCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesQueryPickingTrolleysInPackingGet(dqb?: string, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesQueryPickingTrolleysInPackingGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [packingAddressLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesQueryTotesReadyToPackGet(packingAddressLabel?: string, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesQueryTotesReadyToPackGet(packingAddressLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueueItemIntoCargoPackageCommand} [queueItemIntoCargoPackageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesQueueItemIntoCargoPackagePost(queueItemIntoCargoPackageCommand?: QueueItemIntoCargoPackageCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesQueueItemIntoCargoPackagePost(queueItemIntoCargoPackageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueueItemIntoQuarantineToteCommand} [queueItemIntoQuarantineToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesQueueItemIntoQuarantineTotePost(queueItemIntoQuarantineToteCommand?: QueueItemIntoQuarantineToteCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesQueueItemIntoQuarantineTotePost(queueItemIntoQuarantineToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RemoveCargoPackageCommand} [removeCargoPackageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesUnsealCargoPackagePost(unsealCargoPackageCommand?: UnsealCargoPackageCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesUnsealCargoPackagePost(unsealCargoPackageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    public apiV1PackingProcessesCloseCargoPackagePost(closeCargoPackageCommand?: CloseCargoPackageCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesCloseCargoPackagePost(closeCargoPackageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {RemoveCargoPackageCommand} [removeCargoPackageCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesRemoveCargoPackagePost(removeCargoPackageCommand?: RemoveCargoPackageCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesRemoveCargoPackagePost(removeCargoPackageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RemoveItemFromCargoPackageCommand} [removeItemFromCargoPackageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesRemoveItemFromCargoPackagePost(removeItemFromCargoPackageCommand?: RemoveItemFromCargoPackageCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesRemoveItemFromCargoPackagePost(removeItemFromCargoPackageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RemovePackingProcessOfUnpackableToteCommand} [removePackingProcessOfUnpackableToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesRemovePackingProcessOfUnpackableTotePost(removePackingProcessOfUnpackableToteCommand?: RemovePackingProcessOfUnpackableToteCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesRemovePackingProcessOfUnpackableTotePost(removePackingProcessOfUnpackableToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RemovePackingQuarantineProcessCommand} [removePackingQuarantineProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesRemoveQuarantineProcessPost(removePackingQuarantineProcessCommand?: RemovePackingQuarantineProcessCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesRemoveQuarantineProcessPost(removePackingQuarantineProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReprintPalettePackingListCommand} [reprintPalettePackingListCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesReprintPalettePackingListPost(reprintPalettePackingListCommand?: ReprintPalettePackingListCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesReprintPalettePackingListPost(reprintPalettePackingListCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnassignQuarantineToteCommand} [unassignQuarantineToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingProcessesApi
     */
    public apiV1PackingProcessesUnassignQuarantineTotePost(unassignQuarantineToteCommand?: UnassignQuarantineToteCommand, options?: any) {
        return PackingProcessesApiFp(this.configuration).apiV1PackingProcessesUnassignQuarantineTotePost(unassignQuarantineToteCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PackingSingleItemFastPackProcessesApi - axios parameter creator
 * @export
 */
export const PackingSingleItemFastPackProcessesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddCargoPackagesAndPrintCargoPackageLabelsCommand} [addCargoPackagesAndPrintCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemFastPackProcessesAddCargoPackagesAndPrintCargoPackageLabelsPost: async (addCargoPackagesAndPrintCargoPackageLabelsCommand?: AddCargoPackagesAndPrintCargoPackageLabelsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemFastPackProcesses.addCargoPackagesAndPrintCargoPackageLabels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCargoPackagesAndPrintCargoPackageLabelsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteSingleItemFastPackQuarantineProcessCommand} [completeSingleItemFastPackQuarantineProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemFastPackProcessesCompleteSingleItemFastPackPackingQuarantineProcessPost: async (completeSingleItemFastPackQuarantineProcessCommand?: CompleteSingleItemFastPackQuarantineProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemFastPackProcesses.completeSingleItemFastPackPackingQuarantineProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeSingleItemFastPackQuarantineProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand} [completeToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemFastPackProcessesCompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessPost: async (completeToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand?: CompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemFastPackProcesses.completeToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateToteSingleItemFastPackPackingProcessIfNotExistsCommand} [createToteSingleItemFastPackPackingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemFastPackProcessesCreateToteSingleItemFastPackPackingProcessIfNotExistsPost: async (createToteSingleItemFastPackPackingProcessIfNotExistsCommand?: CreateToteSingleItemFastPackPackingProcessIfNotExistsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemFastPackProcesses.createToteSingleItemFastPackPackingProcessIfNotExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createToteSingleItemFastPackPackingProcessIfNotExistsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemFastPackProcessesGetTotePackingTypeGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemFastPackProcesses.getTotePackingType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintSingleItemFastPackSalesOrderCargoPackageLabelsCommand} [printSingleItemFastPackSalesOrderCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemFastPackProcessesPrintSingleItemFastPackSalesOrderCargoPackageLabelsPost: async (printSingleItemFastPackSalesOrderCargoPackageLabelsCommand?: PrintSingleItemFastPackSalesOrderCargoPackageLabelsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemFastPackProcesses.printSingleItemFastPackSalesOrderCargoPackageLabels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printSingleItemFastPackSalesOrderCargoPackageLabelsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} singleItemFastPackPackingProcessId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemFastPackProcessesQuerySingleItemFastPackSalesOrdersToteDetailsGet: async (singleItemFastPackPackingProcessId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'singleItemFastPackPackingProcessId' is not null or undefined
            assertParamExists('apiV1PackingSingleItemFastPackProcessesQuerySingleItemFastPackSalesOrdersToteDetailsGet', 'singleItemFastPackPackingProcessId', singleItemFastPackPackingProcessId)
            const localVarPath = `/api/v1/PackingSingleItemFastPackProcesses.querySingleItemFastPackSalesOrdersToteDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (singleItemFastPackPackingProcessId !== undefined) {
                localVarQueryParameter['singleItemFastPackPackingProcessId'] = singleItemFastPackPackingProcessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PackingSingleItemFastPackProcessesApi - functional programming interface
 * @export
 */
export const PackingSingleItemFastPackProcessesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PackingSingleItemFastPackProcessesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddCargoPackagesAndPrintCargoPackageLabelsCommand} [addCargoPackagesAndPrintCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemFastPackProcessesAddCargoPackagesAndPrintCargoPackageLabelsPost(addCargoPackagesAndPrintCargoPackageLabelsCommand?: AddCargoPackagesAndPrintCargoPackageLabelsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddCargoPackagesAndPrintCargoPackageLabelsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemFastPackProcessesAddCargoPackagesAndPrintCargoPackageLabelsPost(addCargoPackagesAndPrintCargoPackageLabelsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteSingleItemFastPackQuarantineProcessCommand} [completeSingleItemFastPackQuarantineProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemFastPackProcessesCompleteSingleItemFastPackPackingQuarantineProcessPost(completeSingleItemFastPackQuarantineProcessCommand?: CompleteSingleItemFastPackQuarantineProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemFastPackProcessesCompleteSingleItemFastPackPackingQuarantineProcessPost(completeSingleItemFastPackQuarantineProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand} [completeToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemFastPackProcessesCompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessPost(completeToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand?: CompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemFastPackProcessesCompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessPost(completeToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateToteSingleItemFastPackPackingProcessIfNotExistsCommand} [createToteSingleItemFastPackPackingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemFastPackProcessesCreateToteSingleItemFastPackPackingProcessIfNotExistsPost(createToteSingleItemFastPackPackingProcessIfNotExistsCommand?: CreateToteSingleItemFastPackPackingProcessIfNotExistsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateToteSingleItemFastPackPackingProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemFastPackProcessesCreateToteSingleItemFastPackPackingProcessIfNotExistsPost(createToteSingleItemFastPackPackingProcessIfNotExistsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemFastPackProcessesGetTotePackingTypeGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotePackingTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemFastPackProcessesGetTotePackingTypeGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintSingleItemFastPackSalesOrderCargoPackageLabelsCommand} [printSingleItemFastPackSalesOrderCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemFastPackProcessesPrintSingleItemFastPackSalesOrderCargoPackageLabelsPost(printSingleItemFastPackSalesOrderCargoPackageLabelsCommand?: PrintSingleItemFastPackSalesOrderCargoPackageLabelsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemFastPackProcessesPrintSingleItemFastPackSalesOrderCargoPackageLabelsPost(printSingleItemFastPackSalesOrderCargoPackageLabelsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} singleItemFastPackPackingProcessId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemFastPackProcessesQuerySingleItemFastPackSalesOrdersToteDetailsGet(singleItemFastPackPackingProcessId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleItemFastPackSalesOrdersToteDetailsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemFastPackProcessesQuerySingleItemFastPackSalesOrdersToteDetailsGet(singleItemFastPackPackingProcessId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PackingSingleItemFastPackProcessesApi - factory interface
 * @export
 */
export const PackingSingleItemFastPackProcessesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PackingSingleItemFastPackProcessesApiFp(configuration)
    return {
        /**
         * 
         * @param {AddCargoPackagesAndPrintCargoPackageLabelsCommand} [addCargoPackagesAndPrintCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemFastPackProcessesAddCargoPackagesAndPrintCargoPackageLabelsPost(addCargoPackagesAndPrintCargoPackageLabelsCommand?: AddCargoPackagesAndPrintCargoPackageLabelsCommand, options?: any): AxiosPromise<AddCargoPackagesAndPrintCargoPackageLabelsOutputDTO> {
            return localVarFp.apiV1PackingSingleItemFastPackProcessesAddCargoPackagesAndPrintCargoPackageLabelsPost(addCargoPackagesAndPrintCargoPackageLabelsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteSingleItemFastPackQuarantineProcessCommand} [completeSingleItemFastPackQuarantineProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemFastPackProcessesCompleteSingleItemFastPackPackingQuarantineProcessPost(completeSingleItemFastPackQuarantineProcessCommand?: CompleteSingleItemFastPackQuarantineProcessCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingSingleItemFastPackProcessesCompleteSingleItemFastPackPackingQuarantineProcessPost(completeSingleItemFastPackQuarantineProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand} [completeToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemFastPackProcessesCompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessPost(completeToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand?: CompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingSingleItemFastPackProcessesCompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessPost(completeToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateToteSingleItemFastPackPackingProcessIfNotExistsCommand} [createToteSingleItemFastPackPackingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemFastPackProcessesCreateToteSingleItemFastPackPackingProcessIfNotExistsPost(createToteSingleItemFastPackPackingProcessIfNotExistsCommand?: CreateToteSingleItemFastPackPackingProcessIfNotExistsCommand, options?: any): AxiosPromise<CreateToteSingleItemFastPackPackingProcessOutputDTO> {
            return localVarFp.apiV1PackingSingleItemFastPackProcessesCreateToteSingleItemFastPackPackingProcessIfNotExistsPost(createToteSingleItemFastPackPackingProcessIfNotExistsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemFastPackProcessesGetTotePackingTypeGet(toteLabel?: string, options?: any): AxiosPromise<TotePackingTypeOutputDTO> {
            return localVarFp.apiV1PackingSingleItemFastPackProcessesGetTotePackingTypeGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintSingleItemFastPackSalesOrderCargoPackageLabelsCommand} [printSingleItemFastPackSalesOrderCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemFastPackProcessesPrintSingleItemFastPackSalesOrderCargoPackageLabelsPost(printSingleItemFastPackSalesOrderCargoPackageLabelsCommand?: PrintSingleItemFastPackSalesOrderCargoPackageLabelsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingSingleItemFastPackProcessesPrintSingleItemFastPackSalesOrderCargoPackageLabelsPost(printSingleItemFastPackSalesOrderCargoPackageLabelsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} singleItemFastPackPackingProcessId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemFastPackProcessesQuerySingleItemFastPackSalesOrdersToteDetailsGet(singleItemFastPackPackingProcessId: string, dqb?: string, options?: any): AxiosPromise<SingleItemFastPackSalesOrdersToteDetailsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PackingSingleItemFastPackProcessesQuerySingleItemFastPackSalesOrdersToteDetailsGet(singleItemFastPackPackingProcessId, dqb, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PackingSingleItemFastPackProcessesApi - object-oriented interface
 * @export
 * @class PackingSingleItemFastPackProcessesApi
 * @extends {BaseAPI}
 */
export class PackingSingleItemFastPackProcessesApi extends BaseAPI {
    /**
     * 
     * @param {AddCargoPackagesAndPrintCargoPackageLabelsCommand} [addCargoPackagesAndPrintCargoPackageLabelsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemFastPackProcessesApi
     */
    public apiV1PackingSingleItemFastPackProcessesAddCargoPackagesAndPrintCargoPackageLabelsPost(addCargoPackagesAndPrintCargoPackageLabelsCommand?: AddCargoPackagesAndPrintCargoPackageLabelsCommand, options?: any) {
        return PackingSingleItemFastPackProcessesApiFp(this.configuration).apiV1PackingSingleItemFastPackProcessesAddCargoPackagesAndPrintCargoPackageLabelsPost(addCargoPackagesAndPrintCargoPackageLabelsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteSingleItemFastPackQuarantineProcessCommand} [completeSingleItemFastPackQuarantineProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemFastPackProcessesApi
     */
    public apiV1PackingSingleItemFastPackProcessesCompleteSingleItemFastPackPackingQuarantineProcessPost(completeSingleItemFastPackQuarantineProcessCommand?: CompleteSingleItemFastPackQuarantineProcessCommand, options?: any) {
        return PackingSingleItemFastPackProcessesApiFp(this.configuration).apiV1PackingSingleItemFastPackProcessesCompleteSingleItemFastPackPackingQuarantineProcessPost(completeSingleItemFastPackQuarantineProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand} [completeToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemFastPackProcessesApi
     */
    public apiV1PackingSingleItemFastPackProcessesCompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessPost(completeToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand?: CompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand, options?: any) {
        return PackingSingleItemFastPackProcessesApiFp(this.configuration).apiV1PackingSingleItemFastPackProcessesCompleteToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessPost(completeToteSingleItemFastPackPackingProcessAndSalesOrderPackingProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateToteSingleItemFastPackPackingProcessIfNotExistsCommand} [createToteSingleItemFastPackPackingProcessIfNotExistsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemFastPackProcessesApi
     */
    public apiV1PackingSingleItemFastPackProcessesCreateToteSingleItemFastPackPackingProcessIfNotExistsPost(createToteSingleItemFastPackPackingProcessIfNotExistsCommand?: CreateToteSingleItemFastPackPackingProcessIfNotExistsCommand, options?: any) {
        return PackingSingleItemFastPackProcessesApiFp(this.configuration).apiV1PackingSingleItemFastPackProcessesCreateToteSingleItemFastPackPackingProcessIfNotExistsPost(createToteSingleItemFastPackPackingProcessIfNotExistsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemFastPackProcessesApi
     */
    public apiV1PackingSingleItemFastPackProcessesGetTotePackingTypeGet(toteLabel?: string, options?: any) {
        return PackingSingleItemFastPackProcessesApiFp(this.configuration).apiV1PackingSingleItemFastPackProcessesGetTotePackingTypeGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintSingleItemFastPackSalesOrderCargoPackageLabelsCommand} [printSingleItemFastPackSalesOrderCargoPackageLabelsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemFastPackProcessesApi
     */
    public apiV1PackingSingleItemFastPackProcessesPrintSingleItemFastPackSalesOrderCargoPackageLabelsPost(printSingleItemFastPackSalesOrderCargoPackageLabelsCommand?: PrintSingleItemFastPackSalesOrderCargoPackageLabelsCommand, options?: any) {
        return PackingSingleItemFastPackProcessesApiFp(this.configuration).apiV1PackingSingleItemFastPackProcessesPrintSingleItemFastPackSalesOrderCargoPackageLabelsPost(printSingleItemFastPackSalesOrderCargoPackageLabelsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} singleItemFastPackPackingProcessId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemFastPackProcessesApi
     */
    public apiV1PackingSingleItemFastPackProcessesQuerySingleItemFastPackSalesOrdersToteDetailsGet(singleItemFastPackPackingProcessId: string, dqb?: string, options?: any) {
        return PackingSingleItemFastPackProcessesApiFp(this.configuration).apiV1PackingSingleItemFastPackProcessesQuerySingleItemFastPackSalesOrdersToteDetailsGet(singleItemFastPackPackingProcessId, dqb, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PackingSingleItemProcessesApi - axios parameter creator
 * @export
 */
export const PackingSingleItemProcessesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddOrUpdateCargoPackageToQueueForSingleItemPackingCommand} [addOrUpdateCargoPackageToQueueForSingleItemPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesAddOrUpdateCargoPackageToQueueForSingleItemPackingPost: async (addOrUpdateCargoPackageToQueueForSingleItemPackingCommand?: AddOrUpdateCargoPackageToQueueForSingleItemPackingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.addOrUpdateCargoPackageToQueueForSingleItemPacking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrUpdateCargoPackageToQueueForSingleItemPackingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {string} [productBarcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesCheckProductBarcodeGet: async (toteLabel?: string, productBarcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.checkProductBarcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }

            if (productBarcode !== undefined) {
                localVarQueryParameter['productBarcode'] = productBarcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckSalesOrderSimpleSerialNumber} [checkSalesOrderSimpleSerialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesCheckSimpleSerialNumberPost: async (checkSalesOrderSimpleSerialNumber?: CheckSalesOrderSimpleSerialNumber, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.checkSimpleSerialNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkSalesOrderSimpleSerialNumber, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteSalesOrderPackingProcessCommand} [completeSalesOrderPackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesCompleteSalesOrderPackingProcessPost: async (completeSalesOrderPackingProcessCommand?: CompleteSalesOrderPackingProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.completeSalesOrderPackingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeSalesOrderPackingProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteSingleItemPackingQuarantineProcessCommand} [completeSingleItemPackingQuarantineProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesCompleteSingleItemPackingQuarantineProcessPost: async (completeSingleItemPackingQuarantineProcessCommand?: CompleteSingleItemPackingQuarantineProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.completeSingleItemPackingQuarantineProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeSingleItemPackingQuarantineProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteToteSingleItemPackingProcessCommand} [completeToteSingleItemPackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesCompleteToteSingleItemPackingProcessPost: async (completeToteSingleItemPackingProcessCommand?: CompleteToteSingleItemPackingProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.completeToteSingleItemPackingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeToteSingleItemPackingProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSalesOrderPackingProcessIfNotExistsCommand} [createSalesOrderPackingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesCreateSalesOrderPackingProcessIfNotExistsPost: async (createSalesOrderPackingProcessIfNotExistsCommand?: CreateSalesOrderPackingProcessIfNotExistsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.createSalesOrderPackingProcessIfNotExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSalesOrderPackingProcessIfNotExistsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateToteSingleItemPackingProcessIfNotExistsCommand} [createToteSingleItemPackingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesCreateToteSingleItemPackingProcessIfNotExistsPost: async (createToteSingleItemPackingProcessIfNotExistsCommand?: CreateToteSingleItemPackingProcessIfNotExistsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.createToteSingleItemPackingProcessIfNotExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createToteSingleItemPackingProcessIfNotExistsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteCargoPackageFromQueueForSingleItemPackingCommand} [deleteCargoPackageFromQueueForSingleItemPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesDeleteCargoPackageFromQueueForSingleItemPackingPost: async (deleteCargoPackageFromQueueForSingleItemPackingCommand?: DeleteCargoPackageFromQueueForSingleItemPackingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.deleteCargoPackageFromQueueForSingleItemPacking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteCargoPackageFromQueueForSingleItemPackingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [singleItemPackingAddressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesGetOngoingSingleItemPackingProcessToteGet: async (singleItemPackingAddressLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.getOngoingSingleItemPackingProcessTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (singleItemPackingAddressLabel !== undefined) {
                localVarQueryParameter['singleItemPackingAddressLabel'] = singleItemPackingAddressLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesGetSingleItemRemainingToteSalesOrdersCountGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.getSingleItemRemainingToteSalesOrdersCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {string} [productBarcode] 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesGetSingleItemSalesOrderStateGet: async (toteLabel?: string, productBarcode?: string, serialNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.getSingleItemSalesOrderState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }

            if (productBarcode !== undefined) {
                localVarQueryParameter['productBarcode'] = productBarcode;
            }

            if (serialNumber !== undefined) {
                localVarQueryParameter['serialNumber'] = serialNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesGetSingleItemSalesOrdersToteRemainingItemsGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.getSingleItemSalesOrdersToteRemainingItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesGetTotePackingTypeGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.getTotePackingType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintSLAMDocumentsOnSingleItemSalesOrderPackingCommand} [printSLAMDocumentsOnSingleItemSalesOrderPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesPrintSLAMDocumentsOnSingleItemSalesOrderPackingPost: async (printSLAMDocumentsOnSingleItemSalesOrderPackingCommand?: PrintSLAMDocumentsOnSingleItemSalesOrderPackingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.printSLAMDocumentsOnSingleItemSalesOrderPacking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printSLAMDocumentsOnSingleItemSalesOrderPackingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintSingleItemSalesOrderCargoPackageLabelsCommand} [printSingleItemSalesOrderCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesPrintSingleItemSalesOrderCargoPackageLabelsPost: async (printSingleItemSalesOrderCargoPackageLabelsCommand?: PrintSingleItemSalesOrderCargoPackageLabelsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.printSingleItemSalesOrderCargoPackageLabels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printSingleItemSalesOrderCargoPackageLabelsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintSingleItemSalesOrderVASCommand} [printSingleItemSalesOrderVASCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesPrintSingleItemSalesOrderVASPost: async (printSingleItemSalesOrderVASCommand?: PrintSingleItemSalesOrderVASCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.printSingleItemSalesOrderVAS`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printSingleItemSalesOrderVASCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} singleItemPackingProcessId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesQuerySingleItemSalesOrdersToteDetailsGet: async (singleItemPackingProcessId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'singleItemPackingProcessId' is not null or undefined
            assertParamExists('apiV1PackingSingleItemProcessesQuerySingleItemSalesOrdersToteDetailsGet', 'singleItemPackingProcessId', singleItemPackingProcessId)
            const localVarPath = `/api/v1/PackingSingleItemProcesses.querySingleItemSalesOrdersToteDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (singleItemPackingProcessId !== undefined) {
                localVarQueryParameter['singleItemPackingProcessId'] = singleItemPackingProcessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesTotesReadyToPackGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PackingSingleItemProcesses.totesReadyToPack`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PackingSingleItemProcessesApi - functional programming interface
 * @export
 */
export const PackingSingleItemProcessesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PackingSingleItemProcessesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddOrUpdateCargoPackageToQueueForSingleItemPackingCommand} [addOrUpdateCargoPackageToQueueForSingleItemPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesAddOrUpdateCargoPackageToQueueForSingleItemPackingPost(addOrUpdateCargoPackageToQueueForSingleItemPackingCommand?: AddOrUpdateCargoPackageToQueueForSingleItemPackingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesAddOrUpdateCargoPackageToQueueForSingleItemPackingPost(addOrUpdateCargoPackageToQueueForSingleItemPackingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {string} [productBarcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesCheckProductBarcodeGet(toteLabel?: string, productBarcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleItemCheckProductBarcodeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesCheckProductBarcodeGet(toteLabel, productBarcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckSalesOrderSimpleSerialNumber} [checkSalesOrderSimpleSerialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber?: CheckSalesOrderSimpleSerialNumber, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteSalesOrderPackingProcessCommand} [completeSalesOrderPackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesCompleteSalesOrderPackingProcessPost(completeSalesOrderPackingProcessCommand?: CompleteSalesOrderPackingProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesCompleteSalesOrderPackingProcessPost(completeSalesOrderPackingProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteSingleItemPackingQuarantineProcessCommand} [completeSingleItemPackingQuarantineProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesCompleteSingleItemPackingQuarantineProcessPost(completeSingleItemPackingQuarantineProcessCommand?: CompleteSingleItemPackingQuarantineProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesCompleteSingleItemPackingQuarantineProcessPost(completeSingleItemPackingQuarantineProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteToteSingleItemPackingProcessCommand} [completeToteSingleItemPackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesCompleteToteSingleItemPackingProcessPost(completeToteSingleItemPackingProcessCommand?: CompleteToteSingleItemPackingProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesCompleteToteSingleItemPackingProcessPost(completeToteSingleItemPackingProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSalesOrderPackingProcessIfNotExistsCommand} [createSalesOrderPackingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesCreateSalesOrderPackingProcessIfNotExistsPost(createSalesOrderPackingProcessIfNotExistsCommand?: CreateSalesOrderPackingProcessIfNotExistsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSalesOrderPackingProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesCreateSalesOrderPackingProcessIfNotExistsPost(createSalesOrderPackingProcessIfNotExistsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateToteSingleItemPackingProcessIfNotExistsCommand} [createToteSingleItemPackingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesCreateToteSingleItemPackingProcessIfNotExistsPost(createToteSingleItemPackingProcessIfNotExistsCommand?: CreateToteSingleItemPackingProcessIfNotExistsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateToteSingleItemPackingProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesCreateToteSingleItemPackingProcessIfNotExistsPost(createToteSingleItemPackingProcessIfNotExistsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteCargoPackageFromQueueForSingleItemPackingCommand} [deleteCargoPackageFromQueueForSingleItemPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesDeleteCargoPackageFromQueueForSingleItemPackingPost(deleteCargoPackageFromQueueForSingleItemPackingCommand?: DeleteCargoPackageFromQueueForSingleItemPackingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesDeleteCargoPackageFromQueueForSingleItemPackingPost(deleteCargoPackageFromQueueForSingleItemPackingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [singleItemPackingAddressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesGetOngoingSingleItemPackingProcessToteGet(singleItemPackingAddressLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOngoingToteSingleItemPackingProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesGetOngoingSingleItemPackingProcessToteGet(singleItemPackingAddressLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesGetSingleItemRemainingToteSalesOrdersCountGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleItemSalesOrdersToteRemainingItemsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesGetSingleItemRemainingToteSalesOrdersCountGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {string} [productBarcode] 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesGetSingleItemSalesOrderStateGet(toteLabel?: string, productBarcode?: string, serialNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleItemSalesOrderStateOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesGetSingleItemSalesOrderStateGet(toteLabel, productBarcode, serialNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesGetSingleItemSalesOrdersToteRemainingItemsGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleItemSalesOrdersToteRemainingItemsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesGetSingleItemSalesOrdersToteRemainingItemsGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesGetTotePackingTypeGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotePackingTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesGetTotePackingTypeGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintSLAMDocumentsOnSingleItemSalesOrderPackingCommand} [printSLAMDocumentsOnSingleItemSalesOrderPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesPrintSLAMDocumentsOnSingleItemSalesOrderPackingPost(printSLAMDocumentsOnSingleItemSalesOrderPackingCommand?: PrintSLAMDocumentsOnSingleItemSalesOrderPackingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrintSLAMDocumentsOnSingleItemPackingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesPrintSLAMDocumentsOnSingleItemSalesOrderPackingPost(printSLAMDocumentsOnSingleItemSalesOrderPackingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintSingleItemSalesOrderCargoPackageLabelsCommand} [printSingleItemSalesOrderCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesPrintSingleItemSalesOrderCargoPackageLabelsPost(printSingleItemSalesOrderCargoPackageLabelsCommand?: PrintSingleItemSalesOrderCargoPackageLabelsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesPrintSingleItemSalesOrderCargoPackageLabelsPost(printSingleItemSalesOrderCargoPackageLabelsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintSingleItemSalesOrderVASCommand} [printSingleItemSalesOrderVASCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesPrintSingleItemSalesOrderVASPost(printSingleItemSalesOrderVASCommand?: PrintSingleItemSalesOrderVASCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesPrintSingleItemSalesOrderVASPost(printSingleItemSalesOrderVASCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} singleItemPackingProcessId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesQuerySingleItemSalesOrdersToteDetailsGet(singleItemPackingProcessId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleItemSalesOrdersToteDetailsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesQuerySingleItemSalesOrdersToteDetailsGet(singleItemPackingProcessId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PackingSingleItemProcessesTotesReadyToPackGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTotesReadyToPackOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PackingSingleItemProcessesTotesReadyToPackGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PackingSingleItemProcessesApi - factory interface
 * @export
 */
export const PackingSingleItemProcessesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PackingSingleItemProcessesApiFp(configuration)
    return {
        /**
         * 
         * @param {AddOrUpdateCargoPackageToQueueForSingleItemPackingCommand} [addOrUpdateCargoPackageToQueueForSingleItemPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesAddOrUpdateCargoPackageToQueueForSingleItemPackingPost(addOrUpdateCargoPackageToQueueForSingleItemPackingCommand?: AddOrUpdateCargoPackageToQueueForSingleItemPackingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingSingleItemProcessesAddOrUpdateCargoPackageToQueueForSingleItemPackingPost(addOrUpdateCargoPackageToQueueForSingleItemPackingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {string} [productBarcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesCheckProductBarcodeGet(toteLabel?: string, productBarcode?: string, options?: any): AxiosPromise<SingleItemCheckProductBarcodeOutputDTO> {
            return localVarFp.apiV1PackingSingleItemProcessesCheckProductBarcodeGet(toteLabel, productBarcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckSalesOrderSimpleSerialNumber} [checkSalesOrderSimpleSerialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber?: CheckSalesOrderSimpleSerialNumber, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingSingleItemProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteSalesOrderPackingProcessCommand} [completeSalesOrderPackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesCompleteSalesOrderPackingProcessPost(completeSalesOrderPackingProcessCommand?: CompleteSalesOrderPackingProcessCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingSingleItemProcessesCompleteSalesOrderPackingProcessPost(completeSalesOrderPackingProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteSingleItemPackingQuarantineProcessCommand} [completeSingleItemPackingQuarantineProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesCompleteSingleItemPackingQuarantineProcessPost(completeSingleItemPackingQuarantineProcessCommand?: CompleteSingleItemPackingQuarantineProcessCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingSingleItemProcessesCompleteSingleItemPackingQuarantineProcessPost(completeSingleItemPackingQuarantineProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteToteSingleItemPackingProcessCommand} [completeToteSingleItemPackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesCompleteToteSingleItemPackingProcessPost(completeToteSingleItemPackingProcessCommand?: CompleteToteSingleItemPackingProcessCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingSingleItemProcessesCompleteToteSingleItemPackingProcessPost(completeToteSingleItemPackingProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSalesOrderPackingProcessIfNotExistsCommand} [createSalesOrderPackingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesCreateSalesOrderPackingProcessIfNotExistsPost(createSalesOrderPackingProcessIfNotExistsCommand?: CreateSalesOrderPackingProcessIfNotExistsCommand, options?: any): AxiosPromise<CreateSalesOrderPackingProcessOutputDTO> {
            return localVarFp.apiV1PackingSingleItemProcessesCreateSalesOrderPackingProcessIfNotExistsPost(createSalesOrderPackingProcessIfNotExistsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateToteSingleItemPackingProcessIfNotExistsCommand} [createToteSingleItemPackingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesCreateToteSingleItemPackingProcessIfNotExistsPost(createToteSingleItemPackingProcessIfNotExistsCommand?: CreateToteSingleItemPackingProcessIfNotExistsCommand, options?: any): AxiosPromise<CreateToteSingleItemPackingProcessOutputDTO> {
            return localVarFp.apiV1PackingSingleItemProcessesCreateToteSingleItemPackingProcessIfNotExistsPost(createToteSingleItemPackingProcessIfNotExistsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteCargoPackageFromQueueForSingleItemPackingCommand} [deleteCargoPackageFromQueueForSingleItemPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesDeleteCargoPackageFromQueueForSingleItemPackingPost(deleteCargoPackageFromQueueForSingleItemPackingCommand?: DeleteCargoPackageFromQueueForSingleItemPackingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingSingleItemProcessesDeleteCargoPackageFromQueueForSingleItemPackingPost(deleteCargoPackageFromQueueForSingleItemPackingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [singleItemPackingAddressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesGetOngoingSingleItemPackingProcessToteGet(singleItemPackingAddressLabel?: string, options?: any): AxiosPromise<GetOngoingToteSingleItemPackingProcessOutputDTO> {
            return localVarFp.apiV1PackingSingleItemProcessesGetOngoingSingleItemPackingProcessToteGet(singleItemPackingAddressLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesGetSingleItemRemainingToteSalesOrdersCountGet(toteLabel?: string, options?: any): AxiosPromise<SingleItemSalesOrdersToteRemainingItemsOutputDTO> {
            return localVarFp.apiV1PackingSingleItemProcessesGetSingleItemRemainingToteSalesOrdersCountGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {string} [productBarcode] 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesGetSingleItemSalesOrderStateGet(toteLabel?: string, productBarcode?: string, serialNumber?: string, options?: any): AxiosPromise<SingleItemSalesOrderStateOutputDTO> {
            return localVarFp.apiV1PackingSingleItemProcessesGetSingleItemSalesOrderStateGet(toteLabel, productBarcode, serialNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesGetSingleItemSalesOrdersToteRemainingItemsGet(toteLabel?: string, options?: any): AxiosPromise<SingleItemSalesOrdersToteRemainingItemsOutputDTO> {
            return localVarFp.apiV1PackingSingleItemProcessesGetSingleItemSalesOrdersToteRemainingItemsGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesGetTotePackingTypeGet(toteLabel?: string, options?: any): AxiosPromise<TotePackingTypeOutputDTO> {
            return localVarFp.apiV1PackingSingleItemProcessesGetTotePackingTypeGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintSLAMDocumentsOnSingleItemSalesOrderPackingCommand} [printSLAMDocumentsOnSingleItemSalesOrderPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesPrintSLAMDocumentsOnSingleItemSalesOrderPackingPost(printSLAMDocumentsOnSingleItemSalesOrderPackingCommand?: PrintSLAMDocumentsOnSingleItemSalesOrderPackingCommand, options?: any): AxiosPromise<PrintSLAMDocumentsOnSingleItemPackingOutputDTO> {
            return localVarFp.apiV1PackingSingleItemProcessesPrintSLAMDocumentsOnSingleItemSalesOrderPackingPost(printSLAMDocumentsOnSingleItemSalesOrderPackingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintSingleItemSalesOrderCargoPackageLabelsCommand} [printSingleItemSalesOrderCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesPrintSingleItemSalesOrderCargoPackageLabelsPost(printSingleItemSalesOrderCargoPackageLabelsCommand?: PrintSingleItemSalesOrderCargoPackageLabelsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingSingleItemProcessesPrintSingleItemSalesOrderCargoPackageLabelsPost(printSingleItemSalesOrderCargoPackageLabelsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintSingleItemSalesOrderVASCommand} [printSingleItemSalesOrderVASCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesPrintSingleItemSalesOrderVASPost(printSingleItemSalesOrderVASCommand?: PrintSingleItemSalesOrderVASCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PackingSingleItemProcessesPrintSingleItemSalesOrderVASPost(printSingleItemSalesOrderVASCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} singleItemPackingProcessId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesQuerySingleItemSalesOrdersToteDetailsGet(singleItemPackingProcessId: string, dqb?: string, options?: any): AxiosPromise<SingleItemSalesOrdersToteDetailsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PackingSingleItemProcessesQuerySingleItemSalesOrdersToteDetailsGet(singleItemPackingProcessId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PackingSingleItemProcessesTotesReadyToPackGet(options?: any): AxiosPromise<Array<GetTotesReadyToPackOutputDTO>> {
            return localVarFp.apiV1PackingSingleItemProcessesTotesReadyToPackGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PackingSingleItemProcessesApi - object-oriented interface
 * @export
 * @class PackingSingleItemProcessesApi
 * @extends {BaseAPI}
 */
export class PackingSingleItemProcessesApi extends BaseAPI {
    /**
     * 
     * @param {AddOrUpdateCargoPackageToQueueForSingleItemPackingCommand} [addOrUpdateCargoPackageToQueueForSingleItemPackingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesAddOrUpdateCargoPackageToQueueForSingleItemPackingPost(addOrUpdateCargoPackageToQueueForSingleItemPackingCommand?: AddOrUpdateCargoPackageToQueueForSingleItemPackingCommand, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesAddOrUpdateCargoPackageToQueueForSingleItemPackingPost(addOrUpdateCargoPackageToQueueForSingleItemPackingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {string} [productBarcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesCheckProductBarcodeGet(toteLabel?: string, productBarcode?: string, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesCheckProductBarcodeGet(toteLabel, productBarcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckSalesOrderSimpleSerialNumber} [checkSalesOrderSimpleSerialNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber?: CheckSalesOrderSimpleSerialNumber, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesCheckSimpleSerialNumberPost(checkSalesOrderSimpleSerialNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteSalesOrderPackingProcessCommand} [completeSalesOrderPackingProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesCompleteSalesOrderPackingProcessPost(completeSalesOrderPackingProcessCommand?: CompleteSalesOrderPackingProcessCommand, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesCompleteSalesOrderPackingProcessPost(completeSalesOrderPackingProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteSingleItemPackingQuarantineProcessCommand} [completeSingleItemPackingQuarantineProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesCompleteSingleItemPackingQuarantineProcessPost(completeSingleItemPackingQuarantineProcessCommand?: CompleteSingleItemPackingQuarantineProcessCommand, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesCompleteSingleItemPackingQuarantineProcessPost(completeSingleItemPackingQuarantineProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteToteSingleItemPackingProcessCommand} [completeToteSingleItemPackingProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesCompleteToteSingleItemPackingProcessPost(completeToteSingleItemPackingProcessCommand?: CompleteToteSingleItemPackingProcessCommand, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesCompleteToteSingleItemPackingProcessPost(completeToteSingleItemPackingProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSalesOrderPackingProcessIfNotExistsCommand} [createSalesOrderPackingProcessIfNotExistsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesCreateSalesOrderPackingProcessIfNotExistsPost(createSalesOrderPackingProcessIfNotExistsCommand?: CreateSalesOrderPackingProcessIfNotExistsCommand, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesCreateSalesOrderPackingProcessIfNotExistsPost(createSalesOrderPackingProcessIfNotExistsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateToteSingleItemPackingProcessIfNotExistsCommand} [createToteSingleItemPackingProcessIfNotExistsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesCreateToteSingleItemPackingProcessIfNotExistsPost(createToteSingleItemPackingProcessIfNotExistsCommand?: CreateToteSingleItemPackingProcessIfNotExistsCommand, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesCreateToteSingleItemPackingProcessIfNotExistsPost(createToteSingleItemPackingProcessIfNotExistsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteCargoPackageFromQueueForSingleItemPackingCommand} [deleteCargoPackageFromQueueForSingleItemPackingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesDeleteCargoPackageFromQueueForSingleItemPackingPost(deleteCargoPackageFromQueueForSingleItemPackingCommand?: DeleteCargoPackageFromQueueForSingleItemPackingCommand, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesDeleteCargoPackageFromQueueForSingleItemPackingPost(deleteCargoPackageFromQueueForSingleItemPackingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [singleItemPackingAddressLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesGetOngoingSingleItemPackingProcessToteGet(singleItemPackingAddressLabel?: string, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesGetOngoingSingleItemPackingProcessToteGet(singleItemPackingAddressLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesGetSingleItemRemainingToteSalesOrdersCountGet(toteLabel?: string, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesGetSingleItemRemainingToteSalesOrdersCountGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {string} [productBarcode] 
     * @param {string} [serialNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesGetSingleItemSalesOrderStateGet(toteLabel?: string, productBarcode?: string, serialNumber?: string, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesGetSingleItemSalesOrderStateGet(toteLabel, productBarcode, serialNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesGetSingleItemSalesOrdersToteRemainingItemsGet(toteLabel?: string, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesGetSingleItemSalesOrdersToteRemainingItemsGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesGetTotePackingTypeGet(toteLabel?: string, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesGetTotePackingTypeGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintSLAMDocumentsOnSingleItemSalesOrderPackingCommand} [printSLAMDocumentsOnSingleItemSalesOrderPackingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesPrintSLAMDocumentsOnSingleItemSalesOrderPackingPost(printSLAMDocumentsOnSingleItemSalesOrderPackingCommand?: PrintSLAMDocumentsOnSingleItemSalesOrderPackingCommand, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesPrintSLAMDocumentsOnSingleItemSalesOrderPackingPost(printSLAMDocumentsOnSingleItemSalesOrderPackingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintSingleItemSalesOrderCargoPackageLabelsCommand} [printSingleItemSalesOrderCargoPackageLabelsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesPrintSingleItemSalesOrderCargoPackageLabelsPost(printSingleItemSalesOrderCargoPackageLabelsCommand?: PrintSingleItemSalesOrderCargoPackageLabelsCommand, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesPrintSingleItemSalesOrderCargoPackageLabelsPost(printSingleItemSalesOrderCargoPackageLabelsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintSingleItemSalesOrderVASCommand} [printSingleItemSalesOrderVASCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesPrintSingleItemSalesOrderVASPost(printSingleItemSalesOrderVASCommand?: PrintSingleItemSalesOrderVASCommand, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesPrintSingleItemSalesOrderVASPost(printSingleItemSalesOrderVASCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} singleItemPackingProcessId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesQuerySingleItemSalesOrdersToteDetailsGet(singleItemPackingProcessId: string, dqb?: string, options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesQuerySingleItemSalesOrdersToteDetailsGet(singleItemPackingProcessId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackingSingleItemProcessesApi
     */
    public apiV1PackingSingleItemProcessesTotesReadyToPackGet(options?: any) {
        return PackingSingleItemProcessesApiFp(this.configuration).apiV1PackingSingleItemProcessesTotesReadyToPackGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PalletPutAwayApi - axios parameter creator
 * @export
 */
export const PalletPutAwayApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletPutAwayCheckCellGet: async (cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PalletPutAway.checkCell`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompletePalletPutAwayCommand} [completePalletPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletPutAwayCompletePost: async (completePalletPutAwayCommand?: CompletePalletPutAwayCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PalletPutAway.complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completePalletPutAwayCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletPutAwayCreatePost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PalletPutAway.create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [putAwayId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletPutAwayGetHistoryGet: async (putAwayId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PalletPutAway.getHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (putAwayId !== undefined) {
                localVarQueryParameter['putAwayId'] = putAwayId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [palletLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletPutAwayGetPalletProductsGet: async (palletLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PalletPutAway.getPalletProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (palletLabel !== undefined) {
                localVarQueryParameter['palletLabel'] = palletLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlacePalletCommand} [placePalletCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletPutAwayPlacePalletPost: async (placePalletCommand?: PlacePalletCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PalletPutAway.placePallet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placePalletCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SelectPalletToPutAwayCommand} [selectPalletToPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletPutAwaySelectPalletPost: async (selectPalletToPutAwayCommand?: SelectPalletToPutAwayCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PalletPutAway.selectPallet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectPalletToPutAwayCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PalletPutAwayApi - functional programming interface
 * @export
 */
export const PalletPutAwayApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PalletPutAwayApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PalletPutAwayCheckCellGet(cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalletPutAwayCellOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PalletPutAwayCheckCellGet(cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompletePalletPutAwayCommand} [completePalletPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PalletPutAwayCompletePost(completePalletPutAwayCommand?: CompletePalletPutAwayCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalletPutAwayOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PalletPutAwayCompletePost(completePalletPutAwayCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PalletPutAwayCreatePost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalletPutAwayOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PalletPutAwayCreatePost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [putAwayId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PalletPutAwayGetHistoryGet(putAwayId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalletPutAwayHistoryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PalletPutAwayGetHistoryGet(putAwayId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [palletLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PalletPutAwayGetPalletProductsGet(palletLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalletProductDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PalletPutAwayGetPalletProductsGet(palletLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlacePalletCommand} [placePalletCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PalletPutAwayPlacePalletPost(placePalletCommand?: PlacePalletCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalletPutAwayOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PalletPutAwayPlacePalletPost(placePalletCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SelectPalletToPutAwayCommand} [selectPalletToPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PalletPutAwaySelectPalletPost(selectPalletToPutAwayCommand?: SelectPalletToPutAwayCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalletPutAwayZoneOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PalletPutAwaySelectPalletPost(selectPalletToPutAwayCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PalletPutAwayApi - factory interface
 * @export
 */
export const PalletPutAwayApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PalletPutAwayApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletPutAwayCheckCellGet(cellLabel?: string, options?: any): AxiosPromise<PalletPutAwayCellOutputDTO> {
            return localVarFp.apiV1PalletPutAwayCheckCellGet(cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompletePalletPutAwayCommand} [completePalletPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletPutAwayCompletePost(completePalletPutAwayCommand?: CompletePalletPutAwayCommand, options?: any): AxiosPromise<PalletPutAwayOutputDTO> {
            return localVarFp.apiV1PalletPutAwayCompletePost(completePalletPutAwayCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletPutAwayCreatePost(options?: any): AxiosPromise<PalletPutAwayOutputDTO> {
            return localVarFp.apiV1PalletPutAwayCreatePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [putAwayId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletPutAwayGetHistoryGet(putAwayId?: string, options?: any): AxiosPromise<PalletPutAwayHistoryOutputDTO> {
            return localVarFp.apiV1PalletPutAwayGetHistoryGet(putAwayId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [palletLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletPutAwayGetPalletProductsGet(palletLabel?: string, options?: any): AxiosPromise<PalletProductDetailsOutputDTO> {
            return localVarFp.apiV1PalletPutAwayGetPalletProductsGet(palletLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacePalletCommand} [placePalletCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletPutAwayPlacePalletPost(placePalletCommand?: PlacePalletCommand, options?: any): AxiosPromise<PalletPutAwayOutputDTO> {
            return localVarFp.apiV1PalletPutAwayPlacePalletPost(placePalletCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SelectPalletToPutAwayCommand} [selectPalletToPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletPutAwaySelectPalletPost(selectPalletToPutAwayCommand?: SelectPalletToPutAwayCommand, options?: any): AxiosPromise<PalletPutAwayZoneOutputDTO> {
            return localVarFp.apiV1PalletPutAwaySelectPalletPost(selectPalletToPutAwayCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PalletPutAwayApi - object-oriented interface
 * @export
 * @class PalletPutAwayApi
 * @extends {BaseAPI}
 */
export class PalletPutAwayApi extends BaseAPI {
    /**
     * 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalletPutAwayApi
     */
    public apiV1PalletPutAwayCheckCellGet(cellLabel?: string, options?: any) {
        return PalletPutAwayApiFp(this.configuration).apiV1PalletPutAwayCheckCellGet(cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompletePalletPutAwayCommand} [completePalletPutAwayCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalletPutAwayApi
     */
    public apiV1PalletPutAwayCompletePost(completePalletPutAwayCommand?: CompletePalletPutAwayCommand, options?: any) {
        return PalletPutAwayApiFp(this.configuration).apiV1PalletPutAwayCompletePost(completePalletPutAwayCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalletPutAwayApi
     */
    public apiV1PalletPutAwayCreatePost(options?: any) {
        return PalletPutAwayApiFp(this.configuration).apiV1PalletPutAwayCreatePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [putAwayId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalletPutAwayApi
     */
    public apiV1PalletPutAwayGetHistoryGet(putAwayId?: string, options?: any) {
        return PalletPutAwayApiFp(this.configuration).apiV1PalletPutAwayGetHistoryGet(putAwayId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [palletLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalletPutAwayApi
     */
    public apiV1PalletPutAwayGetPalletProductsGet(palletLabel?: string, options?: any) {
        return PalletPutAwayApiFp(this.configuration).apiV1PalletPutAwayGetPalletProductsGet(palletLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacePalletCommand} [placePalletCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalletPutAwayApi
     */
    public apiV1PalletPutAwayPlacePalletPost(placePalletCommand?: PlacePalletCommand, options?: any) {
        return PalletPutAwayApiFp(this.configuration).apiV1PalletPutAwayPlacePalletPost(placePalletCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SelectPalletToPutAwayCommand} [selectPalletToPutAwayCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalletPutAwayApi
     */
    public apiV1PalletPutAwaySelectPalletPost(selectPalletToPutAwayCommand?: SelectPalletToPutAwayCommand, options?: any) {
        return PalletPutAwayApiFp(this.configuration).apiV1PalletPutAwaySelectPalletPost(selectPalletToPutAwayCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PalletReceivingApi - axios parameter creator
 * @export
 */
export const PalletReceivingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddReceivedItemCommand} [addReceivedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletReceivingAddReceivedItemPost: async (addReceivedItemCommand?: AddReceivedItemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PalletReceiving.addReceivedItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addReceivedItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletReceivingCheckWaitingPalletsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PalletReceiving.checkWaitingPallets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [amount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletReceivingGenerateBarcodesPost: async (amount?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PalletReceiving.generateBarcodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [palletLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletReceivingGetSummaryGet: async (palletLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PalletReceiving.getSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (palletLabel !== undefined) {
                localVarQueryParameter['palletLabel'] = palletLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MoveReceivedItemCommand} [moveReceivedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletReceivingMoveReceivedItemPost: async (moveReceivedItemCommand?: MoveReceivedItemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PalletReceiving.moveReceivedItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveReceivedItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletReceivingQueryWaitingPalletsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PalletReceiving.queryWaitingPallets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PalletReceivingApi - functional programming interface
 * @export
 */
export const PalletReceivingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PalletReceivingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddReceivedItemCommand} [addReceivedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PalletReceivingAddReceivedItemPost(addReceivedItemCommand?: AddReceivedItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceItemOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PalletReceivingAddReceivedItemPost(addReceivedItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PalletReceivingCheckWaitingPalletsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckWaitingPutAwayPalletsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PalletReceivingCheckWaitingPalletsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [amount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PalletReceivingGenerateBarcodesPost(amount?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PalletReceivingGenerateBarcodesPost(amount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [palletLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PalletReceivingGetSummaryGet(palletLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalletSummaryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PalletReceivingGetSummaryGet(palletLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MoveReceivedItemCommand} [moveReceivedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PalletReceivingMoveReceivedItemPost(moveReceivedItemCommand?: MoveReceivedItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceItemOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PalletReceivingMoveReceivedItemPost(moveReceivedItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PalletReceivingQueryWaitingPalletsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaitingPutAwayPalletsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PalletReceivingQueryWaitingPalletsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PalletReceivingApi - factory interface
 * @export
 */
export const PalletReceivingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PalletReceivingApiFp(configuration)
    return {
        /**
         * 
         * @param {AddReceivedItemCommand} [addReceivedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletReceivingAddReceivedItemPost(addReceivedItemCommand?: AddReceivedItemCommand, options?: any): AxiosPromise<PlaceItemOutputDTO> {
            return localVarFp.apiV1PalletReceivingAddReceivedItemPost(addReceivedItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletReceivingCheckWaitingPalletsGet(options?: any): AxiosPromise<CheckWaitingPutAwayPalletsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PalletReceivingCheckWaitingPalletsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [amount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletReceivingGenerateBarcodesPost(amount?: number, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiV1PalletReceivingGenerateBarcodesPost(amount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [palletLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletReceivingGetSummaryGet(palletLabel?: string, options?: any): AxiosPromise<PalletSummaryOutputDTO> {
            return localVarFp.apiV1PalletReceivingGetSummaryGet(palletLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MoveReceivedItemCommand} [moveReceivedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletReceivingMoveReceivedItemPost(moveReceivedItemCommand?: MoveReceivedItemCommand, options?: any): AxiosPromise<PlaceItemOutputDTO> {
            return localVarFp.apiV1PalletReceivingMoveReceivedItemPost(moveReceivedItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PalletReceivingQueryWaitingPalletsGet(dqb?: string, options?: any): AxiosPromise<WaitingPutAwayPalletsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PalletReceivingQueryWaitingPalletsGet(dqb, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PalletReceivingApi - object-oriented interface
 * @export
 * @class PalletReceivingApi
 * @extends {BaseAPI}
 */
export class PalletReceivingApi extends BaseAPI {
    /**
     * 
     * @param {AddReceivedItemCommand} [addReceivedItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalletReceivingApi
     */
    public apiV1PalletReceivingAddReceivedItemPost(addReceivedItemCommand?: AddReceivedItemCommand, options?: any) {
        return PalletReceivingApiFp(this.configuration).apiV1PalletReceivingAddReceivedItemPost(addReceivedItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalletReceivingApi
     */
    public apiV1PalletReceivingCheckWaitingPalletsGet(options?: any) {
        return PalletReceivingApiFp(this.configuration).apiV1PalletReceivingCheckWaitingPalletsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [amount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalletReceivingApi
     */
    public apiV1PalletReceivingGenerateBarcodesPost(amount?: number, options?: any) {
        return PalletReceivingApiFp(this.configuration).apiV1PalletReceivingGenerateBarcodesPost(amount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [palletLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalletReceivingApi
     */
    public apiV1PalletReceivingGetSummaryGet(palletLabel?: string, options?: any) {
        return PalletReceivingApiFp(this.configuration).apiV1PalletReceivingGetSummaryGet(palletLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MoveReceivedItemCommand} [moveReceivedItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalletReceivingApi
     */
    public apiV1PalletReceivingMoveReceivedItemPost(moveReceivedItemCommand?: MoveReceivedItemCommand, options?: any) {
        return PalletReceivingApiFp(this.configuration).apiV1PalletReceivingMoveReceivedItemPost(moveReceivedItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalletReceivingApi
     */
    public apiV1PalletReceivingQueryWaitingPalletsGet(dqb?: string, options?: any) {
        return PalletReceivingApiFp(this.configuration).apiV1PalletReceivingQueryWaitingPalletsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PickListRequestsApi - axios parameter creator
 * @export
 */
export const PickListRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DeletePickListRequestsCommand} [deletePickListRequestsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickListRequestsDelete: async (deletePickListRequestsCommand?: DeletePickListRequestsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickListRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deletePickListRequestsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeprioritizePickListRequestsCommand} [deprioritizePickListRequestsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickListRequestsDeprioritizeDelete: async (deprioritizePickListRequestsCommand?: DeprioritizePickListRequestsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickListRequests.deprioritize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deprioritizePickListRequestsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickListRequestsGetBatchNextQrCodeGet: async (referenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickListRequests.getBatchNextQrCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickListRequestsGetPickListRequestStateDetailsGet: async (referenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickListRequests.getPickListRequestStateDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrioritizePickListRequestsCommand} [prioritizePickListRequestsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickListRequestsPrioritizeDelete: async (prioritizePickListRequestsCommand?: PrioritizePickListRequestsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickListRequests.prioritize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prioritizePickListRequestsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} referenceNumber 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickListRequestsQueryPickListRequestPickListDetailsGet: async (referenceNumber: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'referenceNumber' is not null or undefined
            assertParamExists('apiV1PickListRequestsQueryPickListRequestPickListDetailsGet', 'referenceNumber', referenceNumber)
            const localVarPath = `/api/v1/PickListRequests.queryPickListRequestPickListDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} referenceNumber 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickListRequestsQueryPickListRequestSalesOrderDetailsGet: async (referenceNumber: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'referenceNumber' is not null or undefined
            assertParamExists('apiV1PickListRequestsQueryPickListRequestSalesOrderDetailsGet', 'referenceNumber', referenceNumber)
            const localVarPath = `/api/v1/PickListRequests.queryPickListRequestSalesOrderDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickListRequestsQueryPickListRequestsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickListRequests.queryPickListRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PickListRequestsApi - functional programming interface
 * @export
 */
export const PickListRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PickListRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DeletePickListRequestsCommand} [deletePickListRequestsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickListRequestsDelete(deletePickListRequestsCommand?: DeletePickListRequestsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickListRequestsDelete(deletePickListRequestsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeprioritizePickListRequestsCommand} [deprioritizePickListRequestsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickListRequestsDeprioritizeDelete(deprioritizePickListRequestsCommand?: DeprioritizePickListRequestsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickListRequestsDeprioritizeDelete(deprioritizePickListRequestsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickListRequestsGetBatchNextQrCodeGet(referenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickListQrCodeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickListRequestsGetBatchNextQrCodeGet(referenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickListRequestsGetPickListRequestStateDetailsGet(referenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickListRequestStateDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickListRequestsGetPickListRequestStateDetailsGet(referenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrioritizePickListRequestsCommand} [prioritizePickListRequestsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickListRequestsPrioritizeDelete(prioritizePickListRequestsCommand?: PrioritizePickListRequestsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickListRequestsPrioritizeDelete(prioritizePickListRequestsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} referenceNumber 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickListRequestsQueryPickListRequestPickListDetailsGet(referenceNumber: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickListRequestPickListDetailsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickListRequestsQueryPickListRequestPickListDetailsGet(referenceNumber, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} referenceNumber 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickListRequestsQueryPickListRequestSalesOrderDetailsGet(referenceNumber: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickListRequestSalesOrderDetailsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickListRequestsQueryPickListRequestSalesOrderDetailsGet(referenceNumber, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickListRequestsQueryPickListRequestsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickListRequestQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickListRequestsQueryPickListRequestsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PickListRequestsApi - factory interface
 * @export
 */
export const PickListRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PickListRequestsApiFp(configuration)
    return {
        /**
         * 
         * @param {DeletePickListRequestsCommand} [deletePickListRequestsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickListRequestsDelete(deletePickListRequestsCommand?: DeletePickListRequestsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PickListRequestsDelete(deletePickListRequestsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeprioritizePickListRequestsCommand} [deprioritizePickListRequestsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickListRequestsDeprioritizeDelete(deprioritizePickListRequestsCommand?: DeprioritizePickListRequestsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PickListRequestsDeprioritizeDelete(deprioritizePickListRequestsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickListRequestsGetBatchNextQrCodeGet(referenceNumber?: string, options?: any): AxiosPromise<PickListQrCodeOutputDTO> {
            return localVarFp.apiV1PickListRequestsGetBatchNextQrCodeGet(referenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickListRequestsGetPickListRequestStateDetailsGet(referenceNumber?: string, options?: any): AxiosPromise<PickListRequestStateDetailsOutputDTO> {
            return localVarFp.apiV1PickListRequestsGetPickListRequestStateDetailsGet(referenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrioritizePickListRequestsCommand} [prioritizePickListRequestsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickListRequestsPrioritizeDelete(prioritizePickListRequestsCommand?: PrioritizePickListRequestsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PickListRequestsPrioritizeDelete(prioritizePickListRequestsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} referenceNumber 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickListRequestsQueryPickListRequestPickListDetailsGet(referenceNumber: string, dqb?: string, options?: any): AxiosPromise<PickListRequestPickListDetailsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickListRequestsQueryPickListRequestPickListDetailsGet(referenceNumber, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} referenceNumber 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickListRequestsQueryPickListRequestSalesOrderDetailsGet(referenceNumber: string, dqb?: string, options?: any): AxiosPromise<PickListRequestSalesOrderDetailsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickListRequestsQueryPickListRequestSalesOrderDetailsGet(referenceNumber, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickListRequestsQueryPickListRequestsGet(dqb?: string, options?: any): AxiosPromise<PickListRequestQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickListRequestsQueryPickListRequestsGet(dqb, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PickListRequestsApi - object-oriented interface
 * @export
 * @class PickListRequestsApi
 * @extends {BaseAPI}
 */
export class PickListRequestsApi extends BaseAPI {
    /**
     * 
     * @param {DeletePickListRequestsCommand} [deletePickListRequestsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickListRequestsApi
     */
    public apiV1PickListRequestsDelete(deletePickListRequestsCommand?: DeletePickListRequestsCommand, options?: any) {
        return PickListRequestsApiFp(this.configuration).apiV1PickListRequestsDelete(deletePickListRequestsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeprioritizePickListRequestsCommand} [deprioritizePickListRequestsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickListRequestsApi
     */
    public apiV1PickListRequestsDeprioritizeDelete(deprioritizePickListRequestsCommand?: DeprioritizePickListRequestsCommand, options?: any) {
        return PickListRequestsApiFp(this.configuration).apiV1PickListRequestsDeprioritizeDelete(deprioritizePickListRequestsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [referenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickListRequestsApi
     */
    public apiV1PickListRequestsGetBatchNextQrCodeGet(referenceNumber?: string, options?: any) {
        return PickListRequestsApiFp(this.configuration).apiV1PickListRequestsGetBatchNextQrCodeGet(referenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [referenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickListRequestsApi
     */
    public apiV1PickListRequestsGetPickListRequestStateDetailsGet(referenceNumber?: string, options?: any) {
        return PickListRequestsApiFp(this.configuration).apiV1PickListRequestsGetPickListRequestStateDetailsGet(referenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrioritizePickListRequestsCommand} [prioritizePickListRequestsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickListRequestsApi
     */
    public apiV1PickListRequestsPrioritizeDelete(prioritizePickListRequestsCommand?: PrioritizePickListRequestsCommand, options?: any) {
        return PickListRequestsApiFp(this.configuration).apiV1PickListRequestsPrioritizeDelete(prioritizePickListRequestsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} referenceNumber 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickListRequestsApi
     */
    public apiV1PickListRequestsQueryPickListRequestPickListDetailsGet(referenceNumber: string, dqb?: string, options?: any) {
        return PickListRequestsApiFp(this.configuration).apiV1PickListRequestsQueryPickListRequestPickListDetailsGet(referenceNumber, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} referenceNumber 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickListRequestsApi
     */
    public apiV1PickListRequestsQueryPickListRequestSalesOrderDetailsGet(referenceNumber: string, dqb?: string, options?: any) {
        return PickListRequestsApiFp(this.configuration).apiV1PickListRequestsQueryPickListRequestSalesOrderDetailsGet(referenceNumber, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickListRequestsApi
     */
    public apiV1PickListRequestsQueryPickListRequestsGet(dqb?: string, options?: any) {
        return PickListRequestsApiFp(this.configuration).apiV1PickListRequestsQueryPickListRequestsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PickListsApi - axios parameter creator
 * @export
 */
export const PickListsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateRasPickListsForOrdersCommand} [createRasPickListsForOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PickListsCreateRasPickListsForOrdersPost: async (createRasPickListsForOrdersCommand?: CreateRasPickListsForOrdersCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/PickLists/createRasPickListsForOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRasPickListsForOrdersCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForceDeletePickListsCommand} [forceDeletePickListsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PickListsForceDeletePickListsPost: async (forceDeletePickListsCommand?: ForceDeletePickListsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/PickLists/forceDeletePickLists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forceDeletePickListsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PickListsApi - functional programming interface
 * @export
 */
export const PickListsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PickListsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateRasPickListsForOrdersCommand} [createRasPickListsForOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1PickListsCreateRasPickListsForOrdersPost(createRasPickListsForOrdersCommand?: CreateRasPickListsForOrdersCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateRasPickListsForOrdersOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1PickListsCreateRasPickListsForOrdersPost(createRasPickListsForOrdersCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ForceDeletePickListsCommand} [forceDeletePickListsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1PickListsForceDeletePickListsPost(forceDeletePickListsCommand?: ForceDeletePickListsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForceDeletePickListsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1PickListsForceDeletePickListsPost(forceDeletePickListsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PickListsApi - factory interface
 * @export
 */
export const PickListsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PickListsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateRasPickListsForOrdersCommand} [createRasPickListsForOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PickListsCreateRasPickListsForOrdersPost(createRasPickListsForOrdersCommand?: CreateRasPickListsForOrdersCommand, options?: any): AxiosPromise<CreateRasPickListsForOrdersOutputDTO> {
            return localVarFp.supportV1PickListsCreateRasPickListsForOrdersPost(createRasPickListsForOrdersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ForceDeletePickListsCommand} [forceDeletePickListsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PickListsForceDeletePickListsPost(forceDeletePickListsCommand?: ForceDeletePickListsCommand, options?: any): AxiosPromise<ForceDeletePickListsOutputDTO> {
            return localVarFp.supportV1PickListsForceDeletePickListsPost(forceDeletePickListsCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PickListsApi - object-oriented interface
 * @export
 * @class PickListsApi
 * @extends {BaseAPI}
 */
export class PickListsApi extends BaseAPI {
    /**
     * 
     * @param {CreateRasPickListsForOrdersCommand} [createRasPickListsForOrdersCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickListsApi
     */
    public supportV1PickListsCreateRasPickListsForOrdersPost(createRasPickListsForOrdersCommand?: CreateRasPickListsForOrdersCommand, options?: any) {
        return PickListsApiFp(this.configuration).supportV1PickListsCreateRasPickListsForOrdersPost(createRasPickListsForOrdersCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ForceDeletePickListsCommand} [forceDeletePickListsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickListsApi
     */
    public supportV1PickListsForceDeletePickListsPost(forceDeletePickListsCommand?: ForceDeletePickListsCommand, options?: any) {
        return PickListsApiFp(this.configuration).supportV1PickListsForceDeletePickListsPost(forceDeletePickListsCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PickingProcessApi - axios parameter creator
 * @export
 */
export const PickingProcessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {number} [pickingReferenceNumber] 
         * @param {string} [productLabels] 
         * @param {string} [cellLabel] 
         * @param {string} [pickingToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCheckBarcodeTypeGet: async (barcode?: string, pickingReferenceNumber?: number, productLabels?: string, cellLabel?: string, pickingToteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.checkBarcodeType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }

            if (pickingReferenceNumber !== undefined) {
                localVarQueryParameter['pickingReferenceNumber'] = pickingReferenceNumber;
            }

            if (productLabels !== undefined) {
                localVarQueryParameter['productLabels'] = productLabels;
            }

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }

            if (pickingToteLabel !== undefined) {
                localVarQueryParameter['pickingToteLabel'] = pickingToteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckCellCommand} [checkCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCheckCellPost: async (checkCellCommand?: CheckCellCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.checkCell`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkCellCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCheckIfControlCountingIsActiveGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.checkIfControlCountingIsActive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {string} [productLabel] 
         * @param {number} [allocatedItemId] 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCheckPickingProductSerialNumberGet: async (cellLabel?: string, productLabel?: string, allocatedItemId?: number, serialNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.checkPickingProductSerialNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellLabel !== undefined) {
                localVarQueryParameter['CellLabel'] = cellLabel;
            }

            if (productLabel !== undefined) {
                localVarQueryParameter['ProductLabel'] = productLabel;
            }

            if (allocatedItemId !== undefined) {
                localVarQueryParameter['AllocatedItemId'] = allocatedItemId;
            }

            if (serialNumber !== undefined) {
                localVarQueryParameter['SerialNumber'] = serialNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckPickingItemExistCommand} [checkPickingItemExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCheckProductExistPost: async (checkPickingItemExistCommand?: CheckPickingItemExistCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.checkProductExist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkPickingItemExistCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [productBarcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCheckProductForControlCountingGet: async (productBarcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.checkProductForControlCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (productBarcode !== undefined) {
                localVarQueryParameter['productBarcode'] = productBarcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCheckUserActivePickingGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.checkUserActivePicking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompletePickingProcessCommand} [completePickingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCompletePickingProcessPost: async (completePickingProcessCommand?: CompletePickingProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.completePickingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completePickingProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ContinuePickingIfExistCommand} [continuePickingIfExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessContinueIfExistPost: async (continuePickingIfExistCommand?: ContinuePickingIfExistCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.continueIfExist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(continuePickingIfExistCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePickingProcessCommand} [createPickingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCreatePost: async (createPickingProcessCommand?: CreatePickingProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPickingProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePickingProcessCommandWithQrCode} [createPickingProcessCommandWithQrCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCreateWithQrCodePost: async (createPickingProcessCommandWithQrCode?: CreatePickingProcessCommandWithQrCode, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.createWithQrCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPickingProcessCommandWithQrCode, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeletePickListsCommand} [deletePickListsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessDeletePickListsDelete: async (deletePickListsCommand?: DeletePickListsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.deletePickLists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deletePickListsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessGetIsPickingStockZoneInputActiveGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.getIsPickingStockZoneInputActive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [pickListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessGetPickListDetailsGet: async (pickListId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.getPickListDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (pickListId !== undefined) {
                localVarQueryParameter['pickListId'] = pickListId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessGetPickingProcessMissingItemsGet: async (referenceNumber?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.getPickingProcessMissingItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [pickingProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessGetPickingRouteElementsGet: async (pickingProcessId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.getPickingRouteElements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (pickingProcessId !== undefined) {
                localVarQueryParameter['pickingProcessId'] = pickingProcessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessGetZoneByCellLabelGet: async (cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.getZoneByCellLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LostItemCommand} [lostItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessLostItemPost: async (lostItemCommand?: LostItemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.lostItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lostItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceProductToPickingToteCommand} [placeProductToPickingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessPlaceProductPost: async (placeProductToPickingToteCommand?: PlaceProductToPickingToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.placeProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeProductToPickingToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SalesOrderPickingPriority} priority 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessPrioritizeAllSalesOrdersGet: async (priority: SalesOrderPickingPriority, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'priority' is not null or undefined
            assertParamExists('apiV1PickingProcessPrioritizeAllSalesOrdersGet', 'priority', priority)
            const localVarPath = `/api/v1/PickingProcess.prioritizeAllSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (priority !== undefined) {
                localVarQueryParameter['priority'] = priority;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrioritizeSalesOrdersCommand} [prioritizeSalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessPrioritizeSalesOrdersPost: async (prioritizeSalesOrdersCommand?: PrioritizeSalesOrdersCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.prioritizeSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prioritizeSalesOrdersCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryActivePickingProcessesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.queryActivePickingProcesses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryAvailablePickingTrolleysGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.queryAvailablePickingTrolleys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} toteLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryDropAddressedPickingToteDetailsGet: async (toteLabel: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'toteLabel' is not null or undefined
            assertParamExists('apiV1PickingProcessQueryDropAddressedPickingToteDetailsGet', 'toteLabel', toteLabel)
            const localVarPath = `/api/v1/PickingProcess.queryDropAddressedPickingToteDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryDropAddressedPickingTotesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.queryDropAddressedPickingTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cellLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryPickListExpectedItemsByCellLabelGet: async (cellLabel: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cellLabel' is not null or undefined
            assertParamExists('apiV1PickingProcessQueryPickListExpectedItemsByCellLabelGet', 'cellLabel', cellLabel)
            const localVarPath = `/api/v1/PickingProcess.queryPickListExpectedItemsByCellLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pickListId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryPickListPickingHistoryGet: async (pickListId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pickListId' is not null or undefined
            assertParamExists('apiV1PickingProcessQueryPickListPickingHistoryGet', 'pickListId', pickListId)
            const localVarPath = `/api/v1/PickingProcess.queryPickListPickingHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (pickListId !== undefined) {
                localVarQueryParameter['pickListId'] = pickListId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pickListId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryPickListPickingPlanGet: async (pickListId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pickListId' is not null or undefined
            assertParamExists('apiV1PickingProcessQueryPickListPickingPlanGet', 'pickListId', pickListId)
            const localVarPath = `/api/v1/PickingProcess.queryPickListPickingPlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (pickListId !== undefined) {
                localVarQueryParameter['pickListId'] = pickListId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pickListId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryPickListSalesOrdersGet: async (pickListId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pickListId' is not null or undefined
            assertParamExists('apiV1PickingProcessQueryPickListSalesOrdersGet', 'pickListId', pickListId)
            const localVarPath = `/api/v1/PickingProcess.queryPickListSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (pickListId !== undefined) {
                localVarQueryParameter['pickListId'] = pickListId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryPickListsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.queryPickLists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryPickPerformanceGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.queryPickPerformance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryPickingQuarantineTotesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.queryPickingQuarantineTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryPrioritizedSalesOrdersGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.queryPrioritizedSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryWaitingForPickingSalesOrdersGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.queryWaitingForPickingSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RemovePickingPrioritiesCommand} [removePickingPrioritiesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessRemovePickingPrioritiesPost: async (removePickingPrioritiesCommand?: RemovePickingPrioritiesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.removePickingPriorities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removePickingPrioritiesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetProductsControlCountingCommand} [setProductsControlCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessSetProductsControlCountingPost: async (setProductsControlCountingCommand?: SetProductsControlCountingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.setProductsControlCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setProductsControlCountingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetToteUnavailableForControlCountingCommand} [setToteUnavailableForControlCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessSetToteUnavailableForControlCountingPost: async (setToteUnavailableForControlCountingCommand?: SetToteUnavailableForControlCountingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.setToteUnavailableForControlCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setToteUnavailableForControlCountingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartCreatedPickingCommand} [startCreatedPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessStartCreatedPickingPost: async (startCreatedPickingCommand?: StartCreatedPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingProcess.startCreatedPicking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startCreatedPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PickingProcessApi - functional programming interface
 * @export
 */
export const PickingProcessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PickingProcessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {number} [pickingReferenceNumber] 
         * @param {string} [productLabels] 
         * @param {string} [cellLabel] 
         * @param {string} [pickingToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessCheckBarcodeTypeGet(barcode?: string, pickingReferenceNumber?: number, productLabels?: string, cellLabel?: string, pickingToteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckBarcodeTypeForMultiItemPickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessCheckBarcodeTypeGet(barcode, pickingReferenceNumber, productLabels, cellLabel, pickingToteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckCellCommand} [checkCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessCheckCellPost(checkCellCommand?: CheckCellCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessCheckCellPost(checkCellCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessCheckIfControlCountingIsActiveGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckIfControlCountingIsActiveOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessCheckIfControlCountingIsActiveGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {string} [productLabel] 
         * @param {number} [allocatedItemId] 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessCheckPickingProductSerialNumberGet(cellLabel?: string, productLabel?: string, allocatedItemId?: number, serialNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckPickingProductSerialNumberOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessCheckPickingProductSerialNumberGet(cellLabel, productLabel, allocatedItemId, serialNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckPickingItemExistCommand} [checkPickingItemExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessCheckProductExistPost(checkPickingItemExistCommand?: CheckPickingItemExistCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessCheckProductExistPost(checkPickingItemExistCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [productBarcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessCheckProductForControlCountingGet(productBarcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProductForControlCountingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessCheckProductForControlCountingGet(productBarcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessCheckUserActivePickingGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckUserActivePickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessCheckUserActivePickingGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompletePickingProcessCommand} [completePickingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessCompletePickingProcessPost(completePickingProcessCommand?: CompletePickingProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessCompletePickingProcessPost(completePickingProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ContinuePickingIfExistCommand} [continuePickingIfExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessContinueIfExistPost(continuePickingIfExistCommand?: ContinuePickingIfExistCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContinuePickingIfExistCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessContinueIfExistPost(continuePickingIfExistCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePickingProcessCommand} [createPickingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessCreatePost(createPickingProcessCommand?: CreatePickingProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePickingProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessCreatePost(createPickingProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePickingProcessCommandWithQrCode} [createPickingProcessCommandWithQrCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessCreateWithQrCodePost(createPickingProcessCommandWithQrCode?: CreatePickingProcessCommandWithQrCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePickingProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessCreateWithQrCodePost(createPickingProcessCommandWithQrCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeletePickListsCommand} [deletePickListsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessDeletePickListsDelete(deletePickListsCommand?: DeletePickListsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeletedPickListsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessDeletePickListsDelete(deletePickListsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessGetIsPickingStockZoneInputActiveGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIsPickingStockZoneInputActiveOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessGetIsPickingStockZoneInputActiveGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [pickListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessGetPickListDetailsGet(pickListId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickListDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessGetPickListDetailsGet(pickListId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessGetPickingProcessMissingItemsGet(referenceNumber?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MissingItemOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessGetPickingProcessMissingItemsGet(referenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [pickingProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessGetPickingRouteElementsGet(pickingProcessId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPickingRouteElementsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessGetPickingRouteElementsGet(pickingProcessId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessGetZoneByCellLabelGet(cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetZoneByCellLabelOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessGetZoneByCellLabelGet(cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LostItemCommand} [lostItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessLostItemPost(lostItemCommand?: LostItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessLostItemPost(lostItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceProductToPickingToteCommand} [placeProductToPickingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessPlaceProductPost(placeProductToPickingToteCommand?: PlaceProductToPickingToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessPlaceProductPost(placeProductToPickingToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SalesOrderPickingPriority} priority 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessPrioritizeAllSalesOrdersGet(priority: SalesOrderPickingPriority, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaitingForPickingSalesOrdersOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessPrioritizeAllSalesOrdersGet(priority, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrioritizeSalesOrdersCommand} [prioritizeSalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessPrioritizeSalesOrdersPost(prioritizeSalesOrdersCommand?: PrioritizeSalesOrdersCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SalesOrderPrioritizationFailedOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessPrioritizeSalesOrdersPost(prioritizeSalesOrdersCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessQueryActivePickingProcessesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivePickingProcessesOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessQueryActivePickingProcessesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessQueryAvailablePickingTrolleysGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailablePickingTrolleysOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessQueryAvailablePickingTrolleysGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} toteLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessQueryDropAddressedPickingToteDetailsGet(toteLabel: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryDropAddressedPickingToteDetailsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessQueryDropAddressedPickingToteDetailsGet(toteLabel, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessQueryDropAddressedPickingTotesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryDropAddressedPickingTotesOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessQueryDropAddressedPickingTotesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} cellLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessQueryPickListExpectedItemsByCellLabelGet(cellLabel: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickListPickingPlanByCellLabelOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessQueryPickListExpectedItemsByCellLabelGet(cellLabel, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} pickListId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessQueryPickListPickingHistoryGet(pickListId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickListPickingHistoryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessQueryPickListPickingHistoryGet(pickListId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} pickListId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessQueryPickListPickingPlanGet(pickListId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickListPickingPlanOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessQueryPickListPickingPlanGet(pickListId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} pickListId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessQueryPickListSalesOrdersGet(pickListId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickListSalesOrdersOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessQueryPickListSalesOrdersGet(pickListId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessQueryPickListsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryPickListsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessQueryPickListsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessQueryPickPerformanceGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPickPerformanceOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessQueryPickPerformanceGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessQueryPickingQuarantineTotesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickingQuarantineTotesOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessQueryPickingQuarantineTotesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessQueryPrioritizedSalesOrdersGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrioritizedSalesOrderOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessQueryPrioritizedSalesOrdersGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessQueryWaitingForPickingSalesOrdersGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaitingForPickingSalesOrdersOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessQueryWaitingForPickingSalesOrdersGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RemovePickingPrioritiesCommand} [removePickingPrioritiesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessRemovePickingPrioritiesPost(removePickingPrioritiesCommand?: RemovePickingPrioritiesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SalesOrderPrioritizationFailedOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessRemovePickingPrioritiesPost(removePickingPrioritiesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetProductsControlCountingCommand} [setProductsControlCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessSetProductsControlCountingPost(setProductsControlCountingCommand?: SetProductsControlCountingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductControlCountingResultOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessSetProductsControlCountingPost(setProductsControlCountingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetToteUnavailableForControlCountingCommand} [setToteUnavailableForControlCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessSetToteUnavailableForControlCountingPost(setToteUnavailableForControlCountingCommand?: SetToteUnavailableForControlCountingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessSetToteUnavailableForControlCountingPost(setToteUnavailableForControlCountingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StartCreatedPickingCommand} [startCreatedPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingProcessStartCreatedPickingPost(startCreatedPickingCommand?: StartCreatedPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingProcessStartCreatedPickingPost(startCreatedPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PickingProcessApi - factory interface
 * @export
 */
export const PickingProcessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PickingProcessApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {number} [pickingReferenceNumber] 
         * @param {string} [productLabels] 
         * @param {string} [cellLabel] 
         * @param {string} [pickingToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCheckBarcodeTypeGet(barcode?: string, pickingReferenceNumber?: number, productLabels?: string, cellLabel?: string, pickingToteLabel?: string, options?: any): AxiosPromise<CheckBarcodeTypeForMultiItemPickingOutputDTO> {
            return localVarFp.apiV1PickingProcessCheckBarcodeTypeGet(barcode, pickingReferenceNumber, productLabels, cellLabel, pickingToteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckCellCommand} [checkCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCheckCellPost(checkCellCommand?: CheckCellCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PickingProcessCheckCellPost(checkCellCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCheckIfControlCountingIsActiveGet(options?: any): AxiosPromise<CheckIfControlCountingIsActiveOutputDTO> {
            return localVarFp.apiV1PickingProcessCheckIfControlCountingIsActiveGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {string} [productLabel] 
         * @param {number} [allocatedItemId] 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCheckPickingProductSerialNumberGet(cellLabel?: string, productLabel?: string, allocatedItemId?: number, serialNumber?: string, options?: any): AxiosPromise<CheckPickingProductSerialNumberOutputDTO> {
            return localVarFp.apiV1PickingProcessCheckPickingProductSerialNumberGet(cellLabel, productLabel, allocatedItemId, serialNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckPickingItemExistCommand} [checkPickingItemExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCheckProductExistPost(checkPickingItemExistCommand?: CheckPickingItemExistCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PickingProcessCheckProductExistPost(checkPickingItemExistCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [productBarcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCheckProductForControlCountingGet(productBarcode?: string, options?: any): AxiosPromise<CheckProductForControlCountingOutputDTO> {
            return localVarFp.apiV1PickingProcessCheckProductForControlCountingGet(productBarcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCheckUserActivePickingGet(dqb?: string, options?: any): AxiosPromise<CheckUserActivePickingOutputDTO> {
            return localVarFp.apiV1PickingProcessCheckUserActivePickingGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompletePickingProcessCommand} [completePickingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCompletePickingProcessPost(completePickingProcessCommand?: CompletePickingProcessCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PickingProcessCompletePickingProcessPost(completePickingProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContinuePickingIfExistCommand} [continuePickingIfExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessContinueIfExistPost(continuePickingIfExistCommand?: ContinuePickingIfExistCommand, options?: any): AxiosPromise<ContinuePickingIfExistCommandOutputDTO> {
            return localVarFp.apiV1PickingProcessContinueIfExistPost(continuePickingIfExistCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePickingProcessCommand} [createPickingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCreatePost(createPickingProcessCommand?: CreatePickingProcessCommand, options?: any): AxiosPromise<CreatePickingProcessOutputDTO> {
            return localVarFp.apiV1PickingProcessCreatePost(createPickingProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePickingProcessCommandWithQrCode} [createPickingProcessCommandWithQrCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessCreateWithQrCodePost(createPickingProcessCommandWithQrCode?: CreatePickingProcessCommandWithQrCode, options?: any): AxiosPromise<CreatePickingProcessOutputDTO> {
            return localVarFp.apiV1PickingProcessCreateWithQrCodePost(createPickingProcessCommandWithQrCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeletePickListsCommand} [deletePickListsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessDeletePickListsDelete(deletePickListsCommand?: DeletePickListsCommand, options?: any): AxiosPromise<DeletedPickListsOutputDTO> {
            return localVarFp.apiV1PickingProcessDeletePickListsDelete(deletePickListsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessGetIsPickingStockZoneInputActiveGet(options?: any): AxiosPromise<GetIsPickingStockZoneInputActiveOutputDTO> {
            return localVarFp.apiV1PickingProcessGetIsPickingStockZoneInputActiveGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [pickListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessGetPickListDetailsGet(pickListId?: string, options?: any): AxiosPromise<PickListDetailsOutputDTO> {
            return localVarFp.apiV1PickingProcessGetPickListDetailsGet(pickListId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessGetPickingProcessMissingItemsGet(referenceNumber?: number, options?: any): AxiosPromise<Array<MissingItemOutputDTO>> {
            return localVarFp.apiV1PickingProcessGetPickingProcessMissingItemsGet(referenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [pickingProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessGetPickingRouteElementsGet(pickingProcessId?: string, options?: any): AxiosPromise<GetPickingRouteElementsOutputDTO> {
            return localVarFp.apiV1PickingProcessGetPickingRouteElementsGet(pickingProcessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessGetZoneByCellLabelGet(cellLabel?: string, options?: any): AxiosPromise<GetZoneByCellLabelOutputDTO> {
            return localVarFp.apiV1PickingProcessGetZoneByCellLabelGet(cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LostItemCommand} [lostItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessLostItemPost(lostItemCommand?: LostItemCommand, options?: any): AxiosPromise<RouteOutputDTO> {
            return localVarFp.apiV1PickingProcessLostItemPost(lostItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceProductToPickingToteCommand} [placeProductToPickingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessPlaceProductPost(placeProductToPickingToteCommand?: PlaceProductToPickingToteCommand, options?: any): AxiosPromise<RouteOutputDTO> {
            return localVarFp.apiV1PickingProcessPlaceProductPost(placeProductToPickingToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SalesOrderPickingPriority} priority 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessPrioritizeAllSalesOrdersGet(priority: SalesOrderPickingPriority, dqb?: string, options?: any): AxiosPromise<WaitingForPickingSalesOrdersOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingProcessPrioritizeAllSalesOrdersGet(priority, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrioritizeSalesOrdersCommand} [prioritizeSalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessPrioritizeSalesOrdersPost(prioritizeSalesOrdersCommand?: PrioritizeSalesOrdersCommand, options?: any): AxiosPromise<Array<SalesOrderPrioritizationFailedOutputDTO>> {
            return localVarFp.apiV1PickingProcessPrioritizeSalesOrdersPost(prioritizeSalesOrdersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryActivePickingProcessesGet(dqb?: string, options?: any): AxiosPromise<ActivePickingProcessesOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingProcessQueryActivePickingProcessesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryAvailablePickingTrolleysGet(dqb?: string, options?: any): AxiosPromise<AvailablePickingTrolleysOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingProcessQueryAvailablePickingTrolleysGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} toteLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryDropAddressedPickingToteDetailsGet(toteLabel: string, dqb?: string, options?: any): AxiosPromise<QueryDropAddressedPickingToteDetailsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingProcessQueryDropAddressedPickingToteDetailsGet(toteLabel, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryDropAddressedPickingTotesGet(dqb?: string, options?: any): AxiosPromise<QueryDropAddressedPickingTotesOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingProcessQueryDropAddressedPickingTotesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cellLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryPickListExpectedItemsByCellLabelGet(cellLabel: string, dqb?: string, options?: any): AxiosPromise<PickListPickingPlanByCellLabelOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingProcessQueryPickListExpectedItemsByCellLabelGet(cellLabel, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} pickListId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryPickListPickingHistoryGet(pickListId: string, dqb?: string, options?: any): AxiosPromise<PickListPickingHistoryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingProcessQueryPickListPickingHistoryGet(pickListId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} pickListId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryPickListPickingPlanGet(pickListId: string, dqb?: string, options?: any): AxiosPromise<PickListPickingPlanOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingProcessQueryPickListPickingPlanGet(pickListId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} pickListId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryPickListSalesOrdersGet(pickListId: string, dqb?: string, options?: any): AxiosPromise<PickListSalesOrdersOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingProcessQueryPickListSalesOrdersGet(pickListId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryPickListsGet(dqb?: string, options?: any): AxiosPromise<QueryPickListsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingProcessQueryPickListsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryPickPerformanceGet(options?: any): AxiosPromise<UserPickPerformanceOutputDTO> {
            return localVarFp.apiV1PickingProcessQueryPickPerformanceGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryPickingQuarantineTotesGet(dqb?: string, options?: any): AxiosPromise<PickingQuarantineTotesOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingProcessQueryPickingQuarantineTotesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryPrioritizedSalesOrdersGet(dqb?: string, options?: any): AxiosPromise<PrioritizedSalesOrderOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingProcessQueryPrioritizedSalesOrdersGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessQueryWaitingForPickingSalesOrdersGet(dqb?: string, options?: any): AxiosPromise<WaitingForPickingSalesOrdersOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingProcessQueryWaitingForPickingSalesOrdersGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RemovePickingPrioritiesCommand} [removePickingPrioritiesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessRemovePickingPrioritiesPost(removePickingPrioritiesCommand?: RemovePickingPrioritiesCommand, options?: any): AxiosPromise<Array<SalesOrderPrioritizationFailedOutputDTO>> {
            return localVarFp.apiV1PickingProcessRemovePickingPrioritiesPost(removePickingPrioritiesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetProductsControlCountingCommand} [setProductsControlCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessSetProductsControlCountingPost(setProductsControlCountingCommand?: SetProductsControlCountingCommand, options?: any): AxiosPromise<ProductControlCountingResultOutputDTO> {
            return localVarFp.apiV1PickingProcessSetProductsControlCountingPost(setProductsControlCountingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetToteUnavailableForControlCountingCommand} [setToteUnavailableForControlCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessSetToteUnavailableForControlCountingPost(setToteUnavailableForControlCountingCommand?: SetToteUnavailableForControlCountingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PickingProcessSetToteUnavailableForControlCountingPost(setToteUnavailableForControlCountingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StartCreatedPickingCommand} [startCreatedPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingProcessStartCreatedPickingPost(startCreatedPickingCommand?: StartCreatedPickingCommand, options?: any): AxiosPromise<RouteOutputDTO> {
            return localVarFp.apiV1PickingProcessStartCreatedPickingPost(startCreatedPickingCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PickingProcessApi - object-oriented interface
 * @export
 * @class PickingProcessApi
 * @extends {BaseAPI}
 */
export class PickingProcessApi extends BaseAPI {
    /**
     * 
     * @param {string} [barcode] 
     * @param {number} [pickingReferenceNumber] 
     * @param {string} [productLabels] 
     * @param {string} [cellLabel] 
     * @param {string} [pickingToteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessCheckBarcodeTypeGet(barcode?: string, pickingReferenceNumber?: number, productLabels?: string, cellLabel?: string, pickingToteLabel?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessCheckBarcodeTypeGet(barcode, pickingReferenceNumber, productLabels, cellLabel, pickingToteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckCellCommand} [checkCellCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessCheckCellPost(checkCellCommand?: CheckCellCommand, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessCheckCellPost(checkCellCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessCheckIfControlCountingIsActiveGet(options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessCheckIfControlCountingIsActiveGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cellLabel] 
     * @param {string} [productLabel] 
     * @param {number} [allocatedItemId] 
     * @param {string} [serialNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessCheckPickingProductSerialNumberGet(cellLabel?: string, productLabel?: string, allocatedItemId?: number, serialNumber?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessCheckPickingProductSerialNumberGet(cellLabel, productLabel, allocatedItemId, serialNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckPickingItemExistCommand} [checkPickingItemExistCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessCheckProductExistPost(checkPickingItemExistCommand?: CheckPickingItemExistCommand, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessCheckProductExistPost(checkPickingItemExistCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [productBarcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessCheckProductForControlCountingGet(productBarcode?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessCheckProductForControlCountingGet(productBarcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessCheckUserActivePickingGet(dqb?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessCheckUserActivePickingGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompletePickingProcessCommand} [completePickingProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessCompletePickingProcessPost(completePickingProcessCommand?: CompletePickingProcessCommand, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessCompletePickingProcessPost(completePickingProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContinuePickingIfExistCommand} [continuePickingIfExistCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessContinueIfExistPost(continuePickingIfExistCommand?: ContinuePickingIfExistCommand, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessContinueIfExistPost(continuePickingIfExistCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePickingProcessCommand} [createPickingProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessCreatePost(createPickingProcessCommand?: CreatePickingProcessCommand, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessCreatePost(createPickingProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePickingProcessCommandWithQrCode} [createPickingProcessCommandWithQrCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessCreateWithQrCodePost(createPickingProcessCommandWithQrCode?: CreatePickingProcessCommandWithQrCode, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessCreateWithQrCodePost(createPickingProcessCommandWithQrCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeletePickListsCommand} [deletePickListsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessDeletePickListsDelete(deletePickListsCommand?: DeletePickListsCommand, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessDeletePickListsDelete(deletePickListsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessGetIsPickingStockZoneInputActiveGet(options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessGetIsPickingStockZoneInputActiveGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [pickListId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessGetPickListDetailsGet(pickListId?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessGetPickListDetailsGet(pickListId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [referenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessGetPickingProcessMissingItemsGet(referenceNumber?: number, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessGetPickingProcessMissingItemsGet(referenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [pickingProcessId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessGetPickingRouteElementsGet(pickingProcessId?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessGetPickingRouteElementsGet(pickingProcessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessGetZoneByCellLabelGet(cellLabel?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessGetZoneByCellLabelGet(cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LostItemCommand} [lostItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessLostItemPost(lostItemCommand?: LostItemCommand, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessLostItemPost(lostItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceProductToPickingToteCommand} [placeProductToPickingToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessPlaceProductPost(placeProductToPickingToteCommand?: PlaceProductToPickingToteCommand, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessPlaceProductPost(placeProductToPickingToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SalesOrderPickingPriority} priority 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessPrioritizeAllSalesOrdersGet(priority: SalesOrderPickingPriority, dqb?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessPrioritizeAllSalesOrdersGet(priority, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrioritizeSalesOrdersCommand} [prioritizeSalesOrdersCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessPrioritizeSalesOrdersPost(prioritizeSalesOrdersCommand?: PrioritizeSalesOrdersCommand, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessPrioritizeSalesOrdersPost(prioritizeSalesOrdersCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessQueryActivePickingProcessesGet(dqb?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessQueryActivePickingProcessesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessQueryAvailablePickingTrolleysGet(dqb?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessQueryAvailablePickingTrolleysGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} toteLabel 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessQueryDropAddressedPickingToteDetailsGet(toteLabel: string, dqb?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessQueryDropAddressedPickingToteDetailsGet(toteLabel, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessQueryDropAddressedPickingTotesGet(dqb?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessQueryDropAddressedPickingTotesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cellLabel 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessQueryPickListExpectedItemsByCellLabelGet(cellLabel: string, dqb?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessQueryPickListExpectedItemsByCellLabelGet(cellLabel, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} pickListId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessQueryPickListPickingHistoryGet(pickListId: string, dqb?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessQueryPickListPickingHistoryGet(pickListId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} pickListId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessQueryPickListPickingPlanGet(pickListId: string, dqb?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessQueryPickListPickingPlanGet(pickListId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} pickListId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessQueryPickListSalesOrdersGet(pickListId: string, dqb?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessQueryPickListSalesOrdersGet(pickListId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessQueryPickListsGet(dqb?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessQueryPickListsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessQueryPickPerformanceGet(options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessQueryPickPerformanceGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessQueryPickingQuarantineTotesGet(dqb?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessQueryPickingQuarantineTotesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessQueryPrioritizedSalesOrdersGet(dqb?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessQueryPrioritizedSalesOrdersGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessQueryWaitingForPickingSalesOrdersGet(dqb?: string, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessQueryWaitingForPickingSalesOrdersGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RemovePickingPrioritiesCommand} [removePickingPrioritiesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessRemovePickingPrioritiesPost(removePickingPrioritiesCommand?: RemovePickingPrioritiesCommand, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessRemovePickingPrioritiesPost(removePickingPrioritiesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetProductsControlCountingCommand} [setProductsControlCountingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessSetProductsControlCountingPost(setProductsControlCountingCommand?: SetProductsControlCountingCommand, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessSetProductsControlCountingPost(setProductsControlCountingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetToteUnavailableForControlCountingCommand} [setToteUnavailableForControlCountingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessSetToteUnavailableForControlCountingPost(setToteUnavailableForControlCountingCommand?: SetToteUnavailableForControlCountingCommand, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessSetToteUnavailableForControlCountingPost(setToteUnavailableForControlCountingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StartCreatedPickingCommand} [startCreatedPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingProcessApi
     */
    public apiV1PickingProcessStartCreatedPickingPost(startCreatedPickingCommand?: StartCreatedPickingCommand, options?: any) {
        return PickingProcessApiFp(this.configuration).apiV1PickingProcessStartCreatedPickingPost(startCreatedPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PickingSingleItemApi - axios parameter creator
 * @export
 */
export const PickingSingleItemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemCheckBarcodeTypeGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItem.checkBarcodeType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckCellForSingleItemPickingCommand} [checkCellForSingleItemPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemCheckCellPost: async (checkCellForSingleItemPickingCommand?: CheckCellForSingleItemPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItem.checkCell`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkCellForSingleItemPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemCheckIfControlCountingIsActiveGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItem.checkIfControlCountingIsActive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompletePickingProcessForSingleItemPickingCommand} [completePickingProcessForSingleItemPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemCompletePickingProcessPost: async (completePickingProcessForSingleItemPickingCommand?: CompletePickingProcessForSingleItemPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItem.completePickingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completePickingProcessForSingleItemPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand} [forceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemForceCompletePickingProcessAndPlaceTrolleyToParkAddressPost: async (forceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand?: ForceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItem.forceCompletePickingProcessAndPlaceTrolleyToParkAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemGetSingleItemPickingTrolleyTotesGet: async (trolleyLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItem.getSingleItemPickingTrolleyTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (trolleyLabel !== undefined) {
                localVarQueryParameter['trolleyLabel'] = trolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LostItemForSingleItemPickingCommand} [lostItemForSingleItemPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemLostItemPost: async (lostItemForSingleItemPickingCommand?: LostItemForSingleItemPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItem.lostItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lostItemForSingleItemPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MountToteToSingleItemPickingTrolleyCommand} [mountToteToSingleItemPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemMountToteToTrolleyIfNotMountedPost: async (mountToteToSingleItemPickingTrolleyCommand?: MountToteToSingleItemPickingTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItem.mountToteToTrolleyIfNotMounted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mountToteToSingleItemPickingTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceProductForSingleItemPickingCommand} [placeProductForSingleItemPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemPlaceProductPost: async (placeProductForSingleItemPickingCommand?: PlaceProductForSingleItemPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItem.placeProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeProductForSingleItemPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceSingleItemPickingTrolleyToParkAddressCommand} [placeSingleItemPickingTrolleyToParkAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemPlaceSingleItemPickingTrolleyToParkAddressPost: async (placeSingleItemPickingTrolleyToParkAddressCommand?: PlaceSingleItemPickingTrolleyToParkAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItem.placeSingleItemPickingTrolleyToParkAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeSingleItemPickingTrolleyToParkAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} toteLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemQuerySingleItemPickingToteDetailsGet: async (toteLabel: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'toteLabel' is not null or undefined
            assertParamExists('apiV1PickingSingleItemQuerySingleItemPickingToteDetailsGet', 'toteLabel', toteLabel)
            const localVarPath = `/api/v1/PickingSingleItem.querySingleItemPickingToteDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemQuerySingleItemPickingTotesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItem.querySingleItemPickingTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartCreatedPickingForSingleItemPickingCommand} [startCreatedPickingForSingleItemPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemStartCreatedPickingPost: async (startCreatedPickingForSingleItemPickingCommand?: StartCreatedPickingForSingleItemPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItem.startCreatedPicking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startCreatedPickingForSingleItemPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnmountToteFromSingleItemPickingTrolleyCommand} [unmountToteFromSingleItemPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemUnmountToteFromTrolleyPost: async (unmountToteFromSingleItemPickingTrolleyCommand?: UnmountToteFromSingleItemPickingTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItem.unmountToteFromTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unmountToteFromSingleItemPickingTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PickingSingleItemApi - functional programming interface
 * @export
 */
export const PickingSingleItemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PickingSingleItemApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemCheckBarcodeTypeGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckBarcodeTypeForSingleItemPickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemCheckBarcodeTypeGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckCellForSingleItemPickingCommand} [checkCellForSingleItemPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemCheckCellPost(checkCellForSingleItemPickingCommand?: CheckCellForSingleItemPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemCheckCellPost(checkCellForSingleItemPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemCheckIfControlCountingIsActiveGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckIfControlCountingIsActiveForSingleItemPickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemCheckIfControlCountingIsActiveGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompletePickingProcessForSingleItemPickingCommand} [completePickingProcessForSingleItemPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemCompletePickingProcessPost(completePickingProcessForSingleItemPickingCommand?: CompletePickingProcessForSingleItemPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemCompletePickingProcessPost(completePickingProcessForSingleItemPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ForceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand} [forceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemForceCompletePickingProcessAndPlaceTrolleyToParkAddressPost(forceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand?: ForceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemForceCompletePickingProcessAndPlaceTrolleyToParkAddressPost(forceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemGetSingleItemPickingTrolleyTotesGet(trolleyLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSingleItemPickingTrolleyTotesOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemGetSingleItemPickingTrolleyTotesGet(trolleyLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LostItemForSingleItemPickingCommand} [lostItemForSingleItemPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemLostItemPost(lostItemForSingleItemPickingCommand?: LostItemForSingleItemPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LostItemForSingleItemPickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemLostItemPost(lostItemForSingleItemPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MountToteToSingleItemPickingTrolleyCommand} [mountToteToSingleItemPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemMountToteToTrolleyIfNotMountedPost(mountToteToSingleItemPickingTrolleyCommand?: MountToteToSingleItemPickingTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MountToteToSingleItemPickingTrolleyCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemMountToteToTrolleyIfNotMountedPost(mountToteToSingleItemPickingTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceProductForSingleItemPickingCommand} [placeProductForSingleItemPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemPlaceProductPost(placeProductForSingleItemPickingCommand?: PlaceProductForSingleItemPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceProductForSingleItemPickingCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemPlaceProductPost(placeProductForSingleItemPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceSingleItemPickingTrolleyToParkAddressCommand} [placeSingleItemPickingTrolleyToParkAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemPlaceSingleItemPickingTrolleyToParkAddressPost(placeSingleItemPickingTrolleyToParkAddressCommand?: PlaceSingleItemPickingTrolleyToParkAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemPlaceSingleItemPickingTrolleyToParkAddressPost(placeSingleItemPickingTrolleyToParkAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} toteLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemQuerySingleItemPickingToteDetailsGet(toteLabel: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleItemPickingToteDetailsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemQuerySingleItemPickingToteDetailsGet(toteLabel, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemQuerySingleItemPickingTotesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuerySingleItemPickingTotesOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemQuerySingleItemPickingTotesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StartCreatedPickingForSingleItemPickingCommand} [startCreatedPickingForSingleItemPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemStartCreatedPickingPost(startCreatedPickingForSingleItemPickingCommand?: StartCreatedPickingForSingleItemPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartCreatedPickingForSingleItemPickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemStartCreatedPickingPost(startCreatedPickingForSingleItemPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UnmountToteFromSingleItemPickingTrolleyCommand} [unmountToteFromSingleItemPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemUnmountToteFromTrolleyPost(unmountToteFromSingleItemPickingTrolleyCommand?: UnmountToteFromSingleItemPickingTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnmountToteFromSingleItemPickingTrolleyCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemUnmountToteFromTrolleyPost(unmountToteFromSingleItemPickingTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PickingSingleItemApi - factory interface
 * @export
 */
export const PickingSingleItemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PickingSingleItemApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemCheckBarcodeTypeGet(barcode?: string, options?: any): AxiosPromise<CheckBarcodeTypeForSingleItemPickingOutputDTO> {
            return localVarFp.apiV1PickingSingleItemCheckBarcodeTypeGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckCellForSingleItemPickingCommand} [checkCellForSingleItemPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemCheckCellPost(checkCellForSingleItemPickingCommand?: CheckCellForSingleItemPickingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PickingSingleItemCheckCellPost(checkCellForSingleItemPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemCheckIfControlCountingIsActiveGet(options?: any): AxiosPromise<CheckIfControlCountingIsActiveForSingleItemPickingOutputDTO> {
            return localVarFp.apiV1PickingSingleItemCheckIfControlCountingIsActiveGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompletePickingProcessForSingleItemPickingCommand} [completePickingProcessForSingleItemPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemCompletePickingProcessPost(completePickingProcessForSingleItemPickingCommand?: CompletePickingProcessForSingleItemPickingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PickingSingleItemCompletePickingProcessPost(completePickingProcessForSingleItemPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ForceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand} [forceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemForceCompletePickingProcessAndPlaceTrolleyToParkAddressPost(forceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand?: ForceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand, options?: any): AxiosPromise<RouteOutputDTO> {
            return localVarFp.apiV1PickingSingleItemForceCompletePickingProcessAndPlaceTrolleyToParkAddressPost(forceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemGetSingleItemPickingTrolleyTotesGet(trolleyLabel?: string, options?: any): AxiosPromise<GetSingleItemPickingTrolleyTotesOutputDTO> {
            return localVarFp.apiV1PickingSingleItemGetSingleItemPickingTrolleyTotesGet(trolleyLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LostItemForSingleItemPickingCommand} [lostItemForSingleItemPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemLostItemPost(lostItemForSingleItemPickingCommand?: LostItemForSingleItemPickingCommand, options?: any): AxiosPromise<LostItemForSingleItemPickingOutputDTO> {
            return localVarFp.apiV1PickingSingleItemLostItemPost(lostItemForSingleItemPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MountToteToSingleItemPickingTrolleyCommand} [mountToteToSingleItemPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemMountToteToTrolleyIfNotMountedPost(mountToteToSingleItemPickingTrolleyCommand?: MountToteToSingleItemPickingTrolleyCommand, options?: any): AxiosPromise<MountToteToSingleItemPickingTrolleyCommandOutputDTO> {
            return localVarFp.apiV1PickingSingleItemMountToteToTrolleyIfNotMountedPost(mountToteToSingleItemPickingTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceProductForSingleItemPickingCommand} [placeProductForSingleItemPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemPlaceProductPost(placeProductForSingleItemPickingCommand?: PlaceProductForSingleItemPickingCommand, options?: any): AxiosPromise<PlaceProductForSingleItemPickingCommandOutputDTO> {
            return localVarFp.apiV1PickingSingleItemPlaceProductPost(placeProductForSingleItemPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceSingleItemPickingTrolleyToParkAddressCommand} [placeSingleItemPickingTrolleyToParkAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemPlaceSingleItemPickingTrolleyToParkAddressPost(placeSingleItemPickingTrolleyToParkAddressCommand?: PlaceSingleItemPickingTrolleyToParkAddressCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PickingSingleItemPlaceSingleItemPickingTrolleyToParkAddressPost(placeSingleItemPickingTrolleyToParkAddressCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} toteLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemQuerySingleItemPickingToteDetailsGet(toteLabel: string, dqb?: string, options?: any): AxiosPromise<SingleItemPickingToteDetailsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingSingleItemQuerySingleItemPickingToteDetailsGet(toteLabel, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemQuerySingleItemPickingTotesGet(dqb?: string, options?: any): AxiosPromise<QuerySingleItemPickingTotesOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingSingleItemQuerySingleItemPickingTotesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StartCreatedPickingForSingleItemPickingCommand} [startCreatedPickingForSingleItemPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemStartCreatedPickingPost(startCreatedPickingForSingleItemPickingCommand?: StartCreatedPickingForSingleItemPickingCommand, options?: any): AxiosPromise<StartCreatedPickingForSingleItemPickingOutputDTO> {
            return localVarFp.apiV1PickingSingleItemStartCreatedPickingPost(startCreatedPickingForSingleItemPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnmountToteFromSingleItemPickingTrolleyCommand} [unmountToteFromSingleItemPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemUnmountToteFromTrolleyPost(unmountToteFromSingleItemPickingTrolleyCommand?: UnmountToteFromSingleItemPickingTrolleyCommand, options?: any): AxiosPromise<UnmountToteFromSingleItemPickingTrolleyCommandOutputDTO> {
            return localVarFp.apiV1PickingSingleItemUnmountToteFromTrolleyPost(unmountToteFromSingleItemPickingTrolleyCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PickingSingleItemApi - object-oriented interface
 * @export
 * @class PickingSingleItemApi
 * @extends {BaseAPI}
 */
export class PickingSingleItemApi extends BaseAPI {
    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemApi
     */
    public apiV1PickingSingleItemCheckBarcodeTypeGet(barcode?: string, options?: any) {
        return PickingSingleItemApiFp(this.configuration).apiV1PickingSingleItemCheckBarcodeTypeGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckCellForSingleItemPickingCommand} [checkCellForSingleItemPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemApi
     */
    public apiV1PickingSingleItemCheckCellPost(checkCellForSingleItemPickingCommand?: CheckCellForSingleItemPickingCommand, options?: any) {
        return PickingSingleItemApiFp(this.configuration).apiV1PickingSingleItemCheckCellPost(checkCellForSingleItemPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemApi
     */
    public apiV1PickingSingleItemCheckIfControlCountingIsActiveGet(options?: any) {
        return PickingSingleItemApiFp(this.configuration).apiV1PickingSingleItemCheckIfControlCountingIsActiveGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompletePickingProcessForSingleItemPickingCommand} [completePickingProcessForSingleItemPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemApi
     */
    public apiV1PickingSingleItemCompletePickingProcessPost(completePickingProcessForSingleItemPickingCommand?: CompletePickingProcessForSingleItemPickingCommand, options?: any) {
        return PickingSingleItemApiFp(this.configuration).apiV1PickingSingleItemCompletePickingProcessPost(completePickingProcessForSingleItemPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ForceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand} [forceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemApi
     */
    public apiV1PickingSingleItemForceCompletePickingProcessAndPlaceTrolleyToParkAddressPost(forceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand?: ForceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand, options?: any) {
        return PickingSingleItemApiFp(this.configuration).apiV1PickingSingleItemForceCompletePickingProcessAndPlaceTrolleyToParkAddressPost(forceCompletePickingProcessAndPlaceTrolleyToParkAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [trolleyLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemApi
     */
    public apiV1PickingSingleItemGetSingleItemPickingTrolleyTotesGet(trolleyLabel?: string, options?: any) {
        return PickingSingleItemApiFp(this.configuration).apiV1PickingSingleItemGetSingleItemPickingTrolleyTotesGet(trolleyLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LostItemForSingleItemPickingCommand} [lostItemForSingleItemPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemApi
     */
    public apiV1PickingSingleItemLostItemPost(lostItemForSingleItemPickingCommand?: LostItemForSingleItemPickingCommand, options?: any) {
        return PickingSingleItemApiFp(this.configuration).apiV1PickingSingleItemLostItemPost(lostItemForSingleItemPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MountToteToSingleItemPickingTrolleyCommand} [mountToteToSingleItemPickingTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemApi
     */
    public apiV1PickingSingleItemMountToteToTrolleyIfNotMountedPost(mountToteToSingleItemPickingTrolleyCommand?: MountToteToSingleItemPickingTrolleyCommand, options?: any) {
        return PickingSingleItemApiFp(this.configuration).apiV1PickingSingleItemMountToteToTrolleyIfNotMountedPost(mountToteToSingleItemPickingTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceProductForSingleItemPickingCommand} [placeProductForSingleItemPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemApi
     */
    public apiV1PickingSingleItemPlaceProductPost(placeProductForSingleItemPickingCommand?: PlaceProductForSingleItemPickingCommand, options?: any) {
        return PickingSingleItemApiFp(this.configuration).apiV1PickingSingleItemPlaceProductPost(placeProductForSingleItemPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceSingleItemPickingTrolleyToParkAddressCommand} [placeSingleItemPickingTrolleyToParkAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemApi
     */
    public apiV1PickingSingleItemPlaceSingleItemPickingTrolleyToParkAddressPost(placeSingleItemPickingTrolleyToParkAddressCommand?: PlaceSingleItemPickingTrolleyToParkAddressCommand, options?: any) {
        return PickingSingleItemApiFp(this.configuration).apiV1PickingSingleItemPlaceSingleItemPickingTrolleyToParkAddressPost(placeSingleItemPickingTrolleyToParkAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} toteLabel 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemApi
     */
    public apiV1PickingSingleItemQuerySingleItemPickingToteDetailsGet(toteLabel: string, dqb?: string, options?: any) {
        return PickingSingleItemApiFp(this.configuration).apiV1PickingSingleItemQuerySingleItemPickingToteDetailsGet(toteLabel, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemApi
     */
    public apiV1PickingSingleItemQuerySingleItemPickingTotesGet(dqb?: string, options?: any) {
        return PickingSingleItemApiFp(this.configuration).apiV1PickingSingleItemQuerySingleItemPickingTotesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StartCreatedPickingForSingleItemPickingCommand} [startCreatedPickingForSingleItemPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemApi
     */
    public apiV1PickingSingleItemStartCreatedPickingPost(startCreatedPickingForSingleItemPickingCommand?: StartCreatedPickingForSingleItemPickingCommand, options?: any) {
        return PickingSingleItemApiFp(this.configuration).apiV1PickingSingleItemStartCreatedPickingPost(startCreatedPickingForSingleItemPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnmountToteFromSingleItemPickingTrolleyCommand} [unmountToteFromSingleItemPickingTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemApi
     */
    public apiV1PickingSingleItemUnmountToteFromTrolleyPost(unmountToteFromSingleItemPickingTrolleyCommand?: UnmountToteFromSingleItemPickingTrolleyCommand, options?: any) {
        return PickingSingleItemApiFp(this.configuration).apiV1PickingSingleItemUnmountToteFromTrolleyPost(unmountToteFromSingleItemPickingTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PickingSingleItemFastPackApi - axios parameter creator
 * @export
 */
export const PickingSingleItemFastPackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackCheckBarcodeTypeGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItemFastPack.checkBarcodeType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckCellForSingleItemFastPackPickingCommand} [checkCellForSingleItemFastPackPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackCheckCellPost: async (checkCellForSingleItemFastPackPickingCommand?: CheckCellForSingleItemFastPackPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItemFastPack.checkCell`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkCellForSingleItemFastPackPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackCheckIfControlCountingIsActiveGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItemFastPack.checkIfControlCountingIsActive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompletePickingProcessForSingleItemFastPackPickingCommand} [completePickingProcessForSingleItemFastPackPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackCompletePickingProcessPost: async (completePickingProcessForSingleItemFastPackPickingCommand?: CompletePickingProcessForSingleItemFastPackPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItemFastPack.completePickingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completePickingProcessForSingleItemFastPackPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand} [forceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackForceCompletePickingProcessAndPlaceTrolleyToParkAddressPost: async (forceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand?: ForceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItemFastPack.forceCompletePickingProcessAndPlaceTrolleyToParkAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackGetSingleItemFastPackPickingTrolleyTotesGet: async (trolleyLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItemFastPack.getSingleItemFastPackPickingTrolleyTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (trolleyLabel !== undefined) {
                localVarQueryParameter['trolleyLabel'] = trolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LostItemForSingleItemFastPackPickingCommand} [lostItemForSingleItemFastPackPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackLostItemPost: async (lostItemForSingleItemFastPackPickingCommand?: LostItemForSingleItemFastPackPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItemFastPack.lostItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lostItemForSingleItemFastPackPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MountToteToSingleItemFastPackPickingTrolleyCommand} [mountToteToSingleItemFastPackPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackMountToteToTrolleyIfNotMountedPost: async (mountToteToSingleItemFastPackPickingTrolleyCommand?: MountToteToSingleItemFastPackPickingTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItemFastPack.mountToteToTrolleyIfNotMounted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mountToteToSingleItemFastPackPickingTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceProductForSingleItemFastPackPickingCommand} [placeProductForSingleItemFastPackPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackPlaceProductPost: async (placeProductForSingleItemFastPackPickingCommand?: PlaceProductForSingleItemFastPackPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItemFastPack.placeProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeProductForSingleItemFastPackPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceSingleItemFastPackPickingTrolleyToParkAddressCommand} [placeSingleItemFastPackPickingTrolleyToParkAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackPlaceSingleItemFastPackPickingTrolleyToParkAddressPost: async (placeSingleItemFastPackPickingTrolleyToParkAddressCommand?: PlaceSingleItemFastPackPickingTrolleyToParkAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItemFastPack.placeSingleItemFastPackPickingTrolleyToParkAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeSingleItemFastPackPickingTrolleyToParkAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} toteLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackQuerySingleItemFastPackPickingToteDetailsGet: async (toteLabel: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'toteLabel' is not null or undefined
            assertParamExists('apiV1PickingSingleItemFastPackQuerySingleItemFastPackPickingToteDetailsGet', 'toteLabel', toteLabel)
            const localVarPath = `/api/v1/PickingSingleItemFastPack.querySingleItemFastPackPickingToteDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackQuerySingleItemFastPackPickingTotesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItemFastPack.querySingleItemFastPackPickingTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartCreatedPickingForSingleItemFastPackPickingCommand} [startCreatedPickingForSingleItemFastPackPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackStartCreatedPickingPost: async (startCreatedPickingForSingleItemFastPackPickingCommand?: StartCreatedPickingForSingleItemFastPackPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItemFastPack.startCreatedPicking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startCreatedPickingForSingleItemFastPackPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnmountToteFromSingleItemFastPackPickingTrolleyCommand} [unmountToteFromSingleItemFastPackPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackUnmountToteFromTrolleyPost: async (unmountToteFromSingleItemFastPackPickingTrolleyCommand?: UnmountToteFromSingleItemFastPackPickingTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PickingSingleItemFastPack.unmountToteFromTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unmountToteFromSingleItemFastPackPickingTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PickingSingleItemFastPackApi - functional programming interface
 * @export
 */
export const PickingSingleItemFastPackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PickingSingleItemFastPackApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemFastPackCheckBarcodeTypeGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckBarcodeTypeForFastPackPickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemFastPackCheckBarcodeTypeGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckCellForSingleItemFastPackPickingCommand} [checkCellForSingleItemFastPackPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemFastPackCheckCellPost(checkCellForSingleItemFastPackPickingCommand?: CheckCellForSingleItemFastPackPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemFastPackCheckCellPost(checkCellForSingleItemFastPackPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemFastPackCheckIfControlCountingIsActiveGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckIfControlCountingIsActiveForSingleItemFastPackPickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemFastPackCheckIfControlCountingIsActiveGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompletePickingProcessForSingleItemFastPackPickingCommand} [completePickingProcessForSingleItemFastPackPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemFastPackCompletePickingProcessPost(completePickingProcessForSingleItemFastPackPickingCommand?: CompletePickingProcessForSingleItemFastPackPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemFastPackCompletePickingProcessPost(completePickingProcessForSingleItemFastPackPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ForceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand} [forceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemFastPackForceCompletePickingProcessAndPlaceTrolleyToParkAddressPost(forceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand?: ForceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemFastPackForceCompletePickingProcessAndPlaceTrolleyToParkAddressPost(forceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemFastPackGetSingleItemFastPackPickingTrolleyTotesGet(trolleyLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSingleItemFastPackPickingTrolleyTotesOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemFastPackGetSingleItemFastPackPickingTrolleyTotesGet(trolleyLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LostItemForSingleItemFastPackPickingCommand} [lostItemForSingleItemFastPackPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemFastPackLostItemPost(lostItemForSingleItemFastPackPickingCommand?: LostItemForSingleItemFastPackPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LostItemForSingleItemFastPackPickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemFastPackLostItemPost(lostItemForSingleItemFastPackPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MountToteToSingleItemFastPackPickingTrolleyCommand} [mountToteToSingleItemFastPackPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemFastPackMountToteToTrolleyIfNotMountedPost(mountToteToSingleItemFastPackPickingTrolleyCommand?: MountToteToSingleItemFastPackPickingTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MountToteToFastPackPickingTrolleyCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemFastPackMountToteToTrolleyIfNotMountedPost(mountToteToSingleItemFastPackPickingTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceProductForSingleItemFastPackPickingCommand} [placeProductForSingleItemFastPackPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemFastPackPlaceProductPost(placeProductForSingleItemFastPackPickingCommand?: PlaceProductForSingleItemFastPackPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceProductForFastPackPickingCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemFastPackPlaceProductPost(placeProductForSingleItemFastPackPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceSingleItemFastPackPickingTrolleyToParkAddressCommand} [placeSingleItemFastPackPickingTrolleyToParkAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemFastPackPlaceSingleItemFastPackPickingTrolleyToParkAddressPost(placeSingleItemFastPackPickingTrolleyToParkAddressCommand?: PlaceSingleItemFastPackPickingTrolleyToParkAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemFastPackPlaceSingleItemFastPackPickingTrolleyToParkAddressPost(placeSingleItemFastPackPickingTrolleyToParkAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} toteLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemFastPackQuerySingleItemFastPackPickingToteDetailsGet(toteLabel: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleItemFastPackPickingToteDetailsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemFastPackQuerySingleItemFastPackPickingToteDetailsGet(toteLabel, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemFastPackQuerySingleItemFastPackPickingTotesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuerySingleItemFastPackPickingTotesOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemFastPackQuerySingleItemFastPackPickingTotesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StartCreatedPickingForSingleItemFastPackPickingCommand} [startCreatedPickingForSingleItemFastPackPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemFastPackStartCreatedPickingPost(startCreatedPickingForSingleItemFastPackPickingCommand?: StartCreatedPickingForSingleItemFastPackPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartCreatedPickingForSingleItemFastPackPickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemFastPackStartCreatedPickingPost(startCreatedPickingForSingleItemFastPackPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UnmountToteFromSingleItemFastPackPickingTrolleyCommand} [unmountToteFromSingleItemFastPackPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PickingSingleItemFastPackUnmountToteFromTrolleyPost(unmountToteFromSingleItemFastPackPickingTrolleyCommand?: UnmountToteFromSingleItemFastPackPickingTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnmountToteFromFastPackPickingTrolleyCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PickingSingleItemFastPackUnmountToteFromTrolleyPost(unmountToteFromSingleItemFastPackPickingTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PickingSingleItemFastPackApi - factory interface
 * @export
 */
export const PickingSingleItemFastPackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PickingSingleItemFastPackApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackCheckBarcodeTypeGet(barcode?: string, options?: any): AxiosPromise<CheckBarcodeTypeForFastPackPickingOutputDTO> {
            return localVarFp.apiV1PickingSingleItemFastPackCheckBarcodeTypeGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckCellForSingleItemFastPackPickingCommand} [checkCellForSingleItemFastPackPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackCheckCellPost(checkCellForSingleItemFastPackPickingCommand?: CheckCellForSingleItemFastPackPickingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PickingSingleItemFastPackCheckCellPost(checkCellForSingleItemFastPackPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackCheckIfControlCountingIsActiveGet(options?: any): AxiosPromise<CheckIfControlCountingIsActiveForSingleItemFastPackPickingOutputDTO> {
            return localVarFp.apiV1PickingSingleItemFastPackCheckIfControlCountingIsActiveGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompletePickingProcessForSingleItemFastPackPickingCommand} [completePickingProcessForSingleItemFastPackPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackCompletePickingProcessPost(completePickingProcessForSingleItemFastPackPickingCommand?: CompletePickingProcessForSingleItemFastPackPickingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PickingSingleItemFastPackCompletePickingProcessPost(completePickingProcessForSingleItemFastPackPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ForceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand} [forceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackForceCompletePickingProcessAndPlaceTrolleyToParkAddressPost(forceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand?: ForceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand, options?: any): AxiosPromise<RouteOutputDTO> {
            return localVarFp.apiV1PickingSingleItemFastPackForceCompletePickingProcessAndPlaceTrolleyToParkAddressPost(forceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackGetSingleItemFastPackPickingTrolleyTotesGet(trolleyLabel?: string, options?: any): AxiosPromise<GetSingleItemFastPackPickingTrolleyTotesOutputDTO> {
            return localVarFp.apiV1PickingSingleItemFastPackGetSingleItemFastPackPickingTrolleyTotesGet(trolleyLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LostItemForSingleItemFastPackPickingCommand} [lostItemForSingleItemFastPackPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackLostItemPost(lostItemForSingleItemFastPackPickingCommand?: LostItemForSingleItemFastPackPickingCommand, options?: any): AxiosPromise<LostItemForSingleItemFastPackPickingOutputDTO> {
            return localVarFp.apiV1PickingSingleItemFastPackLostItemPost(lostItemForSingleItemFastPackPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MountToteToSingleItemFastPackPickingTrolleyCommand} [mountToteToSingleItemFastPackPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackMountToteToTrolleyIfNotMountedPost(mountToteToSingleItemFastPackPickingTrolleyCommand?: MountToteToSingleItemFastPackPickingTrolleyCommand, options?: any): AxiosPromise<MountToteToFastPackPickingTrolleyCommandOutputDTO> {
            return localVarFp.apiV1PickingSingleItemFastPackMountToteToTrolleyIfNotMountedPost(mountToteToSingleItemFastPackPickingTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceProductForSingleItemFastPackPickingCommand} [placeProductForSingleItemFastPackPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackPlaceProductPost(placeProductForSingleItemFastPackPickingCommand?: PlaceProductForSingleItemFastPackPickingCommand, options?: any): AxiosPromise<PlaceProductForFastPackPickingCommandOutputDTO> {
            return localVarFp.apiV1PickingSingleItemFastPackPlaceProductPost(placeProductForSingleItemFastPackPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceSingleItemFastPackPickingTrolleyToParkAddressCommand} [placeSingleItemFastPackPickingTrolleyToParkAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackPlaceSingleItemFastPackPickingTrolleyToParkAddressPost(placeSingleItemFastPackPickingTrolleyToParkAddressCommand?: PlaceSingleItemFastPackPickingTrolleyToParkAddressCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PickingSingleItemFastPackPlaceSingleItemFastPackPickingTrolleyToParkAddressPost(placeSingleItemFastPackPickingTrolleyToParkAddressCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} toteLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackQuerySingleItemFastPackPickingToteDetailsGet(toteLabel: string, dqb?: string, options?: any): AxiosPromise<SingleItemFastPackPickingToteDetailsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingSingleItemFastPackQuerySingleItemFastPackPickingToteDetailsGet(toteLabel, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackQuerySingleItemFastPackPickingTotesGet(dqb?: string, options?: any): AxiosPromise<QuerySingleItemFastPackPickingTotesOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PickingSingleItemFastPackQuerySingleItemFastPackPickingTotesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StartCreatedPickingForSingleItemFastPackPickingCommand} [startCreatedPickingForSingleItemFastPackPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackStartCreatedPickingPost(startCreatedPickingForSingleItemFastPackPickingCommand?: StartCreatedPickingForSingleItemFastPackPickingCommand, options?: any): AxiosPromise<StartCreatedPickingForSingleItemFastPackPickingOutputDTO> {
            return localVarFp.apiV1PickingSingleItemFastPackStartCreatedPickingPost(startCreatedPickingForSingleItemFastPackPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnmountToteFromSingleItemFastPackPickingTrolleyCommand} [unmountToteFromSingleItemFastPackPickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PickingSingleItemFastPackUnmountToteFromTrolleyPost(unmountToteFromSingleItemFastPackPickingTrolleyCommand?: UnmountToteFromSingleItemFastPackPickingTrolleyCommand, options?: any): AxiosPromise<UnmountToteFromFastPackPickingTrolleyCommandOutputDTO> {
            return localVarFp.apiV1PickingSingleItemFastPackUnmountToteFromTrolleyPost(unmountToteFromSingleItemFastPackPickingTrolleyCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PickingSingleItemFastPackApi - object-oriented interface
 * @export
 * @class PickingSingleItemFastPackApi
 * @extends {BaseAPI}
 */
export class PickingSingleItemFastPackApi extends BaseAPI {
    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemFastPackApi
     */
    public apiV1PickingSingleItemFastPackCheckBarcodeTypeGet(barcode?: string, options?: any) {
        return PickingSingleItemFastPackApiFp(this.configuration).apiV1PickingSingleItemFastPackCheckBarcodeTypeGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckCellForSingleItemFastPackPickingCommand} [checkCellForSingleItemFastPackPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemFastPackApi
     */
    public apiV1PickingSingleItemFastPackCheckCellPost(checkCellForSingleItemFastPackPickingCommand?: CheckCellForSingleItemFastPackPickingCommand, options?: any) {
        return PickingSingleItemFastPackApiFp(this.configuration).apiV1PickingSingleItemFastPackCheckCellPost(checkCellForSingleItemFastPackPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemFastPackApi
     */
    public apiV1PickingSingleItemFastPackCheckIfControlCountingIsActiveGet(options?: any) {
        return PickingSingleItemFastPackApiFp(this.configuration).apiV1PickingSingleItemFastPackCheckIfControlCountingIsActiveGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompletePickingProcessForSingleItemFastPackPickingCommand} [completePickingProcessForSingleItemFastPackPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemFastPackApi
     */
    public apiV1PickingSingleItemFastPackCompletePickingProcessPost(completePickingProcessForSingleItemFastPackPickingCommand?: CompletePickingProcessForSingleItemFastPackPickingCommand, options?: any) {
        return PickingSingleItemFastPackApiFp(this.configuration).apiV1PickingSingleItemFastPackCompletePickingProcessPost(completePickingProcessForSingleItemFastPackPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ForceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand} [forceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemFastPackApi
     */
    public apiV1PickingSingleItemFastPackForceCompletePickingProcessAndPlaceTrolleyToParkAddressPost(forceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand?: ForceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand, options?: any) {
        return PickingSingleItemFastPackApiFp(this.configuration).apiV1PickingSingleItemFastPackForceCompletePickingProcessAndPlaceTrolleyToParkAddressPost(forceCompleteFastPackPickingProcessAndPlaceTrolleyToParkAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [trolleyLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemFastPackApi
     */
    public apiV1PickingSingleItemFastPackGetSingleItemFastPackPickingTrolleyTotesGet(trolleyLabel?: string, options?: any) {
        return PickingSingleItemFastPackApiFp(this.configuration).apiV1PickingSingleItemFastPackGetSingleItemFastPackPickingTrolleyTotesGet(trolleyLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LostItemForSingleItemFastPackPickingCommand} [lostItemForSingleItemFastPackPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemFastPackApi
     */
    public apiV1PickingSingleItemFastPackLostItemPost(lostItemForSingleItemFastPackPickingCommand?: LostItemForSingleItemFastPackPickingCommand, options?: any) {
        return PickingSingleItemFastPackApiFp(this.configuration).apiV1PickingSingleItemFastPackLostItemPost(lostItemForSingleItemFastPackPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MountToteToSingleItemFastPackPickingTrolleyCommand} [mountToteToSingleItemFastPackPickingTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemFastPackApi
     */
    public apiV1PickingSingleItemFastPackMountToteToTrolleyIfNotMountedPost(mountToteToSingleItemFastPackPickingTrolleyCommand?: MountToteToSingleItemFastPackPickingTrolleyCommand, options?: any) {
        return PickingSingleItemFastPackApiFp(this.configuration).apiV1PickingSingleItemFastPackMountToteToTrolleyIfNotMountedPost(mountToteToSingleItemFastPackPickingTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceProductForSingleItemFastPackPickingCommand} [placeProductForSingleItemFastPackPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemFastPackApi
     */
    public apiV1PickingSingleItemFastPackPlaceProductPost(placeProductForSingleItemFastPackPickingCommand?: PlaceProductForSingleItemFastPackPickingCommand, options?: any) {
        return PickingSingleItemFastPackApiFp(this.configuration).apiV1PickingSingleItemFastPackPlaceProductPost(placeProductForSingleItemFastPackPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceSingleItemFastPackPickingTrolleyToParkAddressCommand} [placeSingleItemFastPackPickingTrolleyToParkAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemFastPackApi
     */
    public apiV1PickingSingleItemFastPackPlaceSingleItemFastPackPickingTrolleyToParkAddressPost(placeSingleItemFastPackPickingTrolleyToParkAddressCommand?: PlaceSingleItemFastPackPickingTrolleyToParkAddressCommand, options?: any) {
        return PickingSingleItemFastPackApiFp(this.configuration).apiV1PickingSingleItemFastPackPlaceSingleItemFastPackPickingTrolleyToParkAddressPost(placeSingleItemFastPackPickingTrolleyToParkAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} toteLabel 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemFastPackApi
     */
    public apiV1PickingSingleItemFastPackQuerySingleItemFastPackPickingToteDetailsGet(toteLabel: string, dqb?: string, options?: any) {
        return PickingSingleItemFastPackApiFp(this.configuration).apiV1PickingSingleItemFastPackQuerySingleItemFastPackPickingToteDetailsGet(toteLabel, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemFastPackApi
     */
    public apiV1PickingSingleItemFastPackQuerySingleItemFastPackPickingTotesGet(dqb?: string, options?: any) {
        return PickingSingleItemFastPackApiFp(this.configuration).apiV1PickingSingleItemFastPackQuerySingleItemFastPackPickingTotesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StartCreatedPickingForSingleItemFastPackPickingCommand} [startCreatedPickingForSingleItemFastPackPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemFastPackApi
     */
    public apiV1PickingSingleItemFastPackStartCreatedPickingPost(startCreatedPickingForSingleItemFastPackPickingCommand?: StartCreatedPickingForSingleItemFastPackPickingCommand, options?: any) {
        return PickingSingleItemFastPackApiFp(this.configuration).apiV1PickingSingleItemFastPackStartCreatedPickingPost(startCreatedPickingForSingleItemFastPackPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnmountToteFromSingleItemFastPackPickingTrolleyCommand} [unmountToteFromSingleItemFastPackPickingTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickingSingleItemFastPackApi
     */
    public apiV1PickingSingleItemFastPackUnmountToteFromTrolleyPost(unmountToteFromSingleItemFastPackPickingTrolleyCommand?: UnmountToteFromSingleItemFastPackPickingTrolleyCommand, options?: any) {
        return PickingSingleItemFastPackApiFp(this.configuration).apiV1PickingSingleItemFastPackUnmountToteFromTrolleyPost(unmountToteFromSingleItemFastPackPickingTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PrintersApi - axios parameter creator
 * @export
 */
export const PrintersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddAddPrinterActionCommand} [addAddPrinterActionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersAddAddPrinterActionPost: async (addAddPrinterActionCommand?: AddAddPrinterActionCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Printers.addAddPrinterAction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAddPrinterActionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddDeletePrinterActionCommand} [addDeletePrinterActionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersAddDeletePrinterActionPost: async (addDeletePrinterActionCommand?: AddDeletePrinterActionCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Printers.addDeletePrinterAction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDeletePrinterActionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeletePrinterCommand} [deletePrinterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersDeletePost: async (deletePrinterCommand?: DeletePrinterCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Printers.delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deletePrinterCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [selectedPrinterName] 
         * @param {string} [machineName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersGetGet: async (selectedPrinterName?: string, machineName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Printers.get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (selectedPrinterName !== undefined) {
                localVarQueryParameter['selectedPrinterName'] = selectedPrinterName;
            }

            if (machineName !== undefined) {
                localVarQueryParameter['machineName'] = machineName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersGetInstalledPrintersGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Printers.getInstalledPrinters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [machineName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersGetPrintersForMachineGet: async (machineName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Printers.getPrintersForMachine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (machineName !== undefined) {
                localVarQueryParameter['machineName'] = machineName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersGetStorageAccountConnectionStringGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Printers.getStorageAccountConnectionString`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InstallOrUpdatePrinterOrchestratorCommand} [installOrUpdatePrinterOrchestratorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersInstallOrUpdateOrchestratorPost: async (installOrUpdatePrinterOrchestratorCommand?: InstallOrUpdatePrinterOrchestratorCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Printers.installOrUpdateOrchestrator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(installOrUpdatePrinterOrchestratorCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InstallPrinterCommand} [installPrinterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersInstallPost: async (installPrinterCommand?: InstallPrinterCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Printers.install`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(installPrinterCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintTestPageCommand} [printTestPageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersPrintTestPagePost: async (printTestPageCommand?: PrintTestPageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Printers.printTestPage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printTestPageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Printers.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddPrinterAddressCommand} [addPrinterAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PrintersAddAddressPost: async (addPrinterAddressCommand?: AddPrinterAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Printers/addAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPrinterAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeletePrinterCommand} [deletePrinterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PrintersDeletePrinterPost: async (deletePrinterCommand?: DeletePrinterCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Printers/deletePrinter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deletePrinterCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RemovePrinterAddressCommand} [removePrinterAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PrintersRemoveAddressPost: async (removePrinterAddressCommand?: RemovePrinterAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Printers/removeAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removePrinterAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdatePrinterAddressCommand} [updatePrinterAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PrintersUpdateAddressPost: async (updatePrinterAddressCommand?: UpdatePrinterAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Printers/updateAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePrinterAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrintersApi - functional programming interface
 * @export
 */
export const PrintersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrintersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddAddPrinterActionCommand} [addAddPrinterActionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PrintersAddAddPrinterActionPost(addAddPrinterActionCommand?: AddAddPrinterActionCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PrintersAddAddPrinterActionPost(addAddPrinterActionCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddDeletePrinterActionCommand} [addDeletePrinterActionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PrintersAddDeletePrinterActionPost(addDeletePrinterActionCommand?: AddDeletePrinterActionCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PrintersAddDeletePrinterActionPost(addDeletePrinterActionCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeletePrinterCommand} [deletePrinterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PrintersDeletePost(deletePrinterCommand?: DeletePrinterCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeletePrinterOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PrintersDeletePost(deletePrinterCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [selectedPrinterName] 
         * @param {string} [machineName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PrintersGetGet(selectedPrinterName?: string, machineName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPrinterOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PrintersGetGet(selectedPrinterName, machineName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PrintersGetInstalledPrintersGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PrinterOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PrintersGetInstalledPrintersGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [machineName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PrintersGetPrintersForMachineGet(machineName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PrinterOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PrintersGetPrintersForMachineGet(machineName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PrintersGetStorageAccountConnectionStringGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStorageAccountConnectionStringOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PrintersGetStorageAccountConnectionStringGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InstallOrUpdatePrinterOrchestratorCommand} [installOrUpdatePrinterOrchestratorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PrintersInstallOrUpdateOrchestratorPost(installOrUpdatePrinterOrchestratorCommand?: InstallOrUpdatePrinterOrchestratorCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstallOrUpdatePrinterOrchestratorOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PrintersInstallOrUpdateOrchestratorPost(installOrUpdatePrinterOrchestratorCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InstallPrinterCommand} [installPrinterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PrintersInstallPost(installPrinterCommand?: InstallPrinterCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstallPrinterOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PrintersInstallPost(installPrinterCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintTestPageCommand} [printTestPageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PrintersPrintTestPagePost(printTestPageCommand?: PrintTestPageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PrintersPrintTestPagePost(printTestPageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PrintersQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstalledPrinterQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PrintersQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddPrinterAddressCommand} [addPrinterAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1PrintersAddAddressPost(addPrinterAddressCommand?: AddPrinterAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrinterAddressOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1PrintersAddAddressPost(addPrinterAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeletePrinterCommand} [deletePrinterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1PrintersDeletePrinterPost(deletePrinterCommand?: DeletePrinterCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeletePrinterOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1PrintersDeletePrinterPost(deletePrinterCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RemovePrinterAddressCommand} [removePrinterAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1PrintersRemoveAddressPost(removePrinterAddressCommand?: RemovePrinterAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrinterAddressOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1PrintersRemoveAddressPost(removePrinterAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdatePrinterAddressCommand} [updatePrinterAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1PrintersUpdateAddressPost(updatePrinterAddressCommand?: UpdatePrinterAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrinterAddressOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1PrintersUpdateAddressPost(updatePrinterAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PrintersApi - factory interface
 * @export
 */
export const PrintersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrintersApiFp(configuration)
    return {
        /**
         * 
         * @param {AddAddPrinterActionCommand} [addAddPrinterActionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersAddAddPrinterActionPost(addAddPrinterActionCommand?: AddAddPrinterActionCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PrintersAddAddPrinterActionPost(addAddPrinterActionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddDeletePrinterActionCommand} [addDeletePrinterActionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersAddDeletePrinterActionPost(addDeletePrinterActionCommand?: AddDeletePrinterActionCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PrintersAddDeletePrinterActionPost(addDeletePrinterActionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeletePrinterCommand} [deletePrinterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersDeletePost(deletePrinterCommand?: DeletePrinterCommand, options?: any): AxiosPromise<DeletePrinterOutputDTO> {
            return localVarFp.apiV1PrintersDeletePost(deletePrinterCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [selectedPrinterName] 
         * @param {string} [machineName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersGetGet(selectedPrinterName?: string, machineName?: string, options?: any): AxiosPromise<GetPrinterOutputDTO> {
            return localVarFp.apiV1PrintersGetGet(selectedPrinterName, machineName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersGetInstalledPrintersGet(options?: any): AxiosPromise<Array<PrinterOutputDTO>> {
            return localVarFp.apiV1PrintersGetInstalledPrintersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [machineName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersGetPrintersForMachineGet(machineName?: string, options?: any): AxiosPromise<Array<PrinterOutputDTO>> {
            return localVarFp.apiV1PrintersGetPrintersForMachineGet(machineName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersGetStorageAccountConnectionStringGet(options?: any): AxiosPromise<GetStorageAccountConnectionStringOutputDTO> {
            return localVarFp.apiV1PrintersGetStorageAccountConnectionStringGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InstallOrUpdatePrinterOrchestratorCommand} [installOrUpdatePrinterOrchestratorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersInstallOrUpdateOrchestratorPost(installOrUpdatePrinterOrchestratorCommand?: InstallOrUpdatePrinterOrchestratorCommand, options?: any): AxiosPromise<InstallOrUpdatePrinterOrchestratorOutputDTO> {
            return localVarFp.apiV1PrintersInstallOrUpdateOrchestratorPost(installOrUpdatePrinterOrchestratorCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InstallPrinterCommand} [installPrinterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersInstallPost(installPrinterCommand?: InstallPrinterCommand, options?: any): AxiosPromise<InstallPrinterOutputDTO> {
            return localVarFp.apiV1PrintersInstallPost(installPrinterCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintTestPageCommand} [printTestPageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersPrintTestPagePost(printTestPageCommand?: PrintTestPageCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PrintersPrintTestPagePost(printTestPageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrintersQueryGet(dqb?: string, options?: any): AxiosPromise<InstalledPrinterQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PrintersQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddPrinterAddressCommand} [addPrinterAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PrintersAddAddressPost(addPrinterAddressCommand?: AddPrinterAddressCommand, options?: any): AxiosPromise<PrinterAddressOutputDTO> {
            return localVarFp.supportV1PrintersAddAddressPost(addPrinterAddressCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeletePrinterCommand} [deletePrinterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PrintersDeletePrinterPost(deletePrinterCommand?: DeletePrinterCommand, options?: any): AxiosPromise<DeletePrinterOutputDTO> {
            return localVarFp.supportV1PrintersDeletePrinterPost(deletePrinterCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RemovePrinterAddressCommand} [removePrinterAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PrintersRemoveAddressPost(removePrinterAddressCommand?: RemovePrinterAddressCommand, options?: any): AxiosPromise<PrinterAddressOutputDTO> {
            return localVarFp.supportV1PrintersRemoveAddressPost(removePrinterAddressCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdatePrinterAddressCommand} [updatePrinterAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PrintersUpdateAddressPost(updatePrinterAddressCommand?: UpdatePrinterAddressCommand, options?: any): AxiosPromise<PrinterAddressOutputDTO> {
            return localVarFp.supportV1PrintersUpdateAddressPost(updatePrinterAddressCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrintersApi - object-oriented interface
 * @export
 * @class PrintersApi
 * @extends {BaseAPI}
 */
export class PrintersApi extends BaseAPI {
    /**
     * 
     * @param {AddAddPrinterActionCommand} [addAddPrinterActionCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintersApi
     */
    public apiV1PrintersAddAddPrinterActionPost(addAddPrinterActionCommand?: AddAddPrinterActionCommand, options?: any) {
        return PrintersApiFp(this.configuration).apiV1PrintersAddAddPrinterActionPost(addAddPrinterActionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddDeletePrinterActionCommand} [addDeletePrinterActionCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintersApi
     */
    public apiV1PrintersAddDeletePrinterActionPost(addDeletePrinterActionCommand?: AddDeletePrinterActionCommand, options?: any) {
        return PrintersApiFp(this.configuration).apiV1PrintersAddDeletePrinterActionPost(addDeletePrinterActionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeletePrinterCommand} [deletePrinterCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintersApi
     */
    public apiV1PrintersDeletePost(deletePrinterCommand?: DeletePrinterCommand, options?: any) {
        return PrintersApiFp(this.configuration).apiV1PrintersDeletePost(deletePrinterCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [selectedPrinterName] 
     * @param {string} [machineName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintersApi
     */
    public apiV1PrintersGetGet(selectedPrinterName?: string, machineName?: string, options?: any) {
        return PrintersApiFp(this.configuration).apiV1PrintersGetGet(selectedPrinterName, machineName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintersApi
     */
    public apiV1PrintersGetInstalledPrintersGet(options?: any) {
        return PrintersApiFp(this.configuration).apiV1PrintersGetInstalledPrintersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [machineName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintersApi
     */
    public apiV1PrintersGetPrintersForMachineGet(machineName?: string, options?: any) {
        return PrintersApiFp(this.configuration).apiV1PrintersGetPrintersForMachineGet(machineName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintersApi
     */
    public apiV1PrintersGetStorageAccountConnectionStringGet(options?: any) {
        return PrintersApiFp(this.configuration).apiV1PrintersGetStorageAccountConnectionStringGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InstallOrUpdatePrinterOrchestratorCommand} [installOrUpdatePrinterOrchestratorCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintersApi
     */
    public apiV1PrintersInstallOrUpdateOrchestratorPost(installOrUpdatePrinterOrchestratorCommand?: InstallOrUpdatePrinterOrchestratorCommand, options?: any) {
        return PrintersApiFp(this.configuration).apiV1PrintersInstallOrUpdateOrchestratorPost(installOrUpdatePrinterOrchestratorCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InstallPrinterCommand} [installPrinterCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintersApi
     */
    public apiV1PrintersInstallPost(installPrinterCommand?: InstallPrinterCommand, options?: any) {
        return PrintersApiFp(this.configuration).apiV1PrintersInstallPost(installPrinterCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintTestPageCommand} [printTestPageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintersApi
     */
    public apiV1PrintersPrintTestPagePost(printTestPageCommand?: PrintTestPageCommand, options?: any) {
        return PrintersApiFp(this.configuration).apiV1PrintersPrintTestPagePost(printTestPageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintersApi
     */
    public apiV1PrintersQueryGet(dqb?: string, options?: any) {
        return PrintersApiFp(this.configuration).apiV1PrintersQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddPrinterAddressCommand} [addPrinterAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintersApi
     */
    public supportV1PrintersAddAddressPost(addPrinterAddressCommand?: AddPrinterAddressCommand, options?: any) {
        return PrintersApiFp(this.configuration).supportV1PrintersAddAddressPost(addPrinterAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeletePrinterCommand} [deletePrinterCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintersApi
     */
    public supportV1PrintersDeletePrinterPost(deletePrinterCommand?: DeletePrinterCommand, options?: any) {
        return PrintersApiFp(this.configuration).supportV1PrintersDeletePrinterPost(deletePrinterCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RemovePrinterAddressCommand} [removePrinterAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintersApi
     */
    public supportV1PrintersRemoveAddressPost(removePrinterAddressCommand?: RemovePrinterAddressCommand, options?: any) {
        return PrintersApiFp(this.configuration).supportV1PrintersRemoveAddressPost(removePrinterAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdatePrinterAddressCommand} [updatePrinterAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintersApi
     */
    public supportV1PrintersUpdateAddressPost(updatePrinterAddressCommand?: UpdatePrinterAddressCommand, options?: any) {
        return PrintersApiFp(this.configuration).supportV1PrintersUpdateAddressPost(updatePrinterAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProblemSolverApi - axios parameter creator
 * @export
 */
export const ProblemSolverApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemSolverQueryMissingNotificationsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ProblemSolver.queryMissingNotifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemSolverQueryMissingOrderDetailsGet: async (salesOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ProblemSolver.queryMissingOrderDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemSolverQueryMissingOrdersCountsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ProblemSolver.queryMissingOrdersCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemSolverQueryMissingOrdersGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ProblemSolver.queryMissingOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemSolverQueryPendingCancellationsByCellGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ProblemSolver.queryPendingCancellationsByCell`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemSolverQueryPendingCancellationsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ProblemSolver.queryPendingCancellations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemSolverQueryRasMissingNotificationsByFaceGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ProblemSolver.queryRasMissingNotificationsByFace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemSolverQueryRasMissingNotificationsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ProblemSolver.queryRasMissingNotifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProblemSolverApi - functional programming interface
 * @export
 */
export const ProblemSolverApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProblemSolverApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemSolverQueryMissingNotificationsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MissingNotificationQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemSolverQueryMissingNotificationsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemSolverQueryMissingOrderDetailsGet(salesOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MissingSalesOrderDetailsQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemSolverQueryMissingOrderDetailsGet(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemSolverQueryMissingOrdersCountsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MissingSalesOrderCountsQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemSolverQueryMissingOrdersCountsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemSolverQueryMissingOrdersGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MissingSalesOrderQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemSolverQueryMissingOrdersGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemSolverQueryPendingCancellationsByCellGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PendingCancellationCellSummaryQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemSolverQueryPendingCancellationsByCellGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemSolverQueryPendingCancellationsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PendingItemCancellationQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemSolverQueryPendingCancellationsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemSolverQueryRasMissingNotificationsByFaceGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RasMissingNotificationFaceSummaryQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemSolverQueryRasMissingNotificationsByFaceGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemSolverQueryRasMissingNotificationsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RasProblemSolverMissingNotificationQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemSolverQueryRasMissingNotificationsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProblemSolverApi - factory interface
 * @export
 */
export const ProblemSolverApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProblemSolverApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemSolverQueryMissingNotificationsGet(dqb?: string, options?: any): AxiosPromise<MissingNotificationQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ProblemSolverQueryMissingNotificationsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemSolverQueryMissingOrderDetailsGet(salesOrderId?: string, options?: any): AxiosPromise<MissingSalesOrderDetailsQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ProblemSolverQueryMissingOrderDetailsGet(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemSolverQueryMissingOrdersCountsGet(options?: any): AxiosPromise<MissingSalesOrderCountsQueryOutputDTO> {
            return localVarFp.apiV1ProblemSolverQueryMissingOrdersCountsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemSolverQueryMissingOrdersGet(dqb?: string, options?: any): AxiosPromise<MissingSalesOrderQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ProblemSolverQueryMissingOrdersGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemSolverQueryPendingCancellationsByCellGet(dqb?: string, options?: any): AxiosPromise<PendingCancellationCellSummaryQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ProblemSolverQueryPendingCancellationsByCellGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemSolverQueryPendingCancellationsGet(dqb?: string, options?: any): AxiosPromise<PendingItemCancellationQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ProblemSolverQueryPendingCancellationsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemSolverQueryRasMissingNotificationsByFaceGet(dqb?: string, options?: any): AxiosPromise<RasMissingNotificationFaceSummaryQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ProblemSolverQueryRasMissingNotificationsByFaceGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemSolverQueryRasMissingNotificationsGet(dqb?: string, options?: any): AxiosPromise<RasProblemSolverMissingNotificationQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ProblemSolverQueryRasMissingNotificationsGet(dqb, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProblemSolverApi - object-oriented interface
 * @export
 * @class ProblemSolverApi
 * @extends {BaseAPI}
 */
export class ProblemSolverApi extends BaseAPI {
    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemSolverApi
     */
    public apiV1ProblemSolverQueryMissingNotificationsGet(dqb?: string, options?: any) {
        return ProblemSolverApiFp(this.configuration).apiV1ProblemSolverQueryMissingNotificationsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemSolverApi
     */
    public apiV1ProblemSolverQueryMissingOrderDetailsGet(salesOrderId?: string, options?: any) {
        return ProblemSolverApiFp(this.configuration).apiV1ProblemSolverQueryMissingOrderDetailsGet(salesOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemSolverApi
     */
    public apiV1ProblemSolverQueryMissingOrdersCountsGet(options?: any) {
        return ProblemSolverApiFp(this.configuration).apiV1ProblemSolverQueryMissingOrdersCountsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemSolverApi
     */
    public apiV1ProblemSolverQueryMissingOrdersGet(dqb?: string, options?: any) {
        return ProblemSolverApiFp(this.configuration).apiV1ProblemSolverQueryMissingOrdersGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemSolverApi
     */
    public apiV1ProblemSolverQueryPendingCancellationsByCellGet(dqb?: string, options?: any) {
        return ProblemSolverApiFp(this.configuration).apiV1ProblemSolverQueryPendingCancellationsByCellGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemSolverApi
     */
    public apiV1ProblemSolverQueryPendingCancellationsGet(dqb?: string, options?: any) {
        return ProblemSolverApiFp(this.configuration).apiV1ProblemSolverQueryPendingCancellationsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemSolverApi
     */
    public apiV1ProblemSolverQueryRasMissingNotificationsByFaceGet(dqb?: string, options?: any) {
        return ProblemSolverApiFp(this.configuration).apiV1ProblemSolverQueryRasMissingNotificationsByFaceGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemSolverApi
     */
    public apiV1ProblemSolverQueryRasMissingNotificationsGet(dqb?: string, options?: any) {
        return ProblemSolverApiFp(this.configuration).apiV1ProblemSolverQueryRasMissingNotificationsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProblemsApi - axios parameter creator
 * @export
 */
export const ProblemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsCheckBarcodeTypeGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.checkBarcodeType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CorrectWrongShippingAddressCommand} [correctWrongShippingAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsCorrectWrongShippingAddressPost: async (correctWrongShippingAddressCommand?: CorrectWrongShippingAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.correctWrongShippingAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(correctWrongShippingAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCargoCarrierPreferenceProblemCommand} [createCargoCarrierPreferenceProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsCreateCargoCarrierPreferenceProblemPost: async (createCargoCarrierPreferenceProblemCommand?: CreateCargoCarrierPreferenceProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.createCargoCarrierPreferenceProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCargoCarrierPreferenceProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateMissingCargoPackageLabelProblemCommand} [createMissingCargoPackageLabelProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsCreateMissingCargoPackageLabelProblemPost: async (createMissingCargoPackageLabelProblemCommand?: CreateMissingCargoPackageLabelProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.createMissingCargoPackageLabelProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMissingCargoPackageLabelProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateMissingSLAMLabelProblemCommand} [createMissingSLAMLabelProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsCreateMissingSLAMLabelProblemPost: async (createMissingSLAMLabelProblemCommand?: CreateMissingSLAMLabelProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.createMissingSLAMLabelProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMissingSLAMLabelProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetCargoCarrierPreferenceProblemDetailsGet: async (problemReferenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getCargoCarrierPreferenceProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemReferenceNumber !== undefined) {
                localVarQueryParameter['problemReferenceNumber'] = problemReferenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetCargoCarrierQuotaProblemDetailsGet: async (problemReferenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getCargoCarrierQuotaProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemReferenceNumber !== undefined) {
                localVarQueryParameter['problemReferenceNumber'] = problemReferenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetCargoCodeUpdatedProblemDetailsGet: async (problemReferenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getCargoCodeUpdatedProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemReferenceNumber !== undefined) {
                localVarQueryParameter['problemReferenceNumber'] = problemReferenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetCreatedProblemsBySalesOrderIdGet: async (salesOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getCreatedProblemsBySalesOrderId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetDetailLostItemProblemSalesOrderGet: async (salesOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getDetailLostItemProblemSalesOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetInProgressProblemsBySalesOrderIdGet: async (salesOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getInProgressProblemsBySalesOrderId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetIntegrationCodeProblemDetailsGet: async (problemReferenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getIntegrationCodeProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemReferenceNumber !== undefined) {
                localVarQueryParameter['problemReferenceNumber'] = problemReferenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetLostItemProblemDetailsGet: async (problemReferenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getLostItemProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemReferenceNumber !== undefined) {
                localVarQueryParameter['problemReferenceNumber'] = problemReferenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetLostItemProblemSalesOrdersQuery} [getLostItemProblemSalesOrdersQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetLostItemProblemSalesOrdersPost: async (getLostItemProblemSalesOrdersQuery?: GetLostItemProblemSalesOrdersQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getLostItemProblemSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getLostItemProblemSalesOrdersQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetMarketplaceCargoCarrierQuotaProblemDetailsGet: async (problemReferenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getMarketplaceCargoCarrierQuotaProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemReferenceNumber !== undefined) {
                localVarQueryParameter['problemReferenceNumber'] = problemReferenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetMissingCargoPackageLabelProblemDetailsGet: async (problemReferenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getMissingCargoPackageLabelProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemReferenceNumber !== undefined) {
                localVarQueryParameter['problemReferenceNumber'] = problemReferenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetMissingSLAMLabelProblemDetailsGet: async (problemReferenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getMissingSLAMLabelProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemReferenceNumber !== undefined) {
                localVarQueryParameter['problemReferenceNumber'] = problemReferenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetResolvedProblemsBySalesOrderIdGet: async (salesOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getResolvedProblemsBySalesOrderId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetSLAMShipmentProblemDetailsGet: async (problemReferenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getSLAMShipmentProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemReferenceNumber !== undefined) {
                localVarQueryParameter['problemReferenceNumber'] = problemReferenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetSalesOrderDetailsForProblemGet: async (problemReferenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getSalesOrderDetailsForProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemReferenceNumber !== undefined) {
                localVarQueryParameter['problemReferenceNumber'] = problemReferenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetSalesOrderProblemDetailsGet: async (salesOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getSalesOrderProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetWrongShippingAddressProblemDetailsGet: async (problemReferenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.getWrongShippingAddressProblemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (problemReferenceNumber !== undefined) {
                localVarQueryParameter['problemReferenceNumber'] = problemReferenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsListReportedByUserProblemsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.listReportedByUserProblems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsQueryDispatchProblemsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.queryDispatchProblems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsQueryDispatchProblemsManagementCountsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.queryDispatchProblemsManagementCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsQueryPickingProblemsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.queryPickingProblems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsQueryPickingProblemsManagementCountsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.queryPickingProblemsManagementCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RenewExternalContractCommand} [renewExternalContractCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsRenewExternalContractPost: async (renewExternalContractCommand?: RenewExternalContractCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.renewExternalContract`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renewExternalContractCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolveCargoCarrierPreferenceProblemCommand} [solveCargoCarrierPreferenceProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveCargoCarrierPreferenceProblemPost: async (solveCargoCarrierPreferenceProblemCommand?: SolveCargoCarrierPreferenceProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.solveCargoCarrierPreferenceProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solveCargoCarrierPreferenceProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolveCargoCarrierQuotaProblemCommand} [solveCargoCarrierQuotaProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveCargoCarrierQuotaProblemPost: async (solveCargoCarrierQuotaProblemCommand?: SolveCargoCarrierQuotaProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.solveCargoCarrierQuotaProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solveCargoCarrierQuotaProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolveSalesOrderProblemCommand} [solveSalesOrderProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveCargoCodeUpdatedProblemPost: async (solveSalesOrderProblemCommand?: SolveSalesOrderProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.solveCargoCodeUpdatedProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solveSalesOrderProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolveSalesOrderProblemCommand} [solveSalesOrderProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveIntegrationCodeProblemForSLAMPost: async (solveSalesOrderProblemCommand?: SolveSalesOrderProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.solveIntegrationCodeProblemForSLAM`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solveSalesOrderProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolveIntegrationCodeProblemCommand} [solveIntegrationCodeProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveIntegrationCodeProblemPost: async (solveIntegrationCodeProblemCommand?: SolveIntegrationCodeProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.solveIntegrationCodeProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solveIntegrationCodeProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolveMarketplaceCargoCarrierQuotaProblemCommand} [solveMarketplaceCargoCarrierQuotaProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveMarketplaceCargoCarrierQuotaProblemPost: async (solveMarketplaceCargoCarrierQuotaProblemCommand?: SolveMarketplaceCargoCarrierQuotaProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.solveMarketplaceCargoCarrierQuotaProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solveMarketplaceCargoCarrierQuotaProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolveMissingCargoPackageLabelProblemCommand} [solveMissingCargoPackageLabelProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveMissingCargoPackageLabelProblemPost: async (solveMissingCargoPackageLabelProblemCommand?: SolveMissingCargoPackageLabelProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.solveMissingCargoPackageLabelProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solveMissingCargoPackageLabelProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolveMissingSLAMLabelProblemCommand} [solveMissingSLAMLabelProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveMissingSLAMLabelProblemPost: async (solveMissingSLAMLabelProblemCommand?: SolveMissingSLAMLabelProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.solveMissingSLAMLabelProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solveMissingSLAMLabelProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolveSLAMShipmentProblemCommand} [solveSLAMShipmentProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveSLAMShipmentProblemPost: async (solveSLAMShipmentProblemCommand?: SolveSLAMShipmentProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.solveSLAMShipmentProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solveSLAMShipmentProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolveWrongShippingAddressProblemCommand} [solveWrongShippingAddressProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveWrongShippingAddressProblemPost: async (solveWrongShippingAddressProblemCommand?: SolveWrongShippingAddressProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.solveWrongShippingAddressProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solveWrongShippingAddressProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCargoDetailsIntegrationCodeProblemCommand} [updateCargoDetailsIntegrationCodeProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsUpdateCargoDetailsIntegrationCodeProblemPost: async (updateCargoDetailsIntegrationCodeProblemCommand?: UpdateCargoDetailsIntegrationCodeProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.updateCargoDetailsIntegrationCodeProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCargoDetailsIntegrationCodeProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateLostItemProblemSolutionTypeCommand} [updateLostItemProblemSolutionTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsUpdateLostItemProblemSolutionTypePost: async (updateLostItemProblemSolutionTypeCommand?: UpdateLostItemProblemSolutionTypeCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Problems.updateLostItemProblemSolutionType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLostItemProblemSolutionTypeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProblemsApi - functional programming interface
 * @export
 */
export const ProblemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProblemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsCheckBarcodeTypeGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BarcodeTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsCheckBarcodeTypeGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CorrectWrongShippingAddressCommand} [correctWrongShippingAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsCorrectWrongShippingAddressPost(correctWrongShippingAddressCommand?: CorrectWrongShippingAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsCorrectWrongShippingAddressPost(correctWrongShippingAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateCargoCarrierPreferenceProblemCommand} [createCargoCarrierPreferenceProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsCreateCargoCarrierPreferenceProblemPost(createCargoCarrierPreferenceProblemCommand?: CreateCargoCarrierPreferenceProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsCreateCargoCarrierPreferenceProblemPost(createCargoCarrierPreferenceProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateMissingCargoPackageLabelProblemCommand} [createMissingCargoPackageLabelProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsCreateMissingCargoPackageLabelProblemPost(createMissingCargoPackageLabelProblemCommand?: CreateMissingCargoPackageLabelProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsCreateMissingCargoPackageLabelProblemPost(createMissingCargoPackageLabelProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateMissingSLAMLabelProblemCommand} [createMissingSLAMLabelProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsCreateMissingSLAMLabelProblemPost(createMissingSLAMLabelProblemCommand?: CreateMissingSLAMLabelProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsCreateMissingSLAMLabelProblemPost(createMissingSLAMLabelProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetCargoCarrierPreferenceProblemDetailsGet(problemReferenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCargoCarrierPreferenceProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetCargoCarrierPreferenceProblemDetailsGet(problemReferenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetCargoCarrierQuotaProblemDetailsGet(problemReferenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCargoCarrierQuotaProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetCargoCarrierQuotaProblemDetailsGet(problemReferenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetCargoCodeUpdatedProblemDetailsGet(problemReferenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CargoCodeUpdatedProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetCargoCodeUpdatedProblemDetailsGet(problemReferenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetCreatedProblemsBySalesOrderIdGet(salesOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SalesOrderProblemsOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetCreatedProblemsBySalesOrderIdGet(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetDetailLostItemProblemSalesOrderGet(salesOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDetailLostItemProblemSalesOrderOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetDetailLostItemProblemSalesOrderGet(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetInProgressProblemsBySalesOrderIdGet(salesOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SalesOrderProblemsOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetInProgressProblemsBySalesOrderIdGet(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetIntegrationCodeProblemDetailsGet(problemReferenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationCodeProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetIntegrationCodeProblemDetailsGet(problemReferenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetLostItemProblemDetailsGet(problemReferenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLostItemProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetLostItemProblemDetailsGet(problemReferenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetLostItemProblemSalesOrdersQuery} [getLostItemProblemSalesOrdersQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetLostItemProblemSalesOrdersPost(getLostItemProblemSalesOrdersQuery?: GetLostItemProblemSalesOrdersQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetLostItemProblemSalesOrdersOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetLostItemProblemSalesOrdersPost(getLostItemProblemSalesOrdersQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetMarketplaceCargoCarrierQuotaProblemDetailsGet(problemReferenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMarketplaceCargoCarrierQuotaProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetMarketplaceCargoCarrierQuotaProblemDetailsGet(problemReferenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetMissingCargoPackageLabelProblemDetailsGet(problemReferenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MissingCargoPackageLabelProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetMissingCargoPackageLabelProblemDetailsGet(problemReferenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetMissingSLAMLabelProblemDetailsGet(problemReferenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MissingSLAMLabelProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetMissingSLAMLabelProblemDetailsGet(problemReferenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetResolvedProblemsBySalesOrderIdGet(salesOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SalesOrderProblemsOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetResolvedProblemsBySalesOrderIdGet(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetSLAMShipmentProblemDetailsGet(problemReferenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SLAMShipmentProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetSLAMShipmentProblemDetailsGet(problemReferenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetSalesOrderDetailsForProblemGet(problemReferenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSalesOrderDetailsForProblemOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetSalesOrderDetailsForProblemGet(problemReferenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetSalesOrderProblemDetailsGet(salesOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrderProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetSalesOrderProblemDetailsGet(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsGetWrongShippingAddressProblemDetailsGet(problemReferenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WrongShippingAddressProblemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsGetWrongShippingAddressProblemDetailsGet(problemReferenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsListReportedByUserProblemsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsListReportedByUserProblemsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsQueryDispatchProblemsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProblemQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsQueryDispatchProblemsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsQueryDispatchProblemsManagementCountsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryDispatchProblemsManagementCountsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsQueryDispatchProblemsManagementCountsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsQueryPickingProblemsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickingProblemQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsQueryPickingProblemsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsQueryPickingProblemsManagementCountsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryPickingProblemsManagementCountsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsQueryPickingProblemsManagementCountsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RenewExternalContractCommand} [renewExternalContractCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsRenewExternalContractPost(renewExternalContractCommand?: RenewExternalContractCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsRenewExternalContractPost(renewExternalContractCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SolveCargoCarrierPreferenceProblemCommand} [solveCargoCarrierPreferenceProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsSolveCargoCarrierPreferenceProblemPost(solveCargoCarrierPreferenceProblemCommand?: SolveCargoCarrierPreferenceProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsSolveCargoCarrierPreferenceProblemPost(solveCargoCarrierPreferenceProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SolveCargoCarrierQuotaProblemCommand} [solveCargoCarrierQuotaProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsSolveCargoCarrierQuotaProblemPost(solveCargoCarrierQuotaProblemCommand?: SolveCargoCarrierQuotaProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsSolveCargoCarrierQuotaProblemPost(solveCargoCarrierQuotaProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SolveSalesOrderProblemCommand} [solveSalesOrderProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsSolveCargoCodeUpdatedProblemPost(solveSalesOrderProblemCommand?: SolveSalesOrderProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SolveCargoCodeUpdatedProblemOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsSolveCargoCodeUpdatedProblemPost(solveSalesOrderProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SolveSalesOrderProblemCommand} [solveSalesOrderProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsSolveIntegrationCodeProblemForSLAMPost(solveSalesOrderProblemCommand?: SolveSalesOrderProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsSolveIntegrationCodeProblemForSLAMPost(solveSalesOrderProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SolveIntegrationCodeProblemCommand} [solveIntegrationCodeProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsSolveIntegrationCodeProblemPost(solveIntegrationCodeProblemCommand?: SolveIntegrationCodeProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsSolveIntegrationCodeProblemPost(solveIntegrationCodeProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SolveMarketplaceCargoCarrierQuotaProblemCommand} [solveMarketplaceCargoCarrierQuotaProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsSolveMarketplaceCargoCarrierQuotaProblemPost(solveMarketplaceCargoCarrierQuotaProblemCommand?: SolveMarketplaceCargoCarrierQuotaProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsSolveMarketplaceCargoCarrierQuotaProblemPost(solveMarketplaceCargoCarrierQuotaProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SolveMissingCargoPackageLabelProblemCommand} [solveMissingCargoPackageLabelProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsSolveMissingCargoPackageLabelProblemPost(solveMissingCargoPackageLabelProblemCommand?: SolveMissingCargoPackageLabelProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsSolveMissingCargoPackageLabelProblemPost(solveMissingCargoPackageLabelProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SolveMissingSLAMLabelProblemCommand} [solveMissingSLAMLabelProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsSolveMissingSLAMLabelProblemPost(solveMissingSLAMLabelProblemCommand?: SolveMissingSLAMLabelProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsSolveMissingSLAMLabelProblemPost(solveMissingSLAMLabelProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SolveSLAMShipmentProblemCommand} [solveSLAMShipmentProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsSolveSLAMShipmentProblemPost(solveSLAMShipmentProblemCommand?: SolveSLAMShipmentProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SolveSLAMShipmentProblemOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsSolveSLAMShipmentProblemPost(solveSLAMShipmentProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SolveWrongShippingAddressProblemCommand} [solveWrongShippingAddressProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsSolveWrongShippingAddressProblemPost(solveWrongShippingAddressProblemCommand?: SolveWrongShippingAddressProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SolveWrongShippingAddressProblemOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsSolveWrongShippingAddressProblemPost(solveWrongShippingAddressProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateCargoDetailsIntegrationCodeProblemCommand} [updateCargoDetailsIntegrationCodeProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsUpdateCargoDetailsIntegrationCodeProblemPost(updateCargoDetailsIntegrationCodeProblemCommand?: UpdateCargoDetailsIntegrationCodeProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsUpdateCargoDetailsIntegrationCodeProblemPost(updateCargoDetailsIntegrationCodeProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateLostItemProblemSolutionTypeCommand} [updateLostItemProblemSolutionTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProblemsUpdateLostItemProblemSolutionTypePost(updateLostItemProblemSolutionTypeCommand?: UpdateLostItemProblemSolutionTypeCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProblemsUpdateLostItemProblemSolutionTypePost(updateLostItemProblemSolutionTypeCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProblemsApi - factory interface
 * @export
 */
export const ProblemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProblemsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsCheckBarcodeTypeGet(barcode?: string, options?: any): AxiosPromise<BarcodeTypeOutputDTO> {
            return localVarFp.apiV1ProblemsCheckBarcodeTypeGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CorrectWrongShippingAddressCommand} [correctWrongShippingAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsCorrectWrongShippingAddressPost(correctWrongShippingAddressCommand?: CorrectWrongShippingAddressCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ProblemsCorrectWrongShippingAddressPost(correctWrongShippingAddressCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCargoCarrierPreferenceProblemCommand} [createCargoCarrierPreferenceProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsCreateCargoCarrierPreferenceProblemPost(createCargoCarrierPreferenceProblemCommand?: CreateCargoCarrierPreferenceProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ProblemsCreateCargoCarrierPreferenceProblemPost(createCargoCarrierPreferenceProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateMissingCargoPackageLabelProblemCommand} [createMissingCargoPackageLabelProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsCreateMissingCargoPackageLabelProblemPost(createMissingCargoPackageLabelProblemCommand?: CreateMissingCargoPackageLabelProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ProblemsCreateMissingCargoPackageLabelProblemPost(createMissingCargoPackageLabelProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateMissingSLAMLabelProblemCommand} [createMissingSLAMLabelProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsCreateMissingSLAMLabelProblemPost(createMissingSLAMLabelProblemCommand?: CreateMissingSLAMLabelProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ProblemsCreateMissingSLAMLabelProblemPost(createMissingSLAMLabelProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetCargoCarrierPreferenceProblemDetailsGet(problemReferenceNumber?: string, options?: any): AxiosPromise<GetCargoCarrierPreferenceProblemDetailsOutputDTO> {
            return localVarFp.apiV1ProblemsGetCargoCarrierPreferenceProblemDetailsGet(problemReferenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetCargoCarrierQuotaProblemDetailsGet(problemReferenceNumber?: string, options?: any): AxiosPromise<GetCargoCarrierQuotaProblemDetailsOutputDTO> {
            return localVarFp.apiV1ProblemsGetCargoCarrierQuotaProblemDetailsGet(problemReferenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetCargoCodeUpdatedProblemDetailsGet(problemReferenceNumber?: string, options?: any): AxiosPromise<CargoCodeUpdatedProblemDetailsOutputDTO> {
            return localVarFp.apiV1ProblemsGetCargoCodeUpdatedProblemDetailsGet(problemReferenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetCreatedProblemsBySalesOrderIdGet(salesOrderId?: string, options?: any): AxiosPromise<Array<SalesOrderProblemsOutputDTO>> {
            return localVarFp.apiV1ProblemsGetCreatedProblemsBySalesOrderIdGet(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetDetailLostItemProblemSalesOrderGet(salesOrderId?: string, options?: any): AxiosPromise<GetDetailLostItemProblemSalesOrderOutputDTO> {
            return localVarFp.apiV1ProblemsGetDetailLostItemProblemSalesOrderGet(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetInProgressProblemsBySalesOrderIdGet(salesOrderId?: string, options?: any): AxiosPromise<Array<SalesOrderProblemsOutputDTO>> {
            return localVarFp.apiV1ProblemsGetInProgressProblemsBySalesOrderIdGet(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetIntegrationCodeProblemDetailsGet(problemReferenceNumber?: string, options?: any): AxiosPromise<IntegrationCodeProblemDetailsOutputDTO> {
            return localVarFp.apiV1ProblemsGetIntegrationCodeProblemDetailsGet(problemReferenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetLostItemProblemDetailsGet(problemReferenceNumber?: string, options?: any): AxiosPromise<GetLostItemProblemDetailsOutputDTO> {
            return localVarFp.apiV1ProblemsGetLostItemProblemDetailsGet(problemReferenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetLostItemProblemSalesOrdersQuery} [getLostItemProblemSalesOrdersQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetLostItemProblemSalesOrdersPost(getLostItemProblemSalesOrdersQuery?: GetLostItemProblemSalesOrdersQuery, options?: any): AxiosPromise<Array<GetLostItemProblemSalesOrdersOutputDTO>> {
            return localVarFp.apiV1ProblemsGetLostItemProblemSalesOrdersPost(getLostItemProblemSalesOrdersQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetMarketplaceCargoCarrierQuotaProblemDetailsGet(problemReferenceNumber?: string, options?: any): AxiosPromise<GetMarketplaceCargoCarrierQuotaProblemDetailsOutputDTO> {
            return localVarFp.apiV1ProblemsGetMarketplaceCargoCarrierQuotaProblemDetailsGet(problemReferenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetMissingCargoPackageLabelProblemDetailsGet(problemReferenceNumber?: string, options?: any): AxiosPromise<MissingCargoPackageLabelProblemDetailsOutputDTO> {
            return localVarFp.apiV1ProblemsGetMissingCargoPackageLabelProblemDetailsGet(problemReferenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetMissingSLAMLabelProblemDetailsGet(problemReferenceNumber?: string, options?: any): AxiosPromise<MissingSLAMLabelProblemDetailsOutputDTO> {
            return localVarFp.apiV1ProblemsGetMissingSLAMLabelProblemDetailsGet(problemReferenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetResolvedProblemsBySalesOrderIdGet(salesOrderId?: string, options?: any): AxiosPromise<Array<SalesOrderProblemsOutputDTO>> {
            return localVarFp.apiV1ProblemsGetResolvedProblemsBySalesOrderIdGet(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetSLAMShipmentProblemDetailsGet(problemReferenceNumber?: string, options?: any): AxiosPromise<SLAMShipmentProblemDetailsOutputDTO> {
            return localVarFp.apiV1ProblemsGetSLAMShipmentProblemDetailsGet(problemReferenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetSalesOrderDetailsForProblemGet(problemReferenceNumber?: string, options?: any): AxiosPromise<GetSalesOrderDetailsForProblemOutputDTO> {
            return localVarFp.apiV1ProblemsGetSalesOrderDetailsForProblemGet(problemReferenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetSalesOrderProblemDetailsGet(salesOrderId?: string, options?: any): AxiosPromise<SalesOrderProblemDetailsOutputDTO> {
            return localVarFp.apiV1ProblemsGetSalesOrderProblemDetailsGet(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [problemReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsGetWrongShippingAddressProblemDetailsGet(problemReferenceNumber?: string, options?: any): AxiosPromise<WrongShippingAddressProblemDetailsOutputDTO> {
            return localVarFp.apiV1ProblemsGetWrongShippingAddressProblemDetailsGet(problemReferenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsListReportedByUserProblemsGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiV1ProblemsListReportedByUserProblemsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsQueryDispatchProblemsGet(dqb?: string, options?: any): AxiosPromise<ProblemQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ProblemsQueryDispatchProblemsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsQueryDispatchProblemsManagementCountsGet(options?: any): AxiosPromise<QueryDispatchProblemsManagementCountsOutputDTO> {
            return localVarFp.apiV1ProblemsQueryDispatchProblemsManagementCountsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsQueryPickingProblemsGet(dqb?: string, options?: any): AxiosPromise<PickingProblemQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ProblemsQueryPickingProblemsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsQueryPickingProblemsManagementCountsGet(options?: any): AxiosPromise<QueryPickingProblemsManagementCountsOutputDTO> {
            return localVarFp.apiV1ProblemsQueryPickingProblemsManagementCountsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RenewExternalContractCommand} [renewExternalContractCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsRenewExternalContractPost(renewExternalContractCommand?: RenewExternalContractCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ProblemsRenewExternalContractPost(renewExternalContractCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolveCargoCarrierPreferenceProblemCommand} [solveCargoCarrierPreferenceProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveCargoCarrierPreferenceProblemPost(solveCargoCarrierPreferenceProblemCommand?: SolveCargoCarrierPreferenceProblemCommand, options?: any): AxiosPromise<string> {
            return localVarFp.apiV1ProblemsSolveCargoCarrierPreferenceProblemPost(solveCargoCarrierPreferenceProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolveCargoCarrierQuotaProblemCommand} [solveCargoCarrierQuotaProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveCargoCarrierQuotaProblemPost(solveCargoCarrierQuotaProblemCommand?: SolveCargoCarrierQuotaProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ProblemsSolveCargoCarrierQuotaProblemPost(solveCargoCarrierQuotaProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolveSalesOrderProblemCommand} [solveSalesOrderProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveCargoCodeUpdatedProblemPost(solveSalesOrderProblemCommand?: SolveSalesOrderProblemCommand, options?: any): AxiosPromise<SolveCargoCodeUpdatedProblemOutputDTO> {
            return localVarFp.apiV1ProblemsSolveCargoCodeUpdatedProblemPost(solveSalesOrderProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolveSalesOrderProblemCommand} [solveSalesOrderProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveIntegrationCodeProblemForSLAMPost(solveSalesOrderProblemCommand?: SolveSalesOrderProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ProblemsSolveIntegrationCodeProblemForSLAMPost(solveSalesOrderProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolveIntegrationCodeProblemCommand} [solveIntegrationCodeProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveIntegrationCodeProblemPost(solveIntegrationCodeProblemCommand?: SolveIntegrationCodeProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ProblemsSolveIntegrationCodeProblemPost(solveIntegrationCodeProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolveMarketplaceCargoCarrierQuotaProblemCommand} [solveMarketplaceCargoCarrierQuotaProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveMarketplaceCargoCarrierQuotaProblemPost(solveMarketplaceCargoCarrierQuotaProblemCommand?: SolveMarketplaceCargoCarrierQuotaProblemCommand, options?: any): AxiosPromise<string> {
            return localVarFp.apiV1ProblemsSolveMarketplaceCargoCarrierQuotaProblemPost(solveMarketplaceCargoCarrierQuotaProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolveMissingCargoPackageLabelProblemCommand} [solveMissingCargoPackageLabelProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveMissingCargoPackageLabelProblemPost(solveMissingCargoPackageLabelProblemCommand?: SolveMissingCargoPackageLabelProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ProblemsSolveMissingCargoPackageLabelProblemPost(solveMissingCargoPackageLabelProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolveMissingSLAMLabelProblemCommand} [solveMissingSLAMLabelProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveMissingSLAMLabelProblemPost(solveMissingSLAMLabelProblemCommand?: SolveMissingSLAMLabelProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ProblemsSolveMissingSLAMLabelProblemPost(solveMissingSLAMLabelProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolveSLAMShipmentProblemCommand} [solveSLAMShipmentProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveSLAMShipmentProblemPost(solveSLAMShipmentProblemCommand?: SolveSLAMShipmentProblemCommand, options?: any): AxiosPromise<SolveSLAMShipmentProblemOutputDTO> {
            return localVarFp.apiV1ProblemsSolveSLAMShipmentProblemPost(solveSLAMShipmentProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolveWrongShippingAddressProblemCommand} [solveWrongShippingAddressProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsSolveWrongShippingAddressProblemPost(solveWrongShippingAddressProblemCommand?: SolveWrongShippingAddressProblemCommand, options?: any): AxiosPromise<SolveWrongShippingAddressProblemOutputDTO> {
            return localVarFp.apiV1ProblemsSolveWrongShippingAddressProblemPost(solveWrongShippingAddressProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCargoDetailsIntegrationCodeProblemCommand} [updateCargoDetailsIntegrationCodeProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsUpdateCargoDetailsIntegrationCodeProblemPost(updateCargoDetailsIntegrationCodeProblemCommand?: UpdateCargoDetailsIntegrationCodeProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ProblemsUpdateCargoDetailsIntegrationCodeProblemPost(updateCargoDetailsIntegrationCodeProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateLostItemProblemSolutionTypeCommand} [updateLostItemProblemSolutionTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProblemsUpdateLostItemProblemSolutionTypePost(updateLostItemProblemSolutionTypeCommand?: UpdateLostItemProblemSolutionTypeCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ProblemsUpdateLostItemProblemSolutionTypePost(updateLostItemProblemSolutionTypeCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProblemsApi - object-oriented interface
 * @export
 * @class ProblemsApi
 * @extends {BaseAPI}
 */
export class ProblemsApi extends BaseAPI {
    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsCheckBarcodeTypeGet(barcode?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsCheckBarcodeTypeGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CorrectWrongShippingAddressCommand} [correctWrongShippingAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsCorrectWrongShippingAddressPost(correctWrongShippingAddressCommand?: CorrectWrongShippingAddressCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsCorrectWrongShippingAddressPost(correctWrongShippingAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateCargoCarrierPreferenceProblemCommand} [createCargoCarrierPreferenceProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsCreateCargoCarrierPreferenceProblemPost(createCargoCarrierPreferenceProblemCommand?: CreateCargoCarrierPreferenceProblemCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsCreateCargoCarrierPreferenceProblemPost(createCargoCarrierPreferenceProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateMissingCargoPackageLabelProblemCommand} [createMissingCargoPackageLabelProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsCreateMissingCargoPackageLabelProblemPost(createMissingCargoPackageLabelProblemCommand?: CreateMissingCargoPackageLabelProblemCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsCreateMissingCargoPackageLabelProblemPost(createMissingCargoPackageLabelProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateMissingSLAMLabelProblemCommand} [createMissingSLAMLabelProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsCreateMissingSLAMLabelProblemPost(createMissingSLAMLabelProblemCommand?: CreateMissingSLAMLabelProblemCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsCreateMissingSLAMLabelProblemPost(createMissingSLAMLabelProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemReferenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetCargoCarrierPreferenceProblemDetailsGet(problemReferenceNumber?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetCargoCarrierPreferenceProblemDetailsGet(problemReferenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemReferenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetCargoCarrierQuotaProblemDetailsGet(problemReferenceNumber?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetCargoCarrierQuotaProblemDetailsGet(problemReferenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemReferenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetCargoCodeUpdatedProblemDetailsGet(problemReferenceNumber?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetCargoCodeUpdatedProblemDetailsGet(problemReferenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetCreatedProblemsBySalesOrderIdGet(salesOrderId?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetCreatedProblemsBySalesOrderIdGet(salesOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetDetailLostItemProblemSalesOrderGet(salesOrderId?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetDetailLostItemProblemSalesOrderGet(salesOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetInProgressProblemsBySalesOrderIdGet(salesOrderId?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetInProgressProblemsBySalesOrderIdGet(salesOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemReferenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetIntegrationCodeProblemDetailsGet(problemReferenceNumber?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetIntegrationCodeProblemDetailsGet(problemReferenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemReferenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetLostItemProblemDetailsGet(problemReferenceNumber?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetLostItemProblemDetailsGet(problemReferenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetLostItemProblemSalesOrdersQuery} [getLostItemProblemSalesOrdersQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetLostItemProblemSalesOrdersPost(getLostItemProblemSalesOrdersQuery?: GetLostItemProblemSalesOrdersQuery, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetLostItemProblemSalesOrdersPost(getLostItemProblemSalesOrdersQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemReferenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetMarketplaceCargoCarrierQuotaProblemDetailsGet(problemReferenceNumber?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetMarketplaceCargoCarrierQuotaProblemDetailsGet(problemReferenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemReferenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetMissingCargoPackageLabelProblemDetailsGet(problemReferenceNumber?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetMissingCargoPackageLabelProblemDetailsGet(problemReferenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemReferenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetMissingSLAMLabelProblemDetailsGet(problemReferenceNumber?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetMissingSLAMLabelProblemDetailsGet(problemReferenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetResolvedProblemsBySalesOrderIdGet(salesOrderId?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetResolvedProblemsBySalesOrderIdGet(salesOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemReferenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetSLAMShipmentProblemDetailsGet(problemReferenceNumber?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetSLAMShipmentProblemDetailsGet(problemReferenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemReferenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetSalesOrderDetailsForProblemGet(problemReferenceNumber?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetSalesOrderDetailsForProblemGet(problemReferenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetSalesOrderProblemDetailsGet(salesOrderId?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetSalesOrderProblemDetailsGet(salesOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [problemReferenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsGetWrongShippingAddressProblemDetailsGet(problemReferenceNumber?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsGetWrongShippingAddressProblemDetailsGet(problemReferenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsListReportedByUserProblemsGet(options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsListReportedByUserProblemsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsQueryDispatchProblemsGet(dqb?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsQueryDispatchProblemsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsQueryDispatchProblemsManagementCountsGet(options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsQueryDispatchProblemsManagementCountsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsQueryPickingProblemsGet(dqb?: string, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsQueryPickingProblemsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsQueryPickingProblemsManagementCountsGet(options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsQueryPickingProblemsManagementCountsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RenewExternalContractCommand} [renewExternalContractCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsRenewExternalContractPost(renewExternalContractCommand?: RenewExternalContractCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsRenewExternalContractPost(renewExternalContractCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolveCargoCarrierPreferenceProblemCommand} [solveCargoCarrierPreferenceProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsSolveCargoCarrierPreferenceProblemPost(solveCargoCarrierPreferenceProblemCommand?: SolveCargoCarrierPreferenceProblemCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsSolveCargoCarrierPreferenceProblemPost(solveCargoCarrierPreferenceProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolveCargoCarrierQuotaProblemCommand} [solveCargoCarrierQuotaProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsSolveCargoCarrierQuotaProblemPost(solveCargoCarrierQuotaProblemCommand?: SolveCargoCarrierQuotaProblemCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsSolveCargoCarrierQuotaProblemPost(solveCargoCarrierQuotaProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolveSalesOrderProblemCommand} [solveSalesOrderProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsSolveCargoCodeUpdatedProblemPost(solveSalesOrderProblemCommand?: SolveSalesOrderProblemCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsSolveCargoCodeUpdatedProblemPost(solveSalesOrderProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolveSalesOrderProblemCommand} [solveSalesOrderProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsSolveIntegrationCodeProblemForSLAMPost(solveSalesOrderProblemCommand?: SolveSalesOrderProblemCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsSolveIntegrationCodeProblemForSLAMPost(solveSalesOrderProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolveIntegrationCodeProblemCommand} [solveIntegrationCodeProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsSolveIntegrationCodeProblemPost(solveIntegrationCodeProblemCommand?: SolveIntegrationCodeProblemCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsSolveIntegrationCodeProblemPost(solveIntegrationCodeProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolveMarketplaceCargoCarrierQuotaProblemCommand} [solveMarketplaceCargoCarrierQuotaProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsSolveMarketplaceCargoCarrierQuotaProblemPost(solveMarketplaceCargoCarrierQuotaProblemCommand?: SolveMarketplaceCargoCarrierQuotaProblemCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsSolveMarketplaceCargoCarrierQuotaProblemPost(solveMarketplaceCargoCarrierQuotaProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolveMissingCargoPackageLabelProblemCommand} [solveMissingCargoPackageLabelProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsSolveMissingCargoPackageLabelProblemPost(solveMissingCargoPackageLabelProblemCommand?: SolveMissingCargoPackageLabelProblemCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsSolveMissingCargoPackageLabelProblemPost(solveMissingCargoPackageLabelProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolveMissingSLAMLabelProblemCommand} [solveMissingSLAMLabelProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsSolveMissingSLAMLabelProblemPost(solveMissingSLAMLabelProblemCommand?: SolveMissingSLAMLabelProblemCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsSolveMissingSLAMLabelProblemPost(solveMissingSLAMLabelProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolveSLAMShipmentProblemCommand} [solveSLAMShipmentProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsSolveSLAMShipmentProblemPost(solveSLAMShipmentProblemCommand?: SolveSLAMShipmentProblemCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsSolveSLAMShipmentProblemPost(solveSLAMShipmentProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolveWrongShippingAddressProblemCommand} [solveWrongShippingAddressProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsSolveWrongShippingAddressProblemPost(solveWrongShippingAddressProblemCommand?: SolveWrongShippingAddressProblemCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsSolveWrongShippingAddressProblemPost(solveWrongShippingAddressProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCargoDetailsIntegrationCodeProblemCommand} [updateCargoDetailsIntegrationCodeProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsUpdateCargoDetailsIntegrationCodeProblemPost(updateCargoDetailsIntegrationCodeProblemCommand?: UpdateCargoDetailsIntegrationCodeProblemCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsUpdateCargoDetailsIntegrationCodeProblemPost(updateCargoDetailsIntegrationCodeProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateLostItemProblemSolutionTypeCommand} [updateLostItemProblemSolutionTypeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemsApi
     */
    public apiV1ProblemsUpdateLostItemProblemSolutionTypePost(updateLostItemProblemSolutionTypeCommand?: UpdateLostItemProblemSolutionTypeCommand, options?: any) {
        return ProblemsApiFp(this.configuration).apiV1ProblemsUpdateLostItemProblemSolutionTypePost(updateLostItemProblemSolutionTypeCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProcessConfigurationsApi - axios parameter creator
 * @export
 */
export const ProcessConfigurationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProcessConfigurationsGetProcessConfigurationsByOperationIdGet: async (operationId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ProcessConfigurations.getProcessConfigurationsByOperationId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (operationId !== undefined) {
                localVarQueryParameter['operationId'] = operationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [zoneId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProcessConfigurationsGetProcessConfigurationsByZoneIdGet: async (zoneId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ProcessConfigurations.getProcessConfigurationsByZoneId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (zoneId !== undefined) {
                localVarQueryParameter['zoneId'] = zoneId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessConfigurationsApi - functional programming interface
 * @export
 */
export const ProcessConfigurationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessConfigurationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProcessConfigurationsGetProcessConfigurationsByOperationIdGet(operationId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessConfigurationsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProcessConfigurationsGetProcessConfigurationsByOperationIdGet(operationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [zoneId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProcessConfigurationsGetProcessConfigurationsByZoneIdGet(zoneId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessConfigurationsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProcessConfigurationsGetProcessConfigurationsByZoneIdGet(zoneId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProcessConfigurationsApi - factory interface
 * @export
 */
export const ProcessConfigurationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessConfigurationsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProcessConfigurationsGetProcessConfigurationsByOperationIdGet(operationId?: string, options?: any): AxiosPromise<ProcessConfigurationsOutputDTO> {
            return localVarFp.apiV1ProcessConfigurationsGetProcessConfigurationsByOperationIdGet(operationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [zoneId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProcessConfigurationsGetProcessConfigurationsByZoneIdGet(zoneId?: number, options?: any): AxiosPromise<ProcessConfigurationsOutputDTO> {
            return localVarFp.apiV1ProcessConfigurationsGetProcessConfigurationsByZoneIdGet(zoneId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessConfigurationsApi - object-oriented interface
 * @export
 * @class ProcessConfigurationsApi
 * @extends {BaseAPI}
 */
export class ProcessConfigurationsApi extends BaseAPI {
    /**
     * 
     * @param {string} [operationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessConfigurationsApi
     */
    public apiV1ProcessConfigurationsGetProcessConfigurationsByOperationIdGet(operationId?: string, options?: any) {
        return ProcessConfigurationsApiFp(this.configuration).apiV1ProcessConfigurationsGetProcessConfigurationsByOperationIdGet(operationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [zoneId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessConfigurationsApi
     */
    public apiV1ProcessConfigurationsGetProcessConfigurationsByZoneIdGet(zoneId?: number, options?: any) {
        return ProcessConfigurationsApiFp(this.configuration).apiV1ProcessConfigurationsGetProcessConfigurationsByZoneIdGet(zoneId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProcessDetailsApi - axios parameter creator
 * @export
 */
export const ProcessDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [processId] 
         * @param {ProcessType} [processType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProcessDetailsGetProcessCompletionTimeDetailsGet: async (processId?: string, processType?: ProcessType, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ProcessDetails.getProcessCompletionTimeDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (processId !== undefined) {
                localVarQueryParameter['ProcessId'] = processId;
            }

            if (processType !== undefined) {
                localVarQueryParameter['ProcessType'] = processType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessDetailsApi - functional programming interface
 * @export
 */
export const ProcessDetailsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessDetailsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [processId] 
         * @param {ProcessType} [processType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProcessDetailsGetProcessCompletionTimeDetailsGet(processId?: string, processType?: ProcessType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompletionTimeResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProcessDetailsGetProcessCompletionTimeDetailsGet(processId, processType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProcessDetailsApi - factory interface
 * @export
 */
export const ProcessDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessDetailsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [processId] 
         * @param {ProcessType} [processType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProcessDetailsGetProcessCompletionTimeDetailsGet(processId?: string, processType?: ProcessType, options?: any): AxiosPromise<CompletionTimeResultDTO> {
            return localVarFp.apiV1ProcessDetailsGetProcessCompletionTimeDetailsGet(processId, processType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessDetailsApi - object-oriented interface
 * @export
 * @class ProcessDetailsApi
 * @extends {BaseAPI}
 */
export class ProcessDetailsApi extends BaseAPI {
    /**
     * 
     * @param {string} [processId] 
     * @param {ProcessType} [processType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessDetailsApi
     */
    public apiV1ProcessDetailsGetProcessCompletionTimeDetailsGet(processId?: string, processType?: ProcessType, options?: any) {
        return ProcessDetailsApiFp(this.configuration).apiV1ProcessDetailsGetProcessCompletionTimeDetailsGet(processId, processType, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsGetInventoryStatusByProductGet: async (productId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Products.getInventoryStatusByProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {string} [productBarcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsGetProductDetailsGet: async (productId?: string, productBarcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Products.getProductDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }

            if (productBarcode !== undefined) {
                localVarQueryParameter['productBarcode'] = productBarcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Products.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsQueryInventoryItemsByProductGet: async (productId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiV1ProductsQueryInventoryItemsByProductGet', 'productId', productId)
            const localVarPath = `/api/v1/Products.queryInventoryItemsByProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsQueryProductListingsGet: async (productId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiV1ProductsQueryProductListingsGet', 'productId', productId)
            const localVarPath = `/api/v1/Products.queryProductListings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsQueryProductReturnPackageDetailsGet: async (productId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiV1ProductsQueryProductReturnPackageDetailsGet', 'productId', productId)
            const localVarPath = `/api/v1/Products.queryProductReturnPackageDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsQueryProductStockCountingListsGet: async (productId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiV1ProductsQueryProductStockCountingListsGet', 'productId', productId)
            const localVarPath = `/api/v1/Products.queryProductStockCountingLists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsQueryShippingItemsByProductGet: async (productId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiV1ProductsQueryShippingItemsByProductGet', 'productId', productId)
            const localVarPath = `/api/v1/Products.queryShippingItemsByProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kittingappV1ProductsQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/kittingapp/v1/Products/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataProducts: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/odata/Products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataProductsCount: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/odata/Products/$count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkCreateProductCommand} [bulkCreateProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1ProductsBulkCreatePost: async (bulkCreateProductCommand?: BulkCreateProductCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/Products/bulkCreate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkUpsertProductCommand} [bulkUpsertProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1ProductsBulkUpsertPost: async (bulkUpsertProductCommand?: BulkUpsertProductCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/Products/bulkUpsert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpsertProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteProductCommand} [deleteProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1ProductsDelete: async (deleteProductCommand?: DeleteProductCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/Products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddBarcodeCommand} [addBarcodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsAddBarcodePost: async (addBarcodeCommand?: AddBarcodeCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Products/addBarcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addBarcodeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CleanupDeletedOperationInventoryItemsCommand} [cleanupDeletedOperationInventoryItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsCleanupDeletedOperationInventoryItemsPost: async (cleanupDeletedOperationInventoryItemsCommand?: CleanupDeletedOperationInventoryItemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Products/cleanupDeletedOperationInventoryItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cleanupDeletedOperationInventoryItemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteProductBarcodeCommand} [deleteProductBarcodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsDeleteBarcodePost: async (deleteProductBarcodeCommand?: DeleteProductBarcodeCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Products/deleteBarcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteProductBarcodeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteSupportProductCommand} [deleteSupportProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsDeleteProductPost: async (deleteSupportProductCommand?: DeleteSupportProductCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Products/deleteProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSupportProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteProductsCommand} [deleteProductsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsDeleteProductsPost: async (deleteProductsCommand?: DeleteProductsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Products/deleteProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteProductsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DisableProductExpirationTrackingCommand} [disableProductExpirationTrackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsDisableProductExpirationTrackingPost: async (disableProductExpirationTrackingCommand?: DisableProductExpirationTrackingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Products/disableProductExpirationTracking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(disableProductExpirationTrackingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DisableProductLotNumberTrackingCommand} [disableProductLotNumberTrackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsDisableProductLotNumberTrackingPost: async (disableProductLotNumberTrackingCommand?: DisableProductLotNumberTrackingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Products/disableProductLotNumberTracking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(disableProductLotNumberTrackingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnableProductExpirationDateCommand} [enableProductExpirationDateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsEnableProductExpirationDatePost: async (enableProductExpirationDateCommand?: EnableProductExpirationDateCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Products/enableProductExpirationDate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enableProductExpirationDateCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnableProductLotNumberTrackingCommand} [enableProductLotNumberTrackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsEnableProductLotNumberTrackingPost: async (enableProductLotNumberTrackingCommand?: EnableProductLotNumberTrackingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Products/enableProductLotNumberTracking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enableProductLotNumberTrackingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SyncStockItemAmountsCommand} [syncStockItemAmountsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsSyncStockItemAmountsPost: async (syncStockItemAmountsCommand?: SyncStockItemAmountsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Products/syncStockItemAmounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncStockItemAmountsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateProductBarcodeCommand} [updateProductBarcodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsUpdateBarcodePost: async (updateProductBarcodeCommand?: UpdateProductBarcodeCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Products/updateBarcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductBarcodeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateProductSkuCommand} [updateProductSkuCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsUpdateProductSkuPost: async (updateProductSkuCommand?: UpdateProductSkuCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Products/updateProductSku`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductSkuCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertMasterCartonProductCommand} [upsertMasterCartonProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsUpsertMasterCartonProductPost: async (upsertMasterCartonProductCommand?: UpsertMasterCartonProductCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Products/upsertMasterCartonProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertMasterCartonProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertProductDimensionsBulkCommand} [upsertProductDimensionsBulkCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsUpsertProductDimensionsBulkPost: async (upsertProductDimensionsBulkCommand?: UpsertProductDimensionsBulkCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Products/upsertProductDimensionsBulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertProductDimensionsBulkCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductsGetInventoryStatusByProductGet(productId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryStatusByProductOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductsGetInventoryStatusByProductGet(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {string} [productBarcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductsGetProductDetailsGet(productId?: string, productBarcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductsGetProductDetailsGet(productId, productBarcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductsQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductsQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductsQueryInventoryItemsByProductGet(productId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryByProductQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductsQueryInventoryItemsByProductGet(productId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductsQueryProductListingsGet(productId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductListingQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductsQueryProductListingsGet(productId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductsQueryProductReturnPackageDetailsGet(productId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductReturnPackageDetailsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductsQueryProductReturnPackageDetailsGet(productId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductsQueryProductStockCountingListsGet(productId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductStockCountingListsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductsQueryProductStockCountingListsGet(productId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ProductsQueryShippingItemsByProductGet(productId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShippingByProductQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProductsQueryShippingItemsByProductGet(productId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kittingappV1ProductsQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kittingappV1ProductsQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async odataProducts(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.odataProducts(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async odataProductsCount(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.odataProductsCount(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkCreateProductCommand} [bulkCreateProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1ProductsBulkCreatePost(bulkCreateProductCommand?: BulkCreateProductCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkCreateProductCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1ProductsBulkCreatePost(bulkCreateProductCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkUpsertProductCommand} [bulkUpsertProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1ProductsBulkUpsertPost(bulkUpsertProductCommand?: BulkUpsertProductCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkUpsertProductCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1ProductsBulkUpsertPost(bulkUpsertProductCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteProductCommand} [deleteProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1ProductsDelete(deleteProductCommand?: DeleteProductCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1ProductsDelete(deleteProductCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddBarcodeCommand} [addBarcodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ProductsAddBarcodePost(addBarcodeCommand?: AddBarcodeCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddProductBarcodeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ProductsAddBarcodePost(addBarcodeCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CleanupDeletedOperationInventoryItemsCommand} [cleanupDeletedOperationInventoryItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ProductsCleanupDeletedOperationInventoryItemsPost(cleanupDeletedOperationInventoryItemsCommand?: CleanupDeletedOperationInventoryItemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CleanupDeletedOperationInventoryItemsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ProductsCleanupDeletedOperationInventoryItemsPost(cleanupDeletedOperationInventoryItemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteProductBarcodeCommand} [deleteProductBarcodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ProductsDeleteBarcodePost(deleteProductBarcodeCommand?: DeleteProductBarcodeCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteProductBarcodeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ProductsDeleteBarcodePost(deleteProductBarcodeCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteSupportProductCommand} [deleteSupportProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ProductsDeleteProductPost(deleteSupportProductCommand?: DeleteSupportProductCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteProductOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ProductsDeleteProductPost(deleteSupportProductCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteProductsCommand} [deleteProductsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ProductsDeleteProductsPost(deleteProductsCommand?: DeleteProductsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteProductsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ProductsDeleteProductsPost(deleteProductsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DisableProductExpirationTrackingCommand} [disableProductExpirationTrackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ProductsDisableProductExpirationTrackingPost(disableProductExpirationTrackingCommand?: DisableProductExpirationTrackingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisableProductExpirationTrackingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ProductsDisableProductExpirationTrackingPost(disableProductExpirationTrackingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DisableProductLotNumberTrackingCommand} [disableProductLotNumberTrackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ProductsDisableProductLotNumberTrackingPost(disableProductLotNumberTrackingCommand?: DisableProductLotNumberTrackingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisableProductLotNumberTrackingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ProductsDisableProductLotNumberTrackingPost(disableProductLotNumberTrackingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EnableProductExpirationDateCommand} [enableProductExpirationDateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ProductsEnableProductExpirationDatePost(enableProductExpirationDateCommand?: EnableProductExpirationDateCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnableProductExpirationDateOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ProductsEnableProductExpirationDatePost(enableProductExpirationDateCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EnableProductLotNumberTrackingCommand} [enableProductLotNumberTrackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ProductsEnableProductLotNumberTrackingPost(enableProductLotNumberTrackingCommand?: EnableProductLotNumberTrackingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnableProductLotNumberTrackingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ProductsEnableProductLotNumberTrackingPost(enableProductLotNumberTrackingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SyncStockItemAmountsCommand} [syncStockItemAmountsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ProductsSyncStockItemAmountsPost(syncStockItemAmountsCommand?: SyncStockItemAmountsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ProductsSyncStockItemAmountsPost(syncStockItemAmountsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateProductBarcodeCommand} [updateProductBarcodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ProductsUpdateBarcodePost(updateProductBarcodeCommand?: UpdateProductBarcodeCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateProductBarcodeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ProductsUpdateBarcodePost(updateProductBarcodeCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateProductSkuCommand} [updateProductSkuCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ProductsUpdateProductSkuPost(updateProductSkuCommand?: UpdateProductSkuCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateProductSkuOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ProductsUpdateProductSkuPost(updateProductSkuCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpsertMasterCartonProductCommand} [upsertMasterCartonProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ProductsUpsertMasterCartonProductPost(upsertMasterCartonProductCommand?: UpsertMasterCartonProductCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertMasterCartonProductOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ProductsUpsertMasterCartonProductPost(upsertMasterCartonProductCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpsertProductDimensionsBulkCommand} [upsertProductDimensionsBulkCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ProductsUpsertProductDimensionsBulkPost(upsertProductDimensionsBulkCommand?: UpsertProductDimensionsBulkCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertProductDimensionsBulkOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ProductsUpsertProductDimensionsBulkPost(upsertProductDimensionsBulkCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsGetInventoryStatusByProductGet(productId?: string, options?: any): AxiosPromise<InventoryStatusByProductOutputDTO> {
            return localVarFp.apiV1ProductsGetInventoryStatusByProductGet(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {string} [productBarcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsGetProductDetailsGet(productId?: string, productBarcode?: string, options?: any): AxiosPromise<ProductDetailsOutputDTO> {
            return localVarFp.apiV1ProductsGetProductDetailsGet(productId, productBarcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsQueryGet(dqb?: string, options?: any): AxiosPromise<ProductQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ProductsQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsQueryInventoryItemsByProductGet(productId: string, dqb?: string, options?: any): AxiosPromise<InventoryByProductQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ProductsQueryInventoryItemsByProductGet(productId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsQueryProductListingsGet(productId: string, dqb?: string, options?: any): AxiosPromise<ProductListingQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ProductsQueryProductListingsGet(productId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsQueryProductReturnPackageDetailsGet(productId: string, dqb?: string, options?: any): AxiosPromise<ProductReturnPackageDetailsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ProductsQueryProductReturnPackageDetailsGet(productId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsQueryProductStockCountingListsGet(productId: string, dqb?: string, options?: any): AxiosPromise<ProductStockCountingListsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ProductsQueryProductStockCountingListsGet(productId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ProductsQueryShippingItemsByProductGet(productId: string, dqb?: string, options?: any): AxiosPromise<ShippingByProductQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ProductsQueryShippingItemsByProductGet(productId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kittingappV1ProductsQueryGet(dqb?: string, options?: any): AxiosPromise<ProductQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.kittingappV1ProductsQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataProducts(dqb?: string, options?: any): AxiosPromise<ProductQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.odataProducts(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataProductsCount(dqb?: string, options?: any): AxiosPromise<ProductQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.odataProductsCount(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkCreateProductCommand} [bulkCreateProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1ProductsBulkCreatePost(bulkCreateProductCommand?: BulkCreateProductCommand, options?: any): AxiosPromise<BulkCreateProductCommandOutputDTO> {
            return localVarFp.openapiV1ProductsBulkCreatePost(bulkCreateProductCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkUpsertProductCommand} [bulkUpsertProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1ProductsBulkUpsertPost(bulkUpsertProductCommand?: BulkUpsertProductCommand, options?: any): AxiosPromise<BulkUpsertProductCommandOutputDTO> {
            return localVarFp.openapiV1ProductsBulkUpsertPost(bulkUpsertProductCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteProductCommand} [deleteProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1ProductsDelete(deleteProductCommand?: DeleteProductCommand, options?: any): AxiosPromise<void> {
            return localVarFp.openapiV1ProductsDelete(deleteProductCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddBarcodeCommand} [addBarcodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsAddBarcodePost(addBarcodeCommand?: AddBarcodeCommand, options?: any): AxiosPromise<AddProductBarcodeOutputDTO> {
            return localVarFp.supportV1ProductsAddBarcodePost(addBarcodeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CleanupDeletedOperationInventoryItemsCommand} [cleanupDeletedOperationInventoryItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsCleanupDeletedOperationInventoryItemsPost(cleanupDeletedOperationInventoryItemsCommand?: CleanupDeletedOperationInventoryItemsCommand, options?: any): AxiosPromise<CleanupDeletedOperationInventoryItemsOutputDTO> {
            return localVarFp.supportV1ProductsCleanupDeletedOperationInventoryItemsPost(cleanupDeletedOperationInventoryItemsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteProductBarcodeCommand} [deleteProductBarcodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsDeleteBarcodePost(deleteProductBarcodeCommand?: DeleteProductBarcodeCommand, options?: any): AxiosPromise<DeleteProductBarcodeOutputDTO> {
            return localVarFp.supportV1ProductsDeleteBarcodePost(deleteProductBarcodeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteSupportProductCommand} [deleteSupportProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsDeleteProductPost(deleteSupportProductCommand?: DeleteSupportProductCommand, options?: any): AxiosPromise<DeleteProductOutputDTO> {
            return localVarFp.supportV1ProductsDeleteProductPost(deleteSupportProductCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteProductsCommand} [deleteProductsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsDeleteProductsPost(deleteProductsCommand?: DeleteProductsCommand, options?: any): AxiosPromise<DeleteProductsOutputDTO> {
            return localVarFp.supportV1ProductsDeleteProductsPost(deleteProductsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DisableProductExpirationTrackingCommand} [disableProductExpirationTrackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsDisableProductExpirationTrackingPost(disableProductExpirationTrackingCommand?: DisableProductExpirationTrackingCommand, options?: any): AxiosPromise<DisableProductExpirationTrackingOutputDTO> {
            return localVarFp.supportV1ProductsDisableProductExpirationTrackingPost(disableProductExpirationTrackingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DisableProductLotNumberTrackingCommand} [disableProductLotNumberTrackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsDisableProductLotNumberTrackingPost(disableProductLotNumberTrackingCommand?: DisableProductLotNumberTrackingCommand, options?: any): AxiosPromise<DisableProductLotNumberTrackingOutputDTO> {
            return localVarFp.supportV1ProductsDisableProductLotNumberTrackingPost(disableProductLotNumberTrackingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnableProductExpirationDateCommand} [enableProductExpirationDateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsEnableProductExpirationDatePost(enableProductExpirationDateCommand?: EnableProductExpirationDateCommand, options?: any): AxiosPromise<EnableProductExpirationDateOutputDTO> {
            return localVarFp.supportV1ProductsEnableProductExpirationDatePost(enableProductExpirationDateCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnableProductLotNumberTrackingCommand} [enableProductLotNumberTrackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsEnableProductLotNumberTrackingPost(enableProductLotNumberTrackingCommand?: EnableProductLotNumberTrackingCommand, options?: any): AxiosPromise<EnableProductLotNumberTrackingOutputDTO> {
            return localVarFp.supportV1ProductsEnableProductLotNumberTrackingPost(enableProductLotNumberTrackingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SyncStockItemAmountsCommand} [syncStockItemAmountsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsSyncStockItemAmountsPost(syncStockItemAmountsCommand?: SyncStockItemAmountsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1ProductsSyncStockItemAmountsPost(syncStockItemAmountsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateProductBarcodeCommand} [updateProductBarcodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsUpdateBarcodePost(updateProductBarcodeCommand?: UpdateProductBarcodeCommand, options?: any): AxiosPromise<UpdateProductBarcodeOutputDTO> {
            return localVarFp.supportV1ProductsUpdateBarcodePost(updateProductBarcodeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateProductSkuCommand} [updateProductSkuCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsUpdateProductSkuPost(updateProductSkuCommand?: UpdateProductSkuCommand, options?: any): AxiosPromise<UpdateProductSkuOutputDTO> {
            return localVarFp.supportV1ProductsUpdateProductSkuPost(updateProductSkuCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertMasterCartonProductCommand} [upsertMasterCartonProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsUpsertMasterCartonProductPost(upsertMasterCartonProductCommand?: UpsertMasterCartonProductCommand, options?: any): AxiosPromise<UpsertMasterCartonProductOutputDTO> {
            return localVarFp.supportV1ProductsUpsertMasterCartonProductPost(upsertMasterCartonProductCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertProductDimensionsBulkCommand} [upsertProductDimensionsBulkCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ProductsUpsertProductDimensionsBulkPost(upsertProductDimensionsBulkCommand?: UpsertProductDimensionsBulkCommand, options?: any): AxiosPromise<UpsertProductDimensionsBulkOutputDTO> {
            return localVarFp.supportV1ProductsUpsertProductDimensionsBulkPost(upsertProductDimensionsBulkCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @param {string} [productId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiV1ProductsGetInventoryStatusByProductGet(productId?: string, options?: any) {
        return ProductsApiFp(this.configuration).apiV1ProductsGetInventoryStatusByProductGet(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [productId] 
     * @param {string} [productBarcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiV1ProductsGetProductDetailsGet(productId?: string, productBarcode?: string, options?: any) {
        return ProductsApiFp(this.configuration).apiV1ProductsGetProductDetailsGet(productId, productBarcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiV1ProductsQueryGet(dqb?: string, options?: any) {
        return ProductsApiFp(this.configuration).apiV1ProductsQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiV1ProductsQueryInventoryItemsByProductGet(productId: string, dqb?: string, options?: any) {
        return ProductsApiFp(this.configuration).apiV1ProductsQueryInventoryItemsByProductGet(productId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiV1ProductsQueryProductListingsGet(productId: string, dqb?: string, options?: any) {
        return ProductsApiFp(this.configuration).apiV1ProductsQueryProductListingsGet(productId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiV1ProductsQueryProductReturnPackageDetailsGet(productId: string, dqb?: string, options?: any) {
        return ProductsApiFp(this.configuration).apiV1ProductsQueryProductReturnPackageDetailsGet(productId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiV1ProductsQueryProductStockCountingListsGet(productId: string, dqb?: string, options?: any) {
        return ProductsApiFp(this.configuration).apiV1ProductsQueryProductStockCountingListsGet(productId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiV1ProductsQueryShippingItemsByProductGet(productId: string, dqb?: string, options?: any) {
        return ProductsApiFp(this.configuration).apiV1ProductsQueryShippingItemsByProductGet(productId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public kittingappV1ProductsQueryGet(dqb?: string, options?: any) {
        return ProductsApiFp(this.configuration).kittingappV1ProductsQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public odataProducts(dqb?: string, options?: any) {
        return ProductsApiFp(this.configuration).odataProducts(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public odataProductsCount(dqb?: string, options?: any) {
        return ProductsApiFp(this.configuration).odataProductsCount(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkCreateProductCommand} [bulkCreateProductCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public openapiV1ProductsBulkCreatePost(bulkCreateProductCommand?: BulkCreateProductCommand, options?: any) {
        return ProductsApiFp(this.configuration).openapiV1ProductsBulkCreatePost(bulkCreateProductCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkUpsertProductCommand} [bulkUpsertProductCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public openapiV1ProductsBulkUpsertPost(bulkUpsertProductCommand?: BulkUpsertProductCommand, options?: any) {
        return ProductsApiFp(this.configuration).openapiV1ProductsBulkUpsertPost(bulkUpsertProductCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteProductCommand} [deleteProductCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public openapiV1ProductsDelete(deleteProductCommand?: DeleteProductCommand, options?: any) {
        return ProductsApiFp(this.configuration).openapiV1ProductsDelete(deleteProductCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddBarcodeCommand} [addBarcodeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public supportV1ProductsAddBarcodePost(addBarcodeCommand?: AddBarcodeCommand, options?: any) {
        return ProductsApiFp(this.configuration).supportV1ProductsAddBarcodePost(addBarcodeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CleanupDeletedOperationInventoryItemsCommand} [cleanupDeletedOperationInventoryItemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public supportV1ProductsCleanupDeletedOperationInventoryItemsPost(cleanupDeletedOperationInventoryItemsCommand?: CleanupDeletedOperationInventoryItemsCommand, options?: any) {
        return ProductsApiFp(this.configuration).supportV1ProductsCleanupDeletedOperationInventoryItemsPost(cleanupDeletedOperationInventoryItemsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteProductBarcodeCommand} [deleteProductBarcodeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public supportV1ProductsDeleteBarcodePost(deleteProductBarcodeCommand?: DeleteProductBarcodeCommand, options?: any) {
        return ProductsApiFp(this.configuration).supportV1ProductsDeleteBarcodePost(deleteProductBarcodeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteSupportProductCommand} [deleteSupportProductCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public supportV1ProductsDeleteProductPost(deleteSupportProductCommand?: DeleteSupportProductCommand, options?: any) {
        return ProductsApiFp(this.configuration).supportV1ProductsDeleteProductPost(deleteSupportProductCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteProductsCommand} [deleteProductsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public supportV1ProductsDeleteProductsPost(deleteProductsCommand?: DeleteProductsCommand, options?: any) {
        return ProductsApiFp(this.configuration).supportV1ProductsDeleteProductsPost(deleteProductsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DisableProductExpirationTrackingCommand} [disableProductExpirationTrackingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public supportV1ProductsDisableProductExpirationTrackingPost(disableProductExpirationTrackingCommand?: DisableProductExpirationTrackingCommand, options?: any) {
        return ProductsApiFp(this.configuration).supportV1ProductsDisableProductExpirationTrackingPost(disableProductExpirationTrackingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DisableProductLotNumberTrackingCommand} [disableProductLotNumberTrackingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public supportV1ProductsDisableProductLotNumberTrackingPost(disableProductLotNumberTrackingCommand?: DisableProductLotNumberTrackingCommand, options?: any) {
        return ProductsApiFp(this.configuration).supportV1ProductsDisableProductLotNumberTrackingPost(disableProductLotNumberTrackingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnableProductExpirationDateCommand} [enableProductExpirationDateCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public supportV1ProductsEnableProductExpirationDatePost(enableProductExpirationDateCommand?: EnableProductExpirationDateCommand, options?: any) {
        return ProductsApiFp(this.configuration).supportV1ProductsEnableProductExpirationDatePost(enableProductExpirationDateCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnableProductLotNumberTrackingCommand} [enableProductLotNumberTrackingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public supportV1ProductsEnableProductLotNumberTrackingPost(enableProductLotNumberTrackingCommand?: EnableProductLotNumberTrackingCommand, options?: any) {
        return ProductsApiFp(this.configuration).supportV1ProductsEnableProductLotNumberTrackingPost(enableProductLotNumberTrackingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SyncStockItemAmountsCommand} [syncStockItemAmountsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public supportV1ProductsSyncStockItemAmountsPost(syncStockItemAmountsCommand?: SyncStockItemAmountsCommand, options?: any) {
        return ProductsApiFp(this.configuration).supportV1ProductsSyncStockItemAmountsPost(syncStockItemAmountsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateProductBarcodeCommand} [updateProductBarcodeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public supportV1ProductsUpdateBarcodePost(updateProductBarcodeCommand?: UpdateProductBarcodeCommand, options?: any) {
        return ProductsApiFp(this.configuration).supportV1ProductsUpdateBarcodePost(updateProductBarcodeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateProductSkuCommand} [updateProductSkuCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public supportV1ProductsUpdateProductSkuPost(updateProductSkuCommand?: UpdateProductSkuCommand, options?: any) {
        return ProductsApiFp(this.configuration).supportV1ProductsUpdateProductSkuPost(updateProductSkuCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertMasterCartonProductCommand} [upsertMasterCartonProductCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public supportV1ProductsUpsertMasterCartonProductPost(upsertMasterCartonProductCommand?: UpsertMasterCartonProductCommand, options?: any) {
        return ProductsApiFp(this.configuration).supportV1ProductsUpsertMasterCartonProductPost(upsertMasterCartonProductCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertProductDimensionsBulkCommand} [upsertProductDimensionsBulkCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public supportV1ProductsUpsertProductDimensionsBulkPost(upsertProductDimensionsBulkCommand?: UpsertProductDimensionsBulkCommand, options?: any) {
        return ProductsApiFp(this.configuration).supportV1ProductsUpsertProductDimensionsBulkPost(upsertProductDimensionsBulkCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductsODataApi - axios parameter creator
 * @export
 */
export const ProductsODataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataV1ProductsODataGet: async (authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('odataV1ProductsODataGet', 'authorization', authorization)
            const localVarPath = `/odata/v1/ProductsOData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsODataApi - functional programming interface
 * @export
 */
export const ProductsODataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsODataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async odataV1ProductsODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ODataResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.odataV1ProductsODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsODataApi - factory interface
 * @export
 */
export const ProductsODataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsODataApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataV1ProductsODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any): AxiosPromise<ODataResponseModel> {
            return localVarFp.odataV1ProductsODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsODataApi - object-oriented interface
 * @export
 * @class ProductsODataApi
 * @extends {BaseAPI}
 */
export class ProductsODataApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization The authorization token
     * @param {string} [$select] Get selected properties
     * @param {string} [$filter] Filter the results using OData syntax.
     * @param {string} [$expand] Get the entities that depend on the model
     * @param {string} [$orderby] Order the results using OData syntax
     * @param {string} [$skip] Skip the specified number of entries
     * @param {string} [$top] Get the top x number of records
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsODataApi
     */
    public odataV1ProductsODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any) {
        return ProductsODataApiFp(this.configuration).odataV1ProductsODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PurchaseOrdersApi - axios parameter creator
 * @export
 */
export const PurchaseOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CompletePurchaseOrderCommand} [completePurchaseOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersCompletePurchaseOrderPost: async (completePurchaseOrderCommand?: CompletePurchaseOrderCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PurchaseOrders.completePurchaseOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completePurchaseOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePurchaseOrderCommand} [createPurchaseOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersCreatePost: async (createPurchaseOrderCommand?: CreatePurchaseOrderCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PurchaseOrders.create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPurchaseOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePurchaseOrderLineItemCommand} [createPurchaseOrderLineItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersCreatePurchaseOrderLineItemPost: async (createPurchaseOrderLineItemCommand?: CreatePurchaseOrderLineItemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PurchaseOrders.createPurchaseOrderLineItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPurchaseOrderLineItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [purchaseOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersGetLineItemCountsByPurchaseOrderGet: async (purchaseOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PurchaseOrders.getLineItemCountsByPurchaseOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (purchaseOrderId !== undefined) {
                localVarQueryParameter['purchaseOrderId'] = purchaseOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [purchaseOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersGetPurchaseOrderDetailsGet: async (purchaseOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PurchaseOrders.getPurchaseOrderDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (purchaseOrderId !== undefined) {
                localVarQueryParameter['purchaseOrderId'] = purchaseOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [operationId] 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersListByOperationAndReferenceNumberGet: async (operationId?: string, referenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PurchaseOrders.listByOperationAndReferenceNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (operationId !== undefined) {
                localVarQueryParameter['operationId'] = operationId;
            }

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} operationId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersQueryByOperationGet: async (operationId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('apiV1PurchaseOrdersQueryByOperationGet', 'operationId', operationId)
            const localVarPath = `/api/v1/PurchaseOrders.queryByOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (operationId !== undefined) {
                localVarQueryParameter['operationId'] = operationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PurchaseOrders.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} purchaseOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersQueryLineItemLotNumbersGet: async (purchaseOrderId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseOrderId' is not null or undefined
            assertParamExists('apiV1PurchaseOrdersQueryLineItemLotNumbersGet', 'purchaseOrderId', purchaseOrderId)
            const localVarPath = `/api/v1/PurchaseOrders.queryLineItemLotNumbers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (purchaseOrderId !== undefined) {
                localVarQueryParameter['purchaseOrderId'] = purchaseOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} purchaseOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersQueryLineItemsByPurchaseOrderGet: async (purchaseOrderId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseOrderId' is not null or undefined
            assertParamExists('apiV1PurchaseOrdersQueryLineItemsByPurchaseOrderGet', 'purchaseOrderId', purchaseOrderId)
            const localVarPath = `/api/v1/PurchaseOrders.queryLineItemsByPurchaseOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (purchaseOrderId !== undefined) {
                localVarQueryParameter['purchaseOrderId'] = purchaseOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersQueryPurchaseOrderByProductGet: async (productId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiV1PurchaseOrdersQueryPurchaseOrderByProductGet', 'productId', productId)
            const localVarPath = `/api/v1/PurchaseOrders.queryPurchaseOrderByProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersQueryPurchaseOrderManagementCountsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PurchaseOrders.queryPurchaseOrderManagementCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdatePurchaseOrderExpectedAmountCommand} [updatePurchaseOrderExpectedAmountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersUpdatePurchaseOrderExpectedAmountPost: async (updatePurchaseOrderExpectedAmountCommand?: UpdatePurchaseOrderExpectedAmountCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PurchaseOrders.updatePurchaseOrderExpectedAmount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePurchaseOrderExpectedAmountCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkSyncPurchaseOrderFromIntegrationCommand} [bulkSyncPurchaseOrderFromIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kittingappV1PurchaseOrdersBulkCreatePost: async (bulkSyncPurchaseOrderFromIntegrationCommand?: BulkSyncPurchaseOrderFromIntegrationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/kittingapp/v1/PurchaseOrders/bulkCreate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSyncPurchaseOrderFromIntegrationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kittingappV1PurchaseOrdersPurchaseOrdersQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/kittingapp/v1/PurchaseOrders/PurchaseOrders.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkSyncPurchaseOrderFromIntegrationCommand} [bulkSyncPurchaseOrderFromIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1PurchaseOrdersBulkCreatePost: async (bulkSyncPurchaseOrderFromIntegrationCommand?: BulkSyncPurchaseOrderFromIntegrationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/PurchaseOrders/bulkCreate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSyncPurchaseOrderFromIntegrationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1PurchaseOrdersPurchaseOrdersQueryByReferenceNumberGet: async (operationName?: string, referenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/PurchaseOrders/PurchaseOrders.queryByReferenceNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (operationName !== undefined) {
                localVarQueryParameter['operationName'] = operationName;
            }

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1PurchaseOrdersPurchaseOrdersQueryProductsOpenReceivingGet: async (operationName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/PurchaseOrders/PurchaseOrders.queryProductsOpenReceiving`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (operationName !== undefined) {
                localVarQueryParameter['operationName'] = operationName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddAcceptedLineItemRecordsAndDeleteCommand} [addAcceptedLineItemRecordsAndDeleteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PurchaseOrdersAddAcceptedLineItemRecordsAndDeletePost: async (addAcceptedLineItemRecordsAndDeleteCommand?: AddAcceptedLineItemRecordsAndDeleteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/PurchaseOrders/addAcceptedLineItemRecordsAndDelete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAcceptedLineItemRecordsAndDeleteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkSyncOperationPurchaseOrdersCommand} [bulkSyncOperationPurchaseOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PurchaseOrdersBulkSyncOperationPurchaseOrdersPost: async (bulkSyncOperationPurchaseOrdersCommand?: BulkSyncOperationPurchaseOrdersCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/PurchaseOrders/bulkSyncOperationPurchaseOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSyncOperationPurchaseOrdersCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CancelReservationCommand} [cancelReservationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PurchaseOrdersCancelReservationPost: async (cancelReservationCommand?: CancelReservationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/PurchaseOrders/cancelReservation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelReservationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteExcessReceivingProductsCommand} [deleteExcessReceivingProductsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PurchaseOrdersDeleteExcessReceivingProductsPost: async (deleteExcessReceivingProductsCommand?: DeleteExcessReceivingProductsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/PurchaseOrders/deleteExcessReceivingProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteExcessReceivingProductsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeletePurchaseOrderCommand} [deletePurchaseOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PurchaseOrdersDeletePurchaseOrderPost: async (deletePurchaseOrderCommand?: DeletePurchaseOrderCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/PurchaseOrders/deletePurchaseOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deletePurchaseOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {string} [purchaseOrderReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PurchaseOrdersQueryPurchaseOrderLineItemRecordsForPurchaseOrderGet: async (operationName?: string, purchaseOrderReferenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/PurchaseOrders/queryPurchaseOrderLineItemRecordsForPurchaseOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (operationName !== undefined) {
                localVarQueryParameter['operationName'] = operationName;
            }

            if (purchaseOrderReferenceNumber !== undefined) {
                localVarQueryParameter['purchaseOrderReferenceNumber'] = purchaseOrderReferenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReactivatePurchaseOrderCommand} [reactivatePurchaseOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PurchaseOrdersReactivatePurchaseOrderPost: async (reactivatePurchaseOrderCommand?: ReactivatePurchaseOrderCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/PurchaseOrders/reactivatePurchaseOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reactivatePurchaseOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<SyncPurchaseOrderCommand>} [syncPurchaseOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PurchaseOrdersSyncPurchaseOrdersPost: async (syncPurchaseOrderCommand?: Array<SyncPurchaseOrderCommand>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/PurchaseOrders/syncPurchaseOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncPurchaseOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PurchaseOrdersApi - functional programming interface
 * @export
 */
export const PurchaseOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PurchaseOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CompletePurchaseOrderCommand} [completePurchaseOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseOrdersCompletePurchaseOrderPost(completePurchaseOrderCommand?: CompletePurchaseOrderCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseOrdersCompletePurchaseOrderPost(completePurchaseOrderCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePurchaseOrderCommand} [createPurchaseOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseOrdersCreatePost(createPurchaseOrderCommand?: CreatePurchaseOrderCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrderOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseOrdersCreatePost(createPurchaseOrderCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePurchaseOrderLineItemCommand} [createPurchaseOrderLineItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseOrdersCreatePurchaseOrderLineItemPost(createPurchaseOrderLineItemCommand?: CreatePurchaseOrderLineItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrderOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseOrdersCreatePurchaseOrderLineItemPost(createPurchaseOrderLineItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [purchaseOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseOrdersGetLineItemCountsByPurchaseOrderGet(purchaseOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrderLineItemCountsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseOrdersGetLineItemCountsByPurchaseOrderGet(purchaseOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [purchaseOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseOrdersGetPurchaseOrderDetailsGet(purchaseOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrderDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseOrdersGetPurchaseOrderDetailsGet(purchaseOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [operationId] 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseOrdersListByOperationAndReferenceNumberGet(operationId?: string, referenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PurchaseOrderOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseOrdersListByOperationAndReferenceNumberGet(operationId, referenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} operationId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseOrdersQueryByOperationGet(operationId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrderQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseOrdersQueryByOperationGet(operationId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseOrdersQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrderQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseOrdersQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} purchaseOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseOrdersQueryLineItemLotNumbersGet(purchaseOrderId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrderLotNumberSummaryDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseOrdersQueryLineItemLotNumbersGet(purchaseOrderId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} purchaseOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseOrdersQueryLineItemsByPurchaseOrderGet(purchaseOrderId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrderLineItemQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseOrdersQueryLineItemsByPurchaseOrderGet(purchaseOrderId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseOrdersQueryPurchaseOrderByProductGet(productId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrderQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseOrdersQueryPurchaseOrderByProductGet(productId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseOrdersQueryPurchaseOrderManagementCountsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrderManagementCountsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseOrdersQueryPurchaseOrderManagementCountsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdatePurchaseOrderExpectedAmountCommand} [updatePurchaseOrderExpectedAmountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseOrdersUpdatePurchaseOrderExpectedAmountPost(updatePurchaseOrderExpectedAmountCommand?: UpdatePurchaseOrderExpectedAmountCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseOrdersUpdatePurchaseOrderExpectedAmountPost(updatePurchaseOrderExpectedAmountCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkSyncPurchaseOrderFromIntegrationCommand} [bulkSyncPurchaseOrderFromIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kittingappV1PurchaseOrdersBulkCreatePost(bulkSyncPurchaseOrderFromIntegrationCommand?: BulkSyncPurchaseOrderFromIntegrationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncPurchaseOrderFromIntegrationCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kittingappV1PurchaseOrdersBulkCreatePost(bulkSyncPurchaseOrderFromIntegrationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kittingappV1PurchaseOrdersPurchaseOrdersQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrderQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kittingappV1PurchaseOrdersPurchaseOrdersQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkSyncPurchaseOrderFromIntegrationCommand} [bulkSyncPurchaseOrderFromIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1PurchaseOrdersBulkCreatePost(bulkSyncPurchaseOrderFromIntegrationCommand?: BulkSyncPurchaseOrderFromIntegrationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncPurchaseOrderFromIntegrationCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1PurchaseOrdersBulkCreatePost(bulkSyncPurchaseOrderFromIntegrationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1PurchaseOrdersPurchaseOrdersQueryByReferenceNumberGet(operationName?: string, referenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrderSummaryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1PurchaseOrdersPurchaseOrdersQueryByReferenceNumberGet(operationName, referenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1PurchaseOrdersPurchaseOrdersQueryProductsOpenReceivingGet(operationName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductOpenReceivingDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1PurchaseOrdersPurchaseOrdersQueryProductsOpenReceivingGet(operationName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddAcceptedLineItemRecordsAndDeleteCommand} [addAcceptedLineItemRecordsAndDeleteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1PurchaseOrdersAddAcceptedLineItemRecordsAndDeletePost(addAcceptedLineItemRecordsAndDeleteCommand?: AddAcceptedLineItemRecordsAndDeleteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1PurchaseOrdersAddAcceptedLineItemRecordsAndDeletePost(addAcceptedLineItemRecordsAndDeleteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkSyncOperationPurchaseOrdersCommand} [bulkSyncOperationPurchaseOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1PurchaseOrdersBulkSyncOperationPurchaseOrdersPost(bulkSyncOperationPurchaseOrdersCommand?: BulkSyncOperationPurchaseOrdersCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkSyncResultsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1PurchaseOrdersBulkSyncOperationPurchaseOrdersPost(bulkSyncOperationPurchaseOrdersCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CancelReservationCommand} [cancelReservationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1PurchaseOrdersCancelReservationPost(cancelReservationCommand?: CancelReservationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1PurchaseOrdersCancelReservationPost(cancelReservationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteExcessReceivingProductsCommand} [deleteExcessReceivingProductsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1PurchaseOrdersDeleteExcessReceivingProductsPost(deleteExcessReceivingProductsCommand?: DeleteExcessReceivingProductsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1PurchaseOrdersDeleteExcessReceivingProductsPost(deleteExcessReceivingProductsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeletePurchaseOrderCommand} [deletePurchaseOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1PurchaseOrdersDeletePurchaseOrderPost(deletePurchaseOrderCommand?: DeletePurchaseOrderCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1PurchaseOrdersDeletePurchaseOrderPost(deletePurchaseOrderCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {string} [purchaseOrderReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1PurchaseOrdersQueryPurchaseOrderLineItemRecordsForPurchaseOrderGet(operationName?: string, purchaseOrderReferenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOrderLineItemRecordsForDeleteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1PurchaseOrdersQueryPurchaseOrderLineItemRecordsForPurchaseOrderGet(operationName, purchaseOrderReferenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReactivatePurchaseOrderCommand} [reactivatePurchaseOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1PurchaseOrdersReactivatePurchaseOrderPost(reactivatePurchaseOrderCommand?: ReactivatePurchaseOrderCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReactivatePurchaseOrderOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1PurchaseOrdersReactivatePurchaseOrderPost(reactivatePurchaseOrderCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<SyncPurchaseOrderCommand>} [syncPurchaseOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1PurchaseOrdersSyncPurchaseOrdersPost(syncPurchaseOrderCommand?: Array<SyncPurchaseOrderCommand>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1PurchaseOrdersSyncPurchaseOrdersPost(syncPurchaseOrderCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PurchaseOrdersApi - factory interface
 * @export
 */
export const PurchaseOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PurchaseOrdersApiFp(configuration)
    return {
        /**
         * 
         * @param {CompletePurchaseOrderCommand} [completePurchaseOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersCompletePurchaseOrderPost(completePurchaseOrderCommand?: CompletePurchaseOrderCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PurchaseOrdersCompletePurchaseOrderPost(completePurchaseOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePurchaseOrderCommand} [createPurchaseOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersCreatePost(createPurchaseOrderCommand?: CreatePurchaseOrderCommand, options?: any): AxiosPromise<PurchaseOrderOutputDTO> {
            return localVarFp.apiV1PurchaseOrdersCreatePost(createPurchaseOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePurchaseOrderLineItemCommand} [createPurchaseOrderLineItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersCreatePurchaseOrderLineItemPost(createPurchaseOrderLineItemCommand?: CreatePurchaseOrderLineItemCommand, options?: any): AxiosPromise<PurchaseOrderOutputDTO> {
            return localVarFp.apiV1PurchaseOrdersCreatePurchaseOrderLineItemPost(createPurchaseOrderLineItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [purchaseOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersGetLineItemCountsByPurchaseOrderGet(purchaseOrderId?: string, options?: any): AxiosPromise<PurchaseOrderLineItemCountsOutputDTO> {
            return localVarFp.apiV1PurchaseOrdersGetLineItemCountsByPurchaseOrderGet(purchaseOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [purchaseOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersGetPurchaseOrderDetailsGet(purchaseOrderId?: string, options?: any): AxiosPromise<PurchaseOrderDetailsOutputDTO> {
            return localVarFp.apiV1PurchaseOrdersGetPurchaseOrderDetailsGet(purchaseOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [operationId] 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersListByOperationAndReferenceNumberGet(operationId?: string, referenceNumber?: string, options?: any): AxiosPromise<Array<PurchaseOrderOutputDTO>> {
            return localVarFp.apiV1PurchaseOrdersListByOperationAndReferenceNumberGet(operationId, referenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} operationId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersQueryByOperationGet(operationId: string, dqb?: string, options?: any): AxiosPromise<PurchaseOrderQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PurchaseOrdersQueryByOperationGet(operationId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersQueryGet(dqb?: string, options?: any): AxiosPromise<PurchaseOrderQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PurchaseOrdersQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} purchaseOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersQueryLineItemLotNumbersGet(purchaseOrderId: string, dqb?: string, options?: any): AxiosPromise<PurchaseOrderLotNumberSummaryDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PurchaseOrdersQueryLineItemLotNumbersGet(purchaseOrderId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} purchaseOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersQueryLineItemsByPurchaseOrderGet(purchaseOrderId: string, dqb?: string, options?: any): AxiosPromise<PurchaseOrderLineItemQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PurchaseOrdersQueryLineItemsByPurchaseOrderGet(purchaseOrderId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersQueryPurchaseOrderByProductGet(productId: string, dqb?: string, options?: any): AxiosPromise<PurchaseOrderQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PurchaseOrdersQueryPurchaseOrderByProductGet(productId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersQueryPurchaseOrderManagementCountsGet(options?: any): AxiosPromise<PurchaseOrderManagementCountsOutputDTO> {
            return localVarFp.apiV1PurchaseOrdersQueryPurchaseOrderManagementCountsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdatePurchaseOrderExpectedAmountCommand} [updatePurchaseOrderExpectedAmountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseOrdersUpdatePurchaseOrderExpectedAmountPost(updatePurchaseOrderExpectedAmountCommand?: UpdatePurchaseOrderExpectedAmountCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PurchaseOrdersUpdatePurchaseOrderExpectedAmountPost(updatePurchaseOrderExpectedAmountCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkSyncPurchaseOrderFromIntegrationCommand} [bulkSyncPurchaseOrderFromIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kittingappV1PurchaseOrdersBulkCreatePost(bulkSyncPurchaseOrderFromIntegrationCommand?: BulkSyncPurchaseOrderFromIntegrationCommand, options?: any): AxiosPromise<SyncPurchaseOrderFromIntegrationCommandOutputDTO> {
            return localVarFp.kittingappV1PurchaseOrdersBulkCreatePost(bulkSyncPurchaseOrderFromIntegrationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kittingappV1PurchaseOrdersPurchaseOrdersQueryGet(dqb?: string, options?: any): AxiosPromise<PurchaseOrderQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.kittingappV1PurchaseOrdersPurchaseOrdersQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkSyncPurchaseOrderFromIntegrationCommand} [bulkSyncPurchaseOrderFromIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1PurchaseOrdersBulkCreatePost(bulkSyncPurchaseOrderFromIntegrationCommand?: BulkSyncPurchaseOrderFromIntegrationCommand, options?: any): AxiosPromise<SyncPurchaseOrderFromIntegrationCommandOutputDTO> {
            return localVarFp.openapiV1PurchaseOrdersBulkCreatePost(bulkSyncPurchaseOrderFromIntegrationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1PurchaseOrdersPurchaseOrdersQueryByReferenceNumberGet(operationName?: string, referenceNumber?: string, options?: any): AxiosPromise<PurchaseOrderSummaryOutputDTO> {
            return localVarFp.openapiV1PurchaseOrdersPurchaseOrdersQueryByReferenceNumberGet(operationName, referenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1PurchaseOrdersPurchaseOrdersQueryProductsOpenReceivingGet(operationName?: string, options?: any): AxiosPromise<Array<ProductOpenReceivingDTO>> {
            return localVarFp.openapiV1PurchaseOrdersPurchaseOrdersQueryProductsOpenReceivingGet(operationName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddAcceptedLineItemRecordsAndDeleteCommand} [addAcceptedLineItemRecordsAndDeleteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PurchaseOrdersAddAcceptedLineItemRecordsAndDeletePost(addAcceptedLineItemRecordsAndDeleteCommand?: AddAcceptedLineItemRecordsAndDeleteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1PurchaseOrdersAddAcceptedLineItemRecordsAndDeletePost(addAcceptedLineItemRecordsAndDeleteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkSyncOperationPurchaseOrdersCommand} [bulkSyncOperationPurchaseOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PurchaseOrdersBulkSyncOperationPurchaseOrdersPost(bulkSyncOperationPurchaseOrdersCommand?: BulkSyncOperationPurchaseOrdersCommand, options?: any): AxiosPromise<BulkSyncResultsOutputDTO> {
            return localVarFp.supportV1PurchaseOrdersBulkSyncOperationPurchaseOrdersPost(bulkSyncOperationPurchaseOrdersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CancelReservationCommand} [cancelReservationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PurchaseOrdersCancelReservationPost(cancelReservationCommand?: CancelReservationCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1PurchaseOrdersCancelReservationPost(cancelReservationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteExcessReceivingProductsCommand} [deleteExcessReceivingProductsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PurchaseOrdersDeleteExcessReceivingProductsPost(deleteExcessReceivingProductsCommand?: DeleteExcessReceivingProductsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1PurchaseOrdersDeleteExcessReceivingProductsPost(deleteExcessReceivingProductsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeletePurchaseOrderCommand} [deletePurchaseOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PurchaseOrdersDeletePurchaseOrderPost(deletePurchaseOrderCommand?: DeletePurchaseOrderCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1PurchaseOrdersDeletePurchaseOrderPost(deletePurchaseOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {string} [purchaseOrderReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PurchaseOrdersQueryPurchaseOrderLineItemRecordsForPurchaseOrderGet(operationName?: string, purchaseOrderReferenceNumber?: string, options?: any): AxiosPromise<PurchaseOrderLineItemRecordsForDeleteOutputDTO> {
            return localVarFp.supportV1PurchaseOrdersQueryPurchaseOrderLineItemRecordsForPurchaseOrderGet(operationName, purchaseOrderReferenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReactivatePurchaseOrderCommand} [reactivatePurchaseOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PurchaseOrdersReactivatePurchaseOrderPost(reactivatePurchaseOrderCommand?: ReactivatePurchaseOrderCommand, options?: any): AxiosPromise<ReactivatePurchaseOrderOutputDTO> {
            return localVarFp.supportV1PurchaseOrdersReactivatePurchaseOrderPost(reactivatePurchaseOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<SyncPurchaseOrderCommand>} [syncPurchaseOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1PurchaseOrdersSyncPurchaseOrdersPost(syncPurchaseOrderCommand?: Array<SyncPurchaseOrderCommand>, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1PurchaseOrdersSyncPurchaseOrdersPost(syncPurchaseOrderCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PurchaseOrdersApi - object-oriented interface
 * @export
 * @class PurchaseOrdersApi
 * @extends {BaseAPI}
 */
export class PurchaseOrdersApi extends BaseAPI {
    /**
     * 
     * @param {CompletePurchaseOrderCommand} [completePurchaseOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public apiV1PurchaseOrdersCompletePurchaseOrderPost(completePurchaseOrderCommand?: CompletePurchaseOrderCommand, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).apiV1PurchaseOrdersCompletePurchaseOrderPost(completePurchaseOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePurchaseOrderCommand} [createPurchaseOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public apiV1PurchaseOrdersCreatePost(createPurchaseOrderCommand?: CreatePurchaseOrderCommand, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).apiV1PurchaseOrdersCreatePost(createPurchaseOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePurchaseOrderLineItemCommand} [createPurchaseOrderLineItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public apiV1PurchaseOrdersCreatePurchaseOrderLineItemPost(createPurchaseOrderLineItemCommand?: CreatePurchaseOrderLineItemCommand, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).apiV1PurchaseOrdersCreatePurchaseOrderLineItemPost(createPurchaseOrderLineItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [purchaseOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public apiV1PurchaseOrdersGetLineItemCountsByPurchaseOrderGet(purchaseOrderId?: string, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).apiV1PurchaseOrdersGetLineItemCountsByPurchaseOrderGet(purchaseOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [purchaseOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public apiV1PurchaseOrdersGetPurchaseOrderDetailsGet(purchaseOrderId?: string, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).apiV1PurchaseOrdersGetPurchaseOrderDetailsGet(purchaseOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [operationId] 
     * @param {string} [referenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public apiV1PurchaseOrdersListByOperationAndReferenceNumberGet(operationId?: string, referenceNumber?: string, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).apiV1PurchaseOrdersListByOperationAndReferenceNumberGet(operationId, referenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} operationId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public apiV1PurchaseOrdersQueryByOperationGet(operationId: string, dqb?: string, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).apiV1PurchaseOrdersQueryByOperationGet(operationId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public apiV1PurchaseOrdersQueryGet(dqb?: string, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).apiV1PurchaseOrdersQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} purchaseOrderId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public apiV1PurchaseOrdersQueryLineItemLotNumbersGet(purchaseOrderId: string, dqb?: string, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).apiV1PurchaseOrdersQueryLineItemLotNumbersGet(purchaseOrderId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} purchaseOrderId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public apiV1PurchaseOrdersQueryLineItemsByPurchaseOrderGet(purchaseOrderId: string, dqb?: string, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).apiV1PurchaseOrdersQueryLineItemsByPurchaseOrderGet(purchaseOrderId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public apiV1PurchaseOrdersQueryPurchaseOrderByProductGet(productId: string, dqb?: string, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).apiV1PurchaseOrdersQueryPurchaseOrderByProductGet(productId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public apiV1PurchaseOrdersQueryPurchaseOrderManagementCountsGet(options?: any) {
        return PurchaseOrdersApiFp(this.configuration).apiV1PurchaseOrdersQueryPurchaseOrderManagementCountsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdatePurchaseOrderExpectedAmountCommand} [updatePurchaseOrderExpectedAmountCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public apiV1PurchaseOrdersUpdatePurchaseOrderExpectedAmountPost(updatePurchaseOrderExpectedAmountCommand?: UpdatePurchaseOrderExpectedAmountCommand, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).apiV1PurchaseOrdersUpdatePurchaseOrderExpectedAmountPost(updatePurchaseOrderExpectedAmountCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkSyncPurchaseOrderFromIntegrationCommand} [bulkSyncPurchaseOrderFromIntegrationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public kittingappV1PurchaseOrdersBulkCreatePost(bulkSyncPurchaseOrderFromIntegrationCommand?: BulkSyncPurchaseOrderFromIntegrationCommand, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).kittingappV1PurchaseOrdersBulkCreatePost(bulkSyncPurchaseOrderFromIntegrationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public kittingappV1PurchaseOrdersPurchaseOrdersQueryGet(dqb?: string, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).kittingappV1PurchaseOrdersPurchaseOrdersQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkSyncPurchaseOrderFromIntegrationCommand} [bulkSyncPurchaseOrderFromIntegrationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public openapiV1PurchaseOrdersBulkCreatePost(bulkSyncPurchaseOrderFromIntegrationCommand?: BulkSyncPurchaseOrderFromIntegrationCommand, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).openapiV1PurchaseOrdersBulkCreatePost(bulkSyncPurchaseOrderFromIntegrationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [operationName] 
     * @param {string} [referenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public openapiV1PurchaseOrdersPurchaseOrdersQueryByReferenceNumberGet(operationName?: string, referenceNumber?: string, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).openapiV1PurchaseOrdersPurchaseOrdersQueryByReferenceNumberGet(operationName, referenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [operationName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public openapiV1PurchaseOrdersPurchaseOrdersQueryProductsOpenReceivingGet(operationName?: string, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).openapiV1PurchaseOrdersPurchaseOrdersQueryProductsOpenReceivingGet(operationName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddAcceptedLineItemRecordsAndDeleteCommand} [addAcceptedLineItemRecordsAndDeleteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public supportV1PurchaseOrdersAddAcceptedLineItemRecordsAndDeletePost(addAcceptedLineItemRecordsAndDeleteCommand?: AddAcceptedLineItemRecordsAndDeleteCommand, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).supportV1PurchaseOrdersAddAcceptedLineItemRecordsAndDeletePost(addAcceptedLineItemRecordsAndDeleteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkSyncOperationPurchaseOrdersCommand} [bulkSyncOperationPurchaseOrdersCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public supportV1PurchaseOrdersBulkSyncOperationPurchaseOrdersPost(bulkSyncOperationPurchaseOrdersCommand?: BulkSyncOperationPurchaseOrdersCommand, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).supportV1PurchaseOrdersBulkSyncOperationPurchaseOrdersPost(bulkSyncOperationPurchaseOrdersCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CancelReservationCommand} [cancelReservationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public supportV1PurchaseOrdersCancelReservationPost(cancelReservationCommand?: CancelReservationCommand, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).supportV1PurchaseOrdersCancelReservationPost(cancelReservationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteExcessReceivingProductsCommand} [deleteExcessReceivingProductsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public supportV1PurchaseOrdersDeleteExcessReceivingProductsPost(deleteExcessReceivingProductsCommand?: DeleteExcessReceivingProductsCommand, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).supportV1PurchaseOrdersDeleteExcessReceivingProductsPost(deleteExcessReceivingProductsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeletePurchaseOrderCommand} [deletePurchaseOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public supportV1PurchaseOrdersDeletePurchaseOrderPost(deletePurchaseOrderCommand?: DeletePurchaseOrderCommand, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).supportV1PurchaseOrdersDeletePurchaseOrderPost(deletePurchaseOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [operationName] 
     * @param {string} [purchaseOrderReferenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public supportV1PurchaseOrdersQueryPurchaseOrderLineItemRecordsForPurchaseOrderGet(operationName?: string, purchaseOrderReferenceNumber?: string, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).supportV1PurchaseOrdersQueryPurchaseOrderLineItemRecordsForPurchaseOrderGet(operationName, purchaseOrderReferenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReactivatePurchaseOrderCommand} [reactivatePurchaseOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public supportV1PurchaseOrdersReactivatePurchaseOrderPost(reactivatePurchaseOrderCommand?: ReactivatePurchaseOrderCommand, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).supportV1PurchaseOrdersReactivatePurchaseOrderPost(reactivatePurchaseOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<SyncPurchaseOrderCommand>} [syncPurchaseOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public supportV1PurchaseOrdersSyncPurchaseOrdersPost(syncPurchaseOrderCommand?: Array<SyncPurchaseOrderCommand>, options?: any) {
        return PurchaseOrdersApiFp(this.configuration).supportV1PurchaseOrdersSyncPurchaseOrdersPost(syncPurchaseOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PurchaseOrdersODataApi - axios parameter creator
 * @export
 */
export const PurchaseOrdersODataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataV1PurchaseOrdersODataGet: async (authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('odataV1PurchaseOrdersODataGet', 'authorization', authorization)
            const localVarPath = `/odata/v1/PurchaseOrdersOData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PurchaseOrdersODataApi - functional programming interface
 * @export
 */
export const PurchaseOrdersODataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PurchaseOrdersODataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async odataV1PurchaseOrdersODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ODataResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.odataV1PurchaseOrdersODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PurchaseOrdersODataApi - factory interface
 * @export
 */
export const PurchaseOrdersODataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PurchaseOrdersODataApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataV1PurchaseOrdersODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any): AxiosPromise<ODataResponseModel> {
            return localVarFp.odataV1PurchaseOrdersODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PurchaseOrdersODataApi - object-oriented interface
 * @export
 * @class PurchaseOrdersODataApi
 * @extends {BaseAPI}
 */
export class PurchaseOrdersODataApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization The authorization token
     * @param {string} [$select] Get selected properties
     * @param {string} [$filter] Filter the results using OData syntax.
     * @param {string} [$expand] Get the entities that depend on the model
     * @param {string} [$orderby] Order the results using OData syntax
     * @param {string} [$skip] Skip the specified number of entries
     * @param {string} [$top] Get the top x number of records
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersODataApi
     */
    public odataV1PurchaseOrdersODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any) {
        return PurchaseOrdersODataApiFp(this.configuration).odataV1PurchaseOrdersODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PutAwayApi - axios parameter creator
 * @export
 */
export const PutAwayApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddOrUpdatePutAwayCellRuleCommand} [addOrUpdatePutAwayCellRuleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayAddOrUpdatePutAwayCellRulePost: async (addOrUpdatePutAwayCellRuleCommand?: AddOrUpdatePutAwayCellRuleCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.addOrUpdatePutAwayCellRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrUpdatePutAwayCellRuleCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckProductExistCellSuggestedCommand} [checkProductExistCellSuggestedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayCheckProductExistCellSuggestedPost: async (checkProductExistCellSuggestedCommand?: CheckProductExistCellSuggestedCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.checkProductExistCellSuggested`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkProductExistCellSuggestedCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckProductExistCommand} [checkProductExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayCheckProductExistPost: async (checkProductExistCommand?: CheckProductExistCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.checkProductExist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkProductExistCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckTotalProductCountExistCommand} [checkTotalProductCountExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayCheckTotalProductCountExistPost: async (checkTotalProductCountExistCommand?: CheckTotalProductCountExistCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.checkTotalProductCountExist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkTotalProductCountExistCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckToteOnTrolleyCommand} [checkToteOnTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayCheckToteOnTrolleyPost: async (checkToteOnTrolleyCommand?: CheckToteOnTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.checkToteOnTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkToteOnTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompletePutAwayCommand} [completePutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayCompletePutAwayPost: async (completePutAwayCommand?: CompletePutAwayCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.completePutAway`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completePutAwayCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePutAwayIfNotExistCommand} [createPutAwayIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayCreateIfNotExistPost: async (createPutAwayIfNotExistCommand?: CreatePutAwayIfNotExistCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.createIfNotExist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPutAwayIfNotExistCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeletePutAwayCellRuleCommand} [deletePutAwayCellRuleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayDeletePutAwayCellRulePost: async (deletePutAwayCellRuleCommand?: DeletePutAwayCellRuleCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.deletePutAwayCellRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deletePutAwayCellRuleCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DropToteToRasDropAddressCommand} [dropToteToRasDropAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayDropToteToRasDropAddressPost: async (dropToteToRasDropAddressCommand?: DropToteToRasDropAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.dropToteToRasDropAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dropToteToRasDropAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForceCompletePutAwayCommand} [forceCompletePutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayForceCompletePutAwayMissingPost: async (forceCompletePutAwayCommand?: ForceCompletePutAwayCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.forceCompletePutAwayMissing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forceCompletePutAwayCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForceCompletePutAwayReleaseCommand} [forceCompletePutAwayReleaseCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayForceCompletePutAwayReleasePost: async (forceCompletePutAwayReleaseCommand?: ForceCompletePutAwayReleaseCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.forceCompletePutAwayRelease`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forceCompletePutAwayReleaseCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayGetCellTypeGet: async (cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.getCellType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPutAwayCellAddressForToteCommand} [getPutAwayCellAddressForToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayGetNextPutAwayCellAddressForTotePost: async (getPutAwayCellAddressForToteCommand?: GetPutAwayCellAddressForToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.getNextPutAwayCellAddressForTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPutAwayCellAddressForToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {number} [zoneId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayGetProductAddressDetailsGet: async (productId?: string, zoneId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.getProductAddressDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }

            if (zoneId !== undefined) {
                localVarQueryParameter['zoneId'] = zoneId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [putAwayReferenceNumber] 
         * @param {string} [currentZone] 
         * @param {boolean} [skipCurrentZone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayGetPutAwayNextZonePost: async (putAwayReferenceNumber?: number, currentZone?: string, skipCurrentZone?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.getPutAwayNextZone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (putAwayReferenceNumber !== undefined) {
                localVarQueryParameter['PutAwayReferenceNumber'] = putAwayReferenceNumber;
            }

            if (currentZone !== undefined) {
                localVarQueryParameter['CurrentZone'] = currentZone;
            }

            if (skipCurrentZone !== undefined) {
                localVarQueryParameter['SkipCurrentZone'] = skipCurrentZone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LeavePutAwayCommand} [leavePutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayLeavePutAwayPost: async (leavePutAwayCommand?: LeavePutAwayCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.leavePutAway`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leavePutAwayCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OnHoldPutAwayCommand} [onHoldPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayOnHoldPutAwayPost: async (onHoldPutAwayCommand?: OnHoldPutAwayCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.onHoldPutAway`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onHoldPutAwayCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ParkTrolleyCommand} [parkTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayParkTrolleyPost: async (parkTrolleyCommand?: ParkTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.parkTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(parkTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceProductCellSuggestedCommand} [placeProductCellSuggestedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayPlaceProductCellSuggestedPost: async (placeProductCellSuggestedCommand?: PlaceProductCellSuggestedCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.placeProductCellSuggested`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeProductCellSuggestedCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceProductCommand} [placeProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayPlaceProductPost: async (placeProductCommand?: PlaceProductCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.placeProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceToteToInboundCommand} [placeToteToInboundCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayPlaceToteToInboundPost: async (placeToteToInboundCommand?: PlaceToteToInboundCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.placeToteToInbound`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeToteToInboundCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceToteToRASTrolleyCommand} [placeToteToRASTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayPlaceToteToRasTrolleyPost: async (placeToteToRASTrolleyCommand?: PlaceToteToRASTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.placeToteToRasTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeToteToRASTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceToteToTrolleyCommand} [placeToteToTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayPlaceToteToTrolleyPost: async (placeToteToTrolleyCommand?: PlaceToteToTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.placeToteToTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeToteToTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PutAwayProductMissingCommand} [putAwayProductMissingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayPutAwayProductLostItemPost: async (putAwayProductMissingCommand?: PutAwayProductMissingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.putAwayProductLostItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putAwayProductMissingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PutAwayToteLostItemsCommand} [putAwayToteLostItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayPutAwayToteLostItemPost: async (putAwayToteLostItemsCommand?: PutAwayToteLostItemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.putAwayToteLostItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putAwayToteLostItemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayQueryActivePutAwaysGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.queryActivePutAways`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayQueryAvailablePutAwayTrolleysGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.queryAvailablePutAwayTrolleys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayQueryPutAwayManagementCountsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.queryPutAwayManagementCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayQueryReservedProductManagementBlockerFeedsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.queryReservedProductManagementBlockerFeeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayQueryReservedProductManagementCountsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.queryReservedProductManagementCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayQueryReservedProductManagementProposedFeedsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.queryReservedProductManagementProposedFeeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayQueryReservedProductManagementReservedProductsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.queryReservedProductManagementReservedProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayQueryWaitingTotesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.queryWaitingTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PutAwayTrolleyReturnCommand} [putAwayTrolleyReturnCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayReturnPutAwayTrolleyPost: async (putAwayTrolleyReturnCommand?: PutAwayTrolleyReturnCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.returnPutAwayTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putAwayTrolleyReturnCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetCellFullCommand} [setCellFullCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwaySetCellFullPost: async (setCellFullCommand?: SetCellFullCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.setCellFull`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setCellFullCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartPutAwayCommand} [startPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayStartPutAwayPost: async (startPutAwayCommand?: StartPutAwayCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.startPutAway`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startPutAwayCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnmountToteFromRASTrolleyCommand} [unmountToteFromRASTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayUnmountToteFromRasTrolleyPost: async (unmountToteFromRASTrolleyCommand?: UnmountToteFromRASTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/PutAway.unmountToteFromRasTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unmountToteFromRASTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PutAwayApi - functional programming interface
 * @export
 */
export const PutAwayApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PutAwayApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddOrUpdatePutAwayCellRuleCommand} [addOrUpdatePutAwayCellRuleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayAddOrUpdatePutAwayCellRulePost(addOrUpdatePutAwayCellRuleCommand?: AddOrUpdatePutAwayCellRuleCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAwayCellRuleOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayAddOrUpdatePutAwayCellRulePost(addOrUpdatePutAwayCellRuleCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckProductExistCellSuggestedCommand} [checkProductExistCellSuggestedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayCheckProductExistCellSuggestedPost(checkProductExistCellSuggestedCommand?: CheckProductExistCellSuggestedCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProductExistOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayCheckProductExistCellSuggestedPost(checkProductExistCellSuggestedCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckProductExistCommand} [checkProductExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayCheckProductExistPost(checkProductExistCommand?: CheckProductExistCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProductExistOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayCheckProductExistPost(checkProductExistCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckTotalProductCountExistCommand} [checkTotalProductCountExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayCheckTotalProductCountExistPost(checkTotalProductCountExistCommand?: CheckTotalProductCountExistCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayCheckTotalProductCountExistPost(checkTotalProductCountExistCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckToteOnTrolleyCommand} [checkToteOnTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayCheckToteOnTrolleyPost(checkToteOnTrolleyCommand?: CheckToteOnTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayCheckToteOnTrolleyPost(checkToteOnTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompletePutAwayCommand} [completePutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayCompletePutAwayPost(completePutAwayCommand?: CompletePutAwayCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayCompletePutAwayPost(completePutAwayCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePutAwayIfNotExistCommand} [createPutAwayIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayCreateIfNotExistPost(createPutAwayIfNotExistCommand?: CreatePutAwayIfNotExistCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAwayOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayCreateIfNotExistPost(createPutAwayIfNotExistCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeletePutAwayCellRuleCommand} [deletePutAwayCellRuleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayDeletePutAwayCellRulePost(deletePutAwayCellRuleCommand?: DeletePutAwayCellRuleCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayDeletePutAwayCellRulePost(deletePutAwayCellRuleCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DropToteToRasDropAddressCommand} [dropToteToRasDropAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayDropToteToRasDropAddressPost(dropToteToRasDropAddressCommand?: DropToteToRasDropAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAwayOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayDropToteToRasDropAddressPost(dropToteToRasDropAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ForceCompletePutAwayCommand} [forceCompletePutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayForceCompletePutAwayMissingPost(forceCompletePutAwayCommand?: ForceCompletePutAwayCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PutAwayLostItemOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayForceCompletePutAwayMissingPost(forceCompletePutAwayCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ForceCompletePutAwayReleaseCommand} [forceCompletePutAwayReleaseCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayForceCompletePutAwayReleasePost(forceCompletePutAwayReleaseCommand?: ForceCompletePutAwayReleaseCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RemainingReceivedItemOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayForceCompletePutAwayReleasePost(forceCompletePutAwayReleaseCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayGetCellTypeGet(cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckCellTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayGetCellTypeGet(cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetPutAwayCellAddressForToteCommand} [getPutAwayCellAddressForToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayGetNextPutAwayCellAddressForTotePost(getPutAwayCellAddressForToteCommand?: GetPutAwayCellAddressForToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPutAwayCellAddressForToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayGetNextPutAwayCellAddressForTotePost(getPutAwayCellAddressForToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {number} [zoneId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayGetProductAddressDetailsGet(productId?: string, zoneId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProductAddressDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayGetProductAddressDetailsGet(productId, zoneId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [putAwayReferenceNumber] 
         * @param {string} [currentZone] 
         * @param {boolean} [skipCurrentZone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayGetPutAwayNextZonePost(putAwayReferenceNumber?: number, currentZone?: string, skipCurrentZone?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAwayNextZoneOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayGetPutAwayNextZonePost(putAwayReferenceNumber, currentZone, skipCurrentZone, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LeavePutAwayCommand} [leavePutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayLeavePutAwayPost(leavePutAwayCommand?: LeavePutAwayCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayLeavePutAwayPost(leavePutAwayCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {OnHoldPutAwayCommand} [onHoldPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayOnHoldPutAwayPost(onHoldPutAwayCommand?: OnHoldPutAwayCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RemainingReceivedItemOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayOnHoldPutAwayPost(onHoldPutAwayCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ParkTrolleyCommand} [parkTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayParkTrolleyPost(parkTrolleyCommand?: ParkTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayParkTrolleyPost(parkTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceProductCellSuggestedCommand} [placeProductCellSuggestedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayPlaceProductCellSuggestedPost(placeProductCellSuggestedCommand?: PlaceProductCellSuggestedCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceProductCellSuggestedOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayPlaceProductCellSuggestedPost(placeProductCellSuggestedCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceProductCommand} [placeProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayPlaceProductPost(placeProductCommand?: PlaceProductCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAwayOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayPlaceProductPost(placeProductCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceToteToInboundCommand} [placeToteToInboundCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayPlaceToteToInboundPost(placeToteToInboundCommand?: PlaceToteToInboundCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAwayOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayPlaceToteToInboundPost(placeToteToInboundCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceToteToRASTrolleyCommand} [placeToteToRASTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayPlaceToteToRasTrolleyPost(placeToteToRASTrolleyCommand?: PlaceToteToRASTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAwayOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayPlaceToteToRasTrolleyPost(placeToteToRASTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceToteToTrolleyCommand} [placeToteToTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayPlaceToteToTrolleyPost(placeToteToTrolleyCommand?: PlaceToteToTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAwayOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayPlaceToteToTrolleyPost(placeToteToTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PutAwayProductMissingCommand} [putAwayProductMissingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayPutAwayProductLostItemPost(putAwayProductMissingCommand?: PutAwayProductMissingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceProductCellSuggestedOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayPutAwayProductLostItemPost(putAwayProductMissingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PutAwayToteLostItemsCommand} [putAwayToteLostItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayPutAwayToteLostItemPost(putAwayToteLostItemsCommand?: PutAwayToteLostItemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceProductCellSuggestedOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayPutAwayToteLostItemPost(putAwayToteLostItemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayQueryActivePutAwaysGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivePutAwayOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayQueryActivePutAwaysGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayQueryAvailablePutAwayTrolleysGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailablePutAwayTrolleysOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayQueryAvailablePutAwayTrolleysGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayQueryPutAwayManagementCountsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryPutAwayManagementCountsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayQueryPutAwayManagementCountsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayQueryReservedProductManagementBlockerFeedsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryReservedProductManagementBlockerFeedsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayQueryReservedProductManagementBlockerFeedsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayQueryReservedProductManagementCountsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryReservedProductManagementCountsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayQueryReservedProductManagementCountsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayQueryReservedProductManagementProposedFeedsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryReservedProductManagementProposedFeedsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayQueryReservedProductManagementProposedFeedsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayQueryReservedProductManagementReservedProductsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryReservedProductManagementReservedProductsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayQueryReservedProductManagementReservedProductsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayQueryWaitingTotesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaitingPutAwayTotesOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayQueryWaitingTotesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PutAwayTrolleyReturnCommand} [putAwayTrolleyReturnCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayReturnPutAwayTrolleyPost(putAwayTrolleyReturnCommand?: PutAwayTrolleyReturnCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayReturnPutAwayTrolleyPost(putAwayTrolleyReturnCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetCellFullCommand} [setCellFullCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwaySetCellFullPost(setCellFullCommand?: SetCellFullCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPutAwayCellAddressForToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwaySetCellFullPost(setCellFullCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StartPutAwayCommand} [startPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayStartPutAwayPost(startPutAwayCommand?: StartPutAwayCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAwayNextZoneOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayStartPutAwayPost(startPutAwayCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UnmountToteFromRASTrolleyCommand} [unmountToteFromRASTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PutAwayUnmountToteFromRasTrolleyPost(unmountToteFromRASTrolleyCommand?: UnmountToteFromRASTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAwayOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PutAwayUnmountToteFromRasTrolleyPost(unmountToteFromRASTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PutAwayApi - factory interface
 * @export
 */
export const PutAwayApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PutAwayApiFp(configuration)
    return {
        /**
         * 
         * @param {AddOrUpdatePutAwayCellRuleCommand} [addOrUpdatePutAwayCellRuleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayAddOrUpdatePutAwayCellRulePost(addOrUpdatePutAwayCellRuleCommand?: AddOrUpdatePutAwayCellRuleCommand, options?: any): AxiosPromise<PutAwayCellRuleOutputDTO> {
            return localVarFp.apiV1PutAwayAddOrUpdatePutAwayCellRulePost(addOrUpdatePutAwayCellRuleCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckProductExistCellSuggestedCommand} [checkProductExistCellSuggestedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayCheckProductExistCellSuggestedPost(checkProductExistCellSuggestedCommand?: CheckProductExistCellSuggestedCommand, options?: any): AxiosPromise<CheckProductExistOutputDTO> {
            return localVarFp.apiV1PutAwayCheckProductExistCellSuggestedPost(checkProductExistCellSuggestedCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckProductExistCommand} [checkProductExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayCheckProductExistPost(checkProductExistCommand?: CheckProductExistCommand, options?: any): AxiosPromise<CheckProductExistOutputDTO> {
            return localVarFp.apiV1PutAwayCheckProductExistPost(checkProductExistCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckTotalProductCountExistCommand} [checkTotalProductCountExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayCheckTotalProductCountExistPost(checkTotalProductCountExistCommand?: CheckTotalProductCountExistCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PutAwayCheckTotalProductCountExistPost(checkTotalProductCountExistCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckToteOnTrolleyCommand} [checkToteOnTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayCheckToteOnTrolleyPost(checkToteOnTrolleyCommand?: CheckToteOnTrolleyCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PutAwayCheckToteOnTrolleyPost(checkToteOnTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompletePutAwayCommand} [completePutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayCompletePutAwayPost(completePutAwayCommand?: CompletePutAwayCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PutAwayCompletePutAwayPost(completePutAwayCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePutAwayIfNotExistCommand} [createPutAwayIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayCreateIfNotExistPost(createPutAwayIfNotExistCommand?: CreatePutAwayIfNotExistCommand, options?: any): AxiosPromise<PutAwayOutputDTO> {
            return localVarFp.apiV1PutAwayCreateIfNotExistPost(createPutAwayIfNotExistCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeletePutAwayCellRuleCommand} [deletePutAwayCellRuleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayDeletePutAwayCellRulePost(deletePutAwayCellRuleCommand?: DeletePutAwayCellRuleCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PutAwayDeletePutAwayCellRulePost(deletePutAwayCellRuleCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DropToteToRasDropAddressCommand} [dropToteToRasDropAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayDropToteToRasDropAddressPost(dropToteToRasDropAddressCommand?: DropToteToRasDropAddressCommand, options?: any): AxiosPromise<PutAwayOutputDTO> {
            return localVarFp.apiV1PutAwayDropToteToRasDropAddressPost(dropToteToRasDropAddressCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ForceCompletePutAwayCommand} [forceCompletePutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayForceCompletePutAwayMissingPost(forceCompletePutAwayCommand?: ForceCompletePutAwayCommand, options?: any): AxiosPromise<Array<PutAwayLostItemOutputDTO>> {
            return localVarFp.apiV1PutAwayForceCompletePutAwayMissingPost(forceCompletePutAwayCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ForceCompletePutAwayReleaseCommand} [forceCompletePutAwayReleaseCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayForceCompletePutAwayReleasePost(forceCompletePutAwayReleaseCommand?: ForceCompletePutAwayReleaseCommand, options?: any): AxiosPromise<Array<RemainingReceivedItemOutputDTO>> {
            return localVarFp.apiV1PutAwayForceCompletePutAwayReleasePost(forceCompletePutAwayReleaseCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayGetCellTypeGet(cellLabel?: string, options?: any): AxiosPromise<CheckCellTypeOutputDTO> {
            return localVarFp.apiV1PutAwayGetCellTypeGet(cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPutAwayCellAddressForToteCommand} [getPutAwayCellAddressForToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayGetNextPutAwayCellAddressForTotePost(getPutAwayCellAddressForToteCommand?: GetPutAwayCellAddressForToteCommand, options?: any): AxiosPromise<GetPutAwayCellAddressForToteOutputDTO> {
            return localVarFp.apiV1PutAwayGetNextPutAwayCellAddressForTotePost(getPutAwayCellAddressForToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {number} [zoneId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayGetProductAddressDetailsGet(productId?: string, zoneId?: number, options?: any): AxiosPromise<GetProductAddressDetailsOutputDTO> {
            return localVarFp.apiV1PutAwayGetProductAddressDetailsGet(productId, zoneId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [putAwayReferenceNumber] 
         * @param {string} [currentZone] 
         * @param {boolean} [skipCurrentZone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayGetPutAwayNextZonePost(putAwayReferenceNumber?: number, currentZone?: string, skipCurrentZone?: boolean, options?: any): AxiosPromise<PutAwayNextZoneOutputDTO> {
            return localVarFp.apiV1PutAwayGetPutAwayNextZonePost(putAwayReferenceNumber, currentZone, skipCurrentZone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LeavePutAwayCommand} [leavePutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayLeavePutAwayPost(leavePutAwayCommand?: LeavePutAwayCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PutAwayLeavePutAwayPost(leavePutAwayCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OnHoldPutAwayCommand} [onHoldPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayOnHoldPutAwayPost(onHoldPutAwayCommand?: OnHoldPutAwayCommand, options?: any): AxiosPromise<Array<RemainingReceivedItemOutputDTO>> {
            return localVarFp.apiV1PutAwayOnHoldPutAwayPost(onHoldPutAwayCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkTrolleyCommand} [parkTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayParkTrolleyPost(parkTrolleyCommand?: ParkTrolleyCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PutAwayParkTrolleyPost(parkTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceProductCellSuggestedCommand} [placeProductCellSuggestedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayPlaceProductCellSuggestedPost(placeProductCellSuggestedCommand?: PlaceProductCellSuggestedCommand, options?: any): AxiosPromise<PlaceProductCellSuggestedOutputDTO> {
            return localVarFp.apiV1PutAwayPlaceProductCellSuggestedPost(placeProductCellSuggestedCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceProductCommand} [placeProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayPlaceProductPost(placeProductCommand?: PlaceProductCommand, options?: any): AxiosPromise<PutAwayOutputDTO> {
            return localVarFp.apiV1PutAwayPlaceProductPost(placeProductCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceToteToInboundCommand} [placeToteToInboundCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayPlaceToteToInboundPost(placeToteToInboundCommand?: PlaceToteToInboundCommand, options?: any): AxiosPromise<PutAwayOutputDTO> {
            return localVarFp.apiV1PutAwayPlaceToteToInboundPost(placeToteToInboundCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceToteToRASTrolleyCommand} [placeToteToRASTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayPlaceToteToRasTrolleyPost(placeToteToRASTrolleyCommand?: PlaceToteToRASTrolleyCommand, options?: any): AxiosPromise<PutAwayOutputDTO> {
            return localVarFp.apiV1PutAwayPlaceToteToRasTrolleyPost(placeToteToRASTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceToteToTrolleyCommand} [placeToteToTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayPlaceToteToTrolleyPost(placeToteToTrolleyCommand?: PlaceToteToTrolleyCommand, options?: any): AxiosPromise<PutAwayOutputDTO> {
            return localVarFp.apiV1PutAwayPlaceToteToTrolleyPost(placeToteToTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PutAwayProductMissingCommand} [putAwayProductMissingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayPutAwayProductLostItemPost(putAwayProductMissingCommand?: PutAwayProductMissingCommand, options?: any): AxiosPromise<PlaceProductCellSuggestedOutputDTO> {
            return localVarFp.apiV1PutAwayPutAwayProductLostItemPost(putAwayProductMissingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PutAwayToteLostItemsCommand} [putAwayToteLostItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayPutAwayToteLostItemPost(putAwayToteLostItemsCommand?: PutAwayToteLostItemsCommand, options?: any): AxiosPromise<PlaceProductCellSuggestedOutputDTO> {
            return localVarFp.apiV1PutAwayPutAwayToteLostItemPost(putAwayToteLostItemsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayQueryActivePutAwaysGet(dqb?: string, options?: any): AxiosPromise<ActivePutAwayOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PutAwayQueryActivePutAwaysGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayQueryAvailablePutAwayTrolleysGet(dqb?: string, options?: any): AxiosPromise<AvailablePutAwayTrolleysOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PutAwayQueryAvailablePutAwayTrolleysGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayQueryPutAwayManagementCountsGet(options?: any): AxiosPromise<QueryPutAwayManagementCountsOutputDTO> {
            return localVarFp.apiV1PutAwayQueryPutAwayManagementCountsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayQueryReservedProductManagementBlockerFeedsGet(dqb?: string, options?: any): AxiosPromise<QueryReservedProductManagementBlockerFeedsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PutAwayQueryReservedProductManagementBlockerFeedsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayQueryReservedProductManagementCountsGet(options?: any): AxiosPromise<QueryReservedProductManagementCountsOutputDTO> {
            return localVarFp.apiV1PutAwayQueryReservedProductManagementCountsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayQueryReservedProductManagementProposedFeedsGet(dqb?: string, options?: any): AxiosPromise<QueryReservedProductManagementProposedFeedsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PutAwayQueryReservedProductManagementProposedFeedsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayQueryReservedProductManagementReservedProductsGet(dqb?: string, options?: any): AxiosPromise<QueryReservedProductManagementReservedProductsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PutAwayQueryReservedProductManagementReservedProductsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayQueryWaitingTotesGet(dqb?: string, options?: any): AxiosPromise<WaitingPutAwayTotesOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1PutAwayQueryWaitingTotesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PutAwayTrolleyReturnCommand} [putAwayTrolleyReturnCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayReturnPutAwayTrolleyPost(putAwayTrolleyReturnCommand?: PutAwayTrolleyReturnCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PutAwayReturnPutAwayTrolleyPost(putAwayTrolleyReturnCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetCellFullCommand} [setCellFullCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwaySetCellFullPost(setCellFullCommand?: SetCellFullCommand, options?: any): AxiosPromise<GetPutAwayCellAddressForToteOutputDTO> {
            return localVarFp.apiV1PutAwaySetCellFullPost(setCellFullCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StartPutAwayCommand} [startPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayStartPutAwayPost(startPutAwayCommand?: StartPutAwayCommand, options?: any): AxiosPromise<PutAwayNextZoneOutputDTO> {
            return localVarFp.apiV1PutAwayStartPutAwayPost(startPutAwayCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnmountToteFromRASTrolleyCommand} [unmountToteFromRASTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PutAwayUnmountToteFromRasTrolleyPost(unmountToteFromRASTrolleyCommand?: UnmountToteFromRASTrolleyCommand, options?: any): AxiosPromise<PutAwayOutputDTO> {
            return localVarFp.apiV1PutAwayUnmountToteFromRasTrolleyPost(unmountToteFromRASTrolleyCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PutAwayApi - object-oriented interface
 * @export
 * @class PutAwayApi
 * @extends {BaseAPI}
 */
export class PutAwayApi extends BaseAPI {
    /**
     * 
     * @param {AddOrUpdatePutAwayCellRuleCommand} [addOrUpdatePutAwayCellRuleCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayAddOrUpdatePutAwayCellRulePost(addOrUpdatePutAwayCellRuleCommand?: AddOrUpdatePutAwayCellRuleCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayAddOrUpdatePutAwayCellRulePost(addOrUpdatePutAwayCellRuleCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckProductExistCellSuggestedCommand} [checkProductExistCellSuggestedCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayCheckProductExistCellSuggestedPost(checkProductExistCellSuggestedCommand?: CheckProductExistCellSuggestedCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayCheckProductExistCellSuggestedPost(checkProductExistCellSuggestedCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckProductExistCommand} [checkProductExistCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayCheckProductExistPost(checkProductExistCommand?: CheckProductExistCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayCheckProductExistPost(checkProductExistCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckTotalProductCountExistCommand} [checkTotalProductCountExistCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayCheckTotalProductCountExistPost(checkTotalProductCountExistCommand?: CheckTotalProductCountExistCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayCheckTotalProductCountExistPost(checkTotalProductCountExistCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckToteOnTrolleyCommand} [checkToteOnTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayCheckToteOnTrolleyPost(checkToteOnTrolleyCommand?: CheckToteOnTrolleyCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayCheckToteOnTrolleyPost(checkToteOnTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompletePutAwayCommand} [completePutAwayCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayCompletePutAwayPost(completePutAwayCommand?: CompletePutAwayCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayCompletePutAwayPost(completePutAwayCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePutAwayIfNotExistCommand} [createPutAwayIfNotExistCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayCreateIfNotExistPost(createPutAwayIfNotExistCommand?: CreatePutAwayIfNotExistCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayCreateIfNotExistPost(createPutAwayIfNotExistCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeletePutAwayCellRuleCommand} [deletePutAwayCellRuleCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayDeletePutAwayCellRulePost(deletePutAwayCellRuleCommand?: DeletePutAwayCellRuleCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayDeletePutAwayCellRulePost(deletePutAwayCellRuleCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DropToteToRasDropAddressCommand} [dropToteToRasDropAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayDropToteToRasDropAddressPost(dropToteToRasDropAddressCommand?: DropToteToRasDropAddressCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayDropToteToRasDropAddressPost(dropToteToRasDropAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ForceCompletePutAwayCommand} [forceCompletePutAwayCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayForceCompletePutAwayMissingPost(forceCompletePutAwayCommand?: ForceCompletePutAwayCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayForceCompletePutAwayMissingPost(forceCompletePutAwayCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ForceCompletePutAwayReleaseCommand} [forceCompletePutAwayReleaseCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayForceCompletePutAwayReleasePost(forceCompletePutAwayReleaseCommand?: ForceCompletePutAwayReleaseCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayForceCompletePutAwayReleasePost(forceCompletePutAwayReleaseCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayGetCellTypeGet(cellLabel?: string, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayGetCellTypeGet(cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPutAwayCellAddressForToteCommand} [getPutAwayCellAddressForToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayGetNextPutAwayCellAddressForTotePost(getPutAwayCellAddressForToteCommand?: GetPutAwayCellAddressForToteCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayGetNextPutAwayCellAddressForTotePost(getPutAwayCellAddressForToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [productId] 
     * @param {number} [zoneId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayGetProductAddressDetailsGet(productId?: string, zoneId?: number, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayGetProductAddressDetailsGet(productId, zoneId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [putAwayReferenceNumber] 
     * @param {string} [currentZone] 
     * @param {boolean} [skipCurrentZone] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayGetPutAwayNextZonePost(putAwayReferenceNumber?: number, currentZone?: string, skipCurrentZone?: boolean, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayGetPutAwayNextZonePost(putAwayReferenceNumber, currentZone, skipCurrentZone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LeavePutAwayCommand} [leavePutAwayCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayLeavePutAwayPost(leavePutAwayCommand?: LeavePutAwayCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayLeavePutAwayPost(leavePutAwayCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OnHoldPutAwayCommand} [onHoldPutAwayCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayOnHoldPutAwayPost(onHoldPutAwayCommand?: OnHoldPutAwayCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayOnHoldPutAwayPost(onHoldPutAwayCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkTrolleyCommand} [parkTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayParkTrolleyPost(parkTrolleyCommand?: ParkTrolleyCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayParkTrolleyPost(parkTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceProductCellSuggestedCommand} [placeProductCellSuggestedCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayPlaceProductCellSuggestedPost(placeProductCellSuggestedCommand?: PlaceProductCellSuggestedCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayPlaceProductCellSuggestedPost(placeProductCellSuggestedCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceProductCommand} [placeProductCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayPlaceProductPost(placeProductCommand?: PlaceProductCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayPlaceProductPost(placeProductCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceToteToInboundCommand} [placeToteToInboundCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayPlaceToteToInboundPost(placeToteToInboundCommand?: PlaceToteToInboundCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayPlaceToteToInboundPost(placeToteToInboundCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceToteToRASTrolleyCommand} [placeToteToRASTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayPlaceToteToRasTrolleyPost(placeToteToRASTrolleyCommand?: PlaceToteToRASTrolleyCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayPlaceToteToRasTrolleyPost(placeToteToRASTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceToteToTrolleyCommand} [placeToteToTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayPlaceToteToTrolleyPost(placeToteToTrolleyCommand?: PlaceToteToTrolleyCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayPlaceToteToTrolleyPost(placeToteToTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PutAwayProductMissingCommand} [putAwayProductMissingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayPutAwayProductLostItemPost(putAwayProductMissingCommand?: PutAwayProductMissingCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayPutAwayProductLostItemPost(putAwayProductMissingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PutAwayToteLostItemsCommand} [putAwayToteLostItemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayPutAwayToteLostItemPost(putAwayToteLostItemsCommand?: PutAwayToteLostItemsCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayPutAwayToteLostItemPost(putAwayToteLostItemsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayQueryActivePutAwaysGet(dqb?: string, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayQueryActivePutAwaysGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayQueryAvailablePutAwayTrolleysGet(dqb?: string, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayQueryAvailablePutAwayTrolleysGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayQueryPutAwayManagementCountsGet(options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayQueryPutAwayManagementCountsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayQueryReservedProductManagementBlockerFeedsGet(dqb?: string, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayQueryReservedProductManagementBlockerFeedsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayQueryReservedProductManagementCountsGet(options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayQueryReservedProductManagementCountsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayQueryReservedProductManagementProposedFeedsGet(dqb?: string, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayQueryReservedProductManagementProposedFeedsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayQueryReservedProductManagementReservedProductsGet(dqb?: string, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayQueryReservedProductManagementReservedProductsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayQueryWaitingTotesGet(dqb?: string, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayQueryWaitingTotesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PutAwayTrolleyReturnCommand} [putAwayTrolleyReturnCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayReturnPutAwayTrolleyPost(putAwayTrolleyReturnCommand?: PutAwayTrolleyReturnCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayReturnPutAwayTrolleyPost(putAwayTrolleyReturnCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetCellFullCommand} [setCellFullCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwaySetCellFullPost(setCellFullCommand?: SetCellFullCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwaySetCellFullPost(setCellFullCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StartPutAwayCommand} [startPutAwayCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayStartPutAwayPost(startPutAwayCommand?: StartPutAwayCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayStartPutAwayPost(startPutAwayCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnmountToteFromRASTrolleyCommand} [unmountToteFromRASTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PutAwayApi
     */
    public apiV1PutAwayUnmountToteFromRasTrolleyPost(unmountToteFromRASTrolleyCommand?: UnmountToteFromRASTrolleyCommand, options?: any) {
        return PutAwayApiFp(this.configuration).apiV1PutAwayUnmountToteFromRasTrolleyPost(unmountToteFromRASTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * QuarantineManagementApi - axios parameter creator
 * @export
 */
export const QuarantineManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [addressType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuarantineManagementListDamagedItemTotesGet: async (addressType?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QuarantineManagement.listDamagedItemTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (addressType !== undefined) {
                localVarQueryParameter['addressType'] = addressType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [addressType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuarantineManagementListOutboundItemTotesGet: async (addressType?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QuarantineManagement.listOutboundItemTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (addressType !== undefined) {
                localVarQueryParameter['addressType'] = addressType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [addressType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuarantineManagementListReceivedItemTotesGet: async (addressType?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QuarantineManagement.listReceivedItemTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (addressType !== undefined) {
                localVarQueryParameter['addressType'] = addressType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QuarantineItemType} itemType 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuarantineManagementQuarantineItemCountsGet: async (itemType: QuarantineItemType, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemType' is not null or undefined
            assertParamExists('apiV1QuarantineManagementQuarantineItemCountsGet', 'itemType', itemType)
            const localVarPath = `/api/v1/QuarantineManagement.quarantineItemCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (itemType !== undefined) {
                localVarQueryParameter['itemType'] = itemType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuarantineManagementQueryDamagedItemTotesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QuarantineManagement.queryDamagedItemTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuarantineManagementQueryLostItemsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QuarantineManagement.queryLostItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuarantineManagementQueryOutboundItemTotesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QuarantineManagement.queryOutboundItemTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuarantineManagementQueryReceivedItemTotesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QuarantineManagement.queryReceivedItemTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuarantineManagementApi - functional programming interface
 * @export
 */
export const QuarantineManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuarantineManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [addressType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QuarantineManagementListDamagedItemTotesGet(addressType?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamagedItemsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QuarantineManagementListDamagedItemTotesGet(addressType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [addressType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QuarantineManagementListOutboundItemTotesGet(addressType?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutboundItemsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QuarantineManagementListOutboundItemTotesGet(addressType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [addressType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QuarantineManagementListReceivedItemTotesGet(addressType?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceivedItemsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QuarantineManagementListReceivedItemTotesGet(addressType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {QuarantineItemType} itemType 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QuarantineManagementQuarantineItemCountsGet(itemType: QuarantineItemType, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuarantineItemCountOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QuarantineManagementQuarantineItemCountsGet(itemType, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QuarantineManagementQueryDamagedItemTotesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamagedItemToteOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QuarantineManagementQueryDamagedItemTotesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QuarantineManagementQueryLostItemsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LostItemQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QuarantineManagementQueryLostItemsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QuarantineManagementQueryOutboundItemTotesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutboundItemToteOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QuarantineManagementQueryOutboundItemTotesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QuarantineManagementQueryReceivedItemTotesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceivedItemToteOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QuarantineManagementQueryReceivedItemTotesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QuarantineManagementApi - factory interface
 * @export
 */
export const QuarantineManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuarantineManagementApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [addressType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuarantineManagementListDamagedItemTotesGet(addressType?: string, options?: any): AxiosPromise<DamagedItemsOutputDTO> {
            return localVarFp.apiV1QuarantineManagementListDamagedItemTotesGet(addressType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [addressType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuarantineManagementListOutboundItemTotesGet(addressType?: string, options?: any): AxiosPromise<OutboundItemsOutputDTO> {
            return localVarFp.apiV1QuarantineManagementListOutboundItemTotesGet(addressType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [addressType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuarantineManagementListReceivedItemTotesGet(addressType?: string, options?: any): AxiosPromise<ReceivedItemsOutputDTO> {
            return localVarFp.apiV1QuarantineManagementListReceivedItemTotesGet(addressType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuarantineItemType} itemType 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuarantineManagementQuarantineItemCountsGet(itemType: QuarantineItemType, dqb?: string, options?: any): AxiosPromise<QuarantineItemCountOutputDTO> {
            return localVarFp.apiV1QuarantineManagementQuarantineItemCountsGet(itemType, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuarantineManagementQueryDamagedItemTotesGet(dqb?: string, options?: any): AxiosPromise<DamagedItemToteOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1QuarantineManagementQueryDamagedItemTotesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuarantineManagementQueryLostItemsGet(dqb?: string, options?: any): AxiosPromise<LostItemQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1QuarantineManagementQueryLostItemsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuarantineManagementQueryOutboundItemTotesGet(dqb?: string, options?: any): AxiosPromise<OutboundItemToteOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1QuarantineManagementQueryOutboundItemTotesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuarantineManagementQueryReceivedItemTotesGet(dqb?: string, options?: any): AxiosPromise<ReceivedItemToteOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1QuarantineManagementQueryReceivedItemTotesGet(dqb, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuarantineManagementApi - object-oriented interface
 * @export
 * @class QuarantineManagementApi
 * @extends {BaseAPI}
 */
export class QuarantineManagementApi extends BaseAPI {
    /**
     * 
     * @param {string} [addressType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineManagementApi
     */
    public apiV1QuarantineManagementListDamagedItemTotesGet(addressType?: string, options?: any) {
        return QuarantineManagementApiFp(this.configuration).apiV1QuarantineManagementListDamagedItemTotesGet(addressType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [addressType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineManagementApi
     */
    public apiV1QuarantineManagementListOutboundItemTotesGet(addressType?: string, options?: any) {
        return QuarantineManagementApiFp(this.configuration).apiV1QuarantineManagementListOutboundItemTotesGet(addressType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [addressType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineManagementApi
     */
    public apiV1QuarantineManagementListReceivedItemTotesGet(addressType?: string, options?: any) {
        return QuarantineManagementApiFp(this.configuration).apiV1QuarantineManagementListReceivedItemTotesGet(addressType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuarantineItemType} itemType 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineManagementApi
     */
    public apiV1QuarantineManagementQuarantineItemCountsGet(itemType: QuarantineItemType, dqb?: string, options?: any) {
        return QuarantineManagementApiFp(this.configuration).apiV1QuarantineManagementQuarantineItemCountsGet(itemType, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineManagementApi
     */
    public apiV1QuarantineManagementQueryDamagedItemTotesGet(dqb?: string, options?: any) {
        return QuarantineManagementApiFp(this.configuration).apiV1QuarantineManagementQueryDamagedItemTotesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineManagementApi
     */
    public apiV1QuarantineManagementQueryLostItemsGet(dqb?: string, options?: any) {
        return QuarantineManagementApiFp(this.configuration).apiV1QuarantineManagementQueryLostItemsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineManagementApi
     */
    public apiV1QuarantineManagementQueryOutboundItemTotesGet(dqb?: string, options?: any) {
        return QuarantineManagementApiFp(this.configuration).apiV1QuarantineManagementQueryOutboundItemTotesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineManagementApi
     */
    public apiV1QuarantineManagementQueryReceivedItemTotesGet(dqb?: string, options?: any) {
        return QuarantineManagementApiFp(this.configuration).apiV1QuarantineManagementQueryReceivedItemTotesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * QueryManagementApi - axios parameter creator
 * @export
 */
export const QueryManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetContainerDetailsGet: async (cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QueryManagement.getContainerDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetContainerProductDetailsGet: async (cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QueryManagement.getContainerProductDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [containerLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetInventoryItemsByContainerGet: async (containerLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QueryManagement.getInventoryItemsByContainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerLabel !== undefined) {
                localVarQueryParameter['containerLabel'] = containerLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [serialNumber] 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetProductContainerDetailsBySerialNumberGet: async (serialNumber?: string, operationId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QueryManagement.getProductContainerDetailsBySerialNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (serialNumber !== undefined) {
                localVarQueryParameter['serialNumber'] = serialNumber;
            }

            if (operationId !== undefined) {
                localVarQueryParameter['operationId'] = operationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetProductContainerDetailsGet: async (productId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QueryManagement.getProductContainerDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetProductDamagedItemTotesGet: async (productId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QueryManagement.getProductDamagedItemTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetProductDetailsByOperationGet: async (barcode?: string, operationId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QueryManagement.getProductDetailsByOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }

            if (operationId !== undefined) {
                localVarQueryParameter['operationId'] = operationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetProductDetailsBySerialNumberGet: async (serialNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QueryManagement.getProductDetailsBySerialNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (serialNumber !== undefined) {
                localVarQueryParameter['serialNumber'] = serialNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetProductDetailsGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QueryManagement.getProductDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetProductInventoryItemDetailsGet: async (productId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QueryManagement.getProductInventoryItemDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetProductPickingItemTotesGet: async (productId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QueryManagement.getProductPickingItemTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementListInventoryItemsByProductGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QueryManagement.listInventoryItemsByProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementListStockItemsByProductGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QueryManagement.listStockItemsByProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QueryManagementApi - functional programming interface
 * @export
 */
export const QueryManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QueryManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QueryManagementGetContainerDetailsGet(cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QueryManagementGetContainerDetailsGet(cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QueryManagementGetContainerProductDetailsGet(cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerProductDetailsOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QueryManagementGetContainerProductDetailsGet(cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [containerLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QueryManagementGetInventoryItemsByContainerGet(containerLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InventoryItemsByContainerOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QueryManagementGetInventoryItemsByContainerGet(containerLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [serialNumber] 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QueryManagementGetProductContainerDetailsBySerialNumberGet(serialNumber?: string, operationId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductContainerDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QueryManagementGetProductContainerDetailsBySerialNumberGet(serialNumber, operationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QueryManagementGetProductContainerDetailsGet(productId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductContainerDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QueryManagementGetProductContainerDetailsGet(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QueryManagementGetProductDamagedItemTotesGet(productId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QueryManagementGetProductDamagedItemTotesGet(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QueryManagementGetProductDetailsByOperationGet(barcode?: string, operationId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailsByOperationOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QueryManagementGetProductDetailsByOperationGet(barcode, operationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QueryManagementGetProductDetailsBySerialNumberGet(serialNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailsWithOperationsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QueryManagementGetProductDetailsBySerialNumberGet(serialNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QueryManagementGetProductDetailsGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailsWithOperationsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QueryManagementGetProductDetailsGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QueryManagementGetProductInventoryItemDetailsGet(productId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductInventoryItemDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QueryManagementGetProductInventoryItemDetailsGet(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QueryManagementGetProductPickingItemTotesGet(productId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QueryManagementGetProductPickingItemTotesGet(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QueryManagementListInventoryItemsByProductGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InventoryItemsByProductOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QueryManagementListInventoryItemsByProductGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QueryManagementListStockItemsByProductGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockItemsByProductOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QueryManagementListStockItemsByProductGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QueryManagementApi - factory interface
 * @export
 */
export const QueryManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QueryManagementApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetContainerDetailsGet(cellLabel?: string, options?: any): AxiosPromise<ContainerDetailsOutputDTO> {
            return localVarFp.apiV1QueryManagementGetContainerDetailsGet(cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetContainerProductDetailsGet(cellLabel?: string, options?: any): AxiosPromise<Array<ContainerProductDetailsOutputDTO>> {
            return localVarFp.apiV1QueryManagementGetContainerProductDetailsGet(cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [containerLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetInventoryItemsByContainerGet(containerLabel?: string, options?: any): AxiosPromise<Array<InventoryItemsByContainerOutputDTO>> {
            return localVarFp.apiV1QueryManagementGetInventoryItemsByContainerGet(containerLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [serialNumber] 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetProductContainerDetailsBySerialNumberGet(serialNumber?: string, operationId?: string, options?: any): AxiosPromise<ProductContainerDetailsOutputDTO> {
            return localVarFp.apiV1QueryManagementGetProductContainerDetailsBySerialNumberGet(serialNumber, operationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetProductContainerDetailsGet(productId?: string, options?: any): AxiosPromise<ProductContainerDetailsOutputDTO> {
            return localVarFp.apiV1QueryManagementGetProductContainerDetailsGet(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetProductDamagedItemTotesGet(productId?: string, options?: any): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.apiV1QueryManagementGetProductDamagedItemTotesGet(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetProductDetailsByOperationGet(barcode?: string, operationId?: string, options?: any): AxiosPromise<ProductDetailsByOperationOutputDTO> {
            return localVarFp.apiV1QueryManagementGetProductDetailsByOperationGet(barcode, operationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetProductDetailsBySerialNumberGet(serialNumber?: string, options?: any): AxiosPromise<ProductDetailsWithOperationsOutputDTO> {
            return localVarFp.apiV1QueryManagementGetProductDetailsBySerialNumberGet(serialNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetProductDetailsGet(barcode?: string, options?: any): AxiosPromise<ProductDetailsWithOperationsOutputDTO> {
            return localVarFp.apiV1QueryManagementGetProductDetailsGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetProductInventoryItemDetailsGet(productId?: string, options?: any): AxiosPromise<ProductInventoryItemDetailsOutputDTO> {
            return localVarFp.apiV1QueryManagementGetProductInventoryItemDetailsGet(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementGetProductPickingItemTotesGet(productId?: string, options?: any): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.apiV1QueryManagementGetProductPickingItemTotesGet(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementListInventoryItemsByProductGet(barcode?: string, options?: any): AxiosPromise<Array<InventoryItemsByProductOutputDTO>> {
            return localVarFp.apiV1QueryManagementListInventoryItemsByProductGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueryManagementListStockItemsByProductGet(barcode?: string, options?: any): AxiosPromise<StockItemsByProductOutputDTO> {
            return localVarFp.apiV1QueryManagementListStockItemsByProductGet(barcode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QueryManagementApi - object-oriented interface
 * @export
 * @class QueryManagementApi
 * @extends {BaseAPI}
 */
export class QueryManagementApi extends BaseAPI {
    /**
     * 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryManagementApi
     */
    public apiV1QueryManagementGetContainerDetailsGet(cellLabel?: string, options?: any) {
        return QueryManagementApiFp(this.configuration).apiV1QueryManagementGetContainerDetailsGet(cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryManagementApi
     */
    public apiV1QueryManagementGetContainerProductDetailsGet(cellLabel?: string, options?: any) {
        return QueryManagementApiFp(this.configuration).apiV1QueryManagementGetContainerProductDetailsGet(cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [containerLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryManagementApi
     */
    public apiV1QueryManagementGetInventoryItemsByContainerGet(containerLabel?: string, options?: any) {
        return QueryManagementApiFp(this.configuration).apiV1QueryManagementGetInventoryItemsByContainerGet(containerLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [serialNumber] 
     * @param {string} [operationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryManagementApi
     */
    public apiV1QueryManagementGetProductContainerDetailsBySerialNumberGet(serialNumber?: string, operationId?: string, options?: any) {
        return QueryManagementApiFp(this.configuration).apiV1QueryManagementGetProductContainerDetailsBySerialNumberGet(serialNumber, operationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [productId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryManagementApi
     */
    public apiV1QueryManagementGetProductContainerDetailsGet(productId?: string, options?: any) {
        return QueryManagementApiFp(this.configuration).apiV1QueryManagementGetProductContainerDetailsGet(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [productId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryManagementApi
     */
    public apiV1QueryManagementGetProductDamagedItemTotesGet(productId?: string, options?: any) {
        return QueryManagementApiFp(this.configuration).apiV1QueryManagementGetProductDamagedItemTotesGet(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {string} [operationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryManagementApi
     */
    public apiV1QueryManagementGetProductDetailsByOperationGet(barcode?: string, operationId?: string, options?: any) {
        return QueryManagementApiFp(this.configuration).apiV1QueryManagementGetProductDetailsByOperationGet(barcode, operationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [serialNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryManagementApi
     */
    public apiV1QueryManagementGetProductDetailsBySerialNumberGet(serialNumber?: string, options?: any) {
        return QueryManagementApiFp(this.configuration).apiV1QueryManagementGetProductDetailsBySerialNumberGet(serialNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryManagementApi
     */
    public apiV1QueryManagementGetProductDetailsGet(barcode?: string, options?: any) {
        return QueryManagementApiFp(this.configuration).apiV1QueryManagementGetProductDetailsGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [productId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryManagementApi
     */
    public apiV1QueryManagementGetProductInventoryItemDetailsGet(productId?: string, options?: any) {
        return QueryManagementApiFp(this.configuration).apiV1QueryManagementGetProductInventoryItemDetailsGet(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [productId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryManagementApi
     */
    public apiV1QueryManagementGetProductPickingItemTotesGet(productId?: string, options?: any) {
        return QueryManagementApiFp(this.configuration).apiV1QueryManagementGetProductPickingItemTotesGet(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryManagementApi
     */
    public apiV1QueryManagementListInventoryItemsByProductGet(barcode?: string, options?: any) {
        return QueryManagementApiFp(this.configuration).apiV1QueryManagementListInventoryItemsByProductGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryManagementApi
     */
    public apiV1QueryManagementListStockItemsByProductGet(barcode?: string, options?: any) {
        return QueryManagementApiFp(this.configuration).apiV1QueryManagementListStockItemsByProductGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * QuickPutAwayApi - axios parameter creator
 * @export
 */
export const QuickPutAwayApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CheckBarcodeTypeForQuickPutAway} [checkBarcodeTypeForQuickPutAway] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuickPutAwayCheckBarcodeTypePost: async (checkBarcodeTypeForQuickPutAway?: CheckBarcodeTypeForQuickPutAway, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QuickPutAway.checkBarcodeType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkBarcodeTypeForQuickPutAway, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckProductExistForQuickPutAwayCommand} [checkProductExistForQuickPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuickPutAwayCheckProductExistPost: async (checkProductExistForQuickPutAwayCommand?: CheckProductExistForQuickPutAwayCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QuickPutAway.checkProductExist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkProductExistForQuickPutAwayCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteQuickPutAwayCommand} [completeQuickPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuickPutAwayCompletePutAwayPost: async (completeQuickPutAwayCommand?: CompleteQuickPutAwayCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QuickPutAway.completePutAway`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeQuickPutAwayCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateQuickPutAwayIfNotExistCommand} [createQuickPutAwayIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuickPutAwayCreateIfNotExistPost: async (createQuickPutAwayIfNotExistCommand?: CreateQuickPutAwayIfNotExistCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QuickPutAway.createIfNotExist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuickPutAwayIfNotExistCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceProductForQuickPutAwayCommand} [placeProductForQuickPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuickPutAwayPlaceProductPost: async (placeProductForQuickPutAwayCommand?: PlaceProductForQuickPutAwayCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/QuickPutAway.placeProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeProductForQuickPutAwayCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuickPutAwayApi - functional programming interface
 * @export
 */
export const QuickPutAwayApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuickPutAwayApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CheckBarcodeTypeForQuickPutAway} [checkBarcodeTypeForQuickPutAway] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QuickPutAwayCheckBarcodeTypePost(checkBarcodeTypeForQuickPutAway?: CheckBarcodeTypeForQuickPutAway, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckBarcodeTypeForQuickPutAwayOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QuickPutAwayCheckBarcodeTypePost(checkBarcodeTypeForQuickPutAway, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckProductExistForQuickPutAwayCommand} [checkProductExistForQuickPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QuickPutAwayCheckProductExistPost(checkProductExistForQuickPutAwayCommand?: CheckProductExistForQuickPutAwayCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProductExistOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QuickPutAwayCheckProductExistPost(checkProductExistForQuickPutAwayCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteQuickPutAwayCommand} [completeQuickPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QuickPutAwayCompletePutAwayPost(completeQuickPutAwayCommand?: CompleteQuickPutAwayCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QuickPutAwayCompletePutAwayPost(completeQuickPutAwayCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateQuickPutAwayIfNotExistCommand} [createQuickPutAwayIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QuickPutAwayCreateIfNotExistPost(createQuickPutAwayIfNotExistCommand?: CreateQuickPutAwayIfNotExistCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuickPutAwayOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QuickPutAwayCreateIfNotExistPost(createQuickPutAwayIfNotExistCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceProductForQuickPutAwayCommand} [placeProductForQuickPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1QuickPutAwayPlaceProductPost(placeProductForQuickPutAwayCommand?: PlaceProductForQuickPutAwayCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1QuickPutAwayPlaceProductPost(placeProductForQuickPutAwayCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QuickPutAwayApi - factory interface
 * @export
 */
export const QuickPutAwayApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuickPutAwayApiFp(configuration)
    return {
        /**
         * 
         * @param {CheckBarcodeTypeForQuickPutAway} [checkBarcodeTypeForQuickPutAway] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuickPutAwayCheckBarcodeTypePost(checkBarcodeTypeForQuickPutAway?: CheckBarcodeTypeForQuickPutAway, options?: any): AxiosPromise<CheckBarcodeTypeForQuickPutAwayOutputDTO> {
            return localVarFp.apiV1QuickPutAwayCheckBarcodeTypePost(checkBarcodeTypeForQuickPutAway, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckProductExistForQuickPutAwayCommand} [checkProductExistForQuickPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuickPutAwayCheckProductExistPost(checkProductExistForQuickPutAwayCommand?: CheckProductExistForQuickPutAwayCommand, options?: any): AxiosPromise<CheckProductExistOutputDTO> {
            return localVarFp.apiV1QuickPutAwayCheckProductExistPost(checkProductExistForQuickPutAwayCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteQuickPutAwayCommand} [completeQuickPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuickPutAwayCompletePutAwayPost(completeQuickPutAwayCommand?: CompleteQuickPutAwayCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1QuickPutAwayCompletePutAwayPost(completeQuickPutAwayCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateQuickPutAwayIfNotExistCommand} [createQuickPutAwayIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuickPutAwayCreateIfNotExistPost(createQuickPutAwayIfNotExistCommand?: CreateQuickPutAwayIfNotExistCommand, options?: any): AxiosPromise<QuickPutAwayOutputDTO> {
            return localVarFp.apiV1QuickPutAwayCreateIfNotExistPost(createQuickPutAwayIfNotExistCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceProductForQuickPutAwayCommand} [placeProductForQuickPutAwayCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QuickPutAwayPlaceProductPost(placeProductForQuickPutAwayCommand?: PlaceProductForQuickPutAwayCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1QuickPutAwayPlaceProductPost(placeProductForQuickPutAwayCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuickPutAwayApi - object-oriented interface
 * @export
 * @class QuickPutAwayApi
 * @extends {BaseAPI}
 */
export class QuickPutAwayApi extends BaseAPI {
    /**
     * 
     * @param {CheckBarcodeTypeForQuickPutAway} [checkBarcodeTypeForQuickPutAway] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickPutAwayApi
     */
    public apiV1QuickPutAwayCheckBarcodeTypePost(checkBarcodeTypeForQuickPutAway?: CheckBarcodeTypeForQuickPutAway, options?: any) {
        return QuickPutAwayApiFp(this.configuration).apiV1QuickPutAwayCheckBarcodeTypePost(checkBarcodeTypeForQuickPutAway, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckProductExistForQuickPutAwayCommand} [checkProductExistForQuickPutAwayCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickPutAwayApi
     */
    public apiV1QuickPutAwayCheckProductExistPost(checkProductExistForQuickPutAwayCommand?: CheckProductExistForQuickPutAwayCommand, options?: any) {
        return QuickPutAwayApiFp(this.configuration).apiV1QuickPutAwayCheckProductExistPost(checkProductExistForQuickPutAwayCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteQuickPutAwayCommand} [completeQuickPutAwayCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickPutAwayApi
     */
    public apiV1QuickPutAwayCompletePutAwayPost(completeQuickPutAwayCommand?: CompleteQuickPutAwayCommand, options?: any) {
        return QuickPutAwayApiFp(this.configuration).apiV1QuickPutAwayCompletePutAwayPost(completeQuickPutAwayCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateQuickPutAwayIfNotExistCommand} [createQuickPutAwayIfNotExistCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickPutAwayApi
     */
    public apiV1QuickPutAwayCreateIfNotExistPost(createQuickPutAwayIfNotExistCommand?: CreateQuickPutAwayIfNotExistCommand, options?: any) {
        return QuickPutAwayApiFp(this.configuration).apiV1QuickPutAwayCreateIfNotExistPost(createQuickPutAwayIfNotExistCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceProductForQuickPutAwayCommand} [placeProductForQuickPutAwayCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickPutAwayApi
     */
    public apiV1QuickPutAwayPlaceProductPost(placeProductForQuickPutAwayCommand?: PlaceProductForQuickPutAwayCommand, options?: any) {
        return QuickPutAwayApiFp(this.configuration).apiV1QuickPutAwayPlaceProductPost(placeProductForQuickPutAwayCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RasApi - axios parameter creator
 * @export
 */
export const RasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasCheckBarcodeTypeForReplenishmentGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.checkBarcodeTypeForReplenishment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasCheckBarcodeTypeGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.checkBarcodeType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasCheckCellGet: async (addressLabel?: string, cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.checkCell`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (addressLabel !== undefined) {
                localVarQueryParameter['addressLabel'] = addressLabel;
            }

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckEligibleProductsForTransferCommand} [checkEligibleProductsForTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasCheckProductsEligibleForTransferPost: async (checkEligibleProductsForTransferCommand?: CheckEligibleProductsForTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.checkProductsEligibleForTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkEligibleProductsForTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasCheckTrolleyForReplenishmentGet: async (trolleyLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.checkTrolleyForReplenishment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (trolleyLabel !== undefined) {
                localVarQueryParameter['trolleyLabel'] = trolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePutAwayIfNotExistCommand} [createPutAwayIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasCreateIfNotExistPost: async (createPutAwayIfNotExistCommand?: CreatePutAwayIfNotExistCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.createIfNotExist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPutAwayIfNotExistCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DropToteToRasDropAddressForReplenishmentCommand} [dropToteToRasDropAddressForReplenishmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasDropToteToRasDropAddressPost: async (dropToteToRasDropAddressForReplenishmentCommand?: DropToteToRasDropAddressForReplenishmentCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.dropToteToRasDropAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dropToteToRasDropAddressForReplenishmentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasListItemsByCellLabelGet: async (cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.listItemsByCellLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickClusterGet: async (salesOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.orderBasedPick.cluster`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['SalesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [amount] 
         * @param {boolean} [onlyCreated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickListsGet: async (amount?: number, onlyCreated?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.orderBasedPickLists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (onlyCreated !== undefined) {
                localVarQueryParameter['onlyCreated'] = onlyCreated;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RasOrderBasedPickMissingItemCommand} [rasOrderBasedPickMissingItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickMissingItemPost: async (rasOrderBasedPickMissingItemCommand?: RasOrderBasedPickMissingItemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.orderBasedPick.missingItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rasOrderBasedPickMissingItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ParkTrolleyCommand} [parkTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasParkTrolleyPost: async (parkTrolleyCommand?: ParkTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.parkTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(parkTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [cellLabel] 
         * @param {string} [productBarcode] 
         * @param {string} [pickListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPickCheckProductGet: async (addressLabel?: string, cellLabel?: string, productBarcode?: string, pickListId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.pick.checkProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (addressLabel !== undefined) {
                localVarQueryParameter['addressLabel'] = addressLabel;
            }

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }

            if (productBarcode !== undefined) {
                localVarQueryParameter['productBarcode'] = productBarcode;
            }

            if (pickListId !== undefined) {
                localVarQueryParameter['pickListId'] = pickListId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPickCheckToteGet: async (addressLabel?: string, toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.pick.checkTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (addressLabel !== undefined) {
                localVarQueryParameter['addressLabel'] = addressLabel;
            }

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClosePickStationCommand} [closePickStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPickCloseStationPost: async (closePickStationCommand?: ClosePickStationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.pick.closeStation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(closePickStationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DropToteFromPickStationCommand} [dropToteFromPickStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPickDropTotePost: async (dropToteFromPickStationCommand?: DropToteFromPickStationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.pick.dropTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dropToteFromPickStationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [amount] 
         * @param {boolean} [onlyCreated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPickListsGet: async (amount?: number, onlyCreated?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.pickLists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (onlyCreated !== undefined) {
                localVarQueryParameter['onlyCreated'] = onlyCreated;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RasLostItemCommand} [rasLostItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPickLostItemPost: async (rasLostItemCommand?: RasLostItemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.pick.lostItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rasLostItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ItemPickedCommand} [itemPickedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPickPlaceProductPost: async (itemPickedCommand?: ItemPickedCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.pick.placeProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(itemPickedCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceToteToPickStationCommand} [placeToteToPickStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPickPlaceTotePost: async (placeToteToPickStationCommand?: PlaceToteToPickStationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.pick.placeTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeToteToPickStationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceToteToTrolleyForRasReplenishmentCommand} [placeToteToTrolleyForRasReplenishmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPlaceToteToTrolleyPost: async (placeToteToTrolleyForRasReplenishmentCommand?: PlaceToteToTrolleyForRasReplenishmentCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.placeToteToTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeToteToTrolleyForRasReplenishmentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPodsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.pods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CallPodCommand} [callPodCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasProblemSolverCallPodPost: async (callPodCommand?: CallPodCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.problemSolver.callPod`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callPodCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RasProblemSolverItemFoundCommand} [rasProblemSolverItemFoundCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasProblemSolverItemFoundPost: async (rasProblemSolverItemFoundCommand?: RasProblemSolverItemFoundCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.problemSolver.itemFound`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rasProblemSolverItemFoundCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RasProblemSolverItemLostCommand} [rasProblemSolverItemLostCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasProblemSolverItemLostPost: async (rasProblemSolverItemLostCommand?: RasProblemSolverItemLostCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.problemSolver.itemLost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rasProblemSolverItemLostCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [podAddressLabel] 
         * @param {string} [stationAddressLabel] 
         * @param {string} [face] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasProblemSolverPodMissingItemsGet: async (podAddressLabel?: string, stationAddressLabel?: string, face?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.problemSolver.podMissingItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (podAddressLabel !== undefined) {
                localVarQueryParameter['PodAddressLabel'] = podAddressLabel;
            }

            if (stationAddressLabel !== undefined) {
                localVarQueryParameter['StationAddressLabel'] = stationAddressLabel;
            }

            if (face !== undefined) {
                localVarQueryParameter['Face'] = face;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [podAddressLabel] 
         * @param {string} [stationAddressLabel] 
         * @param {string} [face] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasProblemSolverPodPendingCancellationsGet: async (podAddressLabel?: string, stationAddressLabel?: string, face?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.problemSolver.podPendingCancellations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (podAddressLabel !== undefined) {
                localVarQueryParameter['PodAddressLabel'] = podAddressLabel;
            }

            if (stationAddressLabel !== undefined) {
                localVarQueryParameter['StationAddressLabel'] = stationAddressLabel;
            }

            if (face !== undefined) {
                localVarQueryParameter['Face'] = face;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RasProblemSolverStripCancelledItemCommand} [rasProblemSolverStripCancelledItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasProblemSolverStripCancelledItemPost: async (rasProblemSolverStripCancelledItemCommand?: RasProblemSolverStripCancelledItemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.problemSolver.stripCancelledItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rasProblemSolverStripCancelledItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasProductsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasRasConfigGet: async (addressLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.rasConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (addressLabel !== undefined) {
                localVarQueryParameter['addressLabel'] = addressLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RasConfigDTO} [rasConfigDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasRasConfigPost: async (rasConfigDTO?: RasConfigDTO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.rasConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rasConfigDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RasMetricDTO} [rasMetricDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasRasMetricPost: async (rasMetricDTO?: RasMetricDTO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.rasMetric`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rasMetricDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RasStationMetricDTO} [rasStationMetricDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasRasStationMetricPost: async (rasStationMetricDTO?: RasStationMetricDTO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.rasStationMetric`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rasStationMetricDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReleasePodCommand} [releasePodCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasReleasePodPost: async (releasePodCommand?: ReleasePodCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.releasePod`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(releasePodCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStartedPickListsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.startedPickLists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStationTotesGet: async (addressLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.stationTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (addressLabel !== undefined) {
                localVarQueryParameter['addressLabel'] = addressLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [podLabel] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStockItemsGet: async (podLabel?: string, cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.stockItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (podLabel !== undefined) {
                localVarQueryParameter['podLabel'] = podLabel;
            }

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StowStationActiveToteCommand} [stowStationActiveToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowActiveTotePost: async (stowStationActiveToteCommand?: StowStationActiveToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.stow.activeTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stowStationActiveToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [toteLabel] 
         * @param {string} [productBarcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowCheckProductGet: async (addressLabel?: string, toteLabel?: string, productBarcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.stow.checkProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (addressLabel !== undefined) {
                localVarQueryParameter['addressLabel'] = addressLabel;
            }

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }

            if (productBarcode !== undefined) {
                localVarQueryParameter['productBarcode'] = productBarcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowCheckToteGet: async (addressLabel?: string, toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.stow.checkTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (addressLabel !== undefined) {
                localVarQueryParameter['addressLabel'] = addressLabel;
            }

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CloseStowStationCommand} [closeStowStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowCloseStationPost: async (closeStowStationCommand?: CloseStowStationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.stow.closeStation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(closeStowStationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [productBarcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowDirectCheckProductGet: async (addressLabel?: string, productBarcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.stow.direct.checkProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (addressLabel !== undefined) {
                localVarQueryParameter['addressLabel'] = addressLabel;
            }

            if (productBarcode !== undefined) {
                localVarQueryParameter['productBarcode'] = productBarcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DirectItemPlacedCommand} [directItemPlacedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowDirectPlaceProductPost: async (directItemPlacedCommand?: DirectItemPlacedCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.stow.direct.placeProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(directItemPlacedCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DivertCancelledItemToToteCommand} [divertCancelledItemToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowDivertCancelledItemPost: async (divertCancelledItemToToteCommand?: DivertCancelledItemToToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.stow.divertCancelledItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(divertCancelledItemToToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DropToteFromStowStationCommand} [dropToteFromStowStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowDropTotePost: async (dropToteFromStowStationCommand?: DropToteFromStowStationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.stow.dropTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dropToteFromStowStationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ItemPlacedCommand} [itemPlacedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowPlaceProductPost: async (itemPlacedCommand?: ItemPlacedCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.stow.placeProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(itemPlacedCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceToteToStowStationCommand} [placeToteToStowStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowPlaceTotePost: async (placeToteToStowStationCommand?: PlaceToteToStowStationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.stow.placeTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeToteToStowStationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SwitchToteOnTrolleyCommand} [switchToteOnTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasSwitchTotePost: async (switchToteOnTrolleyCommand?: SwitchToteOnTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.switchTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(switchToteOnTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferAllProductsToToteCommand} [transferAllProductsToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasTransferAllProductsToTotePost: async (transferAllProductsToToteCommand?: TransferAllProductsToToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.transferAllProductsToTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferAllProductsToToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferSelectedProductsToToteCommand} [transferSelectedProductsToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasTransferProductsToTotePost: async (transferSelectedProductsToToteCommand?: TransferSelectedProductsToToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Ras.transferProductsToTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferSelectedProductsToToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RasApi - functional programming interface
 * @export
 */
export const RasApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RasApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasCheckBarcodeTypeForReplenishmentGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckBarcodeTypeForRasOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasCheckBarcodeTypeForReplenishmentGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasCheckBarcodeTypeGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckBarcodeTypeForRasOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasCheckBarcodeTypeGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasCheckCellGet(addressLabel?: string, cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasCheckCellGet(addressLabel, cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckEligibleProductsForTransferCommand} [checkEligibleProductsForTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasCheckProductsEligibleForTransferPost(checkEligibleProductsForTransferCommand?: CheckEligibleProductsForTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferProductsToToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasCheckProductsEligibleForTransferPost(checkEligibleProductsForTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasCheckTrolleyForReplenishmentGet(trolleyLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckTrolleyForRasReplenishmentOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasCheckTrolleyForReplenishmentGet(trolleyLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePutAwayIfNotExistCommand} [createPutAwayIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasCreateIfNotExistPost(createPutAwayIfNotExistCommand?: CreatePutAwayIfNotExistCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAwayOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasCreateIfNotExistPost(createPutAwayIfNotExistCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DropToteToRasDropAddressForReplenishmentCommand} [dropToteToRasDropAddressForReplenishmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasDropToteToRasDropAddressPost(dropToteToRasDropAddressForReplenishmentCommand?: DropToteToRasDropAddressForReplenishmentCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceToteToTrolleyOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasDropToteToRasDropAddressPost(dropToteToRasDropAddressForReplenishmentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasListItemsByCellLabelGet(cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InventoryItemWithProductOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasListItemsByCellLabelGet(cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasOrderBasedPickClusterGet(salesOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RasOrderBasedPickClusterOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasOrderBasedPickClusterGet(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [amount] 
         * @param {boolean} [onlyCreated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasOrderBasedPickListsGet(amount?: number, onlyCreated?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RasPickListsOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasOrderBasedPickListsGet(amount, onlyCreated, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RasOrderBasedPickMissingItemCommand} [rasOrderBasedPickMissingItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasOrderBasedPickMissingItemPost(rasOrderBasedPickMissingItemCommand?: RasOrderBasedPickMissingItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasOrderBasedPickMissingItemPost(rasOrderBasedPickMissingItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ParkTrolleyCommand} [parkTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasParkTrolleyPost(parkTrolleyCommand?: ParkTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParkPutAwayTrolleyOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasParkTrolleyPost(parkTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [cellLabel] 
         * @param {string} [productBarcode] 
         * @param {string} [pickListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasPickCheckProductGet(addressLabel?: string, cellLabel?: string, productBarcode?: string, pickListId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProductForPickOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasPickCheckProductGet(addressLabel, cellLabel, productBarcode, pickListId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasPickCheckToteGet(addressLabel?: string, toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasPickCheckToteGet(addressLabel, toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ClosePickStationCommand} [closePickStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasPickCloseStationPost(closePickStationCommand?: ClosePickStationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasPickCloseStationPost(closePickStationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DropToteFromPickStationCommand} [dropToteFromPickStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasPickDropTotePost(dropToteFromPickStationCommand?: DropToteFromPickStationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasPickDropTotePost(dropToteFromPickStationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [amount] 
         * @param {boolean} [onlyCreated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasPickListsGet(amount?: number, onlyCreated?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RasPickListsOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasPickListsGet(amount, onlyCreated, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RasLostItemCommand} [rasLostItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasPickLostItemPost(rasLostItemCommand?: RasLostItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RasPlaceProductOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasPickLostItemPost(rasLostItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ItemPickedCommand} [itemPickedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasPickPlaceProductPost(itemPickedCommand?: ItemPickedCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RasPlaceProductOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasPickPlaceProductPost(itemPickedCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceToteToPickStationCommand} [placeToteToPickStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasPickPlaceTotePost(placeToteToPickStationCommand?: PlaceToteToPickStationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasPickPlaceTotePost(placeToteToPickStationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceToteToTrolleyForRasReplenishmentCommand} [placeToteToTrolleyForRasReplenishmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasPlaceToteToTrolleyPost(placeToteToTrolleyForRasReplenishmentCommand?: PlaceToteToTrolleyForRasReplenishmentCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceToteToTrolleyOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasPlaceToteToTrolleyPost(placeToteToTrolleyForRasReplenishmentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasPodsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RasPodOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasPodsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CallPodCommand} [callPodCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasProblemSolverCallPodPost(callPodCommand?: CallPodCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasProblemSolverCallPodPost(callPodCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RasProblemSolverItemFoundCommand} [rasProblemSolverItemFoundCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasProblemSolverItemFoundPost(rasProblemSolverItemFoundCommand?: RasProblemSolverItemFoundCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasProblemSolverItemFoundPost(rasProblemSolverItemFoundCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RasProblemSolverItemLostCommand} [rasProblemSolverItemLostCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasProblemSolverItemLostPost(rasProblemSolverItemLostCommand?: RasProblemSolverItemLostCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasProblemSolverItemLostPost(rasProblemSolverItemLostCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [podAddressLabel] 
         * @param {string} [stationAddressLabel] 
         * @param {string} [face] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasProblemSolverPodMissingItemsGet(podAddressLabel?: string, stationAddressLabel?: string, face?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RasProblemSolverPodItemOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasProblemSolverPodMissingItemsGet(podAddressLabel, stationAddressLabel, face, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [podAddressLabel] 
         * @param {string} [stationAddressLabel] 
         * @param {string} [face] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasProblemSolverPodPendingCancellationsGet(podAddressLabel?: string, stationAddressLabel?: string, face?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RasProblemSolverPodCancellationItemOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasProblemSolverPodPendingCancellationsGet(podAddressLabel, stationAddressLabel, face, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RasProblemSolverStripCancelledItemCommand} [rasProblemSolverStripCancelledItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasProblemSolverStripCancelledItemPost(rasProblemSolverStripCancelledItemCommand?: RasProblemSolverStripCancelledItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasProblemSolverStripCancelledItemPost(rasProblemSolverStripCancelledItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasProductsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RasStockItemProductOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasProductsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasRasConfigGet(addressLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RasConfigOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasRasConfigGet(addressLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RasConfigDTO} [rasConfigDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasRasConfigPost(rasConfigDTO?: RasConfigDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasRasConfigPost(rasConfigDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RasMetricDTO} [rasMetricDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasRasMetricPost(rasMetricDTO?: RasMetricDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasRasMetricPost(rasMetricDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RasStationMetricDTO} [rasStationMetricDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasRasStationMetricPost(rasStationMetricDTO?: RasStationMetricDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasRasStationMetricPost(rasStationMetricDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReleasePodCommand} [releasePodCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasReleasePodPost(releasePodCommand?: ReleasePodCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasReleasePodPost(releasePodCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasStartedPickListsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RasPickListsOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasStartedPickListsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasStationTotesGet(addressLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RasStationToteOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasStationTotesGet(addressLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [podLabel] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasStockItemsGet(podLabel?: string, cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RasStockItemsOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasStockItemsGet(podLabel, cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StowStationActiveToteCommand} [stowStationActiveToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasStowActiveTotePost(stowStationActiveToteCommand?: StowStationActiveToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RasStationToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasStowActiveTotePost(stowStationActiveToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [toteLabel] 
         * @param {string} [productBarcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasStowCheckProductGet(addressLabel?: string, toteLabel?: string, productBarcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProductForStowOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasStowCheckProductGet(addressLabel, toteLabel, productBarcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasStowCheckToteGet(addressLabel?: string, toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasStowCheckToteGet(addressLabel, toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CloseStowStationCommand} [closeStowStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasStowCloseStationPost(closeStowStationCommand?: CloseStowStationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasStowCloseStationPost(closeStowStationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [productBarcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasStowDirectCheckProductGet(addressLabel?: string, productBarcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProductForDirectStowOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasStowDirectCheckProductGet(addressLabel, productBarcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DirectItemPlacedCommand} [directItemPlacedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasStowDirectPlaceProductPost(directItemPlacedCommand?: DirectItemPlacedCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RasDirectItemPlacedOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasStowDirectPlaceProductPost(directItemPlacedCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DivertCancelledItemToToteCommand} [divertCancelledItemToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasStowDivertCancelledItemPost(divertCancelledItemToToteCommand?: DivertCancelledItemToToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasStowDivertCancelledItemPost(divertCancelledItemToToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DropToteFromStowStationCommand} [dropToteFromStowStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasStowDropTotePost(dropToteFromStowStationCommand?: DropToteFromStowStationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasStowDropTotePost(dropToteFromStowStationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ItemPlacedCommand} [itemPlacedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasStowPlaceProductPost(itemPlacedCommand?: ItemPlacedCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RasItemPlacedOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasStowPlaceProductPost(itemPlacedCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceToteToStowStationCommand} [placeToteToStowStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasStowPlaceTotePost(placeToteToStowStationCommand?: PlaceToteToStowStationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RasStationToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasStowPlaceTotePost(placeToteToStowStationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SwitchToteOnTrolleyCommand} [switchToteOnTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasSwitchTotePost(switchToteOnTrolleyCommand?: SwitchToteOnTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceToteToTrolleyOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasSwitchTotePost(switchToteOnTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferAllProductsToToteCommand} [transferAllProductsToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasTransferAllProductsToTotePost(transferAllProductsToToteCommand?: TransferAllProductsToToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferProductsToToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasTransferAllProductsToTotePost(transferAllProductsToToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferSelectedProductsToToteCommand} [transferSelectedProductsToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasTransferProductsToTotePost(transferSelectedProductsToToteCommand?: TransferSelectedProductsToToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferProductsToToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasTransferProductsToTotePost(transferSelectedProductsToToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RasApi - factory interface
 * @export
 */
export const RasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RasApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasCheckBarcodeTypeForReplenishmentGet(barcode?: string, options?: any): AxiosPromise<CheckBarcodeTypeForRasOutputDTO> {
            return localVarFp.apiV1RasCheckBarcodeTypeForReplenishmentGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasCheckBarcodeTypeGet(barcode?: string, options?: any): AxiosPromise<CheckBarcodeTypeForRasOutputDTO> {
            return localVarFp.apiV1RasCheckBarcodeTypeGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasCheckCellGet(addressLabel?: string, cellLabel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasCheckCellGet(addressLabel, cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckEligibleProductsForTransferCommand} [checkEligibleProductsForTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasCheckProductsEligibleForTransferPost(checkEligibleProductsForTransferCommand?: CheckEligibleProductsForTransferCommand, options?: any): AxiosPromise<TransferProductsToToteOutputDTO> {
            return localVarFp.apiV1RasCheckProductsEligibleForTransferPost(checkEligibleProductsForTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasCheckTrolleyForReplenishmentGet(trolleyLabel?: string, options?: any): AxiosPromise<CheckTrolleyForRasReplenishmentOutputDTO> {
            return localVarFp.apiV1RasCheckTrolleyForReplenishmentGet(trolleyLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePutAwayIfNotExistCommand} [createPutAwayIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasCreateIfNotExistPost(createPutAwayIfNotExistCommand?: CreatePutAwayIfNotExistCommand, options?: any): AxiosPromise<PutAwayOutputDTO> {
            return localVarFp.apiV1RasCreateIfNotExistPost(createPutAwayIfNotExistCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DropToteToRasDropAddressForReplenishmentCommand} [dropToteToRasDropAddressForReplenishmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasDropToteToRasDropAddressPost(dropToteToRasDropAddressForReplenishmentCommand?: DropToteToRasDropAddressForReplenishmentCommand, options?: any): AxiosPromise<PlaceToteToTrolleyOutputDTO> {
            return localVarFp.apiV1RasDropToteToRasDropAddressPost(dropToteToRasDropAddressForReplenishmentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasListItemsByCellLabelGet(cellLabel?: string, options?: any): AxiosPromise<Array<InventoryItemWithProductOutputDTO>> {
            return localVarFp.apiV1RasListItemsByCellLabelGet(cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickClusterGet(salesOrderId?: string, options?: any): AxiosPromise<RasOrderBasedPickClusterOutputDTO> {
            return localVarFp.apiV1RasOrderBasedPickClusterGet(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [amount] 
         * @param {boolean} [onlyCreated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickListsGet(amount?: number, onlyCreated?: boolean, options?: any): AxiosPromise<Array<RasPickListsOutputDTO>> {
            return localVarFp.apiV1RasOrderBasedPickListsGet(amount, onlyCreated, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RasOrderBasedPickMissingItemCommand} [rasOrderBasedPickMissingItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickMissingItemPost(rasOrderBasedPickMissingItemCommand?: RasOrderBasedPickMissingItemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasOrderBasedPickMissingItemPost(rasOrderBasedPickMissingItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ParkTrolleyCommand} [parkTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasParkTrolleyPost(parkTrolleyCommand?: ParkTrolleyCommand, options?: any): AxiosPromise<ParkPutAwayTrolleyOutputDTO> {
            return localVarFp.apiV1RasParkTrolleyPost(parkTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [cellLabel] 
         * @param {string} [productBarcode] 
         * @param {string} [pickListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPickCheckProductGet(addressLabel?: string, cellLabel?: string, productBarcode?: string, pickListId?: string, options?: any): AxiosPromise<CheckProductForPickOutputDTO> {
            return localVarFp.apiV1RasPickCheckProductGet(addressLabel, cellLabel, productBarcode, pickListId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPickCheckToteGet(addressLabel?: string, toteLabel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasPickCheckToteGet(addressLabel, toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClosePickStationCommand} [closePickStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPickCloseStationPost(closePickStationCommand?: ClosePickStationCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasPickCloseStationPost(closePickStationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DropToteFromPickStationCommand} [dropToteFromPickStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPickDropTotePost(dropToteFromPickStationCommand?: DropToteFromPickStationCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasPickDropTotePost(dropToteFromPickStationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [amount] 
         * @param {boolean} [onlyCreated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPickListsGet(amount?: number, onlyCreated?: boolean, options?: any): AxiosPromise<Array<RasPickListsOutputDTO>> {
            return localVarFp.apiV1RasPickListsGet(amount, onlyCreated, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RasLostItemCommand} [rasLostItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPickLostItemPost(rasLostItemCommand?: RasLostItemCommand, options?: any): AxiosPromise<RasPlaceProductOutputDTO> {
            return localVarFp.apiV1RasPickLostItemPost(rasLostItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ItemPickedCommand} [itemPickedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPickPlaceProductPost(itemPickedCommand?: ItemPickedCommand, options?: any): AxiosPromise<RasPlaceProductOutputDTO> {
            return localVarFp.apiV1RasPickPlaceProductPost(itemPickedCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceToteToPickStationCommand} [placeToteToPickStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPickPlaceTotePost(placeToteToPickStationCommand?: PlaceToteToPickStationCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasPickPlaceTotePost(placeToteToPickStationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceToteToTrolleyForRasReplenishmentCommand} [placeToteToTrolleyForRasReplenishmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPlaceToteToTrolleyPost(placeToteToTrolleyForRasReplenishmentCommand?: PlaceToteToTrolleyForRasReplenishmentCommand, options?: any): AxiosPromise<PlaceToteToTrolleyOutputDTO> {
            return localVarFp.apiV1RasPlaceToteToTrolleyPost(placeToteToTrolleyForRasReplenishmentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasPodsGet(dqb?: string, options?: any): AxiosPromise<Array<RasPodOutputDTO>> {
            return localVarFp.apiV1RasPodsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CallPodCommand} [callPodCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasProblemSolverCallPodPost(callPodCommand?: CallPodCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasProblemSolverCallPodPost(callPodCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RasProblemSolverItemFoundCommand} [rasProblemSolverItemFoundCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasProblemSolverItemFoundPost(rasProblemSolverItemFoundCommand?: RasProblemSolverItemFoundCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasProblemSolverItemFoundPost(rasProblemSolverItemFoundCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RasProblemSolverItemLostCommand} [rasProblemSolverItemLostCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasProblemSolverItemLostPost(rasProblemSolverItemLostCommand?: RasProblemSolverItemLostCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasProblemSolverItemLostPost(rasProblemSolverItemLostCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [podAddressLabel] 
         * @param {string} [stationAddressLabel] 
         * @param {string} [face] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasProblemSolverPodMissingItemsGet(podAddressLabel?: string, stationAddressLabel?: string, face?: string, options?: any): AxiosPromise<Array<RasProblemSolverPodItemOutputDTO>> {
            return localVarFp.apiV1RasProblemSolverPodMissingItemsGet(podAddressLabel, stationAddressLabel, face, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [podAddressLabel] 
         * @param {string} [stationAddressLabel] 
         * @param {string} [face] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasProblemSolverPodPendingCancellationsGet(podAddressLabel?: string, stationAddressLabel?: string, face?: string, options?: any): AxiosPromise<Array<RasProblemSolverPodCancellationItemOutputDTO>> {
            return localVarFp.apiV1RasProblemSolverPodPendingCancellationsGet(podAddressLabel, stationAddressLabel, face, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RasProblemSolverStripCancelledItemCommand} [rasProblemSolverStripCancelledItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasProblemSolverStripCancelledItemPost(rasProblemSolverStripCancelledItemCommand?: RasProblemSolverStripCancelledItemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasProblemSolverStripCancelledItemPost(rasProblemSolverStripCancelledItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasProductsGet(dqb?: string, options?: any): AxiosPromise<RasStockItemProductOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1RasProductsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasRasConfigGet(addressLabel?: string, options?: any): AxiosPromise<RasConfigOutputDTO> {
            return localVarFp.apiV1RasRasConfigGet(addressLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RasConfigDTO} [rasConfigDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasRasConfigPost(rasConfigDTO?: RasConfigDTO, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasRasConfigPost(rasConfigDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RasMetricDTO} [rasMetricDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasRasMetricPost(rasMetricDTO?: RasMetricDTO, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasRasMetricPost(rasMetricDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RasStationMetricDTO} [rasStationMetricDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasRasStationMetricPost(rasStationMetricDTO?: RasStationMetricDTO, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasRasStationMetricPost(rasStationMetricDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReleasePodCommand} [releasePodCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasReleasePodPost(releasePodCommand?: ReleasePodCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasReleasePodPost(releasePodCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStartedPickListsGet(options?: any): AxiosPromise<Array<RasPickListsOutputDTO>> {
            return localVarFp.apiV1RasStartedPickListsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStationTotesGet(addressLabel?: string, options?: any): AxiosPromise<Array<RasStationToteOutputDTO>> {
            return localVarFp.apiV1RasStationTotesGet(addressLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [podLabel] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStockItemsGet(podLabel?: string, cellLabel?: string, options?: any): AxiosPromise<Array<RasStockItemsOutputDTO>> {
            return localVarFp.apiV1RasStockItemsGet(podLabel, cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StowStationActiveToteCommand} [stowStationActiveToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowActiveTotePost(stowStationActiveToteCommand?: StowStationActiveToteCommand, options?: any): AxiosPromise<RasStationToteOutputDTO> {
            return localVarFp.apiV1RasStowActiveTotePost(stowStationActiveToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [toteLabel] 
         * @param {string} [productBarcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowCheckProductGet(addressLabel?: string, toteLabel?: string, productBarcode?: string, options?: any): AxiosPromise<CheckProductForStowOutputDTO> {
            return localVarFp.apiV1RasStowCheckProductGet(addressLabel, toteLabel, productBarcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowCheckToteGet(addressLabel?: string, toteLabel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasStowCheckToteGet(addressLabel, toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CloseStowStationCommand} [closeStowStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowCloseStationPost(closeStowStationCommand?: CloseStowStationCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasStowCloseStationPost(closeStowStationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {string} [productBarcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowDirectCheckProductGet(addressLabel?: string, productBarcode?: string, options?: any): AxiosPromise<CheckProductForDirectStowOutputDTO> {
            return localVarFp.apiV1RasStowDirectCheckProductGet(addressLabel, productBarcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DirectItemPlacedCommand} [directItemPlacedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowDirectPlaceProductPost(directItemPlacedCommand?: DirectItemPlacedCommand, options?: any): AxiosPromise<RasDirectItemPlacedOutputDTO> {
            return localVarFp.apiV1RasStowDirectPlaceProductPost(directItemPlacedCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DivertCancelledItemToToteCommand} [divertCancelledItemToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowDivertCancelledItemPost(divertCancelledItemToToteCommand?: DivertCancelledItemToToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasStowDivertCancelledItemPost(divertCancelledItemToToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DropToteFromStowStationCommand} [dropToteFromStowStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowDropTotePost(dropToteFromStowStationCommand?: DropToteFromStowStationCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasStowDropTotePost(dropToteFromStowStationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ItemPlacedCommand} [itemPlacedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowPlaceProductPost(itemPlacedCommand?: ItemPlacedCommand, options?: any): AxiosPromise<RasItemPlacedOutputDTO> {
            return localVarFp.apiV1RasStowPlaceProductPost(itemPlacedCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceToteToStowStationCommand} [placeToteToStowStationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasStowPlaceTotePost(placeToteToStowStationCommand?: PlaceToteToStowStationCommand, options?: any): AxiosPromise<RasStationToteOutputDTO> {
            return localVarFp.apiV1RasStowPlaceTotePost(placeToteToStowStationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SwitchToteOnTrolleyCommand} [switchToteOnTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasSwitchTotePost(switchToteOnTrolleyCommand?: SwitchToteOnTrolleyCommand, options?: any): AxiosPromise<PlaceToteToTrolleyOutputDTO> {
            return localVarFp.apiV1RasSwitchTotePost(switchToteOnTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferAllProductsToToteCommand} [transferAllProductsToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasTransferAllProductsToTotePost(transferAllProductsToToteCommand?: TransferAllProductsToToteCommand, options?: any): AxiosPromise<TransferProductsToToteOutputDTO> {
            return localVarFp.apiV1RasTransferAllProductsToTotePost(transferAllProductsToToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferSelectedProductsToToteCommand} [transferSelectedProductsToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasTransferProductsToTotePost(transferSelectedProductsToToteCommand?: TransferSelectedProductsToToteCommand, options?: any): AxiosPromise<TransferProductsToToteOutputDTO> {
            return localVarFp.apiV1RasTransferProductsToTotePost(transferSelectedProductsToToteCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RasApi - object-oriented interface
 * @export
 * @class RasApi
 * @extends {BaseAPI}
 */
export class RasApi extends BaseAPI {
    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasCheckBarcodeTypeForReplenishmentGet(barcode?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasCheckBarcodeTypeForReplenishmentGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasCheckBarcodeTypeGet(barcode?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasCheckBarcodeTypeGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [addressLabel] 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasCheckCellGet(addressLabel?: string, cellLabel?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasCheckCellGet(addressLabel, cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckEligibleProductsForTransferCommand} [checkEligibleProductsForTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasCheckProductsEligibleForTransferPost(checkEligibleProductsForTransferCommand?: CheckEligibleProductsForTransferCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasCheckProductsEligibleForTransferPost(checkEligibleProductsForTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [trolleyLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasCheckTrolleyForReplenishmentGet(trolleyLabel?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasCheckTrolleyForReplenishmentGet(trolleyLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePutAwayIfNotExistCommand} [createPutAwayIfNotExistCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasCreateIfNotExistPost(createPutAwayIfNotExistCommand?: CreatePutAwayIfNotExistCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasCreateIfNotExistPost(createPutAwayIfNotExistCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DropToteToRasDropAddressForReplenishmentCommand} [dropToteToRasDropAddressForReplenishmentCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasDropToteToRasDropAddressPost(dropToteToRasDropAddressForReplenishmentCommand?: DropToteToRasDropAddressForReplenishmentCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasDropToteToRasDropAddressPost(dropToteToRasDropAddressForReplenishmentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasListItemsByCellLabelGet(cellLabel?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasListItemsByCellLabelGet(cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasOrderBasedPickClusterGet(salesOrderId?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasOrderBasedPickClusterGet(salesOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [amount] 
     * @param {boolean} [onlyCreated] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasOrderBasedPickListsGet(amount?: number, onlyCreated?: boolean, options?: any) {
        return RasApiFp(this.configuration).apiV1RasOrderBasedPickListsGet(amount, onlyCreated, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RasOrderBasedPickMissingItemCommand} [rasOrderBasedPickMissingItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasOrderBasedPickMissingItemPost(rasOrderBasedPickMissingItemCommand?: RasOrderBasedPickMissingItemCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasOrderBasedPickMissingItemPost(rasOrderBasedPickMissingItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ParkTrolleyCommand} [parkTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasParkTrolleyPost(parkTrolleyCommand?: ParkTrolleyCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasParkTrolleyPost(parkTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [addressLabel] 
     * @param {string} [cellLabel] 
     * @param {string} [productBarcode] 
     * @param {string} [pickListId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasPickCheckProductGet(addressLabel?: string, cellLabel?: string, productBarcode?: string, pickListId?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasPickCheckProductGet(addressLabel, cellLabel, productBarcode, pickListId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [addressLabel] 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasPickCheckToteGet(addressLabel?: string, toteLabel?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasPickCheckToteGet(addressLabel, toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClosePickStationCommand} [closePickStationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasPickCloseStationPost(closePickStationCommand?: ClosePickStationCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasPickCloseStationPost(closePickStationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DropToteFromPickStationCommand} [dropToteFromPickStationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasPickDropTotePost(dropToteFromPickStationCommand?: DropToteFromPickStationCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasPickDropTotePost(dropToteFromPickStationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [amount] 
     * @param {boolean} [onlyCreated] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasPickListsGet(amount?: number, onlyCreated?: boolean, options?: any) {
        return RasApiFp(this.configuration).apiV1RasPickListsGet(amount, onlyCreated, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RasLostItemCommand} [rasLostItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasPickLostItemPost(rasLostItemCommand?: RasLostItemCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasPickLostItemPost(rasLostItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ItemPickedCommand} [itemPickedCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasPickPlaceProductPost(itemPickedCommand?: ItemPickedCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasPickPlaceProductPost(itemPickedCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceToteToPickStationCommand} [placeToteToPickStationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasPickPlaceTotePost(placeToteToPickStationCommand?: PlaceToteToPickStationCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasPickPlaceTotePost(placeToteToPickStationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceToteToTrolleyForRasReplenishmentCommand} [placeToteToTrolleyForRasReplenishmentCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasPlaceToteToTrolleyPost(placeToteToTrolleyForRasReplenishmentCommand?: PlaceToteToTrolleyForRasReplenishmentCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasPlaceToteToTrolleyPost(placeToteToTrolleyForRasReplenishmentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasPodsGet(dqb?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasPodsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CallPodCommand} [callPodCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasProblemSolverCallPodPost(callPodCommand?: CallPodCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasProblemSolverCallPodPost(callPodCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RasProblemSolverItemFoundCommand} [rasProblemSolverItemFoundCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasProblemSolverItemFoundPost(rasProblemSolverItemFoundCommand?: RasProblemSolverItemFoundCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasProblemSolverItemFoundPost(rasProblemSolverItemFoundCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RasProblemSolverItemLostCommand} [rasProblemSolverItemLostCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasProblemSolverItemLostPost(rasProblemSolverItemLostCommand?: RasProblemSolverItemLostCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasProblemSolverItemLostPost(rasProblemSolverItemLostCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [podAddressLabel] 
     * @param {string} [stationAddressLabel] 
     * @param {string} [face] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasProblemSolverPodMissingItemsGet(podAddressLabel?: string, stationAddressLabel?: string, face?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasProblemSolverPodMissingItemsGet(podAddressLabel, stationAddressLabel, face, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [podAddressLabel] 
     * @param {string} [stationAddressLabel] 
     * @param {string} [face] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasProblemSolverPodPendingCancellationsGet(podAddressLabel?: string, stationAddressLabel?: string, face?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasProblemSolverPodPendingCancellationsGet(podAddressLabel, stationAddressLabel, face, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RasProblemSolverStripCancelledItemCommand} [rasProblemSolverStripCancelledItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasProblemSolverStripCancelledItemPost(rasProblemSolverStripCancelledItemCommand?: RasProblemSolverStripCancelledItemCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasProblemSolverStripCancelledItemPost(rasProblemSolverStripCancelledItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasProductsGet(dqb?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasProductsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [addressLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasRasConfigGet(addressLabel?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasRasConfigGet(addressLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RasConfigDTO} [rasConfigDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasRasConfigPost(rasConfigDTO?: RasConfigDTO, options?: any) {
        return RasApiFp(this.configuration).apiV1RasRasConfigPost(rasConfigDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RasMetricDTO} [rasMetricDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasRasMetricPost(rasMetricDTO?: RasMetricDTO, options?: any) {
        return RasApiFp(this.configuration).apiV1RasRasMetricPost(rasMetricDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RasStationMetricDTO} [rasStationMetricDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasRasStationMetricPost(rasStationMetricDTO?: RasStationMetricDTO, options?: any) {
        return RasApiFp(this.configuration).apiV1RasRasStationMetricPost(rasStationMetricDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReleasePodCommand} [releasePodCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasReleasePodPost(releasePodCommand?: ReleasePodCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasReleasePodPost(releasePodCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasStartedPickListsGet(options?: any) {
        return RasApiFp(this.configuration).apiV1RasStartedPickListsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [addressLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasStationTotesGet(addressLabel?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasStationTotesGet(addressLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [podLabel] 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasStockItemsGet(podLabel?: string, cellLabel?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasStockItemsGet(podLabel, cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StowStationActiveToteCommand} [stowStationActiveToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasStowActiveTotePost(stowStationActiveToteCommand?: StowStationActiveToteCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasStowActiveTotePost(stowStationActiveToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [addressLabel] 
     * @param {string} [toteLabel] 
     * @param {string} [productBarcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasStowCheckProductGet(addressLabel?: string, toteLabel?: string, productBarcode?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasStowCheckProductGet(addressLabel, toteLabel, productBarcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [addressLabel] 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasStowCheckToteGet(addressLabel?: string, toteLabel?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasStowCheckToteGet(addressLabel, toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CloseStowStationCommand} [closeStowStationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasStowCloseStationPost(closeStowStationCommand?: CloseStowStationCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasStowCloseStationPost(closeStowStationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [addressLabel] 
     * @param {string} [productBarcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasStowDirectCheckProductGet(addressLabel?: string, productBarcode?: string, options?: any) {
        return RasApiFp(this.configuration).apiV1RasStowDirectCheckProductGet(addressLabel, productBarcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DirectItemPlacedCommand} [directItemPlacedCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasStowDirectPlaceProductPost(directItemPlacedCommand?: DirectItemPlacedCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasStowDirectPlaceProductPost(directItemPlacedCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DivertCancelledItemToToteCommand} [divertCancelledItemToToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasStowDivertCancelledItemPost(divertCancelledItemToToteCommand?: DivertCancelledItemToToteCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasStowDivertCancelledItemPost(divertCancelledItemToToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DropToteFromStowStationCommand} [dropToteFromStowStationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasStowDropTotePost(dropToteFromStowStationCommand?: DropToteFromStowStationCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasStowDropTotePost(dropToteFromStowStationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ItemPlacedCommand} [itemPlacedCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasStowPlaceProductPost(itemPlacedCommand?: ItemPlacedCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasStowPlaceProductPost(itemPlacedCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceToteToStowStationCommand} [placeToteToStowStationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasStowPlaceTotePost(placeToteToStowStationCommand?: PlaceToteToStowStationCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasStowPlaceTotePost(placeToteToStowStationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SwitchToteOnTrolleyCommand} [switchToteOnTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasSwitchTotePost(switchToteOnTrolleyCommand?: SwitchToteOnTrolleyCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasSwitchTotePost(switchToteOnTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferAllProductsToToteCommand} [transferAllProductsToToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasTransferAllProductsToTotePost(transferAllProductsToToteCommand?: TransferAllProductsToToteCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasTransferAllProductsToTotePost(transferAllProductsToToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferSelectedProductsToToteCommand} [transferSelectedProductsToToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasApi
     */
    public apiV1RasTransferProductsToTotePost(transferSelectedProductsToToteCommand?: TransferSelectedProductsToToteCommand, options?: any) {
        return RasApiFp(this.configuration).apiV1RasTransferProductsToTotePost(transferSelectedProductsToToteCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RasOrderBasedPickApi - axios parameter creator
 * @export
 */
export const RasOrderBasedPickApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RasOrderBasedPickCancelledItemCommand} [rasOrderBasedPickCancelledItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickCancelledItemPost: async (rasOrderBasedPickCancelledItemCommand?: RasOrderBasedPickCancelledItemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RasOrderBasedPick.cancelledItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rasOrderBasedPickCancelledItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stationLabel] 
         * @param {string} [salesOrderId] 
         * @param {string} [pickListId] 
         * @param {string} [cellLabel] 
         * @param {string} [productBarcode] 
         * @param {boolean} [isRestore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickCheckProductGet: async (stationLabel?: string, salesOrderId?: string, pickListId?: string, cellLabel?: string, productBarcode?: string, isRestore?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RasOrderBasedPick.checkProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (stationLabel !== undefined) {
                localVarQueryParameter['stationLabel'] = stationLabel;
            }

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }

            if (pickListId !== undefined) {
                localVarQueryParameter['pickListId'] = pickListId;
            }

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }

            if (productBarcode !== undefined) {
                localVarQueryParameter['productBarcode'] = productBarcode;
            }

            if (isRestore !== undefined) {
                localVarQueryParameter['isRestore'] = isRestore;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickCheckTrolleyGet: async (trolleyLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RasOrderBasedPick.checkTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (trolleyLabel !== undefined) {
                localVarQueryParameter['trolleyLabel'] = trolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceProductForRasOrderBasedPickCommand} [placeProductForRasOrderBasedPickCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickPlaceProductPost: async (placeProductForRasOrderBasedPickCommand?: PlaceProductForRasOrderBasedPickCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RasOrderBasedPick.placeProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeProductForRasOrderBasedPickCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceTrolleysCommand} [placeTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickPlaceTrolleysPost: async (placeTrolleysCommand?: PlaceTrolleysCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RasOrderBasedPick.placeTrolleys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeTrolleysCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stationLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickStationTrolleysGet: async (stationLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RasOrderBasedPick.stationTrolleys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (stationLabel !== undefined) {
                localVarQueryParameter['stationLabel'] = stationLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RasOrderBasedPickApi - functional programming interface
 * @export
 */
export const RasOrderBasedPickApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RasOrderBasedPickApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {RasOrderBasedPickCancelledItemCommand} [rasOrderBasedPickCancelledItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasOrderBasedPickCancelledItemPost(rasOrderBasedPickCancelledItemCommand?: RasOrderBasedPickCancelledItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasOrderBasedPickCancelledItemPost(rasOrderBasedPickCancelledItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [stationLabel] 
         * @param {string} [salesOrderId] 
         * @param {string} [pickListId] 
         * @param {string} [cellLabel] 
         * @param {string} [productBarcode] 
         * @param {boolean} [isRestore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasOrderBasedPickCheckProductGet(stationLabel?: string, salesOrderId?: string, pickListId?: string, cellLabel?: string, productBarcode?: string, isRestore?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RasOrderBasedPickCheckProductOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasOrderBasedPickCheckProductGet(stationLabel, salesOrderId, pickListId, cellLabel, productBarcode, isRestore, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasOrderBasedPickCheckTrolleyGet(trolleyLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasOrderBasedPickCheckTrolleyGet(trolleyLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceProductForRasOrderBasedPickCommand} [placeProductForRasOrderBasedPickCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasOrderBasedPickPlaceProductPost(placeProductForRasOrderBasedPickCommand?: PlaceProductForRasOrderBasedPickCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasOrderBasedPickPlaceProductPost(placeProductForRasOrderBasedPickCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceTrolleysCommand} [placeTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasOrderBasedPickPlaceTrolleysPost(placeTrolleysCommand?: PlaceTrolleysCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasOrderBasedPickPlaceTrolleysPost(placeTrolleysCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [stationLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RasOrderBasedPickStationTrolleysGet(stationLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RasOrderBasedPickStationTrolleysOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RasOrderBasedPickStationTrolleysGet(stationLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RasOrderBasedPickApi - factory interface
 * @export
 */
export const RasOrderBasedPickApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RasOrderBasedPickApiFp(configuration)
    return {
        /**
         * 
         * @param {RasOrderBasedPickCancelledItemCommand} [rasOrderBasedPickCancelledItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickCancelledItemPost(rasOrderBasedPickCancelledItemCommand?: RasOrderBasedPickCancelledItemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasOrderBasedPickCancelledItemPost(rasOrderBasedPickCancelledItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [stationLabel] 
         * @param {string} [salesOrderId] 
         * @param {string} [pickListId] 
         * @param {string} [cellLabel] 
         * @param {string} [productBarcode] 
         * @param {boolean} [isRestore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickCheckProductGet(stationLabel?: string, salesOrderId?: string, pickListId?: string, cellLabel?: string, productBarcode?: string, isRestore?: boolean, options?: any): AxiosPromise<RasOrderBasedPickCheckProductOutputDTO> {
            return localVarFp.apiV1RasOrderBasedPickCheckProductGet(stationLabel, salesOrderId, pickListId, cellLabel, productBarcode, isRestore, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickCheckTrolleyGet(trolleyLabel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasOrderBasedPickCheckTrolleyGet(trolleyLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceProductForRasOrderBasedPickCommand} [placeProductForRasOrderBasedPickCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickPlaceProductPost(placeProductForRasOrderBasedPickCommand?: PlaceProductForRasOrderBasedPickCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasOrderBasedPickPlaceProductPost(placeProductForRasOrderBasedPickCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceTrolleysCommand} [placeTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickPlaceTrolleysPost(placeTrolleysCommand?: PlaceTrolleysCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RasOrderBasedPickPlaceTrolleysPost(placeTrolleysCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [stationLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RasOrderBasedPickStationTrolleysGet(stationLabel?: string, options?: any): AxiosPromise<RasOrderBasedPickStationTrolleysOutputDTO> {
            return localVarFp.apiV1RasOrderBasedPickStationTrolleysGet(stationLabel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RasOrderBasedPickApi - object-oriented interface
 * @export
 * @class RasOrderBasedPickApi
 * @extends {BaseAPI}
 */
export class RasOrderBasedPickApi extends BaseAPI {
    /**
     * 
     * @param {RasOrderBasedPickCancelledItemCommand} [rasOrderBasedPickCancelledItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasOrderBasedPickApi
     */
    public apiV1RasOrderBasedPickCancelledItemPost(rasOrderBasedPickCancelledItemCommand?: RasOrderBasedPickCancelledItemCommand, options?: any) {
        return RasOrderBasedPickApiFp(this.configuration).apiV1RasOrderBasedPickCancelledItemPost(rasOrderBasedPickCancelledItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [stationLabel] 
     * @param {string} [salesOrderId] 
     * @param {string} [pickListId] 
     * @param {string} [cellLabel] 
     * @param {string} [productBarcode] 
     * @param {boolean} [isRestore] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasOrderBasedPickApi
     */
    public apiV1RasOrderBasedPickCheckProductGet(stationLabel?: string, salesOrderId?: string, pickListId?: string, cellLabel?: string, productBarcode?: string, isRestore?: boolean, options?: any) {
        return RasOrderBasedPickApiFp(this.configuration).apiV1RasOrderBasedPickCheckProductGet(stationLabel, salesOrderId, pickListId, cellLabel, productBarcode, isRestore, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [trolleyLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasOrderBasedPickApi
     */
    public apiV1RasOrderBasedPickCheckTrolleyGet(trolleyLabel?: string, options?: any) {
        return RasOrderBasedPickApiFp(this.configuration).apiV1RasOrderBasedPickCheckTrolleyGet(trolleyLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceProductForRasOrderBasedPickCommand} [placeProductForRasOrderBasedPickCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasOrderBasedPickApi
     */
    public apiV1RasOrderBasedPickPlaceProductPost(placeProductForRasOrderBasedPickCommand?: PlaceProductForRasOrderBasedPickCommand, options?: any) {
        return RasOrderBasedPickApiFp(this.configuration).apiV1RasOrderBasedPickPlaceProductPost(placeProductForRasOrderBasedPickCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceTrolleysCommand} [placeTrolleysCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasOrderBasedPickApi
     */
    public apiV1RasOrderBasedPickPlaceTrolleysPost(placeTrolleysCommand?: PlaceTrolleysCommand, options?: any) {
        return RasOrderBasedPickApiFp(this.configuration).apiV1RasOrderBasedPickPlaceTrolleysPost(placeTrolleysCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [stationLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RasOrderBasedPickApi
     */
    public apiV1RasOrderBasedPickStationTrolleysGet(stationLabel?: string, options?: any) {
        return RasOrderBasedPickApiFp(this.configuration).apiV1RasOrderBasedPickStationTrolleysGet(stationLabel, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RebinSortingApi - axios parameter creator
 * @export
 */
export const RebinSortingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AssignRebinTrolleyCommand} [assignRebinTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingAssignRebinTrolleyPost: async (assignRebinTrolleyCommand?: AssignRebinTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.assignRebinTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignRebinTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckAndPlaceBatchPickingProductCommand} [checkAndPlaceBatchPickingProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingCheckAndPlaceBatchPickingProductPost: async (checkAndPlaceBatchPickingProductCommand?: CheckAndPlaceBatchPickingProductCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.checkAndPlaceBatchPickingProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkAndPlaceBatchPickingProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckBatchPickingProductCommand} [checkBatchPickingProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingCheckBatchPickingProductPost: async (checkBatchPickingProductCommand?: CheckBatchPickingProductCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.checkBatchPickingProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkBatchPickingProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckBatchPickingToteForRebinCommand} [checkBatchPickingToteForRebinCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingCheckBatchPickingTotePost: async (checkBatchPickingToteForRebinCommand?: CheckBatchPickingToteForRebinCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.checkBatchPickingTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkBatchPickingToteForRebinCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckBatchTrolleyCommand} [checkBatchTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingCheckBatchTrolleyPost: async (checkBatchTrolleyCommand?: CheckBatchTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.checkBatchTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkBatchTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingCheckHOVToteGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.checkHOVTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteHOVSortingCommand} [completeHOVSortingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingCompleteHOVSortingPost: async (completeHOVSortingCommand?: CompleteHOVSortingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.completeHOVSorting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeHOVSortingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DropAllBatchTotesCommand} [dropAllBatchTotesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingDropAllBatchTotesPost: async (dropAllBatchTotesCommand?: DropAllBatchTotesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.dropAllBatchTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dropAllBatchTotesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DropAllBatchTotesWithLostItemsCommand} [dropAllBatchTotesWithLostItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingDropAllBatchTotesWithLostItemsPost: async (dropAllBatchTotesWithLostItemsCommand?: DropAllBatchTotesWithLostItemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.dropAllBatchTotesWithLostItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dropAllBatchTotesWithLostItemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DropBatchToteCommand} [dropBatchToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingDropBatchTotePost: async (dropBatchToteCommand?: DropBatchToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.dropBatchTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dropBatchToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DropBatchToteWithLostItemsCommand} [dropBatchToteWithLostItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingDropBatchToteWithLostItemsPost: async (dropBatchToteWithLostItemsCommand?: DropBatchToteWithLostItemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.dropBatchToteWithLostItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dropBatchToteWithLostItemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DropBatchTrolleyCommand} [dropBatchTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingDropBatchTrolleyPost: async (dropBatchTrolleyCommand?: DropBatchTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.dropBatchTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dropBatchTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DropRebinTrolleyCommand} [dropRebinTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingDropRebinTrolleyPost: async (dropRebinTrolleyCommand?: DropRebinTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.dropRebinTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dropRebinTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAllBatchPickingTotesDetails} [getAllBatchPickingTotesDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingGetAllBatchPickingTotesDetailsPost: async (getAllBatchPickingTotesDetails?: GetAllBatchPickingTotesDetails, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.getAllBatchPickingTotesDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAllBatchPickingTotesDetails, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} sortingProcessReferenceNumber 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingGetAllRebinSortingHistoryGet: async (sortingProcessReferenceNumber: number, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortingProcessReferenceNumber' is not null or undefined
            assertParamExists('apiV1RebinSortingGetAllRebinSortingHistoryGet', 'sortingProcessReferenceNumber', sortingProcessReferenceNumber)
            const localVarPath = `/api/v1/RebinSorting.getAllRebinSortingHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (sortingProcessReferenceNumber !== undefined) {
                localVarQueryParameter['sortingProcessReferenceNumber'] = sortingProcessReferenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetBatchPickingToteDetails} [getBatchPickingToteDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingGetBatchPickingToteDetailsPost: async (getBatchPickingToteDetails?: GetBatchPickingToteDetails, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.getBatchPickingToteDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getBatchPickingToteDetails, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceBatchPickingProductCommand} [placeBatchPickingProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingPlaceProductPost: async (placeBatchPickingProductCommand?: PlaceBatchPickingProductCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.placeProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeBatchPickingProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartSortingProcessCommand} [startSortingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingStartSortingProcessPost: async (startSortingProcessCommand?: StartSortingProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/RebinSorting.startSortingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startSortingProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RebinSortingApi - functional programming interface
 * @export
 */
export const RebinSortingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RebinSortingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AssignRebinTrolleyCommand} [assignRebinTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingAssignRebinTrolleyPost(assignRebinTrolleyCommand?: AssignRebinTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingAssignRebinTrolleyPost(assignRebinTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckAndPlaceBatchPickingProductCommand} [checkAndPlaceBatchPickingProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingCheckAndPlaceBatchPickingProductPost(checkAndPlaceBatchPickingProductCommand?: CheckAndPlaceBatchPickingProductCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckAndPlaceBatchPickingProductOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingCheckAndPlaceBatchPickingProductPost(checkAndPlaceBatchPickingProductCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckBatchPickingProductCommand} [checkBatchPickingProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingCheckBatchPickingProductPost(checkBatchPickingProductCommand?: CheckBatchPickingProductCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchPickingProductDetailWithToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingCheckBatchPickingProductPost(checkBatchPickingProductCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckBatchPickingToteForRebinCommand} [checkBatchPickingToteForRebinCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingCheckBatchPickingTotePost(checkBatchPickingToteForRebinCommand?: CheckBatchPickingToteForRebinCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckBatchPickingToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingCheckBatchPickingTotePost(checkBatchPickingToteForRebinCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckBatchTrolleyCommand} [checkBatchTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingCheckBatchTrolleyPost(checkBatchTrolleyCommand?: CheckBatchTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchTrolleyDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingCheckBatchTrolleyPost(checkBatchTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingCheckHOVToteGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingCheckHOVToteGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteHOVSortingCommand} [completeHOVSortingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingCompleteHOVSortingPost(completeHOVSortingCommand?: CompleteHOVSortingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteHovSortingOutputDtoDynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingCompleteHOVSortingPost(completeHOVSortingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DropAllBatchTotesCommand} [dropAllBatchTotesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingDropAllBatchTotesPost(dropAllBatchTotesCommand?: DropAllBatchTotesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingDropAllBatchTotesPost(dropAllBatchTotesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DropAllBatchTotesWithLostItemsCommand} [dropAllBatchTotesWithLostItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingDropAllBatchTotesWithLostItemsPost(dropAllBatchTotesWithLostItemsCommand?: DropAllBatchTotesWithLostItemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingDropAllBatchTotesWithLostItemsPost(dropAllBatchTotesWithLostItemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DropBatchToteCommand} [dropBatchToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingDropBatchTotePost(dropBatchToteCommand?: DropBatchToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DropBatchToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingDropBatchTotePost(dropBatchToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DropBatchToteWithLostItemsCommand} [dropBatchToteWithLostItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingDropBatchToteWithLostItemsPost(dropBatchToteWithLostItemsCommand?: DropBatchToteWithLostItemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DropBatchToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingDropBatchToteWithLostItemsPost(dropBatchToteWithLostItemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DropBatchTrolleyCommand} [dropBatchTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingDropBatchTrolleyPost(dropBatchTrolleyCommand?: DropBatchTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingDropBatchTrolleyPost(dropBatchTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DropRebinTrolleyCommand} [dropRebinTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingDropRebinTrolleyPost(dropRebinTrolleyCommand?: DropRebinTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingDropRebinTrolleyPost(dropRebinTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetAllBatchPickingTotesDetails} [getAllBatchPickingTotesDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingGetAllBatchPickingTotesDetailsPost(getAllBatchPickingTotesDetails?: GetAllBatchPickingTotesDetails, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BatchPickingProductDetailOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingGetAllBatchPickingTotesDetailsPost(getAllBatchPickingTotesDetails, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} sortingProcessReferenceNumber 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingGetAllRebinSortingHistoryGet(sortingProcessReferenceNumber: number, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RebinSortingHistoryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingGetAllRebinSortingHistoryGet(sortingProcessReferenceNumber, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetBatchPickingToteDetails} [getBatchPickingToteDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingGetBatchPickingToteDetailsPost(getBatchPickingToteDetails?: GetBatchPickingToteDetails, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BatchPickingProductDetailOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingGetBatchPickingToteDetailsPost(getBatchPickingToteDetails, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceBatchPickingProductCommand} [placeBatchPickingProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingPlaceProductPost(placeBatchPickingProductCommand?: PlaceBatchPickingProductCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceProductOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingPlaceProductPost(placeBatchPickingProductCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StartSortingProcessCommand} [startSortingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RebinSortingStartSortingProcessPost(startSortingProcessCommand?: StartSortingProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartSortingProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RebinSortingStartSortingProcessPost(startSortingProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RebinSortingApi - factory interface
 * @export
 */
export const RebinSortingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RebinSortingApiFp(configuration)
    return {
        /**
         * 
         * @param {AssignRebinTrolleyCommand} [assignRebinTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingAssignRebinTrolleyPost(assignRebinTrolleyCommand?: AssignRebinTrolleyCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RebinSortingAssignRebinTrolleyPost(assignRebinTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckAndPlaceBatchPickingProductCommand} [checkAndPlaceBatchPickingProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingCheckAndPlaceBatchPickingProductPost(checkAndPlaceBatchPickingProductCommand?: CheckAndPlaceBatchPickingProductCommand, options?: any): AxiosPromise<CheckAndPlaceBatchPickingProductOutputDTO> {
            return localVarFp.apiV1RebinSortingCheckAndPlaceBatchPickingProductPost(checkAndPlaceBatchPickingProductCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckBatchPickingProductCommand} [checkBatchPickingProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingCheckBatchPickingProductPost(checkBatchPickingProductCommand?: CheckBatchPickingProductCommand, options?: any): AxiosPromise<BatchPickingProductDetailWithToteOutputDTO> {
            return localVarFp.apiV1RebinSortingCheckBatchPickingProductPost(checkBatchPickingProductCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckBatchPickingToteForRebinCommand} [checkBatchPickingToteForRebinCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingCheckBatchPickingTotePost(checkBatchPickingToteForRebinCommand?: CheckBatchPickingToteForRebinCommand, options?: any): AxiosPromise<CheckBatchPickingToteOutputDTO> {
            return localVarFp.apiV1RebinSortingCheckBatchPickingTotePost(checkBatchPickingToteForRebinCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckBatchTrolleyCommand} [checkBatchTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingCheckBatchTrolleyPost(checkBatchTrolleyCommand?: CheckBatchTrolleyCommand, options?: any): AxiosPromise<BatchTrolleyDetailsOutputDTO> {
            return localVarFp.apiV1RebinSortingCheckBatchTrolleyPost(checkBatchTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingCheckHOVToteGet(toteLabel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RebinSortingCheckHOVToteGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteHOVSortingCommand} [completeHOVSortingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingCompleteHOVSortingPost(completeHOVSortingCommand?: CompleteHOVSortingCommand, options?: any): AxiosPromise<CompleteHovSortingOutputDtoDynamicQueryOutputDTO> {
            return localVarFp.apiV1RebinSortingCompleteHOVSortingPost(completeHOVSortingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DropAllBatchTotesCommand} [dropAllBatchTotesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingDropAllBatchTotesPost(dropAllBatchTotesCommand?: DropAllBatchTotesCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RebinSortingDropAllBatchTotesPost(dropAllBatchTotesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DropAllBatchTotesWithLostItemsCommand} [dropAllBatchTotesWithLostItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingDropAllBatchTotesWithLostItemsPost(dropAllBatchTotesWithLostItemsCommand?: DropAllBatchTotesWithLostItemsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RebinSortingDropAllBatchTotesWithLostItemsPost(dropAllBatchTotesWithLostItemsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DropBatchToteCommand} [dropBatchToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingDropBatchTotePost(dropBatchToteCommand?: DropBatchToteCommand, options?: any): AxiosPromise<DropBatchToteOutputDTO> {
            return localVarFp.apiV1RebinSortingDropBatchTotePost(dropBatchToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DropBatchToteWithLostItemsCommand} [dropBatchToteWithLostItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingDropBatchToteWithLostItemsPost(dropBatchToteWithLostItemsCommand?: DropBatchToteWithLostItemsCommand, options?: any): AxiosPromise<DropBatchToteOutputDTO> {
            return localVarFp.apiV1RebinSortingDropBatchToteWithLostItemsPost(dropBatchToteWithLostItemsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DropBatchTrolleyCommand} [dropBatchTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingDropBatchTrolleyPost(dropBatchTrolleyCommand?: DropBatchTrolleyCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RebinSortingDropBatchTrolleyPost(dropBatchTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DropRebinTrolleyCommand} [dropRebinTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingDropRebinTrolleyPost(dropRebinTrolleyCommand?: DropRebinTrolleyCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RebinSortingDropRebinTrolleyPost(dropRebinTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAllBatchPickingTotesDetails} [getAllBatchPickingTotesDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingGetAllBatchPickingTotesDetailsPost(getAllBatchPickingTotesDetails?: GetAllBatchPickingTotesDetails, options?: any): AxiosPromise<Array<BatchPickingProductDetailOutputDTO>> {
            return localVarFp.apiV1RebinSortingGetAllBatchPickingTotesDetailsPost(getAllBatchPickingTotesDetails, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} sortingProcessReferenceNumber 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingGetAllRebinSortingHistoryGet(sortingProcessReferenceNumber: number, dqb?: string, options?: any): AxiosPromise<RebinSortingHistoryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1RebinSortingGetAllRebinSortingHistoryGet(sortingProcessReferenceNumber, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetBatchPickingToteDetails} [getBatchPickingToteDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingGetBatchPickingToteDetailsPost(getBatchPickingToteDetails?: GetBatchPickingToteDetails, options?: any): AxiosPromise<Array<BatchPickingProductDetailOutputDTO>> {
            return localVarFp.apiV1RebinSortingGetBatchPickingToteDetailsPost(getBatchPickingToteDetails, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceBatchPickingProductCommand} [placeBatchPickingProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingPlaceProductPost(placeBatchPickingProductCommand?: PlaceBatchPickingProductCommand, options?: any): AxiosPromise<PlaceProductOutputDTO> {
            return localVarFp.apiV1RebinSortingPlaceProductPost(placeBatchPickingProductCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StartSortingProcessCommand} [startSortingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RebinSortingStartSortingProcessPost(startSortingProcessCommand?: StartSortingProcessCommand, options?: any): AxiosPromise<StartSortingProcessOutputDTO> {
            return localVarFp.apiV1RebinSortingStartSortingProcessPost(startSortingProcessCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RebinSortingApi - object-oriented interface
 * @export
 * @class RebinSortingApi
 * @extends {BaseAPI}
 */
export class RebinSortingApi extends BaseAPI {
    /**
     * 
     * @param {AssignRebinTrolleyCommand} [assignRebinTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingAssignRebinTrolleyPost(assignRebinTrolleyCommand?: AssignRebinTrolleyCommand, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingAssignRebinTrolleyPost(assignRebinTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckAndPlaceBatchPickingProductCommand} [checkAndPlaceBatchPickingProductCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingCheckAndPlaceBatchPickingProductPost(checkAndPlaceBatchPickingProductCommand?: CheckAndPlaceBatchPickingProductCommand, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingCheckAndPlaceBatchPickingProductPost(checkAndPlaceBatchPickingProductCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckBatchPickingProductCommand} [checkBatchPickingProductCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingCheckBatchPickingProductPost(checkBatchPickingProductCommand?: CheckBatchPickingProductCommand, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingCheckBatchPickingProductPost(checkBatchPickingProductCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckBatchPickingToteForRebinCommand} [checkBatchPickingToteForRebinCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingCheckBatchPickingTotePost(checkBatchPickingToteForRebinCommand?: CheckBatchPickingToteForRebinCommand, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingCheckBatchPickingTotePost(checkBatchPickingToteForRebinCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckBatchTrolleyCommand} [checkBatchTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingCheckBatchTrolleyPost(checkBatchTrolleyCommand?: CheckBatchTrolleyCommand, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingCheckBatchTrolleyPost(checkBatchTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingCheckHOVToteGet(toteLabel?: string, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingCheckHOVToteGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteHOVSortingCommand} [completeHOVSortingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingCompleteHOVSortingPost(completeHOVSortingCommand?: CompleteHOVSortingCommand, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingCompleteHOVSortingPost(completeHOVSortingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DropAllBatchTotesCommand} [dropAllBatchTotesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingDropAllBatchTotesPost(dropAllBatchTotesCommand?: DropAllBatchTotesCommand, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingDropAllBatchTotesPost(dropAllBatchTotesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DropAllBatchTotesWithLostItemsCommand} [dropAllBatchTotesWithLostItemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingDropAllBatchTotesWithLostItemsPost(dropAllBatchTotesWithLostItemsCommand?: DropAllBatchTotesWithLostItemsCommand, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingDropAllBatchTotesWithLostItemsPost(dropAllBatchTotesWithLostItemsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DropBatchToteCommand} [dropBatchToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingDropBatchTotePost(dropBatchToteCommand?: DropBatchToteCommand, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingDropBatchTotePost(dropBatchToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DropBatchToteWithLostItemsCommand} [dropBatchToteWithLostItemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingDropBatchToteWithLostItemsPost(dropBatchToteWithLostItemsCommand?: DropBatchToteWithLostItemsCommand, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingDropBatchToteWithLostItemsPost(dropBatchToteWithLostItemsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DropBatchTrolleyCommand} [dropBatchTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingDropBatchTrolleyPost(dropBatchTrolleyCommand?: DropBatchTrolleyCommand, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingDropBatchTrolleyPost(dropBatchTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DropRebinTrolleyCommand} [dropRebinTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingDropRebinTrolleyPost(dropRebinTrolleyCommand?: DropRebinTrolleyCommand, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingDropRebinTrolleyPost(dropRebinTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAllBatchPickingTotesDetails} [getAllBatchPickingTotesDetails] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingGetAllBatchPickingTotesDetailsPost(getAllBatchPickingTotesDetails?: GetAllBatchPickingTotesDetails, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingGetAllBatchPickingTotesDetailsPost(getAllBatchPickingTotesDetails, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} sortingProcessReferenceNumber 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingGetAllRebinSortingHistoryGet(sortingProcessReferenceNumber: number, dqb?: string, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingGetAllRebinSortingHistoryGet(sortingProcessReferenceNumber, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetBatchPickingToteDetails} [getBatchPickingToteDetails] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingGetBatchPickingToteDetailsPost(getBatchPickingToteDetails?: GetBatchPickingToteDetails, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingGetBatchPickingToteDetailsPost(getBatchPickingToteDetails, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceBatchPickingProductCommand} [placeBatchPickingProductCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingPlaceProductPost(placeBatchPickingProductCommand?: PlaceBatchPickingProductCommand, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingPlaceProductPost(placeBatchPickingProductCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StartSortingProcessCommand} [startSortingProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebinSortingApi
     */
    public apiV1RebinSortingStartSortingProcessPost(startSortingProcessCommand?: StartSortingProcessCommand, options?: any) {
        return RebinSortingApiFp(this.configuration).apiV1RebinSortingStartSortingProcessPost(startSortingProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReceivingLoadSeedApi - axios parameter creator
 * @export
 */
export const ReceivingLoadSeedApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apikey] 
         * @param {ReceivingInitialLoadSeedPayload} [receivingInitialLoadSeedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadseedV1ReceivingLoadSeedReceivingInitialPost: async (apikey?: string, receivingInitialLoadSeedPayload?: ReceivingInitialLoadSeedPayload, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/loadseed/v1/ReceivingLoadSeed/ReceivingInitial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(receivingInitialLoadSeedPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReceivingLoadSeedApi - functional programming interface
 * @export
 */
export const ReceivingLoadSeedApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReceivingLoadSeedApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apikey] 
         * @param {ReceivingInitialLoadSeedPayload} [receivingInitialLoadSeedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadseedV1ReceivingLoadSeedReceivingInitialPost(apikey?: string, receivingInitialLoadSeedPayload?: ReceivingInitialLoadSeedPayload, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadseedV1ReceivingLoadSeedReceivingInitialPost(apikey, receivingInitialLoadSeedPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReceivingLoadSeedApi - factory interface
 * @export
 */
export const ReceivingLoadSeedApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReceivingLoadSeedApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apikey] 
         * @param {ReceivingInitialLoadSeedPayload} [receivingInitialLoadSeedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadseedV1ReceivingLoadSeedReceivingInitialPost(apikey?: string, receivingInitialLoadSeedPayload?: ReceivingInitialLoadSeedPayload, options?: any): AxiosPromise<void> {
            return localVarFp.loadseedV1ReceivingLoadSeedReceivingInitialPost(apikey, receivingInitialLoadSeedPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReceivingLoadSeedApi - object-oriented interface
 * @export
 * @class ReceivingLoadSeedApi
 * @extends {BaseAPI}
 */
export class ReceivingLoadSeedApi extends BaseAPI {
    /**
     * 
     * @param {string} [apikey] 
     * @param {ReceivingInitialLoadSeedPayload} [receivingInitialLoadSeedPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingLoadSeedApi
     */
    public loadseedV1ReceivingLoadSeedReceivingInitialPost(apikey?: string, receivingInitialLoadSeedPayload?: ReceivingInitialLoadSeedPayload, options?: any) {
        return ReceivingLoadSeedApiFp(this.configuration).loadseedV1ReceivingLoadSeedReceivingInitialPost(apikey, receivingInitialLoadSeedPayload, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReceivingProcessesApi - axios parameter creator
 * @export
 */
export const ReceivingProcessesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [receivingProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesCheckBarcodeTypeGet: async (barcode?: string, receivingProcessId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.checkBarcodeType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }

            if (receivingProcessId !== undefined) {
                localVarQueryParameter['receivingProcessId'] = receivingProcessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [receivingProcessId] 
         * @param {string} [barcode] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesCheckExpirationDateIsExpiredGet: async (receivingProcessId?: string, barcode?: string, expirationDate?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.checkExpirationDateIsExpired`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (receivingProcessId !== undefined) {
                localVarQueryParameter['receivingProcessId'] = receivingProcessId;
            }

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }

            if (expirationDate !== undefined) {
                localVarQueryParameter['expirationDate'] = (expirationDate as any instanceof Date) ?
                    (expirationDate as any).toISOString() :
                    expirationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteReceivingProcessCommand} [completeReceivingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesCompletePost: async (completeReceivingProcessCommand?: CompleteReceivingProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeReceivingProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateReceivingProcessIfNotExistsCommand} [createReceivingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesCreateIfNotExistsPost: async (createReceivingProcessIfNotExistsCommand?: CreateReceivingProcessIfNotExistsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.createIfNotExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReceivingProcessIfNotExistsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteDamagedItemsCommand} [deleteDamagedItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesDeleteDamagedItemsPost: async (deleteDamagedItemsCommand?: DeleteDamagedItemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.deleteDamagedItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteDamagedItemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteReceivedItemsCommand} [deleteReceivedItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesDeleteReceivedItemsPost: async (deleteReceivedItemsCommand?: DeleteReceivedItemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.deleteReceivedItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteReceivedItemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesGetDamagedItemToteGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.getDamagedItemTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [inboundBoxLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesGetInboundBoxDetailsGet: async (inboundBoxLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.getInboundBoxDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (inboundBoxLabel !== undefined) {
                localVarQueryParameter['inboundBoxLabel'] = inboundBoxLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesGetReceivedItemToteGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.getReceivedItemTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [receivingToteLabel] 
         * @param {string} [quarantineToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesGetTotalItemAmountGet: async (receivingToteLabel?: string, quarantineToteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.getTotalItemAmount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (receivingToteLabel !== undefined) {
                localVarQueryParameter['receivingToteLabel'] = receivingToteLabel;
            }

            if (quarantineToteLabel !== undefined) {
                localVarQueryParameter['quarantineToteLabel'] = quarantineToteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceDamagedItemCommand} [placeDamagedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesPlaceDamagedItemPost: async (placeDamagedItemCommand?: PlaceDamagedItemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.placeDamagedItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeDamagedItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceReceivedItemCommand} [placeReceivedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesPlaceReceivedItemPost: async (placeReceivedItemCommand?: PlaceReceivedItemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.placeReceivedItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeReceivedItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesQueryActiveInboundBoxesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.queryActiveInboundBoxes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} inboundBoxLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesQueryInboundBoxRecordsGet: async (inboundBoxLabel: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inboundBoxLabel' is not null or undefined
            assertParamExists('apiV1ReceivingProcessesQueryInboundBoxRecordsGet', 'inboundBoxLabel', inboundBoxLabel)
            const localVarPath = `/api/v1/ReceivingProcesses.queryInboundBoxRecords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (inboundBoxLabel !== undefined) {
                localVarQueryParameter['inboundBoxLabel'] = inboundBoxLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SelectContainerForReceivingCommand} [selectContainerForReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesSelectContainerForReceivingPost: async (selectContainerForReceivingCommand?: SelectContainerForReceivingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.selectContainerForReceiving`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectContainerForReceivingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SelectToteForMeasurementCommand} [selectToteForMeasurementCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesSelectToteForMeasurementPost: async (selectToteForMeasurementCommand?: SelectToteForMeasurementCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.selectToteForMeasurement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectToteForMeasurementCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SelectToteForQuarantineCommand} [selectToteForQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesSelectToteForQuarantinePost: async (selectToteForQuarantineCommand?: SelectToteForQuarantineCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.selectToteForQuarantine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectToteForQuarantineCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferToQuarantineCommand} [transferToQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesTransferToQuarantinePost: async (transferToQuarantineCommand?: TransferToQuarantineCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.transferToQuarantine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferToQuarantineCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDamagedItemAmountCommand} [updateDamagedItemAmountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesUpdateDamagedItemAmountPost: async (updateDamagedItemAmountCommand?: UpdateDamagedItemAmountCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.updateDamagedItemAmount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDamagedItemAmountCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateReceivedItemAmountCommand} [updateReceivedItemAmountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesUpdateReceivedItemAmountPost: async (updateReceivedItemAmountCommand?: UpdateReceivedItemAmountCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.updateReceivedItemAmount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReceivedItemAmountCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesUploadDamagedItemImagePost: async (file?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingProcesses.uploadDamagedItemImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReceivingProcessesApi - functional programming interface
 * @export
 */
export const ReceivingProcessesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReceivingProcessesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [receivingProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesCheckBarcodeTypeGet(barcode?: string, receivingProcessId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckBarcodeTypeForReceivingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesCheckBarcodeTypeGet(barcode, receivingProcessId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [receivingProcessId] 
         * @param {string} [barcode] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesCheckExpirationDateIsExpiredGet(receivingProcessId?: string, barcode?: string, expirationDate?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesCheckExpirationDateIsExpiredGet(receivingProcessId, barcode, expirationDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteReceivingProcessCommand} [completeReceivingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesCompletePost(completeReceivingProcessCommand?: CompleteReceivingProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesCompletePost(completeReceivingProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateReceivingProcessIfNotExistsCommand} [createReceivingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesCreateIfNotExistsPost(createReceivingProcessIfNotExistsCommand?: CreateReceivingProcessIfNotExistsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateReceivingProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesCreateIfNotExistsPost(createReceivingProcessIfNotExistsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteDamagedItemsCommand} [deleteDamagedItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesDeleteDamagedItemsPost(deleteDamagedItemsCommand?: DeleteDamagedItemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesDeleteDamagedItemsPost(deleteDamagedItemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteReceivedItemsCommand} [deleteReceivedItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesDeleteReceivedItemsPost(deleteReceivedItemsCommand?: DeleteReceivedItemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesDeleteReceivedItemsPost(deleteReceivedItemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesGetDamagedItemToteGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToteWithDamagedItemsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesGetDamagedItemToteGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [inboundBoxLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesGetInboundBoxDetailsGet(inboundBoxLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInboundBoxDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesGetInboundBoxDetailsGet(inboundBoxLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesGetReceivedItemToteGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerWithReceivedItemsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesGetReceivedItemToteGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [receivingToteLabel] 
         * @param {string} [quarantineToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesGetTotalItemAmountGet(receivingToteLabel?: string, quarantineToteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceivingProcessTotalItemAmountOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesGetTotalItemAmountGet(receivingToteLabel, quarantineToteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceDamagedItemCommand} [placeDamagedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesPlaceDamagedItemPost(placeDamagedItemCommand?: PlaceDamagedItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceItemOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesPlaceDamagedItemPost(placeDamagedItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceReceivedItemCommand} [placeReceivedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesPlaceReceivedItemPost(placeReceivedItemCommand?: PlaceReceivedItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceItemOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesPlaceReceivedItemPost(placeReceivedItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesQueryActiveInboundBoxesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveInboundBoxesOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesQueryActiveInboundBoxesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} inboundBoxLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesQueryInboundBoxRecordsGet(inboundBoxLabel: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryInboundBoxRecordsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesQueryInboundBoxRecordsGet(inboundBoxLabel, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SelectContainerForReceivingCommand} [selectContainerForReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesSelectContainerForReceivingPost(selectContainerForReceivingCommand?: SelectContainerForReceivingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerWithReceivedItemsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesSelectContainerForReceivingPost(selectContainerForReceivingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SelectToteForMeasurementCommand} [selectToteForMeasurementCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesSelectToteForMeasurementPost(selectToteForMeasurementCommand?: SelectToteForMeasurementCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesSelectToteForMeasurementPost(selectToteForMeasurementCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SelectToteForQuarantineCommand} [selectToteForQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesSelectToteForQuarantinePost(selectToteForQuarantineCommand?: SelectToteForQuarantineCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToteWithDamagedItemsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesSelectToteForQuarantinePost(selectToteForQuarantineCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferToQuarantineCommand} [transferToQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesTransferToQuarantinePost(transferToQuarantineCommand?: TransferToQuarantineCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesTransferToQuarantinePost(transferToQuarantineCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateDamagedItemAmountCommand} [updateDamagedItemAmountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesUpdateDamagedItemAmountPost(updateDamagedItemAmountCommand?: UpdateDamagedItemAmountCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesUpdateDamagedItemAmountPost(updateDamagedItemAmountCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateReceivedItemAmountCommand} [updateReceivedItemAmountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesUpdateReceivedItemAmountPost(updateReceivedItemAmountCommand?: UpdateReceivedItemAmountCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesUpdateReceivedItemAmountPost(updateReceivedItemAmountCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingProcessesUploadDamagedItemImagePost(file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingProcessesUploadDamagedItemImagePost(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReceivingProcessesApi - factory interface
 * @export
 */
export const ReceivingProcessesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReceivingProcessesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [receivingProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesCheckBarcodeTypeGet(barcode?: string, receivingProcessId?: string, options?: any): AxiosPromise<CheckBarcodeTypeForReceivingOutputDTO> {
            return localVarFp.apiV1ReceivingProcessesCheckBarcodeTypeGet(barcode, receivingProcessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [receivingProcessId] 
         * @param {string} [barcode] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesCheckExpirationDateIsExpiredGet(receivingProcessId?: string, barcode?: string, expirationDate?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ReceivingProcessesCheckExpirationDateIsExpiredGet(receivingProcessId, barcode, expirationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteReceivingProcessCommand} [completeReceivingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesCompletePost(completeReceivingProcessCommand?: CompleteReceivingProcessCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ReceivingProcessesCompletePost(completeReceivingProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateReceivingProcessIfNotExistsCommand} [createReceivingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesCreateIfNotExistsPost(createReceivingProcessIfNotExistsCommand?: CreateReceivingProcessIfNotExistsCommand, options?: any): AxiosPromise<CreateReceivingProcessOutputDTO> {
            return localVarFp.apiV1ReceivingProcessesCreateIfNotExistsPost(createReceivingProcessIfNotExistsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteDamagedItemsCommand} [deleteDamagedItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesDeleteDamagedItemsPost(deleteDamagedItemsCommand?: DeleteDamagedItemsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ReceivingProcessesDeleteDamagedItemsPost(deleteDamagedItemsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteReceivedItemsCommand} [deleteReceivedItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesDeleteReceivedItemsPost(deleteReceivedItemsCommand?: DeleteReceivedItemsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ReceivingProcessesDeleteReceivedItemsPost(deleteReceivedItemsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesGetDamagedItemToteGet(toteLabel?: string, options?: any): AxiosPromise<ToteWithDamagedItemsOutputDTO> {
            return localVarFp.apiV1ReceivingProcessesGetDamagedItemToteGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [inboundBoxLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesGetInboundBoxDetailsGet(inboundBoxLabel?: string, options?: any): AxiosPromise<GetInboundBoxDetailsOutputDTO> {
            return localVarFp.apiV1ReceivingProcessesGetInboundBoxDetailsGet(inboundBoxLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesGetReceivedItemToteGet(toteLabel?: string, options?: any): AxiosPromise<ContainerWithReceivedItemsOutputDTO> {
            return localVarFp.apiV1ReceivingProcessesGetReceivedItemToteGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [receivingToteLabel] 
         * @param {string} [quarantineToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesGetTotalItemAmountGet(receivingToteLabel?: string, quarantineToteLabel?: string, options?: any): AxiosPromise<ReceivingProcessTotalItemAmountOutputDTO> {
            return localVarFp.apiV1ReceivingProcessesGetTotalItemAmountGet(receivingToteLabel, quarantineToteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceDamagedItemCommand} [placeDamagedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesPlaceDamagedItemPost(placeDamagedItemCommand?: PlaceDamagedItemCommand, options?: any): AxiosPromise<PlaceItemOutputDTO> {
            return localVarFp.apiV1ReceivingProcessesPlaceDamagedItemPost(placeDamagedItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceReceivedItemCommand} [placeReceivedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesPlaceReceivedItemPost(placeReceivedItemCommand?: PlaceReceivedItemCommand, options?: any): AxiosPromise<PlaceItemOutputDTO> {
            return localVarFp.apiV1ReceivingProcessesPlaceReceivedItemPost(placeReceivedItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesQueryActiveInboundBoxesGet(dqb?: string, options?: any): AxiosPromise<ActiveInboundBoxesOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ReceivingProcessesQueryActiveInboundBoxesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} inboundBoxLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesQueryInboundBoxRecordsGet(inboundBoxLabel: string, dqb?: string, options?: any): AxiosPromise<QueryInboundBoxRecordsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ReceivingProcessesQueryInboundBoxRecordsGet(inboundBoxLabel, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SelectContainerForReceivingCommand} [selectContainerForReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesSelectContainerForReceivingPost(selectContainerForReceivingCommand?: SelectContainerForReceivingCommand, options?: any): AxiosPromise<ContainerWithReceivedItemsOutputDTO> {
            return localVarFp.apiV1ReceivingProcessesSelectContainerForReceivingPost(selectContainerForReceivingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SelectToteForMeasurementCommand} [selectToteForMeasurementCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesSelectToteForMeasurementPost(selectToteForMeasurementCommand?: SelectToteForMeasurementCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ReceivingProcessesSelectToteForMeasurementPost(selectToteForMeasurementCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SelectToteForQuarantineCommand} [selectToteForQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesSelectToteForQuarantinePost(selectToteForQuarantineCommand?: SelectToteForQuarantineCommand, options?: any): AxiosPromise<ToteWithDamagedItemsOutputDTO> {
            return localVarFp.apiV1ReceivingProcessesSelectToteForQuarantinePost(selectToteForQuarantineCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferToQuarantineCommand} [transferToQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesTransferToQuarantinePost(transferToQuarantineCommand?: TransferToQuarantineCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ReceivingProcessesTransferToQuarantinePost(transferToQuarantineCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateDamagedItemAmountCommand} [updateDamagedItemAmountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesUpdateDamagedItemAmountPost(updateDamagedItemAmountCommand?: UpdateDamagedItemAmountCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ReceivingProcessesUpdateDamagedItemAmountPost(updateDamagedItemAmountCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateReceivedItemAmountCommand} [updateReceivedItemAmountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesUpdateReceivedItemAmountPost(updateReceivedItemAmountCommand?: UpdateReceivedItemAmountCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ReceivingProcessesUpdateReceivedItemAmountPost(updateReceivedItemAmountCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingProcessesUploadDamagedItemImagePost(file?: any, options?: any): AxiosPromise<ImageOutputDTO> {
            return localVarFp.apiV1ReceivingProcessesUploadDamagedItemImagePost(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReceivingProcessesApi - object-oriented interface
 * @export
 * @class ReceivingProcessesApi
 * @extends {BaseAPI}
 */
export class ReceivingProcessesApi extends BaseAPI {
    /**
     * 
     * @param {string} [barcode] 
     * @param {string} [receivingProcessId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesCheckBarcodeTypeGet(barcode?: string, receivingProcessId?: string, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesCheckBarcodeTypeGet(barcode, receivingProcessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [receivingProcessId] 
     * @param {string} [barcode] 
     * @param {string} [expirationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesCheckExpirationDateIsExpiredGet(receivingProcessId?: string, barcode?: string, expirationDate?: string, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesCheckExpirationDateIsExpiredGet(receivingProcessId, barcode, expirationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteReceivingProcessCommand} [completeReceivingProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesCompletePost(completeReceivingProcessCommand?: CompleteReceivingProcessCommand, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesCompletePost(completeReceivingProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateReceivingProcessIfNotExistsCommand} [createReceivingProcessIfNotExistsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesCreateIfNotExistsPost(createReceivingProcessIfNotExistsCommand?: CreateReceivingProcessIfNotExistsCommand, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesCreateIfNotExistsPost(createReceivingProcessIfNotExistsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteDamagedItemsCommand} [deleteDamagedItemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesDeleteDamagedItemsPost(deleteDamagedItemsCommand?: DeleteDamagedItemsCommand, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesDeleteDamagedItemsPost(deleteDamagedItemsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteReceivedItemsCommand} [deleteReceivedItemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesDeleteReceivedItemsPost(deleteReceivedItemsCommand?: DeleteReceivedItemsCommand, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesDeleteReceivedItemsPost(deleteReceivedItemsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesGetDamagedItemToteGet(toteLabel?: string, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesGetDamagedItemToteGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [inboundBoxLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesGetInboundBoxDetailsGet(inboundBoxLabel?: string, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesGetInboundBoxDetailsGet(inboundBoxLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesGetReceivedItemToteGet(toteLabel?: string, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesGetReceivedItemToteGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [receivingToteLabel] 
     * @param {string} [quarantineToteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesGetTotalItemAmountGet(receivingToteLabel?: string, quarantineToteLabel?: string, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesGetTotalItemAmountGet(receivingToteLabel, quarantineToteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceDamagedItemCommand} [placeDamagedItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesPlaceDamagedItemPost(placeDamagedItemCommand?: PlaceDamagedItemCommand, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesPlaceDamagedItemPost(placeDamagedItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceReceivedItemCommand} [placeReceivedItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesPlaceReceivedItemPost(placeReceivedItemCommand?: PlaceReceivedItemCommand, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesPlaceReceivedItemPost(placeReceivedItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesQueryActiveInboundBoxesGet(dqb?: string, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesQueryActiveInboundBoxesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} inboundBoxLabel 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesQueryInboundBoxRecordsGet(inboundBoxLabel: string, dqb?: string, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesQueryInboundBoxRecordsGet(inboundBoxLabel, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SelectContainerForReceivingCommand} [selectContainerForReceivingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesSelectContainerForReceivingPost(selectContainerForReceivingCommand?: SelectContainerForReceivingCommand, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesSelectContainerForReceivingPost(selectContainerForReceivingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SelectToteForMeasurementCommand} [selectToteForMeasurementCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesSelectToteForMeasurementPost(selectToteForMeasurementCommand?: SelectToteForMeasurementCommand, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesSelectToteForMeasurementPost(selectToteForMeasurementCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SelectToteForQuarantineCommand} [selectToteForQuarantineCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesSelectToteForQuarantinePost(selectToteForQuarantineCommand?: SelectToteForQuarantineCommand, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesSelectToteForQuarantinePost(selectToteForQuarantineCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferToQuarantineCommand} [transferToQuarantineCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesTransferToQuarantinePost(transferToQuarantineCommand?: TransferToQuarantineCommand, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesTransferToQuarantinePost(transferToQuarantineCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateDamagedItemAmountCommand} [updateDamagedItemAmountCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesUpdateDamagedItemAmountPost(updateDamagedItemAmountCommand?: UpdateDamagedItemAmountCommand, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesUpdateDamagedItemAmountPost(updateDamagedItemAmountCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateReceivedItemAmountCommand} [updateReceivedItemAmountCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesUpdateReceivedItemAmountPost(updateReceivedItemAmountCommand?: UpdateReceivedItemAmountCommand, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesUpdateReceivedItemAmountPost(updateReceivedItemAmountCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingProcessesApi
     */
    public apiV1ReceivingProcessesUploadDamagedItemImagePost(file?: any, options?: any) {
        return ReceivingProcessesApiFp(this.configuration).apiV1ReceivingProcessesUploadDamagedItemImagePost(file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReceivingTransfersApi - axios parameter creator
 * @export
 */
export const ReceivingTransfersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingTransfersCheckBarcodeGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingTransfers.checkBarcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sourceContainer] 
         * @param {string} [sku] 
         * @param {number} [count] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingTransfersCheckTransferItemGet: async (sourceContainer?: string, sku?: string, count?: number, expirationDate?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingTransfers.checkTransferItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (sourceContainer !== undefined) {
                localVarQueryParameter['sourceContainer'] = sourceContainer;
            }

            if (sku !== undefined) {
                localVarQueryParameter['sku'] = sku;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (expirationDate !== undefined) {
                localVarQueryParameter['expirationDate'] = (expirationDate as any instanceof Date) ?
                    (expirationDate as any).toISOString() :
                    expirationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [containerLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingTransfersGetContainerDetailsGet: async (containerLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingTransfers.getContainerDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerLabel !== undefined) {
                localVarQueryParameter['containerLabel'] = containerLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferAllContainerItemsCommand} [transferAllContainerItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingTransfersTransferAllContainerItemsPost: async (transferAllContainerItemsCommand?: TransferAllContainerItemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingTransfers.transferAllContainerItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferAllContainerItemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferContainerItemsCommand} [transferContainerItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingTransfersTransferContainerItemsPost: async (transferContainerItemsCommand?: TransferContainerItemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingTransfers.transferContainerItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferContainerItemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [containerLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingTransfersTransferHistoryGet: async (containerLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReceivingTransfers.transferHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerLabel !== undefined) {
                localVarQueryParameter['containerLabel'] = containerLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReceivingTransfersApi - functional programming interface
 * @export
 */
export const ReceivingTransfersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReceivingTransfersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingTransfersCheckBarcodeGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckBarcodeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingTransfersCheckBarcodeGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [sourceContainer] 
         * @param {string} [sku] 
         * @param {number} [count] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingTransfersCheckTransferItemGet(sourceContainer?: string, sku?: string, count?: number, expirationDate?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingTransfersCheckTransferItemGet(sourceContainer, sku, count, expirationDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [containerLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingTransfersGetContainerDetailsGet(containerLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarriableTransferContainerDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingTransfersGetContainerDetailsGet(containerLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferAllContainerItemsCommand} [transferAllContainerItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingTransfersTransferAllContainerItemsPost(transferAllContainerItemsCommand?: TransferAllContainerItemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferContainerItemsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingTransfersTransferAllContainerItemsPost(transferAllContainerItemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferContainerItemsCommand} [transferContainerItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingTransfersTransferContainerItemsPost(transferContainerItemsCommand?: TransferContainerItemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferContainerItemsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingTransfersTransferContainerItemsPost(transferContainerItemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [containerLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReceivingTransfersTransferHistoryGet(containerLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceivingTransferHistoryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReceivingTransfersTransferHistoryGet(containerLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReceivingTransfersApi - factory interface
 * @export
 */
export const ReceivingTransfersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReceivingTransfersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingTransfersCheckBarcodeGet(barcode?: string, options?: any): AxiosPromise<CheckBarcodeOutputDTO> {
            return localVarFp.apiV1ReceivingTransfersCheckBarcodeGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [sourceContainer] 
         * @param {string} [sku] 
         * @param {number} [count] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingTransfersCheckTransferItemGet(sourceContainer?: string, sku?: string, count?: number, expirationDate?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ReceivingTransfersCheckTransferItemGet(sourceContainer, sku, count, expirationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [containerLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingTransfersGetContainerDetailsGet(containerLabel?: string, options?: any): AxiosPromise<CarriableTransferContainerDetailsOutputDTO> {
            return localVarFp.apiV1ReceivingTransfersGetContainerDetailsGet(containerLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferAllContainerItemsCommand} [transferAllContainerItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingTransfersTransferAllContainerItemsPost(transferAllContainerItemsCommand?: TransferAllContainerItemsCommand, options?: any): AxiosPromise<TransferContainerItemsOutputDTO> {
            return localVarFp.apiV1ReceivingTransfersTransferAllContainerItemsPost(transferAllContainerItemsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferContainerItemsCommand} [transferContainerItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingTransfersTransferContainerItemsPost(transferContainerItemsCommand?: TransferContainerItemsCommand, options?: any): AxiosPromise<TransferContainerItemsOutputDTO> {
            return localVarFp.apiV1ReceivingTransfersTransferContainerItemsPost(transferContainerItemsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [containerLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReceivingTransfersTransferHistoryGet(containerLabel?: string, options?: any): AxiosPromise<ReceivingTransferHistoryOutputDTO> {
            return localVarFp.apiV1ReceivingTransfersTransferHistoryGet(containerLabel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReceivingTransfersApi - object-oriented interface
 * @export
 * @class ReceivingTransfersApi
 * @extends {BaseAPI}
 */
export class ReceivingTransfersApi extends BaseAPI {
    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingTransfersApi
     */
    public apiV1ReceivingTransfersCheckBarcodeGet(barcode?: string, options?: any) {
        return ReceivingTransfersApiFp(this.configuration).apiV1ReceivingTransfersCheckBarcodeGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [sourceContainer] 
     * @param {string} [sku] 
     * @param {number} [count] 
     * @param {string} [expirationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingTransfersApi
     */
    public apiV1ReceivingTransfersCheckTransferItemGet(sourceContainer?: string, sku?: string, count?: number, expirationDate?: string, options?: any) {
        return ReceivingTransfersApiFp(this.configuration).apiV1ReceivingTransfersCheckTransferItemGet(sourceContainer, sku, count, expirationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [containerLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingTransfersApi
     */
    public apiV1ReceivingTransfersGetContainerDetailsGet(containerLabel?: string, options?: any) {
        return ReceivingTransfersApiFp(this.configuration).apiV1ReceivingTransfersGetContainerDetailsGet(containerLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferAllContainerItemsCommand} [transferAllContainerItemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingTransfersApi
     */
    public apiV1ReceivingTransfersTransferAllContainerItemsPost(transferAllContainerItemsCommand?: TransferAllContainerItemsCommand, options?: any) {
        return ReceivingTransfersApiFp(this.configuration).apiV1ReceivingTransfersTransferAllContainerItemsPost(transferAllContainerItemsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferContainerItemsCommand} [transferContainerItemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingTransfersApi
     */
    public apiV1ReceivingTransfersTransferContainerItemsPost(transferContainerItemsCommand?: TransferContainerItemsCommand, options?: any) {
        return ReceivingTransfersApiFp(this.configuration).apiV1ReceivingTransfersTransferContainerItemsPost(transferContainerItemsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [containerLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivingTransfersApi
     */
    public apiV1ReceivingTransfersTransferHistoryGet(containerLabel?: string, options?: any) {
        return ReceivingTransfersApiFp(this.configuration).apiV1ReceivingTransfersTransferHistoryGet(containerLabel, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReplenishmentJobsApi - axios parameter creator
 * @export
 */
export const ReplenishmentJobsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsAlternateSourcesGet: async (jobId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReplenishmentJobs.alternateSources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (jobId !== undefined) {
                localVarQueryParameter['jobId'] = jobId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReplenishmentJobType} [jobType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsAvailableGet: async (jobType?: ReplenishmentJobType, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReplenishmentJobs.available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (jobType !== undefined) {
                localVarQueryParameter['jobType'] = jobType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CancelReplenishmentJobsInputDTO} [cancelReplenishmentJobsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsCancelBulkPost: async (cancelReplenishmentJobsInputDTO?: CancelReplenishmentJobsInputDTO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReplenishmentJobs.cancelBulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelReplenishmentJobsInputDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsCancelPost: async (jobId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReplenishmentJobs.cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (jobId !== undefined) {
                localVarQueryParameter['jobId'] = jobId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsCellContentGet: async (cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReplenishmentJobs.cellContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsClaimPost: async (jobId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReplenishmentJobs.claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (jobId !== undefined) {
                localVarQueryParameter['jobId'] = jobId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteReplenishmentJobInputDTO} [completeReplenishmentJobInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsCompletePost: async (completeReplenishmentJobInputDTO?: CompleteReplenishmentJobInputDTO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReplenishmentJobs.complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeReplenishmentJobInputDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateManualReplenishmentJobsInputDTO} [createManualReplenishmentJobsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsCreateManualPost: async (createManualReplenishmentJobsInputDTO?: CreateManualReplenishmentJobsInputDTO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReplenishmentJobs.createManual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManualReplenishmentJobsInputDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateReplenishmentJobsInputDTO} [createReplenishmentJobsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsCreatePost: async (createReplenishmentJobsInputDTO?: CreateReplenishmentJobsInputDTO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReplenishmentJobs.create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReplenishmentJobsInputDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsNeedsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReplenishmentJobs.needs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReplenishmentJobs.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsReleasePost: async (jobId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReplenishmentJobs.release`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (jobId !== undefined) {
                localVarQueryParameter['jobId'] = jobId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsSuggestedTargetsGet: async (jobId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReplenishmentJobs.suggestedTargets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (jobId !== undefined) {
                localVarQueryParameter['jobId'] = jobId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [jobId] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsTransferableAmountGet: async (jobId?: string, cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReplenishmentJobs.transferableAmount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (jobId !== undefined) {
                localVarQueryParameter['jobId'] = jobId;
            }

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ValidateManualReplenishmentJobsInputDTO} [validateManualReplenishmentJobsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsValidateManualPost: async (validateManualReplenishmentJobsInputDTO?: ValidateManualReplenishmentJobsInputDTO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ReplenishmentJobs.validateManual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateManualReplenishmentJobsInputDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReplenishmentJobsApi - functional programming interface
 * @export
 */
export const ReplenishmentJobsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReplenishmentJobsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReplenishmentJobsAlternateSourcesGet(jobId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlternateSourceCellOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReplenishmentJobsAlternateSourcesGet(jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReplenishmentJobType} [jobType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReplenishmentJobsAvailableGet(jobType?: ReplenishmentJobType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReplenishmentJobOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReplenishmentJobsAvailableGet(jobType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CancelReplenishmentJobsInputDTO} [cancelReplenishmentJobsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReplenishmentJobsCancelBulkPost(cancelReplenishmentJobsInputDTO?: CancelReplenishmentJobsInputDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelReplenishmentJobsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReplenishmentJobsCancelBulkPost(cancelReplenishmentJobsInputDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReplenishmentJobsCancelPost(jobId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReplenishmentJobsCancelPost(jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReplenishmentJobsCellContentGet(cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReplenishmentCellContentOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReplenishmentJobsCellContentGet(cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReplenishmentJobsClaimPost(jobId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReplenishmentJobOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReplenishmentJobsClaimPost(jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteReplenishmentJobInputDTO} [completeReplenishmentJobInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReplenishmentJobsCompletePost(completeReplenishmentJobInputDTO?: CompleteReplenishmentJobInputDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReplenishmentJobOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReplenishmentJobsCompletePost(completeReplenishmentJobInputDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateManualReplenishmentJobsInputDTO} [createManualReplenishmentJobsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReplenishmentJobsCreateManualPost(createManualReplenishmentJobsInputDTO?: CreateManualReplenishmentJobsInputDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateManualReplenishmentJobsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReplenishmentJobsCreateManualPost(createManualReplenishmentJobsInputDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateReplenishmentJobsInputDTO} [createReplenishmentJobsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReplenishmentJobsCreatePost(createReplenishmentJobsInputDTO?: CreateReplenishmentJobsInputDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateReplenishmentJobsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReplenishmentJobsCreatePost(createReplenishmentJobsInputDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReplenishmentJobsNeedsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReplenishmentNeedOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReplenishmentJobsNeedsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReplenishmentJobsQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReplenishmentJobManagementOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReplenishmentJobsQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReplenishmentJobsReleasePost(jobId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReplenishmentJobsReleasePost(jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReplenishmentJobsSuggestedTargetsGet(jobId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SuggestedTargetCellOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReplenishmentJobsSuggestedTargetsGet(jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [jobId] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReplenishmentJobsTransferableAmountGet(jobId?: string, cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReplenishmentTransferableAmountOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReplenishmentJobsTransferableAmountGet(jobId, cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ValidateManualReplenishmentJobsInputDTO} [validateManualReplenishmentJobsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReplenishmentJobsValidateManualPost(validateManualReplenishmentJobsInputDTO?: ValidateManualReplenishmentJobsInputDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManualReplenishmentValidationOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReplenishmentJobsValidateManualPost(validateManualReplenishmentJobsInputDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReplenishmentJobsApi - factory interface
 * @export
 */
export const ReplenishmentJobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReplenishmentJobsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsAlternateSourcesGet(jobId?: string, options?: any): AxiosPromise<Array<AlternateSourceCellOutputDTO>> {
            return localVarFp.apiV1ReplenishmentJobsAlternateSourcesGet(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReplenishmentJobType} [jobType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsAvailableGet(jobType?: ReplenishmentJobType, options?: any): AxiosPromise<Array<ReplenishmentJobOutputDTO>> {
            return localVarFp.apiV1ReplenishmentJobsAvailableGet(jobType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CancelReplenishmentJobsInputDTO} [cancelReplenishmentJobsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsCancelBulkPost(cancelReplenishmentJobsInputDTO?: CancelReplenishmentJobsInputDTO, options?: any): AxiosPromise<CancelReplenishmentJobsOutputDTO> {
            return localVarFp.apiV1ReplenishmentJobsCancelBulkPost(cancelReplenishmentJobsInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsCancelPost(jobId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ReplenishmentJobsCancelPost(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsCellContentGet(cellLabel?: string, options?: any): AxiosPromise<ReplenishmentCellContentOutputDTO> {
            return localVarFp.apiV1ReplenishmentJobsCellContentGet(cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsClaimPost(jobId?: string, options?: any): AxiosPromise<ReplenishmentJobOutputDTO> {
            return localVarFp.apiV1ReplenishmentJobsClaimPost(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteReplenishmentJobInputDTO} [completeReplenishmentJobInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsCompletePost(completeReplenishmentJobInputDTO?: CompleteReplenishmentJobInputDTO, options?: any): AxiosPromise<ReplenishmentJobOutputDTO> {
            return localVarFp.apiV1ReplenishmentJobsCompletePost(completeReplenishmentJobInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateManualReplenishmentJobsInputDTO} [createManualReplenishmentJobsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsCreateManualPost(createManualReplenishmentJobsInputDTO?: CreateManualReplenishmentJobsInputDTO, options?: any): AxiosPromise<CreateManualReplenishmentJobsOutputDTO> {
            return localVarFp.apiV1ReplenishmentJobsCreateManualPost(createManualReplenishmentJobsInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateReplenishmentJobsInputDTO} [createReplenishmentJobsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsCreatePost(createReplenishmentJobsInputDTO?: CreateReplenishmentJobsInputDTO, options?: any): AxiosPromise<CreateReplenishmentJobsOutputDTO> {
            return localVarFp.apiV1ReplenishmentJobsCreatePost(createReplenishmentJobsInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsNeedsGet(dqb?: string, options?: any): AxiosPromise<ReplenishmentNeedOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ReplenishmentJobsNeedsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsQueryGet(dqb?: string, options?: any): AxiosPromise<ReplenishmentJobManagementOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ReplenishmentJobsQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsReleasePost(jobId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ReplenishmentJobsReleasePost(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsSuggestedTargetsGet(jobId?: string, options?: any): AxiosPromise<Array<SuggestedTargetCellOutputDTO>> {
            return localVarFp.apiV1ReplenishmentJobsSuggestedTargetsGet(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [jobId] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsTransferableAmountGet(jobId?: string, cellLabel?: string, options?: any): AxiosPromise<ReplenishmentTransferableAmountOutputDTO> {
            return localVarFp.apiV1ReplenishmentJobsTransferableAmountGet(jobId, cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ValidateManualReplenishmentJobsInputDTO} [validateManualReplenishmentJobsInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReplenishmentJobsValidateManualPost(validateManualReplenishmentJobsInputDTO?: ValidateManualReplenishmentJobsInputDTO, options?: any): AxiosPromise<ManualReplenishmentValidationOutputDTO> {
            return localVarFp.apiV1ReplenishmentJobsValidateManualPost(validateManualReplenishmentJobsInputDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReplenishmentJobsApi - object-oriented interface
 * @export
 * @class ReplenishmentJobsApi
 * @extends {BaseAPI}
 */
export class ReplenishmentJobsApi extends BaseAPI {
    /**
     * 
     * @param {string} [jobId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentJobsApi
     */
    public apiV1ReplenishmentJobsAlternateSourcesGet(jobId?: string, options?: any) {
        return ReplenishmentJobsApiFp(this.configuration).apiV1ReplenishmentJobsAlternateSourcesGet(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReplenishmentJobType} [jobType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentJobsApi
     */
    public apiV1ReplenishmentJobsAvailableGet(jobType?: ReplenishmentJobType, options?: any) {
        return ReplenishmentJobsApiFp(this.configuration).apiV1ReplenishmentJobsAvailableGet(jobType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CancelReplenishmentJobsInputDTO} [cancelReplenishmentJobsInputDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentJobsApi
     */
    public apiV1ReplenishmentJobsCancelBulkPost(cancelReplenishmentJobsInputDTO?: CancelReplenishmentJobsInputDTO, options?: any) {
        return ReplenishmentJobsApiFp(this.configuration).apiV1ReplenishmentJobsCancelBulkPost(cancelReplenishmentJobsInputDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [jobId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentJobsApi
     */
    public apiV1ReplenishmentJobsCancelPost(jobId?: string, options?: any) {
        return ReplenishmentJobsApiFp(this.configuration).apiV1ReplenishmentJobsCancelPost(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentJobsApi
     */
    public apiV1ReplenishmentJobsCellContentGet(cellLabel?: string, options?: any) {
        return ReplenishmentJobsApiFp(this.configuration).apiV1ReplenishmentJobsCellContentGet(cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [jobId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentJobsApi
     */
    public apiV1ReplenishmentJobsClaimPost(jobId?: string, options?: any) {
        return ReplenishmentJobsApiFp(this.configuration).apiV1ReplenishmentJobsClaimPost(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteReplenishmentJobInputDTO} [completeReplenishmentJobInputDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentJobsApi
     */
    public apiV1ReplenishmentJobsCompletePost(completeReplenishmentJobInputDTO?: CompleteReplenishmentJobInputDTO, options?: any) {
        return ReplenishmentJobsApiFp(this.configuration).apiV1ReplenishmentJobsCompletePost(completeReplenishmentJobInputDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateManualReplenishmentJobsInputDTO} [createManualReplenishmentJobsInputDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentJobsApi
     */
    public apiV1ReplenishmentJobsCreateManualPost(createManualReplenishmentJobsInputDTO?: CreateManualReplenishmentJobsInputDTO, options?: any) {
        return ReplenishmentJobsApiFp(this.configuration).apiV1ReplenishmentJobsCreateManualPost(createManualReplenishmentJobsInputDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateReplenishmentJobsInputDTO} [createReplenishmentJobsInputDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentJobsApi
     */
    public apiV1ReplenishmentJobsCreatePost(createReplenishmentJobsInputDTO?: CreateReplenishmentJobsInputDTO, options?: any) {
        return ReplenishmentJobsApiFp(this.configuration).apiV1ReplenishmentJobsCreatePost(createReplenishmentJobsInputDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentJobsApi
     */
    public apiV1ReplenishmentJobsNeedsGet(dqb?: string, options?: any) {
        return ReplenishmentJobsApiFp(this.configuration).apiV1ReplenishmentJobsNeedsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentJobsApi
     */
    public apiV1ReplenishmentJobsQueryGet(dqb?: string, options?: any) {
        return ReplenishmentJobsApiFp(this.configuration).apiV1ReplenishmentJobsQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [jobId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentJobsApi
     */
    public apiV1ReplenishmentJobsReleasePost(jobId?: string, options?: any) {
        return ReplenishmentJobsApiFp(this.configuration).apiV1ReplenishmentJobsReleasePost(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [jobId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentJobsApi
     */
    public apiV1ReplenishmentJobsSuggestedTargetsGet(jobId?: string, options?: any) {
        return ReplenishmentJobsApiFp(this.configuration).apiV1ReplenishmentJobsSuggestedTargetsGet(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [jobId] 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentJobsApi
     */
    public apiV1ReplenishmentJobsTransferableAmountGet(jobId?: string, cellLabel?: string, options?: any) {
        return ReplenishmentJobsApiFp(this.configuration).apiV1ReplenishmentJobsTransferableAmountGet(jobId, cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ValidateManualReplenishmentJobsInputDTO} [validateManualReplenishmentJobsInputDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReplenishmentJobsApi
     */
    public apiV1ReplenishmentJobsValidateManualPost(validateManualReplenishmentJobsInputDTO?: ValidateManualReplenishmentJobsInputDTO, options?: any) {
        return ReplenishmentJobsApiFp(this.configuration).apiV1ReplenishmentJobsValidateManualPost(validateManualReplenishmentJobsInputDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReportsApi - axios parameter creator
 * @export
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} reportName 
         * @param {string} referenceId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReportsExportToExcelGet: async (reportName: string, referenceId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportName' is not null or undefined
            assertParamExists('apiV1ReportsExportToExcelGet', 'reportName', reportName)
            // verify required parameter 'referenceId' is not null or undefined
            assertParamExists('apiV1ReportsExportToExcelGet', 'referenceId', referenceId)
            const localVarPath = `/api/v1/Reports.exportToExcel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (reportName !== undefined) {
                localVarQueryParameter['reportName'] = reportName;
            }

            if (referenceId !== undefined) {
                localVarQueryParameter['referenceId'] = referenceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} reportName 
         * @param {string} referenceId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReportsExportToExcelGet(reportName: string, referenceId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReportsExportToExcelGet(reportName, referenceId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} reportName 
         * @param {string} referenceId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReportsExportToExcelGet(reportName: string, referenceId: string, dqb?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ReportsExportToExcelGet(reportName, referenceId, dqb, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI {
    /**
     * 
     * @param {string} reportName 
     * @param {string} referenceId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public apiV1ReportsExportToExcelGet(reportName: string, referenceId: string, dqb?: string, options?: any) {
        return ReportsApiFp(this.configuration).apiV1ReportsExportToExcelGet(reportName, referenceId, dqb, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RetoolApi - axios parameter creator
 * @export
 */
export const RetoolApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UpdateSalesOrderDeliveryTypeToManualCommand} [updateSalesOrderDeliveryTypeToManualCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RetoolUpdateSalesOrderDeliveryTypeToManualPost: async (updateSalesOrderDeliveryTypeToManualCommand?: UpdateSalesOrderDeliveryTypeToManualCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Retool.updateSalesOrderDeliveryTypeToManual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSalesOrderDeliveryTypeToManualCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RetoolApi - functional programming interface
 * @export
 */
export const RetoolApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RetoolApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {UpdateSalesOrderDeliveryTypeToManualCommand} [updateSalesOrderDeliveryTypeToManualCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1RetoolUpdateSalesOrderDeliveryTypeToManualPost(updateSalesOrderDeliveryTypeToManualCommand?: UpdateSalesOrderDeliveryTypeToManualCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RetoolUpdateSalesOrderDeliveryTypeToManualPost(updateSalesOrderDeliveryTypeToManualCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RetoolApi - factory interface
 * @export
 */
export const RetoolApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RetoolApiFp(configuration)
    return {
        /**
         * 
         * @param {UpdateSalesOrderDeliveryTypeToManualCommand} [updateSalesOrderDeliveryTypeToManualCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RetoolUpdateSalesOrderDeliveryTypeToManualPost(updateSalesOrderDeliveryTypeToManualCommand?: UpdateSalesOrderDeliveryTypeToManualCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1RetoolUpdateSalesOrderDeliveryTypeToManualPost(updateSalesOrderDeliveryTypeToManualCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RetoolApi - object-oriented interface
 * @export
 * @class RetoolApi
 * @extends {BaseAPI}
 */
export class RetoolApi extends BaseAPI {
    /**
     * 
     * @param {UpdateSalesOrderDeliveryTypeToManualCommand} [updateSalesOrderDeliveryTypeToManualCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetoolApi
     */
    public apiV1RetoolUpdateSalesOrderDeliveryTypeToManualPost(updateSalesOrderDeliveryTypeToManualCommand?: UpdateSalesOrderDeliveryTypeToManualCommand, options?: any) {
        return RetoolApiFp(this.configuration).apiV1RetoolUpdateSalesOrderDeliveryTypeToManualPost(updateSalesOrderDeliveryTypeToManualCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReturnApi - axios parameter creator
 * @export
 */
export const ReturnApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {string} [productId] 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnCheckReturnItemSerialNumberGet: async (salesOrderId?: string, productId?: string, serialNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.checkReturnItemSerialNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['SalesOrderId'] = salesOrderId;
            }

            if (productId !== undefined) {
                localVarQueryParameter['ProductId'] = productId;
            }

            if (serialNumber !== undefined) {
                localVarQueryParameter['SerialNumber'] = serialNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteReturnProcessCommand} [completeReturnProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnCompleteReturnProcessPost: async (completeReturnProcessCommand?: CompleteReturnProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.completeReturnProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeReturnProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteReturnReceivingCommand} [completeReturnReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnCompleteReturnReceivingPost: async (completeReturnReceivingCommand?: CompleteReturnReceivingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.completeReturnReceiving`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeReturnReceivingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateReturnProcessIfNotExistCommand} [createReturnProcessIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnCreateReturnProcessIfNotExistPost: async (createReturnProcessIfNotExistCommand?: CreateReturnProcessIfNotExistCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.createReturnProcessIfNotExist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReturnProcessIfNotExistCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateReturnReceivingProcessIfNotExistCommand} [createReturnReceivingProcessIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnCreateReturnReceivingProcessIfNotExistPost: async (createReturnReceivingProcessIfNotExistCommand?: CreateReturnReceivingProcessIfNotExistCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.createReturnReceivingProcessIfNotExist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReturnReceivingProcessIfNotExistCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUndefinedReturnPackageCommand} [createUndefinedReturnPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnCreateUndefinedReturnPackagePost: async (createUndefinedReturnPackageCommand?: CreateUndefinedReturnPackageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.createUndefinedReturnPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUndefinedReturnPackageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnGetCargoCarriersGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.getCargoCarriers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [returnPackageId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnGetImagesGet: async (returnPackageId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.getImages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (returnPackageId !== undefined) {
                localVarQueryParameter['returnPackageId'] = returnPackageId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnGetSalesOrderDetailsGet: async (salesOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.getSalesOrderDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcodes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnListOperationsByProductBarcodesGet: async (barcodes?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.listOperationsByProductBarcodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcodes !== undefined) {
                localVarQueryParameter['barcodes'] = barcodes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceReturnPackageToTrolleyCommand} [placeReturnPackageToTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnPlaceReturnPackageToTrolleyPost: async (placeReturnPackageToTrolleyCommand?: PlaceReturnPackageToTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.placeReturnPackageToTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeReturnPackageToTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintReceivedReturnPackagesCommand} [printReceivedReturnPackagesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnPrintReceivedReturnPackagesPost: async (printReceivedReturnPackagesCommand?: PrintReceivedReturnPackagesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.printReceivedReturnPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printReceivedReturnPackagesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnQueryArrivedReturnPackagesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.queryArrivedReturnPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnQueryInProcessReturnPackagesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.queryInProcessReturnPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} returnPackageId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnQueryLineItemsGet: async (returnPackageId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'returnPackageId' is not null or undefined
            assertParamExists('apiV1ReturnQueryLineItemsGet', 'returnPackageId', returnPackageId)
            const localVarPath = `/api/v1/Return.queryLineItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (returnPackageId !== undefined) {
                localVarQueryParameter['returnPackageId'] = returnPackageId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnQueryResolvedReturnPackagesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.queryResolvedReturnPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnQueryReturnLineItemsGet: async (salesOrderId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'salesOrderId' is not null or undefined
            assertParamExists('apiV1ReturnQueryReturnLineItemsGet', 'salesOrderId', salesOrderId)
            const localVarPath = `/api/v1/Return.queryReturnLineItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnQueryReturnPackagesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.queryReturnPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnQueryUndefinedReturnPackagesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.queryUndefinedReturnPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [returnId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnReturnPackageDetailsGet: async (returnId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.returnPackageDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (returnId !== undefined) {
                localVarQueryParameter['returnId'] = returnId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnSearchReturnByReferenceGet: async (referenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.searchReturnByReference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnSearchSalesOrdersGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.searchSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SelectSalesOrderForReturnCommand} [selectSalesOrderForReturnCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnSelectSalesOrderForReturnPost: async (selectSalesOrderForReturnCommand?: SelectSalesOrderForReturnCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.selectSalesOrderForReturn`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectSalesOrderForReturnCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SelectToteForReturnProcessCommand} [selectToteForReturnProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnSelectToteForReturnProcessPost: async (selectToteForReturnProcessCommand?: SelectToteForReturnProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.selectToteForReturnProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectToteForReturnProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [returnId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnStateDetailsGet: async (returnId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.stateDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (returnId !== undefined) {
                localVarQueryParameter['returnId'] = returnId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateTrackingInfoCommand} [updateTrackingInfoCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnUpdateTrackingInfoPost: async (updateTrackingInfoCommand?: UpdateTrackingInfoCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.updateTrackingInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTrackingInfoCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [returnPackageId] 
         * @param {string} [returnLineItemId] 
         * @param {any} [file] 
         * @param {string} [description] 
         * @param {ReturnImageCategory} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnUploadImagePost: async (returnPackageId?: string, returnLineItemId?: string, file?: any, description?: string, category?: ReturnImageCategory, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.uploadImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


            if (returnPackageId !== undefined) { 
                localVarFormParams.append('ReturnPackageId', new Blob([JSON.stringify(returnPackageId)], { type: "application/json", }));
            }
    
            if (returnLineItemId !== undefined) { 
                localVarFormParams.append('ReturnLineItemId', new Blob([JSON.stringify(returnLineItemId)], { type: "application/json", }));
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('Description', description as any);
            }
    
            if (category !== undefined) { 
                localVarFormParams.append('Category', new Blob([JSON.stringify(category)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnValidateBarcodeForReturnGet: async (referenceNumber?: string, barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Return.validateBarcodeForReturn`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkSyncReturnsFromIntegrationCommand} [bulkSyncReturnsFromIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1ReturnBulkCreatePost: async (bulkSyncReturnsFromIntegrationCommand?: BulkSyncReturnsFromIntegrationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/Return/bulkCreate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSyncReturnsFromIntegrationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkSyncOperationReturnRequestsCommand} [bulkSyncOperationReturnRequestsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ReturnBulkSyncOperationReturnsPost: async (bulkSyncOperationReturnRequestsCommand?: BulkSyncOperationReturnRequestsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Return/bulkSyncOperationReturns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSyncOperationReturnRequestsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteReturnPackageCommand} [deleteReturnPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ReturnDeleteReturnPackagePost: async (deleteReturnPackageCommand?: DeleteReturnPackageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Return/deleteReturnPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteReturnPackageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkSycnCompleteReturnCommand} [bulkSycnCompleteReturnCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ReturnSycnCompleteReturnPost: async (bulkSycnCompleteReturnCommand?: BulkSycnCompleteReturnCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Return/sycnCompleteReturn`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSycnCompleteReturnCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateReturnLineItemsStateCommand} [updateReturnLineItemsStateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ReturnUpdateReturnLineItemsStatePost: async (updateReturnLineItemsStateCommand?: UpdateReturnLineItemsStateCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Return/updateReturnLineItemsState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReturnLineItemsStateCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReturnApi - functional programming interface
 * @export
 */
export const ReturnApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReturnApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {string} [productId] 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnCheckReturnItemSerialNumberGet(salesOrderId?: string, productId?: string, serialNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckReturnItemSerialNumberCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnCheckReturnItemSerialNumberGet(salesOrderId, productId, serialNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteReturnProcessCommand} [completeReturnProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnCompleteReturnProcessPost(completeReturnProcessCommand?: CompleteReturnProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnCompleteReturnProcessPost(completeReturnProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteReturnReceivingCommand} [completeReturnReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnCompleteReturnReceivingPost(completeReturnReceivingCommand?: CompleteReturnReceivingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteReturnReceivingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnCompleteReturnReceivingPost(completeReturnReceivingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateReturnProcessIfNotExistCommand} [createReturnProcessIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnCreateReturnProcessIfNotExistPost(createReturnProcessIfNotExistCommand?: CreateReturnProcessIfNotExistCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateReturnProcessIfNotExistOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnCreateReturnProcessIfNotExistPost(createReturnProcessIfNotExistCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateReturnReceivingProcessIfNotExistCommand} [createReturnReceivingProcessIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnCreateReturnReceivingProcessIfNotExistPost(createReturnReceivingProcessIfNotExistCommand?: CreateReturnReceivingProcessIfNotExistCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnReceivingProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnCreateReturnReceivingProcessIfNotExistPost(createReturnReceivingProcessIfNotExistCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateUndefinedReturnPackageCommand} [createUndefinedReturnPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnCreateUndefinedReturnPackagePost(createUndefinedReturnPackageCommand?: CreateUndefinedReturnPackageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnCreateUndefinedReturnPackagePost(createUndefinedReturnPackageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnGetCargoCarriersGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCargoCarriersQueryOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnGetCargoCarriersGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [returnPackageId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnGetImagesGet(returnPackageId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReturnImageOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnGetImagesGet(returnPackageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnGetSalesOrderDetailsGet(salesOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSalesOrderDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnGetSalesOrderDetailsGet(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcodes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnListOperationsByProductBarcodesGet(barcodes?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductDetailsWithOperationOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnListOperationsByProductBarcodesGet(barcodes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceReturnPackageToTrolleyCommand} [placeReturnPackageToTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnPlaceReturnPackageToTrolleyPost(placeReturnPackageToTrolleyCommand?: PlaceReturnPackageToTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceReturnPackageToTrolleyOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnPlaceReturnPackageToTrolleyPost(placeReturnPackageToTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintReceivedReturnPackagesCommand} [printReceivedReturnPackagesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnPrintReceivedReturnPackagesPost(printReceivedReturnPackagesCommand?: PrintReceivedReturnPackagesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnPrintReceivedReturnPackagesPost(printReceivedReturnPackagesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnQueryArrivedReturnPackagesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrivedReturnPackageQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnQueryArrivedReturnPackagesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnQueryInProcessReturnPackagesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InProcessReturnPackageQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnQueryInProcessReturnPackagesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} returnPackageId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnQueryLineItemsGet(returnPackageId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnPackageLineItemQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnQueryLineItemsGet(returnPackageId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnQueryResolvedReturnPackagesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResolvedReturnPackageQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnQueryResolvedReturnPackagesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnQueryReturnLineItemsGet(salesOrderId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnLineItemOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnQueryReturnLineItemsGet(salesOrderId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnQueryReturnPackagesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnPackageQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnQueryReturnPackagesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnQueryUndefinedReturnPackagesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UndefinedReturnPackageQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnQueryUndefinedReturnPackagesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [returnId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnReturnPackageDetailsGet(returnId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnPackageDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnReturnPackageDetailsGet(returnId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnSearchReturnByReferenceGet(referenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnPackageDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnSearchReturnByReferenceGet(referenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnSearchSalesOrdersGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrdersSearchOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnSearchSalesOrdersGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SelectSalesOrderForReturnCommand} [selectSalesOrderForReturnCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnSelectSalesOrderForReturnPost(selectSalesOrderForReturnCommand?: SelectSalesOrderForReturnCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectSalesOrderForReturnOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnSelectSalesOrderForReturnPost(selectSalesOrderForReturnCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SelectToteForReturnProcessCommand} [selectToteForReturnProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnSelectToteForReturnProcessPost(selectToteForReturnProcessCommand?: SelectToteForReturnProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectToteForReturnProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnSelectToteForReturnProcessPost(selectToteForReturnProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [returnId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnStateDetailsGet(returnId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnPackageStateDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnStateDetailsGet(returnId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateTrackingInfoCommand} [updateTrackingInfoCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnUpdateTrackingInfoPost(updateTrackingInfoCommand?: UpdateTrackingInfoCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTrackingInfoCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnUpdateTrackingInfoPost(updateTrackingInfoCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [returnPackageId] 
         * @param {string} [returnLineItemId] 
         * @param {any} [file] 
         * @param {string} [description] 
         * @param {ReturnImageCategory} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnUploadImagePost(returnPackageId?: string, returnLineItemId?: string, file?: any, description?: string, category?: ReturnImageCategory, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnImageOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnUploadImagePost(returnPackageId, returnLineItemId, file, description, category, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ReturnValidateBarcodeForReturnGet(referenceNumber?: string, barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateBarcodeForReturnOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ReturnValidateBarcodeForReturnGet(referenceNumber, barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkSyncReturnsFromIntegrationCommand} [bulkSyncReturnsFromIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1ReturnBulkCreatePost(bulkSyncReturnsFromIntegrationCommand?: BulkSyncReturnsFromIntegrationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkSyncReturnsFromIntegrationCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1ReturnBulkCreatePost(bulkSyncReturnsFromIntegrationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkSyncOperationReturnRequestsCommand} [bulkSyncOperationReturnRequestsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ReturnBulkSyncOperationReturnsPost(bulkSyncOperationReturnRequestsCommand?: BulkSyncOperationReturnRequestsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkSyncResultsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ReturnBulkSyncOperationReturnsPost(bulkSyncOperationReturnRequestsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteReturnPackageCommand} [deleteReturnPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ReturnDeleteReturnPackagePost(deleteReturnPackageCommand?: DeleteReturnPackageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ReturnDeleteReturnPackagePost(deleteReturnPackageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkSycnCompleteReturnCommand} [bulkSycnCompleteReturnCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ReturnSycnCompleteReturnPost(bulkSycnCompleteReturnCommand?: BulkSycnCompleteReturnCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ReturnSycnCompleteReturnPost(bulkSycnCompleteReturnCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateReturnLineItemsStateCommand} [updateReturnLineItemsStateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ReturnUpdateReturnLineItemsStatePost(updateReturnLineItemsStateCommand?: UpdateReturnLineItemsStateCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateReturnLineItemsStateOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ReturnUpdateReturnLineItemsStatePost(updateReturnLineItemsStateCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReturnApi - factory interface
 * @export
 */
export const ReturnApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReturnApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {string} [productId] 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnCheckReturnItemSerialNumberGet(salesOrderId?: string, productId?: string, serialNumber?: string, options?: any): AxiosPromise<CheckReturnItemSerialNumberCommandOutputDTO> {
            return localVarFp.apiV1ReturnCheckReturnItemSerialNumberGet(salesOrderId, productId, serialNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteReturnProcessCommand} [completeReturnProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnCompleteReturnProcessPost(completeReturnProcessCommand?: CompleteReturnProcessCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ReturnCompleteReturnProcessPost(completeReturnProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteReturnReceivingCommand} [completeReturnReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnCompleteReturnReceivingPost(completeReturnReceivingCommand?: CompleteReturnReceivingCommand, options?: any): AxiosPromise<CompleteReturnReceivingOutputDTO> {
            return localVarFp.apiV1ReturnCompleteReturnReceivingPost(completeReturnReceivingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateReturnProcessIfNotExistCommand} [createReturnProcessIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnCreateReturnProcessIfNotExistPost(createReturnProcessIfNotExistCommand?: CreateReturnProcessIfNotExistCommand, options?: any): AxiosPromise<CreateReturnProcessIfNotExistOutputDTO> {
            return localVarFp.apiV1ReturnCreateReturnProcessIfNotExistPost(createReturnProcessIfNotExistCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateReturnReceivingProcessIfNotExistCommand} [createReturnReceivingProcessIfNotExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnCreateReturnReceivingProcessIfNotExistPost(createReturnReceivingProcessIfNotExistCommand?: CreateReturnReceivingProcessIfNotExistCommand, options?: any): AxiosPromise<ReturnReceivingProcessOutputDTO> {
            return localVarFp.apiV1ReturnCreateReturnReceivingProcessIfNotExistPost(createReturnReceivingProcessIfNotExistCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateUndefinedReturnPackageCommand} [createUndefinedReturnPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnCreateUndefinedReturnPackagePost(createUndefinedReturnPackageCommand?: CreateUndefinedReturnPackageCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ReturnCreateUndefinedReturnPackagePost(createUndefinedReturnPackageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnGetCargoCarriersGet(options?: any): AxiosPromise<Array<GetCargoCarriersQueryOutputDTO>> {
            return localVarFp.apiV1ReturnGetCargoCarriersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [returnPackageId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnGetImagesGet(returnPackageId?: string, options?: any): AxiosPromise<Array<ReturnImageOutputDTO>> {
            return localVarFp.apiV1ReturnGetImagesGet(returnPackageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnGetSalesOrderDetailsGet(salesOrderId?: string, options?: any): AxiosPromise<GetSalesOrderDetailsOutputDTO> {
            return localVarFp.apiV1ReturnGetSalesOrderDetailsGet(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcodes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnListOperationsByProductBarcodesGet(barcodes?: string, options?: any): AxiosPromise<Array<ProductDetailsWithOperationOutputDTO>> {
            return localVarFp.apiV1ReturnListOperationsByProductBarcodesGet(barcodes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceReturnPackageToTrolleyCommand} [placeReturnPackageToTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnPlaceReturnPackageToTrolleyPost(placeReturnPackageToTrolleyCommand?: PlaceReturnPackageToTrolleyCommand, options?: any): AxiosPromise<PlaceReturnPackageToTrolleyOutputDTO> {
            return localVarFp.apiV1ReturnPlaceReturnPackageToTrolleyPost(placeReturnPackageToTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintReceivedReturnPackagesCommand} [printReceivedReturnPackagesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnPrintReceivedReturnPackagesPost(printReceivedReturnPackagesCommand?: PrintReceivedReturnPackagesCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ReturnPrintReceivedReturnPackagesPost(printReceivedReturnPackagesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnQueryArrivedReturnPackagesGet(dqb?: string, options?: any): AxiosPromise<ArrivedReturnPackageQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ReturnQueryArrivedReturnPackagesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnQueryInProcessReturnPackagesGet(dqb?: string, options?: any): AxiosPromise<InProcessReturnPackageQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ReturnQueryInProcessReturnPackagesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} returnPackageId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnQueryLineItemsGet(returnPackageId: string, dqb?: string, options?: any): AxiosPromise<ReturnPackageLineItemQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ReturnQueryLineItemsGet(returnPackageId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnQueryResolvedReturnPackagesGet(dqb?: string, options?: any): AxiosPromise<ResolvedReturnPackageQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ReturnQueryResolvedReturnPackagesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnQueryReturnLineItemsGet(salesOrderId: string, dqb?: string, options?: any): AxiosPromise<ReturnLineItemOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ReturnQueryReturnLineItemsGet(salesOrderId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnQueryReturnPackagesGet(dqb?: string, options?: any): AxiosPromise<ReturnPackageQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ReturnQueryReturnPackagesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnQueryUndefinedReturnPackagesGet(dqb?: string, options?: any): AxiosPromise<UndefinedReturnPackageQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ReturnQueryUndefinedReturnPackagesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [returnId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnReturnPackageDetailsGet(returnId?: string, options?: any): AxiosPromise<ReturnPackageDetailsOutputDTO> {
            return localVarFp.apiV1ReturnReturnPackageDetailsGet(returnId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnSearchReturnByReferenceGet(referenceNumber?: string, options?: any): AxiosPromise<ReturnPackageDetailsOutputDTO> {
            return localVarFp.apiV1ReturnSearchReturnByReferenceGet(referenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnSearchSalesOrdersGet(dqb?: string, options?: any): AxiosPromise<SalesOrdersSearchOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ReturnSearchSalesOrdersGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SelectSalesOrderForReturnCommand} [selectSalesOrderForReturnCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnSelectSalesOrderForReturnPost(selectSalesOrderForReturnCommand?: SelectSalesOrderForReturnCommand, options?: any): AxiosPromise<SelectSalesOrderForReturnOutputDTO> {
            return localVarFp.apiV1ReturnSelectSalesOrderForReturnPost(selectSalesOrderForReturnCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SelectToteForReturnProcessCommand} [selectToteForReturnProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnSelectToteForReturnProcessPost(selectToteForReturnProcessCommand?: SelectToteForReturnProcessCommand, options?: any): AxiosPromise<SelectToteForReturnProcessOutputDTO> {
            return localVarFp.apiV1ReturnSelectToteForReturnProcessPost(selectToteForReturnProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [returnId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnStateDetailsGet(returnId?: string, options?: any): AxiosPromise<ReturnPackageStateDetailsOutputDTO> {
            return localVarFp.apiV1ReturnStateDetailsGet(returnId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateTrackingInfoCommand} [updateTrackingInfoCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnUpdateTrackingInfoPost(updateTrackingInfoCommand?: UpdateTrackingInfoCommand, options?: any): AxiosPromise<UpdateTrackingInfoCommandOutputDTO> {
            return localVarFp.apiV1ReturnUpdateTrackingInfoPost(updateTrackingInfoCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [returnPackageId] 
         * @param {string} [returnLineItemId] 
         * @param {any} [file] 
         * @param {string} [description] 
         * @param {ReturnImageCategory} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnUploadImagePost(returnPackageId?: string, returnLineItemId?: string, file?: any, description?: string, category?: ReturnImageCategory, options?: any): AxiosPromise<ReturnImageOutputDTO> {
            return localVarFp.apiV1ReturnUploadImagePost(returnPackageId, returnLineItemId, file, description, category, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ReturnValidateBarcodeForReturnGet(referenceNumber?: string, barcode?: string, options?: any): AxiosPromise<ValidateBarcodeForReturnOutputDTO> {
            return localVarFp.apiV1ReturnValidateBarcodeForReturnGet(referenceNumber, barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkSyncReturnsFromIntegrationCommand} [bulkSyncReturnsFromIntegrationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1ReturnBulkCreatePost(bulkSyncReturnsFromIntegrationCommand?: BulkSyncReturnsFromIntegrationCommand, options?: any): AxiosPromise<BulkSyncReturnsFromIntegrationCommandOutputDTO> {
            return localVarFp.openapiV1ReturnBulkCreatePost(bulkSyncReturnsFromIntegrationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkSyncOperationReturnRequestsCommand} [bulkSyncOperationReturnRequestsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ReturnBulkSyncOperationReturnsPost(bulkSyncOperationReturnRequestsCommand?: BulkSyncOperationReturnRequestsCommand, options?: any): AxiosPromise<BulkSyncResultsOutputDTO> {
            return localVarFp.supportV1ReturnBulkSyncOperationReturnsPost(bulkSyncOperationReturnRequestsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteReturnPackageCommand} [deleteReturnPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ReturnDeleteReturnPackagePost(deleteReturnPackageCommand?: DeleteReturnPackageCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1ReturnDeleteReturnPackagePost(deleteReturnPackageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkSycnCompleteReturnCommand} [bulkSycnCompleteReturnCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ReturnSycnCompleteReturnPost(bulkSycnCompleteReturnCommand?: BulkSycnCompleteReturnCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1ReturnSycnCompleteReturnPost(bulkSycnCompleteReturnCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateReturnLineItemsStateCommand} [updateReturnLineItemsStateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ReturnUpdateReturnLineItemsStatePost(updateReturnLineItemsStateCommand?: UpdateReturnLineItemsStateCommand, options?: any): AxiosPromise<UpdateReturnLineItemsStateOutputDTO> {
            return localVarFp.supportV1ReturnUpdateReturnLineItemsStatePost(updateReturnLineItemsStateCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReturnApi - object-oriented interface
 * @export
 * @class ReturnApi
 * @extends {BaseAPI}
 */
export class ReturnApi extends BaseAPI {
    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {string} [productId] 
     * @param {string} [serialNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnCheckReturnItemSerialNumberGet(salesOrderId?: string, productId?: string, serialNumber?: string, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnCheckReturnItemSerialNumberGet(salesOrderId, productId, serialNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteReturnProcessCommand} [completeReturnProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnCompleteReturnProcessPost(completeReturnProcessCommand?: CompleteReturnProcessCommand, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnCompleteReturnProcessPost(completeReturnProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteReturnReceivingCommand} [completeReturnReceivingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnCompleteReturnReceivingPost(completeReturnReceivingCommand?: CompleteReturnReceivingCommand, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnCompleteReturnReceivingPost(completeReturnReceivingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateReturnProcessIfNotExistCommand} [createReturnProcessIfNotExistCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnCreateReturnProcessIfNotExistPost(createReturnProcessIfNotExistCommand?: CreateReturnProcessIfNotExistCommand, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnCreateReturnProcessIfNotExistPost(createReturnProcessIfNotExistCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateReturnReceivingProcessIfNotExistCommand} [createReturnReceivingProcessIfNotExistCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnCreateReturnReceivingProcessIfNotExistPost(createReturnReceivingProcessIfNotExistCommand?: CreateReturnReceivingProcessIfNotExistCommand, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnCreateReturnReceivingProcessIfNotExistPost(createReturnReceivingProcessIfNotExistCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateUndefinedReturnPackageCommand} [createUndefinedReturnPackageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnCreateUndefinedReturnPackagePost(createUndefinedReturnPackageCommand?: CreateUndefinedReturnPackageCommand, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnCreateUndefinedReturnPackagePost(createUndefinedReturnPackageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnGetCargoCarriersGet(options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnGetCargoCarriersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [returnPackageId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnGetImagesGet(returnPackageId?: string, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnGetImagesGet(returnPackageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnGetSalesOrderDetailsGet(salesOrderId?: string, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnGetSalesOrderDetailsGet(salesOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcodes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnListOperationsByProductBarcodesGet(barcodes?: string, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnListOperationsByProductBarcodesGet(barcodes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceReturnPackageToTrolleyCommand} [placeReturnPackageToTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnPlaceReturnPackageToTrolleyPost(placeReturnPackageToTrolleyCommand?: PlaceReturnPackageToTrolleyCommand, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnPlaceReturnPackageToTrolleyPost(placeReturnPackageToTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintReceivedReturnPackagesCommand} [printReceivedReturnPackagesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnPrintReceivedReturnPackagesPost(printReceivedReturnPackagesCommand?: PrintReceivedReturnPackagesCommand, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnPrintReceivedReturnPackagesPost(printReceivedReturnPackagesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnQueryArrivedReturnPackagesGet(dqb?: string, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnQueryArrivedReturnPackagesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnQueryInProcessReturnPackagesGet(dqb?: string, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnQueryInProcessReturnPackagesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} returnPackageId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnQueryLineItemsGet(returnPackageId: string, dqb?: string, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnQueryLineItemsGet(returnPackageId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnQueryResolvedReturnPackagesGet(dqb?: string, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnQueryResolvedReturnPackagesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} salesOrderId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnQueryReturnLineItemsGet(salesOrderId: string, dqb?: string, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnQueryReturnLineItemsGet(salesOrderId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnQueryReturnPackagesGet(dqb?: string, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnQueryReturnPackagesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnQueryUndefinedReturnPackagesGet(dqb?: string, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnQueryUndefinedReturnPackagesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [returnId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnReturnPackageDetailsGet(returnId?: string, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnReturnPackageDetailsGet(returnId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [referenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnSearchReturnByReferenceGet(referenceNumber?: string, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnSearchReturnByReferenceGet(referenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnSearchSalesOrdersGet(dqb?: string, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnSearchSalesOrdersGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SelectSalesOrderForReturnCommand} [selectSalesOrderForReturnCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnSelectSalesOrderForReturnPost(selectSalesOrderForReturnCommand?: SelectSalesOrderForReturnCommand, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnSelectSalesOrderForReturnPost(selectSalesOrderForReturnCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SelectToteForReturnProcessCommand} [selectToteForReturnProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnSelectToteForReturnProcessPost(selectToteForReturnProcessCommand?: SelectToteForReturnProcessCommand, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnSelectToteForReturnProcessPost(selectToteForReturnProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [returnId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnStateDetailsGet(returnId?: string, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnStateDetailsGet(returnId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateTrackingInfoCommand} [updateTrackingInfoCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnUpdateTrackingInfoPost(updateTrackingInfoCommand?: UpdateTrackingInfoCommand, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnUpdateTrackingInfoPost(updateTrackingInfoCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [returnPackageId] 
     * @param {string} [returnLineItemId] 
     * @param {any} [file] 
     * @param {string} [description] 
     * @param {ReturnImageCategory} [category] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnUploadImagePost(returnPackageId?: string, returnLineItemId?: string, file?: any, description?: string, category?: ReturnImageCategory, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnUploadImagePost(returnPackageId, returnLineItemId, file, description, category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [referenceNumber] 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public apiV1ReturnValidateBarcodeForReturnGet(referenceNumber?: string, barcode?: string, options?: any) {
        return ReturnApiFp(this.configuration).apiV1ReturnValidateBarcodeForReturnGet(referenceNumber, barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkSyncReturnsFromIntegrationCommand} [bulkSyncReturnsFromIntegrationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public openapiV1ReturnBulkCreatePost(bulkSyncReturnsFromIntegrationCommand?: BulkSyncReturnsFromIntegrationCommand, options?: any) {
        return ReturnApiFp(this.configuration).openapiV1ReturnBulkCreatePost(bulkSyncReturnsFromIntegrationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkSyncOperationReturnRequestsCommand} [bulkSyncOperationReturnRequestsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public supportV1ReturnBulkSyncOperationReturnsPost(bulkSyncOperationReturnRequestsCommand?: BulkSyncOperationReturnRequestsCommand, options?: any) {
        return ReturnApiFp(this.configuration).supportV1ReturnBulkSyncOperationReturnsPost(bulkSyncOperationReturnRequestsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteReturnPackageCommand} [deleteReturnPackageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public supportV1ReturnDeleteReturnPackagePost(deleteReturnPackageCommand?: DeleteReturnPackageCommand, options?: any) {
        return ReturnApiFp(this.configuration).supportV1ReturnDeleteReturnPackagePost(deleteReturnPackageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkSycnCompleteReturnCommand} [bulkSycnCompleteReturnCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public supportV1ReturnSycnCompleteReturnPost(bulkSycnCompleteReturnCommand?: BulkSycnCompleteReturnCommand, options?: any) {
        return ReturnApiFp(this.configuration).supportV1ReturnSycnCompleteReturnPost(bulkSycnCompleteReturnCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateReturnLineItemsStateCommand} [updateReturnLineItemsStateCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnApi
     */
    public supportV1ReturnUpdateReturnLineItemsStatePost(updateReturnLineItemsStateCommand?: UpdateReturnLineItemsStateCommand, options?: any) {
        return ReturnApiFp(this.configuration).supportV1ReturnUpdateReturnLineItemsStatePost(updateReturnLineItemsStateCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReturnsODataApi - axios parameter creator
 * @export
 */
export const ReturnsODataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataV1ReturnsODataGet: async (authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('odataV1ReturnsODataGet', 'authorization', authorization)
            const localVarPath = `/odata/v1/ReturnsOData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReturnsODataApi - functional programming interface
 * @export
 */
export const ReturnsODataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReturnsODataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async odataV1ReturnsODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ODataResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.odataV1ReturnsODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReturnsODataApi - factory interface
 * @export
 */
export const ReturnsODataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReturnsODataApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataV1ReturnsODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any): AxiosPromise<ODataResponseModel> {
            return localVarFp.odataV1ReturnsODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReturnsODataApi - object-oriented interface
 * @export
 * @class ReturnsODataApi
 * @extends {BaseAPI}
 */
export class ReturnsODataApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization The authorization token
     * @param {string} [$select] Get selected properties
     * @param {string} [$filter] Filter the results using OData syntax.
     * @param {string} [$expand] Get the entities that depend on the model
     * @param {string} [$orderby] Order the results using OData syntax
     * @param {string} [$skip] Skip the specified number of entries
     * @param {string} [$top] Get the top x number of records
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsODataApi
     */
    public odataV1ReturnsODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any) {
        return ReturnsODataApiFp(this.configuration).odataV1ReturnsODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SLAMApi - axios parameter creator
 * @export
 */
export const SLAMApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SLAMGetReadyToShipCargoPackagesCountGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SLAM.getReadyToShipCargoPackagesCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SLAMGetWaitingForSLAMCargoPackagesCountGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SLAM.getWaitingForSLAMCargoPackagesCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintApprovedCargoPackageCarrierLabelCommand} [printApprovedCargoPackageCarrierLabelCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SLAMPrintApprovedCargoPackageCarrierLabelPost: async (printApprovedCargoPackageCarrierLabelCommand?: PrintApprovedCargoPackageCarrierLabelCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SLAM.printApprovedCargoPackageCarrierLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printApprovedCargoPackageCarrierLabelCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintCargoPackageCarrierLabelCommand} [printCargoPackageCarrierLabelCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SLAMPrintCargoPackageCarrierLabelPost: async (printCargoPackageCarrierLabelCommand?: PrintCargoPackageCarrierLabelCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SLAM.printCargoPackageCarrierLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printCargoPackageCarrierLabelCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SLAMQueryReadyToShipCargoPackagesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SLAM.queryReadyToShipCargoPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SLAMQueryWaitingForSLAMApprovedCargoPackagesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SLAM.queryWaitingForSLAMApprovedCargoPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SLAMQueryWaitingForSLAMCargoPackagesGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SLAM.queryWaitingForSLAMCargoPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SLAMApi - functional programming interface
 * @export
 */
export const SLAMApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SLAMApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SLAMGetReadyToShipCargoPackagesCountGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadyToShipCargoPackagesCountOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SLAMGetReadyToShipCargoPackagesCountGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SLAMGetWaitingForSLAMCargoPackagesCountGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaitingForSLAMCargoPackagesCountOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SLAMGetWaitingForSLAMCargoPackagesCountGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintApprovedCargoPackageCarrierLabelCommand} [printApprovedCargoPackageCarrierLabelCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SLAMPrintApprovedCargoPackageCarrierLabelPost(printApprovedCargoPackageCarrierLabelCommand?: PrintApprovedCargoPackageCarrierLabelCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PrintApprovedCargoPackageCarrierLabelOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SLAMPrintApprovedCargoPackageCarrierLabelPost(printApprovedCargoPackageCarrierLabelCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintCargoPackageCarrierLabelCommand} [printCargoPackageCarrierLabelCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SLAMPrintCargoPackageCarrierLabelPost(printCargoPackageCarrierLabelCommand?: PrintCargoPackageCarrierLabelCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PrintCargoPackageCarrierLabelOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SLAMPrintCargoPackageCarrierLabelPost(printCargoPackageCarrierLabelCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SLAMQueryReadyToShipCargoPackagesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadyToShipCargoPackagesOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SLAMQueryReadyToShipCargoPackagesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SLAMQueryWaitingForSLAMApprovedCargoPackagesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaitingForSLAMApprovedCargoPackageOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SLAMQueryWaitingForSLAMApprovedCargoPackagesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SLAMQueryWaitingForSLAMCargoPackagesGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaitingForSLAMCargoPackageOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SLAMQueryWaitingForSLAMCargoPackagesGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SLAMApi - factory interface
 * @export
 */
export const SLAMApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SLAMApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SLAMGetReadyToShipCargoPackagesCountGet(options?: any): AxiosPromise<ReadyToShipCargoPackagesCountOutputDTO> {
            return localVarFp.apiV1SLAMGetReadyToShipCargoPackagesCountGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SLAMGetWaitingForSLAMCargoPackagesCountGet(options?: any): AxiosPromise<WaitingForSLAMCargoPackagesCountOutputDTO> {
            return localVarFp.apiV1SLAMGetWaitingForSLAMCargoPackagesCountGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintApprovedCargoPackageCarrierLabelCommand} [printApprovedCargoPackageCarrierLabelCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SLAMPrintApprovedCargoPackageCarrierLabelPost(printApprovedCargoPackageCarrierLabelCommand?: PrintApprovedCargoPackageCarrierLabelCommand, options?: any): AxiosPromise<Array<PrintApprovedCargoPackageCarrierLabelOutputDTO>> {
            return localVarFp.apiV1SLAMPrintApprovedCargoPackageCarrierLabelPost(printApprovedCargoPackageCarrierLabelCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintCargoPackageCarrierLabelCommand} [printCargoPackageCarrierLabelCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SLAMPrintCargoPackageCarrierLabelPost(printCargoPackageCarrierLabelCommand?: PrintCargoPackageCarrierLabelCommand, options?: any): AxiosPromise<Array<PrintCargoPackageCarrierLabelOutputDTO>> {
            return localVarFp.apiV1SLAMPrintCargoPackageCarrierLabelPost(printCargoPackageCarrierLabelCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SLAMQueryReadyToShipCargoPackagesGet(dqb?: string, options?: any): AxiosPromise<ReadyToShipCargoPackagesOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SLAMQueryReadyToShipCargoPackagesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SLAMQueryWaitingForSLAMApprovedCargoPackagesGet(dqb?: string, options?: any): AxiosPromise<WaitingForSLAMApprovedCargoPackageOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SLAMQueryWaitingForSLAMApprovedCargoPackagesGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SLAMQueryWaitingForSLAMCargoPackagesGet(dqb?: string, options?: any): AxiosPromise<WaitingForSLAMCargoPackageOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SLAMQueryWaitingForSLAMCargoPackagesGet(dqb, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SLAMApi - object-oriented interface
 * @export
 * @class SLAMApi
 * @extends {BaseAPI}
 */
export class SLAMApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLAMApi
     */
    public apiV1SLAMGetReadyToShipCargoPackagesCountGet(options?: any) {
        return SLAMApiFp(this.configuration).apiV1SLAMGetReadyToShipCargoPackagesCountGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLAMApi
     */
    public apiV1SLAMGetWaitingForSLAMCargoPackagesCountGet(options?: any) {
        return SLAMApiFp(this.configuration).apiV1SLAMGetWaitingForSLAMCargoPackagesCountGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintApprovedCargoPackageCarrierLabelCommand} [printApprovedCargoPackageCarrierLabelCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLAMApi
     */
    public apiV1SLAMPrintApprovedCargoPackageCarrierLabelPost(printApprovedCargoPackageCarrierLabelCommand?: PrintApprovedCargoPackageCarrierLabelCommand, options?: any) {
        return SLAMApiFp(this.configuration).apiV1SLAMPrintApprovedCargoPackageCarrierLabelPost(printApprovedCargoPackageCarrierLabelCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintCargoPackageCarrierLabelCommand} [printCargoPackageCarrierLabelCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLAMApi
     */
    public apiV1SLAMPrintCargoPackageCarrierLabelPost(printCargoPackageCarrierLabelCommand?: PrintCargoPackageCarrierLabelCommand, options?: any) {
        return SLAMApiFp(this.configuration).apiV1SLAMPrintCargoPackageCarrierLabelPost(printCargoPackageCarrierLabelCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLAMApi
     */
    public apiV1SLAMQueryReadyToShipCargoPackagesGet(dqb?: string, options?: any) {
        return SLAMApiFp(this.configuration).apiV1SLAMQueryReadyToShipCargoPackagesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLAMApi
     */
    public apiV1SLAMQueryWaitingForSLAMApprovedCargoPackagesGet(dqb?: string, options?: any) {
        return SLAMApiFp(this.configuration).apiV1SLAMQueryWaitingForSLAMApprovedCargoPackagesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLAMApi
     */
    public apiV1SLAMQueryWaitingForSLAMCargoPackagesGet(dqb?: string, options?: any) {
        return SLAMApiFp(this.configuration).apiV1SLAMQueryWaitingForSLAMCargoPackagesGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SalesOrderLoadSeedApi - axios parameter creator
 * @export
 */
export const SalesOrderLoadSeedApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apikey] 
         * @param {CreatePackingCompletedSalesOrdersLoadSeedPayload} [createPackingCompletedSalesOrdersLoadSeedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadseedV1SalesOrderLoadSeedCreatePackingCompletedSalesOrdersPost: async (apikey?: string, createPackingCompletedSalesOrdersLoadSeedPayload?: CreatePackingCompletedSalesOrdersLoadSeedPayload, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/loadseed/v1/SalesOrderLoadSeed/CreatePackingCompletedSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPackingCompletedSalesOrdersLoadSeedPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {CreatePickingCompletedSalesOrdersLoadSeedPayload} [createPickingCompletedSalesOrdersLoadSeedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadseedV1SalesOrderLoadSeedCreatePickingCompletedSalesOrdersPost: async (apikey?: string, createPickingCompletedSalesOrdersLoadSeedPayload?: CreatePickingCompletedSalesOrdersLoadSeedPayload, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/loadseed/v1/SalesOrderLoadSeed/CreatePickingCompletedSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPickingCompletedSalesOrdersLoadSeedPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {CreatePickingStartedSalesOrderLoadSeedPayload} [createPickingStartedSalesOrderLoadSeedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadseedV1SalesOrderLoadSeedCreatePickingStartedSalesOrdersPost: async (apikey?: string, createPickingStartedSalesOrderLoadSeedPayload?: CreatePickingStartedSalesOrderLoadSeedPayload, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/loadseed/v1/SalesOrderLoadSeed/CreatePickingStartedSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPickingStartedSalesOrderLoadSeedPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {CreateSLAMCompletedSalesOrdersLoadSeedPayload} [createSLAMCompletedSalesOrdersLoadSeedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadseedV1SalesOrderLoadSeedCreateSLAMCompletedSalesOrdersPost: async (apikey?: string, createSLAMCompletedSalesOrdersLoadSeedPayload?: CreateSLAMCompletedSalesOrdersLoadSeedPayload, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/loadseed/v1/SalesOrderLoadSeed/CreateSLAMCompletedSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (apikey !== undefined && apikey !== null) {
                localVarHeaderParameter['apikey'] = String(apikey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSLAMCompletedSalesOrdersLoadSeedPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesOrderLoadSeedApi - functional programming interface
 * @export
 */
export const SalesOrderLoadSeedApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesOrderLoadSeedApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apikey] 
         * @param {CreatePackingCompletedSalesOrdersLoadSeedPayload} [createPackingCompletedSalesOrdersLoadSeedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadseedV1SalesOrderLoadSeedCreatePackingCompletedSalesOrdersPost(apikey?: string, createPackingCompletedSalesOrdersLoadSeedPayload?: CreatePackingCompletedSalesOrdersLoadSeedPayload, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadseedV1SalesOrderLoadSeedCreatePackingCompletedSalesOrdersPost(apikey, createPackingCompletedSalesOrdersLoadSeedPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {CreatePickingCompletedSalesOrdersLoadSeedPayload} [createPickingCompletedSalesOrdersLoadSeedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadseedV1SalesOrderLoadSeedCreatePickingCompletedSalesOrdersPost(apikey?: string, createPickingCompletedSalesOrdersLoadSeedPayload?: CreatePickingCompletedSalesOrdersLoadSeedPayload, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadseedV1SalesOrderLoadSeedCreatePickingCompletedSalesOrdersPost(apikey, createPickingCompletedSalesOrdersLoadSeedPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {CreatePickingStartedSalesOrderLoadSeedPayload} [createPickingStartedSalesOrderLoadSeedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadseedV1SalesOrderLoadSeedCreatePickingStartedSalesOrdersPost(apikey?: string, createPickingStartedSalesOrderLoadSeedPayload?: CreatePickingStartedSalesOrderLoadSeedPayload, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadseedV1SalesOrderLoadSeedCreatePickingStartedSalesOrdersPost(apikey, createPickingStartedSalesOrderLoadSeedPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {CreateSLAMCompletedSalesOrdersLoadSeedPayload} [createSLAMCompletedSalesOrdersLoadSeedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadseedV1SalesOrderLoadSeedCreateSLAMCompletedSalesOrdersPost(apikey?: string, createSLAMCompletedSalesOrdersLoadSeedPayload?: CreateSLAMCompletedSalesOrdersLoadSeedPayload, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadseedV1SalesOrderLoadSeedCreateSLAMCompletedSalesOrdersPost(apikey, createSLAMCompletedSalesOrdersLoadSeedPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SalesOrderLoadSeedApi - factory interface
 * @export
 */
export const SalesOrderLoadSeedApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesOrderLoadSeedApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apikey] 
         * @param {CreatePackingCompletedSalesOrdersLoadSeedPayload} [createPackingCompletedSalesOrdersLoadSeedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadseedV1SalesOrderLoadSeedCreatePackingCompletedSalesOrdersPost(apikey?: string, createPackingCompletedSalesOrdersLoadSeedPayload?: CreatePackingCompletedSalesOrdersLoadSeedPayload, options?: any): AxiosPromise<void> {
            return localVarFp.loadseedV1SalesOrderLoadSeedCreatePackingCompletedSalesOrdersPost(apikey, createPackingCompletedSalesOrdersLoadSeedPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {CreatePickingCompletedSalesOrdersLoadSeedPayload} [createPickingCompletedSalesOrdersLoadSeedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadseedV1SalesOrderLoadSeedCreatePickingCompletedSalesOrdersPost(apikey?: string, createPickingCompletedSalesOrdersLoadSeedPayload?: CreatePickingCompletedSalesOrdersLoadSeedPayload, options?: any): AxiosPromise<void> {
            return localVarFp.loadseedV1SalesOrderLoadSeedCreatePickingCompletedSalesOrdersPost(apikey, createPickingCompletedSalesOrdersLoadSeedPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {CreatePickingStartedSalesOrderLoadSeedPayload} [createPickingStartedSalesOrderLoadSeedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadseedV1SalesOrderLoadSeedCreatePickingStartedSalesOrdersPost(apikey?: string, createPickingStartedSalesOrderLoadSeedPayload?: CreatePickingStartedSalesOrderLoadSeedPayload, options?: any): AxiosPromise<void> {
            return localVarFp.loadseedV1SalesOrderLoadSeedCreatePickingStartedSalesOrdersPost(apikey, createPickingStartedSalesOrderLoadSeedPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apikey] 
         * @param {CreateSLAMCompletedSalesOrdersLoadSeedPayload} [createSLAMCompletedSalesOrdersLoadSeedPayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadseedV1SalesOrderLoadSeedCreateSLAMCompletedSalesOrdersPost(apikey?: string, createSLAMCompletedSalesOrdersLoadSeedPayload?: CreateSLAMCompletedSalesOrdersLoadSeedPayload, options?: any): AxiosPromise<void> {
            return localVarFp.loadseedV1SalesOrderLoadSeedCreateSLAMCompletedSalesOrdersPost(apikey, createSLAMCompletedSalesOrdersLoadSeedPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalesOrderLoadSeedApi - object-oriented interface
 * @export
 * @class SalesOrderLoadSeedApi
 * @extends {BaseAPI}
 */
export class SalesOrderLoadSeedApi extends BaseAPI {
    /**
     * 
     * @param {string} [apikey] 
     * @param {CreatePackingCompletedSalesOrdersLoadSeedPayload} [createPackingCompletedSalesOrdersLoadSeedPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrderLoadSeedApi
     */
    public loadseedV1SalesOrderLoadSeedCreatePackingCompletedSalesOrdersPost(apikey?: string, createPackingCompletedSalesOrdersLoadSeedPayload?: CreatePackingCompletedSalesOrdersLoadSeedPayload, options?: any) {
        return SalesOrderLoadSeedApiFp(this.configuration).loadseedV1SalesOrderLoadSeedCreatePackingCompletedSalesOrdersPost(apikey, createPackingCompletedSalesOrdersLoadSeedPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apikey] 
     * @param {CreatePickingCompletedSalesOrdersLoadSeedPayload} [createPickingCompletedSalesOrdersLoadSeedPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrderLoadSeedApi
     */
    public loadseedV1SalesOrderLoadSeedCreatePickingCompletedSalesOrdersPost(apikey?: string, createPickingCompletedSalesOrdersLoadSeedPayload?: CreatePickingCompletedSalesOrdersLoadSeedPayload, options?: any) {
        return SalesOrderLoadSeedApiFp(this.configuration).loadseedV1SalesOrderLoadSeedCreatePickingCompletedSalesOrdersPost(apikey, createPickingCompletedSalesOrdersLoadSeedPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apikey] 
     * @param {CreatePickingStartedSalesOrderLoadSeedPayload} [createPickingStartedSalesOrderLoadSeedPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrderLoadSeedApi
     */
    public loadseedV1SalesOrderLoadSeedCreatePickingStartedSalesOrdersPost(apikey?: string, createPickingStartedSalesOrderLoadSeedPayload?: CreatePickingStartedSalesOrderLoadSeedPayload, options?: any) {
        return SalesOrderLoadSeedApiFp(this.configuration).loadseedV1SalesOrderLoadSeedCreatePickingStartedSalesOrdersPost(apikey, createPickingStartedSalesOrderLoadSeedPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apikey] 
     * @param {CreateSLAMCompletedSalesOrdersLoadSeedPayload} [createSLAMCompletedSalesOrdersLoadSeedPayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrderLoadSeedApi
     */
    public loadseedV1SalesOrderLoadSeedCreateSLAMCompletedSalesOrdersPost(apikey?: string, createSLAMCompletedSalesOrdersLoadSeedPayload?: CreateSLAMCompletedSalesOrdersLoadSeedPayload, options?: any) {
        return SalesOrderLoadSeedApiFp(this.configuration).loadseedV1SalesOrderLoadSeedCreateSLAMCompletedSalesOrdersPost(apikey, createSLAMCompletedSalesOrdersLoadSeedPayload, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SalesOrderNpsApi - axios parameter creator
 * @export
 */
export const SalesOrderNpsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [uniqueId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrderNpsGet: async (uniqueId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrderNps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (uniqueId !== undefined) {
                localVarQueryParameter['uniqueId'] = uniqueId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrderNpsQrIdGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrderNps.QrId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetIsNpsActiveDTO} [setIsNpsActiveDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrderNpsSetNpsIsActivePost: async (setIsNpsActiveDTO?: SetIsNpsActiveDTO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrderNps.setNpsIsActive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setIsNpsActiveDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesOrderNpsApi - functional programming interface
 * @export
 */
export const SalesOrderNpsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesOrderNpsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [uniqueId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrderNpsGet(uniqueId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrderNpsGet(uniqueId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrderNpsQrIdGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrderNpsQrIdGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetIsNpsActiveDTO} [setIsNpsActiveDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrderNpsSetNpsIsActivePost(setIsNpsActiveDTO?: SetIsNpsActiveDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrderNpsSetNpsIsActivePost(setIsNpsActiveDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SalesOrderNpsApi - factory interface
 * @export
 */
export const SalesOrderNpsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesOrderNpsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [uniqueId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrderNpsGet(uniqueId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SalesOrderNpsGet(uniqueId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrderNpsQrIdGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SalesOrderNpsQrIdGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetIsNpsActiveDTO} [setIsNpsActiveDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrderNpsSetNpsIsActivePost(setIsNpsActiveDTO?: SetIsNpsActiveDTO, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SalesOrderNpsSetNpsIsActivePost(setIsNpsActiveDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalesOrderNpsApi - object-oriented interface
 * @export
 * @class SalesOrderNpsApi
 * @extends {BaseAPI}
 */
export class SalesOrderNpsApi extends BaseAPI {
    /**
     * 
     * @param {string} [uniqueId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrderNpsApi
     */
    public apiV1SalesOrderNpsGet(uniqueId?: string, options?: any) {
        return SalesOrderNpsApiFp(this.configuration).apiV1SalesOrderNpsGet(uniqueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrderNpsApi
     */
    public apiV1SalesOrderNpsQrIdGet(options?: any) {
        return SalesOrderNpsApiFp(this.configuration).apiV1SalesOrderNpsQrIdGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetIsNpsActiveDTO} [setIsNpsActiveDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrderNpsApi
     */
    public apiV1SalesOrderNpsSetNpsIsActivePost(setIsNpsActiveDTO?: SetIsNpsActiveDTO, options?: any) {
        return SalesOrderNpsApiFp(this.configuration).apiV1SalesOrderNpsSetNpsIsActivePost(setIsNpsActiveDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SalesOrdersApi - axios parameter creator
 * @export
 */
export const SalesOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddCustomActionVasToSalesOrderCommand} [addCustomActionVasToSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersAddCustomActionVasToSalesOrderPost: async (addCustomActionVasToSalesOrderCommand?: AddCustomActionVasToSalesOrderCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.addCustomActionVasToSalesOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCustomActionVasToSalesOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCustomActionVASTypeCommand} [createCustomActionVASTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersCreateCustomActionVASTypePost: async (createCustomActionVASTypeCommand?: CreateCustomActionVASTypeCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.createCustomActionVASType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomActionVASTypeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSalesOrderNoteCommand} [createSalesOrderNoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersCreateSalesOrderNotePost: async (createSalesOrderNoteCommand?: CreateSalesOrderNoteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.createSalesOrderNote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSalesOrderNoteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeliverCargoPackagesForManualDeliverySalesOrdersCommand} [deliverCargoPackagesForManualDeliverySalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersDeliverCargoPackagesForManualDeliverySalesOrdersPost: async (deliverCargoPackagesForManualDeliverySalesOrdersCommand?: DeliverCargoPackagesForManualDeliverySalesOrdersCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.deliverCargoPackagesForManualDeliverySalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deliverCargoPackagesForManualDeliverySalesOrdersCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeliverCargoPackagesForSingleManualDeliverySalesOrderCommand} [deliverCargoPackagesForSingleManualDeliverySalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersDeliverCargoPackagesForSingleManualDeliverySalesOrderPost: async (deliverCargoPackagesForSingleManualDeliverySalesOrderCommand?: DeliverCargoPackagesForSingleManualDeliverySalesOrderCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.deliverCargoPackagesForSingleManualDeliverySalesOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deliverCargoPackagesForSingleManualDeliverySalesOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersDetailGet: async (salesOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {ExcelExtensionType} [fileType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersDownloadCargoPackagesExcelGet: async (salesOrderId?: string, fileType?: ExcelExtensionType, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.downloadCargoPackagesExcel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }

            if (fileType !== undefined) {
                localVarQueryParameter['fileType'] = fileType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersGetCustomActionVASTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.getCustomActionVASTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersGetPickListDetailsGet: async (salesOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.getPickListDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersGetSalesOrderFilterableFieldsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.getSalesOrderFilterableFields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersGetSalesOrdersInHoldingZoneAddressPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.getSalesOrdersInHoldingZoneAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersGetUnprintedWaybillOrdersGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.getUnprintedWaybillOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersGetWaybillStationInfoGet: async (referenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.getWaybillStationInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersListCargoPackagesGet: async (salesOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.listCargoPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersListReturnPackagesGet: async (salesOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.listReturnPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MarkWaybillAsPrintedCommand} [markWaybillAsPrintedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersMarkWaybillAsPrintedPost: async (markWaybillAsPrintedCommand?: MarkWaybillAsPrintedCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.markWaybillAsPrinted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markWaybillAsPrintedCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintWaybillDocumentCommand} [printWaybillDocumentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersPrintWaybillDocumentPost: async (printWaybillDocumentCommand?: PrintWaybillDocumentCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.printWaybillDocument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printWaybillDocumentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryCancelledOrdersGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.queryCancelledOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryCargoCarrierNamesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.queryCargoCarrierNames`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryCreatedOrdersGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.queryCreatedOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryDeliveredOrdersGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.queryDeliveredOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryLineItemsGet: async (salesOrderId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'salesOrderId' is not null or undefined
            assertParamExists('apiV1SalesOrdersQueryLineItemsGet', 'salesOrderId', salesOrderId)
            const localVarPath = `/api/v1/SalesOrders.queryLineItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryMarketPlaceSalesOrdersGet: async (salesOrderId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'salesOrderId' is not null or undefined
            assertParamExists('apiV1SalesOrdersQueryMarketPlaceSalesOrdersGet', 'salesOrderId', salesOrderId)
            const localVarPath = `/api/v1/SalesOrders.queryMarketPlaceSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOperationalStateDetailsGet: async (salesOrderId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'salesOrderId' is not null or undefined
            assertParamExists('apiV1SalesOrdersQueryOperationalStateDetailsGet', 'salesOrderId', salesOrderId)
            const localVarPath = `/api/v1/SalesOrders.queryOperationalStateDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} operationId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOrderTrackingPendingOrdersGet: async (operationId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('apiV1SalesOrdersQueryOrderTrackingPendingOrdersGet', 'operationId', operationId)
            const localVarPath = `/api/v1/SalesOrders.queryOrderTrackingPendingOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (operationId !== undefined) {
                localVarQueryParameter['operationId'] = operationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [operationId] 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOrderTrackingReportSeriesGet: async (operationId?: string, days?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.queryOrderTrackingReportSeries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (operationId !== undefined) {
                localVarQueryParameter['operationId'] = operationId;
            }

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOrdersGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.queryOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOrdersInDispatchGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.queryOrdersInDispatch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOrdersInPackingGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.queryOrdersInPacking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOrdersInPickingGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.queryOrdersInPicking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOrdersInSLAMGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.queryOrdersInSLAM`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOrdersInSortingGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.queryOrdersInSorting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryPickListItemsGet: async (salesOrderId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'salesOrderId' is not null or undefined
            assertParamExists('apiV1SalesOrdersQueryPickListItemsGet', 'salesOrderId', salesOrderId)
            const localVarPath = `/api/v1/SalesOrders.queryPickListItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryProblemsGet: async (salesOrderId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'salesOrderId' is not null or undefined
            assertParamExists('apiV1SalesOrdersQueryProblemsGet', 'salesOrderId', salesOrderId)
            const localVarPath = `/api/v1/SalesOrders.queryProblems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQuerySalesOrderByProductGet: async (productId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiV1SalesOrdersQuerySalesOrderByProductGet', 'productId', productId)
            const localVarPath = `/api/v1/SalesOrders.querySalesOrderByProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQuerySalesOrderCargoPackagesGet: async (referenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.querySalesOrderCargoPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQuerySalesOrderNotesGet: async (salesOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.querySalesOrderNotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQuerySalesOrderSerialNumberTrackingsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.querySalesOrderSerialNumberTrackings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQuerySalesOrderVasGet: async (salesOrderId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'salesOrderId' is not null or undefined
            assertParamExists('apiV1SalesOrdersQuerySalesOrderVasGet', 'salesOrderId', salesOrderId)
            const localVarPath = `/api/v1/SalesOrders.querySalesOrderVas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQuerySalesOrdersOperationCountGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.querySalesOrdersOperationCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQuerySalesOrdersWithPickListProblemsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.querySalesOrdersWithPickListProblems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersRecipientAddressDetailsGet: async (salesOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.recipientAddressDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetSalesOrderPriorityCommand} [setSalesOrderPriorityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersSetPriorityPost: async (setSalesOrderPriorityCommand?: SetSalesOrderPriorityCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.setPriority`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setSalesOrderPriorityCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetSalesOrdersForManualDeliveryCommand} [setSalesOrdersForManualDeliveryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersSetSalesOrdersForManualDispatchPost: async (setSalesOrdersForManualDeliveryCommand?: SetSalesOrdersForManualDeliveryCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.setSalesOrdersForManualDispatch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setSalesOrdersForManualDeliveryCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetSalesOrdersForRegularDeliveryCommand} [setSalesOrdersForRegularDeliveryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersSetSalesOrdersForRegularDeliveryPost: async (setSalesOrdersForRegularDeliveryCommand?: SetSalesOrdersForRegularDeliveryCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.setSalesOrdersForRegularDelivery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setSalesOrdersForRegularDeliveryCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetSalesOrdersForSameDayDeliveryCommand} [setSalesOrdersForSameDayDeliveryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersSetSalesOrdersForSameDayDeliveryPost: async (setSalesOrdersForSameDayDeliveryCommand?: SetSalesOrdersForSameDayDeliveryCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.setSalesOrdersForSameDayDelivery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setSalesOrdersForSameDayDeliveryCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetTargetDispatchTimeForSalesOrdersCommand} [setTargetDispatchTimeForSalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersSetTargetDispatchTimeForSalesOrdersPost: async (setTargetDispatchTimeForSalesOrdersCommand?: SetTargetDispatchTimeForSalesOrdersCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.setTargetDispatchTimeForSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setTargetDispatchTimeForSalesOrdersCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersShipmentDetailsGet: async (salesOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.shipmentDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteSLAMForManualDeliverySalesOrdersCommand} [completeSLAMForManualDeliverySalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersSlamCompleteForManualDeliverySalesOrdersPost: async (completeSLAMForManualDeliverySalesOrdersCommand?: CompleteSLAMForManualDeliverySalesOrdersCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.slamCompleteForManualDeliverySalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeSLAMForManualDeliverySalesOrdersCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersStateDetailsGet: async (salesOrderId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SalesOrders.stateDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (salesOrderId !== undefined) {
                localVarQueryParameter['salesOrderId'] = salesOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkCreateSalesOrderWithCustomerCommand} [bulkCreateSalesOrderWithCustomerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kittingappV1SalesOrdersBulkCreatePost: async (bulkCreateSalesOrderWithCustomerCommand?: BulkCreateSalesOrderWithCustomerCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/kittingapp/v1/SalesOrders/bulkCreate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateSalesOrderWithCustomerCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CancelSalesOrderCommand} [cancelSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kittingappV1SalesOrdersCancelPut: async (cancelSalesOrderCommand?: CancelSalesOrderCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/kittingapp/v1/SalesOrders/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelSalesOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kittingappV1SalesOrdersSalesOrdersQueryOrdersGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/kittingapp/v1/SalesOrders/SalesOrders.queryOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddVasDocumentUrlCommand} [addVasDocumentUrlCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1SalesOrdersAddVasDocumentUrlPost: async (addVasDocumentUrlCommand?: AddVasDocumentUrlCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/SalesOrders/addVasDocumentUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addVasDocumentUrlCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApproveSalesOrderDispatchCommand} [approveSalesOrderDispatchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1SalesOrdersApproveSalesOrderPut: async (approveSalesOrderDispatchCommand?: ApproveSalesOrderDispatchCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/SalesOrders/approveSalesOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveSalesOrderDispatchCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkCreateSalesOrderWithCustomerCommand} [bulkCreateSalesOrderWithCustomerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1SalesOrdersBulkCreateOverQueuePost: async (bulkCreateSalesOrderWithCustomerCommand?: BulkCreateSalesOrderWithCustomerCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/SalesOrders/bulkCreateOverQueue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateSalesOrderWithCustomerCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CancelSalesOrderCommand} [cancelSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1SalesOrdersCancelPut: async (cancelSalesOrderCommand?: CancelSalesOrderCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/SalesOrders/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelSalesOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetSalesOrderCargoPackagesByReferenceQuery} [getSalesOrderCargoPackagesByReferenceQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1SalesOrdersGetCargoPackagesPost: async (getSalesOrderCargoPackagesByReferenceQuery?: GetSalesOrderCargoPackagesByReferenceQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/SalesOrders/getCargoPackages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSalesOrderCargoPackagesByReferenceQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSalesOrderCargoInfoCommand} [updateSalesOrderCargoInfoCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1SalesOrdersUpdateCargoInfoPut: async (updateSalesOrderCargoInfoCommand?: UpdateSalesOrderCargoInfoCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/SalesOrders/updateCargoInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSalesOrderCargoInfoCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSalesOrderCustomerInfoCommand} [updateSalesOrderCustomerInfoCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1SalesOrdersUpdateSalesOrderCustomerInfoPut: async (updateSalesOrderCustomerInfoCommand?: UpdateSalesOrderCustomerInfoCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi/v1/SalesOrders/updateSalesOrderCustomerInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSalesOrderCustomerInfoCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddContainerToSalesOrderCommand} [addContainerToSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersAddContainerToSalesOrderPost: async (addContainerToSalesOrderCommand?: AddContainerToSalesOrderCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/addContainerToSalesOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addContainerToSalesOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddSalesOrderLostItemToToteCommand} [addSalesOrderLostItemToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersAddLostItemsToTotePost: async (addSalesOrderLostItemToToteCommand?: AddSalesOrderLostItemToToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/addLostItemsToTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSalesOrderLostItemToToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChangeDeliveryTypeCommand} [changeDeliveryTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersChangeDeliveryTypePost: async (changeDeliveryTypeCommand?: ChangeDeliveryTypeCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/changeDeliveryType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeDeliveryTypeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClearSalesOrderSuspendedStateCommand} [clearSalesOrderSuspendedStateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersClearSalesOrderSuspendedStatePost: async (clearSalesOrderSuspendedStateCommand?: ClearSalesOrderSuspendedStateCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/clearSalesOrderSuspendedState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clearSalesOrderSuspendedStateCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CombineSalesOrderItemsToToteCommand} [combineSalesOrderItemsToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersCombineItemsToTotePost: async (combineSalesOrderItemsToToteCommand?: CombineSalesOrderItemsToToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/combineItemsToTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(combineSalesOrderItemsToToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteHOVSalesOrderPackingCommand} [completeHOVSalesOrderPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersCompleteHOVSalesOrderPackingPost: async (completeHOVSalesOrderPackingCommand?: CompleteHOVSalesOrderPackingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/completeHOVSalesOrderPacking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeHOVSalesOrderPackingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteHOVSalesOrderPickingCommand} [completeHOVSalesOrderPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersCompleteHOVSalesOrderPickingPost: async (completeHOVSalesOrderPickingCommand?: CompleteHOVSalesOrderPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/completeHOVSalesOrderPicking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeHOVSalesOrderPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteUnassignedHOVSalesOrderPickingCommand} [completeUnassignedHOVSalesOrderPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersCompleteUnassignedHOVSalesOrderPickingPost: async (completeUnassignedHOVSalesOrderPickingCommand?: CompleteUnassignedHOVSalesOrderPickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/completeUnassignedHOVSalesOrderPicking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeUnassignedHOVSalesOrderPickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DispatchSalesOrderWithProblemToDeliverCommand} [dispatchSalesOrderWithProblemToDeliverCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersDispatchSalesOrderWithProblemToDeliverPost: async (dispatchSalesOrderWithProblemToDeliverCommand?: DispatchSalesOrderWithProblemToDeliverCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/dispatchSalesOrderWithProblemToDeliver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dispatchSalesOrderWithProblemToDeliverCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForceManualDeliveryCommand} [forceManualDeliveryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersForceManualDeliveryPost: async (forceManualDeliveryCommand?: ForceManualDeliveryCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/forceManualDelivery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forceManualDeliveryCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersGetItemsToCombineInfoGet: async (operationName?: string, referenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/getItemsToCombineInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (operationName !== undefined) {
                localVarQueryParameter['operationName'] = operationName;
            }

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ManuallyDeliverSalesOrdersCommand} [manuallyDeliverSalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersManuallyDeliverSalesOrdersPost: async (manuallyDeliverSalesOrdersCommand?: ManuallyDeliverSalesOrdersCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/manuallyDeliverSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(manuallyDeliverSalesOrdersCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ManuallyDispatchSalesOrdersCommand} [manuallyDispatchSalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersManuallyDispatchSalesOrdersPost: async (manuallyDispatchSalesOrdersCommand?: ManuallyDispatchSalesOrdersCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/manuallyDispatchSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(manuallyDispatchSalesOrdersCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ManuallyPackSalesOrdersCommand} [manuallyPackSalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersManuallyPackSalesOrdersPost: async (manuallyPackSalesOrdersCommand?: ManuallyPackSalesOrdersCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/manuallyPackSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(manuallyPackSalesOrdersCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MarketPlaceSalesOrderDeliverToDispatchCommand} [marketPlaceSalesOrderDeliverToDispatchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersMarketPlaceSalesOrderDeliverToDispatchPost: async (marketPlaceSalesOrderDeliverToDispatchCommand?: MarketPlaceSalesOrderDeliverToDispatchCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/marketPlaceSalesOrderDeliverToDispatch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(marketPlaceSalesOrderDeliverToDispatchCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MoveContainerItemsCommand} [moveContainerItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersMoveContainerItemsPost: async (moveContainerItemsCommand?: MoveContainerItemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/moveContainerItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveContainerItemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RemoveContainerFromSalesOrderCommand} [removeContainerFromSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersRemoveContainerFromSalesOrderPost: async (removeContainerFromSalesOrderCommand?: RemoveContainerFromSalesOrderCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/removeContainerFromSalesOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeContainerFromSalesOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetSalesOrderStateToInitialCommand} [resetSalesOrderStateToInitialCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersResetSalesOrderStateToInitialPost: async (resetSalesOrderStateToInitialCommand?: ResetSalesOrderStateToInitialCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/resetSalesOrderStateToInitial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetSalesOrderStateToInitialCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResolveSalesOrderProblemsCommand} [resolveSalesOrderProblemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersResolveSalesOrderProblemsPost: async (resolveSalesOrderProblemsCommand?: ResolveSalesOrderProblemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/resolveSalesOrderProblems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveSalesOrderProblemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RevertDispatchedSalesOrderToPackingStateCommand} [revertDispatchedSalesOrderToPackingStateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersRevertDispatchedSalesOrderToPackingPost: async (revertDispatchedSalesOrderToPackingStateCommand?: RevertDispatchedSalesOrderToPackingStateCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/revertDispatchedSalesOrderToPacking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(revertDispatchedSalesOrderToPackingStateCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RevertToDispatchedCommand} [revertToDispatchedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersRevertToDispatchedPost: async (revertToDispatchedCommand?: RevertToDispatchedCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/revertToDispatched`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(revertToDispatchedCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReviewLostItemProblemByOrderCommand} [reviewLostItemProblemByOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersReviewLostItemProblemByOrderPost: async (reviewLostItemProblemByOrderCommand?: ReviewLostItemProblemByOrderCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/reviewLostItemProblemByOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewLostItemProblemByOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReviewLostItemProblemByTrolleyCommand} [reviewLostItemProblemByTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersReviewLostItemProblemByTrolleyPost: async (reviewLostItemProblemByTrolleyCommand?: ReviewLostItemProblemByTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/reviewLostItemProblemByTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewLostItemProblemByTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReviewSalesOrderMissingProblemCommand} [reviewSalesOrderMissingProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersReviewMissingProblemPost: async (reviewSalesOrderMissingProblemCommand?: ReviewSalesOrderMissingProblemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/reviewMissingProblem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewSalesOrderMissingProblemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RollbackDispatchOrSLAMSalesOrdersToPackingStateCommand} [rollbackDispatchOrSLAMSalesOrdersToPackingStateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersRollbackDispatchOrSLAMSalesOrdersToPackingStatePost: async (rollbackDispatchOrSLAMSalesOrdersToPackingStateCommand?: RollbackDispatchOrSLAMSalesOrdersToPackingStateCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/rollbackDispatchOrSLAMSalesOrdersToPackingState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rollbackDispatchOrSLAMSalesOrdersToPackingStateCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SLAMSalesOrderWithProblemToDispatchCommand} [sLAMSalesOrderWithProblemToDispatchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersSLAMSalesOrderWithProblemToDispatchPost: async (sLAMSalesOrderWithProblemToDispatchCommand?: SLAMSalesOrderWithProblemToDispatchCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/SLAMSalesOrderWithProblemToDispatch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sLAMSalesOrderWithProblemToDispatchCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AutoScaleTestCommand} [autoScaleTestCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersSalesOrdersAutoScaleTestPost: async (autoScaleTestCommand?: AutoScaleTestCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/SalesOrders.autoScaleTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(autoScaleTestCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkSyncOperationSalesOrderStatesCommand} [bulkSyncOperationSalesOrderStatesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersSalesOrdersBulkSyncOperationSalesOrdersPost: async (bulkSyncOperationSalesOrderStatesCommand?: BulkSyncOperationSalesOrderStatesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/SalesOrders.bulkSyncOperationSalesOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSyncOperationSalesOrderStatesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersSalesOrdersGetSalesOrderCargoPackageTypesReportGet: async (startDate: string, endDate: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('supportV1SalesOrdersSalesOrdersGetSalesOrderCargoPackageTypesReportGet', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('supportV1SalesOrdersSalesOrdersGetSalesOrderCargoPackageTypesReportGet', 'endDate', endDate)
            const localVarPath = `/support/v1/SalesOrders/SalesOrders.getSalesOrderCargoPackageTypesReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['StartDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['EndDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSalesOrderShippingAddressCommand} [updateSalesOrderShippingAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersSalesOrdersUpdateSalesOrderShippingAddressPost: async (updateSalesOrderShippingAddressCommand?: UpdateSalesOrderShippingAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/SalesOrders.updateSalesOrderShippingAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSalesOrderShippingAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSalesOrderStatesCommand} [updateSalesOrderStatesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersSalesOrdersUpdateSalesOrderStatesPost: async (updateSalesOrderStatesCommand?: UpdateSalesOrderStatesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/SalesOrders.updateSalesOrderStates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSalesOrderStatesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SyncTotePickListIdCommand} [syncTotePickListIdCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersSyncTotePickListIdPost: async (syncTotePickListIdCommand?: SyncTotePickListIdCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/syncTotePickListId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncTotePickListIdCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDispatchCompletedAtCommand} [updateDispatchCompletedAtCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersUpdateDispatchCompletedAtPatch: async (updateDispatchCompletedAtCommand?: UpdateDispatchCompletedAtCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/updateDispatchCompletedAt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDispatchCompletedAtCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateGiftNoteCommand} [updateGiftNoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersUpdateGiftNotePost: async (updateGiftNoteCommand?: UpdateGiftNoteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/updateGiftNote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGiftNoteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdatePreferredCargoCarrierCommand} [updatePreferredCargoCarrierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersUpdatePreferredCargoCarrierPost: async (updatePreferredCargoCarrierCommand?: UpdatePreferredCargoCarrierCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/updatePreferredCargoCarrier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePreferredCargoCarrierCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSalesOrderShippingTrackingIdCommand} [updateSalesOrderShippingTrackingIdCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersUpdateSalesOrderShippingTrackingIdPost: async (updateSalesOrderShippingTrackingIdCommand?: UpdateSalesOrderShippingTrackingIdCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/updateSalesOrderShippingTrackingId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSalesOrderShippingTrackingIdCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateVasDocumentUrlCommand} [updateVasDocumentUrlCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersUpdateVasDocumentUrlPost: async (updateVasDocumentUrlCommand?: UpdateVasDocumentUrlCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/SalesOrders/updateVasDocumentUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVasDocumentUrlCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesOrdersApi - functional programming interface
 * @export
 */
export const SalesOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddCustomActionVasToSalesOrderCommand} [addCustomActionVasToSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersAddCustomActionVasToSalesOrderPost(addCustomActionVasToSalesOrderCommand?: AddCustomActionVasToSalesOrderCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersAddCustomActionVasToSalesOrderPost(addCustomActionVasToSalesOrderCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateCustomActionVASTypeCommand} [createCustomActionVASTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersCreateCustomActionVASTypePost(createCustomActionVASTypeCommand?: CreateCustomActionVASTypeCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersCreateCustomActionVASTypePost(createCustomActionVASTypeCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSalesOrderNoteCommand} [createSalesOrderNoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersCreateSalesOrderNotePost(createSalesOrderNoteCommand?: CreateSalesOrderNoteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersCreateSalesOrderNotePost(createSalesOrderNoteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeliverCargoPackagesForManualDeliverySalesOrdersCommand} [deliverCargoPackagesForManualDeliverySalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersDeliverCargoPackagesForManualDeliverySalesOrdersPost(deliverCargoPackagesForManualDeliverySalesOrdersCommand?: DeliverCargoPackagesForManualDeliverySalesOrdersCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliverCargoPackagesForManualDeliverySalesOrdersCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersDeliverCargoPackagesForManualDeliverySalesOrdersPost(deliverCargoPackagesForManualDeliverySalesOrdersCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeliverCargoPackagesForSingleManualDeliverySalesOrderCommand} [deliverCargoPackagesForSingleManualDeliverySalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersDeliverCargoPackagesForSingleManualDeliverySalesOrderPost(deliverCargoPackagesForSingleManualDeliverySalesOrderCommand?: DeliverCargoPackagesForSingleManualDeliverySalesOrderCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersDeliverCargoPackagesForSingleManualDeliverySalesOrderPost(deliverCargoPackagesForSingleManualDeliverySalesOrderCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersDetailGet(salesOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrderDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersDetailGet(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {ExcelExtensionType} [fileType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersDownloadCargoPackagesExcelGet(salesOrderId?: string, fileType?: ExcelExtensionType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersDownloadCargoPackagesExcelGet(salesOrderId, fileType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersGetCustomActionVASTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomActionVasTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersGetCustomActionVASTypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersGetPickListDetailsGet(salesOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPickListDetailsBySalesOrderIdOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersGetPickListDetailsGet(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersGetSalesOrderFilterableFieldsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ObjectCustomFilterableField>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersGetSalesOrderFilterableFieldsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersGetSalesOrdersInHoldingZoneAddressPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SalesOrdersHoldingZoneAddressesOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersGetSalesOrdersInHoldingZoneAddressPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersGetUnprintedWaybillOrdersGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UnprintedWaybillOrderDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersGetUnprintedWaybillOrdersGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersGetWaybillStationInfoGet(referenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaybillStationInfoOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersGetWaybillStationInfoGet(referenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersListCargoPackagesGet(salesOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CargoPackageListOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersListCargoPackagesGet(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersListReturnPackagesGet(salesOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SalesOrderReturnPackageOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersListReturnPackagesGet(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MarkWaybillAsPrintedCommand} [markWaybillAsPrintedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersMarkWaybillAsPrintedPost(markWaybillAsPrintedCommand?: MarkWaybillAsPrintedCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersMarkWaybillAsPrintedPost(markWaybillAsPrintedCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintWaybillDocumentCommand} [printWaybillDocumentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersPrintWaybillDocumentPost(printWaybillDocumentCommand?: PrintWaybillDocumentCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersPrintWaybillDocumentPost(printWaybillDocumentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryCancelledOrdersGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelledSalesOrderQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryCancelledOrdersGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryCargoCarrierNamesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryCargoCarrierNamesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryCreatedOrdersGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedSalesOrderQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryCreatedOrdersGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryDeliveredOrdersGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveredSalesOrderQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryDeliveredOrdersGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryLineItemsGet(salesOrderId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrderLineItemQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryLineItemsGet(salesOrderId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryMarketPlaceSalesOrdersGet(salesOrderId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketPlaceSalesOrderOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryMarketPlaceSalesOrdersGet(salesOrderId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryOperationalStateDetailsGet(salesOrderId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrderStateDetailsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryOperationalStateDetailsGet(salesOrderId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} operationId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryOrderTrackingPendingOrdersGet(operationId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderTrackingPendingSalesOrderOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryOrderTrackingPendingOrdersGet(operationId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [operationId] 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryOrderTrackingReportSeriesGet(operationId?: string, days?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderTrackingReportSeriesOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryOrderTrackingReportSeriesGet(operationId, days, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryOrdersGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrderQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryOrdersGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryOrdersInDispatchGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InDispatchSalesOrderQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryOrdersInDispatchGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryOrdersInPackingGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InPackingSalesOrderQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryOrdersInPackingGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryOrdersInPickingGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InPickingSalesOrderQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryOrdersInPickingGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryOrdersInSLAMGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InSLAMOrSuspendedSalesOrderQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryOrdersInSLAMGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryOrdersInSortingGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InSortingSalesOrderQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryOrdersInSortingGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryPickListItemsGet(salesOrderId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickListItemOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryPickListItemsGet(salesOrderId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQueryProblemsGet(salesOrderId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrderProblemOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQueryProblemsGet(salesOrderId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQuerySalesOrderByProductGet(productId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuerySalesOrdersForDispatchOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQuerySalesOrderByProductGet(productId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQuerySalesOrderCargoPackagesGet(referenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManualDeliverySalesOrderWithCargoPackagesOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQuerySalesOrderCargoPackagesGet(referenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQuerySalesOrderNotesGet(salesOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrderNotesQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQuerySalesOrderNotesGet(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQuerySalesOrderSerialNumberTrackingsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrderSerialNumberTrackingOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQuerySalesOrderSerialNumberTrackingsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQuerySalesOrderVasGet(salesOrderId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrderVasOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQuerySalesOrderVasGet(salesOrderId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQuerySalesOrdersOperationCountGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrdersOperationCountOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQuerySalesOrdersOperationCountGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersQuerySalesOrdersWithPickListProblemsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSalesOrdersWithPickListProblemsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersQuerySalesOrdersWithPickListProblemsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersRecipientAddressDetailsGet(salesOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecipientAddressDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersRecipientAddressDetailsGet(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetSalesOrderPriorityCommand} [setSalesOrderPriorityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersSetPriorityPost(setSalesOrderPriorityCommand?: SetSalesOrderPriorityCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersSetPriorityPost(setSalesOrderPriorityCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetSalesOrdersForManualDeliveryCommand} [setSalesOrdersForManualDeliveryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersSetSalesOrdersForManualDispatchPost(setSalesOrdersForManualDeliveryCommand?: SetSalesOrdersForManualDeliveryCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetSalesOrdersForManualDeliveryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersSetSalesOrdersForManualDispatchPost(setSalesOrdersForManualDeliveryCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetSalesOrdersForRegularDeliveryCommand} [setSalesOrdersForRegularDeliveryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersSetSalesOrdersForRegularDeliveryPost(setSalesOrdersForRegularDeliveryCommand?: SetSalesOrdersForRegularDeliveryCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetSalesOrdersForRegularDeliveryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersSetSalesOrdersForRegularDeliveryPost(setSalesOrdersForRegularDeliveryCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetSalesOrdersForSameDayDeliveryCommand} [setSalesOrdersForSameDayDeliveryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersSetSalesOrdersForSameDayDeliveryPost(setSalesOrdersForSameDayDeliveryCommand?: SetSalesOrdersForSameDayDeliveryCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetSalesOrdersForSameDayDeliveryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersSetSalesOrdersForSameDayDeliveryPost(setSalesOrdersForSameDayDeliveryCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetTargetDispatchTimeForSalesOrdersCommand} [setTargetDispatchTimeForSalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersSetTargetDispatchTimeForSalesOrdersPost(setTargetDispatchTimeForSalesOrdersCommand?: SetTargetDispatchTimeForSalesOrdersCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetTargetDispatchTimeForSalesOrdersOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersSetTargetDispatchTimeForSalesOrdersPost(setTargetDispatchTimeForSalesOrdersCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersShipmentDetailsGet(salesOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrderShipmentDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersShipmentDetailsGet(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteSLAMForManualDeliverySalesOrdersCommand} [completeSLAMForManualDeliverySalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersSlamCompleteForManualDeliverySalesOrdersPost(completeSLAMForManualDeliverySalesOrdersCommand?: CompleteSLAMForManualDeliverySalesOrdersCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersSlamCompleteForManualDeliverySalesOrdersPost(completeSLAMForManualDeliverySalesOrdersCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SalesOrdersStateDetailsGet(salesOrderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrdersStateDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SalesOrdersStateDetailsGet(salesOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkCreateSalesOrderWithCustomerCommand} [bulkCreateSalesOrderWithCustomerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kittingappV1SalesOrdersBulkCreatePost(bulkCreateSalesOrderWithCustomerCommand?: BulkCreateSalesOrderWithCustomerCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkCreateSalesOrderWithCustomerCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kittingappV1SalesOrdersBulkCreatePost(bulkCreateSalesOrderWithCustomerCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CancelSalesOrderCommand} [cancelSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kittingappV1SalesOrdersCancelPut(cancelSalesOrderCommand?: CancelSalesOrderCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelSalesOrderOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kittingappV1SalesOrdersCancelPut(cancelSalesOrderCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kittingappV1SalesOrdersSalesOrdersQueryOrdersGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrdersOperationQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kittingappV1SalesOrdersSalesOrdersQueryOrdersGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddVasDocumentUrlCommand} [addVasDocumentUrlCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1SalesOrdersAddVasDocumentUrlPost(addVasDocumentUrlCommand?: AddVasDocumentUrlCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddVasDocumentUrlOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1SalesOrdersAddVasDocumentUrlPost(addVasDocumentUrlCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApproveSalesOrderDispatchCommand} [approveSalesOrderDispatchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1SalesOrdersApproveSalesOrderPut(approveSalesOrderDispatchCommand?: ApproveSalesOrderDispatchCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1SalesOrdersApproveSalesOrderPut(approveSalesOrderDispatchCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkCreateSalesOrderWithCustomerCommand} [bulkCreateSalesOrderWithCustomerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1SalesOrdersBulkCreateOverQueuePost(bulkCreateSalesOrderWithCustomerCommand?: BulkCreateSalesOrderWithCustomerCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkCreateSalesOrderWithCustomerCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1SalesOrdersBulkCreateOverQueuePost(bulkCreateSalesOrderWithCustomerCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CancelSalesOrderCommand} [cancelSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1SalesOrdersCancelPut(cancelSalesOrderCommand?: CancelSalesOrderCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelSalesOrderOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1SalesOrdersCancelPut(cancelSalesOrderCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetSalesOrderCargoPackagesByReferenceQuery} [getSalesOrderCargoPackagesByReferenceQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1SalesOrdersGetCargoPackagesPost(getSalesOrderCargoPackagesByReferenceQuery?: GetSalesOrderCargoPackagesByReferenceQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CargoPackageListOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1SalesOrdersGetCargoPackagesPost(getSalesOrderCargoPackagesByReferenceQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateSalesOrderCargoInfoCommand} [updateSalesOrderCargoInfoCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1SalesOrdersUpdateCargoInfoPut(updateSalesOrderCargoInfoCommand?: UpdateSalesOrderCargoInfoCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1SalesOrdersUpdateCargoInfoPut(updateSalesOrderCargoInfoCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateSalesOrderCustomerInfoCommand} [updateSalesOrderCustomerInfoCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiV1SalesOrdersUpdateSalesOrderCustomerInfoPut(updateSalesOrderCustomerInfoCommand?: UpdateSalesOrderCustomerInfoCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiV1SalesOrdersUpdateSalesOrderCustomerInfoPut(updateSalesOrderCustomerInfoCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddContainerToSalesOrderCommand} [addContainerToSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersAddContainerToSalesOrderPost(addContainerToSalesOrderCommand?: AddContainerToSalesOrderCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddContainerToSalesOrderOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersAddContainerToSalesOrderPost(addContainerToSalesOrderCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddSalesOrderLostItemToToteCommand} [addSalesOrderLostItemToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersAddLostItemsToTotePost(addSalesOrderLostItemToToteCommand?: AddSalesOrderLostItemToToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddLostItemToToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersAddLostItemsToTotePost(addSalesOrderLostItemToToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ChangeDeliveryTypeCommand} [changeDeliveryTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersChangeDeliveryTypePost(changeDeliveryTypeCommand?: ChangeDeliveryTypeCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeDeliveryTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersChangeDeliveryTypePost(changeDeliveryTypeCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ClearSalesOrderSuspendedStateCommand} [clearSalesOrderSuspendedStateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersClearSalesOrderSuspendedStatePost(clearSalesOrderSuspendedStateCommand?: ClearSalesOrderSuspendedStateCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersClearSalesOrderSuspendedStatePost(clearSalesOrderSuspendedStateCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CombineSalesOrderItemsToToteCommand} [combineSalesOrderItemsToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersCombineItemsToTotePost(combineSalesOrderItemsToToteCommand?: CombineSalesOrderItemsToToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CombineToToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersCombineItemsToTotePost(combineSalesOrderItemsToToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteHOVSalesOrderPackingCommand} [completeHOVSalesOrderPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersCompleteHOVSalesOrderPackingPost(completeHOVSalesOrderPackingCommand?: CompleteHOVSalesOrderPackingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrdersResultOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersCompleteHOVSalesOrderPackingPost(completeHOVSalesOrderPackingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteHOVSalesOrderPickingCommand} [completeHOVSalesOrderPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersCompleteHOVSalesOrderPickingPost(completeHOVSalesOrderPickingCommand?: CompleteHOVSalesOrderPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrdersResultOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersCompleteHOVSalesOrderPickingPost(completeHOVSalesOrderPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteUnassignedHOVSalesOrderPickingCommand} [completeUnassignedHOVSalesOrderPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersCompleteUnassignedHOVSalesOrderPickingPost(completeUnassignedHOVSalesOrderPickingCommand?: CompleteUnassignedHOVSalesOrderPickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrdersResultOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersCompleteUnassignedHOVSalesOrderPickingPost(completeUnassignedHOVSalesOrderPickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DispatchSalesOrderWithProblemToDeliverCommand} [dispatchSalesOrderWithProblemToDeliverCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersDispatchSalesOrderWithProblemToDeliverPost(dispatchSalesOrderWithProblemToDeliverCommand?: DispatchSalesOrderWithProblemToDeliverCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersDispatchSalesOrderWithProblemToDeliverPost(dispatchSalesOrderWithProblemToDeliverCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ForceManualDeliveryCommand} [forceManualDeliveryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersForceManualDeliveryPost(forceManualDeliveryCommand?: ForceManualDeliveryCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeDeliveryTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersForceManualDeliveryPost(forceManualDeliveryCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersGetItemsToCombineInfoGet(operationName?: string, referenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrderItemsToCombineOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersGetItemsToCombineInfoGet(operationName, referenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ManuallyDeliverSalesOrdersCommand} [manuallyDeliverSalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersManuallyDeliverSalesOrdersPost(manuallyDeliverSalesOrdersCommand?: ManuallyDeliverSalesOrdersCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrdersResultOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersManuallyDeliverSalesOrdersPost(manuallyDeliverSalesOrdersCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ManuallyDispatchSalesOrdersCommand} [manuallyDispatchSalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersManuallyDispatchSalesOrdersPost(manuallyDispatchSalesOrdersCommand?: ManuallyDispatchSalesOrdersCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrdersResultOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersManuallyDispatchSalesOrdersPost(manuallyDispatchSalesOrdersCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ManuallyPackSalesOrdersCommand} [manuallyPackSalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersManuallyPackSalesOrdersPost(manuallyPackSalesOrdersCommand?: ManuallyPackSalesOrdersCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrdersResultOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersManuallyPackSalesOrdersPost(manuallyPackSalesOrdersCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MarketPlaceSalesOrderDeliverToDispatchCommand} [marketPlaceSalesOrderDeliverToDispatchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersMarketPlaceSalesOrderDeliverToDispatchPost(marketPlaceSalesOrderDeliverToDispatchCommand?: MarketPlaceSalesOrderDeliverToDispatchCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersMarketPlaceSalesOrderDeliverToDispatchPost(marketPlaceSalesOrderDeliverToDispatchCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MoveContainerItemsCommand} [moveContainerItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersMoveContainerItemsPost(moveContainerItemsCommand?: MoveContainerItemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MoveContainerItemsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersMoveContainerItemsPost(moveContainerItemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RemoveContainerFromSalesOrderCommand} [removeContainerFromSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersRemoveContainerFromSalesOrderPost(removeContainerFromSalesOrderCommand?: RemoveContainerFromSalesOrderCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoveContainerFromSalesOrderOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersRemoveContainerFromSalesOrderPost(removeContainerFromSalesOrderCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ResetSalesOrderStateToInitialCommand} [resetSalesOrderStateToInitialCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersResetSalesOrderStateToInitialPost(resetSalesOrderStateToInitialCommand?: ResetSalesOrderStateToInitialCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersResetSalesOrderStateToInitialPost(resetSalesOrderStateToInitialCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ResolveSalesOrderProblemsCommand} [resolveSalesOrderProblemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersResolveSalesOrderProblemsPost(resolveSalesOrderProblemsCommand?: ResolveSalesOrderProblemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersResolveSalesOrderProblemsPost(resolveSalesOrderProblemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RevertDispatchedSalesOrderToPackingStateCommand} [revertDispatchedSalesOrderToPackingStateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersRevertDispatchedSalesOrderToPackingPost(revertDispatchedSalesOrderToPackingStateCommand?: RevertDispatchedSalesOrderToPackingStateCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersRevertDispatchedSalesOrderToPackingPost(revertDispatchedSalesOrderToPackingStateCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RevertToDispatchedCommand} [revertToDispatchedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersRevertToDispatchedPost(revertToDispatchedCommand?: RevertToDispatchedCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersRevertToDispatchedPost(revertToDispatchedCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReviewLostItemProblemByOrderCommand} [reviewLostItemProblemByOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersReviewLostItemProblemByOrderPost(reviewLostItemProblemByOrderCommand?: ReviewLostItemProblemByOrderCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersReviewLostItemProblemByOrderPost(reviewLostItemProblemByOrderCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReviewLostItemProblemByTrolleyCommand} [reviewLostItemProblemByTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersReviewLostItemProblemByTrolleyPost(reviewLostItemProblemByTrolleyCommand?: ReviewLostItemProblemByTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewLostItemProblemByTrolleyOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersReviewLostItemProblemByTrolleyPost(reviewLostItemProblemByTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReviewSalesOrderMissingProblemCommand} [reviewSalesOrderMissingProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersReviewMissingProblemPost(reviewSalesOrderMissingProblemCommand?: ReviewSalesOrderMissingProblemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersReviewMissingProblemPost(reviewSalesOrderMissingProblemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RollbackDispatchOrSLAMSalesOrdersToPackingStateCommand} [rollbackDispatchOrSLAMSalesOrdersToPackingStateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersRollbackDispatchOrSLAMSalesOrdersToPackingStatePost(rollbackDispatchOrSLAMSalesOrdersToPackingStateCommand?: RollbackDispatchOrSLAMSalesOrdersToPackingStateCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrdersResultOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersRollbackDispatchOrSLAMSalesOrdersToPackingStatePost(rollbackDispatchOrSLAMSalesOrdersToPackingStateCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SLAMSalesOrderWithProblemToDispatchCommand} [sLAMSalesOrderWithProblemToDispatchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersSLAMSalesOrderWithProblemToDispatchPost(sLAMSalesOrderWithProblemToDispatchCommand?: SLAMSalesOrderWithProblemToDispatchCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersSLAMSalesOrderWithProblemToDispatchPost(sLAMSalesOrderWithProblemToDispatchCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AutoScaleTestCommand} [autoScaleTestCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersSalesOrdersAutoScaleTestPost(autoScaleTestCommand?: AutoScaleTestCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersSalesOrdersAutoScaleTestPost(autoScaleTestCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkSyncOperationSalesOrderStatesCommand} [bulkSyncOperationSalesOrderStatesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersSalesOrdersBulkSyncOperationSalesOrdersPost(bulkSyncOperationSalesOrderStatesCommand?: BulkSyncOperationSalesOrderStatesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkSyncResultsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersSalesOrdersBulkSyncOperationSalesOrdersPost(bulkSyncOperationSalesOrderStatesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersSalesOrdersGetSalesOrderCargoPackageTypesReportGet(startDate: string, endDate: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrderCargoPackageTypesOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersSalesOrdersGetSalesOrderCargoPackageTypesReportGet(startDate, endDate, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateSalesOrderShippingAddressCommand} [updateSalesOrderShippingAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersSalesOrdersUpdateSalesOrderShippingAddressPost(updateSalesOrderShippingAddressCommand?: UpdateSalesOrderShippingAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersSalesOrdersUpdateSalesOrderShippingAddressPost(updateSalesOrderShippingAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateSalesOrderStatesCommand} [updateSalesOrderStatesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersSalesOrdersUpdateSalesOrderStatesPost(updateSalesOrderStatesCommand?: UpdateSalesOrderStatesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrdersResultOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersSalesOrdersUpdateSalesOrderStatesPost(updateSalesOrderStatesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SyncTotePickListIdCommand} [syncTotePickListIdCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersSyncTotePickListIdPost(syncTotePickListIdCommand?: SyncTotePickListIdCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkSyncResultsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersSyncTotePickListIdPost(syncTotePickListIdCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateDispatchCompletedAtCommand} [updateDispatchCompletedAtCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersUpdateDispatchCompletedAtPatch(updateDispatchCompletedAtCommand?: UpdateDispatchCompletedAtCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersUpdateDispatchCompletedAtPatch(updateDispatchCompletedAtCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateGiftNoteCommand} [updateGiftNoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersUpdateGiftNotePost(updateGiftNoteCommand?: UpdateGiftNoteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateGiftNoteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersUpdateGiftNotePost(updateGiftNoteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdatePreferredCargoCarrierCommand} [updatePreferredCargoCarrierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersUpdatePreferredCargoCarrierPost(updatePreferredCargoCarrierCommand?: UpdatePreferredCargoCarrierCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdatePreferredCargoCarrierOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersUpdatePreferredCargoCarrierPost(updatePreferredCargoCarrierCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateSalesOrderShippingTrackingIdCommand} [updateSalesOrderShippingTrackingIdCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersUpdateSalesOrderShippingTrackingIdPost(updateSalesOrderShippingTrackingIdCommand?: UpdateSalesOrderShippingTrackingIdCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersUpdateSalesOrderShippingTrackingIdPost(updateSalesOrderShippingTrackingIdCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateVasDocumentUrlCommand} [updateVasDocumentUrlCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1SalesOrdersUpdateVasDocumentUrlPost(updateVasDocumentUrlCommand?: UpdateVasDocumentUrlCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateVasDocumentUrlOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1SalesOrdersUpdateVasDocumentUrlPost(updateVasDocumentUrlCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SalesOrdersApi - factory interface
 * @export
 */
export const SalesOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesOrdersApiFp(configuration)
    return {
        /**
         * 
         * @param {AddCustomActionVasToSalesOrderCommand} [addCustomActionVasToSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersAddCustomActionVasToSalesOrderPost(addCustomActionVasToSalesOrderCommand?: AddCustomActionVasToSalesOrderCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SalesOrdersAddCustomActionVasToSalesOrderPost(addCustomActionVasToSalesOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCustomActionVASTypeCommand} [createCustomActionVASTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersCreateCustomActionVASTypePost(createCustomActionVASTypeCommand?: CreateCustomActionVASTypeCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SalesOrdersCreateCustomActionVASTypePost(createCustomActionVASTypeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSalesOrderNoteCommand} [createSalesOrderNoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersCreateSalesOrderNotePost(createSalesOrderNoteCommand?: CreateSalesOrderNoteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SalesOrdersCreateSalesOrderNotePost(createSalesOrderNoteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeliverCargoPackagesForManualDeliverySalesOrdersCommand} [deliverCargoPackagesForManualDeliverySalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersDeliverCargoPackagesForManualDeliverySalesOrdersPost(deliverCargoPackagesForManualDeliverySalesOrdersCommand?: DeliverCargoPackagesForManualDeliverySalesOrdersCommand, options?: any): AxiosPromise<DeliverCargoPackagesForManualDeliverySalesOrdersCommandOutputDTO> {
            return localVarFp.apiV1SalesOrdersDeliverCargoPackagesForManualDeliverySalesOrdersPost(deliverCargoPackagesForManualDeliverySalesOrdersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeliverCargoPackagesForSingleManualDeliverySalesOrderCommand} [deliverCargoPackagesForSingleManualDeliverySalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersDeliverCargoPackagesForSingleManualDeliverySalesOrderPost(deliverCargoPackagesForSingleManualDeliverySalesOrderCommand?: DeliverCargoPackagesForSingleManualDeliverySalesOrderCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SalesOrdersDeliverCargoPackagesForSingleManualDeliverySalesOrderPost(deliverCargoPackagesForSingleManualDeliverySalesOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersDetailGet(salesOrderId?: string, options?: any): AxiosPromise<SalesOrderDetailDTO> {
            return localVarFp.apiV1SalesOrdersDetailGet(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {ExcelExtensionType} [fileType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersDownloadCargoPackagesExcelGet(salesOrderId?: string, fileType?: ExcelExtensionType, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SalesOrdersDownloadCargoPackagesExcelGet(salesOrderId, fileType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersGetCustomActionVASTypesGet(options?: any): AxiosPromise<CustomActionVasTypeOutputDTO> {
            return localVarFp.apiV1SalesOrdersGetCustomActionVASTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersGetPickListDetailsGet(salesOrderId?: string, options?: any): AxiosPromise<GetPickListDetailsBySalesOrderIdOutputDTO> {
            return localVarFp.apiV1SalesOrdersGetPickListDetailsGet(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersGetSalesOrderFilterableFieldsGet(options?: any): AxiosPromise<Array<ObjectCustomFilterableField>> {
            return localVarFp.apiV1SalesOrdersGetSalesOrderFilterableFieldsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersGetSalesOrdersInHoldingZoneAddressPost(options?: any): AxiosPromise<Array<SalesOrdersHoldingZoneAddressesOutputDTO>> {
            return localVarFp.apiV1SalesOrdersGetSalesOrdersInHoldingZoneAddressPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersGetUnprintedWaybillOrdersGet(options?: any): AxiosPromise<Array<UnprintedWaybillOrderDTO>> {
            return localVarFp.apiV1SalesOrdersGetUnprintedWaybillOrdersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersGetWaybillStationInfoGet(referenceNumber?: string, options?: any): AxiosPromise<WaybillStationInfoOutputDTO> {
            return localVarFp.apiV1SalesOrdersGetWaybillStationInfoGet(referenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersListCargoPackagesGet(salesOrderId?: string, options?: any): AxiosPromise<Array<CargoPackageListOutputDTO>> {
            return localVarFp.apiV1SalesOrdersListCargoPackagesGet(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersListReturnPackagesGet(salesOrderId?: string, options?: any): AxiosPromise<Array<SalesOrderReturnPackageOutputDTO>> {
            return localVarFp.apiV1SalesOrdersListReturnPackagesGet(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MarkWaybillAsPrintedCommand} [markWaybillAsPrintedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersMarkWaybillAsPrintedPost(markWaybillAsPrintedCommand?: MarkWaybillAsPrintedCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SalesOrdersMarkWaybillAsPrintedPost(markWaybillAsPrintedCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintWaybillDocumentCommand} [printWaybillDocumentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersPrintWaybillDocumentPost(printWaybillDocumentCommand?: PrintWaybillDocumentCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SalesOrdersPrintWaybillDocumentPost(printWaybillDocumentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryCancelledOrdersGet(dqb?: string, options?: any): AxiosPromise<CancelledSalesOrderQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQueryCancelledOrdersGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryCargoCarrierNamesGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiV1SalesOrdersQueryCargoCarrierNamesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryCreatedOrdersGet(dqb?: string, options?: any): AxiosPromise<CreatedSalesOrderQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQueryCreatedOrdersGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryDeliveredOrdersGet(dqb?: string, options?: any): AxiosPromise<DeliveredSalesOrderQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQueryDeliveredOrdersGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryLineItemsGet(salesOrderId: string, dqb?: string, options?: any): AxiosPromise<SalesOrderLineItemQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQueryLineItemsGet(salesOrderId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryMarketPlaceSalesOrdersGet(salesOrderId: string, dqb?: string, options?: any): AxiosPromise<MarketPlaceSalesOrderOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQueryMarketPlaceSalesOrdersGet(salesOrderId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOperationalStateDetailsGet(salesOrderId: string, dqb?: string, options?: any): AxiosPromise<SalesOrderStateDetailsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQueryOperationalStateDetailsGet(salesOrderId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} operationId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOrderTrackingPendingOrdersGet(operationId: string, dqb?: string, options?: any): AxiosPromise<OrderTrackingPendingSalesOrderOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQueryOrderTrackingPendingOrdersGet(operationId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [operationId] 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOrderTrackingReportSeriesGet(operationId?: string, days?: number, options?: any): AxiosPromise<OrderTrackingReportSeriesOutputDTO> {
            return localVarFp.apiV1SalesOrdersQueryOrderTrackingReportSeriesGet(operationId, days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOrdersGet(dqb?: string, options?: any): AxiosPromise<SalesOrderQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQueryOrdersGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOrdersInDispatchGet(dqb?: string, options?: any): AxiosPromise<InDispatchSalesOrderQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQueryOrdersInDispatchGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOrdersInPackingGet(dqb?: string, options?: any): AxiosPromise<InPackingSalesOrderQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQueryOrdersInPackingGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOrdersInPickingGet(dqb?: string, options?: any): AxiosPromise<InPickingSalesOrderQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQueryOrdersInPickingGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOrdersInSLAMGet(dqb?: string, options?: any): AxiosPromise<InSLAMOrSuspendedSalesOrderQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQueryOrdersInSLAMGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryOrdersInSortingGet(dqb?: string, options?: any): AxiosPromise<InSortingSalesOrderQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQueryOrdersInSortingGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryPickListItemsGet(salesOrderId: string, dqb?: string, options?: any): AxiosPromise<PickListItemOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQueryPickListItemsGet(salesOrderId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQueryProblemsGet(salesOrderId: string, dqb?: string, options?: any): AxiosPromise<SalesOrderProblemOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQueryProblemsGet(salesOrderId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQuerySalesOrderByProductGet(productId: string, dqb?: string, options?: any): AxiosPromise<QuerySalesOrdersForDispatchOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQuerySalesOrderByProductGet(productId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQuerySalesOrderCargoPackagesGet(referenceNumber?: string, options?: any): AxiosPromise<ManualDeliverySalesOrderWithCargoPackagesOutputDTO> {
            return localVarFp.apiV1SalesOrdersQuerySalesOrderCargoPackagesGet(referenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQuerySalesOrderNotesGet(salesOrderId?: string, options?: any): AxiosPromise<SalesOrderNotesQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQuerySalesOrderNotesGet(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQuerySalesOrderSerialNumberTrackingsGet(dqb?: string, options?: any): AxiosPromise<SalesOrderSerialNumberTrackingOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQuerySalesOrderSerialNumberTrackingsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} salesOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQuerySalesOrderVasGet(salesOrderId: string, dqb?: string, options?: any): AxiosPromise<SalesOrderVasOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQuerySalesOrderVasGet(salesOrderId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQuerySalesOrdersOperationCountGet(dqb?: string, options?: any): AxiosPromise<SalesOrdersOperationCountOutputDTO> {
            return localVarFp.apiV1SalesOrdersQuerySalesOrdersOperationCountGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersQuerySalesOrdersWithPickListProblemsGet(dqb?: string, options?: any): AxiosPromise<GetSalesOrdersWithPickListProblemsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SalesOrdersQuerySalesOrdersWithPickListProblemsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersRecipientAddressDetailsGet(salesOrderId?: string, options?: any): AxiosPromise<RecipientAddressDetailsOutputDTO> {
            return localVarFp.apiV1SalesOrdersRecipientAddressDetailsGet(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetSalesOrderPriorityCommand} [setSalesOrderPriorityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersSetPriorityPost(setSalesOrderPriorityCommand?: SetSalesOrderPriorityCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SalesOrdersSetPriorityPost(setSalesOrderPriorityCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetSalesOrdersForManualDeliveryCommand} [setSalesOrdersForManualDeliveryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersSetSalesOrdersForManualDispatchPost(setSalesOrdersForManualDeliveryCommand?: SetSalesOrdersForManualDeliveryCommand, options?: any): AxiosPromise<SetSalesOrdersForManualDeliveryOutputDTO> {
            return localVarFp.apiV1SalesOrdersSetSalesOrdersForManualDispatchPost(setSalesOrdersForManualDeliveryCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetSalesOrdersForRegularDeliveryCommand} [setSalesOrdersForRegularDeliveryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersSetSalesOrdersForRegularDeliveryPost(setSalesOrdersForRegularDeliveryCommand?: SetSalesOrdersForRegularDeliveryCommand, options?: any): AxiosPromise<SetSalesOrdersForRegularDeliveryOutputDTO> {
            return localVarFp.apiV1SalesOrdersSetSalesOrdersForRegularDeliveryPost(setSalesOrdersForRegularDeliveryCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetSalesOrdersForSameDayDeliveryCommand} [setSalesOrdersForSameDayDeliveryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersSetSalesOrdersForSameDayDeliveryPost(setSalesOrdersForSameDayDeliveryCommand?: SetSalesOrdersForSameDayDeliveryCommand, options?: any): AxiosPromise<SetSalesOrdersForSameDayDeliveryOutputDTO> {
            return localVarFp.apiV1SalesOrdersSetSalesOrdersForSameDayDeliveryPost(setSalesOrdersForSameDayDeliveryCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetTargetDispatchTimeForSalesOrdersCommand} [setTargetDispatchTimeForSalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersSetTargetDispatchTimeForSalesOrdersPost(setTargetDispatchTimeForSalesOrdersCommand?: SetTargetDispatchTimeForSalesOrdersCommand, options?: any): AxiosPromise<SetTargetDispatchTimeForSalesOrdersOutputDTO> {
            return localVarFp.apiV1SalesOrdersSetTargetDispatchTimeForSalesOrdersPost(setTargetDispatchTimeForSalesOrdersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersShipmentDetailsGet(salesOrderId?: string, options?: any): AxiosPromise<SalesOrderShipmentDetailsOutputDTO> {
            return localVarFp.apiV1SalesOrdersShipmentDetailsGet(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteSLAMForManualDeliverySalesOrdersCommand} [completeSLAMForManualDeliverySalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersSlamCompleteForManualDeliverySalesOrdersPost(completeSLAMForManualDeliverySalesOrdersCommand?: CompleteSLAMForManualDeliverySalesOrdersCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SalesOrdersSlamCompleteForManualDeliverySalesOrdersPost(completeSLAMForManualDeliverySalesOrdersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [salesOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SalesOrdersStateDetailsGet(salesOrderId?: string, options?: any): AxiosPromise<SalesOrdersStateDetailsOutputDTO> {
            return localVarFp.apiV1SalesOrdersStateDetailsGet(salesOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkCreateSalesOrderWithCustomerCommand} [bulkCreateSalesOrderWithCustomerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kittingappV1SalesOrdersBulkCreatePost(bulkCreateSalesOrderWithCustomerCommand?: BulkCreateSalesOrderWithCustomerCommand, options?: any): AxiosPromise<BulkCreateSalesOrderWithCustomerCommandOutputDTO> {
            return localVarFp.kittingappV1SalesOrdersBulkCreatePost(bulkCreateSalesOrderWithCustomerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CancelSalesOrderCommand} [cancelSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kittingappV1SalesOrdersCancelPut(cancelSalesOrderCommand?: CancelSalesOrderCommand, options?: any): AxiosPromise<CancelSalesOrderOutputDTO> {
            return localVarFp.kittingappV1SalesOrdersCancelPut(cancelSalesOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kittingappV1SalesOrdersSalesOrdersQueryOrdersGet(dqb?: string, options?: any): AxiosPromise<SalesOrdersOperationQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.kittingappV1SalesOrdersSalesOrdersQueryOrdersGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddVasDocumentUrlCommand} [addVasDocumentUrlCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1SalesOrdersAddVasDocumentUrlPost(addVasDocumentUrlCommand?: AddVasDocumentUrlCommand, options?: any): AxiosPromise<AddVasDocumentUrlOutputDTO> {
            return localVarFp.openapiV1SalesOrdersAddVasDocumentUrlPost(addVasDocumentUrlCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApproveSalesOrderDispatchCommand} [approveSalesOrderDispatchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1SalesOrdersApproveSalesOrderPut(approveSalesOrderDispatchCommand?: ApproveSalesOrderDispatchCommand, options?: any): AxiosPromise<void> {
            return localVarFp.openapiV1SalesOrdersApproveSalesOrderPut(approveSalesOrderDispatchCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkCreateSalesOrderWithCustomerCommand} [bulkCreateSalesOrderWithCustomerCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1SalesOrdersBulkCreateOverQueuePost(bulkCreateSalesOrderWithCustomerCommand?: BulkCreateSalesOrderWithCustomerCommand, options?: any): AxiosPromise<BulkCreateSalesOrderWithCustomerCommandOutputDTO> {
            return localVarFp.openapiV1SalesOrdersBulkCreateOverQueuePost(bulkCreateSalesOrderWithCustomerCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CancelSalesOrderCommand} [cancelSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1SalesOrdersCancelPut(cancelSalesOrderCommand?: CancelSalesOrderCommand, options?: any): AxiosPromise<CancelSalesOrderOutputDTO> {
            return localVarFp.openapiV1SalesOrdersCancelPut(cancelSalesOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetSalesOrderCargoPackagesByReferenceQuery} [getSalesOrderCargoPackagesByReferenceQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1SalesOrdersGetCargoPackagesPost(getSalesOrderCargoPackagesByReferenceQuery?: GetSalesOrderCargoPackagesByReferenceQuery, options?: any): AxiosPromise<Array<CargoPackageListOutputDTO>> {
            return localVarFp.openapiV1SalesOrdersGetCargoPackagesPost(getSalesOrderCargoPackagesByReferenceQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateSalesOrderCargoInfoCommand} [updateSalesOrderCargoInfoCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1SalesOrdersUpdateCargoInfoPut(updateSalesOrderCargoInfoCommand?: UpdateSalesOrderCargoInfoCommand, options?: any): AxiosPromise<void> {
            return localVarFp.openapiV1SalesOrdersUpdateCargoInfoPut(updateSalesOrderCargoInfoCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateSalesOrderCustomerInfoCommand} [updateSalesOrderCustomerInfoCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiV1SalesOrdersUpdateSalesOrderCustomerInfoPut(updateSalesOrderCustomerInfoCommand?: UpdateSalesOrderCustomerInfoCommand, options?: any): AxiosPromise<void> {
            return localVarFp.openapiV1SalesOrdersUpdateSalesOrderCustomerInfoPut(updateSalesOrderCustomerInfoCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddContainerToSalesOrderCommand} [addContainerToSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersAddContainerToSalesOrderPost(addContainerToSalesOrderCommand?: AddContainerToSalesOrderCommand, options?: any): AxiosPromise<AddContainerToSalesOrderOutputDTO> {
            return localVarFp.supportV1SalesOrdersAddContainerToSalesOrderPost(addContainerToSalesOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddSalesOrderLostItemToToteCommand} [addSalesOrderLostItemToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersAddLostItemsToTotePost(addSalesOrderLostItemToToteCommand?: AddSalesOrderLostItemToToteCommand, options?: any): AxiosPromise<AddLostItemToToteOutputDTO> {
            return localVarFp.supportV1SalesOrdersAddLostItemsToTotePost(addSalesOrderLostItemToToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChangeDeliveryTypeCommand} [changeDeliveryTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersChangeDeliveryTypePost(changeDeliveryTypeCommand?: ChangeDeliveryTypeCommand, options?: any): AxiosPromise<ChangeDeliveryTypeOutputDTO> {
            return localVarFp.supportV1SalesOrdersChangeDeliveryTypePost(changeDeliveryTypeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClearSalesOrderSuspendedStateCommand} [clearSalesOrderSuspendedStateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersClearSalesOrderSuspendedStatePost(clearSalesOrderSuspendedStateCommand?: ClearSalesOrderSuspendedStateCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1SalesOrdersClearSalesOrderSuspendedStatePost(clearSalesOrderSuspendedStateCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CombineSalesOrderItemsToToteCommand} [combineSalesOrderItemsToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersCombineItemsToTotePost(combineSalesOrderItemsToToteCommand?: CombineSalesOrderItemsToToteCommand, options?: any): AxiosPromise<CombineToToteOutputDTO> {
            return localVarFp.supportV1SalesOrdersCombineItemsToTotePost(combineSalesOrderItemsToToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteHOVSalesOrderPackingCommand} [completeHOVSalesOrderPackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersCompleteHOVSalesOrderPackingPost(completeHOVSalesOrderPackingCommand?: CompleteHOVSalesOrderPackingCommand, options?: any): AxiosPromise<SalesOrdersResultOutputDTO> {
            return localVarFp.supportV1SalesOrdersCompleteHOVSalesOrderPackingPost(completeHOVSalesOrderPackingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteHOVSalesOrderPickingCommand} [completeHOVSalesOrderPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersCompleteHOVSalesOrderPickingPost(completeHOVSalesOrderPickingCommand?: CompleteHOVSalesOrderPickingCommand, options?: any): AxiosPromise<SalesOrdersResultOutputDTO> {
            return localVarFp.supportV1SalesOrdersCompleteHOVSalesOrderPickingPost(completeHOVSalesOrderPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteUnassignedHOVSalesOrderPickingCommand} [completeUnassignedHOVSalesOrderPickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersCompleteUnassignedHOVSalesOrderPickingPost(completeUnassignedHOVSalesOrderPickingCommand?: CompleteUnassignedHOVSalesOrderPickingCommand, options?: any): AxiosPromise<SalesOrdersResultOutputDTO> {
            return localVarFp.supportV1SalesOrdersCompleteUnassignedHOVSalesOrderPickingPost(completeUnassignedHOVSalesOrderPickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DispatchSalesOrderWithProblemToDeliverCommand} [dispatchSalesOrderWithProblemToDeliverCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersDispatchSalesOrderWithProblemToDeliverPost(dispatchSalesOrderWithProblemToDeliverCommand?: DispatchSalesOrderWithProblemToDeliverCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1SalesOrdersDispatchSalesOrderWithProblemToDeliverPost(dispatchSalesOrderWithProblemToDeliverCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ForceManualDeliveryCommand} [forceManualDeliveryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersForceManualDeliveryPost(forceManualDeliveryCommand?: ForceManualDeliveryCommand, options?: any): AxiosPromise<ChangeDeliveryTypeOutputDTO> {
            return localVarFp.supportV1SalesOrdersForceManualDeliveryPost(forceManualDeliveryCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [operationName] 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersGetItemsToCombineInfoGet(operationName?: string, referenceNumber?: string, options?: any): AxiosPromise<SalesOrderItemsToCombineOutputDTO> {
            return localVarFp.supportV1SalesOrdersGetItemsToCombineInfoGet(operationName, referenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManuallyDeliverSalesOrdersCommand} [manuallyDeliverSalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersManuallyDeliverSalesOrdersPost(manuallyDeliverSalesOrdersCommand?: ManuallyDeliverSalesOrdersCommand, options?: any): AxiosPromise<SalesOrdersResultOutputDTO> {
            return localVarFp.supportV1SalesOrdersManuallyDeliverSalesOrdersPost(manuallyDeliverSalesOrdersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManuallyDispatchSalesOrdersCommand} [manuallyDispatchSalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersManuallyDispatchSalesOrdersPost(manuallyDispatchSalesOrdersCommand?: ManuallyDispatchSalesOrdersCommand, options?: any): AxiosPromise<SalesOrdersResultOutputDTO> {
            return localVarFp.supportV1SalesOrdersManuallyDispatchSalesOrdersPost(manuallyDispatchSalesOrdersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManuallyPackSalesOrdersCommand} [manuallyPackSalesOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersManuallyPackSalesOrdersPost(manuallyPackSalesOrdersCommand?: ManuallyPackSalesOrdersCommand, options?: any): AxiosPromise<SalesOrdersResultOutputDTO> {
            return localVarFp.supportV1SalesOrdersManuallyPackSalesOrdersPost(manuallyPackSalesOrdersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MarketPlaceSalesOrderDeliverToDispatchCommand} [marketPlaceSalesOrderDeliverToDispatchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersMarketPlaceSalesOrderDeliverToDispatchPost(marketPlaceSalesOrderDeliverToDispatchCommand?: MarketPlaceSalesOrderDeliverToDispatchCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1SalesOrdersMarketPlaceSalesOrderDeliverToDispatchPost(marketPlaceSalesOrderDeliverToDispatchCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MoveContainerItemsCommand} [moveContainerItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersMoveContainerItemsPost(moveContainerItemsCommand?: MoveContainerItemsCommand, options?: any): AxiosPromise<MoveContainerItemsOutputDTO> {
            return localVarFp.supportV1SalesOrdersMoveContainerItemsPost(moveContainerItemsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RemoveContainerFromSalesOrderCommand} [removeContainerFromSalesOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersRemoveContainerFromSalesOrderPost(removeContainerFromSalesOrderCommand?: RemoveContainerFromSalesOrderCommand, options?: any): AxiosPromise<RemoveContainerFromSalesOrderOutputDTO> {
            return localVarFp.supportV1SalesOrdersRemoveContainerFromSalesOrderPost(removeContainerFromSalesOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResetSalesOrderStateToInitialCommand} [resetSalesOrderStateToInitialCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersResetSalesOrderStateToInitialPost(resetSalesOrderStateToInitialCommand?: ResetSalesOrderStateToInitialCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1SalesOrdersResetSalesOrderStateToInitialPost(resetSalesOrderStateToInitialCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResolveSalesOrderProblemsCommand} [resolveSalesOrderProblemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersResolveSalesOrderProblemsPost(resolveSalesOrderProblemsCommand?: ResolveSalesOrderProblemsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1SalesOrdersResolveSalesOrderProblemsPost(resolveSalesOrderProblemsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RevertDispatchedSalesOrderToPackingStateCommand} [revertDispatchedSalesOrderToPackingStateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersRevertDispatchedSalesOrderToPackingPost(revertDispatchedSalesOrderToPackingStateCommand?: RevertDispatchedSalesOrderToPackingStateCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1SalesOrdersRevertDispatchedSalesOrderToPackingPost(revertDispatchedSalesOrderToPackingStateCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RevertToDispatchedCommand} [revertToDispatchedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersRevertToDispatchedPost(revertToDispatchedCommand?: RevertToDispatchedCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1SalesOrdersRevertToDispatchedPost(revertToDispatchedCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReviewLostItemProblemByOrderCommand} [reviewLostItemProblemByOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersReviewLostItemProblemByOrderPost(reviewLostItemProblemByOrderCommand?: ReviewLostItemProblemByOrderCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1SalesOrdersReviewLostItemProblemByOrderPost(reviewLostItemProblemByOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReviewLostItemProblemByTrolleyCommand} [reviewLostItemProblemByTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersReviewLostItemProblemByTrolleyPost(reviewLostItemProblemByTrolleyCommand?: ReviewLostItemProblemByTrolleyCommand, options?: any): AxiosPromise<ReviewLostItemProblemByTrolleyOutputDTO> {
            return localVarFp.supportV1SalesOrdersReviewLostItemProblemByTrolleyPost(reviewLostItemProblemByTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReviewSalesOrderMissingProblemCommand} [reviewSalesOrderMissingProblemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersReviewMissingProblemPost(reviewSalesOrderMissingProblemCommand?: ReviewSalesOrderMissingProblemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1SalesOrdersReviewMissingProblemPost(reviewSalesOrderMissingProblemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RollbackDispatchOrSLAMSalesOrdersToPackingStateCommand} [rollbackDispatchOrSLAMSalesOrdersToPackingStateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersRollbackDispatchOrSLAMSalesOrdersToPackingStatePost(rollbackDispatchOrSLAMSalesOrdersToPackingStateCommand?: RollbackDispatchOrSLAMSalesOrdersToPackingStateCommand, options?: any): AxiosPromise<SalesOrdersResultOutputDTO> {
            return localVarFp.supportV1SalesOrdersRollbackDispatchOrSLAMSalesOrdersToPackingStatePost(rollbackDispatchOrSLAMSalesOrdersToPackingStateCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SLAMSalesOrderWithProblemToDispatchCommand} [sLAMSalesOrderWithProblemToDispatchCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersSLAMSalesOrderWithProblemToDispatchPost(sLAMSalesOrderWithProblemToDispatchCommand?: SLAMSalesOrderWithProblemToDispatchCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1SalesOrdersSLAMSalesOrderWithProblemToDispatchPost(sLAMSalesOrderWithProblemToDispatchCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AutoScaleTestCommand} [autoScaleTestCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersSalesOrdersAutoScaleTestPost(autoScaleTestCommand?: AutoScaleTestCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1SalesOrdersSalesOrdersAutoScaleTestPost(autoScaleTestCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkSyncOperationSalesOrderStatesCommand} [bulkSyncOperationSalesOrderStatesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersSalesOrdersBulkSyncOperationSalesOrdersPost(bulkSyncOperationSalesOrderStatesCommand?: BulkSyncOperationSalesOrderStatesCommand, options?: any): AxiosPromise<BulkSyncResultsOutputDTO> {
            return localVarFp.supportV1SalesOrdersSalesOrdersBulkSyncOperationSalesOrdersPost(bulkSyncOperationSalesOrderStatesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersSalesOrdersGetSalesOrderCargoPackageTypesReportGet(startDate: string, endDate: string, dqb?: string, options?: any): AxiosPromise<SalesOrderCargoPackageTypesOutputDTODynamicQueryOutputDTO> {
            return localVarFp.supportV1SalesOrdersSalesOrdersGetSalesOrderCargoPackageTypesReportGet(startDate, endDate, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateSalesOrderShippingAddressCommand} [updateSalesOrderShippingAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersSalesOrdersUpdateSalesOrderShippingAddressPost(updateSalesOrderShippingAddressCommand?: UpdateSalesOrderShippingAddressCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1SalesOrdersSalesOrdersUpdateSalesOrderShippingAddressPost(updateSalesOrderShippingAddressCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateSalesOrderStatesCommand} [updateSalesOrderStatesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersSalesOrdersUpdateSalesOrderStatesPost(updateSalesOrderStatesCommand?: UpdateSalesOrderStatesCommand, options?: any): AxiosPromise<SalesOrdersResultOutputDTO> {
            return localVarFp.supportV1SalesOrdersSalesOrdersUpdateSalesOrderStatesPost(updateSalesOrderStatesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SyncTotePickListIdCommand} [syncTotePickListIdCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersSyncTotePickListIdPost(syncTotePickListIdCommand?: SyncTotePickListIdCommand, options?: any): AxiosPromise<BulkSyncResultsOutputDTO> {
            return localVarFp.supportV1SalesOrdersSyncTotePickListIdPost(syncTotePickListIdCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateDispatchCompletedAtCommand} [updateDispatchCompletedAtCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersUpdateDispatchCompletedAtPatch(updateDispatchCompletedAtCommand?: UpdateDispatchCompletedAtCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1SalesOrdersUpdateDispatchCompletedAtPatch(updateDispatchCompletedAtCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateGiftNoteCommand} [updateGiftNoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersUpdateGiftNotePost(updateGiftNoteCommand?: UpdateGiftNoteCommand, options?: any): AxiosPromise<UpdateGiftNoteOutputDTO> {
            return localVarFp.supportV1SalesOrdersUpdateGiftNotePost(updateGiftNoteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdatePreferredCargoCarrierCommand} [updatePreferredCargoCarrierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersUpdatePreferredCargoCarrierPost(updatePreferredCargoCarrierCommand?: UpdatePreferredCargoCarrierCommand, options?: any): AxiosPromise<UpdatePreferredCargoCarrierOutputDTO> {
            return localVarFp.supportV1SalesOrdersUpdatePreferredCargoCarrierPost(updatePreferredCargoCarrierCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateSalesOrderShippingTrackingIdCommand} [updateSalesOrderShippingTrackingIdCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersUpdateSalesOrderShippingTrackingIdPost(updateSalesOrderShippingTrackingIdCommand?: UpdateSalesOrderShippingTrackingIdCommand, options?: any): AxiosPromise<void> {
            return localVarFp.supportV1SalesOrdersUpdateSalesOrderShippingTrackingIdPost(updateSalesOrderShippingTrackingIdCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateVasDocumentUrlCommand} [updateVasDocumentUrlCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1SalesOrdersUpdateVasDocumentUrlPost(updateVasDocumentUrlCommand?: UpdateVasDocumentUrlCommand, options?: any): AxiosPromise<UpdateVasDocumentUrlOutputDTO> {
            return localVarFp.supportV1SalesOrdersUpdateVasDocumentUrlPost(updateVasDocumentUrlCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalesOrdersApi - object-oriented interface
 * @export
 * @class SalesOrdersApi
 * @extends {BaseAPI}
 */
export class SalesOrdersApi extends BaseAPI {
    /**
     * 
     * @param {AddCustomActionVasToSalesOrderCommand} [addCustomActionVasToSalesOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersAddCustomActionVasToSalesOrderPost(addCustomActionVasToSalesOrderCommand?: AddCustomActionVasToSalesOrderCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersAddCustomActionVasToSalesOrderPost(addCustomActionVasToSalesOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateCustomActionVASTypeCommand} [createCustomActionVASTypeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersCreateCustomActionVASTypePost(createCustomActionVASTypeCommand?: CreateCustomActionVASTypeCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersCreateCustomActionVASTypePost(createCustomActionVASTypeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSalesOrderNoteCommand} [createSalesOrderNoteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersCreateSalesOrderNotePost(createSalesOrderNoteCommand?: CreateSalesOrderNoteCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersCreateSalesOrderNotePost(createSalesOrderNoteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeliverCargoPackagesForManualDeliverySalesOrdersCommand} [deliverCargoPackagesForManualDeliverySalesOrdersCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersDeliverCargoPackagesForManualDeliverySalesOrdersPost(deliverCargoPackagesForManualDeliverySalesOrdersCommand?: DeliverCargoPackagesForManualDeliverySalesOrdersCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersDeliverCargoPackagesForManualDeliverySalesOrdersPost(deliverCargoPackagesForManualDeliverySalesOrdersCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeliverCargoPackagesForSingleManualDeliverySalesOrderCommand} [deliverCargoPackagesForSingleManualDeliverySalesOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersDeliverCargoPackagesForSingleManualDeliverySalesOrderPost(deliverCargoPackagesForSingleManualDeliverySalesOrderCommand?: DeliverCargoPackagesForSingleManualDeliverySalesOrderCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersDeliverCargoPackagesForSingleManualDeliverySalesOrderPost(deliverCargoPackagesForSingleManualDeliverySalesOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersDetailGet(salesOrderId?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersDetailGet(salesOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {ExcelExtensionType} [fileType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersDownloadCargoPackagesExcelGet(salesOrderId?: string, fileType?: ExcelExtensionType, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersDownloadCargoPackagesExcelGet(salesOrderId, fileType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersGetCustomActionVASTypesGet(options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersGetCustomActionVASTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersGetPickListDetailsGet(salesOrderId?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersGetPickListDetailsGet(salesOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersGetSalesOrderFilterableFieldsGet(options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersGetSalesOrderFilterableFieldsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersGetSalesOrdersInHoldingZoneAddressPost(options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersGetSalesOrdersInHoldingZoneAddressPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersGetUnprintedWaybillOrdersGet(options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersGetUnprintedWaybillOrdersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [referenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersGetWaybillStationInfoGet(referenceNumber?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersGetWaybillStationInfoGet(referenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersListCargoPackagesGet(salesOrderId?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersListCargoPackagesGet(salesOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersListReturnPackagesGet(salesOrderId?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersListReturnPackagesGet(salesOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MarkWaybillAsPrintedCommand} [markWaybillAsPrintedCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersMarkWaybillAsPrintedPost(markWaybillAsPrintedCommand?: MarkWaybillAsPrintedCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersMarkWaybillAsPrintedPost(markWaybillAsPrintedCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintWaybillDocumentCommand} [printWaybillDocumentCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersPrintWaybillDocumentPost(printWaybillDocumentCommand?: PrintWaybillDocumentCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersPrintWaybillDocumentPost(printWaybillDocumentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryCancelledOrdersGet(dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryCancelledOrdersGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryCargoCarrierNamesGet(options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryCargoCarrierNamesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryCreatedOrdersGet(dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryCreatedOrdersGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryDeliveredOrdersGet(dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryDeliveredOrdersGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} salesOrderId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryLineItemsGet(salesOrderId: string, dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryLineItemsGet(salesOrderId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} salesOrderId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryMarketPlaceSalesOrdersGet(salesOrderId: string, dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryMarketPlaceSalesOrdersGet(salesOrderId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} salesOrderId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryOperationalStateDetailsGet(salesOrderId: string, dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryOperationalStateDetailsGet(salesOrderId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} operationId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryOrderTrackingPendingOrdersGet(operationId: string, dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryOrderTrackingPendingOrdersGet(operationId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [operationId] 
     * @param {number} [days] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryOrderTrackingReportSeriesGet(operationId?: string, days?: number, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryOrderTrackingReportSeriesGet(operationId, days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryOrdersGet(dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryOrdersGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryOrdersInDispatchGet(dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryOrdersInDispatchGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryOrdersInPackingGet(dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryOrdersInPackingGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryOrdersInPickingGet(dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryOrdersInPickingGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryOrdersInSLAMGet(dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryOrdersInSLAMGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryOrdersInSortingGet(dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryOrdersInSortingGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} salesOrderId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryPickListItemsGet(salesOrderId: string, dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryPickListItemsGet(salesOrderId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} salesOrderId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQueryProblemsGet(salesOrderId: string, dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQueryProblemsGet(salesOrderId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQuerySalesOrderByProductGet(productId: string, dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQuerySalesOrderByProductGet(productId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [referenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQuerySalesOrderCargoPackagesGet(referenceNumber?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQuerySalesOrderCargoPackagesGet(referenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQuerySalesOrderNotesGet(salesOrderId?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQuerySalesOrderNotesGet(salesOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQuerySalesOrderSerialNumberTrackingsGet(dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQuerySalesOrderSerialNumberTrackingsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} salesOrderId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQuerySalesOrderVasGet(salesOrderId: string, dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQuerySalesOrderVasGet(salesOrderId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQuerySalesOrdersOperationCountGet(dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQuerySalesOrdersOperationCountGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersQuerySalesOrdersWithPickListProblemsGet(dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersQuerySalesOrdersWithPickListProblemsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersRecipientAddressDetailsGet(salesOrderId?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersRecipientAddressDetailsGet(salesOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetSalesOrderPriorityCommand} [setSalesOrderPriorityCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersSetPriorityPost(setSalesOrderPriorityCommand?: SetSalesOrderPriorityCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersSetPriorityPost(setSalesOrderPriorityCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetSalesOrdersForManualDeliveryCommand} [setSalesOrdersForManualDeliveryCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersSetSalesOrdersForManualDispatchPost(setSalesOrdersForManualDeliveryCommand?: SetSalesOrdersForManualDeliveryCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersSetSalesOrdersForManualDispatchPost(setSalesOrdersForManualDeliveryCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetSalesOrdersForRegularDeliveryCommand} [setSalesOrdersForRegularDeliveryCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersSetSalesOrdersForRegularDeliveryPost(setSalesOrdersForRegularDeliveryCommand?: SetSalesOrdersForRegularDeliveryCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersSetSalesOrdersForRegularDeliveryPost(setSalesOrdersForRegularDeliveryCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetSalesOrdersForSameDayDeliveryCommand} [setSalesOrdersForSameDayDeliveryCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersSetSalesOrdersForSameDayDeliveryPost(setSalesOrdersForSameDayDeliveryCommand?: SetSalesOrdersForSameDayDeliveryCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersSetSalesOrdersForSameDayDeliveryPost(setSalesOrdersForSameDayDeliveryCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetTargetDispatchTimeForSalesOrdersCommand} [setTargetDispatchTimeForSalesOrdersCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersSetTargetDispatchTimeForSalesOrdersPost(setTargetDispatchTimeForSalesOrdersCommand?: SetTargetDispatchTimeForSalesOrdersCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersSetTargetDispatchTimeForSalesOrdersPost(setTargetDispatchTimeForSalesOrdersCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersShipmentDetailsGet(salesOrderId?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersShipmentDetailsGet(salesOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteSLAMForManualDeliverySalesOrdersCommand} [completeSLAMForManualDeliverySalesOrdersCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersSlamCompleteForManualDeliverySalesOrdersPost(completeSLAMForManualDeliverySalesOrdersCommand?: CompleteSLAMForManualDeliverySalesOrdersCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersSlamCompleteForManualDeliverySalesOrdersPost(completeSLAMForManualDeliverySalesOrdersCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [salesOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public apiV1SalesOrdersStateDetailsGet(salesOrderId?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).apiV1SalesOrdersStateDetailsGet(salesOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkCreateSalesOrderWithCustomerCommand} [bulkCreateSalesOrderWithCustomerCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public kittingappV1SalesOrdersBulkCreatePost(bulkCreateSalesOrderWithCustomerCommand?: BulkCreateSalesOrderWithCustomerCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).kittingappV1SalesOrdersBulkCreatePost(bulkCreateSalesOrderWithCustomerCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CancelSalesOrderCommand} [cancelSalesOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public kittingappV1SalesOrdersCancelPut(cancelSalesOrderCommand?: CancelSalesOrderCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).kittingappV1SalesOrdersCancelPut(cancelSalesOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public kittingappV1SalesOrdersSalesOrdersQueryOrdersGet(dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).kittingappV1SalesOrdersSalesOrdersQueryOrdersGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddVasDocumentUrlCommand} [addVasDocumentUrlCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public openapiV1SalesOrdersAddVasDocumentUrlPost(addVasDocumentUrlCommand?: AddVasDocumentUrlCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).openapiV1SalesOrdersAddVasDocumentUrlPost(addVasDocumentUrlCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApproveSalesOrderDispatchCommand} [approveSalesOrderDispatchCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public openapiV1SalesOrdersApproveSalesOrderPut(approveSalesOrderDispatchCommand?: ApproveSalesOrderDispatchCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).openapiV1SalesOrdersApproveSalesOrderPut(approveSalesOrderDispatchCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkCreateSalesOrderWithCustomerCommand} [bulkCreateSalesOrderWithCustomerCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public openapiV1SalesOrdersBulkCreateOverQueuePost(bulkCreateSalesOrderWithCustomerCommand?: BulkCreateSalesOrderWithCustomerCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).openapiV1SalesOrdersBulkCreateOverQueuePost(bulkCreateSalesOrderWithCustomerCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CancelSalesOrderCommand} [cancelSalesOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public openapiV1SalesOrdersCancelPut(cancelSalesOrderCommand?: CancelSalesOrderCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).openapiV1SalesOrdersCancelPut(cancelSalesOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetSalesOrderCargoPackagesByReferenceQuery} [getSalesOrderCargoPackagesByReferenceQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public openapiV1SalesOrdersGetCargoPackagesPost(getSalesOrderCargoPackagesByReferenceQuery?: GetSalesOrderCargoPackagesByReferenceQuery, options?: any) {
        return SalesOrdersApiFp(this.configuration).openapiV1SalesOrdersGetCargoPackagesPost(getSalesOrderCargoPackagesByReferenceQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateSalesOrderCargoInfoCommand} [updateSalesOrderCargoInfoCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public openapiV1SalesOrdersUpdateCargoInfoPut(updateSalesOrderCargoInfoCommand?: UpdateSalesOrderCargoInfoCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).openapiV1SalesOrdersUpdateCargoInfoPut(updateSalesOrderCargoInfoCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateSalesOrderCustomerInfoCommand} [updateSalesOrderCustomerInfoCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public openapiV1SalesOrdersUpdateSalesOrderCustomerInfoPut(updateSalesOrderCustomerInfoCommand?: UpdateSalesOrderCustomerInfoCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).openapiV1SalesOrdersUpdateSalesOrderCustomerInfoPut(updateSalesOrderCustomerInfoCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddContainerToSalesOrderCommand} [addContainerToSalesOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersAddContainerToSalesOrderPost(addContainerToSalesOrderCommand?: AddContainerToSalesOrderCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersAddContainerToSalesOrderPost(addContainerToSalesOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddSalesOrderLostItemToToteCommand} [addSalesOrderLostItemToToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersAddLostItemsToTotePost(addSalesOrderLostItemToToteCommand?: AddSalesOrderLostItemToToteCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersAddLostItemsToTotePost(addSalesOrderLostItemToToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChangeDeliveryTypeCommand} [changeDeliveryTypeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersChangeDeliveryTypePost(changeDeliveryTypeCommand?: ChangeDeliveryTypeCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersChangeDeliveryTypePost(changeDeliveryTypeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClearSalesOrderSuspendedStateCommand} [clearSalesOrderSuspendedStateCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersClearSalesOrderSuspendedStatePost(clearSalesOrderSuspendedStateCommand?: ClearSalesOrderSuspendedStateCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersClearSalesOrderSuspendedStatePost(clearSalesOrderSuspendedStateCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CombineSalesOrderItemsToToteCommand} [combineSalesOrderItemsToToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersCombineItemsToTotePost(combineSalesOrderItemsToToteCommand?: CombineSalesOrderItemsToToteCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersCombineItemsToTotePost(combineSalesOrderItemsToToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteHOVSalesOrderPackingCommand} [completeHOVSalesOrderPackingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersCompleteHOVSalesOrderPackingPost(completeHOVSalesOrderPackingCommand?: CompleteHOVSalesOrderPackingCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersCompleteHOVSalesOrderPackingPost(completeHOVSalesOrderPackingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteHOVSalesOrderPickingCommand} [completeHOVSalesOrderPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersCompleteHOVSalesOrderPickingPost(completeHOVSalesOrderPickingCommand?: CompleteHOVSalesOrderPickingCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersCompleteHOVSalesOrderPickingPost(completeHOVSalesOrderPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteUnassignedHOVSalesOrderPickingCommand} [completeUnassignedHOVSalesOrderPickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersCompleteUnassignedHOVSalesOrderPickingPost(completeUnassignedHOVSalesOrderPickingCommand?: CompleteUnassignedHOVSalesOrderPickingCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersCompleteUnassignedHOVSalesOrderPickingPost(completeUnassignedHOVSalesOrderPickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DispatchSalesOrderWithProblemToDeliverCommand} [dispatchSalesOrderWithProblemToDeliverCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersDispatchSalesOrderWithProblemToDeliverPost(dispatchSalesOrderWithProblemToDeliverCommand?: DispatchSalesOrderWithProblemToDeliverCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersDispatchSalesOrderWithProblemToDeliverPost(dispatchSalesOrderWithProblemToDeliverCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ForceManualDeliveryCommand} [forceManualDeliveryCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersForceManualDeliveryPost(forceManualDeliveryCommand?: ForceManualDeliveryCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersForceManualDeliveryPost(forceManualDeliveryCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [operationName] 
     * @param {string} [referenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersGetItemsToCombineInfoGet(operationName?: string, referenceNumber?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersGetItemsToCombineInfoGet(operationName, referenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManuallyDeliverSalesOrdersCommand} [manuallyDeliverSalesOrdersCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersManuallyDeliverSalesOrdersPost(manuallyDeliverSalesOrdersCommand?: ManuallyDeliverSalesOrdersCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersManuallyDeliverSalesOrdersPost(manuallyDeliverSalesOrdersCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManuallyDispatchSalesOrdersCommand} [manuallyDispatchSalesOrdersCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersManuallyDispatchSalesOrdersPost(manuallyDispatchSalesOrdersCommand?: ManuallyDispatchSalesOrdersCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersManuallyDispatchSalesOrdersPost(manuallyDispatchSalesOrdersCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManuallyPackSalesOrdersCommand} [manuallyPackSalesOrdersCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersManuallyPackSalesOrdersPost(manuallyPackSalesOrdersCommand?: ManuallyPackSalesOrdersCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersManuallyPackSalesOrdersPost(manuallyPackSalesOrdersCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MarketPlaceSalesOrderDeliverToDispatchCommand} [marketPlaceSalesOrderDeliverToDispatchCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersMarketPlaceSalesOrderDeliverToDispatchPost(marketPlaceSalesOrderDeliverToDispatchCommand?: MarketPlaceSalesOrderDeliverToDispatchCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersMarketPlaceSalesOrderDeliverToDispatchPost(marketPlaceSalesOrderDeliverToDispatchCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MoveContainerItemsCommand} [moveContainerItemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersMoveContainerItemsPost(moveContainerItemsCommand?: MoveContainerItemsCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersMoveContainerItemsPost(moveContainerItemsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RemoveContainerFromSalesOrderCommand} [removeContainerFromSalesOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersRemoveContainerFromSalesOrderPost(removeContainerFromSalesOrderCommand?: RemoveContainerFromSalesOrderCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersRemoveContainerFromSalesOrderPost(removeContainerFromSalesOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResetSalesOrderStateToInitialCommand} [resetSalesOrderStateToInitialCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersResetSalesOrderStateToInitialPost(resetSalesOrderStateToInitialCommand?: ResetSalesOrderStateToInitialCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersResetSalesOrderStateToInitialPost(resetSalesOrderStateToInitialCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResolveSalesOrderProblemsCommand} [resolveSalesOrderProblemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersResolveSalesOrderProblemsPost(resolveSalesOrderProblemsCommand?: ResolveSalesOrderProblemsCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersResolveSalesOrderProblemsPost(resolveSalesOrderProblemsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RevertDispatchedSalesOrderToPackingStateCommand} [revertDispatchedSalesOrderToPackingStateCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersRevertDispatchedSalesOrderToPackingPost(revertDispatchedSalesOrderToPackingStateCommand?: RevertDispatchedSalesOrderToPackingStateCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersRevertDispatchedSalesOrderToPackingPost(revertDispatchedSalesOrderToPackingStateCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RevertToDispatchedCommand} [revertToDispatchedCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersRevertToDispatchedPost(revertToDispatchedCommand?: RevertToDispatchedCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersRevertToDispatchedPost(revertToDispatchedCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReviewLostItemProblemByOrderCommand} [reviewLostItemProblemByOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersReviewLostItemProblemByOrderPost(reviewLostItemProblemByOrderCommand?: ReviewLostItemProblemByOrderCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersReviewLostItemProblemByOrderPost(reviewLostItemProblemByOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReviewLostItemProblemByTrolleyCommand} [reviewLostItemProblemByTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersReviewLostItemProblemByTrolleyPost(reviewLostItemProblemByTrolleyCommand?: ReviewLostItemProblemByTrolleyCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersReviewLostItemProblemByTrolleyPost(reviewLostItemProblemByTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReviewSalesOrderMissingProblemCommand} [reviewSalesOrderMissingProblemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersReviewMissingProblemPost(reviewSalesOrderMissingProblemCommand?: ReviewSalesOrderMissingProblemCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersReviewMissingProblemPost(reviewSalesOrderMissingProblemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RollbackDispatchOrSLAMSalesOrdersToPackingStateCommand} [rollbackDispatchOrSLAMSalesOrdersToPackingStateCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersRollbackDispatchOrSLAMSalesOrdersToPackingStatePost(rollbackDispatchOrSLAMSalesOrdersToPackingStateCommand?: RollbackDispatchOrSLAMSalesOrdersToPackingStateCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersRollbackDispatchOrSLAMSalesOrdersToPackingStatePost(rollbackDispatchOrSLAMSalesOrdersToPackingStateCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SLAMSalesOrderWithProblemToDispatchCommand} [sLAMSalesOrderWithProblemToDispatchCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersSLAMSalesOrderWithProblemToDispatchPost(sLAMSalesOrderWithProblemToDispatchCommand?: SLAMSalesOrderWithProblemToDispatchCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersSLAMSalesOrderWithProblemToDispatchPost(sLAMSalesOrderWithProblemToDispatchCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AutoScaleTestCommand} [autoScaleTestCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersSalesOrdersAutoScaleTestPost(autoScaleTestCommand?: AutoScaleTestCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersSalesOrdersAutoScaleTestPost(autoScaleTestCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkSyncOperationSalesOrderStatesCommand} [bulkSyncOperationSalesOrderStatesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersSalesOrdersBulkSyncOperationSalesOrdersPost(bulkSyncOperationSalesOrderStatesCommand?: BulkSyncOperationSalesOrderStatesCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersSalesOrdersBulkSyncOperationSalesOrdersPost(bulkSyncOperationSalesOrderStatesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersSalesOrdersGetSalesOrderCargoPackageTypesReportGet(startDate: string, endDate: string, dqb?: string, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersSalesOrdersGetSalesOrderCargoPackageTypesReportGet(startDate, endDate, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateSalesOrderShippingAddressCommand} [updateSalesOrderShippingAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersSalesOrdersUpdateSalesOrderShippingAddressPost(updateSalesOrderShippingAddressCommand?: UpdateSalesOrderShippingAddressCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersSalesOrdersUpdateSalesOrderShippingAddressPost(updateSalesOrderShippingAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateSalesOrderStatesCommand} [updateSalesOrderStatesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersSalesOrdersUpdateSalesOrderStatesPost(updateSalesOrderStatesCommand?: UpdateSalesOrderStatesCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersSalesOrdersUpdateSalesOrderStatesPost(updateSalesOrderStatesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SyncTotePickListIdCommand} [syncTotePickListIdCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersSyncTotePickListIdPost(syncTotePickListIdCommand?: SyncTotePickListIdCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersSyncTotePickListIdPost(syncTotePickListIdCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateDispatchCompletedAtCommand} [updateDispatchCompletedAtCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersUpdateDispatchCompletedAtPatch(updateDispatchCompletedAtCommand?: UpdateDispatchCompletedAtCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersUpdateDispatchCompletedAtPatch(updateDispatchCompletedAtCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateGiftNoteCommand} [updateGiftNoteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersUpdateGiftNotePost(updateGiftNoteCommand?: UpdateGiftNoteCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersUpdateGiftNotePost(updateGiftNoteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdatePreferredCargoCarrierCommand} [updatePreferredCargoCarrierCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersUpdatePreferredCargoCarrierPost(updatePreferredCargoCarrierCommand?: UpdatePreferredCargoCarrierCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersUpdatePreferredCargoCarrierPost(updatePreferredCargoCarrierCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateSalesOrderShippingTrackingIdCommand} [updateSalesOrderShippingTrackingIdCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersUpdateSalesOrderShippingTrackingIdPost(updateSalesOrderShippingTrackingIdCommand?: UpdateSalesOrderShippingTrackingIdCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersUpdateSalesOrderShippingTrackingIdPost(updateSalesOrderShippingTrackingIdCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateVasDocumentUrlCommand} [updateVasDocumentUrlCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    public supportV1SalesOrdersUpdateVasDocumentUrlPost(updateVasDocumentUrlCommand?: UpdateVasDocumentUrlCommand, options?: any) {
        return SalesOrdersApiFp(this.configuration).supportV1SalesOrdersUpdateVasDocumentUrlPost(updateVasDocumentUrlCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SalesOrdersODataApi - axios parameter creator
 * @export
 */
export const SalesOrdersODataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataV1SalesOrdersODataGet: async (authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('odataV1SalesOrdersODataGet', 'authorization', authorization)
            const localVarPath = `/odata/v1/SalesOrdersOData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if ($select !== undefined) {
                localVarQueryParameter['$select'] = $select;
            }

            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }

            if ($expand !== undefined) {
                localVarQueryParameter['$expand'] = $expand;
            }

            if ($orderby !== undefined) {
                localVarQueryParameter['$orderby'] = $orderby;
            }

            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }

            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesOrdersODataApi - functional programming interface
 * @export
 */
export const SalesOrdersODataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesOrdersODataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async odataV1SalesOrdersODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ODataResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.odataV1SalesOrdersODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SalesOrdersODataApi - factory interface
 * @export
 */
export const SalesOrdersODataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesOrdersODataApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization The authorization token
         * @param {string} [$select] Get selected properties
         * @param {string} [$filter] Filter the results using OData syntax.
         * @param {string} [$expand] Get the entities that depend on the model
         * @param {string} [$orderby] Order the results using OData syntax
         * @param {string} [$skip] Skip the specified number of entries
         * @param {string} [$top] Get the top x number of records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odataV1SalesOrdersODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any): AxiosPromise<ODataResponseModel> {
            return localVarFp.odataV1SalesOrdersODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalesOrdersODataApi - object-oriented interface
 * @export
 * @class SalesOrdersODataApi
 * @extends {BaseAPI}
 */
export class SalesOrdersODataApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization The authorization token
     * @param {string} [$select] Get selected properties
     * @param {string} [$filter] Filter the results using OData syntax.
     * @param {string} [$expand] Get the entities that depend on the model
     * @param {string} [$orderby] Order the results using OData syntax
     * @param {string} [$skip] Skip the specified number of entries
     * @param {string} [$top] Get the top x number of records
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersODataApi
     */
    public odataV1SalesOrdersODataGet(authorization: string, $select?: string, $filter?: string, $expand?: string, $orderby?: string, $skip?: string, $top?: string, options?: any) {
        return SalesOrdersODataApiFp(this.configuration).odataV1SalesOrdersODataGet(authorization, $select, $filter, $expand, $orderby, $skip, $top, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShippingItemsApi - axios parameter creator
 * @export
 */
export const ShippingItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [cargoPackageLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ShippingItemsGetShippingItemsByCargoPackageLabelGet: async (cargoPackageLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ShippingItems.getShippingItemsByCargoPackageLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cargoPackageLabel !== undefined) {
                localVarQueryParameter['cargoPackageLabel'] = cargoPackageLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ShippingItemsGetShippingItemsCountGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ShippingItems.getShippingItemsCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ShippingItemsQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ShippingItems.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ShippingItemsQueryShippingItemExpirationDateTrackingsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ShippingItems.queryShippingItemExpirationDateTrackings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ShippingItemsQueryShippingItemsByProductWithSerialNumberGet: async (productId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiV1ShippingItemsQueryShippingItemsByProductWithSerialNumberGet', 'productId', productId)
            const localVarPath = `/api/v1/ShippingItems.queryShippingItemsByProductWithSerialNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShippingItemsApi - functional programming interface
 * @export
 */
export const ShippingItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShippingItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [cargoPackageLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ShippingItemsGetShippingItemsByCargoPackageLabelGet(cargoPackageLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShippingItemGetByCargoPackageLabelGroupByDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ShippingItemsGetShippingItemsByCargoPackageLabelGet(cargoPackageLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ShippingItemsGetShippingItemsCountGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShippingItemCountOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ShippingItemsGetShippingItemsCountGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ShippingItemsQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShippingItemOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ShippingItemsQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ShippingItemsQueryShippingItemExpirationDateTrackingsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShippingItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ShippingItemsQueryShippingItemExpirationDateTrackingsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ShippingItemsQueryShippingItemsByProductWithSerialNumberGet(productId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShippingItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ShippingItemsQueryShippingItemsByProductWithSerialNumberGet(productId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShippingItemsApi - factory interface
 * @export
 */
export const ShippingItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShippingItemsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [cargoPackageLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ShippingItemsGetShippingItemsByCargoPackageLabelGet(cargoPackageLabel?: string, options?: any): AxiosPromise<Array<ShippingItemGetByCargoPackageLabelGroupByDTO>> {
            return localVarFp.apiV1ShippingItemsGetShippingItemsByCargoPackageLabelGet(cargoPackageLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ShippingItemsGetShippingItemsCountGet(dqb?: string, options?: any): AxiosPromise<ShippingItemCountOutputDTO> {
            return localVarFp.apiV1ShippingItemsGetShippingItemsCountGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ShippingItemsQueryGet(dqb?: string, options?: any): AxiosPromise<ShippingItemOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ShippingItemsQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ShippingItemsQueryShippingItemExpirationDateTrackingsGet(dqb?: string, options?: any): AxiosPromise<ShippingItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ShippingItemsQueryShippingItemExpirationDateTrackingsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ShippingItemsQueryShippingItemsByProductWithSerialNumberGet(productId: string, dqb?: string, options?: any): AxiosPromise<ShippingItemExpirationDateAndSerialNoTrackingOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ShippingItemsQueryShippingItemsByProductWithSerialNumberGet(productId, dqb, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShippingItemsApi - object-oriented interface
 * @export
 * @class ShippingItemsApi
 * @extends {BaseAPI}
 */
export class ShippingItemsApi extends BaseAPI {
    /**
     * 
     * @param {string} [cargoPackageLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingItemsApi
     */
    public apiV1ShippingItemsGetShippingItemsByCargoPackageLabelGet(cargoPackageLabel?: string, options?: any) {
        return ShippingItemsApiFp(this.configuration).apiV1ShippingItemsGetShippingItemsByCargoPackageLabelGet(cargoPackageLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingItemsApi
     */
    public apiV1ShippingItemsGetShippingItemsCountGet(dqb?: string, options?: any) {
        return ShippingItemsApiFp(this.configuration).apiV1ShippingItemsGetShippingItemsCountGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingItemsApi
     */
    public apiV1ShippingItemsQueryGet(dqb?: string, options?: any) {
        return ShippingItemsApiFp(this.configuration).apiV1ShippingItemsQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingItemsApi
     */
    public apiV1ShippingItemsQueryShippingItemExpirationDateTrackingsGet(dqb?: string, options?: any) {
        return ShippingItemsApiFp(this.configuration).apiV1ShippingItemsQueryShippingItemExpirationDateTrackingsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingItemsApi
     */
    public apiV1ShippingItemsQueryShippingItemsByProductWithSerialNumberGet(productId: string, dqb?: string, options?: any) {
        return ShippingItemsApiFp(this.configuration).apiV1ShippingItemsQueryShippingItemsByProductWithSerialNumberGet(productId, dqb, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SimplePackingProcessApi - axios parameter creator
 * @export
 */
export const SimplePackingProcessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddSimpleCargoPackageCommand} [addSimpleCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePackingProcessAddCargoPackagePost: async (addSimpleCargoPackageCommand?: AddSimpleCargoPackageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SimplePackingProcess.addCargoPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSimpleCargoPackageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [simplePackingAddress] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePackingProcessCheckPackingProcessExistsGet: async (simplePackingAddress?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SimplePackingProcess.checkPackingProcessExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (simplePackingAddress !== undefined) {
                localVarQueryParameter['simplePackingAddress'] = simplePackingAddress;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteSimplePackingProcessCommand} [completeSimplePackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePackingProcessCompletePackingProcessPost: async (completeSimplePackingProcessCommand?: CompleteSimplePackingProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SimplePackingProcess.completePackingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeSimplePackingProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSimplePackingProcessCommand} [createSimplePackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePackingProcessCreatePackingProcessPost: async (createSimplePackingProcessCommand?: CreateSimplePackingProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SimplePackingProcess.createPackingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSimplePackingProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintCargoPackageLabelsCommand} [printCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePackingProcessPrintCargoPackageLabelsPost: async (printCargoPackageLabelsCommand?: PrintCargoPackageLabelsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SimplePackingProcess.printCargoPackageLabels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printCargoPackageLabelsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintSLAMDocumentsOnSimplePackingCommand} [printSLAMDocumentsOnSimplePackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePackingProcessPrintSLAMDocumentsPost: async (printSLAMDocumentsOnSimplePackingCommand?: PrintSLAMDocumentsOnSimplePackingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SimplePackingProcess.printSLAMDocuments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printSLAMDocumentsOnSimplePackingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueueItemsIntoCargoPackageCommand} [queueItemsIntoCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePackingProcessQueueItemsIntoCargoPackagePost: async (queueItemsIntoCargoPackageCommand?: QueueItemsIntoCargoPackageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SimplePackingProcess.queueItemsIntoCargoPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queueItemsIntoCargoPackageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePackingProcessTotesReadyToPackGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SimplePackingProcess.totesReadyToPack`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SimplePackingProcessApi - functional programming interface
 * @export
 */
export const SimplePackingProcessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SimplePackingProcessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddSimpleCargoPackageCommand} [addSimpleCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SimplePackingProcessAddCargoPackagePost(addSimpleCargoPackageCommand?: AddSimpleCargoPackageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddCargoPackageCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SimplePackingProcessAddCargoPackagePost(addSimpleCargoPackageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [simplePackingAddress] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SimplePackingProcessCheckPackingProcessExistsGet(simplePackingAddress?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimplePackingProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SimplePackingProcessCheckPackingProcessExistsGet(simplePackingAddress, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteSimplePackingProcessCommand} [completeSimplePackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SimplePackingProcessCompletePackingProcessPost(completeSimplePackingProcessCommand?: CompleteSimplePackingProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SimplePackingProcessCompletePackingProcessPost(completeSimplePackingProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSimplePackingProcessCommand} [createSimplePackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SimplePackingProcessCreatePackingProcessPost(createSimplePackingProcessCommand?: CreateSimplePackingProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimplePackingProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SimplePackingProcessCreatePackingProcessPost(createSimplePackingProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintCargoPackageLabelsCommand} [printCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SimplePackingProcessPrintCargoPackageLabelsPost(printCargoPackageLabelsCommand?: PrintCargoPackageLabelsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SimplePackingProcessPrintCargoPackageLabelsPost(printCargoPackageLabelsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintSLAMDocumentsOnSimplePackingCommand} [printSLAMDocumentsOnSimplePackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SimplePackingProcessPrintSLAMDocumentsPost(printSLAMDocumentsOnSimplePackingCommand?: PrintSLAMDocumentsOnSimplePackingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrintSLAMDocumentsOnPackingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SimplePackingProcessPrintSLAMDocumentsPost(printSLAMDocumentsOnSimplePackingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {QueueItemsIntoCargoPackageCommand} [queueItemsIntoCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SimplePackingProcessQueueItemsIntoCargoPackagePost(queueItemsIntoCargoPackageCommand?: QueueItemsIntoCargoPackageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SimplePackingProcessQueueItemsIntoCargoPackagePost(queueItemsIntoCargoPackageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SimplePackingProcessTotesReadyToPackGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimplePackingTotesReadyToPackOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SimplePackingProcessTotesReadyToPackGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SimplePackingProcessApi - factory interface
 * @export
 */
export const SimplePackingProcessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SimplePackingProcessApiFp(configuration)
    return {
        /**
         * 
         * @param {AddSimpleCargoPackageCommand} [addSimpleCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePackingProcessAddCargoPackagePost(addSimpleCargoPackageCommand?: AddSimpleCargoPackageCommand, options?: any): AxiosPromise<AddCargoPackageCommandOutputDTO> {
            return localVarFp.apiV1SimplePackingProcessAddCargoPackagePost(addSimpleCargoPackageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [simplePackingAddress] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePackingProcessCheckPackingProcessExistsGet(simplePackingAddress?: string, options?: any): AxiosPromise<SimplePackingProcessOutputDTO> {
            return localVarFp.apiV1SimplePackingProcessCheckPackingProcessExistsGet(simplePackingAddress, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteSimplePackingProcessCommand} [completeSimplePackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePackingProcessCompletePackingProcessPost(completeSimplePackingProcessCommand?: CompleteSimplePackingProcessCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SimplePackingProcessCompletePackingProcessPost(completeSimplePackingProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSimplePackingProcessCommand} [createSimplePackingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePackingProcessCreatePackingProcessPost(createSimplePackingProcessCommand?: CreateSimplePackingProcessCommand, options?: any): AxiosPromise<SimplePackingProcessOutputDTO> {
            return localVarFp.apiV1SimplePackingProcessCreatePackingProcessPost(createSimplePackingProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintCargoPackageLabelsCommand} [printCargoPackageLabelsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePackingProcessPrintCargoPackageLabelsPost(printCargoPackageLabelsCommand?: PrintCargoPackageLabelsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SimplePackingProcessPrintCargoPackageLabelsPost(printCargoPackageLabelsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintSLAMDocumentsOnSimplePackingCommand} [printSLAMDocumentsOnSimplePackingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePackingProcessPrintSLAMDocumentsPost(printSLAMDocumentsOnSimplePackingCommand?: PrintSLAMDocumentsOnSimplePackingCommand, options?: any): AxiosPromise<PrintSLAMDocumentsOnPackingOutputDTO> {
            return localVarFp.apiV1SimplePackingProcessPrintSLAMDocumentsPost(printSLAMDocumentsOnSimplePackingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueueItemsIntoCargoPackageCommand} [queueItemsIntoCargoPackageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePackingProcessQueueItemsIntoCargoPackagePost(queueItemsIntoCargoPackageCommand?: QueueItemsIntoCargoPackageCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SimplePackingProcessQueueItemsIntoCargoPackagePost(queueItemsIntoCargoPackageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePackingProcessTotesReadyToPackGet(options?: any): AxiosPromise<Array<SimplePackingTotesReadyToPackOutputDTO>> {
            return localVarFp.apiV1SimplePackingProcessTotesReadyToPackGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SimplePackingProcessApi - object-oriented interface
 * @export
 * @class SimplePackingProcessApi
 * @extends {BaseAPI}
 */
export class SimplePackingProcessApi extends BaseAPI {
    /**
     * 
     * @param {AddSimpleCargoPackageCommand} [addSimpleCargoPackageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimplePackingProcessApi
     */
    public apiV1SimplePackingProcessAddCargoPackagePost(addSimpleCargoPackageCommand?: AddSimpleCargoPackageCommand, options?: any) {
        return SimplePackingProcessApiFp(this.configuration).apiV1SimplePackingProcessAddCargoPackagePost(addSimpleCargoPackageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [simplePackingAddress] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimplePackingProcessApi
     */
    public apiV1SimplePackingProcessCheckPackingProcessExistsGet(simplePackingAddress?: string, options?: any) {
        return SimplePackingProcessApiFp(this.configuration).apiV1SimplePackingProcessCheckPackingProcessExistsGet(simplePackingAddress, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteSimplePackingProcessCommand} [completeSimplePackingProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimplePackingProcessApi
     */
    public apiV1SimplePackingProcessCompletePackingProcessPost(completeSimplePackingProcessCommand?: CompleteSimplePackingProcessCommand, options?: any) {
        return SimplePackingProcessApiFp(this.configuration).apiV1SimplePackingProcessCompletePackingProcessPost(completeSimplePackingProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSimplePackingProcessCommand} [createSimplePackingProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimplePackingProcessApi
     */
    public apiV1SimplePackingProcessCreatePackingProcessPost(createSimplePackingProcessCommand?: CreateSimplePackingProcessCommand, options?: any) {
        return SimplePackingProcessApiFp(this.configuration).apiV1SimplePackingProcessCreatePackingProcessPost(createSimplePackingProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintCargoPackageLabelsCommand} [printCargoPackageLabelsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimplePackingProcessApi
     */
    public apiV1SimplePackingProcessPrintCargoPackageLabelsPost(printCargoPackageLabelsCommand?: PrintCargoPackageLabelsCommand, options?: any) {
        return SimplePackingProcessApiFp(this.configuration).apiV1SimplePackingProcessPrintCargoPackageLabelsPost(printCargoPackageLabelsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintSLAMDocumentsOnSimplePackingCommand} [printSLAMDocumentsOnSimplePackingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimplePackingProcessApi
     */
    public apiV1SimplePackingProcessPrintSLAMDocumentsPost(printSLAMDocumentsOnSimplePackingCommand?: PrintSLAMDocumentsOnSimplePackingCommand, options?: any) {
        return SimplePackingProcessApiFp(this.configuration).apiV1SimplePackingProcessPrintSLAMDocumentsPost(printSLAMDocumentsOnSimplePackingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueueItemsIntoCargoPackageCommand} [queueItemsIntoCargoPackageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimplePackingProcessApi
     */
    public apiV1SimplePackingProcessQueueItemsIntoCargoPackagePost(queueItemsIntoCargoPackageCommand?: QueueItemsIntoCargoPackageCommand, options?: any) {
        return SimplePackingProcessApiFp(this.configuration).apiV1SimplePackingProcessQueueItemsIntoCargoPackagePost(queueItemsIntoCargoPackageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimplePackingProcessApi
     */
    public apiV1SimplePackingProcessTotesReadyToPackGet(options?: any) {
        return SimplePackingProcessApiFp(this.configuration).apiV1SimplePackingProcessTotesReadyToPackGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SimplePickingProcessApi - axios parameter creator
 * @export
 */
export const SimplePickingProcessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CheckCellCommand} [checkCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePickingProcessCheckCellPost: async (checkCellCommand?: CheckCellCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SimplePickingProcess.checkCell`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkCellCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckPickingItemExistCommand} [checkPickingItemExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePickingProcessCheckProductExistPost: async (checkPickingItemExistCommand?: CheckPickingItemExistCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SimplePickingProcess.checkProductExist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkPickingItemExistCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteSimplePickingProcessCommand} [completeSimplePickingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePickingProcessCompletePickingProcessPost: async (completeSimplePickingProcessCommand?: CompleteSimplePickingProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SimplePickingProcess.completePickingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeSimplePickingProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ContinueCreatedSimplePickingCommand} [continueCreatedSimplePickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePickingProcessContinuePickingPost: async (continueCreatedSimplePickingCommand?: ContinueCreatedSimplePickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SimplePickingProcess.continuePicking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(continueCreatedSimplePickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePickingProcessGetZoneByCellLabelGet: async (cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SimplePickingProcess.getZoneByCellLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceProductToSimplePickingToteCommand} [placeProductToSimplePickingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePickingProcessPlaceProductPost: async (placeProductToSimplePickingToteCommand?: PlaceProductToSimplePickingToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SimplePickingProcess.placeProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeProductToSimplePickingToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartCreatedSimplePickingCommand} [startCreatedSimplePickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePickingProcessStartCreatedPickingPost: async (startCreatedSimplePickingCommand?: StartCreatedSimplePickingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SimplePickingProcess.startCreatedPicking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startCreatedSimplePickingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SimplePickingProcessApi - functional programming interface
 * @export
 */
export const SimplePickingProcessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SimplePickingProcessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CheckCellCommand} [checkCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SimplePickingProcessCheckCellPost(checkCellCommand?: CheckCellCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SimplePickingProcessCheckCellPost(checkCellCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckPickingItemExistCommand} [checkPickingItemExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SimplePickingProcessCheckProductExistPost(checkPickingItemExistCommand?: CheckPickingItemExistCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SimplePickingProcessCheckProductExistPost(checkPickingItemExistCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteSimplePickingProcessCommand} [completeSimplePickingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SimplePickingProcessCompletePickingProcessPost(completeSimplePickingProcessCommand?: CompleteSimplePickingProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SimplePickingProcessCompletePickingProcessPost(completeSimplePickingProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ContinueCreatedSimplePickingCommand} [continueCreatedSimplePickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SimplePickingProcessContinuePickingPost(continueCreatedSimplePickingCommand?: ContinueCreatedSimplePickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimplePickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SimplePickingProcessContinuePickingPost(continueCreatedSimplePickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SimplePickingProcessGetZoneByCellLabelGet(cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetZoneByCellLabelOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SimplePickingProcessGetZoneByCellLabelGet(cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceProductToSimplePickingToteCommand} [placeProductToSimplePickingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SimplePickingProcessPlaceProductPost(placeProductToSimplePickingToteCommand?: PlaceProductToSimplePickingToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimplePickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SimplePickingProcessPlaceProductPost(placeProductToSimplePickingToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StartCreatedSimplePickingCommand} [startCreatedSimplePickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SimplePickingProcessStartCreatedPickingPost(startCreatedSimplePickingCommand?: StartCreatedSimplePickingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimplePickingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SimplePickingProcessStartCreatedPickingPost(startCreatedSimplePickingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SimplePickingProcessApi - factory interface
 * @export
 */
export const SimplePickingProcessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SimplePickingProcessApiFp(configuration)
    return {
        /**
         * 
         * @param {CheckCellCommand} [checkCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePickingProcessCheckCellPost(checkCellCommand?: CheckCellCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SimplePickingProcessCheckCellPost(checkCellCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckPickingItemExistCommand} [checkPickingItemExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePickingProcessCheckProductExistPost(checkPickingItemExistCommand?: CheckPickingItemExistCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SimplePickingProcessCheckProductExistPost(checkPickingItemExistCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteSimplePickingProcessCommand} [completeSimplePickingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePickingProcessCompletePickingProcessPost(completeSimplePickingProcessCommand?: CompleteSimplePickingProcessCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SimplePickingProcessCompletePickingProcessPost(completeSimplePickingProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContinueCreatedSimplePickingCommand} [continueCreatedSimplePickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePickingProcessContinuePickingPost(continueCreatedSimplePickingCommand?: ContinueCreatedSimplePickingCommand, options?: any): AxiosPromise<SimplePickingOutputDTO> {
            return localVarFp.apiV1SimplePickingProcessContinuePickingPost(continueCreatedSimplePickingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePickingProcessGetZoneByCellLabelGet(cellLabel?: string, options?: any): AxiosPromise<GetZoneByCellLabelOutputDTO> {
            return localVarFp.apiV1SimplePickingProcessGetZoneByCellLabelGet(cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceProductToSimplePickingToteCommand} [placeProductToSimplePickingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePickingProcessPlaceProductPost(placeProductToSimplePickingToteCommand?: PlaceProductToSimplePickingToteCommand, options?: any): AxiosPromise<SimplePickingOutputDTO> {
            return localVarFp.apiV1SimplePickingProcessPlaceProductPost(placeProductToSimplePickingToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StartCreatedSimplePickingCommand} [startCreatedSimplePickingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SimplePickingProcessStartCreatedPickingPost(startCreatedSimplePickingCommand?: StartCreatedSimplePickingCommand, options?: any): AxiosPromise<SimplePickingOutputDTO> {
            return localVarFp.apiV1SimplePickingProcessStartCreatedPickingPost(startCreatedSimplePickingCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SimplePickingProcessApi - object-oriented interface
 * @export
 * @class SimplePickingProcessApi
 * @extends {BaseAPI}
 */
export class SimplePickingProcessApi extends BaseAPI {
    /**
     * 
     * @param {CheckCellCommand} [checkCellCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimplePickingProcessApi
     */
    public apiV1SimplePickingProcessCheckCellPost(checkCellCommand?: CheckCellCommand, options?: any) {
        return SimplePickingProcessApiFp(this.configuration).apiV1SimplePickingProcessCheckCellPost(checkCellCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckPickingItemExistCommand} [checkPickingItemExistCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimplePickingProcessApi
     */
    public apiV1SimplePickingProcessCheckProductExistPost(checkPickingItemExistCommand?: CheckPickingItemExistCommand, options?: any) {
        return SimplePickingProcessApiFp(this.configuration).apiV1SimplePickingProcessCheckProductExistPost(checkPickingItemExistCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteSimplePickingProcessCommand} [completeSimplePickingProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimplePickingProcessApi
     */
    public apiV1SimplePickingProcessCompletePickingProcessPost(completeSimplePickingProcessCommand?: CompleteSimplePickingProcessCommand, options?: any) {
        return SimplePickingProcessApiFp(this.configuration).apiV1SimplePickingProcessCompletePickingProcessPost(completeSimplePickingProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContinueCreatedSimplePickingCommand} [continueCreatedSimplePickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimplePickingProcessApi
     */
    public apiV1SimplePickingProcessContinuePickingPost(continueCreatedSimplePickingCommand?: ContinueCreatedSimplePickingCommand, options?: any) {
        return SimplePickingProcessApiFp(this.configuration).apiV1SimplePickingProcessContinuePickingPost(continueCreatedSimplePickingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimplePickingProcessApi
     */
    public apiV1SimplePickingProcessGetZoneByCellLabelGet(cellLabel?: string, options?: any) {
        return SimplePickingProcessApiFp(this.configuration).apiV1SimplePickingProcessGetZoneByCellLabelGet(cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceProductToSimplePickingToteCommand} [placeProductToSimplePickingToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimplePickingProcessApi
     */
    public apiV1SimplePickingProcessPlaceProductPost(placeProductToSimplePickingToteCommand?: PlaceProductToSimplePickingToteCommand, options?: any) {
        return SimplePickingProcessApiFp(this.configuration).apiV1SimplePickingProcessPlaceProductPost(placeProductToSimplePickingToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StartCreatedSimplePickingCommand} [startCreatedSimplePickingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimplePickingProcessApi
     */
    public apiV1SimplePickingProcessStartCreatedPickingPost(startCreatedSimplePickingCommand?: StartCreatedSimplePickingCommand, options?: any) {
        return SimplePickingProcessApiFp(this.configuration).apiV1SimplePickingProcessStartCreatedPickingPost(startCreatedSimplePickingCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SingleItemReceivingApi - axios parameter creator
 * @export
 */
export const SingleItemReceivingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [receivingProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingCheckBarcodeTypeGet: async (barcode?: string, receivingProcessId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.checkBarcodeType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }

            if (receivingProcessId !== undefined) {
                localVarQueryParameter['receivingProcessId'] = receivingProcessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [receivingProcessId] 
         * @param {string} [barcode] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingCheckExpirationDateIsExpiredGet: async (receivingProcessId?: string, barcode?: string, expirationDate?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.checkExpirationDateIsExpired`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (receivingProcessId !== undefined) {
                localVarQueryParameter['receivingProcessId'] = receivingProcessId;
            }

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }

            if (expirationDate !== undefined) {
                localVarQueryParameter['expirationDate'] = (expirationDate as any instanceof Date) ?
                    (expirationDate as any).toISOString() :
                    expirationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteSingleItemReceivingCommand} [completeSingleItemReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingCompletePost: async (completeSingleItemReceivingCommand?: CompleteSingleItemReceivingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeSingleItemReceivingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SingleItemReceivingCreateProcessIfNotExistsCommand} [singleItemReceivingCreateProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingCreateIfNotExistsPost: async (singleItemReceivingCreateProcessIfNotExistsCommand?: SingleItemReceivingCreateProcessIfNotExistsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.createIfNotExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(singleItemReceivingCreateProcessIfNotExistsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteLastDamagedItemCommand} [deleteLastDamagedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingDeleteLastDamagedItemPost: async (deleteLastDamagedItemCommand?: DeleteLastDamagedItemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.deleteLastDamagedItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteLastDamagedItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteLastReceivedItemCommand} [deleteLastReceivedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingDeleteLastReceivedItemPost: async (deleteLastReceivedItemCommand?: DeleteLastReceivedItemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.deleteLastReceivedItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteLastReceivedItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingGetInboundBoxDetailsGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.getInboundBoxDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingGetQuarantineToteDetailsGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.getQuarantineToteDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingGetReceivingContainerDetailsGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.getReceivingContainerDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [receivingToteLabel] 
         * @param {string} [quarantineToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingGetTotalItemAmountGet: async (receivingToteLabel?: string, quarantineToteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.getTotalItemAmount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (receivingToteLabel !== undefined) {
                localVarQueryParameter['receivingToteLabel'] = receivingToteLabel;
            }

            if (quarantineToteLabel !== undefined) {
                localVarQueryParameter['quarantineToteLabel'] = quarantineToteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceItemToQuarantineToteCommand} [placeItemToQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingPlaceItemToQuarantineTotePost: async (placeItemToQuarantineToteCommand?: PlaceItemToQuarantineToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.placeItemToQuarantineTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeItemToQuarantineToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceItemToReceivingToteCommand} [placeItemToReceivingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingPlaceItemToReceivingTotePost: async (placeItemToReceivingToteCommand?: PlaceItemToReceivingToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.placeItemToReceivingTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeItemToReceivingToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SelectContainerForReceivingCommand} [selectContainerForReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingSelectContainerForReceivingPost: async (selectContainerForReceivingCommand?: SelectContainerForReceivingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.selectContainerForReceiving`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectContainerForReceivingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SelectToteForMeasurementCommand} [selectToteForMeasurementCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingSelectToteForMeasurementPost: async (selectToteForMeasurementCommand?: SelectToteForMeasurementCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.selectToteForMeasurement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectToteForMeasurementCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SelectToteForQuarantineCommand} [selectToteForQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingSelectToteForQuarantinePost: async (selectToteForQuarantineCommand?: SelectToteForQuarantineCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.selectToteForQuarantine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectToteForQuarantineCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferItemToQuarantineCommand} [transferItemToQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingTransferItemToQuarantinePost: async (transferItemToQuarantineCommand?: TransferItemToQuarantineCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.transferItemToQuarantine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferItemToQuarantineCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingUploadDamagedItemImagePost: async (file?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SingleItemReceiving.uploadDamagedItemImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SingleItemReceivingApi - functional programming interface
 * @export
 */
export const SingleItemReceivingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SingleItemReceivingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [receivingProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingCheckBarcodeTypeGet(barcode?: string, receivingProcessId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckBarcodeTypeForSingleItemReceivingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingCheckBarcodeTypeGet(barcode, receivingProcessId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [receivingProcessId] 
         * @param {string} [barcode] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingCheckExpirationDateIsExpiredGet(receivingProcessId?: string, barcode?: string, expirationDate?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingCheckExpirationDateIsExpiredGet(receivingProcessId, barcode, expirationDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteSingleItemReceivingCommand} [completeSingleItemReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingCompletePost(completeSingleItemReceivingCommand?: CompleteSingleItemReceivingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingCompletePost(completeSingleItemReceivingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SingleItemReceivingCreateProcessIfNotExistsCommand} [singleItemReceivingCreateProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingCreateIfNotExistsPost(singleItemReceivingCreateProcessIfNotExistsCommand?: SingleItemReceivingCreateProcessIfNotExistsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleItemReceivingCreateProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingCreateIfNotExistsPost(singleItemReceivingCreateProcessIfNotExistsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteLastDamagedItemCommand} [deleteLastDamagedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingDeleteLastDamagedItemPost(deleteLastDamagedItemCommand?: DeleteLastDamagedItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingDeleteLastDamagedItemPost(deleteLastDamagedItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteLastReceivedItemCommand} [deleteLastReceivedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingDeleteLastReceivedItemPost(deleteLastReceivedItemCommand?: DeleteLastReceivedItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingDeleteLastReceivedItemPost(deleteLastReceivedItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingGetInboundBoxDetailsGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleItemReceivingInboundBoxDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingGetInboundBoxDetailsGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingGetQuarantineToteDetailsGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuarantineToteDetailsForSingleItemReceivingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingGetQuarantineToteDetailsGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingGetReceivingContainerDetailsGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReceivingContainerDetailsForSingleItemReceivingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingGetReceivingContainerDetailsGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [receivingToteLabel] 
         * @param {string} [quarantineToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingGetTotalItemAmountGet(receivingToteLabel?: string, quarantineToteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleItemReceivingTotalItemAmountOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingGetTotalItemAmountGet(receivingToteLabel, quarantineToteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceItemToQuarantineToteCommand} [placeItemToQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingPlaceItemToQuarantineTotePost(placeItemToQuarantineToteCommand?: PlaceItemToQuarantineToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceItemToQuarantineToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingPlaceItemToQuarantineTotePost(placeItemToQuarantineToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceItemToReceivingToteCommand} [placeItemToReceivingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingPlaceItemToReceivingTotePost(placeItemToReceivingToteCommand?: PlaceItemToReceivingToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceItemToReceivingToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingPlaceItemToReceivingTotePost(placeItemToReceivingToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SelectContainerForReceivingCommand} [selectContainerForReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingSelectContainerForReceivingPost(selectContainerForReceivingCommand?: SelectContainerForReceivingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingSelectContainerForReceivingPost(selectContainerForReceivingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SelectToteForMeasurementCommand} [selectToteForMeasurementCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingSelectToteForMeasurementPost(selectToteForMeasurementCommand?: SelectToteForMeasurementCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingSelectToteForMeasurementPost(selectToteForMeasurementCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SelectToteForQuarantineCommand} [selectToteForQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingSelectToteForQuarantinePost(selectToteForQuarantineCommand?: SelectToteForQuarantineCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingSelectToteForQuarantinePost(selectToteForQuarantineCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferItemToQuarantineCommand} [transferItemToQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingTransferItemToQuarantinePost(transferItemToQuarantineCommand?: TransferItemToQuarantineCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingTransferItemToQuarantinePost(transferItemToQuarantineCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SingleItemReceivingUploadDamagedItemImagePost(file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SingleItemReceivingUploadDamagedItemImagePost(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SingleItemReceivingApi - factory interface
 * @export
 */
export const SingleItemReceivingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SingleItemReceivingApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [receivingProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingCheckBarcodeTypeGet(barcode?: string, receivingProcessId?: string, options?: any): AxiosPromise<CheckBarcodeTypeForSingleItemReceivingOutputDTO> {
            return localVarFp.apiV1SingleItemReceivingCheckBarcodeTypeGet(barcode, receivingProcessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [receivingProcessId] 
         * @param {string} [barcode] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingCheckExpirationDateIsExpiredGet(receivingProcessId?: string, barcode?: string, expirationDate?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SingleItemReceivingCheckExpirationDateIsExpiredGet(receivingProcessId, barcode, expirationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteSingleItemReceivingCommand} [completeSingleItemReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingCompletePost(completeSingleItemReceivingCommand?: CompleteSingleItemReceivingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SingleItemReceivingCompletePost(completeSingleItemReceivingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SingleItemReceivingCreateProcessIfNotExistsCommand} [singleItemReceivingCreateProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingCreateIfNotExistsPost(singleItemReceivingCreateProcessIfNotExistsCommand?: SingleItemReceivingCreateProcessIfNotExistsCommand, options?: any): AxiosPromise<SingleItemReceivingCreateProcessOutputDTO> {
            return localVarFp.apiV1SingleItemReceivingCreateIfNotExistsPost(singleItemReceivingCreateProcessIfNotExistsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteLastDamagedItemCommand} [deleteLastDamagedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingDeleteLastDamagedItemPost(deleteLastDamagedItemCommand?: DeleteLastDamagedItemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SingleItemReceivingDeleteLastDamagedItemPost(deleteLastDamagedItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteLastReceivedItemCommand} [deleteLastReceivedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingDeleteLastReceivedItemPost(deleteLastReceivedItemCommand?: DeleteLastReceivedItemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SingleItemReceivingDeleteLastReceivedItemPost(deleteLastReceivedItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingGetInboundBoxDetailsGet(barcode?: string, options?: any): AxiosPromise<SingleItemReceivingInboundBoxDetailsOutputDTO> {
            return localVarFp.apiV1SingleItemReceivingGetInboundBoxDetailsGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingGetQuarantineToteDetailsGet(barcode?: string, options?: any): AxiosPromise<GetQuarantineToteDetailsForSingleItemReceivingOutputDTO> {
            return localVarFp.apiV1SingleItemReceivingGetQuarantineToteDetailsGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingGetReceivingContainerDetailsGet(barcode?: string, options?: any): AxiosPromise<GetReceivingContainerDetailsForSingleItemReceivingOutputDTO> {
            return localVarFp.apiV1SingleItemReceivingGetReceivingContainerDetailsGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [receivingToteLabel] 
         * @param {string} [quarantineToteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingGetTotalItemAmountGet(receivingToteLabel?: string, quarantineToteLabel?: string, options?: any): AxiosPromise<SingleItemReceivingTotalItemAmountOutputDTO> {
            return localVarFp.apiV1SingleItemReceivingGetTotalItemAmountGet(receivingToteLabel, quarantineToteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceItemToQuarantineToteCommand} [placeItemToQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingPlaceItemToQuarantineTotePost(placeItemToQuarantineToteCommand?: PlaceItemToQuarantineToteCommand, options?: any): AxiosPromise<PlaceItemToQuarantineToteOutputDTO> {
            return localVarFp.apiV1SingleItemReceivingPlaceItemToQuarantineTotePost(placeItemToQuarantineToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceItemToReceivingToteCommand} [placeItemToReceivingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingPlaceItemToReceivingTotePost(placeItemToReceivingToteCommand?: PlaceItemToReceivingToteCommand, options?: any): AxiosPromise<PlaceItemToReceivingToteOutputDTO> {
            return localVarFp.apiV1SingleItemReceivingPlaceItemToReceivingTotePost(placeItemToReceivingToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SelectContainerForReceivingCommand} [selectContainerForReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingSelectContainerForReceivingPost(selectContainerForReceivingCommand?: SelectContainerForReceivingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SingleItemReceivingSelectContainerForReceivingPost(selectContainerForReceivingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SelectToteForMeasurementCommand} [selectToteForMeasurementCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingSelectToteForMeasurementPost(selectToteForMeasurementCommand?: SelectToteForMeasurementCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SingleItemReceivingSelectToteForMeasurementPost(selectToteForMeasurementCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SelectToteForQuarantineCommand} [selectToteForQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingSelectToteForQuarantinePost(selectToteForQuarantineCommand?: SelectToteForQuarantineCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SingleItemReceivingSelectToteForQuarantinePost(selectToteForQuarantineCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferItemToQuarantineCommand} [transferItemToQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingTransferItemToQuarantinePost(transferItemToQuarantineCommand?: TransferItemToQuarantineCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SingleItemReceivingTransferItemToQuarantinePost(transferItemToQuarantineCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SingleItemReceivingUploadDamagedItemImagePost(file?: any, options?: any): AxiosPromise<ImageOutputDTO> {
            return localVarFp.apiV1SingleItemReceivingUploadDamagedItemImagePost(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SingleItemReceivingApi - object-oriented interface
 * @export
 * @class SingleItemReceivingApi
 * @extends {BaseAPI}
 */
export class SingleItemReceivingApi extends BaseAPI {
    /**
     * 
     * @param {string} [barcode] 
     * @param {string} [receivingProcessId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingCheckBarcodeTypeGet(barcode?: string, receivingProcessId?: string, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingCheckBarcodeTypeGet(barcode, receivingProcessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [receivingProcessId] 
     * @param {string} [barcode] 
     * @param {string} [expirationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingCheckExpirationDateIsExpiredGet(receivingProcessId?: string, barcode?: string, expirationDate?: string, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingCheckExpirationDateIsExpiredGet(receivingProcessId, barcode, expirationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteSingleItemReceivingCommand} [completeSingleItemReceivingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingCompletePost(completeSingleItemReceivingCommand?: CompleteSingleItemReceivingCommand, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingCompletePost(completeSingleItemReceivingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SingleItemReceivingCreateProcessIfNotExistsCommand} [singleItemReceivingCreateProcessIfNotExistsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingCreateIfNotExistsPost(singleItemReceivingCreateProcessIfNotExistsCommand?: SingleItemReceivingCreateProcessIfNotExistsCommand, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingCreateIfNotExistsPost(singleItemReceivingCreateProcessIfNotExistsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteLastDamagedItemCommand} [deleteLastDamagedItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingDeleteLastDamagedItemPost(deleteLastDamagedItemCommand?: DeleteLastDamagedItemCommand, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingDeleteLastDamagedItemPost(deleteLastDamagedItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteLastReceivedItemCommand} [deleteLastReceivedItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingDeleteLastReceivedItemPost(deleteLastReceivedItemCommand?: DeleteLastReceivedItemCommand, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingDeleteLastReceivedItemPost(deleteLastReceivedItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingGetInboundBoxDetailsGet(barcode?: string, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingGetInboundBoxDetailsGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingGetQuarantineToteDetailsGet(barcode?: string, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingGetQuarantineToteDetailsGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingGetReceivingContainerDetailsGet(barcode?: string, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingGetReceivingContainerDetailsGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [receivingToteLabel] 
     * @param {string} [quarantineToteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingGetTotalItemAmountGet(receivingToteLabel?: string, quarantineToteLabel?: string, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingGetTotalItemAmountGet(receivingToteLabel, quarantineToteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceItemToQuarantineToteCommand} [placeItemToQuarantineToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingPlaceItemToQuarantineTotePost(placeItemToQuarantineToteCommand?: PlaceItemToQuarantineToteCommand, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingPlaceItemToQuarantineTotePost(placeItemToQuarantineToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceItemToReceivingToteCommand} [placeItemToReceivingToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingPlaceItemToReceivingTotePost(placeItemToReceivingToteCommand?: PlaceItemToReceivingToteCommand, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingPlaceItemToReceivingTotePost(placeItemToReceivingToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SelectContainerForReceivingCommand} [selectContainerForReceivingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingSelectContainerForReceivingPost(selectContainerForReceivingCommand?: SelectContainerForReceivingCommand, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingSelectContainerForReceivingPost(selectContainerForReceivingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SelectToteForMeasurementCommand} [selectToteForMeasurementCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingSelectToteForMeasurementPost(selectToteForMeasurementCommand?: SelectToteForMeasurementCommand, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingSelectToteForMeasurementPost(selectToteForMeasurementCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SelectToteForQuarantineCommand} [selectToteForQuarantineCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingSelectToteForQuarantinePost(selectToteForQuarantineCommand?: SelectToteForQuarantineCommand, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingSelectToteForQuarantinePost(selectToteForQuarantineCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferItemToQuarantineCommand} [transferItemToQuarantineCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingTransferItemToQuarantinePost(transferItemToQuarantineCommand?: TransferItemToQuarantineCommand, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingTransferItemToQuarantinePost(transferItemToQuarantineCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SingleItemReceivingApi
     */
    public apiV1SingleItemReceivingUploadDamagedItemImagePost(file?: any, options?: any) {
        return SingleItemReceivingApiFp(this.configuration).apiV1SingleItemReceivingUploadDamagedItemImagePost(file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SortCellsApi - axios parameter creator
 * @export
 */
export const SortCellsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SortCellFlushedRequest} [sortCellFlushedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trendyolV1SortCellsFlushedPost: async (sortCellFlushedRequest?: SortCellFlushedRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/trendyol/v1/SortCells/flushed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sortCellFlushedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SortCellsApi - functional programming interface
 * @export
 */
export const SortCellsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SortCellsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SortCellFlushedRequest} [sortCellFlushedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trendyolV1SortCellsFlushedPost(sortCellFlushedRequest?: SortCellFlushedRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrendyolAck>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trendyolV1SortCellsFlushedPost(sortCellFlushedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SortCellsApi - factory interface
 * @export
 */
export const SortCellsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SortCellsApiFp(configuration)
    return {
        /**
         * 
         * @param {SortCellFlushedRequest} [sortCellFlushedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trendyolV1SortCellsFlushedPost(sortCellFlushedRequest?: SortCellFlushedRequest, options?: any): AxiosPromise<TrendyolAck> {
            return localVarFp.trendyolV1SortCellsFlushedPost(sortCellFlushedRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SortCellsApi - object-oriented interface
 * @export
 * @class SortCellsApi
 * @extends {BaseAPI}
 */
export class SortCellsApi extends BaseAPI {
    /**
     * 
     * @param {SortCellFlushedRequest} [sortCellFlushedRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SortCellsApi
     */
    public trendyolV1SortCellsFlushedPost(sortCellFlushedRequest?: SortCellFlushedRequest, options?: any) {
        return SortCellsApiFp(this.configuration).trendyolV1SortCellsFlushedPost(sortCellFlushedRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SorterApi - axios parameter creator
 * @export
 */
export const SorterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateSorterCommand} [createSorterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterCreatePost: async (createSorterCommand?: CreateSorterCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Sorter.create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSorterCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteSorterCommand} [deleteSorterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterDeleteDelete: async (deleteSorterCommand?: DeleteSorterCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Sorter.delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSorterCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sorterId 
         * @param {string} salesOrderId 
         * @param {string} cargoPackageLabel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterDispatchCargoPackageSorterIdSalesOrderIdCargoPackageLabelPost: async (sorterId: string, salesOrderId: string, cargoPackageLabel: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sorterId' is not null or undefined
            assertParamExists('apiV1SorterDispatchCargoPackageSorterIdSalesOrderIdCargoPackageLabelPost', 'sorterId', sorterId)
            // verify required parameter 'salesOrderId' is not null or undefined
            assertParamExists('apiV1SorterDispatchCargoPackageSorterIdSalesOrderIdCargoPackageLabelPost', 'salesOrderId', salesOrderId)
            // verify required parameter 'cargoPackageLabel' is not null or undefined
            assertParamExists('apiV1SorterDispatchCargoPackageSorterIdSalesOrderIdCargoPackageLabelPost', 'cargoPackageLabel', cargoPackageLabel)
            const localVarPath = `/api/v1/Sorter.dispatchCargoPackage/{sorterId}/{salesOrderId}/{cargoPackageLabel}`
                .replace(`{${"sorterId"}}`, encodeURIComponent(String(sorterId)))
                .replace(`{${"salesOrderId"}}`, encodeURIComponent(String(salesOrderId)))
                .replace(`{${"cargoPackageLabel"}}`, encodeURIComponent(String(cargoPackageLabel)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sorterId 
         * @param {SelectSorterExitInputDTO} [selectSorterExitInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterFindExitSorterIdPost: async (sorterId: string, selectSorterExitInputDTO?: SelectSorterExitInputDTO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sorterId' is not null or undefined
            assertParamExists('apiV1SorterFindExitSorterIdPost', 'sorterId', sorterId)
            const localVarPath = `/api/v1/Sorter.findExit/{sorterId}`
                .replace(`{${"sorterId"}}`, encodeURIComponent(String(sorterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectSorterExitInputDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sorterId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterListConfigsGet: async (sorterId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Sorter.listConfigs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (sorterId !== undefined) {
                localVarQueryParameter['sorterId'] = sorterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterListGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Sorter.list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sorterId 
         * @param {SelectSorterExitInputDTO} [selectSorterExitInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterSelectExitSorterIdPost: async (sorterId: string, selectSorterExitInputDTO?: SelectSorterExitInputDTO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sorterId' is not null or undefined
            assertParamExists('apiV1SorterSelectExitSorterIdPost', 'sorterId', sorterId)
            const localVarPath = `/api/v1/Sorter.selectExit/{sorterId}`
                .replace(`{${"sorterId"}}`, encodeURIComponent(String(sorterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectSorterExitInputDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSorterCommand} [updateSorterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterUpdatePut: async (updateSorterCommand?: UpdateSorterCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Sorter.update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSorterCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertSorterConfigCommand} [upsertSorterConfigCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterUpsertSorterConfigPost: async (upsertSorterConfigCommand?: UpsertSorterConfigCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Sorter.upsertSorterConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertSorterConfigCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SorterApi - functional programming interface
 * @export
 */
export const SorterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SorterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateSorterCommand} [createSorterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SorterCreatePost(createSorterCommand?: CreateSorterCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SorterCreatePost(createSorterCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteSorterCommand} [deleteSorterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SorterDeleteDelete(deleteSorterCommand?: DeleteSorterCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SorterDeleteDelete(deleteSorterCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sorterId 
         * @param {string} salesOrderId 
         * @param {string} cargoPackageLabel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SorterDispatchCargoPackageSorterIdSalesOrderIdCargoPackageLabelPost(sorterId: string, salesOrderId: string, cargoPackageLabel: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SorterDispatchCargoPackageSorterIdSalesOrderIdCargoPackageLabelPost(sorterId, salesOrderId, cargoPackageLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sorterId 
         * @param {SelectSorterExitInputDTO} [selectSorterExitInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SorterFindExitSorterIdPost(sorterId: string, selectSorterExitInputDTO?: SelectSorterExitInputDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectSorterExitOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SorterFindExitSorterIdPost(sorterId, selectSorterExitInputDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [sorterId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SorterListConfigsGet(sorterId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SorterConfigOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SorterListConfigsGet(sorterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SorterListGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SorterOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SorterListGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sorterId 
         * @param {SelectSorterExitInputDTO} [selectSorterExitInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SorterSelectExitSorterIdPost(sorterId: string, selectSorterExitInputDTO?: SelectSorterExitInputDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectSorterExitOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SorterSelectExitSorterIdPost(sorterId, selectSorterExitInputDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateSorterCommand} [updateSorterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SorterUpdatePut(updateSorterCommand?: UpdateSorterCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SorterUpdatePut(updateSorterCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpsertSorterConfigCommand} [upsertSorterConfigCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SorterUpsertSorterConfigPost(upsertSorterConfigCommand?: UpsertSorterConfigCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SorterUpsertSorterConfigPost(upsertSorterConfigCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SorterApi - factory interface
 * @export
 */
export const SorterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SorterApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateSorterCommand} [createSorterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterCreatePost(createSorterCommand?: CreateSorterCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SorterCreatePost(createSorterCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteSorterCommand} [deleteSorterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterDeleteDelete(deleteSorterCommand?: DeleteSorterCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SorterDeleteDelete(deleteSorterCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sorterId 
         * @param {string} salesOrderId 
         * @param {string} cargoPackageLabel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterDispatchCargoPackageSorterIdSalesOrderIdCargoPackageLabelPost(sorterId: string, salesOrderId: string, cargoPackageLabel: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SorterDispatchCargoPackageSorterIdSalesOrderIdCargoPackageLabelPost(sorterId, salesOrderId, cargoPackageLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sorterId 
         * @param {SelectSorterExitInputDTO} [selectSorterExitInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterFindExitSorterIdPost(sorterId: string, selectSorterExitInputDTO?: SelectSorterExitInputDTO, options?: any): AxiosPromise<SelectSorterExitOutputDTO> {
            return localVarFp.apiV1SorterFindExitSorterIdPost(sorterId, selectSorterExitInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [sorterId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterListConfigsGet(sorterId?: string, options?: any): AxiosPromise<Array<SorterConfigOutputDTO>> {
            return localVarFp.apiV1SorterListConfigsGet(sorterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterListGet(options?: any): AxiosPromise<Array<SorterOutputDTO>> {
            return localVarFp.apiV1SorterListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sorterId 
         * @param {SelectSorterExitInputDTO} [selectSorterExitInputDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterSelectExitSorterIdPost(sorterId: string, selectSorterExitInputDTO?: SelectSorterExitInputDTO, options?: any): AxiosPromise<SelectSorterExitOutputDTO> {
            return localVarFp.apiV1SorterSelectExitSorterIdPost(sorterId, selectSorterExitInputDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateSorterCommand} [updateSorterCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterUpdatePut(updateSorterCommand?: UpdateSorterCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SorterUpdatePut(updateSorterCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertSorterConfigCommand} [upsertSorterConfigCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SorterUpsertSorterConfigPost(upsertSorterConfigCommand?: UpsertSorterConfigCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SorterUpsertSorterConfigPost(upsertSorterConfigCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SorterApi - object-oriented interface
 * @export
 * @class SorterApi
 * @extends {BaseAPI}
 */
export class SorterApi extends BaseAPI {
    /**
     * 
     * @param {CreateSorterCommand} [createSorterCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SorterApi
     */
    public apiV1SorterCreatePost(createSorterCommand?: CreateSorterCommand, options?: any) {
        return SorterApiFp(this.configuration).apiV1SorterCreatePost(createSorterCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteSorterCommand} [deleteSorterCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SorterApi
     */
    public apiV1SorterDeleteDelete(deleteSorterCommand?: DeleteSorterCommand, options?: any) {
        return SorterApiFp(this.configuration).apiV1SorterDeleteDelete(deleteSorterCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sorterId 
     * @param {string} salesOrderId 
     * @param {string} cargoPackageLabel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SorterApi
     */
    public apiV1SorterDispatchCargoPackageSorterIdSalesOrderIdCargoPackageLabelPost(sorterId: string, salesOrderId: string, cargoPackageLabel: string, options?: any) {
        return SorterApiFp(this.configuration).apiV1SorterDispatchCargoPackageSorterIdSalesOrderIdCargoPackageLabelPost(sorterId, salesOrderId, cargoPackageLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sorterId 
     * @param {SelectSorterExitInputDTO} [selectSorterExitInputDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SorterApi
     */
    public apiV1SorterFindExitSorterIdPost(sorterId: string, selectSorterExitInputDTO?: SelectSorterExitInputDTO, options?: any) {
        return SorterApiFp(this.configuration).apiV1SorterFindExitSorterIdPost(sorterId, selectSorterExitInputDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [sorterId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SorterApi
     */
    public apiV1SorterListConfigsGet(sorterId?: string, options?: any) {
        return SorterApiFp(this.configuration).apiV1SorterListConfigsGet(sorterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SorterApi
     */
    public apiV1SorterListGet(options?: any) {
        return SorterApiFp(this.configuration).apiV1SorterListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sorterId 
     * @param {SelectSorterExitInputDTO} [selectSorterExitInputDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SorterApi
     */
    public apiV1SorterSelectExitSorterIdPost(sorterId: string, selectSorterExitInputDTO?: SelectSorterExitInputDTO, options?: any) {
        return SorterApiFp(this.configuration).apiV1SorterSelectExitSorterIdPost(sorterId, selectSorterExitInputDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateSorterCommand} [updateSorterCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SorterApi
     */
    public apiV1SorterUpdatePut(updateSorterCommand?: UpdateSorterCommand, options?: any) {
        return SorterApiFp(this.configuration).apiV1SorterUpdatePut(updateSorterCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertSorterConfigCommand} [upsertSorterConfigCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SorterApi
     */
    public apiV1SorterUpsertSorterConfigPost(upsertSorterConfigCommand?: UpsertSorterConfigCommand, options?: any) {
        return SorterApiFp(this.configuration).apiV1SorterUpsertSorterConfigPost(upsertSorterConfigCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StockAdjustmentApi - axios parameter creator
 * @export
 */
export const StockAdjustmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockAdjustmentGetContainerDetailsGet: async (cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockAdjustment.getContainerDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockAdjustmentGetContainerProductDetailsGet: async (cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockAdjustment.getContainerProductDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockAdjustmentGetProductDetailsGet: async (barcode?: string, cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockAdjustment.getProductDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StockAdjustmentApi - functional programming interface
 * @export
 */
export const StockAdjustmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StockAdjustmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockAdjustmentGetContainerDetailsGet(cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockAdjustmentGetContainerDetailsGet(cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockAdjustmentGetContainerProductDetailsGet(cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerProductDetailsOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockAdjustmentGetContainerProductDetailsGet(cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockAdjustmentGetProductDetailsGet(barcode?: string, cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerProductDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockAdjustmentGetProductDetailsGet(barcode, cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StockAdjustmentApi - factory interface
 * @export
 */
export const StockAdjustmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StockAdjustmentApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockAdjustmentGetContainerDetailsGet(cellLabel?: string, options?: any): AxiosPromise<ContainerDetailsOutputDTO> {
            return localVarFp.apiV1StockAdjustmentGetContainerDetailsGet(cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockAdjustmentGetContainerProductDetailsGet(cellLabel?: string, options?: any): AxiosPromise<Array<ContainerProductDetailsOutputDTO>> {
            return localVarFp.apiV1StockAdjustmentGetContainerProductDetailsGet(cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockAdjustmentGetProductDetailsGet(barcode?: string, cellLabel?: string, options?: any): AxiosPromise<ContainerProductDetailsOutputDTO> {
            return localVarFp.apiV1StockAdjustmentGetProductDetailsGet(barcode, cellLabel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StockAdjustmentApi - object-oriented interface
 * @export
 * @class StockAdjustmentApi
 * @extends {BaseAPI}
 */
export class StockAdjustmentApi extends BaseAPI {
    /**
     * 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockAdjustmentApi
     */
    public apiV1StockAdjustmentGetContainerDetailsGet(cellLabel?: string, options?: any) {
        return StockAdjustmentApiFp(this.configuration).apiV1StockAdjustmentGetContainerDetailsGet(cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockAdjustmentApi
     */
    public apiV1StockAdjustmentGetContainerProductDetailsGet(cellLabel?: string, options?: any) {
        return StockAdjustmentApiFp(this.configuration).apiV1StockAdjustmentGetContainerProductDetailsGet(cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockAdjustmentApi
     */
    public apiV1StockAdjustmentGetProductDetailsGet(barcode?: string, cellLabel?: string, options?: any) {
        return StockAdjustmentApiFp(this.configuration).apiV1StockAdjustmentGetProductDetailsGet(barcode, cellLabel, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StockCellTypesApi - axios parameter creator
 * @export
 */
export const StockCellTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AssignStockCellTypeCommand} [assignStockCellTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesAssignCellStockTypesToAddressesPost: async (assignStockCellTypeCommand?: AssignStockCellTypeCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/StockCellTypes.assignCellStockTypesToAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignStockCellTypeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateStockCellTypeCommand} [createStockCellTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesCreateStockCellTypePost: async (createStockCellTypeCommand?: CreateStockCellTypeCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/StockCellTypes.createStockCellType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStockCellTypeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteStockCellTypeCommand} [deleteStockCellTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesDeleteStockCellTypePost: async (deleteStockCellTypeCommand?: DeleteStockCellTypeCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/StockCellTypes.deleteStockCellType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteStockCellTypeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesGetCellTypeOccupancyGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/StockCellTypes.getCellTypeOccupancy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [comparer] 
         * @param {number} [skuCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesGetOccupancyBySKUCountGet: async (comparer?: string, skuCount?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/StockCellTypes.getOccupancyBySKUCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (comparer !== undefined) {
                localVarQueryParameter['comparer'] = comparer;
            }

            if (skuCount !== undefined) {
                localVarQueryParameter['skuCount'] = skuCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesGetOperationOccupancyGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/StockCellTypes.getOperationOccupancy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesGetStockCellDetailsByCellGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/StockCellTypes.getStockCellDetailsByCell`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesGetStockCellTypesWithCountsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/StockCellTypes.getStockCellTypesWithCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesGetWarehouseOccupancyGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/StockCellTypes.getWarehouseOccupancy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesGetZoneOccupancyGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/StockCellTypes.getZoneOccupancy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateStockCellTypeCommand} [updateStockCellTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesUpdateStockCellTypePost: async (updateStockCellTypeCommand?: UpdateStockCellTypeCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/StockCellTypes.updateStockCellType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStockCellTypeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StockCellTypesApi - functional programming interface
 * @export
 */
export const StockCellTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StockCellTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AssignStockCellTypeCommand} [assignStockCellTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1StockCellTypesAssignCellStockTypesToAddressesPost(assignStockCellTypeCommand?: AssignStockCellTypeCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1StockCellTypesAssignCellStockTypesToAddressesPost(assignStockCellTypeCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateStockCellTypeCommand} [createStockCellTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1StockCellTypesCreateStockCellTypePost(createStockCellTypeCommand?: CreateStockCellTypeCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockCellTypeOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1StockCellTypesCreateStockCellTypePost(createStockCellTypeCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteStockCellTypeCommand} [deleteStockCellTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1StockCellTypesDeleteStockCellTypePost(deleteStockCellTypeCommand?: DeleteStockCellTypeCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1StockCellTypesDeleteStockCellTypePost(deleteStockCellTypeCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1StockCellTypesGetCellTypeOccupancyGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CellTypeOccupancyDetailsOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1StockCellTypesGetCellTypeOccupancyGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [comparer] 
         * @param {number} [skuCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1StockCellTypesGetOccupancyBySKUCountGet(comparer?: string, skuCount?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OccupancyBySKUCountOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1StockCellTypesGetOccupancyBySKUCountGet(comparer, skuCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1StockCellTypesGetOperationOccupancyGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OperationOccupancyDetailsOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1StockCellTypesGetOperationOccupancyGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1StockCellTypesGetStockCellDetailsByCellGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockCellDetailsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1StockCellTypesGetStockCellDetailsByCellGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1StockCellTypesGetStockCellTypesWithCountsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockCellTypesWithCountsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1StockCellTypesGetStockCellTypesWithCountsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1StockCellTypesGetWarehouseOccupancyGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1StockCellTypesGetWarehouseOccupancyGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1StockCellTypesGetZoneOccupancyGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ZoneOccupancyDetailsOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1StockCellTypesGetZoneOccupancyGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateStockCellTypeCommand} [updateStockCellTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1StockCellTypesUpdateStockCellTypePost(updateStockCellTypeCommand?: UpdateStockCellTypeCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1StockCellTypesUpdateStockCellTypePost(updateStockCellTypeCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StockCellTypesApi - factory interface
 * @export
 */
export const StockCellTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StockCellTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {AssignStockCellTypeCommand} [assignStockCellTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesAssignCellStockTypesToAddressesPost(assignStockCellTypeCommand?: AssignStockCellTypeCommand, options?: any): AxiosPromise<void> {
            return localVarFp.adminV1StockCellTypesAssignCellStockTypesToAddressesPost(assignStockCellTypeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateStockCellTypeCommand} [createStockCellTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesCreateStockCellTypePost(createStockCellTypeCommand?: CreateStockCellTypeCommand, options?: any): AxiosPromise<Array<StockCellTypeOutputDTO>> {
            return localVarFp.adminV1StockCellTypesCreateStockCellTypePost(createStockCellTypeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteStockCellTypeCommand} [deleteStockCellTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesDeleteStockCellTypePost(deleteStockCellTypeCommand?: DeleteStockCellTypeCommand, options?: any): AxiosPromise<void> {
            return localVarFp.adminV1StockCellTypesDeleteStockCellTypePost(deleteStockCellTypeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesGetCellTypeOccupancyGet(options?: any): AxiosPromise<Array<CellTypeOccupancyDetailsOutputDTO>> {
            return localVarFp.adminV1StockCellTypesGetCellTypeOccupancyGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [comparer] 
         * @param {number} [skuCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesGetOccupancyBySKUCountGet(comparer?: string, skuCount?: number, options?: any): AxiosPromise<OccupancyBySKUCountOutputDTO> {
            return localVarFp.adminV1StockCellTypesGetOccupancyBySKUCountGet(comparer, skuCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesGetOperationOccupancyGet(options?: any): AxiosPromise<Array<OperationOccupancyDetailsOutputDTO>> {
            return localVarFp.adminV1StockCellTypesGetOperationOccupancyGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesGetStockCellDetailsByCellGet(dqb?: string, options?: any): AxiosPromise<StockCellDetailsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.adminV1StockCellTypesGetStockCellDetailsByCellGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesGetStockCellTypesWithCountsGet(dqb?: string, options?: any): AxiosPromise<StockCellTypesWithCountsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.adminV1StockCellTypesGetStockCellTypesWithCountsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesGetWarehouseOccupancyGet(options?: any): AxiosPromise<number> {
            return localVarFp.adminV1StockCellTypesGetWarehouseOccupancyGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesGetZoneOccupancyGet(options?: any): AxiosPromise<Array<ZoneOccupancyDetailsOutputDTO>> {
            return localVarFp.adminV1StockCellTypesGetZoneOccupancyGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateStockCellTypeCommand} [updateStockCellTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1StockCellTypesUpdateStockCellTypePost(updateStockCellTypeCommand?: UpdateStockCellTypeCommand, options?: any): AxiosPromise<void> {
            return localVarFp.adminV1StockCellTypesUpdateStockCellTypePost(updateStockCellTypeCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StockCellTypesApi - object-oriented interface
 * @export
 * @class StockCellTypesApi
 * @extends {BaseAPI}
 */
export class StockCellTypesApi extends BaseAPI {
    /**
     * 
     * @param {AssignStockCellTypeCommand} [assignStockCellTypeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCellTypesApi
     */
    public adminV1StockCellTypesAssignCellStockTypesToAddressesPost(assignStockCellTypeCommand?: AssignStockCellTypeCommand, options?: any) {
        return StockCellTypesApiFp(this.configuration).adminV1StockCellTypesAssignCellStockTypesToAddressesPost(assignStockCellTypeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateStockCellTypeCommand} [createStockCellTypeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCellTypesApi
     */
    public adminV1StockCellTypesCreateStockCellTypePost(createStockCellTypeCommand?: CreateStockCellTypeCommand, options?: any) {
        return StockCellTypesApiFp(this.configuration).adminV1StockCellTypesCreateStockCellTypePost(createStockCellTypeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteStockCellTypeCommand} [deleteStockCellTypeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCellTypesApi
     */
    public adminV1StockCellTypesDeleteStockCellTypePost(deleteStockCellTypeCommand?: DeleteStockCellTypeCommand, options?: any) {
        return StockCellTypesApiFp(this.configuration).adminV1StockCellTypesDeleteStockCellTypePost(deleteStockCellTypeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCellTypesApi
     */
    public adminV1StockCellTypesGetCellTypeOccupancyGet(options?: any) {
        return StockCellTypesApiFp(this.configuration).adminV1StockCellTypesGetCellTypeOccupancyGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [comparer] 
     * @param {number} [skuCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCellTypesApi
     */
    public adminV1StockCellTypesGetOccupancyBySKUCountGet(comparer?: string, skuCount?: number, options?: any) {
        return StockCellTypesApiFp(this.configuration).adminV1StockCellTypesGetOccupancyBySKUCountGet(comparer, skuCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCellTypesApi
     */
    public adminV1StockCellTypesGetOperationOccupancyGet(options?: any) {
        return StockCellTypesApiFp(this.configuration).adminV1StockCellTypesGetOperationOccupancyGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCellTypesApi
     */
    public adminV1StockCellTypesGetStockCellDetailsByCellGet(dqb?: string, options?: any) {
        return StockCellTypesApiFp(this.configuration).adminV1StockCellTypesGetStockCellDetailsByCellGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCellTypesApi
     */
    public adminV1StockCellTypesGetStockCellTypesWithCountsGet(dqb?: string, options?: any) {
        return StockCellTypesApiFp(this.configuration).adminV1StockCellTypesGetStockCellTypesWithCountsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCellTypesApi
     */
    public adminV1StockCellTypesGetWarehouseOccupancyGet(options?: any) {
        return StockCellTypesApiFp(this.configuration).adminV1StockCellTypesGetWarehouseOccupancyGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCellTypesApi
     */
    public adminV1StockCellTypesGetZoneOccupancyGet(options?: any) {
        return StockCellTypesApiFp(this.configuration).adminV1StockCellTypesGetZoneOccupancyGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateStockCellTypeCommand} [updateStockCellTypeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCellTypesApi
     */
    public adminV1StockCellTypesUpdateStockCellTypePost(updateStockCellTypeCommand?: UpdateStockCellTypeCommand, options?: any) {
        return StockCellTypesApiFp(this.configuration).adminV1StockCellTypesUpdateStockCellTypePost(updateStockCellTypeCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StockCountingTasksApi - axios parameter creator
 * @export
 */
export const StockCountingTasksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AdjustCellStockCommand} [adjustCellStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksAdjustCellStockPost: async (adjustCellStockCommand?: AdjustCellStockCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.adjustCellStock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adjustCellStockCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckCellContainsPickingStartedItemsCommand} [checkCellContainsPickingStartedItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckCellContainsPickingStartedItemsPost: async (checkCellContainsPickingStartedItemsCommand?: CheckCellContainsPickingStartedItemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.checkCellContainsPickingStartedItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkCellContainsPickingStartedItemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckCellLabelCommand} [checkCellLabelCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckCellIfExistsPost: async (checkCellLabelCommand?: CheckCellLabelCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.checkCellIfExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkCellLabelCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckCellIncludesAnyItemsForStockCountingGet: async (cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.checkCellIncludesAnyItemsForStockCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckCellProductContainsPickingStartedItemsCommand} [checkCellProductContainsPickingStartedItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckCellProductContainsPickingStartedItemsPost: async (checkCellProductContainsPickingStartedItemsCommand?: CheckCellProductContainsPickingStartedItemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.checkCellProductContainsPickingStartedItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkCellProductContainsPickingStartedItemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckPlanSelectionActiveInStockCountingsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.checkPlanSelectionActiveInStockCountings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckProductForCellStockCountingGet: async (barcode?: string, cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.checkProductForCellStockCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckProductForManualCellStockCountingGet: async (barcode?: string, cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.checkProductForManualCellStockCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckSerialNumberExistsInOtherCellCommand} [checkSerialNumberExistsInOtherCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckSerialNumberExistsInOtherCellPost: async (checkSerialNumberExistsInOtherCellCommand?: CheckSerialNumberExistsInOtherCellCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.checkSerialNumberExistsInOtherCell`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkSerialNumberExistsInOtherCellCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckToteIfAvailableCommand} [checkToteIfAvailableCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckToteIfAvailableForManualCellStockCountingPost: async (checkToteIfAvailableCommand?: CheckToteIfAvailableCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.checkToteIfAvailableForManualCellStockCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkToteIfAvailableCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckToteIfAvailableCommand} [checkToteIfAvailableCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckToteIfAvailablePost: async (checkToteIfAvailableCommand?: CheckToteIfAvailableCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.checkToteIfAvailable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkToteIfAvailableCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteStockCountingListCommand} [completeStockCountingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCompleteStockCountingListPost: async (completeStockCountingListCommand?: CompleteStockCountingListCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.completeStockCountingList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeStockCountingListCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CountCellStockCountingCommand} [countCellStockCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCountCellStockCountingPost: async (countCellStockCountingCommand?: CountCellStockCountingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.countCellStockCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(countCellStockCountingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CountCellTotalStockCountingCommand} [countCellTotalStockCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCountCellTotalStockCountingPost: async (countCellTotalStockCountingCommand?: CountCellTotalStockCountingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.countCellTotalStockCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(countCellTotalStockCountingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CountManualCellStockCountingCommand} [countManualCellStockCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCountManualCellStockCountingPost: async (countManualCellStockCountingCommand?: CountManualCellStockCountingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.countManualCellStockCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(countManualCellStockCountingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CountProductStockCountingCommand} [countProductStockCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCountProductStockCountingPost: async (countProductStockCountingCommand?: CountProductStockCountingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.countProductStockCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(countProductStockCountingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateManualCellStockCountingProcessCommand} [createManualCellStockCountingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCreateManualCellStockCountingProcessPost: async (createManualCellStockCountingProcessCommand?: CreateManualCellStockCountingProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.createManualCellStockCountingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManualCellStockCountingProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateStockCountingPlanCommand} [createStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCreateStockCountingPlanPost: async (createStockCountingPlanCommand?: CreateStockCountingPlanCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.createStockCountingPlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStockCountingPlanCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateStockCountingProcessCommand} [createStockCountingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCreateStockCountingProcessPost: async (createStockCountingProcessCommand?: CreateStockCountingProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.createStockCountingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStockCountingProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeprioritizeStockCountingPlanCommand} [deprioritizeStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksDeprioritizeStockCountingPlanPost: async (deprioritizeStockCountingPlanCommand?: DeprioritizeStockCountingPlanCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.deprioritizeStockCountingPlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deprioritizeStockCountingPlanCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForceCompleteStockCountingListCommand} [forceCompleteStockCountingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksForceCompleteStockCountingListPost: async (forceCompleteStockCountingListCommand?: ForceCompleteStockCountingListCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.forceCompleteStockCountingList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forceCompleteStockCountingListCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetActiveStockCountingPlansGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.getActiveStockCountingPlans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetCellStockCountingTaskAddressDetails} [getCellStockCountingTaskAddressDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetCellStockCountingTaskAdressesPost: async (getCellStockCountingTaskAddressDetails?: GetCellStockCountingTaskAddressDetails, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.getCellStockCountingTaskAdresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCellStockCountingTaskAddressDetails, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetCellStockCountingTasksQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.getCellStockCountingTasksQuery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stockCountingListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetNextCellStockCountingGet: async (stockCountingListId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.getNextCellStockCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (stockCountingListId !== undefined) {
                localVarQueryParameter['stockCountingListId'] = stockCountingListId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stockCountingListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetNextCellTotalStockCountingGet: async (stockCountingListId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.getNextCellTotalStockCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (stockCountingListId !== undefined) {
                localVarQueryParameter['stockCountingListId'] = stockCountingListId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stockCountingListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetNextProductStockCountingGet: async (stockCountingListId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.getNextProductStockCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (stockCountingListId !== undefined) {
                localVarQueryParameter['stockCountingListId'] = stockCountingListId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cellIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetPendingCellStockCountingPlanDetailsGet: async (cellIds?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.getPendingCellStockCountingPlanDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellIds !== undefined) {
                localVarQueryParameter['cellIds'] = cellIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cellAndProductIdPairs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetPendingItemStockCountingPlanDetailsGet: async (cellAndProductIdPairs?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.getPendingItemStockCountingPlanDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellAndProductIdPairs !== undefined) {
                localVarQueryParameter['cellAndProductIdPairs'] = cellAndProductIdPairs;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetStockCountingListDetailsGet: async (referenceNumber?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.getStockCountingListDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetStockCountingListsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.getStockCountingLists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [referenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetStockCountingPlanDetailsGet: async (referenceId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.getStockCountingPlanDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (referenceId !== undefined) {
                localVarQueryParameter['referenceId'] = referenceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetStockCountingStatisticsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.getStockCountingStatistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrioritizeStockCountingPlanCommand} [prioritizeStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksPrioritizeStockCountingPlanPost: async (prioritizeStockCountingPlanCommand?: PrioritizeStockCountingPlanCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.prioritizeStockCountingPlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prioritizeStockCountingPlanCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryActiveStockCountingListGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.queryActiveStockCountingList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryAutomaticStockCountingTasksGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.queryAutomaticStockCountingTasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryManualStockCountingTasksGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.queryManualStockCountingTasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryQualityStockCountingTasksGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.queryQualityStockCountingTasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryStockCountingListConfigurationsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.queryStockCountingListConfigurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stockCountingListId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryStockCountingListDetailsGet: async (stockCountingListId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockCountingListId' is not null or undefined
            assertParamExists('apiV1StockCountingTasksQueryStockCountingListDetailsGet', 'stockCountingListId', stockCountingListId)
            const localVarPath = `/api/v1/StockCountingTasks.queryStockCountingListDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockCountingListId !== undefined) {
                localVarQueryParameter['stockCountingListId'] = stockCountingListId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryStockCountingListsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.queryStockCountingLists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} referenceId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryStockCountingPlanItemsByPlanReferenceNumberGet: async (referenceId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'referenceId' is not null or undefined
            assertParamExists('apiV1StockCountingTasksQueryStockCountingPlanItemsByPlanReferenceNumberGet', 'referenceId', referenceId)
            const localVarPath = `/api/v1/StockCountingTasks.queryStockCountingPlanItemsByPlanReferenceNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (referenceId !== undefined) {
                localVarQueryParameter['referenceId'] = referenceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryStockCountingPlansGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.queryStockCountingPlans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cellLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryStockCountingTasksByCellLabelGet: async (cellLabel: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cellLabel' is not null or undefined
            assertParamExists('apiV1StockCountingTasksQueryStockCountingTasksByCellLabelGet', 'cellLabel', cellLabel)
            const localVarPath = `/api/v1/StockCountingTasks.queryStockCountingTasksByCellLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryToCreateCellStockCountingPlanGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.queryToCreateCellStockCountingPlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryToCreateItemStockCountingPlanGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.queryToCreateItemStockCountingPlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetStockCountingListConfigurationStatusCommand} [setStockCountingListConfigurationStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksSetStockCountingListConfigurationStatusPost: async (setStockCountingListConfigurationStatusCommand?: SetStockCountingListConfigurationStatusCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/StockCountingTasks.setStockCountingListConfigurationStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setStockCountingListConfigurationStatusCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StockCountingTasksApi - functional programming interface
 * @export
 */
export const StockCountingTasksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StockCountingTasksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AdjustCellStockCommand} [adjustCellStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksAdjustCellStockPost(adjustCellStockCommand?: AdjustCellStockCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksAdjustCellStockPost(adjustCellStockCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckCellContainsPickingStartedItemsCommand} [checkCellContainsPickingStartedItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCheckCellContainsPickingStartedItemsPost(checkCellContainsPickingStartedItemsCommand?: CheckCellContainsPickingStartedItemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCheckCellContainsPickingStartedItemsPost(checkCellContainsPickingStartedItemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckCellLabelCommand} [checkCellLabelCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCheckCellIfExistsPost(checkCellLabelCommand?: CheckCellLabelCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCheckCellIfExistsPost(checkCellLabelCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCheckCellIncludesAnyItemsForStockCountingGet(cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCheckCellIncludesAnyItemsForStockCountingGet(cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckCellProductContainsPickingStartedItemsCommand} [checkCellProductContainsPickingStartedItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCheckCellProductContainsPickingStartedItemsPost(checkCellProductContainsPickingStartedItemsCommand?: CheckCellProductContainsPickingStartedItemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCheckCellProductContainsPickingStartedItemsPost(checkCellProductContainsPickingStartedItemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCheckPlanSelectionActiveInStockCountingsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckPlanSelectionActiveInStockCountingsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCheckPlanSelectionActiveInStockCountingsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCheckProductForCellStockCountingGet(barcode?: string, cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProductForCellStockCountingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCheckProductForCellStockCountingGet(barcode, cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCheckProductForManualCellStockCountingGet(barcode?: string, cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProductForManualCellStockCountingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCheckProductForManualCellStockCountingGet(barcode, cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckSerialNumberExistsInOtherCellCommand} [checkSerialNumberExistsInOtherCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCheckSerialNumberExistsInOtherCellPost(checkSerialNumberExistsInOtherCellCommand?: CheckSerialNumberExistsInOtherCellCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckSerialNumberExistsInOtherCellOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCheckSerialNumberExistsInOtherCellPost(checkSerialNumberExistsInOtherCellCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckToteIfAvailableCommand} [checkToteIfAvailableCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCheckToteIfAvailableForManualCellStockCountingPost(checkToteIfAvailableCommand?: CheckToteIfAvailableCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCheckToteIfAvailableForManualCellStockCountingPost(checkToteIfAvailableCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckToteIfAvailableCommand} [checkToteIfAvailableCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCheckToteIfAvailablePost(checkToteIfAvailableCommand?: CheckToteIfAvailableCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCheckToteIfAvailablePost(checkToteIfAvailableCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteStockCountingListCommand} [completeStockCountingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCompleteStockCountingListPost(completeStockCountingListCommand?: CompleteStockCountingListCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteStockCountingListCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCompleteStockCountingListPost(completeStockCountingListCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CountCellStockCountingCommand} [countCellStockCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCountCellStockCountingPost(countCellStockCountingCommand?: CountCellStockCountingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCountCellStockCountingPost(countCellStockCountingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CountCellTotalStockCountingCommand} [countCellTotalStockCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCountCellTotalStockCountingPost(countCellTotalStockCountingCommand?: CountCellTotalStockCountingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCountCellTotalStockCountingPost(countCellTotalStockCountingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CountManualCellStockCountingCommand} [countManualCellStockCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCountManualCellStockCountingPost(countManualCellStockCountingCommand?: CountManualCellStockCountingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCountManualCellStockCountingPost(countManualCellStockCountingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CountProductStockCountingCommand} [countProductStockCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCountProductStockCountingPost(countProductStockCountingCommand?: CountProductStockCountingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCountProductStockCountingPost(countProductStockCountingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateManualCellStockCountingProcessCommand} [createManualCellStockCountingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCreateManualCellStockCountingProcessPost(createManualCellStockCountingProcessCommand?: CreateManualCellStockCountingProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateManualCellStockCountingProcessCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCreateManualCellStockCountingProcessPost(createManualCellStockCountingProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateStockCountingPlanCommand} [createStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCreateStockCountingPlanPost(createStockCountingPlanCommand?: CreateStockCountingPlanCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCreateStockCountingPlanPost(createStockCountingPlanCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateStockCountingProcessCommand} [createStockCountingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksCreateStockCountingProcessPost(createStockCountingProcessCommand?: CreateStockCountingProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateStockCountingProcessCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksCreateStockCountingProcessPost(createStockCountingProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeprioritizeStockCountingPlanCommand} [deprioritizeStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksDeprioritizeStockCountingPlanPost(deprioritizeStockCountingPlanCommand?: DeprioritizeStockCountingPlanCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksDeprioritizeStockCountingPlanPost(deprioritizeStockCountingPlanCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ForceCompleteStockCountingListCommand} [forceCompleteStockCountingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksForceCompleteStockCountingListPost(forceCompleteStockCountingListCommand?: ForceCompleteStockCountingListCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForceCompleteStockCountingListCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksForceCompleteStockCountingListPost(forceCompleteStockCountingListCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksGetActiveStockCountingPlansGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetActiveStockCountingPlansOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksGetActiveStockCountingPlansGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetCellStockCountingTaskAddressDetails} [getCellStockCountingTaskAddressDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksGetCellStockCountingTaskAdressesPost(getCellStockCountingTaskAddressDetails?: GetCellStockCountingTaskAddressDetails, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CellStockCountProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksGetCellStockCountingTaskAdressesPost(getCellStockCountingTaskAddressDetails, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksGetCellStockCountingTasksQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CellStockCountingTasksQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksGetCellStockCountingTasksQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [stockCountingListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksGetNextCellStockCountingGet(stockCountingListId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNextCellStockCountingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksGetNextCellStockCountingGet(stockCountingListId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [stockCountingListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksGetNextCellTotalStockCountingGet(stockCountingListId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNextCellTotalStockCountingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksGetNextCellTotalStockCountingGet(stockCountingListId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [stockCountingListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksGetNextProductStockCountingGet(stockCountingListId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNextProductStockCountingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksGetNextProductStockCountingGet(stockCountingListId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cellIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksGetPendingCellStockCountingPlanDetailsGet(cellIds?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPendingCellStockCountingPlanDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksGetPendingCellStockCountingPlanDetailsGet(cellIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cellAndProductIdPairs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksGetPendingItemStockCountingPlanDetailsGet(cellAndProductIdPairs?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPendingItemStockCountingPlanDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksGetPendingItemStockCountingPlanDetailsGet(cellAndProductIdPairs, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksGetStockCountingListDetailsGet(referenceNumber?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockCountingListDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksGetStockCountingListDetailsGet(referenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksGetStockCountingListsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockCountingListsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksGetStockCountingListsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [referenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksGetStockCountingPlanDetailsGet(referenceId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStockCountingPlanDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksGetStockCountingPlanDetailsGet(referenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksGetStockCountingStatisticsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockCountingStatisticsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksGetStockCountingStatisticsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrioritizeStockCountingPlanCommand} [prioritizeStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksPrioritizeStockCountingPlanPost(prioritizeStockCountingPlanCommand?: PrioritizeStockCountingPlanCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksPrioritizeStockCountingPlanPost(prioritizeStockCountingPlanCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksQueryActiveStockCountingListGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveStockCountingListsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksQueryActiveStockCountingListGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksQueryAutomaticStockCountingTasksGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryAutomaticStockCountingTasksOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksQueryAutomaticStockCountingTasksGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksQueryManualStockCountingTasksGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryManualStockCountingTasksOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksQueryManualStockCountingTasksGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksQueryQualityStockCountingTasksGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryQualityStockCountingTasksOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksQueryQualityStockCountingTasksGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksQueryStockCountingListConfigurationsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryStockCountingListConfigurationsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksQueryStockCountingListConfigurationsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stockCountingListId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksQueryStockCountingListDetailsGet(stockCountingListId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryStockCountingListDetailsByReferenceNumberOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksQueryStockCountingListDetailsGet(stockCountingListId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksQueryStockCountingListsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryStockCountingListsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksQueryStockCountingListsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} referenceId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksQueryStockCountingPlanItemsByPlanReferenceNumberGet(referenceId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksQueryStockCountingPlanItemsByPlanReferenceNumberGet(referenceId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksQueryStockCountingPlansGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryStockCountingPlanOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksQueryStockCountingPlansGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} cellLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksQueryStockCountingTasksByCellLabelGet(cellLabel: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryStockCountingTasksByCellLabelOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksQueryStockCountingTasksByCellLabelGet(cellLabel, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksQueryToCreateCellStockCountingPlanGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryToCreateCellStockCountingPlanOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksQueryToCreateCellStockCountingPlanGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksQueryToCreateItemStockCountingPlanGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryToCreateItemStockCountingPlanOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksQueryToCreateItemStockCountingPlanGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetStockCountingListConfigurationStatusCommand} [setStockCountingListConfigurationStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StockCountingTasksSetStockCountingListConfigurationStatusPost(setStockCountingListConfigurationStatusCommand?: SetStockCountingListConfigurationStatusCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StockCountingTasksSetStockCountingListConfigurationStatusPost(setStockCountingListConfigurationStatusCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StockCountingTasksApi - factory interface
 * @export
 */
export const StockCountingTasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StockCountingTasksApiFp(configuration)
    return {
        /**
         * 
         * @param {AdjustCellStockCommand} [adjustCellStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksAdjustCellStockPost(adjustCellStockCommand?: AdjustCellStockCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1StockCountingTasksAdjustCellStockPost(adjustCellStockCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckCellContainsPickingStartedItemsCommand} [checkCellContainsPickingStartedItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckCellContainsPickingStartedItemsPost(checkCellContainsPickingStartedItemsCommand?: CheckCellContainsPickingStartedItemsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1StockCountingTasksCheckCellContainsPickingStartedItemsPost(checkCellContainsPickingStartedItemsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckCellLabelCommand} [checkCellLabelCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckCellIfExistsPost(checkCellLabelCommand?: CheckCellLabelCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1StockCountingTasksCheckCellIfExistsPost(checkCellLabelCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckCellIncludesAnyItemsForStockCountingGet(cellLabel?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiV1StockCountingTasksCheckCellIncludesAnyItemsForStockCountingGet(cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckCellProductContainsPickingStartedItemsCommand} [checkCellProductContainsPickingStartedItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckCellProductContainsPickingStartedItemsPost(checkCellProductContainsPickingStartedItemsCommand?: CheckCellProductContainsPickingStartedItemsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1StockCountingTasksCheckCellProductContainsPickingStartedItemsPost(checkCellProductContainsPickingStartedItemsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckPlanSelectionActiveInStockCountingsGet(options?: any): AxiosPromise<CheckPlanSelectionActiveInStockCountingsOutputDTO> {
            return localVarFp.apiV1StockCountingTasksCheckPlanSelectionActiveInStockCountingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckProductForCellStockCountingGet(barcode?: string, cellLabel?: string, options?: any): AxiosPromise<CheckProductForCellStockCountingOutputDTO> {
            return localVarFp.apiV1StockCountingTasksCheckProductForCellStockCountingGet(barcode, cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckProductForManualCellStockCountingGet(barcode?: string, cellLabel?: string, options?: any): AxiosPromise<CheckProductForManualCellStockCountingOutputDTO> {
            return localVarFp.apiV1StockCountingTasksCheckProductForManualCellStockCountingGet(barcode, cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckSerialNumberExistsInOtherCellCommand} [checkSerialNumberExistsInOtherCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckSerialNumberExistsInOtherCellPost(checkSerialNumberExistsInOtherCellCommand?: CheckSerialNumberExistsInOtherCellCommand, options?: any): AxiosPromise<CheckSerialNumberExistsInOtherCellOutputDTO> {
            return localVarFp.apiV1StockCountingTasksCheckSerialNumberExistsInOtherCellPost(checkSerialNumberExistsInOtherCellCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckToteIfAvailableCommand} [checkToteIfAvailableCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckToteIfAvailableForManualCellStockCountingPost(checkToteIfAvailableCommand?: CheckToteIfAvailableCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1StockCountingTasksCheckToteIfAvailableForManualCellStockCountingPost(checkToteIfAvailableCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckToteIfAvailableCommand} [checkToteIfAvailableCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCheckToteIfAvailablePost(checkToteIfAvailableCommand?: CheckToteIfAvailableCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1StockCountingTasksCheckToteIfAvailablePost(checkToteIfAvailableCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteStockCountingListCommand} [completeStockCountingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCompleteStockCountingListPost(completeStockCountingListCommand?: CompleteStockCountingListCommand, options?: any): AxiosPromise<CompleteStockCountingListCommandOutputDTO> {
            return localVarFp.apiV1StockCountingTasksCompleteStockCountingListPost(completeStockCountingListCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CountCellStockCountingCommand} [countCellStockCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCountCellStockCountingPost(countCellStockCountingCommand?: CountCellStockCountingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1StockCountingTasksCountCellStockCountingPost(countCellStockCountingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CountCellTotalStockCountingCommand} [countCellTotalStockCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCountCellTotalStockCountingPost(countCellTotalStockCountingCommand?: CountCellTotalStockCountingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1StockCountingTasksCountCellTotalStockCountingPost(countCellTotalStockCountingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CountManualCellStockCountingCommand} [countManualCellStockCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCountManualCellStockCountingPost(countManualCellStockCountingCommand?: CountManualCellStockCountingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1StockCountingTasksCountManualCellStockCountingPost(countManualCellStockCountingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CountProductStockCountingCommand} [countProductStockCountingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCountProductStockCountingPost(countProductStockCountingCommand?: CountProductStockCountingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1StockCountingTasksCountProductStockCountingPost(countProductStockCountingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateManualCellStockCountingProcessCommand} [createManualCellStockCountingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCreateManualCellStockCountingProcessPost(createManualCellStockCountingProcessCommand?: CreateManualCellStockCountingProcessCommand, options?: any): AxiosPromise<CreateManualCellStockCountingProcessCommandOutputDTO> {
            return localVarFp.apiV1StockCountingTasksCreateManualCellStockCountingProcessPost(createManualCellStockCountingProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateStockCountingPlanCommand} [createStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCreateStockCountingPlanPost(createStockCountingPlanCommand?: CreateStockCountingPlanCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1StockCountingTasksCreateStockCountingPlanPost(createStockCountingPlanCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateStockCountingProcessCommand} [createStockCountingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksCreateStockCountingProcessPost(createStockCountingProcessCommand?: CreateStockCountingProcessCommand, options?: any): AxiosPromise<CreateStockCountingProcessCommandOutputDTO> {
            return localVarFp.apiV1StockCountingTasksCreateStockCountingProcessPost(createStockCountingProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeprioritizeStockCountingPlanCommand} [deprioritizeStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksDeprioritizeStockCountingPlanPost(deprioritizeStockCountingPlanCommand?: DeprioritizeStockCountingPlanCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1StockCountingTasksDeprioritizeStockCountingPlanPost(deprioritizeStockCountingPlanCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ForceCompleteStockCountingListCommand} [forceCompleteStockCountingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksForceCompleteStockCountingListPost(forceCompleteStockCountingListCommand?: ForceCompleteStockCountingListCommand, options?: any): AxiosPromise<ForceCompleteStockCountingListCommandOutputDTO> {
            return localVarFp.apiV1StockCountingTasksForceCompleteStockCountingListPost(forceCompleteStockCountingListCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetActiveStockCountingPlansGet(options?: any): AxiosPromise<Array<GetActiveStockCountingPlansOutputDTO>> {
            return localVarFp.apiV1StockCountingTasksGetActiveStockCountingPlansGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetCellStockCountingTaskAddressDetails} [getCellStockCountingTaskAddressDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetCellStockCountingTaskAdressesPost(getCellStockCountingTaskAddressDetails?: GetCellStockCountingTaskAddressDetails, options?: any): AxiosPromise<CellStockCountProcessOutputDTO> {
            return localVarFp.apiV1StockCountingTasksGetCellStockCountingTaskAdressesPost(getCellStockCountingTaskAddressDetails, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetCellStockCountingTasksQueryGet(dqb?: string, options?: any): AxiosPromise<CellStockCountingTasksQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1StockCountingTasksGetCellStockCountingTasksQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [stockCountingListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetNextCellStockCountingGet(stockCountingListId?: string, options?: any): AxiosPromise<GetNextCellStockCountingOutputDTO> {
            return localVarFp.apiV1StockCountingTasksGetNextCellStockCountingGet(stockCountingListId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [stockCountingListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetNextCellTotalStockCountingGet(stockCountingListId?: string, options?: any): AxiosPromise<GetNextCellTotalStockCountingOutputDTO> {
            return localVarFp.apiV1StockCountingTasksGetNextCellTotalStockCountingGet(stockCountingListId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [stockCountingListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetNextProductStockCountingGet(stockCountingListId?: string, options?: any): AxiosPromise<GetNextProductStockCountingOutputDTO> {
            return localVarFp.apiV1StockCountingTasksGetNextProductStockCountingGet(stockCountingListId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cellIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetPendingCellStockCountingPlanDetailsGet(cellIds?: string, options?: any): AxiosPromise<GetPendingCellStockCountingPlanDetailsOutputDTO> {
            return localVarFp.apiV1StockCountingTasksGetPendingCellStockCountingPlanDetailsGet(cellIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cellAndProductIdPairs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetPendingItemStockCountingPlanDetailsGet(cellAndProductIdPairs?: string, options?: any): AxiosPromise<GetPendingItemStockCountingPlanDetailsOutputDTO> {
            return localVarFp.apiV1StockCountingTasksGetPendingItemStockCountingPlanDetailsGet(cellAndProductIdPairs, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetStockCountingListDetailsGet(referenceNumber?: number, options?: any): AxiosPromise<StockCountingListDetailsOutputDTO> {
            return localVarFp.apiV1StockCountingTasksGetStockCountingListDetailsGet(referenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetStockCountingListsGet(options?: any): AxiosPromise<StockCountingListsOutputDTO> {
            return localVarFp.apiV1StockCountingTasksGetStockCountingListsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [referenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetStockCountingPlanDetailsGet(referenceId?: string, options?: any): AxiosPromise<GetStockCountingPlanDetailsOutputDTO> {
            return localVarFp.apiV1StockCountingTasksGetStockCountingPlanDetailsGet(referenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksGetStockCountingStatisticsGet(options?: any): AxiosPromise<StockCountingStatisticsOutputDTO> {
            return localVarFp.apiV1StockCountingTasksGetStockCountingStatisticsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrioritizeStockCountingPlanCommand} [prioritizeStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksPrioritizeStockCountingPlanPost(prioritizeStockCountingPlanCommand?: PrioritizeStockCountingPlanCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1StockCountingTasksPrioritizeStockCountingPlanPost(prioritizeStockCountingPlanCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryActiveStockCountingListGet(dqb?: string, options?: any): AxiosPromise<ActiveStockCountingListsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1StockCountingTasksQueryActiveStockCountingListGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryAutomaticStockCountingTasksGet(dqb?: string, options?: any): AxiosPromise<QueryAutomaticStockCountingTasksOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1StockCountingTasksQueryAutomaticStockCountingTasksGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryManualStockCountingTasksGet(dqb?: string, options?: any): AxiosPromise<QueryManualStockCountingTasksOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1StockCountingTasksQueryManualStockCountingTasksGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryQualityStockCountingTasksGet(dqb?: string, options?: any): AxiosPromise<QueryQualityStockCountingTasksOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1StockCountingTasksQueryQualityStockCountingTasksGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryStockCountingListConfigurationsGet(dqb?: string, options?: any): AxiosPromise<QueryStockCountingListConfigurationsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1StockCountingTasksQueryStockCountingListConfigurationsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stockCountingListId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryStockCountingListDetailsGet(stockCountingListId: string, dqb?: string, options?: any): AxiosPromise<QueryStockCountingListDetailsByReferenceNumberOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1StockCountingTasksQueryStockCountingListDetailsGet(stockCountingListId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryStockCountingListsGet(dqb?: string, options?: any): AxiosPromise<QueryStockCountingListsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1StockCountingTasksQueryStockCountingListsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} referenceId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryStockCountingPlanItemsByPlanReferenceNumberGet(referenceId: string, dqb?: string, options?: any): AxiosPromise<QueryStockCountingPlanItemsByPlanReferenceNumberOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1StockCountingTasksQueryStockCountingPlanItemsByPlanReferenceNumberGet(referenceId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryStockCountingPlansGet(dqb?: string, options?: any): AxiosPromise<QueryStockCountingPlanOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1StockCountingTasksQueryStockCountingPlansGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} cellLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryStockCountingTasksByCellLabelGet(cellLabel: string, dqb?: string, options?: any): AxiosPromise<QueryStockCountingTasksByCellLabelOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1StockCountingTasksQueryStockCountingTasksByCellLabelGet(cellLabel, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryToCreateCellStockCountingPlanGet(dqb?: string, options?: any): AxiosPromise<QueryToCreateCellStockCountingPlanOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1StockCountingTasksQueryToCreateCellStockCountingPlanGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksQueryToCreateItemStockCountingPlanGet(dqb?: string, options?: any): AxiosPromise<QueryToCreateItemStockCountingPlanOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1StockCountingTasksQueryToCreateItemStockCountingPlanGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetStockCountingListConfigurationStatusCommand} [setStockCountingListConfigurationStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StockCountingTasksSetStockCountingListConfigurationStatusPost(setStockCountingListConfigurationStatusCommand?: SetStockCountingListConfigurationStatusCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1StockCountingTasksSetStockCountingListConfigurationStatusPost(setStockCountingListConfigurationStatusCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StockCountingTasksApi - object-oriented interface
 * @export
 * @class StockCountingTasksApi
 * @extends {BaseAPI}
 */
export class StockCountingTasksApi extends BaseAPI {
    /**
     * 
     * @param {AdjustCellStockCommand} [adjustCellStockCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksAdjustCellStockPost(adjustCellStockCommand?: AdjustCellStockCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksAdjustCellStockPost(adjustCellStockCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckCellContainsPickingStartedItemsCommand} [checkCellContainsPickingStartedItemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCheckCellContainsPickingStartedItemsPost(checkCellContainsPickingStartedItemsCommand?: CheckCellContainsPickingStartedItemsCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCheckCellContainsPickingStartedItemsPost(checkCellContainsPickingStartedItemsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckCellLabelCommand} [checkCellLabelCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCheckCellIfExistsPost(checkCellLabelCommand?: CheckCellLabelCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCheckCellIfExistsPost(checkCellLabelCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCheckCellIncludesAnyItemsForStockCountingGet(cellLabel?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCheckCellIncludesAnyItemsForStockCountingGet(cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckCellProductContainsPickingStartedItemsCommand} [checkCellProductContainsPickingStartedItemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCheckCellProductContainsPickingStartedItemsPost(checkCellProductContainsPickingStartedItemsCommand?: CheckCellProductContainsPickingStartedItemsCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCheckCellProductContainsPickingStartedItemsPost(checkCellProductContainsPickingStartedItemsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCheckPlanSelectionActiveInStockCountingsGet(options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCheckPlanSelectionActiveInStockCountingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCheckProductForCellStockCountingGet(barcode?: string, cellLabel?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCheckProductForCellStockCountingGet(barcode, cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCheckProductForManualCellStockCountingGet(barcode?: string, cellLabel?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCheckProductForManualCellStockCountingGet(barcode, cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckSerialNumberExistsInOtherCellCommand} [checkSerialNumberExistsInOtherCellCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCheckSerialNumberExistsInOtherCellPost(checkSerialNumberExistsInOtherCellCommand?: CheckSerialNumberExistsInOtherCellCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCheckSerialNumberExistsInOtherCellPost(checkSerialNumberExistsInOtherCellCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckToteIfAvailableCommand} [checkToteIfAvailableCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCheckToteIfAvailableForManualCellStockCountingPost(checkToteIfAvailableCommand?: CheckToteIfAvailableCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCheckToteIfAvailableForManualCellStockCountingPost(checkToteIfAvailableCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckToteIfAvailableCommand} [checkToteIfAvailableCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCheckToteIfAvailablePost(checkToteIfAvailableCommand?: CheckToteIfAvailableCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCheckToteIfAvailablePost(checkToteIfAvailableCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteStockCountingListCommand} [completeStockCountingListCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCompleteStockCountingListPost(completeStockCountingListCommand?: CompleteStockCountingListCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCompleteStockCountingListPost(completeStockCountingListCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CountCellStockCountingCommand} [countCellStockCountingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCountCellStockCountingPost(countCellStockCountingCommand?: CountCellStockCountingCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCountCellStockCountingPost(countCellStockCountingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CountCellTotalStockCountingCommand} [countCellTotalStockCountingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCountCellTotalStockCountingPost(countCellTotalStockCountingCommand?: CountCellTotalStockCountingCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCountCellTotalStockCountingPost(countCellTotalStockCountingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CountManualCellStockCountingCommand} [countManualCellStockCountingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCountManualCellStockCountingPost(countManualCellStockCountingCommand?: CountManualCellStockCountingCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCountManualCellStockCountingPost(countManualCellStockCountingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CountProductStockCountingCommand} [countProductStockCountingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCountProductStockCountingPost(countProductStockCountingCommand?: CountProductStockCountingCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCountProductStockCountingPost(countProductStockCountingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateManualCellStockCountingProcessCommand} [createManualCellStockCountingProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCreateManualCellStockCountingProcessPost(createManualCellStockCountingProcessCommand?: CreateManualCellStockCountingProcessCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCreateManualCellStockCountingProcessPost(createManualCellStockCountingProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateStockCountingPlanCommand} [createStockCountingPlanCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCreateStockCountingPlanPost(createStockCountingPlanCommand?: CreateStockCountingPlanCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCreateStockCountingPlanPost(createStockCountingPlanCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateStockCountingProcessCommand} [createStockCountingProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksCreateStockCountingProcessPost(createStockCountingProcessCommand?: CreateStockCountingProcessCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksCreateStockCountingProcessPost(createStockCountingProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeprioritizeStockCountingPlanCommand} [deprioritizeStockCountingPlanCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksDeprioritizeStockCountingPlanPost(deprioritizeStockCountingPlanCommand?: DeprioritizeStockCountingPlanCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksDeprioritizeStockCountingPlanPost(deprioritizeStockCountingPlanCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ForceCompleteStockCountingListCommand} [forceCompleteStockCountingListCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksForceCompleteStockCountingListPost(forceCompleteStockCountingListCommand?: ForceCompleteStockCountingListCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksForceCompleteStockCountingListPost(forceCompleteStockCountingListCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksGetActiveStockCountingPlansGet(options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksGetActiveStockCountingPlansGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetCellStockCountingTaskAddressDetails} [getCellStockCountingTaskAddressDetails] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksGetCellStockCountingTaskAdressesPost(getCellStockCountingTaskAddressDetails?: GetCellStockCountingTaskAddressDetails, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksGetCellStockCountingTaskAdressesPost(getCellStockCountingTaskAddressDetails, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksGetCellStockCountingTasksQueryGet(dqb?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksGetCellStockCountingTasksQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [stockCountingListId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksGetNextCellStockCountingGet(stockCountingListId?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksGetNextCellStockCountingGet(stockCountingListId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [stockCountingListId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksGetNextCellTotalStockCountingGet(stockCountingListId?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksGetNextCellTotalStockCountingGet(stockCountingListId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [stockCountingListId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksGetNextProductStockCountingGet(stockCountingListId?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksGetNextProductStockCountingGet(stockCountingListId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cellIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksGetPendingCellStockCountingPlanDetailsGet(cellIds?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksGetPendingCellStockCountingPlanDetailsGet(cellIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cellAndProductIdPairs] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksGetPendingItemStockCountingPlanDetailsGet(cellAndProductIdPairs?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksGetPendingItemStockCountingPlanDetailsGet(cellAndProductIdPairs, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [referenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksGetStockCountingListDetailsGet(referenceNumber?: number, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksGetStockCountingListDetailsGet(referenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksGetStockCountingListsGet(options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksGetStockCountingListsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [referenceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksGetStockCountingPlanDetailsGet(referenceId?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksGetStockCountingPlanDetailsGet(referenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksGetStockCountingStatisticsGet(options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksGetStockCountingStatisticsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrioritizeStockCountingPlanCommand} [prioritizeStockCountingPlanCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksPrioritizeStockCountingPlanPost(prioritizeStockCountingPlanCommand?: PrioritizeStockCountingPlanCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksPrioritizeStockCountingPlanPost(prioritizeStockCountingPlanCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksQueryActiveStockCountingListGet(dqb?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksQueryActiveStockCountingListGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksQueryAutomaticStockCountingTasksGet(dqb?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksQueryAutomaticStockCountingTasksGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksQueryManualStockCountingTasksGet(dqb?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksQueryManualStockCountingTasksGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksQueryQualityStockCountingTasksGet(dqb?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksQueryQualityStockCountingTasksGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksQueryStockCountingListConfigurationsGet(dqb?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksQueryStockCountingListConfigurationsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stockCountingListId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksQueryStockCountingListDetailsGet(stockCountingListId: string, dqb?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksQueryStockCountingListDetailsGet(stockCountingListId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksQueryStockCountingListsGet(dqb?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksQueryStockCountingListsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} referenceId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksQueryStockCountingPlanItemsByPlanReferenceNumberGet(referenceId: string, dqb?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksQueryStockCountingPlanItemsByPlanReferenceNumberGet(referenceId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksQueryStockCountingPlansGet(dqb?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksQueryStockCountingPlansGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} cellLabel 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksQueryStockCountingTasksByCellLabelGet(cellLabel: string, dqb?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksQueryStockCountingTasksByCellLabelGet(cellLabel, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksQueryToCreateCellStockCountingPlanGet(dqb?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksQueryToCreateCellStockCountingPlanGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksQueryToCreateItemStockCountingPlanGet(dqb?: string, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksQueryToCreateItemStockCountingPlanGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetStockCountingListConfigurationStatusCommand} [setStockCountingListConfigurationStatusCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockCountingTasksApi
     */
    public apiV1StockCountingTasksSetStockCountingListConfigurationStatusPost(setStockCountingListConfigurationStatusCommand?: SetStockCountingListConfigurationStatusCommand, options?: any) {
        return StockCountingTasksApiFp(this.configuration).apiV1StockCountingTasksSetStockCountingListConfigurationStatusPost(setStockCountingListConfigurationStatusCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SubZonesApi - axios parameter creator
 * @export
 */
export const SubZonesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AssignAddressesToSubZoneCommand} [assignAddressesToSubZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubZonesAssignAddressesPost: async (assignAddressesToSubZoneCommand?: AssignAddressesToSubZoneCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SubZones.assignAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignAddressesToSubZoneCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSubZoneCommand} [createSubZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubZonesCreatePost: async (createSubZoneCommand?: CreateSubZoneCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SubZones.create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSubZoneCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} stockZoneId 
         * @param {boolean} onlyEnabled 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubZonesQueryGet: async (stockZoneId: number, onlyEnabled: boolean, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockZoneId' is not null or undefined
            assertParamExists('apiV1SubZonesQueryGet', 'stockZoneId', stockZoneId)
            // verify required parameter 'onlyEnabled' is not null or undefined
            assertParamExists('apiV1SubZonesQueryGet', 'onlyEnabled', onlyEnabled)
            const localVarPath = `/api/v1/SubZones.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockZoneId !== undefined) {
                localVarQueryParameter['stockZoneId'] = stockZoneId;
            }

            if (onlyEnabled !== undefined) {
                localVarQueryParameter['onlyEnabled'] = onlyEnabled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSubZoneCommand} [updateSubZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubZonesUpdatePost: async (updateSubZoneCommand?: UpdateSubZoneCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/SubZones.update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSubZoneCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubZonesApi - functional programming interface
 * @export
 */
export const SubZonesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubZonesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AssignAddressesToSubZoneCommand} [assignAddressesToSubZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SubZonesAssignAddressesPost(assignAddressesToSubZoneCommand?: AssignAddressesToSubZoneCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SubZonesAssignAddressesPost(assignAddressesToSubZoneCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSubZoneCommand} [createSubZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SubZonesCreatePost(createSubZoneCommand?: CreateSubZoneCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SubZonesCreatePost(createSubZoneCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} stockZoneId 
         * @param {boolean} onlyEnabled 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SubZonesQueryGet(stockZoneId: number, onlyEnabled: boolean, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubZoneOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SubZonesQueryGet(stockZoneId, onlyEnabled, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateSubZoneCommand} [updateSubZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SubZonesUpdatePost(updateSubZoneCommand?: UpdateSubZoneCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SubZonesUpdatePost(updateSubZoneCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SubZonesApi - factory interface
 * @export
 */
export const SubZonesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubZonesApiFp(configuration)
    return {
        /**
         * 
         * @param {AssignAddressesToSubZoneCommand} [assignAddressesToSubZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubZonesAssignAddressesPost(assignAddressesToSubZoneCommand?: AssignAddressesToSubZoneCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiV1SubZonesAssignAddressesPost(assignAddressesToSubZoneCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSubZoneCommand} [createSubZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubZonesCreatePost(createSubZoneCommand?: CreateSubZoneCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiV1SubZonesCreatePost(createSubZoneCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} stockZoneId 
         * @param {boolean} onlyEnabled 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubZonesQueryGet(stockZoneId: number, onlyEnabled: boolean, dqb?: string, options?: any): AxiosPromise<SubZoneOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1SubZonesQueryGet(stockZoneId, onlyEnabled, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateSubZoneCommand} [updateSubZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SubZonesUpdatePost(updateSubZoneCommand?: UpdateSubZoneCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1SubZonesUpdatePost(updateSubZoneCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubZonesApi - object-oriented interface
 * @export
 * @class SubZonesApi
 * @extends {BaseAPI}
 */
export class SubZonesApi extends BaseAPI {
    /**
     * 
     * @param {AssignAddressesToSubZoneCommand} [assignAddressesToSubZoneCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubZonesApi
     */
    public apiV1SubZonesAssignAddressesPost(assignAddressesToSubZoneCommand?: AssignAddressesToSubZoneCommand, options?: any) {
        return SubZonesApiFp(this.configuration).apiV1SubZonesAssignAddressesPost(assignAddressesToSubZoneCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSubZoneCommand} [createSubZoneCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubZonesApi
     */
    public apiV1SubZonesCreatePost(createSubZoneCommand?: CreateSubZoneCommand, options?: any) {
        return SubZonesApiFp(this.configuration).apiV1SubZonesCreatePost(createSubZoneCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} stockZoneId 
     * @param {boolean} onlyEnabled 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubZonesApi
     */
    public apiV1SubZonesQueryGet(stockZoneId: number, onlyEnabled: boolean, dqb?: string, options?: any) {
        return SubZonesApiFp(this.configuration).apiV1SubZonesQueryGet(stockZoneId, onlyEnabled, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateSubZoneCommand} [updateSubZoneCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubZonesApi
     */
    public apiV1SubZonesUpdatePost(updateSubZoneCommand?: UpdateSubZoneCommand, options?: any) {
        return SubZonesApiFp(this.configuration).apiV1SubZonesUpdatePost(updateSubZoneCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TenantsApi - axios parameter creator
 * @export
 */
export const TenantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateTenantCommand} [createTenantCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1TenantsCreatePost: async (createTenantCommand?: CreateTenantCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Tenants.create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTenantCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteTenantCommand} [deleteTenantCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1TenantsDeletePost: async (deleteTenantCommand?: DeleteTenantCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Tenants.delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteTenantCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1TenantsGetStockCountingListConfigurationsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Tenants.getStockCountingListConfigurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1TenantsQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Tenants.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateStockCountingListConfigurationsCommand} [updateStockCountingListConfigurationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1TenantsUpdateStockCountingListConfigurationsPost: async (updateStockCountingListConfigurationsCommand?: UpdateStockCountingListConfigurationsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Tenants.updateStockCountingListConfigurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStockCountingListConfigurationsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantsGetTenantConfigurationsByTenantIdGet: async (tenantId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Tenants.getTenantConfigurationsByTenantId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantsListRolesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Tenants.listRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantsQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Tenants.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantsApi - functional programming interface
 * @export
 */
export const TenantsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateTenantCommand} [createTenantCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1TenantsCreatePost(createTenantCommand?: CreateTenantCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTenantOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1TenantsCreatePost(createTenantCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteTenantCommand} [deleteTenantCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1TenantsDeletePost(deleteTenantCommand?: DeleteTenantCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1TenantsDeletePost(deleteTenantCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1TenantsGetStockCountingListConfigurationsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockCountingListConfigurationOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1TenantsGetStockCountingListConfigurationsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1TenantsQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1TenantsQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateStockCountingListConfigurationsCommand} [updateStockCountingListConfigurationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1TenantsUpdateStockCountingListConfigurationsPost(updateStockCountingListConfigurationsCommand?: UpdateStockCountingListConfigurationsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1TenantsUpdateStockCountingListConfigurationsPost(updateStockCountingListConfigurationsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantsGetTenantConfigurationsByTenantIdGet(tenantId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantConfigurationsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantsGetTenantConfigurationsByTenantIdGet(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantsListRolesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantsListRolesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TenantsQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TenantsQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenantsApi - factory interface
 * @export
 */
export const TenantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateTenantCommand} [createTenantCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1TenantsCreatePost(createTenantCommand?: CreateTenantCommand, options?: any): AxiosPromise<CreateTenantOutputDTO> {
            return localVarFp.adminV1TenantsCreatePost(createTenantCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteTenantCommand} [deleteTenantCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1TenantsDeletePost(deleteTenantCommand?: DeleteTenantCommand, options?: any): AxiosPromise<void> {
            return localVarFp.adminV1TenantsDeletePost(deleteTenantCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1TenantsGetStockCountingListConfigurationsGet(options?: any): AxiosPromise<Array<StockCountingListConfigurationOutputDTO>> {
            return localVarFp.adminV1TenantsGetStockCountingListConfigurationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1TenantsQueryGet(dqb?: string, options?: any): AxiosPromise<TenantQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.adminV1TenantsQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateStockCountingListConfigurationsCommand} [updateStockCountingListConfigurationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1TenantsUpdateStockCountingListConfigurationsPost(updateStockCountingListConfigurationsCommand?: UpdateStockCountingListConfigurationsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.adminV1TenantsUpdateStockCountingListConfigurationsPost(updateStockCountingListConfigurationsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantsGetTenantConfigurationsByTenantIdGet(tenantId?: string, options?: any): AxiosPromise<TenantConfigurationsOutputDTO> {
            return localVarFp.apiV1TenantsGetTenantConfigurationsByTenantIdGet(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantsListRolesGet(options?: any): AxiosPromise<Array<RoleOutputDTO>> {
            return localVarFp.apiV1TenantsListRolesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TenantsQueryGet(dqb?: string, options?: any): AxiosPromise<UserQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1TenantsQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantsApi - object-oriented interface
 * @export
 * @class TenantsApi
 * @extends {BaseAPI}
 */
export class TenantsApi extends BaseAPI {
    /**
     * 
     * @param {CreateTenantCommand} [createTenantCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public adminV1TenantsCreatePost(createTenantCommand?: CreateTenantCommand, options?: any) {
        return TenantsApiFp(this.configuration).adminV1TenantsCreatePost(createTenantCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteTenantCommand} [deleteTenantCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public adminV1TenantsDeletePost(deleteTenantCommand?: DeleteTenantCommand, options?: any) {
        return TenantsApiFp(this.configuration).adminV1TenantsDeletePost(deleteTenantCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public adminV1TenantsGetStockCountingListConfigurationsGet(options?: any) {
        return TenantsApiFp(this.configuration).adminV1TenantsGetStockCountingListConfigurationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public adminV1TenantsQueryGet(dqb?: string, options?: any) {
        return TenantsApiFp(this.configuration).adminV1TenantsQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateStockCountingListConfigurationsCommand} [updateStockCountingListConfigurationsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public adminV1TenantsUpdateStockCountingListConfigurationsPost(updateStockCountingListConfigurationsCommand?: UpdateStockCountingListConfigurationsCommand, options?: any) {
        return TenantsApiFp(this.configuration).adminV1TenantsUpdateStockCountingListConfigurationsPost(updateStockCountingListConfigurationsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [tenantId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public apiV1TenantsGetTenantConfigurationsByTenantIdGet(tenantId?: string, options?: any) {
        return TenantsApiFp(this.configuration).apiV1TenantsGetTenantConfigurationsByTenantIdGet(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public apiV1TenantsListRolesGet(options?: any) {
        return TenantsApiFp(this.configuration).apiV1TenantsListRolesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public apiV1TenantsQueryGet(dqb?: string, options?: any) {
        return TenantsApiFp(this.configuration).apiV1TenantsQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ToteSelectivePickingProcessApi - axios parameter creator
 * @export
 */
export const ToteSelectivePickingProcessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CheckCellCommand} [checkCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessCheckCellPost: async (checkCellCommand?: CheckCellCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteSelectivePickingProcess.checkCell`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkCellCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckToteSelectivePickingDropAddressCommand} [checkToteSelectivePickingDropAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessCheckDropAddressPost: async (checkToteSelectivePickingDropAddressCommand?: CheckToteSelectivePickingDropAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteSelectivePickingProcess.checkDropAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkToteSelectivePickingDropAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessCheckIfControlCountingIsActiveGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteSelectivePickingProcess.checkIfControlCountingIsActive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckPickingItemExistCommand} [checkPickingItemExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessCheckProductExistPost: async (checkPickingItemExistCommand?: CheckPickingItemExistCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteSelectivePickingProcess.checkProductExist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkPickingItemExistCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckToteCommand} [checkToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessCheckTotePost: async (checkToteCommand?: CheckToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteSelectivePickingProcess.checkTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompletePickingProcessCommand} [completePickingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessCompletePickingProcessPost: async (completePickingProcessCommand?: CompletePickingProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteSelectivePickingProcess.completePickingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completePickingProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessGetZoneByCellLabelGet: async (cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteSelectivePickingProcess.getZoneByCellLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LostItemCommand} [lostItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessLostItemPost: async (lostItemCommand?: LostItemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteSelectivePickingProcess.lostItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lostItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MountToteToToteSelectivePickingTrolleyCommand} [mountToteToToteSelectivePickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessMountToteToTrolleyIfNotMountedPost: async (mountToteToToteSelectivePickingTrolleyCommand?: MountToteToToteSelectivePickingTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteSelectivePickingProcess.mountToteToTrolleyIfNotMounted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mountToteToToteSelectivePickingTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceProductToPickingToteCommand} [placeProductToPickingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessPlaceProductPost: async (placeProductToPickingToteCommand?: PlaceProductToPickingToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteSelectivePickingProcess.placeProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeProductToPickingToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartCreatedPickingToteSelectiveCommand} [startCreatedPickingToteSelectiveCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessStartCreatedPickingPost: async (startCreatedPickingToteSelectiveCommand?: StartCreatedPickingToteSelectiveCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteSelectivePickingProcess.startCreatedPicking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startCreatedPickingToteSelectiveCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnmountToteFromToteSelectivePickingTrolleyCommand} [unmountToteFromToteSelectivePickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessUnmountToteFromTrolleyPost: async (unmountToteFromToteSelectivePickingTrolleyCommand?: UnmountToteFromToteSelectivePickingTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteSelectivePickingProcess.unmountToteFromTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unmountToteFromToteSelectivePickingTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ToteSelectivePickingProcessApi - functional programming interface
 * @export
 */
export const ToteSelectivePickingProcessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ToteSelectivePickingProcessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CheckCellCommand} [checkCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteSelectivePickingProcessCheckCellPost(checkCellCommand?: CheckCellCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteSelectivePickingProcessCheckCellPost(checkCellCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckToteSelectivePickingDropAddressCommand} [checkToteSelectivePickingDropAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteSelectivePickingProcessCheckDropAddressPost(checkToteSelectivePickingDropAddressCommand?: CheckToteSelectivePickingDropAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckToteSelectivePickingDropAddressCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteSelectivePickingProcessCheckDropAddressPost(checkToteSelectivePickingDropAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteSelectivePickingProcessCheckIfControlCountingIsActiveGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckIfControlCountingIsActiveOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteSelectivePickingProcessCheckIfControlCountingIsActiveGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckPickingItemExistCommand} [checkPickingItemExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteSelectivePickingProcessCheckProductExistPost(checkPickingItemExistCommand?: CheckPickingItemExistCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteSelectivePickingProcessCheckProductExistPost(checkPickingItemExistCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckToteCommand} [checkToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteSelectivePickingProcessCheckTotePost(checkToteCommand?: CheckToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteSelectivePickingProcessCheckTotePost(checkToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompletePickingProcessCommand} [completePickingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteSelectivePickingProcessCompletePickingProcessPost(completePickingProcessCommand?: CompletePickingProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteSelectivePickingProcessCompletePickingProcessPost(completePickingProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteSelectivePickingProcessGetZoneByCellLabelGet(cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetZoneByCellLabelOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteSelectivePickingProcessGetZoneByCellLabelGet(cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LostItemCommand} [lostItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteSelectivePickingProcessLostItemPost(lostItemCommand?: LostItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteSelectivePickingProcessLostItemPost(lostItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MountToteToToteSelectivePickingTrolleyCommand} [mountToteToToteSelectivePickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteSelectivePickingProcessMountToteToTrolleyIfNotMountedPost(mountToteToToteSelectivePickingTrolleyCommand?: MountToteToToteSelectivePickingTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteSelectivePickingProcessMountToteToTrolleyIfNotMountedPost(mountToteToToteSelectivePickingTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceProductToPickingToteCommand} [placeProductToPickingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteSelectivePickingProcessPlaceProductPost(placeProductToPickingToteCommand?: PlaceProductToPickingToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteSelectivePickingProcessPlaceProductPost(placeProductToPickingToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StartCreatedPickingToteSelectiveCommand} [startCreatedPickingToteSelectiveCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteSelectivePickingProcessStartCreatedPickingPost(startCreatedPickingToteSelectiveCommand?: StartCreatedPickingToteSelectiveCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartCreatedPickingToteSelectiveCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteSelectivePickingProcessStartCreatedPickingPost(startCreatedPickingToteSelectiveCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UnmountToteFromToteSelectivePickingTrolleyCommand} [unmountToteFromToteSelectivePickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteSelectivePickingProcessUnmountToteFromTrolleyPost(unmountToteFromToteSelectivePickingTrolleyCommand?: UnmountToteFromToteSelectivePickingTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnmountToteFromToteSelectivePickingTrolleyCommandOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteSelectivePickingProcessUnmountToteFromTrolleyPost(unmountToteFromToteSelectivePickingTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ToteSelectivePickingProcessApi - factory interface
 * @export
 */
export const ToteSelectivePickingProcessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ToteSelectivePickingProcessApiFp(configuration)
    return {
        /**
         * 
         * @param {CheckCellCommand} [checkCellCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessCheckCellPost(checkCellCommand?: CheckCellCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ToteSelectivePickingProcessCheckCellPost(checkCellCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckToteSelectivePickingDropAddressCommand} [checkToteSelectivePickingDropAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessCheckDropAddressPost(checkToteSelectivePickingDropAddressCommand?: CheckToteSelectivePickingDropAddressCommand, options?: any): AxiosPromise<CheckToteSelectivePickingDropAddressCommandOutputDTO> {
            return localVarFp.apiV1ToteSelectivePickingProcessCheckDropAddressPost(checkToteSelectivePickingDropAddressCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessCheckIfControlCountingIsActiveGet(options?: any): AxiosPromise<CheckIfControlCountingIsActiveOutputDTO> {
            return localVarFp.apiV1ToteSelectivePickingProcessCheckIfControlCountingIsActiveGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckPickingItemExistCommand} [checkPickingItemExistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessCheckProductExistPost(checkPickingItemExistCommand?: CheckPickingItemExistCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ToteSelectivePickingProcessCheckProductExistPost(checkPickingItemExistCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckToteCommand} [checkToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessCheckTotePost(checkToteCommand?: CheckToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ToteSelectivePickingProcessCheckTotePost(checkToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompletePickingProcessCommand} [completePickingProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessCompletePickingProcessPost(completePickingProcessCommand?: CompletePickingProcessCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ToteSelectivePickingProcessCompletePickingProcessPost(completePickingProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessGetZoneByCellLabelGet(cellLabel?: string, options?: any): AxiosPromise<GetZoneByCellLabelOutputDTO> {
            return localVarFp.apiV1ToteSelectivePickingProcessGetZoneByCellLabelGet(cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LostItemCommand} [lostItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessLostItemPost(lostItemCommand?: LostItemCommand, options?: any): AxiosPromise<RouteOutputDTO> {
            return localVarFp.apiV1ToteSelectivePickingProcessLostItemPost(lostItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MountToteToToteSelectivePickingTrolleyCommand} [mountToteToToteSelectivePickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessMountToteToTrolleyIfNotMountedPost(mountToteToToteSelectivePickingTrolleyCommand?: MountToteToToteSelectivePickingTrolleyCommand, options?: any): AxiosPromise<RouteOutputDTO> {
            return localVarFp.apiV1ToteSelectivePickingProcessMountToteToTrolleyIfNotMountedPost(mountToteToToteSelectivePickingTrolleyCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceProductToPickingToteCommand} [placeProductToPickingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessPlaceProductPost(placeProductToPickingToteCommand?: PlaceProductToPickingToteCommand, options?: any): AxiosPromise<RouteOutputDTO> {
            return localVarFp.apiV1ToteSelectivePickingProcessPlaceProductPost(placeProductToPickingToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StartCreatedPickingToteSelectiveCommand} [startCreatedPickingToteSelectiveCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessStartCreatedPickingPost(startCreatedPickingToteSelectiveCommand?: StartCreatedPickingToteSelectiveCommand, options?: any): AxiosPromise<StartCreatedPickingToteSelectiveCommandOutputDTO> {
            return localVarFp.apiV1ToteSelectivePickingProcessStartCreatedPickingPost(startCreatedPickingToteSelectiveCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnmountToteFromToteSelectivePickingTrolleyCommand} [unmountToteFromToteSelectivePickingTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteSelectivePickingProcessUnmountToteFromTrolleyPost(unmountToteFromToteSelectivePickingTrolleyCommand?: UnmountToteFromToteSelectivePickingTrolleyCommand, options?: any): AxiosPromise<UnmountToteFromToteSelectivePickingTrolleyCommandOutputDTO> {
            return localVarFp.apiV1ToteSelectivePickingProcessUnmountToteFromTrolleyPost(unmountToteFromToteSelectivePickingTrolleyCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ToteSelectivePickingProcessApi - object-oriented interface
 * @export
 * @class ToteSelectivePickingProcessApi
 * @extends {BaseAPI}
 */
export class ToteSelectivePickingProcessApi extends BaseAPI {
    /**
     * 
     * @param {CheckCellCommand} [checkCellCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteSelectivePickingProcessApi
     */
    public apiV1ToteSelectivePickingProcessCheckCellPost(checkCellCommand?: CheckCellCommand, options?: any) {
        return ToteSelectivePickingProcessApiFp(this.configuration).apiV1ToteSelectivePickingProcessCheckCellPost(checkCellCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckToteSelectivePickingDropAddressCommand} [checkToteSelectivePickingDropAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteSelectivePickingProcessApi
     */
    public apiV1ToteSelectivePickingProcessCheckDropAddressPost(checkToteSelectivePickingDropAddressCommand?: CheckToteSelectivePickingDropAddressCommand, options?: any) {
        return ToteSelectivePickingProcessApiFp(this.configuration).apiV1ToteSelectivePickingProcessCheckDropAddressPost(checkToteSelectivePickingDropAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteSelectivePickingProcessApi
     */
    public apiV1ToteSelectivePickingProcessCheckIfControlCountingIsActiveGet(options?: any) {
        return ToteSelectivePickingProcessApiFp(this.configuration).apiV1ToteSelectivePickingProcessCheckIfControlCountingIsActiveGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckPickingItemExistCommand} [checkPickingItemExistCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteSelectivePickingProcessApi
     */
    public apiV1ToteSelectivePickingProcessCheckProductExistPost(checkPickingItemExistCommand?: CheckPickingItemExistCommand, options?: any) {
        return ToteSelectivePickingProcessApiFp(this.configuration).apiV1ToteSelectivePickingProcessCheckProductExistPost(checkPickingItemExistCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckToteCommand} [checkToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteSelectivePickingProcessApi
     */
    public apiV1ToteSelectivePickingProcessCheckTotePost(checkToteCommand?: CheckToteCommand, options?: any) {
        return ToteSelectivePickingProcessApiFp(this.configuration).apiV1ToteSelectivePickingProcessCheckTotePost(checkToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompletePickingProcessCommand} [completePickingProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteSelectivePickingProcessApi
     */
    public apiV1ToteSelectivePickingProcessCompletePickingProcessPost(completePickingProcessCommand?: CompletePickingProcessCommand, options?: any) {
        return ToteSelectivePickingProcessApiFp(this.configuration).apiV1ToteSelectivePickingProcessCompletePickingProcessPost(completePickingProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteSelectivePickingProcessApi
     */
    public apiV1ToteSelectivePickingProcessGetZoneByCellLabelGet(cellLabel?: string, options?: any) {
        return ToteSelectivePickingProcessApiFp(this.configuration).apiV1ToteSelectivePickingProcessGetZoneByCellLabelGet(cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LostItemCommand} [lostItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteSelectivePickingProcessApi
     */
    public apiV1ToteSelectivePickingProcessLostItemPost(lostItemCommand?: LostItemCommand, options?: any) {
        return ToteSelectivePickingProcessApiFp(this.configuration).apiV1ToteSelectivePickingProcessLostItemPost(lostItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MountToteToToteSelectivePickingTrolleyCommand} [mountToteToToteSelectivePickingTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteSelectivePickingProcessApi
     */
    public apiV1ToteSelectivePickingProcessMountToteToTrolleyIfNotMountedPost(mountToteToToteSelectivePickingTrolleyCommand?: MountToteToToteSelectivePickingTrolleyCommand, options?: any) {
        return ToteSelectivePickingProcessApiFp(this.configuration).apiV1ToteSelectivePickingProcessMountToteToTrolleyIfNotMountedPost(mountToteToToteSelectivePickingTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceProductToPickingToteCommand} [placeProductToPickingToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteSelectivePickingProcessApi
     */
    public apiV1ToteSelectivePickingProcessPlaceProductPost(placeProductToPickingToteCommand?: PlaceProductToPickingToteCommand, options?: any) {
        return ToteSelectivePickingProcessApiFp(this.configuration).apiV1ToteSelectivePickingProcessPlaceProductPost(placeProductToPickingToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StartCreatedPickingToteSelectiveCommand} [startCreatedPickingToteSelectiveCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteSelectivePickingProcessApi
     */
    public apiV1ToteSelectivePickingProcessStartCreatedPickingPost(startCreatedPickingToteSelectiveCommand?: StartCreatedPickingToteSelectiveCommand, options?: any) {
        return ToteSelectivePickingProcessApiFp(this.configuration).apiV1ToteSelectivePickingProcessStartCreatedPickingPost(startCreatedPickingToteSelectiveCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnmountToteFromToteSelectivePickingTrolleyCommand} [unmountToteFromToteSelectivePickingTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteSelectivePickingProcessApi
     */
    public apiV1ToteSelectivePickingProcessUnmountToteFromTrolleyPost(unmountToteFromToteSelectivePickingTrolleyCommand?: UnmountToteFromToteSelectivePickingTrolleyCommand, options?: any) {
        return ToteSelectivePickingProcessApiFp(this.configuration).apiV1ToteSelectivePickingProcessUnmountToteFromTrolleyPost(unmountToteFromToteSelectivePickingTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ToteWranglingApi - axios parameter creator
 * @export
 */
export const ToteWranglingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CheckWranglingToteCommand} [checkWranglingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteWranglingCheckWranglingTotePost: async (checkWranglingToteCommand?: CheckWranglingToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteWrangling.checkWranglingTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkWranglingToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteBatchWranglingCommand} [completeBatchWranglingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteWranglingCompleteBatchWranglingPost: async (completeBatchWranglingCommand?: CompleteBatchWranglingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteWrangling.completeBatchWrangling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeBatchWranglingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteHOVBatchWranglingCommand} [completeHOVBatchWranglingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteWranglingCompleteHOVBatchWranglingPost: async (completeHOVBatchWranglingCommand?: CompleteHOVBatchWranglingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteWrangling.completeHOVBatchWrangling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeHOVBatchWranglingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteMissingWranglingCommand} [completeMissingWranglingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteWranglingCompleteMissingWranglingPost: async (completeMissingWranglingCommand?: CompleteMissingWranglingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteWrangling.completeMissingWrangling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeMissingWranglingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteSingleWranglingCommand} [completeSingleWranglingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteWranglingCompleteSingleWranglingPost: async (completeSingleWranglingCommand?: CompleteSingleWranglingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteWrangling.completeSingleWrangling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeSingleWranglingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MountToteToBatchTrolleyCommand} [mountToteToBatchTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteWranglingMountToteToBatchTrolleyPost: async (mountToteToBatchTrolleyCommand?: MountToteToBatchTrolleyCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ToteWrangling.mountToteToBatchTrolley`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mountToteToBatchTrolleyCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ToteWranglingApi - functional programming interface
 * @export
 */
export const ToteWranglingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ToteWranglingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CheckWranglingToteCommand} [checkWranglingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteWranglingCheckWranglingTotePost(checkWranglingToteCommand?: CheckWranglingToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckWranglingToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteWranglingCheckWranglingTotePost(checkWranglingToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteBatchWranglingCommand} [completeBatchWranglingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteWranglingCompleteBatchWranglingPost(completeBatchWranglingCommand?: CompleteBatchWranglingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteWranglingCompleteBatchWranglingPost(completeBatchWranglingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteHOVBatchWranglingCommand} [completeHOVBatchWranglingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteWranglingCompleteHOVBatchWranglingPost(completeHOVBatchWranglingCommand?: CompleteHOVBatchWranglingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteWranglingCompleteHOVBatchWranglingPost(completeHOVBatchWranglingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteMissingWranglingCommand} [completeMissingWranglingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteWranglingCompleteMissingWranglingPost(completeMissingWranglingCommand?: CompleteMissingWranglingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteWranglingCompleteMissingWranglingPost(completeMissingWranglingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteSingleWranglingCommand} [completeSingleWranglingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteWranglingCompleteSingleWranglingPost(completeSingleWranglingCommand?: CompleteSingleWranglingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteWranglingCompleteSingleWranglingPost(completeSingleWranglingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MountToteToBatchTrolleyCommand} [mountToteToBatchTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ToteWranglingMountToteToBatchTrolleyPost(mountToteToBatchTrolleyCommand?: MountToteToBatchTrolleyCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MountToteToBatchTrolleyOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ToteWranglingMountToteToBatchTrolleyPost(mountToteToBatchTrolleyCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ToteWranglingApi - factory interface
 * @export
 */
export const ToteWranglingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ToteWranglingApiFp(configuration)
    return {
        /**
         * 
         * @param {CheckWranglingToteCommand} [checkWranglingToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteWranglingCheckWranglingTotePost(checkWranglingToteCommand?: CheckWranglingToteCommand, options?: any): AxiosPromise<CheckWranglingToteOutputDTO> {
            return localVarFp.apiV1ToteWranglingCheckWranglingTotePost(checkWranglingToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteBatchWranglingCommand} [completeBatchWranglingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteWranglingCompleteBatchWranglingPost(completeBatchWranglingCommand?: CompleteBatchWranglingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ToteWranglingCompleteBatchWranglingPost(completeBatchWranglingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteHOVBatchWranglingCommand} [completeHOVBatchWranglingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteWranglingCompleteHOVBatchWranglingPost(completeHOVBatchWranglingCommand?: CompleteHOVBatchWranglingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ToteWranglingCompleteHOVBatchWranglingPost(completeHOVBatchWranglingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteMissingWranglingCommand} [completeMissingWranglingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteWranglingCompleteMissingWranglingPost(completeMissingWranglingCommand?: CompleteMissingWranglingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ToteWranglingCompleteMissingWranglingPost(completeMissingWranglingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteSingleWranglingCommand} [completeSingleWranglingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteWranglingCompleteSingleWranglingPost(completeSingleWranglingCommand?: CompleteSingleWranglingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1ToteWranglingCompleteSingleWranglingPost(completeSingleWranglingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MountToteToBatchTrolleyCommand} [mountToteToBatchTrolleyCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ToteWranglingMountToteToBatchTrolleyPost(mountToteToBatchTrolleyCommand?: MountToteToBatchTrolleyCommand, options?: any): AxiosPromise<MountToteToBatchTrolleyOutputDTO> {
            return localVarFp.apiV1ToteWranglingMountToteToBatchTrolleyPost(mountToteToBatchTrolleyCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ToteWranglingApi - object-oriented interface
 * @export
 * @class ToteWranglingApi
 * @extends {BaseAPI}
 */
export class ToteWranglingApi extends BaseAPI {
    /**
     * 
     * @param {CheckWranglingToteCommand} [checkWranglingToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteWranglingApi
     */
    public apiV1ToteWranglingCheckWranglingTotePost(checkWranglingToteCommand?: CheckWranglingToteCommand, options?: any) {
        return ToteWranglingApiFp(this.configuration).apiV1ToteWranglingCheckWranglingTotePost(checkWranglingToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteBatchWranglingCommand} [completeBatchWranglingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteWranglingApi
     */
    public apiV1ToteWranglingCompleteBatchWranglingPost(completeBatchWranglingCommand?: CompleteBatchWranglingCommand, options?: any) {
        return ToteWranglingApiFp(this.configuration).apiV1ToteWranglingCompleteBatchWranglingPost(completeBatchWranglingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteHOVBatchWranglingCommand} [completeHOVBatchWranglingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteWranglingApi
     */
    public apiV1ToteWranglingCompleteHOVBatchWranglingPost(completeHOVBatchWranglingCommand?: CompleteHOVBatchWranglingCommand, options?: any) {
        return ToteWranglingApiFp(this.configuration).apiV1ToteWranglingCompleteHOVBatchWranglingPost(completeHOVBatchWranglingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteMissingWranglingCommand} [completeMissingWranglingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteWranglingApi
     */
    public apiV1ToteWranglingCompleteMissingWranglingPost(completeMissingWranglingCommand?: CompleteMissingWranglingCommand, options?: any) {
        return ToteWranglingApiFp(this.configuration).apiV1ToteWranglingCompleteMissingWranglingPost(completeMissingWranglingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteSingleWranglingCommand} [completeSingleWranglingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteWranglingApi
     */
    public apiV1ToteWranglingCompleteSingleWranglingPost(completeSingleWranglingCommand?: CompleteSingleWranglingCommand, options?: any) {
        return ToteWranglingApiFp(this.configuration).apiV1ToteWranglingCompleteSingleWranglingPost(completeSingleWranglingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MountToteToBatchTrolleyCommand} [mountToteToBatchTrolleyCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToteWranglingApi
     */
    public apiV1ToteWranglingMountToteToBatchTrolleyPost(mountToteToBatchTrolleyCommand?: MountToteToBatchTrolleyCommand, options?: any) {
        return ToteWranglingApiFp(this.configuration).apiV1ToteWranglingMountToteToBatchTrolleyPost(mountToteToBatchTrolleyCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TransfersApi - axios parameter creator
 * @export
 */
export const TransfersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckAddressToSalesOrderTransferPost: async (addressLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.checkAddressToSalesOrderTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (addressLabel !== undefined) {
                localVarQueryParameter['addressLabel'] = addressLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckBarcodeTypeGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.checkBarcodeType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckCellForStockToQuarantineTransferCommand} [checkCellForStockToQuarantineTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckCellForStockToQuarantineTransferPost: async (checkCellForStockToQuarantineTransferCommand?: CheckCellForStockToQuarantineTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.checkCellForStockToQuarantineTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkCellForStockToQuarantineTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckCellForStockToRestowTransferCommand} [checkCellForStockToRestowTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckCellForStockToRestowTransferPost: async (checkCellForStockToRestowTransferCommand?: CheckCellForStockToRestowTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.checkCellForStockToRestowTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkCellForStockToRestowTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckProductExistsForTransferCommand} [checkProductExistsForTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckProductExistPost: async (checkProductExistsForTransferCommand?: CheckProductExistsForTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.checkProductExist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkProductExistsForTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckProductForQuarantineToValidTransferCommand} [checkProductForQuarantineToValidTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckProductForQuarantineToValidTransferPost: async (checkProductForQuarantineToValidTransferCommand?: CheckProductForQuarantineToValidTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.checkProductForQuarantineToValidTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkProductForQuarantineToValidTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckProductForStockToQuarantineTransferCommand} [checkProductForStockToQuarantineTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckProductForStockToQuarantineTransferPost: async (checkProductForStockToQuarantineTransferCommand?: CheckProductForStockToQuarantineTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.checkProductForStockToQuarantineTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkProductForStockToQuarantineTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cargoPackageLabel] 
         * @param {string} [salesOrderReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckSalesOrderCargoPackageToTransferPost: async (cargoPackageLabel?: string, salesOrderReferenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.checkSalesOrderCargoPackageToTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cargoPackageLabel !== undefined) {
                localVarQueryParameter['cargoPackageLabel'] = cargoPackageLabel;
            }

            if (salesOrderReferenceNumber !== undefined) {
                localVarQueryParameter['salesOrderReferenceNumber'] = salesOrderReferenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckProductsSerialNumberCommand} [checkProductsSerialNumberCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckSourceProductsSerialNumberPost: async (checkProductsSerialNumberCommand?: CheckProductsSerialNumberCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.checkSourceProductsSerialNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkProductsSerialNumberCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckTargetToteForQuarantineToValidTransferCommand} [checkTargetToteForQuarantineToValidTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckTargetToteForQuarantineToValidTransferPost: async (checkTargetToteForQuarantineToValidTransferCommand?: CheckTargetToteForQuarantineToValidTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.checkTargetToteForQuarantineToValidTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkTargetToteForQuarantineToValidTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckTotalCountForQuarantineToValidTransferCommand} [checkTotalCountForQuarantineToValidTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckTotalCountForQuarantineToValidTransferPost: async (checkTotalCountForQuarantineToValidTransferCommand?: CheckTotalCountForQuarantineToValidTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.checkTotalCountForQuarantineToValidTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkTotalCountForQuarantineToValidTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckProductExistsInToteForTransferCommand} [checkProductExistsInToteForTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckToteContainsProductPost: async (checkProductExistsInToteForTransferCommand?: CheckProductExistsInToteForTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.checkToteContainsProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkProductExistsInToteForTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckToteForQuarantineToValidTransferCommand} [checkToteForQuarantineToValidTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckToteForQuarantineToValidTransferPost: async (checkToteForQuarantineToValidTransferCommand?: CheckToteForQuarantineToValidTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.checkToteForQuarantineToValidTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkToteForQuarantineToValidTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckToteForStockToQuarantineTransferCommand} [checkToteForStockToQuarantineTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckToteForStockToQuarantineTransferPost: async (checkToteForStockToQuarantineTransferCommand?: CheckToteForStockToQuarantineTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.checkToteForStockToQuarantineTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkToteForStockToQuarantineTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckToteForStockToRestowTransferCommand} [checkToteForStockToRestowTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckToteForStockToRestowTransferPost: async (checkToteForStockToRestowTransferCommand?: CheckToteForStockToRestowTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.checkToteForStockToRestowTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkToteForStockToRestowTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckToteForToteItemsToToteTransferGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.checkToteForToteItemsToToteTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteSalesOrderCargoPackagesTransferToAddressCommand} [completeSalesOrderCargoPackagesTransferToAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCompleteSalesOrderCargoPackagesTransferPost: async (completeSalesOrderCargoPackagesTransferToAddressCommand?: CompleteSalesOrderCargoPackagesTransferToAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.completeSalesOrderCargoPackagesTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeSalesOrderCargoPackagesTransferToAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {string} [addressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCompleteSalesOrderTransferPost: async (referenceNumber?: string, addressLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.completeSalesOrderTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }

            if (addressLabel !== undefined) {
                localVarQueryParameter['addressLabel'] = addressLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteStockItemsToRestowTransferCommand} [completeStockItemsToRestowTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCompleteStockItemsToRestowTransferPost: async (completeStockItemsToRestowTransferCommand?: CompleteStockItemsToRestowTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.completeStockItemsToRestowTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeStockItemsToRestowTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [label] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersGetCargoPackageByLabelGet: async (label?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.getCargoPackageByLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (label !== undefined) {
                localVarQueryParameter['label'] = label;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersGetProductAddressDetailsGet: async (productId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.getProductAddressDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersGetSalesOrderToTransferPost: async (referenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.getSalesOrderToTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersGetToteItemsGet: async (toteLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.getToteItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (toteLabel !== undefined) {
                localVarQueryParameter['toteLabel'] = toteLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersListItemsByCellLabelGet: async (cellLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.listItemsByCellLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (cellLabel !== undefined) {
                localVarQueryParameter['cellLabel'] = cellLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SelectAllItemsForTransferToQuarantineCommand} [selectAllItemsForTransferToQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersSelectAllItemsForTransferToQuarantinePost: async (selectAllItemsForTransferToQuarantineCommand?: SelectAllItemsForTransferToQuarantineCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.selectAllItemsForTransferToQuarantine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectAllItemsForTransferToQuarantineCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StripCancelledCellItemToToteCommand} [stripCancelledCellItemToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersStripCancelledCellItemPost: async (stripCancelledCellItemToToteCommand?: StripCancelledCellItemToToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.stripCancelledCellItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stripCancelledCellItemToToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StripCancelledToteItemToToteCommand} [stripCancelledToteItemToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersStripCancelledToteItemPost: async (stripCancelledToteItemToToteCommand?: StripCancelledToteItemToToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.stripCancelledToteItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stripCancelledToteItemToToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferAllStockItemsToRestowCommand} [transferAllStockItemsToRestowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersTransferAllStockItemsToRestowPost: async (transferAllStockItemsToRestowCommand?: TransferAllStockItemsToRestowCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.transferAllStockItemsToRestow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferAllStockItemsToRestowCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferPackingItemsToToteCommand} [transferPackingItemsToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersTransferPackingItemsToTotePost: async (transferPackingItemsToToteCommand?: TransferPackingItemsToToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.transferPackingItemsToTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferPackingItemsToToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferQuarantineToValidCommand} [transferQuarantineToValidCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersTransferQuarantineToValidPost: async (transferQuarantineToValidCommand?: TransferQuarantineToValidCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.transferQuarantineToValid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferQuarantineToValidCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferStockItemsCommand} [transferStockItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersTransferStockItemsPost: async (transferStockItemsCommand?: TransferStockItemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.transferStockItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferStockItemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferStockItemsToQuarantineCommand} [transferStockItemsToQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersTransferStockItemsToQuarantinePost: async (transferStockItemsToQuarantineCommand?: TransferStockItemsToQuarantineCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.transferStockItemsToQuarantine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferStockItemsToQuarantineCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferStockItemsToRestowCommand} [transferStockItemsToRestowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersTransferStockItemsToRestowPost: async (transferStockItemsToRestowCommand?: TransferStockItemsToRestowCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.transferStockItemsToRestow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferStockItemsToRestowCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferToteItemsToToteCommand} [transferToteItemsToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersTransferToteItemsToTotePost: async (transferToteItemsToToteCommand?: TransferToteItemsToToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.transferToteItemsToTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferToteItemsToToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersUploadImageForStockToQuarantineTransferPost: async (file?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Transfers.uploadImageForStockToQuarantineTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransfersApi - functional programming interface
 * @export
 */
export const TransfersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransfersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCheckAddressToSalesOrderTransferPost(addressLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCheckAddressToSalesOrderTransferPost(addressLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCheckBarcodeTypeGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckBarcodeTypeForTransferOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCheckBarcodeTypeGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckCellForStockToQuarantineTransferCommand} [checkCellForStockToQuarantineTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCheckCellForStockToQuarantineTransferPost(checkCellForStockToQuarantineTransferCommand?: CheckCellForStockToQuarantineTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCheckCellForStockToQuarantineTransferPost(checkCellForStockToQuarantineTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckCellForStockToRestowTransferCommand} [checkCellForStockToRestowTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCheckCellForStockToRestowTransferPost(checkCellForStockToRestowTransferCommand?: CheckCellForStockToRestowTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckCellForStockToRestowTransferOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCheckCellForStockToRestowTransferPost(checkCellForStockToRestowTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckProductExistsForTransferCommand} [checkProductExistsForTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCheckProductExistPost(checkProductExistsForTransferCommand?: CheckProductExistsForTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProductExistOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCheckProductExistPost(checkProductExistsForTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckProductForQuarantineToValidTransferCommand} [checkProductForQuarantineToValidTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCheckProductForQuarantineToValidTransferPost(checkProductForQuarantineToValidTransferCommand?: CheckProductForQuarantineToValidTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProductForQuarantineToValidTransferOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCheckProductForQuarantineToValidTransferPost(checkProductForQuarantineToValidTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckProductForStockToQuarantineTransferCommand} [checkProductForStockToQuarantineTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCheckProductForStockToQuarantineTransferPost(checkProductForStockToQuarantineTransferCommand?: CheckProductForStockToQuarantineTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProductForStockToQuarantineTransferOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCheckProductForStockToQuarantineTransferPost(checkProductForStockToQuarantineTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cargoPackageLabel] 
         * @param {string} [salesOrderReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCheckSalesOrderCargoPackageToTransferPost(cargoPackageLabel?: string, salesOrderReferenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCheckSalesOrderCargoPackageToTransferPost(cargoPackageLabel, salesOrderReferenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckProductsSerialNumberCommand} [checkProductsSerialNumberCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCheckSourceProductsSerialNumberPost(checkProductsSerialNumberCommand?: CheckProductsSerialNumberCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCheckSourceProductsSerialNumberPost(checkProductsSerialNumberCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckTargetToteForQuarantineToValidTransferCommand} [checkTargetToteForQuarantineToValidTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCheckTargetToteForQuarantineToValidTransferPost(checkTargetToteForQuarantineToValidTransferCommand?: CheckTargetToteForQuarantineToValidTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCheckTargetToteForQuarantineToValidTransferPost(checkTargetToteForQuarantineToValidTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckTotalCountForQuarantineToValidTransferCommand} [checkTotalCountForQuarantineToValidTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCheckTotalCountForQuarantineToValidTransferPost(checkTotalCountForQuarantineToValidTransferCommand?: CheckTotalCountForQuarantineToValidTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCheckTotalCountForQuarantineToValidTransferPost(checkTotalCountForQuarantineToValidTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckProductExistsInToteForTransferCommand} [checkProductExistsInToteForTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCheckToteContainsProductPost(checkProductExistsInToteForTransferCommand?: CheckProductExistsInToteForTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProductExistInToteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCheckToteContainsProductPost(checkProductExistsInToteForTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckToteForQuarantineToValidTransferCommand} [checkToteForQuarantineToValidTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCheckToteForQuarantineToValidTransferPost(checkToteForQuarantineToValidTransferCommand?: CheckToteForQuarantineToValidTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCheckToteForQuarantineToValidTransferPost(checkToteForQuarantineToValidTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckToteForStockToQuarantineTransferCommand} [checkToteForStockToQuarantineTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCheckToteForStockToQuarantineTransferPost(checkToteForStockToQuarantineTransferCommand?: CheckToteForStockToQuarantineTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCheckToteForStockToQuarantineTransferPost(checkToteForStockToQuarantineTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckToteForStockToRestowTransferCommand} [checkToteForStockToRestowTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCheckToteForStockToRestowTransferPost(checkToteForStockToRestowTransferCommand?: CheckToteForStockToRestowTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCheckToteForStockToRestowTransferPost(checkToteForStockToRestowTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCheckToteForToteItemsToToteTransferGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCheckToteForToteItemsToToteTransferGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteSalesOrderCargoPackagesTransferToAddressCommand} [completeSalesOrderCargoPackagesTransferToAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCompleteSalesOrderCargoPackagesTransferPost(completeSalesOrderCargoPackagesTransferToAddressCommand?: CompleteSalesOrderCargoPackagesTransferToAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCompleteSalesOrderCargoPackagesTransferPost(completeSalesOrderCargoPackagesTransferToAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {string} [addressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCompleteSalesOrderTransferPost(referenceNumber?: string, addressLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCompleteSalesOrderTransferPost(referenceNumber, addressLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteStockItemsToRestowTransferCommand} [completeStockItemsToRestowTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersCompleteStockItemsToRestowTransferPost(completeStockItemsToRestowTransferCommand?: CompleteStockItemsToRestowTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersCompleteStockItemsToRestowTransferPost(completeStockItemsToRestowTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [label] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersGetCargoPackageByLabelGet(label?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CargoPackageOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersGetCargoPackageByLabelGet(label, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersGetProductAddressDetailsGet(productId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProductAddressDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersGetProductAddressDetailsGet(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersGetSalesOrderToTransferPost(referenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesOrderToBeTransferredInfoDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersGetSalesOrderToTransferPost(referenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersGetToteItemsGet(toteLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InventoryItemGetByToteLabelGroupByDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersGetToteItemsGet(toteLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersListItemsByCellLabelGet(cellLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InventoryItemWithProductOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersListItemsByCellLabelGet(cellLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SelectAllItemsForTransferToQuarantineCommand} [selectAllItemsForTransferToQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersSelectAllItemsForTransferToQuarantinePost(selectAllItemsForTransferToQuarantineCommand?: SelectAllItemsForTransferToQuarantineCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelectAllItemsForTransferToQuarantineDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersSelectAllItemsForTransferToQuarantinePost(selectAllItemsForTransferToQuarantineCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StripCancelledCellItemToToteCommand} [stripCancelledCellItemToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersStripCancelledCellItemPost(stripCancelledCellItemToToteCommand?: StripCancelledCellItemToToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersStripCancelledCellItemPost(stripCancelledCellItemToToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StripCancelledToteItemToToteCommand} [stripCancelledToteItemToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersStripCancelledToteItemPost(stripCancelledToteItemToToteCommand?: StripCancelledToteItemToToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersStripCancelledToteItemPost(stripCancelledToteItemToToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferAllStockItemsToRestowCommand} [transferAllStockItemsToRestowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersTransferAllStockItemsToRestowPost(transferAllStockItemsToRestowCommand?: TransferAllStockItemsToRestowCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersTransferAllStockItemsToRestowPost(transferAllStockItemsToRestowCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferPackingItemsToToteCommand} [transferPackingItemsToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersTransferPackingItemsToTotePost(transferPackingItemsToToteCommand?: TransferPackingItemsToToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersTransferPackingItemsToTotePost(transferPackingItemsToToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferQuarantineToValidCommand} [transferQuarantineToValidCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersTransferQuarantineToValidPost(transferQuarantineToValidCommand?: TransferQuarantineToValidCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersTransferQuarantineToValidPost(transferQuarantineToValidCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferStockItemsCommand} [transferStockItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersTransferStockItemsPost(transferStockItemsCommand?: TransferStockItemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersTransferStockItemsPost(transferStockItemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferStockItemsToQuarantineCommand} [transferStockItemsToQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersTransferStockItemsToQuarantinePost(transferStockItemsToQuarantineCommand?: TransferStockItemsToQuarantineCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransferItemOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersTransferStockItemsToQuarantinePost(transferStockItemsToQuarantineCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferStockItemsToRestowCommand} [transferStockItemsToRestowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersTransferStockItemsToRestowPost(transferStockItemsToRestowCommand?: TransferStockItemsToRestowCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersTransferStockItemsToRestowPost(transferStockItemsToRestowCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferToteItemsToToteCommand} [transferToteItemsToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersTransferToteItemsToTotePost(transferToteItemsToToteCommand?: TransferToteItemsToToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferToteItemOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersTransferToteItemsToTotePost(transferToteItemsToToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TransfersUploadImageForStockToQuarantineTransferPost(file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TransfersUploadImageForStockToQuarantineTransferPost(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TransfersApi - factory interface
 * @export
 */
export const TransfersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransfersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [addressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckAddressToSalesOrderTransferPost(addressLabel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersCheckAddressToSalesOrderTransferPost(addressLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckBarcodeTypeGet(barcode?: string, options?: any): AxiosPromise<CheckBarcodeTypeForTransferOutputDTO> {
            return localVarFp.apiV1TransfersCheckBarcodeTypeGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckCellForStockToQuarantineTransferCommand} [checkCellForStockToQuarantineTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckCellForStockToQuarantineTransferPost(checkCellForStockToQuarantineTransferCommand?: CheckCellForStockToQuarantineTransferCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersCheckCellForStockToQuarantineTransferPost(checkCellForStockToQuarantineTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckCellForStockToRestowTransferCommand} [checkCellForStockToRestowTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckCellForStockToRestowTransferPost(checkCellForStockToRestowTransferCommand?: CheckCellForStockToRestowTransferCommand, options?: any): AxiosPromise<CheckCellForStockToRestowTransferOutputDTO> {
            return localVarFp.apiV1TransfersCheckCellForStockToRestowTransferPost(checkCellForStockToRestowTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckProductExistsForTransferCommand} [checkProductExistsForTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckProductExistPost(checkProductExistsForTransferCommand?: CheckProductExistsForTransferCommand, options?: any): AxiosPromise<CheckProductExistOutputDTO> {
            return localVarFp.apiV1TransfersCheckProductExistPost(checkProductExistsForTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckProductForQuarantineToValidTransferCommand} [checkProductForQuarantineToValidTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckProductForQuarantineToValidTransferPost(checkProductForQuarantineToValidTransferCommand?: CheckProductForQuarantineToValidTransferCommand, options?: any): AxiosPromise<CheckProductForQuarantineToValidTransferOutputDTO> {
            return localVarFp.apiV1TransfersCheckProductForQuarantineToValidTransferPost(checkProductForQuarantineToValidTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckProductForStockToQuarantineTransferCommand} [checkProductForStockToQuarantineTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckProductForStockToQuarantineTransferPost(checkProductForStockToQuarantineTransferCommand?: CheckProductForStockToQuarantineTransferCommand, options?: any): AxiosPromise<CheckProductForStockToQuarantineTransferOutputDTO> {
            return localVarFp.apiV1TransfersCheckProductForStockToQuarantineTransferPost(checkProductForStockToQuarantineTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cargoPackageLabel] 
         * @param {string} [salesOrderReferenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckSalesOrderCargoPackageToTransferPost(cargoPackageLabel?: string, salesOrderReferenceNumber?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersCheckSalesOrderCargoPackageToTransferPost(cargoPackageLabel, salesOrderReferenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckProductsSerialNumberCommand} [checkProductsSerialNumberCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckSourceProductsSerialNumberPost(checkProductsSerialNumberCommand?: CheckProductsSerialNumberCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersCheckSourceProductsSerialNumberPost(checkProductsSerialNumberCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckTargetToteForQuarantineToValidTransferCommand} [checkTargetToteForQuarantineToValidTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckTargetToteForQuarantineToValidTransferPost(checkTargetToteForQuarantineToValidTransferCommand?: CheckTargetToteForQuarantineToValidTransferCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersCheckTargetToteForQuarantineToValidTransferPost(checkTargetToteForQuarantineToValidTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckTotalCountForQuarantineToValidTransferCommand} [checkTotalCountForQuarantineToValidTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckTotalCountForQuarantineToValidTransferPost(checkTotalCountForQuarantineToValidTransferCommand?: CheckTotalCountForQuarantineToValidTransferCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersCheckTotalCountForQuarantineToValidTransferPost(checkTotalCountForQuarantineToValidTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckProductExistsInToteForTransferCommand} [checkProductExistsInToteForTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckToteContainsProductPost(checkProductExistsInToteForTransferCommand?: CheckProductExistsInToteForTransferCommand, options?: any): AxiosPromise<CheckProductExistInToteOutputDTO> {
            return localVarFp.apiV1TransfersCheckToteContainsProductPost(checkProductExistsInToteForTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckToteForQuarantineToValidTransferCommand} [checkToteForQuarantineToValidTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckToteForQuarantineToValidTransferPost(checkToteForQuarantineToValidTransferCommand?: CheckToteForQuarantineToValidTransferCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersCheckToteForQuarantineToValidTransferPost(checkToteForQuarantineToValidTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckToteForStockToQuarantineTransferCommand} [checkToteForStockToQuarantineTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckToteForStockToQuarantineTransferPost(checkToteForStockToQuarantineTransferCommand?: CheckToteForStockToQuarantineTransferCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersCheckToteForStockToQuarantineTransferPost(checkToteForStockToQuarantineTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckToteForStockToRestowTransferCommand} [checkToteForStockToRestowTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckToteForStockToRestowTransferPost(checkToteForStockToRestowTransferCommand?: CheckToteForStockToRestowTransferCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersCheckToteForStockToRestowTransferPost(checkToteForStockToRestowTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCheckToteForToteItemsToToteTransferGet(toteLabel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersCheckToteForToteItemsToToteTransferGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteSalesOrderCargoPackagesTransferToAddressCommand} [completeSalesOrderCargoPackagesTransferToAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCompleteSalesOrderCargoPackagesTransferPost(completeSalesOrderCargoPackagesTransferToAddressCommand?: CompleteSalesOrderCargoPackagesTransferToAddressCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersCompleteSalesOrderCargoPackagesTransferPost(completeSalesOrderCargoPackagesTransferToAddressCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {string} [addressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCompleteSalesOrderTransferPost(referenceNumber?: string, addressLabel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersCompleteSalesOrderTransferPost(referenceNumber, addressLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteStockItemsToRestowTransferCommand} [completeStockItemsToRestowTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersCompleteStockItemsToRestowTransferPost(completeStockItemsToRestowTransferCommand?: CompleteStockItemsToRestowTransferCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersCompleteStockItemsToRestowTransferPost(completeStockItemsToRestowTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [label] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersGetCargoPackageByLabelGet(label?: string, options?: any): AxiosPromise<CargoPackageOutputDTO> {
            return localVarFp.apiV1TransfersGetCargoPackageByLabelGet(label, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersGetProductAddressDetailsGet(productId?: string, options?: any): AxiosPromise<GetProductAddressDetailsOutputDTO> {
            return localVarFp.apiV1TransfersGetProductAddressDetailsGet(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersGetSalesOrderToTransferPost(referenceNumber?: string, options?: any): AxiosPromise<SalesOrderToBeTransferredInfoDTO> {
            return localVarFp.apiV1TransfersGetSalesOrderToTransferPost(referenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [toteLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersGetToteItemsGet(toteLabel?: string, options?: any): AxiosPromise<Array<InventoryItemGetByToteLabelGroupByDTO>> {
            return localVarFp.apiV1TransfersGetToteItemsGet(toteLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cellLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersListItemsByCellLabelGet(cellLabel?: string, options?: any): AxiosPromise<Array<InventoryItemWithProductOutputDTO>> {
            return localVarFp.apiV1TransfersListItemsByCellLabelGet(cellLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SelectAllItemsForTransferToQuarantineCommand} [selectAllItemsForTransferToQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersSelectAllItemsForTransferToQuarantinePost(selectAllItemsForTransferToQuarantineCommand?: SelectAllItemsForTransferToQuarantineCommand, options?: any): AxiosPromise<SelectAllItemsForTransferToQuarantineDTO> {
            return localVarFp.apiV1TransfersSelectAllItemsForTransferToQuarantinePost(selectAllItemsForTransferToQuarantineCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StripCancelledCellItemToToteCommand} [stripCancelledCellItemToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersStripCancelledCellItemPost(stripCancelledCellItemToToteCommand?: StripCancelledCellItemToToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersStripCancelledCellItemPost(stripCancelledCellItemToToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StripCancelledToteItemToToteCommand} [stripCancelledToteItemToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersStripCancelledToteItemPost(stripCancelledToteItemToToteCommand?: StripCancelledToteItemToToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersStripCancelledToteItemPost(stripCancelledToteItemToToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferAllStockItemsToRestowCommand} [transferAllStockItemsToRestowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersTransferAllStockItemsToRestowPost(transferAllStockItemsToRestowCommand?: TransferAllStockItemsToRestowCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersTransferAllStockItemsToRestowPost(transferAllStockItemsToRestowCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferPackingItemsToToteCommand} [transferPackingItemsToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersTransferPackingItemsToTotePost(transferPackingItemsToToteCommand?: TransferPackingItemsToToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersTransferPackingItemsToTotePost(transferPackingItemsToToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferQuarantineToValidCommand} [transferQuarantineToValidCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersTransferQuarantineToValidPost(transferQuarantineToValidCommand?: TransferQuarantineToValidCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersTransferQuarantineToValidPost(transferQuarantineToValidCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferStockItemsCommand} [transferStockItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersTransferStockItemsPost(transferStockItemsCommand?: TransferStockItemsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersTransferStockItemsPost(transferStockItemsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferStockItemsToQuarantineCommand} [transferStockItemsToQuarantineCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersTransferStockItemsToQuarantinePost(transferStockItemsToQuarantineCommand?: TransferStockItemsToQuarantineCommand, options?: any): AxiosPromise<Array<TransferItemOutputDTO>> {
            return localVarFp.apiV1TransfersTransferStockItemsToQuarantinePost(transferStockItemsToQuarantineCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferStockItemsToRestowCommand} [transferStockItemsToRestowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersTransferStockItemsToRestowPost(transferStockItemsToRestowCommand?: TransferStockItemsToRestowCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TransfersTransferStockItemsToRestowPost(transferStockItemsToRestowCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferToteItemsToToteCommand} [transferToteItemsToToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersTransferToteItemsToTotePost(transferToteItemsToToteCommand?: TransferToteItemsToToteCommand, options?: any): AxiosPromise<TransferToteItemOutputDTO> {
            return localVarFp.apiV1TransfersTransferToteItemsToTotePost(transferToteItemsToToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TransfersUploadImageForStockToQuarantineTransferPost(file?: any, options?: any): AxiosPromise<ImageOutputDTO> {
            return localVarFp.apiV1TransfersUploadImageForStockToQuarantineTransferPost(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransfersApi - object-oriented interface
 * @export
 * @class TransfersApi
 * @extends {BaseAPI}
 */
export class TransfersApi extends BaseAPI {
    /**
     * 
     * @param {string} [addressLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCheckAddressToSalesOrderTransferPost(addressLabel?: string, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCheckAddressToSalesOrderTransferPost(addressLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCheckBarcodeTypeGet(barcode?: string, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCheckBarcodeTypeGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckCellForStockToQuarantineTransferCommand} [checkCellForStockToQuarantineTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCheckCellForStockToQuarantineTransferPost(checkCellForStockToQuarantineTransferCommand?: CheckCellForStockToQuarantineTransferCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCheckCellForStockToQuarantineTransferPost(checkCellForStockToQuarantineTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckCellForStockToRestowTransferCommand} [checkCellForStockToRestowTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCheckCellForStockToRestowTransferPost(checkCellForStockToRestowTransferCommand?: CheckCellForStockToRestowTransferCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCheckCellForStockToRestowTransferPost(checkCellForStockToRestowTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckProductExistsForTransferCommand} [checkProductExistsForTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCheckProductExistPost(checkProductExistsForTransferCommand?: CheckProductExistsForTransferCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCheckProductExistPost(checkProductExistsForTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckProductForQuarantineToValidTransferCommand} [checkProductForQuarantineToValidTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCheckProductForQuarantineToValidTransferPost(checkProductForQuarantineToValidTransferCommand?: CheckProductForQuarantineToValidTransferCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCheckProductForQuarantineToValidTransferPost(checkProductForQuarantineToValidTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckProductForStockToQuarantineTransferCommand} [checkProductForStockToQuarantineTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCheckProductForStockToQuarantineTransferPost(checkProductForStockToQuarantineTransferCommand?: CheckProductForStockToQuarantineTransferCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCheckProductForStockToQuarantineTransferPost(checkProductForStockToQuarantineTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cargoPackageLabel] 
     * @param {string} [salesOrderReferenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCheckSalesOrderCargoPackageToTransferPost(cargoPackageLabel?: string, salesOrderReferenceNumber?: string, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCheckSalesOrderCargoPackageToTransferPost(cargoPackageLabel, salesOrderReferenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckProductsSerialNumberCommand} [checkProductsSerialNumberCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCheckSourceProductsSerialNumberPost(checkProductsSerialNumberCommand?: CheckProductsSerialNumberCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCheckSourceProductsSerialNumberPost(checkProductsSerialNumberCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckTargetToteForQuarantineToValidTransferCommand} [checkTargetToteForQuarantineToValidTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCheckTargetToteForQuarantineToValidTransferPost(checkTargetToteForQuarantineToValidTransferCommand?: CheckTargetToteForQuarantineToValidTransferCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCheckTargetToteForQuarantineToValidTransferPost(checkTargetToteForQuarantineToValidTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckTotalCountForQuarantineToValidTransferCommand} [checkTotalCountForQuarantineToValidTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCheckTotalCountForQuarantineToValidTransferPost(checkTotalCountForQuarantineToValidTransferCommand?: CheckTotalCountForQuarantineToValidTransferCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCheckTotalCountForQuarantineToValidTransferPost(checkTotalCountForQuarantineToValidTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckProductExistsInToteForTransferCommand} [checkProductExistsInToteForTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCheckToteContainsProductPost(checkProductExistsInToteForTransferCommand?: CheckProductExistsInToteForTransferCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCheckToteContainsProductPost(checkProductExistsInToteForTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckToteForQuarantineToValidTransferCommand} [checkToteForQuarantineToValidTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCheckToteForQuarantineToValidTransferPost(checkToteForQuarantineToValidTransferCommand?: CheckToteForQuarantineToValidTransferCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCheckToteForQuarantineToValidTransferPost(checkToteForQuarantineToValidTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckToteForStockToQuarantineTransferCommand} [checkToteForStockToQuarantineTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCheckToteForStockToQuarantineTransferPost(checkToteForStockToQuarantineTransferCommand?: CheckToteForStockToQuarantineTransferCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCheckToteForStockToQuarantineTransferPost(checkToteForStockToQuarantineTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckToteForStockToRestowTransferCommand} [checkToteForStockToRestowTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCheckToteForStockToRestowTransferPost(checkToteForStockToRestowTransferCommand?: CheckToteForStockToRestowTransferCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCheckToteForStockToRestowTransferPost(checkToteForStockToRestowTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCheckToteForToteItemsToToteTransferGet(toteLabel?: string, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCheckToteForToteItemsToToteTransferGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteSalesOrderCargoPackagesTransferToAddressCommand} [completeSalesOrderCargoPackagesTransferToAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCompleteSalesOrderCargoPackagesTransferPost(completeSalesOrderCargoPackagesTransferToAddressCommand?: CompleteSalesOrderCargoPackagesTransferToAddressCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCompleteSalesOrderCargoPackagesTransferPost(completeSalesOrderCargoPackagesTransferToAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [referenceNumber] 
     * @param {string} [addressLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCompleteSalesOrderTransferPost(referenceNumber?: string, addressLabel?: string, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCompleteSalesOrderTransferPost(referenceNumber, addressLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteStockItemsToRestowTransferCommand} [completeStockItemsToRestowTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersCompleteStockItemsToRestowTransferPost(completeStockItemsToRestowTransferCommand?: CompleteStockItemsToRestowTransferCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersCompleteStockItemsToRestowTransferPost(completeStockItemsToRestowTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [label] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersGetCargoPackageByLabelGet(label?: string, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersGetCargoPackageByLabelGet(label, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [productId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersGetProductAddressDetailsGet(productId?: string, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersGetProductAddressDetailsGet(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [referenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersGetSalesOrderToTransferPost(referenceNumber?: string, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersGetSalesOrderToTransferPost(referenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [toteLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersGetToteItemsGet(toteLabel?: string, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersGetToteItemsGet(toteLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cellLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersListItemsByCellLabelGet(cellLabel?: string, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersListItemsByCellLabelGet(cellLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SelectAllItemsForTransferToQuarantineCommand} [selectAllItemsForTransferToQuarantineCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersSelectAllItemsForTransferToQuarantinePost(selectAllItemsForTransferToQuarantineCommand?: SelectAllItemsForTransferToQuarantineCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersSelectAllItemsForTransferToQuarantinePost(selectAllItemsForTransferToQuarantineCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StripCancelledCellItemToToteCommand} [stripCancelledCellItemToToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersStripCancelledCellItemPost(stripCancelledCellItemToToteCommand?: StripCancelledCellItemToToteCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersStripCancelledCellItemPost(stripCancelledCellItemToToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StripCancelledToteItemToToteCommand} [stripCancelledToteItemToToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersStripCancelledToteItemPost(stripCancelledToteItemToToteCommand?: StripCancelledToteItemToToteCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersStripCancelledToteItemPost(stripCancelledToteItemToToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferAllStockItemsToRestowCommand} [transferAllStockItemsToRestowCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersTransferAllStockItemsToRestowPost(transferAllStockItemsToRestowCommand?: TransferAllStockItemsToRestowCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersTransferAllStockItemsToRestowPost(transferAllStockItemsToRestowCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferPackingItemsToToteCommand} [transferPackingItemsToToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersTransferPackingItemsToTotePost(transferPackingItemsToToteCommand?: TransferPackingItemsToToteCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersTransferPackingItemsToTotePost(transferPackingItemsToToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferQuarantineToValidCommand} [transferQuarantineToValidCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersTransferQuarantineToValidPost(transferQuarantineToValidCommand?: TransferQuarantineToValidCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersTransferQuarantineToValidPost(transferQuarantineToValidCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferStockItemsCommand} [transferStockItemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersTransferStockItemsPost(transferStockItemsCommand?: TransferStockItemsCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersTransferStockItemsPost(transferStockItemsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferStockItemsToQuarantineCommand} [transferStockItemsToQuarantineCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersTransferStockItemsToQuarantinePost(transferStockItemsToQuarantineCommand?: TransferStockItemsToQuarantineCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersTransferStockItemsToQuarantinePost(transferStockItemsToQuarantineCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferStockItemsToRestowCommand} [transferStockItemsToRestowCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersTransferStockItemsToRestowPost(transferStockItemsToRestowCommand?: TransferStockItemsToRestowCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersTransferStockItemsToRestowPost(transferStockItemsToRestowCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferToteItemsToToteCommand} [transferToteItemsToToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersTransferToteItemsToTotePost(transferToteItemsToToteCommand?: TransferToteItemsToToteCommand, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersTransferToteItemsToTotePost(transferToteItemsToToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public apiV1TransfersUploadImageForStockToQuarantineTransferPost(file?: any, options?: any) {
        return TransfersApiFp(this.configuration).apiV1TransfersUploadImageForStockToQuarantineTransferPost(file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TrolleyTransfersApi - axios parameter creator
 * @export
 */
export const TrolleyTransfersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrolleyTransfersCheckTransferTrolleyBarcodeTypeGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/TrolleyTransfers.checkTransferTrolleyBarcodeType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [transferTrolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrolleyTransfersCheckTransferTrolleyLabelGet: async (transferTrolleyLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/TrolleyTransfers.checkTransferTrolleyLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (transferTrolleyLabel !== undefined) {
                localVarQueryParameter['transferTrolleyLabel'] = transferTrolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteTrolleyTransferCommand} [completeTrolleyTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrolleyTransfersCompleteTrolleyTransferPost: async (completeTrolleyTransferCommand?: CompleteTrolleyTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/TrolleyTransfers.completeTrolleyTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeTrolleyTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrolleyTransfersGetPickingTrolleyDetailsGet: async (trolleyLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/TrolleyTransfers.getPickingTrolleyDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (trolleyLabel !== undefined) {
                localVarQueryParameter['trolleyLabel'] = trolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrolleyTransfersGetTransferTrolleyDetailsGet: async (trolleyLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/TrolleyTransfers.getTransferTrolleyDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (trolleyLabel !== undefined) {
                localVarQueryParameter['trolleyLabel'] = trolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrolleyTransfersQueryActiveTransferTrolleysGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/TrolleyTransfers.queryActiveTransferTrolleys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} trolleyLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrolleyTransfersQueryPickingTrolleyPickingTotesGet: async (trolleyLabel: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'trolleyLabel' is not null or undefined
            assertParamExists('apiV1TrolleyTransfersQueryPickingTrolleyPickingTotesGet', 'trolleyLabel', trolleyLabel)
            const localVarPath = `/api/v1/TrolleyTransfers.queryPickingTrolleyPickingTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (trolleyLabel !== undefined) {
                localVarQueryParameter['trolleyLabel'] = trolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} trolleyLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrolleyTransfersQueryTransferTrolleyPickingTotesGet: async (trolleyLabel: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'trolleyLabel' is not null or undefined
            assertParamExists('apiV1TrolleyTransfersQueryTransferTrolleyPickingTotesGet', 'trolleyLabel', trolleyLabel)
            const localVarPath = `/api/v1/TrolleyTransfers.queryTransferTrolleyPickingTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (trolleyLabel !== undefined) {
                localVarQueryParameter['trolleyLabel'] = trolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrolleyTransfersApi - functional programming interface
 * @export
 */
export const TrolleyTransfersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrolleyTransfersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TrolleyTransfersCheckTransferTrolleyBarcodeTypeGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckTransferTrolleyBarcodeTypeOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TrolleyTransfersCheckTransferTrolleyBarcodeTypeGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [transferTrolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TrolleyTransfersCheckTransferTrolleyLabelGet(transferTrolleyLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TrolleyTransfersCheckTransferTrolleyLabelGet(transferTrolleyLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteTrolleyTransferCommand} [completeTrolleyTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TrolleyTransfersCompleteTrolleyTransferPost(completeTrolleyTransferCommand?: CompleteTrolleyTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TrolleyTransfersCompleteTrolleyTransferPost(completeTrolleyTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TrolleyTransfersGetPickingTrolleyDetailsGet(trolleyLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPickingTrolleyDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TrolleyTransfersGetPickingTrolleyDetailsGet(trolleyLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TrolleyTransfersGetTransferTrolleyDetailsGet(trolleyLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferTrolleyDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TrolleyTransfersGetTransferTrolleyDetailsGet(trolleyLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TrolleyTransfersQueryActiveTransferTrolleysGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveTransferTrolleysOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TrolleyTransfersQueryActiveTransferTrolleysGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} trolleyLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TrolleyTransfersQueryPickingTrolleyPickingTotesGet(trolleyLabel: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickingTrolleyTotesQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TrolleyTransfersQueryPickingTrolleyPickingTotesGet(trolleyLabel, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} trolleyLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TrolleyTransfersQueryTransferTrolleyPickingTotesGet(trolleyLabel: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferTrolleyTotesQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TrolleyTransfersQueryTransferTrolleyPickingTotesGet(trolleyLabel, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrolleyTransfersApi - factory interface
 * @export
 */
export const TrolleyTransfersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrolleyTransfersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrolleyTransfersCheckTransferTrolleyBarcodeTypeGet(barcode?: string, options?: any): AxiosPromise<CheckTransferTrolleyBarcodeTypeOutputDTO> {
            return localVarFp.apiV1TrolleyTransfersCheckTransferTrolleyBarcodeTypeGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [transferTrolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrolleyTransfersCheckTransferTrolleyLabelGet(transferTrolleyLabel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TrolleyTransfersCheckTransferTrolleyLabelGet(transferTrolleyLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteTrolleyTransferCommand} [completeTrolleyTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrolleyTransfersCompleteTrolleyTransferPost(completeTrolleyTransferCommand?: CompleteTrolleyTransferCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1TrolleyTransfersCompleteTrolleyTransferPost(completeTrolleyTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrolleyTransfersGetPickingTrolleyDetailsGet(trolleyLabel?: string, options?: any): AxiosPromise<GetPickingTrolleyDetailsOutputDTO> {
            return localVarFp.apiV1TrolleyTransfersGetPickingTrolleyDetailsGet(trolleyLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrolleyTransfersGetTransferTrolleyDetailsGet(trolleyLabel?: string, options?: any): AxiosPromise<TransferTrolleyDetailsOutputDTO> {
            return localVarFp.apiV1TrolleyTransfersGetTransferTrolleyDetailsGet(trolleyLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrolleyTransfersQueryActiveTransferTrolleysGet(dqb?: string, options?: any): AxiosPromise<ActiveTransferTrolleysOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1TrolleyTransfersQueryActiveTransferTrolleysGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} trolleyLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrolleyTransfersQueryPickingTrolleyPickingTotesGet(trolleyLabel: string, dqb?: string, options?: any): AxiosPromise<PickingTrolleyTotesQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1TrolleyTransfersQueryPickingTrolleyPickingTotesGet(trolleyLabel, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} trolleyLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrolleyTransfersQueryTransferTrolleyPickingTotesGet(trolleyLabel: string, dqb?: string, options?: any): AxiosPromise<TransferTrolleyTotesQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1TrolleyTransfersQueryTransferTrolleyPickingTotesGet(trolleyLabel, dqb, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrolleyTransfersApi - object-oriented interface
 * @export
 * @class TrolleyTransfersApi
 * @extends {BaseAPI}
 */
export class TrolleyTransfersApi extends BaseAPI {
    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrolleyTransfersApi
     */
    public apiV1TrolleyTransfersCheckTransferTrolleyBarcodeTypeGet(barcode?: string, options?: any) {
        return TrolleyTransfersApiFp(this.configuration).apiV1TrolleyTransfersCheckTransferTrolleyBarcodeTypeGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [transferTrolleyLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrolleyTransfersApi
     */
    public apiV1TrolleyTransfersCheckTransferTrolleyLabelGet(transferTrolleyLabel?: string, options?: any) {
        return TrolleyTransfersApiFp(this.configuration).apiV1TrolleyTransfersCheckTransferTrolleyLabelGet(transferTrolleyLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteTrolleyTransferCommand} [completeTrolleyTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrolleyTransfersApi
     */
    public apiV1TrolleyTransfersCompleteTrolleyTransferPost(completeTrolleyTransferCommand?: CompleteTrolleyTransferCommand, options?: any) {
        return TrolleyTransfersApiFp(this.configuration).apiV1TrolleyTransfersCompleteTrolleyTransferPost(completeTrolleyTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [trolleyLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrolleyTransfersApi
     */
    public apiV1TrolleyTransfersGetPickingTrolleyDetailsGet(trolleyLabel?: string, options?: any) {
        return TrolleyTransfersApiFp(this.configuration).apiV1TrolleyTransfersGetPickingTrolleyDetailsGet(trolleyLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [trolleyLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrolleyTransfersApi
     */
    public apiV1TrolleyTransfersGetTransferTrolleyDetailsGet(trolleyLabel?: string, options?: any) {
        return TrolleyTransfersApiFp(this.configuration).apiV1TrolleyTransfersGetTransferTrolleyDetailsGet(trolleyLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrolleyTransfersApi
     */
    public apiV1TrolleyTransfersQueryActiveTransferTrolleysGet(dqb?: string, options?: any) {
        return TrolleyTransfersApiFp(this.configuration).apiV1TrolleyTransfersQueryActiveTransferTrolleysGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} trolleyLabel 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrolleyTransfersApi
     */
    public apiV1TrolleyTransfersQueryPickingTrolleyPickingTotesGet(trolleyLabel: string, dqb?: string, options?: any) {
        return TrolleyTransfersApiFp(this.configuration).apiV1TrolleyTransfersQueryPickingTrolleyPickingTotesGet(trolleyLabel, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} trolleyLabel 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrolleyTransfersApi
     */
    public apiV1TrolleyTransfersQueryTransferTrolleyPickingTotesGet(trolleyLabel: string, dqb?: string, options?: any) {
        return TrolleyTransfersApiFp(this.configuration).apiV1TrolleyTransfersQueryTransferTrolleyPickingTotesGet(trolleyLabel, dqb, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateUserCommand} [createUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersCreateUserPost: async (createUserCommand?: CreateUserCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Users.createUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [fullName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersSearchOperatorsByFullNameGet: async (fullName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Users.searchOperatorsByFullName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (fullName !== undefined) {
                localVarQueryParameter['fullName'] = fullName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [fullName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersSearchUsersByFullNameGet: async (fullName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Users.searchUsersByFullName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (fullName !== undefined) {
                localVarQueryParameter['fullName'] = fullName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateUserCommand} [createUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersCreateUserPost(createUserCommand?: CreateUserCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUserOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersCreateUserPost(createUserCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [fullName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersSearchOperatorsByFullNameGet(fullName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchUserByFullNameOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersSearchOperatorsByFullNameGet(fullName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [fullName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersSearchUsersByFullNameGet(fullName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchUserByFullNameOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersSearchUsersByFullNameGet(fullName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateUserCommand} [createUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersCreateUserPost(createUserCommand?: CreateUserCommand, options?: any): AxiosPromise<CreateUserOutputDTO> {
            return localVarFp.apiV1UsersCreateUserPost(createUserCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [fullName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersSearchOperatorsByFullNameGet(fullName?: string, options?: any): AxiosPromise<Array<SearchUserByFullNameOutputDTO>> {
            return localVarFp.apiV1UsersSearchOperatorsByFullNameGet(fullName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [fullName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersSearchUsersByFullNameGet(fullName?: string, options?: any): AxiosPromise<Array<SearchUserByFullNameOutputDTO>> {
            return localVarFp.apiV1UsersSearchUsersByFullNameGet(fullName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {CreateUserCommand} [createUserCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiV1UsersCreateUserPost(createUserCommand?: CreateUserCommand, options?: any) {
        return UsersApiFp(this.configuration).apiV1UsersCreateUserPost(createUserCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [fullName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiV1UsersSearchOperatorsByFullNameGet(fullName?: string, options?: any) {
        return UsersApiFp(this.configuration).apiV1UsersSearchOperatorsByFullNameGet(fullName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [fullName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiV1UsersSearchUsersByFullNameGet(fullName?: string, options?: any) {
        return UsersApiFp(this.configuration).apiV1UsersSearchUsersByFullNameGet(fullName, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VasApi - axios parameter creator
 * @export
 */
export const VasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddManualVasRecordCommand} [addManualVasRecordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasAddManualVasRecordPost: async (addManualVasRecordCommand?: AddManualVasRecordCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vas.addManualVasRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addManualVasRecordCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddVasConditionCommand} [addVasConditionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasAddVasConditionPost: async (addVasConditionCommand?: AddVasConditionCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vas.addVasCondition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addVasConditionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddVasDefinitionCommand} [addVasDefinitionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasAddVasDefinitionPost: async (addVasDefinitionCommand?: AddVasDefinitionCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vas.addVasDefinition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addVasDefinitionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} manualVasId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasCompleteManualVasManualVasIdPost: async (manualVasId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'manualVasId' is not null or undefined
            assertParamExists('apiV1VasCompleteManualVasManualVasIdPost', 'manualVasId', manualVasId)
            const localVarPath = `/api/v1/Vas.completeManualVas/{manualVasId}`
                .replace(`{${"manualVasId"}}`, encodeURIComponent(String(manualVasId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} manualVasId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasDeleteManualVasManualVasIdPost: async (manualVasId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'manualVasId' is not null or undefined
            assertParamExists('apiV1VasDeleteManualVasManualVasIdPost', 'manualVasId', manualVasId)
            const localVarPath = `/api/v1/Vas.deleteManualVas/{manualVasId}`
                .replace(`{${"manualVasId"}}`, encodeURIComponent(String(manualVasId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vasConditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasDeleteVasConditionVasConditionIdDelete: async (vasConditionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vasConditionId' is not null or undefined
            assertParamExists('apiV1VasDeleteVasConditionVasConditionIdDelete', 'vasConditionId', vasConditionId)
            const localVarPath = `/api/v1/Vas.deleteVasCondition/{vasConditionId}`
                .replace(`{${"vasConditionId"}}`, encodeURIComponent(String(vasConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vasId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasDeleteVasDefinitionVasIdDelete: async (vasId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vasId' is not null or undefined
            assertParamExists('apiV1VasDeleteVasDefinitionVasIdDelete', 'vasId', vasId)
            const localVarPath = `/api/v1/Vas.deleteVasDefinition/{vasId}`
                .replace(`{${"vasId"}}`, encodeURIComponent(String(vasId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vasConditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasDisableVasConditionVasConditionIdPost: async (vasConditionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vasConditionId' is not null or undefined
            assertParamExists('apiV1VasDisableVasConditionVasConditionIdPost', 'vasConditionId', vasConditionId)
            const localVarPath = `/api/v1/Vas.disableVasCondition/{vasConditionId}`
                .replace(`{${"vasConditionId"}}`, encodeURIComponent(String(vasConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vasId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasDisableVasDefinitionVasIdPost: async (vasId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vasId' is not null or undefined
            assertParamExists('apiV1VasDisableVasDefinitionVasIdPost', 'vasId', vasId)
            const localVarPath = `/api/v1/Vas.disableVasDefinition/{vasId}`
                .replace(`{${"vasId"}}`, encodeURIComponent(String(vasId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vasConditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasEnableVasConditionVasConditionIdPost: async (vasConditionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vasConditionId' is not null or undefined
            assertParamExists('apiV1VasEnableVasConditionVasConditionIdPost', 'vasConditionId', vasConditionId)
            const localVarPath = `/api/v1/Vas.enableVasCondition/{vasConditionId}`
                .replace(`{${"vasConditionId"}}`, encodeURIComponent(String(vasConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vasId 
         * @param {boolean} [enableConditions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasEnableVasDefinitionVasIdPost: async (vasId: number, enableConditions?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vasId' is not null or undefined
            assertParamExists('apiV1VasEnableVasDefinitionVasIdPost', 'vasId', vasId)
            const localVarPath = `/api/v1/Vas.enableVasDefinition/{vasId}`
                .replace(`{${"vasId"}}`, encodeURIComponent(String(vasId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (enableConditions !== undefined) {
                localVarQueryParameter['enableConditions'] = enableConditions;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasListManualVasRecordsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vas.listManualVasRecords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vasDefinitionId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasListVasConditionsGet: async (vasDefinitionId: number, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vasDefinitionId' is not null or undefined
            assertParamExists('apiV1VasListVasConditionsGet', 'vasDefinitionId', vasDefinitionId)
            const localVarPath = `/api/v1/Vas.listVasConditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (vasDefinitionId !== undefined) {
                localVarQueryParameter['vasDefinitionId'] = vasDefinitionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasListVasDefinitionsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vas.listVasDefinitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasListVasRecordsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vas.listVasRecords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasListVasRecordsLimitGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vas.listVasRecordsLimit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateManualVasRecordCommand} [updateManualVasRecordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasUpdateManualVasRecordPut: async (updateManualVasRecordCommand?: UpdateManualVasRecordCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vas.updateManualVasRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateManualVasRecordCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateVasConditionCommand} [updateVasConditionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasUpdateVasConditionPut: async (updateVasConditionCommand?: UpdateVasConditionCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vas.updateVasCondition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVasConditionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VasApi - functional programming interface
 * @export
 */
export const VasApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VasApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddManualVasRecordCommand} [addManualVasRecordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasAddManualVasRecordPost(addManualVasRecordCommand?: AddManualVasRecordCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasAddManualVasRecordPost(addManualVasRecordCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddVasConditionCommand} [addVasConditionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasAddVasConditionPost(addVasConditionCommand?: AddVasConditionCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasAddVasConditionPost(addVasConditionCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddVasDefinitionCommand} [addVasDefinitionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasAddVasDefinitionPost(addVasDefinitionCommand?: AddVasDefinitionCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasAddVasDefinitionPost(addVasDefinitionCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} manualVasId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasCompleteManualVasManualVasIdPost(manualVasId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasCompleteManualVasManualVasIdPost(manualVasId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} manualVasId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasDeleteManualVasManualVasIdPost(manualVasId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasDeleteManualVasManualVasIdPost(manualVasId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vasConditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasDeleteVasConditionVasConditionIdDelete(vasConditionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasDeleteVasConditionVasConditionIdDelete(vasConditionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vasId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasDeleteVasDefinitionVasIdDelete(vasId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasDeleteVasDefinitionVasIdDelete(vasId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vasConditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasDisableVasConditionVasConditionIdPost(vasConditionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasDisableVasConditionVasConditionIdPost(vasConditionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vasId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasDisableVasDefinitionVasIdPost(vasId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasDisableVasDefinitionVasIdPost(vasId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vasConditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasEnableVasConditionVasConditionIdPost(vasConditionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasEnableVasConditionVasConditionIdPost(vasConditionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vasId 
         * @param {boolean} [enableConditions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasEnableVasDefinitionVasIdPost(vasId: number, enableConditions?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasEnableVasDefinitionVasIdPost(vasId, enableConditions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasListManualVasRecordsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManualVasRecordOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasListManualVasRecordsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vasDefinitionId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasListVasConditionsGet(vasDefinitionId: number, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VasConditionOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasListVasConditionsGet(vasDefinitionId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasListVasDefinitionsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VasDefinitionOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasListVasDefinitionsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasListVasRecordsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VasRecordOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasListVasRecordsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasListVasRecordsLimitGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VasRecordOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasListVasRecordsLimitGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateManualVasRecordCommand} [updateManualVasRecordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasUpdateManualVasRecordPut(updateManualVasRecordCommand?: UpdateManualVasRecordCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasUpdateManualVasRecordPut(updateManualVasRecordCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateVasConditionCommand} [updateVasConditionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VasUpdateVasConditionPut(updateVasConditionCommand?: UpdateVasConditionCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VasUpdateVasConditionPut(updateVasConditionCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VasApi - factory interface
 * @export
 */
export const VasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VasApiFp(configuration)
    return {
        /**
         * 
         * @param {AddManualVasRecordCommand} [addManualVasRecordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasAddManualVasRecordPost(addManualVasRecordCommand?: AddManualVasRecordCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1VasAddManualVasRecordPost(addManualVasRecordCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddVasConditionCommand} [addVasConditionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasAddVasConditionPost(addVasConditionCommand?: AddVasConditionCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1VasAddVasConditionPost(addVasConditionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddVasDefinitionCommand} [addVasDefinitionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasAddVasDefinitionPost(addVasDefinitionCommand?: AddVasDefinitionCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1VasAddVasDefinitionPost(addVasDefinitionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} manualVasId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasCompleteManualVasManualVasIdPost(manualVasId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1VasCompleteManualVasManualVasIdPost(manualVasId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} manualVasId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasDeleteManualVasManualVasIdPost(manualVasId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1VasDeleteManualVasManualVasIdPost(manualVasId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vasConditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasDeleteVasConditionVasConditionIdDelete(vasConditionId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1VasDeleteVasConditionVasConditionIdDelete(vasConditionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vasId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasDeleteVasDefinitionVasIdDelete(vasId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1VasDeleteVasDefinitionVasIdDelete(vasId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vasConditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasDisableVasConditionVasConditionIdPost(vasConditionId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1VasDisableVasConditionVasConditionIdPost(vasConditionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vasId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasDisableVasDefinitionVasIdPost(vasId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1VasDisableVasDefinitionVasIdPost(vasId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vasConditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasEnableVasConditionVasConditionIdPost(vasConditionId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1VasEnableVasConditionVasConditionIdPost(vasConditionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vasId 
         * @param {boolean} [enableConditions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasEnableVasDefinitionVasIdPost(vasId: number, enableConditions?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1VasEnableVasDefinitionVasIdPost(vasId, enableConditions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasListManualVasRecordsGet(dqb?: string, options?: any): AxiosPromise<ManualVasRecordOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1VasListManualVasRecordsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vasDefinitionId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasListVasConditionsGet(vasDefinitionId: number, dqb?: string, options?: any): AxiosPromise<VasConditionOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1VasListVasConditionsGet(vasDefinitionId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasListVasDefinitionsGet(dqb?: string, options?: any): AxiosPromise<VasDefinitionOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1VasListVasDefinitionsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasListVasRecordsGet(dqb?: string, options?: any): AxiosPromise<VasRecordOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1VasListVasRecordsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasListVasRecordsLimitGet(dqb?: string, options?: any): AxiosPromise<VasRecordOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1VasListVasRecordsLimitGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateManualVasRecordCommand} [updateManualVasRecordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasUpdateManualVasRecordPut(updateManualVasRecordCommand?: UpdateManualVasRecordCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1VasUpdateManualVasRecordPut(updateManualVasRecordCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateVasConditionCommand} [updateVasConditionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VasUpdateVasConditionPut(updateVasConditionCommand?: UpdateVasConditionCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1VasUpdateVasConditionPut(updateVasConditionCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VasApi - object-oriented interface
 * @export
 * @class VasApi
 * @extends {BaseAPI}
 */
export class VasApi extends BaseAPI {
    /**
     * 
     * @param {AddManualVasRecordCommand} [addManualVasRecordCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasAddManualVasRecordPost(addManualVasRecordCommand?: AddManualVasRecordCommand, options?: any) {
        return VasApiFp(this.configuration).apiV1VasAddManualVasRecordPost(addManualVasRecordCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddVasConditionCommand} [addVasConditionCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasAddVasConditionPost(addVasConditionCommand?: AddVasConditionCommand, options?: any) {
        return VasApiFp(this.configuration).apiV1VasAddVasConditionPost(addVasConditionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddVasDefinitionCommand} [addVasDefinitionCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasAddVasDefinitionPost(addVasDefinitionCommand?: AddVasDefinitionCommand, options?: any) {
        return VasApiFp(this.configuration).apiV1VasAddVasDefinitionPost(addVasDefinitionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} manualVasId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasCompleteManualVasManualVasIdPost(manualVasId: number, options?: any) {
        return VasApiFp(this.configuration).apiV1VasCompleteManualVasManualVasIdPost(manualVasId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} manualVasId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasDeleteManualVasManualVasIdPost(manualVasId: number, options?: any) {
        return VasApiFp(this.configuration).apiV1VasDeleteManualVasManualVasIdPost(manualVasId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vasConditionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasDeleteVasConditionVasConditionIdDelete(vasConditionId: number, options?: any) {
        return VasApiFp(this.configuration).apiV1VasDeleteVasConditionVasConditionIdDelete(vasConditionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vasId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasDeleteVasDefinitionVasIdDelete(vasId: number, options?: any) {
        return VasApiFp(this.configuration).apiV1VasDeleteVasDefinitionVasIdDelete(vasId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vasConditionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasDisableVasConditionVasConditionIdPost(vasConditionId: number, options?: any) {
        return VasApiFp(this.configuration).apiV1VasDisableVasConditionVasConditionIdPost(vasConditionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vasId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasDisableVasDefinitionVasIdPost(vasId: number, options?: any) {
        return VasApiFp(this.configuration).apiV1VasDisableVasDefinitionVasIdPost(vasId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vasConditionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasEnableVasConditionVasConditionIdPost(vasConditionId: number, options?: any) {
        return VasApiFp(this.configuration).apiV1VasEnableVasConditionVasConditionIdPost(vasConditionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vasId 
     * @param {boolean} [enableConditions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasEnableVasDefinitionVasIdPost(vasId: number, enableConditions?: boolean, options?: any) {
        return VasApiFp(this.configuration).apiV1VasEnableVasDefinitionVasIdPost(vasId, enableConditions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasListManualVasRecordsGet(dqb?: string, options?: any) {
        return VasApiFp(this.configuration).apiV1VasListManualVasRecordsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vasDefinitionId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasListVasConditionsGet(vasDefinitionId: number, dqb?: string, options?: any) {
        return VasApiFp(this.configuration).apiV1VasListVasConditionsGet(vasDefinitionId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasListVasDefinitionsGet(dqb?: string, options?: any) {
        return VasApiFp(this.configuration).apiV1VasListVasDefinitionsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasListVasRecordsGet(dqb?: string, options?: any) {
        return VasApiFp(this.configuration).apiV1VasListVasRecordsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasListVasRecordsLimitGet(dqb?: string, options?: any) {
        return VasApiFp(this.configuration).apiV1VasListVasRecordsLimitGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateManualVasRecordCommand} [updateManualVasRecordCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasUpdateManualVasRecordPut(updateManualVasRecordCommand?: UpdateManualVasRecordCommand, options?: any) {
        return VasApiFp(this.configuration).apiV1VasUpdateManualVasRecordPut(updateManualVasRecordCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateVasConditionCommand} [updateVasConditionCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VasApi
     */
    public apiV1VasUpdateVasConditionPut(updateVasConditionCommand?: UpdateVasConditionCommand, options?: any) {
        return VasApiFp(this.configuration).apiV1VasUpdateVasConditionPut(updateVasConditionCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VehiclesApi - axios parameter creator
 * @export
 */
export const VehiclesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateBatchTrolleysCommand} [createBatchTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1VehiclesCreateBatchTrolleysPost: async (createBatchTrolleysCommand?: CreateBatchTrolleysCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Vehicles.createBatchTrolleys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBatchTrolleysCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePickingTrolleysCommand} [createPickingTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1VehiclesCreatePickingTrolleysPost: async (createPickingTrolleysCommand?: CreatePickingTrolleysCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Vehicles.createPickingTrolleys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPickingTrolleysCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePutAwayTrolleysCommand} [createPutAwayTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1VehiclesCreatePutAwayTrolleysPost: async (createPutAwayTrolleysCommand?: CreatePutAwayTrolleysCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Vehicles.createPutAwayTrolleys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPutAwayTrolleysCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRebinTrolleysCommand} [createRebinTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1VehiclesCreateRebinTrolleysPost: async (createRebinTrolleysCommand?: CreateRebinTrolleysCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Vehicles.createRebinTrolleys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRebinTrolleysCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateReturnTrolleysCommand} [createReturnTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1VehiclesCreateReturnTrolleysPost: async (createReturnTrolleysCommand?: CreateReturnTrolleysCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Vehicles.createReturnTrolleys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReturnTrolleysCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateVirtualTrolleysCommand} [createVirtualTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1VehiclesCreateVirtualTrolleysPost: async (createVirtualTrolleysCommand?: CreateVirtualTrolleysCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Vehicles.createVirtualTrolleys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVirtualTrolleysCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesGetPickingTrolleyDetailsGet: async (trolleyLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vehicles.getPickingTrolleyDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (trolleyLabel !== undefined) {
                localVarQueryParameter['trolleyLabel'] = trolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesGetPutAwayTrolleyDetailsGet: async (trolleyLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vehicles.getPutAwayTrolleyDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (trolleyLabel !== undefined) {
                localVarQueryParameter['trolleyLabel'] = trolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesGetTrolleyDetailGet: async (trolleyLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vehicles.getTrolleyDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (trolleyLabel !== undefined) {
                localVarQueryParameter['trolleyLabel'] = trolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [label] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesGetTrolleyStatusGet: async (label?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vehicles.getTrolleyStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (label !== undefined) {
                localVarQueryParameter['label'] = label;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesGetTrolleyTotesGet: async (trolleyLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vehicles.getTrolleyTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (trolleyLabel !== undefined) {
                localVarQueryParameter['trolleyLabel'] = trolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vehicles.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} trolleyLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesQueryPickingTrolleyPickingTotesGet: async (trolleyLabel: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'trolleyLabel' is not null or undefined
            assertParamExists('apiV1VehiclesQueryPickingTrolleyPickingTotesGet', 'trolleyLabel', trolleyLabel)
            const localVarPath = `/api/v1/Vehicles.queryPickingTrolleyPickingTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (trolleyLabel !== undefined) {
                localVarQueryParameter['trolleyLabel'] = trolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesQueryPickingTrolleySelectionConfigurationsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vehicles.queryPickingTrolleySelectionConfigurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} trolleyLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesQueryPutAwayTrolleyTotesGet: async (trolleyLabel: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'trolleyLabel' is not null or undefined
            assertParamExists('apiV1VehiclesQueryPutAwayTrolleyTotesGet', 'trolleyLabel', trolleyLabel)
            const localVarPath = `/api/v1/Vehicles.queryPutAwayTrolleyTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (trolleyLabel !== undefined) {
                localVarQueryParameter['trolleyLabel'] = trolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesQueryTrolleyStatusGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vehicles.queryTrolleyStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} trolleyLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesQueryTrolleyTotesGet: async (trolleyLabel: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'trolleyLabel' is not null or undefined
            assertParamExists('apiV1VehiclesQueryTrolleyTotesGet', 'trolleyLabel', trolleyLabel)
            const localVarPath = `/api/v1/Vehicles.queryTrolleyTotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (trolleyLabel !== undefined) {
                localVarQueryParameter['trolleyLabel'] = trolleyLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetPickingTrolleySelectionConfigurationStatusCommand} [setPickingTrolleySelectionConfigurationStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesSetPickingTrolleySelectionConfigurationStatusPost: async (setPickingTrolleySelectionConfigurationStatusCommand?: SetPickingTrolleySelectionConfigurationStatusCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vehicles.setPickingTrolleySelectionConfigurationStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPickingTrolleySelectionConfigurationStatusCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand} [updatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesUpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityPost: async (updatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand?: UpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Vehicles.updatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehiclesApi - functional programming interface
 * @export
 */
export const VehiclesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehiclesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateBatchTrolleysCommand} [createBatchTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1VehiclesCreateBatchTrolleysPost(createBatchTrolleysCommand?: CreateBatchTrolleysCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateBatchTrolleyOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1VehiclesCreateBatchTrolleysPost(createBatchTrolleysCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePickingTrolleysCommand} [createPickingTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1VehiclesCreatePickingTrolleysPost(createPickingTrolleysCommand?: CreatePickingTrolleysCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreatePickingTrolleyOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1VehiclesCreatePickingTrolleysPost(createPickingTrolleysCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePutAwayTrolleysCommand} [createPutAwayTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1VehiclesCreatePutAwayTrolleysPost(createPutAwayTrolleysCommand?: CreatePutAwayTrolleysCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreatePutAwayTrolleyOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1VehiclesCreatePutAwayTrolleysPost(createPutAwayTrolleysCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateRebinTrolleysCommand} [createRebinTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1VehiclesCreateRebinTrolleysPost(createRebinTrolleysCommand?: CreateRebinTrolleysCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateRebinTrolleyOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1VehiclesCreateRebinTrolleysPost(createRebinTrolleysCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateReturnTrolleysCommand} [createReturnTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1VehiclesCreateReturnTrolleysPost(createReturnTrolleysCommand?: CreateReturnTrolleysCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateReturnTrolleyOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1VehiclesCreateReturnTrolleysPost(createReturnTrolleysCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateVirtualTrolleysCommand} [createVirtualTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1VehiclesCreateVirtualTrolleysPost(createVirtualTrolleysCommand?: CreateVirtualTrolleysCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateVirtualTrolleyOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1VehiclesCreateVirtualTrolleysPost(createVirtualTrolleysCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesGetPickingTrolleyDetailsGet(trolleyLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickingTrolleyDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesGetPickingTrolleyDetailsGet(trolleyLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesGetPutAwayTrolleyDetailsGet(trolleyLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAwayTrolleyDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesGetPutAwayTrolleyDetailsGet(trolleyLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesGetTrolleyDetailGet(trolleyLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrolleyDetailOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesGetTrolleyDetailGet(trolleyLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [label] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesGetTrolleyStatusGet(label?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrolleyStatusOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesGetTrolleyStatusGet(label, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesGetTrolleyTotesGet(trolleyLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrolleyTotesResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesGetTrolleyTotesGet(trolleyLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} trolleyLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesQueryPickingTrolleyPickingTotesGet(trolleyLabel: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickingTrolleyPickingToteQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesQueryPickingTrolleyPickingTotesGet(trolleyLabel, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesQueryPickingTrolleySelectionConfigurationsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickingTrolleySelectionConfigurationOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesQueryPickingTrolleySelectionConfigurationsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} trolleyLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesQueryPutAwayTrolleyTotesGet(trolleyLabel: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutAwayTrolleyToteQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesQueryPutAwayTrolleyTotesGet(trolleyLabel, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesQueryTrolleyStatusGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrolleyStatusOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesQueryTrolleyStatusGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} trolleyLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesQueryTrolleyTotesGet(trolleyLabel: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrolleyToteOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesQueryTrolleyTotesGet(trolleyLabel, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetPickingTrolleySelectionConfigurationStatusCommand} [setPickingTrolleySelectionConfigurationStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesSetPickingTrolleySelectionConfigurationStatusPost(setPickingTrolleySelectionConfigurationStatusCommand?: SetPickingTrolleySelectionConfigurationStatusCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickingTrolleySelectionConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesSetPickingTrolleySelectionConfigurationStatusPost(setPickingTrolleySelectionConfigurationStatusCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand} [updatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1VehiclesUpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityPost(updatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand?: UpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickingTrolleySelectionConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1VehiclesUpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityPost(updatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VehiclesApi - factory interface
 * @export
 */
export const VehiclesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehiclesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateBatchTrolleysCommand} [createBatchTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1VehiclesCreateBatchTrolleysPost(createBatchTrolleysCommand?: CreateBatchTrolleysCommand, options?: any): AxiosPromise<Array<CreateBatchTrolleyOutputDTO>> {
            return localVarFp.adminV1VehiclesCreateBatchTrolleysPost(createBatchTrolleysCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePickingTrolleysCommand} [createPickingTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1VehiclesCreatePickingTrolleysPost(createPickingTrolleysCommand?: CreatePickingTrolleysCommand, options?: any): AxiosPromise<Array<CreatePickingTrolleyOutputDTO>> {
            return localVarFp.adminV1VehiclesCreatePickingTrolleysPost(createPickingTrolleysCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePutAwayTrolleysCommand} [createPutAwayTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1VehiclesCreatePutAwayTrolleysPost(createPutAwayTrolleysCommand?: CreatePutAwayTrolleysCommand, options?: any): AxiosPromise<Array<CreatePutAwayTrolleyOutputDTO>> {
            return localVarFp.adminV1VehiclesCreatePutAwayTrolleysPost(createPutAwayTrolleysCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRebinTrolleysCommand} [createRebinTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1VehiclesCreateRebinTrolleysPost(createRebinTrolleysCommand?: CreateRebinTrolleysCommand, options?: any): AxiosPromise<Array<CreateRebinTrolleyOutputDTO>> {
            return localVarFp.adminV1VehiclesCreateRebinTrolleysPost(createRebinTrolleysCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateReturnTrolleysCommand} [createReturnTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1VehiclesCreateReturnTrolleysPost(createReturnTrolleysCommand?: CreateReturnTrolleysCommand, options?: any): AxiosPromise<Array<CreateReturnTrolleyOutputDTO>> {
            return localVarFp.adminV1VehiclesCreateReturnTrolleysPost(createReturnTrolleysCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateVirtualTrolleysCommand} [createVirtualTrolleysCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1VehiclesCreateVirtualTrolleysPost(createVirtualTrolleysCommand?: CreateVirtualTrolleysCommand, options?: any): AxiosPromise<Array<CreateVirtualTrolleyOutputDTO>> {
            return localVarFp.adminV1VehiclesCreateVirtualTrolleysPost(createVirtualTrolleysCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesGetPickingTrolleyDetailsGet(trolleyLabel?: string, options?: any): AxiosPromise<PickingTrolleyDetailsOutputDTO> {
            return localVarFp.apiV1VehiclesGetPickingTrolleyDetailsGet(trolleyLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesGetPutAwayTrolleyDetailsGet(trolleyLabel?: string, options?: any): AxiosPromise<PutAwayTrolleyDetailsOutputDTO> {
            return localVarFp.apiV1VehiclesGetPutAwayTrolleyDetailsGet(trolleyLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesGetTrolleyDetailGet(trolleyLabel?: string, options?: any): AxiosPromise<TrolleyDetailOutputDTO> {
            return localVarFp.apiV1VehiclesGetTrolleyDetailGet(trolleyLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [label] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesGetTrolleyStatusGet(label?: string, options?: any): AxiosPromise<TrolleyStatusOutputDTO> {
            return localVarFp.apiV1VehiclesGetTrolleyStatusGet(label, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [trolleyLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesGetTrolleyTotesGet(trolleyLabel?: string, options?: any): AxiosPromise<GetTrolleyTotesResponseDTO> {
            return localVarFp.apiV1VehiclesGetTrolleyTotesGet(trolleyLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesQueryGet(dqb?: string, options?: any): AxiosPromise<VehicleQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1VehiclesQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} trolleyLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesQueryPickingTrolleyPickingTotesGet(trolleyLabel: string, dqb?: string, options?: any): AxiosPromise<PickingTrolleyPickingToteQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1VehiclesQueryPickingTrolleyPickingTotesGet(trolleyLabel, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesQueryPickingTrolleySelectionConfigurationsGet(dqb?: string, options?: any): AxiosPromise<PickingTrolleySelectionConfigurationOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1VehiclesQueryPickingTrolleySelectionConfigurationsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} trolleyLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesQueryPutAwayTrolleyTotesGet(trolleyLabel: string, dqb?: string, options?: any): AxiosPromise<PutAwayTrolleyToteQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1VehiclesQueryPutAwayTrolleyTotesGet(trolleyLabel, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesQueryTrolleyStatusGet(dqb?: string, options?: any): AxiosPromise<TrolleyStatusOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1VehiclesQueryTrolleyStatusGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} trolleyLabel 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesQueryTrolleyTotesGet(trolleyLabel: string, dqb?: string, options?: any): AxiosPromise<TrolleyToteOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1VehiclesQueryTrolleyTotesGet(trolleyLabel, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetPickingTrolleySelectionConfigurationStatusCommand} [setPickingTrolleySelectionConfigurationStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesSetPickingTrolleySelectionConfigurationStatusPost(setPickingTrolleySelectionConfigurationStatusCommand?: SetPickingTrolleySelectionConfigurationStatusCommand, options?: any): AxiosPromise<PickingTrolleySelectionConfiguration> {
            return localVarFp.apiV1VehiclesSetPickingTrolleySelectionConfigurationStatusPost(setPickingTrolleySelectionConfigurationStatusCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand} [updatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VehiclesUpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityPost(updatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand?: UpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand, options?: any): AxiosPromise<PickingTrolleySelectionConfiguration> {
            return localVarFp.apiV1VehiclesUpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityPost(updatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehiclesApi - object-oriented interface
 * @export
 * @class VehiclesApi
 * @extends {BaseAPI}
 */
export class VehiclesApi extends BaseAPI {
    /**
     * 
     * @param {CreateBatchTrolleysCommand} [createBatchTrolleysCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public adminV1VehiclesCreateBatchTrolleysPost(createBatchTrolleysCommand?: CreateBatchTrolleysCommand, options?: any) {
        return VehiclesApiFp(this.configuration).adminV1VehiclesCreateBatchTrolleysPost(createBatchTrolleysCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePickingTrolleysCommand} [createPickingTrolleysCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public adminV1VehiclesCreatePickingTrolleysPost(createPickingTrolleysCommand?: CreatePickingTrolleysCommand, options?: any) {
        return VehiclesApiFp(this.configuration).adminV1VehiclesCreatePickingTrolleysPost(createPickingTrolleysCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePutAwayTrolleysCommand} [createPutAwayTrolleysCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public adminV1VehiclesCreatePutAwayTrolleysPost(createPutAwayTrolleysCommand?: CreatePutAwayTrolleysCommand, options?: any) {
        return VehiclesApiFp(this.configuration).adminV1VehiclesCreatePutAwayTrolleysPost(createPutAwayTrolleysCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRebinTrolleysCommand} [createRebinTrolleysCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public adminV1VehiclesCreateRebinTrolleysPost(createRebinTrolleysCommand?: CreateRebinTrolleysCommand, options?: any) {
        return VehiclesApiFp(this.configuration).adminV1VehiclesCreateRebinTrolleysPost(createRebinTrolleysCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateReturnTrolleysCommand} [createReturnTrolleysCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public adminV1VehiclesCreateReturnTrolleysPost(createReturnTrolleysCommand?: CreateReturnTrolleysCommand, options?: any) {
        return VehiclesApiFp(this.configuration).adminV1VehiclesCreateReturnTrolleysPost(createReturnTrolleysCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateVirtualTrolleysCommand} [createVirtualTrolleysCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public adminV1VehiclesCreateVirtualTrolleysPost(createVirtualTrolleysCommand?: CreateVirtualTrolleysCommand, options?: any) {
        return VehiclesApiFp(this.configuration).adminV1VehiclesCreateVirtualTrolleysPost(createVirtualTrolleysCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [trolleyLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesGetPickingTrolleyDetailsGet(trolleyLabel?: string, options?: any) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesGetPickingTrolleyDetailsGet(trolleyLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [trolleyLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesGetPutAwayTrolleyDetailsGet(trolleyLabel?: string, options?: any) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesGetPutAwayTrolleyDetailsGet(trolleyLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [trolleyLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesGetTrolleyDetailGet(trolleyLabel?: string, options?: any) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesGetTrolleyDetailGet(trolleyLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [label] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesGetTrolleyStatusGet(label?: string, options?: any) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesGetTrolleyStatusGet(label, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [trolleyLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesGetTrolleyTotesGet(trolleyLabel?: string, options?: any) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesGetTrolleyTotesGet(trolleyLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesQueryGet(dqb?: string, options?: any) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} trolleyLabel 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesQueryPickingTrolleyPickingTotesGet(trolleyLabel: string, dqb?: string, options?: any) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesQueryPickingTrolleyPickingTotesGet(trolleyLabel, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesQueryPickingTrolleySelectionConfigurationsGet(dqb?: string, options?: any) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesQueryPickingTrolleySelectionConfigurationsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} trolleyLabel 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesQueryPutAwayTrolleyTotesGet(trolleyLabel: string, dqb?: string, options?: any) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesQueryPutAwayTrolleyTotesGet(trolleyLabel, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesQueryTrolleyStatusGet(dqb?: string, options?: any) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesQueryTrolleyStatusGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} trolleyLabel 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesQueryTrolleyTotesGet(trolleyLabel: string, dqb?: string, options?: any) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesQueryTrolleyTotesGet(trolleyLabel, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetPickingTrolleySelectionConfigurationStatusCommand} [setPickingTrolleySelectionConfigurationStatusCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesSetPickingTrolleySelectionConfigurationStatusPost(setPickingTrolleySelectionConfigurationStatusCommand?: SetPickingTrolleySelectionConfigurationStatusCommand, options?: any) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesSetPickingTrolleySelectionConfigurationStatusPost(setPickingTrolleySelectionConfigurationStatusCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand} [updatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public apiV1VehiclesUpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityPost(updatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand?: UpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand, options?: any) {
        return VehiclesApiFp(this.configuration).apiV1VehiclesUpdatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityPost(updatePickingTrolleySelectionConfigurationMinSalesOrderToStartAndCapacityCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WallToWallStockCountingResultsApi - axios parameter creator
 * @export
 */
export const WallToWallStockCountingResultsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApplyWallToWallStockCountingResultsCommand} [applyWallToWallStockCountingResultsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingResultsApplyStockCountingResultsPost: async (applyWallToWallStockCountingResultsCommand?: ApplyWallToWallStockCountingResultsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingResults.applyStockCountingResults`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyWallToWallStockCountingResultsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApplyWallToWallStockCountingPlanToStockCommand} [applyWallToWallStockCountingPlanToStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingResultsApplyWallToWallStockCountingPlanToStockPut: async (applyWallToWallStockCountingPlanToStockCommand?: ApplyWallToWallStockCountingPlanToStockCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingResults.applyWallToWallStockCountingPlanToStock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyWallToWallStockCountingPlanToStockCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WallToWallStockCountingResultsApi - functional programming interface
 * @export
 */
export const WallToWallStockCountingResultsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WallToWallStockCountingResultsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApplyWallToWallStockCountingResultsCommand} [applyWallToWallStockCountingResultsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingResultsApplyStockCountingResultsPost(applyWallToWallStockCountingResultsCommand?: ApplyWallToWallStockCountingResultsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingResultsApplyStockCountingResultsPost(applyWallToWallStockCountingResultsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApplyWallToWallStockCountingPlanToStockCommand} [applyWallToWallStockCountingPlanToStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingResultsApplyWallToWallStockCountingPlanToStockPut(applyWallToWallStockCountingPlanToStockCommand?: ApplyWallToWallStockCountingPlanToStockCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingResultsApplyWallToWallStockCountingPlanToStockPut(applyWallToWallStockCountingPlanToStockCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WallToWallStockCountingResultsApi - factory interface
 * @export
 */
export const WallToWallStockCountingResultsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WallToWallStockCountingResultsApiFp(configuration)
    return {
        /**
         * 
         * @param {ApplyWallToWallStockCountingResultsCommand} [applyWallToWallStockCountingResultsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingResultsApplyStockCountingResultsPost(applyWallToWallStockCountingResultsCommand?: ApplyWallToWallStockCountingResultsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WallToWallStockCountingResultsApplyStockCountingResultsPost(applyWallToWallStockCountingResultsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApplyWallToWallStockCountingPlanToStockCommand} [applyWallToWallStockCountingPlanToStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingResultsApplyWallToWallStockCountingPlanToStockPut(applyWallToWallStockCountingPlanToStockCommand?: ApplyWallToWallStockCountingPlanToStockCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WallToWallStockCountingResultsApplyWallToWallStockCountingPlanToStockPut(applyWallToWallStockCountingPlanToStockCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WallToWallStockCountingResultsApi - object-oriented interface
 * @export
 * @class WallToWallStockCountingResultsApi
 * @extends {BaseAPI}
 */
export class WallToWallStockCountingResultsApi extends BaseAPI {
    /**
     * 
     * @param {ApplyWallToWallStockCountingResultsCommand} [applyWallToWallStockCountingResultsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingResultsApi
     */
    public apiV1WallToWallStockCountingResultsApplyStockCountingResultsPost(applyWallToWallStockCountingResultsCommand?: ApplyWallToWallStockCountingResultsCommand, options?: any) {
        return WallToWallStockCountingResultsApiFp(this.configuration).apiV1WallToWallStockCountingResultsApplyStockCountingResultsPost(applyWallToWallStockCountingResultsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApplyWallToWallStockCountingPlanToStockCommand} [applyWallToWallStockCountingPlanToStockCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingResultsApi
     */
    public apiV1WallToWallStockCountingResultsApplyWallToWallStockCountingPlanToStockPut(applyWallToWallStockCountingPlanToStockCommand?: ApplyWallToWallStockCountingPlanToStockCommand, options?: any) {
        return WallToWallStockCountingResultsApiFp(this.configuration).apiV1WallToWallStockCountingResultsApplyWallToWallStockCountingPlanToStockPut(applyWallToWallStockCountingPlanToStockCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WallToWallStockCountingTasksApi - axios parameter creator
 * @export
 */
export const WallToWallStockCountingTasksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApplyWallToWallStockCountingPlanToStockCommand} [applyWallToWallStockCountingPlanToStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksApplyWallToWallStockCountingPlanToStockPut: async (applyWallToWallStockCountingPlanToStockCommand?: ApplyWallToWallStockCountingPlanToStockCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.applyWallToWallStockCountingPlanToStock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyWallToWallStockCountingPlanToStockCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AssignNewAddressesToPlanCommand} [assignNewAddressesToPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksAssignNewAddressesToPlanPost: async (assignNewAddressesToPlanCommand?: AssignNewAddressesToPlanCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.assignNewAddressesToPlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignNewAddressesToPlanCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AssignToWallToWallStockCountingPlanCommand} [assignToWallToWallStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksAssignToWallToWallStockCountingPlanPost: async (assignToWallToWallStockCountingPlanCommand?: AssignToWallToWallStockCountingPlanCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.assignToWallToWallStockCountingPlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignToWallToWallStockCountingPlanCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckDamagedProductCommand} [checkDamagedProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCheckDamagedProductPost: async (checkDamagedProductCommand?: CheckDamagedProductCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.checkDamagedProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkDamagedProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {number} [cellId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCheckProductForWallToWallStockCountingGet: async (barcode?: string, cellId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.checkProductForWallToWallStockCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }

            if (cellId !== undefined) {
                localVarQueryParameter['cellId'] = cellId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckQuarantineToteCommand} [checkQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCheckQuarantineTotePost: async (checkQuarantineToteCommand?: CheckQuarantineToteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.checkQuarantineTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkQuarantineToteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckToteIfAvailableCommand} [checkToteIfAvailableCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCheckToteIfAvailablePost: async (checkToteIfAvailableCommand?: CheckToteIfAvailableCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.checkToteIfAvailable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkToteIfAvailableCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckWallToWallStockCountingPlanNameIfAvailableCommand} [checkWallToWallStockCountingPlanNameIfAvailableCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCheckWallToWallStockCountingPlanNameIfAvailablePost: async (checkWallToWallStockCountingPlanNameIfAvailableCommand?: CheckWallToWallStockCountingPlanNameIfAvailableCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.checkWallToWallStockCountingPlanNameIfAvailable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkWallToWallStockCountingPlanNameIfAvailableCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteRestowProcessCommand} [completeRestowProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCompleteRestowProcessPost: async (completeRestowProcessCommand?: CompleteRestowProcessCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.completeRestowProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeRestowProcessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ContinueWallToWallStockCountingListCommand} [continueWallToWallStockCountingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksContinueWallToWallStockCountingListPost: async (continueWallToWallStockCountingListCommand?: ContinueWallToWallStockCountingListCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.continueWallToWallStockCountingList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(continueWallToWallStockCountingListCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CountDamagedItemsCommand} [countDamagedItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCountDamagedItemsPost: async (countDamagedItemsCommand?: CountDamagedItemsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.countDamagedItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(countDamagedItemsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CountWallToWallStockCountingProductsCommand} [countWallToWallStockCountingProductsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCountProductsPost: async (countWallToWallStockCountingProductsCommand?: CountWallToWallStockCountingProductsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.countProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(countWallToWallStockCountingProductsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateListForIncorrectCountedCellsCommand} [createListForIncorrectCountedCellsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCreateListForIncorrectCountedCellsPost: async (createListForIncorrectCountedCellsCommand?: CreateListForIncorrectCountedCellsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.createListForIncorrectCountedCells`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createListForIncorrectCountedCellsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteWallToWallStockCountingAddressCommand} [deleteWallToWallStockCountingAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksDeleteWallToWallStockCountingAddressDelete: async (deleteWallToWallStockCountingAddressCommand?: DeleteWallToWallStockCountingAddressCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.deleteWallToWallStockCountingAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteWallToWallStockCountingAddressCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteWallToWallStockCountingListCommand} [deleteWallToWallStockCountingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksDeleteWallToWallStockCountingListDelete: async (deleteWallToWallStockCountingListCommand?: DeleteWallToWallStockCountingListCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.deleteWallToWallStockCountingList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteWallToWallStockCountingListCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FinishWallToWallStockCountingPlanCommand} [finishWallToWallStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksFinishWallToWallStockCountingPlanPut: async (finishWallToWallStockCountingPlanCommand?: FinishWallToWallStockCountingPlanCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.finishWallToWallStockCountingPlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(finishWallToWallStockCountingPlanCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetActiveWallToWallStockCountingPlansGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.getActiveWallToWallStockCountingPlans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetAllWallToWallStockCountingPlansGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.getAllWallToWallStockCountingPlans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetCellsForControlCountGet: async (stockCountingPlanId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockCountingPlanId' is not null or undefined
            assertParamExists('apiV1WallToWallStockCountingTasksGetCellsForControlCountGet', 'stockCountingPlanId', stockCountingPlanId)
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.getCellsForControlCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetCompletedWallToWallStockCountingPlansGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.getCompletedWallToWallStockCountingPlans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetCreatedStateWallToWallStockCountingListsGet: async (stockCountingPlanId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.getCreatedStateWallToWallStockCountingLists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetCreatedWallToWallStockCountingPlansGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.getCreatedWallToWallStockCountingPlans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetListsWithIncorrectCountedCellsGet: async (stockCountingPlanId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockCountingPlanId' is not null or undefined
            assertParamExists('apiV1WallToWallStockCountingTasksGetListsWithIncorrectCountedCellsGet', 'stockCountingPlanId', stockCountingPlanId)
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.getListsWithIncorrectCountedCells`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetNextCellStockCounting} [getNextCellStockCounting] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetNextCellStockCountingPost: async (getNextCellStockCounting?: GetNextCellStockCounting, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.getNextCellStockCounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getNextCellStockCounting, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetWallToWallStockCountingCountsGet: async (stockCountingPlanId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.getWallToWallStockCountingCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetWallToWallStockCountingListsGet: async (stockCountingPlanId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.getWallToWallStockCountingLists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetWallToWallStockCountingPlanGet: async (stockCountingPlanId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.getWallToWallStockCountingPlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetWallToWallStockCountingPlansGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.getWallToWallStockCountingPlans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetWallToWallStockCountingReportCountsGet: async (stockCountingPlanId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.getWallToWallStockCountingReportCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetWallToWallStockCountingTrackingCountsGet: async (stockCountingPlanId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.getWallToWallStockCountingTrackingCounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stockCountingListId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksPreviewWallToWallStockCountingPlanItemsGet: async (stockCountingListId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockCountingListId' is not null or undefined
            assertParamExists('apiV1WallToWallStockCountingTasksPreviewWallToWallStockCountingPlanItemsGet', 'stockCountingListId', stockCountingListId)
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.previewWallToWallStockCountingPlanItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockCountingListId !== undefined) {
                localVarQueryParameter['stockCountingListId'] = stockCountingListId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksPreviewWallToWallStockCountingPlanListsGet: async (stockCountingPlanId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockCountingPlanId' is not null or undefined
            assertParamExists('apiV1WallToWallStockCountingTasksPreviewWallToWallStockCountingPlanListsGet', 'stockCountingPlanId', stockCountingPlanId)
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.previewWallToWallStockCountingPlanLists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryCellsGet: async (stockCountingPlanId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockCountingPlanId' is not null or undefined
            assertParamExists('apiV1WallToWallStockCountingTasksQueryCellsGet', 'stockCountingPlanId', stockCountingPlanId)
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.queryCells`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressesGet: async (stockCountingPlanId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockCountingPlanId' is not null or undefined
            assertParamExists('apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressesGet', 'stockCountingPlanId', stockCountingPlanId)
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.queryWallToWallStockCountingAddresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressProductsReportGet: async (stockCountingPlanId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockCountingPlanId' is not null or undefined
            assertParamExists('apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressProductsReportGet', 'stockCountingPlanId', stockCountingPlanId)
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.queryWallToWallStockCountingAddressProductsReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressesReportGet: async (stockCountingPlanId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockCountingPlanId' is not null or undefined
            assertParamExists('apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressesReportGet', 'stockCountingPlanId', stockCountingPlanId)
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.queryWallToWallStockCountingAddressesReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingDamagedItemsGet: async (stockCountingPlanId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockCountingPlanId' is not null or undefined
            assertParamExists('apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingDamagedItemsGet', 'stockCountingPlanId', stockCountingPlanId)
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.queryWallToWallStockCountingDamagedItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingDamagedItemsReportGet: async (stockCountingPlanId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockCountingPlanId' is not null or undefined
            assertParamExists('apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingDamagedItemsReportGet', 'stockCountingPlanId', stockCountingPlanId)
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.queryWallToWallStockCountingDamagedItemsReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingListsGet: async (stockCountingPlanId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockCountingPlanId' is not null or undefined
            assertParamExists('apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingListsGet', 'stockCountingPlanId', stockCountingPlanId)
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.queryWallToWallStockCountingLists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingListsReportGet: async (stockCountingPlanId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockCountingPlanId' is not null or undefined
            assertParamExists('apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingListsReportGet', 'stockCountingPlanId', stockCountingPlanId)
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.queryWallToWallStockCountingListsReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingOperationsReportGet: async (stockCountingPlanId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockCountingPlanId' is not null or undefined
            assertParamExists('apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingOperationsReportGet', 'stockCountingPlanId', stockCountingPlanId)
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.queryWallToWallStockCountingOperationsReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {number} cellId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsGet: async (stockCountingPlanId: string, cellId: number, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockCountingPlanId' is not null or undefined
            assertParamExists('apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsGet', 'stockCountingPlanId', stockCountingPlanId)
            // verify required parameter 'cellId' is not null or undefined
            assertParamExists('apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsGet', 'cellId', cellId)
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.queryWallToWallStockCountingProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }

            if (cellId !== undefined) {
                localVarQueryParameter['cellId'] = cellId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsReportGet: async (stockCountingPlanId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stockCountingPlanId' is not null or undefined
            assertParamExists('apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsReportGet', 'stockCountingPlanId', stockCountingPlanId)
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.queryWallToWallStockCountingProductsReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingSummaryReportGet: async (stockCountingPlanId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.queryWallToWallStockCountingSummaryReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (stockCountingPlanId !== undefined) {
                localVarQueryParameter['stockCountingPlanId'] = stockCountingPlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RestowUndamagedItemCommand} [restowUndamagedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksRestowUndamagedItemsPost: async (restowUndamagedItemCommand?: RestowUndamagedItemCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.restowUndamagedItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(restowUndamagedItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartWallToWallStockCountingListCommand} [startWallToWallStockCountingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksStartWallToWallStockCountingListPost: async (startWallToWallStockCountingListCommand?: StartWallToWallStockCountingListCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.startWallToWallStockCountingList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startWallToWallStockCountingListCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartWallToWallStockCountingPlanCommand} [startWallToWallStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksStartWallToWallStockCountingPlanPut: async (startWallToWallStockCountingPlanCommand?: StartWallToWallStockCountingPlanCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WallToWallStockCountingTasks.startWallToWallStockCountingPlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startWallToWallStockCountingPlanCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WallToWallStockCountingTasksApi - functional programming interface
 * @export
 */
export const WallToWallStockCountingTasksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WallToWallStockCountingTasksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApplyWallToWallStockCountingPlanToStockCommand} [applyWallToWallStockCountingPlanToStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksApplyWallToWallStockCountingPlanToStockPut(applyWallToWallStockCountingPlanToStockCommand?: ApplyWallToWallStockCountingPlanToStockCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksApplyWallToWallStockCountingPlanToStockPut(applyWallToWallStockCountingPlanToStockCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AssignNewAddressesToPlanCommand} [assignNewAddressesToPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksAssignNewAddressesToPlanPost(assignNewAddressesToPlanCommand?: AssignNewAddressesToPlanCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksAssignNewAddressesToPlanPost(assignNewAddressesToPlanCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AssignToWallToWallStockCountingPlanCommand} [assignToWallToWallStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksAssignToWallToWallStockCountingPlanPost(assignToWallToWallStockCountingPlanCommand?: AssignToWallToWallStockCountingPlanCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingPlanOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksAssignToWallToWallStockCountingPlanPost(assignToWallToWallStockCountingPlanCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckDamagedProductCommand} [checkDamagedProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksCheckDamagedProductPost(checkDamagedProductCommand?: CheckDamagedProductCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckDamagedProductOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksCheckDamagedProductPost(checkDamagedProductCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {number} [cellId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksCheckProductForWallToWallStockCountingGet(barcode?: string, cellId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckProductForWallToWallStockCountingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksCheckProductForWallToWallStockCountingGet(barcode, cellId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckQuarantineToteCommand} [checkQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksCheckQuarantineTotePost(checkQuarantineToteCommand?: CheckQuarantineToteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksCheckQuarantineTotePost(checkQuarantineToteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckToteIfAvailableCommand} [checkToteIfAvailableCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksCheckToteIfAvailablePost(checkToteIfAvailableCommand?: CheckToteIfAvailableCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksCheckToteIfAvailablePost(checkToteIfAvailableCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckWallToWallStockCountingPlanNameIfAvailableCommand} [checkWallToWallStockCountingPlanNameIfAvailableCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksCheckWallToWallStockCountingPlanNameIfAvailablePost(checkWallToWallStockCountingPlanNameIfAvailableCommand?: CheckWallToWallStockCountingPlanNameIfAvailableCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksCheckWallToWallStockCountingPlanNameIfAvailablePost(checkWallToWallStockCountingPlanNameIfAvailableCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteRestowProcessCommand} [completeRestowProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksCompleteRestowProcessPost(completeRestowProcessCommand?: CompleteRestowProcessCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteRestowProcessOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksCompleteRestowProcessPost(completeRestowProcessCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ContinueWallToWallStockCountingListCommand} [continueWallToWallStockCountingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksContinueWallToWallStockCountingListPost(continueWallToWallStockCountingListCommand?: ContinueWallToWallStockCountingListCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartWallToWallStockCountingListOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksContinueWallToWallStockCountingListPost(continueWallToWallStockCountingListCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CountDamagedItemsCommand} [countDamagedItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksCountDamagedItemsPost(countDamagedItemsCommand?: CountDamagedItemsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksCountDamagedItemsPost(countDamagedItemsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CountWallToWallStockCountingProductsCommand} [countWallToWallStockCountingProductsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksCountProductsPost(countWallToWallStockCountingProductsCommand?: CountWallToWallStockCountingProductsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksCountProductsPost(countWallToWallStockCountingProductsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateListForIncorrectCountedCellsCommand} [createListForIncorrectCountedCellsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksCreateListForIncorrectCountedCellsPost(createListForIncorrectCountedCellsCommand?: CreateListForIncorrectCountedCellsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksCreateListForIncorrectCountedCellsPost(createListForIncorrectCountedCellsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteWallToWallStockCountingAddressCommand} [deleteWallToWallStockCountingAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksDeleteWallToWallStockCountingAddressDelete(deleteWallToWallStockCountingAddressCommand?: DeleteWallToWallStockCountingAddressCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksDeleteWallToWallStockCountingAddressDelete(deleteWallToWallStockCountingAddressCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteWallToWallStockCountingListCommand} [deleteWallToWallStockCountingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksDeleteWallToWallStockCountingListDelete(deleteWallToWallStockCountingListCommand?: DeleteWallToWallStockCountingListCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksDeleteWallToWallStockCountingListDelete(deleteWallToWallStockCountingListCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FinishWallToWallStockCountingPlanCommand} [finishWallToWallStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksFinishWallToWallStockCountingPlanPut(finishWallToWallStockCountingPlanCommand?: FinishWallToWallStockCountingPlanCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksFinishWallToWallStockCountingPlanPut(finishWallToWallStockCountingPlanCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksGetActiveWallToWallStockCountingPlansGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingPlansOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksGetActiveWallToWallStockCountingPlansGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksGetAllWallToWallStockCountingPlansGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingPlansOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksGetAllWallToWallStockCountingPlansGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksGetCellsForControlCountGet(stockCountingPlanId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CellsForControlCountOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksGetCellsForControlCountGet(stockCountingPlanId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksGetCompletedWallToWallStockCountingPlansGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingPlansOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksGetCompletedWallToWallStockCountingPlansGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksGetCreatedStateWallToWallStockCountingListsGet(stockCountingPlanId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingListsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksGetCreatedStateWallToWallStockCountingListsGet(stockCountingPlanId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksGetCreatedWallToWallStockCountingPlansGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingPlansOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksGetCreatedWallToWallStockCountingPlansGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksGetListsWithIncorrectCountedCellsGet(stockCountingPlanId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingListsWithIncorrectCountedCellsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksGetListsWithIncorrectCountedCellsGet(stockCountingPlanId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetNextCellStockCounting} [getNextCellStockCounting] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksGetNextCellStockCountingPost(getNextCellStockCounting?: GetNextCellStockCounting, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingRouteOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksGetNextCellStockCountingPost(getNextCellStockCounting, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksGetWallToWallStockCountingCountsGet(stockCountingPlanId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingCountsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksGetWallToWallStockCountingCountsGet(stockCountingPlanId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksGetWallToWallStockCountingListsGet(stockCountingPlanId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingListsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksGetWallToWallStockCountingListsGet(stockCountingPlanId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksGetWallToWallStockCountingPlanGet(stockCountingPlanId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingPlanOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksGetWallToWallStockCountingPlanGet(stockCountingPlanId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksGetWallToWallStockCountingPlansGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingPlansOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksGetWallToWallStockCountingPlansGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksGetWallToWallStockCountingReportCountsGet(stockCountingPlanId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingReportCountsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksGetWallToWallStockCountingReportCountsGet(stockCountingPlanId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksGetWallToWallStockCountingTrackingCountsGet(stockCountingPlanId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingTrackingCountsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksGetWallToWallStockCountingTrackingCountsGet(stockCountingPlanId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stockCountingListId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksPreviewWallToWallStockCountingPlanItemsGet(stockCountingListId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewWallToWallStockCountingPlanItemOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksPreviewWallToWallStockCountingPlanItemsGet(stockCountingListId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksPreviewWallToWallStockCountingPlanListsGet(stockCountingPlanId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewWallToWallStockCountingPlanListOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksPreviewWallToWallStockCountingPlanListsGet(stockCountingPlanId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksQueryCellsGet(stockCountingPlanId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockCellStatusOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksQueryCellsGet(stockCountingPlanId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressesGet(stockCountingPlanId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingAddressesOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressesGet(stockCountingPlanId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressProductsReportGet(stockCountingPlanId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingAddressProductsReportOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressProductsReportGet(stockCountingPlanId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressesReportGet(stockCountingPlanId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingAddressesReportOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressesReportGet(stockCountingPlanId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingDamagedItemsGet(stockCountingPlanId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingDamagedItemsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingDamagedItemsGet(stockCountingPlanId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingDamagedItemsReportGet(stockCountingPlanId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingDamagedItemsReportOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingDamagedItemsReportGet(stockCountingPlanId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingListsGet(stockCountingPlanId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingListOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingListsGet(stockCountingPlanId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingListsReportGet(stockCountingPlanId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingListsReportOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingListsReportGet(stockCountingPlanId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingOperationsReportGet(stockCountingPlanId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingOperationsReportOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingOperationsReportGet(stockCountingPlanId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {number} cellId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsGet(stockCountingPlanId: string, cellId: number, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingProductsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsGet(stockCountingPlanId, cellId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsReportGet(stockCountingPlanId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingProductsReportOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsReportGet(stockCountingPlanId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingSummaryReportGet(stockCountingPlanId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WallToWallStockCountingSummaryReportOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingSummaryReportGet(stockCountingPlanId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RestowUndamagedItemCommand} [restowUndamagedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksRestowUndamagedItemsPost(restowUndamagedItemCommand?: RestowUndamagedItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksRestowUndamagedItemsPost(restowUndamagedItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StartWallToWallStockCountingListCommand} [startWallToWallStockCountingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksStartWallToWallStockCountingListPost(startWallToWallStockCountingListCommand?: StartWallToWallStockCountingListCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartWallToWallStockCountingListOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksStartWallToWallStockCountingListPost(startWallToWallStockCountingListCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StartWallToWallStockCountingPlanCommand} [startWallToWallStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WallToWallStockCountingTasksStartWallToWallStockCountingPlanPut(startWallToWallStockCountingPlanCommand?: StartWallToWallStockCountingPlanCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WallToWallStockCountingTasksStartWallToWallStockCountingPlanPut(startWallToWallStockCountingPlanCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WallToWallStockCountingTasksApi - factory interface
 * @export
 */
export const WallToWallStockCountingTasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WallToWallStockCountingTasksApiFp(configuration)
    return {
        /**
         * 
         * @param {ApplyWallToWallStockCountingPlanToStockCommand} [applyWallToWallStockCountingPlanToStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksApplyWallToWallStockCountingPlanToStockPut(applyWallToWallStockCountingPlanToStockCommand?: ApplyWallToWallStockCountingPlanToStockCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WallToWallStockCountingTasksApplyWallToWallStockCountingPlanToStockPut(applyWallToWallStockCountingPlanToStockCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignNewAddressesToPlanCommand} [assignNewAddressesToPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksAssignNewAddressesToPlanPost(assignNewAddressesToPlanCommand?: AssignNewAddressesToPlanCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WallToWallStockCountingTasksAssignNewAddressesToPlanPost(assignNewAddressesToPlanCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignToWallToWallStockCountingPlanCommand} [assignToWallToWallStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksAssignToWallToWallStockCountingPlanPost(assignToWallToWallStockCountingPlanCommand?: AssignToWallToWallStockCountingPlanCommand, options?: any): AxiosPromise<WallToWallStockCountingPlanOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksAssignToWallToWallStockCountingPlanPost(assignToWallToWallStockCountingPlanCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckDamagedProductCommand} [checkDamagedProductCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCheckDamagedProductPost(checkDamagedProductCommand?: CheckDamagedProductCommand, options?: any): AxiosPromise<CheckDamagedProductOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksCheckDamagedProductPost(checkDamagedProductCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {number} [cellId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCheckProductForWallToWallStockCountingGet(barcode?: string, cellId?: number, options?: any): AxiosPromise<CheckProductForWallToWallStockCountingOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksCheckProductForWallToWallStockCountingGet(barcode, cellId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckQuarantineToteCommand} [checkQuarantineToteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCheckQuarantineTotePost(checkQuarantineToteCommand?: CheckQuarantineToteCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WallToWallStockCountingTasksCheckQuarantineTotePost(checkQuarantineToteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckToteIfAvailableCommand} [checkToteIfAvailableCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCheckToteIfAvailablePost(checkToteIfAvailableCommand?: CheckToteIfAvailableCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WallToWallStockCountingTasksCheckToteIfAvailablePost(checkToteIfAvailableCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckWallToWallStockCountingPlanNameIfAvailableCommand} [checkWallToWallStockCountingPlanNameIfAvailableCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCheckWallToWallStockCountingPlanNameIfAvailablePost(checkWallToWallStockCountingPlanNameIfAvailableCommand?: CheckWallToWallStockCountingPlanNameIfAvailableCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WallToWallStockCountingTasksCheckWallToWallStockCountingPlanNameIfAvailablePost(checkWallToWallStockCountingPlanNameIfAvailableCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteRestowProcessCommand} [completeRestowProcessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCompleteRestowProcessPost(completeRestowProcessCommand?: CompleteRestowProcessCommand, options?: any): AxiosPromise<CompleteRestowProcessOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksCompleteRestowProcessPost(completeRestowProcessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContinueWallToWallStockCountingListCommand} [continueWallToWallStockCountingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksContinueWallToWallStockCountingListPost(continueWallToWallStockCountingListCommand?: ContinueWallToWallStockCountingListCommand, options?: any): AxiosPromise<StartWallToWallStockCountingListOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksContinueWallToWallStockCountingListPost(continueWallToWallStockCountingListCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CountDamagedItemsCommand} [countDamagedItemsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCountDamagedItemsPost(countDamagedItemsCommand?: CountDamagedItemsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WallToWallStockCountingTasksCountDamagedItemsPost(countDamagedItemsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CountWallToWallStockCountingProductsCommand} [countWallToWallStockCountingProductsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCountProductsPost(countWallToWallStockCountingProductsCommand?: CountWallToWallStockCountingProductsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WallToWallStockCountingTasksCountProductsPost(countWallToWallStockCountingProductsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateListForIncorrectCountedCellsCommand} [createListForIncorrectCountedCellsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksCreateListForIncorrectCountedCellsPost(createListForIncorrectCountedCellsCommand?: CreateListForIncorrectCountedCellsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WallToWallStockCountingTasksCreateListForIncorrectCountedCellsPost(createListForIncorrectCountedCellsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteWallToWallStockCountingAddressCommand} [deleteWallToWallStockCountingAddressCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksDeleteWallToWallStockCountingAddressDelete(deleteWallToWallStockCountingAddressCommand?: DeleteWallToWallStockCountingAddressCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WallToWallStockCountingTasksDeleteWallToWallStockCountingAddressDelete(deleteWallToWallStockCountingAddressCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteWallToWallStockCountingListCommand} [deleteWallToWallStockCountingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksDeleteWallToWallStockCountingListDelete(deleteWallToWallStockCountingListCommand?: DeleteWallToWallStockCountingListCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WallToWallStockCountingTasksDeleteWallToWallStockCountingListDelete(deleteWallToWallStockCountingListCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FinishWallToWallStockCountingPlanCommand} [finishWallToWallStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksFinishWallToWallStockCountingPlanPut(finishWallToWallStockCountingPlanCommand?: FinishWallToWallStockCountingPlanCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WallToWallStockCountingTasksFinishWallToWallStockCountingPlanPut(finishWallToWallStockCountingPlanCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetActiveWallToWallStockCountingPlansGet(options?: any): AxiosPromise<WallToWallStockCountingPlansOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksGetActiveWallToWallStockCountingPlansGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetAllWallToWallStockCountingPlansGet(options?: any): AxiosPromise<WallToWallStockCountingPlansOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksGetAllWallToWallStockCountingPlansGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetCellsForControlCountGet(stockCountingPlanId: string, dqb?: string, options?: any): AxiosPromise<CellsForControlCountOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksGetCellsForControlCountGet(stockCountingPlanId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetCompletedWallToWallStockCountingPlansGet(options?: any): AxiosPromise<WallToWallStockCountingPlansOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksGetCompletedWallToWallStockCountingPlansGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetCreatedStateWallToWallStockCountingListsGet(stockCountingPlanId?: string, options?: any): AxiosPromise<WallToWallStockCountingListsOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksGetCreatedStateWallToWallStockCountingListsGet(stockCountingPlanId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetCreatedWallToWallStockCountingPlansGet(options?: any): AxiosPromise<WallToWallStockCountingPlansOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksGetCreatedWallToWallStockCountingPlansGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetListsWithIncorrectCountedCellsGet(stockCountingPlanId: string, dqb?: string, options?: any): AxiosPromise<WallToWallStockCountingListsWithIncorrectCountedCellsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksGetListsWithIncorrectCountedCellsGet(stockCountingPlanId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetNextCellStockCounting} [getNextCellStockCounting] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetNextCellStockCountingPost(getNextCellStockCounting?: GetNextCellStockCounting, options?: any): AxiosPromise<WallToWallStockCountingRouteOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksGetNextCellStockCountingPost(getNextCellStockCounting, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetWallToWallStockCountingCountsGet(stockCountingPlanId?: string, options?: any): AxiosPromise<WallToWallStockCountingCountsOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksGetWallToWallStockCountingCountsGet(stockCountingPlanId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetWallToWallStockCountingListsGet(stockCountingPlanId?: string, options?: any): AxiosPromise<WallToWallStockCountingListsOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksGetWallToWallStockCountingListsGet(stockCountingPlanId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetWallToWallStockCountingPlanGet(stockCountingPlanId?: string, options?: any): AxiosPromise<WallToWallStockCountingPlanOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksGetWallToWallStockCountingPlanGet(stockCountingPlanId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetWallToWallStockCountingPlansGet(options?: any): AxiosPromise<WallToWallStockCountingPlansOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksGetWallToWallStockCountingPlansGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetWallToWallStockCountingReportCountsGet(stockCountingPlanId?: string, options?: any): AxiosPromise<WallToWallStockCountingReportCountsOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksGetWallToWallStockCountingReportCountsGet(stockCountingPlanId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksGetWallToWallStockCountingTrackingCountsGet(stockCountingPlanId?: string, options?: any): AxiosPromise<WallToWallStockCountingTrackingCountsOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksGetWallToWallStockCountingTrackingCountsGet(stockCountingPlanId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stockCountingListId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksPreviewWallToWallStockCountingPlanItemsGet(stockCountingListId: string, dqb?: string, options?: any): AxiosPromise<PreviewWallToWallStockCountingPlanItemOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksPreviewWallToWallStockCountingPlanItemsGet(stockCountingListId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksPreviewWallToWallStockCountingPlanListsGet(stockCountingPlanId: string, dqb?: string, options?: any): AxiosPromise<PreviewWallToWallStockCountingPlanListOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksPreviewWallToWallStockCountingPlanListsGet(stockCountingPlanId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryCellsGet(stockCountingPlanId: string, dqb?: string, options?: any): AxiosPromise<StockCellStatusOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksQueryCellsGet(stockCountingPlanId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressesGet(stockCountingPlanId: string, dqb?: string, options?: any): AxiosPromise<WallToWallStockCountingAddressesOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressesGet(stockCountingPlanId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressProductsReportGet(stockCountingPlanId: string, dqb?: string, options?: any): AxiosPromise<WallToWallStockCountingAddressProductsReportOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressProductsReportGet(stockCountingPlanId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressesReportGet(stockCountingPlanId: string, dqb?: string, options?: any): AxiosPromise<WallToWallStockCountingAddressesReportOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressesReportGet(stockCountingPlanId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingDamagedItemsGet(stockCountingPlanId: string, dqb?: string, options?: any): AxiosPromise<WallToWallStockCountingDamagedItemsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingDamagedItemsGet(stockCountingPlanId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingDamagedItemsReportGet(stockCountingPlanId: string, dqb?: string, options?: any): AxiosPromise<WallToWallStockCountingDamagedItemsReportOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingDamagedItemsReportGet(stockCountingPlanId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingListsGet(stockCountingPlanId: string, dqb?: string, options?: any): AxiosPromise<WallToWallStockCountingListOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingListsGet(stockCountingPlanId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingListsReportGet(stockCountingPlanId: string, dqb?: string, options?: any): AxiosPromise<WallToWallStockCountingListsReportOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingListsReportGet(stockCountingPlanId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingOperationsReportGet(stockCountingPlanId: string, dqb?: string, options?: any): AxiosPromise<WallToWallStockCountingOperationsReportOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingOperationsReportGet(stockCountingPlanId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {number} cellId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsGet(stockCountingPlanId: string, cellId: number, dqb?: string, options?: any): AxiosPromise<WallToWallStockCountingProductsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsGet(stockCountingPlanId, cellId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stockCountingPlanId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsReportGet(stockCountingPlanId: string, dqb?: string, options?: any): AxiosPromise<WallToWallStockCountingProductsReportOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsReportGet(stockCountingPlanId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [stockCountingPlanId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingSummaryReportGet(stockCountingPlanId?: string, options?: any): AxiosPromise<WallToWallStockCountingSummaryReportOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingSummaryReportGet(stockCountingPlanId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RestowUndamagedItemCommand} [restowUndamagedItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksRestowUndamagedItemsPost(restowUndamagedItemCommand?: RestowUndamagedItemCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WallToWallStockCountingTasksRestowUndamagedItemsPost(restowUndamagedItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StartWallToWallStockCountingListCommand} [startWallToWallStockCountingListCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksStartWallToWallStockCountingListPost(startWallToWallStockCountingListCommand?: StartWallToWallStockCountingListCommand, options?: any): AxiosPromise<StartWallToWallStockCountingListOutputDTO> {
            return localVarFp.apiV1WallToWallStockCountingTasksStartWallToWallStockCountingListPost(startWallToWallStockCountingListCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StartWallToWallStockCountingPlanCommand} [startWallToWallStockCountingPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WallToWallStockCountingTasksStartWallToWallStockCountingPlanPut(startWallToWallStockCountingPlanCommand?: StartWallToWallStockCountingPlanCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WallToWallStockCountingTasksStartWallToWallStockCountingPlanPut(startWallToWallStockCountingPlanCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WallToWallStockCountingTasksApi - object-oriented interface
 * @export
 * @class WallToWallStockCountingTasksApi
 * @extends {BaseAPI}
 */
export class WallToWallStockCountingTasksApi extends BaseAPI {
    /**
     * 
     * @param {ApplyWallToWallStockCountingPlanToStockCommand} [applyWallToWallStockCountingPlanToStockCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksApplyWallToWallStockCountingPlanToStockPut(applyWallToWallStockCountingPlanToStockCommand?: ApplyWallToWallStockCountingPlanToStockCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksApplyWallToWallStockCountingPlanToStockPut(applyWallToWallStockCountingPlanToStockCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignNewAddressesToPlanCommand} [assignNewAddressesToPlanCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksAssignNewAddressesToPlanPost(assignNewAddressesToPlanCommand?: AssignNewAddressesToPlanCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksAssignNewAddressesToPlanPost(assignNewAddressesToPlanCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignToWallToWallStockCountingPlanCommand} [assignToWallToWallStockCountingPlanCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksAssignToWallToWallStockCountingPlanPost(assignToWallToWallStockCountingPlanCommand?: AssignToWallToWallStockCountingPlanCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksAssignToWallToWallStockCountingPlanPost(assignToWallToWallStockCountingPlanCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckDamagedProductCommand} [checkDamagedProductCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksCheckDamagedProductPost(checkDamagedProductCommand?: CheckDamagedProductCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksCheckDamagedProductPost(checkDamagedProductCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {number} [cellId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksCheckProductForWallToWallStockCountingGet(barcode?: string, cellId?: number, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksCheckProductForWallToWallStockCountingGet(barcode, cellId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckQuarantineToteCommand} [checkQuarantineToteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksCheckQuarantineTotePost(checkQuarantineToteCommand?: CheckQuarantineToteCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksCheckQuarantineTotePost(checkQuarantineToteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckToteIfAvailableCommand} [checkToteIfAvailableCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksCheckToteIfAvailablePost(checkToteIfAvailableCommand?: CheckToteIfAvailableCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksCheckToteIfAvailablePost(checkToteIfAvailableCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckWallToWallStockCountingPlanNameIfAvailableCommand} [checkWallToWallStockCountingPlanNameIfAvailableCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksCheckWallToWallStockCountingPlanNameIfAvailablePost(checkWallToWallStockCountingPlanNameIfAvailableCommand?: CheckWallToWallStockCountingPlanNameIfAvailableCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksCheckWallToWallStockCountingPlanNameIfAvailablePost(checkWallToWallStockCountingPlanNameIfAvailableCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteRestowProcessCommand} [completeRestowProcessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksCompleteRestowProcessPost(completeRestowProcessCommand?: CompleteRestowProcessCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksCompleteRestowProcessPost(completeRestowProcessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContinueWallToWallStockCountingListCommand} [continueWallToWallStockCountingListCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksContinueWallToWallStockCountingListPost(continueWallToWallStockCountingListCommand?: ContinueWallToWallStockCountingListCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksContinueWallToWallStockCountingListPost(continueWallToWallStockCountingListCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CountDamagedItemsCommand} [countDamagedItemsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksCountDamagedItemsPost(countDamagedItemsCommand?: CountDamagedItemsCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksCountDamagedItemsPost(countDamagedItemsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CountWallToWallStockCountingProductsCommand} [countWallToWallStockCountingProductsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksCountProductsPost(countWallToWallStockCountingProductsCommand?: CountWallToWallStockCountingProductsCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksCountProductsPost(countWallToWallStockCountingProductsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateListForIncorrectCountedCellsCommand} [createListForIncorrectCountedCellsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksCreateListForIncorrectCountedCellsPost(createListForIncorrectCountedCellsCommand?: CreateListForIncorrectCountedCellsCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksCreateListForIncorrectCountedCellsPost(createListForIncorrectCountedCellsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteWallToWallStockCountingAddressCommand} [deleteWallToWallStockCountingAddressCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksDeleteWallToWallStockCountingAddressDelete(deleteWallToWallStockCountingAddressCommand?: DeleteWallToWallStockCountingAddressCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksDeleteWallToWallStockCountingAddressDelete(deleteWallToWallStockCountingAddressCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteWallToWallStockCountingListCommand} [deleteWallToWallStockCountingListCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksDeleteWallToWallStockCountingListDelete(deleteWallToWallStockCountingListCommand?: DeleteWallToWallStockCountingListCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksDeleteWallToWallStockCountingListDelete(deleteWallToWallStockCountingListCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FinishWallToWallStockCountingPlanCommand} [finishWallToWallStockCountingPlanCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksFinishWallToWallStockCountingPlanPut(finishWallToWallStockCountingPlanCommand?: FinishWallToWallStockCountingPlanCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksFinishWallToWallStockCountingPlanPut(finishWallToWallStockCountingPlanCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksGetActiveWallToWallStockCountingPlansGet(options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksGetActiveWallToWallStockCountingPlansGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksGetAllWallToWallStockCountingPlansGet(options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksGetAllWallToWallStockCountingPlansGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stockCountingPlanId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksGetCellsForControlCountGet(stockCountingPlanId: string, dqb?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksGetCellsForControlCountGet(stockCountingPlanId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksGetCompletedWallToWallStockCountingPlansGet(options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksGetCompletedWallToWallStockCountingPlansGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [stockCountingPlanId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksGetCreatedStateWallToWallStockCountingListsGet(stockCountingPlanId?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksGetCreatedStateWallToWallStockCountingListsGet(stockCountingPlanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksGetCreatedWallToWallStockCountingPlansGet(options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksGetCreatedWallToWallStockCountingPlansGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stockCountingPlanId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksGetListsWithIncorrectCountedCellsGet(stockCountingPlanId: string, dqb?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksGetListsWithIncorrectCountedCellsGet(stockCountingPlanId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetNextCellStockCounting} [getNextCellStockCounting] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksGetNextCellStockCountingPost(getNextCellStockCounting?: GetNextCellStockCounting, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksGetNextCellStockCountingPost(getNextCellStockCounting, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [stockCountingPlanId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksGetWallToWallStockCountingCountsGet(stockCountingPlanId?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksGetWallToWallStockCountingCountsGet(stockCountingPlanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [stockCountingPlanId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksGetWallToWallStockCountingListsGet(stockCountingPlanId?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksGetWallToWallStockCountingListsGet(stockCountingPlanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [stockCountingPlanId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksGetWallToWallStockCountingPlanGet(stockCountingPlanId?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksGetWallToWallStockCountingPlanGet(stockCountingPlanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksGetWallToWallStockCountingPlansGet(options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksGetWallToWallStockCountingPlansGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [stockCountingPlanId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksGetWallToWallStockCountingReportCountsGet(stockCountingPlanId?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksGetWallToWallStockCountingReportCountsGet(stockCountingPlanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [stockCountingPlanId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksGetWallToWallStockCountingTrackingCountsGet(stockCountingPlanId?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksGetWallToWallStockCountingTrackingCountsGet(stockCountingPlanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stockCountingListId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksPreviewWallToWallStockCountingPlanItemsGet(stockCountingListId: string, dqb?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksPreviewWallToWallStockCountingPlanItemsGet(stockCountingListId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stockCountingPlanId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksPreviewWallToWallStockCountingPlanListsGet(stockCountingPlanId: string, dqb?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksPreviewWallToWallStockCountingPlanListsGet(stockCountingPlanId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stockCountingPlanId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksQueryCellsGet(stockCountingPlanId: string, dqb?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksQueryCellsGet(stockCountingPlanId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stockCountingPlanId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressesGet(stockCountingPlanId: string, dqb?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressesGet(stockCountingPlanId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stockCountingPlanId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressProductsReportGet(stockCountingPlanId: string, dqb?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressProductsReportGet(stockCountingPlanId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stockCountingPlanId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressesReportGet(stockCountingPlanId: string, dqb?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingAddressesReportGet(stockCountingPlanId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stockCountingPlanId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingDamagedItemsGet(stockCountingPlanId: string, dqb?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingDamagedItemsGet(stockCountingPlanId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stockCountingPlanId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingDamagedItemsReportGet(stockCountingPlanId: string, dqb?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingDamagedItemsReportGet(stockCountingPlanId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stockCountingPlanId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingListsGet(stockCountingPlanId: string, dqb?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingListsGet(stockCountingPlanId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stockCountingPlanId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingListsReportGet(stockCountingPlanId: string, dqb?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingListsReportGet(stockCountingPlanId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stockCountingPlanId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingOperationsReportGet(stockCountingPlanId: string, dqb?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingOperationsReportGet(stockCountingPlanId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stockCountingPlanId 
     * @param {number} cellId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsGet(stockCountingPlanId: string, cellId: number, dqb?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsGet(stockCountingPlanId, cellId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stockCountingPlanId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsReportGet(stockCountingPlanId: string, dqb?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingProductsReportGet(stockCountingPlanId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [stockCountingPlanId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingSummaryReportGet(stockCountingPlanId?: string, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksQueryWallToWallStockCountingSummaryReportGet(stockCountingPlanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RestowUndamagedItemCommand} [restowUndamagedItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksRestowUndamagedItemsPost(restowUndamagedItemCommand?: RestowUndamagedItemCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksRestowUndamagedItemsPost(restowUndamagedItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StartWallToWallStockCountingListCommand} [startWallToWallStockCountingListCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksStartWallToWallStockCountingListPost(startWallToWallStockCountingListCommand?: StartWallToWallStockCountingListCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksStartWallToWallStockCountingListPost(startWallToWallStockCountingListCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StartWallToWallStockCountingPlanCommand} [startWallToWallStockCountingPlanCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WallToWallStockCountingTasksApi
     */
    public apiV1WallToWallStockCountingTasksStartWallToWallStockCountingPlanPut(startWallToWallStockCountingPlanCommand?: StartWallToWallStockCountingPlanCommand, options?: any) {
        return WallToWallStockCountingTasksApiFp(this.configuration).apiV1WallToWallStockCountingTasksStartWallToWallStockCountingPlanPut(startWallToWallStockCountingPlanCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WarehouseApi - axios parameter creator
 * @export
 */
export const WarehouseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WarehouseWarehouseConfigGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Warehouse.warehouseConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WarehouseApi - functional programming interface
 * @export
 */
export const WarehouseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WarehouseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WarehouseWarehouseConfigGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseConfigOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WarehouseWarehouseConfigGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WarehouseApi - factory interface
 * @export
 */
export const WarehouseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WarehouseApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WarehouseWarehouseConfigGet(options?: any): AxiosPromise<WarehouseConfigOutputDTO> {
            return localVarFp.apiV1WarehouseWarehouseConfigGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WarehouseApi - object-oriented interface
 * @export
 * @class WarehouseApi
 * @extends {BaseAPI}
 */
export class WarehouseApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public apiV1WarehouseWarehouseConfigGet(options?: any) {
        return WarehouseApiFp(this.configuration).apiV1WarehouseWarehouseConfigGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WaybillsApi - axios parameter creator
 * @export
 */
export const WaybillsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddWaybillImageCommand} [addWaybillImageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsAddWaybillImagePost: async (addWaybillImageCommand?: AddWaybillImageCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Waybills.addWaybillImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addWaybillImageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AssignPalletBarcodeToWaybillCommand} [assignPalletBarcodeToWaybillCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsAssignPalletToWaybillPost: async (assignPalletBarcodeToWaybillCommand?: AssignPalletBarcodeToWaybillCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Waybills.assignPalletToWaybill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignPalletBarcodeToWaybillCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteWaybillCommand} [completeWaybillCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsCompleteWaybillPost: async (completeWaybillCommand?: CompleteWaybillCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Waybills.completeWaybill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeWaybillCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateWaybillCommand} [createWaybillCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsCreatePost: async (createWaybillCommand?: CreateWaybillCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Waybills.create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWaybillCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteWaybillImageUrlCommand} [deleteWaybillImageUrlCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsDeleteWaybillImagePost: async (deleteWaybillImageUrlCommand?: DeleteWaybillImageUrlCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Waybills.deleteWaybillImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteWaybillImageUrlCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [waybillId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsGetDetailsGet: async (waybillId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Waybills.getDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (waybillId !== undefined) {
                localVarQueryParameter['waybillId'] = waybillId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsGetInboundBoxDetailsGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Waybills.getInboundBoxDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsGetSupplierCompaniesGet: async (searchName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Waybills.getSupplierCompanies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (searchName !== undefined) {
                localVarQueryParameter['searchName'] = searchName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [purchaseOrderId] 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsListByPurchaseOrderAndReferenceNumberGet: async (purchaseOrderId?: string, referenceNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Waybills.listByPurchaseOrderAndReferenceNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (purchaseOrderId !== undefined) {
                localVarQueryParameter['purchaseOrderId'] = purchaseOrderId;
            }

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintNewPalletCommand} [printNewPalletCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsPrintNewPalletPost: async (printNewPalletCommand?: PrintNewPalletCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Waybills.printNewPallet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printNewPalletCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrintWaybillCommand} [printWaybillCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsPrintWayBillPost: async (printWaybillCommand?: PrintWaybillCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Waybills.printWayBill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printWaybillCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} purchaseOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsQueryByPurchaseOrderGet: async (purchaseOrderId: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseOrderId' is not null or undefined
            assertParamExists('apiV1WaybillsQueryByPurchaseOrderGet', 'purchaseOrderId', purchaseOrderId)
            const localVarPath = `/api/v1/Waybills.queryByPurchaseOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (purchaseOrderId !== undefined) {
                localVarQueryParameter['purchaseOrderId'] = purchaseOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsQueryWaybillsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Waybills.queryWaybills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCarrierInfoCommand} [updateCarrierInfoCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsUpdateCarrierInfoPost: async (updateCarrierInfoCommand?: UpdateCarrierInfoCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Waybills.updateCarrierInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCarrierInfoCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateWaybillCommand} [updateWaybillCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsUpdatePost: async (updateWaybillCommand?: UpdateWaybillCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Waybills.update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWaybillCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateWaybillNotesCommand} [updateWaybillNotesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsUpdateWaybillNotesPost: async (updateWaybillNotesCommand?: UpdateWaybillNotesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Waybills.updateWaybillNotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWaybillNotesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsUploadWaybillImagePost: async (file?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Waybills.uploadWaybillImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaybillsApi - functional programming interface
 * @export
 */
export const WaybillsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WaybillsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddWaybillImageCommand} [addWaybillImageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsAddWaybillImagePost(addWaybillImageCommand?: AddWaybillImageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsAddWaybillImagePost(addWaybillImageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AssignPalletBarcodeToWaybillCommand} [assignPalletBarcodeToWaybillCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsAssignPalletToWaybillPost(assignPalletBarcodeToWaybillCommand?: AssignPalletBarcodeToWaybillCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaybillOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsAssignPalletToWaybillPost(assignPalletBarcodeToWaybillCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteWaybillCommand} [completeWaybillCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsCompleteWaybillPost(completeWaybillCommand?: CompleteWaybillCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsCompleteWaybillPost(completeWaybillCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateWaybillCommand} [createWaybillCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsCreatePost(createWaybillCommand?: CreateWaybillCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateWaybillOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsCreatePost(createWaybillCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteWaybillImageUrlCommand} [deleteWaybillImageUrlCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsDeleteWaybillImagePost(deleteWaybillImageUrlCommand?: DeleteWaybillImageUrlCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsDeleteWaybillImagePost(deleteWaybillImageUrlCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [waybillId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsGetDetailsGet(waybillId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaybillDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsGetDetailsGet(waybillId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsGetInboundBoxDetailsGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InboundBoxDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsGetInboundBoxDetailsGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [searchName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsGetSupplierCompaniesGet(searchName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SupplierCompaniesOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsGetSupplierCompaniesGet(searchName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [purchaseOrderId] 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsListByPurchaseOrderAndReferenceNumberGet(purchaseOrderId?: string, referenceNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaybillOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsListByPurchaseOrderAndReferenceNumberGet(purchaseOrderId, referenceNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintNewPalletCommand} [printNewPalletCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsPrintNewPalletPost(printNewPalletCommand?: PrintNewPalletCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PalletWaybillOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsPrintNewPalletPost(printNewPalletCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PrintWaybillCommand} [printWaybillCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsPrintWayBillPost(printWaybillCommand?: PrintWaybillCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaybillOutputDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsPrintWayBillPost(printWaybillCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} purchaseOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsQueryByPurchaseOrderGet(purchaseOrderId: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaybillQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsQueryByPurchaseOrderGet(purchaseOrderId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsQueryWaybillsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWaybillsQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsQueryWaybillsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateCarrierInfoCommand} [updateCarrierInfoCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsUpdateCarrierInfoPost(updateCarrierInfoCommand?: UpdateCarrierInfoCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCarrierInfoOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsUpdateCarrierInfoPost(updateCarrierInfoCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateWaybillCommand} [updateWaybillCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsUpdatePost(updateWaybillCommand?: UpdateWaybillCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateWaybillOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsUpdatePost(updateWaybillCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateWaybillNotesCommand} [updateWaybillNotesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsUpdateWaybillNotesPost(updateWaybillNotesCommand?: UpdateWaybillNotesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateWaybillNotesOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsUpdateWaybillNotesPost(updateWaybillNotesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WaybillsUploadWaybillImagePost(file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WaybillsUploadWaybillImagePost(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WaybillsApi - factory interface
 * @export
 */
export const WaybillsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WaybillsApiFp(configuration)
    return {
        /**
         * 
         * @param {AddWaybillImageCommand} [addWaybillImageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsAddWaybillImagePost(addWaybillImageCommand?: AddWaybillImageCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WaybillsAddWaybillImagePost(addWaybillImageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignPalletBarcodeToWaybillCommand} [assignPalletBarcodeToWaybillCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsAssignPalletToWaybillPost(assignPalletBarcodeToWaybillCommand?: AssignPalletBarcodeToWaybillCommand, options?: any): AxiosPromise<Array<WaybillOutputDTO>> {
            return localVarFp.apiV1WaybillsAssignPalletToWaybillPost(assignPalletBarcodeToWaybillCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteWaybillCommand} [completeWaybillCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsCompleteWaybillPost(completeWaybillCommand?: CompleteWaybillCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WaybillsCompleteWaybillPost(completeWaybillCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateWaybillCommand} [createWaybillCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsCreatePost(createWaybillCommand?: CreateWaybillCommand, options?: any): AxiosPromise<CreateWaybillOutputDTO> {
            return localVarFp.apiV1WaybillsCreatePost(createWaybillCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteWaybillImageUrlCommand} [deleteWaybillImageUrlCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsDeleteWaybillImagePost(deleteWaybillImageUrlCommand?: DeleteWaybillImageUrlCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WaybillsDeleteWaybillImagePost(deleteWaybillImageUrlCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [waybillId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsGetDetailsGet(waybillId?: string, options?: any): AxiosPromise<WaybillDetailsOutputDTO> {
            return localVarFp.apiV1WaybillsGetDetailsGet(waybillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsGetInboundBoxDetailsGet(barcode?: string, options?: any): AxiosPromise<InboundBoxDetailsOutputDTO> {
            return localVarFp.apiV1WaybillsGetInboundBoxDetailsGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [searchName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsGetSupplierCompaniesGet(searchName?: string, options?: any): AxiosPromise<Array<SupplierCompaniesOutputDTO>> {
            return localVarFp.apiV1WaybillsGetSupplierCompaniesGet(searchName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [purchaseOrderId] 
         * @param {string} [referenceNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsListByPurchaseOrderAndReferenceNumberGet(purchaseOrderId?: string, referenceNumber?: string, options?: any): AxiosPromise<Array<WaybillOutputDTO>> {
            return localVarFp.apiV1WaybillsListByPurchaseOrderAndReferenceNumberGet(purchaseOrderId, referenceNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintNewPalletCommand} [printNewPalletCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsPrintNewPalletPost(printNewPalletCommand?: PrintNewPalletCommand, options?: any): AxiosPromise<PalletWaybillOutputDTO> {
            return localVarFp.apiV1WaybillsPrintNewPalletPost(printNewPalletCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrintWaybillCommand} [printWaybillCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsPrintWayBillPost(printWaybillCommand?: PrintWaybillCommand, options?: any): AxiosPromise<Array<WaybillOutputDTO>> {
            return localVarFp.apiV1WaybillsPrintWayBillPost(printWaybillCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} purchaseOrderId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsQueryByPurchaseOrderGet(purchaseOrderId: string, dqb?: string, options?: any): AxiosPromise<WaybillQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WaybillsQueryByPurchaseOrderGet(purchaseOrderId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsQueryWaybillsGet(dqb?: string, options?: any): AxiosPromise<GetWaybillsQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WaybillsQueryWaybillsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCarrierInfoCommand} [updateCarrierInfoCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsUpdateCarrierInfoPost(updateCarrierInfoCommand?: UpdateCarrierInfoCommand, options?: any): AxiosPromise<UpdateCarrierInfoOutputDTO> {
            return localVarFp.apiV1WaybillsUpdateCarrierInfoPost(updateCarrierInfoCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateWaybillCommand} [updateWaybillCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsUpdatePost(updateWaybillCommand?: UpdateWaybillCommand, options?: any): AxiosPromise<UpdateWaybillOutputDTO> {
            return localVarFp.apiV1WaybillsUpdatePost(updateWaybillCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateWaybillNotesCommand} [updateWaybillNotesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsUpdateWaybillNotesPost(updateWaybillNotesCommand?: UpdateWaybillNotesCommand, options?: any): AxiosPromise<UpdateWaybillNotesOutputDTO> {
            return localVarFp.apiV1WaybillsUpdateWaybillNotesPost(updateWaybillNotesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WaybillsUploadWaybillImagePost(file?: any, options?: any): AxiosPromise<ImageOutputDTO> {
            return localVarFp.apiV1WaybillsUploadWaybillImagePost(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WaybillsApi - object-oriented interface
 * @export
 * @class WaybillsApi
 * @extends {BaseAPI}
 */
export class WaybillsApi extends BaseAPI {
    /**
     * 
     * @param {AddWaybillImageCommand} [addWaybillImageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsAddWaybillImagePost(addWaybillImageCommand?: AddWaybillImageCommand, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsAddWaybillImagePost(addWaybillImageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignPalletBarcodeToWaybillCommand} [assignPalletBarcodeToWaybillCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsAssignPalletToWaybillPost(assignPalletBarcodeToWaybillCommand?: AssignPalletBarcodeToWaybillCommand, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsAssignPalletToWaybillPost(assignPalletBarcodeToWaybillCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteWaybillCommand} [completeWaybillCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsCompleteWaybillPost(completeWaybillCommand?: CompleteWaybillCommand, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsCompleteWaybillPost(completeWaybillCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateWaybillCommand} [createWaybillCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsCreatePost(createWaybillCommand?: CreateWaybillCommand, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsCreatePost(createWaybillCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteWaybillImageUrlCommand} [deleteWaybillImageUrlCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsDeleteWaybillImagePost(deleteWaybillImageUrlCommand?: DeleteWaybillImageUrlCommand, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsDeleteWaybillImagePost(deleteWaybillImageUrlCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [waybillId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsGetDetailsGet(waybillId?: string, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsGetDetailsGet(waybillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsGetInboundBoxDetailsGet(barcode?: string, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsGetInboundBoxDetailsGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [searchName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsGetSupplierCompaniesGet(searchName?: string, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsGetSupplierCompaniesGet(searchName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [purchaseOrderId] 
     * @param {string} [referenceNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsListByPurchaseOrderAndReferenceNumberGet(purchaseOrderId?: string, referenceNumber?: string, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsListByPurchaseOrderAndReferenceNumberGet(purchaseOrderId, referenceNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintNewPalletCommand} [printNewPalletCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsPrintNewPalletPost(printNewPalletCommand?: PrintNewPalletCommand, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsPrintNewPalletPost(printNewPalletCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrintWaybillCommand} [printWaybillCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsPrintWayBillPost(printWaybillCommand?: PrintWaybillCommand, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsPrintWayBillPost(printWaybillCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} purchaseOrderId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsQueryByPurchaseOrderGet(purchaseOrderId: string, dqb?: string, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsQueryByPurchaseOrderGet(purchaseOrderId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsQueryWaybillsGet(dqb?: string, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsQueryWaybillsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCarrierInfoCommand} [updateCarrierInfoCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsUpdateCarrierInfoPost(updateCarrierInfoCommand?: UpdateCarrierInfoCommand, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsUpdateCarrierInfoPost(updateCarrierInfoCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateWaybillCommand} [updateWaybillCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsUpdatePost(updateWaybillCommand?: UpdateWaybillCommand, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsUpdatePost(updateWaybillCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateWaybillNotesCommand} [updateWaybillNotesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsUpdateWaybillNotesPost(updateWaybillNotesCommand?: UpdateWaybillNotesCommand, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsUpdateWaybillNotesPost(updateWaybillNotesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaybillsApi
     */
    public apiV1WaybillsUploadWaybillImagePost(file?: any, options?: any) {
        return WaybillsApiFp(this.configuration).apiV1WaybillsUploadWaybillImagePost(file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WebReceivingProcessesApi - axios parameter creator
 * @export
 */
export const WebReceivingProcessesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesCheckBarcodeTypeGet: async (barcode?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WebReceivingProcesses.checkBarcodeType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteWebReceivingCommand} [completeWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesCompletePost: async (completeWebReceivingCommand?: CompleteWebReceivingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WebReceivingProcesses.complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeWebReceivingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [receivingAddressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesContinueIfTotesExistsOnReceivingAddressGet: async (receivingAddressLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WebReceivingProcesses.continueIfTotesExistsOnReceivingAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (receivingAddressLabel !== undefined) {
                localVarQueryParameter['receivingAddressLabel'] = receivingAddressLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateWebReceivingProcessIfNotExistsCommand} [createWebReceivingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesCreateIfNotExistsPost: async (createWebReceivingProcessIfNotExistsCommand?: CreateWebReceivingProcessIfNotExistsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WebReceivingProcesses.createIfNotExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWebReceivingProcessIfNotExistsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DropToteForWebReceivingCommand} [dropToteForWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesDropTotePost: async (dropToteForWebReceivingCommand?: DropToteForWebReceivingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WebReceivingProcesses.dropTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dropToteForWebReceivingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [receivingAddressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesGetInboundBoxDetailsGet: async (barcode?: string, receivingAddressLabel?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WebReceivingProcesses.getInboundBoxDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }

            if (receivingAddressLabel !== undefined) {
                localVarQueryParameter['receivingAddressLabel'] = receivingAddressLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} barcode 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesGetQuarantineToteDetailsGet: async (barcode: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'barcode' is not null or undefined
            assertParamExists('apiV1WebReceivingProcessesGetQuarantineToteDetailsGet', 'barcode', barcode)
            const localVarPath = `/api/v1/WebReceivingProcesses.getQuarantineToteDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} barcode 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesGetReceivingToteDetailsGet: async (barcode: string, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'barcode' is not null or undefined
            assertParamExists('apiV1WebReceivingProcessesGetReceivingToteDetailsGet', 'barcode', barcode)
            const localVarPath = `/api/v1/WebReceivingProcesses.getReceivingToteDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (barcode !== undefined) {
                localVarQueryParameter['barcode'] = barcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceItemToQuarantineToteForWebReceivingCommand} [placeItemToQuarantineToteForWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesPlaceItemToQuarantineTotePost: async (placeItemToQuarantineToteForWebReceivingCommand?: PlaceItemToQuarantineToteForWebReceivingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WebReceivingProcesses.placeItemToQuarantineTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeItemToQuarantineToteForWebReceivingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceItemToReceivingToteForWebReceivingCommand} [placeItemToReceivingToteForWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesPlaceItemToReceivingTotePost: async (placeItemToReceivingToteForWebReceivingCommand?: PlaceItemToReceivingToteForWebReceivingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WebReceivingProcesses.placeItemToReceivingTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeItemToReceivingToteForWebReceivingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesQueryActiveWebReceivingProcessGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WebReceivingProcesses.queryActiveWebReceivingProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SelectQuarantineToteForWebReceivingCommand} [selectQuarantineToteForWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesSelectQuarantineTotePost: async (selectQuarantineToteForWebReceivingCommand?: SelectQuarantineToteForWebReceivingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WebReceivingProcesses.selectQuarantineTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectQuarantineToteForWebReceivingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SelectReceivingToteForWebReceivingCommand} [selectReceivingToteForWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesSelectReceivingTotePost: async (selectReceivingToteForWebReceivingCommand?: SelectReceivingToteForWebReceivingCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/WebReceivingProcesses.selectReceivingTote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectReceivingToteForWebReceivingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebReceivingProcessesApi - functional programming interface
 * @export
 */
export const WebReceivingProcessesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebReceivingProcessesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebReceivingProcessesCheckBarcodeTypeGet(barcode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckBarcodeTypeForWebReceivingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebReceivingProcessesCheckBarcodeTypeGet(barcode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompleteWebReceivingCommand} [completeWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebReceivingProcessesCompletePost(completeWebReceivingCommand?: CompleteWebReceivingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebReceivingProcessesCompletePost(completeWebReceivingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [receivingAddressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebReceivingProcessesContinueIfTotesExistsOnReceivingAddressGet(receivingAddressLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContinueIfTotesExistsOnReceivingAddressOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebReceivingProcessesContinueIfTotesExistsOnReceivingAddressGet(receivingAddressLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateWebReceivingProcessIfNotExistsCommand} [createWebReceivingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebReceivingProcessesCreateIfNotExistsPost(createWebReceivingProcessIfNotExistsCommand?: CreateWebReceivingProcessIfNotExistsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateWebReceivingProcessIfNotExistsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebReceivingProcessesCreateIfNotExistsPost(createWebReceivingProcessIfNotExistsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DropToteForWebReceivingCommand} [dropToteForWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebReceivingProcessesDropTotePost(dropToteForWebReceivingCommand?: DropToteForWebReceivingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebReceivingProcessesDropTotePost(dropToteForWebReceivingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [receivingAddressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebReceivingProcessesGetInboundBoxDetailsGet(barcode?: string, receivingAddressLabel?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebReceivingInboundBoxDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebReceivingProcessesGetInboundBoxDetailsGet(barcode, receivingAddressLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} barcode 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebReceivingProcessesGetQuarantineToteDetailsGet(barcode: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuarantineToteDetailsForWebReceivingOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebReceivingProcessesGetQuarantineToteDetailsGet(barcode, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} barcode 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebReceivingProcessesGetReceivingToteDetailsGet(barcode: string, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceivingToteDetailsForWebReceivingOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebReceivingProcessesGetReceivingToteDetailsGet(barcode, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceItemToQuarantineToteForWebReceivingCommand} [placeItemToQuarantineToteForWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebReceivingProcessesPlaceItemToQuarantineTotePost(placeItemToQuarantineToteForWebReceivingCommand?: PlaceItemToQuarantineToteForWebReceivingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceItemToQuarantineToteForWebReceivingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebReceivingProcessesPlaceItemToQuarantineTotePost(placeItemToQuarantineToteForWebReceivingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaceItemToReceivingToteForWebReceivingCommand} [placeItemToReceivingToteForWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebReceivingProcessesPlaceItemToReceivingTotePost(placeItemToReceivingToteForWebReceivingCommand?: PlaceItemToReceivingToteForWebReceivingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceItemToReceivingToteForWebReceivingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebReceivingProcessesPlaceItemToReceivingTotePost(placeItemToReceivingToteForWebReceivingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebReceivingProcessesQueryActiveWebReceivingProcessGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveWebReceivingProcessOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebReceivingProcessesQueryActiveWebReceivingProcessGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SelectQuarantineToteForWebReceivingCommand} [selectQuarantineToteForWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebReceivingProcessesSelectQuarantineTotePost(selectQuarantineToteForWebReceivingCommand?: SelectQuarantineToteForWebReceivingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebReceivingToteDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebReceivingProcessesSelectQuarantineTotePost(selectQuarantineToteForWebReceivingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SelectReceivingToteForWebReceivingCommand} [selectReceivingToteForWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WebReceivingProcessesSelectReceivingTotePost(selectReceivingToteForWebReceivingCommand?: SelectReceivingToteForWebReceivingCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebReceivingToteDetailsOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WebReceivingProcessesSelectReceivingTotePost(selectReceivingToteForWebReceivingCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WebReceivingProcessesApi - factory interface
 * @export
 */
export const WebReceivingProcessesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebReceivingProcessesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [barcode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesCheckBarcodeTypeGet(barcode?: string, options?: any): AxiosPromise<CheckBarcodeTypeForWebReceivingOutputDTO> {
            return localVarFp.apiV1WebReceivingProcessesCheckBarcodeTypeGet(barcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompleteWebReceivingCommand} [completeWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesCompletePost(completeWebReceivingCommand?: CompleteWebReceivingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WebReceivingProcessesCompletePost(completeWebReceivingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [receivingAddressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesContinueIfTotesExistsOnReceivingAddressGet(receivingAddressLabel?: string, options?: any): AxiosPromise<ContinueIfTotesExistsOnReceivingAddressOutputDTO> {
            return localVarFp.apiV1WebReceivingProcessesContinueIfTotesExistsOnReceivingAddressGet(receivingAddressLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateWebReceivingProcessIfNotExistsCommand} [createWebReceivingProcessIfNotExistsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesCreateIfNotExistsPost(createWebReceivingProcessIfNotExistsCommand?: CreateWebReceivingProcessIfNotExistsCommand, options?: any): AxiosPromise<CreateWebReceivingProcessIfNotExistsOutputDTO> {
            return localVarFp.apiV1WebReceivingProcessesCreateIfNotExistsPost(createWebReceivingProcessIfNotExistsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DropToteForWebReceivingCommand} [dropToteForWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesDropTotePost(dropToteForWebReceivingCommand?: DropToteForWebReceivingCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WebReceivingProcessesDropTotePost(dropToteForWebReceivingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [barcode] 
         * @param {string} [receivingAddressLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesGetInboundBoxDetailsGet(barcode?: string, receivingAddressLabel?: string, options?: any): AxiosPromise<WebReceivingInboundBoxDetailsOutputDTO> {
            return localVarFp.apiV1WebReceivingProcessesGetInboundBoxDetailsGet(barcode, receivingAddressLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} barcode 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesGetQuarantineToteDetailsGet(barcode: string, dqb?: string, options?: any): AxiosPromise<QuarantineToteDetailsForWebReceivingOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WebReceivingProcessesGetQuarantineToteDetailsGet(barcode, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} barcode 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesGetReceivingToteDetailsGet(barcode: string, dqb?: string, options?: any): AxiosPromise<ReceivingToteDetailsForWebReceivingOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WebReceivingProcessesGetReceivingToteDetailsGet(barcode, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceItemToQuarantineToteForWebReceivingCommand} [placeItemToQuarantineToteForWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesPlaceItemToQuarantineTotePost(placeItemToQuarantineToteForWebReceivingCommand?: PlaceItemToQuarantineToteForWebReceivingCommand, options?: any): AxiosPromise<PlaceItemToQuarantineToteForWebReceivingOutputDTO> {
            return localVarFp.apiV1WebReceivingProcessesPlaceItemToQuarantineTotePost(placeItemToQuarantineToteForWebReceivingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceItemToReceivingToteForWebReceivingCommand} [placeItemToReceivingToteForWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesPlaceItemToReceivingTotePost(placeItemToReceivingToteForWebReceivingCommand?: PlaceItemToReceivingToteForWebReceivingCommand, options?: any): AxiosPromise<PlaceItemToReceivingToteForWebReceivingOutputDTO> {
            return localVarFp.apiV1WebReceivingProcessesPlaceItemToReceivingTotePost(placeItemToReceivingToteForWebReceivingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesQueryActiveWebReceivingProcessGet(dqb?: string, options?: any): AxiosPromise<ActiveWebReceivingProcessOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WebReceivingProcessesQueryActiveWebReceivingProcessGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SelectQuarantineToteForWebReceivingCommand} [selectQuarantineToteForWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesSelectQuarantineTotePost(selectQuarantineToteForWebReceivingCommand?: SelectQuarantineToteForWebReceivingCommand, options?: any): AxiosPromise<WebReceivingToteDetailsOutputDTO> {
            return localVarFp.apiV1WebReceivingProcessesSelectQuarantineTotePost(selectQuarantineToteForWebReceivingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SelectReceivingToteForWebReceivingCommand} [selectReceivingToteForWebReceivingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WebReceivingProcessesSelectReceivingTotePost(selectReceivingToteForWebReceivingCommand?: SelectReceivingToteForWebReceivingCommand, options?: any): AxiosPromise<WebReceivingToteDetailsOutputDTO> {
            return localVarFp.apiV1WebReceivingProcessesSelectReceivingTotePost(selectReceivingToteForWebReceivingCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebReceivingProcessesApi - object-oriented interface
 * @export
 * @class WebReceivingProcessesApi
 * @extends {BaseAPI}
 */
export class WebReceivingProcessesApi extends BaseAPI {
    /**
     * 
     * @param {string} [barcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReceivingProcessesApi
     */
    public apiV1WebReceivingProcessesCheckBarcodeTypeGet(barcode?: string, options?: any) {
        return WebReceivingProcessesApiFp(this.configuration).apiV1WebReceivingProcessesCheckBarcodeTypeGet(barcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompleteWebReceivingCommand} [completeWebReceivingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReceivingProcessesApi
     */
    public apiV1WebReceivingProcessesCompletePost(completeWebReceivingCommand?: CompleteWebReceivingCommand, options?: any) {
        return WebReceivingProcessesApiFp(this.configuration).apiV1WebReceivingProcessesCompletePost(completeWebReceivingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [receivingAddressLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReceivingProcessesApi
     */
    public apiV1WebReceivingProcessesContinueIfTotesExistsOnReceivingAddressGet(receivingAddressLabel?: string, options?: any) {
        return WebReceivingProcessesApiFp(this.configuration).apiV1WebReceivingProcessesContinueIfTotesExistsOnReceivingAddressGet(receivingAddressLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateWebReceivingProcessIfNotExistsCommand} [createWebReceivingProcessIfNotExistsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReceivingProcessesApi
     */
    public apiV1WebReceivingProcessesCreateIfNotExistsPost(createWebReceivingProcessIfNotExistsCommand?: CreateWebReceivingProcessIfNotExistsCommand, options?: any) {
        return WebReceivingProcessesApiFp(this.configuration).apiV1WebReceivingProcessesCreateIfNotExistsPost(createWebReceivingProcessIfNotExistsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DropToteForWebReceivingCommand} [dropToteForWebReceivingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReceivingProcessesApi
     */
    public apiV1WebReceivingProcessesDropTotePost(dropToteForWebReceivingCommand?: DropToteForWebReceivingCommand, options?: any) {
        return WebReceivingProcessesApiFp(this.configuration).apiV1WebReceivingProcessesDropTotePost(dropToteForWebReceivingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [barcode] 
     * @param {string} [receivingAddressLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReceivingProcessesApi
     */
    public apiV1WebReceivingProcessesGetInboundBoxDetailsGet(barcode?: string, receivingAddressLabel?: string, options?: any) {
        return WebReceivingProcessesApiFp(this.configuration).apiV1WebReceivingProcessesGetInboundBoxDetailsGet(barcode, receivingAddressLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} barcode 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReceivingProcessesApi
     */
    public apiV1WebReceivingProcessesGetQuarantineToteDetailsGet(barcode: string, dqb?: string, options?: any) {
        return WebReceivingProcessesApiFp(this.configuration).apiV1WebReceivingProcessesGetQuarantineToteDetailsGet(barcode, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} barcode 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReceivingProcessesApi
     */
    public apiV1WebReceivingProcessesGetReceivingToteDetailsGet(barcode: string, dqb?: string, options?: any) {
        return WebReceivingProcessesApiFp(this.configuration).apiV1WebReceivingProcessesGetReceivingToteDetailsGet(barcode, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceItemToQuarantineToteForWebReceivingCommand} [placeItemToQuarantineToteForWebReceivingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReceivingProcessesApi
     */
    public apiV1WebReceivingProcessesPlaceItemToQuarantineTotePost(placeItemToQuarantineToteForWebReceivingCommand?: PlaceItemToQuarantineToteForWebReceivingCommand, options?: any) {
        return WebReceivingProcessesApiFp(this.configuration).apiV1WebReceivingProcessesPlaceItemToQuarantineTotePost(placeItemToQuarantineToteForWebReceivingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceItemToReceivingToteForWebReceivingCommand} [placeItemToReceivingToteForWebReceivingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReceivingProcessesApi
     */
    public apiV1WebReceivingProcessesPlaceItemToReceivingTotePost(placeItemToReceivingToteForWebReceivingCommand?: PlaceItemToReceivingToteForWebReceivingCommand, options?: any) {
        return WebReceivingProcessesApiFp(this.configuration).apiV1WebReceivingProcessesPlaceItemToReceivingTotePost(placeItemToReceivingToteForWebReceivingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReceivingProcessesApi
     */
    public apiV1WebReceivingProcessesQueryActiveWebReceivingProcessGet(dqb?: string, options?: any) {
        return WebReceivingProcessesApiFp(this.configuration).apiV1WebReceivingProcessesQueryActiveWebReceivingProcessGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SelectQuarantineToteForWebReceivingCommand} [selectQuarantineToteForWebReceivingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReceivingProcessesApi
     */
    public apiV1WebReceivingProcessesSelectQuarantineTotePost(selectQuarantineToteForWebReceivingCommand?: SelectQuarantineToteForWebReceivingCommand, options?: any) {
        return WebReceivingProcessesApiFp(this.configuration).apiV1WebReceivingProcessesSelectQuarantineTotePost(selectQuarantineToteForWebReceivingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SelectReceivingToteForWebReceivingCommand} [selectReceivingToteForWebReceivingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebReceivingProcessesApi
     */
    public apiV1WebReceivingProcessesSelectReceivingTotePost(selectReceivingToteForWebReceivingCommand?: SelectReceivingToteForWebReceivingCommand, options?: any) {
        return WebReceivingProcessesApiFp(this.configuration).apiV1WebReceivingProcessesSelectReceivingTotePost(selectReceivingToteForWebReceivingCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkflowsApi - axios parameter creator
 * @export
 */
export const WorkflowsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GetGet: async (id?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ActivateWorkflowCommand} [activateWorkflowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WorkflowsActivatePost: async (activateWorkflowCommand?: ActivateWorkflowCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Workflows.activate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activateWorkflowCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateWorkflowCommand} [createWorkflowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WorkflowsCreatePost: async (createWorkflowCommand?: CreateWorkflowCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Workflows.create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkflowCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeactivateWorkflowCommand} [deactivateWorkflowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WorkflowsDeactivatePost: async (deactivateWorkflowCommand?: DeactivateWorkflowCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Workflows.deactivate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deactivateWorkflowCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteWorkflowCommand} [deleteWorkflowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WorkflowsDeletePost: async (deleteWorkflowCommand?: DeleteWorkflowCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Workflows.delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteWorkflowCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [eventType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WorkflowsGetApplicationEventPayloadSchemaGet: async (eventType?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Workflows.getApplicationEventPayloadSchema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (eventType !== undefined) {
                localVarQueryParameter['eventType'] = eventType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WorkflowsListApplicationEventsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Workflows.listApplicationEvents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WorkflowsQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Workflows.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateWorkflowCommand} [updateWorkflowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WorkflowsUpdatePost: async (updateWorkflowCommand?: UpdateWorkflowCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Workflows.update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkflowCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkflowsApi - functional programming interface
 * @export
 */
export const WorkflowsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkflowsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1GetGet(id?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GetGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ActivateWorkflowCommand} [activateWorkflowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WorkflowsActivatePost(activateWorkflowCommand?: ActivateWorkflowCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WorkflowsActivatePost(activateWorkflowCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateWorkflowCommand} [createWorkflowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WorkflowsCreatePost(createWorkflowCommand?: CreateWorkflowCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateWorkflowOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WorkflowsCreatePost(createWorkflowCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeactivateWorkflowCommand} [deactivateWorkflowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WorkflowsDeactivatePost(deactivateWorkflowCommand?: DeactivateWorkflowCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WorkflowsDeactivatePost(deactivateWorkflowCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeleteWorkflowCommand} [deleteWorkflowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WorkflowsDeletePost(deleteWorkflowCommand?: DeleteWorkflowCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WorkflowsDeletePost(deleteWorkflowCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [eventType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WorkflowsGetApplicationEventPayloadSchemaGet(eventType?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationEventPayloadSchemaOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WorkflowsGetApplicationEventPayloadSchemaGet(eventType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WorkflowsListApplicationEventsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WorkflowsListApplicationEventsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WorkflowsQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkflowQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WorkflowsQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateWorkflowCommand} [updateWorkflowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WorkflowsUpdatePost(updateWorkflowCommand?: UpdateWorkflowCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateWorkflowOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WorkflowsUpdatePost(updateWorkflowCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkflowsApi - factory interface
 * @export
 */
export const WorkflowsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkflowsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GetGet(id?: string, options?: any): AxiosPromise<WorkflowQueryOutputDTO> {
            return localVarFp.apiV1GetGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ActivateWorkflowCommand} [activateWorkflowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WorkflowsActivatePost(activateWorkflowCommand?: ActivateWorkflowCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WorkflowsActivatePost(activateWorkflowCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateWorkflowCommand} [createWorkflowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WorkflowsCreatePost(createWorkflowCommand?: CreateWorkflowCommand, options?: any): AxiosPromise<CreateWorkflowOutputDTO> {
            return localVarFp.apiV1WorkflowsCreatePost(createWorkflowCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeactivateWorkflowCommand} [deactivateWorkflowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WorkflowsDeactivatePost(deactivateWorkflowCommand?: DeactivateWorkflowCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WorkflowsDeactivatePost(deactivateWorkflowCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteWorkflowCommand} [deleteWorkflowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WorkflowsDeletePost(deleteWorkflowCommand?: DeleteWorkflowCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1WorkflowsDeletePost(deleteWorkflowCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [eventType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WorkflowsGetApplicationEventPayloadSchemaGet(eventType?: string, options?: any): AxiosPromise<ApplicationEventPayloadSchemaOutputDTO> {
            return localVarFp.apiV1WorkflowsGetApplicationEventPayloadSchemaGet(eventType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WorkflowsListApplicationEventsGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiV1WorkflowsListApplicationEventsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WorkflowsQueryGet(dqb?: string, options?: any): AxiosPromise<WorkflowQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1WorkflowsQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateWorkflowCommand} [updateWorkflowCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WorkflowsUpdatePost(updateWorkflowCommand?: UpdateWorkflowCommand, options?: any): AxiosPromise<UpdateWorkflowOutputDTO> {
            return localVarFp.apiV1WorkflowsUpdatePost(updateWorkflowCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkflowsApi - object-oriented interface
 * @export
 * @class WorkflowsApi
 * @extends {BaseAPI}
 */
export class WorkflowsApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowsApi
     */
    public apiV1GetGet(id?: string, options?: any) {
        return WorkflowsApiFp(this.configuration).apiV1GetGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ActivateWorkflowCommand} [activateWorkflowCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowsApi
     */
    public apiV1WorkflowsActivatePost(activateWorkflowCommand?: ActivateWorkflowCommand, options?: any) {
        return WorkflowsApiFp(this.configuration).apiV1WorkflowsActivatePost(activateWorkflowCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateWorkflowCommand} [createWorkflowCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowsApi
     */
    public apiV1WorkflowsCreatePost(createWorkflowCommand?: CreateWorkflowCommand, options?: any) {
        return WorkflowsApiFp(this.configuration).apiV1WorkflowsCreatePost(createWorkflowCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeactivateWorkflowCommand} [deactivateWorkflowCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowsApi
     */
    public apiV1WorkflowsDeactivatePost(deactivateWorkflowCommand?: DeactivateWorkflowCommand, options?: any) {
        return WorkflowsApiFp(this.configuration).apiV1WorkflowsDeactivatePost(deactivateWorkflowCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteWorkflowCommand} [deleteWorkflowCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowsApi
     */
    public apiV1WorkflowsDeletePost(deleteWorkflowCommand?: DeleteWorkflowCommand, options?: any) {
        return WorkflowsApiFp(this.configuration).apiV1WorkflowsDeletePost(deleteWorkflowCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [eventType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowsApi
     */
    public apiV1WorkflowsGetApplicationEventPayloadSchemaGet(eventType?: string, options?: any) {
        return WorkflowsApiFp(this.configuration).apiV1WorkflowsGetApplicationEventPayloadSchemaGet(eventType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowsApi
     */
    public apiV1WorkflowsListApplicationEventsGet(options?: any) {
        return WorkflowsApiFp(this.configuration).apiV1WorkflowsListApplicationEventsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowsApi
     */
    public apiV1WorkflowsQueryGet(dqb?: string, options?: any) {
        return WorkflowsApiFp(this.configuration).apiV1WorkflowsQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateWorkflowCommand} [updateWorkflowCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowsApi
     */
    public apiV1WorkflowsUpdatePost(updateWorkflowCommand?: UpdateWorkflowCommand, options?: any) {
        return WorkflowsApiFp(this.configuration).apiV1WorkflowsUpdatePost(updateWorkflowCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ZoneConfigurationsApi - axios parameter creator
 * @export
 */
export const ZoneConfigurationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateZonePickListConfigurationCommand} [createZonePickListConfigurationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ZoneConfigurationsCreatePickListConfigurationPost: async (createZonePickListConfigurationCommand?: CreateZonePickListConfigurationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ZoneConfigurations.createPickListConfiguration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createZonePickListConfigurationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ZoneConfigurationsQueryPickListConfigurationsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ZoneConfigurations.queryPickListConfigurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateZonePickListConfigurationCommand} [updateZonePickListConfigurationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ZoneConfigurationsUpdatePickListConfigurationPost: async (updateZonePickListConfigurationCommand?: UpdateZonePickListConfigurationCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ZoneConfigurations.updatePickListConfiguration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateZonePickListConfigurationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZoneConfigurationsApi - functional programming interface
 * @export
 */
export const ZoneConfigurationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZoneConfigurationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateZonePickListConfigurationCommand} [createZonePickListConfigurationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ZoneConfigurationsCreatePickListConfigurationPost(createZonePickListConfigurationCommand?: CreateZonePickListConfigurationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateZonePickListConfigurationOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ZoneConfigurationsCreatePickListConfigurationPost(createZonePickListConfigurationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ZoneConfigurationsQueryPickListConfigurationsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZonePickListConfigurationOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ZoneConfigurationsQueryPickListConfigurationsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateZonePickListConfigurationCommand} [updateZonePickListConfigurationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ZoneConfigurationsUpdatePickListConfigurationPost(updateZonePickListConfigurationCommand?: UpdateZonePickListConfigurationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateZonePickListConfigurationOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ZoneConfigurationsUpdatePickListConfigurationPost(updateZonePickListConfigurationCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ZoneConfigurationsApi - factory interface
 * @export
 */
export const ZoneConfigurationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZoneConfigurationsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateZonePickListConfigurationCommand} [createZonePickListConfigurationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ZoneConfigurationsCreatePickListConfigurationPost(createZonePickListConfigurationCommand?: CreateZonePickListConfigurationCommand, options?: any): AxiosPromise<CreateZonePickListConfigurationOutputDTO> {
            return localVarFp.apiV1ZoneConfigurationsCreatePickListConfigurationPost(createZonePickListConfigurationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ZoneConfigurationsQueryPickListConfigurationsGet(dqb?: string, options?: any): AxiosPromise<ZonePickListConfigurationOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ZoneConfigurationsQueryPickListConfigurationsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateZonePickListConfigurationCommand} [updateZonePickListConfigurationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ZoneConfigurationsUpdatePickListConfigurationPost(updateZonePickListConfigurationCommand?: UpdateZonePickListConfigurationCommand, options?: any): AxiosPromise<UpdateZonePickListConfigurationOutputDTO> {
            return localVarFp.apiV1ZoneConfigurationsUpdatePickListConfigurationPost(updateZonePickListConfigurationCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZoneConfigurationsApi - object-oriented interface
 * @export
 * @class ZoneConfigurationsApi
 * @extends {BaseAPI}
 */
export class ZoneConfigurationsApi extends BaseAPI {
    /**
     * 
     * @param {CreateZonePickListConfigurationCommand} [createZonePickListConfigurationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoneConfigurationsApi
     */
    public apiV1ZoneConfigurationsCreatePickListConfigurationPost(createZonePickListConfigurationCommand?: CreateZonePickListConfigurationCommand, options?: any) {
        return ZoneConfigurationsApiFp(this.configuration).apiV1ZoneConfigurationsCreatePickListConfigurationPost(createZonePickListConfigurationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoneConfigurationsApi
     */
    public apiV1ZoneConfigurationsQueryPickListConfigurationsGet(dqb?: string, options?: any) {
        return ZoneConfigurationsApiFp(this.configuration).apiV1ZoneConfigurationsQueryPickListConfigurationsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateZonePickListConfigurationCommand} [updateZonePickListConfigurationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoneConfigurationsApi
     */
    public apiV1ZoneConfigurationsUpdatePickListConfigurationPost(updateZonePickListConfigurationCommand?: UpdateZonePickListConfigurationCommand, options?: any) {
        return ZoneConfigurationsApiFp(this.configuration).apiV1ZoneConfigurationsUpdatePickListConfigurationPost(updateZonePickListConfigurationCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ZoneTransfersApi - axios parameter creator
 * @export
 */
export const ZoneTransfersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DirectZoneTransferCommand} [directZoneTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ZoneTransfersDirectPost: async (directZoneTransferCommand?: DirectZoneTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/ZoneTransfers/direct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(directZoneTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PhysicalCompleteZoneTransferCommand} [physicalCompleteZoneTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ZoneTransfersPhysicalCompletePost: async (physicalCompleteZoneTransferCommand?: PhysicalCompleteZoneTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/ZoneTransfers/physicalComplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(physicalCompleteZoneTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PhysicalPrepareZoneTransferCommand} [physicalPrepareZoneTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ZoneTransfersPhysicalPreparePost: async (physicalPrepareZoneTransferCommand?: PhysicalPrepareZoneTransferCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/ZoneTransfers/physicalPrepare`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(physicalPrepareZoneTransferCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZoneTransfersApi - functional programming interface
 * @export
 */
export const ZoneTransfersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZoneTransfersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DirectZoneTransferCommand} [directZoneTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ZoneTransfersDirectPost(directZoneTransferCommand?: DirectZoneTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoneTransferOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ZoneTransfersDirectPost(directZoneTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PhysicalCompleteZoneTransferCommand} [physicalCompleteZoneTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ZoneTransfersPhysicalCompletePost(physicalCompleteZoneTransferCommand?: PhysicalCompleteZoneTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoneTransferOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ZoneTransfersPhysicalCompletePost(physicalCompleteZoneTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PhysicalPrepareZoneTransferCommand} [physicalPrepareZoneTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ZoneTransfersPhysicalPreparePost(physicalPrepareZoneTransferCommand?: PhysicalPrepareZoneTransferCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoneTransferOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ZoneTransfersPhysicalPreparePost(physicalPrepareZoneTransferCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ZoneTransfersApi - factory interface
 * @export
 */
export const ZoneTransfersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZoneTransfersApiFp(configuration)
    return {
        /**
         * 
         * @param {DirectZoneTransferCommand} [directZoneTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ZoneTransfersDirectPost(directZoneTransferCommand?: DirectZoneTransferCommand, options?: any): AxiosPromise<ZoneTransferOutputDTO> {
            return localVarFp.supportV1ZoneTransfersDirectPost(directZoneTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PhysicalCompleteZoneTransferCommand} [physicalCompleteZoneTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ZoneTransfersPhysicalCompletePost(physicalCompleteZoneTransferCommand?: PhysicalCompleteZoneTransferCommand, options?: any): AxiosPromise<ZoneTransferOutputDTO> {
            return localVarFp.supportV1ZoneTransfersPhysicalCompletePost(physicalCompleteZoneTransferCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PhysicalPrepareZoneTransferCommand} [physicalPrepareZoneTransferCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ZoneTransfersPhysicalPreparePost(physicalPrepareZoneTransferCommand?: PhysicalPrepareZoneTransferCommand, options?: any): AxiosPromise<ZoneTransferOutputDTO> {
            return localVarFp.supportV1ZoneTransfersPhysicalPreparePost(physicalPrepareZoneTransferCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZoneTransfersApi - object-oriented interface
 * @export
 * @class ZoneTransfersApi
 * @extends {BaseAPI}
 */
export class ZoneTransfersApi extends BaseAPI {
    /**
     * 
     * @param {DirectZoneTransferCommand} [directZoneTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoneTransfersApi
     */
    public supportV1ZoneTransfersDirectPost(directZoneTransferCommand?: DirectZoneTransferCommand, options?: any) {
        return ZoneTransfersApiFp(this.configuration).supportV1ZoneTransfersDirectPost(directZoneTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PhysicalCompleteZoneTransferCommand} [physicalCompleteZoneTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoneTransfersApi
     */
    public supportV1ZoneTransfersPhysicalCompletePost(physicalCompleteZoneTransferCommand?: PhysicalCompleteZoneTransferCommand, options?: any) {
        return ZoneTransfersApiFp(this.configuration).supportV1ZoneTransfersPhysicalCompletePost(physicalCompleteZoneTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PhysicalPrepareZoneTransferCommand} [physicalPrepareZoneTransferCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoneTransfersApi
     */
    public supportV1ZoneTransfersPhysicalPreparePost(physicalPrepareZoneTransferCommand?: PhysicalPrepareZoneTransferCommand, options?: any) {
        return ZoneTransfersApiFp(this.configuration).supportV1ZoneTransfersPhysicalPreparePost(physicalPrepareZoneTransferCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ZonesApi - axios parameter creator
 * @export
 */
export const ZonesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddAllUnassignedProductsToZoneCommand} [addAllUnassignedProductsToZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ZonesAddAllUnassignedProductsToZonePost: async (addAllUnassignedProductsToZoneCommand?: AddAllUnassignedProductsToZoneCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Zones.addAllUnassignedProductsToZone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAllUnassignedProductsToZoneCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddProductToZoneCommand} [addProductToZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ZonesAddProductToZonePost: async (addProductToZoneCommand?: AddProductToZoneCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Zones.addProductToZone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addProductToZoneCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkCreateStockZonesCommand} [bulkCreateStockZonesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ZonesCreateStockZonesPost: async (bulkCreateStockZonesCommand?: BulkCreateStockZonesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Zones.createStockZones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateStockZonesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ZonesGetUndefinedZoneProductsGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Zones.getUndefinedZoneProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateStockZoneCommand} [updateStockZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ZonesOverwriteStockZonePost: async (updateStockZoneCommand?: UpdateStockZoneCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Zones.overwriteStockZone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStockZoneCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ZonesQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/v1/Zones.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [zoneId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ZonesGetDetailsGet: async (zoneId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Zones.getDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (zoneId !== undefined) {
                localVarQueryParameter['zoneId'] = zoneId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} zoneId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ZonesQueryAdressesGet: async (zoneId: number, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoneId' is not null or undefined
            assertParamExists('apiV1ZonesQueryAdressesGet', 'zoneId', zoneId)
            const localVarPath = `/api/v1/Zones.queryAdresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (zoneId !== undefined) {
                localVarQueryParameter['zoneId'] = zoneId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ZonesQueryGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Zones.query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} zoneId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ZonesQueryProductsGet: async (zoneId: number, dqb?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoneId' is not null or undefined
            assertParamExists('apiV1ZonesQueryProductsGet', 'zoneId', zoneId)
            const localVarPath = `/api/v1/Zones.queryProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }

            if (zoneId !== undefined) {
                localVarQueryParameter['zoneId'] = zoneId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ZonesQueryStockZonePickListCapacityGet: async (dqb?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Zones.queryStockZonePickListCapacity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (dqb !== undefined) {
                localVarQueryParameter['dqb'] = dqb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkCreateStockZonesCommand} [bulkCreateStockZonesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ZonesZonesCreateStockZonesPost: async (bulkCreateStockZonesCommand?: BulkCreateStockZonesCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/support/v1/Zones/Zones.createStockZones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;odata.metadata=minimal;odata.streaming=true';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateStockZonesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZonesApi - functional programming interface
 * @export
 */
export const ZonesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZonesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddAllUnassignedProductsToZoneCommand} [addAllUnassignedProductsToZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1ZonesAddAllUnassignedProductsToZonePost(addAllUnassignedProductsToZoneCommand?: AddAllUnassignedProductsToZoneCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddProductStockZoneOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1ZonesAddAllUnassignedProductsToZonePost(addAllUnassignedProductsToZoneCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddProductToZoneCommand} [addProductToZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1ZonesAddProductToZonePost(addProductToZoneCommand?: AddProductToZoneCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddProductStockZoneOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1ZonesAddProductToZonePost(addProductToZoneCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkCreateStockZonesCommand} [bulkCreateStockZonesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1ZonesCreateStockZonesPost(bulkCreateStockZonesCommand?: BulkCreateStockZonesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkCreateStockZonesOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1ZonesCreateStockZonesPost(bulkCreateStockZonesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1ZonesGetUndefinedZoneProductsGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUndefinedZoneProductsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1ZonesGetUndefinedZoneProductsGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateStockZoneCommand} [updateStockZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1ZonesOverwriteStockZonePost(updateStockZoneCommand?: UpdateStockZoneCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateStockZoneOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1ZonesOverwriteStockZonePost(updateStockZoneCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV1ZonesQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStockZonesOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV1ZonesQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [zoneId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ZonesGetDetailsGet(zoneId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoneDetailOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ZonesGetDetailsGet(zoneId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} zoneId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ZonesQueryAdressesGet(zoneId: number, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetZoneAdressesOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ZonesQueryAdressesGet(zoneId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ZonesQueryGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoneQueryOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ZonesQueryGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} zoneId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ZonesQueryProductsGet(zoneId: number, dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetZoneProductsOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ZonesQueryProductsGet(zoneId, dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ZonesQueryStockZonePickListCapacityGet(dqb?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStockZonePickListCapacityOutputDTODynamicQueryOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ZonesQueryStockZonePickListCapacityGet(dqb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkCreateStockZonesCommand} [bulkCreateStockZonesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportV1ZonesZonesCreateStockZonesPost(bulkCreateStockZonesCommand?: BulkCreateStockZonesCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkCreateStockZonesOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportV1ZonesZonesCreateStockZonesPost(bulkCreateStockZonesCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ZonesApi - factory interface
 * @export
 */
export const ZonesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZonesApiFp(configuration)
    return {
        /**
         * 
         * @param {AddAllUnassignedProductsToZoneCommand} [addAllUnassignedProductsToZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ZonesAddAllUnassignedProductsToZonePost(addAllUnassignedProductsToZoneCommand?: AddAllUnassignedProductsToZoneCommand, options?: any): AxiosPromise<AddProductStockZoneOutputDTO> {
            return localVarFp.adminV1ZonesAddAllUnassignedProductsToZonePost(addAllUnassignedProductsToZoneCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddProductToZoneCommand} [addProductToZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ZonesAddProductToZonePost(addProductToZoneCommand?: AddProductToZoneCommand, options?: any): AxiosPromise<AddProductStockZoneOutputDTO> {
            return localVarFp.adminV1ZonesAddProductToZonePost(addProductToZoneCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkCreateStockZonesCommand} [bulkCreateStockZonesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ZonesCreateStockZonesPost(bulkCreateStockZonesCommand?: BulkCreateStockZonesCommand, options?: any): AxiosPromise<BulkCreateStockZonesOutputDTO> {
            return localVarFp.adminV1ZonesCreateStockZonesPost(bulkCreateStockZonesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ZonesGetUndefinedZoneProductsGet(dqb?: string, options?: any): AxiosPromise<GetUndefinedZoneProductsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.adminV1ZonesGetUndefinedZoneProductsGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateStockZoneCommand} [updateStockZoneCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ZonesOverwriteStockZonePost(updateStockZoneCommand?: UpdateStockZoneCommand, options?: any): AxiosPromise<UpdateStockZoneOutputDTO> {
            return localVarFp.adminV1ZonesOverwriteStockZonePost(updateStockZoneCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV1ZonesQueryGet(dqb?: string, options?: any): AxiosPromise<GetStockZonesOutputDTODynamicQueryOutputDTO> {
            return localVarFp.adminV1ZonesQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [zoneId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ZonesGetDetailsGet(zoneId?: number, options?: any): AxiosPromise<ZoneDetailOutputDTO> {
            return localVarFp.apiV1ZonesGetDetailsGet(zoneId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} zoneId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ZonesQueryAdressesGet(zoneId: number, dqb?: string, options?: any): AxiosPromise<GetZoneAdressesOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ZonesQueryAdressesGet(zoneId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ZonesQueryGet(dqb?: string, options?: any): AxiosPromise<ZoneQueryOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ZonesQueryGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} zoneId 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ZonesQueryProductsGet(zoneId: number, dqb?: string, options?: any): AxiosPromise<GetZoneProductsOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ZonesQueryProductsGet(zoneId, dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dqb] DynamicQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ZonesQueryStockZonePickListCapacityGet(dqb?: string, options?: any): AxiosPromise<GetStockZonePickListCapacityOutputDTODynamicQueryOutputDTO> {
            return localVarFp.apiV1ZonesQueryStockZonePickListCapacityGet(dqb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkCreateStockZonesCommand} [bulkCreateStockZonesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportV1ZonesZonesCreateStockZonesPost(bulkCreateStockZonesCommand?: BulkCreateStockZonesCommand, options?: any): AxiosPromise<BulkCreateStockZonesOutputDTO> {
            return localVarFp.supportV1ZonesZonesCreateStockZonesPost(bulkCreateStockZonesCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZonesApi - object-oriented interface
 * @export
 * @class ZonesApi
 * @extends {BaseAPI}
 */
export class ZonesApi extends BaseAPI {
    /**
     * 
     * @param {AddAllUnassignedProductsToZoneCommand} [addAllUnassignedProductsToZoneCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    public adminV1ZonesAddAllUnassignedProductsToZonePost(addAllUnassignedProductsToZoneCommand?: AddAllUnassignedProductsToZoneCommand, options?: any) {
        return ZonesApiFp(this.configuration).adminV1ZonesAddAllUnassignedProductsToZonePost(addAllUnassignedProductsToZoneCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddProductToZoneCommand} [addProductToZoneCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    public adminV1ZonesAddProductToZonePost(addProductToZoneCommand?: AddProductToZoneCommand, options?: any) {
        return ZonesApiFp(this.configuration).adminV1ZonesAddProductToZonePost(addProductToZoneCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkCreateStockZonesCommand} [bulkCreateStockZonesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    public adminV1ZonesCreateStockZonesPost(bulkCreateStockZonesCommand?: BulkCreateStockZonesCommand, options?: any) {
        return ZonesApiFp(this.configuration).adminV1ZonesCreateStockZonesPost(bulkCreateStockZonesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    public adminV1ZonesGetUndefinedZoneProductsGet(dqb?: string, options?: any) {
        return ZonesApiFp(this.configuration).adminV1ZonesGetUndefinedZoneProductsGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateStockZoneCommand} [updateStockZoneCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    public adminV1ZonesOverwriteStockZonePost(updateStockZoneCommand?: UpdateStockZoneCommand, options?: any) {
        return ZonesApiFp(this.configuration).adminV1ZonesOverwriteStockZonePost(updateStockZoneCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    public adminV1ZonesQueryGet(dqb?: string, options?: any) {
        return ZonesApiFp(this.configuration).adminV1ZonesQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [zoneId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    public apiV1ZonesGetDetailsGet(zoneId?: number, options?: any) {
        return ZonesApiFp(this.configuration).apiV1ZonesGetDetailsGet(zoneId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} zoneId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    public apiV1ZonesQueryAdressesGet(zoneId: number, dqb?: string, options?: any) {
        return ZonesApiFp(this.configuration).apiV1ZonesQueryAdressesGet(zoneId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    public apiV1ZonesQueryGet(dqb?: string, options?: any) {
        return ZonesApiFp(this.configuration).apiV1ZonesQueryGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} zoneId 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    public apiV1ZonesQueryProductsGet(zoneId: number, dqb?: string, options?: any) {
        return ZonesApiFp(this.configuration).apiV1ZonesQueryProductsGet(zoneId, dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dqb] DynamicQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    public apiV1ZonesQueryStockZonePickListCapacityGet(dqb?: string, options?: any) {
        return ZonesApiFp(this.configuration).apiV1ZonesQueryStockZonePickListCapacityGet(dqb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkCreateStockZonesCommand} [bulkCreateStockZonesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZonesApi
     */
    public supportV1ZonesZonesCreateStockZonesPost(bulkCreateStockZonesCommand?: BulkCreateStockZonesCommand, options?: any) {
        return ZonesApiFp(this.configuration).supportV1ZonesZonesCreateStockZonesPost(bulkCreateStockZonesCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


